import { j as e, M as X7 } from "./react-markdown-D3zycGHc.js";
import qr, { memo as ze, useMemo as je, useState as pe, useEffect as m1, useCallback as w1, useRef as $1, useContext as eo, createElement as to } from "react";
import { Grid as y, ContentBlock as Ne, DropDownMenu as ad, Box as X, Button as Ye, Icon as t1, Checkbox as S1, transparentize as Ot, FilterPanel as id, darken as no, lighten as d5, NewTable as y1, Typography as ce, Divider as M1, Select as W1, ButtonGroup as $4, IconButton as Vt, Spinner as p5, Block as k4, Input as et, Alert as sd, Tooltip as f1, Paper as Gt, AutocompleteInput as It, DatePicker as O3, CheckboxCell as l1, InputCell as Bn, Table as At, Modal as m5, Autocomplete as H1, Chip as ld, IconActionButton as cd, Menu as ro, MenuItem as Xr, Rating as ud, flexRender as oo, EmptyTableStub as h5, useWindowSize as dd, StyledTable as pd, TableHeadRow as Z7, TableRow as Nr, StyledTableCell as v4, BlockTitle as qn, Radio as J7, Dialog as md, DialogTitle as hd, DialogContent as fd, IconActionButtonFilled as xd, useNotifications as gd, ModalTitle as yd, Slider as vd } from "@prometheus/components";
import { DescriptionCard as W4, TitleWithCount as N1, Chart as H4, FormElement as tt, Link as ao, SpinnerWidgetContainer as bd, TabsNavigationNew as f5, FormActionsContainer as io, InlineFormElement as Ve, BaseInfoWrapper as so, ActionCell as lo, ListCell as Cd, IRChartScale as jd, DataSourceLogo as m3, NAME_COLUMN as V4, SecondaryContentWrapper as co, CodeEditor as Sd, FileContentType as wd, ListHeaderSecondary as Td, IconActionButton as uo, Dropzone as Ed, ConfirmationDialog as Ad } from "@prometheus/features";
import { TypesOfContainer as Fr, typesOfCreationBlock as _d, AnalysisTypes as I3, CreateSubmissionFormTabs as Xn, AntivirusFileStatus as _t, analysisTypes as po, DateFormat as _1, DateEdge as n5, IntervalValue as P1, AnalysisSubmissionStatus as Q7, FileExtension as r5 } from "@prometheus/enums";
import Fe from "@emotion/styled";
import { formatNumber as oe, capitalize as Pd, uniqBy as z4, flattenDeep as Od, groupBy as mo, keyBy as Yt, reverse as ho, sortBy as fo, debounce as xo, api as r4, convertExtendedToLegacyConcepts as Id, getFileExtension as Rd, getFileIconName as go, generateAlias as e8, getLongNumberUUID as yo, formatDate as Zr, isBoolean as n4, isEqual as u2, convertFormatDate as $n, checkFormatDate as t8, isString as vo, isObject as o5, getCodeLanguageByFileExtension as bo, getUUID as Kt } from "@prometheus/utils";
import { l as n8, c as Co, s as Nd, h as Fd, e as Dd, a as Ld, i as Md, b as kd, q as zd, d as Bd, t as jo, o as $d, f as Wd } from "./d3-BR7QU6TO.js";
import { c as So } from "./react-plotly.js-b7Wmpgy5.js";
import { P as wo, a as Hd, c as X3 } from "./plotly-vendor-Xl9RTeYD.js";
import { Status as c3 } from "@prometheus/types";
import { Rectangle as Vd, Text as Ud, ResponsiveContainer as R3, BarChart as d2, CartesianGrid as U4, XAxis as G4, YAxis as K4, Tooltip as h3, Bar as p2, Brush as To, PieChart as Eo, Pie as Ao, Cell as m2, ScatterChart as Gd, Scatter as Kd, Legend as Yd, Sankey as qd, ComposedChart as Xd, ReferenceLine as r8, Area as Zd, Line as Jd } from "recharts";
import _o from "react-virtualized-auto-sizer";
import { ModalContext as Po, useSelectedConcepts as Qd, getOverlayHistoryCount as Dr, pushOverlayHistoryState as ep, subscribeOverlayHistoryPop as tp, goBackOverlayHistory as np } from "@prometheus/hooks";
import { useParams as rp, Routes as op, Route as b4 } from "react-router-dom";
Fe.div`
  display: flex;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid
    ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.borderColor.main;
}};
`;
Fe.div`
  font-size: 14px;
  color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
  font-weight: 700;
  padding-top: 16px;
`;
Fe.div`
  font-size: 36px;
  text-align: center;
`;
const o8 = Fe.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 16px 0;
  color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.grey[400];
}};
`;
Fe.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const ap = Fe.div`
  padding: 2px 15px;
`;
Fe.div`
  margin: 15px;
`;
Fe.div`
  /* background-color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.backgroundColor.main;
}}; */
  border-bottom: 1px solid
    ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.borderColor.main;
}};
  border-radius: 4px 4px 0 0;
  padding: 16px;
  h4 {
    margin: 0;
    color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    & + p {
      padding-top: 16px;
    }
  }
`;
const ip = Fe.p`
  margin: 0;
  font-size: 14px;
`, L1 = (n, o, a) => {
  switch (n) {
    case Fr.WORKSPACE:
      return `/workspace/analyses/${o}`;
    case Fr.STUDY:
      return `/study-manager/${a}/analyses/${o}`;
    case Fr.LIBRARY:
      return `/library/analyses/${o}`;
  }
}, a8 = {
  ARTIFACTS_LIBRARY: "ARTIFACTS_LIBRARY",
  CUSTOM_FEATURE_STORE: "CUSTOM_FEATURE_STORE"
}, Iy = ze((n) => {
  var A, P, T, I;
  const {
    id: o,
    subModules: a,
    parentId: i,
    typeContainer: l,
    design: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n, d = (w) => (N) => {
    p(w, N);
  }, f = je(
    () => Array.from(
      /* @__PURE__ */ new Set([
        ...(c == null ? void 0 : c.featureAnalyses) || [],
        ...(c == null ? void 0 : c.customFeatureAnalyses) || []
      ])
    ),
    [c == null ? void 0 : c.customFeatureAnalyses, c == null ? void 0 : c.featureAnalyses]
  ), b = Array.isArray(c == null ? void 0 : c.parameters) ? c.parameters.length : Object.keys((c == null ? void 0 : c.parameters) || {}).length, [C, v] = pe(null);
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1.5, children: [
    (!u || u && ((A = c == null ? void 0 : c.cohorts) == null ? void 0 : A.length) > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(W4, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("b", { children: "Cohort characterization" }),
        " is defined as the process of generating cohort level descriptive summary statistics from person level covariate data. Summary statistics of these person level covariates may be count, mean, sd, var, min, max, median, range, and quantiles. In addition, covariates during a period may be stratified into temporal units of time for time-series analysis such as fixed intervals of time relative to cohort_start_date (e.g. every 7 days, every 30 days etc.), or in absolute calendar intervals such as calendar-week, calendar-month, calendar-quarter, calendar-year."
      ] }) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        a.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: a,
          path: L1(l, o, i),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ e.jsx(
              N1,
              {
                title: "Target cohorts",
                count: (P = c == null ? void 0 : c.cohorts) == null ? void 0 : P.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: l,
            initialData: c == null ? void 0 : c.cohorts,
            onChange: d("cohorts"),
            isSelect: !0,
            parentId: i,
            returnEntityText: g,
            collapsible: !0,
            defaultState: !0,
            viewMode: u
          }
        }
      ) })
    ] }),
    (!u || u && f.length > 0) && /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      a.featureanalyses,
      {
        type: "component",
        name: "widget-feature-import-button",
        subModules: a,
        path: L1(l, o, i),
        viewMode: u,
        config: {
          buttonText: "Import feature analysis",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Feature analyses",
              count: f.length
            }
          ),
          typeContainer: l,
          initialData: f,
          onChange: (w, N) => {
            var E;
            p("featureAnalyses", w), (E = c == null ? void 0 : c.customFeatureAnalyses) != null && E.length && p("customFeatureAnalyses", []);
          },
          isSelect: !0,
          parentId: i,
          returnEntityText: g,
          defaultState: u,
          modalTitle: "Import feature analyses",
          availableSources: [
            a8.ARTIFACTS_LIBRARY,
            a8.CUSTOM_FEATURE_STORE
          ],
          // Feature analyses parameters are only relevant to feature
          // analyses, so they live inside this section rather than a
          // separate block (PRO mockup).
          footer: (!u || u && b > 0) && /* @__PURE__ */ e.jsx(
            a.featureanalyses,
            {
              type: "component",
              name: "widget-feature-params",
              subModules: a,
              path: L1(l, o, i),
              config: {
                initialParams: c == null ? void 0 : c.parameters,
                onChange: (w) => {
                  p(
                    "parameters",
                    Array.isArray(w) ? w : Object.values(w || {})
                  );
                },
                embedded: !0,
                viewMode: u
              }
            }
          )
        }
      }
    ) }) }),
    (!u || u && ((T = c == null ? void 0 : c.strata) == null ? void 0 : T.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
      Ne,
      {
        collapsible: !0,
        keepMounted: !0,
        title: /* @__PURE__ */ e.jsx(
          N1,
          {
            title: "Subgroup analyses",
            count: (I = c == null ? void 0 : c.strata) == null ? void 0 : I.length
          }
        ),
        defaultState: u,
        elevated: !0,
        outlined: !0,
        actions: !u && /* @__PURE__ */ e.jsx(
          ad,
          {
            variant: "contained",
            color: "info",
            options: _d,
            onClick: (w) => {
              v(w);
            },
            title: "New subgroup",
            name: "New subgroup",
            closeOnSelect: !0,
            preventOverflow: !0,
            startIcon: /* @__PURE__ */ e.jsx("span", { "aria-hidden": !0, children: "+" })
          }
        ),
        children: [
          /* @__PURE__ */ e.jsx(ip, { children: "You can provide optional stratification criteria to the analysis that will divide the population into unique groups based on their satisfied criteria." }),
          /* @__PURE__ */ e.jsx(ap, { children: /* @__PURE__ */ e.jsx(
            a.cohort,
            {
              type: "component",
              name: "widget-criteria-group",
              subModules: a,
              config: {
                onChange: (w, N) => {
                  p("strata", w);
                },
                onChangeStrataOnly: (w) => {
                  p("strataOnly", w);
                },
                onChangeStrataBy: (w) => {
                  p("stratifiedBy", w);
                },
                typeContainer: l,
                parentId: i,
                values: (c == null ? void 0 : c.strata) || [],
                buttonText: "New subgroup",
                titleText: "",
                isDesignStrata: !0,
                strataParams: {
                  strataOnly: c.strataOnly,
                  stratifiedBy: c.stratifiedBy
                },
                hiddenParentConcept: !0,
                contextConceptSets: {
                  conceptSets: c == null ? void 0 : c.strataConceptSets,
                  updateConceptSets: (w) => {
                    p("strataConceptSets", w);
                  }
                },
                viewMode: u,
                hideCriteriaGroupHeader: !0,
                parentCriteriaElement: C,
                clearParentCriteriaElement: () => {
                  v(null);
                }
              }
            }
          ) })
        ]
      }
    ) })
  ] });
}), Ry = () => ({
  cohorts: [],
  featureAnalyses: [],
  customFeatureAnalyses: [],
  embeddedFeatureAnalyses: [],
  parameters: [],
  strata: [],
  strataConceptSets: [],
  strataOnly: !1,
  stratifiedBy: null
}), Ny = (n) => {
  var o;
  return `${oe(((o = n == null ? void 0 : n.reports) == null ? void 0 : o.length) || 0)} reports`;
}, Fy = (n, o) => ({
  ...o,
  type: n.type
  // strataConceptSets: design.strataConceptSets.map(cs => ({
  //   ...cs,
  //   expression: {
  //     ...cs.expression,
  //     items: cs.expression.items.map(item => {
  //       const newItem = { ...item };
  //       if (
  //         item.concept.STANDARD_CONCEPT === StandardConceptTypes.NON_STANDARD
  //       ) {
  //         newItem.hierarchy = newItem.includeDescendants;
  //         delete newItem.includeMapped;
  //         delete newItem.includeDescendants;
  //       }
  //       return newItem;
  //     }),
  //   },
  // })),
}), sp = ze((n) => {
  const { reports: o, cohorts: a } = n, i = je(() => o.map((u) => {
    const d = u == null ? void 0 : u.analysisName, f = u != null && u.item ? u == null ? void 0 : u.item.map((b) => {
      var C, v, A, P;
      return {
        covariateName: b.covariateName,
        xValue: ((v = (C = b == null ? void 0 : b.records) == null ? void 0 : C[0]) == null ? void 0 : v.avg) * 100 || 0,
        yValue: ((P = (A = b == null ? void 0 : b.records) == null ? void 0 : A[1]) == null ? void 0 : P.avg) * 100 || 0
      };
    }) : [];
    return {
      name: d,
      values: f
    };
  }), [o]), l = n8().domain([0, 100]), c = n8().domain([0, 100]), p = Co;
  return /* @__PURE__ */ e.jsx(
    H4,
    {
      type: "scatterplot",
      chartData: i,
      options: () => {
        var g, u;
        return {
          xLabel: (g = a == null ? void 0 : a[0]) == null ? void 0 : g.name,
          yLabel: (u = a == null ? void 0 : a[1]) == null ? void 0 : u.name,
          colors: p,
          circleRadius: 4,
          addDiagonal: !0,
          xScale: l,
          yScale: c,
          tooltip: (d) => `
            <div class="tooltip-scatterplot">Series: ${d.seriesName}</div>
            <div class="tooltip-scatterplot">Covariate: ${d.covariateName}</div>
            <div class="tooltip-scatterplot"> X: ${d.xValue.toFixed(2)}%</div>
            <div class="tooltip-scatterplot">Y: ${d.yValue.toFixed(2)}%</div>
            `
        };
      }
    }
  );
}), lp = ze((n) => {
  const { report: o, cohorts: a, items: i, records: l } = n, c = je(() => {
    var b, C, v, A, P, T;
    const p = i || [
      {
        covariateName: (C = (b = o.item) == null ? void 0 : b[0]) == null ? void 0 : C.covariateName,
        name: (A = (v = o.item) == null ? void 0 : v[0]) == null ? void 0 : A.name,
        records: l || ((T = (P = o.item) == null ? void 0 : P[0]) == null ? void 0 : T.records) || []
      }
    ], g = (I) => Array.isArray(I.records) ? I.records : Object.values(I.records || {}), u = (I) => I.covariateName || I.fullCovariateName || I.name || "", d = (I, w) => {
      const N = (w == null ? void 0 : w.min) ?? (w == null ? void 0 : w.minValue), E = (w == null ? void 0 : w.max) ?? (w == null ? void 0 : w.maxValue), x = (w == null ? void 0 : w.median) ?? (w == null ? void 0 : w.medianValue), m = (w == null ? void 0 : w.p25) ?? (w == null ? void 0 : w.p25Value) ?? x, j = (w == null ? void 0 : w.p75) ?? (w == null ? void 0 : w.p75Value) ?? x;
      return {
        Category: I.name,
        min: N,
        max: E,
        median: x,
        LIF: (w == null ? void 0 : w.p10) ?? (w == null ? void 0 : w.p10Value) ?? N,
        q1: m,
        q3: j,
        UIF: (w == null ? void 0 : w.p90) ?? (w == null ? void 0 : w.p90Value) ?? E
      };
    }, f = (I) => [I.min, I.max, I.median, I.q1, I.q3].every(
      (w) => w != null && !Number.isNaN(w)
    );
    return p.map((I) => {
      const w = g(I), N = d(
        a == null ? void 0 : a[0],
        w.find((x) => x.cohortId === (a == null ? void 0 : a[0].id))
      ), E = d(
        a == null ? void 0 : a[1],
        w.find((x) => x.cohortId === (a == null ? void 0 : a[1].id))
      );
      return {
        Category: u(I) || N.Category,
        target: N,
        compare: E
      };
    }).filter(
      (I) => f(I.target) && f(I.compare)
    );
  }, [a, i, l, o]);
  return /* @__PURE__ */ e.jsx(
    H4,
    {
      type: "splitBoxplot",
      chartData: c,
      options: () => ({
        showYAxis: !0,
        boxHeight: 40,
        minHeight: 125,
        valueFormatter: (p) => p,
        format: {
          valueFormatter: (p) => p
        }
      })
    }
  );
}), cp = So(wo), up = 24, dp = 43, pp = 75, Wn = 4, Hn = [
  { fill: "#fff2a8", stroke: "#ffd400" },
  { fill: "#8db7ff", stroke: "#2f74ff" },
  { fill: "#ffd0a0", stroke: "#ff8a1a" },
  { fill: "#a9e5c0", stroke: "#32a852" },
  { fill: "#d9b8ff", stroke: "#8e48d8" },
  { fill: "#9ee3e7", stroke: "#15a1a8" }
], mp = {
  autosize: !0,
  showlegend: !1,
  hovermode: "closest",
  xaxis: {
    automargin: !0,
    gridcolor: "#e5e7eb",
    zeroline: !1
  },
  yaxis: {
    visible: !1,
    fixedrange: !0,
    zeroline: !1
  },
  margin: {
    l: 0,
    r: 20,
    b: 36,
    t: 8,
    pad: 4
  }
}, hp = {
  responsive: !0,
  displayModeBar: !0,
  displaylogo: !1,
  modeBarButtonsToRemove: [
    "pan2d",
    "lasso2d",
    "select2d",
    "resetScale2d",
    "zoom"
  ]
}, T3 = (n) => {
  const o = Number(n);
  return Number.isFinite(o) ? o : void 0;
}, E3 = (n) => n === void 0 ? "N/A" : n, fp = (n) => (n == null ? void 0 : n.covariateName) || (n == null ? void 0 : n.fullCovariateName) || (n == null ? void 0 : n.name) || "", i8 = (n) => String(n ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"), xp = (n) => Array.isArray(n == null ? void 0 : n.records) ? n.records : Object.values((n == null ? void 0 : n.records) || {}), s8 = (n, o) => {
  if (!(!n || !o))
    return Array.isArray(n) ? n.find(
      (a) => String(a == null ? void 0 : a.cohortId) === String(o.id)
    ) : n[o.id] || n[String(o.id)];
}, gp = (n, o) => {
  const a = n || "Distribution";
  return o ? `${a} (${o})` : a;
}, yp = (n) => {
  const o = T3((n == null ? void 0 : n.min) ?? (n == null ? void 0 : n.minValue)), a = T3((n == null ? void 0 : n.max) ?? (n == null ? void 0 : n.maxValue)), i = T3((n == null ? void 0 : n.median) ?? (n == null ? void 0 : n.medianValue)), l = T3((n == null ? void 0 : n.p25) ?? (n == null ? void 0 : n.p25Value) ?? i), c = T3((n == null ? void 0 : n.p75) ?? (n == null ? void 0 : n.p75Value) ?? i), p = T3((n == null ? void 0 : n.p10) ?? (n == null ? void 0 : n.p10Value) ?? o), g = T3((n == null ? void 0 : n.p90) ?? (n == null ? void 0 : n.p90Value) ?? a);
  return {
    min: o,
    max: a,
    median: i,
    lif: p,
    q1: l,
    q3: c,
    uif: g
  };
}, vp = (n) => [n.min, n.max, n.median, n.q1, n.q3].every(
  (o) => o !== void 0
), bp = (n) => `${[
  n.covariateName && `<b>${i8(n.covariateName)}</b>`,
  n.strataName && n.strataName !== "All Stratas" && `Strata: ${i8(n.strataName)}`,
  `Max: ${E3(n.max)}`,
  `P90: ${E3(n.uif)}`,
  `P75: ${E3(n.q3)}`,
  `Median: ${E3(n.median)}`,
  `P25: ${E3(n.q1)}`,
  `P10: ${E3(n.lif)}`,
  `Min: ${E3(n.min)}`
].filter(Boolean).join("<br>")}<extra></extra>`, Cp = (n, o) => n.map((a) => {
  const i = a.color, l = [a.id];
  return [
    {
      type: "box",
      orientation: "h",
      name: a.cohortName,
      y: l,
      lowerfence: [a.lif],
      q1: [a.q1],
      median: [a.median],
      q3: [a.q3],
      upperfence: [a.uif],
      line: {
        color: i.stroke,
        width: 1
      },
      marker: {
        color: Ot(0.35, i.fill),
        line: {
          color: i.stroke,
          width: 1
        }
      },
      hoverinfo: "skip",
      showlegend: !1
    },
    {
      type: "scatter",
      mode: "markers",
      x: [a.median ?? a.max ?? a.min],
      y: l,
      marker: {
        size: 12,
        opacity: 0
      },
      hovertemplate: bp(a),
      showlegend: !1
    },
    ...o ? [] : [
      {
        type: "scatter",
        mode: "markers",
        x: [a.min],
        y: l,
        marker: {
          color: i.stroke,
          size: 7,
          symbol: "circle"
        },
        hoverinfo: "skip",
        showlegend: !1
      },
      {
        type: "scatter",
        mode: "markers",
        x: [a.max],
        y: l,
        marker: {
          color: i.stroke,
          size: 7,
          symbol: "circle"
        },
        hoverinfo: "skip",
        showlegend: !1
      }
    ]
  ];
}).flat(), jp = ze((n) => {
  const { report: o, cohorts: a, items: i, records: l } = n, [c, p] = pe(
    []
  ), g = je(() => {
    var T, I, w, N, E, x;
    return i || [
      {
        covariateName: (I = (T = o.item) == null ? void 0 : T[0]) == null ? void 0 : I.covariateName,
        name: (N = (w = o.item) == null ? void 0 : w[0]) == null ? void 0 : N.name,
        records: l || ((x = (E = o.item) == null ? void 0 : E[0]) == null ? void 0 : x.records) || []
      }
    ];
  }, [i, l, o]), u = je(() => g.length ? g.map((T, I) => {
    var m;
    const w = xp(T), N = fp(T), E = ((m = s8(w, a == null ? void 0 : a[0])) == null ? void 0 : m.strataName) || "All Stratas", x = a.map((j, _) => {
      const z = s8(w, j);
      return {
        ...yp(z),
        id: `${I}-${j.id}`,
        cohortName: j.name,
        covariateName: N,
        strataName: E,
        color: Hn[_ % Hn.length]
      };
    }).filter(vp);
    return {
      id: `${I}-${N}-${E}`,
      title: gp(N, E),
      rows: x
    };
  }).filter((T) => T.rows.length) : [], [g, a]), d = je(
    () => u.slice(0, Wn).map((T) => T.id),
    [u]
  ), [f, b] = pe(
    d
  ), C = u.length > Wn;
  m1(() => {
    b(d);
  }, [d]), m1(() => {
    p(
      (T) => T.filter(
        (I) => u.some((w) => w.id === I)
      )
    );
  }, [u]);
  const v = (T) => {
    b(
      (I) => I.includes(T) ? I.filter((w) => w !== T) : [...I, T]
    );
  }, A = (T, I) => {
    p(
      (w) => I ? [.../* @__PURE__ */ new Set([...w, T])] : w.filter((N) => N !== T)
    );
  }, P = je(
    () => a.map((T, I) => ({
      name: T.name,
      color: Hn[I % Hn.length]
    })),
    [a]
  );
  return u.length ? /* @__PURE__ */ e.jsx(X, { sx: { py: 2, minWidth: 0 }, children: /* @__PURE__ */ e.jsxs(
    X,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          md: "minmax(620px, 1fr) 260px"
        },
        columnGap: 2,
        alignItems: "start"
      },
      children: [
        /* @__PURE__ */ e.jsx(X, { sx: { minWidth: 0, overflowX: "auto" }, children: u.map((T, I) => {
          const w = Math.max(
            pp,
            T.rows.length * up + dp
          ), N = c.includes(T.id), E = Cp(T.rows, N), x = !C || f.includes(T.id);
          return /* @__PURE__ */ e.jsxs(
            X,
            {
              sx: {
                mb: I === u.length - 1 ? 0 : 2.5,
                borderTop: C && I >= Wn ? "1px solid #e5e7eb" : void 0,
                pt: C && I >= Wn ? 1.25 : 0
              },
              children: [
                /* @__PURE__ */ e.jsxs(
                  X,
                  {
                    sx: {
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      minWidth: 620,
                      mb: x ? 0.5 : 0
                    },
                    children: [
                      C && /* @__PURE__ */ e.jsx(
                        Ye,
                        {
                          size: "small",
                          variant: "text",
                          onClick: () => v(T.id),
                          sx: {
                            flex: "0 0 auto",
                            minWidth: 24,
                            width: 24,
                            height: 24,
                            p: 0
                          },
                          "aria-label": x ? "Collapse" : "Expand",
                          title: x ? "Collapse" : "Expand",
                          children: /* @__PURE__ */ e.jsx(
                            t1,
                            {
                              iconName: x ? "collapse" : "add",
                              sx: { fontSize: 12 }
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        X,
                        {
                          sx: {
                            minWidth: 0,
                            flex: "1 1 auto",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: 12,
                            fontWeight: 600
                          },
                          title: T.title,
                          children: T.title
                        }
                      )
                    ]
                  }
                ),
                x && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx(X, { sx: { width: "100%", minWidth: 620, height: w }, children: /* @__PURE__ */ e.jsx(
                    cp,
                    {
                      data: E,
                      config: hp,
                      style: { width: "100%", height: "100%" },
                      layout: {
                        ...mp,
                        height: w
                      },
                      useResizeHandler: !0
                    }
                  ) }),
                  /* @__PURE__ */ e.jsxs(
                    X,
                    {
                      component: "label",
                      sx: {
                        display: "inline-flex",
                        alignItems: "center",
                        mt: 0.5,
                        fontSize: 12
                      },
                      children: [
                        /* @__PURE__ */ e.jsx(
                          S1,
                          {
                            checked: N,
                            onChange: (m) => A(T.id, m.target.checked),
                            size: "small",
                            sx: { mr: 1 }
                          }
                        ),
                        "Hide Min/Max"
                      ]
                    }
                  )
                ] })
              ]
            },
            `${T.id || "distribution"}-${I}`
          );
        }) }),
        /* @__PURE__ */ e.jsx(
          X,
          {
            sx: {
              mt: { xs: 2, md: 3.5 },
              minWidth: 0,
              fontSize: 12
            },
            children: P.map((T) => /* @__PURE__ */ e.jsxs(
              X,
              {
                sx: { display: "flex", alignItems: "center", mb: 0.75 },
                children: [
                  /* @__PURE__ */ e.jsx(
                    X,
                    {
                      sx: {
                        width: 8,
                        height: 8,
                        mr: 1,
                        borderRadius: "50%",
                        bgcolor: T.color.stroke,
                        flex: "0 0 auto"
                      }
                    }
                  ),
                  /* @__PURE__ */ e.jsx(X, { sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: T.name })
                ]
              },
              T.name
            ))
          }
        )
      ]
    }
  ) }) : null;
});
var R1 = /* @__PURE__ */ ((n) => (n.PREVALENCE = "PREVALENCE", n.DISTRIBUTION = "DISTRIBUTION", n))(R1 || {}), Oo = /* @__PURE__ */ ((n) => (n.PRESET = "PRESET", n))(Oo || {});
const Sp = Fe.div`
  width: 100%;
  height: 450px;
`;
ze((n) => {
  const { reports: o, cohorts: a, type: i } = n, l = w1(() => {
    switch (i) {
      case R1.PREVALENCE:
        return /* @__PURE__ */ e.jsx(sp, { reports: o || [], cohorts: a || [] });
      case R1.DISTRIBUTION: {
        const [c] = o;
        return /* @__PURE__ */ e.jsx(lp, { report: c || {}, cohorts: a || [] });
      }
      default:
        return /* @__PURE__ */ e.jsx(e.Fragment, {});
    }
  }, [o, a]);
  return /* @__PURE__ */ e.jsx(Sp, { children: l() });
});
const wp = Fe.div`
  .filter-containter {
    display: flex;
    gap: 12px;

    .c-filter-panel {
      min-width: 300px;
    }
  }
`;
var Zn = /* @__PURE__ */ ((n) => (n.COHORTS = "cohorts", n.ANALYSES = "reports", n.DOMAINS = "domains", n))(Zn || {});
const Lr = (n = [], o = null, a = null, i = !1) => n.map((l) => {
  const c = (l == null ? void 0 : l[a]) ?? (l == null ? void 0 : l.name) ?? (l == null ? void 0 : l.realNameAnalysis) ?? (l == null ? void 0 : l.analysisName) ?? (l == null ? void 0 : l.designName) ?? (l == null ? void 0 : l.domain) ?? (l == null ? void 0 : l.id) ?? (l == null ? void 0 : l.analysisId) ?? l, p = typeof c == "object" ? "" : String(c);
  return {
    value: (l == null ? void 0 : l[o]) ?? l,
    name: i ? Pd(p) : p
  };
}), Tp = (n) => {
  const { reports: o, cohorts: a, onFilterResults: i, value: l, status: c } = n, p = Lr(
    a,
    "id",
    "name"
  ), g = Lr(
    o,
    "analysisId",
    "realNameAnalysis"
  ), u = Lr(
    z4(o, "domain"),
    "domain",
    "domain",
    !0
  ), d = [
    {
      type: "multiselect",
      name: "cohorts",
      label: "Cohorts",
      options: p
    },
    {
      type: "multiselect",
      name: "reports",
      label: "Analyses",
      options: g
    },
    {
      type: "multiselect",
      name: "domains",
      label: "Domains",
      options: u
    }
  ], f = (C, v) => {
    switch (C) {
      case Zn.COHORTS:
        i(
          C,
          v.length ? a.filter((A) => v.includes(A.id)) : []
        );
        break;
      case Zn.ANALYSES:
        i(
          C,
          v.length ? o.filter(
            (A) => v.includes(A.analysisId)
          ) : []
        );
        break;
      case Zn.DOMAINS:
        i(C, v);
        break;
    }
  }, b = Object.keys(l).reduce((C, v) => (C[v] = l[v].map(
    (A) => (A == null ? void 0 : A.value) || (A == null ? void 0 : A.analysisId) || (A == null ? void 0 : A.id) || A
  ), C), {});
  return /* @__PURE__ */ e.jsx(wp, { children: /* @__PURE__ */ e.jsx(
    id,
    {
      showLabel: !0,
      filters: d,
      hiddenTags: !0,
      value: b,
      className: "filter-containter",
      onChange: f,
      isReloading: c === c3.IN_PROGRESS
    }
  ) });
}, Io = (n) => {
  const { report: o, cohorts: a, items: i, records: l } = n;
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
    jp,
    {
      report: o || {},
      cohorts: a || [],
      items: i,
      records: l
    }
  ) });
};
function a5(n) {
  return n == null ? "" : n.replace(/([A-Z])/g, " $1").trim();
}
const h2 = Fe.div`
  background: #ffffff;
  padding: 5px;
`, Ro = (n) => {
  if (n.active && n.payload && n.payload.length) {
    const o = parseFloat(n.payload[0].value) < 100 ? n.payload[0].value : parseInt(n.payload[0].value), a = n.payload[0].payload;
    return /* @__PURE__ */ e.jsxs(h2, { children: [
      /* @__PURE__ */ e.jsx(tt, { name: "series", textLabel: "Series", inline: !0, children: ": " + a5(a == null ? void 0 : a.analysisType) }),
      /* @__PURE__ */ e.jsx(tt, { name: "covariate", textLabel: "Covariate", inline: !0, children: ": " + a5(a == null ? void 0 : a.tooltip) }),
      /* @__PURE__ */ e.jsxs(
        tt,
        {
          name: n.payload[0].payload.name,
          textLabel: "Pct, %",
          inline: !0,
          children: [
            ": " + o,
            "%"
          ]
        }
      )
    ] });
  }
  return null;
}, Ep = (n) => n.active && n.payload && n.payload.length ? /* @__PURE__ */ e.jsx(h2, { children: /* @__PURE__ */ e.jsx(
  tt,
  {
    name: n.payload[0].payload.name,
    textLabel: n.payload[0].payload.name,
    children: n.labelField ? n.payload[0].payload[n.labelField] : n.payload[0].value
  }
) }) : null, Ap = (n) => /* @__PURE__ */ e.jsxs("g", { children: [
  /* @__PURE__ */ e.jsx(
    Vd,
    {
      x: n.x,
      y: n.y,
      width: n.width,
      height: n.height,
      fill: n.fill
    }
  ),
  /* @__PURE__ */ e.jsx(
    Ud,
    {
      angle: 90,
      x: n.x + n.width / 3.5,
      y: n.y + n.height - 10,
      fontSize: 12,
      fill: "#333",
      textAnchor: "end",
      dominantBaseline: "start",
      children: n.name
    }
  )
] }), No = ze((n) => {
  const { list: o, cohort: a } = n, i = Math.floor(450 / 6.8), l = je(() => o.map((c) => {
    var p, g, u, d;
    return {
      analysisType: c == null ? void 0 : c.analysisType,
      name: ((p = c.covariateName) == null ? void 0 : p.length) > i ? c.covariateName.slice(0, i) + "..." : c.covariateName,
      tooltip: c.covariateName,
      pct: ((((g = c.records[a.id]) == null ? void 0 : g.avg) || ((d = (u = c.records[a.id]) == null ? void 0 : u[0]) == null ? void 0 : d.avg)) * 100).toFixed(3)
    };
  }), [o]);
  return /* @__PURE__ */ e.jsx(R3, { height: 470, children: /* @__PURE__ */ e.jsxs(
    d2,
    {
      data: l,
      margin: {
        top: 15,
        right: 10,
        left: 10,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ e.jsx(U4, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ e.jsx(
          G4,
          {
            dataKey: "name",
            tickCount: 0,
            tick: !1,
            label: {
              value: "Covariate",
              position: "insideBottom",
              offset: 10,
              fontSize: "13px"
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          K4,
          {
            unit: "%",
            tickSize: 1,
            domain: [0, 100],
            label: {
              value: "Pct, %",
              angle: -90,
              offset: 20,
              position: "insideLeft",
              fontSize: "13px"
            },
            tick: { fontSize: "13px" }
          }
        ),
        /* @__PURE__ */ e.jsx(
          h3,
          {
            content: /* @__PURE__ */ e.jsx(Ro, {}),
            cursor: { fill: Ot(0.8, no(0.2, "#ebeef4")) }
          }
        ),
        /* @__PURE__ */ e.jsx(
          p2,
          {
            dataKey: "pct",
            fill: Ot(0.3, "#7ba9ff"),
            shape: /* @__PURE__ */ e.jsx(Ap, {})
          }
        ),
        l.length > 20 && /* @__PURE__ */ e.jsx(To, { dataKey: "name", height: 20, stroke: "#7ba9ff" })
      ]
    }
  ) });
}), Dy = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], J3 = {
  COLORS: ["#7ba9ff", "#ff9315", "#55DBCB", "#DC6BAD"],
  RADIAN: Math.PI / 180
}, _p = ({
  cx: n,
  cy: o,
  midAngle: a,
  innerRadius: i,
  outerRadius: l,
  percent: c,
  index: p
}) => {
  const g = i + (l - i) * 0.5, u = n + g * Math.cos(-a * J3.RADIAN), d = o + g * Math.sin(-a * J3.RADIAN);
  return /* @__PURE__ */ e.jsx(
    "text",
    {
      x: u,
      y: d,
      fill: "white",
      textAnchor: u > n ? "start" : "end",
      dominantBaseline: "central",
      children: `${(c * 100).toFixed(2)}%`
    }
  );
}, Fo = ze((n) => {
  const { list: o, cohort: a, addNA: i } = n, l = je(() => {
    let c = [];
    if (c = o.map((p) => {
      var g, u, d, f;
      return {
        name: p.covariateName,
        value: parseFloat(
          ((((g = p.records[a.id]) == null ? void 0 : g.avg) || ((d = (u = p.records[a.id]) == null ? void 0 : u[0]) == null ? void 0 : d.avg)) * 100).toFixed(2)
        ),
        count: (f = p.records[a.id]) == null ? void 0 : f.count
      };
    }), i) {
      const p = parseFloat(
        (o.reduce(
          (g, u) => {
            var d, f, b;
            return g + (((d = u.records[a.id]) == null ? void 0 : d.avg) || ((b = (f = u.records[a.id]) == null ? void 0 : f[0]) == null ? void 0 : b.avg));
          },
          0
        ) * 100).toFixed(2)
      );
      if (p < 100) {
        const g = parseFloat((100 - p).toFixed(2));
        c.push({
          name: "N/A",
          value: g,
          count: ""
        });
      }
    }
    return c;
  }, [o]);
  return /* @__PURE__ */ e.jsx(R3, { height: 450, children: /* @__PURE__ */ e.jsxs(Eo, { children: [
    /* @__PURE__ */ e.jsx(
      Ao,
      {
        data: l,
        cx: "50%",
        cy: "50%",
        labelLine: !1,
        label: _p,
        fill: "#7ba9ff",
        dataKey: "value",
        children: l.map((c, p) => /* @__PURE__ */ e.jsx(
          m2,
          {
            fill: J3.COLORS[p % (J3.COLORS.length - (p >= J3.COLORS.length ? J3.COLORS.length : 0))]
          },
          `cell-${p}`
        ))
      }
    ),
    /* @__PURE__ */ e.jsx(h3, { content: /* @__PURE__ */ e.jsx(Ep, { labelField: "count" }) })
  ] }) });
}), Pp = (n) => {
  const { active: o, payload: a } = n;
  if (o && a && a.length) {
    const i = a[0].payload;
    return /* @__PURE__ */ e.jsxs(h2, { children: [
      /* @__PURE__ */ e.jsx(tt, { name: "series", textLabel: "Series", inline: !0, children: ": " + a5(i == null ? void 0 : i.analysisType) }),
      /* @__PURE__ */ e.jsx(tt, { name: "covariate", textLabel: "Covariate", inline: !0, children: ": " + a5(i == null ? void 0 : i.covariateName) }),
      a.map((l, c) => /* @__PURE__ */ e.jsxs(tt, { name: l == null ? void 0 : l.name, textLabel: l == null ? void 0 : l.name, inline: !0, children: [
        ": " + parseFloat(l == null ? void 0 : l.value).toFixed(2),
        l == null ? void 0 : l.unit
      ] }, c))
    ] });
  }
  return null;
}, Op = (n, o, a) => {
  if (a)
    switch (n.analysisType) {
      case "ConditionEraAnyTimePrior":
        return "#7ba9ff";
      case "DrugGroupEraAnyTimePrior":
        return "#7bffa4";
      case "ConditionGroupEraAnyTimePrior":
        return "#ff7b7b";
      case "MeasurementAnyTimePrior":
        return "#fcff7b";
      case "DrugExposureAnyTimePrior":
        return "#af7bff";
      case "ConditionOccurrenceAnyTimePrior":
        return "#ff7be2";
      case "DemographicsEthnicity":
        return "#ff4c4c";
      case "DemographicsAgeGroup":
        return "#6a4cff";
      case "DemographicsGender":
        return "#4cffef";
      case "DrugEraAnyTimePrior":
        return "#11ad07";
      case "CharlsonIndex":
        return "#6a7105";
      case "DemographicsAge":
        return "#a886b5";
      case "Chads2":
        return "#343434";
    }
  return "#7ba9ff";
}, Do = ze((n) => {
  const { list: o, cohorts: a, allResults: i, fullList: l } = n, [c, p] = pe({ width: 0, height: 0 }), g = Math.floor(c.width / 9), u = Math.floor(c.height / 9), d = je(() => o.map((C) => {
    var v, A, P, T, I, w, N, E, x, m, j, _, z, Y;
    return {
      analysisType: C == null ? void 0 : C.analysisType,
      covariateName: C == null ? void 0 : C.covariateName,
      xValue: ((((P = (A = C == null ? void 0 : C.records) == null ? void 0 : A[(v = a[0]) == null ? void 0 : v.id]) == null ? void 0 : P.avg) || ((N = (w = (I = C == null ? void 0 : C.records) == null ? void 0 : I[(T = a[0]) == null ? void 0 : T.id]) == null ? void 0 : w[0]) == null ? void 0 : N.avg)) * 100 || 0).toFixed(3),
      yValue: ((((m = (x = C == null ? void 0 : C.records) == null ? void 0 : x[(E = a[1]) == null ? void 0 : E.id]) == null ? void 0 : m.avg) || ((Y = (z = (_ = C == null ? void 0 : C.records) == null ? void 0 : _[(j = a[1]) == null ? void 0 : j.id]) == null ? void 0 : z[0]) == null ? void 0 : Y.avg)) * 100 || 0).toFixed(3)
    };
  }), [o, a]), f = je(() => {
    if (i && a.length > 1) {
      const C = Object.keys(l).map((v) => l[v].map((P) => {
        var T, I, w, N, E, x, m, j, _, z, Y, W, D, F;
        return {
          analysisType: P == null ? void 0 : P.analysisType,
          covariateName: P == null ? void 0 : P.covariateName,
          xValue: ((((w = (I = P == null ? void 0 : P.records) == null ? void 0 : I[(T = a[0]) == null ? void 0 : T.id]) == null ? void 0 : w.avg) || ((m = (x = (E = P == null ? void 0 : P.records) == null ? void 0 : E[(N = a[0]) == null ? void 0 : N.id]) == null ? void 0 : x[0]) == null ? void 0 : m.avg)) * 100 || 0).toFixed(3),
          yValue: ((((z = (_ = P == null ? void 0 : P.records) == null ? void 0 : _[(j = a[1]) == null ? void 0 : j.id]) == null ? void 0 : z.avg) || ((F = (D = (W = P == null ? void 0 : P.records) == null ? void 0 : W[(Y = a[1]) == null ? void 0 : Y.id]) == null ? void 0 : D[0]) == null ? void 0 : F.avg)) * 100 || 0).toFixed(3)
        };
      }));
      return Od(C);
    }
  }, [a, i, l]), b = w1((C, v) => (C == null ? void 0 : C.length) > v ? C.slice(0, v) + "..." : C, []);
  return /* @__PURE__ */ e.jsx(
    R3,
    {
      height: 450,
      onResize: (C, v) => p({ width: C, height: v }),
      children: /* @__PURE__ */ e.jsxs(
        Gd,
        {
          margin: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          },
          children: [
            /* @__PURE__ */ e.jsx(U4, {}),
            /* @__PURE__ */ e.jsx(
              K4,
              {
                label: {
                  value: b(a[1].name, u),
                  angle: -90,
                  position: "innerLeft",
                  fontSize: "13px",
                  dx: -20
                },
                name: a[1].name,
                type: "number",
                dataKey: "yValue",
                unit: "%",
                width: 40,
                tick: { fontSize: "13px" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              G4,
              {
                label: {
                  value: b(a[0].name, g),
                  position: "insideBottom",
                  fontSize: "13px",
                  dy: 15
                },
                type: "number",
                dataKey: "xValue",
                name: a[0].name,
                unit: "%",
                height: 30,
                width: c.width,
                tick: { fontSize: "13px" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              h3,
              {
                cursor: { strokeDasharray: "3 3" },
                content: /* @__PURE__ */ e.jsx(Pp, {})
              }
            ),
            /* @__PURE__ */ e.jsx(
              Kd,
              {
                name: "",
                data: i ? f : d,
                fill: "#7ba9ff",
                children: f && f.map((C, v) => /* @__PURE__ */ e.jsx(
                  m2,
                  {
                    fill: Op(C, v, i)
                  },
                  `cell-${v}`
                ))
              }
            )
          ]
        }
      )
    }
  );
}), Lo = (n, o = 10) => {
  const a = {};
  let i = 0;
  const l = n.length, c = l / o, p = parseInt(c) + (l % o > 0 ? 1 : 0);
  return n.forEach((g, u) => {
    i = Math.floor(u / o), a[i] || (a[i] = []), a[i].push(g);
  }), {
    list: a,
    countElements: l,
    countPage: p
  };
}, Ip = (n) => {
  const { payload: o, mapper: a } = n;
  return /* @__PURE__ */ e.jsx(X, { ml: 6, display: "flex", justifyContent: "space-around", flexWrap: "wrap", children: o.map((i, l) => /* @__PURE__ */ e.jsx(
    X,
    {
      sx: {
        fontSize: 13,
        color: i.color,
        lineHeight: "12px",
        mb: 1,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        "::before": {
          content: '""',
          height: "8px",
          width: "8px",
          backgroundColor: i.color,
          borderRadius: "50%",
          display: "inline-block",
          mr: 1
        }
      },
      children: a[i.value] || i.value
    },
    `item-${l}`
  )) });
}, Pt = ["#7ba9ff", "#ff9315", "#DC6BAD", "#55DBCB"], Mo = ze((n) => {
  const { list: o, cohorts: a, xAxisTickFormatter: i } = n, l = je(() => o.map((c) => ({
    analysisType: c == null ? void 0 : c.analysisType,
    name: c.covariateName,
    ...a.reduce((p, g) => {
      var u, d, f;
      return p[g.id] = ((((u = c.records[g.id]) == null ? void 0 : u.avg) || ((f = (d = c.records[g.id]) == null ? void 0 : d[0]) == null ? void 0 : f.avg)) * 100).toFixed(3), p;
    }, {})
  })), [o]);
  return /* @__PURE__ */ e.jsx(R3, { height: 470, children: /* @__PURE__ */ e.jsxs(
    d2,
    {
      data: l,
      margin: {
        top: 20,
        right: 10,
        left: 10,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ e.jsx(U4, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ e.jsx(
          G4,
          {
            dataKey: "name",
            fontSize: 12,
            tickFormatter: i
          }
        ),
        /* @__PURE__ */ e.jsx(
          K4,
          {
            unit: "%",
            tickSize: 1,
            domain: [0, 100],
            label: {
              value: "Pct, %",
              angle: -90,
              position: "innerLeft",
              fontSize: "13px",
              dx: -20
            },
            fontSize: 14
          }
        ),
        /* @__PURE__ */ e.jsx(
          Yd,
          {
            align: "center",
            iconType: "circle",
            content: (c) => /* @__PURE__ */ e.jsx(
              Ip,
              {
                ...c,
                mapper: a.reduce(
                  (p, g) => ({ ...p, [g.id]: g.name }),
                  {}
                )
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(h3, { content: /* @__PURE__ */ e.jsx(Ro, {}) }),
        a.map((c, p) => /* @__PURE__ */ e.jsx(
          p2,
          {
            dataKey: c.id,
            fill: p >= Pt.length ? d5(
              `0.${p / (1 * Pt.length)}`,
              Pt[p % Pt.length]
            ) : Pt[p]
          }
        )),
        l.length > 20 && /* @__PURE__ */ e.jsx(To, { dataKey: "name", height: 20, stroke: "#7ba9ff" })
      ]
    }
  ) });
});
Fe.div`
  flex: 1;
  min-width: 60%;
  margin-right: 16px;
`;
const Jr = Fe.div`
  width: calc(100% - 16px);
  background: var(--bgcolor-dark);
  font-size: 14px;
  padding: 0;
  color: #333333;
  position: absolute;
  height: calc(100% - 8px);
  z-index: 1;
  top: 4px;

  &::after {
    content: '${(n) => n.label}';
    text-indent: 8px;
    line-height: 1.8em;
    display: block;
    width: ${(n) => n.width || 0}%;
    background: ${(n) => Ot(0.3, n.color || "#7ba9ff")};

    padding: 0;
    position: absolute;
    height: 100%;
    z-index: 2;
  }
`, Qr = Fe.div`
  z-index: 3;
  position: relative;
`, Rp = "CUSTOM_FE", l8 = (n) => n.find((o) => o != null && o !== ""), c8 = (n, o) => {
  const a = (o == null ? void 0 : o.faType) === Rp, i = l8([
    n.fullCovariateName,
    n.full_covariate_name
  ]), l = l8([
    n.covariateName,
    n.covariate_name,
    n.name
  ]);
  return a ? i ?? l ?? n.covariateId ?? "" : l ?? i ?? n.covariateId ?? "";
}, Np = (n, o, a) => {
  let i = [];
  switch (n) {
    case R1.PREVALENCE:
      i = ((o == null ? void 0 : o.item) || []).map((l) => {
        const c = l.analysisType || a, p = c8(l, o), g = (l.records || []).reduce((u, d) => {
          const f = d.cohortId, b = d.strataId ?? 0;
          return u[f] || (u[f] = {}), u[f][b] || (u[f][b] = d), u;
        }, {});
        return {
          ...l,
          covariateName: p,
          analysisType: c,
          records: g
        };
      });
      break;
    case R1.DISTRIBUTION:
      ((o == null ? void 0 : o.item) || []).map((l) => {
        const c = l.analysisType || a, p = c8(l, o);
        let g = {};
        Object.entries(
          mo(l.records || [], (u) => u.strataId || 0)
        ).forEach(([u, d]) => {
          g[u] = {
            covariateName: p,
            conceptId: l.conceptId,
            analysisType: c,
            records: Yt(d, "cohortId")
          };
        }), i.push(...Object.values(g));
      });
      break;
  }
  return i;
}, Fp = (n, o, a, i = !0, l = !1, c = !1) => {
  const p = (u) => {
    if (u == null || u === "") return 0;
    const d = Number(u);
    return Number.isNaN(d) ? 0 : d;
  };
  let g = [];
  switch (n) {
    case R1.PREVALENCE:
      g = [
        {
          header: "Covariate",
          id: "covariateName",
          accessorKey: "covariateName",
          minSize: 120,
          size: 180,
          maxSize: 500,
          meta: {
            filterVariant: "value"
          }
          // sortType: sortByString('covariateName'),
        },
        {
          header: "Concept Id",
          id: "conceptId",
          accessorKey: "conceptId",
          maxSize: 120,
          minSize: 80,
          enableColumnFilter: !1,
          cell: ({ getValue: u }) => /* @__PURE__ */ e.jsx(ao, { to: `modal/related/${u()}`, children: u() })
        },
        ...o.map((u, d) => ({
          header: /* @__PURE__ */ e.jsx(X, { sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: u.name }),
          id: u.id,
          // align: 'center',
          // disableSortBy: true,
          columns: [
            ...c ? [] : [
              {
                header: "Count",
                id: `records___${u.id}.0.count`,
                accessorFn: (f) => {
                  var b, C, v;
                  return p((v = (C = (b = f == null ? void 0 : f.records) == null ? void 0 : b[u.id]) == null ? void 0 : C[0]) == null ? void 0 : v.count);
                },
                minSize: 60,
                size: 80,
                maxSize: 150,
                cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
                enableColumnFilter: !1,
                sortingFn: "basic"
              },
              {
                header: "Pct, %",
                id: `avg___${d}`,
                accessorFn: (f) => {
                  var b, C, v;
                  return p((v = (C = (b = f == null ? void 0 : f.records) == null ? void 0 : b[u.id]) == null ? void 0 : C[0]) == null ? void 0 : v.avg);
                },
                maxSize: 150,
                size: 80,
                minSize: 60,
                enableColumnFilter: !1,
                sortingFn: "basic",
                cell: ({ getValue: f }) => {
                  const b = (f() || 0) * 100, C = oe(b, 2, 2);
                  return /* @__PURE__ */ e.jsx(e.Fragment, { children: i ? /* @__PURE__ */ e.jsx(
                    Jr,
                    {
                      width: b,
                      label: `${C}%`
                    }
                  ) : /* @__PURE__ */ e.jsx(Qr, { children: `${C}%` }) });
                }
              }
            ],
            ...a ? a == null ? void 0 : a.map((f) => ({
              header: f.name,
              id: Math.abs(f.id),
              columns: [
                {
                  header: "Count",
                  id: `records___[${u.id}].${Math.abs(
                    f.id
                  )}.count`,
                  accessorFn: (b) => {
                    var C, v, A;
                    return p(
                      (A = (v = (C = b == null ? void 0 : b.records) == null ? void 0 : C[u.id]) == null ? void 0 : v[Math.abs(f.id)]) == null ? void 0 : A.count
                    );
                  },
                  cell: ({ getValue: b }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(b()) }),
                  minSize: 60,
                  size: 80,
                  enableColumnFilter: !1,
                  sortingFn: "basic"
                },
                {
                  header: "Pct, %",
                  id: `records___[${u.id}].${Math.abs(
                    f.id
                  )}.avg`,
                  accessorFn: (b) => {
                    var C, v, A;
                    return p(
                      (A = (v = (C = b == null ? void 0 : b.records) == null ? void 0 : C[u.id]) == null ? void 0 : v[Math.abs(f.id)]) == null ? void 0 : A.avg
                    );
                  },
                  minSize: 60,
                  size: 80,
                  enableColumnFilter: !1,
                  sortingFn: "basic",
                  // sortType: sortByNumber,
                  cell: ({ getValue: b }) => {
                    const C = (b() || 0) * 100, v = oe(C, 2, 2);
                    return /* @__PURE__ */ e.jsx(e.Fragment, { children: i ? /* @__PURE__ */ e.jsx(
                      Jr,
                      {
                        width: C,
                        label: `${v}%`
                      }
                    ) : /* @__PURE__ */ e.jsx(Qr, { children: `${v}%` }) });
                  }
                }
              ]
            })) : []
          ]
        })),
        ...o.length === 2 && !(a != null && a.length) && !l ? [
          {
            header: "Std diff",
            id: "stdDiff",
            size: 80,
            maxSize: 80,
            enableColumnFilter: !1,
            cell: ({ row: u }) => {
              const d = u8(
                Object.values(u.original.records).map((f) => f[0])
              );
              return oe(d, 4, 4);
            }
          }
        ] : []
      ];
      break;
    case R1.DISTRIBUTION:
      g = [
        {
          header: "Strata",
          id: "strataName",
          accessorFn: (u) => {
            var d, f;
            return ((f = (d = u == null ? void 0 : u.records) == null ? void 0 : d[o[0].id]) == null ? void 0 : f.strataName) || "All Stratas";
          },
          minSize: 100,
          size: 130,
          maxSize: 220,
          meta: {
            filterVariant: "value"
          }
        },
        {
          header: "Covariate",
          id: "covariateName",
          accessorKey: "covariateName",
          minSize: 120,
          size: 180,
          maxSize: 500,
          meta: {
            filterVariant: "value"
          }
          // sortType: sortByString('covariateName'),
        },
        ...o.map((u, d) => ({
          header: /* @__PURE__ */ e.jsx(X, { sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: u.name }),
          id: u.id,
          columns: [
            {
              header: "Persons",
              accessorKey: `records.${u.id}.count`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Avg",
              accessorKey: `records.${u.id}.avg`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Std Dev",
              accessorKey: `records.${u.id}.stdDev`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Min",
              accessorKey: `records.${u.id}.min`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P10",
              accessorKey: `records.${u.id}.p10`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P25",
              accessorKey: `records.${u.id}.p25`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Median",
              accessorKey: `records.${u.id}.median`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P75",
              accessorKey: `records.${u.id}.p75`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P90",
              accessorKey: `records.${u.id}.p90`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Max",
              accessorKey: `records.${u.id}.max`,
              cell: ({ getValue: f }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(f()) }),
              size: 70,
              enableColumnFilter: !1
            }
          ]
        })),
        ...o.length === 2 && !l ? [
          {
            header: "Std diff",
            id: "stdDiff",
            size: 80,
            maxSize: 80,
            enableColumnFilter: !1,
            cell: ({ row: u }) => {
              const d = u8(
                Object.values(u.original.records)
              );
              return oe(d, 4, 4);
            }
          }
        ] : []
      ];
  }
  return g;
}, u8 = (n) => {
  const o = n == null ? void 0 : n[0], a = n == null ? void 0 : n[1], i = Math.sqrt(
    ((o == null ? void 0 : o.diffValue) + (a == null ? void 0 : a.diffValue)) / 2
  );
  return i == 0 ? 0 : ((o == null ? void 0 : o.avg) - (a == null ? void 0 : a.avg)) / i;
}, Dp = (n) => {
  const {
    data: o,
    cohorts: a,
    analysis: i,
    subgroups: l,
    setChartData: c,
    resultType: p,
    strataOnly: g = !1,
    report: u,
    name: d
  } = n, f = je(() => Fp(
    p,
    a,
    l,
    o.length > 2,
    (i == null ? void 0 : i.type) === I3.BULK_COHORT_COUNTS || (i == null ? void 0 : i.type) === I3.FEASIBILITY,
    g
  ), [p, a, l, o.length, i == null ? void 0 : i.type, g]), b = p === R1.DISTRIBUTION ? {
    left: ["strataName", "covariateName"]
  } : void 0;
  return /* @__PURE__ */ e.jsx(
    X,
    {
      sx: {
        ".td": {
          height: 34
        }
      },
      children: /* @__PURE__ */ e.jsx(
        y1,
        {
          columns: f,
          data: o,
          withDuplicates: !0,
          enableFiltering: !0,
          getCurrentPage: c,
          pinnedColumns: b,
          defaultSorting: ((u == null ? void 0 : u.designName) === "DemographicsAgeGroup" || d === "Demographics Age Group") && (a != null && a.length) ? {
            id: `records___${a[0].id}.0.count`,
            desc: !1
          } : void 0
        }
      )
    }
  );
}, Lp = [
  {
    type: "Feature",
    properties: {
      name: "Fiji"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              178.12,
              -17.51
            ],
            [
              178.37,
              -17.34
            ],
            [
              178.72,
              -17.63
            ],
            [
              178.55,
              -18.15
            ],
            [
              177.93,
              -18.29
            ],
            [
              177.38,
              -18.16
            ],
            [
              177.29,
              -17.72
            ],
            [
              177.67,
              -17.38
            ],
            [
              178.12,
              -17.51
            ]
          ]
        ],
        [
          [
            [
              -180,
              -16.07
            ],
            [
              -179.79,
              -16.02
            ],
            [
              -179.92,
              -16.5
            ],
            [
              -180,
              -16.56
            ],
            [
              179.36,
              -16.8
            ],
            [
              178.73,
              -17.01
            ],
            [
              178.6,
              -16.64
            ],
            [
              179.1,
              -16.43
            ],
            [
              179.41,
              -16.38
            ],
            [
              180,
              -16.07
            ],
            [
              -180,
              -16.07
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Tanzania"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            33.9,
            -0.95
          ],
          [
            34.07,
            -1.06
          ],
          [
            37.7,
            -3.1
          ],
          [
            37.77,
            -3.68
          ],
          [
            39.2,
            -4.68
          ],
          [
            38.74,
            -5.91
          ],
          [
            38.8,
            -6.48
          ],
          [
            39.44,
            -6.84
          ],
          [
            39.47,
            -7.1
          ],
          [
            39.2,
            -7.7
          ],
          [
            39.25,
            -8.01
          ],
          [
            39.19,
            -8.49
          ],
          [
            39.54,
            -9.11
          ],
          [
            39.95,
            -10.1
          ],
          [
            40.32,
            -10.32
          ],
          [
            39.52,
            -10.9
          ],
          [
            38.43,
            -11.29
          ],
          [
            37.83,
            -11.27
          ],
          [
            37.47,
            -11.57
          ],
          [
            36.78,
            -11.6
          ],
          [
            36.51,
            -11.72
          ],
          [
            35.31,
            -11.44
          ],
          [
            34.56,
            -11.52
          ],
          [
            34.28,
            -10.16
          ],
          [
            33.94,
            -9.69
          ],
          [
            33.74,
            -9.42
          ],
          [
            32.76,
            -9.23
          ],
          [
            32.19,
            -8.93
          ],
          [
            31.56,
            -8.76
          ],
          [
            31.16,
            -8.59
          ],
          [
            30.74,
            -8.34
          ],
          [
            30.2,
            -7.08
          ],
          [
            29.62,
            -6.52
          ],
          [
            29.42,
            -5.94
          ],
          [
            29.52,
            -5.42
          ],
          [
            29.34,
            -4.5
          ],
          [
            29.75,
            -4.45
          ],
          [
            30.12,
            -4.09
          ],
          [
            30.5,
            -3.57
          ],
          [
            30.75,
            -3.36
          ],
          [
            30.74,
            -3.03
          ],
          [
            30.53,
            -2.81
          ],
          [
            30.47,
            -2.41
          ],
          [
            30.76,
            -2.29
          ],
          [
            30.81,
            -1.7
          ],
          [
            30.42,
            -1.14
          ],
          [
            30.77,
            -1.01
          ],
          [
            31.87,
            -1.03
          ],
          [
            33.9,
            -0.95
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "W. Sahara"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -8.67,
            27.66
          ],
          [
            -8.66,
            27.59
          ],
          [
            -8.69,
            27.4
          ],
          [
            -8.69,
            25.88
          ],
          [
            -11.97,
            25.93
          ],
          [
            -11.94,
            23.37
          ],
          [
            -12.88,
            23.29
          ],
          [
            -13.12,
            22.77
          ],
          [
            -12.93,
            21.33
          ],
          [
            -16.85,
            21.33
          ],
          [
            -17.06,
            21
          ],
          [
            -17.02,
            21.42
          ],
          [
            -17,
            21.42
          ],
          [
            -14.75,
            21.5
          ],
          [
            -14.63,
            21.86
          ],
          [
            -14.22,
            22.31
          ],
          [
            -13.89,
            23.69
          ],
          [
            -12.5,
            24.77
          ],
          [
            -12.03,
            26.03
          ],
          [
            -11.72,
            26.1
          ],
          [
            -11.39,
            26.88
          ],
          [
            -10.55,
            26.99
          ],
          [
            -10.19,
            26.86
          ],
          [
            -9.74,
            26.86
          ],
          [
            -9.41,
            27.09
          ],
          [
            -8.79,
            27.12
          ],
          [
            -8.82,
            27.66
          ],
          [
            -8.67,
            27.66
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Canada"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -122.84,
              49
            ],
            [
              -122.98,
              49
            ],
            [
              -124.91,
              49.99
            ],
            [
              -125.63,
              50.42
            ],
            [
              -127.44,
              50.83
            ],
            [
              -127.99,
              51.72
            ],
            [
              -127.85,
              52.33
            ],
            [
              -129.13,
              52.76
            ],
            [
              -129.3,
              53.56
            ],
            [
              -130.51,
              54.29
            ],
            [
              -130.54,
              54.8
            ],
            [
              -129.98,
              55.28
            ],
            [
              -130.01,
              55.92
            ],
            [
              -131.71,
              56.55
            ],
            [
              -132.73,
              57.69
            ],
            [
              -133.35,
              58.41
            ],
            [
              -134.27,
              58.86
            ],
            [
              -134.95,
              59.27
            ],
            [
              -135.47,
              59.79
            ],
            [
              -136.48,
              59.46
            ],
            [
              -137.45,
              58.91
            ],
            [
              -138.34,
              59.56
            ],
            [
              -139.04,
              60
            ],
            [
              -140.01,
              60.28
            ],
            [
              -141,
              60.31
            ],
            [
              -140.99,
              66
            ],
            [
              -140.99,
              69.71
            ],
            [
              -139.12,
              69.47
            ],
            [
              -137.54,
              68.99
            ],
            [
              -136.5,
              68.9
            ],
            [
              -135.63,
              69.32
            ],
            [
              -134.42,
              69.63
            ],
            [
              -132.93,
              69.51
            ],
            [
              -131.43,
              69.94
            ],
            [
              -129.79,
              70.19
            ],
            [
              -129.11,
              69.78
            ],
            [
              -128.36,
              70.01
            ],
            [
              -128.14,
              70.48
            ],
            [
              -127.45,
              70.38
            ],
            [
              -125.75,
              69.48
            ],
            [
              -124.43,
              70.16
            ],
            [
              -124.29,
              69.4
            ],
            [
              -123.06,
              69.56
            ],
            [
              -122.68,
              69.86
            ],
            [
              -121.47,
              69.8
            ],
            [
              -119.94,
              69.38
            ],
            [
              -117.6,
              69.01
            ],
            [
              -116.23,
              68.84
            ],
            [
              -115.25,
              68.91
            ],
            [
              -113.9,
              68.4
            ],
            [
              -115.3,
              67.9
            ],
            [
              -113.5,
              67.69
            ],
            [
              -110.8,
              67.81
            ],
            [
              -109.95,
              67.98
            ],
            [
              -108.88,
              67.38
            ],
            [
              -107.79,
              67.89
            ],
            [
              -108.81,
              68.31
            ],
            [
              -108.17,
              68.65
            ],
            [
              -106.95,
              68.7
            ],
            [
              -106.15,
              68.8
            ],
            [
              -105.34,
              68.56
            ],
            [
              -104.34,
              68.02
            ],
            [
              -103.22,
              68.1
            ],
            [
              -101.45,
              67.65
            ],
            [
              -99.9,
              67.81
            ],
            [
              -98.44,
              67.78
            ],
            [
              -98.56,
              68.4
            ],
            [
              -97.67,
              68.58
            ],
            [
              -96.12,
              68.24
            ],
            [
              -96.13,
              67.29
            ],
            [
              -95.49,
              68.09
            ],
            [
              -94.69,
              68.06
            ],
            [
              -94.23,
              69.07
            ],
            [
              -95.31,
              69.68
            ],
            [
              -96.47,
              70.09
            ],
            [
              -96.39,
              71.19
            ],
            [
              -95.21,
              71.92
            ],
            [
              -93.89,
              71.76
            ],
            [
              -92.88,
              71.32
            ],
            [
              -91.52,
              70.19
            ],
            [
              -92.41,
              69.7
            ],
            [
              -90.55,
              69.5
            ],
            [
              -90.55,
              68.47
            ],
            [
              -89.21,
              69.26
            ],
            [
              -88.02,
              68.62
            ],
            [
              -88.32,
              67.87
            ],
            [
              -87.35,
              67.2
            ],
            [
              -86.31,
              67.92
            ],
            [
              -85.58,
              68.78
            ],
            [
              -85.52,
              69.88
            ],
            [
              -84.1,
              69.81
            ],
            [
              -82.62,
              69.66
            ],
            [
              -81.28,
              69.16
            ],
            [
              -81.22,
              68.67
            ],
            [
              -81.96,
              68.13
            ],
            [
              -81.26,
              67.6
            ],
            [
              -81.39,
              67.11
            ],
            [
              -83.35,
              66.41
            ],
            [
              -84.74,
              66.26
            ],
            [
              -85.77,
              66.56
            ],
            [
              -86.07,
              66.06
            ],
            [
              -87.03,
              65.21
            ],
            [
              -87.32,
              64.77
            ],
            [
              -88.48,
              64.1
            ],
            [
              -89.91,
              64.03
            ],
            [
              -90.7,
              63.61
            ],
            [
              -90.77,
              62.96
            ],
            [
              -91.93,
              62.84
            ],
            [
              -93.16,
              62.02
            ],
            [
              -94.24,
              60.9
            ],
            [
              -94.63,
              60.11
            ],
            [
              -94.69,
              58.95
            ],
            [
              -93.21,
              58.78
            ],
            [
              -92.76,
              57.85
            ],
            [
              -92.3,
              57.09
            ],
            [
              -90.9,
              57.29
            ],
            [
              -89.04,
              56.85
            ],
            [
              -88.04,
              56.47
            ],
            [
              -87.32,
              56
            ],
            [
              -86.07,
              55.72
            ],
            [
              -85.01,
              55.3
            ],
            [
              -83.36,
              55.25
            ],
            [
              -82.27,
              55.15
            ],
            [
              -82.44,
              54.28
            ],
            [
              -82.13,
              53.28
            ],
            [
              -81.4,
              52.16
            ],
            [
              -79.91,
              51.21
            ],
            [
              -79.14,
              51.53
            ],
            [
              -78.6,
              52.56
            ],
            [
              -79.12,
              54.14
            ],
            [
              -79.83,
              54.67
            ],
            [
              -78.23,
              55.14
            ],
            [
              -77.1,
              55.84
            ],
            [
              -76.54,
              56.53
            ],
            [
              -76.62,
              57.2
            ],
            [
              -77.3,
              58.05
            ],
            [
              -78.52,
              58.81
            ],
            [
              -77.34,
              59.85
            ],
            [
              -77.77,
              60.76
            ],
            [
              -78.11,
              62.32
            ],
            [
              -77.41,
              62.55
            ],
            [
              -75.7,
              62.28
            ],
            [
              -74.67,
              62.18
            ],
            [
              -73.84,
              62.44
            ],
            [
              -72.91,
              62.11
            ],
            [
              -71.68,
              61.53
            ],
            [
              -71.37,
              61.14
            ],
            [
              -69.59,
              61.06
            ],
            [
              -69.62,
              60.22
            ],
            [
              -69.29,
              58.96
            ],
            [
              -68.37,
              58.8
            ],
            [
              -67.65,
              58.21
            ],
            [
              -66.2,
              58.77
            ],
            [
              -65.25,
              59.87
            ],
            [
              -64.58,
              60.34
            ],
            [
              -63.81,
              59.44
            ],
            [
              -62.5,
              58.17
            ],
            [
              -61.4,
              56.97
            ],
            [
              -61.8,
              56.34
            ],
            [
              -60.47,
              55.78
            ],
            [
              -59.57,
              55.2
            ],
            [
              -57.98,
              54.95
            ],
            [
              -57.33,
              54.63
            ],
            [
              -56.94,
              53.78
            ],
            [
              -56.16,
              53.65
            ],
            [
              -55.76,
              53.27
            ],
            [
              -55.68,
              52.15
            ],
            [
              -56.41,
              51.77
            ],
            [
              -57.13,
              51.42
            ],
            [
              -58.78,
              51.07
            ],
            [
              -60.03,
              50.24
            ],
            [
              -61.72,
              50.08
            ],
            [
              -63.86,
              50.29
            ],
            [
              -65.36,
              50.3
            ],
            [
              -66.4,
              50.23
            ],
            [
              -67.24,
              49.51
            ],
            [
              -68.51,
              49.07
            ],
            [
              -69.95,
              47.74
            ],
            [
              -71.11,
              46.82
            ],
            [
              -70.26,
              46.99
            ],
            [
              -68.65,
              48.3
            ],
            [
              -66.55,
              49.13
            ],
            [
              -65.06,
              49.23
            ],
            [
              -64.17,
              48.74
            ],
            [
              -65.12,
              48.07
            ],
            [
              -64.8,
              46.99
            ],
            [
              -64.47,
              46.24
            ],
            [
              -63.17,
              45.74
            ],
            [
              -61.52,
              45.88
            ],
            [
              -60.52,
              47.01
            ],
            [
              -60.45,
              46.28
            ],
            [
              -59.8,
              45.92
            ],
            [
              -61.04,
              45.26
            ],
            [
              -63.25,
              44.67
            ],
            [
              -64.25,
              44.27
            ],
            [
              -65.36,
              43.55
            ],
            [
              -66.12,
              43.62
            ],
            [
              -66.16,
              44.47
            ],
            [
              -64.42,
              45.29
            ],
            [
              -66.03,
              45.26
            ],
            [
              -67.14,
              45.14
            ],
            [
              -67.79,
              45.7
            ],
            [
              -67.79,
              47.07
            ],
            [
              -68.23,
              47.35
            ],
            [
              -68.91,
              47.19
            ],
            [
              -69.24,
              47.45
            ],
            [
              -70,
              46.69
            ],
            [
              -70.3,
              45.91
            ],
            [
              -70.66,
              45.46
            ],
            [
              -71.08,
              45.31
            ],
            [
              -71.4,
              45.25
            ],
            [
              -71.51,
              45.01
            ],
            [
              -73.35,
              45.01
            ],
            [
              -74.87,
              45
            ],
            [
              -75.32,
              44.82
            ],
            [
              -76.38,
              44.1
            ],
            [
              -76.5,
              44.02
            ],
            [
              -76.82,
              43.63
            ],
            [
              -77.74,
              43.63
            ],
            [
              -78.72,
              43.62
            ],
            [
              -79.17,
              43.47
            ],
            [
              -79.01,
              43.27
            ],
            [
              -78.92,
              42.96
            ],
            [
              -78.94,
              42.86
            ],
            [
              -80.25,
              42.37
            ],
            [
              -81.28,
              42.21
            ],
            [
              -82.44,
              41.67
            ],
            [
              -82.69,
              41.67
            ],
            [
              -83.03,
              41.83
            ],
            [
              -83.14,
              41.98
            ],
            [
              -83.12,
              42.08
            ],
            [
              -82.9,
              42.43
            ],
            [
              -82.43,
              42.98
            ],
            [
              -82.14,
              43.57
            ],
            [
              -82.34,
              44.44
            ],
            [
              -82.55,
              45.35
            ],
            [
              -83.59,
              45.82
            ],
            [
              -83.47,
              45.99
            ],
            [
              -83.62,
              46.12
            ],
            [
              -83.89,
              46.12
            ],
            [
              -84.09,
              46.28
            ],
            [
              -84.14,
              46.51
            ],
            [
              -84.34,
              46.41
            ],
            [
              -84.61,
              46.44
            ],
            [
              -84.55,
              46.54
            ],
            [
              -84.78,
              46.64
            ],
            [
              -84.88,
              46.9
            ],
            [
              -85.65,
              47.22
            ],
            [
              -86.46,
              47.55
            ],
            [
              -87.44,
              47.94
            ],
            [
              -88.38,
              48.3
            ],
            [
              -89.27,
              48.02
            ],
            [
              -89.6,
              48.01
            ],
            [
              -90.83,
              48.27
            ],
            [
              -91.64,
              48.14
            ],
            [
              -92.61,
              48.45
            ],
            [
              -93.63,
              48.61
            ],
            [
              -94.33,
              48.67
            ],
            [
              -94.64,
              48.84
            ],
            [
              -94.82,
              49.39
            ],
            [
              -95.15,
              49.38
            ],
            [
              -95.16,
              49
            ],
            [
              -97.23,
              49
            ],
            [
              -100.65,
              49
            ],
            [
              -104.05,
              49
            ],
            [
              -107.05,
              49
            ],
            [
              -110.05,
              49
            ],
            [
              -113,
              49
            ],
            [
              -116.05,
              49
            ],
            [
              -117.03,
              49
            ],
            [
              -120,
              49
            ],
            [
              -122.84,
              49
            ]
          ]
        ],
        [
          [
            [
              -83.99,
              62.45
            ],
            [
              -83.25,
              62.91
            ],
            [
              -81.88,
              62.9
            ],
            [
              -81.9,
              62.71
            ],
            [
              -83.07,
              62.16
            ],
            [
              -83.77,
              62.18
            ],
            [
              -83.99,
              62.45
            ]
          ]
        ],
        [
          [
            [
              -79.77,
              72.8
            ],
            [
              -80.88,
              73.33
            ],
            [
              -80.83,
              73.69
            ],
            [
              -80.35,
              73.76
            ],
            [
              -78.06,
              73.65
            ],
            [
              -76.34,
              73.1
            ],
            [
              -76.25,
              72.83
            ],
            [
              -77.32,
              72.86
            ],
            [
              -78.39,
              72.88
            ],
            [
              -79.49,
              72.74
            ],
            [
              -79.77,
              72.8
            ]
          ]
        ],
        [
          [
            [
              -80.32,
              62.09
            ],
            [
              -79.93,
              62.38
            ],
            [
              -79.52,
              62.36
            ],
            [
              -79.27,
              62.16
            ],
            [
              -79.66,
              61.63
            ],
            [
              -80.1,
              61.72
            ],
            [
              -80.36,
              62.02
            ],
            [
              -80.32,
              62.09
            ]
          ]
        ],
        [
          [
            [
              -93.61,
              74.98
            ],
            [
              -94.16,
              74.59
            ],
            [
              -95.61,
              74.67
            ],
            [
              -96.82,
              74.93
            ],
            [
              -96.29,
              75.38
            ],
            [
              -94.85,
              75.65
            ],
            [
              -93.98,
              75.3
            ],
            [
              -93.61,
              74.98
            ]
          ]
        ],
        [
          [
            [
              -93.84,
              77.52
            ],
            [
              -94.29,
              77.49
            ],
            [
              -96.17,
              77.56
            ],
            [
              -96.44,
              77.83
            ],
            [
              -94.42,
              77.82
            ],
            [
              -93.72,
              77.63
            ],
            [
              -93.84,
              77.52
            ]
          ]
        ],
        [
          [
            [
              -96.75,
              78.77
            ],
            [
              -95.56,
              78.42
            ],
            [
              -95.83,
              78.06
            ],
            [
              -97.31,
              77.85
            ],
            [
              -98.12,
              78.08
            ],
            [
              -98.55,
              78.46
            ],
            [
              -98.63,
              78.87
            ],
            [
              -97.34,
              78.83
            ],
            [
              -96.75,
              78.77
            ]
          ]
        ],
        [
          [
            [
              -88.15,
              74.39
            ],
            [
              -89.77,
              74.52
            ],
            [
              -92.42,
              74.84
            ],
            [
              -92.77,
              75.39
            ],
            [
              -92.89,
              75.88
            ],
            [
              -93.89,
              76.32
            ],
            [
              -95.96,
              76.44
            ],
            [
              -97.12,
              76.75
            ],
            [
              -96.75,
              77.16
            ],
            [
              -94.68,
              77.1
            ],
            [
              -93.57,
              76.78
            ],
            [
              -91.6,
              76.78
            ],
            [
              -90.74,
              76.45
            ],
            [
              -90.97,
              76.07
            ],
            [
              -89.82,
              75.85
            ],
            [
              -89.19,
              75.61
            ],
            [
              -87.84,
              75.57
            ],
            [
              -86.38,
              75.48
            ],
            [
              -84.79,
              75.7
            ],
            [
              -82.75,
              75.78
            ],
            [
              -81.13,
              75.71
            ],
            [
              -80.06,
              75.34
            ],
            [
              -79.83,
              74.92
            ],
            [
              -80.46,
              74.66
            ],
            [
              -81.95,
              74.44
            ],
            [
              -83.23,
              74.56
            ],
            [
              -86.1,
              74.41
            ],
            [
              -88.15,
              74.39
            ]
          ]
        ],
        [
          [
            [
              -111.26,
              78.15
            ],
            [
              -109.85,
              78
            ],
            [
              -110.19,
              77.7
            ],
            [
              -112.05,
              77.41
            ],
            [
              -113.53,
              77.73
            ],
            [
              -112.73,
              78.05
            ],
            [
              -111.26,
              78.15
            ]
          ]
        ],
        [
          [
            [
              -110.96,
              78.8
            ],
            [
              -109.66,
              78.6
            ],
            [
              -110.88,
              78.41
            ],
            [
              -112.54,
              78.41
            ],
            [
              -112.52,
              78.55
            ],
            [
              -111.5,
              78.85
            ],
            [
              -110.96,
              78.8
            ]
          ]
        ],
        [
          [
            [
              -55.6,
              51.32
            ],
            [
              -56.13,
              50.69
            ],
            [
              -56.8,
              49.81
            ],
            [
              -56.14,
              50.15
            ],
            [
              -55.47,
              49.94
            ],
            [
              -55.82,
              49.59
            ],
            [
              -54.93,
              49.31
            ],
            [
              -54.47,
              49.56
            ],
            [
              -53.48,
              49.25
            ],
            [
              -53.79,
              48.52
            ],
            [
              -53.09,
              48.69
            ],
            [
              -52.96,
              48.16
            ],
            [
              -52.65,
              47.54
            ],
            [
              -53.07,
              46.66
            ],
            [
              -53.52,
              46.62
            ],
            [
              -54.18,
              46.81
            ],
            [
              -53.96,
              47.63
            ],
            [
              -54.24,
              47.75
            ],
            [
              -55.4,
              46.88
            ],
            [
              -56,
              46.92
            ],
            [
              -55.29,
              47.39
            ],
            [
              -56.25,
              47.63
            ],
            [
              -57.33,
              47.57
            ],
            [
              -59.27,
              47.6
            ],
            [
              -59.42,
              47.9
            ],
            [
              -58.8,
              48.25
            ],
            [
              -59.23,
              48.52
            ],
            [
              -58.39,
              49.13
            ],
            [
              -57.36,
              50.72
            ],
            [
              -56.74,
              51.29
            ],
            [
              -55.87,
              51.63
            ],
            [
              -55.41,
              51.59
            ],
            [
              -55.6,
              51.32
            ]
          ]
        ],
        [
          [
            [
              -83.88,
              65.11
            ],
            [
              -82.79,
              64.77
            ],
            [
              -81.64,
              64.45
            ],
            [
              -81.55,
              63.98
            ],
            [
              -80.82,
              64.06
            ],
            [
              -80.1,
              63.73
            ],
            [
              -80.99,
              63.41
            ],
            [
              -82.55,
              63.65
            ],
            [
              -83.11,
              64.1
            ],
            [
              -84.1,
              63.57
            ],
            [
              -85.52,
              63.05
            ],
            [
              -85.87,
              63.64
            ],
            [
              -87.22,
              63.54
            ],
            [
              -86.35,
              64.04
            ],
            [
              -86.23,
              64.82
            ],
            [
              -85.88,
              65.74
            ],
            [
              -85.16,
              65.66
            ],
            [
              -84.98,
              65.22
            ],
            [
              -84.46,
              65.37
            ],
            [
              -83.88,
              65.11
            ]
          ]
        ],
        [
          [
            [
              -78.77,
              72.35
            ],
            [
              -77.82,
              72.75
            ],
            [
              -75.61,
              72.24
            ],
            [
              -74.23,
              71.77
            ],
            [
              -74.1,
              71.33
            ],
            [
              -72.24,
              71.56
            ],
            [
              -71.2,
              70.92
            ],
            [
              -68.79,
              70.52
            ],
            [
              -67.92,
              70.12
            ],
            [
              -66.97,
              69.19
            ],
            [
              -68.81,
              68.72
            ],
            [
              -66.45,
              68.07
            ],
            [
              -64.86,
              67.85
            ],
            [
              -63.42,
              66.93
            ],
            [
              -61.85,
              66.86
            ],
            [
              -62.16,
              66.16
            ],
            [
              -63.92,
              65
            ],
            [
              -65.15,
              65.43
            ],
            [
              -66.72,
              66.39
            ],
            [
              -68.01,
              66.26
            ],
            [
              -68.14,
              65.69
            ],
            [
              -67.09,
              65.11
            ],
            [
              -65.73,
              64.65
            ],
            [
              -65.32,
              64.38
            ],
            [
              -64.67,
              63.39
            ],
            [
              -65.01,
              62.67
            ],
            [
              -66.27,
              62.95
            ],
            [
              -68.78,
              63.75
            ],
            [
              -67.37,
              62.88
            ],
            [
              -66.33,
              62.28
            ],
            [
              -66.17,
              61.93
            ],
            [
              -68.88,
              62.33
            ],
            [
              -71.02,
              62.91
            ],
            [
              -72.24,
              63.4
            ],
            [
              -71.89,
              63.68
            ],
            [
              -73.38,
              64.19
            ],
            [
              -74.84,
              64.68
            ],
            [
              -74.82,
              64.39
            ],
            [
              -77.71,
              64.23
            ],
            [
              -78.55,
              64.57
            ],
            [
              -77.9,
              65.31
            ],
            [
              -76.02,
              65.33
            ],
            [
              -73.96,
              65.46
            ],
            [
              -74.29,
              65.81
            ],
            [
              -73.95,
              66.31
            ],
            [
              -72.65,
              67.28
            ],
            [
              -72.93,
              67.73
            ],
            [
              -73.31,
              68.07
            ],
            [
              -74.84,
              68.55
            ],
            [
              -76.87,
              68.89
            ],
            [
              -76.23,
              69.15
            ],
            [
              -77.29,
              69.77
            ],
            [
              -78.17,
              69.83
            ],
            [
              -78.96,
              70.17
            ],
            [
              -79.49,
              69.87
            ],
            [
              -81.31,
              69.74
            ],
            [
              -84.94,
              69.97
            ],
            [
              -87.06,
              70.26
            ],
            [
              -88.68,
              70.41
            ],
            [
              -89.51,
              70.76
            ],
            [
              -88.47,
              71.22
            ],
            [
              -89.89,
              71.22
            ],
            [
              -90.2,
              72.24
            ],
            [
              -89.44,
              73.13
            ],
            [
              -88.41,
              73.54
            ],
            [
              -85.83,
              73.8
            ],
            [
              -86.56,
              73.16
            ],
            [
              -85.77,
              72.53
            ],
            [
              -84.85,
              73.34
            ],
            [
              -82.32,
              73.75
            ],
            [
              -80.6,
              72.72
            ],
            [
              -80.75,
              72.06
            ],
            [
              -78.77,
              72.35
            ]
          ]
        ],
        [
          [
            [
              -94.5,
              74.13
            ],
            [
              -92.42,
              74.1
            ],
            [
              -90.51,
              73.86
            ],
            [
              -92,
              72.97
            ],
            [
              -93.2,
              72.77
            ],
            [
              -94.27,
              72.02
            ],
            [
              -95.41,
              72.06
            ],
            [
              -96.03,
              72.94
            ],
            [
              -96.02,
              73.44
            ],
            [
              -95.5,
              73.86
            ],
            [
              -94.5,
              74.13
            ]
          ]
        ],
        [
          [
            [
              -122.86,
              76.12
            ],
            [
              -121.16,
              76.86
            ],
            [
              -119.11,
              77.51
            ],
            [
              -117.57,
              77.5
            ],
            [
              -116.2,
              77.65
            ],
            [
              -116.34,
              76.88
            ],
            [
              -117.11,
              76.53
            ],
            [
              -118.04,
              76.48
            ],
            [
              -119.9,
              76.05
            ],
            [
              -121.5,
              75.9
            ],
            [
              -122.86,
              76.12
            ]
          ]
        ],
        [
          [
            [
              -132.71,
              54.04
            ],
            [
              -131.75,
              54.12
            ],
            [
              -132.05,
              52.98
            ],
            [
              -131.18,
              52.18
            ],
            [
              -131.58,
              52.18
            ],
            [
              -132.18,
              52.64
            ],
            [
              -132.55,
              53.1
            ],
            [
              -133.06,
              53.41
            ],
            [
              -133.24,
              53.85
            ],
            [
              -133.18,
              54.17
            ],
            [
              -132.71,
              54.04
            ]
          ]
        ],
        [
          [
            [
              -105.49,
              79.3
            ],
            [
              -103.53,
              79.16
            ],
            [
              -100.82,
              78.8
            ],
            [
              -100.06,
              78.33
            ],
            [
              -99.67,
              77.91
            ],
            [
              -101.3,
              78.02
            ],
            [
              -102.95,
              78.34
            ],
            [
              -105.18,
              78.38
            ],
            [
              -104.21,
              78.68
            ],
            [
              -105.42,
              78.92
            ],
            [
              -105.49,
              79.3
            ]
          ]
        ],
        [
          [
            [
              -123.51,
              48.51
            ],
            [
              -124.01,
              48.37
            ],
            [
              -125.65,
              48.83
            ],
            [
              -125.96,
              49.18
            ],
            [
              -126.85,
              49.53
            ],
            [
              -127.03,
              49.81
            ],
            [
              -128.06,
              50
            ],
            [
              -128.44,
              50.54
            ],
            [
              -128.36,
              50.77
            ],
            [
              -127.31,
              50.55
            ],
            [
              -126.69,
              50.4
            ],
            [
              -125.75,
              50.29
            ],
            [
              -125.42,
              49.95
            ],
            [
              -124.92,
              49.48
            ],
            [
              -123.92,
              49.06
            ],
            [
              -123.51,
              48.51
            ]
          ]
        ],
        [
          [
            [
              -121.54,
              74.45
            ],
            [
              -120.11,
              74.24
            ],
            [
              -117.56,
              74.19
            ],
            [
              -116.59,
              73.9
            ],
            [
              -115.51,
              73.47
            ],
            [
              -116.77,
              73.22
            ],
            [
              -119.22,
              72.52
            ],
            [
              -120.46,
              71.82
            ],
            [
              -120.46,
              71.38
            ],
            [
              -123.09,
              70.9
            ],
            [
              -123.62,
              71.34
            ],
            [
              -125.93,
              71.87
            ],
            [
              -125.5,
              72.29
            ],
            [
              -124.81,
              73.02
            ],
            [
              -123.94,
              73.68
            ],
            [
              -124.92,
              74.29
            ],
            [
              -121.54,
              74.45
            ]
          ]
        ],
        [
          [
            [
              -107.82,
              75.85
            ],
            [
              -106.93,
              76.01
            ],
            [
              -105.88,
              75.97
            ],
            [
              -105.71,
              75.48
            ],
            [
              -106.31,
              75
            ],
            [
              -109.7,
              74.85
            ],
            [
              -112.22,
              74.42
            ],
            [
              -113.74,
              74.39
            ],
            [
              -113.87,
              74.72
            ],
            [
              -111.79,
              75.16
            ],
            [
              -116.31,
              75.04
            ],
            [
              -117.71,
              75.22
            ],
            [
              -116.35,
              76.2
            ],
            [
              -115.4,
              76.48
            ],
            [
              -112.59,
              76.14
            ],
            [
              -110.81,
              75.55
            ],
            [
              -109.07,
              75.47
            ],
            [
              -110.5,
              76.43
            ],
            [
              -109.58,
              76.79
            ],
            [
              -108.55,
              76.68
            ],
            [
              -108.21,
              76.2
            ],
            [
              -107.82,
              75.85
            ]
          ]
        ],
        [
          [
            [
              -106.52,
              73.08
            ],
            [
              -105.4,
              72.67
            ],
            [
              -104.77,
              71.7
            ],
            [
              -104.46,
              70.99
            ],
            [
              -102.79,
              70.5
            ],
            [
              -100.98,
              70.03
            ],
            [
              -101.09,
              69.59
            ],
            [
              -102.73,
              69.5
            ],
            [
              -102.09,
              69.12
            ],
            [
              -102.43,
              68.75
            ],
            [
              -104.24,
              68.91
            ],
            [
              -105.96,
              69.18
            ],
            [
              -107.12,
              69.12
            ],
            [
              -109,
              68.78
            ],
            [
              -111.53,
              68.63
            ],
            [
              -113.31,
              68.54
            ],
            [
              -113.86,
              69.01
            ],
            [
              -115.22,
              69.28
            ],
            [
              -116.11,
              69.17
            ],
            [
              -117.34,
              69.96
            ],
            [
              -116.68,
              70.07
            ],
            [
              -115.13,
              70.24
            ],
            [
              -113.72,
              70.19
            ],
            [
              -112.42,
              70.37
            ],
            [
              -114.35,
              70.6
            ],
            [
              -116.49,
              70.52
            ],
            [
              -117.91,
              70.54
            ],
            [
              -118.43,
              70.91
            ],
            [
              -116.11,
              71.31
            ],
            [
              -117.65,
              71.29
            ],
            [
              -119.4,
              71.56
            ],
            [
              -118.56,
              72.31
            ],
            [
              -117.87,
              72.71
            ],
            [
              -115.19,
              73.31
            ],
            [
              -114.17,
              73.12
            ],
            [
              -114.67,
              72.65
            ],
            [
              -112.44,
              72.95
            ],
            [
              -111.05,
              72.45
            ],
            [
              -109.92,
              72.96
            ],
            [
              -109.01,
              72.63
            ],
            [
              -108.19,
              71.65
            ],
            [
              -107.69,
              72.06
            ],
            [
              -108.4,
              73.09
            ],
            [
              -107.52,
              73.24
            ],
            [
              -106.52,
              73.08
            ]
          ]
        ],
        [
          [
            [
              -100.44,
              72.71
            ],
            [
              -101.54,
              73.36
            ],
            [
              -100.36,
              73.84
            ],
            [
              -99.16,
              73.63
            ],
            [
              -97.38,
              73.76
            ],
            [
              -97.12,
              73.47
            ],
            [
              -98.05,
              72.99
            ],
            [
              -96.54,
              72.56
            ],
            [
              -96.72,
              71.66
            ],
            [
              -98.36,
              71.27
            ],
            [
              -99.32,
              71.36
            ],
            [
              -100.01,
              71.74
            ],
            [
              -102.5,
              72.51
            ],
            [
              -102.48,
              72.83
            ],
            [
              -100.44,
              72.71
            ]
          ]
        ],
        [
          [
            [
              -106.6,
              73.6
            ],
            [
              -105.26,
              73.64
            ],
            [
              -104.5,
              73.42
            ],
            [
              -105.38,
              72.76
            ],
            [
              -106.94,
              73.46
            ],
            [
              -106.6,
              73.6
            ]
          ]
        ],
        [
          [
            [
              -98.5,
              76.72
            ],
            [
              -97.74,
              76.26
            ],
            [
              -97.7,
              75.74
            ],
            [
              -98.16,
              75
            ],
            [
              -99.81,
              74.9
            ],
            [
              -100.88,
              75.06
            ],
            [
              -100.86,
              75.64
            ],
            [
              -102.5,
              75.56
            ],
            [
              -102.57,
              76.34
            ],
            [
              -101.49,
              76.31
            ],
            [
              -99.98,
              76.65
            ],
            [
              -98.58,
              76.59
            ],
            [
              -98.5,
              76.72
            ]
          ]
        ],
        [
          [
            [
              -96.01,
              80.6
            ],
            [
              -95.32,
              80.91
            ],
            [
              -94.3,
              80.98
            ],
            [
              -94.74,
              81.21
            ],
            [
              -92.41,
              81.26
            ],
            [
              -91.13,
              80.72
            ],
            [
              -89.45,
              80.51
            ],
            [
              -87.81,
              80.32
            ],
            [
              -87.02,
              79.66
            ],
            [
              -85.82,
              79.34
            ],
            [
              -87.19,
              79.04
            ],
            [
              -89.03,
              78.29
            ],
            [
              -90.81,
              78.22
            ],
            [
              -92.88,
              78.34
            ],
            [
              -93.95,
              78.75
            ],
            [
              -93.94,
              79.11
            ],
            [
              -93.15,
              79.38
            ],
            [
              -94.97,
              79.37
            ],
            [
              -96.08,
              79.7
            ],
            [
              -96.71,
              80.16
            ],
            [
              -96.01,
              80.6
            ]
          ]
        ],
        [
          [
            [
              -91.59,
              81.9
            ],
            [
              -90.1,
              82.08
            ],
            [
              -88.93,
              82.12
            ],
            [
              -86.97,
              82.28
            ],
            [
              -85.5,
              82.65
            ],
            [
              -84.26,
              82.6
            ],
            [
              -83.18,
              82.32
            ],
            [
              -82.42,
              82.86
            ],
            [
              -81.1,
              83.02
            ],
            [
              -79.31,
              83.13
            ],
            [
              -76.25,
              83.17
            ],
            [
              -75.72,
              83.06
            ],
            [
              -72.83,
              83.23
            ],
            [
              -70.67,
              83.17
            ],
            [
              -68.5,
              83.11
            ],
            [
              -65.83,
              83.03
            ],
            [
              -63.68,
              82.9
            ],
            [
              -61.85,
              82.63
            ],
            [
              -61.89,
              82.36
            ],
            [
              -64.33,
              81.93
            ],
            [
              -66.75,
              81.73
            ],
            [
              -67.66,
              81.5
            ],
            [
              -65.48,
              81.51
            ],
            [
              -67.84,
              80.9
            ],
            [
              -69.47,
              80.62
            ],
            [
              -71.18,
              79.8
            ],
            [
              -73.24,
              79.63
            ],
            [
              -73.88,
              79.43
            ],
            [
              -76.91,
              79.32
            ],
            [
              -75.53,
              79.2
            ],
            [
              -76.22,
              79.02
            ],
            [
              -75.39,
              78.53
            ],
            [
              -76.34,
              78.18
            ],
            [
              -77.89,
              77.9
            ],
            [
              -78.36,
              77.51
            ],
            [
              -79.76,
              77.21
            ],
            [
              -79.62,
              76.98
            ],
            [
              -77.91,
              77.02
            ],
            [
              -77.89,
              76.78
            ],
            [
              -80.56,
              76.18
            ],
            [
              -83.17,
              76.45
            ],
            [
              -86.11,
              76.3
            ],
            [
              -87.6,
              76.42
            ],
            [
              -89.49,
              76.47
            ],
            [
              -89.62,
              76.95
            ],
            [
              -87.77,
              77.18
            ],
            [
              -88.26,
              77.9
            ],
            [
              -87.65,
              77.97
            ],
            [
              -84.98,
              77.54
            ],
            [
              -86.34,
              78.18
            ],
            [
              -87.96,
              78.37
            ],
            [
              -87.15,
              78.76
            ],
            [
              -85.38,
              79
            ],
            [
              -85.1,
              79.35
            ],
            [
              -86.51,
              79.74
            ],
            [
              -86.93,
              80.25
            ],
            [
              -84.2,
              80.21
            ],
            [
              -83.41,
              80.1
            ],
            [
              -81.85,
              80.46
            ],
            [
              -84.1,
              80.58
            ],
            [
              -87.6,
              80.52
            ],
            [
              -89.37,
              80.86
            ],
            [
              -90.2,
              81.26
            ],
            [
              -91.37,
              81.55
            ],
            [
              -91.59,
              81.9
            ]
          ]
        ],
        [
          [
            [
              -75.22,
              67.44
            ],
            [
              -75.87,
              67.15
            ],
            [
              -76.99,
              67.1
            ],
            [
              -77.24,
              67.59
            ],
            [
              -76.81,
              68.15
            ],
            [
              -75.89,
              68.29
            ],
            [
              -75.11,
              68.01
            ],
            [
              -75.1,
              67.58
            ],
            [
              -75.22,
              67.44
            ]
          ]
        ],
        [
          [
            [
              -96.26,
              69.49
            ],
            [
              -95.65,
              69.11
            ],
            [
              -96.27,
              68.76
            ],
            [
              -97.62,
              69.06
            ],
            [
              -98.43,
              68.95
            ],
            [
              -99.8,
              69.4
            ],
            [
              -98.92,
              69.71
            ],
            [
              -98.22,
              70.14
            ],
            [
              -97.16,
              69.86
            ],
            [
              -96.56,
              69.68
            ],
            [
              -96.26,
              69.49
            ]
          ]
        ],
        [
          [
            [
              -64.52,
              49.87
            ],
            [
              -64.17,
              49.96
            ],
            [
              -62.86,
              49.71
            ],
            [
              -61.84,
              49.29
            ],
            [
              -61.81,
              49.11
            ],
            [
              -62.29,
              49.09
            ],
            [
              -63.59,
              49.4
            ],
            [
              -64.52,
              49.87
            ]
          ]
        ],
        [
          [
            [
              -64.01,
              47.04
            ],
            [
              -63.66,
              46.55
            ],
            [
              -62.94,
              46.42
            ],
            [
              -62.01,
              46.44
            ],
            [
              -62.51,
              46.03
            ],
            [
              -62.87,
              45.97
            ],
            [
              -64.14,
              46.39
            ],
            [
              -64.39,
              46.73
            ],
            [
              -64.01,
              47.04
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "United States of America"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -122.84,
              49
            ],
            [
              -120,
              49
            ],
            [
              -117.03,
              49
            ],
            [
              -116.05,
              49
            ],
            [
              -113,
              49
            ],
            [
              -110.05,
              49
            ],
            [
              -107.05,
              49
            ],
            [
              -104.05,
              49
            ],
            [
              -100.65,
              49
            ],
            [
              -97.23,
              49
            ],
            [
              -95.16,
              49
            ],
            [
              -95.15,
              49.38
            ],
            [
              -94.82,
              49.39
            ],
            [
              -94.64,
              48.84
            ],
            [
              -94.33,
              48.67
            ],
            [
              -93.63,
              48.61
            ],
            [
              -92.61,
              48.45
            ],
            [
              -91.64,
              48.14
            ],
            [
              -90.83,
              48.27
            ],
            [
              -89.6,
              48.01
            ],
            [
              -89.27,
              48.02
            ],
            [
              -88.38,
              48.3
            ],
            [
              -87.44,
              47.94
            ],
            [
              -86.46,
              47.55
            ],
            [
              -85.65,
              47.22
            ],
            [
              -84.88,
              46.9
            ],
            [
              -84.78,
              46.64
            ],
            [
              -84.55,
              46.54
            ],
            [
              -84.61,
              46.44
            ],
            [
              -84.34,
              46.41
            ],
            [
              -84.14,
              46.51
            ],
            [
              -84.09,
              46.28
            ],
            [
              -83.89,
              46.12
            ],
            [
              -83.62,
              46.12
            ],
            [
              -83.47,
              45.99
            ],
            [
              -83.59,
              45.82
            ],
            [
              -82.55,
              45.35
            ],
            [
              -82.34,
              44.44
            ],
            [
              -82.14,
              43.57
            ],
            [
              -82.43,
              42.98
            ],
            [
              -82.9,
              42.43
            ],
            [
              -83.12,
              42.08
            ],
            [
              -83.14,
              41.98
            ],
            [
              -83.03,
              41.83
            ],
            [
              -82.69,
              41.67
            ],
            [
              -82.44,
              41.67
            ],
            [
              -81.28,
              42.21
            ],
            [
              -80.25,
              42.37
            ],
            [
              -78.94,
              42.86
            ],
            [
              -78.92,
              42.96
            ],
            [
              -79.01,
              43.27
            ],
            [
              -79.17,
              43.47
            ],
            [
              -78.72,
              43.62
            ],
            [
              -77.74,
              43.63
            ],
            [
              -76.82,
              43.63
            ],
            [
              -76.5,
              44.02
            ],
            [
              -76.38,
              44.1
            ],
            [
              -75.32,
              44.82
            ],
            [
              -74.87,
              45
            ],
            [
              -73.35,
              45.01
            ],
            [
              -71.51,
              45.01
            ],
            [
              -71.4,
              45.25
            ],
            [
              -71.08,
              45.31
            ],
            [
              -70.66,
              45.46
            ],
            [
              -70.3,
              45.91
            ],
            [
              -70,
              46.69
            ],
            [
              -69.24,
              47.45
            ],
            [
              -68.91,
              47.19
            ],
            [
              -68.23,
              47.35
            ],
            [
              -67.79,
              47.07
            ],
            [
              -67.79,
              45.7
            ],
            [
              -67.14,
              45.14
            ],
            [
              -66.97,
              44.81
            ],
            [
              -68.03,
              44.33
            ],
            [
              -69.06,
              43.98
            ],
            [
              -70.12,
              43.68
            ],
            [
              -70.65,
              43.09
            ],
            [
              -70.81,
              42.86
            ],
            [
              -70.83,
              42.33
            ],
            [
              -70.49,
              41.81
            ],
            [
              -70.08,
              41.78
            ],
            [
              -70.18,
              42.15
            ],
            [
              -69.89,
              41.92
            ],
            [
              -69.96,
              41.64
            ],
            [
              -70.64,
              41.48
            ],
            [
              -71.12,
              41.49
            ],
            [
              -71.86,
              41.32
            ],
            [
              -72.29,
              41.27
            ],
            [
              -72.88,
              41.22
            ],
            [
              -73.71,
              40.93
            ],
            [
              -72.24,
              41.12
            ],
            [
              -71.94,
              40.93
            ],
            [
              -73.35,
              40.63
            ],
            [
              -73.98,
              40.63
            ],
            [
              -73.95,
              40.75
            ],
            [
              -74.26,
              40.47
            ],
            [
              -73.96,
              40.43
            ],
            [
              -74.18,
              39.71
            ],
            [
              -74.91,
              38.94
            ],
            [
              -74.98,
              39.2
            ],
            [
              -75.2,
              39.25
            ],
            [
              -75.53,
              39.5
            ],
            [
              -75.32,
              38.96
            ],
            [
              -75.07,
              38.78
            ],
            [
              -75.06,
              38.4
            ],
            [
              -75.38,
              38.02
            ],
            [
              -75.94,
              37.22
            ],
            [
              -76.03,
              37.26
            ],
            [
              -75.72,
              37.94
            ],
            [
              -76.23,
              38.32
            ],
            [
              -76.35,
              39.15
            ],
            [
              -76.54,
              38.72
            ],
            [
              -76.33,
              38.08
            ],
            [
              -76.99,
              38.24
            ],
            [
              -76.3,
              37.92
            ],
            [
              -76.26,
              36.97
            ],
            [
              -75.97,
              36.9
            ],
            [
              -75.87,
              36.55
            ],
            [
              -75.73,
              35.55
            ],
            [
              -76.36,
              34.81
            ],
            [
              -77.4,
              34.51
            ],
            [
              -78.05,
              33.93
            ],
            [
              -78.55,
              33.86
            ],
            [
              -79.06,
              33.49
            ],
            [
              -79.2,
              33.16
            ],
            [
              -80.3,
              32.51
            ],
            [
              -80.87,
              32.03
            ],
            [
              -81.34,
              31.44
            ],
            [
              -81.49,
              30.73
            ],
            [
              -81.31,
              30.04
            ],
            [
              -80.98,
              29.18
            ],
            [
              -80.53,
              28.47
            ],
            [
              -80.53,
              28.04
            ],
            [
              -80.06,
              26.88
            ],
            [
              -80.09,
              26.21
            ],
            [
              -80.13,
              25.82
            ],
            [
              -80.38,
              25.21
            ],
            [
              -80.68,
              25.08
            ],
            [
              -81.17,
              25.2
            ],
            [
              -81.33,
              25.64
            ],
            [
              -81.71,
              25.87
            ],
            [
              -82.24,
              26.73
            ],
            [
              -82.71,
              27.49
            ],
            [
              -82.86,
              27.89
            ],
            [
              -82.65,
              28.55
            ],
            [
              -82.93,
              29.1
            ],
            [
              -83.71,
              29.94
            ],
            [
              -84.1,
              30.09
            ],
            [
              -85.11,
              29.64
            ],
            [
              -85.29,
              29.69
            ],
            [
              -85.77,
              30.15
            ],
            [
              -86.4,
              30.4
            ],
            [
              -87.53,
              30.27
            ],
            [
              -88.42,
              30.39
            ],
            [
              -89.18,
              30.32
            ],
            [
              -89.59,
              30.16
            ],
            [
              -89.41,
              29.89
            ],
            [
              -89.43,
              29.49
            ],
            [
              -89.22,
              29.29
            ],
            [
              -89.41,
              29.16
            ],
            [
              -89.78,
              29.31
            ],
            [
              -90.15,
              29.12
            ],
            [
              -90.88,
              29.15
            ],
            [
              -91.63,
              29.68
            ],
            [
              -92.5,
              29.55
            ],
            [
              -93.22,
              29.78
            ],
            [
              -93.85,
              29.71
            ],
            [
              -94.69,
              29.48
            ],
            [
              -95.6,
              28.74
            ],
            [
              -96.59,
              28.31
            ],
            [
              -97.14,
              27.83
            ],
            [
              -97.37,
              27.38
            ],
            [
              -97.38,
              26.69
            ],
            [
              -97.33,
              26.21
            ],
            [
              -97.14,
              25.87
            ],
            [
              -97.53,
              25.84
            ],
            [
              -98.24,
              26.06
            ],
            [
              -99.02,
              26.37
            ],
            [
              -99.3,
              26.84
            ],
            [
              -99.52,
              27.54
            ],
            [
              -100.11,
              28.11
            ],
            [
              -100.46,
              28.7
            ],
            [
              -100.96,
              29.38
            ],
            [
              -101.66,
              29.78
            ],
            [
              -102.48,
              29.76
            ],
            [
              -103.11,
              28.97
            ],
            [
              -103.94,
              29.27
            ],
            [
              -104.46,
              29.57
            ],
            [
              -104.71,
              30.12
            ],
            [
              -105.04,
              30.64
            ],
            [
              -105.63,
              31.08
            ],
            [
              -106.14,
              31.4
            ],
            [
              -106.51,
              31.75
            ],
            [
              -108.24,
              31.75
            ],
            [
              -108.24,
              31.34
            ],
            [
              -109.04,
              31.34
            ],
            [
              -111.02,
              31.33
            ],
            [
              -113.31,
              32.04
            ],
            [
              -114.81,
              32.52
            ],
            [
              -114.72,
              32.72
            ],
            [
              -115.99,
              32.61
            ],
            [
              -117.13,
              32.53
            ],
            [
              -117.29,
              33.05
            ],
            [
              -117.94,
              33.62
            ],
            [
              -118.41,
              33.74
            ],
            [
              -118.52,
              34.03
            ],
            [
              -119.08,
              34.08
            ],
            [
              -119.44,
              34.35
            ],
            [
              -120.37,
              34.45
            ],
            [
              -120.62,
              34.61
            ],
            [
              -120.74,
              35.16
            ],
            [
              -121.72,
              36.16
            ],
            [
              -122.55,
              37.55
            ],
            [
              -122.51,
              37.78
            ],
            [
              -122.95,
              38.11
            ],
            [
              -123.73,
              38.95
            ],
            [
              -123.86,
              39.77
            ],
            [
              -124.4,
              40.31
            ],
            [
              -124.18,
              41.14
            ],
            [
              -124.21,
              42
            ],
            [
              -124.53,
              42.77
            ],
            [
              -124.14,
              43.71
            ],
            [
              -124.02,
              44.62
            ],
            [
              -123.9,
              45.52
            ],
            [
              -124.08,
              46.86
            ],
            [
              -124.4,
              47.72
            ],
            [
              -124.69,
              48.18
            ],
            [
              -124.57,
              48.38
            ],
            [
              -123.12,
              48.04
            ],
            [
              -122.59,
              47.1
            ],
            [
              -122.34,
              47.36
            ],
            [
              -122.5,
              48.18
            ],
            [
              -122.84,
              49
            ]
          ]
        ],
        [
          [
            [
              -155.4,
              20.08
            ],
            [
              -155.22,
              19.99
            ],
            [
              -155.06,
              19.86
            ],
            [
              -154.81,
              19.51
            ],
            [
              -154.83,
              19.45
            ],
            [
              -155.22,
              19.24
            ],
            [
              -155.54,
              19.08
            ],
            [
              -155.69,
              18.92
            ],
            [
              -155.94,
              19.06
            ],
            [
              -155.91,
              19.34
            ],
            [
              -156.07,
              19.7
            ],
            [
              -156.02,
              19.81
            ],
            [
              -155.85,
              19.98
            ],
            [
              -155.92,
              20.17
            ],
            [
              -155.86,
              20.27
            ],
            [
              -155.79,
              20.25
            ],
            [
              -155.4,
              20.08
            ]
          ]
        ],
        [
          [
            [
              -155.99,
              20.76
            ],
            [
              -156.08,
              20.64
            ],
            [
              -156.42,
              20.57
            ],
            [
              -156.59,
              20.78
            ],
            [
              -156.7,
              20.86
            ],
            [
              -156.71,
              20.93
            ],
            [
              -156.61,
              21.01
            ],
            [
              -156.26,
              20.92
            ],
            [
              -155.99,
              20.76
            ]
          ]
        ],
        [
          [
            [
              -156.76,
              21.18
            ],
            [
              -156.79,
              21.07
            ],
            [
              -157.33,
              21.1
            ],
            [
              -157.25,
              21.22
            ],
            [
              -156.76,
              21.18
            ]
          ]
        ],
        [
          [
            [
              -158.03,
              21.72
            ],
            [
              -157.94,
              21.65
            ],
            [
              -157.65,
              21.32
            ],
            [
              -157.71,
              21.26
            ],
            [
              -157.78,
              21.28
            ],
            [
              -158.13,
              21.31
            ],
            [
              -158.25,
              21.54
            ],
            [
              -158.29,
              21.58
            ],
            [
              -158.03,
              21.72
            ]
          ]
        ],
        [
          [
            [
              -159.36,
              22.22
            ],
            [
              -159.35,
              21.98
            ],
            [
              -159.47,
              21.88
            ],
            [
              -159.8,
              22.06
            ],
            [
              -159.75,
              22.14
            ],
            [
              -159.59,
              22.24
            ],
            [
              -159.36,
              22.22
            ]
          ]
        ],
        [
          [
            [
              -166.47,
              60.38
            ],
            [
              -165.68,
              60.29
            ],
            [
              -165.58,
              59.91
            ],
            [
              -166.19,
              59.75
            ],
            [
              -166.85,
              59.94
            ],
            [
              -167.45,
              60.21
            ],
            [
              -166.47,
              60.38
            ]
          ]
        ],
        [
          [
            [
              -153.23,
              57.97
            ],
            [
              -152.56,
              57.9
            ],
            [
              -152.14,
              57.59
            ],
            [
              -153.01,
              57.12
            ],
            [
              -154,
              56.74
            ],
            [
              -154.52,
              56.99
            ],
            [
              -154.67,
              57.46
            ],
            [
              -153.76,
              57.82
            ],
            [
              -153.23,
              57.97
            ]
          ]
        ],
        [
          [
            [
              -140.99,
              69.71
            ],
            [
              -140.99,
              66
            ],
            [
              -141,
              60.31
            ],
            [
              -140.01,
              60.28
            ],
            [
              -139.04,
              60
            ],
            [
              -138.34,
              59.56
            ],
            [
              -137.45,
              58.91
            ],
            [
              -136.48,
              59.46
            ],
            [
              -135.47,
              59.79
            ],
            [
              -134.95,
              59.27
            ],
            [
              -134.27,
              58.86
            ],
            [
              -133.35,
              58.41
            ],
            [
              -132.73,
              57.69
            ],
            [
              -131.71,
              56.55
            ],
            [
              -130.01,
              55.92
            ],
            [
              -129.98,
              55.28
            ],
            [
              -130.54,
              54.8
            ],
            [
              -131.09,
              55.18
            ],
            [
              -131.97,
              55.5
            ],
            [
              -132.25,
              56.37
            ],
            [
              -133.54,
              57.18
            ],
            [
              -134.08,
              58.12
            ],
            [
              -135.04,
              58.19
            ],
            [
              -136.63,
              58.21
            ],
            [
              -137.8,
              58.5
            ],
            [
              -139.87,
              59.54
            ],
            [
              -140.82,
              59.73
            ],
            [
              -142.57,
              60.08
            ],
            [
              -143.96,
              60
            ],
            [
              -145.93,
              60.46
            ],
            [
              -147.11,
              60.89
            ],
            [
              -148.23,
              60.67
            ],
            [
              -148.02,
              59.98
            ],
            [
              -148.57,
              59.91
            ],
            [
              -149.73,
              59.71
            ],
            [
              -150.61,
              59.37
            ],
            [
              -151.72,
              59.16
            ],
            [
              -151.86,
              59.74
            ],
            [
              -151.41,
              60.73
            ],
            [
              -150.35,
              61.03
            ],
            [
              -150.62,
              61.28
            ],
            [
              -151.89,
              60.73
            ],
            [
              -152.58,
              60.06
            ],
            [
              -154.02,
              59.35
            ],
            [
              -153.29,
              58.86
            ],
            [
              -154.23,
              58.15
            ],
            [
              -155.31,
              57.73
            ],
            [
              -156.31,
              57.42
            ],
            [
              -156.56,
              56.98
            ],
            [
              -158.12,
              56.46
            ],
            [
              -158.43,
              55.99
            ],
            [
              -159.6,
              55.57
            ],
            [
              -160.29,
              55.64
            ],
            [
              -161.22,
              55.36
            ],
            [
              -162.24,
              55.02
            ],
            [
              -163.07,
              54.69
            ],
            [
              -164.79,
              54.4
            ],
            [
              -164.94,
              54.57
            ],
            [
              -163.85,
              55.04
            ],
            [
              -162.87,
              55.35
            ],
            [
              -161.81,
              55.9
            ],
            [
              -160.56,
              56.01
            ],
            [
              -160.07,
              56.42
            ],
            [
              -158.68,
              57.02
            ],
            [
              -158.46,
              57.22
            ],
            [
              -157.72,
              57.57
            ],
            [
              -157.55,
              58.33
            ],
            [
              -157.04,
              58.92
            ],
            [
              -158.19,
              58.62
            ],
            [
              -158.52,
              58.79
            ],
            [
              -159.06,
              58.42
            ],
            [
              -159.71,
              58.93
            ],
            [
              -159.98,
              58.57
            ],
            [
              -160.35,
              59.07
            ],
            [
              -161.36,
              58.67
            ],
            [
              -161.97,
              58.67
            ],
            [
              -162.05,
              59.27
            ],
            [
              -161.87,
              59.63
            ],
            [
              -162.52,
              59.99
            ],
            [
              -163.82,
              59.8
            ],
            [
              -164.66,
              60.27
            ],
            [
              -165.35,
              60.51
            ],
            [
              -165.35,
              61.07
            ],
            [
              -166.12,
              61.5
            ],
            [
              -165.73,
              62.08
            ],
            [
              -164.92,
              62.63
            ],
            [
              -164.56,
              63.15
            ],
            [
              -163.75,
              63.22
            ],
            [
              -163.07,
              63.06
            ],
            [
              -162.26,
              63.54
            ],
            [
              -161.54,
              63.46
            ],
            [
              -160.77,
              63.77
            ],
            [
              -160.96,
              64.22
            ],
            [
              -161.52,
              64.4
            ],
            [
              -160.78,
              64.79
            ],
            [
              -161.39,
              64.78
            ],
            [
              -162.45,
              64.56
            ],
            [
              -162.76,
              64.34
            ],
            [
              -163.55,
              64.56
            ],
            [
              -164.96,
              64.45
            ],
            [
              -166.42,
              64.69
            ],
            [
              -166.85,
              65.09
            ],
            [
              -168.11,
              65.67
            ],
            [
              -166.71,
              66.09
            ],
            [
              -164.47,
              66.58
            ],
            [
              -163.65,
              66.58
            ],
            [
              -163.79,
              66.08
            ],
            [
              -161.68,
              66.12
            ],
            [
              -162.49,
              66.73
            ],
            [
              -163.72,
              67.12
            ],
            [
              -164.43,
              67.62
            ],
            [
              -165.39,
              68.04
            ],
            [
              -166.76,
              68.36
            ],
            [
              -166.2,
              68.88
            ],
            [
              -164.43,
              68.91
            ],
            [
              -163.17,
              69.37
            ],
            [
              -162.93,
              69.86
            ],
            [
              -161.91,
              70.33
            ],
            [
              -160.93,
              70.45
            ],
            [
              -159.04,
              70.89
            ],
            [
              -158.12,
              70.82
            ],
            [
              -156.58,
              71.36
            ],
            [
              -155.07,
              71.15
            ],
            [
              -154.34,
              70.7
            ],
            [
              -153.9,
              70.89
            ],
            [
              -152.21,
              70.83
            ],
            [
              -152.27,
              70.6
            ],
            [
              -150.74,
              70.43
            ],
            [
              -149.72,
              70.53
            ],
            [
              -147.61,
              70.21
            ],
            [
              -145.69,
              70.12
            ],
            [
              -144.92,
              69.99
            ],
            [
              -143.59,
              70.15
            ],
            [
              -142.07,
              69.85
            ],
            [
              -140.99,
              69.71
            ]
          ]
        ],
        [
          [
            [
              -171.73,
              63.78
            ],
            [
              -171.12,
              63.59
            ],
            [
              -170.49,
              63.69
            ],
            [
              -169.68,
              63.43
            ],
            [
              -168.69,
              63.3
            ],
            [
              -168.77,
              63.19
            ],
            [
              -169.53,
              62.98
            ],
            [
              -170.29,
              63.19
            ],
            [
              -170.67,
              63.38
            ],
            [
              -171.55,
              63.32
            ],
            [
              -171.79,
              63.41
            ],
            [
              -171.73,
              63.78
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kazakhstan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            87.36,
            49.22
          ],
          [
            86.6,
            48.55
          ],
          [
            85.77,
            48.46
          ],
          [
            85.72,
            47.45
          ],
          [
            85.16,
            47
          ],
          [
            83.18,
            47.33
          ],
          [
            82.46,
            45.54
          ],
          [
            81.95,
            45.32
          ],
          [
            79.97,
            44.92
          ],
          [
            80.87,
            43.18
          ],
          [
            80.18,
            42.92
          ],
          [
            80.26,
            42.35
          ],
          [
            79.65,
            42.5
          ],
          [
            79.14,
            42.86
          ],
          [
            77.66,
            42.96
          ],
          [
            76,
            42.99
          ],
          [
            75.64,
            42.88
          ],
          [
            74.21,
            43.3
          ],
          [
            73.64,
            43.09
          ],
          [
            73.49,
            42.5
          ],
          [
            71.84,
            42.85
          ],
          [
            71.19,
            42.7
          ],
          [
            70.96,
            42.27
          ],
          [
            70.39,
            42.08
          ],
          [
            69.07,
            41.38
          ],
          [
            68.63,
            40.67
          ],
          [
            68.26,
            40.66
          ],
          [
            67.98,
            41.14
          ],
          [
            66.71,
            41.17
          ],
          [
            66.51,
            41.99
          ],
          [
            66.02,
            41.99
          ],
          [
            66.1,
            43
          ],
          [
            64.9,
            43.73
          ],
          [
            63.19,
            43.65
          ],
          [
            62.01,
            43.5
          ],
          [
            61.06,
            44.41
          ],
          [
            60.24,
            44.78
          ],
          [
            58.69,
            45.5
          ],
          [
            58.5,
            45.59
          ],
          [
            55.93,
            45
          ],
          [
            55.97,
            41.31
          ],
          [
            55.46,
            41.26
          ],
          [
            54.75,
            42.04
          ],
          [
            54.08,
            42.32
          ],
          [
            52.94,
            42.12
          ],
          [
            52.5,
            41.78
          ],
          [
            52.45,
            42.03
          ],
          [
            52.69,
            42.44
          ],
          [
            52.5,
            42.79
          ],
          [
            51.34,
            43.13
          ],
          [
            50.89,
            44.03
          ],
          [
            50.34,
            44.28
          ],
          [
            50.31,
            44.61
          ],
          [
            51.28,
            44.51
          ],
          [
            51.32,
            45.25
          ],
          [
            52.17,
            45.41
          ],
          [
            53.04,
            45.26
          ],
          [
            53.22,
            46.23
          ],
          [
            53.04,
            46.85
          ],
          [
            52.04,
            46.8
          ],
          [
            51.19,
            47.05
          ],
          [
            50.04,
            46.61
          ],
          [
            49.1,
            46.4
          ],
          [
            48.59,
            46.56
          ],
          [
            48.7,
            47.08
          ],
          [
            48.06,
            47.74
          ],
          [
            47.31,
            47.72
          ],
          [
            46.47,
            48.39
          ],
          [
            47.04,
            49.15
          ],
          [
            46.75,
            49.36
          ],
          [
            47.55,
            50.45
          ],
          [
            48.58,
            49.88
          ],
          [
            48.7,
            50.6
          ],
          [
            50.77,
            51.69
          ],
          [
            52.33,
            51.72
          ],
          [
            54.53,
            51.03
          ],
          [
            55.72,
            50.62
          ],
          [
            56.78,
            51.04
          ],
          [
            58.36,
            51.06
          ],
          [
            59.64,
            50.55
          ],
          [
            59.93,
            50.84
          ],
          [
            61.34,
            50.8
          ],
          [
            61.59,
            51.27
          ],
          [
            59.97,
            51.96
          ],
          [
            60.93,
            52.45
          ],
          [
            60.74,
            52.72
          ],
          [
            61.7,
            52.98
          ],
          [
            60.98,
            53.66
          ],
          [
            61.44,
            54.01
          ],
          [
            65.18,
            54.35
          ],
          [
            65.67,
            54.6
          ],
          [
            68.17,
            54.97
          ],
          [
            69.07,
            55.38
          ],
          [
            70.86,
            55.17
          ],
          [
            71.18,
            54.13
          ],
          [
            72.23,
            54.38
          ],
          [
            73.51,
            54.04
          ],
          [
            73.42,
            53.49
          ],
          [
            74.39,
            53.55
          ],
          [
            76.89,
            54.49
          ],
          [
            76.52,
            54.18
          ],
          [
            77.8,
            53.4
          ],
          [
            80.03,
            50.87
          ],
          [
            80.57,
            51.39
          ],
          [
            81.95,
            50.81
          ],
          [
            83.38,
            51.07
          ],
          [
            83.94,
            50.89
          ],
          [
            84.42,
            50.31
          ],
          [
            85.11,
            50.12
          ],
          [
            85.54,
            49.69
          ],
          [
            86.83,
            49.83
          ],
          [
            87.36,
            49.22
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Uzbekistan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            55.97,
            41.31
          ],
          [
            55.93,
            45
          ],
          [
            58.5,
            45.59
          ],
          [
            58.69,
            45.5
          ],
          [
            60.24,
            44.78
          ],
          [
            61.06,
            44.41
          ],
          [
            62.01,
            43.5
          ],
          [
            63.19,
            43.65
          ],
          [
            64.9,
            43.73
          ],
          [
            66.1,
            43
          ],
          [
            66.02,
            41.99
          ],
          [
            66.51,
            41.99
          ],
          [
            66.71,
            41.17
          ],
          [
            67.98,
            41.14
          ],
          [
            68.26,
            40.66
          ],
          [
            68.63,
            40.67
          ],
          [
            69.07,
            41.38
          ],
          [
            70.39,
            42.08
          ],
          [
            70.96,
            42.27
          ],
          [
            71.26,
            42.17
          ],
          [
            70.42,
            41.52
          ],
          [
            71.16,
            41.14
          ],
          [
            71.87,
            41.39
          ],
          [
            73.05,
            40.87
          ],
          [
            71.78,
            40.15
          ],
          [
            71.01,
            40.24
          ],
          [
            70.6,
            40.22
          ],
          [
            70.46,
            40.5
          ],
          [
            70.67,
            40.96
          ],
          [
            69.33,
            40.73
          ],
          [
            69.01,
            40.09
          ],
          [
            68.54,
            39.53
          ],
          [
            67.7,
            39.58
          ],
          [
            67.44,
            39.14
          ],
          [
            68.18,
            38.9
          ],
          [
            68.39,
            38.16
          ],
          [
            67.83,
            37.15
          ],
          [
            67.07,
            37.36
          ],
          [
            66.52,
            37.36
          ],
          [
            66.54,
            37.97
          ],
          [
            65.22,
            38.4
          ],
          [
            64.17,
            38.89
          ],
          [
            63.52,
            39.36
          ],
          [
            62.38,
            40.05
          ],
          [
            61.88,
            41.08
          ],
          [
            61.55,
            41.27
          ],
          [
            60.46,
            41.22
          ],
          [
            60.08,
            41.43
          ],
          [
            59.97,
            42.22
          ],
          [
            58.63,
            42.75
          ],
          [
            57.79,
            42.17
          ],
          [
            56.93,
            41.83
          ],
          [
            57.09,
            41.32
          ],
          [
            55.97,
            41.31
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Papua New Guinea"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              141,
              -2.6
            ],
            [
              142.74,
              -3.29
            ],
            [
              144.58,
              -3.86
            ],
            [
              145.27,
              -4.37
            ],
            [
              145.83,
              -4.88
            ],
            [
              145.98,
              -5.47
            ],
            [
              147.65,
              -6.08
            ],
            [
              147.89,
              -6.61
            ],
            [
              146.97,
              -6.72
            ],
            [
              147.19,
              -7.39
            ],
            [
              148.09,
              -8.04
            ],
            [
              148.73,
              -9.11
            ],
            [
              149.31,
              -9.07
            ],
            [
              149.27,
              -9.51
            ],
            [
              150.04,
              -9.68
            ],
            [
              149.74,
              -9.87
            ],
            [
              150.8,
              -10.29
            ],
            [
              150.69,
              -10.58
            ],
            [
              150.03,
              -10.65
            ],
            [
              149.78,
              -10.39
            ],
            [
              148.92,
              -10.28
            ],
            [
              147.91,
              -10.13
            ],
            [
              147.14,
              -9.49
            ],
            [
              146.57,
              -8.94
            ],
            [
              146.05,
              -8.07
            ],
            [
              144.74,
              -7.63
            ],
            [
              143.9,
              -7.92
            ],
            [
              143.29,
              -8.25
            ],
            [
              143.41,
              -8.98
            ],
            [
              142.63,
              -9.33
            ],
            [
              142.07,
              -9.16
            ],
            [
              141.03,
              -9.12
            ],
            [
              141.02,
              -5.86
            ],
            [
              141,
              -2.6
            ]
          ]
        ],
        [
          [
            [
              152.64,
              -3.66
            ],
            [
              153.02,
              -3.98
            ],
            [
              153.14,
              -4.5
            ],
            [
              152.83,
              -4.77
            ],
            [
              152.64,
              -4.18
            ],
            [
              152.41,
              -3.79
            ],
            [
              151.95,
              -3.46
            ],
            [
              151.38,
              -3.04
            ],
            [
              150.66,
              -2.74
            ],
            [
              150.94,
              -2.5
            ],
            [
              151.48,
              -2.78
            ],
            [
              151.82,
              -3
            ],
            [
              152.24,
              -3.24
            ],
            [
              152.64,
              -3.66
            ]
          ]
        ],
        [
          [
            [
              151.3,
              -5.84
            ],
            [
              150.75,
              -6.08
            ],
            [
              150.24,
              -6.32
            ],
            [
              149.71,
              -6.32
            ],
            [
              148.89,
              -6.03
            ],
            [
              148.32,
              -5.75
            ],
            [
              148.4,
              -5.44
            ],
            [
              149.3,
              -5.58
            ],
            [
              149.85,
              -5.51
            ],
            [
              150,
              -5.03
            ],
            [
              150.14,
              -5
            ],
            [
              150.24,
              -5.53
            ],
            [
              150.81,
              -5.46
            ],
            [
              151.09,
              -5.11
            ],
            [
              151.65,
              -4.76
            ],
            [
              151.54,
              -4.17
            ],
            [
              152.14,
              -4.15
            ],
            [
              152.34,
              -4.31
            ],
            [
              152.32,
              -4.87
            ],
            [
              151.98,
              -5.48
            ],
            [
              151.46,
              -5.56
            ],
            [
              151.3,
              -5.84
            ]
          ]
        ],
        [
          [
            [
              154.76,
              -5.34
            ],
            [
              155.06,
              -5.57
            ],
            [
              155.55,
              -6.2
            ],
            [
              156.02,
              -6.54
            ],
            [
              155.88,
              -6.82
            ],
            [
              155.6,
              -6.92
            ],
            [
              155.17,
              -6.54
            ],
            [
              154.73,
              -5.9
            ],
            [
              154.52,
              -5.14
            ],
            [
              154.65,
              -5.04
            ],
            [
              154.76,
              -5.34
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Indonesia"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              141,
              -2.6
            ],
            [
              141.02,
              -5.86
            ],
            [
              141.03,
              -9.12
            ],
            [
              140.14,
              -8.3
            ],
            [
              139.13,
              -8.1
            ],
            [
              138.88,
              -8.38
            ],
            [
              137.61,
              -8.41
            ],
            [
              138.04,
              -7.6
            ],
            [
              138.67,
              -7.32
            ],
            [
              138.41,
              -6.23
            ],
            [
              137.93,
              -5.39
            ],
            [
              135.99,
              -4.55
            ],
            [
              135.17,
              -4.46
            ],
            [
              133.66,
              -3.54
            ],
            [
              133.37,
              -4.02
            ],
            [
              132.98,
              -4.11
            ],
            [
              132.76,
              -3.75
            ],
            [
              132.75,
              -3.31
            ],
            [
              131.99,
              -2.82
            ],
            [
              133.07,
              -2.46
            ],
            [
              133.78,
              -2.48
            ],
            [
              133.7,
              -2.21
            ],
            [
              132.23,
              -2.21
            ],
            [
              131.84,
              -1.62
            ],
            [
              130.94,
              -1.43
            ],
            [
              130.52,
              -0.94
            ],
            [
              131.87,
              -0.7
            ],
            [
              132.38,
              -0.37
            ],
            [
              133.98,
              -0.78
            ],
            [
              134.14,
              -1.15
            ],
            [
              134.42,
              -2.77
            ],
            [
              135.46,
              -3.37
            ],
            [
              136.29,
              -2.31
            ],
            [
              137.44,
              -1.7
            ],
            [
              138.33,
              -1.7
            ],
            [
              139.19,
              -2.05
            ],
            [
              139.93,
              -2.41
            ],
            [
              141,
              -2.6
            ]
          ]
        ],
        [
          [
            [
              124.97,
              -8.89
            ],
            [
              125.07,
              -9.09
            ],
            [
              125.09,
              -9.39
            ],
            [
              124.44,
              -10.14
            ],
            [
              123.58,
              -10.36
            ],
            [
              123.46,
              -10.24
            ],
            [
              123.55,
              -9.9
            ],
            [
              123.98,
              -9.29
            ],
            [
              124.97,
              -8.89
            ]
          ]
        ],
        [
          [
            [
              134.21,
              -6.89
            ],
            [
              134.11,
              -6.14
            ],
            [
              134.29,
              -5.78
            ],
            [
              134.5,
              -5.44
            ],
            [
              134.73,
              -5.74
            ],
            [
              134.73,
              -6.21
            ],
            [
              134.21,
              -6.89
            ]
          ]
        ],
        [
          [
            [
              117.88,
              4.14
            ],
            [
              117.31,
              3.24
            ],
            [
              118.05,
              2.29
            ],
            [
              117.87,
              1.83
            ],
            [
              119,
              0.9
            ],
            [
              117.81,
              0.78
            ],
            [
              117.48,
              0.1
            ],
            [
              117.52,
              -0.8
            ],
            [
              116.56,
              -1.49
            ],
            [
              116.53,
              -2.48
            ],
            [
              116.15,
              -4.01
            ],
            [
              116,
              -3.66
            ],
            [
              114.86,
              -4.11
            ],
            [
              114.47,
              -3.5
            ],
            [
              113.76,
              -3.44
            ],
            [
              113.26,
              -3.12
            ],
            [
              112.07,
              -3.48
            ],
            [
              111.7,
              -3
            ],
            [
              111.05,
              -3.05
            ],
            [
              110.22,
              -2.93
            ],
            [
              110.07,
              -1.59
            ],
            [
              109.57,
              -1.31
            ],
            [
              109.09,
              -0.46
            ],
            [
              108.95,
              0.42
            ],
            [
              109.07,
              1.34
            ],
            [
              109.66,
              2.01
            ],
            [
              109.83,
              1.34
            ],
            [
              110.52,
              0.77
            ],
            [
              111.16,
              0.98
            ],
            [
              111.8,
              0.9
            ],
            [
              112.38,
              1.41
            ],
            [
              112.86,
              1.5
            ],
            [
              113.81,
              1.22
            ],
            [
              114.62,
              1.43
            ],
            [
              115.13,
              2.82
            ],
            [
              115.52,
              3.17
            ],
            [
              115.87,
              4.31
            ],
            [
              117.01,
              4.31
            ],
            [
              117.88,
              4.14
            ]
          ]
        ],
        [
          [
            [
              129.37,
              -2.8
            ],
            [
              130.47,
              -3.09
            ],
            [
              130.83,
              -3.86
            ],
            [
              129.99,
              -3.45
            ],
            [
              129.16,
              -3.36
            ],
            [
              128.59,
              -3.43
            ],
            [
              127.9,
              -3.39
            ],
            [
              128.13,
              -2.84
            ],
            [
              129.37,
              -2.8
            ]
          ]
        ],
        [
          [
            [
              126.87,
              -3.79
            ],
            [
              126.18,
              -3.61
            ],
            [
              125.99,
              -3.18
            ],
            [
              127,
              -3.13
            ],
            [
              127.25,
              -3.46
            ],
            [
              126.87,
              -3.79
            ]
          ]
        ],
        [
          [
            [
              127.93,
              2.17
            ],
            [
              128,
              1.63
            ],
            [
              128.6,
              1.54
            ],
            [
              128.69,
              1.13
            ],
            [
              128.63,
              0.26
            ],
            [
              128.12,
              0.36
            ],
            [
              127.97,
              -0.25
            ],
            [
              128.38,
              -0.78
            ],
            [
              128.1,
              -0.9
            ],
            [
              127.7,
              -0.27
            ],
            [
              127.4,
              1.01
            ],
            [
              127.6,
              1.81
            ],
            [
              127.93,
              2.17
            ]
          ]
        ],
        [
          [
            [
              122.93,
              0.88
            ],
            [
              124.08,
              0.92
            ],
            [
              125.07,
              1.64
            ],
            [
              125.24,
              1.42
            ],
            [
              124.44,
              0.43
            ],
            [
              123.68,
              0.24
            ],
            [
              122.72,
              0.43
            ],
            [
              121.06,
              0.38
            ],
            [
              120.18,
              0.24
            ],
            [
              120.04,
              -0.52
            ],
            [
              120.93,
              -1.41
            ],
            [
              121.47,
              -0.96
            ],
            [
              123.34,
              -0.62
            ],
            [
              123.26,
              -1.08
            ],
            [
              122.82,
              -0.93
            ],
            [
              122.39,
              -1.52
            ],
            [
              121.51,
              -1.91
            ],
            [
              122.45,
              -3.19
            ],
            [
              122.27,
              -3.53
            ],
            [
              123.17,
              -4.68
            ],
            [
              123.16,
              -5.34
            ],
            [
              122.63,
              -5.63
            ],
            [
              122.24,
              -5.28
            ],
            [
              122.72,
              -4.46
            ],
            [
              121.74,
              -4.85
            ],
            [
              121.49,
              -4.57
            ],
            [
              121.62,
              -4.19
            ],
            [
              120.9,
              -3.6
            ],
            [
              120.97,
              -2.63
            ],
            [
              120.3,
              -2.93
            ],
            [
              120.39,
              -4.1
            ],
            [
              120.43,
              -5.53
            ],
            [
              119.8,
              -5.67
            ],
            [
              119.37,
              -5.38
            ],
            [
              119.65,
              -4.46
            ],
            [
              119.5,
              -3.49
            ],
            [
              119.08,
              -3.49
            ],
            [
              118.77,
              -2.8
            ],
            [
              119.18,
              -2.15
            ],
            [
              119.32,
              -1.35
            ],
            [
              119.83,
              0.15
            ],
            [
              120.03,
              0.57
            ],
            [
              120.89,
              1.31
            ],
            [
              121.67,
              1.01
            ],
            [
              122.93,
              0.88
            ]
          ]
        ],
        [
          [
            [
              120.29,
              -10.26
            ],
            [
              118.97,
              -9.56
            ],
            [
              119.9,
              -9.36
            ],
            [
              120.43,
              -9.67
            ],
            [
              120.78,
              -9.97
            ],
            [
              120.71,
              -10.24
            ],
            [
              120.29,
              -10.26
            ]
          ]
        ],
        [
          [
            [
              121.34,
              -8.54
            ],
            [
              122.01,
              -8.46
            ],
            [
              122.9,
              -8.09
            ],
            [
              122.76,
              -8.65
            ],
            [
              121.25,
              -8.93
            ],
            [
              119.92,
              -8.81
            ],
            [
              119.92,
              -8.45
            ],
            [
              120.71,
              -8.24
            ],
            [
              121.34,
              -8.54
            ]
          ]
        ],
        [
          [
            [
              118.26,
              -8.36
            ],
            [
              118.88,
              -8.28
            ],
            [
              119.13,
              -8.71
            ],
            [
              117.97,
              -8.91
            ],
            [
              117.28,
              -9.04
            ],
            [
              116.74,
              -9.03
            ],
            [
              117.08,
              -8.46
            ],
            [
              117.63,
              -8.45
            ],
            [
              117.9,
              -8.09
            ],
            [
              118.26,
              -8.36
            ]
          ]
        ],
        [
          [
            [
              108.49,
              -6.42
            ],
            [
              108.62,
              -6.78
            ],
            [
              110.54,
              -6.88
            ],
            [
              110.76,
              -6.46
            ],
            [
              112.61,
              -6.95
            ],
            [
              112.98,
              -7.59
            ],
            [
              114.48,
              -7.78
            ],
            [
              115.71,
              -8.37
            ],
            [
              114.57,
              -8.75
            ],
            [
              113.46,
              -8.35
            ],
            [
              112.56,
              -8.38
            ],
            [
              111.52,
              -8.3
            ],
            [
              110.59,
              -8.12
            ],
            [
              109.43,
              -7.74
            ],
            [
              108.69,
              -7.64
            ],
            [
              108.28,
              -7.77
            ],
            [
              106.45,
              -7.36
            ],
            [
              106.28,
              -6.93
            ],
            [
              105.36,
              -6.85
            ],
            [
              106.05,
              -5.9
            ],
            [
              107.26,
              -5.96
            ],
            [
              108.07,
              -6.35
            ],
            [
              108.49,
              -6.42
            ]
          ]
        ],
        [
          [
            [
              104.37,
              -1.08
            ],
            [
              104.54,
              -1.78
            ],
            [
              104.89,
              -2.34
            ],
            [
              105.62,
              -2.43
            ],
            [
              106.11,
              -3.06
            ],
            [
              105.86,
              -4.31
            ],
            [
              105.82,
              -5.85
            ],
            [
              104.71,
              -5.87
            ],
            [
              103.87,
              -5.04
            ],
            [
              102.58,
              -4.22
            ],
            [
              102.16,
              -3.61
            ],
            [
              101.4,
              -2.8
            ],
            [
              100.9,
              -2.05
            ],
            [
              100.14,
              -0.65
            ],
            [
              99.26,
              0.18
            ],
            [
              98.97,
              1.04
            ],
            [
              98.6,
              1.82
            ],
            [
              97.7,
              2.45
            ],
            [
              97.18,
              3.31
            ],
            [
              96.43,
              3.87
            ],
            [
              95.38,
              4.97
            ],
            [
              95.29,
              5.48
            ],
            [
              95.94,
              5.44
            ],
            [
              97.48,
              5.25
            ],
            [
              98.37,
              4.27
            ],
            [
              99.14,
              3.59
            ],
            [
              99.69,
              3.17
            ],
            [
              100.64,
              2.1
            ],
            [
              101.66,
              2.08
            ],
            [
              102.5,
              1.4
            ],
            [
              103.08,
              0.56
            ],
            [
              103.84,
              0.1
            ],
            [
              103.44,
              -0.71
            ],
            [
              104.01,
              -1.06
            ],
            [
              104.37,
              -1.08
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Argentina"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -68.63,
              -52.64
            ],
            [
              -68.25,
              -53.1
            ],
            [
              -67.75,
              -53.85
            ],
            [
              -66.45,
              -54.45
            ],
            [
              -65.05,
              -54.7
            ],
            [
              -65.5,
              -55.2
            ],
            [
              -66.45,
              -55.25
            ],
            [
              -66.96,
              -54.9
            ],
            [
              -67.56,
              -54.87
            ],
            [
              -68.63,
              -54.87
            ],
            [
              -68.63,
              -52.64
            ]
          ]
        ],
        [
          [
            [
              -57.62,
              -30.22
            ],
            [
              -57.88,
              -31.02
            ],
            [
              -58.14,
              -32.04
            ],
            [
              -58.13,
              -33.04
            ],
            [
              -58.35,
              -33.26
            ],
            [
              -58.43,
              -33.91
            ],
            [
              -58.5,
              -34.43
            ],
            [
              -57.22,
              -35.29
            ],
            [
              -57.36,
              -35.98
            ],
            [
              -56.74,
              -36.41
            ],
            [
              -56.79,
              -36.9
            ],
            [
              -57.75,
              -38.18
            ],
            [
              -59.23,
              -38.72
            ],
            [
              -61.24,
              -38.93
            ],
            [
              -62.34,
              -38.83
            ],
            [
              -62.12,
              -39.42
            ],
            [
              -62.33,
              -40.17
            ],
            [
              -62.15,
              -40.68
            ],
            [
              -62.75,
              -41.03
            ],
            [
              -63.77,
              -41.17
            ],
            [
              -64.73,
              -40.8
            ],
            [
              -65.12,
              -41.06
            ],
            [
              -64.98,
              -42.06
            ],
            [
              -64.3,
              -42.36
            ],
            [
              -63.75,
              -42.04
            ],
            [
              -63.46,
              -42.56
            ],
            [
              -64.38,
              -42.87
            ],
            [
              -65.18,
              -43.49
            ],
            [
              -65.33,
              -44.5
            ],
            [
              -65.57,
              -45.04
            ],
            [
              -66.51,
              -45.04
            ],
            [
              -67.29,
              -45.55
            ],
            [
              -67.58,
              -46.3
            ],
            [
              -66.6,
              -47.03
            ],
            [
              -65.64,
              -47.24
            ],
            [
              -65.99,
              -48.13
            ],
            [
              -67.17,
              -48.7
            ],
            [
              -67.82,
              -49.87
            ],
            [
              -68.73,
              -50.27
            ],
            [
              -69.14,
              -50.73
            ],
            [
              -68.82,
              -51.77
            ],
            [
              -68.15,
              -52.35
            ],
            [
              -68.57,
              -52.3
            ],
            [
              -69.5,
              -52.14
            ],
            [
              -71.92,
              -52.01
            ],
            [
              -72.33,
              -51.43
            ],
            [
              -72.31,
              -50.68
            ],
            [
              -72.97,
              -50.74
            ],
            [
              -73.33,
              -50.38
            ],
            [
              -73.41,
              -49.32
            ],
            [
              -72.65,
              -48.88
            ],
            [
              -72.33,
              -48.24
            ],
            [
              -72.45,
              -47.74
            ],
            [
              -71.92,
              -46.88
            ],
            [
              -71.55,
              -45.56
            ],
            [
              -71.66,
              -44.97
            ],
            [
              -71.22,
              -44.78
            ],
            [
              -71.33,
              -44.41
            ],
            [
              -71.79,
              -44.21
            ],
            [
              -71.46,
              -43.79
            ],
            [
              -71.92,
              -43.41
            ],
            [
              -72.15,
              -42.25
            ],
            [
              -71.75,
              -42.05
            ],
            [
              -71.92,
              -40.83
            ],
            [
              -71.68,
              -39.81
            ],
            [
              -71.41,
              -38.92
            ],
            [
              -70.81,
              -38.55
            ],
            [
              -71.12,
              -37.58
            ],
            [
              -71.12,
              -36.66
            ],
            [
              -70.36,
              -36.01
            ],
            [
              -70.39,
              -35.17
            ],
            [
              -69.82,
              -34.19
            ],
            [
              -69.81,
              -33.27
            ],
            [
              -70.07,
              -33.09
            ],
            [
              -70.53,
              -31.36
            ],
            [
              -69.92,
              -30.34
            ],
            [
              -70.02,
              -29.37
            ],
            [
              -69.66,
              -28.46
            ],
            [
              -69,
              -27.52
            ],
            [
              -68.29,
              -26.9
            ],
            [
              -68.59,
              -26.51
            ],
            [
              -68.38,
              -26.18
            ],
            [
              -68.42,
              -24.52
            ],
            [
              -67.33,
              -24.03
            ],
            [
              -66.98,
              -22.99
            ],
            [
              -67.11,
              -22.74
            ],
            [
              -66.27,
              -21.83
            ],
            [
              -64.96,
              -22.08
            ],
            [
              -64.38,
              -22.8
            ],
            [
              -63.99,
              -21.99
            ],
            [
              -62.85,
              -22.03
            ],
            [
              -62.69,
              -22.25
            ],
            [
              -60.85,
              -23.88
            ],
            [
              -60.03,
              -24.03
            ],
            [
              -58.81,
              -24.77
            ],
            [
              -57.78,
              -25.16
            ],
            [
              -57.63,
              -25.6
            ],
            [
              -58.62,
              -27.12
            ],
            [
              -57.61,
              -27.4
            ],
            [
              -56.49,
              -27.55
            ],
            [
              -55.69,
              -27.39
            ],
            [
              -54.79,
              -26.62
            ],
            [
              -54.63,
              -25.74
            ],
            [
              -54.13,
              -25.55
            ],
            [
              -53.63,
              -26.12
            ],
            [
              -53.65,
              -26.92
            ],
            [
              -54.49,
              -27.47
            ],
            [
              -55.16,
              -27.88
            ],
            [
              -56.29,
              -28.85
            ],
            [
              -57.62,
              -30.22
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Chile"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -68.63,
              -52.64
            ],
            [
              -68.63,
              -54.87
            ],
            [
              -67.56,
              -54.87
            ],
            [
              -66.96,
              -54.9
            ],
            [
              -67.29,
              -55.3
            ],
            [
              -68.15,
              -55.61
            ],
            [
              -68.64,
              -55.58
            ],
            [
              -69.23,
              -55.5
            ],
            [
              -69.96,
              -55.2
            ],
            [
              -71.01,
              -55.05
            ],
            [
              -72.27,
              -54.49
            ],
            [
              -73.28,
              -53.96
            ],
            [
              -74.66,
              -52.84
            ],
            [
              -73.84,
              -53.05
            ],
            [
              -72.43,
              -53.72
            ],
            [
              -71.11,
              -54.07
            ],
            [
              -70.59,
              -53.62
            ],
            [
              -70.27,
              -52.93
            ],
            [
              -69.35,
              -52.52
            ],
            [
              -68.63,
              -52.64
            ]
          ]
        ],
        [
          [
            [
              -69.59,
              -17.58
            ],
            [
              -69.1,
              -18.26
            ],
            [
              -68.97,
              -18.98
            ],
            [
              -68.44,
              -19.4
            ],
            [
              -68.76,
              -20.37
            ],
            [
              -68.22,
              -21.49
            ],
            [
              -67.83,
              -22.87
            ],
            [
              -67.11,
              -22.74
            ],
            [
              -66.98,
              -22.99
            ],
            [
              -67.33,
              -24.03
            ],
            [
              -68.42,
              -24.52
            ],
            [
              -68.38,
              -26.18
            ],
            [
              -68.59,
              -26.51
            ],
            [
              -68.29,
              -26.9
            ],
            [
              -69,
              -27.52
            ],
            [
              -69.66,
              -28.46
            ],
            [
              -70.02,
              -29.37
            ],
            [
              -69.92,
              -30.34
            ],
            [
              -70.53,
              -31.36
            ],
            [
              -70.07,
              -33.09
            ],
            [
              -69.81,
              -33.27
            ],
            [
              -69.82,
              -34.19
            ],
            [
              -70.39,
              -35.17
            ],
            [
              -70.36,
              -36.01
            ],
            [
              -71.12,
              -36.66
            ],
            [
              -71.12,
              -37.58
            ],
            [
              -70.81,
              -38.55
            ],
            [
              -71.41,
              -38.92
            ],
            [
              -71.68,
              -39.81
            ],
            [
              -71.92,
              -40.83
            ],
            [
              -71.75,
              -42.05
            ],
            [
              -72.15,
              -42.25
            ],
            [
              -71.92,
              -43.41
            ],
            [
              -71.46,
              -43.79
            ],
            [
              -71.79,
              -44.21
            ],
            [
              -71.33,
              -44.41
            ],
            [
              -71.22,
              -44.78
            ],
            [
              -71.66,
              -44.97
            ],
            [
              -71.55,
              -45.56
            ],
            [
              -71.92,
              -46.88
            ],
            [
              -72.45,
              -47.74
            ],
            [
              -72.33,
              -48.24
            ],
            [
              -72.65,
              -48.88
            ],
            [
              -73.41,
              -49.32
            ],
            [
              -73.33,
              -50.38
            ],
            [
              -72.97,
              -50.74
            ],
            [
              -72.31,
              -50.68
            ],
            [
              -72.33,
              -51.43
            ],
            [
              -71.92,
              -52.01
            ],
            [
              -69.5,
              -52.14
            ],
            [
              -68.57,
              -52.3
            ],
            [
              -69.46,
              -52.29
            ],
            [
              -69.94,
              -52.54
            ],
            [
              -70.84,
              -52.9
            ],
            [
              -71.01,
              -53.83
            ],
            [
              -71.43,
              -53.86
            ],
            [
              -72.56,
              -53.53
            ],
            [
              -73.7,
              -52.83
            ],
            [
              -74.95,
              -52.26
            ],
            [
              -75.26,
              -51.63
            ],
            [
              -74.98,
              -51.04
            ],
            [
              -75.48,
              -50.38
            ],
            [
              -75.61,
              -48.67
            ],
            [
              -75.18,
              -47.71
            ],
            [
              -74.13,
              -46.94
            ],
            [
              -75.65,
              -46.65
            ],
            [
              -74.69,
              -45.76
            ],
            [
              -74.35,
              -44.1
            ],
            [
              -73.24,
              -44.45
            ],
            [
              -72.72,
              -42.38
            ],
            [
              -73.39,
              -42.12
            ],
            [
              -73.7,
              -43.37
            ],
            [
              -74.33,
              -43.23
            ],
            [
              -74.02,
              -41.8
            ],
            [
              -73.68,
              -39.94
            ],
            [
              -73.22,
              -39.26
            ],
            [
              -73.51,
              -38.28
            ],
            [
              -73.59,
              -37.16
            ],
            [
              -73.17,
              -37.12
            ],
            [
              -72.55,
              -35.51
            ],
            [
              -71.86,
              -33.91
            ],
            [
              -71.44,
              -32.42
            ],
            [
              -71.67,
              -30.92
            ],
            [
              -71.37,
              -30.1
            ],
            [
              -71.49,
              -28.86
            ],
            [
              -70.9,
              -27.64
            ],
            [
              -70.72,
              -25.71
            ],
            [
              -70.4,
              -23.63
            ],
            [
              -70.09,
              -21.39
            ],
            [
              -70.16,
              -19.76
            ],
            [
              -70.37,
              -18.35
            ],
            [
              -69.86,
              -18.09
            ],
            [
              -69.59,
              -17.58
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Dem. Rep. Congo"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            29.34,
            -4.5
          ],
          [
            29.52,
            -5.42
          ],
          [
            29.42,
            -5.94
          ],
          [
            29.62,
            -6.52
          ],
          [
            30.2,
            -7.08
          ],
          [
            30.74,
            -8.34
          ],
          [
            30.35,
            -8.24
          ],
          [
            29,
            -8.41
          ],
          [
            28.73,
            -8.53
          ],
          [
            28.45,
            -9.16
          ],
          [
            28.67,
            -9.61
          ],
          [
            28.5,
            -10.79
          ],
          [
            28.37,
            -11.79
          ],
          [
            28.64,
            -11.97
          ],
          [
            29.34,
            -12.36
          ],
          [
            29.62,
            -12.18
          ],
          [
            29.7,
            -13.26
          ],
          [
            28.94,
            -13.25
          ],
          [
            28.52,
            -12.7
          ],
          [
            28.15,
            -12.27
          ],
          [
            27.39,
            -12.13
          ],
          [
            27.16,
            -11.61
          ],
          [
            26.55,
            -11.93
          ],
          [
            25.75,
            -11.78
          ],
          [
            25.42,
            -11.33
          ],
          [
            24.78,
            -11.24
          ],
          [
            24.31,
            -11.26
          ],
          [
            24.26,
            -10.95
          ],
          [
            23.91,
            -10.93
          ],
          [
            23.46,
            -10.87
          ],
          [
            22.84,
            -11.02
          ],
          [
            22.4,
            -10.99
          ],
          [
            22.16,
            -11.08
          ],
          [
            22.21,
            -9.89
          ],
          [
            21.88,
            -9.52
          ],
          [
            21.8,
            -8.91
          ],
          [
            21.95,
            -8.31
          ],
          [
            21.75,
            -7.92
          ],
          [
            21.73,
            -7.29
          ],
          [
            20.51,
            -7.3
          ],
          [
            20.6,
            -6.94
          ],
          [
            20.09,
            -6.94
          ],
          [
            20.04,
            -7.12
          ],
          [
            19.42,
            -7.16
          ],
          [
            19.17,
            -7.74
          ],
          [
            19.02,
            -7.99
          ],
          [
            18.46,
            -7.85
          ],
          [
            18.14,
            -7.99
          ],
          [
            17.47,
            -8.07
          ],
          [
            17.09,
            -7.54
          ],
          [
            16.86,
            -7.22
          ],
          [
            16.57,
            -6.62
          ],
          [
            16.33,
            -5.88
          ],
          [
            13.38,
            -5.86
          ],
          [
            13.02,
            -5.98
          ],
          [
            12.74,
            -5.97
          ],
          [
            12.32,
            -6.1
          ],
          [
            12.18,
            -5.79
          ],
          [
            12.44,
            -5.68
          ],
          [
            12.47,
            -5.25
          ],
          [
            12.63,
            -4.99
          ],
          [
            12.99,
            -4.78
          ],
          [
            13.26,
            -4.88
          ],
          [
            13.6,
            -4.5
          ],
          [
            14.15,
            -4.51
          ],
          [
            14.21,
            -4.79
          ],
          [
            14.58,
            -4.97
          ],
          [
            15.17,
            -4.34
          ],
          [
            15.75,
            -3.86
          ],
          [
            16.01,
            -3.54
          ],
          [
            15.97,
            -2.71
          ],
          [
            16.41,
            -1.74
          ],
          [
            16.86,
            -1.23
          ],
          [
            17.52,
            -0.74
          ],
          [
            17.64,
            -0.42
          ],
          [
            17.66,
            -0.06
          ],
          [
            17.83,
            0.29
          ],
          [
            17.78,
            0.86
          ],
          [
            17.9,
            1.74
          ],
          [
            18.1,
            2.37
          ],
          [
            18.39,
            2.9
          ],
          [
            18.45,
            3.5
          ],
          [
            18.54,
            4.2
          ],
          [
            18.93,
            4.71
          ],
          [
            19.47,
            5.03
          ],
          [
            20.29,
            4.69
          ],
          [
            20.93,
            4.32
          ],
          [
            21.66,
            4.22
          ],
          [
            22.4,
            4.03
          ],
          [
            22.7,
            4.63
          ],
          [
            22.84,
            4.71
          ],
          [
            23.3,
            4.61
          ],
          [
            24.41,
            5.11
          ],
          [
            24.81,
            4.9
          ],
          [
            25.13,
            4.93
          ],
          [
            25.28,
            5.17
          ],
          [
            25.65,
            5.26
          ],
          [
            26.4,
            5.15
          ],
          [
            27.05,
            5.13
          ],
          [
            27.37,
            5.23
          ],
          [
            27.98,
            4.41
          ],
          [
            28.43,
            4.29
          ],
          [
            28.7,
            4.46
          ],
          [
            29.16,
            4.39
          ],
          [
            29.72,
            4.6
          ],
          [
            29.95,
            4.17
          ],
          [
            30.83,
            3.51
          ],
          [
            30.77,
            2.34
          ],
          [
            31.17,
            2.2
          ],
          [
            30.85,
            1.85
          ],
          [
            30.47,
            1.58
          ],
          [
            30.09,
            1.06
          ],
          [
            29.87,
            0.6
          ],
          [
            29.82,
            -0.21
          ],
          [
            29.59,
            -0.59
          ],
          [
            29.58,
            -1.34
          ],
          [
            29.29,
            -1.62
          ],
          [
            29.26,
            -2.21
          ],
          [
            29.12,
            -2.29
          ],
          [
            29.03,
            -2.84
          ],
          [
            29.28,
            -3.29
          ],
          [
            29.34,
            -4.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Somalia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            41.59,
            -1.68
          ],
          [
            40.99,
            -0.86
          ],
          [
            40.98,
            2.78
          ],
          [
            41.86,
            3.92
          ],
          [
            42.13,
            4.23
          ],
          [
            42.77,
            4.25
          ],
          [
            43.66,
            4.96
          ],
          [
            44.96,
            5
          ],
          [
            47.79,
            8
          ],
          [
            48.49,
            8.84
          ],
          [
            48.94,
            9.45
          ],
          [
            48.94,
            9.97
          ],
          [
            48.94,
            10.98
          ],
          [
            48.94,
            11.39
          ],
          [
            48.95,
            11.41
          ],
          [
            49.27,
            11.43
          ],
          [
            49.73,
            11.58
          ],
          [
            50.26,
            11.68
          ],
          [
            50.73,
            12.02
          ],
          [
            51.11,
            12.02
          ],
          [
            51.13,
            11.75
          ],
          [
            51.04,
            11.17
          ],
          [
            51.05,
            10.64
          ],
          [
            50.83,
            10.28
          ],
          [
            50.55,
            9.2
          ],
          [
            50.07,
            8.08
          ],
          [
            49.45,
            6.8
          ],
          [
            48.6,
            5.34
          ],
          [
            47.74,
            4.22
          ],
          [
            46.56,
            2.86
          ],
          [
            45.56,
            2.05
          ],
          [
            44.07,
            1.05
          ],
          [
            43.14,
            0.29
          ],
          [
            42.04,
            -0.92
          ],
          [
            41.81,
            -1.45
          ],
          [
            41.59,
            -1.68
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kenya"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            39.2,
            -4.68
          ],
          [
            37.77,
            -3.68
          ],
          [
            37.7,
            -3.1
          ],
          [
            34.07,
            -1.06
          ],
          [
            33.9,
            -0.95
          ],
          [
            33.89,
            0.11
          ],
          [
            34.18,
            0.52
          ],
          [
            34.67,
            1.18
          ],
          [
            35.04,
            1.91
          ],
          [
            34.59,
            3.05
          ],
          [
            34.48,
            3.55
          ],
          [
            34,
            4.25
          ],
          [
            34.62,
            4.85
          ],
          [
            35.3,
            5.51
          ],
          [
            35.82,
            5.34
          ],
          [
            35.82,
            4.78
          ],
          [
            36.16,
            4.45
          ],
          [
            36.86,
            4.45
          ],
          [
            38.12,
            3.6
          ],
          [
            38.44,
            3.59
          ],
          [
            38.67,
            3.62
          ],
          [
            38.89,
            3.5
          ],
          [
            39.56,
            3.42
          ],
          [
            39.85,
            3.84
          ],
          [
            40.77,
            4.26
          ],
          [
            41.17,
            3.92
          ],
          [
            41.86,
            3.92
          ],
          [
            40.98,
            2.78
          ],
          [
            40.99,
            -0.86
          ],
          [
            41.59,
            -1.68
          ],
          [
            40.88,
            -2.08
          ],
          [
            40.64,
            -2.5
          ],
          [
            40.26,
            -2.57
          ],
          [
            40.12,
            -3.28
          ],
          [
            39.8,
            -3.68
          ],
          [
            39.61,
            -4.35
          ],
          [
            39.2,
            -4.68
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Sudan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            24.57,
            8.23
          ],
          [
            23.81,
            8.67
          ],
          [
            23.46,
            8.95
          ],
          [
            23.39,
            9.27
          ],
          [
            23.56,
            9.68
          ],
          [
            23.55,
            10.09
          ],
          [
            22.98,
            10.71
          ],
          [
            22.87,
            11.14
          ],
          [
            22.88,
            11.38
          ],
          [
            22.51,
            11.68
          ],
          [
            22.5,
            12.26
          ],
          [
            22.29,
            12.65
          ],
          [
            21.94,
            12.59
          ],
          [
            22.04,
            12.96
          ],
          [
            22.3,
            13.37
          ],
          [
            22.18,
            13.79
          ],
          [
            22.51,
            14.09
          ],
          [
            22.3,
            14.33
          ],
          [
            22.57,
            14.94
          ],
          [
            23.02,
            15.68
          ],
          [
            23.89,
            15.61
          ],
          [
            23.84,
            19.58
          ],
          [
            23.85,
            20
          ],
          [
            25,
            20
          ],
          [
            25,
            22
          ],
          [
            29.02,
            22
          ],
          [
            32.9,
            22
          ],
          [
            36.87,
            22
          ],
          [
            37.19,
            21.02
          ],
          [
            36.97,
            20.84
          ],
          [
            37.11,
            19.81
          ],
          [
            37.48,
            18.61
          ],
          [
            37.86,
            18.37
          ],
          [
            38.41,
            18
          ],
          [
            37.9,
            17.43
          ],
          [
            37.17,
            17.26
          ],
          [
            36.85,
            16.96
          ],
          [
            36.75,
            16.29
          ],
          [
            36.32,
            14.82
          ],
          [
            36.43,
            14.42
          ],
          [
            36.27,
            13.56
          ],
          [
            35.87,
            12.58
          ],
          [
            35.26,
            12.08
          ],
          [
            34.83,
            11.32
          ],
          [
            34.73,
            10.91
          ],
          [
            34.26,
            10.63
          ],
          [
            33.96,
            9.58
          ],
          [
            33.98,
            8.69
          ],
          [
            33.96,
            9.46
          ],
          [
            33.82,
            9.48
          ],
          [
            33.84,
            9.98
          ],
          [
            33.72,
            10.33
          ],
          [
            33.21,
            10.72
          ],
          [
            33.09,
            11.44
          ],
          [
            33.21,
            12.18
          ],
          [
            32.74,
            12.25
          ],
          [
            32.68,
            12.02
          ],
          [
            32.07,
            11.97
          ],
          [
            32.32,
            11.68
          ],
          [
            32.4,
            11.08
          ],
          [
            31.85,
            10.53
          ],
          [
            31.35,
            9.81
          ],
          [
            30.84,
            9.71
          ],
          [
            30,
            10.29
          ],
          [
            29.62,
            10.08
          ],
          [
            29.51,
            9.79
          ],
          [
            29,
            9.6
          ],
          [
            28.97,
            9.4
          ],
          [
            27.97,
            9.4
          ],
          [
            27.83,
            9.6
          ],
          [
            27.11,
            9.64
          ],
          [
            26.75,
            9.47
          ],
          [
            26.48,
            9.55
          ],
          [
            25.96,
            10.14
          ],
          [
            25.79,
            10.41
          ],
          [
            25.07,
            10.27
          ],
          [
            24.8,
            9.81
          ],
          [
            24.54,
            8.92
          ],
          [
            24.19,
            8.73
          ],
          [
            23.89,
            8.62
          ],
          [
            24.57,
            8.23
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Chad"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            23.84,
            19.58
          ],
          [
            23.89,
            15.61
          ],
          [
            23.02,
            15.68
          ],
          [
            22.57,
            14.94
          ],
          [
            22.3,
            14.33
          ],
          [
            22.51,
            14.09
          ],
          [
            22.18,
            13.79
          ],
          [
            22.3,
            13.37
          ],
          [
            22.04,
            12.96
          ],
          [
            21.94,
            12.59
          ],
          [
            22.29,
            12.65
          ],
          [
            22.5,
            12.26
          ],
          [
            22.51,
            11.68
          ],
          [
            22.88,
            11.38
          ],
          [
            22.87,
            11.14
          ],
          [
            22.23,
            10.97
          ],
          [
            21.72,
            10.57
          ],
          [
            21,
            9.48
          ],
          [
            20.06,
            9.01
          ],
          [
            19.09,
            9.07
          ],
          [
            18.81,
            8.98
          ],
          [
            18.91,
            8.63
          ],
          [
            18.39,
            8.28
          ],
          [
            17.97,
            7.89
          ],
          [
            16.71,
            7.51
          ],
          [
            16.46,
            7.74
          ],
          [
            16.29,
            7.75
          ],
          [
            16.1,
            7.5
          ],
          [
            15.28,
            7.42
          ],
          [
            15.44,
            7.69
          ],
          [
            15.12,
            8.38
          ],
          [
            14.98,
            8.8
          ],
          [
            14.55,
            8.97
          ],
          [
            13.96,
            9.55
          ],
          [
            14.17,
            10.02
          ],
          [
            14.63,
            9.92
          ],
          [
            14.91,
            9.99
          ],
          [
            15.47,
            9.98
          ],
          [
            14.92,
            10.89
          ],
          [
            14.96,
            11.56
          ],
          [
            14.9,
            12.22
          ],
          [
            14.5,
            12.86
          ],
          [
            14.6,
            13.33
          ],
          [
            13.96,
            13.35
          ],
          [
            13.96,
            14
          ],
          [
            13.54,
            14.37
          ],
          [
            13.97,
            15.68
          ],
          [
            15.25,
            16.63
          ],
          [
            15.3,
            17.93
          ],
          [
            15.69,
            19.96
          ],
          [
            15.9,
            20.39
          ],
          [
            15.49,
            20.73
          ],
          [
            15.47,
            21.05
          ],
          [
            15.1,
            21.31
          ],
          [
            14.85,
            22.86
          ],
          [
            15.86,
            23.41
          ],
          [
            19.85,
            21.49
          ],
          [
            23.84,
            19.58
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Haiti"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -71.71,
            19.71
          ],
          [
            -71.62,
            19.17
          ],
          [
            -71.7,
            18.78
          ],
          [
            -71.94,
            18.62
          ],
          [
            -71.69,
            18.32
          ],
          [
            -71.71,
            18.04
          ],
          [
            -72.37,
            18.21
          ],
          [
            -72.84,
            18.14
          ],
          [
            -73.45,
            18.22
          ],
          [
            -73.92,
            18.03
          ],
          [
            -74.46,
            18.34
          ],
          [
            -74.37,
            18.66
          ],
          [
            -73.45,
            18.53
          ],
          [
            -72.69,
            18.45
          ],
          [
            -72.33,
            18.67
          ],
          [
            -72.79,
            19.1
          ],
          [
            -72.78,
            19.48
          ],
          [
            -73.41,
            19.64
          ],
          [
            -73.19,
            19.92
          ],
          [
            -72.58,
            19.87
          ],
          [
            -71.71,
            19.71
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Dominican Rep."
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -71.71,
            18.04
          ],
          [
            -71.69,
            18.32
          ],
          [
            -71.94,
            18.62
          ],
          [
            -71.7,
            18.78
          ],
          [
            -71.62,
            19.17
          ],
          [
            -71.71,
            19.71
          ],
          [
            -71.59,
            19.88
          ],
          [
            -70.81,
            19.88
          ],
          [
            -70.21,
            19.62
          ],
          [
            -69.95,
            19.65
          ],
          [
            -69.77,
            19.29
          ],
          [
            -69.22,
            19.31
          ],
          [
            -69.26,
            19.01
          ],
          [
            -68.81,
            18.98
          ],
          [
            -68.32,
            18.61
          ],
          [
            -68.69,
            18.21
          ],
          [
            -69.17,
            18.42
          ],
          [
            -69.62,
            18.38
          ],
          [
            -69.95,
            18.43
          ],
          [
            -70.13,
            18.25
          ],
          [
            -70.52,
            18.18
          ],
          [
            -70.67,
            18.43
          ],
          [
            -71,
            18.28
          ],
          [
            -71.4,
            17.6
          ],
          [
            -71.66,
            17.76
          ],
          [
            -71.71,
            18.04
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Russia"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              93.78,
              81.03
            ],
            [
              95.94,
              81.25
            ],
            [
              97.88,
              80.75
            ],
            [
              100.19,
              79.78
            ],
            [
              99.94,
              78.88
            ],
            [
              97.76,
              78.76
            ],
            [
              94.97,
              79.04
            ],
            [
              93.31,
              79.43
            ],
            [
              92.54,
              80.14
            ],
            [
              91.18,
              80.34
            ],
            [
              93.78,
              81.03
            ]
          ]
        ],
        [
          [
            [
              102.84,
              79.28
            ],
            [
              105.37,
              78.71
            ],
            [
              105.08,
              78.31
            ],
            [
              99.44,
              77.92
            ],
            [
              101.26,
              79.23
            ],
            [
              102.09,
              79.35
            ],
            [
              102.84,
              79.28
            ]
          ]
        ],
        [
          [
            [
              138.83,
              76.14
            ],
            [
              141.47,
              76.09
            ],
            [
              145.09,
              75.56
            ],
            [
              144.3,
              74.82
            ],
            [
              140.62,
              74.85
            ],
            [
              138.96,
              74.61
            ],
            [
              136.98,
              75.26
            ],
            [
              137.51,
              75.95
            ],
            [
              138.83,
              76.14
            ]
          ]
        ],
        [
          [
            [
              148.22,
              75.35
            ],
            [
              150.73,
              75.08
            ],
            [
              149.58,
              74.69
            ],
            [
              147.98,
              74.78
            ],
            [
              146.12,
              75.17
            ],
            [
              146.36,
              75.5
            ],
            [
              148.22,
              75.35
            ]
          ]
        ],
        [
          [
            [
              139.86,
              73.37
            ],
            [
              140.81,
              73.77
            ],
            [
              142.06,
              73.86
            ],
            [
              143.48,
              73.47
            ],
            [
              143.6,
              73.21
            ],
            [
              142.09,
              73.21
            ],
            [
              140.04,
              73.32
            ],
            [
              139.86,
              73.37
            ]
          ]
        ],
        [
          [
            [
              44.85,
              80.59
            ],
            [
              46.8,
              80.77
            ],
            [
              48.32,
              80.78
            ],
            [
              48.52,
              80.51
            ],
            [
              49.1,
              80.75
            ],
            [
              50.04,
              80.92
            ],
            [
              51.52,
              80.7
            ],
            [
              51.14,
              80.55
            ],
            [
              49.79,
              80.42
            ],
            [
              48.89,
              80.34
            ],
            [
              48.75,
              80.18
            ],
            [
              47.59,
              80.01
            ],
            [
              46.5,
              80.25
            ],
            [
              47.07,
              80.56
            ],
            [
              44.85,
              80.59
            ]
          ]
        ],
        [
          [
            [
              22.73,
              54.33
            ],
            [
              20.89,
              54.31
            ],
            [
              19.66,
              54.43
            ],
            [
              19.89,
              54.87
            ],
            [
              21.27,
              55.19
            ],
            [
              22.31,
              55.02
            ],
            [
              22.76,
              54.86
            ],
            [
              22.65,
              54.58
            ],
            [
              22.73,
              54.33
            ]
          ]
        ],
        [
          [
            [
              53.51,
              73.75
            ],
            [
              55.9,
              74.63
            ],
            [
              55.63,
              75.08
            ],
            [
              57.87,
              75.61
            ],
            [
              61.17,
              76.25
            ],
            [
              64.5,
              76.44
            ],
            [
              66.21,
              76.81
            ],
            [
              68.16,
              76.94
            ],
            [
              68.85,
              76.54
            ],
            [
              68.18,
              76.23
            ],
            [
              64.64,
              75.74
            ],
            [
              61.58,
              75.26
            ],
            [
              58.48,
              74.31
            ],
            [
              56.99,
              73.33
            ],
            [
              55.42,
              72.37
            ],
            [
              55.62,
              71.54
            ],
            [
              57.53,
              70.72
            ],
            [
              56.94,
              70.63
            ],
            [
              53.68,
              70.76
            ],
            [
              53.41,
              71.21
            ],
            [
              51.6,
              71.47
            ],
            [
              51.46,
              72.02
            ],
            [
              52.48,
              72.23
            ],
            [
              52.44,
              72.78
            ],
            [
              54.43,
              73.63
            ],
            [
              53.51,
              73.75
            ]
          ]
        ],
        [
          [
            [
              142.92,
              53.7
            ],
            [
              143.26,
              52.74
            ],
            [
              143.24,
              51.76
            ],
            [
              143.65,
              50.75
            ],
            [
              144.65,
              48.98
            ],
            [
              143.18,
              49.31
            ],
            [
              142.56,
              47.86
            ],
            [
              143.54,
              46.84
            ],
            [
              143.51,
              46.14
            ],
            [
              142.75,
              46.74
            ],
            [
              142.09,
              45.97
            ],
            [
              141.91,
              46.81
            ],
            [
              142.02,
              47.78
            ],
            [
              141.9,
              48.86
            ],
            [
              142.13,
              49.61
            ],
            [
              142.18,
              50.95
            ],
            [
              141.59,
              51.94
            ],
            [
              141.68,
              53.3
            ],
            [
              142.61,
              53.76
            ],
            [
              142.21,
              54.23
            ],
            [
              142.65,
              54.37
            ],
            [
              142.92,
              53.7
            ]
          ]
        ],
        [
          [
            [
              130.78,
              42.22
            ],
            [
              130.64,
              42.4
            ],
            [
              130.63,
              42.9
            ],
            [
              131.14,
              42.93
            ],
            [
              131.29,
              44.11
            ],
            [
              131.03,
              44.97
            ],
            [
              131.88,
              45.32
            ],
            [
              133.1,
              45.14
            ],
            [
              133.77,
              46.12
            ],
            [
              134.11,
              47.21
            ],
            [
              134.5,
              47.58
            ],
            [
              135.02,
              48.48
            ],
            [
              133.37,
              48.18
            ],
            [
              132.51,
              47.79
            ],
            [
              130.99,
              47.79
            ],
            [
              130.58,
              48.73
            ],
            [
              129.4,
              49.44
            ],
            [
              127.66,
              49.76
            ],
            [
              127.29,
              50.74
            ],
            [
              126.94,
              51.35
            ],
            [
              126.56,
              51.78
            ],
            [
              125.95,
              52.79
            ],
            [
              125.07,
              53.16
            ],
            [
              123.57,
              53.46
            ],
            [
              122.24,
              53.43
            ],
            [
              121,
              53.25
            ],
            [
              120.18,
              52.75
            ],
            [
              120.73,
              52.52
            ],
            [
              120.74,
              51.96
            ],
            [
              120.18,
              51.64
            ],
            [
              119.28,
              50.58
            ],
            [
              119.29,
              50.14
            ],
            [
              117.88,
              49.51
            ],
            [
              116.68,
              49.89
            ],
            [
              115.49,
              49.81
            ],
            [
              114.96,
              50.14
            ],
            [
              114.36,
              50.25
            ],
            [
              112.9,
              49.54
            ],
            [
              111.58,
              49.38
            ],
            [
              110.66,
              49.13
            ],
            [
              109.4,
              49.29
            ],
            [
              108.47,
              49.28
            ],
            [
              107.87,
              49.79
            ],
            [
              106.89,
              50.27
            ],
            [
              105.89,
              50.41
            ],
            [
              104.62,
              50.27
            ],
            [
              103.68,
              50.09
            ],
            [
              102.26,
              50.51
            ],
            [
              102.07,
              51.26
            ],
            [
              100.89,
              51.52
            ],
            [
              99.98,
              51.63
            ],
            [
              98.86,
              52.05
            ],
            [
              97.83,
              51.01
            ],
            [
              98.23,
              50.42
            ],
            [
              97.26,
              49.73
            ],
            [
              95.81,
              49.98
            ],
            [
              94.82,
              50.01
            ],
            [
              94.15,
              50.48
            ],
            [
              93.11,
              50.49
            ],
            [
              92.23,
              50.8
            ],
            [
              90.71,
              50.33
            ],
            [
              88.8,
              49.47
            ],
            [
              87.75,
              49.3
            ],
            [
              87.36,
              49.22
            ],
            [
              86.83,
              49.83
            ],
            [
              85.54,
              49.69
            ],
            [
              85.11,
              50.12
            ],
            [
              84.42,
              50.31
            ],
            [
              83.94,
              50.89
            ],
            [
              83.38,
              51.07
            ],
            [
              81.95,
              50.81
            ],
            [
              80.57,
              51.39
            ],
            [
              80.03,
              50.87
            ],
            [
              77.8,
              53.4
            ],
            [
              76.52,
              54.18
            ],
            [
              76.89,
              54.49
            ],
            [
              74.39,
              53.55
            ],
            [
              73.42,
              53.49
            ],
            [
              73.51,
              54.04
            ],
            [
              72.23,
              54.38
            ],
            [
              71.18,
              54.13
            ],
            [
              70.86,
              55.17
            ],
            [
              69.07,
              55.38
            ],
            [
              68.17,
              54.97
            ],
            [
              65.67,
              54.6
            ],
            [
              65.18,
              54.35
            ],
            [
              61.44,
              54.01
            ],
            [
              60.98,
              53.66
            ],
            [
              61.7,
              52.98
            ],
            [
              60.74,
              52.72
            ],
            [
              60.93,
              52.45
            ],
            [
              59.97,
              51.96
            ],
            [
              61.59,
              51.27
            ],
            [
              61.34,
              50.8
            ],
            [
              59.93,
              50.84
            ],
            [
              59.64,
              50.55
            ],
            [
              58.36,
              51.06
            ],
            [
              56.78,
              51.04
            ],
            [
              55.72,
              50.62
            ],
            [
              54.53,
              51.03
            ],
            [
              52.33,
              51.72
            ],
            [
              50.77,
              51.69
            ],
            [
              48.7,
              50.6
            ],
            [
              48.58,
              49.88
            ],
            [
              47.55,
              50.45
            ],
            [
              46.75,
              49.36
            ],
            [
              47.04,
              49.15
            ],
            [
              46.47,
              48.39
            ],
            [
              47.31,
              47.72
            ],
            [
              48.06,
              47.74
            ],
            [
              48.7,
              47.08
            ],
            [
              48.59,
              46.56
            ],
            [
              49.1,
              46.4
            ],
            [
              48.65,
              45.81
            ],
            [
              47.68,
              45.64
            ],
            [
              46.68,
              44.61
            ],
            [
              47.59,
              43.66
            ],
            [
              47.49,
              42.99
            ],
            [
              48.58,
              41.81
            ],
            [
              47.99,
              41.41
            ],
            [
              47.81,
              41.15
            ],
            [
              47.37,
              41.22
            ],
            [
              46.69,
              41.83
            ],
            [
              46.41,
              41.86
            ],
            [
              45.78,
              42.09
            ],
            [
              45.47,
              42.5
            ],
            [
              44.54,
              42.71
            ],
            [
              43.93,
              42.55
            ],
            [
              43.76,
              42.74
            ],
            [
              42.4,
              43.22
            ],
            [
              40.92,
              43.38
            ],
            [
              40.08,
              43.55
            ],
            [
              39.95,
              43.44
            ],
            [
              38.68,
              44.28
            ],
            [
              37.54,
              44.66
            ],
            [
              36.68,
              45.24
            ],
            [
              37.4,
              45.41
            ],
            [
              38.23,
              46.24
            ],
            [
              37.67,
              46.64
            ],
            [
              39.15,
              47.05
            ],
            [
              39.12,
              47.26
            ],
            [
              38.22,
              47.1
            ],
            [
              38.26,
              47.55
            ],
            [
              38.77,
              47.83
            ],
            [
              39.74,
              47.9
            ],
            [
              39.9,
              48.23
            ],
            [
              39.67,
              48.78
            ],
            [
              40.08,
              49.31
            ],
            [
              40.07,
              49.6
            ],
            [
              38.59,
              49.93
            ],
            [
              38.01,
              49.92
            ],
            [
              37.39,
              50.38
            ],
            [
              36.62,
              50.23
            ],
            [
              35.36,
              50.58
            ],
            [
              35.38,
              50.77
            ],
            [
              35.02,
              51.21
            ],
            [
              34.22,
              51.26
            ],
            [
              34.14,
              51.57
            ],
            [
              34.39,
              51.77
            ],
            [
              33.75,
              52.33
            ],
            [
              32.72,
              52.24
            ],
            [
              32.41,
              52.29
            ],
            [
              32.16,
              52.06
            ],
            [
              31.79,
              52.1
            ],
            [
              31.54,
              52.74
            ],
            [
              31.3,
              53.07
            ],
            [
              31.5,
              53.17
            ],
            [
              32.3,
              53.13
            ],
            [
              32.69,
              53.35
            ],
            [
              32.41,
              53.62
            ],
            [
              31.73,
              53.79
            ],
            [
              31.79,
              53.97
            ],
            [
              31.38,
              54.16
            ],
            [
              30.76,
              54.81
            ],
            [
              30.97,
              55.08
            ],
            [
              30.88,
              55.55
            ],
            [
              29.9,
              55.79
            ],
            [
              29.37,
              55.67
            ],
            [
              29.23,
              55.92
            ],
            [
              28.18,
              56.17
            ],
            [
              27.86,
              56.76
            ],
            [
              27.77,
              57.24
            ],
            [
              27.29,
              57.47
            ],
            [
              27.72,
              57.79
            ],
            [
              27.42,
              58.72
            ],
            [
              28.13,
              59.3
            ],
            [
              27.98,
              59.48
            ],
            [
              29.12,
              60.03
            ],
            [
              28.07,
              60.5
            ],
            [
              30.21,
              61.78
            ],
            [
              31.14,
              62.36
            ],
            [
              31.52,
              62.87
            ],
            [
              30.04,
              63.55
            ],
            [
              30.44,
              64.2
            ],
            [
              29.54,
              64.95
            ],
            [
              30.22,
              65.81
            ],
            [
              29.05,
              66.94
            ],
            [
              29.98,
              67.7
            ],
            [
              28.45,
              68.36
            ],
            [
              28.59,
              69.07
            ],
            [
              29.4,
              69.16
            ],
            [
              31.1,
              69.56
            ],
            [
              32.13,
              69.91
            ],
            [
              33.77,
              69.3
            ],
            [
              36.51,
              69.06
            ],
            [
              40.29,
              67.93
            ],
            [
              41.06,
              67.46
            ],
            [
              41.13,
              66.79
            ],
            [
              40.02,
              66.27
            ],
            [
              38.38,
              66
            ],
            [
              33.92,
              66.76
            ],
            [
              33.18,
              66.63
            ],
            [
              34.81,
              65.9
            ],
            [
              34.88,
              65.44
            ],
            [
              34.94,
              64.41
            ],
            [
              36.23,
              64.11
            ],
            [
              37.01,
              63.85
            ],
            [
              37.14,
              64.33
            ],
            [
              36.54,
              64.76
            ],
            [
              37.18,
              65.14
            ],
            [
              39.59,
              64.52
            ],
            [
              40.43,
              64.76
            ],
            [
              39.76,
              65.5
            ],
            [
              42.09,
              66.48
            ],
            [
              43.02,
              66.42
            ],
            [
              43.95,
              66.07
            ],
            [
              44.53,
              66.76
            ],
            [
              43.7,
              67.35
            ],
            [
              44.19,
              67.95
            ],
            [
              43.45,
              68.57
            ],
            [
              46.25,
              68.25
            ],
            [
              46.82,
              67.69
            ],
            [
              45.56,
              67.57
            ],
            [
              45.56,
              67.01
            ],
            [
              46.35,
              66.67
            ],
            [
              47.89,
              66.88
            ],
            [
              48.14,
              67.52
            ],
            [
              50.23,
              68
            ],
            [
              53.72,
              68.86
            ],
            [
              54.47,
              68.81
            ],
            [
              53.49,
              68.2
            ],
            [
              54.73,
              68.1
            ],
            [
              55.44,
              68.44
            ],
            [
              57.32,
              68.47
            ],
            [
              58.8,
              68.88
            ],
            [
              59.94,
              68.28
            ],
            [
              61.08,
              68.94
            ],
            [
              60.03,
              69.52
            ],
            [
              60.55,
              69.85
            ],
            [
              63.5,
              69.55
            ],
            [
              64.89,
              69.23
            ],
            [
              68.51,
              68.09
            ],
            [
              69.18,
              68.62
            ],
            [
              68.16,
              69.14
            ],
            [
              68.14,
              69.36
            ],
            [
              66.93,
              69.45
            ],
            [
              67.26,
              69.93
            ],
            [
              66.72,
              70.71
            ],
            [
              66.7,
              71.03
            ],
            [
              68.54,
              71.93
            ],
            [
              69.2,
              72.84
            ],
            [
              69.94,
              73.04
            ],
            [
              72.59,
              72.78
            ],
            [
              72.79,
              72.22
            ],
            [
              71.85,
              71.41
            ],
            [
              72.47,
              71.09
            ],
            [
              72.79,
              70.39
            ],
            [
              72.56,
              69.02
            ],
            [
              73.67,
              68.41
            ],
            [
              73.24,
              67.74
            ],
            [
              71.28,
              66.32
            ],
            [
              72.42,
              66.17
            ],
            [
              72.82,
              66.53
            ],
            [
              73.92,
              66.79
            ],
            [
              74.19,
              67.28
            ],
            [
              75.05,
              67.76
            ],
            [
              74.47,
              68.33
            ],
            [
              74.94,
              68.99
            ],
            [
              73.84,
              69.07
            ],
            [
              73.6,
              69.63
            ],
            [
              74.4,
              70.63
            ],
            [
              73.1,
              71.45
            ],
            [
              74.89,
              72.12
            ],
            [
              74.66,
              72.83
            ],
            [
              75.16,
              72.86
            ],
            [
              75.68,
              72.3
            ],
            [
              75.29,
              71.34
            ],
            [
              76.36,
              71.15
            ],
            [
              75.9,
              71.87
            ],
            [
              77.58,
              72.27
            ],
            [
              79.65,
              72.32
            ],
            [
              81.5,
              71.75
            ],
            [
              80.61,
              72.58
            ],
            [
              80.51,
              73.65
            ],
            [
              82.25,
              73.85
            ],
            [
              84.66,
              73.81
            ],
            [
              86.82,
              73.94
            ],
            [
              86.01,
              74.46
            ],
            [
              87.17,
              75.12
            ],
            [
              88.31,
              75.14
            ],
            [
              90.26,
              75.64
            ],
            [
              92.9,
              75.77
            ],
            [
              93.24,
              76.05
            ],
            [
              95.86,
              76.14
            ],
            [
              96.68,
              75.92
            ],
            [
              98.92,
              76.45
            ],
            [
              100.76,
              76.43
            ],
            [
              101.04,
              76.86
            ],
            [
              101.99,
              77.29
            ],
            [
              104.35,
              77.7
            ],
            [
              106.07,
              77.37
            ],
            [
              104.71,
              77.13
            ],
            [
              106.97,
              76.97
            ],
            [
              107.24,
              76.48
            ],
            [
              108.15,
              76.72
            ],
            [
              111.08,
              76.71
            ],
            [
              113.33,
              76.22
            ],
            [
              114.13,
              75.85
            ],
            [
              113.89,
              75.33
            ],
            [
              112.78,
              75.03
            ],
            [
              110.15,
              74.48
            ],
            [
              109.4,
              74.18
            ],
            [
              110.64,
              74.04
            ],
            [
              112.12,
              73.79
            ],
            [
              113.02,
              73.98
            ],
            [
              113.53,
              73.34
            ],
            [
              113.97,
              73.59
            ],
            [
              115.57,
              73.75
            ],
            [
              118.78,
              73.59
            ],
            [
              119.02,
              73.12
            ],
            [
              123.2,
              72.97
            ],
            [
              123.26,
              73.74
            ],
            [
              125.38,
              73.56
            ],
            [
              126.98,
              73.57
            ],
            [
              128.59,
              73.04
            ],
            [
              129.05,
              72.4
            ],
            [
              128.46,
              71.98
            ],
            [
              129.71,
              71.19
            ],
            [
              131.29,
              70.79
            ],
            [
              132.25,
              71.84
            ],
            [
              133.86,
              71.39
            ],
            [
              135.56,
              71.66
            ],
            [
              137.5,
              71.35
            ],
            [
              138.23,
              71.63
            ],
            [
              139.87,
              71.49
            ],
            [
              139.15,
              72.42
            ],
            [
              140.47,
              72.85
            ],
            [
              149.5,
              72.2
            ],
            [
              150.35,
              71.61
            ],
            [
              152.97,
              70.84
            ],
            [
              157.01,
              71.03
            ],
            [
              159,
              70.87
            ],
            [
              159.83,
              70.45
            ],
            [
              159.71,
              69.72
            ],
            [
              160.94,
              69.44
            ],
            [
              162.28,
              69.64
            ],
            [
              164.05,
              69.67
            ],
            [
              165.94,
              69.47
            ],
            [
              167.84,
              69.58
            ],
            [
              169.58,
              68.69
            ],
            [
              170.82,
              69.01
            ],
            [
              170.01,
              69.65
            ],
            [
              170.45,
              70.1
            ],
            [
              173.64,
              69.82
            ],
            [
              175.72,
              69.88
            ],
            [
              178.6,
              69.4
            ],
            [
              -180,
              68.96
            ],
            [
              -177.55,
              68.2
            ],
            [
              -174.93,
              67.21
            ],
            [
              -175.01,
              66.58
            ],
            [
              -174.34,
              66.34
            ],
            [
              -174.57,
              67.06
            ],
            [
              -171.86,
              66.91
            ],
            [
              -169.9,
              65.98
            ],
            [
              -170.89,
              65.54
            ],
            [
              -172.53,
              65.44
            ],
            [
              -172.56,
              64.46
            ],
            [
              -172.95,
              64.25
            ],
            [
              -173.89,
              64.28
            ],
            [
              -174.65,
              64.63
            ],
            [
              -175.98,
              64.92
            ],
            [
              -176.21,
              65.36
            ],
            [
              -177.22,
              65.52
            ],
            [
              -178.36,
              65.39
            ],
            [
              -178.9,
              65.74
            ],
            [
              -178.69,
              66.11
            ],
            [
              -179.88,
              65.87
            ],
            [
              -179.43,
              65.4
            ],
            [
              -180,
              64.98
            ],
            [
              179.99,
              64.97
            ],
            [
              178.71,
              64.53
            ],
            [
              177.41,
              64.61
            ],
            [
              178.31,
              64.08
            ],
            [
              178.91,
              63.25
            ],
            [
              179.37,
              62.98
            ],
            [
              179.49,
              62.57
            ],
            [
              179.23,
              62.3
            ],
            [
              177.36,
              62.52
            ],
            [
              174.57,
              61.77
            ],
            [
              173.68,
              61.65
            ],
            [
              172.15,
              60.95
            ],
            [
              170.7,
              60.34
            ],
            [
              170.33,
              59.88
            ],
            [
              168.9,
              60.57
            ],
            [
              166.29,
              59.79
            ],
            [
              165.84,
              60.16
            ],
            [
              164.88,
              59.73
            ],
            [
              163.54,
              59.87
            ],
            [
              163.22,
              59.21
            ],
            [
              162.02,
              58.24
            ],
            [
              162.05,
              57.84
            ],
            [
              163.19,
              57.62
            ],
            [
              163.06,
              56.16
            ],
            [
              162.13,
              56.12
            ],
            [
              161.7,
              55.29
            ],
            [
              162.12,
              54.85
            ],
            [
              160.37,
              54.34
            ],
            [
              160.02,
              53.2
            ],
            [
              158.53,
              52.96
            ],
            [
              158.23,
              51.94
            ],
            [
              156.79,
              51.01
            ],
            [
              156.42,
              51.7
            ],
            [
              155.99,
              53.16
            ],
            [
              155.43,
              55.38
            ],
            [
              155.92,
              56.77
            ],
            [
              156.76,
              57.36
            ],
            [
              156.81,
              57.83
            ],
            [
              158.36,
              58.06
            ],
            [
              160.15,
              59.31
            ],
            [
              161.87,
              60.34
            ],
            [
              163.67,
              61.14
            ],
            [
              164.47,
              62.55
            ],
            [
              163.26,
              62.47
            ],
            [
              162.66,
              61.64
            ],
            [
              160.12,
              60.54
            ],
            [
              159.3,
              61.77
            ],
            [
              156.72,
              61.43
            ],
            [
              154.22,
              59.76
            ],
            [
              155.04,
              59.15
            ],
            [
              152.81,
              58.88
            ],
            [
              151.26,
              58.78
            ],
            [
              151.34,
              59.5
            ],
            [
              149.78,
              59.66
            ],
            [
              148.55,
              59.16
            ],
            [
              145.49,
              59.34
            ],
            [
              142.2,
              59.04
            ],
            [
              138.96,
              57.09
            ],
            [
              135.13,
              54.73
            ],
            [
              136.7,
              54.6
            ],
            [
              137.19,
              53.98
            ],
            [
              138.16,
              53.75
            ],
            [
              138.8,
              54.25
            ],
            [
              139.9,
              54.19
            ],
            [
              141.35,
              53.09
            ],
            [
              141.38,
              52.24
            ],
            [
              140.6,
              51.24
            ],
            [
              140.51,
              50.05
            ],
            [
              140.06,
              48.45
            ],
            [
              138.56,
              47
            ],
            [
              138.22,
              46.31
            ],
            [
              136.86,
              45.14
            ],
            [
              135.51,
              43.99
            ],
            [
              134.87,
              43.4
            ],
            [
              133.54,
              42.81
            ],
            [
              132.91,
              42.8
            ],
            [
              132.28,
              43.28
            ],
            [
              130.94,
              42.55
            ],
            [
              130.78,
              42.22
            ]
          ]
        ],
        [
          [
            [
              -180,
              71.52
            ],
            [
              -179.87,
              71.56
            ],
            [
              -179.02,
              71.56
            ],
            [
              -177.58,
              71.27
            ],
            [
              -177.66,
              71.13
            ],
            [
              -178.69,
              70.89
            ],
            [
              -180,
              70.83
            ],
            [
              178.9,
              70.78
            ],
            [
              178.73,
              71.1
            ],
            [
              -180,
              71.52
            ]
          ]
        ],
        [
          [
            [
              33.44,
              45.97
            ],
            [
              33.7,
              46.22
            ],
            [
              34.41,
              46
            ],
            [
              34.73,
              45.97
            ],
            [
              34.86,
              45.77
            ],
            [
              35.01,
              45.74
            ],
            [
              35.02,
              45.65
            ],
            [
              35.51,
              45.41
            ],
            [
              36.53,
              45.47
            ],
            [
              36.33,
              45.11
            ],
            [
              35.24,
              44.94
            ],
            [
              33.88,
              44.36
            ],
            [
              33.33,
              44.57
            ],
            [
              33.55,
              45.03
            ],
            [
              32.45,
              45.33
            ],
            [
              32.63,
              45.52
            ],
            [
              33.59,
              45.85
            ],
            [
              33.44,
              45.97
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bahamas"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -78.98,
              26.79
            ],
            [
              -78.51,
              26.87
            ],
            [
              -77.85,
              26.84
            ],
            [
              -77.82,
              26.58
            ],
            [
              -78.91,
              26.42
            ],
            [
              -78.98,
              26.79
            ]
          ]
        ],
        [
          [
            [
              -77.79,
              27.04
            ],
            [
              -77,
              26.59
            ],
            [
              -77.17,
              25.88
            ],
            [
              -77.36,
              26.01
            ],
            [
              -77.34,
              26.53
            ],
            [
              -77.79,
              26.93
            ],
            [
              -77.79,
              27.04
            ]
          ]
        ],
        [
          [
            [
              -78.19,
              25.21
            ],
            [
              -77.89,
              25.17
            ],
            [
              -77.54,
              24.34
            ],
            [
              -77.54,
              23.76
            ],
            [
              -77.78,
              23.71
            ],
            [
              -78.03,
              24.29
            ],
            [
              -78.41,
              24.57
            ],
            [
              -78.19,
              25.21
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Falkland Is."
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -61.2,
            -51.85
          ],
          [
            -60,
            -51.25
          ],
          [
            -59.15,
            -51.5
          ],
          [
            -58.55,
            -51.1
          ],
          [
            -57.75,
            -51.55
          ],
          [
            -58.05,
            -51.9
          ],
          [
            -59.4,
            -52.2
          ],
          [
            -59.85,
            -51.85
          ],
          [
            -60.7,
            -52.3
          ],
          [
            -61.2,
            -51.85
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Norway"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              15.14,
              79.67
            ],
            [
              15.52,
              80.02
            ],
            [
              16.99,
              80.05
            ],
            [
              18.25,
              79.7
            ],
            [
              21.54,
              78.96
            ],
            [
              19.03,
              78.56
            ],
            [
              18.47,
              77.83
            ],
            [
              17.6,
              77.64
            ],
            [
              17.12,
              76.81
            ],
            [
              15.91,
              76.77
            ],
            [
              13.76,
              77.38
            ],
            [
              14.67,
              77.74
            ],
            [
              13.17,
              78.02
            ],
            [
              11.22,
              78.87
            ],
            [
              10.45,
              79.65
            ],
            [
              13.17,
              80.01
            ],
            [
              13.72,
              79.66
            ],
            [
              15.14,
              79.67
            ]
          ]
        ],
        [
          [
            [
              31.1,
              69.56
            ],
            [
              29.4,
              69.16
            ],
            [
              28.59,
              69.07
            ],
            [
              29.01,
              69.77
            ],
            [
              27.73,
              70.16
            ],
            [
              26.18,
              69.83
            ],
            [
              25.69,
              69.09
            ],
            [
              24.73,
              68.65
            ],
            [
              23.66,
              68.89
            ],
            [
              22.36,
              68.84
            ],
            [
              21.25,
              69.37
            ],
            [
              20.64,
              69.11
            ],
            [
              20.03,
              69.07
            ],
            [
              19.88,
              68.41
            ],
            [
              17.99,
              68.57
            ],
            [
              17.73,
              68.01
            ],
            [
              16.77,
              68.01
            ],
            [
              16.11,
              67.3
            ],
            [
              15.11,
              66.19
            ],
            [
              13.56,
              64.79
            ],
            [
              13.92,
              64.44
            ],
            [
              13.57,
              64.05
            ],
            [
              12.58,
              64.07
            ],
            [
              11.93,
              63.13
            ],
            [
              11.99,
              61.8
            ],
            [
              12.63,
              61.29
            ],
            [
              12.3,
              60.12
            ],
            [
              11.47,
              59.43
            ],
            [
              11.03,
              58.86
            ],
            [
              10.36,
              59.47
            ],
            [
              8.38,
              58.31
            ],
            [
              7.05,
              58.08
            ],
            [
              5.66,
              58.59
            ],
            [
              5.31,
              59.66
            ],
            [
              4.99,
              61.97
            ],
            [
              5.91,
              62.62
            ],
            [
              8.55,
              63.45
            ],
            [
              10.53,
              64.49
            ],
            [
              12.36,
              65.88
            ],
            [
              14.76,
              67.81
            ],
            [
              16.44,
              68.56
            ],
            [
              19.18,
              69.82
            ],
            [
              21.38,
              70.26
            ],
            [
              23.02,
              70.2
            ],
            [
              24.55,
              71.03
            ],
            [
              26.37,
              70.99
            ],
            [
              28.16,
              71.19
            ],
            [
              31.29,
              70.45
            ],
            [
              30,
              70.19
            ],
            [
              31.1,
              69.56
            ]
          ]
        ],
        [
          [
            [
              27.41,
              80.06
            ],
            [
              25.93,
              79.52
            ],
            [
              23.02,
              79.4
            ],
            [
              20.08,
              79.57
            ],
            [
              19.9,
              79.84
            ],
            [
              18.46,
              79.86
            ],
            [
              17.37,
              80.32
            ],
            [
              20.46,
              80.6
            ],
            [
              21.91,
              80.36
            ],
            [
              22.92,
              80.66
            ],
            [
              25.45,
              80.41
            ],
            [
              27.41,
              80.06
            ]
          ]
        ],
        [
          [
            [
              24.72,
              77.85
            ],
            [
              22.49,
              77.45
            ],
            [
              20.73,
              77.68
            ],
            [
              21.41,
              77.93
            ],
            [
              20.81,
              78.25
            ],
            [
              22.88,
              78.46
            ],
            [
              23.28,
              78.08
            ],
            [
              24.72,
              77.85
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Greenland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -46.76,
            82.63
          ],
          [
            -43.41,
            83.23
          ],
          [
            -39.9,
            83.18
          ],
          [
            -38.62,
            83.55
          ],
          [
            -35.09,
            83.65
          ],
          [
            -27.1,
            83.52
          ],
          [
            -20.85,
            82.73
          ],
          [
            -22.69,
            82.34
          ],
          [
            -26.52,
            82.3
          ],
          [
            -31.9,
            82.2
          ],
          [
            -31.4,
            82.02
          ],
          [
            -27.86,
            82.13
          ],
          [
            -24.85,
            81.79
          ],
          [
            -22.9,
            82.09
          ],
          [
            -22.07,
            81.73
          ],
          [
            -23.17,
            81.15
          ],
          [
            -20.62,
            81.52
          ],
          [
            -15.77,
            81.91
          ],
          [
            -12.77,
            81.72
          ],
          [
            -12.21,
            81.29
          ],
          [
            -16.28,
            80.58
          ],
          [
            -16.85,
            80.35
          ],
          [
            -20.05,
            80.18
          ],
          [
            -17.73,
            80.13
          ],
          [
            -18.9,
            79.4
          ],
          [
            -19.7,
            78.75
          ],
          [
            -19.67,
            77.64
          ],
          [
            -18.47,
            76.98
          ],
          [
            -20.04,
            76.94
          ],
          [
            -21.68,
            76.63
          ],
          [
            -19.83,
            76.1
          ],
          [
            -19.6,
            75.25
          ],
          [
            -20.67,
            75.16
          ],
          [
            -19.37,
            74.3
          ],
          [
            -21.59,
            74.22
          ],
          [
            -20.44,
            73.82
          ],
          [
            -20.76,
            73.46
          ],
          [
            -22.17,
            73.31
          ],
          [
            -23.57,
            73.31
          ],
          [
            -22.31,
            72.63
          ],
          [
            -22.3,
            72.18
          ],
          [
            -24.28,
            72.6
          ],
          [
            -24.79,
            72.33
          ],
          [
            -23.44,
            72.08
          ],
          [
            -22.13,
            71.47
          ],
          [
            -21.75,
            70.66
          ],
          [
            -23.54,
            70.47
          ],
          [
            -24.31,
            70.86
          ],
          [
            -25.54,
            71.43
          ],
          [
            -25.2,
            70.75
          ],
          [
            -26.36,
            70.23
          ],
          [
            -23.73,
            70.18
          ],
          [
            -22.35,
            70.13
          ],
          [
            -25.03,
            69.26
          ],
          [
            -27.75,
            68.47
          ],
          [
            -30.67,
            68.12
          ],
          [
            -31.78,
            68.12
          ],
          [
            -32.81,
            67.74
          ],
          [
            -34.2,
            66.68
          ],
          [
            -36.35,
            65.98
          ],
          [
            -37.04,
            65.94
          ],
          [
            -38.37,
            65.69
          ],
          [
            -39.81,
            65.46
          ],
          [
            -40.67,
            64.84
          ],
          [
            -40.68,
            64.14
          ],
          [
            -41.19,
            63.48
          ],
          [
            -42.82,
            62.68
          ],
          [
            -42.42,
            61.9
          ],
          [
            -42.87,
            61.07
          ],
          [
            -43.38,
            60.1
          ],
          [
            -44.79,
            60.04
          ],
          [
            -46.26,
            60.85
          ],
          [
            -48.26,
            60.86
          ],
          [
            -49.23,
            61.41
          ],
          [
            -49.9,
            62.38
          ],
          [
            -51.63,
            63.63
          ],
          [
            -52.14,
            64.28
          ],
          [
            -52.28,
            65.18
          ],
          [
            -53.66,
            66.1
          ],
          [
            -53.3,
            66.84
          ],
          [
            -53.97,
            67.19
          ],
          [
            -52.98,
            68.36
          ],
          [
            -51.48,
            68.73
          ],
          [
            -51.08,
            69.15
          ],
          [
            -50.87,
            69.93
          ],
          [
            -52.02,
            69.57
          ],
          [
            -52.56,
            69.43
          ],
          [
            -53.46,
            69.28
          ],
          [
            -54.68,
            69.61
          ],
          [
            -54.75,
            70.29
          ],
          [
            -54.36,
            70.82
          ],
          [
            -53.43,
            70.84
          ],
          [
            -51.39,
            70.57
          ],
          [
            -53.11,
            71.2
          ],
          [
            -54.01,
            71.55
          ],
          [
            -55,
            71.41
          ],
          [
            -55.83,
            71.66
          ],
          [
            -54.72,
            72.59
          ],
          [
            -55.33,
            72.96
          ],
          [
            -56.12,
            73.65
          ],
          [
            -57.33,
            74.71
          ],
          [
            -58.6,
            75.1
          ],
          [
            -58.59,
            75.52
          ],
          [
            -61.27,
            76.1
          ],
          [
            -63.39,
            76.18
          ],
          [
            -66.07,
            76.14
          ],
          [
            -68.5,
            76.06
          ],
          [
            -69.67,
            76.38
          ],
          [
            -71.4,
            77.01
          ],
          [
            -68.78,
            77.32
          ],
          [
            -66.76,
            77.38
          ],
          [
            -71.04,
            77.64
          ],
          [
            -73.3,
            78.04
          ],
          [
            -73.16,
            78.43
          ],
          [
            -69.37,
            78.91
          ],
          [
            -65.71,
            79.4
          ],
          [
            -65.32,
            79.76
          ],
          [
            -68.02,
            80.12
          ],
          [
            -67.15,
            80.52
          ],
          [
            -63.69,
            81.21
          ],
          [
            -62.24,
            81.32
          ],
          [
            -62.65,
            81.77
          ],
          [
            -60.28,
            82.03
          ],
          [
            -57.21,
            82.19
          ],
          [
            -54.14,
            82.2
          ],
          [
            -53.04,
            81.89
          ],
          [
            -50.39,
            82.44
          ],
          [
            -48,
            82.06
          ],
          [
            -46.6,
            81.99
          ],
          [
            -44.52,
            81.66
          ],
          [
            -46.9,
            82.2
          ],
          [
            -46.76,
            82.63
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Fr. S. Antarctic Lands"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            68.94,
            -48.62
          ],
          [
            69.58,
            -48.94
          ],
          [
            70.53,
            -49.07
          ],
          [
            70.56,
            -49.25
          ],
          [
            70.28,
            -49.71
          ],
          [
            68.74,
            -49.77
          ],
          [
            68.72,
            -49.24
          ],
          [
            68.87,
            -48.83
          ],
          [
            68.94,
            -48.62
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Timor-Leste"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            124.97,
            -8.89
          ],
          [
            125.09,
            -8.66
          ],
          [
            125.95,
            -8.43
          ],
          [
            126.64,
            -8.4
          ],
          [
            126.96,
            -8.27
          ],
          [
            127.34,
            -8.4
          ],
          [
            126.97,
            -8.67
          ],
          [
            125.93,
            -9.11
          ],
          [
            125.09,
            -9.39
          ],
          [
            125.07,
            -9.09
          ],
          [
            124.97,
            -8.89
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "South Africa"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            16.35,
            -28.58
          ],
          [
            16.82,
            -28.08
          ],
          [
            17.22,
            -28.36
          ],
          [
            17.39,
            -28.78
          ],
          [
            17.84,
            -28.86
          ],
          [
            18.47,
            -29.05
          ],
          [
            19,
            -28.97
          ],
          [
            19.9,
            -28.46
          ],
          [
            19.9,
            -24.77
          ],
          [
            20.17,
            -24.92
          ],
          [
            20.76,
            -25.87
          ],
          [
            20.67,
            -26.48
          ],
          [
            20.89,
            -26.83
          ],
          [
            21.61,
            -26.73
          ],
          [
            22.11,
            -26.28
          ],
          [
            22.58,
            -25.98
          ],
          [
            22.83,
            -25.5
          ],
          [
            23.31,
            -25.27
          ],
          [
            23.73,
            -25.39
          ],
          [
            24.21,
            -25.67
          ],
          [
            25.03,
            -25.72
          ],
          [
            25.67,
            -25.49
          ],
          [
            25.77,
            -25.17
          ],
          [
            25.94,
            -24.7
          ],
          [
            26.49,
            -24.62
          ],
          [
            26.79,
            -24.24
          ],
          [
            27.12,
            -23.58
          ],
          [
            28.02,
            -22.83
          ],
          [
            29.43,
            -22.09
          ],
          [
            29.84,
            -22.1
          ],
          [
            30.32,
            -22.27
          ],
          [
            30.66,
            -22.15
          ],
          [
            31.19,
            -22.25
          ],
          [
            31.67,
            -23.66
          ],
          [
            31.93,
            -24.37
          ],
          [
            31.75,
            -25.48
          ],
          [
            31.84,
            -25.84
          ],
          [
            31.33,
            -25.66
          ],
          [
            31.04,
            -25.73
          ],
          [
            30.95,
            -26.02
          ],
          [
            30.68,
            -26.4
          ],
          [
            30.68,
            -26.74
          ],
          [
            31.28,
            -27.29
          ],
          [
            31.87,
            -27.18
          ],
          [
            32.07,
            -26.73
          ],
          [
            32.83,
            -26.74
          ],
          [
            32.58,
            -27.47
          ],
          [
            32.46,
            -28.3
          ],
          [
            32.2,
            -28.75
          ],
          [
            31.52,
            -29.26
          ],
          [
            31.33,
            -29.4
          ],
          [
            30.9,
            -29.91
          ],
          [
            30.62,
            -30.42
          ],
          [
            30.05,
            -31.14
          ],
          [
            28.92,
            -32.17
          ],
          [
            28.22,
            -32.77
          ],
          [
            27.46,
            -33.23
          ],
          [
            26.42,
            -33.62
          ],
          [
            25.91,
            -33.67
          ],
          [
            25.78,
            -33.95
          ],
          [
            25.17,
            -33.8
          ],
          [
            24.68,
            -33.99
          ],
          [
            23.59,
            -33.79
          ],
          [
            22.99,
            -33.92
          ],
          [
            22.57,
            -33.86
          ],
          [
            21.54,
            -34.26
          ],
          [
            20.69,
            -34.42
          ],
          [
            20.07,
            -34.8
          ],
          [
            19.61,
            -34.82
          ],
          [
            19.19,
            -34.46
          ],
          [
            18.86,
            -34.44
          ],
          [
            18.42,
            -34
          ],
          [
            18.38,
            -34.14
          ],
          [
            18.24,
            -33.87
          ],
          [
            18.25,
            -33.28
          ],
          [
            17.93,
            -32.61
          ],
          [
            18.25,
            -32.43
          ],
          [
            18.22,
            -31.66
          ],
          [
            17.57,
            -30.73
          ],
          [
            17.07,
            -29.88
          ],
          [
            17.06,
            -29.88
          ],
          [
            16.35,
            -28.58
          ]
        ],
        [
          [
            28.98,
            -28.96
          ],
          [
            28.54,
            -28.65
          ],
          [
            28.07,
            -28.85
          ],
          [
            27.53,
            -29.24
          ],
          [
            27,
            -29.88
          ],
          [
            27.75,
            -30.64
          ],
          [
            28.11,
            -30.55
          ],
          [
            28.29,
            -30.23
          ],
          [
            28.85,
            -30.07
          ],
          [
            29.02,
            -29.74
          ],
          [
            29.32,
            -29.26
          ],
          [
            28.98,
            -28.96
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Lesotho"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            28.98,
            -28.96
          ],
          [
            29.32,
            -29.26
          ],
          [
            29.02,
            -29.74
          ],
          [
            28.85,
            -30.07
          ],
          [
            28.29,
            -30.23
          ],
          [
            28.11,
            -30.55
          ],
          [
            27.75,
            -30.64
          ],
          [
            27,
            -29.88
          ],
          [
            27.53,
            -29.24
          ],
          [
            28.07,
            -28.85
          ],
          [
            28.54,
            -28.65
          ],
          [
            28.98,
            -28.96
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mexico"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -117.13,
            32.53
          ],
          [
            -115.99,
            32.61
          ],
          [
            -114.72,
            32.72
          ],
          [
            -114.81,
            32.52
          ],
          [
            -113.31,
            32.04
          ],
          [
            -111.02,
            31.33
          ],
          [
            -109.04,
            31.34
          ],
          [
            -108.24,
            31.34
          ],
          [
            -108.24,
            31.75
          ],
          [
            -106.51,
            31.75
          ],
          [
            -106.14,
            31.4
          ],
          [
            -105.63,
            31.08
          ],
          [
            -105.04,
            30.64
          ],
          [
            -104.71,
            30.12
          ],
          [
            -104.46,
            29.57
          ],
          [
            -103.94,
            29.27
          ],
          [
            -103.11,
            28.97
          ],
          [
            -102.48,
            29.76
          ],
          [
            -101.66,
            29.78
          ],
          [
            -100.96,
            29.38
          ],
          [
            -100.46,
            28.7
          ],
          [
            -100.11,
            28.11
          ],
          [
            -99.52,
            27.54
          ],
          [
            -99.3,
            26.84
          ],
          [
            -99.02,
            26.37
          ],
          [
            -98.24,
            26.06
          ],
          [
            -97.53,
            25.84
          ],
          [
            -97.14,
            25.87
          ],
          [
            -97.53,
            24.99
          ],
          [
            -97.7,
            24.27
          ],
          [
            -97.78,
            22.93
          ],
          [
            -97.87,
            22.44
          ],
          [
            -97.7,
            21.9
          ],
          [
            -97.39,
            21.41
          ],
          [
            -97.19,
            20.64
          ],
          [
            -96.53,
            19.89
          ],
          [
            -96.29,
            19.32
          ],
          [
            -95.9,
            18.83
          ],
          [
            -94.84,
            18.56
          ],
          [
            -94.43,
            18.14
          ],
          [
            -93.55,
            18.42
          ],
          [
            -92.79,
            18.53
          ],
          [
            -92.04,
            18.71
          ],
          [
            -91.41,
            18.88
          ],
          [
            -90.77,
            19.28
          ],
          [
            -90.53,
            19.87
          ],
          [
            -90.45,
            20.71
          ],
          [
            -90.28,
            21
          ],
          [
            -89.6,
            21.26
          ],
          [
            -88.54,
            21.49
          ],
          [
            -87.66,
            21.46
          ],
          [
            -87.05,
            21.54
          ],
          [
            -86.81,
            21.33
          ],
          [
            -86.85,
            20.85
          ],
          [
            -87.38,
            20.26
          ],
          [
            -87.62,
            19.65
          ],
          [
            -87.44,
            19.47
          ],
          [
            -87.59,
            19.04
          ],
          [
            -87.84,
            18.26
          ],
          [
            -88.09,
            18.52
          ],
          [
            -88.3,
            18.5
          ],
          [
            -88.49,
            18.49
          ],
          [
            -88.85,
            17.88
          ],
          [
            -89.03,
            18
          ],
          [
            -89.15,
            17.96
          ],
          [
            -89.14,
            17.81
          ],
          [
            -90.07,
            17.82
          ],
          [
            -91,
            17.82
          ],
          [
            -91,
            17.25
          ],
          [
            -91.45,
            17.25
          ],
          [
            -91.08,
            16.92
          ],
          [
            -90.71,
            16.69
          ],
          [
            -90.6,
            16.47
          ],
          [
            -90.44,
            16.41
          ],
          [
            -90.46,
            16.07
          ],
          [
            -91.75,
            16.07
          ],
          [
            -92.23,
            15.25
          ],
          [
            -92.09,
            15.06
          ],
          [
            -92.2,
            14.83
          ],
          [
            -92.23,
            14.54
          ],
          [
            -93.36,
            15.62
          ],
          [
            -93.88,
            15.94
          ],
          [
            -94.69,
            16.2
          ],
          [
            -95.25,
            16.13
          ],
          [
            -96.05,
            15.75
          ],
          [
            -96.56,
            15.65
          ],
          [
            -97.26,
            15.92
          ],
          [
            -98.01,
            16.11
          ],
          [
            -98.95,
            16.57
          ],
          [
            -99.7,
            16.71
          ],
          [
            -100.83,
            17.17
          ],
          [
            -101.67,
            17.65
          ],
          [
            -101.92,
            17.92
          ],
          [
            -102.48,
            17.98
          ],
          [
            -103.5,
            18.29
          ],
          [
            -103.92,
            18.75
          ],
          [
            -104.99,
            19.32
          ],
          [
            -105.49,
            19.95
          ],
          [
            -105.73,
            20.43
          ],
          [
            -105.4,
            20.53
          ],
          [
            -105.5,
            20.82
          ],
          [
            -105.27,
            21.08
          ],
          [
            -105.27,
            21.42
          ],
          [
            -105.6,
            21.87
          ],
          [
            -105.69,
            22.27
          ],
          [
            -106.03,
            22.77
          ],
          [
            -106.91,
            23.77
          ],
          [
            -107.92,
            24.55
          ],
          [
            -108.4,
            25.17
          ],
          [
            -109.26,
            25.58
          ],
          [
            -109.44,
            25.83
          ],
          [
            -109.29,
            26.44
          ],
          [
            -109.8,
            26.68
          ],
          [
            -110.39,
            27.16
          ],
          [
            -110.64,
            27.86
          ],
          [
            -111.18,
            27.94
          ],
          [
            -111.76,
            28.47
          ],
          [
            -112.23,
            28.96
          ],
          [
            -112.27,
            29.27
          ],
          [
            -112.81,
            30.02
          ],
          [
            -113.17,
            30.79
          ],
          [
            -113.15,
            31.17
          ],
          [
            -113.87,
            31.57
          ],
          [
            -114.21,
            31.52
          ],
          [
            -114.78,
            31.8
          ],
          [
            -114.94,
            31.39
          ],
          [
            -114.77,
            30.91
          ],
          [
            -114.67,
            30.16
          ],
          [
            -114.33,
            29.75
          ],
          [
            -113.59,
            29.06
          ],
          [
            -113.42,
            28.83
          ],
          [
            -113.27,
            28.76
          ],
          [
            -113.14,
            28.41
          ],
          [
            -112.96,
            28.43
          ],
          [
            -112.76,
            27.78
          ],
          [
            -112.46,
            27.53
          ],
          [
            -112.24,
            27.17
          ],
          [
            -111.62,
            26.66
          ],
          [
            -111.29,
            25.73
          ],
          [
            -110.99,
            25.29
          ],
          [
            -110.71,
            24.83
          ],
          [
            -110.66,
            24.3
          ],
          [
            -110.17,
            24.27
          ],
          [
            -109.77,
            23.81
          ],
          [
            -109.41,
            23.36
          ],
          [
            -109.43,
            23.19
          ],
          [
            -109.85,
            22.82
          ],
          [
            -110.03,
            22.82
          ],
          [
            -110.3,
            23.43
          ],
          [
            -110.95,
            24
          ],
          [
            -111.67,
            24.49
          ],
          [
            -112.18,
            24.74
          ],
          [
            -112.15,
            25.47
          ],
          [
            -112.3,
            26.01
          ],
          [
            -112.78,
            26.32
          ],
          [
            -113.46,
            26.77
          ],
          [
            -113.6,
            26.64
          ],
          [
            -113.85,
            26.9
          ],
          [
            -114.46,
            27.14
          ],
          [
            -115.06,
            27.72
          ],
          [
            -114.98,
            27.8
          ],
          [
            -114.57,
            27.74
          ],
          [
            -114.2,
            28.12
          ],
          [
            -114.16,
            28.57
          ],
          [
            -114.93,
            29.28
          ],
          [
            -115.52,
            29.56
          ],
          [
            -115.89,
            30.18
          ],
          [
            -116.26,
            30.84
          ],
          [
            -116.72,
            31.64
          ],
          [
            -117.13,
            32.53
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Uruguay"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -57.62,
            -30.22
          ],
          [
            -56.98,
            -30.11
          ],
          [
            -55.97,
            -30.88
          ],
          [
            -55.6,
            -30.85
          ],
          [
            -54.57,
            -31.49
          ],
          [
            -53.79,
            -32.05
          ],
          [
            -53.21,
            -32.73
          ],
          [
            -53.65,
            -33.2
          ],
          [
            -53.37,
            -33.77
          ],
          [
            -53.81,
            -34.4
          ],
          [
            -54.93,
            -34.95
          ],
          [
            -55.67,
            -34.75
          ],
          [
            -56.22,
            -34.86
          ],
          [
            -57.14,
            -34.43
          ],
          [
            -57.82,
            -34.46
          ],
          [
            -58.43,
            -33.91
          ],
          [
            -58.35,
            -33.26
          ],
          [
            -58.13,
            -33.04
          ],
          [
            -58.14,
            -32.04
          ],
          [
            -57.88,
            -31.02
          ],
          [
            -57.62,
            -30.22
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Brazil"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -53.37,
            -33.77
          ],
          [
            -53.65,
            -33.2
          ],
          [
            -53.21,
            -32.73
          ],
          [
            -53.79,
            -32.05
          ],
          [
            -54.57,
            -31.49
          ],
          [
            -55.6,
            -30.85
          ],
          [
            -55.97,
            -30.88
          ],
          [
            -56.98,
            -30.11
          ],
          [
            -57.62,
            -30.22
          ],
          [
            -56.29,
            -28.85
          ],
          [
            -55.16,
            -27.88
          ],
          [
            -54.49,
            -27.47
          ],
          [
            -53.65,
            -26.92
          ],
          [
            -53.63,
            -26.12
          ],
          [
            -54.13,
            -25.55
          ],
          [
            -54.63,
            -25.74
          ],
          [
            -54.43,
            -25.16
          ],
          [
            -54.29,
            -24.57
          ],
          [
            -54.29,
            -24.02
          ],
          [
            -54.65,
            -23.84
          ],
          [
            -55.03,
            -24
          ],
          [
            -55.4,
            -23.96
          ],
          [
            -55.52,
            -23.57
          ],
          [
            -55.61,
            -22.66
          ],
          [
            -55.8,
            -22.36
          ],
          [
            -56.47,
            -22.09
          ],
          [
            -56.88,
            -22.28
          ],
          [
            -57.94,
            -22.09
          ],
          [
            -57.87,
            -20.73
          ],
          [
            -58.17,
            -20.18
          ],
          [
            -57.85,
            -19.97
          ],
          [
            -57.95,
            -19.4
          ],
          [
            -57.67,
            -18.96
          ],
          [
            -57.5,
            -18.17
          ],
          [
            -57.74,
            -17.55
          ],
          [
            -58.28,
            -17.27
          ],
          [
            -58.39,
            -16.88
          ],
          [
            -58.24,
            -16.3
          ],
          [
            -60.16,
            -16.26
          ],
          [
            -60.54,
            -15.09
          ],
          [
            -60.25,
            -15.08
          ],
          [
            -60.26,
            -14.65
          ],
          [
            -60.46,
            -14.35
          ],
          [
            -60.5,
            -13.78
          ],
          [
            -61.08,
            -13.48
          ],
          [
            -61.71,
            -13.49
          ],
          [
            -62.13,
            -13.2
          ],
          [
            -62.8,
            -13
          ],
          [
            -63.2,
            -12.63
          ],
          [
            -64.32,
            -12.46
          ],
          [
            -65.4,
            -11.57
          ],
          [
            -65.32,
            -10.9
          ],
          [
            -65.44,
            -10.51
          ],
          [
            -65.34,
            -9.76
          ],
          [
            -66.65,
            -9.93
          ],
          [
            -67.17,
            -10.31
          ],
          [
            -68.05,
            -10.71
          ],
          [
            -68.27,
            -11.01
          ],
          [
            -68.79,
            -11.04
          ],
          [
            -69.53,
            -10.95
          ],
          [
            -70.09,
            -11.12
          ],
          [
            -70.55,
            -11.01
          ],
          [
            -70.48,
            -9.49
          ],
          [
            -71.3,
            -10.08
          ],
          [
            -72.19,
            -10.05
          ],
          [
            -72.56,
            -9.52
          ],
          [
            -73.23,
            -9.46
          ],
          [
            -73.01,
            -9.03
          ],
          [
            -73.57,
            -8.42
          ],
          [
            -73.99,
            -7.52
          ],
          [
            -73.72,
            -7.34
          ],
          [
            -73.72,
            -6.92
          ],
          [
            -73.12,
            -6.63
          ],
          [
            -73.22,
            -6.09
          ],
          [
            -72.96,
            -5.74
          ],
          [
            -72.89,
            -5.28
          ],
          [
            -71.75,
            -4.59
          ],
          [
            -70.93,
            -4.4
          ],
          [
            -70.8,
            -4.25
          ],
          [
            -69.89,
            -4.3
          ],
          [
            -69.44,
            -1.56
          ],
          [
            -69.42,
            -1.12
          ],
          [
            -69.58,
            -0.55
          ],
          [
            -70.02,
            -0.19
          ],
          [
            -70.02,
            0.54
          ],
          [
            -69.45,
            0.71
          ],
          [
            -69.25,
            0.6
          ],
          [
            -69.22,
            0.99
          ],
          [
            -69.8,
            1.09
          ],
          [
            -69.82,
            1.72
          ],
          [
            -67.87,
            1.69
          ],
          [
            -67.54,
            2.04
          ],
          [
            -67.26,
            1.72
          ],
          [
            -67.06,
            1.13
          ],
          [
            -66.88,
            1.25
          ],
          [
            -66.33,
            0.72
          ],
          [
            -65.55,
            0.79
          ],
          [
            -65.35,
            1.1
          ],
          [
            -64.61,
            1.33
          ],
          [
            -64.2,
            1.49
          ],
          [
            -64.08,
            1.92
          ],
          [
            -63.37,
            2.2
          ],
          [
            -63.42,
            2.41
          ],
          [
            -64.27,
            2.5
          ],
          [
            -64.41,
            3.13
          ],
          [
            -64.37,
            3.8
          ],
          [
            -64.82,
            4.06
          ],
          [
            -64.63,
            4.15
          ],
          [
            -63.89,
            4.02
          ],
          [
            -63.09,
            3.77
          ],
          [
            -62.8,
            4.01
          ],
          [
            -62.08,
            4.16
          ],
          [
            -60.97,
            4.54
          ],
          [
            -60.6,
            4.92
          ],
          [
            -60.73,
            5.2
          ],
          [
            -60.21,
            5.24
          ],
          [
            -59.98,
            5.01
          ],
          [
            -60.11,
            4.58
          ],
          [
            -59.77,
            4.42
          ],
          [
            -59.54,
            3.96
          ],
          [
            -59.82,
            3.61
          ],
          [
            -59.97,
            2.76
          ],
          [
            -59.72,
            2.25
          ],
          [
            -59.65,
            1.79
          ],
          [
            -59.03,
            1.32
          ],
          [
            -58.54,
            1.27
          ],
          [
            -58.43,
            1.46
          ],
          [
            -58.11,
            1.51
          ],
          [
            -57.66,
            1.68
          ],
          [
            -57.34,
            1.95
          ],
          [
            -56.78,
            1.86
          ],
          [
            -56.54,
            1.9
          ],
          [
            -56,
            1.82
          ],
          [
            -55.91,
            2.02
          ],
          [
            -56.07,
            2.22
          ],
          [
            -55.97,
            2.51
          ],
          [
            -55.57,
            2.42
          ],
          [
            -55.1,
            2.52
          ],
          [
            -54.52,
            2.31
          ],
          [
            -54.09,
            2.11
          ],
          [
            -53.78,
            2.38
          ],
          [
            -53.56,
            2.33
          ],
          [
            -53.42,
            2.05
          ],
          [
            -52.94,
            2.12
          ],
          [
            -52.56,
            2.5
          ],
          [
            -52.25,
            3.24
          ],
          [
            -51.66,
            4.16
          ],
          [
            -51.32,
            4.2
          ],
          [
            -51.07,
            3.65
          ],
          [
            -50.51,
            1.9
          ],
          [
            -49.97,
            1.74
          ],
          [
            -49.95,
            1.05
          ],
          [
            -50.7,
            0.22
          ],
          [
            -50.39,
            -0.08
          ],
          [
            -48.62,
            -0.23
          ],
          [
            -48.58,
            -1.24
          ],
          [
            -47.82,
            -0.58
          ],
          [
            -46.57,
            -0.94
          ],
          [
            -44.91,
            -1.55
          ],
          [
            -44.42,
            -2.14
          ],
          [
            -44.58,
            -2.69
          ],
          [
            -43.42,
            -2.38
          ],
          [
            -41.47,
            -2.91
          ],
          [
            -39.98,
            -2.87
          ],
          [
            -38.5,
            -3.7
          ],
          [
            -37.22,
            -4.82
          ],
          [
            -36.45,
            -5.11
          ],
          [
            -35.6,
            -5.15
          ],
          [
            -35.24,
            -5.46
          ],
          [
            -34.9,
            -6.74
          ],
          [
            -34.73,
            -7.34
          ],
          [
            -35.13,
            -9
          ],
          [
            -35.64,
            -9.65
          ],
          [
            -37.05,
            -11.04
          ],
          [
            -37.68,
            -12.17
          ],
          [
            -38.42,
            -13.04
          ],
          [
            -38.67,
            -13.06
          ],
          [
            -38.95,
            -13.79
          ],
          [
            -38.88,
            -15.67
          ],
          [
            -39.16,
            -17.21
          ],
          [
            -39.27,
            -17.87
          ],
          [
            -39.58,
            -18.26
          ],
          [
            -39.76,
            -19.6
          ],
          [
            -40.78,
            -20.9
          ],
          [
            -40.95,
            -21.94
          ],
          [
            -41.76,
            -22.37
          ],
          [
            -41.99,
            -22.97
          ],
          [
            -43.08,
            -22.97
          ],
          [
            -44.65,
            -23.35
          ],
          [
            -45.35,
            -23.8
          ],
          [
            -46.47,
            -24.09
          ],
          [
            -47.65,
            -24.89
          ],
          [
            -48.49,
            -25.88
          ],
          [
            -48.64,
            -26.62
          ],
          [
            -48.48,
            -27.18
          ],
          [
            -48.66,
            -28.19
          ],
          [
            -48.89,
            -28.67
          ],
          [
            -49.59,
            -29.22
          ],
          [
            -50.7,
            -30.99
          ],
          [
            -51.58,
            -31.78
          ],
          [
            -52.26,
            -32.25
          ],
          [
            -52.71,
            -33.2
          ],
          [
            -53.37,
            -33.77
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bolivia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -69.53,
            -10.95
          ],
          [
            -68.79,
            -11.04
          ],
          [
            -68.27,
            -11.01
          ],
          [
            -68.05,
            -10.71
          ],
          [
            -67.17,
            -10.31
          ],
          [
            -66.65,
            -9.93
          ],
          [
            -65.34,
            -9.76
          ],
          [
            -65.44,
            -10.51
          ],
          [
            -65.32,
            -10.9
          ],
          [
            -65.4,
            -11.57
          ],
          [
            -64.32,
            -12.46
          ],
          [
            -63.2,
            -12.63
          ],
          [
            -62.8,
            -13
          ],
          [
            -62.13,
            -13.2
          ],
          [
            -61.71,
            -13.49
          ],
          [
            -61.08,
            -13.48
          ],
          [
            -60.5,
            -13.78
          ],
          [
            -60.46,
            -14.35
          ],
          [
            -60.26,
            -14.65
          ],
          [
            -60.25,
            -15.08
          ],
          [
            -60.54,
            -15.09
          ],
          [
            -60.16,
            -16.26
          ],
          [
            -58.24,
            -16.3
          ],
          [
            -58.39,
            -16.88
          ],
          [
            -58.28,
            -17.27
          ],
          [
            -57.74,
            -17.55
          ],
          [
            -57.5,
            -18.17
          ],
          [
            -57.67,
            -18.96
          ],
          [
            -57.95,
            -19.4
          ],
          [
            -57.85,
            -19.97
          ],
          [
            -58.17,
            -20.18
          ],
          [
            -58.18,
            -19.87
          ],
          [
            -59.11,
            -19.36
          ],
          [
            -60.04,
            -19.34
          ],
          [
            -61.79,
            -19.63
          ],
          [
            -62.26,
            -20.51
          ],
          [
            -62.29,
            -21.05
          ],
          [
            -62.69,
            -22.25
          ],
          [
            -62.85,
            -22.03
          ],
          [
            -63.99,
            -21.99
          ],
          [
            -64.38,
            -22.8
          ],
          [
            -64.96,
            -22.08
          ],
          [
            -66.27,
            -21.83
          ],
          [
            -67.11,
            -22.74
          ],
          [
            -67.83,
            -22.87
          ],
          [
            -68.22,
            -21.49
          ],
          [
            -68.76,
            -20.37
          ],
          [
            -68.44,
            -19.4
          ],
          [
            -68.97,
            -18.98
          ],
          [
            -69.1,
            -18.26
          ],
          [
            -69.59,
            -17.58
          ],
          [
            -68.96,
            -16.5
          ],
          [
            -69.39,
            -15.66
          ],
          [
            -69.16,
            -15.32
          ],
          [
            -69.34,
            -14.95
          ],
          [
            -68.95,
            -14.45
          ],
          [
            -68.93,
            -13.6
          ],
          [
            -68.88,
            -12.9
          ],
          [
            -68.67,
            -12.56
          ],
          [
            -69.53,
            -10.95
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Peru"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -69.89,
            -4.3
          ],
          [
            -70.8,
            -4.25
          ],
          [
            -70.93,
            -4.4
          ],
          [
            -71.75,
            -4.59
          ],
          [
            -72.89,
            -5.28
          ],
          [
            -72.96,
            -5.74
          ],
          [
            -73.22,
            -6.09
          ],
          [
            -73.12,
            -6.63
          ],
          [
            -73.72,
            -6.92
          ],
          [
            -73.72,
            -7.34
          ],
          [
            -73.99,
            -7.52
          ],
          [
            -73.57,
            -8.42
          ],
          [
            -73.01,
            -9.03
          ],
          [
            -73.23,
            -9.46
          ],
          [
            -72.56,
            -9.52
          ],
          [
            -72.19,
            -10.05
          ],
          [
            -71.3,
            -10.08
          ],
          [
            -70.48,
            -9.49
          ],
          [
            -70.55,
            -11.01
          ],
          [
            -70.09,
            -11.12
          ],
          [
            -69.53,
            -10.95
          ],
          [
            -68.67,
            -12.56
          ],
          [
            -68.88,
            -12.9
          ],
          [
            -68.93,
            -13.6
          ],
          [
            -68.95,
            -14.45
          ],
          [
            -69.34,
            -14.95
          ],
          [
            -69.16,
            -15.32
          ],
          [
            -69.39,
            -15.66
          ],
          [
            -68.96,
            -16.5
          ],
          [
            -69.59,
            -17.58
          ],
          [
            -69.86,
            -18.09
          ],
          [
            -70.37,
            -18.35
          ],
          [
            -71.38,
            -17.77
          ],
          [
            -71.46,
            -17.36
          ],
          [
            -73.45,
            -16.36
          ],
          [
            -75.24,
            -15.27
          ],
          [
            -76.01,
            -14.65
          ],
          [
            -76.42,
            -13.82
          ],
          [
            -76.26,
            -13.53
          ],
          [
            -77.11,
            -12.22
          ],
          [
            -78.09,
            -10.38
          ],
          [
            -79.04,
            -8.39
          ],
          [
            -79.45,
            -7.93
          ],
          [
            -79.76,
            -7.19
          ],
          [
            -80.54,
            -6.54
          ],
          [
            -81.25,
            -6.14
          ],
          [
            -80.93,
            -5.69
          ],
          [
            -81.41,
            -4.74
          ],
          [
            -81.1,
            -4.04
          ],
          [
            -80.3,
            -3.4
          ],
          [
            -80.19,
            -3.82
          ],
          [
            -80.47,
            -4.06
          ],
          [
            -80.44,
            -4.43
          ],
          [
            -80.03,
            -4.35
          ],
          [
            -79.62,
            -4.45
          ],
          [
            -79.21,
            -4.96
          ],
          [
            -78.64,
            -4.55
          ],
          [
            -78.45,
            -3.87
          ],
          [
            -77.84,
            -3
          ],
          [
            -76.64,
            -2.61
          ],
          [
            -75.54,
            -1.56
          ],
          [
            -75.24,
            -0.91
          ],
          [
            -75.37,
            -0.15
          ],
          [
            -75.11,
            -0.06
          ],
          [
            -74.44,
            -0.53
          ],
          [
            -74.12,
            -1
          ],
          [
            -73.66,
            -1.26
          ],
          [
            -73.07,
            -2.31
          ],
          [
            -72.33,
            -2.44
          ],
          [
            -71.78,
            -2.17
          ],
          [
            -71.41,
            -2.34
          ],
          [
            -70.81,
            -2.26
          ],
          [
            -70.05,
            -2.72
          ],
          [
            -70.69,
            -3.74
          ],
          [
            -70.39,
            -3.77
          ],
          [
            -69.89,
            -4.3
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Colombia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -66.88,
            1.25
          ],
          [
            -67.06,
            1.13
          ],
          [
            -67.26,
            1.72
          ],
          [
            -67.54,
            2.04
          ],
          [
            -67.87,
            1.69
          ],
          [
            -69.82,
            1.72
          ],
          [
            -69.8,
            1.09
          ],
          [
            -69.22,
            0.99
          ],
          [
            -69.25,
            0.6
          ],
          [
            -69.45,
            0.71
          ],
          [
            -70.02,
            0.54
          ],
          [
            -70.02,
            -0.19
          ],
          [
            -69.58,
            -0.55
          ],
          [
            -69.42,
            -1.12
          ],
          [
            -69.44,
            -1.56
          ],
          [
            -69.89,
            -4.3
          ],
          [
            -70.39,
            -3.77
          ],
          [
            -70.69,
            -3.74
          ],
          [
            -70.05,
            -2.72
          ],
          [
            -70.81,
            -2.26
          ],
          [
            -71.41,
            -2.34
          ],
          [
            -71.78,
            -2.17
          ],
          [
            -72.33,
            -2.44
          ],
          [
            -73.07,
            -2.31
          ],
          [
            -73.66,
            -1.26
          ],
          [
            -74.12,
            -1
          ],
          [
            -74.44,
            -0.53
          ],
          [
            -75.11,
            -0.06
          ],
          [
            -75.37,
            -0.15
          ],
          [
            -75.8,
            0.09
          ],
          [
            -76.29,
            0.42
          ],
          [
            -76.58,
            0.26
          ],
          [
            -77.42,
            0.39
          ],
          [
            -77.67,
            0.83
          ],
          [
            -77.86,
            0.81
          ],
          [
            -78.86,
            1.38
          ],
          [
            -78.99,
            1.69
          ],
          [
            -78.62,
            1.77
          ],
          [
            -78.66,
            2.27
          ],
          [
            -78.43,
            2.63
          ],
          [
            -77.93,
            2.7
          ],
          [
            -77.51,
            3.32
          ],
          [
            -77.13,
            3.85
          ],
          [
            -77.5,
            4.09
          ],
          [
            -77.31,
            4.67
          ],
          [
            -77.53,
            5.58
          ],
          [
            -77.32,
            5.84
          ],
          [
            -77.48,
            6.69
          ],
          [
            -77.88,
            7.22
          ],
          [
            -77.75,
            7.71
          ],
          [
            -77.43,
            7.64
          ],
          [
            -77.24,
            7.94
          ],
          [
            -77.47,
            8.52
          ],
          [
            -77.35,
            8.67
          ],
          [
            -76.84,
            8.64
          ],
          [
            -76.08,
            9.34
          ],
          [
            -75.67,
            9.44
          ],
          [
            -75.66,
            9.77
          ],
          [
            -75.48,
            10.62
          ],
          [
            -74.91,
            11.08
          ],
          [
            -74.28,
            11.1
          ],
          [
            -74.2,
            11.31
          ],
          [
            -73.41,
            11.23
          ],
          [
            -72.63,
            11.73
          ],
          [
            -72.24,
            11.96
          ],
          [
            -71.75,
            12.44
          ],
          [
            -71.4,
            12.38
          ],
          [
            -71.14,
            12.11
          ],
          [
            -71.33,
            11.78
          ],
          [
            -71.97,
            11.61
          ],
          [
            -72.23,
            11.11
          ],
          [
            -72.61,
            10.82
          ],
          [
            -72.91,
            10.45
          ],
          [
            -73.03,
            9.74
          ],
          [
            -73.31,
            9.15
          ],
          [
            -72.79,
            9.08
          ],
          [
            -72.66,
            8.63
          ],
          [
            -72.44,
            8.41
          ],
          [
            -72.36,
            8
          ],
          [
            -72.48,
            7.63
          ],
          [
            -72.45,
            7.42
          ],
          [
            -72.2,
            7.34
          ],
          [
            -71.96,
            6.99
          ],
          [
            -70.67,
            7.09
          ],
          [
            -70.09,
            6.96
          ],
          [
            -69.39,
            6.1
          ],
          [
            -68.99,
            6.21
          ],
          [
            -68.27,
            6.15
          ],
          [
            -67.7,
            6.27
          ],
          [
            -67.34,
            6.1
          ],
          [
            -67.52,
            5.56
          ],
          [
            -67.74,
            5.22
          ],
          [
            -67.82,
            4.5
          ],
          [
            -67.62,
            3.84
          ],
          [
            -67.34,
            3.54
          ],
          [
            -67.3,
            3.32
          ],
          [
            -67.81,
            2.82
          ],
          [
            -67.45,
            2.6
          ],
          [
            -67.18,
            2.25
          ],
          [
            -66.88,
            1.25
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Panama"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -77.35,
            8.67
          ],
          [
            -77.47,
            8.52
          ],
          [
            -77.24,
            7.94
          ],
          [
            -77.43,
            7.64
          ],
          [
            -77.75,
            7.71
          ],
          [
            -77.88,
            7.22
          ],
          [
            -78.22,
            7.51
          ],
          [
            -78.43,
            8.05
          ],
          [
            -78.18,
            8.32
          ],
          [
            -78.44,
            8.39
          ],
          [
            -78.62,
            8.72
          ],
          [
            -79.12,
            9
          ],
          [
            -79.56,
            8.93
          ],
          [
            -79.76,
            8.59
          ],
          [
            -80.16,
            8.33
          ],
          [
            -80.38,
            8.3
          ],
          [
            -80.48,
            8.09
          ],
          [
            -80.01,
            7.55
          ],
          [
            -80.28,
            7.42
          ],
          [
            -80.42,
            7.27
          ],
          [
            -80.89,
            7.22
          ],
          [
            -81.06,
            7.82
          ],
          [
            -81.19,
            7.65
          ],
          [
            -81.52,
            7.71
          ],
          [
            -81.72,
            8.11
          ],
          [
            -82.13,
            8.18
          ],
          [
            -82.39,
            8.29
          ],
          [
            -82.82,
            8.29
          ],
          [
            -82.85,
            8.07
          ],
          [
            -82.96,
            8.22
          ],
          [
            -82.91,
            8.42
          ],
          [
            -82.83,
            8.63
          ],
          [
            -82.87,
            8.81
          ],
          [
            -82.72,
            8.93
          ],
          [
            -82.93,
            9.07
          ],
          [
            -82.93,
            9.48
          ],
          [
            -82.55,
            9.57
          ],
          [
            -82.19,
            9.21
          ],
          [
            -82.21,
            8.99
          ],
          [
            -81.81,
            8.95
          ],
          [
            -81.72,
            9.03
          ],
          [
            -81.44,
            8.79
          ],
          [
            -80.95,
            8.86
          ],
          [
            -80.52,
            9.11
          ],
          [
            -79.92,
            9.31
          ],
          [
            -79.57,
            9.61
          ],
          [
            -79.02,
            9.55
          ],
          [
            -79.06,
            9.46
          ],
          [
            -78.5,
            9.42
          ],
          [
            -78.05,
            9.25
          ],
          [
            -77.73,
            8.95
          ],
          [
            -77.35,
            8.67
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Costa Rica"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -82.55,
            9.57
          ],
          [
            -82.93,
            9.48
          ],
          [
            -82.93,
            9.07
          ],
          [
            -82.72,
            8.93
          ],
          [
            -82.87,
            8.81
          ],
          [
            -82.83,
            8.63
          ],
          [
            -82.91,
            8.42
          ],
          [
            -82.96,
            8.22
          ],
          [
            -83.51,
            8.45
          ],
          [
            -83.71,
            8.66
          ],
          [
            -83.59,
            8.83
          ],
          [
            -83.63,
            9.05
          ],
          [
            -83.91,
            9.29
          ],
          [
            -84.3,
            9.49
          ],
          [
            -84.65,
            9.62
          ],
          [
            -84.71,
            9.91
          ],
          [
            -84.98,
            10.09
          ],
          [
            -84.91,
            9.8
          ],
          [
            -85.11,
            9.56
          ],
          [
            -85.34,
            9.83
          ],
          [
            -85.66,
            9.93
          ],
          [
            -85.8,
            10.14
          ],
          [
            -85.79,
            10.44
          ],
          [
            -85.66,
            10.76
          ],
          [
            -85.94,
            10.9
          ],
          [
            -85.71,
            11.09
          ],
          [
            -85.56,
            11.22
          ],
          [
            -84.9,
            10.95
          ],
          [
            -84.67,
            11.08
          ],
          [
            -84.35,
            11
          ],
          [
            -84.19,
            10.79
          ],
          [
            -83.89,
            10.73
          ],
          [
            -83.66,
            10.94
          ],
          [
            -83.4,
            10.4
          ],
          [
            -83.02,
            9.99
          ],
          [
            -82.55,
            9.57
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Nicaragua"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -83.66,
            10.94
          ],
          [
            -83.89,
            10.73
          ],
          [
            -84.19,
            10.79
          ],
          [
            -84.35,
            11
          ],
          [
            -84.67,
            11.08
          ],
          [
            -84.9,
            10.95
          ],
          [
            -85.56,
            11.22
          ],
          [
            -85.71,
            11.09
          ],
          [
            -86.06,
            11.4
          ],
          [
            -86.53,
            11.81
          ],
          [
            -86.74,
            12.14
          ],
          [
            -87.17,
            12.46
          ],
          [
            -87.67,
            12.91
          ],
          [
            -87.56,
            13.06
          ],
          [
            -87.39,
            12.91
          ],
          [
            -87.32,
            12.98
          ],
          [
            -87.01,
            13.03
          ],
          [
            -86.88,
            13.26
          ],
          [
            -86.73,
            13.26
          ],
          [
            -86.76,
            13.75
          ],
          [
            -86.52,
            13.78
          ],
          [
            -86.31,
            13.77
          ],
          [
            -86.1,
            14.04
          ],
          [
            -85.8,
            13.84
          ],
          [
            -85.7,
            13.96
          ],
          [
            -85.51,
            14.08
          ],
          [
            -85.16,
            14.36
          ],
          [
            -85.15,
            14.56
          ],
          [
            -85.05,
            14.55
          ],
          [
            -84.92,
            14.79
          ],
          [
            -84.82,
            14.82
          ],
          [
            -84.65,
            14.67
          ],
          [
            -84.45,
            14.62
          ],
          [
            -84.23,
            14.75
          ],
          [
            -83.98,
            14.75
          ],
          [
            -83.63,
            14.88
          ],
          [
            -83.49,
            15.02
          ],
          [
            -83.15,
            15
          ],
          [
            -83.23,
            14.9
          ],
          [
            -83.29,
            14.68
          ],
          [
            -83.18,
            14.31
          ],
          [
            -83.41,
            13.97
          ],
          [
            -83.52,
            13.57
          ],
          [
            -83.55,
            13.13
          ],
          [
            -83.5,
            12.87
          ],
          [
            -83.47,
            12.42
          ],
          [
            -83.63,
            12.32
          ],
          [
            -83.72,
            11.89
          ],
          [
            -83.65,
            11.63
          ],
          [
            -83.85,
            11.37
          ],
          [
            -83.81,
            11.1
          ],
          [
            -83.66,
            10.94
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Honduras"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -83.15,
            15
          ],
          [
            -83.49,
            15.02
          ],
          [
            -83.63,
            14.88
          ],
          [
            -83.98,
            14.75
          ],
          [
            -84.23,
            14.75
          ],
          [
            -84.45,
            14.62
          ],
          [
            -84.65,
            14.67
          ],
          [
            -84.82,
            14.82
          ],
          [
            -84.92,
            14.79
          ],
          [
            -85.05,
            14.55
          ],
          [
            -85.15,
            14.56
          ],
          [
            -85.16,
            14.36
          ],
          [
            -85.51,
            14.08
          ],
          [
            -85.7,
            13.96
          ],
          [
            -85.8,
            13.84
          ],
          [
            -86.1,
            14.04
          ],
          [
            -86.31,
            13.77
          ],
          [
            -86.52,
            13.78
          ],
          [
            -86.76,
            13.75
          ],
          [
            -86.73,
            13.26
          ],
          [
            -86.88,
            13.26
          ],
          [
            -87.01,
            13.03
          ],
          [
            -87.32,
            12.98
          ],
          [
            -87.49,
            13.3
          ],
          [
            -87.79,
            13.38
          ],
          [
            -87.72,
            13.78
          ],
          [
            -87.86,
            13.89
          ],
          [
            -88.07,
            13.96
          ],
          [
            -88.51,
            13.85
          ],
          [
            -88.54,
            13.98
          ],
          [
            -88.84,
            14.14
          ],
          [
            -89.06,
            14.34
          ],
          [
            -89.35,
            14.42
          ],
          [
            -89.15,
            14.68
          ],
          [
            -89.23,
            14.87
          ],
          [
            -89.15,
            15.07
          ],
          [
            -88.68,
            15.35
          ],
          [
            -88.22,
            15.73
          ],
          [
            -88.12,
            15.69
          ],
          [
            -87.9,
            15.86
          ],
          [
            -87.62,
            15.88
          ],
          [
            -87.52,
            15.8
          ],
          [
            -87.37,
            15.85
          ],
          [
            -86.9,
            15.76
          ],
          [
            -86.44,
            15.78
          ],
          [
            -86.12,
            15.89
          ],
          [
            -86,
            16.01
          ],
          [
            -85.68,
            15.95
          ],
          [
            -85.45,
            15.89
          ],
          [
            -85.18,
            15.91
          ],
          [
            -84.98,
            16
          ],
          [
            -84.53,
            15.86
          ],
          [
            -84.37,
            15.83
          ],
          [
            -84.06,
            15.65
          ],
          [
            -83.77,
            15.42
          ],
          [
            -83.41,
            15.27
          ],
          [
            -83.15,
            15
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "El Salvador"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -89.35,
            14.42
          ],
          [
            -89.06,
            14.34
          ],
          [
            -88.84,
            14.14
          ],
          [
            -88.54,
            13.98
          ],
          [
            -88.51,
            13.85
          ],
          [
            -88.07,
            13.96
          ],
          [
            -87.86,
            13.89
          ],
          [
            -87.72,
            13.78
          ],
          [
            -87.79,
            13.38
          ],
          [
            -87.9,
            13.15
          ],
          [
            -88.48,
            13.16
          ],
          [
            -88.84,
            13.26
          ],
          [
            -89.26,
            13.46
          ],
          [
            -89.81,
            13.52
          ],
          [
            -90.1,
            13.74
          ],
          [
            -90.06,
            13.88
          ],
          [
            -89.72,
            14.13
          ],
          [
            -89.53,
            14.25
          ],
          [
            -89.59,
            14.36
          ],
          [
            -89.35,
            14.42
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Guatemala"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -92.23,
            14.54
          ],
          [
            -92.2,
            14.83
          ],
          [
            -92.09,
            15.06
          ],
          [
            -92.23,
            15.25
          ],
          [
            -91.75,
            16.07
          ],
          [
            -90.46,
            16.07
          ],
          [
            -90.44,
            16.41
          ],
          [
            -90.6,
            16.47
          ],
          [
            -90.71,
            16.69
          ],
          [
            -91.08,
            16.92
          ],
          [
            -91.45,
            17.25
          ],
          [
            -91,
            17.25
          ],
          [
            -91,
            17.82
          ],
          [
            -90.07,
            17.82
          ],
          [
            -89.14,
            17.81
          ],
          [
            -89.15,
            17.02
          ],
          [
            -89.23,
            15.89
          ],
          [
            -88.93,
            15.89
          ],
          [
            -88.61,
            15.71
          ],
          [
            -88.52,
            15.85
          ],
          [
            -88.22,
            15.73
          ],
          [
            -88.68,
            15.35
          ],
          [
            -89.15,
            15.07
          ],
          [
            -89.23,
            14.87
          ],
          [
            -89.15,
            14.68
          ],
          [
            -89.35,
            14.42
          ],
          [
            -89.59,
            14.36
          ],
          [
            -89.53,
            14.25
          ],
          [
            -89.72,
            14.13
          ],
          [
            -90.06,
            13.88
          ],
          [
            -90.1,
            13.74
          ],
          [
            -90.61,
            13.91
          ],
          [
            -91.23,
            13.93
          ],
          [
            -91.69,
            14.13
          ],
          [
            -92.23,
            14.54
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Belize"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -89.14,
            17.81
          ],
          [
            -89.15,
            17.96
          ],
          [
            -89.03,
            18
          ],
          [
            -88.85,
            17.88
          ],
          [
            -88.49,
            18.49
          ],
          [
            -88.3,
            18.5
          ],
          [
            -88.3,
            18.35
          ],
          [
            -88.11,
            18.35
          ],
          [
            -88.12,
            18.08
          ],
          [
            -88.29,
            17.64
          ],
          [
            -88.2,
            17.49
          ],
          [
            -88.3,
            17.13
          ],
          [
            -88.24,
            17.04
          ],
          [
            -88.35,
            16.53
          ],
          [
            -88.55,
            16.27
          ],
          [
            -88.73,
            16.23
          ],
          [
            -88.93,
            15.89
          ],
          [
            -89.23,
            15.89
          ],
          [
            -89.15,
            17.02
          ],
          [
            -89.14,
            17.81
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Venezuela"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -60.73,
            5.2
          ],
          [
            -60.6,
            4.92
          ],
          [
            -60.97,
            4.54
          ],
          [
            -62.08,
            4.16
          ],
          [
            -62.8,
            4.01
          ],
          [
            -63.09,
            3.77
          ],
          [
            -63.89,
            4.02
          ],
          [
            -64.63,
            4.15
          ],
          [
            -64.82,
            4.06
          ],
          [
            -64.37,
            3.8
          ],
          [
            -64.41,
            3.13
          ],
          [
            -64.27,
            2.5
          ],
          [
            -63.42,
            2.41
          ],
          [
            -63.37,
            2.2
          ],
          [
            -64.08,
            1.92
          ],
          [
            -64.2,
            1.49
          ],
          [
            -64.61,
            1.33
          ],
          [
            -65.35,
            1.1
          ],
          [
            -65.55,
            0.79
          ],
          [
            -66.33,
            0.72
          ],
          [
            -66.88,
            1.25
          ],
          [
            -67.18,
            2.25
          ],
          [
            -67.45,
            2.6
          ],
          [
            -67.81,
            2.82
          ],
          [
            -67.3,
            3.32
          ],
          [
            -67.34,
            3.54
          ],
          [
            -67.62,
            3.84
          ],
          [
            -67.82,
            4.5
          ],
          [
            -67.74,
            5.22
          ],
          [
            -67.52,
            5.56
          ],
          [
            -67.34,
            6.1
          ],
          [
            -67.7,
            6.27
          ],
          [
            -68.27,
            6.15
          ],
          [
            -68.99,
            6.21
          ],
          [
            -69.39,
            6.1
          ],
          [
            -70.09,
            6.96
          ],
          [
            -70.67,
            7.09
          ],
          [
            -71.96,
            6.99
          ],
          [
            -72.2,
            7.34
          ],
          [
            -72.45,
            7.42
          ],
          [
            -72.48,
            7.63
          ],
          [
            -72.36,
            8
          ],
          [
            -72.44,
            8.41
          ],
          [
            -72.66,
            8.63
          ],
          [
            -72.79,
            9.08
          ],
          [
            -73.31,
            9.15
          ],
          [
            -73.03,
            9.74
          ],
          [
            -72.91,
            10.45
          ],
          [
            -72.61,
            10.82
          ],
          [
            -72.23,
            11.11
          ],
          [
            -71.97,
            11.61
          ],
          [
            -71.33,
            11.78
          ],
          [
            -71.36,
            11.54
          ],
          [
            -71.95,
            11.42
          ],
          [
            -71.62,
            10.97
          ],
          [
            -71.63,
            10.45
          ],
          [
            -72.07,
            9.86
          ],
          [
            -71.7,
            9.07
          ],
          [
            -71.26,
            9.14
          ],
          [
            -71.04,
            9.86
          ],
          [
            -71.35,
            10.21
          ],
          [
            -71.4,
            10.97
          ],
          [
            -70.16,
            11.38
          ],
          [
            -70.29,
            11.85
          ],
          [
            -69.94,
            12.16
          ],
          [
            -69.58,
            11.46
          ],
          [
            -68.88,
            11.44
          ],
          [
            -68.23,
            10.89
          ],
          [
            -68.19,
            10.56
          ],
          [
            -67.3,
            10.55
          ],
          [
            -66.23,
            10.65
          ],
          [
            -65.66,
            10.2
          ],
          [
            -64.89,
            10.08
          ],
          [
            -64.33,
            10.39
          ],
          [
            -64.32,
            10.64
          ],
          [
            -63.08,
            10.7
          ],
          [
            -61.88,
            10.72
          ],
          [
            -62.73,
            10.42
          ],
          [
            -62.39,
            9.95
          ],
          [
            -61.59,
            9.87
          ],
          [
            -60.83,
            9.38
          ],
          [
            -60.67,
            8.58
          ],
          [
            -60.15,
            8.6
          ],
          [
            -59.76,
            8.37
          ],
          [
            -60.55,
            7.78
          ],
          [
            -60.64,
            7.42
          ],
          [
            -60.3,
            7.04
          ],
          [
            -60.54,
            6.86
          ],
          [
            -61.16,
            6.7
          ],
          [
            -61.14,
            6.23
          ],
          [
            -61.41,
            5.96
          ],
          [
            -60.73,
            5.2
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Guyana"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -56.54,
            1.9
          ],
          [
            -56.78,
            1.86
          ],
          [
            -57.34,
            1.95
          ],
          [
            -57.66,
            1.68
          ],
          [
            -58.11,
            1.51
          ],
          [
            -58.43,
            1.46
          ],
          [
            -58.54,
            1.27
          ],
          [
            -59.03,
            1.32
          ],
          [
            -59.65,
            1.79
          ],
          [
            -59.72,
            2.25
          ],
          [
            -59.97,
            2.76
          ],
          [
            -59.82,
            3.61
          ],
          [
            -59.54,
            3.96
          ],
          [
            -59.77,
            4.42
          ],
          [
            -60.11,
            4.58
          ],
          [
            -59.98,
            5.01
          ],
          [
            -60.21,
            5.24
          ],
          [
            -60.73,
            5.2
          ],
          [
            -61.41,
            5.96
          ],
          [
            -61.14,
            6.23
          ],
          [
            -61.16,
            6.7
          ],
          [
            -60.54,
            6.86
          ],
          [
            -60.3,
            7.04
          ],
          [
            -60.64,
            7.42
          ],
          [
            -60.55,
            7.78
          ],
          [
            -59.76,
            8.37
          ],
          [
            -59.1,
            8
          ],
          [
            -58.48,
            7.35
          ],
          [
            -58.46,
            6.83
          ],
          [
            -58.08,
            6.81
          ],
          [
            -57.54,
            6.32
          ],
          [
            -57.15,
            5.97
          ],
          [
            -57.31,
            5.07
          ],
          [
            -57.92,
            4.81
          ],
          [
            -57.86,
            4.58
          ],
          [
            -58.05,
            4.06
          ],
          [
            -57.6,
            3.33
          ],
          [
            -57.28,
            3.33
          ],
          [
            -57.15,
            2.77
          ],
          [
            -56.54,
            1.9
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Suriname"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -54.52,
            2.31
          ],
          [
            -55.1,
            2.52
          ],
          [
            -55.57,
            2.42
          ],
          [
            -55.97,
            2.51
          ],
          [
            -56.07,
            2.22
          ],
          [
            -55.91,
            2.02
          ],
          [
            -56,
            1.82
          ],
          [
            -56.54,
            1.9
          ],
          [
            -57.15,
            2.77
          ],
          [
            -57.28,
            3.33
          ],
          [
            -57.6,
            3.33
          ],
          [
            -58.05,
            4.06
          ],
          [
            -57.86,
            4.58
          ],
          [
            -57.92,
            4.81
          ],
          [
            -57.31,
            5.07
          ],
          [
            -57.15,
            5.97
          ],
          [
            -55.95,
            5.77
          ],
          [
            -55.84,
            5.95
          ],
          [
            -55.03,
            6.03
          ],
          [
            -53.96,
            5.76
          ],
          [
            -54.48,
            4.9
          ],
          [
            -54.4,
            4.21
          ],
          [
            -54.01,
            3.62
          ],
          [
            -54.18,
            3.19
          ],
          [
            -54.27,
            2.73
          ],
          [
            -54.52,
            2.31
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "France"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -51.66,
              4.16
            ],
            [
              -52.25,
              3.24
            ],
            [
              -52.56,
              2.5
            ],
            [
              -52.94,
              2.12
            ],
            [
              -53.42,
              2.05
            ],
            [
              -53.56,
              2.33
            ],
            [
              -53.78,
              2.38
            ],
            [
              -54.09,
              2.11
            ],
            [
              -54.52,
              2.31
            ],
            [
              -54.27,
              2.73
            ],
            [
              -54.18,
              3.19
            ],
            [
              -54.01,
              3.62
            ],
            [
              -54.4,
              4.21
            ],
            [
              -54.48,
              4.9
            ],
            [
              -53.96,
              5.76
            ],
            [
              -53.62,
              5.65
            ],
            [
              -52.88,
              5.41
            ],
            [
              -51.82,
              4.57
            ],
            [
              -51.66,
              4.16
            ]
          ]
        ],
        [
          [
            [
              6.19,
              49.46
            ],
            [
              6.66,
              49.2
            ],
            [
              8.1,
              49.02
            ],
            [
              7.59,
              48.33
            ],
            [
              7.47,
              47.62
            ],
            [
              7.19,
              47.45
            ],
            [
              6.74,
              47.54
            ],
            [
              6.77,
              47.29
            ],
            [
              6.04,
              46.73
            ],
            [
              6.02,
              46.27
            ],
            [
              6.5,
              46.43
            ],
            [
              6.84,
              45.99
            ],
            [
              6.8,
              45.71
            ],
            [
              7.1,
              45.33
            ],
            [
              6.75,
              45.03
            ],
            [
              7.01,
              44.25
            ],
            [
              7.55,
              44.13
            ],
            [
              7.44,
              43.69
            ],
            [
              6.53,
              43.13
            ],
            [
              4.56,
              43.4
            ],
            [
              3.1,
              43.07
            ],
            [
              2.99,
              42.47
            ],
            [
              1.83,
              42.34
            ],
            [
              0.7,
              42.8
            ],
            [
              0.34,
              42.58
            ],
            [
              -1.5,
              43.03
            ],
            [
              -1.9,
              43.42
            ],
            [
              -1.38,
              44.02
            ],
            [
              -1.19,
              46.01
            ],
            [
              -2.23,
              47.06
            ],
            [
              -2.96,
              47.57
            ],
            [
              -4.49,
              47.95
            ],
            [
              -4.59,
              48.68
            ],
            [
              -3.3,
              48.9
            ],
            [
              -1.62,
              48.64
            ],
            [
              -1.94,
              49.78
            ],
            [
              -0.99,
              49.35
            ],
            [
              1.34,
              50.13
            ],
            [
              1.64,
              50.95
            ],
            [
              2.51,
              51.15
            ],
            [
              2.66,
              50.8
            ],
            [
              3.12,
              50.78
            ],
            [
              3.59,
              50.38
            ],
            [
              4.29,
              49.91
            ],
            [
              4.8,
              49.99
            ],
            [
              5.68,
              49.53
            ],
            [
              5.9,
              49.44
            ],
            [
              6.19,
              49.46
            ]
          ]
        ],
        [
          [
            [
              8.75,
              42.63
            ],
            [
              9.39,
              43.01
            ],
            [
              9.56,
              42.15
            ],
            [
              9.23,
              41.38
            ],
            [
              8.78,
              41.58
            ],
            [
              8.54,
              42.26
            ],
            [
              8.75,
              42.63
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ecuador"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -75.37,
            -0.15
          ],
          [
            -75.24,
            -0.91
          ],
          [
            -75.54,
            -1.56
          ],
          [
            -76.64,
            -2.61
          ],
          [
            -77.84,
            -3
          ],
          [
            -78.45,
            -3.87
          ],
          [
            -78.64,
            -4.55
          ],
          [
            -79.21,
            -4.96
          ],
          [
            -79.62,
            -4.45
          ],
          [
            -80.03,
            -4.35
          ],
          [
            -80.44,
            -4.43
          ],
          [
            -80.47,
            -4.06
          ],
          [
            -80.19,
            -3.82
          ],
          [
            -80.3,
            -3.4
          ],
          [
            -79.77,
            -2.66
          ],
          [
            -79.99,
            -2.22
          ],
          [
            -80.37,
            -2.69
          ],
          [
            -80.97,
            -2.25
          ],
          [
            -80.77,
            -1.96
          ],
          [
            -80.93,
            -1.06
          ],
          [
            -80.59,
            -0.91
          ],
          [
            -80.4,
            -0.28
          ],
          [
            -80.02,
            0.36
          ],
          [
            -80.09,
            0.77
          ],
          [
            -79.54,
            0.98
          ],
          [
            -78.86,
            1.38
          ],
          [
            -77.86,
            0.81
          ],
          [
            -77.67,
            0.83
          ],
          [
            -77.42,
            0.39
          ],
          [
            -76.58,
            0.26
          ],
          [
            -76.29,
            0.42
          ],
          [
            -75.8,
            0.09
          ],
          [
            -75.37,
            -0.15
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Puerto Rico"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -66.28,
            18.52
          ],
          [
            -65.77,
            18.43
          ],
          [
            -65.59,
            18.23
          ],
          [
            -65.85,
            17.98
          ],
          [
            -66.6,
            17.98
          ],
          [
            -67.19,
            17.95
          ],
          [
            -67.24,
            18.37
          ],
          [
            -67.1,
            18.52
          ],
          [
            -66.28,
            18.52
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Jamaica"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -77.57,
            18.49
          ],
          [
            -76.89,
            18.4
          ],
          [
            -76.37,
            18.16
          ],
          [
            -76.2,
            17.89
          ],
          [
            -76.9,
            17.87
          ],
          [
            -77.2,
            17.7
          ],
          [
            -77.77,
            17.86
          ],
          [
            -78.34,
            18.23
          ],
          [
            -78.22,
            18.45
          ],
          [
            -77.8,
            18.52
          ],
          [
            -77.57,
            18.49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Cuba"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -82.27,
            23.19
          ],
          [
            -81.41,
            23.12
          ],
          [
            -80.62,
            23.11
          ],
          [
            -79.68,
            22.77
          ],
          [
            -79.28,
            22.4
          ],
          [
            -78.35,
            22.51
          ],
          [
            -77.99,
            22.28
          ],
          [
            -77.15,
            21.66
          ],
          [
            -76.52,
            21.21
          ],
          [
            -76.19,
            21.22
          ],
          [
            -75.6,
            21.02
          ],
          [
            -75.67,
            20.73
          ],
          [
            -74.93,
            20.69
          ],
          [
            -74.18,
            20.28
          ],
          [
            -74.3,
            20.05
          ],
          [
            -74.96,
            19.92
          ],
          [
            -75.63,
            19.87
          ],
          [
            -76.32,
            19.95
          ],
          [
            -77.76,
            19.86
          ],
          [
            -77.09,
            20.41
          ],
          [
            -77.49,
            20.67
          ],
          [
            -78.14,
            20.74
          ],
          [
            -78.48,
            21.03
          ],
          [
            -78.72,
            21.6
          ],
          [
            -79.29,
            21.56
          ],
          [
            -80.22,
            21.83
          ],
          [
            -80.52,
            22.04
          ],
          [
            -81.82,
            22.19
          ],
          [
            -82.17,
            22.39
          ],
          [
            -81.79,
            22.64
          ],
          [
            -82.78,
            22.69
          ],
          [
            -83.49,
            22.17
          ],
          [
            -83.91,
            22.15
          ],
          [
            -84.05,
            21.91
          ],
          [
            -84.55,
            21.8
          ],
          [
            -84.97,
            21.9
          ],
          [
            -84.45,
            22.21
          ],
          [
            -84.23,
            22.57
          ],
          [
            -83.78,
            22.79
          ],
          [
            -83.27,
            22.98
          ],
          [
            -82.51,
            23.08
          ],
          [
            -82.27,
            23.19
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Zimbabwe"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            31.19,
            -22.25
          ],
          [
            30.66,
            -22.15
          ],
          [
            30.32,
            -22.27
          ],
          [
            29.84,
            -22.1
          ],
          [
            29.43,
            -22.09
          ],
          [
            28.79,
            -21.64
          ],
          [
            28.02,
            -21.49
          ],
          [
            27.73,
            -20.85
          ],
          [
            27.73,
            -20.5
          ],
          [
            27.3,
            -20.39
          ],
          [
            26.16,
            -19.29
          ],
          [
            25.85,
            -18.71
          ],
          [
            25.65,
            -18.54
          ],
          [
            25.26,
            -17.74
          ],
          [
            26.38,
            -17.85
          ],
          [
            26.71,
            -17.96
          ],
          [
            27.05,
            -17.94
          ],
          [
            27.6,
            -17.29
          ],
          [
            28.47,
            -16.47
          ],
          [
            28.83,
            -16.39
          ],
          [
            28.95,
            -16.04
          ],
          [
            29.52,
            -15.65
          ],
          [
            30.27,
            -15.51
          ],
          [
            30.34,
            -15.88
          ],
          [
            31.17,
            -15.86
          ],
          [
            31.64,
            -16.07
          ],
          [
            31.85,
            -16.32
          ],
          [
            32.33,
            -16.39
          ],
          [
            32.85,
            -16.71
          ],
          [
            32.85,
            -17.98
          ],
          [
            32.65,
            -18.67
          ],
          [
            32.61,
            -19.42
          ],
          [
            32.77,
            -19.72
          ],
          [
            32.66,
            -20.31
          ],
          [
            32.51,
            -20.39
          ],
          [
            32.24,
            -21.12
          ],
          [
            31.19,
            -22.25
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Botswana"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            29.43,
            -22.09
          ],
          [
            28.02,
            -22.83
          ],
          [
            27.12,
            -23.58
          ],
          [
            26.79,
            -24.24
          ],
          [
            26.49,
            -24.62
          ],
          [
            25.94,
            -24.7
          ],
          [
            25.77,
            -25.17
          ],
          [
            25.67,
            -25.49
          ],
          [
            25.03,
            -25.72
          ],
          [
            24.21,
            -25.67
          ],
          [
            23.73,
            -25.39
          ],
          [
            23.31,
            -25.27
          ],
          [
            22.83,
            -25.5
          ],
          [
            22.58,
            -25.98
          ],
          [
            22.11,
            -26.28
          ],
          [
            21.61,
            -26.73
          ],
          [
            20.89,
            -26.83
          ],
          [
            20.67,
            -26.48
          ],
          [
            20.76,
            -25.87
          ],
          [
            20.17,
            -24.92
          ],
          [
            19.9,
            -24.77
          ],
          [
            19.9,
            -21.85
          ],
          [
            20.88,
            -21.81
          ],
          [
            20.91,
            -18.25
          ],
          [
            21.66,
            -18.22
          ],
          [
            23.2,
            -17.87
          ],
          [
            23.58,
            -18.28
          ],
          [
            24.22,
            -17.89
          ],
          [
            24.52,
            -17.89
          ],
          [
            25.08,
            -17.66
          ],
          [
            25.26,
            -17.74
          ],
          [
            25.65,
            -18.54
          ],
          [
            25.85,
            -18.71
          ],
          [
            26.16,
            -19.29
          ],
          [
            27.3,
            -20.39
          ],
          [
            27.73,
            -20.5
          ],
          [
            27.73,
            -20.85
          ],
          [
            28.02,
            -21.49
          ],
          [
            28.79,
            -21.64
          ],
          [
            29.43,
            -22.09
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Namibia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            19.9,
            -24.77
          ],
          [
            19.9,
            -28.46
          ],
          [
            19,
            -28.97
          ],
          [
            18.47,
            -29.05
          ],
          [
            17.84,
            -28.86
          ],
          [
            17.39,
            -28.78
          ],
          [
            17.22,
            -28.36
          ],
          [
            16.82,
            -28.08
          ],
          [
            16.35,
            -28.58
          ],
          [
            15.6,
            -27.82
          ],
          [
            15.21,
            -27.09
          ],
          [
            14.99,
            -26.12
          ],
          [
            14.74,
            -25.39
          ],
          [
            14.41,
            -23.85
          ],
          [
            14.38,
            -22.66
          ],
          [
            14.26,
            -22.11
          ],
          [
            13.87,
            -21.7
          ],
          [
            13.35,
            -20.87
          ],
          [
            12.83,
            -19.67
          ],
          [
            12.61,
            -19.05
          ],
          [
            11.8,
            -18.07
          ],
          [
            11.73,
            -17.3
          ],
          [
            12.22,
            -17.11
          ],
          [
            12.81,
            -16.94
          ],
          [
            13.46,
            -16.97
          ],
          [
            14.06,
            -17.42
          ],
          [
            14.21,
            -17.35
          ],
          [
            18.26,
            -17.31
          ],
          [
            18.96,
            -17.79
          ],
          [
            21.38,
            -17.93
          ],
          [
            23.21,
            -17.52
          ],
          [
            24.04,
            -17.3
          ],
          [
            24.68,
            -17.35
          ],
          [
            25.08,
            -17.58
          ],
          [
            25.08,
            -17.66
          ],
          [
            24.52,
            -17.89
          ],
          [
            24.22,
            -17.89
          ],
          [
            23.58,
            -18.28
          ],
          [
            23.2,
            -17.87
          ],
          [
            21.66,
            -18.22
          ],
          [
            20.91,
            -18.25
          ],
          [
            20.88,
            -21.81
          ],
          [
            19.9,
            -21.85
          ],
          [
            19.9,
            -24.77
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Senegal"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -16.71,
            13.6
          ],
          [
            -17.13,
            14.37
          ],
          [
            -17.62,
            14.73
          ],
          [
            -17.18,
            14.92
          ],
          [
            -16.7,
            15.62
          ],
          [
            -16.46,
            16.14
          ],
          [
            -16.12,
            16.46
          ],
          [
            -15.62,
            16.37
          ],
          [
            -15.14,
            16.59
          ],
          [
            -14.58,
            16.6
          ],
          [
            -14.1,
            16.3
          ],
          [
            -13.44,
            16.04
          ],
          [
            -12.83,
            15.3
          ],
          [
            -12.17,
            14.62
          ],
          [
            -12.12,
            13.99
          ],
          [
            -11.93,
            13.42
          ],
          [
            -11.55,
            13.14
          ],
          [
            -11.47,
            12.75
          ],
          [
            -11.51,
            12.44
          ],
          [
            -11.66,
            12.39
          ],
          [
            -12.2,
            12.47
          ],
          [
            -12.28,
            12.35
          ],
          [
            -12.5,
            12.33
          ],
          [
            -13.22,
            12.58
          ],
          [
            -13.7,
            12.59
          ],
          [
            -15.55,
            12.63
          ],
          [
            -15.82,
            12.52
          ],
          [
            -16.15,
            12.55
          ],
          [
            -16.68,
            12.39
          ],
          [
            -16.84,
            13.15
          ],
          [
            -15.93,
            13.13
          ],
          [
            -15.69,
            13.27
          ],
          [
            -15.51,
            13.28
          ],
          [
            -15.14,
            13.51
          ],
          [
            -14.71,
            13.3
          ],
          [
            -14.28,
            13.28
          ],
          [
            -13.84,
            13.51
          ],
          [
            -14.05,
            13.79
          ],
          [
            -14.38,
            13.63
          ],
          [
            -14.69,
            13.63
          ],
          [
            -15.08,
            13.88
          ],
          [
            -15.4,
            13.86
          ],
          [
            -15.63,
            13.62
          ],
          [
            -16.71,
            13.6
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mali"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -11.51,
            12.44
          ],
          [
            -11.47,
            12.75
          ],
          [
            -11.55,
            13.14
          ],
          [
            -11.93,
            13.42
          ],
          [
            -12.12,
            13.99
          ],
          [
            -12.17,
            14.62
          ],
          [
            -11.84,
            14.8
          ],
          [
            -11.67,
            15.39
          ],
          [
            -11.35,
            15.41
          ],
          [
            -10.65,
            15.13
          ],
          [
            -10.09,
            15.33
          ],
          [
            -9.7,
            15.26
          ],
          [
            -9.55,
            15.49
          ],
          [
            -5.54,
            15.5
          ],
          [
            -5.32,
            16.2
          ],
          [
            -5.49,
            16.33
          ],
          [
            -5.97,
            20.64
          ],
          [
            -6.45,
            24.96
          ],
          [
            -4.92,
            24.97
          ],
          [
            -1.55,
            22.79
          ],
          [
            1.82,
            20.61
          ],
          [
            2.06,
            20.14
          ],
          [
            2.68,
            19.86
          ],
          [
            3.15,
            19.69
          ],
          [
            3.16,
            19.06
          ],
          [
            4.27,
            19.16
          ],
          [
            4.27,
            16.85
          ],
          [
            3.72,
            16.18
          ],
          [
            3.64,
            15.57
          ],
          [
            2.75,
            15.41
          ],
          [
            1.38,
            15.32
          ],
          [
            1.02,
            14.97
          ],
          [
            0.38,
            14.93
          ],
          [
            -0.26,
            14.92
          ],
          [
            -0.52,
            15.12
          ],
          [
            -1.07,
            14.97
          ],
          [
            -2,
            14.56
          ],
          [
            -2.19,
            14.25
          ],
          [
            -2.97,
            13.8
          ],
          [
            -3.11,
            13.54
          ],
          [
            -3.52,
            13.34
          ],
          [
            -4.01,
            13.47
          ],
          [
            -4.28,
            13.23
          ],
          [
            -4.43,
            12.54
          ],
          [
            -5.22,
            11.71
          ],
          [
            -5.2,
            11.37
          ],
          [
            -5.47,
            10.95
          ],
          [
            -5.41,
            10.37
          ],
          [
            -5.82,
            10.22
          ],
          [
            -6.05,
            10.1
          ],
          [
            -6.2,
            10.52
          ],
          [
            -6.49,
            10.41
          ],
          [
            -6.67,
            10.43
          ],
          [
            -6.85,
            10.14
          ],
          [
            -7.62,
            10.15
          ],
          [
            -7.9,
            10.3
          ],
          [
            -8.03,
            10.21
          ],
          [
            -8.34,
            10.49
          ],
          [
            -8.28,
            10.79
          ],
          [
            -8.41,
            10.91
          ],
          [
            -8.62,
            10.81
          ],
          [
            -8.58,
            11.14
          ],
          [
            -8.38,
            11.39
          ],
          [
            -8.79,
            11.81
          ],
          [
            -8.9,
            12.09
          ],
          [
            -9.13,
            12.31
          ],
          [
            -9.33,
            12.33
          ],
          [
            -9.57,
            12.19
          ],
          [
            -9.89,
            12.06
          ],
          [
            -10.16,
            11.84
          ],
          [
            -10.59,
            11.92
          ],
          [
            -10.87,
            12.18
          ],
          [
            -11.04,
            12.21
          ],
          [
            -11.3,
            12.08
          ],
          [
            -11.46,
            12.08
          ],
          [
            -11.51,
            12.44
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mauritania"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -17.06,
            21
          ],
          [
            -16.85,
            21.33
          ],
          [
            -12.93,
            21.33
          ],
          [
            -13.12,
            22.77
          ],
          [
            -12.88,
            23.29
          ],
          [
            -11.94,
            23.37
          ],
          [
            -11.97,
            25.93
          ],
          [
            -8.69,
            25.88
          ],
          [
            -8.69,
            27.4
          ],
          [
            -4.92,
            24.97
          ],
          [
            -6.45,
            24.96
          ],
          [
            -5.97,
            20.64
          ],
          [
            -5.49,
            16.33
          ],
          [
            -5.32,
            16.2
          ],
          [
            -5.54,
            15.5
          ],
          [
            -9.55,
            15.49
          ],
          [
            -9.7,
            15.26
          ],
          [
            -10.09,
            15.33
          ],
          [
            -10.65,
            15.13
          ],
          [
            -11.35,
            15.41
          ],
          [
            -11.67,
            15.39
          ],
          [
            -11.84,
            14.8
          ],
          [
            -12.17,
            14.62
          ],
          [
            -12.83,
            15.3
          ],
          [
            -13.44,
            16.04
          ],
          [
            -14.1,
            16.3
          ],
          [
            -14.58,
            16.6
          ],
          [
            -15.14,
            16.59
          ],
          [
            -15.62,
            16.37
          ],
          [
            -16.12,
            16.46
          ],
          [
            -16.46,
            16.14
          ],
          [
            -16.55,
            16.67
          ],
          [
            -16.27,
            17.17
          ],
          [
            -16.15,
            18.11
          ],
          [
            -16.26,
            19.1
          ],
          [
            -16.38,
            19.59
          ],
          [
            -16.28,
            20.09
          ],
          [
            -16.54,
            20.57
          ],
          [
            -17.06,
            21
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Benin"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            2.69,
            6.26
          ],
          [
            1.87,
            6.14
          ],
          [
            1.62,
            6.83
          ],
          [
            1.67,
            9.13
          ],
          [
            1.46,
            9.34
          ],
          [
            1.42,
            9.83
          ],
          [
            1.08,
            10.18
          ],
          [
            0.77,
            10.47
          ],
          [
            0.9,
            11
          ],
          [
            1.24,
            11.11
          ],
          [
            1.45,
            11.55
          ],
          [
            1.94,
            11.64
          ],
          [
            2.15,
            11.94
          ],
          [
            2.49,
            12.23
          ],
          [
            2.85,
            12.24
          ],
          [
            3.61,
            11.66
          ],
          [
            3.57,
            11.33
          ],
          [
            3.8,
            10.73
          ],
          [
            3.6,
            10.33
          ],
          [
            3.71,
            10.06
          ],
          [
            3.22,
            9.44
          ],
          [
            2.91,
            9.14
          ],
          [
            2.72,
            8.51
          ],
          [
            2.75,
            7.87
          ],
          [
            2.69,
            6.26
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Niger"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            14.85,
            22.86
          ],
          [
            15.1,
            21.31
          ],
          [
            15.47,
            21.05
          ],
          [
            15.49,
            20.73
          ],
          [
            15.9,
            20.39
          ],
          [
            15.69,
            19.96
          ],
          [
            15.3,
            17.93
          ],
          [
            15.25,
            16.63
          ],
          [
            13.97,
            15.68
          ],
          [
            13.54,
            14.37
          ],
          [
            13.96,
            14
          ],
          [
            13.96,
            13.35
          ],
          [
            14.6,
            13.33
          ],
          [
            14.5,
            12.86
          ],
          [
            14.21,
            12.8
          ],
          [
            14.18,
            12.48
          ],
          [
            14,
            12.46
          ],
          [
            13.32,
            13.56
          ],
          [
            13.08,
            13.6
          ],
          [
            12.3,
            13.04
          ],
          [
            11.53,
            13.33
          ],
          [
            10.99,
            13.39
          ],
          [
            10.7,
            13.25
          ],
          [
            10.11,
            13.28
          ],
          [
            9.52,
            12.85
          ],
          [
            9.02,
            12.83
          ],
          [
            7.8,
            13.34
          ],
          [
            7.33,
            13.1
          ],
          [
            6.82,
            13.11
          ],
          [
            6.45,
            13.49
          ],
          [
            5.44,
            13.87
          ],
          [
            4.37,
            13.75
          ],
          [
            4.11,
            13.53
          ],
          [
            3.97,
            12.96
          ],
          [
            3.68,
            12.55
          ],
          [
            3.61,
            11.66
          ],
          [
            2.85,
            12.24
          ],
          [
            2.49,
            12.23
          ],
          [
            2.15,
            11.94
          ],
          [
            2.18,
            12.63
          ],
          [
            1.02,
            12.85
          ],
          [
            0.99,
            13.34
          ],
          [
            0.43,
            13.99
          ],
          [
            0.3,
            14.44
          ],
          [
            0.38,
            14.93
          ],
          [
            1.02,
            14.97
          ],
          [
            1.38,
            15.32
          ],
          [
            2.75,
            15.41
          ],
          [
            3.64,
            15.57
          ],
          [
            3.72,
            16.18
          ],
          [
            4.27,
            16.85
          ],
          [
            4.27,
            19.16
          ],
          [
            5.68,
            19.6
          ],
          [
            8.57,
            21.57
          ],
          [
            12,
            23.47
          ],
          [
            13.58,
            23.04
          ],
          [
            14.14,
            22.49
          ],
          [
            14.85,
            22.86
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Nigeria"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            2.69,
            6.26
          ],
          [
            2.75,
            7.87
          ],
          [
            2.72,
            8.51
          ],
          [
            2.91,
            9.14
          ],
          [
            3.22,
            9.44
          ],
          [
            3.71,
            10.06
          ],
          [
            3.6,
            10.33
          ],
          [
            3.8,
            10.73
          ],
          [
            3.57,
            11.33
          ],
          [
            3.61,
            11.66
          ],
          [
            3.68,
            12.55
          ],
          [
            3.97,
            12.96
          ],
          [
            4.11,
            13.53
          ],
          [
            4.37,
            13.75
          ],
          [
            5.44,
            13.87
          ],
          [
            6.45,
            13.49
          ],
          [
            6.82,
            13.11
          ],
          [
            7.33,
            13.1
          ],
          [
            7.8,
            13.34
          ],
          [
            9.02,
            12.83
          ],
          [
            9.52,
            12.85
          ],
          [
            10.11,
            13.28
          ],
          [
            10.7,
            13.25
          ],
          [
            10.99,
            13.39
          ],
          [
            11.53,
            13.33
          ],
          [
            12.3,
            13.04
          ],
          [
            13.08,
            13.6
          ],
          [
            13.32,
            13.56
          ],
          [
            14,
            12.46
          ],
          [
            14.18,
            12.48
          ],
          [
            14.58,
            12.09
          ],
          [
            14.47,
            11.9
          ],
          [
            14.42,
            11.57
          ],
          [
            13.57,
            10.8
          ],
          [
            13.31,
            10.16
          ],
          [
            13.17,
            9.64
          ],
          [
            12.95,
            9.42
          ],
          [
            12.75,
            8.72
          ],
          [
            12.22,
            8.31
          ],
          [
            12.07,
            7.8
          ],
          [
            11.84,
            7.4
          ],
          [
            11.75,
            6.98
          ],
          [
            11.06,
            6.64
          ],
          [
            10.5,
            7.06
          ],
          [
            10.12,
            7.04
          ],
          [
            9.52,
            6.45
          ],
          [
            9.23,
            6.44
          ],
          [
            8.76,
            5.48
          ],
          [
            8.5,
            4.77
          ],
          [
            7.46,
            4.41
          ],
          [
            7.08,
            4.46
          ],
          [
            6.7,
            4.24
          ],
          [
            5.9,
            4.26
          ],
          [
            5.36,
            4.89
          ],
          [
            5.03,
            5.61
          ],
          [
            4.33,
            6.27
          ],
          [
            3.57,
            6.26
          ],
          [
            2.69,
            6.26
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Cameroon"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            14.5,
            12.86
          ],
          [
            14.9,
            12.22
          ],
          [
            14.96,
            11.56
          ],
          [
            14.92,
            10.89
          ],
          [
            15.47,
            9.98
          ],
          [
            14.91,
            9.99
          ],
          [
            14.63,
            9.92
          ],
          [
            14.17,
            10.02
          ],
          [
            13.96,
            9.55
          ],
          [
            14.55,
            8.97
          ],
          [
            14.98,
            8.8
          ],
          [
            15.12,
            8.38
          ],
          [
            15.44,
            7.69
          ],
          [
            15.28,
            7.42
          ],
          [
            14.78,
            6.41
          ],
          [
            14.54,
            6.23
          ],
          [
            14.46,
            5.45
          ],
          [
            14.56,
            5.03
          ],
          [
            14.48,
            4.73
          ],
          [
            14.95,
            4.21
          ],
          [
            15.04,
            3.85
          ],
          [
            15.41,
            3.33
          ],
          [
            15.86,
            3.01
          ],
          [
            15.91,
            2.56
          ],
          [
            16.01,
            2.27
          ],
          [
            15.94,
            1.73
          ],
          [
            15.15,
            1.96
          ],
          [
            14.34,
            2.23
          ],
          [
            13.08,
            2.27
          ],
          [
            12.95,
            2.32
          ],
          [
            12.36,
            2.19
          ],
          [
            11.75,
            2.33
          ],
          [
            11.28,
            2.26
          ],
          [
            9.65,
            2.28
          ],
          [
            9.79,
            3.07
          ],
          [
            9.41,
            3.73
          ],
          [
            8.95,
            3.9
          ],
          [
            8.75,
            4.35
          ],
          [
            8.49,
            4.5
          ],
          [
            8.5,
            4.77
          ],
          [
            8.76,
            5.48
          ],
          [
            9.23,
            6.44
          ],
          [
            9.52,
            6.45
          ],
          [
            10.12,
            7.04
          ],
          [
            10.5,
            7.06
          ],
          [
            11.06,
            6.64
          ],
          [
            11.75,
            6.98
          ],
          [
            11.84,
            7.4
          ],
          [
            12.07,
            7.8
          ],
          [
            12.22,
            8.31
          ],
          [
            12.75,
            8.72
          ],
          [
            12.95,
            9.42
          ],
          [
            13.17,
            9.64
          ],
          [
            13.31,
            10.16
          ],
          [
            13.57,
            10.8
          ],
          [
            14.42,
            11.57
          ],
          [
            14.47,
            11.9
          ],
          [
            14.58,
            12.09
          ],
          [
            14.18,
            12.48
          ],
          [
            14.21,
            12.8
          ],
          [
            14.5,
            12.86
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Togo"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            0.9,
            11
          ],
          [
            0.77,
            10.47
          ],
          [
            1.08,
            10.18
          ],
          [
            1.42,
            9.83
          ],
          [
            1.46,
            9.34
          ],
          [
            1.67,
            9.13
          ],
          [
            1.62,
            6.83
          ],
          [
            1.87,
            6.14
          ],
          [
            1.06,
            5.93
          ],
          [
            0.84,
            6.28
          ],
          [
            0.57,
            6.91
          ],
          [
            0.49,
            7.41
          ],
          [
            0.71,
            8.31
          ],
          [
            0.46,
            8.68
          ],
          [
            0.37,
            9.47
          ],
          [
            0.37,
            10.19
          ],
          [
            -0.05,
            10.71
          ],
          [
            0.02,
            11.02
          ],
          [
            0.9,
            11
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ghana"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            0.02,
            11.02
          ],
          [
            -0.05,
            10.71
          ],
          [
            0.37,
            10.19
          ],
          [
            0.37,
            9.47
          ],
          [
            0.46,
            8.68
          ],
          [
            0.71,
            8.31
          ],
          [
            0.49,
            7.41
          ],
          [
            0.57,
            6.91
          ],
          [
            0.84,
            6.28
          ],
          [
            1.06,
            5.93
          ],
          [
            -0.51,
            5.34
          ],
          [
            -1.06,
            5
          ],
          [
            -1.96,
            4.71
          ],
          [
            -2.86,
            5
          ],
          [
            -2.81,
            5.39
          ],
          [
            -3.25,
            6.25
          ],
          [
            -2.98,
            7.38
          ],
          [
            -2.56,
            8.22
          ],
          [
            -2.83,
            9.64
          ],
          [
            -2.96,
            10.39
          ],
          [
            -2.94,
            10.96
          ],
          [
            -1.2,
            11.01
          ],
          [
            -0.76,
            10.94
          ],
          [
            -0.44,
            11.1
          ],
          [
            0.02,
            11.02
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Côte d'Ivoire"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -8.03,
            10.21
          ],
          [
            -7.9,
            10.3
          ],
          [
            -7.62,
            10.15
          ],
          [
            -6.85,
            10.14
          ],
          [
            -6.67,
            10.43
          ],
          [
            -6.49,
            10.41
          ],
          [
            -6.2,
            10.52
          ],
          [
            -6.05,
            10.1
          ],
          [
            -5.82,
            10.22
          ],
          [
            -5.41,
            10.37
          ],
          [
            -4.96,
            10.15
          ],
          [
            -4.78,
            9.82
          ],
          [
            -4.33,
            9.61
          ],
          [
            -3.98,
            9.86
          ],
          [
            -3.51,
            9.9
          ],
          [
            -2.83,
            9.64
          ],
          [
            -2.56,
            8.22
          ],
          [
            -2.98,
            7.38
          ],
          [
            -3.25,
            6.25
          ],
          [
            -2.81,
            5.39
          ],
          [
            -2.86,
            5
          ],
          [
            -3.31,
            4.98
          ],
          [
            -4.01,
            5.18
          ],
          [
            -4.65,
            5.17
          ],
          [
            -5.83,
            4.99
          ],
          [
            -6.53,
            4.71
          ],
          [
            -7.52,
            4.34
          ],
          [
            -7.71,
            4.36
          ],
          [
            -7.63,
            5.19
          ],
          [
            -7.54,
            5.31
          ],
          [
            -7.57,
            5.71
          ],
          [
            -7.99,
            6.13
          ],
          [
            -8.31,
            6.19
          ],
          [
            -8.6,
            6.47
          ],
          [
            -8.39,
            6.91
          ],
          [
            -8.49,
            7.4
          ],
          [
            -8.44,
            7.69
          ],
          [
            -8.28,
            7.69
          ],
          [
            -8.22,
            8.12
          ],
          [
            -8.3,
            8.32
          ],
          [
            -8.2,
            8.45
          ],
          [
            -7.83,
            8.58
          ],
          [
            -8.08,
            9.38
          ],
          [
            -8.31,
            9.79
          ],
          [
            -8.23,
            10.13
          ],
          [
            -8.03,
            10.21
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Guinea"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -13.7,
            12.59
          ],
          [
            -13.22,
            12.58
          ],
          [
            -12.5,
            12.33
          ],
          [
            -12.28,
            12.35
          ],
          [
            -12.2,
            12.47
          ],
          [
            -11.66,
            12.39
          ],
          [
            -11.51,
            12.44
          ],
          [
            -11.46,
            12.08
          ],
          [
            -11.3,
            12.08
          ],
          [
            -11.04,
            12.21
          ],
          [
            -10.87,
            12.18
          ],
          [
            -10.59,
            11.92
          ],
          [
            -10.16,
            11.84
          ],
          [
            -9.89,
            12.06
          ],
          [
            -9.57,
            12.19
          ],
          [
            -9.33,
            12.33
          ],
          [
            -9.13,
            12.31
          ],
          [
            -8.9,
            12.09
          ],
          [
            -8.79,
            11.81
          ],
          [
            -8.38,
            11.39
          ],
          [
            -8.58,
            11.14
          ],
          [
            -8.62,
            10.81
          ],
          [
            -8.41,
            10.91
          ],
          [
            -8.28,
            10.79
          ],
          [
            -8.34,
            10.49
          ],
          [
            -8.03,
            10.21
          ],
          [
            -8.23,
            10.13
          ],
          [
            -8.31,
            9.79
          ],
          [
            -8.08,
            9.38
          ],
          [
            -7.83,
            8.58
          ],
          [
            -8.2,
            8.45
          ],
          [
            -8.3,
            8.32
          ],
          [
            -8.22,
            8.12
          ],
          [
            -8.28,
            7.69
          ],
          [
            -8.44,
            7.69
          ],
          [
            -8.72,
            7.71
          ],
          [
            -8.93,
            7.31
          ],
          [
            -9.21,
            7.31
          ],
          [
            -9.41,
            7.53
          ],
          [
            -9.34,
            7.93
          ],
          [
            -9.75,
            8.54
          ],
          [
            -10.02,
            8.43
          ],
          [
            -10.23,
            8.41
          ],
          [
            -10.51,
            8.35
          ],
          [
            -10.5,
            8.72
          ],
          [
            -10.65,
            8.98
          ],
          [
            -10.62,
            9.27
          ],
          [
            -10.84,
            9.69
          ],
          [
            -11.12,
            10.05
          ],
          [
            -11.92,
            10.05
          ],
          [
            -12.15,
            9.86
          ],
          [
            -12.43,
            9.84
          ],
          [
            -12.6,
            9.62
          ],
          [
            -12.71,
            9.34
          ],
          [
            -13.25,
            8.9
          ],
          [
            -13.69,
            9.49
          ],
          [
            -14.07,
            9.89
          ],
          [
            -14.33,
            10.02
          ],
          [
            -14.58,
            10.22
          ],
          [
            -14.69,
            10.66
          ],
          [
            -14.84,
            10.88
          ],
          [
            -15.13,
            11.04
          ],
          [
            -14.69,
            11.53
          ],
          [
            -14.38,
            11.51
          ],
          [
            -14.12,
            11.68
          ],
          [
            -13.9,
            11.68
          ],
          [
            -13.74,
            11.81
          ],
          [
            -13.83,
            12.14
          ],
          [
            -13.72,
            12.25
          ],
          [
            -13.7,
            12.59
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Guinea-Bissau"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -16.68,
            12.39
          ],
          [
            -16.15,
            12.55
          ],
          [
            -15.82,
            12.52
          ],
          [
            -15.55,
            12.63
          ],
          [
            -13.7,
            12.59
          ],
          [
            -13.72,
            12.25
          ],
          [
            -13.83,
            12.14
          ],
          [
            -13.74,
            11.81
          ],
          [
            -13.9,
            11.68
          ],
          [
            -14.12,
            11.68
          ],
          [
            -14.38,
            11.51
          ],
          [
            -14.69,
            11.53
          ],
          [
            -15.13,
            11.04
          ],
          [
            -15.67,
            11.46
          ],
          [
            -16.09,
            11.53
          ],
          [
            -16.31,
            11.81
          ],
          [
            -16.31,
            11.96
          ],
          [
            -16.61,
            12.17
          ],
          [
            -16.68,
            12.39
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Liberia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -8.44,
            7.69
          ],
          [
            -8.49,
            7.4
          ],
          [
            -8.39,
            6.91
          ],
          [
            -8.6,
            6.47
          ],
          [
            -8.31,
            6.19
          ],
          [
            -7.99,
            6.13
          ],
          [
            -7.57,
            5.71
          ],
          [
            -7.54,
            5.31
          ],
          [
            -7.63,
            5.19
          ],
          [
            -7.71,
            4.36
          ],
          [
            -7.98,
            4.36
          ],
          [
            -9.01,
            4.83
          ],
          [
            -9.91,
            5.59
          ],
          [
            -10.77,
            6.14
          ],
          [
            -11.44,
            6.79
          ],
          [
            -11.2,
            7.11
          ],
          [
            -11.15,
            7.4
          ],
          [
            -10.69,
            7.94
          ],
          [
            -10.23,
            8.41
          ],
          [
            -10.02,
            8.43
          ],
          [
            -9.75,
            8.54
          ],
          [
            -9.34,
            7.93
          ],
          [
            -9.41,
            7.53
          ],
          [
            -9.21,
            7.31
          ],
          [
            -8.93,
            7.31
          ],
          [
            -8.72,
            7.71
          ],
          [
            -8.44,
            7.69
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Sierra Leone"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -13.25,
            8.9
          ],
          [
            -12.71,
            9.34
          ],
          [
            -12.6,
            9.62
          ],
          [
            -12.43,
            9.84
          ],
          [
            -12.15,
            9.86
          ],
          [
            -11.92,
            10.05
          ],
          [
            -11.12,
            10.05
          ],
          [
            -10.84,
            9.69
          ],
          [
            -10.62,
            9.27
          ],
          [
            -10.65,
            8.98
          ],
          [
            -10.5,
            8.72
          ],
          [
            -10.51,
            8.35
          ],
          [
            -10.23,
            8.41
          ],
          [
            -10.69,
            7.94
          ],
          [
            -11.15,
            7.4
          ],
          [
            -11.2,
            7.11
          ],
          [
            -11.44,
            6.79
          ],
          [
            -11.71,
            6.86
          ],
          [
            -12.43,
            7.26
          ],
          [
            -12.95,
            7.8
          ],
          [
            -13.12,
            8.16
          ],
          [
            -13.25,
            8.9
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Burkina Faso"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -5.41,
            10.37
          ],
          [
            -5.47,
            10.95
          ],
          [
            -5.2,
            11.37
          ],
          [
            -5.22,
            11.71
          ],
          [
            -4.43,
            12.54
          ],
          [
            -4.28,
            13.23
          ],
          [
            -4.01,
            13.47
          ],
          [
            -3.52,
            13.34
          ],
          [
            -3.11,
            13.54
          ],
          [
            -2.97,
            13.8
          ],
          [
            -2.19,
            14.25
          ],
          [
            -2,
            14.56
          ],
          [
            -1.07,
            14.97
          ],
          [
            -0.52,
            15.12
          ],
          [
            -0.26,
            14.92
          ],
          [
            0.38,
            14.93
          ],
          [
            0.3,
            14.44
          ],
          [
            0.43,
            13.99
          ],
          [
            0.99,
            13.34
          ],
          [
            1.02,
            12.85
          ],
          [
            2.18,
            12.63
          ],
          [
            2.15,
            11.94
          ],
          [
            1.94,
            11.64
          ],
          [
            1.45,
            11.55
          ],
          [
            1.24,
            11.11
          ],
          [
            0.9,
            11
          ],
          [
            0.02,
            11.02
          ],
          [
            -0.44,
            11.1
          ],
          [
            -0.76,
            10.94
          ],
          [
            -1.2,
            11.01
          ],
          [
            -2.94,
            10.96
          ],
          [
            -2.96,
            10.39
          ],
          [
            -2.83,
            9.64
          ],
          [
            -3.51,
            9.9
          ],
          [
            -3.98,
            9.86
          ],
          [
            -4.33,
            9.61
          ],
          [
            -4.78,
            9.82
          ],
          [
            -4.96,
            10.15
          ],
          [
            -5.41,
            10.37
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Central African Rep."
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            27.37,
            5.23
          ],
          [
            27.05,
            5.13
          ],
          [
            26.4,
            5.15
          ],
          [
            25.65,
            5.26
          ],
          [
            25.28,
            5.17
          ],
          [
            25.13,
            4.93
          ],
          [
            24.81,
            4.9
          ],
          [
            24.41,
            5.11
          ],
          [
            23.3,
            4.61
          ],
          [
            22.84,
            4.71
          ],
          [
            22.7,
            4.63
          ],
          [
            22.4,
            4.03
          ],
          [
            21.66,
            4.22
          ],
          [
            20.93,
            4.32
          ],
          [
            20.29,
            4.69
          ],
          [
            19.47,
            5.03
          ],
          [
            18.93,
            4.71
          ],
          [
            18.54,
            4.2
          ],
          [
            18.45,
            3.5
          ],
          [
            17.81,
            3.56
          ],
          [
            17.13,
            3.73
          ],
          [
            16.54,
            3.2
          ],
          [
            16.01,
            2.27
          ],
          [
            15.91,
            2.56
          ],
          [
            15.86,
            3.01
          ],
          [
            15.41,
            3.33
          ],
          [
            15.04,
            3.85
          ],
          [
            14.95,
            4.21
          ],
          [
            14.48,
            4.73
          ],
          [
            14.56,
            5.03
          ],
          [
            14.46,
            5.45
          ],
          [
            14.54,
            6.23
          ],
          [
            14.78,
            6.41
          ],
          [
            15.28,
            7.42
          ],
          [
            16.1,
            7.5
          ],
          [
            16.29,
            7.75
          ],
          [
            16.46,
            7.74
          ],
          [
            16.71,
            7.51
          ],
          [
            17.97,
            7.89
          ],
          [
            18.39,
            8.28
          ],
          [
            18.91,
            8.63
          ],
          [
            18.81,
            8.98
          ],
          [
            19.09,
            9.07
          ],
          [
            20.06,
            9.01
          ],
          [
            21,
            9.48
          ],
          [
            21.72,
            10.57
          ],
          [
            22.23,
            10.97
          ],
          [
            22.87,
            11.14
          ],
          [
            22.98,
            10.71
          ],
          [
            23.55,
            10.09
          ],
          [
            23.56,
            9.68
          ],
          [
            23.39,
            9.27
          ],
          [
            23.46,
            8.95
          ],
          [
            23.81,
            8.67
          ],
          [
            24.57,
            8.23
          ],
          [
            25.12,
            7.83
          ],
          [
            25.12,
            7.5
          ],
          [
            25.8,
            6.98
          ],
          [
            26.21,
            6.55
          ],
          [
            26.47,
            5.95
          ],
          [
            27.21,
            5.55
          ],
          [
            27.37,
            5.23
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Congo"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            18.45,
            3.5
          ],
          [
            18.39,
            2.9
          ],
          [
            18.1,
            2.37
          ],
          [
            17.9,
            1.74
          ],
          [
            17.78,
            0.86
          ],
          [
            17.83,
            0.29
          ],
          [
            17.66,
            -0.06
          ],
          [
            17.64,
            -0.42
          ],
          [
            17.52,
            -0.74
          ],
          [
            16.86,
            -1.23
          ],
          [
            16.41,
            -1.74
          ],
          [
            15.97,
            -2.71
          ],
          [
            16.01,
            -3.54
          ],
          [
            15.75,
            -3.86
          ],
          [
            15.17,
            -4.34
          ],
          [
            14.58,
            -4.97
          ],
          [
            14.21,
            -4.79
          ],
          [
            14.15,
            -4.51
          ],
          [
            13.6,
            -4.5
          ],
          [
            13.26,
            -4.88
          ],
          [
            12.99,
            -4.78
          ],
          [
            12.62,
            -4.44
          ],
          [
            12.32,
            -4.61
          ],
          [
            11.91,
            -5.04
          ],
          [
            11.09,
            -3.98
          ],
          [
            11.86,
            -3.43
          ],
          [
            11.48,
            -2.77
          ],
          [
            11.82,
            -2.51
          ],
          [
            12.49,
            -2.39
          ],
          [
            12.58,
            -1.95
          ],
          [
            13.11,
            -2.43
          ],
          [
            13.99,
            -2.47
          ],
          [
            14.3,
            -2
          ],
          [
            14.43,
            -1.33
          ],
          [
            14.32,
            -0.55
          ],
          [
            13.84,
            0.04
          ],
          [
            14.28,
            1.2
          ],
          [
            14.03,
            1.4
          ],
          [
            13.28,
            1.31
          ],
          [
            13,
            1.83
          ],
          [
            13.08,
            2.27
          ],
          [
            14.34,
            2.23
          ],
          [
            15.15,
            1.96
          ],
          [
            15.94,
            1.73
          ],
          [
            16.01,
            2.27
          ],
          [
            16.54,
            3.2
          ],
          [
            17.13,
            3.73
          ],
          [
            17.81,
            3.56
          ],
          [
            18.45,
            3.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Gabon"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            11.28,
            2.26
          ],
          [
            11.75,
            2.33
          ],
          [
            12.36,
            2.19
          ],
          [
            12.95,
            2.32
          ],
          [
            13.08,
            2.27
          ],
          [
            13,
            1.83
          ],
          [
            13.28,
            1.31
          ],
          [
            14.03,
            1.4
          ],
          [
            14.28,
            1.2
          ],
          [
            13.84,
            0.04
          ],
          [
            14.32,
            -0.55
          ],
          [
            14.43,
            -1.33
          ],
          [
            14.3,
            -2
          ],
          [
            13.99,
            -2.47
          ],
          [
            13.11,
            -2.43
          ],
          [
            12.58,
            -1.95
          ],
          [
            12.49,
            -2.39
          ],
          [
            11.82,
            -2.51
          ],
          [
            11.48,
            -2.77
          ],
          [
            11.86,
            -3.43
          ],
          [
            11.09,
            -3.98
          ],
          [
            10.07,
            -2.97
          ],
          [
            9.41,
            -2.14
          ],
          [
            8.8,
            -1.11
          ],
          [
            8.83,
            -0.78
          ],
          [
            9.05,
            -0.46
          ],
          [
            9.29,
            0.27
          ],
          [
            9.49,
            1.01
          ],
          [
            9.83,
            1.07
          ],
          [
            11.28,
            1.06
          ],
          [
            11.28,
            2.26
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Eq. Guinea"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            9.65,
            2.28
          ],
          [
            11.28,
            2.26
          ],
          [
            11.28,
            1.06
          ],
          [
            9.83,
            1.07
          ],
          [
            9.49,
            1.01
          ],
          [
            9.3,
            1.16
          ],
          [
            9.65,
            2.28
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Zambia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            30.74,
            -8.34
          ],
          [
            31.16,
            -8.59
          ],
          [
            31.56,
            -8.76
          ],
          [
            32.19,
            -8.93
          ],
          [
            32.76,
            -9.23
          ],
          [
            33.23,
            -9.68
          ],
          [
            33.49,
            -10.53
          ],
          [
            33.32,
            -10.8
          ],
          [
            33.11,
            -11.61
          ],
          [
            33.31,
            -12.44
          ],
          [
            32.99,
            -12.78
          ],
          [
            32.69,
            -13.71
          ],
          [
            33.22,
            -13.97
          ],
          [
            30.18,
            -14.8
          ],
          [
            30.27,
            -15.51
          ],
          [
            29.52,
            -15.65
          ],
          [
            28.95,
            -16.04
          ],
          [
            28.83,
            -16.39
          ],
          [
            28.47,
            -16.47
          ],
          [
            27.6,
            -17.29
          ],
          [
            27.05,
            -17.94
          ],
          [
            26.71,
            -17.96
          ],
          [
            26.38,
            -17.85
          ],
          [
            25.26,
            -17.74
          ],
          [
            25.08,
            -17.66
          ],
          [
            25.08,
            -17.58
          ],
          [
            24.68,
            -17.35
          ],
          [
            24.04,
            -17.3
          ],
          [
            23.21,
            -17.52
          ],
          [
            22.56,
            -16.9
          ],
          [
            21.89,
            -16.08
          ],
          [
            21.93,
            -12.9
          ],
          [
            24.02,
            -12.91
          ],
          [
            23.93,
            -12.57
          ],
          [
            24.08,
            -12.19
          ],
          [
            23.9,
            -11.72
          ],
          [
            24.02,
            -11.24
          ],
          [
            23.91,
            -10.93
          ],
          [
            24.26,
            -10.95
          ],
          [
            24.31,
            -11.26
          ],
          [
            24.78,
            -11.24
          ],
          [
            25.42,
            -11.33
          ],
          [
            25.75,
            -11.78
          ],
          [
            26.55,
            -11.93
          ],
          [
            27.16,
            -11.61
          ],
          [
            27.39,
            -12.13
          ],
          [
            28.15,
            -12.27
          ],
          [
            28.52,
            -12.7
          ],
          [
            28.94,
            -13.25
          ],
          [
            29.7,
            -13.26
          ],
          [
            29.62,
            -12.18
          ],
          [
            29.34,
            -12.36
          ],
          [
            28.64,
            -11.97
          ],
          [
            28.37,
            -11.79
          ],
          [
            28.5,
            -10.79
          ],
          [
            28.67,
            -9.61
          ],
          [
            28.45,
            -9.16
          ],
          [
            28.73,
            -8.53
          ],
          [
            29,
            -8.41
          ],
          [
            30.35,
            -8.24
          ],
          [
            30.74,
            -8.34
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Malawi"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            32.76,
            -9.23
          ],
          [
            33.74,
            -9.42
          ],
          [
            33.94,
            -9.69
          ],
          [
            34.28,
            -10.16
          ],
          [
            34.56,
            -11.52
          ],
          [
            34.28,
            -12.28
          ],
          [
            34.56,
            -13.58
          ],
          [
            34.91,
            -13.57
          ],
          [
            35.27,
            -13.89
          ],
          [
            35.69,
            -14.61
          ],
          [
            35.77,
            -15.9
          ],
          [
            35.34,
            -16.11
          ],
          [
            35.03,
            -16.8
          ],
          [
            34.38,
            -16.18
          ],
          [
            34.31,
            -15.48
          ],
          [
            34.52,
            -15.01
          ],
          [
            34.46,
            -14.61
          ],
          [
            34.07,
            -14.36
          ],
          [
            33.79,
            -14.45
          ],
          [
            33.22,
            -13.97
          ],
          [
            32.69,
            -13.71
          ],
          [
            32.99,
            -12.78
          ],
          [
            33.31,
            -12.44
          ],
          [
            33.11,
            -11.61
          ],
          [
            33.32,
            -10.8
          ],
          [
            33.49,
            -10.53
          ],
          [
            33.23,
            -9.68
          ],
          [
            32.76,
            -9.23
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mozambique"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            34.56,
            -11.52
          ],
          [
            35.31,
            -11.44
          ],
          [
            36.51,
            -11.72
          ],
          [
            36.78,
            -11.6
          ],
          [
            37.47,
            -11.57
          ],
          [
            37.83,
            -11.27
          ],
          [
            38.43,
            -11.29
          ],
          [
            39.52,
            -10.9
          ],
          [
            40.32,
            -10.32
          ],
          [
            40.48,
            -10.77
          ],
          [
            40.44,
            -11.76
          ],
          [
            40.56,
            -12.64
          ],
          [
            40.6,
            -14.2
          ],
          [
            40.78,
            -14.69
          ],
          [
            40.48,
            -15.41
          ],
          [
            40.09,
            -16.1
          ],
          [
            39.45,
            -16.72
          ],
          [
            38.54,
            -17.1
          ],
          [
            37.41,
            -17.59
          ],
          [
            36.28,
            -18.66
          ],
          [
            35.9,
            -18.84
          ],
          [
            35.2,
            -19.55
          ],
          [
            34.79,
            -19.78
          ],
          [
            34.7,
            -20.5
          ],
          [
            35.18,
            -21.25
          ],
          [
            35.37,
            -21.84
          ],
          [
            35.39,
            -22.14
          ],
          [
            35.56,
            -22.09
          ],
          [
            35.53,
            -23.07
          ],
          [
            35.37,
            -23.54
          ],
          [
            35.61,
            -23.71
          ],
          [
            35.46,
            -24.12
          ],
          [
            35.04,
            -24.48
          ],
          [
            34.22,
            -24.82
          ],
          [
            33.01,
            -25.36
          ],
          [
            32.57,
            -25.73
          ],
          [
            32.66,
            -26.15
          ],
          [
            32.92,
            -26.22
          ],
          [
            32.83,
            -26.74
          ],
          [
            32.07,
            -26.73
          ],
          [
            31.98,
            -26.29
          ],
          [
            31.84,
            -25.84
          ],
          [
            31.75,
            -25.48
          ],
          [
            31.93,
            -24.37
          ],
          [
            31.67,
            -23.66
          ],
          [
            31.19,
            -22.25
          ],
          [
            32.24,
            -21.12
          ],
          [
            32.51,
            -20.39
          ],
          [
            32.66,
            -20.31
          ],
          [
            32.77,
            -19.72
          ],
          [
            32.61,
            -19.42
          ],
          [
            32.65,
            -18.67
          ],
          [
            32.85,
            -17.98
          ],
          [
            32.85,
            -16.71
          ],
          [
            32.33,
            -16.39
          ],
          [
            31.85,
            -16.32
          ],
          [
            31.64,
            -16.07
          ],
          [
            31.17,
            -15.86
          ],
          [
            30.34,
            -15.88
          ],
          [
            30.27,
            -15.51
          ],
          [
            30.18,
            -14.8
          ],
          [
            33.22,
            -13.97
          ],
          [
            33.79,
            -14.45
          ],
          [
            34.07,
            -14.36
          ],
          [
            34.46,
            -14.61
          ],
          [
            34.52,
            -15.01
          ],
          [
            34.31,
            -15.48
          ],
          [
            34.38,
            -16.18
          ],
          [
            35.03,
            -16.8
          ],
          [
            35.34,
            -16.11
          ],
          [
            35.77,
            -15.9
          ],
          [
            35.69,
            -14.61
          ],
          [
            35.27,
            -13.89
          ],
          [
            34.91,
            -13.57
          ],
          [
            34.56,
            -13.58
          ],
          [
            34.28,
            -12.28
          ],
          [
            34.56,
            -11.52
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "eSwatini"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            32.07,
            -26.73
          ],
          [
            31.87,
            -27.18
          ],
          [
            31.28,
            -27.29
          ],
          [
            30.68,
            -26.74
          ],
          [
            30.68,
            -26.4
          ],
          [
            30.95,
            -26.02
          ],
          [
            31.04,
            -25.73
          ],
          [
            31.33,
            -25.66
          ],
          [
            31.84,
            -25.84
          ],
          [
            31.98,
            -26.29
          ],
          [
            32.07,
            -26.73
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Angola"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              12.99,
              -4.78
            ],
            [
              12.63,
              -4.99
            ],
            [
              12.47,
              -5.25
            ],
            [
              12.44,
              -5.68
            ],
            [
              12.18,
              -5.79
            ],
            [
              11.91,
              -5.04
            ],
            [
              12.32,
              -4.61
            ],
            [
              12.62,
              -4.44
            ],
            [
              12.99,
              -4.78
            ]
          ]
        ],
        [
          [
            [
              12.32,
              -6.1
            ],
            [
              12.74,
              -5.97
            ],
            [
              13.02,
              -5.98
            ],
            [
              13.38,
              -5.86
            ],
            [
              16.33,
              -5.88
            ],
            [
              16.57,
              -6.62
            ],
            [
              16.86,
              -7.22
            ],
            [
              17.09,
              -7.54
            ],
            [
              17.47,
              -8.07
            ],
            [
              18.14,
              -7.99
            ],
            [
              18.46,
              -7.85
            ],
            [
              19.02,
              -7.99
            ],
            [
              19.17,
              -7.74
            ],
            [
              19.42,
              -7.16
            ],
            [
              20.04,
              -7.12
            ],
            [
              20.09,
              -6.94
            ],
            [
              20.6,
              -6.94
            ],
            [
              20.51,
              -7.3
            ],
            [
              21.73,
              -7.29
            ],
            [
              21.75,
              -7.92
            ],
            [
              21.95,
              -8.31
            ],
            [
              21.8,
              -8.91
            ],
            [
              21.88,
              -9.52
            ],
            [
              22.21,
              -9.89
            ],
            [
              22.16,
              -11.08
            ],
            [
              22.4,
              -10.99
            ],
            [
              22.84,
              -11.02
            ],
            [
              23.46,
              -10.87
            ],
            [
              23.91,
              -10.93
            ],
            [
              24.02,
              -11.24
            ],
            [
              23.9,
              -11.72
            ],
            [
              24.08,
              -12.19
            ],
            [
              23.93,
              -12.57
            ],
            [
              24.02,
              -12.91
            ],
            [
              21.93,
              -12.9
            ],
            [
              21.89,
              -16.08
            ],
            [
              22.56,
              -16.9
            ],
            [
              23.21,
              -17.52
            ],
            [
              21.38,
              -17.93
            ],
            [
              18.96,
              -17.79
            ],
            [
              18.26,
              -17.31
            ],
            [
              14.21,
              -17.35
            ],
            [
              14.06,
              -17.42
            ],
            [
              13.46,
              -16.97
            ],
            [
              12.81,
              -16.94
            ],
            [
              12.22,
              -17.11
            ],
            [
              11.73,
              -17.3
            ],
            [
              11.64,
              -16.67
            ],
            [
              11.78,
              -15.79
            ],
            [
              12.12,
              -14.88
            ],
            [
              12.18,
              -14.45
            ],
            [
              12.5,
              -13.55
            ],
            [
              12.74,
              -13.14
            ],
            [
              13.31,
              -12.48
            ],
            [
              13.64,
              -12.04
            ],
            [
              13.74,
              -11.3
            ],
            [
              13.69,
              -10.73
            ],
            [
              13.39,
              -10.37
            ],
            [
              13.12,
              -9.77
            ],
            [
              12.88,
              -9.17
            ],
            [
              12.93,
              -8.96
            ],
            [
              13.24,
              -8.56
            ],
            [
              12.93,
              -7.6
            ],
            [
              12.73,
              -6.93
            ],
            [
              12.23,
              -6.29
            ],
            [
              12.32,
              -6.1
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Burundi"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            30.47,
            -2.41
          ],
          [
            30.53,
            -2.81
          ],
          [
            30.74,
            -3.03
          ],
          [
            30.75,
            -3.36
          ],
          [
            30.5,
            -3.57
          ],
          [
            30.12,
            -4.09
          ],
          [
            29.75,
            -4.45
          ],
          [
            29.34,
            -4.5
          ],
          [
            29.28,
            -3.29
          ],
          [
            29.03,
            -2.84
          ],
          [
            29.63,
            -2.92
          ],
          [
            29.94,
            -2.35
          ],
          [
            30.47,
            -2.41
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Israel"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            35.72,
            32.71
          ],
          [
            35.54,
            32.39
          ],
          [
            35.18,
            32.53
          ],
          [
            34.98,
            31.87
          ],
          [
            35.22,
            31.75
          ],
          [
            34.97,
            31.62
          ],
          [
            34.93,
            31.35
          ],
          [
            35.4,
            31.49
          ],
          [
            35.42,
            31.1
          ],
          [
            34.92,
            29.5
          ],
          [
            34.82,
            29.76
          ],
          [
            34.27,
            31.22
          ],
          [
            34.55,
            31.55
          ],
          [
            34.49,
            31.61
          ],
          [
            34.75,
            32.07
          ],
          [
            34.95,
            32.83
          ],
          [
            35.1,
            33.08
          ],
          [
            35.13,
            33.09
          ],
          [
            35.46,
            33.09
          ],
          [
            35.55,
            33.26
          ],
          [
            35.82,
            33.28
          ],
          [
            35.84,
            32.87
          ],
          [
            35.7,
            32.72
          ],
          [
            35.72,
            32.71
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Lebanon"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            35.82,
            33.28
          ],
          [
            35.55,
            33.26
          ],
          [
            35.46,
            33.09
          ],
          [
            35.13,
            33.09
          ],
          [
            35.48,
            33.91
          ],
          [
            35.98,
            34.61
          ],
          [
            36,
            34.65
          ],
          [
            36.45,
            34.59
          ],
          [
            36.61,
            34.2
          ],
          [
            36.07,
            33.82
          ],
          [
            35.82,
            33.28
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Madagascar"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            49.54,
            -12.47
          ],
          [
            49.81,
            -12.9
          ],
          [
            50.06,
            -13.56
          ],
          [
            50.22,
            -14.76
          ],
          [
            50.48,
            -15.23
          ],
          [
            50.38,
            -15.71
          ],
          [
            50.2,
            -16
          ],
          [
            49.86,
            -15.41
          ],
          [
            49.67,
            -15.71
          ],
          [
            49.86,
            -16.45
          ],
          [
            49.78,
            -16.87
          ],
          [
            49.5,
            -17.11
          ],
          [
            49.43,
            -17.95
          ],
          [
            49.04,
            -19.12
          ],
          [
            48.55,
            -20.5
          ],
          [
            47.93,
            -22.39
          ],
          [
            47.55,
            -23.78
          ],
          [
            47.1,
            -24.94
          ],
          [
            46.28,
            -25.18
          ],
          [
            45.41,
            -25.6
          ],
          [
            44.83,
            -25.35
          ],
          [
            44.04,
            -24.99
          ],
          [
            43.76,
            -24.46
          ],
          [
            43.7,
            -23.57
          ],
          [
            43.35,
            -22.78
          ],
          [
            43.25,
            -22.06
          ],
          [
            43.43,
            -21.34
          ],
          [
            43.89,
            -21.16
          ],
          [
            43.9,
            -20.83
          ],
          [
            44.38,
            -20.07
          ],
          [
            44.47,
            -19.44
          ],
          [
            44.23,
            -18.96
          ],
          [
            44.04,
            -18.33
          ],
          [
            43.96,
            -17.41
          ],
          [
            44.31,
            -16.85
          ],
          [
            44.45,
            -16.22
          ],
          [
            44.94,
            -16.18
          ],
          [
            45.5,
            -15.97
          ],
          [
            45.87,
            -15.79
          ],
          [
            46.31,
            -15.78
          ],
          [
            46.88,
            -15.21
          ],
          [
            47.71,
            -14.59
          ],
          [
            48,
            -14.09
          ],
          [
            47.87,
            -13.66
          ],
          [
            48.29,
            -13.78
          ],
          [
            48.84,
            -13.09
          ],
          [
            48.87,
            -12.49
          ],
          [
            49.2,
            -12.04
          ],
          [
            49.54,
            -12.47
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Palestine"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            35.4,
            31.49
          ],
          [
            34.93,
            31.35
          ],
          [
            34.97,
            31.62
          ],
          [
            35.22,
            31.75
          ],
          [
            34.98,
            31.87
          ],
          [
            35.18,
            32.53
          ],
          [
            35.54,
            32.39
          ],
          [
            35.54,
            31.78
          ],
          [
            35.4,
            31.49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Gambia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -16.71,
            13.6
          ],
          [
            -15.63,
            13.62
          ],
          [
            -15.4,
            13.86
          ],
          [
            -15.08,
            13.88
          ],
          [
            -14.69,
            13.63
          ],
          [
            -14.38,
            13.63
          ],
          [
            -14.05,
            13.79
          ],
          [
            -13.84,
            13.51
          ],
          [
            -14.28,
            13.28
          ],
          [
            -14.71,
            13.3
          ],
          [
            -15.14,
            13.51
          ],
          [
            -15.51,
            13.28
          ],
          [
            -15.69,
            13.27
          ],
          [
            -15.93,
            13.13
          ],
          [
            -16.84,
            13.15
          ],
          [
            -16.71,
            13.6
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Tunisia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            9.48,
            30.31
          ],
          [
            9.06,
            32.1
          ],
          [
            8.44,
            32.51
          ],
          [
            8.43,
            32.75
          ],
          [
            7.61,
            33.34
          ],
          [
            7.53,
            34.1
          ],
          [
            8.14,
            34.66
          ],
          [
            8.38,
            35.48
          ],
          [
            8.22,
            36.43
          ],
          [
            8.42,
            36.95
          ],
          [
            9.51,
            37.35
          ],
          [
            10.21,
            37.23
          ],
          [
            10.18,
            36.72
          ],
          [
            11.03,
            37.09
          ],
          [
            11.1,
            36.9
          ],
          [
            10.6,
            36.41
          ],
          [
            10.59,
            35.95
          ],
          [
            10.94,
            35.7
          ],
          [
            10.81,
            34.83
          ],
          [
            10.15,
            34.33
          ],
          [
            10.34,
            33.79
          ],
          [
            10.86,
            33.77
          ],
          [
            11.11,
            33.29
          ],
          [
            11.49,
            33.14
          ],
          [
            11.43,
            32.37
          ],
          [
            10.95,
            32.08
          ],
          [
            10.64,
            31.76
          ],
          [
            9.95,
            31.38
          ],
          [
            10.06,
            30.96
          ],
          [
            9.97,
            30.54
          ],
          [
            9.48,
            30.31
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Algeria"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -8.69,
            27.4
          ],
          [
            -8.66,
            27.59
          ],
          [
            -8.67,
            27.66
          ],
          [
            -8.67,
            28.84
          ],
          [
            -7.06,
            29.58
          ],
          [
            -6.06,
            29.73
          ],
          [
            -5.24,
            30
          ],
          [
            -4.86,
            30.5
          ],
          [
            -3.69,
            30.9
          ],
          [
            -3.65,
            31.64
          ],
          [
            -3.07,
            31.72
          ],
          [
            -2.62,
            32.09
          ],
          [
            -1.31,
            32.26
          ],
          [
            -1.13,
            32.65
          ],
          [
            -1.39,
            32.86
          ],
          [
            -1.73,
            33.92
          ],
          [
            -1.79,
            34.53
          ],
          [
            -2.17,
            35.17
          ],
          [
            -1.21,
            35.72
          ],
          [
            -0.13,
            35.89
          ],
          [
            0.5,
            36.3
          ],
          [
            1.47,
            36.61
          ],
          [
            3.16,
            36.78
          ],
          [
            4.82,
            36.86
          ],
          [
            5.32,
            36.72
          ],
          [
            6.26,
            37.11
          ],
          [
            7.33,
            37.12
          ],
          [
            7.74,
            36.89
          ],
          [
            8.42,
            36.95
          ],
          [
            8.22,
            36.43
          ],
          [
            8.38,
            35.48
          ],
          [
            8.14,
            34.66
          ],
          [
            7.53,
            34.1
          ],
          [
            7.61,
            33.34
          ],
          [
            8.43,
            32.75
          ],
          [
            8.44,
            32.51
          ],
          [
            9.06,
            32.1
          ],
          [
            9.48,
            30.31
          ],
          [
            9.8,
            29.42
          ],
          [
            9.86,
            28.96
          ],
          [
            9.68,
            28.14
          ],
          [
            9.76,
            27.69
          ],
          [
            9.63,
            27.14
          ],
          [
            9.71,
            26.51
          ],
          [
            9.32,
            26.09
          ],
          [
            9.91,
            25.37
          ],
          [
            9.95,
            24.94
          ],
          [
            10.31,
            24.38
          ],
          [
            10.77,
            24.56
          ],
          [
            11.56,
            24.1
          ],
          [
            12,
            23.47
          ],
          [
            8.57,
            21.57
          ],
          [
            5.68,
            19.6
          ],
          [
            4.27,
            19.16
          ],
          [
            3.16,
            19.06
          ],
          [
            3.15,
            19.69
          ],
          [
            2.68,
            19.86
          ],
          [
            2.06,
            20.14
          ],
          [
            1.82,
            20.61
          ],
          [
            -1.55,
            22.79
          ],
          [
            -4.92,
            24.97
          ],
          [
            -8.69,
            27.4
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Jordan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            35.54,
            32.39
          ],
          [
            35.72,
            32.71
          ],
          [
            36.83,
            32.31
          ],
          [
            38.79,
            33.38
          ],
          [
            39.2,
            32.16
          ],
          [
            39,
            32.01
          ],
          [
            37,
            31.51
          ],
          [
            38,
            30.51
          ],
          [
            37.67,
            30.34
          ],
          [
            37.5,
            30
          ],
          [
            36.74,
            29.87
          ],
          [
            36.5,
            29.51
          ],
          [
            36.07,
            29.2
          ],
          [
            34.95,
            29.36
          ],
          [
            34.92,
            29.5
          ],
          [
            35.42,
            31.1
          ],
          [
            35.4,
            31.49
          ],
          [
            35.54,
            31.78
          ],
          [
            35.54,
            32.39
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "United Arab Emirates"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            51.58,
            24.24
          ],
          [
            51.76,
            24.29
          ],
          [
            51.8,
            24.02
          ],
          [
            52.58,
            24.18
          ],
          [
            53.4,
            24.15
          ],
          [
            54.01,
            24.12
          ],
          [
            54.69,
            24.8
          ],
          [
            55.44,
            25.44
          ],
          [
            56.07,
            26.06
          ],
          [
            56.26,
            25.71
          ],
          [
            56.4,
            24.93
          ],
          [
            55.89,
            24.92
          ],
          [
            55.8,
            24.27
          ],
          [
            55.98,
            24.13
          ],
          [
            55.53,
            23.93
          ],
          [
            55.53,
            23.53
          ],
          [
            55.23,
            23.11
          ],
          [
            55.21,
            22.71
          ],
          [
            55.01,
            22.5
          ],
          [
            52,
            23
          ],
          [
            51.62,
            24.01
          ],
          [
            51.58,
            24.24
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Qatar"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            50.81,
            24.75
          ],
          [
            50.74,
            25.48
          ],
          [
            51.01,
            26.01
          ],
          [
            51.29,
            26.12
          ],
          [
            51.59,
            25.8
          ],
          [
            51.61,
            25.22
          ],
          [
            51.39,
            24.63
          ],
          [
            51.11,
            24.56
          ],
          [
            50.81,
            24.75
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kuwait"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            47.98,
            29.98
          ],
          [
            48.18,
            29.53
          ],
          [
            48.09,
            29.31
          ],
          [
            48.42,
            28.55
          ],
          [
            47.71,
            28.53
          ],
          [
            47.46,
            29
          ],
          [
            46.57,
            29.1
          ],
          [
            47.3,
            30.06
          ],
          [
            47.98,
            29.98
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Iraq"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            39.2,
            32.16
          ],
          [
            38.79,
            33.38
          ],
          [
            41.01,
            34.42
          ],
          [
            41.38,
            35.63
          ],
          [
            41.29,
            36.36
          ],
          [
            41.84,
            36.61
          ],
          [
            42.35,
            37.23
          ],
          [
            42.78,
            37.39
          ],
          [
            43.94,
            37.26
          ],
          [
            44.29,
            37
          ],
          [
            44.77,
            37.17
          ],
          [
            45.42,
            35.98
          ],
          [
            46.08,
            35.68
          ],
          [
            46.15,
            35.09
          ],
          [
            45.65,
            34.75
          ],
          [
            45.42,
            33.97
          ],
          [
            46.11,
            33.02
          ],
          [
            47.34,
            32.47
          ],
          [
            47.85,
            31.71
          ],
          [
            47.68,
            30.98
          ],
          [
            48,
            30.98
          ],
          [
            48.02,
            30.45
          ],
          [
            48.57,
            29.93
          ],
          [
            47.98,
            29.98
          ],
          [
            47.3,
            30.06
          ],
          [
            46.57,
            29.1
          ],
          [
            44.71,
            29.18
          ],
          [
            41.89,
            31.19
          ],
          [
            40.4,
            31.89
          ],
          [
            39.2,
            32.16
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Oman"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              55.21,
              22.71
            ],
            [
              55.23,
              23.11
            ],
            [
              55.53,
              23.53
            ],
            [
              55.53,
              23.93
            ],
            [
              55.98,
              24.13
            ],
            [
              55.8,
              24.27
            ],
            [
              55.89,
              24.92
            ],
            [
              56.4,
              24.93
            ],
            [
              56.85,
              24.24
            ],
            [
              57.4,
              23.88
            ],
            [
              58.14,
              23.75
            ],
            [
              58.73,
              23.57
            ],
            [
              59.18,
              22.99
            ],
            [
              59.45,
              22.66
            ],
            [
              59.81,
              22.53
            ],
            [
              59.81,
              22.31
            ],
            [
              59.44,
              21.71
            ],
            [
              59.28,
              21.43
            ],
            [
              58.86,
              21.11
            ],
            [
              58.49,
              20.43
            ],
            [
              58.03,
              20.48
            ],
            [
              57.83,
              20.24
            ],
            [
              57.67,
              19.74
            ],
            [
              57.79,
              19.07
            ],
            [
              57.7,
              18.95
            ],
            [
              57.24,
              18.95
            ],
            [
              56.61,
              18.57
            ],
            [
              56.51,
              18.09
            ],
            [
              56.28,
              17.88
            ],
            [
              55.66,
              17.88
            ],
            [
              55.27,
              17.63
            ],
            [
              55.27,
              17.23
            ],
            [
              54.79,
              16.95
            ],
            [
              54.24,
              17.04
            ],
            [
              53.57,
              16.71
            ],
            [
              53.11,
              16.65
            ],
            [
              52.78,
              17.35
            ],
            [
              52,
              19
            ],
            [
              55,
              20
            ],
            [
              55.67,
              22
            ],
            [
              55.21,
              22.71
            ]
          ]
        ],
        [
          [
            [
              56.26,
              25.71
            ],
            [
              56.07,
              26.06
            ],
            [
              56.36,
              26.4
            ],
            [
              56.49,
              26.31
            ],
            [
              56.39,
              25.9
            ],
            [
              56.26,
              25.71
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Vanuatu"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              167.22,
              -15.89
            ],
            [
              167.85,
              -16.47
            ],
            [
              167.52,
              -16.6
            ],
            [
              167.18,
              -16.16
            ],
            [
              167.22,
              -15.89
            ]
          ]
        ],
        [
          [
            [
              166.79,
              -15.67
            ],
            [
              166.65,
              -15.39
            ],
            [
              166.63,
              -14.63
            ],
            [
              167.11,
              -14.93
            ],
            [
              167.27,
              -15.74
            ],
            [
              167,
              -15.61
            ],
            [
              166.79,
              -15.67
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Cambodia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            102.58,
            12.19
          ],
          [
            102.35,
            13.39
          ],
          [
            102.99,
            14.23
          ],
          [
            104.28,
            14.42
          ],
          [
            105.22,
            14.27
          ],
          [
            106.04,
            13.88
          ],
          [
            106.5,
            14.57
          ],
          [
            107.38,
            14.2
          ],
          [
            107.61,
            13.54
          ],
          [
            107.49,
            12.34
          ],
          [
            105.81,
            11.57
          ],
          [
            106.25,
            10.96
          ],
          [
            105.2,
            10.89
          ],
          [
            104.33,
            10.49
          ],
          [
            103.5,
            10.63
          ],
          [
            103.09,
            11.15
          ],
          [
            102.58,
            12.19
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Thailand"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            105.22,
            14.27
          ],
          [
            104.28,
            14.42
          ],
          [
            102.99,
            14.23
          ],
          [
            102.35,
            13.39
          ],
          [
            102.58,
            12.19
          ],
          [
            101.69,
            12.65
          ],
          [
            100.83,
            12.63
          ],
          [
            100.98,
            13.41
          ],
          [
            100.1,
            13.41
          ],
          [
            100.02,
            12.31
          ],
          [
            99.48,
            10.85
          ],
          [
            99.15,
            9.96
          ],
          [
            99.22,
            9.24
          ],
          [
            99.87,
            9.21
          ],
          [
            100.28,
            8.3
          ],
          [
            100.46,
            7.43
          ],
          [
            101.02,
            6.86
          ],
          [
            101.62,
            6.74
          ],
          [
            102.14,
            6.22
          ],
          [
            101.81,
            5.81
          ],
          [
            101.16,
            5.69
          ],
          [
            101.08,
            6.21
          ],
          [
            100.26,
            6.64
          ],
          [
            100.09,
            6.46
          ],
          [
            99.69,
            6.85
          ],
          [
            99.52,
            7.34
          ],
          [
            98.99,
            7.91
          ],
          [
            98.5,
            8.38
          ],
          [
            98.34,
            7.79
          ],
          [
            98.15,
            8.35
          ],
          [
            98.26,
            8.97
          ],
          [
            98.55,
            9.93
          ],
          [
            99.04,
            10.96
          ],
          [
            99.59,
            11.89
          ],
          [
            99.2,
            12.8
          ],
          [
            99.21,
            13.27
          ],
          [
            99.1,
            13.83
          ],
          [
            98.43,
            14.62
          ],
          [
            98.19,
            15.12
          ],
          [
            98.54,
            15.31
          ],
          [
            98.9,
            16.18
          ],
          [
            98.5,
            16.84
          ],
          [
            97.86,
            17.57
          ],
          [
            97.38,
            18.45
          ],
          [
            97.8,
            18.63
          ],
          [
            98.25,
            19.71
          ],
          [
            98.96,
            19.75
          ],
          [
            99.54,
            20.19
          ],
          [
            100.12,
            20.42
          ],
          [
            100.55,
            20.11
          ],
          [
            100.6,
            19.51
          ],
          [
            101.28,
            19.46
          ],
          [
            101.04,
            18.41
          ],
          [
            101.06,
            17.51
          ],
          [
            102.11,
            18.11
          ],
          [
            102.41,
            17.93
          ],
          [
            103,
            17.96
          ],
          [
            103.2,
            18.31
          ],
          [
            103.96,
            18.24
          ],
          [
            104.72,
            17.43
          ],
          [
            104.78,
            16.44
          ],
          [
            105.59,
            15.57
          ],
          [
            105.54,
            14.72
          ],
          [
            105.22,
            14.27
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Laos"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            107.38,
            14.2
          ],
          [
            106.5,
            14.57
          ],
          [
            106.04,
            13.88
          ],
          [
            105.22,
            14.27
          ],
          [
            105.54,
            14.72
          ],
          [
            105.59,
            15.57
          ],
          [
            104.78,
            16.44
          ],
          [
            104.72,
            17.43
          ],
          [
            103.96,
            18.24
          ],
          [
            103.2,
            18.31
          ],
          [
            103,
            17.96
          ],
          [
            102.41,
            17.93
          ],
          [
            102.11,
            18.11
          ],
          [
            101.06,
            17.51
          ],
          [
            101.04,
            18.41
          ],
          [
            101.28,
            19.46
          ],
          [
            100.6,
            19.51
          ],
          [
            100.55,
            20.11
          ],
          [
            100.12,
            20.42
          ],
          [
            100.33,
            20.79
          ],
          [
            101.18,
            21.44
          ],
          [
            101.27,
            21.2
          ],
          [
            101.8,
            21.17
          ],
          [
            101.65,
            22.32
          ],
          [
            102.17,
            22.46
          ],
          [
            102.75,
            21.68
          ],
          [
            103.2,
            20.77
          ],
          [
            104.44,
            20.76
          ],
          [
            104.82,
            19.89
          ],
          [
            104.18,
            19.62
          ],
          [
            103.9,
            19.27
          ],
          [
            105.09,
            18.67
          ],
          [
            105.93,
            17.48
          ],
          [
            106.56,
            16.6
          ],
          [
            107.31,
            15.91
          ],
          [
            107.56,
            15.2
          ],
          [
            107.38,
            14.2
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Myanmar"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            100.12,
            20.42
          ],
          [
            99.54,
            20.19
          ],
          [
            98.96,
            19.75
          ],
          [
            98.25,
            19.71
          ],
          [
            97.8,
            18.63
          ],
          [
            97.38,
            18.45
          ],
          [
            97.86,
            17.57
          ],
          [
            98.5,
            16.84
          ],
          [
            98.9,
            16.18
          ],
          [
            98.54,
            15.31
          ],
          [
            98.19,
            15.12
          ],
          [
            98.43,
            14.62
          ],
          [
            99.1,
            13.83
          ],
          [
            99.21,
            13.27
          ],
          [
            99.2,
            12.8
          ],
          [
            99.59,
            11.89
          ],
          [
            99.04,
            10.96
          ],
          [
            98.55,
            9.93
          ],
          [
            98.46,
            10.68
          ],
          [
            98.77,
            11.44
          ],
          [
            98.43,
            12.03
          ],
          [
            98.51,
            13.12
          ],
          [
            98.1,
            13.64
          ],
          [
            97.78,
            14.84
          ],
          [
            97.6,
            16.1
          ],
          [
            97.16,
            16.93
          ],
          [
            96.5,
            16.43
          ],
          [
            95.37,
            15.71
          ],
          [
            94.81,
            15.8
          ],
          [
            94.19,
            16.04
          ],
          [
            94.54,
            17.28
          ],
          [
            94.33,
            18.21
          ],
          [
            93.54,
            19.37
          ],
          [
            93.66,
            19.73
          ],
          [
            93.08,
            19.86
          ],
          [
            92.37,
            20.67
          ],
          [
            92.3,
            21.48
          ],
          [
            92.65,
            21.32
          ],
          [
            92.67,
            22.04
          ],
          [
            93.17,
            22.28
          ],
          [
            93.06,
            22.7
          ],
          [
            93.29,
            23.04
          ],
          [
            93.33,
            24.08
          ],
          [
            94.11,
            23.85
          ],
          [
            94.55,
            24.67
          ],
          [
            94.6,
            25.16
          ],
          [
            95.15,
            26
          ],
          [
            95.13,
            26.57
          ],
          [
            96.42,
            27.26
          ],
          [
            97.13,
            27.08
          ],
          [
            97.05,
            27.7
          ],
          [
            97.4,
            27.88
          ],
          [
            97.33,
            28.26
          ],
          [
            97.91,
            28.34
          ],
          [
            98.25,
            27.75
          ],
          [
            98.68,
            27.51
          ],
          [
            98.71,
            26.74
          ],
          [
            98.67,
            25.92
          ],
          [
            97.72,
            25.08
          ],
          [
            97.61,
            23.9
          ],
          [
            98.66,
            24.06
          ],
          [
            98.9,
            23.14
          ],
          [
            99.53,
            22.95
          ],
          [
            99.24,
            22.12
          ],
          [
            99.98,
            21.74
          ],
          [
            100.42,
            21.56
          ],
          [
            101.15,
            21.85
          ],
          [
            101.18,
            21.44
          ],
          [
            100.33,
            20.79
          ],
          [
            100.12,
            20.42
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Vietnam"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            104.33,
            10.49
          ],
          [
            105.2,
            10.89
          ],
          [
            106.25,
            10.96
          ],
          [
            105.81,
            11.57
          ],
          [
            107.49,
            12.34
          ],
          [
            107.61,
            13.54
          ],
          [
            107.38,
            14.2
          ],
          [
            107.56,
            15.2
          ],
          [
            107.31,
            15.91
          ],
          [
            106.56,
            16.6
          ],
          [
            105.93,
            17.48
          ],
          [
            105.09,
            18.67
          ],
          [
            103.9,
            19.27
          ],
          [
            104.18,
            19.62
          ],
          [
            104.82,
            19.89
          ],
          [
            104.44,
            20.76
          ],
          [
            103.2,
            20.77
          ],
          [
            102.75,
            21.68
          ],
          [
            102.17,
            22.46
          ],
          [
            102.71,
            22.71
          ],
          [
            103.5,
            22.7
          ],
          [
            104.48,
            22.82
          ],
          [
            105.33,
            23.35
          ],
          [
            105.81,
            22.98
          ],
          [
            106.72,
            22.79
          ],
          [
            106.57,
            22.22
          ],
          [
            107.04,
            21.81
          ],
          [
            108.05,
            21.55
          ],
          [
            106.71,
            20.7
          ],
          [
            105.88,
            19.75
          ],
          [
            105.66,
            19.06
          ],
          [
            106.43,
            18
          ],
          [
            107.36,
            16.7
          ],
          [
            108.27,
            16.08
          ],
          [
            108.88,
            15.28
          ],
          [
            109.33,
            13.43
          ],
          [
            109.2,
            11.67
          ],
          [
            108.37,
            11.01
          ],
          [
            107.22,
            10.36
          ],
          [
            106.4,
            9.53
          ],
          [
            105.16,
            8.6
          ],
          [
            104.8,
            9.24
          ],
          [
            105.08,
            9.92
          ],
          [
            104.33,
            10.49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "North Korea"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              130.78,
              42.22
            ],
            [
              130.78,
              42.22
            ],
            [
              130.78,
              42.22
            ],
            [
              130.78,
              42.22
            ]
          ]
        ],
        [
          [
            [
              130.64,
              42.4
            ],
            [
              130.78,
              42.22
            ],
            [
              130.4,
              42.28
            ],
            [
              129.97,
              41.94
            ],
            [
              129.67,
              41.6
            ],
            [
              129.7,
              40.88
            ],
            [
              129.19,
              40.66
            ],
            [
              129.01,
              40.48
            ],
            [
              128.63,
              40.19
            ],
            [
              127.97,
              40.03
            ],
            [
              127.53,
              39.76
            ],
            [
              127.5,
              39.32
            ],
            [
              127.39,
              39.21
            ],
            [
              127.79,
              39.05
            ],
            [
              128.35,
              38.61
            ],
            [
              128.21,
              38.37
            ],
            [
              127.78,
              38.3
            ],
            [
              127.07,
              38.26
            ],
            [
              126.68,
              37.81
            ],
            [
              126.24,
              37.84
            ],
            [
              126.18,
              37.75
            ],
            [
              125.69,
              37.94
            ],
            [
              125.57,
              37.75
            ],
            [
              125.28,
              37.67
            ],
            [
              125.24,
              37.86
            ],
            [
              124.98,
              37.95
            ],
            [
              124.71,
              38.11
            ],
            [
              124.98,
              38.55
            ],
            [
              125.22,
              38.67
            ],
            [
              125.13,
              38.85
            ],
            [
              125.39,
              39.39
            ],
            [
              125.32,
              39.55
            ],
            [
              124.74,
              39.66
            ],
            [
              124.26,
              39.93
            ],
            [
              125.08,
              40.57
            ],
            [
              126.18,
              41.11
            ],
            [
              126.87,
              41.82
            ],
            [
              127.34,
              41.5
            ],
            [
              128.21,
              41.47
            ],
            [
              128.05,
              41.99
            ],
            [
              129.6,
              42.42
            ],
            [
              130,
              42.98
            ],
            [
              130.64,
              42.4
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "South Korea"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            126.18,
            37.75
          ],
          [
            126.24,
            37.84
          ],
          [
            126.68,
            37.81
          ],
          [
            127.07,
            38.26
          ],
          [
            127.78,
            38.3
          ],
          [
            128.21,
            38.37
          ],
          [
            128.35,
            38.61
          ],
          [
            129.21,
            37.43
          ],
          [
            129.46,
            36.78
          ],
          [
            129.47,
            35.63
          ],
          [
            129.09,
            35.08
          ],
          [
            128.18,
            34.89
          ],
          [
            127.39,
            34.48
          ],
          [
            126.49,
            34.39
          ],
          [
            126.37,
            34.93
          ],
          [
            126.56,
            35.68
          ],
          [
            126.12,
            36.73
          ],
          [
            126.86,
            36.89
          ],
          [
            126.18,
            37.75
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mongolia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            87.75,
            49.3
          ],
          [
            88.8,
            49.47
          ],
          [
            90.71,
            50.33
          ],
          [
            92.23,
            50.8
          ],
          [
            93.11,
            50.49
          ],
          [
            94.15,
            50.48
          ],
          [
            94.82,
            50.01
          ],
          [
            95.81,
            49.98
          ],
          [
            97.26,
            49.73
          ],
          [
            98.23,
            50.42
          ],
          [
            97.83,
            51.01
          ],
          [
            98.86,
            52.05
          ],
          [
            99.98,
            51.63
          ],
          [
            100.89,
            51.52
          ],
          [
            102.07,
            51.26
          ],
          [
            102.26,
            50.51
          ],
          [
            103.68,
            50.09
          ],
          [
            104.62,
            50.27
          ],
          [
            105.89,
            50.41
          ],
          [
            106.89,
            50.27
          ],
          [
            107.87,
            49.79
          ],
          [
            108.47,
            49.28
          ],
          [
            109.4,
            49.29
          ],
          [
            110.66,
            49.13
          ],
          [
            111.58,
            49.38
          ],
          [
            112.9,
            49.54
          ],
          [
            114.36,
            50.25
          ],
          [
            114.96,
            50.14
          ],
          [
            115.49,
            49.81
          ],
          [
            116.68,
            49.89
          ],
          [
            116.19,
            49.13
          ],
          [
            115.48,
            48.14
          ],
          [
            115.74,
            47.73
          ],
          [
            116.31,
            47.85
          ],
          [
            117.29,
            47.7
          ],
          [
            118.06,
            48.07
          ],
          [
            118.87,
            47.75
          ],
          [
            119.77,
            47.05
          ],
          [
            119.66,
            46.69
          ],
          [
            118.87,
            46.8
          ],
          [
            117.42,
            46.67
          ],
          [
            116.72,
            46.39
          ],
          [
            115.98,
            45.73
          ],
          [
            114.46,
            45.34
          ],
          [
            113.46,
            44.81
          ],
          [
            112.43,
            45.01
          ],
          [
            111.87,
            45.1
          ],
          [
            111.35,
            44.46
          ],
          [
            111.67,
            44.07
          ],
          [
            111.83,
            43.74
          ],
          [
            111.13,
            43.41
          ],
          [
            110.41,
            42.87
          ],
          [
            109.24,
            42.52
          ],
          [
            107.74,
            42.48
          ],
          [
            106.13,
            42.14
          ],
          [
            104.96,
            41.6
          ],
          [
            104.52,
            41.91
          ],
          [
            103.31,
            41.91
          ],
          [
            101.83,
            42.51
          ],
          [
            100.85,
            42.66
          ],
          [
            99.52,
            42.52
          ],
          [
            97.45,
            42.75
          ],
          [
            96.35,
            42.73
          ],
          [
            95.76,
            43.32
          ],
          [
            95.31,
            44.24
          ],
          [
            94.69,
            44.35
          ],
          [
            93.48,
            44.98
          ],
          [
            92.13,
            45.12
          ],
          [
            90.95,
            45.29
          ],
          [
            90.59,
            45.72
          ],
          [
            90.97,
            46.89
          ],
          [
            90.28,
            47.69
          ],
          [
            88.85,
            48.07
          ],
          [
            88.02,
            48.6
          ],
          [
            87.75,
            49.3
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "India"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            97.33,
            28.26
          ],
          [
            97.4,
            27.88
          ],
          [
            97.05,
            27.7
          ],
          [
            97.13,
            27.08
          ],
          [
            96.42,
            27.26
          ],
          [
            95.13,
            26.57
          ],
          [
            95.15,
            26
          ],
          [
            94.6,
            25.16
          ],
          [
            94.55,
            24.67
          ],
          [
            94.11,
            23.85
          ],
          [
            93.33,
            24.08
          ],
          [
            93.29,
            23.04
          ],
          [
            93.06,
            22.7
          ],
          [
            93.17,
            22.28
          ],
          [
            92.67,
            22.04
          ],
          [
            92.14,
            23.63
          ],
          [
            91.87,
            23.62
          ],
          [
            91.71,
            22.99
          ],
          [
            91.16,
            23.5
          ],
          [
            91.47,
            24.07
          ],
          [
            91.91,
            24.13
          ],
          [
            92.38,
            24.98
          ],
          [
            91.8,
            25.15
          ],
          [
            90.87,
            25.13
          ],
          [
            89.92,
            25.27
          ],
          [
            89.83,
            25.96
          ],
          [
            89.35,
            26.02
          ],
          [
            88.56,
            26.45
          ],
          [
            88.21,
            25.77
          ],
          [
            88.93,
            25.24
          ],
          [
            88.31,
            24.87
          ],
          [
            88.08,
            24.5
          ],
          [
            88.7,
            24.23
          ],
          [
            88.53,
            23.63
          ],
          [
            88.88,
            22.88
          ],
          [
            89.03,
            22.06
          ],
          [
            88.89,
            21.69
          ],
          [
            88.21,
            21.7
          ],
          [
            86.98,
            21.5
          ],
          [
            87.03,
            20.74
          ],
          [
            86.5,
            20.15
          ],
          [
            85.06,
            19.48
          ],
          [
            83.94,
            18.3
          ],
          [
            83.19,
            17.67
          ],
          [
            82.19,
            17.02
          ],
          [
            82.19,
            16.56
          ],
          [
            81.69,
            16.31
          ],
          [
            80.79,
            15.95
          ],
          [
            80.33,
            15.9
          ],
          [
            80.02,
            15.14
          ],
          [
            80.23,
            13.84
          ],
          [
            80.29,
            13.01
          ],
          [
            79.86,
            12.06
          ],
          [
            79.86,
            10.36
          ],
          [
            79.34,
            10.31
          ],
          [
            78.89,
            9.55
          ],
          [
            79.19,
            9.22
          ],
          [
            78.28,
            8.93
          ],
          [
            77.94,
            8.25
          ],
          [
            77.54,
            7.97
          ],
          [
            76.59,
            8.9
          ],
          [
            76.13,
            10.3
          ],
          [
            75.75,
            11.31
          ],
          [
            75.4,
            11.78
          ],
          [
            74.86,
            12.74
          ],
          [
            74.62,
            13.99
          ],
          [
            74.44,
            14.62
          ],
          [
            73.53,
            15.99
          ],
          [
            73.12,
            17.93
          ],
          [
            72.82,
            19.21
          ],
          [
            72.82,
            20.42
          ],
          [
            72.63,
            21.36
          ],
          [
            71.17,
            20.76
          ],
          [
            70.47,
            20.88
          ],
          [
            69.17,
            22.09
          ],
          [
            69.64,
            22.45
          ],
          [
            69.35,
            22.84
          ],
          [
            68.18,
            23.69
          ],
          [
            68.84,
            24.36
          ],
          [
            71.04,
            24.36
          ],
          [
            70.84,
            25.21
          ],
          [
            70.28,
            25.72
          ],
          [
            70.17,
            26.49
          ],
          [
            69.51,
            26.94
          ],
          [
            70.62,
            27.99
          ],
          [
            71.78,
            27.91
          ],
          [
            72.82,
            28.96
          ],
          [
            73.45,
            29.98
          ],
          [
            74.42,
            30.98
          ],
          [
            74.41,
            31.69
          ],
          [
            75.26,
            32.27
          ],
          [
            74.45,
            32.77
          ],
          [
            74.1,
            33.44
          ],
          [
            73.75,
            34.32
          ],
          [
            74.24,
            34.75
          ],
          [
            75.76,
            34.51
          ],
          [
            76.87,
            34.65
          ],
          [
            77.84,
            35.49
          ],
          [
            78.91,
            34.32
          ],
          [
            78.81,
            33.51
          ],
          [
            79.21,
            32.99
          ],
          [
            79.18,
            32.48
          ],
          [
            78.46,
            32.62
          ],
          [
            78.74,
            31.52
          ],
          [
            79.72,
            30.88
          ],
          [
            81.11,
            30.18
          ],
          [
            80.48,
            29.73
          ],
          [
            80.09,
            28.79
          ],
          [
            81.06,
            28.42
          ],
          [
            82,
            27.93
          ],
          [
            83.3,
            27.36
          ],
          [
            84.67,
            27.24
          ],
          [
            85.25,
            26.73
          ],
          [
            86.02,
            26.63
          ],
          [
            87.23,
            26.4
          ],
          [
            88.06,
            26.41
          ],
          [
            88.17,
            26.81
          ],
          [
            88.04,
            27.45
          ],
          [
            88.12,
            27.88
          ],
          [
            88.73,
            28.09
          ],
          [
            88.81,
            27.3
          ],
          [
            88.84,
            27.1
          ],
          [
            89.74,
            26.72
          ],
          [
            90.37,
            26.88
          ],
          [
            91.22,
            26.81
          ],
          [
            92.03,
            26.84
          ],
          [
            92.11,
            27.45
          ],
          [
            91.7,
            27.77
          ],
          [
            92.5,
            27.9
          ],
          [
            93.41,
            28.64
          ],
          [
            94.57,
            29.28
          ],
          [
            95.41,
            29.03
          ],
          [
            96.12,
            29.45
          ],
          [
            96.59,
            28.83
          ],
          [
            96.25,
            28.41
          ],
          [
            97.33,
            28.26
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bangladesh"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            92.67,
            22.04
          ],
          [
            92.65,
            21.32
          ],
          [
            92.3,
            21.48
          ],
          [
            92.37,
            20.67
          ],
          [
            92.08,
            21.19
          ],
          [
            92.03,
            21.7
          ],
          [
            91.84,
            22.18
          ],
          [
            91.42,
            22.77
          ],
          [
            90.5,
            22.8
          ],
          [
            90.59,
            22.39
          ],
          [
            90.27,
            21.84
          ],
          [
            89.85,
            22.04
          ],
          [
            89.7,
            21.86
          ],
          [
            89.42,
            21.97
          ],
          [
            89.03,
            22.06
          ],
          [
            88.88,
            22.88
          ],
          [
            88.53,
            23.63
          ],
          [
            88.7,
            24.23
          ],
          [
            88.08,
            24.5
          ],
          [
            88.31,
            24.87
          ],
          [
            88.93,
            25.24
          ],
          [
            88.21,
            25.77
          ],
          [
            88.56,
            26.45
          ],
          [
            89.35,
            26.02
          ],
          [
            89.83,
            25.96
          ],
          [
            89.92,
            25.27
          ],
          [
            90.87,
            25.13
          ],
          [
            91.8,
            25.15
          ],
          [
            92.38,
            24.98
          ],
          [
            91.91,
            24.13
          ],
          [
            91.47,
            24.07
          ],
          [
            91.16,
            23.5
          ],
          [
            91.71,
            22.99
          ],
          [
            91.87,
            23.62
          ],
          [
            92.14,
            23.63
          ],
          [
            92.67,
            22.04
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bhutan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            91.7,
            27.77
          ],
          [
            92.11,
            27.45
          ],
          [
            92.03,
            26.84
          ],
          [
            91.22,
            26.81
          ],
          [
            90.37,
            26.88
          ],
          [
            89.74,
            26.72
          ],
          [
            88.84,
            27.1
          ],
          [
            88.81,
            27.3
          ],
          [
            89.48,
            28.04
          ],
          [
            90.02,
            28.3
          ],
          [
            90.73,
            28.06
          ],
          [
            91.26,
            28.04
          ],
          [
            91.7,
            27.77
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Nepal"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            88.12,
            27.88
          ],
          [
            88.04,
            27.45
          ],
          [
            88.17,
            26.81
          ],
          [
            88.06,
            26.41
          ],
          [
            87.23,
            26.4
          ],
          [
            86.02,
            26.63
          ],
          [
            85.25,
            26.73
          ],
          [
            84.67,
            27.24
          ],
          [
            83.3,
            27.36
          ],
          [
            82,
            27.93
          ],
          [
            81.06,
            28.42
          ],
          [
            80.09,
            28.79
          ],
          [
            80.48,
            29.73
          ],
          [
            81.11,
            30.18
          ],
          [
            81.52,
            30.42
          ],
          [
            82.33,
            30.11
          ],
          [
            83.34,
            29.46
          ],
          [
            83.9,
            29.32
          ],
          [
            84.24,
            28.84
          ],
          [
            85.01,
            28.64
          ],
          [
            85.82,
            28.2
          ],
          [
            86.95,
            27.97
          ],
          [
            88.12,
            27.88
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Pakistan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            77.84,
            35.49
          ],
          [
            76.87,
            34.65
          ],
          [
            75.76,
            34.51
          ],
          [
            74.24,
            34.75
          ],
          [
            73.75,
            34.32
          ],
          [
            74.1,
            33.44
          ],
          [
            74.45,
            32.77
          ],
          [
            75.26,
            32.27
          ],
          [
            74.41,
            31.69
          ],
          [
            74.42,
            30.98
          ],
          [
            73.45,
            29.98
          ],
          [
            72.82,
            28.96
          ],
          [
            71.78,
            27.91
          ],
          [
            70.62,
            27.99
          ],
          [
            69.51,
            26.94
          ],
          [
            70.17,
            26.49
          ],
          [
            70.28,
            25.72
          ],
          [
            70.84,
            25.21
          ],
          [
            71.04,
            24.36
          ],
          [
            68.84,
            24.36
          ],
          [
            68.18,
            23.69
          ],
          [
            67.44,
            23.95
          ],
          [
            67.15,
            24.66
          ],
          [
            66.37,
            25.42
          ],
          [
            64.53,
            25.24
          ],
          [
            62.91,
            25.22
          ],
          [
            61.5,
            25.08
          ],
          [
            61.88,
            26.24
          ],
          [
            63.32,
            26.76
          ],
          [
            63.23,
            27.22
          ],
          [
            62.75,
            27.38
          ],
          [
            62.73,
            28.26
          ],
          [
            61.77,
            28.7
          ],
          [
            61.37,
            29.3
          ],
          [
            60.87,
            29.83
          ],
          [
            62.55,
            29.32
          ],
          [
            63.55,
            29.47
          ],
          [
            64.15,
            29.34
          ],
          [
            64.35,
            29.56
          ],
          [
            65.05,
            29.47
          ],
          [
            66.35,
            29.89
          ],
          [
            66.38,
            30.74
          ],
          [
            66.94,
            31.3
          ],
          [
            67.68,
            31.3
          ],
          [
            67.79,
            31.58
          ],
          [
            68.56,
            31.71
          ],
          [
            68.93,
            31.62
          ],
          [
            69.32,
            31.9
          ],
          [
            69.26,
            32.5
          ],
          [
            69.69,
            33.11
          ],
          [
            70.32,
            33.36
          ],
          [
            69.93,
            34.02
          ],
          [
            70.88,
            33.99
          ],
          [
            71.16,
            34.35
          ],
          [
            71.11,
            34.73
          ],
          [
            71.61,
            35.15
          ],
          [
            71.5,
            35.65
          ],
          [
            71.26,
            36.07
          ],
          [
            71.85,
            36.51
          ],
          [
            72.92,
            36.72
          ],
          [
            74.07,
            36.84
          ],
          [
            74.58,
            37.02
          ],
          [
            75.16,
            37.13
          ],
          [
            75.9,
            36.67
          ],
          [
            76.19,
            35.9
          ],
          [
            77.84,
            35.49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Afghanistan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            66.52,
            37.36
          ],
          [
            67.07,
            37.36
          ],
          [
            67.83,
            37.15
          ],
          [
            68.14,
            37.02
          ],
          [
            68.86,
            37.34
          ],
          [
            69.19,
            37.15
          ],
          [
            69.52,
            37.61
          ],
          [
            70.12,
            37.59
          ],
          [
            70.27,
            37.73
          ],
          [
            70.38,
            38.14
          ],
          [
            70.81,
            38.49
          ],
          [
            71.35,
            38.26
          ],
          [
            71.24,
            37.95
          ],
          [
            71.54,
            37.91
          ],
          [
            71.45,
            37.07
          ],
          [
            71.84,
            36.74
          ],
          [
            72.19,
            36.95
          ],
          [
            72.64,
            37.05
          ],
          [
            73.26,
            37.5
          ],
          [
            73.95,
            37.42
          ],
          [
            74.98,
            37.42
          ],
          [
            75.16,
            37.13
          ],
          [
            74.58,
            37.02
          ],
          [
            74.07,
            36.84
          ],
          [
            72.92,
            36.72
          ],
          [
            71.85,
            36.51
          ],
          [
            71.26,
            36.07
          ],
          [
            71.5,
            35.65
          ],
          [
            71.61,
            35.15
          ],
          [
            71.11,
            34.73
          ],
          [
            71.16,
            34.35
          ],
          [
            70.88,
            33.99
          ],
          [
            69.93,
            34.02
          ],
          [
            70.32,
            33.36
          ],
          [
            69.69,
            33.11
          ],
          [
            69.26,
            32.5
          ],
          [
            69.32,
            31.9
          ],
          [
            68.93,
            31.62
          ],
          [
            68.56,
            31.71
          ],
          [
            67.79,
            31.58
          ],
          [
            67.68,
            31.3
          ],
          [
            66.94,
            31.3
          ],
          [
            66.38,
            30.74
          ],
          [
            66.35,
            29.89
          ],
          [
            65.05,
            29.47
          ],
          [
            64.35,
            29.56
          ],
          [
            64.15,
            29.34
          ],
          [
            63.55,
            29.47
          ],
          [
            62.55,
            29.32
          ],
          [
            60.87,
            29.83
          ],
          [
            61.78,
            30.74
          ],
          [
            61.7,
            31.38
          ],
          [
            60.94,
            31.55
          ],
          [
            60.86,
            32.18
          ],
          [
            60.54,
            32.98
          ],
          [
            60.96,
            33.53
          ],
          [
            60.53,
            33.68
          ],
          [
            60.8,
            34.4
          ],
          [
            61.21,
            35.65
          ],
          [
            62.23,
            35.27
          ],
          [
            62.98,
            35.4
          ],
          [
            63.19,
            35.86
          ],
          [
            63.98,
            36.01
          ],
          [
            64.55,
            36.31
          ],
          [
            64.74,
            37.11
          ],
          [
            65.59,
            37.3
          ],
          [
            65.75,
            37.66
          ],
          [
            66.22,
            37.39
          ],
          [
            66.52,
            37.36
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Tajikistan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            67.83,
            37.15
          ],
          [
            68.39,
            38.16
          ],
          [
            68.18,
            38.9
          ],
          [
            67.44,
            39.14
          ],
          [
            67.7,
            39.58
          ],
          [
            68.54,
            39.53
          ],
          [
            69.01,
            40.09
          ],
          [
            69.33,
            40.73
          ],
          [
            70.67,
            40.96
          ],
          [
            70.46,
            40.5
          ],
          [
            70.6,
            40.22
          ],
          [
            71.01,
            40.24
          ],
          [
            70.65,
            39.94
          ],
          [
            69.56,
            40.1
          ],
          [
            69.46,
            39.53
          ],
          [
            70.55,
            39.6
          ],
          [
            71.78,
            39.28
          ],
          [
            73.68,
            39.43
          ],
          [
            73.93,
            38.51
          ],
          [
            74.26,
            38.61
          ],
          [
            74.86,
            38.38
          ],
          [
            74.83,
            37.99
          ],
          [
            74.98,
            37.42
          ],
          [
            73.95,
            37.42
          ],
          [
            73.26,
            37.5
          ],
          [
            72.64,
            37.05
          ],
          [
            72.19,
            36.95
          ],
          [
            71.84,
            36.74
          ],
          [
            71.45,
            37.07
          ],
          [
            71.54,
            37.91
          ],
          [
            71.24,
            37.95
          ],
          [
            71.35,
            38.26
          ],
          [
            70.81,
            38.49
          ],
          [
            70.38,
            38.14
          ],
          [
            70.27,
            37.73
          ],
          [
            70.12,
            37.59
          ],
          [
            69.52,
            37.61
          ],
          [
            69.19,
            37.15
          ],
          [
            68.86,
            37.34
          ],
          [
            68.14,
            37.02
          ],
          [
            67.83,
            37.15
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kyrgyzstan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            70.96,
            42.27
          ],
          [
            71.19,
            42.7
          ],
          [
            71.84,
            42.85
          ],
          [
            73.49,
            42.5
          ],
          [
            73.64,
            43.09
          ],
          [
            74.21,
            43.3
          ],
          [
            75.64,
            42.88
          ],
          [
            76,
            42.99
          ],
          [
            77.66,
            42.96
          ],
          [
            79.14,
            42.86
          ],
          [
            79.65,
            42.5
          ],
          [
            80.26,
            42.35
          ],
          [
            80.12,
            42.12
          ],
          [
            78.54,
            41.58
          ],
          [
            78.19,
            41.19
          ],
          [
            76.91,
            41.07
          ],
          [
            76.53,
            40.43
          ],
          [
            75.47,
            40.56
          ],
          [
            74.78,
            40.37
          ],
          [
            73.82,
            39.89
          ],
          [
            73.96,
            39.66
          ],
          [
            73.68,
            39.43
          ],
          [
            71.78,
            39.28
          ],
          [
            70.55,
            39.6
          ],
          [
            69.46,
            39.53
          ],
          [
            69.56,
            40.1
          ],
          [
            70.65,
            39.94
          ],
          [
            71.01,
            40.24
          ],
          [
            71.78,
            40.15
          ],
          [
            73.05,
            40.87
          ],
          [
            71.87,
            41.39
          ],
          [
            71.16,
            41.14
          ],
          [
            70.42,
            41.52
          ],
          [
            71.26,
            42.17
          ],
          [
            70.96,
            42.27
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Turkmenistan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            52.5,
            41.78
          ],
          [
            52.94,
            42.12
          ],
          [
            54.08,
            42.32
          ],
          [
            54.75,
            42.04
          ],
          [
            55.46,
            41.26
          ],
          [
            55.97,
            41.31
          ],
          [
            57.09,
            41.32
          ],
          [
            56.93,
            41.83
          ],
          [
            57.79,
            42.17
          ],
          [
            58.63,
            42.75
          ],
          [
            59.97,
            42.22
          ],
          [
            60.08,
            41.43
          ],
          [
            60.46,
            41.22
          ],
          [
            61.55,
            41.27
          ],
          [
            61.88,
            41.08
          ],
          [
            62.38,
            40.05
          ],
          [
            63.52,
            39.36
          ],
          [
            64.17,
            38.89
          ],
          [
            65.22,
            38.4
          ],
          [
            66.54,
            37.97
          ],
          [
            66.52,
            37.36
          ],
          [
            66.22,
            37.39
          ],
          [
            65.75,
            37.66
          ],
          [
            65.59,
            37.3
          ],
          [
            64.74,
            37.11
          ],
          [
            64.55,
            36.31
          ],
          [
            63.98,
            36.01
          ],
          [
            63.19,
            35.86
          ],
          [
            62.98,
            35.4
          ],
          [
            62.23,
            35.27
          ],
          [
            61.21,
            35.65
          ],
          [
            61.12,
            36.49
          ],
          [
            60.38,
            36.53
          ],
          [
            59.23,
            37.41
          ],
          [
            58.44,
            37.52
          ],
          [
            57.33,
            38.03
          ],
          [
            56.62,
            38.12
          ],
          [
            56.18,
            37.94
          ],
          [
            55.51,
            37.96
          ],
          [
            54.8,
            37.39
          ],
          [
            53.92,
            37.2
          ],
          [
            53.74,
            37.91
          ],
          [
            53.88,
            38.95
          ],
          [
            53.1,
            39.29
          ],
          [
            53.36,
            39.98
          ],
          [
            52.7,
            40.03
          ],
          [
            52.92,
            40.88
          ],
          [
            53.86,
            40.63
          ],
          [
            54.74,
            40.95
          ],
          [
            54.01,
            41.55
          ],
          [
            53.72,
            42.12
          ],
          [
            52.92,
            41.87
          ],
          [
            52.81,
            41.13
          ],
          [
            52.5,
            41.78
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Iran"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            48.57,
            29.93
          ],
          [
            48.02,
            30.45
          ],
          [
            48,
            30.98
          ],
          [
            47.68,
            30.98
          ],
          [
            47.85,
            31.71
          ],
          [
            47.34,
            32.47
          ],
          [
            46.11,
            33.02
          ],
          [
            45.42,
            33.97
          ],
          [
            45.65,
            34.75
          ],
          [
            46.15,
            35.09
          ],
          [
            46.08,
            35.68
          ],
          [
            45.42,
            35.98
          ],
          [
            44.77,
            37.17
          ],
          [
            44.22,
            37.97
          ],
          [
            44.42,
            38.28
          ],
          [
            44.11,
            39.43
          ],
          [
            44.79,
            39.71
          ],
          [
            44.95,
            39.34
          ],
          [
            45.46,
            38.87
          ],
          [
            46.14,
            38.74
          ],
          [
            46.51,
            38.77
          ],
          [
            47.68,
            39.51
          ],
          [
            48.06,
            39.58
          ],
          [
            48.35,
            39.29
          ],
          [
            48.01,
            38.79
          ],
          [
            48.63,
            38.27
          ],
          [
            48.88,
            38.32
          ],
          [
            49.2,
            37.58
          ],
          [
            50.15,
            37.37
          ],
          [
            50.84,
            36.87
          ],
          [
            52.26,
            36.7
          ],
          [
            53.83,
            36.96
          ],
          [
            53.92,
            37.2
          ],
          [
            54.8,
            37.39
          ],
          [
            55.51,
            37.96
          ],
          [
            56.18,
            37.94
          ],
          [
            56.62,
            38.12
          ],
          [
            57.33,
            38.03
          ],
          [
            58.44,
            37.52
          ],
          [
            59.23,
            37.41
          ],
          [
            60.38,
            36.53
          ],
          [
            61.12,
            36.49
          ],
          [
            61.21,
            35.65
          ],
          [
            60.8,
            34.4
          ],
          [
            60.53,
            33.68
          ],
          [
            60.96,
            33.53
          ],
          [
            60.54,
            32.98
          ],
          [
            60.86,
            32.18
          ],
          [
            60.94,
            31.55
          ],
          [
            61.7,
            31.38
          ],
          [
            61.78,
            30.74
          ],
          [
            60.87,
            29.83
          ],
          [
            61.37,
            29.3
          ],
          [
            61.77,
            28.7
          ],
          [
            62.73,
            28.26
          ],
          [
            62.75,
            27.38
          ],
          [
            63.23,
            27.22
          ],
          [
            63.32,
            26.76
          ],
          [
            61.88,
            26.24
          ],
          [
            61.5,
            25.08
          ],
          [
            59.61,
            25.38
          ],
          [
            58.52,
            25.61
          ],
          [
            57.4,
            25.74
          ],
          [
            56.97,
            26.97
          ],
          [
            56.49,
            27.14
          ],
          [
            55.72,
            26.96
          ],
          [
            54.72,
            26.48
          ],
          [
            53.49,
            26.81
          ],
          [
            52.48,
            27.58
          ],
          [
            51.52,
            27.87
          ],
          [
            50.85,
            28.81
          ],
          [
            50.11,
            30.15
          ],
          [
            49.58,
            29.99
          ],
          [
            48.94,
            30.32
          ],
          [
            48.57,
            29.93
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Syria"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            35.72,
            32.71
          ],
          [
            35.7,
            32.72
          ],
          [
            35.84,
            32.87
          ],
          [
            35.82,
            33.28
          ],
          [
            36.07,
            33.82
          ],
          [
            36.61,
            34.2
          ],
          [
            36.45,
            34.59
          ],
          [
            36,
            34.65
          ],
          [
            35.9,
            35.41
          ],
          [
            36.15,
            35.82
          ],
          [
            36.42,
            36.04
          ],
          [
            36.69,
            36.26
          ],
          [
            36.74,
            36.82
          ],
          [
            37.07,
            36.62
          ],
          [
            38.17,
            36.9
          ],
          [
            38.7,
            36.71
          ],
          [
            39.52,
            36.72
          ],
          [
            40.68,
            37.09
          ],
          [
            41.21,
            37.07
          ],
          [
            42.35,
            37.23
          ],
          [
            41.84,
            36.61
          ],
          [
            41.29,
            36.36
          ],
          [
            41.38,
            35.63
          ],
          [
            41.01,
            34.42
          ],
          [
            38.79,
            33.38
          ],
          [
            36.83,
            32.31
          ],
          [
            35.72,
            32.71
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Armenia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            46.51,
            38.77
          ],
          [
            46.14,
            38.74
          ],
          [
            45.74,
            39.32
          ],
          [
            45.74,
            39.47
          ],
          [
            45.3,
            39.47
          ],
          [
            45,
            39.74
          ],
          [
            44.79,
            39.71
          ],
          [
            44.4,
            40
          ],
          [
            43.66,
            40.25
          ],
          [
            43.75,
            40.74
          ],
          [
            43.58,
            41.09
          ],
          [
            44.97,
            41.25
          ],
          [
            45.18,
            40.99
          ],
          [
            45.56,
            40.81
          ],
          [
            45.36,
            40.56
          ],
          [
            45.89,
            40.22
          ],
          [
            45.61,
            39.9
          ],
          [
            46.04,
            39.63
          ],
          [
            46.48,
            39.46
          ],
          [
            46.51,
            38.77
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Sweden"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            11.03,
            58.86
          ],
          [
            11.47,
            59.43
          ],
          [
            12.3,
            60.12
          ],
          [
            12.63,
            61.29
          ],
          [
            11.99,
            61.8
          ],
          [
            11.93,
            63.13
          ],
          [
            12.58,
            64.07
          ],
          [
            13.57,
            64.05
          ],
          [
            13.92,
            64.44
          ],
          [
            13.56,
            64.79
          ],
          [
            15.11,
            66.19
          ],
          [
            16.11,
            67.3
          ],
          [
            16.77,
            68.01
          ],
          [
            17.73,
            68.01
          ],
          [
            17.99,
            68.57
          ],
          [
            19.88,
            68.41
          ],
          [
            20.03,
            69.07
          ],
          [
            20.64,
            69.11
          ],
          [
            21.98,
            68.62
          ],
          [
            23.54,
            67.94
          ],
          [
            23.57,
            66.4
          ],
          [
            23.9,
            66.01
          ],
          [
            22.18,
            65.72
          ],
          [
            21.21,
            65.03
          ],
          [
            21.37,
            64.41
          ],
          [
            19.78,
            63.61
          ],
          [
            17.85,
            62.75
          ],
          [
            17.12,
            61.34
          ],
          [
            17.83,
            60.64
          ],
          [
            18.79,
            60.08
          ],
          [
            17.87,
            58.95
          ],
          [
            16.83,
            58.72
          ],
          [
            16.45,
            57.04
          ],
          [
            15.88,
            56.1
          ],
          [
            14.67,
            56.2
          ],
          [
            14.1,
            55.41
          ],
          [
            12.94,
            55.36
          ],
          [
            12.62,
            56.31
          ],
          [
            11.79,
            57.44
          ],
          [
            11.03,
            58.86
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Belarus"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            28.18,
            56.17
          ],
          [
            29.23,
            55.92
          ],
          [
            29.37,
            55.67
          ],
          [
            29.9,
            55.79
          ],
          [
            30.88,
            55.55
          ],
          [
            30.97,
            55.08
          ],
          [
            30.76,
            54.81
          ],
          [
            31.38,
            54.16
          ],
          [
            31.79,
            53.97
          ],
          [
            31.73,
            53.79
          ],
          [
            32.41,
            53.62
          ],
          [
            32.69,
            53.35
          ],
          [
            32.3,
            53.13
          ],
          [
            31.5,
            53.17
          ],
          [
            31.3,
            53.07
          ],
          [
            31.54,
            52.74
          ],
          [
            31.79,
            52.1
          ],
          [
            30.93,
            52.04
          ],
          [
            30.62,
            51.82
          ],
          [
            30.56,
            51.32
          ],
          [
            30.16,
            51.42
          ],
          [
            29.26,
            51.37
          ],
          [
            28.99,
            51.6
          ],
          [
            28.62,
            51.43
          ],
          [
            28.24,
            51.57
          ],
          [
            27.46,
            51.59
          ],
          [
            26.34,
            51.83
          ],
          [
            25.33,
            51.91
          ],
          [
            24.55,
            51.89
          ],
          [
            24.01,
            51.62
          ],
          [
            23.53,
            51.58
          ],
          [
            23.51,
            52.02
          ],
          [
            23.2,
            52.49
          ],
          [
            23.8,
            52.69
          ],
          [
            23.81,
            53.09
          ],
          [
            23.53,
            53.47
          ],
          [
            23.48,
            53.91
          ],
          [
            24.45,
            53.91
          ],
          [
            25.54,
            54.28
          ],
          [
            25.77,
            54.85
          ],
          [
            26.59,
            55.17
          ],
          [
            26.49,
            55.61
          ],
          [
            27.1,
            55.78
          ],
          [
            28.18,
            56.17
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ukraine"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            31.79,
            52.1
          ],
          [
            32.16,
            52.06
          ],
          [
            32.41,
            52.29
          ],
          [
            32.72,
            52.24
          ],
          [
            33.75,
            52.33
          ],
          [
            34.39,
            51.77
          ],
          [
            34.14,
            51.57
          ],
          [
            34.22,
            51.26
          ],
          [
            35.02,
            51.21
          ],
          [
            35.38,
            50.77
          ],
          [
            35.36,
            50.58
          ],
          [
            36.62,
            50.23
          ],
          [
            37.39,
            50.38
          ],
          [
            38.01,
            49.92
          ],
          [
            38.59,
            49.93
          ],
          [
            40.07,
            49.6
          ],
          [
            40.08,
            49.31
          ],
          [
            39.67,
            48.78
          ],
          [
            39.9,
            48.23
          ],
          [
            39.74,
            47.9
          ],
          [
            38.77,
            47.83
          ],
          [
            38.26,
            47.55
          ],
          [
            38.22,
            47.1
          ],
          [
            37.42,
            47.02
          ],
          [
            36.76,
            46.7
          ],
          [
            35.82,
            46.65
          ],
          [
            34.96,
            46.27
          ],
          [
            35.01,
            45.74
          ],
          [
            34.86,
            45.77
          ],
          [
            34.73,
            45.97
          ],
          [
            34.41,
            46
          ],
          [
            33.7,
            46.22
          ],
          [
            33.44,
            45.97
          ],
          [
            33.3,
            46.08
          ],
          [
            31.74,
            46.33
          ],
          [
            31.67,
            46.71
          ],
          [
            30.75,
            46.58
          ],
          [
            30.38,
            46.03
          ],
          [
            29.6,
            45.29
          ],
          [
            29.15,
            45.46
          ],
          [
            28.68,
            45.3
          ],
          [
            28.23,
            45.49
          ],
          [
            28.49,
            45.6
          ],
          [
            28.66,
            45.94
          ],
          [
            28.94,
            46.26
          ],
          [
            28.86,
            46.44
          ],
          [
            29.07,
            46.52
          ],
          [
            29.17,
            46.38
          ],
          [
            29.76,
            46.35
          ],
          [
            30.03,
            46.42
          ],
          [
            29.84,
            46.53
          ],
          [
            29.91,
            46.67
          ],
          [
            29.56,
            46.93
          ],
          [
            29.41,
            47.35
          ],
          [
            29.05,
            47.51
          ],
          [
            29.12,
            47.85
          ],
          [
            28.67,
            48.12
          ],
          [
            28.26,
            48.16
          ],
          [
            27.52,
            48.47
          ],
          [
            26.86,
            48.37
          ],
          [
            26.62,
            48.22
          ],
          [
            26.2,
            48.22
          ],
          [
            25.95,
            47.99
          ],
          [
            25.21,
            47.89
          ],
          [
            24.87,
            47.74
          ],
          [
            24.4,
            47.98
          ],
          [
            23.76,
            47.99
          ],
          [
            23.14,
            48.1
          ],
          [
            22.71,
            47.88
          ],
          [
            22.64,
            48.15
          ],
          [
            22.08,
            48.42
          ],
          [
            22.28,
            48.83
          ],
          [
            22.56,
            49.09
          ],
          [
            22.78,
            49.03
          ],
          [
            22.52,
            49.48
          ],
          [
            23.43,
            50.31
          ],
          [
            23.92,
            50.43
          ],
          [
            24.03,
            50.71
          ],
          [
            23.53,
            51.58
          ],
          [
            24.01,
            51.62
          ],
          [
            24.55,
            51.89
          ],
          [
            25.33,
            51.91
          ],
          [
            26.34,
            51.83
          ],
          [
            27.46,
            51.59
          ],
          [
            28.24,
            51.57
          ],
          [
            28.62,
            51.43
          ],
          [
            28.99,
            51.6
          ],
          [
            29.26,
            51.37
          ],
          [
            30.16,
            51.42
          ],
          [
            30.56,
            51.32
          ],
          [
            30.62,
            51.82
          ],
          [
            30.93,
            52.04
          ],
          [
            31.79,
            52.1
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Poland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            23.48,
            53.91
          ],
          [
            23.53,
            53.47
          ],
          [
            23.81,
            53.09
          ],
          [
            23.8,
            52.69
          ],
          [
            23.2,
            52.49
          ],
          [
            23.51,
            52.02
          ],
          [
            23.53,
            51.58
          ],
          [
            24.03,
            50.71
          ],
          [
            23.92,
            50.43
          ],
          [
            23.43,
            50.31
          ],
          [
            22.52,
            49.48
          ],
          [
            22.78,
            49.03
          ],
          [
            22.56,
            49.09
          ],
          [
            21.61,
            49.47
          ],
          [
            20.89,
            49.33
          ],
          [
            20.42,
            49.43
          ],
          [
            19.82,
            49.22
          ],
          [
            19.32,
            49.57
          ],
          [
            18.91,
            49.44
          ],
          [
            18.85,
            49.5
          ],
          [
            18.39,
            49.99
          ],
          [
            17.65,
            50.05
          ],
          [
            17.56,
            50.36
          ],
          [
            16.87,
            50.47
          ],
          [
            16.72,
            50.22
          ],
          [
            16.18,
            50.42
          ],
          [
            16.24,
            50.7
          ],
          [
            15.49,
            50.78
          ],
          [
            15.02,
            51.11
          ],
          [
            14.61,
            51.75
          ],
          [
            14.69,
            52.09
          ],
          [
            14.44,
            52.63
          ],
          [
            14.07,
            52.98
          ],
          [
            14.35,
            53.25
          ],
          [
            14.12,
            53.76
          ],
          [
            14.8,
            54.05
          ],
          [
            16.36,
            54.51
          ],
          [
            17.62,
            54.85
          ],
          [
            18.62,
            54.68
          ],
          [
            18.7,
            54.44
          ],
          [
            19.66,
            54.43
          ],
          [
            20.89,
            54.31
          ],
          [
            22.73,
            54.33
          ],
          [
            23.24,
            54.22
          ],
          [
            23.48,
            53.91
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Austria"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            16.98,
            48.12
          ],
          [
            16.9,
            47.72
          ],
          [
            16.34,
            47.71
          ],
          [
            16.53,
            47.5
          ],
          [
            16.2,
            46.85
          ],
          [
            16.01,
            46.68
          ],
          [
            15.14,
            46.66
          ],
          [
            14.63,
            46.43
          ],
          [
            13.81,
            46.51
          ],
          [
            12.38,
            46.77
          ],
          [
            12.15,
            47.11
          ],
          [
            11.17,
            46.94
          ],
          [
            11.05,
            46.75
          ],
          [
            10.44,
            46.89
          ],
          [
            9.93,
            46.92
          ],
          [
            9.48,
            47.1
          ],
          [
            9.63,
            47.35
          ],
          [
            9.6,
            47.52
          ],
          [
            9.89,
            47.58
          ],
          [
            10.4,
            47.3
          ],
          [
            10.54,
            47.57
          ],
          [
            11.42,
            47.52
          ],
          [
            12.14,
            47.7
          ],
          [
            12.62,
            47.67
          ],
          [
            12.93,
            47.47
          ],
          [
            13.03,
            47.64
          ],
          [
            12.88,
            48.29
          ],
          [
            13.24,
            48.42
          ],
          [
            13.6,
            48.88
          ],
          [
            14.34,
            48.56
          ],
          [
            14.9,
            48.96
          ],
          [
            15.26,
            49.04
          ],
          [
            16.03,
            48.73
          ],
          [
            16.5,
            48.79
          ],
          [
            16.96,
            48.6
          ],
          [
            16.88,
            48.47
          ],
          [
            16.98,
            48.12
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Hungary"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            22.08,
            48.42
          ],
          [
            22.64,
            48.15
          ],
          [
            22.71,
            47.88
          ],
          [
            22.1,
            47.67
          ],
          [
            21.63,
            46.99
          ],
          [
            21.02,
            46.32
          ],
          [
            20.22,
            46.13
          ],
          [
            19.6,
            46.17
          ],
          [
            18.83,
            45.91
          ],
          [
            18.46,
            45.76
          ],
          [
            17.63,
            45.95
          ],
          [
            16.88,
            46.38
          ],
          [
            16.57,
            46.5
          ],
          [
            16.37,
            46.84
          ],
          [
            16.2,
            46.85
          ],
          [
            16.53,
            47.5
          ],
          [
            16.34,
            47.71
          ],
          [
            16.9,
            47.72
          ],
          [
            16.98,
            48.12
          ],
          [
            17.49,
            47.87
          ],
          [
            17.86,
            47.76
          ],
          [
            18.7,
            47.88
          ],
          [
            18.78,
            48.08
          ],
          [
            19.18,
            48.11
          ],
          [
            19.66,
            48.27
          ],
          [
            19.77,
            48.2
          ],
          [
            20.24,
            48.33
          ],
          [
            20.48,
            48.56
          ],
          [
            20.8,
            48.62
          ],
          [
            21.87,
            48.32
          ],
          [
            22.08,
            48.42
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Moldova"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            26.62,
            48.22
          ],
          [
            26.86,
            48.37
          ],
          [
            27.52,
            48.47
          ],
          [
            28.26,
            48.16
          ],
          [
            28.67,
            48.12
          ],
          [
            29.12,
            47.85
          ],
          [
            29.05,
            47.51
          ],
          [
            29.41,
            47.35
          ],
          [
            29.56,
            46.93
          ],
          [
            29.91,
            46.67
          ],
          [
            29.84,
            46.53
          ],
          [
            30.03,
            46.42
          ],
          [
            29.76,
            46.35
          ],
          [
            29.17,
            46.38
          ],
          [
            29.07,
            46.52
          ],
          [
            28.86,
            46.44
          ],
          [
            28.94,
            46.26
          ],
          [
            28.66,
            45.94
          ],
          [
            28.49,
            45.6
          ],
          [
            28.23,
            45.49
          ],
          [
            28.05,
            45.95
          ],
          [
            28.16,
            46.37
          ],
          [
            28.13,
            46.81
          ],
          [
            27.55,
            47.41
          ],
          [
            27.23,
            47.83
          ],
          [
            26.92,
            48.12
          ],
          [
            26.62,
            48.22
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Romania"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            28.23,
            45.49
          ],
          [
            28.68,
            45.3
          ],
          [
            29.15,
            45.46
          ],
          [
            29.6,
            45.29
          ],
          [
            29.63,
            45.04
          ],
          [
            29.14,
            44.82
          ],
          [
            28.84,
            44.91
          ],
          [
            28.56,
            43.71
          ],
          [
            27.97,
            43.81
          ],
          [
            27.24,
            44.18
          ],
          [
            26.07,
            43.94
          ],
          [
            25.57,
            43.69
          ],
          [
            24.1,
            43.74
          ],
          [
            23.33,
            43.9
          ],
          [
            22.94,
            43.82
          ],
          [
            22.66,
            44.24
          ],
          [
            22.47,
            44.41
          ],
          [
            22.71,
            44.58
          ],
          [
            22.46,
            44.7
          ],
          [
            22.15,
            44.48
          ],
          [
            21.56,
            44.77
          ],
          [
            21.48,
            45.18
          ],
          [
            20.87,
            45.42
          ],
          [
            20.76,
            45.74
          ],
          [
            20.22,
            46.13
          ],
          [
            21.02,
            46.32
          ],
          [
            21.63,
            46.99
          ],
          [
            22.1,
            47.67
          ],
          [
            22.71,
            47.88
          ],
          [
            23.14,
            48.1
          ],
          [
            23.76,
            47.99
          ],
          [
            24.4,
            47.98
          ],
          [
            24.87,
            47.74
          ],
          [
            25.21,
            47.89
          ],
          [
            25.95,
            47.99
          ],
          [
            26.2,
            48.22
          ],
          [
            26.62,
            48.22
          ],
          [
            26.92,
            48.12
          ],
          [
            27.23,
            47.83
          ],
          [
            27.55,
            47.41
          ],
          [
            28.13,
            46.81
          ],
          [
            28.16,
            46.37
          ],
          [
            28.05,
            45.95
          ],
          [
            28.23,
            45.49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Lithuania"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            26.49,
            55.61
          ],
          [
            26.59,
            55.17
          ],
          [
            25.77,
            54.85
          ],
          [
            25.54,
            54.28
          ],
          [
            24.45,
            53.91
          ],
          [
            23.48,
            53.91
          ],
          [
            23.24,
            54.22
          ],
          [
            22.73,
            54.33
          ],
          [
            22.65,
            54.58
          ],
          [
            22.76,
            54.86
          ],
          [
            22.31,
            55.02
          ],
          [
            21.27,
            55.19
          ],
          [
            21.05,
            56.03
          ],
          [
            22.2,
            56.34
          ],
          [
            23.88,
            56.27
          ],
          [
            24.86,
            56.37
          ],
          [
            25,
            56.16
          ],
          [
            25.53,
            56.1
          ],
          [
            26.49,
            55.61
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Latvia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            27.29,
            57.47
          ],
          [
            27.77,
            57.24
          ],
          [
            27.86,
            56.76
          ],
          [
            28.18,
            56.17
          ],
          [
            27.1,
            55.78
          ],
          [
            26.49,
            55.61
          ],
          [
            25.53,
            56.1
          ],
          [
            25,
            56.16
          ],
          [
            24.86,
            56.37
          ],
          [
            23.88,
            56.27
          ],
          [
            22.2,
            56.34
          ],
          [
            21.05,
            56.03
          ],
          [
            21.09,
            56.78
          ],
          [
            21.58,
            57.41
          ],
          [
            22.52,
            57.75
          ],
          [
            23.32,
            57.01
          ],
          [
            24.12,
            57.03
          ],
          [
            24.31,
            57.79
          ],
          [
            25.17,
            57.97
          ],
          [
            25.6,
            57.85
          ],
          [
            26.46,
            57.48
          ],
          [
            27.29,
            57.47
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Estonia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            27.98,
            59.48
          ],
          [
            28.13,
            59.3
          ],
          [
            27.42,
            58.72
          ],
          [
            27.72,
            57.79
          ],
          [
            27.29,
            57.47
          ],
          [
            26.46,
            57.48
          ],
          [
            25.6,
            57.85
          ],
          [
            25.17,
            57.97
          ],
          [
            24.31,
            57.79
          ],
          [
            24.43,
            58.38
          ],
          [
            24.06,
            58.26
          ],
          [
            23.43,
            58.61
          ],
          [
            23.34,
            59.19
          ],
          [
            24.6,
            59.47
          ],
          [
            25.86,
            59.61
          ],
          [
            26.95,
            59.45
          ],
          [
            27.98,
            59.48
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Germany"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            14.12,
            53.76
          ],
          [
            14.35,
            53.25
          ],
          [
            14.07,
            52.98
          ],
          [
            14.44,
            52.63
          ],
          [
            14.69,
            52.09
          ],
          [
            14.61,
            51.75
          ],
          [
            15.02,
            51.11
          ],
          [
            14.57,
            51
          ],
          [
            14.31,
            51.12
          ],
          [
            14.06,
            50.93
          ],
          [
            13.34,
            50.73
          ],
          [
            12.97,
            50.48
          ],
          [
            12.24,
            50.27
          ],
          [
            12.41,
            49.97
          ],
          [
            12.52,
            49.55
          ],
          [
            13.03,
            49.31
          ],
          [
            13.6,
            48.88
          ],
          [
            13.24,
            48.42
          ],
          [
            12.88,
            48.29
          ],
          [
            13.03,
            47.64
          ],
          [
            12.93,
            47.47
          ],
          [
            12.62,
            47.67
          ],
          [
            12.14,
            47.7
          ],
          [
            11.42,
            47.52
          ],
          [
            10.54,
            47.57
          ],
          [
            10.4,
            47.3
          ],
          [
            9.89,
            47.58
          ],
          [
            9.6,
            47.52
          ],
          [
            8.52,
            47.83
          ],
          [
            8.32,
            47.61
          ],
          [
            7.47,
            47.62
          ],
          [
            7.59,
            48.33
          ],
          [
            8.1,
            49.02
          ],
          [
            6.66,
            49.2
          ],
          [
            6.19,
            49.46
          ],
          [
            6.24,
            49.9
          ],
          [
            6.04,
            50.13
          ],
          [
            6.16,
            50.8
          ],
          [
            5.99,
            51.85
          ],
          [
            6.59,
            51.85
          ],
          [
            6.84,
            52.23
          ],
          [
            7.09,
            53.14
          ],
          [
            6.91,
            53.48
          ],
          [
            7.1,
            53.69
          ],
          [
            7.94,
            53.75
          ],
          [
            8.12,
            53.53
          ],
          [
            8.8,
            54.02
          ],
          [
            8.57,
            54.4
          ],
          [
            8.53,
            54.96
          ],
          [
            9.28,
            54.83
          ],
          [
            9.92,
            54.98
          ],
          [
            9.94,
            54.6
          ],
          [
            10.95,
            54.36
          ],
          [
            10.94,
            54.01
          ],
          [
            11.96,
            54.2
          ],
          [
            12.52,
            54.47
          ],
          [
            13.65,
            54.08
          ],
          [
            14.12,
            53.76
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bulgaria"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            22.66,
            44.24
          ],
          [
            22.94,
            43.82
          ],
          [
            23.33,
            43.9
          ],
          [
            24.1,
            43.74
          ],
          [
            25.57,
            43.69
          ],
          [
            26.07,
            43.94
          ],
          [
            27.24,
            44.18
          ],
          [
            27.97,
            43.81
          ],
          [
            28.56,
            43.71
          ],
          [
            28.04,
            43.29
          ],
          [
            27.68,
            42.58
          ],
          [
            28,
            42.01
          ],
          [
            27.14,
            42.14
          ],
          [
            26.12,
            41.83
          ],
          [
            26.11,
            41.33
          ],
          [
            25.2,
            41.23
          ],
          [
            24.49,
            41.58
          ],
          [
            23.69,
            41.31
          ],
          [
            22.95,
            41.34
          ],
          [
            22.88,
            42
          ],
          [
            22.38,
            42.32
          ],
          [
            22.55,
            42.46
          ],
          [
            22.44,
            42.58
          ],
          [
            22.61,
            42.9
          ],
          [
            22.98,
            43.21
          ],
          [
            22.5,
            43.64
          ],
          [
            22.41,
            44.01
          ],
          [
            22.66,
            44.24
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Greece"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              26.29,
              35.3
            ],
            [
              26.16,
              35
            ],
            [
              24.72,
              34.92
            ],
            [
              24.73,
              35.09
            ],
            [
              23.51,
              35.28
            ],
            [
              23.7,
              35.71
            ],
            [
              24.25,
              35.37
            ],
            [
              25.03,
              35.43
            ],
            [
              25.77,
              35.35
            ],
            [
              25.75,
              35.18
            ],
            [
              26.29,
              35.3
            ]
          ]
        ],
        [
          [
            [
              22.95,
              41.34
            ],
            [
              23.69,
              41.31
            ],
            [
              24.49,
              41.58
            ],
            [
              25.2,
              41.23
            ],
            [
              26.11,
              41.33
            ],
            [
              26.12,
              41.83
            ],
            [
              26.6,
              41.56
            ],
            [
              26.29,
              40.94
            ],
            [
              26.06,
              40.82
            ],
            [
              25.45,
              40.85
            ],
            [
              24.92,
              40.95
            ],
            [
              23.72,
              40.69
            ],
            [
              24.41,
              40.12
            ],
            [
              23.9,
              39.96
            ],
            [
              23.34,
              39.96
            ],
            [
              22.82,
              40.48
            ],
            [
              22.63,
              40.26
            ],
            [
              22.85,
              39.66
            ],
            [
              23.35,
              39.19
            ],
            [
              22.97,
              38.97
            ],
            [
              23.53,
              38.51
            ],
            [
              24.02,
              38.22
            ],
            [
              24.04,
              37.65
            ],
            [
              23.11,
              37.92
            ],
            [
              23.41,
              37.41
            ],
            [
              22.78,
              37.3
            ],
            [
              23.15,
              36.42
            ],
            [
              22.49,
              36.41
            ],
            [
              21.67,
              36.84
            ],
            [
              21.3,
              37.64
            ],
            [
              21.12,
              38.31
            ],
            [
              20.73,
              38.77
            ],
            [
              20.22,
              39.34
            ],
            [
              20.15,
              39.63
            ],
            [
              20.62,
              40.11
            ],
            [
              20.67,
              40.44
            ],
            [
              21,
              40.58
            ],
            [
              21.02,
              40.84
            ],
            [
              21.67,
              40.93
            ],
            [
              22.06,
              41.15
            ],
            [
              22.6,
              41.13
            ],
            [
              22.76,
              41.3
            ],
            [
              22.95,
              41.34
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Turkey"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              44.77,
              37.17
            ],
            [
              44.29,
              37
            ],
            [
              43.94,
              37.26
            ],
            [
              42.78,
              37.39
            ],
            [
              42.35,
              37.23
            ],
            [
              41.21,
              37.07
            ],
            [
              40.68,
              37.09
            ],
            [
              39.52,
              36.72
            ],
            [
              38.7,
              36.71
            ],
            [
              38.17,
              36.9
            ],
            [
              37.07,
              36.62
            ],
            [
              36.74,
              36.82
            ],
            [
              36.69,
              36.26
            ],
            [
              36.42,
              36.04
            ],
            [
              36.15,
              35.82
            ],
            [
              35.78,
              36.28
            ],
            [
              36.16,
              36.65
            ],
            [
              35.55,
              36.56
            ],
            [
              34.71,
              36.8
            ],
            [
              34.03,
              36.22
            ],
            [
              32.51,
              36.11
            ],
            [
              31.7,
              36.64
            ],
            [
              30.62,
              36.68
            ],
            [
              30.39,
              36.26
            ],
            [
              29.7,
              36.15
            ],
            [
              28.73,
              36.68
            ],
            [
              27.64,
              36.66
            ],
            [
              27.05,
              37.65
            ],
            [
              26.32,
              38.21
            ],
            [
              26.8,
              38.99
            ],
            [
              26.17,
              39.46
            ],
            [
              27.28,
              40.42
            ],
            [
              28.82,
              40.46
            ],
            [
              29.24,
              41.22
            ],
            [
              31.15,
              41.09
            ],
            [
              32.35,
              41.74
            ],
            [
              33.51,
              42.02
            ],
            [
              35.17,
              42.04
            ],
            [
              36.91,
              41.33
            ],
            [
              38.35,
              40.95
            ],
            [
              39.51,
              41.1
            ],
            [
              40.37,
              41.01
            ],
            [
              41.55,
              41.54
            ],
            [
              42.62,
              41.58
            ],
            [
              43.58,
              41.09
            ],
            [
              43.75,
              40.74
            ],
            [
              43.66,
              40.25
            ],
            [
              44.4,
              40
            ],
            [
              44.79,
              39.71
            ],
            [
              44.11,
              39.43
            ],
            [
              44.42,
              38.28
            ],
            [
              44.22,
              37.97
            ],
            [
              44.77,
              37.17
            ]
          ]
        ],
        [
          [
            [
              26.12,
              41.83
            ],
            [
              27.14,
              42.14
            ],
            [
              28,
              42.01
            ],
            [
              28.11,
              41.62
            ],
            [
              28.99,
              41.3
            ],
            [
              28.81,
              41.06
            ],
            [
              27.62,
              41
            ],
            [
              27.19,
              40.69
            ],
            [
              26.36,
              40.15
            ],
            [
              26.04,
              40.62
            ],
            [
              26.06,
              40.82
            ],
            [
              26.29,
              40.94
            ],
            [
              26.6,
              41.56
            ],
            [
              26.12,
              41.83
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Albania"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            21.02,
            40.84
          ],
          [
            21,
            40.58
          ],
          [
            20.67,
            40.44
          ],
          [
            20.62,
            40.11
          ],
          [
            20.15,
            39.63
          ],
          [
            19.98,
            39.69
          ],
          [
            19.96,
            39.91
          ],
          [
            19.41,
            40.25
          ],
          [
            19.32,
            40.73
          ],
          [
            19.4,
            41.41
          ],
          [
            19.54,
            41.72
          ],
          [
            19.37,
            41.88
          ],
          [
            19.31,
            42.2
          ],
          [
            19.74,
            42.69
          ],
          [
            19.8,
            42.5
          ],
          [
            20.07,
            42.59
          ],
          [
            20.28,
            42.32
          ],
          [
            20.52,
            42.22
          ],
          [
            20.59,
            41.86
          ],
          [
            20.46,
            41.52
          ],
          [
            20.6,
            41.09
          ],
          [
            21.02,
            40.84
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Croatia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            16.57,
            46.5
          ],
          [
            16.88,
            46.38
          ],
          [
            17.63,
            45.95
          ],
          [
            18.46,
            45.76
          ],
          [
            18.83,
            45.91
          ],
          [
            19.07,
            45.52
          ],
          [
            19.39,
            45.24
          ],
          [
            19.01,
            44.86
          ],
          [
            18.55,
            45.08
          ],
          [
            17.86,
            45.07
          ],
          [
            17,
            45.23
          ],
          [
            16.53,
            45.21
          ],
          [
            16.32,
            45
          ],
          [
            15.96,
            45.23
          ],
          [
            15.75,
            44.82
          ],
          [
            16.24,
            44.35
          ],
          [
            16.46,
            44.04
          ],
          [
            16.91,
            43.67
          ],
          [
            17.3,
            43.45
          ],
          [
            17.67,
            43.03
          ],
          [
            18.56,
            42.65
          ],
          [
            18.45,
            42.48
          ],
          [
            17.51,
            42.85
          ],
          [
            16.93,
            43.21
          ],
          [
            16.01,
            43.51
          ],
          [
            15.18,
            44.24
          ],
          [
            15.38,
            44.32
          ],
          [
            14.92,
            44.74
          ],
          [
            14.9,
            45.08
          ],
          [
            14.26,
            45.23
          ],
          [
            13.95,
            44.8
          ],
          [
            13.66,
            45.14
          ],
          [
            13.68,
            45.48
          ],
          [
            13.71,
            45.5
          ],
          [
            14.41,
            45.47
          ],
          [
            14.6,
            45.64
          ],
          [
            14.93,
            45.47
          ],
          [
            15.33,
            45.45
          ],
          [
            15.32,
            45.73
          ],
          [
            15.67,
            45.83
          ],
          [
            15.77,
            46.24
          ],
          [
            16.57,
            46.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Switzerland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            9.6,
            47.52
          ],
          [
            9.63,
            47.35
          ],
          [
            9.48,
            47.1
          ],
          [
            9.93,
            46.92
          ],
          [
            10.44,
            46.89
          ],
          [
            10.36,
            46.48
          ],
          [
            9.92,
            46.31
          ],
          [
            9.18,
            46.44
          ],
          [
            8.97,
            46.04
          ],
          [
            8.49,
            46
          ],
          [
            8.32,
            46.16
          ],
          [
            7.76,
            45.82
          ],
          [
            7.27,
            45.78
          ],
          [
            6.84,
            45.99
          ],
          [
            6.5,
            46.43
          ],
          [
            6.02,
            46.27
          ],
          [
            6.04,
            46.73
          ],
          [
            6.77,
            47.29
          ],
          [
            6.74,
            47.54
          ],
          [
            7.19,
            47.45
          ],
          [
            7.47,
            47.62
          ],
          [
            8.32,
            47.61
          ],
          [
            8.52,
            47.83
          ],
          [
            9.6,
            47.52
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Luxembourg"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            6.04,
            50.13
          ],
          [
            6.24,
            49.9
          ],
          [
            6.19,
            49.46
          ],
          [
            5.9,
            49.44
          ],
          [
            5.68,
            49.53
          ],
          [
            5.78,
            50.09
          ],
          [
            6.04,
            50.13
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Belgium"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            6.16,
            50.8
          ],
          [
            6.04,
            50.13
          ],
          [
            5.78,
            50.09
          ],
          [
            5.68,
            49.53
          ],
          [
            4.8,
            49.99
          ],
          [
            4.29,
            49.91
          ],
          [
            3.59,
            50.38
          ],
          [
            3.12,
            50.78
          ],
          [
            2.66,
            50.8
          ],
          [
            2.51,
            51.15
          ],
          [
            3.31,
            51.35
          ],
          [
            4.05,
            51.27
          ],
          [
            4.97,
            51.47
          ],
          [
            5.61,
            51.04
          ],
          [
            6.16,
            50.8
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Netherlands"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            6.91,
            53.48
          ],
          [
            7.09,
            53.14
          ],
          [
            6.84,
            52.23
          ],
          [
            6.59,
            51.85
          ],
          [
            5.99,
            51.85
          ],
          [
            6.16,
            50.8
          ],
          [
            5.61,
            51.04
          ],
          [
            4.97,
            51.47
          ],
          [
            4.05,
            51.27
          ],
          [
            3.31,
            51.35
          ],
          [
            3.83,
            51.62
          ],
          [
            4.71,
            53.09
          ],
          [
            6.08,
            53.51
          ],
          [
            6.91,
            53.48
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Portugal"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -9.03,
            41.88
          ],
          [
            -8.67,
            42.14
          ],
          [
            -8.26,
            42.28
          ],
          [
            -8.01,
            41.79
          ],
          [
            -7.42,
            41.79
          ],
          [
            -7.25,
            41.92
          ],
          [
            -6.67,
            41.88
          ],
          [
            -6.39,
            41.38
          ],
          [
            -6.85,
            41.11
          ],
          [
            -6.86,
            40.33
          ],
          [
            -7.03,
            40.19
          ],
          [
            -7.07,
            39.71
          ],
          [
            -7.5,
            39.63
          ],
          [
            -7.1,
            39.03
          ],
          [
            -7.37,
            38.37
          ],
          [
            -7.03,
            38.08
          ],
          [
            -7.17,
            37.8
          ],
          [
            -7.54,
            37.43
          ],
          [
            -7.45,
            37.1
          ],
          [
            -7.86,
            36.84
          ],
          [
            -8.38,
            36.98
          ],
          [
            -8.9,
            36.87
          ],
          [
            -8.75,
            37.65
          ],
          [
            -8.84,
            38.27
          ],
          [
            -9.29,
            38.36
          ],
          [
            -9.53,
            38.74
          ],
          [
            -9.45,
            39.39
          ],
          [
            -9.05,
            39.76
          ],
          [
            -8.98,
            40.16
          ],
          [
            -8.77,
            40.76
          ],
          [
            -8.79,
            41.18
          ],
          [
            -8.99,
            41.54
          ],
          [
            -9.03,
            41.88
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Spain"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -7.45,
            37.1
          ],
          [
            -7.54,
            37.43
          ],
          [
            -7.17,
            37.8
          ],
          [
            -7.03,
            38.08
          ],
          [
            -7.37,
            38.37
          ],
          [
            -7.1,
            39.03
          ],
          [
            -7.5,
            39.63
          ],
          [
            -7.07,
            39.71
          ],
          [
            -7.03,
            40.19
          ],
          [
            -6.86,
            40.33
          ],
          [
            -6.85,
            41.11
          ],
          [
            -6.39,
            41.38
          ],
          [
            -6.67,
            41.88
          ],
          [
            -7.25,
            41.92
          ],
          [
            -7.42,
            41.79
          ],
          [
            -8.01,
            41.79
          ],
          [
            -8.26,
            42.28
          ],
          [
            -8.67,
            42.14
          ],
          [
            -9.03,
            41.88
          ],
          [
            -8.98,
            42.59
          ],
          [
            -9.39,
            43.03
          ],
          [
            -7.98,
            43.75
          ],
          [
            -6.76,
            43.57
          ],
          [
            -5.41,
            43.57
          ],
          [
            -4.35,
            43.4
          ],
          [
            -3.52,
            43.46
          ],
          [
            -1.9,
            43.42
          ],
          [
            -1.5,
            43.03
          ],
          [
            0.34,
            42.58
          ],
          [
            0.7,
            42.8
          ],
          [
            1.83,
            42.34
          ],
          [
            2.99,
            42.47
          ],
          [
            3.04,
            41.89
          ],
          [
            2.09,
            41.23
          ],
          [
            0.81,
            41.01
          ],
          [
            0.72,
            40.68
          ],
          [
            0.11,
            40.12
          ],
          [
            -0.28,
            39.31
          ],
          [
            0.11,
            38.74
          ],
          [
            -0.47,
            38.29
          ],
          [
            -0.68,
            37.64
          ],
          [
            -1.44,
            37.44
          ],
          [
            -2.15,
            36.67
          ],
          [
            -3.41,
            36.66
          ],
          [
            -4.37,
            36.68
          ],
          [
            -5,
            36.32
          ],
          [
            -5.38,
            35.95
          ],
          [
            -5.87,
            36.03
          ],
          [
            -6.24,
            36.37
          ],
          [
            -6.52,
            36.94
          ],
          [
            -7.45,
            37.1
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ireland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -6.2,
            53.87
          ],
          [
            -6.03,
            53.15
          ],
          [
            -6.79,
            52.26
          ],
          [
            -8.56,
            51.67
          ],
          [
            -9.98,
            51.82
          ],
          [
            -9.17,
            52.86
          ],
          [
            -9.69,
            53.88
          ],
          [
            -8.33,
            54.67
          ],
          [
            -7.57,
            55.13
          ],
          [
            -7.37,
            54.6
          ],
          [
            -7.57,
            54.06
          ],
          [
            -6.95,
            54.07
          ],
          [
            -6.2,
            53.87
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New Caledonia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            165.78,
            -21.08
          ],
          [
            166.6,
            -21.7
          ],
          [
            167.12,
            -22.16
          ],
          [
            166.74,
            -22.4
          ],
          [
            166.19,
            -22.13
          ],
          [
            165.47,
            -21.68
          ],
          [
            164.83,
            -21.15
          ],
          [
            164.17,
            -20.45
          ],
          [
            164.03,
            -20.11
          ],
          [
            164.46,
            -20.12
          ],
          [
            165.02,
            -20.46
          ],
          [
            165.46,
            -20.8
          ],
          [
            165.78,
            -21.08
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Solomon Is."
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              162.12,
              -10.48
            ],
            [
              162.4,
              -10.83
            ],
            [
              161.7,
              -10.82
            ],
            [
              161.32,
              -10.21
            ],
            [
              161.92,
              -10.45
            ],
            [
              162.12,
              -10.48
            ]
          ]
        ],
        [
          [
            [
              161.68,
              -9.6
            ],
            [
              161.53,
              -9.78
            ],
            [
              160.79,
              -8.92
            ],
            [
              160.58,
              -8.32
            ],
            [
              160.92,
              -8.32
            ],
            [
              161.28,
              -9.12
            ],
            [
              161.68,
              -9.6
            ]
          ]
        ],
        [
          [
            [
              160.85,
              -9.87
            ],
            [
              160.46,
              -9.9
            ],
            [
              159.85,
              -9.79
            ],
            [
              159.64,
              -9.64
            ],
            [
              159.7,
              -9.24
            ],
            [
              160.36,
              -9.4
            ],
            [
              160.69,
              -9.61
            ],
            [
              160.85,
              -9.87
            ]
          ]
        ],
        [
          [
            [
              159.64,
              -8.02
            ],
            [
              159.88,
              -8.34
            ],
            [
              159.92,
              -8.54
            ],
            [
              159.13,
              -8.11
            ],
            [
              158.59,
              -7.75
            ],
            [
              158.21,
              -7.42
            ],
            [
              158.36,
              -7.32
            ],
            [
              158.82,
              -7.56
            ],
            [
              159.64,
              -8.02
            ]
          ]
        ],
        [
          [
            [
              157.14,
              -7.02
            ],
            [
              157.54,
              -7.35
            ],
            [
              157.34,
              -7.4
            ],
            [
              156.9,
              -7.18
            ],
            [
              156.49,
              -6.77
            ],
            [
              156.54,
              -6.6
            ],
            [
              157.14,
              -7.02
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New Zealand"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              176.89,
              -40.07
            ],
            [
              176.51,
              -40.61
            ],
            [
              176.01,
              -41.29
            ],
            [
              175.24,
              -41.69
            ],
            [
              175.07,
              -41.43
            ],
            [
              174.65,
              -41.28
            ],
            [
              175.23,
              -40.46
            ],
            [
              174.9,
              -39.91
            ],
            [
              173.82,
              -39.51
            ],
            [
              173.85,
              -39.15
            ],
            [
              174.57,
              -38.8
            ],
            [
              174.74,
              -38.03
            ],
            [
              174.7,
              -37.38
            ],
            [
              174.29,
              -36.71
            ],
            [
              174.32,
              -36.53
            ],
            [
              173.84,
              -36.12
            ],
            [
              173.06,
              -35.24
            ],
            [
              172.63,
              -34.53
            ],
            [
              173.01,
              -34.45
            ],
            [
              173.55,
              -35.01
            ],
            [
              174.33,
              -35.27
            ],
            [
              174.61,
              -36.16
            ],
            [
              175.34,
              -37.21
            ],
            [
              175.36,
              -36.53
            ],
            [
              175.81,
              -36.8
            ],
            [
              175.96,
              -37.56
            ],
            [
              176.76,
              -37.88
            ],
            [
              177.44,
              -37.96
            ],
            [
              178.01,
              -37.58
            ],
            [
              178.52,
              -37.7
            ],
            [
              178.28,
              -38.58
            ],
            [
              177.97,
              -39.17
            ],
            [
              177.21,
              -39.15
            ],
            [
              176.94,
              -39.45
            ],
            [
              177.03,
              -39.88
            ],
            [
              176.89,
              -40.07
            ]
          ]
        ],
        [
          [
            [
              169.67,
              -43.56
            ],
            [
              170.52,
              -43.03
            ],
            [
              171.13,
              -42.51
            ],
            [
              171.57,
              -41.77
            ],
            [
              171.95,
              -41.51
            ],
            [
              172.1,
              -40.96
            ],
            [
              172.8,
              -40.49
            ],
            [
              173.02,
              -40.92
            ],
            [
              173.25,
              -41.33
            ],
            [
              173.96,
              -40.93
            ],
            [
              174.25,
              -41.35
            ],
            [
              174.25,
              -41.77
            ],
            [
              173.88,
              -42.23
            ],
            [
              173.22,
              -42.97
            ],
            [
              172.71,
              -43.37
            ],
            [
              173.08,
              -43.85
            ],
            [
              172.31,
              -43.87
            ],
            [
              171.45,
              -44.24
            ],
            [
              171.18,
              -44.9
            ],
            [
              170.62,
              -45.91
            ],
            [
              169.83,
              -46.36
            ],
            [
              169.33,
              -46.64
            ],
            [
              168.41,
              -46.62
            ],
            [
              167.76,
              -46.29
            ],
            [
              166.68,
              -46.22
            ],
            [
              166.51,
              -45.85
            ],
            [
              167.05,
              -45.11
            ],
            [
              168.3,
              -44.12
            ],
            [
              168.95,
              -43.94
            ],
            [
              169.67,
              -43.56
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Australia"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              147.69,
              -40.81
            ],
            [
              148.29,
              -40.87
            ],
            [
              148.36,
              -42.06
            ],
            [
              148.02,
              -42.41
            ],
            [
              147.91,
              -43.21
            ],
            [
              147.56,
              -42.94
            ],
            [
              146.87,
              -43.64
            ],
            [
              146.66,
              -43.58
            ],
            [
              146.05,
              -43.55
            ],
            [
              145.43,
              -42.69
            ],
            [
              145.3,
              -42.03
            ],
            [
              144.72,
              -41.16
            ],
            [
              144.74,
              -40.7
            ],
            [
              145.4,
              -40.79
            ],
            [
              146.36,
              -41.14
            ],
            [
              146.91,
              -41
            ],
            [
              147.69,
              -40.81
            ]
          ]
        ],
        [
          [
            [
              126.15,
              -32.22
            ],
            [
              125.09,
              -32.73
            ],
            [
              124.22,
              -32.96
            ],
            [
              124.03,
              -33.48
            ],
            [
              123.66,
              -33.89
            ],
            [
              122.81,
              -33.91
            ],
            [
              122.18,
              -34
            ],
            [
              121.3,
              -33.82
            ],
            [
              120.58,
              -33.93
            ],
            [
              119.89,
              -33.98
            ],
            [
              119.3,
              -34.51
            ],
            [
              119.01,
              -34.46
            ],
            [
              118.5,
              -34.75
            ],
            [
              118.03,
              -35.06
            ],
            [
              117.29,
              -35.03
            ],
            [
              116.62,
              -35.03
            ],
            [
              115.56,
              -34.39
            ],
            [
              115.03,
              -34.2
            ],
            [
              115.05,
              -33.62
            ],
            [
              115.54,
              -33.49
            ],
            [
              115.71,
              -33.26
            ],
            [
              115.68,
              -32.9
            ],
            [
              115.8,
              -32.21
            ],
            [
              115.69,
              -31.61
            ],
            [
              115.16,
              -30.6
            ],
            [
              115,
              -30.03
            ],
            [
              115.04,
              -29.46
            ],
            [
              114.64,
              -28.81
            ],
            [
              114.62,
              -28.52
            ],
            [
              114.17,
              -28.12
            ],
            [
              114.05,
              -27.33
            ],
            [
              113.48,
              -26.54
            ],
            [
              113.34,
              -26.12
            ],
            [
              113.78,
              -26.55
            ],
            [
              113.44,
              -25.62
            ],
            [
              113.94,
              -25.91
            ],
            [
              114.23,
              -26.3
            ],
            [
              114.22,
              -25.79
            ],
            [
              113.72,
              -25
            ],
            [
              113.63,
              -24.68
            ],
            [
              113.39,
              -24.38
            ],
            [
              113.5,
              -23.81
            ],
            [
              113.71,
              -23.56
            ],
            [
              113.84,
              -23.06
            ],
            [
              113.74,
              -22.47
            ],
            [
              114.15,
              -21.76
            ],
            [
              114.22,
              -22.52
            ],
            [
              114.65,
              -21.83
            ],
            [
              115.46,
              -21.49
            ],
            [
              115.95,
              -21.07
            ],
            [
              116.71,
              -20.7
            ],
            [
              117.16,
              -20.62
            ],
            [
              117.44,
              -20.75
            ],
            [
              118.23,
              -20.37
            ],
            [
              118.84,
              -20.26
            ],
            [
              118.99,
              -20.04
            ],
            [
              119.25,
              -19.95
            ],
            [
              119.8,
              -19.98
            ],
            [
              120.86,
              -19.68
            ],
            [
              121.4,
              -19.24
            ],
            [
              121.65,
              -18.71
            ],
            [
              122.24,
              -18.2
            ],
            [
              122.29,
              -17.8
            ],
            [
              122.31,
              -17.26
            ],
            [
              123.01,
              -16.41
            ],
            [
              123.43,
              -17.27
            ],
            [
              123.86,
              -17.07
            ],
            [
              123.5,
              -16.6
            ],
            [
              123.82,
              -16.11
            ],
            [
              124.26,
              -16.33
            ],
            [
              124.38,
              -15.57
            ],
            [
              124.93,
              -15.08
            ],
            [
              125.17,
              -14.68
            ],
            [
              125.67,
              -14.51
            ],
            [
              125.69,
              -14.23
            ],
            [
              126.13,
              -14.35
            ],
            [
              126.14,
              -14.1
            ],
            [
              126.58,
              -13.95
            ],
            [
              127.07,
              -13.82
            ],
            [
              127.8,
              -14.28
            ],
            [
              128.36,
              -14.87
            ],
            [
              128.98,
              -14.88
            ],
            [
              129.62,
              -14.97
            ],
            [
              129.41,
              -14.42
            ],
            [
              129.89,
              -13.62
            ],
            [
              130.34,
              -13.36
            ],
            [
              130.18,
              -13.11
            ],
            [
              130.62,
              -12.54
            ],
            [
              131.22,
              -12.18
            ],
            [
              131.73,
              -12.3
            ],
            [
              132.58,
              -12.11
            ],
            [
              132.56,
              -11.6
            ],
            [
              131.82,
              -11.27
            ],
            [
              132.36,
              -11.13
            ],
            [
              133.02,
              -11.38
            ],
            [
              133.55,
              -11.79
            ],
            [
              134.39,
              -12.04
            ],
            [
              134.68,
              -11.94
            ],
            [
              135.3,
              -12.25
            ],
            [
              135.88,
              -11.96
            ],
            [
              136.26,
              -12.05
            ],
            [
              136.49,
              -11.86
            ],
            [
              136.95,
              -12.35
            ],
            [
              136.68,
              -12.89
            ],
            [
              136.31,
              -13.29
            ],
            [
              135.96,
              -13.32
            ],
            [
              136.08,
              -13.72
            ],
            [
              135.78,
              -14.22
            ],
            [
              135.43,
              -14.72
            ],
            [
              135.5,
              -15
            ],
            [
              136.3,
              -15.55
            ],
            [
              137.07,
              -15.87
            ],
            [
              137.58,
              -16.22
            ],
            [
              138.3,
              -16.81
            ],
            [
              138.59,
              -16.81
            ],
            [
              139.11,
              -17.06
            ],
            [
              139.26,
              -17.37
            ],
            [
              140.22,
              -17.71
            ],
            [
              140.87,
              -17.37
            ],
            [
              141.07,
              -16.83
            ],
            [
              141.27,
              -16.39
            ],
            [
              141.4,
              -15.84
            ],
            [
              141.7,
              -15.04
            ],
            [
              141.56,
              -14.56
            ],
            [
              141.63,
              -14.27
            ],
            [
              141.52,
              -13.7
            ],
            [
              141.65,
              -12.94
            ],
            [
              141.84,
              -12.74
            ],
            [
              141.69,
              -12.41
            ],
            [
              141.93,
              -11.88
            ],
            [
              142.12,
              -11.33
            ],
            [
              142.14,
              -11.04
            ],
            [
              142.52,
              -10.67
            ],
            [
              142.8,
              -11.16
            ],
            [
              142.87,
              -11.78
            ],
            [
              143.12,
              -11.9
            ],
            [
              143.16,
              -12.33
            ],
            [
              143.52,
              -12.83
            ],
            [
              143.6,
              -13.4
            ],
            [
              143.56,
              -13.76
            ],
            [
              143.92,
              -14.55
            ],
            [
              144.56,
              -14.17
            ],
            [
              144.9,
              -14.59
            ],
            [
              145.37,
              -14.99
            ],
            [
              145.27,
              -15.43
            ],
            [
              145.49,
              -16.29
            ],
            [
              145.64,
              -16.78
            ],
            [
              145.89,
              -16.91
            ],
            [
              146.16,
              -17.76
            ],
            [
              146.06,
              -18.28
            ],
            [
              146.39,
              -18.96
            ],
            [
              147.47,
              -19.48
            ],
            [
              148.18,
              -19.96
            ],
            [
              148.85,
              -20.39
            ],
            [
              148.72,
              -20.63
            ],
            [
              149.29,
              -21.26
            ],
            [
              149.68,
              -22.34
            ],
            [
              150.08,
              -22.12
            ],
            [
              150.48,
              -22.56
            ],
            [
              150.73,
              -22.4
            ],
            [
              150.9,
              -23.46
            ],
            [
              151.61,
              -24.08
            ],
            [
              152.07,
              -24.46
            ],
            [
              152.86,
              -25.27
            ],
            [
              153.14,
              -26.07
            ],
            [
              153.16,
              -26.64
            ],
            [
              153.09,
              -27.26
            ],
            [
              153.57,
              -28.11
            ],
            [
              153.51,
              -28.99
            ],
            [
              153.34,
              -29.46
            ],
            [
              153.07,
              -30.35
            ],
            [
              153.09,
              -30.92
            ],
            [
              152.89,
              -31.64
            ],
            [
              152.45,
              -32.55
            ],
            [
              151.71,
              -33.04
            ],
            [
              151.34,
              -33.82
            ],
            [
              151.01,
              -34.31
            ],
            [
              150.71,
              -35.17
            ],
            [
              150.33,
              -35.67
            ],
            [
              150.08,
              -36.42
            ],
            [
              149.95,
              -37.11
            ],
            [
              150,
              -37.43
            ],
            [
              149.42,
              -37.77
            ],
            [
              148.31,
              -37.81
            ],
            [
              147.38,
              -38.22
            ],
            [
              146.92,
              -38.61
            ],
            [
              146.32,
              -39.04
            ],
            [
              145.49,
              -38.59
            ],
            [
              144.88,
              -38.42
            ],
            [
              145.03,
              -37.9
            ],
            [
              144.49,
              -38.09
            ],
            [
              143.61,
              -38.81
            ],
            [
              142.75,
              -38.54
            ],
            [
              142.18,
              -38.38
            ],
            [
              141.61,
              -38.31
            ],
            [
              140.64,
              -38.02
            ],
            [
              139.99,
              -37.4
            ],
            [
              139.81,
              -36.64
            ],
            [
              139.58,
              -36.14
            ],
            [
              139.08,
              -35.73
            ],
            [
              138.12,
              -35.61
            ],
            [
              138.45,
              -35.13
            ],
            [
              138.21,
              -34.39
            ],
            [
              137.72,
              -35.08
            ],
            [
              136.83,
              -35.26
            ],
            [
              137.35,
              -34.71
            ],
            [
              137.51,
              -34.13
            ],
            [
              137.89,
              -33.64
            ],
            [
              137.81,
              -32.9
            ],
            [
              137,
              -33.75
            ],
            [
              136.37,
              -34.09
            ],
            [
              135.99,
              -34.89
            ],
            [
              135.21,
              -34.48
            ],
            [
              135.24,
              -33.95
            ],
            [
              134.61,
              -33.22
            ],
            [
              134.09,
              -32.85
            ],
            [
              134.27,
              -32.62
            ],
            [
              132.99,
              -32.01
            ],
            [
              132.29,
              -31.98
            ],
            [
              131.33,
              -31.5
            ],
            [
              129.53,
              -31.59
            ],
            [
              128.24,
              -31.95
            ],
            [
              127.1,
              -32.28
            ],
            [
              126.15,
              -32.22
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Sri Lanka"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            81.79,
            7.52
          ],
          [
            81.64,
            6.48
          ],
          [
            81.22,
            6.2
          ],
          [
            80.35,
            5.97
          ],
          [
            79.87,
            6.76
          ],
          [
            79.7,
            8.2
          ],
          [
            80.15,
            9.82
          ],
          [
            80.84,
            9.27
          ],
          [
            81.31,
            8.56
          ],
          [
            81.79,
            7.52
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "China"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              109.48,
              18.2
            ],
            [
              108.65,
              18.51
            ],
            [
              108.63,
              19.37
            ],
            [
              109.12,
              19.82
            ],
            [
              110.21,
              20.1
            ],
            [
              110.79,
              20.08
            ],
            [
              111.01,
              19.7
            ],
            [
              110.57,
              19.26
            ],
            [
              110.34,
              18.68
            ],
            [
              109.48,
              18.2
            ]
          ]
        ],
        [
          [
            [
              80.26,
              42.35
            ],
            [
              80.18,
              42.92
            ],
            [
              80.87,
              43.18
            ],
            [
              79.97,
              44.92
            ],
            [
              81.95,
              45.32
            ],
            [
              82.46,
              45.54
            ],
            [
              83.18,
              47.33
            ],
            [
              85.16,
              47
            ],
            [
              85.72,
              47.45
            ],
            [
              85.77,
              48.46
            ],
            [
              86.6,
              48.55
            ],
            [
              87.36,
              49.22
            ],
            [
              87.75,
              49.3
            ],
            [
              88.02,
              48.6
            ],
            [
              88.85,
              48.07
            ],
            [
              90.28,
              47.69
            ],
            [
              90.97,
              46.89
            ],
            [
              90.59,
              45.72
            ],
            [
              90.95,
              45.29
            ],
            [
              92.13,
              45.12
            ],
            [
              93.48,
              44.98
            ],
            [
              94.69,
              44.35
            ],
            [
              95.31,
              44.24
            ],
            [
              95.76,
              43.32
            ],
            [
              96.35,
              42.73
            ],
            [
              97.45,
              42.75
            ],
            [
              99.52,
              42.52
            ],
            [
              100.85,
              42.66
            ],
            [
              101.83,
              42.51
            ],
            [
              103.31,
              41.91
            ],
            [
              104.52,
              41.91
            ],
            [
              104.96,
              41.6
            ],
            [
              106.13,
              42.14
            ],
            [
              107.74,
              42.48
            ],
            [
              109.24,
              42.52
            ],
            [
              110.41,
              42.87
            ],
            [
              111.13,
              43.41
            ],
            [
              111.83,
              43.74
            ],
            [
              111.67,
              44.07
            ],
            [
              111.35,
              44.46
            ],
            [
              111.87,
              45.1
            ],
            [
              112.43,
              45.01
            ],
            [
              113.46,
              44.81
            ],
            [
              114.46,
              45.34
            ],
            [
              115.98,
              45.73
            ],
            [
              116.72,
              46.39
            ],
            [
              117.42,
              46.67
            ],
            [
              118.87,
              46.8
            ],
            [
              119.66,
              46.69
            ],
            [
              119.77,
              47.05
            ],
            [
              118.87,
              47.75
            ],
            [
              118.06,
              48.07
            ],
            [
              117.29,
              47.7
            ],
            [
              116.31,
              47.85
            ],
            [
              115.74,
              47.73
            ],
            [
              115.48,
              48.14
            ],
            [
              116.19,
              49.13
            ],
            [
              116.68,
              49.89
            ],
            [
              117.88,
              49.51
            ],
            [
              119.29,
              50.14
            ],
            [
              119.28,
              50.58
            ],
            [
              120.18,
              51.64
            ],
            [
              120.74,
              51.96
            ],
            [
              120.73,
              52.52
            ],
            [
              120.18,
              52.75
            ],
            [
              121,
              53.25
            ],
            [
              122.24,
              53.43
            ],
            [
              123.57,
              53.46
            ],
            [
              125.07,
              53.16
            ],
            [
              125.95,
              52.79
            ],
            [
              126.56,
              51.78
            ],
            [
              126.94,
              51.35
            ],
            [
              127.29,
              50.74
            ],
            [
              127.66,
              49.76
            ],
            [
              129.4,
              49.44
            ],
            [
              130.58,
              48.73
            ],
            [
              130.99,
              47.79
            ],
            [
              132.51,
              47.79
            ],
            [
              133.37,
              48.18
            ],
            [
              135.02,
              48.48
            ],
            [
              134.5,
              47.58
            ],
            [
              134.11,
              47.21
            ],
            [
              133.77,
              46.12
            ],
            [
              133.1,
              45.14
            ],
            [
              131.88,
              45.32
            ],
            [
              131.03,
              44.97
            ],
            [
              131.29,
              44.11
            ],
            [
              131.14,
              42.93
            ],
            [
              130.63,
              42.9
            ],
            [
              130.64,
              42.4
            ],
            [
              130,
              42.98
            ],
            [
              129.6,
              42.42
            ],
            [
              128.05,
              41.99
            ],
            [
              128.21,
              41.47
            ],
            [
              127.34,
              41.5
            ],
            [
              126.87,
              41.82
            ],
            [
              126.18,
              41.11
            ],
            [
              125.08,
              40.57
            ],
            [
              124.26,
              39.93
            ],
            [
              122.87,
              39.64
            ],
            [
              122.13,
              39.17
            ],
            [
              121.05,
              38.9
            ],
            [
              121.59,
              39.36
            ],
            [
              121.38,
              39.75
            ],
            [
              122.17,
              40.42
            ],
            [
              121.64,
              40.95
            ],
            [
              120.77,
              40.59
            ],
            [
              119.64,
              39.9
            ],
            [
              119.02,
              39.25
            ],
            [
              118.04,
              39.2
            ],
            [
              117.53,
              38.74
            ],
            [
              118.06,
              38.06
            ],
            [
              118.88,
              37.9
            ],
            [
              118.91,
              37.45
            ],
            [
              119.7,
              37.16
            ],
            [
              120.82,
              37.87
            ],
            [
              121.71,
              37.48
            ],
            [
              122.36,
              37.46
            ],
            [
              122.52,
              36.93
            ],
            [
              121.1,
              36.65
            ],
            [
              120.64,
              36.11
            ],
            [
              119.66,
              35.61
            ],
            [
              119.15,
              34.91
            ],
            [
              120.23,
              34.36
            ],
            [
              120.62,
              33.38
            ],
            [
              121.23,
              32.46
            ],
            [
              121.91,
              31.69
            ],
            [
              121.89,
              30.95
            ],
            [
              121.27,
              30.68
            ],
            [
              121.5,
              30.14
            ],
            [
              122.09,
              29.83
            ],
            [
              121.94,
              29.02
            ],
            [
              121.68,
              28.23
            ],
            [
              121.13,
              28.14
            ],
            [
              120.39,
              27.05
            ],
            [
              119.58,
              25.74
            ],
            [
              118.66,
              24.55
            ],
            [
              117.28,
              23.63
            ],
            [
              115.89,
              22.78
            ],
            [
              114.76,
              22.67
            ],
            [
              114.15,
              22.22
            ],
            [
              113.81,
              22.55
            ],
            [
              113.24,
              22.05
            ],
            [
              111.84,
              21.55
            ],
            [
              110.79,
              21.4
            ],
            [
              110.44,
              20.34
            ],
            [
              109.89,
              20.28
            ],
            [
              109.63,
              21.01
            ],
            [
              109.86,
              21.39
            ],
            [
              108.52,
              21.71
            ],
            [
              108.05,
              21.55
            ],
            [
              107.04,
              21.81
            ],
            [
              106.57,
              22.22
            ],
            [
              106.72,
              22.79
            ],
            [
              105.81,
              22.98
            ],
            [
              105.33,
              23.35
            ],
            [
              104.48,
              22.82
            ],
            [
              103.5,
              22.7
            ],
            [
              102.71,
              22.71
            ],
            [
              102.17,
              22.46
            ],
            [
              101.65,
              22.32
            ],
            [
              101.8,
              21.17
            ],
            [
              101.27,
              21.2
            ],
            [
              101.18,
              21.44
            ],
            [
              101.15,
              21.85
            ],
            [
              100.42,
              21.56
            ],
            [
              99.98,
              21.74
            ],
            [
              99.24,
              22.12
            ],
            [
              99.53,
              22.95
            ],
            [
              98.9,
              23.14
            ],
            [
              98.66,
              24.06
            ],
            [
              97.61,
              23.9
            ],
            [
              97.72,
              25.08
            ],
            [
              98.67,
              25.92
            ],
            [
              98.71,
              26.74
            ],
            [
              98.68,
              27.51
            ],
            [
              98.25,
              27.75
            ],
            [
              97.91,
              28.34
            ],
            [
              97.33,
              28.26
            ],
            [
              96.25,
              28.41
            ],
            [
              96.59,
              28.83
            ],
            [
              96.12,
              29.45
            ],
            [
              95.41,
              29.03
            ],
            [
              94.57,
              29.28
            ],
            [
              93.41,
              28.64
            ],
            [
              92.5,
              27.9
            ],
            [
              91.7,
              27.77
            ],
            [
              91.26,
              28.04
            ],
            [
              90.73,
              28.06
            ],
            [
              90.02,
              28.3
            ],
            [
              89.48,
              28.04
            ],
            [
              88.81,
              27.3
            ],
            [
              88.73,
              28.09
            ],
            [
              88.12,
              27.88
            ],
            [
              86.95,
              27.97
            ],
            [
              85.82,
              28.2
            ],
            [
              85.01,
              28.64
            ],
            [
              84.24,
              28.84
            ],
            [
              83.9,
              29.32
            ],
            [
              83.34,
              29.46
            ],
            [
              82.33,
              30.11
            ],
            [
              81.52,
              30.42
            ],
            [
              81.11,
              30.18
            ],
            [
              79.72,
              30.88
            ],
            [
              78.74,
              31.52
            ],
            [
              78.46,
              32.62
            ],
            [
              79.18,
              32.48
            ],
            [
              79.21,
              32.99
            ],
            [
              78.81,
              33.51
            ],
            [
              78.91,
              34.32
            ],
            [
              77.84,
              35.49
            ],
            [
              76.19,
              35.9
            ],
            [
              75.9,
              36.67
            ],
            [
              75.16,
              37.13
            ],
            [
              74.98,
              37.42
            ],
            [
              74.83,
              37.99
            ],
            [
              74.86,
              38.38
            ],
            [
              74.26,
              38.61
            ],
            [
              73.93,
              38.51
            ],
            [
              73.68,
              39.43
            ],
            [
              73.96,
              39.66
            ],
            [
              73.82,
              39.89
            ],
            [
              74.78,
              40.37
            ],
            [
              75.47,
              40.56
            ],
            [
              76.53,
              40.43
            ],
            [
              76.91,
              41.07
            ],
            [
              78.19,
              41.19
            ],
            [
              78.54,
              41.58
            ],
            [
              80.12,
              42.12
            ],
            [
              80.26,
              42.35
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Taiwan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            121.78,
            24.39
          ],
          [
            121.18,
            22.79
          ],
          [
            120.75,
            21.97
          ],
          [
            120.22,
            22.81
          ],
          [
            120.11,
            23.56
          ],
          [
            120.69,
            24.54
          ],
          [
            121.5,
            25.3
          ],
          [
            121.95,
            25
          ],
          [
            121.78,
            24.39
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Italy"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              10.44,
              46.89
            ],
            [
              11.05,
              46.75
            ],
            [
              11.17,
              46.94
            ],
            [
              12.15,
              47.11
            ],
            [
              12.38,
              46.77
            ],
            [
              13.81,
              46.51
            ],
            [
              13.7,
              46.02
            ],
            [
              13.94,
              45.59
            ],
            [
              13.14,
              45.74
            ],
            [
              12.33,
              45.38
            ],
            [
              12.38,
              44.89
            ],
            [
              12.26,
              44.6
            ],
            [
              12.59,
              44.09
            ],
            [
              13.53,
              43.59
            ],
            [
              14.03,
              42.76
            ],
            [
              15.14,
              41.96
            ],
            [
              15.92,
              41.96
            ],
            [
              16.17,
              41.74
            ],
            [
              15.89,
              41.54
            ],
            [
              16.79,
              41.18
            ],
            [
              17.52,
              40.88
            ],
            [
              18.38,
              40.36
            ],
            [
              18.48,
              40.17
            ],
            [
              18.29,
              39.81
            ],
            [
              17.74,
              40.28
            ],
            [
              16.87,
              40.44
            ],
            [
              16.45,
              39.8
            ],
            [
              17.17,
              39.43
            ],
            [
              17.05,
              38.9
            ],
            [
              16.63,
              38.84
            ],
            [
              16.1,
              37.99
            ],
            [
              15.68,
              37.91
            ],
            [
              15.69,
              38.22
            ],
            [
              15.89,
              38.75
            ],
            [
              16.11,
              38.96
            ],
            [
              15.72,
              39.54
            ],
            [
              15.41,
              40.05
            ],
            [
              15,
              40.17
            ],
            [
              14.7,
              40.61
            ],
            [
              14.06,
              40.79
            ],
            [
              13.63,
              41.19
            ],
            [
              12.89,
              41.25
            ],
            [
              12.11,
              41.71
            ],
            [
              11.19,
              42.36
            ],
            [
              10.51,
              42.93
            ],
            [
              10.2,
              43.92
            ],
            [
              9.7,
              44.04
            ],
            [
              8.89,
              44.37
            ],
            [
              8.43,
              44.23
            ],
            [
              7.85,
              43.77
            ],
            [
              7.44,
              43.69
            ],
            [
              7.55,
              44.13
            ],
            [
              7.01,
              44.25
            ],
            [
              6.75,
              45.03
            ],
            [
              7.1,
              45.33
            ],
            [
              6.8,
              45.71
            ],
            [
              6.84,
              45.99
            ],
            [
              7.27,
              45.78
            ],
            [
              7.76,
              45.82
            ],
            [
              8.32,
              46.16
            ],
            [
              8.49,
              46
            ],
            [
              8.97,
              46.04
            ],
            [
              9.18,
              46.44
            ],
            [
              9.92,
              46.31
            ],
            [
              10.36,
              46.48
            ],
            [
              10.44,
              46.89
            ]
          ]
        ],
        [
          [
            [
              14.76,
              38.14
            ],
            [
              15.52,
              38.23
            ],
            [
              15.16,
              37.44
            ],
            [
              15.31,
              37.13
            ],
            [
              15.1,
              36.62
            ],
            [
              14.33,
              37
            ],
            [
              13.83,
              37.1
            ],
            [
              12.43,
              37.61
            ],
            [
              12.57,
              38.13
            ],
            [
              13.74,
              38.04
            ],
            [
              14.76,
              38.14
            ]
          ]
        ],
        [
          [
            [
              8.71,
              40.9
            ],
            [
              9.21,
              41.21
            ],
            [
              9.81,
              40.5
            ],
            [
              9.67,
              39.18
            ],
            [
              9.21,
              39.24
            ],
            [
              8.81,
              38.91
            ],
            [
              8.43,
              39.17
            ],
            [
              8.39,
              40.38
            ],
            [
              8.16,
              40.95
            ],
            [
              8.71,
              40.9
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Denmark"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              9.92,
              54.98
            ],
            [
              9.28,
              54.83
            ],
            [
              8.53,
              54.96
            ],
            [
              8.12,
              55.52
            ],
            [
              8.09,
              56.54
            ],
            [
              8.26,
              56.81
            ],
            [
              8.54,
              57.11
            ],
            [
              9.42,
              57.17
            ],
            [
              9.78,
              57.45
            ],
            [
              10.58,
              57.73
            ],
            [
              10.55,
              57.22
            ],
            [
              10.25,
              56.89
            ],
            [
              10.37,
              56.61
            ],
            [
              10.91,
              56.46
            ],
            [
              10.67,
              56.08
            ],
            [
              10.37,
              56.19
            ],
            [
              9.65,
              55.47
            ],
            [
              9.92,
              54.98
            ]
          ]
        ],
        [
          [
            [
              12.37,
              56.11
            ],
            [
              12.69,
              55.61
            ],
            [
              12.09,
              54.8
            ],
            [
              11.04,
              55.36
            ],
            [
              10.9,
              55.78
            ],
            [
              12.37,
              56.11
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "United Kingdom"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -6.2,
              53.87
            ],
            [
              -6.95,
              54.07
            ],
            [
              -7.57,
              54.06
            ],
            [
              -7.37,
              54.6
            ],
            [
              -7.57,
              55.13
            ],
            [
              -6.73,
              55.17
            ],
            [
              -5.66,
              54.56
            ],
            [
              -6.2,
              53.87
            ]
          ]
        ],
        [
          [
            [
              -3.09,
              53.4
            ],
            [
              -3.09,
              53.4
            ],
            [
              -2.95,
              53.98
            ],
            [
              -3.62,
              54.6
            ],
            [
              -3.63,
              54.61
            ],
            [
              -4.84,
              54.79
            ],
            [
              -5.08,
              55.06
            ],
            [
              -4.72,
              55.51
            ],
            [
              -5.05,
              55.78
            ],
            [
              -5.59,
              55.31
            ],
            [
              -5.65,
              56.27
            ],
            [
              -6.15,
              56.78
            ],
            [
              -5.79,
              57.82
            ],
            [
              -5.01,
              58.63
            ],
            [
              -4.21,
              58.55
            ],
            [
              -3,
              58.63
            ],
            [
              -4.07,
              57.55
            ],
            [
              -3.05,
              57.69
            ],
            [
              -1.96,
              57.68
            ],
            [
              -2.22,
              56.87
            ],
            [
              -3.12,
              55.97
            ],
            [
              -2.09,
              55.91
            ],
            [
              -2.01,
              55.8
            ],
            [
              -1.11,
              54.62
            ],
            [
              -0.43,
              54.46
            ],
            [
              0.19,
              53.32
            ],
            [
              0.47,
              52.93
            ],
            [
              1.68,
              52.74
            ],
            [
              1.56,
              52.1
            ],
            [
              1.05,
              51.81
            ],
            [
              1.45,
              51.29
            ],
            [
              0.55,
              50.77
            ],
            [
              -0.79,
              50.78
            ],
            [
              -2.49,
              50.5
            ],
            [
              -2.96,
              50.7
            ],
            [
              -3.62,
              50.23
            ],
            [
              -4.54,
              50.34
            ],
            [
              -5.24,
              49.96
            ],
            [
              -5.78,
              50.16
            ],
            [
              -4.31,
              51.21
            ],
            [
              -3.41,
              51.43
            ],
            [
              -3.42,
              51.43
            ],
            [
              -4.98,
              51.59
            ],
            [
              -5.27,
              51.99
            ],
            [
              -4.22,
              52.3
            ],
            [
              -4.77,
              52.84
            ],
            [
              -4.58,
              53.5
            ],
            [
              -3.09,
              53.4
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Iceland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -14.51,
            66.46
          ],
          [
            -14.74,
            65.81
          ],
          [
            -13.61,
            65.13
          ],
          [
            -14.91,
            64.36
          ],
          [
            -17.79,
            63.68
          ],
          [
            -18.66,
            63.5
          ],
          [
            -19.97,
            63.64
          ],
          [
            -22.76,
            63.96
          ],
          [
            -21.78,
            64.4
          ],
          [
            -23.96,
            64.89
          ],
          [
            -22.19,
            65.08
          ],
          [
            -22.23,
            65.38
          ],
          [
            -24.33,
            65.61
          ],
          [
            -23.65,
            66.26
          ],
          [
            -22.13,
            66.41
          ],
          [
            -20.58,
            65.73
          ],
          [
            -19.06,
            66.28
          ],
          [
            -17.8,
            65.99
          ],
          [
            -16.17,
            66.53
          ],
          [
            -14.51,
            66.46
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Azerbaijan"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              46.41,
              41.86
            ],
            [
              46.69,
              41.83
            ],
            [
              47.37,
              41.22
            ],
            [
              47.81,
              41.15
            ],
            [
              47.99,
              41.41
            ],
            [
              48.58,
              41.81
            ],
            [
              49.11,
              41.28
            ],
            [
              49.62,
              40.57
            ],
            [
              50.09,
              40.53
            ],
            [
              50.39,
              40.26
            ],
            [
              49.57,
              40.18
            ],
            [
              49.39,
              39.4
            ],
            [
              49.22,
              39.05
            ],
            [
              48.86,
              38.82
            ],
            [
              48.88,
              38.32
            ],
            [
              48.63,
              38.27
            ],
            [
              48.01,
              38.79
            ],
            [
              48.35,
              39.29
            ],
            [
              48.06,
              39.58
            ],
            [
              47.68,
              39.51
            ],
            [
              46.51,
              38.77
            ],
            [
              46.48,
              39.46
            ],
            [
              46.04,
              39.63
            ],
            [
              45.61,
              39.9
            ],
            [
              45.89,
              40.22
            ],
            [
              45.36,
              40.56
            ],
            [
              45.56,
              40.81
            ],
            [
              45.18,
              40.99
            ],
            [
              44.97,
              41.25
            ],
            [
              45.22,
              41.41
            ],
            [
              45.96,
              41.12
            ],
            [
              46.5,
              41.06
            ],
            [
              46.64,
              41.18
            ],
            [
              46.15,
              41.72
            ],
            [
              46.41,
              41.86
            ]
          ]
        ],
        [
          [
            [
              46.14,
              38.74
            ],
            [
              45.46,
              38.87
            ],
            [
              44.95,
              39.34
            ],
            [
              44.79,
              39.71
            ],
            [
              45,
              39.74
            ],
            [
              45.3,
              39.47
            ],
            [
              45.74,
              39.47
            ],
            [
              45.74,
              39.32
            ],
            [
              46.14,
              38.74
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Georgia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            39.95,
            43.44
          ],
          [
            40.08,
            43.55
          ],
          [
            40.92,
            43.38
          ],
          [
            42.4,
            43.22
          ],
          [
            43.76,
            42.74
          ],
          [
            43.93,
            42.55
          ],
          [
            44.54,
            42.71
          ],
          [
            45.47,
            42.5
          ],
          [
            45.78,
            42.09
          ],
          [
            46.41,
            41.86
          ],
          [
            46.15,
            41.72
          ],
          [
            46.64,
            41.18
          ],
          [
            46.5,
            41.06
          ],
          [
            45.96,
            41.12
          ],
          [
            45.22,
            41.41
          ],
          [
            44.97,
            41.25
          ],
          [
            43.58,
            41.09
          ],
          [
            42.62,
            41.58
          ],
          [
            41.55,
            41.54
          ],
          [
            41.7,
            41.96
          ],
          [
            41.45,
            42.64
          ],
          [
            40.88,
            43.01
          ],
          [
            40.32,
            43.13
          ],
          [
            39.95,
            43.44
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Philippines"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              120.83,
              12.7
            ],
            [
              120.32,
              13.47
            ],
            [
              121.18,
              13.43
            ],
            [
              121.53,
              13.07
            ],
            [
              121.26,
              12.21
            ],
            [
              120.83,
              12.7
            ]
          ]
        ],
        [
          [
            [
              122.59,
              9.98
            ],
            [
              122.84,
              10.26
            ],
            [
              122.95,
              10.88
            ],
            [
              123.5,
              10.94
            ],
            [
              123.34,
              10.27
            ],
            [
              124.08,
              11.23
            ],
            [
              123.98,
              10.28
            ],
            [
              123.62,
              9.95
            ],
            [
              123.31,
              9.32
            ],
            [
              123,
              9.02
            ],
            [
              122.38,
              9.71
            ],
            [
              122.59,
              9.98
            ]
          ]
        ],
        [
          [
            [
              126.38,
              8.41
            ],
            [
              126.48,
              7.75
            ],
            [
              126.54,
              7.19
            ],
            [
              126.2,
              6.27
            ],
            [
              125.83,
              7.29
            ],
            [
              125.36,
              6.79
            ],
            [
              125.68,
              6.05
            ],
            [
              125.4,
              5.58
            ],
            [
              124.22,
              6.16
            ],
            [
              123.94,
              6.89
            ],
            [
              124.24,
              7.36
            ],
            [
              123.61,
              7.83
            ],
            [
              123.3,
              7.42
            ],
            [
              122.82,
              7.46
            ],
            [
              122.09,
              6.9
            ],
            [
              121.92,
              7.19
            ],
            [
              122.31,
              8.04
            ],
            [
              122.94,
              8.32
            ],
            [
              123.49,
              8.69
            ],
            [
              123.84,
              8.24
            ],
            [
              124.6,
              8.51
            ],
            [
              124.76,
              8.96
            ],
            [
              125.47,
              8.99
            ],
            [
              125.41,
              9.76
            ],
            [
              126.22,
              9.29
            ],
            [
              126.31,
              8.78
            ],
            [
              126.38,
              8.41
            ]
          ]
        ],
        [
          [
            [
              118.5,
              9.32
            ],
            [
              117.18,
              8.37
            ],
            [
              117.67,
              9.07
            ],
            [
              118.39,
              9.68
            ],
            [
              118.99,
              10.38
            ],
            [
              119.51,
              11.37
            ],
            [
              119.69,
              10.55
            ],
            [
              119.03,
              10
            ],
            [
              118.5,
              9.32
            ]
          ]
        ],
        [
          [
            [
              122.34,
              18.22
            ],
            [
              122.17,
              17.81
            ],
            [
              122.51,
              17.09
            ],
            [
              122.25,
              16.26
            ],
            [
              121.66,
              15.93
            ],
            [
              121.51,
              15.13
            ],
            [
              121.73,
              14.33
            ],
            [
              122.26,
              14.22
            ],
            [
              122.7,
              14.34
            ],
            [
              123.95,
              13.78
            ],
            [
              123.85,
              13.24
            ],
            [
              124.18,
              13
            ],
            [
              124.08,
              12.54
            ],
            [
              123.3,
              13.03
            ],
            [
              122.93,
              13.55
            ],
            [
              122.67,
              13.19
            ],
            [
              122.04,
              13.78
            ],
            [
              121.13,
              13.64
            ],
            [
              120.63,
              13.86
            ],
            [
              120.68,
              14.27
            ],
            [
              120.99,
              14.53
            ],
            [
              120.69,
              14.76
            ],
            [
              120.56,
              14.4
            ],
            [
              120.07,
              14.97
            ],
            [
              119.92,
              15.41
            ],
            [
              119.88,
              16.36
            ],
            [
              120.29,
              16.03
            ],
            [
              120.39,
              17.6
            ],
            [
              120.71,
              18.51
            ],
            [
              121.32,
              18.5
            ],
            [
              121.94,
              18.22
            ],
            [
              122.24,
              18.48
            ],
            [
              122.34,
              18.22
            ]
          ]
        ],
        [
          [
            [
              122.04,
              11.42
            ],
            [
              121.88,
              11.89
            ],
            [
              122.48,
              11.58
            ],
            [
              123.12,
              11.58
            ],
            [
              123.1,
              11.17
            ],
            [
              122.64,
              10.74
            ],
            [
              122,
              10.44
            ],
            [
              121.97,
              10.91
            ],
            [
              122.04,
              11.42
            ]
          ]
        ],
        [
          [
            [
              125.5,
              12.16
            ],
            [
              125.78,
              11.05
            ],
            [
              125.01,
              11.31
            ],
            [
              125.03,
              10.98
            ],
            [
              125.28,
              10.36
            ],
            [
              124.8,
              10.13
            ],
            [
              124.76,
              10.84
            ],
            [
              124.46,
              10.89
            ],
            [
              124.3,
              11.49
            ],
            [
              124.89,
              11.42
            ],
            [
              124.88,
              11.79
            ],
            [
              124.27,
              12.56
            ],
            [
              125.23,
              12.54
            ],
            [
              125.5,
              12.16
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Malaysia"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              100.09,
              6.46
            ],
            [
              100.26,
              6.64
            ],
            [
              101.08,
              6.21
            ],
            [
              101.16,
              5.69
            ],
            [
              101.81,
              5.81
            ],
            [
              102.14,
              6.22
            ],
            [
              102.37,
              6.13
            ],
            [
              102.96,
              5.53
            ],
            [
              103.38,
              4.85
            ],
            [
              103.44,
              4.18
            ],
            [
              103.33,
              3.73
            ],
            [
              103.43,
              3.38
            ],
            [
              103.5,
              2.79
            ],
            [
              103.86,
              2.52
            ],
            [
              104.25,
              1.63
            ],
            [
              104.23,
              1.29
            ],
            [
              103.52,
              1.23
            ],
            [
              102.57,
              1.97
            ],
            [
              101.39,
              2.76
            ],
            [
              101.27,
              3.27
            ],
            [
              100.69,
              3.94
            ],
            [
              100.56,
              4.77
            ],
            [
              100.2,
              5.31
            ],
            [
              100.31,
              6.04
            ],
            [
              100.09,
              6.46
            ]
          ]
        ],
        [
          [
            [
              117.88,
              4.14
            ],
            [
              117.01,
              4.31
            ],
            [
              115.87,
              4.31
            ],
            [
              115.52,
              3.17
            ],
            [
              115.13,
              2.82
            ],
            [
              114.62,
              1.43
            ],
            [
              113.81,
              1.22
            ],
            [
              112.86,
              1.5
            ],
            [
              112.38,
              1.41
            ],
            [
              111.8,
              0.9
            ],
            [
              111.16,
              0.98
            ],
            [
              110.52,
              0.77
            ],
            [
              109.83,
              1.34
            ],
            [
              109.66,
              2.01
            ],
            [
              110.4,
              1.66
            ],
            [
              111.17,
              1.85
            ],
            [
              111.37,
              2.7
            ],
            [
              111.8,
              2.89
            ],
            [
              113,
              3.1
            ],
            [
              113.71,
              3.89
            ],
            [
              114.21,
              4.53
            ],
            [
              114.66,
              4.01
            ],
            [
              114.87,
              4.35
            ],
            [
              115.35,
              4.32
            ],
            [
              115.4,
              4.95
            ],
            [
              115.45,
              5.45
            ],
            [
              116.22,
              6.14
            ],
            [
              116.73,
              6.92
            ],
            [
              117.13,
              6.93
            ],
            [
              117.64,
              6.42
            ],
            [
              117.69,
              5.99
            ],
            [
              118.35,
              5.71
            ],
            [
              119.18,
              5.41
            ],
            [
              119.11,
              5.02
            ],
            [
              118.44,
              4.97
            ],
            [
              118.62,
              4.48
            ],
            [
              117.88,
              4.14
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Brunei"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            115.45,
            5.45
          ],
          [
            115.4,
            4.95
          ],
          [
            115.35,
            4.32
          ],
          [
            114.87,
            4.35
          ],
          [
            114.66,
            4.01
          ],
          [
            114.21,
            4.53
          ],
          [
            114.6,
            4.9
          ],
          [
            115.45,
            5.45
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Slovenia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            13.81,
            46.51
          ],
          [
            14.63,
            46.43
          ],
          [
            15.14,
            46.66
          ],
          [
            16.01,
            46.68
          ],
          [
            16.2,
            46.85
          ],
          [
            16.37,
            46.84
          ],
          [
            16.57,
            46.5
          ],
          [
            15.77,
            46.24
          ],
          [
            15.67,
            45.83
          ],
          [
            15.32,
            45.73
          ],
          [
            15.33,
            45.45
          ],
          [
            14.93,
            45.47
          ],
          [
            14.6,
            45.64
          ],
          [
            14.41,
            45.47
          ],
          [
            13.71,
            45.5
          ],
          [
            13.94,
            45.59
          ],
          [
            13.7,
            46.02
          ],
          [
            13.81,
            46.51
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Finland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            28.59,
            69.07
          ],
          [
            28.45,
            68.36
          ],
          [
            29.98,
            67.7
          ],
          [
            29.05,
            66.94
          ],
          [
            30.22,
            65.81
          ],
          [
            29.54,
            64.95
          ],
          [
            30.44,
            64.2
          ],
          [
            30.04,
            63.55
          ],
          [
            31.52,
            62.87
          ],
          [
            31.14,
            62.36
          ],
          [
            30.21,
            61.78
          ],
          [
            28.07,
            60.5
          ],
          [
            26.26,
            60.42
          ],
          [
            24.5,
            60.06
          ],
          [
            22.87,
            59.85
          ],
          [
            22.29,
            60.39
          ],
          [
            21.32,
            60.72
          ],
          [
            21.54,
            61.7
          ],
          [
            21.06,
            62.61
          ],
          [
            21.54,
            63.19
          ],
          [
            22.44,
            63.82
          ],
          [
            24.73,
            64.9
          ],
          [
            25.4,
            65.11
          ],
          [
            25.3,
            65.53
          ],
          [
            23.9,
            66.01
          ],
          [
            23.57,
            66.4
          ],
          [
            23.54,
            67.94
          ],
          [
            21.98,
            68.62
          ],
          [
            20.64,
            69.11
          ],
          [
            21.25,
            69.37
          ],
          [
            22.36,
            68.84
          ],
          [
            23.66,
            68.89
          ],
          [
            24.73,
            68.65
          ],
          [
            25.69,
            69.09
          ],
          [
            26.18,
            69.83
          ],
          [
            27.73,
            70.16
          ],
          [
            29.01,
            69.77
          ],
          [
            28.59,
            69.07
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Slovakia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            22.56,
            49.09
          ],
          [
            22.28,
            48.83
          ],
          [
            22.08,
            48.42
          ],
          [
            21.87,
            48.32
          ],
          [
            20.8,
            48.62
          ],
          [
            20.48,
            48.56
          ],
          [
            20.24,
            48.33
          ],
          [
            19.77,
            48.2
          ],
          [
            19.66,
            48.27
          ],
          [
            19.18,
            48.11
          ],
          [
            18.78,
            48.08
          ],
          [
            18.7,
            47.88
          ],
          [
            17.86,
            47.76
          ],
          [
            17.49,
            47.87
          ],
          [
            16.98,
            48.12
          ],
          [
            16.88,
            48.47
          ],
          [
            16.96,
            48.6
          ],
          [
            17.1,
            48.82
          ],
          [
            17.54,
            48.8
          ],
          [
            17.89,
            48.9
          ],
          [
            17.91,
            49
          ],
          [
            18.11,
            49.04
          ],
          [
            18.17,
            49.27
          ],
          [
            18.4,
            49.31
          ],
          [
            18.56,
            49.49
          ],
          [
            18.85,
            49.5
          ],
          [
            18.91,
            49.44
          ],
          [
            19.32,
            49.57
          ],
          [
            19.82,
            49.22
          ],
          [
            20.42,
            49.43
          ],
          [
            20.89,
            49.33
          ],
          [
            21.61,
            49.47
          ],
          [
            22.56,
            49.09
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Czechia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            15.02,
            51.11
          ],
          [
            15.49,
            50.78
          ],
          [
            16.24,
            50.7
          ],
          [
            16.18,
            50.42
          ],
          [
            16.72,
            50.22
          ],
          [
            16.87,
            50.47
          ],
          [
            17.56,
            50.36
          ],
          [
            17.65,
            50.05
          ],
          [
            18.39,
            49.99
          ],
          [
            18.85,
            49.5
          ],
          [
            18.56,
            49.49
          ],
          [
            18.4,
            49.31
          ],
          [
            18.17,
            49.27
          ],
          [
            18.11,
            49.04
          ],
          [
            17.91,
            49
          ],
          [
            17.89,
            48.9
          ],
          [
            17.54,
            48.8
          ],
          [
            17.1,
            48.82
          ],
          [
            16.96,
            48.6
          ],
          [
            16.5,
            48.79
          ],
          [
            16.03,
            48.73
          ],
          [
            15.26,
            49.04
          ],
          [
            14.9,
            48.96
          ],
          [
            14.34,
            48.56
          ],
          [
            13.6,
            48.88
          ],
          [
            13.03,
            49.31
          ],
          [
            12.52,
            49.55
          ],
          [
            12.41,
            49.97
          ],
          [
            12.24,
            50.27
          ],
          [
            12.97,
            50.48
          ],
          [
            13.34,
            50.73
          ],
          [
            14.06,
            50.93
          ],
          [
            14.31,
            51.12
          ],
          [
            14.57,
            51
          ],
          [
            15.02,
            51.11
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Eritrea"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            36.43,
            14.42
          ],
          [
            36.32,
            14.82
          ],
          [
            36.75,
            16.29
          ],
          [
            36.85,
            16.96
          ],
          [
            37.17,
            17.26
          ],
          [
            37.9,
            17.43
          ],
          [
            38.41,
            18
          ],
          [
            38.99,
            16.84
          ],
          [
            39.27,
            15.92
          ],
          [
            39.81,
            15.44
          ],
          [
            41.18,
            14.49
          ],
          [
            41.73,
            13.92
          ],
          [
            42.28,
            13.34
          ],
          [
            42.59,
            13
          ],
          [
            43.08,
            12.7
          ],
          [
            42.78,
            12.46
          ],
          [
            42.35,
            12.54
          ],
          [
            42.01,
            12.87
          ],
          [
            41.6,
            13.45
          ],
          [
            41.15,
            13.77
          ],
          [
            40.9,
            14.12
          ],
          [
            40.03,
            14.52
          ],
          [
            39.34,
            14.53
          ],
          [
            39.1,
            14.74
          ],
          [
            38.51,
            14.51
          ],
          [
            37.91,
            14.96
          ],
          [
            37.59,
            14.21
          ],
          [
            36.43,
            14.42
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Japan"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              141.88,
              39.18
            ],
            [
              140.96,
              38.17
            ],
            [
              140.98,
              37.14
            ],
            [
              140.6,
              36.34
            ],
            [
              140.77,
              35.84
            ],
            [
              140.25,
              35.14
            ],
            [
              138.97,
              34.67
            ],
            [
              137.22,
              34.61
            ],
            [
              135.79,
              33.46
            ],
            [
              135.12,
              33.85
            ],
            [
              135.08,
              34.6
            ],
            [
              133.34,
              34.38
            ],
            [
              132.16,
              33.9
            ],
            [
              130.99,
              33.89
            ],
            [
              132,
              33.15
            ],
            [
              131.33,
              31.45
            ],
            [
              130.69,
              31.03
            ],
            [
              130.2,
              31.42
            ],
            [
              130.45,
              32.32
            ],
            [
              129.82,
              32.61
            ],
            [
              129.41,
              33.3
            ],
            [
              130.36,
              33.6
            ],
            [
              130.88,
              34.23
            ],
            [
              131.89,
              34.75
            ],
            [
              132.62,
              35.43
            ],
            [
              134.61,
              35.73
            ],
            [
              135.68,
              35.53
            ],
            [
              136.72,
              37.3
            ],
            [
              137.39,
              36.83
            ],
            [
              138.86,
              37.83
            ],
            [
              139.43,
              38.22
            ],
            [
              140.05,
              39.44
            ],
            [
              139.88,
              40.56
            ],
            [
              140.31,
              41.2
            ],
            [
              141.37,
              41.38
            ],
            [
              141.92,
              39.99
            ],
            [
              141.88,
              39.18
            ]
          ]
        ],
        [
          [
            [
              144.61,
              43.96
            ],
            [
              145.32,
              44.38
            ],
            [
              145.54,
              43.26
            ],
            [
              144.06,
              42.99
            ],
            [
              143.18,
              41.99
            ],
            [
              141.61,
              42.68
            ],
            [
              141.07,
              41.59
            ],
            [
              139.96,
              41.57
            ],
            [
              139.82,
              42.56
            ],
            [
              140.31,
              43.33
            ],
            [
              141.38,
              43.39
            ],
            [
              141.67,
              44.77
            ],
            [
              141.97,
              45.55
            ],
            [
              143.14,
              44.51
            ],
            [
              143.91,
              44.17
            ],
            [
              144.61,
              43.96
            ]
          ]
        ],
        [
          [
            [
              132.37,
              33.46
            ],
            [
              132.93,
              34.06
            ],
            [
              133.49,
              33.94
            ],
            [
              133.91,
              34.36
            ],
            [
              134.64,
              34.15
            ],
            [
              134.77,
              33.81
            ],
            [
              134.2,
              33.2
            ],
            [
              133.79,
              33.52
            ],
            [
              133.28,
              33.29
            ],
            [
              133.02,
              32.7
            ],
            [
              132.36,
              32.99
            ],
            [
              132.37,
              33.46
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Paraguay"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -58.17,
            -20.18
          ],
          [
            -57.87,
            -20.73
          ],
          [
            -57.94,
            -22.09
          ],
          [
            -56.88,
            -22.28
          ],
          [
            -56.47,
            -22.09
          ],
          [
            -55.8,
            -22.36
          ],
          [
            -55.61,
            -22.66
          ],
          [
            -55.52,
            -23.57
          ],
          [
            -55.4,
            -23.96
          ],
          [
            -55.03,
            -24
          ],
          [
            -54.65,
            -23.84
          ],
          [
            -54.29,
            -24.02
          ],
          [
            -54.29,
            -24.57
          ],
          [
            -54.43,
            -25.16
          ],
          [
            -54.63,
            -25.74
          ],
          [
            -54.79,
            -26.62
          ],
          [
            -55.69,
            -27.39
          ],
          [
            -56.49,
            -27.55
          ],
          [
            -57.61,
            -27.4
          ],
          [
            -58.62,
            -27.12
          ],
          [
            -57.63,
            -25.6
          ],
          [
            -57.78,
            -25.16
          ],
          [
            -58.81,
            -24.77
          ],
          [
            -60.03,
            -24.03
          ],
          [
            -60.85,
            -23.88
          ],
          [
            -62.69,
            -22.25
          ],
          [
            -62.29,
            -21.05
          ],
          [
            -62.26,
            -20.51
          ],
          [
            -61.79,
            -19.63
          ],
          [
            -60.04,
            -19.34
          ],
          [
            -59.11,
            -19.36
          ],
          [
            -58.18,
            -19.87
          ],
          [
            -58.17,
            -20.18
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Yemen"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            52,
            19
          ],
          [
            52.78,
            17.35
          ],
          [
            53.11,
            16.65
          ],
          [
            52.39,
            16.38
          ],
          [
            52.19,
            15.94
          ],
          [
            52.17,
            15.6
          ],
          [
            51.17,
            15.18
          ],
          [
            49.57,
            14.71
          ],
          [
            48.68,
            14
          ],
          [
            48.24,
            13.95
          ],
          [
            47.94,
            14.01
          ],
          [
            47.35,
            13.59
          ],
          [
            46.72,
            13.4
          ],
          [
            45.88,
            13.35
          ],
          [
            45.63,
            13.29
          ],
          [
            45.41,
            13.03
          ],
          [
            45.14,
            12.95
          ],
          [
            44.99,
            12.7
          ],
          [
            44.49,
            12.72
          ],
          [
            44.17,
            12.59
          ],
          [
            43.48,
            12.64
          ],
          [
            43.22,
            13.22
          ],
          [
            43.25,
            13.77
          ],
          [
            43.09,
            14.06
          ],
          [
            42.89,
            14.8
          ],
          [
            42.6,
            15.21
          ],
          [
            42.81,
            15.26
          ],
          [
            42.7,
            15.72
          ],
          [
            42.82,
            15.91
          ],
          [
            42.78,
            16.35
          ],
          [
            43.22,
            16.67
          ],
          [
            43.12,
            17.09
          ],
          [
            43.38,
            17.58
          ],
          [
            43.79,
            17.32
          ],
          [
            44.06,
            17.41
          ],
          [
            45.22,
            17.43
          ],
          [
            45.4,
            17.33
          ],
          [
            46.37,
            17.23
          ],
          [
            46.75,
            17.28
          ],
          [
            47,
            16.95
          ],
          [
            47.47,
            17.12
          ],
          [
            48.18,
            18.17
          ],
          [
            49.12,
            18.62
          ],
          [
            52,
            19
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Saudi Arabia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            34.95,
            29.36
          ],
          [
            36.07,
            29.2
          ],
          [
            36.5,
            29.51
          ],
          [
            36.74,
            29.87
          ],
          [
            37.5,
            30
          ],
          [
            37.67,
            30.34
          ],
          [
            38,
            30.51
          ],
          [
            37,
            31.51
          ],
          [
            39,
            32.01
          ],
          [
            39.2,
            32.16
          ],
          [
            40.4,
            31.89
          ],
          [
            41.89,
            31.19
          ],
          [
            44.71,
            29.18
          ],
          [
            46.57,
            29.1
          ],
          [
            47.46,
            29
          ],
          [
            47.71,
            28.53
          ],
          [
            48.42,
            28.55
          ],
          [
            48.81,
            27.69
          ],
          [
            49.3,
            27.46
          ],
          [
            49.47,
            27.11
          ],
          [
            50.15,
            26.69
          ],
          [
            50.21,
            26.28
          ],
          [
            50.11,
            25.94
          ],
          [
            50.24,
            25.61
          ],
          [
            50.53,
            25.33
          ],
          [
            50.66,
            25
          ],
          [
            50.81,
            24.75
          ],
          [
            51.11,
            24.56
          ],
          [
            51.39,
            24.63
          ],
          [
            51.58,
            24.24
          ],
          [
            51.62,
            24.01
          ],
          [
            52,
            23
          ],
          [
            55.01,
            22.5
          ],
          [
            55.21,
            22.71
          ],
          [
            55.67,
            22
          ],
          [
            55,
            20
          ],
          [
            52,
            19
          ],
          [
            49.12,
            18.62
          ],
          [
            48.18,
            18.17
          ],
          [
            47.47,
            17.12
          ],
          [
            47,
            16.95
          ],
          [
            46.75,
            17.28
          ],
          [
            46.37,
            17.23
          ],
          [
            45.4,
            17.33
          ],
          [
            45.22,
            17.43
          ],
          [
            44.06,
            17.41
          ],
          [
            43.79,
            17.32
          ],
          [
            43.38,
            17.58
          ],
          [
            43.12,
            17.09
          ],
          [
            43.22,
            16.67
          ],
          [
            42.78,
            16.35
          ],
          [
            42.65,
            16.77
          ],
          [
            42.35,
            17.08
          ],
          [
            42.27,
            17.47
          ],
          [
            41.76,
            17.83
          ],
          [
            41.22,
            18.67
          ],
          [
            40.94,
            19.49
          ],
          [
            40.25,
            20.17
          ],
          [
            39.8,
            20.34
          ],
          [
            39.14,
            21.29
          ],
          [
            39.02,
            21.99
          ],
          [
            39.07,
            22.58
          ],
          [
            38.49,
            23.69
          ],
          [
            38.03,
            24.08
          ],
          [
            37.49,
            24.29
          ],
          [
            37.15,
            24.86
          ],
          [
            37.21,
            25.08
          ],
          [
            36.93,
            25.6
          ],
          [
            36.64,
            25.83
          ],
          [
            36.25,
            26.57
          ],
          [
            35.64,
            27.38
          ],
          [
            35.13,
            28.06
          ],
          [
            34.63,
            28.06
          ],
          [
            34.79,
            28.61
          ],
          [
            34.83,
            28.96
          ],
          [
            34.95,
            29.36
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Antarctica"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -48.66,
              -78.05
            ],
            [
              -48.15,
              -78.05
            ],
            [
              -46.66,
              -77.83
            ],
            [
              -45.15,
              -78.05
            ],
            [
              -43.92,
              -78.48
            ],
            [
              -43.49,
              -79.09
            ],
            [
              -43.37,
              -79.52
            ],
            [
              -43.33,
              -80.03
            ],
            [
              -44.88,
              -80.34
            ],
            [
              -46.51,
              -80.59
            ],
            [
              -48.39,
              -80.83
            ],
            [
              -50.48,
              -81.03
            ],
            [
              -52.85,
              -80.97
            ],
            [
              -54.16,
              -80.63
            ],
            [
              -53.99,
              -80.22
            ],
            [
              -51.85,
              -79.95
            ],
            [
              -50.99,
              -79.61
            ],
            [
              -50.37,
              -79.18
            ],
            [
              -49.91,
              -78.81
            ],
            [
              -49.31,
              -78.46
            ],
            [
              -48.66,
              -78.05
            ]
          ]
        ],
        [
          [
            [
              -66.29,
              -80.26
            ],
            [
              -64.04,
              -80.29
            ],
            [
              -61.88,
              -80.39
            ],
            [
              -61.14,
              -79.98
            ],
            [
              -60.61,
              -79.63
            ],
            [
              -59.57,
              -80.04
            ],
            [
              -59.87,
              -80.55
            ],
            [
              -60.16,
              -81
            ],
            [
              -62.25,
              -80.86
            ],
            [
              -64.49,
              -80.92
            ],
            [
              -65.74,
              -80.59
            ],
            [
              -65.74,
              -80.55
            ],
            [
              -66.29,
              -80.26
            ]
          ]
        ],
        [
          [
            [
              -73.91,
              -71.27
            ],
            [
              -73.23,
              -71.15
            ],
            [
              -72.07,
              -71.19
            ],
            [
              -71.78,
              -70.68
            ],
            [
              -71.72,
              -70.31
            ],
            [
              -71.74,
              -69.51
            ],
            [
              -71.17,
              -69.04
            ],
            [
              -70.25,
              -68.88
            ],
            [
              -69.72,
              -69.25
            ],
            [
              -69.49,
              -69.62
            ],
            [
              -69.06,
              -70.07
            ],
            [
              -68.73,
              -70.5
            ],
            [
              -68.45,
              -70.96
            ],
            [
              -68.33,
              -71.41
            ],
            [
              -68.51,
              -71.8
            ],
            [
              -68.78,
              -72.17
            ],
            [
              -69.96,
              -72.31
            ],
            [
              -71.08,
              -72.5
            ],
            [
              -72.39,
              -72.48
            ],
            [
              -71.9,
              -72.09
            ],
            [
              -73.08,
              -72.23
            ],
            [
              -74.19,
              -72.37
            ],
            [
              -74.95,
              -72.07
            ],
            [
              -75.01,
              -71.66
            ],
            [
              -73.91,
              -71.27
            ]
          ]
        ],
        [
          [
            [
              -102.33,
              -71.89
            ],
            [
              -101.7,
              -71.72
            ],
            [
              -100.43,
              -71.86
            ],
            [
              -98.98,
              -71.93
            ],
            [
              -97.88,
              -72.07
            ],
            [
              -96.79,
              -71.95
            ],
            [
              -96.2,
              -72.52
            ],
            [
              -96.98,
              -72.44
            ],
            [
              -98.2,
              -72.48
            ],
            [
              -99.43,
              -72.44
            ],
            [
              -100.78,
              -72.5
            ],
            [
              -101.8,
              -72.31
            ],
            [
              -102.33,
              -71.89
            ]
          ]
        ],
        [
          [
            [
              -122.62,
              -73.66
            ],
            [
              -122.41,
              -73.32
            ],
            [
              -121.21,
              -73.5
            ],
            [
              -119.92,
              -73.66
            ],
            [
              -118.72,
              -73.48
            ],
            [
              -119.29,
              -73.83
            ],
            [
              -120.23,
              -74.09
            ],
            [
              -121.62,
              -74.01
            ],
            [
              -122.62,
              -73.66
            ]
          ]
        ],
        [
          [
            [
              -127.28,
              -73.46
            ],
            [
              -126.56,
              -73.25
            ],
            [
              -125.56,
              -73.48
            ],
            [
              -124.03,
              -73.87
            ],
            [
              -124.62,
              -73.83
            ],
            [
              -125.91,
              -73.74
            ],
            [
              -127.28,
              -73.46
            ]
          ]
        ],
        [
          [
            [
              -163.71,
              -78.6
            ],
            [
              -163.11,
              -78.22
            ],
            [
              -161.24,
              -78.38
            ],
            [
              -160.25,
              -78.69
            ],
            [
              -159.48,
              -79.05
            ],
            [
              -159.21,
              -79.5
            ],
            [
              -161.13,
              -79.63
            ],
            [
              -162.44,
              -79.28
            ],
            [
              -163.03,
              -78.93
            ],
            [
              -163.07,
              -78.87
            ],
            [
              -163.71,
              -78.6
            ]
          ]
        ],
        [
          [
            [
              -180,
              -84.71
            ],
            [
              -179.94,
              -84.72
            ],
            [
              -179.06,
              -84.14
            ],
            [
              -177.26,
              -84.45
            ],
            [
              -177.14,
              -84.42
            ],
            [
              -176.08,
              -84.1
            ],
            [
              -175.95,
              -84.11
            ],
            [
              -175.83,
              -84.12
            ],
            [
              -174.38,
              -84.53
            ],
            [
              -173.12,
              -84.12
            ],
            [
              -172.89,
              -84.06
            ],
            [
              -169.95,
              -83.88
            ],
            [
              -169,
              -84.12
            ],
            [
              -168.53,
              -84.24
            ],
            [
              -167.02,
              -84.57
            ],
            [
              -164.18,
              -84.83
            ],
            [
              -161.93,
              -85.14
            ],
            [
              -158.07,
              -85.37
            ],
            [
              -155.19,
              -85.1
            ],
            [
              -150.94,
              -85.3
            ],
            [
              -148.53,
              -85.61
            ],
            [
              -145.89,
              -85.31
            ],
            [
              -143.11,
              -85.04
            ],
            [
              -142.89,
              -84.57
            ],
            [
              -146.83,
              -84.53
            ],
            [
              -150.06,
              -84.3
            ],
            [
              -150.9,
              -83.9
            ],
            [
              -153.59,
              -83.69
            ],
            [
              -153.41,
              -83.24
            ],
            [
              -153.04,
              -82.83
            ],
            [
              -152.66,
              -82.45
            ],
            [
              -152.86,
              -82.04
            ],
            [
              -154.53,
              -81.77
            ],
            [
              -155.29,
              -81.41
            ],
            [
              -156.84,
              -81.1
            ],
            [
              -154.41,
              -81.16
            ],
            [
              -152.1,
              -81
            ],
            [
              -150.65,
              -81.34
            ],
            [
              -148.87,
              -81.04
            ],
            [
              -147.22,
              -80.67
            ],
            [
              -146.42,
              -80.34
            ],
            [
              -146.77,
              -79.93
            ],
            [
              -148.06,
              -79.65
            ],
            [
              -149.53,
              -79.36
            ],
            [
              -151.59,
              -79.3
            ],
            [
              -153.39,
              -79.16
            ],
            [
              -155.33,
              -79.06
            ],
            [
              -155.98,
              -78.69
            ],
            [
              -157.27,
              -78.38
            ],
            [
              -158.05,
              -78.03
            ],
            [
              -158.36,
              -76.89
            ],
            [
              -157.87,
              -76.99
            ],
            [
              -156.97,
              -77.3
            ],
            [
              -155.33,
              -77.2
            ],
            [
              -153.74,
              -77.07
            ],
            [
              -152.92,
              -77.5
            ],
            [
              -151.33,
              -77.4
            ],
            [
              -150,
              -77.18
            ],
            [
              -148.75,
              -76.91
            ],
            [
              -147.61,
              -76.58
            ],
            [
              -146.11,
              -76.48
            ],
            [
              -146.15,
              -76.11
            ],
            [
              -146.49,
              -75.73
            ],
            [
              -146.2,
              -75.38
            ],
            [
              -144.91,
              -75.2
            ],
            [
              -144.32,
              -75.54
            ],
            [
              -142.79,
              -75.34
            ],
            [
              -141.64,
              -75.09
            ],
            [
              -140.21,
              -75.07
            ],
            [
              -138.86,
              -74.97
            ],
            [
              -137.51,
              -74.73
            ],
            [
              -136.43,
              -74.52
            ],
            [
              -135.22,
              -74.3
            ],
            [
              -134.43,
              -74.36
            ],
            [
              -133.75,
              -74.44
            ],
            [
              -132.26,
              -74.3
            ],
            [
              -130.92,
              -74.48
            ],
            [
              -129.55,
              -74.46
            ],
            [
              -128.24,
              -74.32
            ],
            [
              -126.89,
              -74.42
            ],
            [
              -125.4,
              -74.52
            ],
            [
              -124.01,
              -74.48
            ],
            [
              -122.56,
              -74.5
            ],
            [
              -121.07,
              -74.52
            ],
            [
              -119.7,
              -74.48
            ],
            [
              -118.68,
              -74.18
            ],
            [
              -117.47,
              -74.03
            ],
            [
              -116.21,
              -74.24
            ],
            [
              -115.02,
              -74.07
            ],
            [
              -113.94,
              -73.72
            ],
            [
              -113.3,
              -74.03
            ],
            [
              -112.95,
              -74.38
            ],
            [
              -112.3,
              -74.71
            ],
            [
              -111.26,
              -74.42
            ],
            [
              -110.07,
              -74.79
            ],
            [
              -108.72,
              -74.91
            ],
            [
              -107.56,
              -75.18
            ],
            [
              -106.15,
              -75.13
            ],
            [
              -104.87,
              -74.95
            ],
            [
              -103.37,
              -74.99
            ],
            [
              -102.02,
              -75.13
            ],
            [
              -100.64,
              -75.3
            ],
            [
              -100.12,
              -74.87
            ],
            [
              -100.76,
              -74.54
            ],
            [
              -101.25,
              -74.18
            ],
            [
              -102.55,
              -74.11
            ],
            [
              -103.11,
              -73.73
            ],
            [
              -103.33,
              -73.36
            ],
            [
              -103.68,
              -72.62
            ],
            [
              -102.92,
              -72.75
            ],
            [
              -101.61,
              -72.81
            ],
            [
              -100.31,
              -72.75
            ],
            [
              -99.14,
              -72.91
            ],
            [
              -98.12,
              -73.21
            ],
            [
              -97.69,
              -73.56
            ],
            [
              -96.34,
              -73.62
            ],
            [
              -95.04,
              -73.48
            ],
            [
              -93.67,
              -73.28
            ],
            [
              -92.44,
              -73.17
            ],
            [
              -91.42,
              -73.4
            ],
            [
              -90.09,
              -73.32
            ],
            [
              -89.23,
              -72.56
            ],
            [
              -88.42,
              -73.01
            ],
            [
              -87.27,
              -73.19
            ],
            [
              -86.01,
              -73.09
            ],
            [
              -85.19,
              -73.48
            ],
            [
              -83.88,
              -73.52
            ],
            [
              -82.67,
              -73.64
            ],
            [
              -81.47,
              -73.85
            ],
            [
              -80.69,
              -73.48
            ],
            [
              -80.3,
              -73.13
            ],
            [
              -79.3,
              -73.52
            ],
            [
              -77.92,
              -73.42
            ],
            [
              -76.91,
              -73.64
            ],
            [
              -76.22,
              -73.97
            ],
            [
              -74.89,
              -73.87
            ],
            [
              -73.85,
              -73.66
            ],
            [
              -72.83,
              -73.4
            ],
            [
              -71.62,
              -73.26
            ],
            [
              -70.21,
              -73.15
            ],
            [
              -68.94,
              -73.01
            ],
            [
              -67.96,
              -72.79
            ],
            [
              -67.37,
              -72.48
            ],
            [
              -67.14,
              -72.05
            ],
            [
              -67.25,
              -71.64
            ],
            [
              -67.56,
              -71.25
            ],
            [
              -67.92,
              -70.85
            ],
            [
              -68.23,
              -70.46
            ],
            [
              -68.49,
              -70.11
            ],
            [
              -68.54,
              -69.72
            ],
            [
              -68.45,
              -69.32
            ],
            [
              -67.98,
              -68.95
            ],
            [
              -67.59,
              -68.54
            ],
            [
              -67.43,
              -68.15
            ],
            [
              -67.62,
              -67.72
            ],
            [
              -67.74,
              -67.33
            ],
            [
              -67.25,
              -66.88
            ],
            [
              -66.7,
              -66.58
            ],
            [
              -66.06,
              -66.21
            ],
            [
              -65.37,
              -65.9
            ],
            [
              -64.57,
              -65.6
            ],
            [
              -64.18,
              -65.17
            ],
            [
              -63.63,
              -64.9
            ],
            [
              -63,
              -64.64
            ],
            [
              -62.04,
              -64.58
            ],
            [
              -61.41,
              -64.27
            ],
            [
              -60.71,
              -64.07
            ],
            [
              -59.89,
              -63.96
            ],
            [
              -59.16,
              -63.7
            ],
            [
              -58.6,
              -63.39
            ],
            [
              -57.81,
              -63.27
            ],
            [
              -57.22,
              -63.53
            ],
            [
              -57.6,
              -63.86
            ],
            [
              -58.61,
              -64.15
            ],
            [
              -59.05,
              -64.37
            ],
            [
              -59.79,
              -64.21
            ],
            [
              -60.61,
              -64.31
            ],
            [
              -61.3,
              -64.55
            ],
            [
              -62.02,
              -64.8
            ],
            [
              -62.51,
              -65.09
            ],
            [
              -62.65,
              -65.48
            ],
            [
              -62.59,
              -65.86
            ],
            [
              -62.12,
              -66.19
            ],
            [
              -62.8,
              -66.43
            ],
            [
              -63.74,
              -66.5
            ],
            [
              -64.29,
              -66.84
            ],
            [
              -64.88,
              -67.15
            ],
            [
              -65.51,
              -67.58
            ],
            [
              -65.67,
              -67.95
            ],
            [
              -65.31,
              -68.37
            ],
            [
              -64.78,
              -68.68
            ],
            [
              -63.96,
              -68.91
            ],
            [
              -63.2,
              -69.23
            ],
            [
              -62.79,
              -69.62
            ],
            [
              -62.57,
              -69.99
            ],
            [
              -62.28,
              -70.38
            ],
            [
              -61.81,
              -70.72
            ],
            [
              -61.51,
              -71.09
            ],
            [
              -61.38,
              -72.01
            ],
            [
              -61.08,
              -72.38
            ],
            [
              -61,
              -72.77
            ],
            [
              -60.69,
              -73.17
            ],
            [
              -60.83,
              -73.7
            ],
            [
              -61.38,
              -74.11
            ],
            [
              -61.96,
              -74.44
            ],
            [
              -63.29,
              -74.58
            ],
            [
              -63.74,
              -74.93
            ],
            [
              -64.35,
              -75.26
            ],
            [
              -65.86,
              -75.63
            ],
            [
              -67.19,
              -75.79
            ],
            [
              -68.45,
              -76.01
            ],
            [
              -69.8,
              -76.22
            ],
            [
              -70.6,
              -76.64
            ],
            [
              -72.21,
              -76.67
            ],
            [
              -73.97,
              -76.64
            ],
            [
              -75.56,
              -76.71
            ],
            [
              -77.24,
              -76.71
            ],
            [
              -76.93,
              -77.11
            ],
            [
              -75.4,
              -77.28
            ],
            [
              -74.28,
              -77.56
            ],
            [
              -73.65,
              -77.91
            ],
            [
              -74.77,
              -78.22
            ],
            [
              -76.5,
              -78.12
            ],
            [
              -77.92,
              -78.38
            ],
            [
              -77.99,
              -78.79
            ],
            [
              -78.03,
              -79.18
            ],
            [
              -76.85,
              -79.51
            ],
            [
              -76.63,
              -79.89
            ],
            [
              -75.36,
              -80.26
            ],
            [
              -73.24,
              -80.42
            ],
            [
              -71.44,
              -80.69
            ],
            [
              -70.01,
              -81
            ],
            [
              -68.19,
              -81.32
            ],
            [
              -65.71,
              -81.47
            ],
            [
              -63.25,
              -81.75
            ],
            [
              -61.55,
              -82.04
            ],
            [
              -59.69,
              -82.38
            ],
            [
              -58.71,
              -82.85
            ],
            [
              -58.22,
              -83.22
            ],
            [
              -57.01,
              -82.87
            ],
            [
              -55.36,
              -82.57
            ],
            [
              -53.62,
              -82.26
            ],
            [
              -51.54,
              -82
            ],
            [
              -49.76,
              -81.73
            ],
            [
              -47.27,
              -81.71
            ],
            [
              -44.83,
              -81.85
            ],
            [
              -42.81,
              -82.08
            ],
            [
              -42.16,
              -81.65
            ],
            [
              -40.77,
              -81.36
            ],
            [
              -38.24,
              -81.34
            ],
            [
              -36.26,
              -81.12
            ],
            [
              -34.39,
              -80.91
            ],
            [
              -32.31,
              -80.77
            ],
            [
              -30.1,
              -80.59
            ],
            [
              -28.55,
              -80.34
            ],
            [
              -29.26,
              -79.98
            ],
            [
              -29.68,
              -79.63
            ],
            [
              -29.68,
              -79.26
            ],
            [
              -31.62,
              -79.3
            ],
            [
              -33.68,
              -79.46
            ],
            [
              -35.64,
              -79.46
            ],
            [
              -35.92,
              -79.08
            ],
            [
              -35.78,
              -78.34
            ],
            [
              -35.33,
              -78.12
            ],
            [
              -33.9,
              -77.89
            ],
            [
              -32.21,
              -77.65
            ],
            [
              -31,
              -77.36
            ],
            [
              -29.78,
              -77.07
            ],
            [
              -28.88,
              -76.67
            ],
            [
              -27.51,
              -76.5
            ],
            [
              -26.16,
              -76.36
            ],
            [
              -25.48,
              -76.28
            ],
            [
              -23.93,
              -76.24
            ],
            [
              -22.46,
              -76.11
            ],
            [
              -21.22,
              -75.91
            ],
            [
              -20.01,
              -75.67
            ],
            [
              -18.91,
              -75.44
            ],
            [
              -17.52,
              -75.13
            ],
            [
              -16.64,
              -74.79
            ],
            [
              -15.7,
              -74.5
            ],
            [
              -15.41,
              -74.11
            ],
            [
              -16.46,
              -73.87
            ],
            [
              -16.11,
              -73.46
            ],
            [
              -15.45,
              -73.15
            ],
            [
              -14.41,
              -72.95
            ],
            [
              -13.31,
              -72.72
            ],
            [
              -12.29,
              -72.4
            ],
            [
              -11.51,
              -72.01
            ],
            [
              -11.02,
              -71.54
            ],
            [
              -10.29,
              -71.26
            ],
            [
              -9.1,
              -71.32
            ],
            [
              -8.61,
              -71.66
            ],
            [
              -7.42,
              -71.7
            ],
            [
              -7.38,
              -71.32
            ],
            [
              -6.87,
              -70.93
            ],
            [
              -5.79,
              -71.03
            ],
            [
              -5.54,
              -71.4
            ],
            [
              -4.34,
              -71.46
            ],
            [
              -3.05,
              -71.28
            ],
            [
              -1.79,
              -71.17
            ],
            [
              -0.66,
              -71.23
            ],
            [
              -0.23,
              -71.64
            ],
            [
              0.87,
              -71.31
            ],
            [
              1.89,
              -71.13
            ],
            [
              3.02,
              -70.99
            ],
            [
              4.14,
              -70.85
            ],
            [
              5.16,
              -70.62
            ],
            [
              6.27,
              -70.46
            ],
            [
              7.14,
              -70.25
            ],
            [
              7.74,
              -69.89
            ],
            [
              8.49,
              -70.15
            ],
            [
              9.52,
              -70.01
            ],
            [
              10.25,
              -70.48
            ],
            [
              10.82,
              -70.83
            ],
            [
              11.95,
              -70.64
            ],
            [
              12.4,
              -70.25
            ],
            [
              13.42,
              -69.97
            ],
            [
              14.74,
              -70.03
            ],
            [
              15.13,
              -70.4
            ],
            [
              15.95,
              -70.03
            ],
            [
              17.03,
              -69.91
            ],
            [
              18.2,
              -69.88
            ],
            [
              19.26,
              -69.89
            ],
            [
              20.37,
              -70.01
            ],
            [
              21.45,
              -70.07
            ],
            [
              21.92,
              -70.4
            ],
            [
              22.57,
              -70.7
            ],
            [
              23.66,
              -70.52
            ],
            [
              24.84,
              -70.48
            ],
            [
              25.98,
              -70.48
            ],
            [
              27.09,
              -70.46
            ],
            [
              28.09,
              -70.33
            ],
            [
              29.15,
              -70.21
            ],
            [
              30.03,
              -69.93
            ],
            [
              30.97,
              -69.76
            ],
            [
              31.99,
              -69.66
            ],
            [
              32.75,
              -69.38
            ],
            [
              33.3,
              -68.84
            ],
            [
              33.87,
              -68.5
            ],
            [
              34.91,
              -68.66
            ],
            [
              35.3,
              -69.01
            ],
            [
              36.16,
              -69.25
            ],
            [
              37.2,
              -69.17
            ],
            [
              37.91,
              -69.52
            ],
            [
              38.65,
              -69.78
            ],
            [
              39.67,
              -69.54
            ],
            [
              40.02,
              -69.11
            ],
            [
              40.92,
              -68.93
            ],
            [
              41.96,
              -68.6
            ],
            [
              42.94,
              -68.46
            ],
            [
              44.11,
              -68.27
            ],
            [
              44.9,
              -68.05
            ],
            [
              45.72,
              -67.82
            ],
            [
              46.5,
              -67.6
            ],
            [
              47.44,
              -67.72
            ],
            [
              48.34,
              -67.37
            ],
            [
              48.99,
              -67.09
            ],
            [
              49.93,
              -67.11
            ],
            [
              50.76,
              -66.88
            ],
            [
              50.95,
              -66.52
            ],
            [
              51.79,
              -66.25
            ],
            [
              52.61,
              -66.05
            ],
            [
              53.61,
              -65.9
            ],
            [
              54.54,
              -65.82
            ],
            [
              55.41,
              -65.88
            ],
            [
              56.36,
              -65.98
            ],
            [
              57.16,
              -66.25
            ],
            [
              57.26,
              -66.68
            ],
            [
              58.14,
              -67.01
            ],
            [
              58.74,
              -67.29
            ],
            [
              59.94,
              -67.41
            ],
            [
              60.6,
              -67.68
            ],
            [
              61.43,
              -67.95
            ],
            [
              62.39,
              -68.01
            ],
            [
              63.19,
              -67.82
            ],
            [
              64.05,
              -67.41
            ],
            [
              64.99,
              -67.62
            ],
            [
              65.97,
              -67.74
            ],
            [
              66.91,
              -67.86
            ],
            [
              67.89,
              -67.93
            ],
            [
              68.89,
              -67.93
            ],
            [
              69.71,
              -68.97
            ],
            [
              69.67,
              -69.23
            ],
            [
              69.55,
              -69.68
            ],
            [
              68.6,
              -69.93
            ],
            [
              67.81,
              -70.3
            ],
            [
              67.95,
              -70.7
            ],
            [
              69.06,
              -70.68
            ],
            [
              68.93,
              -71.07
            ],
            [
              68.42,
              -71.44
            ],
            [
              67.95,
              -71.85
            ],
            [
              68.71,
              -72.17
            ],
            [
              69.87,
              -72.26
            ],
            [
              71.02,
              -72.09
            ],
            [
              71.57,
              -71.7
            ],
            [
              71.91,
              -71.32
            ],
            [
              72.46,
              -71.01
            ],
            [
              73.08,
              -70.72
            ],
            [
              73.33,
              -70.36
            ],
            [
              73.86,
              -69.88
            ],
            [
              74.49,
              -69.78
            ],
            [
              75.63,
              -69.74
            ],
            [
              76.62,
              -69.62
            ],
            [
              77.64,
              -69.46
            ],
            [
              78.13,
              -69.07
            ],
            [
              78.43,
              -68.7
            ],
            [
              79.11,
              -68.33
            ],
            [
              80.09,
              -68.07
            ],
            [
              80.93,
              -67.88
            ],
            [
              81.49,
              -67.54
            ],
            [
              82.05,
              -67.37
            ],
            [
              82.78,
              -67.21
            ],
            [
              83.77,
              -67.31
            ],
            [
              84.67,
              -67.21
            ],
            [
              85.65,
              -67.09
            ],
            [
              86.75,
              -67.15
            ],
            [
              87.48,
              -66.88
            ],
            [
              87.99,
              -66.21
            ],
            [
              88.36,
              -66.48
            ],
            [
              88.83,
              -66.96
            ],
            [
              89.67,
              -67.15
            ],
            [
              90.63,
              -67.23
            ],
            [
              91.59,
              -67.11
            ],
            [
              92.61,
              -67.19
            ],
            [
              93.55,
              -67.21
            ],
            [
              94.18,
              -67.11
            ],
            [
              95.02,
              -67.17
            ],
            [
              95.78,
              -67.39
            ],
            [
              96.68,
              -67.25
            ],
            [
              97.76,
              -67.25
            ],
            [
              98.68,
              -67.11
            ],
            [
              99.72,
              -67.25
            ],
            [
              100.39,
              -66.91
            ],
            [
              100.89,
              -66.58
            ],
            [
              101.58,
              -66.31
            ],
            [
              102.83,
              -65.56
            ],
            [
              103.48,
              -65.7
            ],
            [
              104.24,
              -65.98
            ],
            [
              104.91,
              -66.33
            ],
            [
              106.18,
              -66.94
            ],
            [
              107.16,
              -66.96
            ],
            [
              108.08,
              -66.96
            ],
            [
              109.16,
              -66.84
            ],
            [
              110.23,
              -66.7
            ],
            [
              111.06,
              -66.43
            ],
            [
              111.74,
              -66.13
            ],
            [
              112.86,
              -66.09
            ],
            [
              113.6,
              -65.88
            ],
            [
              114.39,
              -66.07
            ],
            [
              114.9,
              -66.39
            ],
            [
              115.6,
              -66.7
            ],
            [
              116.7,
              -66.66
            ],
            [
              117.38,
              -66.91
            ],
            [
              118.58,
              -67.17
            ],
            [
              119.83,
              -67.27
            ],
            [
              120.87,
              -67.19
            ],
            [
              121.65,
              -66.88
            ],
            [
              122.32,
              -66.56
            ],
            [
              123.22,
              -66.48
            ],
            [
              124.12,
              -66.62
            ],
            [
              125.16,
              -66.72
            ],
            [
              126.1,
              -66.56
            ],
            [
              127,
              -66.56
            ],
            [
              127.88,
              -66.66
            ],
            [
              128.8,
              -66.76
            ],
            [
              129.7,
              -66.58
            ],
            [
              130.78,
              -66.43
            ],
            [
              131.8,
              -66.39
            ],
            [
              132.94,
              -66.39
            ],
            [
              133.85,
              -66.29
            ],
            [
              134.76,
              -66.21
            ],
            [
              135.03,
              -65.72
            ],
            [
              135.07,
              -65.31
            ],
            [
              135.7,
              -65.58
            ],
            [
              135.87,
              -66.03
            ],
            [
              136.21,
              -66.45
            ],
            [
              136.62,
              -66.78
            ],
            [
              137.46,
              -66.96
            ],
            [
              138.6,
              -66.9
            ],
            [
              139.91,
              -66.88
            ],
            [
              140.81,
              -66.82
            ],
            [
              142.12,
              -66.82
            ],
            [
              143.06,
              -66.8
            ],
            [
              144.37,
              -66.84
            ],
            [
              145.49,
              -66.91
            ],
            [
              146.2,
              -67.23
            ],
            [
              146,
              -67.6
            ],
            [
              146.65,
              -67.89
            ],
            [
              147.72,
              -68.13
            ],
            [
              148.84,
              -68.39
            ],
            [
              150.13,
              -68.56
            ],
            [
              151.48,
              -68.72
            ],
            [
              152.5,
              -68.87
            ],
            [
              153.64,
              -68.9
            ],
            [
              154.28,
              -68.56
            ],
            [
              155.17,
              -68.84
            ],
            [
              155.93,
              -69.15
            ],
            [
              156.81,
              -69.38
            ],
            [
              158.03,
              -69.48
            ],
            [
              159.18,
              -69.6
            ],
            [
              159.67,
              -69.99
            ],
            [
              160.81,
              -70.23
            ],
            [
              161.57,
              -70.58
            ],
            [
              162.69,
              -70.74
            ],
            [
              163.84,
              -70.72
            ],
            [
              164.92,
              -70.78
            ],
            [
              166.11,
              -70.76
            ],
            [
              167.31,
              -70.83
            ],
            [
              168.43,
              -70.97
            ],
            [
              169.46,
              -71.21
            ],
            [
              170.5,
              -71.4
            ],
            [
              171.21,
              -71.7
            ],
            [
              171.09,
              -72.09
            ],
            [
              170.56,
              -72.44
            ],
            [
              170.11,
              -72.89
            ],
            [
              169.76,
              -73.24
            ],
            [
              169.29,
              -73.66
            ],
            [
              167.98,
              -73.81
            ],
            [
              167.39,
              -74.17
            ],
            [
              166.09,
              -74.38
            ],
            [
              165.64,
              -74.77
            ],
            [
              164.96,
              -75.15
            ],
            [
              164.24,
              -75.46
            ],
            [
              163.82,
              -75.87
            ],
            [
              163.57,
              -76.24
            ],
            [
              163.47,
              -76.69
            ],
            [
              163.49,
              -77.07
            ],
            [
              164.06,
              -77.46
            ],
            [
              164.28,
              -77.83
            ],
            [
              164.74,
              -78.18
            ],
            [
              166.6,
              -78.32
            ],
            [
              167,
              -78.75
            ],
            [
              165.19,
              -78.91
            ],
            [
              163.67,
              -79.12
            ],
            [
              161.77,
              -79.16
            ],
            [
              160.92,
              -79.73
            ],
            [
              160.75,
              -80.2
            ],
            [
              160.32,
              -80.57
            ],
            [
              159.79,
              -80.95
            ],
            [
              161.12,
              -81.28
            ],
            [
              161.63,
              -81.69
            ],
            [
              162.49,
              -82.06
            ],
            [
              163.71,
              -82.39
            ],
            [
              165.1,
              -82.71
            ],
            [
              166.6,
              -83.02
            ],
            [
              168.89,
              -83.34
            ],
            [
              169.41,
              -83.83
            ],
            [
              172.29,
              -84.04
            ],
            [
              172.48,
              -84.12
            ],
            [
              173.22,
              -84.41
            ],
            [
              175.99,
              -84.16
            ],
            [
              178.28,
              -84.47
            ],
            [
              180,
              -84.71
            ],
            [
              -180,
              -84.71
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "N. Cyprus"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            32.73,
            35.14
          ],
          [
            32.8,
            35.14
          ],
          [
            32.95,
            35.39
          ],
          [
            33.67,
            35.37
          ],
          [
            34.58,
            35.67
          ],
          [
            33.9,
            35.25
          ],
          [
            33.98,
            35.06
          ],
          [
            33.87,
            35.09
          ],
          [
            33.68,
            35.02
          ],
          [
            33.53,
            35.04
          ],
          [
            33.47,
            35
          ],
          [
            33.46,
            35.1
          ],
          [
            33.38,
            35.16
          ],
          [
            33.19,
            35.17
          ],
          [
            32.92,
            35.09
          ],
          [
            32.73,
            35.14
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Cyprus"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            32.73,
            35.14
          ],
          [
            32.92,
            35.09
          ],
          [
            33.19,
            35.17
          ],
          [
            33.38,
            35.16
          ],
          [
            33.46,
            35.1
          ],
          [
            33.47,
            35
          ],
          [
            33.53,
            35.04
          ],
          [
            33.68,
            35.02
          ],
          [
            33.87,
            35.09
          ],
          [
            33.98,
            35.06
          ],
          [
            34,
            34.98
          ],
          [
            32.98,
            34.57
          ],
          [
            32.49,
            34.7
          ],
          [
            32.26,
            35.1
          ],
          [
            32.73,
            35.14
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Morocco"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -2.17,
            35.17
          ],
          [
            -1.79,
            34.53
          ],
          [
            -1.73,
            33.92
          ],
          [
            -1.39,
            32.86
          ],
          [
            -1.13,
            32.65
          ],
          [
            -1.31,
            32.26
          ],
          [
            -2.62,
            32.09
          ],
          [
            -3.07,
            31.72
          ],
          [
            -3.65,
            31.64
          ],
          [
            -3.69,
            30.9
          ],
          [
            -4.86,
            30.5
          ],
          [
            -5.24,
            30
          ],
          [
            -6.06,
            29.73
          ],
          [
            -7.06,
            29.58
          ],
          [
            -8.67,
            28.84
          ],
          [
            -8.67,
            27.66
          ],
          [
            -8.82,
            27.66
          ],
          [
            -8.79,
            27.12
          ],
          [
            -9.41,
            27.09
          ],
          [
            -9.74,
            26.86
          ],
          [
            -10.19,
            26.86
          ],
          [
            -10.55,
            26.99
          ],
          [
            -11.39,
            26.88
          ],
          [
            -11.72,
            26.1
          ],
          [
            -12.03,
            26.03
          ],
          [
            -12.5,
            24.77
          ],
          [
            -13.89,
            23.69
          ],
          [
            -14.22,
            22.31
          ],
          [
            -14.63,
            21.86
          ],
          [
            -14.75,
            21.5
          ],
          [
            -17,
            21.42
          ],
          [
            -17.02,
            21.42
          ],
          [
            -16.97,
            21.89
          ],
          [
            -16.59,
            22.16
          ],
          [
            -16.26,
            22.68
          ],
          [
            -16.33,
            23.02
          ],
          [
            -15.98,
            23.72
          ],
          [
            -15.42,
            24.36
          ],
          [
            -15.09,
            24.52
          ],
          [
            -14.82,
            25.1
          ],
          [
            -14.8,
            25.64
          ],
          [
            -14.44,
            26.25
          ],
          [
            -13.78,
            26.62
          ],
          [
            -13.14,
            27.64
          ],
          [
            -13.12,
            27.65
          ],
          [
            -12.62,
            28.04
          ],
          [
            -11.69,
            28.15
          ],
          [
            -10.9,
            28.83
          ],
          [
            -10.4,
            29.1
          ],
          [
            -9.56,
            29.93
          ],
          [
            -9.82,
            31.18
          ],
          [
            -9.43,
            32.04
          ],
          [
            -9.3,
            32.57
          ],
          [
            -8.66,
            33.24
          ],
          [
            -7.66,
            33.7
          ],
          [
            -6.91,
            34.11
          ],
          [
            -6.24,
            35.15
          ],
          [
            -5.93,
            35.76
          ],
          [
            -5.19,
            35.76
          ],
          [
            -4.59,
            35.33
          ],
          [
            -3.64,
            35.4
          ],
          [
            -2.6,
            35.18
          ],
          [
            -2.17,
            35.17
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Egypt"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            36.87,
            22
          ],
          [
            32.9,
            22
          ],
          [
            29.02,
            22
          ],
          [
            25,
            22
          ],
          [
            25,
            25.68
          ],
          [
            25,
            29.24
          ],
          [
            24.7,
            30.04
          ],
          [
            24.96,
            30.66
          ],
          [
            24.8,
            31.09
          ],
          [
            25.17,
            31.57
          ],
          [
            26.49,
            31.59
          ],
          [
            27.46,
            31.32
          ],
          [
            28.45,
            31.03
          ],
          [
            28.91,
            30.87
          ],
          [
            29.68,
            31.19
          ],
          [
            30.09,
            31.47
          ],
          [
            30.98,
            31.56
          ],
          [
            31.69,
            31.43
          ],
          [
            31.96,
            30.93
          ],
          [
            32.19,
            31.26
          ],
          [
            32.99,
            31.02
          ],
          [
            33.77,
            30.97
          ],
          [
            34.27,
            31.22
          ],
          [
            34.82,
            29.76
          ],
          [
            34.92,
            29.5
          ],
          [
            34.64,
            29.1
          ],
          [
            34.43,
            28.34
          ],
          [
            34.16,
            27.82
          ],
          [
            33.92,
            27.65
          ],
          [
            33.59,
            27.97
          ],
          [
            33.14,
            28.42
          ],
          [
            32.42,
            29.85
          ],
          [
            32.32,
            29.76
          ],
          [
            32.73,
            28.7
          ],
          [
            33.35,
            27.7
          ],
          [
            34.1,
            26.14
          ],
          [
            34.47,
            25.6
          ],
          [
            34.8,
            25.03
          ],
          [
            35.69,
            23.93
          ],
          [
            35.49,
            23.75
          ],
          [
            35.53,
            23.1
          ],
          [
            36.69,
            22.21
          ],
          [
            36.87,
            22
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Libya"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            25,
            22
          ],
          [
            25,
            20
          ],
          [
            23.85,
            20
          ],
          [
            23.84,
            19.58
          ],
          [
            19.85,
            21.49
          ],
          [
            15.86,
            23.41
          ],
          [
            14.85,
            22.86
          ],
          [
            14.14,
            22.49
          ],
          [
            13.58,
            23.04
          ],
          [
            12,
            23.47
          ],
          [
            11.56,
            24.1
          ],
          [
            10.77,
            24.56
          ],
          [
            10.31,
            24.38
          ],
          [
            9.95,
            24.94
          ],
          [
            9.91,
            25.37
          ],
          [
            9.32,
            26.09
          ],
          [
            9.71,
            26.51
          ],
          [
            9.63,
            27.14
          ],
          [
            9.76,
            27.69
          ],
          [
            9.68,
            28.14
          ],
          [
            9.86,
            28.96
          ],
          [
            9.8,
            29.42
          ],
          [
            9.48,
            30.31
          ],
          [
            9.97,
            30.54
          ],
          [
            10.06,
            30.96
          ],
          [
            9.95,
            31.38
          ],
          [
            10.64,
            31.76
          ],
          [
            10.95,
            32.08
          ],
          [
            11.43,
            32.37
          ],
          [
            11.49,
            33.14
          ],
          [
            12.66,
            32.79
          ],
          [
            13.08,
            32.88
          ],
          [
            13.92,
            32.71
          ],
          [
            15.24,
            32.27
          ],
          [
            15.71,
            31.38
          ],
          [
            16.61,
            31.18
          ],
          [
            18.02,
            30.76
          ],
          [
            19.09,
            30.27
          ],
          [
            19.58,
            30.53
          ],
          [
            20.05,
            30.99
          ],
          [
            19.82,
            31.75
          ],
          [
            20.13,
            32.24
          ],
          [
            20.85,
            32.71
          ],
          [
            21.54,
            32.84
          ],
          [
            22.89,
            32.64
          ],
          [
            23.24,
            32.19
          ],
          [
            23.61,
            32.19
          ],
          [
            23.93,
            32.02
          ],
          [
            24.92,
            31.9
          ],
          [
            25.17,
            31.57
          ],
          [
            24.8,
            31.09
          ],
          [
            24.96,
            30.66
          ],
          [
            24.7,
            30.04
          ],
          [
            25,
            29.24
          ],
          [
            25,
            25.68
          ],
          [
            25,
            22
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ethiopia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            47.79,
            8
          ],
          [
            44.96,
            5
          ],
          [
            43.66,
            4.96
          ],
          [
            42.77,
            4.25
          ],
          [
            42.13,
            4.23
          ],
          [
            41.86,
            3.92
          ],
          [
            41.17,
            3.92
          ],
          [
            40.77,
            4.26
          ],
          [
            39.85,
            3.84
          ],
          [
            39.56,
            3.42
          ],
          [
            38.89,
            3.5
          ],
          [
            38.67,
            3.62
          ],
          [
            38.44,
            3.59
          ],
          [
            38.12,
            3.6
          ],
          [
            36.86,
            4.45
          ],
          [
            36.16,
            4.45
          ],
          [
            35.82,
            4.78
          ],
          [
            35.82,
            5.34
          ],
          [
            35.3,
            5.51
          ],
          [
            34.71,
            6.59
          ],
          [
            34.25,
            6.83
          ],
          [
            34.08,
            7.23
          ],
          [
            33.57,
            7.71
          ],
          [
            32.95,
            7.78
          ],
          [
            33.29,
            8.36
          ],
          [
            33.82,
            8.38
          ],
          [
            33.98,
            8.69
          ],
          [
            33.96,
            9.58
          ],
          [
            34.26,
            10.63
          ],
          [
            34.73,
            10.91
          ],
          [
            34.83,
            11.32
          ],
          [
            35.26,
            12.08
          ],
          [
            35.87,
            12.58
          ],
          [
            36.27,
            13.56
          ],
          [
            36.43,
            14.42
          ],
          [
            37.59,
            14.21
          ],
          [
            37.91,
            14.96
          ],
          [
            38.51,
            14.51
          ],
          [
            39.1,
            14.74
          ],
          [
            39.34,
            14.53
          ],
          [
            40.03,
            14.52
          ],
          [
            40.9,
            14.12
          ],
          [
            41.15,
            13.77
          ],
          [
            41.6,
            13.45
          ],
          [
            42.01,
            12.87
          ],
          [
            42.35,
            12.54
          ],
          [
            42,
            12.1
          ],
          [
            41.66,
            11.63
          ],
          [
            41.74,
            11.36
          ],
          [
            41.76,
            11.05
          ],
          [
            42.31,
            11.03
          ],
          [
            42.55,
            11.11
          ],
          [
            42.78,
            10.93
          ],
          [
            42.56,
            10.57
          ],
          [
            42.93,
            10.02
          ],
          [
            43.3,
            9.54
          ],
          [
            43.68,
            9.18
          ],
          [
            46.95,
            8
          ],
          [
            47.79,
            8
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Djibouti"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            42.35,
            12.54
          ],
          [
            42.78,
            12.46
          ],
          [
            43.08,
            12.7
          ],
          [
            43.32,
            12.39
          ],
          [
            43.29,
            11.98
          ],
          [
            42.72,
            11.74
          ],
          [
            43.14,
            11.46
          ],
          [
            42.78,
            10.93
          ],
          [
            42.55,
            11.11
          ],
          [
            42.31,
            11.03
          ],
          [
            41.76,
            11.05
          ],
          [
            41.74,
            11.36
          ],
          [
            41.66,
            11.63
          ],
          [
            42,
            12.1
          ],
          [
            42.35,
            12.54
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Somaliland"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            48.95,
            11.41
          ],
          [
            48.94,
            11.39
          ],
          [
            48.94,
            10.98
          ],
          [
            48.94,
            9.97
          ],
          [
            48.94,
            9.45
          ],
          [
            48.49,
            8.84
          ],
          [
            47.79,
            8
          ],
          [
            46.95,
            8
          ],
          [
            43.68,
            9.18
          ],
          [
            43.3,
            9.54
          ],
          [
            42.93,
            10.02
          ],
          [
            42.56,
            10.57
          ],
          [
            42.78,
            10.93
          ],
          [
            43.14,
            11.46
          ],
          [
            43.47,
            11.28
          ],
          [
            43.67,
            10.86
          ],
          [
            44.12,
            10.45
          ],
          [
            44.61,
            10.44
          ],
          [
            45.56,
            10.7
          ],
          [
            46.64,
            10.82
          ],
          [
            47.53,
            11.13
          ],
          [
            48.02,
            11.19
          ],
          [
            48.38,
            11.38
          ],
          [
            48.95,
            11.41
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Uganda"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            33.9,
            -0.95
          ],
          [
            31.87,
            -1.03
          ],
          [
            30.77,
            -1.01
          ],
          [
            30.42,
            -1.14
          ],
          [
            29.82,
            -1.44
          ],
          [
            29.58,
            -1.34
          ],
          [
            29.59,
            -0.59
          ],
          [
            29.82,
            -0.21
          ],
          [
            29.87,
            0.6
          ],
          [
            30.09,
            1.06
          ],
          [
            30.47,
            1.58
          ],
          [
            30.85,
            1.85
          ],
          [
            31.17,
            2.2
          ],
          [
            30.77,
            2.34
          ],
          [
            30.83,
            3.51
          ],
          [
            31.25,
            3.78
          ],
          [
            31.88,
            3.56
          ],
          [
            32.69,
            3.79
          ],
          [
            33.39,
            3.79
          ],
          [
            34,
            4.25
          ],
          [
            34.48,
            3.55
          ],
          [
            34.59,
            3.05
          ],
          [
            35.04,
            1.91
          ],
          [
            34.67,
            1.18
          ],
          [
            34.18,
            0.52
          ],
          [
            33.89,
            0.11
          ],
          [
            33.9,
            -0.95
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Rwanda"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            30.42,
            -1.14
          ],
          [
            30.81,
            -1.7
          ],
          [
            30.76,
            -2.29
          ],
          [
            30.47,
            -2.41
          ],
          [
            29.94,
            -2.35
          ],
          [
            29.63,
            -2.92
          ],
          [
            29.03,
            -2.84
          ],
          [
            29.12,
            -2.29
          ],
          [
            29.26,
            -2.21
          ],
          [
            29.29,
            -1.62
          ],
          [
            29.58,
            -1.34
          ],
          [
            29.82,
            -1.44
          ],
          [
            30.42,
            -1.14
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Bosnia and Herz."
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            18.56,
            42.65
          ],
          [
            17.67,
            43.03
          ],
          [
            17.3,
            43.45
          ],
          [
            16.91,
            43.67
          ],
          [
            16.46,
            44.04
          ],
          [
            16.24,
            44.35
          ],
          [
            15.75,
            44.82
          ],
          [
            15.96,
            45.23
          ],
          [
            16.32,
            45
          ],
          [
            16.53,
            45.21
          ],
          [
            17,
            45.23
          ],
          [
            17.86,
            45.07
          ],
          [
            18.55,
            45.08
          ],
          [
            19.01,
            44.86
          ],
          [
            19.37,
            44.86
          ],
          [
            19.12,
            44.42
          ],
          [
            19.6,
            44.04
          ],
          [
            19.45,
            43.57
          ],
          [
            19.22,
            43.52
          ],
          [
            19.03,
            43.43
          ],
          [
            18.71,
            43.2
          ],
          [
            18.56,
            42.65
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Macedonia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            22.38,
            42.32
          ],
          [
            22.88,
            42
          ],
          [
            22.95,
            41.34
          ],
          [
            22.76,
            41.3
          ],
          [
            22.6,
            41.13
          ],
          [
            22.06,
            41.15
          ],
          [
            21.67,
            40.93
          ],
          [
            21.02,
            40.84
          ],
          [
            20.6,
            41.09
          ],
          [
            20.46,
            41.52
          ],
          [
            20.59,
            41.86
          ],
          [
            20.72,
            41.85
          ],
          [
            20.76,
            42.05
          ],
          [
            21.35,
            42.21
          ],
          [
            21.58,
            42.25
          ],
          [
            21.92,
            42.3
          ],
          [
            22.38,
            42.32
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Serbia"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            18.83,
            45.91
          ],
          [
            19.6,
            46.17
          ],
          [
            20.22,
            46.13
          ],
          [
            20.76,
            45.74
          ],
          [
            20.87,
            45.42
          ],
          [
            21.48,
            45.18
          ],
          [
            21.56,
            44.77
          ],
          [
            22.15,
            44.48
          ],
          [
            22.46,
            44.7
          ],
          [
            22.71,
            44.58
          ],
          [
            22.47,
            44.41
          ],
          [
            22.66,
            44.24
          ],
          [
            22.41,
            44.01
          ],
          [
            22.5,
            43.64
          ],
          [
            22.98,
            43.21
          ],
          [
            22.61,
            42.9
          ],
          [
            22.44,
            42.58
          ],
          [
            22.55,
            42.46
          ],
          [
            22.38,
            42.32
          ],
          [
            21.92,
            42.3
          ],
          [
            21.58,
            42.25
          ],
          [
            21.54,
            42.32
          ],
          [
            21.66,
            42.44
          ],
          [
            21.77,
            42.68
          ],
          [
            21.63,
            42.68
          ],
          [
            21.44,
            42.86
          ],
          [
            21.27,
            42.91
          ],
          [
            21.14,
            43.07
          ],
          [
            20.96,
            43.13
          ],
          [
            20.81,
            43.27
          ],
          [
            20.63,
            43.22
          ],
          [
            20.5,
            42.88
          ],
          [
            20.26,
            42.81
          ],
          [
            20.34,
            42.9
          ],
          [
            19.96,
            43.11
          ],
          [
            19.63,
            43.21
          ],
          [
            19.49,
            43.35
          ],
          [
            19.22,
            43.52
          ],
          [
            19.45,
            43.57
          ],
          [
            19.6,
            44.04
          ],
          [
            19.12,
            44.42
          ],
          [
            19.37,
            44.86
          ],
          [
            19.01,
            44.86
          ],
          [
            19.39,
            45.24
          ],
          [
            19.07,
            45.52
          ],
          [
            18.83,
            45.91
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Montenegro"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            20.07,
            42.59
          ],
          [
            19.8,
            42.5
          ],
          [
            19.74,
            42.69
          ],
          [
            19.31,
            42.2
          ],
          [
            19.37,
            41.88
          ],
          [
            19.16,
            41.96
          ],
          [
            18.88,
            42.28
          ],
          [
            18.45,
            42.48
          ],
          [
            18.56,
            42.65
          ],
          [
            18.71,
            43.2
          ],
          [
            19.03,
            43.43
          ],
          [
            19.22,
            43.52
          ],
          [
            19.49,
            43.35
          ],
          [
            19.63,
            43.21
          ],
          [
            19.96,
            43.11
          ],
          [
            20.34,
            42.9
          ],
          [
            20.26,
            42.81
          ],
          [
            20.07,
            42.59
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kosovo"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            20.59,
            41.86
          ],
          [
            20.52,
            42.22
          ],
          [
            20.28,
            42.32
          ],
          [
            20.07,
            42.59
          ],
          [
            20.26,
            42.81
          ],
          [
            20.5,
            42.88
          ],
          [
            20.63,
            43.22
          ],
          [
            20.81,
            43.27
          ],
          [
            20.96,
            43.13
          ],
          [
            21.14,
            43.07
          ],
          [
            21.27,
            42.91
          ],
          [
            21.44,
            42.86
          ],
          [
            21.63,
            42.68
          ],
          [
            21.77,
            42.68
          ],
          [
            21.66,
            42.44
          ],
          [
            21.54,
            42.32
          ],
          [
            21.58,
            42.25
          ],
          [
            21.35,
            42.21
          ],
          [
            20.76,
            42.05
          ],
          [
            20.72,
            41.85
          ],
          [
            20.59,
            41.86
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Trinidad and Tobago"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -61.68,
            10.76
          ],
          [
            -61.11,
            10.89
          ],
          [
            -60.9,
            10.85
          ],
          [
            -60.94,
            10.11
          ],
          [
            -61.77,
            10
          ],
          [
            -61.95,
            10.09
          ],
          [
            -61.66,
            10.37
          ],
          [
            -61.68,
            10.76
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "S. Sudan"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            30.83,
            3.51
          ],
          [
            29.95,
            4.17
          ],
          [
            29.72,
            4.6
          ],
          [
            29.16,
            4.39
          ],
          [
            28.7,
            4.46
          ],
          [
            28.43,
            4.29
          ],
          [
            27.98,
            4.41
          ],
          [
            27.37,
            5.23
          ],
          [
            27.21,
            5.55
          ],
          [
            26.47,
            5.95
          ],
          [
            26.21,
            6.55
          ],
          [
            25.8,
            6.98
          ],
          [
            25.12,
            7.5
          ],
          [
            25.12,
            7.83
          ],
          [
            24.57,
            8.23
          ],
          [
            23.89,
            8.62
          ],
          [
            24.19,
            8.73
          ],
          [
            24.54,
            8.92
          ],
          [
            24.8,
            9.81
          ],
          [
            25.07,
            10.27
          ],
          [
            25.79,
            10.41
          ],
          [
            25.96,
            10.14
          ],
          [
            26.48,
            9.55
          ],
          [
            26.75,
            9.47
          ],
          [
            27.11,
            9.64
          ],
          [
            27.83,
            9.6
          ],
          [
            27.97,
            9.4
          ],
          [
            28.97,
            9.4
          ],
          [
            29,
            9.6
          ],
          [
            29.51,
            9.79
          ],
          [
            29.62,
            10.08
          ],
          [
            30,
            10.29
          ],
          [
            30.84,
            9.71
          ],
          [
            31.35,
            9.81
          ],
          [
            31.85,
            10.53
          ],
          [
            32.4,
            11.08
          ],
          [
            32.32,
            11.68
          ],
          [
            32.07,
            11.97
          ],
          [
            32.68,
            12.02
          ],
          [
            32.74,
            12.25
          ],
          [
            33.21,
            12.18
          ],
          [
            33.09,
            11.44
          ],
          [
            33.21,
            10.72
          ],
          [
            33.72,
            10.33
          ],
          [
            33.84,
            9.98
          ],
          [
            33.82,
            9.48
          ],
          [
            33.96,
            9.46
          ],
          [
            33.98,
            8.69
          ],
          [
            33.82,
            8.38
          ],
          [
            33.29,
            8.36
          ],
          [
            32.95,
            7.78
          ],
          [
            33.57,
            7.71
          ],
          [
            34.08,
            7.23
          ],
          [
            34.25,
            6.83
          ],
          [
            34.71,
            6.59
          ],
          [
            35.3,
            5.51
          ],
          [
            34.62,
            4.85
          ],
          [
            34,
            4.25
          ],
          [
            33.39,
            3.79
          ],
          [
            32.69,
            3.79
          ],
          [
            31.88,
            3.56
          ],
          [
            31.25,
            3.78
          ],
          [
            30.83,
            3.51
          ]
        ]
      ]
    }
  }
], ko = {
  features: Lp
}, zo = [
  { code: "AL", name: "Alabama", osmConceptId: 42046189 },
  { code: "AK", name: "Alaska", osmConceptId: 42046190 },
  { code: "AS", name: "American Samoa", osmConceptId: 42046191 },
  { code: "AZ", name: "Arizona", osmConceptId: 42046192 },
  { code: "AR", name: "Arkansas", osmConceptId: 42046193 },
  { code: "CA", name: "California", osmConceptId: 42046196 },
  { code: "CO", name: "Colorado", osmConceptId: 42046197 },
  { code: "CT", name: "Connecticut", osmConceptId: 42046198 },
  { code: "DE", name: "Delaware", osmConceptId: 42046199 },
  { code: "DC", name: "District of Columbia", osmConceptId: 42046200 },
  { code: "FL", name: "Florida", osmConceptId: 42046218 },
  { code: "GA", name: "Georgia", osmConceptId: 42046219 },
  { code: "GU", name: "Guam", osmConceptId: 42046220 },
  { code: "HI", name: "Hawaii", osmConceptId: 42046226 },
  { code: "ID", name: "Idaho", osmConceptId: 42046227 },
  { code: "IL", name: "Illinois", osmConceptId: 42046228 },
  { code: "IN", name: "Indiana", osmConceptId: 42046229 },
  { code: "IA", name: "Iowa", osmConceptId: 42046232 },
  { code: "KS", name: "Kansas", osmConceptId: 42046237 },
  { code: "KY", name: "Kentucky", osmConceptId: 42046238 },
  { code: "LA", name: "Louisiana", osmConceptId: 42046239 },
  { code: "ME", name: "Maine", osmConceptId: 42046240 },
  { code: "MD", name: "Maryland", osmConceptId: 42046241 },
  { code: "MA", name: "Massachusetts", osmConceptId: 42046242 },
  { code: "MI", name: "Michigan", osmConceptId: 42046252 },
  { code: "MN", name: "Minnesota", osmConceptId: 42046253 },
  { code: "MS", name: "Mississippi", osmConceptId: 42046254 },
  { code: "MO", name: "Missouri", osmConceptId: 42046255 },
  { code: "MT", name: "Montana", osmConceptId: 42046264 },
  { code: "NE", name: "Nebraska", osmConceptId: 42046265 },
  { code: "NV", name: "Nevada", osmConceptId: 42046266 },
  { code: "NH", name: "New Hampshire", osmConceptId: 42046267 },
  { code: "NJ", name: "New Jersey", osmConceptId: 42046268 },
  { code: "NM", name: "New Mexico", osmConceptId: 42046269 },
  { code: "NY", name: "New York", osmConceptId: 42046270 },
  { code: "NC", name: "North Carolina", osmConceptId: 42046271 },
  { code: "ND", name: "North Dakota", osmConceptId: 42046280 },
  { code: "MP", name: "Northern Mariana Islands", osmConceptId: 42046283 },
  { code: "OH", name: "Ohio", osmConceptId: 42046284 },
  { code: "OK", name: "Oklahoma", osmConceptId: 42046285 },
  { code: "OR", name: "Oregon", osmConceptId: 42046286 },
  { code: "PA", name: "Pennsylvania", osmConceptId: 42046289 },
  { code: "PR", name: "Puerto Rico", osmConceptId: 42046290 },
  { code: "RI", name: "Rhode Island", osmConceptId: 42046292 },
  { code: "SC", name: "South Carolina", osmConceptId: 42046293 },
  { code: "SD", name: "South Dakota", osmConceptId: 42046294 },
  { code: "TN", name: "Tennessee", osmConceptId: 42046298 },
  { code: "TX", name: "Texas", osmConceptId: 42046299 },
  { code: "VI", name: "United States Virgin Islands", osmConceptId: 42046302 },
  { code: "UT", name: "Utah", osmConceptId: 42046303 },
  { code: "VT", name: "Vermont", osmConceptId: 42046304 },
  { code: "VA", name: "Virginia", osmConceptId: 42046309 },
  { code: "WA", name: "Washington", osmConceptId: 42046310 },
  { code: "WV", name: "West Virginia", osmConceptId: 42046311 },
  { code: "WI", name: "Wisconsin", osmConceptId: 42046312 },
  { code: "WY", name: "Wyoming", osmConceptId: 42046313 }
], Jn = zo.reduce(
  (n, o) => ({ ...n, [o.code]: o }),
  {}
), Bo = zo.reduce(
  (n, o) => ({ ...n, [o.name.toLowerCase()]: o.code }),
  {}
), e2 = {
  "United States of America": 42046186,
  Japan: 42006858,
  Germany: 41970930,
  "United Kingdom": 42035286,
  France: 41928898,
  Italy: 41987173,
  Spain: 42020824,
  Canada: 41915371,
  Australia: 41881315,
  Brazil: 41892130,
  China: 41921547,
  India: 4320154,
  Mexico: 4075636,
  Netherlands: 42032171,
  Belgium: 41890291,
  Sweden: 42030997,
  Denmark: 41930999,
  Norway: 4328758,
  Finland: 4320323,
  Poland: 4329597,
  Austria: 4329596,
  Switzerland: 4330427,
  Ireland: 4330438,
  Portugal: 4320170,
  Greece: 4330430,
  "South Korea": 42018935,
  "South Africa": 42014353,
  Argentina: 4073750,
  Israel: 41995088,
  "Saudi Arabia": 42014333,
  Russia: 37162241,
  Turkey: 4133506
}, $o = (n) => n.trim().toLowerCase().replace(/\s+/g, " "), Mp = {
  usa: "United States of America",
  us: "United States of America",
  "u.s.": "United States of America",
  "u.s.a.": "United States of America",
  "united states": "United States of America",
  "united states of america (usa)": "United States of America",
  uk: "United Kingdom",
  "great britain": "United Kingdom",
  england: "United Kingdom",
  "united kingdom of great britain and northern ireland": "United Kingdom",
  "russian federation": "Russia",
  "republic of korea": "South Korea",
  "korea, republic of": "South Korea",
  "korea (south)": "South Korea",
  "korea, democratic people's republic of": "North Korea",
  "czech republic": "Czechia",
  "bosnia and herzegovina": "Bosnia and Herz.",
  "dominican republic": "Dominican Rep.",
  "central african republic": "Central African Rep.",
  "equatorial guinea": "Eq. Guinea",
  "south sudan": "S. Sudan",
  "ivory coast": "Côte d'Ivoire",
  "cote d'ivoire": "Côte d'Ivoire",
  "the netherlands": "Netherlands",
  holland: "Netherlands",
  "democratic republic of the congo": "Dem. Rep. Congo",
  "republic of the congo": "Congo",
  "united republic of tanzania": "Tanzania",
  "viet nam": "Vietnam",
  "syrian arab republic": "Syria",
  "iran (islamic republic of)": "Iran",
  "lao people’s democratic republic": "Laos",
  swaziland: "eSwatini",
  eswatini: "eSwatini",
  macedonia: "Macedonia",
  "north macedonia": "Macedonia",
  "western sahara": "W. Sahara",
  "solomon islands": "Solomon Is.",
  "falkland islands": "Falkland Is.",
  "trinidad & tobago": "Trinidad and Tobago"
};
let C4;
const kp = () => (C4 || (C4 = {}, (ko.features || []).forEach((n) => {
  var a;
  const o = (a = n == null ? void 0 : n.properties) == null ? void 0 : a.name;
  o && (C4[$o(o)] = o);
}), Object.entries(Mp).forEach(([n, o]) => {
  C4[n] = o;
})), C4), zp = new Set(Object.values(e2)), Bp = (n) => {
  const o = n ?? "", a = [o], i = /[:=|]/;
  return i.test(o) && a.push(o.split(i).pop()), a.map($o).filter(Boolean);
}, $p = (n, o) => {
  const a = kp(), i = Bp(n), l = typeof o == "number" && zp.has(o);
  for (const c of i) {
    const p = a[c];
    if (p && l)
      return { level: "country", key: p, name: p };
    const g = Bo[c];
    if (g)
      return {
        level: "state",
        key: g,
        name: Jn[g].name
      };
    const u = c.toUpperCase();
    if (u.length === 2 && Jn[u])
      return { level: "state", key: u, name: Jn[u].name };
    if (p)
      return { level: "country", key: p, name: p };
  }
}, Wp = (n) => Math.round(n * 10) / 10, Mr = (n) => {
  const o = Number(n);
  return Number.isFinite(o) ? o : 0;
}, Hp = ({
  items: n,
  cohort: o,
  strataId: a = 0
}) => {
  if (!(n != null && n.length) || !o)
    return;
  const i = [];
  let l;
  if (n.forEach((c) => {
    var f, b;
    const p = $p(c.covariateName, c.conceptId);
    if (!p)
      return;
    const g = (b = (f = c.records) == null ? void 0 : f[o.id]) == null ? void 0 : b[a], u = Mr(g == null ? void 0 : g.count), d = Mr(g == null ? void 0 : g.avg);
    u && (d > 0 && u > ((l == null ? void 0 : l.count) ?? 0) && (l = { count: u, avg: d }), i.push({
      covariateName: p.name,
      conceptId: Mr(c.conceptId),
      level: p.level,
      count: u,
      pct: Wp(d * 100),
      ...p.level === "country" ? { countryName: p.key } : { stateCode: p.key }
    }));
  }), !!i.length)
    return i.sort((c, p) => p.count - c.count), {
      // Country rows only exist in CDM 5.4 (5.3 has no country_concept_id).
      cdmVersion: i.some((c) => c.level === "country") ? "5.4" : "5.3",
      cohortName: o.name ?? "",
      populationWithLocation: l ? Math.round(l.count / l.avg) : i.reduce((c, p) => c + p.count, 0),
      records: i
    };
}, f2 = {
  CA: 48120,
  TX: 39980,
  NY: 34130,
  FL: 31240,
  PA: 21870,
  IL: 20560,
  OH: 19340,
  GA: 16120,
  NC: 15870,
  MI: 15010,
  NJ: 14230,
  VA: 13120,
  WA: 12980,
  AZ: 12110,
  MA: 11760,
  TN: 10980,
  IN: 10240,
  MO: 9870,
  MD: 9560,
  WI: 9020,
  CO: 8890,
  MN: 8640,
  SC: 7980,
  AL: 7540,
  LA: 6870,
  KY: 6540,
  OR: 6210,
  OK: 5980,
  CT: 5640,
  IA: 4980,
  MS: 4560,
  AR: 4320,
  KS: 4210,
  NV: 4180,
  UT: 3980,
  NM: 3210,
  NE: 3010,
  WV: 2870,
  ID: 2650,
  HI: 2210,
  NH: 2010,
  ME: 1890,
  MT: 1560,
  RI: 1520,
  DE: 1480,
  SD: 1240,
  ND: 1120,
  AK: 980,
  DC: 940,
  VT: 870,
  WY: 760,
  PR: 640
}, Wo = {
  Japan: 41230,
  Germany: 35120,
  "United Kingdom": 29870,
  France: 24560,
  Canada: 21340,
  Australia: 18760,
  Italy: 16540,
  Spain: 14320,
  Brazil: 13210,
  Netherlands: 11980,
  China: 10870,
  India: 9760,
  Mexico: 8540,
  "South Korea": 7320,
  Sweden: 6210,
  Belgium: 5430,
  Switzerland: 4780,
  Poland: 4210,
  Denmark: 3560,
  Norway: 2980
}, x2 = (n) => Object.values(n).reduce((o, a) => o + a, 0), t2 = (n) => Math.round(n * 10) / 10, Ho = (n) => Object.entries(f2).map(([o, a]) => {
  var i;
  return {
    covariateName: ((i = Jn[o]) == null ? void 0 : i.name) ?? o,
    conceptId: 0,
    level: "state",
    count: a,
    pct: t2(a / n * 100),
    stateCode: o
  };
}).sort((o, a) => a.count - o.count), d8 = x2(f2), Vp = {
  cdmVersion: "5.3",
  cohortName: "Diabetes mellitus type 1 — cohort",
  populationWithLocation: d8,
  records: Ho(d8)
}, n2 = x2(f2), i5 = x2(Wo) + n2, Up = [
  {
    covariateName: "United States",
    conceptId: e2["United States of America"],
    level: "country",
    count: n2,
    pct: t2(n2 / i5 * 100),
    countryName: "United States of America"
  },
  ...Object.entries(Wo).map(([n, o]) => ({
    covariateName: n,
    conceptId: e2[n] ?? 0,
    level: "country",
    count: o,
    pct: t2(o / i5 * 100),
    countryName: n
  }))
].sort((n, o) => o.count - n.count), Gp = {
  cdmVersion: "5.4",
  cohortName: "Diabetes mellitus type 1 — cohort",
  populationWithLocation: i5,
  records: [...Up, ...Ho(i5)]
}, Kp = (n) => n === "5.3" ? Vp : Gp, Yp = [
  {
    type: "Feature",
    properties: {
      name: "Alabama",
      fips: "01"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -88.33,
              30.24
            ],
            [
              -88.13,
              30.26
            ],
            [
              -88.13,
              30.28
            ],
            [
              -88.08,
              30.25
            ],
            [
              -88.11,
              30.23
            ],
            [
              -88.14,
              30.24
            ],
            [
              -88.21,
              30.24
            ],
            [
              -88.28,
              30.22
            ],
            [
              -88.33,
              30.24
            ]
          ]
        ],
        [
          [
            [
              -88.2,
              35
            ],
            [
              -88.2,
              35.01
            ],
            [
              -87.66,
              35
            ],
            [
              -87.44,
              35
            ],
            [
              -86.86,
              34.99
            ],
            [
              -86.53,
              34.99
            ],
            [
              -86.4,
              34.99
            ],
            [
              -85.83,
              34.99
            ],
            [
              -85.61,
              34.98
            ],
            [
              -85.55,
              34.71
            ],
            [
              -85.47,
              34.33
            ],
            [
              -85.41,
              34
            ],
            [
              -85.36,
              33.75
            ],
            [
              -85.31,
              33.48
            ],
            [
              -85.19,
              32.87
            ],
            [
              -85.15,
              32.84
            ],
            [
              -85.17,
              32.81
            ],
            [
              -85.12,
              32.77
            ],
            [
              -85.1,
              32.65
            ],
            [
              -85.07,
              32.58
            ],
            [
              -85.01,
              32.52
            ],
            [
              -85,
              32.45
            ],
            [
              -84.96,
              32.42
            ],
            [
              -85,
              32.32
            ],
            [
              -84.94,
              32.3
            ],
            [
              -84.89,
              32.26
            ],
            [
              -84.93,
              32.22
            ],
            [
              -84.97,
              32.22
            ],
            [
              -84.96,
              32.2
            ],
            [
              -85.01,
              32.18
            ],
            [
              -85.06,
              32.14
            ],
            [
              -85.05,
              32.09
            ],
            [
              -85.05,
              32.01
            ],
            [
              -85.08,
              31.94
            ],
            [
              -85.13,
              31.88
            ],
            [
              -85.14,
              31.84
            ],
            [
              -85.12,
              31.73
            ],
            [
              -85.13,
              31.69
            ],
            [
              -85.06,
              31.62
            ],
            [
              -85.05,
              31.52
            ],
            [
              -85.07,
              31.47
            ],
            [
              -85.06,
              31.43
            ],
            [
              -85.09,
              31.36
            ],
            [
              -85.09,
              31.29
            ],
            [
              -85.12,
              31.28
            ],
            [
              -85.1,
              31.23
            ],
            [
              -85.11,
              31.19
            ],
            [
              -85.04,
              31.11
            ],
            [
              -85.01,
              31.05
            ],
            [
              -85,
              31
            ],
            [
              -85.24,
              31
            ],
            [
              -85.5,
              31
            ],
            [
              -85.89,
              30.99
            ],
            [
              -86.52,
              30.99
            ],
            [
              -87,
              31
            ],
            [
              -87.6,
              31
            ],
            [
              -87.59,
              30.96
            ],
            [
              -87.63,
              30.87
            ],
            [
              -87.63,
              30.85
            ],
            [
              -87.54,
              30.78
            ],
            [
              -87.53,
              30.74
            ],
            [
              -87.4,
              30.67
            ],
            [
              -87.39,
              30.62
            ],
            [
              -87.45,
              30.53
            ],
            [
              -87.44,
              30.48
            ],
            [
              -87.37,
              30.44
            ],
            [
              -87.43,
              30.41
            ],
            [
              -87.46,
              30.34
            ],
            [
              -87.49,
              30.32
            ],
            [
              -87.47,
              30.3
            ],
            [
              -87.52,
              30.28
            ],
            [
              -87.66,
              30.25
            ],
            [
              -87.8,
              30.23
            ],
            [
              -88,
              30.23
            ],
            [
              -87.94,
              30.26
            ],
            [
              -87.89,
              30.24
            ],
            [
              -87.77,
              30.26
            ],
            [
              -87.76,
              30.29
            ],
            [
              -87.81,
              30.33
            ],
            [
              -87.84,
              30.37
            ],
            [
              -87.91,
              30.41
            ],
            [
              -87.93,
              30.49
            ],
            [
              -87.9,
              30.55
            ],
            [
              -87.91,
              30.62
            ],
            [
              -87.94,
              30.66
            ],
            [
              -88.01,
              30.68
            ],
            [
              -88.06,
              30.65
            ],
            [
              -88.05,
              30.61
            ],
            [
              -88.09,
              30.56
            ],
            [
              -88.08,
              30.53
            ],
            [
              -88.1,
              30.5
            ],
            [
              -88.11,
              30.38
            ],
            [
              -88.14,
              30.32
            ],
            [
              -88.19,
              30.32
            ],
            [
              -88.19,
              30.35
            ],
            [
              -88.26,
              30.38
            ],
            [
              -88.31,
              30.37
            ],
            [
              -88.33,
              30.39
            ],
            [
              -88.4,
              30.37
            ],
            [
              -88.41,
              30.56
            ],
            [
              -88.42,
              30.87
            ],
            [
              -88.44,
              31.23
            ],
            [
              -88.47,
              31.89
            ],
            [
              -88.44,
              32.14
            ],
            [
              -88.37,
              32.75
            ],
            [
              -88.35,
              32.93
            ],
            [
              -88.23,
              33.89
            ],
            [
              -88.21,
              34.03
            ],
            [
              -88.14,
              34.58
            ],
            [
              -88.1,
              34.89
            ],
            [
              -88.16,
              34.92
            ],
            [
              -88.2,
              35
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Alaska",
      fips: "02"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -150.24,
              61.14
            ],
            [
              -150.22,
              61.17
            ],
            [
              -150.16,
              61.16
            ],
            [
              -150.23,
              61.12
            ],
            [
              -150.24,
              61.14
            ]
          ]
        ],
        [
          [
            [
              -150.77,
              59.33
            ],
            [
              -150.67,
              59.41
            ],
            [
              -150.62,
              59.4
            ],
            [
              -150.62,
              59.36
            ],
            [
              -150.72,
              59.29
            ],
            [
              -150.77,
              59.31
            ],
            [
              -150.77,
              59.33
            ]
          ]
        ],
        [
          [
            [
              -151.53,
              59.15
            ],
            [
              -151.43,
              59.14
            ],
            [
              -151.45,
              59.1
            ],
            [
              -151.53,
              59.15
            ]
          ]
        ],
        [
          [
            [
              -151.72,
              59.13
            ],
            [
              -151.64,
              59.12
            ],
            [
              -151.66,
              59.09
            ],
            [
              -151.71,
              59.1
            ],
            [
              -151.72,
              59.13
            ]
          ]
        ],
        [
          [
            [
              -151.86,
              59.17
            ],
            [
              -151.79,
              59.16
            ],
            [
              -151.81,
              59.14
            ],
            [
              -151.86,
              59.17
            ]
          ]
        ],
        [
          [
            [
              -151.89,
              58.22
            ],
            [
              -151.86,
              58.26
            ],
            [
              -151.79,
              58.25
            ],
            [
              -151.82,
              58.18
            ],
            [
              -151.87,
              58.17
            ],
            [
              -151.89,
              58.22
            ]
          ]
        ],
        [
          [
            [
              -152.07,
              58.92
            ],
            [
              -152.03,
              58.95
            ],
            [
              -151.95,
              58.91
            ],
            [
              -152.07,
              58.91
            ],
            [
              -152.07,
              58.92
            ]
          ]
        ],
        [
          [
            [
              -152.08,
              60.35
            ],
            [
              -151.98,
              60.41
            ],
            [
              -151.95,
              60.51
            ],
            [
              -151.84,
              60.49
            ],
            [
              -151.94,
              60.43
            ],
            [
              -151.97,
              60.39
            ],
            [
              -151.95,
              60.37
            ],
            [
              -152.08,
              60.35
            ]
          ]
        ],
        [
          [
            [
              -152.36,
              58.92
            ],
            [
              -152.31,
              58.96
            ],
            [
              -152.24,
              58.94
            ],
            [
              -152.16,
              58.93
            ],
            [
              -152.28,
              58.91
            ],
            [
              -152.36,
              58.92
            ]
          ]
        ],
        [
          [
            [
              -152.64,
              60.17
            ],
            [
              -152.58,
              60.17
            ],
            [
              -152.56,
              60.09
            ],
            [
              -152.64,
              60.17
            ]
          ]
        ],
        [
          [
            [
              -153.42,
              58.06
            ],
            [
              -153.32,
              58.14
            ],
            [
              -153.26,
              58.15
            ],
            [
              -153.17,
              58.09
            ],
            [
              -153.15,
              58.11
            ],
            [
              -153.23,
              58.16
            ],
            [
              -153.2,
              58.21
            ],
            [
              -153.17,
              58.22
            ],
            [
              -153.07,
              58.2
            ],
            [
              -153,
              58.21
            ],
            [
              -153.1,
              58.26
            ],
            [
              -153.05,
              58.31
            ],
            [
              -152.94,
              58.28
            ],
            [
              -152.89,
              58.28
            ],
            [
              -152.94,
              58.33
            ],
            [
              -152.9,
              58.35
            ],
            [
              -152.82,
              58.33
            ],
            [
              -152.77,
              58.37
            ],
            [
              -152.84,
              58.37
            ],
            [
              -152.88,
              58.4
            ],
            [
              -152.81,
              58.4
            ],
            [
              -152.73,
              58.46
            ],
            [
              -152.61,
              58.48
            ],
            [
              -152.65,
              58.51
            ],
            [
              -152.67,
              58.56
            ],
            [
              -152.57,
              58.62
            ],
            [
              -152.54,
              58.59
            ],
            [
              -152.35,
              58.64
            ],
            [
              -152.33,
              58.63
            ],
            [
              -152.37,
              58.53
            ],
            [
              -152.42,
              58.52
            ],
            [
              -152.51,
              58.43
            ],
            [
              -152.49,
              58.35
            ],
            [
              -152.36,
              58.36
            ],
            [
              -152.36,
              58.42
            ],
            [
              -152.28,
              58.42
            ],
            [
              -152.2,
              58.35
            ],
            [
              -152.13,
              58.4
            ],
            [
              -152.09,
              58.37
            ],
            [
              -152.15,
              58.27
            ],
            [
              -152.12,
              58.25
            ],
            [
              -152.08,
              58.31
            ],
            [
              -151.99,
              58.35
            ],
            [
              -151.96,
              58.33
            ],
            [
              -151.97,
              58.23
            ],
            [
              -152.08,
              58.15
            ],
            [
              -152.2,
              58.17
            ],
            [
              -152.23,
              58.24
            ],
            [
              -152.31,
              58.22
            ],
            [
              -152.26,
              58.14
            ],
            [
              -152.34,
              58.12
            ],
            [
              -152.48,
              58.13
            ],
            [
              -152.54,
              58.08
            ],
            [
              -152.57,
              58.11
            ],
            [
              -152.56,
              58.18
            ],
            [
              -152.6,
              58.18
            ],
            [
              -152.63,
              58.08
            ],
            [
              -152.66,
              58.06
            ],
            [
              -152.77,
              58.05
            ],
            [
              -152.76,
              58.01
            ],
            [
              -152.82,
              58
            ],
            [
              -152.98,
              57.98
            ],
            [
              -153.29,
              58.05
            ],
            [
              -153.37,
              58.04
            ],
            [
              -153.42,
              58.06
            ]
          ]
        ],
        [
          [
            [
              -153.56,
              59.39
            ],
            [
              -153.41,
              59.42
            ],
            [
              -153.35,
              59.38
            ],
            [
              -153.37,
              59.34
            ],
            [
              -153.41,
              59.32
            ],
            [
              -153.52,
              59.32
            ],
            [
              -153.57,
              59.37
            ],
            [
              -153.56,
              59.39
            ]
          ]
        ],
        [
          [
            [
              -154.16,
              56.69
            ],
            [
              -154.05,
              56.73
            ],
            [
              -154.02,
              56.69
            ],
            [
              -154.15,
              56.68
            ],
            [
              -154.16,
              56.69
            ]
          ]
        ],
        [
          [
            [
              -154.36,
              56.54
            ],
            [
              -154.29,
              56.6
            ],
            [
              -154.22,
              56.61
            ],
            [
              -154.18,
              56.6
            ],
            [
              -154.09,
              56.62
            ],
            [
              -154.08,
              56.58
            ],
            [
              -154.01,
              56.55
            ],
            [
              -153.88,
              56.57
            ],
            [
              -153.89,
              56.53
            ],
            [
              -153.95,
              56.51
            ],
            [
              -154.12,
              56.5
            ],
            [
              -154.23,
              56.49
            ],
            [
              -154.35,
              56.51
            ],
            [
              -154.36,
              56.54
            ]
          ]
        ],
        [
          [
            [
              -154.78,
              57.37
            ],
            [
              -154.71,
              57.38
            ],
            [
              -154.69,
              57.45
            ],
            [
              -154.63,
              57.51
            ],
            [
              -154.54,
              57.54
            ],
            [
              -154.52,
              57.58
            ],
            [
              -154.47,
              57.57
            ],
            [
              -154.35,
              57.63
            ],
            [
              -154.23,
              57.66
            ],
            [
              -154.09,
              57.65
            ],
            [
              -153.98,
              57.65
            ],
            [
              -153.98,
              57.55
            ],
            [
              -153.89,
              57.5
            ],
            [
              -153.88,
              57.54
            ],
            [
              -153.81,
              57.59
            ],
            [
              -153.88,
              57.63
            ],
            [
              -153.86,
              57.65
            ],
            [
              -153.67,
              57.64
            ],
            [
              -153.68,
              57.67
            ],
            [
              -153.86,
              57.71
            ],
            [
              -153.93,
              57.7
            ],
            [
              -153.94,
              57.81
            ],
            [
              -153.82,
              57.87
            ],
            [
              -153.72,
              57.89
            ],
            [
              -153.65,
              57.88
            ],
            [
              -153.57,
              57.83
            ],
            [
              -153.55,
              57.72
            ],
            [
              -153.49,
              57.73
            ],
            [
              -153.46,
              57.79
            ],
            [
              -153.48,
              57.84
            ],
            [
              -153.35,
              57.81
            ],
            [
              -153.33,
              57.85
            ],
            [
              -153.46,
              57.88
            ],
            [
              -153.54,
              57.93
            ],
            [
              -153.51,
              57.97
            ],
            [
              -153.45,
              57.96
            ],
            [
              -153.27,
              57.89
            ],
            [
              -153.24,
              57.89
            ],
            [
              -153.13,
              57.86
            ],
            [
              -153.09,
              57.87
            ],
            [
              -153.2,
              57.93
            ],
            [
              -153.27,
              57.96
            ],
            [
              -153.3,
              58
            ],
            [
              -153.24,
              58
            ],
            [
              -153.13,
              57.95
            ],
            [
              -153.02,
              57.96
            ],
            [
              -152.88,
              57.93
            ],
            [
              -152.85,
              57.97
            ],
            [
              -152.72,
              57.99
            ],
            [
              -152.75,
              57.93
            ],
            [
              -152.89,
              57.84
            ],
            [
              -152.92,
              57.77
            ],
            [
              -152.85,
              57.74
            ],
            [
              -152.85,
              57.82
            ],
            [
              -152.79,
              57.86
            ],
            [
              -152.73,
              57.82
            ],
            [
              -152.72,
              57.86
            ],
            [
              -152.65,
              57.88
            ],
            [
              -152.64,
              57.92
            ],
            [
              -152.59,
              57.93
            ],
            [
              -152.55,
              57.9
            ],
            [
              -152.47,
              57.96
            ],
            [
              -152.41,
              57.97
            ],
            [
              -152.43,
              57.93
            ],
            [
              -152.32,
              57.92
            ],
            [
              -152.36,
              57.88
            ],
            [
              -152.4,
              57.9
            ],
            [
              -152.47,
              57.89
            ],
            [
              -152.4,
              57.86
            ],
            [
              -152.42,
              57.82
            ],
            [
              -152.35,
              57.83
            ],
            [
              -152.31,
              57.79
            ],
            [
              -152.21,
              57.79
            ],
            [
              -152.3,
              57.75
            ],
            [
              -152.36,
              57.77
            ],
            [
              -152.44,
              57.78
            ],
            [
              -152.5,
              57.73
            ],
            [
              -152.44,
              57.73
            ],
            [
              -152.47,
              57.68
            ],
            [
              -152.37,
              57.67
            ],
            [
              -152.47,
              57.6
            ],
            [
              -152.39,
              57.61
            ],
            [
              -152.34,
              57.65
            ],
            [
              -152.32,
              57.62
            ],
            [
              -152.15,
              57.62
            ],
            [
              -152.16,
              57.58
            ],
            [
              -152.29,
              57.52
            ],
            [
              -152.34,
              57.42
            ],
            [
              -152.48,
              57.43
            ],
            [
              -152.48,
              57.47
            ],
            [
              -152.52,
              57.43
            ],
            [
              -152.6,
              57.47
            ],
            [
              -152.66,
              57.46
            ],
            [
              -152.74,
              57.51
            ],
            [
              -152.8,
              57.49
            ],
            [
              -152.88,
              57.51
            ],
            [
              -152.91,
              57.47
            ],
            [
              -152.82,
              57.47
            ],
            [
              -152.76,
              57.46
            ],
            [
              -152.6,
              57.38
            ],
            [
              -152.63,
              57.32
            ],
            [
              -152.71,
              57.28
            ],
            [
              -152.75,
              57.31
            ],
            [
              -152.82,
              57.27
            ],
            [
              -152.89,
              57.29
            ],
            [
              -152.91,
              57.32
            ],
            [
              -152.98,
              57.34
            ],
            [
              -153.06,
              57.33
            ],
            [
              -153.12,
              57.3
            ],
            [
              -153.01,
              57.3
            ],
            [
              -152.94,
              57.26
            ],
            [
              -153.08,
              57.21
            ],
            [
              -153.2,
              57.22
            ],
            [
              -153.21,
              57.2
            ],
            [
              -153.12,
              57.18
            ],
            [
              -153.07,
              57.19
            ],
            [
              -152.95,
              57.19
            ],
            [
              -152.87,
              57.15
            ],
            [
              -152.91,
              57.13
            ],
            [
              -153,
              57.12
            ],
            [
              -153.12,
              57.09
            ],
            [
              -153.15,
              57.1
            ],
            [
              -153.21,
              57.08
            ],
            [
              -153.2,
              57.03
            ],
            [
              -153.3,
              56.99
            ],
            [
              -153.35,
              57.01
            ],
            [
              -153.32,
              57.04
            ],
            [
              -153.4,
              57.08
            ],
            [
              -153.38,
              57.12
            ],
            [
              -153.28,
              57.17
            ],
            [
              -153.31,
              57.19
            ],
            [
              -153.37,
              57.18
            ],
            [
              -153.49,
              57.09
            ],
            [
              -153.5,
              57.07
            ],
            [
              -153.58,
              57.09
            ],
            [
              -153.66,
              57.08
            ],
            [
              -153.67,
              57.05
            ],
            [
              -153.58,
              57.05
            ],
            [
              -153.54,
              57
            ],
            [
              -153.6,
              56.94
            ],
            [
              -153.69,
              56.93
            ],
            [
              -153.69,
              56.87
            ],
            [
              -153.78,
              56.83
            ],
            [
              -153.82,
              56.84
            ],
            [
              -153.9,
              56.77
            ],
            [
              -153.97,
              56.75
            ],
            [
              -154.04,
              56.76
            ],
            [
              -154.15,
              56.75
            ],
            [
              -154.07,
              56.85
            ],
            [
              -154.03,
              56.86
            ],
            [
              -153.94,
              56.92
            ],
            [
              -153.85,
              56.94
            ],
            [
              -153.86,
              56.97
            ],
            [
              -153.98,
              56.95
            ],
            [
              -153.96,
              57
            ],
            [
              -153.89,
              57.09
            ],
            [
              -153.78,
              57.13
            ],
            [
              -153.81,
              57.16
            ],
            [
              -153.86,
              57.12
            ],
            [
              -153.98,
              57.07
            ],
            [
              -154.08,
              56.97
            ],
            [
              -154.16,
              56.92
            ],
            [
              -154.21,
              56.91
            ],
            [
              -154.23,
              56.87
            ],
            [
              -154.3,
              56.85
            ],
            [
              -154.31,
              56.92
            ],
            [
              -154.41,
              56.97
            ],
            [
              -154.52,
              56.99
            ],
            [
              -154.51,
              57.08
            ],
            [
              -154.53,
              57.17
            ],
            [
              -154.58,
              57.24
            ],
            [
              -154.61,
              57.27
            ],
            [
              -154.7,
              57.28
            ],
            [
              -154.79,
              57.29
            ],
            [
              -154.74,
              57.31
            ],
            [
              -154.8,
              57.35
            ],
            [
              -154.78,
              57.37
            ]
          ]
        ],
        [
          [
            [
              -154.8,
              56.43
            ],
            [
              -154.71,
              56.52
            ],
            [
              -154.52,
              56.6
            ],
            [
              -154.45,
              56.6
            ],
            [
              -154.39,
              56.55
            ],
            [
              -154.44,
              56.53
            ],
            [
              -154.63,
              56.47
            ],
            [
              -154.74,
              56.4
            ],
            [
              -154.8,
              56.43
            ]
          ]
        ],
        [
          [
            [
              -155.75,
              55.83
            ],
            [
              -155.66,
              55.86
            ],
            [
              -155.64,
              55.89
            ],
            [
              -155.59,
              55.91
            ],
            [
              -155.56,
              55.89
            ],
            [
              -155.58,
              55.85
            ],
            [
              -155.57,
              55.79
            ],
            [
              -155.59,
              55.76
            ],
            [
              -155.72,
              55.77
            ],
            [
              -155.75,
              55.83
            ]
          ]
        ],
        [
          [
            [
              -156.75,
              56.04
            ],
            [
              -156.73,
              56.08
            ],
            [
              -156.68,
              56.1
            ],
            [
              -156.64,
              56.05
            ],
            [
              -156.68,
              55.99
            ],
            [
              -156.75,
              56.04
            ]
          ]
        ],
        [
          [
            [
              -156.8,
              56.2
            ],
            [
              -156.77,
              56.23
            ],
            [
              -156.76,
              56.16
            ],
            [
              -156.8,
              56.16
            ],
            [
              -156.8,
              56.2
            ]
          ]
        ],
        [
          [
            [
              -157.32,
              56.54
            ],
            [
              -157.25,
              56.58
            ],
            [
              -157.08,
              56.58
            ],
            [
              -156.99,
              56.53
            ],
            [
              -157.11,
              56.55
            ],
            [
              -157.17,
              56.53
            ],
            [
              -157.32,
              56.53
            ],
            [
              -157.32,
              56.54
            ]
          ]
        ],
        [
          [
            [
              -157.9,
              56.35
            ],
            [
              -157.83,
              56.37
            ],
            [
              -157.79,
              56.32
            ],
            [
              -157.83,
              56.31
            ],
            [
              -157.9,
              56.35
            ]
          ]
        ],
        [
          [
            [
              -158.9,
              55.83
            ],
            [
              -158.87,
              55.88
            ],
            [
              -158.8,
              55.89
            ],
            [
              -158.7,
              55.84
            ],
            [
              -158.73,
              55.83
            ],
            [
              -158.81,
              55.86
            ],
            [
              -158.9,
              55.83
            ]
          ]
        ],
        [
          [
            [
              -159.14,
              55.88
            ],
            [
              -159.09,
              55.83
            ],
            [
              -159.18,
              55.84
            ],
            [
              -159.14,
              55.88
            ]
          ]
        ],
        [
          [
            [
              -159.32,
              54.9
            ],
            [
              -159.32,
              54.93
            ],
            [
              -159.28,
              54.95
            ],
            [
              -159.21,
              54.93
            ],
            [
              -159.24,
              54.88
            ],
            [
              -159.31,
              54.86
            ],
            [
              -159.32,
              54.9
            ]
          ]
        ],
        [
          [
            [
              -159.38,
              55.75
            ],
            [
              -159.36,
              55.81
            ],
            [
              -159.32,
              55.82
            ],
            [
              -159.28,
              55.76
            ],
            [
              -159.38,
              55.75
            ]
          ]
        ],
        [
          [
            [
              -159.46,
              54.95
            ],
            [
              -159.42,
              55.02
            ],
            [
              -159.46,
              55.06
            ],
            [
              -159.35,
              55.06
            ],
            [
              -159.33,
              54.97
            ],
            [
              -159.43,
              54.94
            ],
            [
              -159.46,
              54.95
            ]
          ]
        ],
        [
          [
            [
              -159.6,
              54.81
            ],
            [
              -159.57,
              54.83
            ],
            [
              -159.51,
              54.79
            ],
            [
              -159.51,
              54.76
            ],
            [
              -159.6,
              54.76
            ],
            [
              -159.6,
              54.81
            ]
          ]
        ],
        [
          [
            [
              -159.66,
              55.19
            ],
            [
              -159.6,
              55.17
            ],
            [
              -159.58,
              55.21
            ],
            [
              -159.52,
              55.25
            ],
            [
              -159.5,
              55.23
            ],
            [
              -159.53,
              55.19
            ],
            [
              -159.5,
              55.17
            ],
            [
              -159.5,
              55.14
            ],
            [
              -159.53,
              55.08
            ],
            [
              -159.49,
              55.06
            ],
            [
              -159.51,
              55.04
            ],
            [
              -159.57,
              55.06
            ],
            [
              -159.58,
              55.04
            ],
            [
              -159.65,
              55.05
            ],
            [
              -159.66,
              55.19
            ]
          ]
        ],
        [
          [
            [
              -159.82,
              54.82
            ],
            [
              -159.74,
              54.84
            ],
            [
              -159.7,
              54.82
            ],
            [
              -159.78,
              54.79
            ],
            [
              -159.82,
              54.82
            ]
          ]
        ],
        [
          [
            [
              -159.85,
              55.06
            ],
            [
              -159.82,
              55.09
            ],
            [
              -159.73,
              55.12
            ],
            [
              -159.71,
              55.09
            ],
            [
              -159.8,
              55.06
            ],
            [
              -159.83,
              55.01
            ],
            [
              -159.85,
              55.06
            ]
          ]
        ],
        [
          [
            [
              -160.11,
              55.33
            ],
            [
              -160.06,
              55.34
            ],
            [
              -160.05,
              55.31
            ],
            [
              -160.11,
              55.33
            ]
          ]
        ],
        [
          [
            [
              -160.25,
              54.93
            ],
            [
              -160.13,
              55.01
            ],
            [
              -160.08,
              55.04
            ],
            [
              -160.1,
              55.05
            ],
            [
              -160.17,
              55.05
            ],
            [
              -160.19,
              55.12
            ],
            [
              -160.11,
              55.16
            ],
            [
              -160.01,
              55.12
            ],
            [
              -160.02,
              55.16
            ],
            [
              -160.06,
              55.2
            ],
            [
              -159.96,
              55.19
            ],
            [
              -159.89,
              55.29
            ],
            [
              -159.85,
              55.27
            ],
            [
              -159.85,
              55.23
            ],
            [
              -159.89,
              55.23
            ],
            [
              -159.91,
              55.16
            ],
            [
              -159.86,
              55.15
            ],
            [
              -159.86,
              55.18
            ],
            [
              -159.82,
              55.18
            ],
            [
              -159.83,
              55.13
            ],
            [
              -159.87,
              55.09
            ],
            [
              -159.95,
              55.11
            ],
            [
              -159.95,
              55.07
            ],
            [
              -160.05,
              55.01
            ],
            [
              -160.12,
              54.98
            ],
            [
              -160.23,
              54.86
            ],
            [
              -160.25,
              54.93
            ]
          ]
        ],
        [
          [
            [
              -160.32,
              58.69
            ],
            [
              -160.3,
              58.73
            ],
            [
              -160.25,
              58.66
            ],
            [
              -160.27,
              58.64
            ],
            [
              -160.32,
              58.69
            ]
          ]
        ],
        [
          [
            [
              -160.35,
              55.43
            ],
            [
              -160.27,
              55.46
            ],
            [
              -160.14,
              55.45
            ],
            [
              -160.14,
              55.38
            ],
            [
              -160.32,
              55.39
            ],
            [
              -160.35,
              55.43
            ]
          ]
        ],
        [
          [
            [
              -160.44,
              58.68
            ],
            [
              -160.41,
              58.75
            ],
            [
              -160.39,
              58.7
            ],
            [
              -160.44,
              58.68
            ]
          ]
        ],
        [
          [
            [
              -160.86,
              55.32
            ],
            [
              -160.8,
              55.38
            ],
            [
              -160.71,
              55.4
            ],
            [
              -160.64,
              55.38
            ],
            [
              -160.65,
              55.34
            ],
            [
              -160.62,
              55.35
            ],
            [
              -160.57,
              55.39
            ],
            [
              -160.52,
              55.36
            ],
            [
              -160.43,
              55.34
            ],
            [
              -160.33,
              55.36
            ],
            [
              -160.31,
              55.3
            ],
            [
              -160.34,
              55.25
            ],
            [
              -160.39,
              55.29
            ],
            [
              -160.47,
              55.29
            ],
            [
              -160.52,
              55.31
            ],
            [
              -160.53,
              55.34
            ],
            [
              -160.57,
              55.33
            ],
            [
              -160.57,
              55.27
            ],
            [
              -160.53,
              55.26
            ],
            [
              -160.49,
              55.18
            ],
            [
              -160.53,
              55.13
            ],
            [
              -160.66,
              55.16
            ],
            [
              -160.69,
              55.21
            ],
            [
              -160.76,
              55.2
            ],
            [
              -160.82,
              55.12
            ],
            [
              -160.81,
              55.17
            ],
            [
              -160.84,
              55.2
            ],
            [
              -160.84,
              55.29
            ],
            [
              -160.86,
              55.32
            ]
          ]
        ],
        [
          [
            [
              -161.08,
              58.59
            ],
            [
              -161.06,
              58.7
            ],
            [
              -160.92,
              58.75
            ],
            [
              -160.84,
              58.75
            ],
            [
              -160.7,
              58.82
            ],
            [
              -160.68,
              58.82
            ],
            [
              -160.88,
              58.58
            ],
            [
              -160.96,
              58.55
            ],
            [
              -161.08,
              58.55
            ],
            [
              -161.08,
              58.59
            ]
          ]
        ],
        [
          [
            [
              -161.43,
              55.22
            ],
            [
              -161.33,
              55.22
            ],
            [
              -161.34,
              55.16
            ],
            [
              -161.44,
              55.2
            ],
            [
              -161.43,
              55.22
            ]
          ]
        ],
        [
          [
            [
              -161.69,
              55.22
            ],
            [
              -161.66,
              55.24
            ],
            [
              -161.53,
              55.25
            ],
            [
              -161.56,
              55.21
            ],
            [
              -161.69,
              55.2
            ],
            [
              -161.69,
              55.22
            ]
          ]
        ],
        [
          [
            [
              -161.9,
              55.12
            ],
            [
              -161.89,
              55.16
            ],
            [
              -161.83,
              55.18
            ],
            [
              -161.74,
              55.16
            ],
            [
              -161.7,
              55.14
            ],
            [
              -161.57,
              55.1
            ],
            [
              -161.55,
              55.07
            ],
            [
              -161.66,
              55.1
            ],
            [
              -161.74,
              55.05
            ],
            [
              -161.84,
              55.12
            ],
            [
              -161.88,
              55.09
            ],
            [
              -161.9,
              55.12
            ]
          ]
        ],
        [
          [
            [
              -162.44,
              54.93
            ],
            [
              -162.33,
              54.99
            ],
            [
              -162.23,
              54.96
            ],
            [
              -162.23,
              54.89
            ],
            [
              -162.27,
              54.85
            ],
            [
              -162.32,
              54.83
            ],
            [
              -162.42,
              54.88
            ],
            [
              -162.44,
              54.93
            ]
          ]
        ],
        [
          [
            [
              -162.68,
              63.58
            ],
            [
              -162.62,
              63.62
            ],
            [
              -162.54,
              63.64
            ],
            [
              -162.45,
              63.62
            ],
            [
              -162.37,
              63.63
            ],
            [
              -162.34,
              63.59
            ],
            [
              -162.35,
              63.55
            ],
            [
              -162.62,
              63.54
            ],
            [
              -162.68,
              63.56
            ],
            [
              -162.68,
              63.58
            ]
          ]
        ],
        [
          [
            [
              -162.83,
              54.45
            ],
            [
              -162.83,
              54.49
            ],
            [
              -162.59,
              54.45
            ],
            [
              -162.52,
              54.41
            ],
            [
              -162.42,
              54.41
            ],
            [
              -162.36,
              54.39
            ],
            [
              -162.43,
              54.37
            ],
            [
              -162.47,
              54.34
            ],
            [
              -162.55,
              54.38
            ],
            [
              -162.61,
              54.37
            ],
            [
              -162.72,
              54.4
            ],
            [
              -162.78,
              54.38
            ],
            [
              -162.86,
              54.42
            ],
            [
              -162.83,
              54.45
            ]
          ]
        ],
        [
          [
            [
              -163.17,
              55.43
            ],
            [
              -163.12,
              55.43
            ],
            [
              -163.14,
              55.4
            ],
            [
              -163.17,
              55.43
            ]
          ]
        ],
        [
          [
            [
              -164.87,
              54.21
            ],
            [
              -164.82,
              54.23
            ],
            [
              -164.77,
              54.21
            ],
            [
              -164.84,
              54.18
            ],
            [
              -164.87,
              54.21
            ]
          ]
        ],
        [
          [
            [
              -165.22,
              54.1
            ],
            [
              -165.14,
              54.13
            ],
            [
              -165.02,
              54.12
            ],
            [
              -164.94,
              54.14
            ],
            [
              -164.92,
              54.12
            ],
            [
              -164.95,
              54.08
            ],
            [
              -165.05,
              54.07
            ],
            [
              -165.21,
              54.09
            ],
            [
              -165.22,
              54.1
            ]
          ]
        ],
        [
          [
            [
              -165.48,
              54.08
            ],
            [
              -165.27,
              54.1
            ],
            [
              -165.24,
              54.07
            ],
            [
              -165.29,
              54.04
            ],
            [
              -165.34,
              54.07
            ],
            [
              -165.46,
              54.07
            ],
            [
              -165.48,
              54.08
            ]
          ]
        ],
        [
          [
            [
              -165.58,
              54.04
            ],
            [
              -165.52,
              54.07
            ],
            [
              -165.49,
              54.04
            ],
            [
              -165.55,
              54.02
            ],
            [
              -165.58,
              54.04
            ]
          ]
        ],
        [
          [
            [
              -165.68,
              54.25
            ],
            [
              -165.64,
              54.3
            ],
            [
              -165.59,
              54.28
            ],
            [
              -165.52,
              54.3
            ],
            [
              -165.48,
              54.28
            ],
            [
              -165.56,
              54.25
            ],
            [
              -165.51,
              54.21
            ],
            [
              -165.4,
              54.21
            ],
            [
              -165.4,
              54.18
            ],
            [
              -165.48,
              54.18
            ],
            [
              -165.55,
              54.11
            ],
            [
              -165.63,
              54.13
            ],
            [
              -165.64,
              54.2
            ],
            [
              -165.58,
              54.23
            ],
            [
              -165.61,
              54.25
            ],
            [
              -165.67,
              54.23
            ],
            [
              -165.68,
              54.25
            ]
          ]
        ],
        [
          [
            [
              -166.1,
              54.14
            ],
            [
              -166.08,
              54.17
            ],
            [
              -165.98,
              54.22
            ],
            [
              -165.87,
              54.22
            ],
            [
              -165.86,
              54.17
            ],
            [
              -165.79,
              54.17
            ],
            [
              -165.74,
              54.16
            ],
            [
              -165.71,
              54.12
            ],
            [
              -165.67,
              54.13
            ],
            [
              -165.67,
              54.1
            ],
            [
              -165.77,
              54.07
            ],
            [
              -165.81,
              54.08
            ],
            [
              -165.87,
              54.04
            ],
            [
              -165.9,
              54.06
            ],
            [
              -165.99,
              54.06
            ],
            [
              -166.05,
              54.04
            ],
            [
              -166.11,
              54.12
            ],
            [
              -166.1,
              54.14
            ]
          ]
        ],
        [
          [
            [
              -166.2,
              53.98
            ],
            [
              -166.17,
              54
            ],
            [
              -166.08,
              53.97
            ],
            [
              -166.19,
              53.96
            ],
            [
              -166.2,
              53.98
            ]
          ]
        ],
        [
          [
            [
              -167.44,
              60.21
            ],
            [
              -167.32,
              60.23
            ],
            [
              -167.11,
              60.23
            ],
            [
              -167.03,
              60.21
            ],
            [
              -166.95,
              60.22
            ],
            [
              -166.92,
              60.2
            ],
            [
              -166.84,
              60.21
            ],
            [
              -166.81,
              60.24
            ],
            [
              -166.84,
              60.27
            ],
            [
              -166.71,
              60.33
            ],
            [
              -166.58,
              60.32
            ],
            [
              -166.58,
              60.35
            ],
            [
              -166.49,
              60.39
            ],
            [
              -166.37,
              60.35
            ],
            [
              -166.29,
              60.38
            ],
            [
              -166.2,
              60.39
            ],
            [
              -166.15,
              60.44
            ],
            [
              -166.08,
              60.32
            ],
            [
              -165.99,
              60.31
            ],
            [
              -165.88,
              60.34
            ],
            [
              -165.78,
              60.33
            ],
            [
              -165.68,
              60.29
            ],
            [
              -165.72,
              60.24
            ],
            [
              -165.68,
              60.2
            ],
            [
              -165.72,
              60.16
            ],
            [
              -165.68,
              60.15
            ],
            [
              -165.66,
              60.1
            ],
            [
              -165.71,
              60.07
            ],
            [
              -165.63,
              60.02
            ],
            [
              -165.63,
              59.97
            ],
            [
              -165.55,
              59.98
            ],
            [
              -165.59,
              59.95
            ],
            [
              -165.58,
              59.91
            ],
            [
              -165.84,
              59.89
            ],
            [
              -165.86,
              59.86
            ],
            [
              -165.93,
              59.88
            ],
            [
              -166.02,
              59.86
            ],
            [
              -166.13,
              59.81
            ],
            [
              -166.1,
              59.76
            ],
            [
              -166.19,
              59.75
            ],
            [
              -166.27,
              59.81
            ],
            [
              -166.41,
              59.85
            ],
            [
              -166.61,
              59.85
            ],
            [
              -166.66,
              59.88
            ],
            [
              -166.76,
              59.89
            ],
            [
              -166.86,
              59.94
            ],
            [
              -166.99,
              59.98
            ],
            [
              -167.13,
              60
            ],
            [
              -167.25,
              60.06
            ],
            [
              -167.33,
              60.07
            ],
            [
              -167.34,
              60.13
            ],
            [
              -167.44,
              60.21
            ]
          ]
        ],
        [
          [
            [
              -167.85,
              53.32
            ],
            [
              -167.79,
              53.34
            ],
            [
              -167.71,
              53.38
            ],
            [
              -167.62,
              53.39
            ],
            [
              -167.49,
              53.42
            ],
            [
              -167.46,
              53.44
            ],
            [
              -167.36,
              53.42
            ],
            [
              -167.31,
              53.44
            ],
            [
              -167.28,
              53.48
            ],
            [
              -167.2,
              53.46
            ],
            [
              -167.19,
              53.52
            ],
            [
              -167.1,
              53.52
            ],
            [
              -167.16,
              53.61
            ],
            [
              -167.09,
              53.63
            ],
            [
              -167.06,
              53.62
            ],
            [
              -167.01,
              53.64
            ],
            [
              -167.07,
              53.67
            ],
            [
              -167.06,
              53.7
            ],
            [
              -167,
              53.72
            ],
            [
              -166.89,
              53.72
            ],
            [
              -166.86,
              53.66
            ],
            [
              -166.81,
              53.67
            ],
            [
              -166.83,
              53.71
            ],
            [
              -166.79,
              53.73
            ],
            [
              -166.98,
              53.78
            ],
            [
              -167.03,
              53.76
            ],
            [
              -167.14,
              53.83
            ],
            [
              -167.14,
              53.87
            ],
            [
              -167.03,
              53.95
            ],
            [
              -166.88,
              53.99
            ],
            [
              -166.75,
              54.02
            ],
            [
              -166.73,
              54
            ],
            [
              -166.65,
              54.01
            ],
            [
              -166.59,
              53.96
            ],
            [
              -166.65,
              53.92
            ],
            [
              -166.62,
              53.89
            ],
            [
              -166.56,
              53.88
            ],
            [
              -166.51,
              53.92
            ],
            [
              -166.49,
              53.9
            ],
            [
              -166.43,
              53.92
            ],
            [
              -166.44,
              53.96
            ],
            [
              -166.37,
              54.01
            ],
            [
              -166.32,
              53.96
            ],
            [
              -166.28,
              53.98
            ],
            [
              -166.21,
              53.93
            ],
            [
              -166.24,
              53.88
            ],
            [
              -166.32,
              53.87
            ],
            [
              -166.41,
              53.81
            ],
            [
              -166.55,
              53.75
            ],
            [
              -166.54,
              53.72
            ],
            [
              -166.42,
              53.76
            ],
            [
              -166.21,
              53.82
            ],
            [
              -166.2,
              53.84
            ],
            [
              -166.12,
              53.86
            ],
            [
              -166.09,
              53.84
            ],
            [
              -166.11,
              53.78
            ],
            [
              -166.17,
              53.73
            ],
            [
              -166.26,
              53.7
            ],
            [
              -166.28,
              53.68
            ],
            [
              -166.44,
              53.64
            ],
            [
              -166.55,
              53.62
            ],
            [
              -166.51,
              53.58
            ],
            [
              -166.57,
              53.58
            ],
            [
              -166.58,
              53.53
            ],
            [
              -166.64,
              53.55
            ],
            [
              -166.66,
              53.48
            ],
            [
              -166.74,
              53.51
            ],
            [
              -166.75,
              53.44
            ],
            [
              -166.88,
              53.43
            ],
            [
              -166.96,
              53.46
            ],
            [
              -166.99,
              53.43
            ],
            [
              -167.04,
              53.45
            ],
            [
              -167.11,
              53.42
            ],
            [
              -167.13,
              53.43
            ],
            [
              -167.29,
              53.36
            ],
            [
              -167.3,
              53.34
            ],
            [
              -167.39,
              53.34
            ],
            [
              -167.44,
              53.32
            ],
            [
              -167.49,
              53.27
            ],
            [
              -167.59,
              53.29
            ],
            [
              -167.62,
              53.25
            ],
            [
              -167.8,
              53.28
            ],
            [
              -167.85,
              53.32
            ]
          ]
        ],
        [
          [
            [
              -168.13,
              65.66
            ],
            [
              -168.1,
              65.69
            ],
            [
              -167.98,
              65.73
            ],
            [
              -167.54,
              65.82
            ],
            [
              -167.31,
              65.88
            ],
            [
              -167.14,
              65.95
            ],
            [
              -166.98,
              66
            ],
            [
              -166.83,
              66.05
            ],
            [
              -166.53,
              66.14
            ],
            [
              -166.33,
              66.19
            ],
            [
              -165.81,
              66.33
            ],
            [
              -165.19,
              66.47
            ],
            [
              -164.71,
              66.54
            ],
            [
              -164.4,
              66.58
            ],
            [
              -163.91,
              66.59
            ],
            [
              -163.73,
              66.58
            ],
            [
              -163.61,
              66.56
            ],
            [
              -163.75,
              66.55
            ],
            [
              -163.73,
              66.52
            ],
            [
              -163.76,
              66.46
            ],
            [
              -163.87,
              66.39
            ],
            [
              -163.87,
              66.33
            ],
            [
              -163.83,
              66.28
            ],
            [
              -163.9,
              66.23
            ],
            [
              -164.08,
              66.2
            ],
            [
              -164.09,
              66.18
            ],
            [
              -163.92,
              66.19
            ],
            [
              -163.77,
              66.06
            ],
            [
              -163.62,
              66.06
            ],
            [
              -163.49,
              66.09
            ],
            [
              -163.34,
              66.08
            ],
            [
              -163.17,
              66.06
            ],
            [
              -163,
              66.08
            ],
            [
              -162.75,
              66.09
            ],
            [
              -162.64,
              66.04
            ],
            [
              -162.46,
              66.06
            ],
            [
              -162.39,
              66.03
            ],
            [
              -162.21,
              66.06
            ],
            [
              -162.14,
              66.08
            ],
            [
              -161.84,
              66.02
            ],
            [
              -161.78,
              66.07
            ],
            [
              -161.68,
              66.11
            ],
            [
              -161.55,
              66.24
            ],
            [
              -161.48,
              66.26
            ],
            [
              -161.34,
              66.25
            ],
            [
              -161.31,
              66.22
            ],
            [
              -161.2,
              66.21
            ],
            [
              -161.09,
              66.23
            ],
            [
              -160.99,
              66.23
            ],
            [
              -161.11,
              66.33
            ],
            [
              -161.36,
              66.38
            ],
            [
              -161.52,
              66.4
            ],
            [
              -161.7,
              66.4
            ],
            [
              -161.91,
              66.34
            ],
            [
              -161.86,
              66.44
            ],
            [
              -161.88,
              66.51
            ],
            [
              -162.1,
              66.61
            ],
            [
              -162.18,
              66.69
            ],
            [
              -162.27,
              66.72
            ],
            [
              -162.48,
              66.73
            ],
            [
              -162.51,
              66.78
            ],
            [
              -162.63,
              66.86
            ],
            [
              -162.6,
              66.9
            ],
            [
              -162.5,
              66.91
            ],
            [
              -162.47,
              66.95
            ],
            [
              -162.41,
              66.92
            ],
            [
              -162.32,
              66.94
            ],
            [
              -162.23,
              66.87
            ],
            [
              -162.1,
              66.79
            ],
            [
              -162.01,
              66.78
            ],
            [
              -162.08,
              66.69
            ],
            [
              -162.07,
              66.65
            ],
            [
              -161.97,
              66.6
            ],
            [
              -161.76,
              66.5
            ],
            [
              -161.57,
              66.44
            ],
            [
              -161.43,
              66.45
            ],
            [
              -161.33,
              66.48
            ],
            [
              -161.29,
              66.52
            ],
            [
              -161.46,
              66.52
            ],
            [
              -161.49,
              66.56
            ],
            [
              -161.69,
              66.62
            ],
            [
              -161.88,
              66.72
            ],
            [
              -161.85,
              66.76
            ],
            [
              -161.85,
              66.81
            ],
            [
              -161.8,
              66.83
            ],
            [
              -161.79,
              66.88
            ],
            [
              -161.67,
              66.96
            ],
            [
              -161.57,
              66.93
            ],
            [
              -161.49,
              66.94
            ],
            [
              -161.48,
              66.96
            ],
            [
              -161.62,
              67.01
            ],
            [
              -161.71,
              67
            ],
            [
              -161.81,
              67.05
            ],
            [
              -162.12,
              67.03
            ],
            [
              -162.24,
              66.99
            ],
            [
              -162.36,
              66.99
            ],
            [
              -162.5,
              66.98
            ],
            [
              -162.62,
              66.99
            ],
            [
              -162.69,
              67.03
            ],
            [
              -162.76,
              67.02
            ],
            [
              -162.83,
              67.03
            ],
            [
              -162.84,
              66.99
            ],
            [
              -162.97,
              67.02
            ],
            [
              -163.3,
              67.06
            ],
            [
              -163.49,
              67.09
            ],
            [
              -163.67,
              67.1
            ],
            [
              -163.75,
              67.13
            ],
            [
              -163.74,
              67.21
            ],
            [
              -163.82,
              67.35
            ],
            [
              -164.01,
              67.54
            ],
            [
              -164.08,
              67.59
            ],
            [
              -164.21,
              67.64
            ],
            [
              -164.54,
              67.73
            ],
            [
              -165.06,
              67.92
            ],
            [
              -165.13,
              67.94
            ],
            [
              -165.31,
              68.02
            ],
            [
              -165.49,
              68.06
            ],
            [
              -165.69,
              68.09
            ],
            [
              -165.87,
              68.11
            ],
            [
              -165.97,
              68.14
            ],
            [
              -166.04,
              68.2
            ],
            [
              -166.24,
              68.27
            ],
            [
              -166.4,
              68.31
            ],
            [
              -166.69,
              68.34
            ],
            [
              -166.84,
              68.34
            ],
            [
              -166.71,
              68.37
            ],
            [
              -166.38,
              68.42
            ],
            [
              -166.3,
              68.46
            ],
            [
              -166.29,
              68.51
            ],
            [
              -166.23,
              68.58
            ],
            [
              -166.19,
              68.78
            ],
            [
              -166.22,
              68.88
            ],
            [
              -165.57,
              68.85
            ],
            [
              -165.33,
              68.86
            ],
            [
              -164.81,
              68.89
            ],
            [
              -164.53,
              68.92
            ],
            [
              -164.25,
              68.93
            ],
            [
              -163.98,
              68.98
            ],
            [
              -163.83,
              69.04
            ],
            [
              -163.72,
              69.07
            ],
            [
              -163.53,
              69.14
            ],
            [
              -163.24,
              69.31
            ],
            [
              -163.17,
              69.39
            ],
            [
              -163.14,
              69.45
            ],
            [
              -163.15,
              69.61
            ],
            [
              -163.01,
              69.81
            ],
            [
              -162.71,
              69.97
            ],
            [
              -162.48,
              70.12
            ],
            [
              -162.34,
              70.19
            ],
            [
              -161.88,
              70.33
            ],
            [
              -161.53,
              70.3
            ],
            [
              -161.29,
              70.3
            ],
            [
              -161.04,
              70.33
            ],
            [
              -160.81,
              70.38
            ],
            [
              -160.48,
              70.47
            ],
            [
              -160.21,
              70.56
            ],
            [
              -160.06,
              70.63
            ],
            [
              -159.65,
              70.79
            ],
            [
              -159.53,
              70.82
            ],
            [
              -159.17,
              70.87
            ],
            [
              -159.15,
              70.83
            ],
            [
              -158.95,
              70.8
            ],
            [
              -158.66,
              70.79
            ],
            [
              -158.41,
              70.8
            ],
            [
              -158.37,
              70.82
            ],
            [
              -158.25,
              70.82
            ],
            [
              -158.03,
              70.83
            ],
            [
              -157.77,
              70.88
            ],
            [
              -157.5,
              70.95
            ],
            [
              -157.25,
              71.05
            ],
            [
              -157.12,
              71.13
            ],
            [
              -156.81,
              71.29
            ],
            [
              -156.57,
              71.35
            ],
            [
              -156.52,
              71.29
            ],
            [
              -156.36,
              71.26
            ],
            [
              -156.22,
              71.26
            ],
            [
              -156.08,
              71.24
            ],
            [
              -156.02,
              71.17
            ],
            [
              -155.92,
              71.21
            ],
            [
              -155.57,
              71.17
            ],
            [
              -155.51,
              71.08
            ],
            [
              -155.71,
              71.02
            ],
            [
              -155.83,
              70.97
            ],
            [
              -155.98,
              70.96
            ],
            [
              -155.94,
              70.84
            ],
            [
              -155.64,
              70.82
            ],
            [
              -155.49,
              70.87
            ],
            [
              -155.51,
              70.94
            ],
            [
              -155.45,
              70.95
            ],
            [
              -155.34,
              71
            ],
            [
              -155.26,
              71.01
            ],
            [
              -155.19,
              70.97
            ],
            [
              -155.18,
              71.03
            ],
            [
              -155.27,
              71.06
            ],
            [
              -155.15,
              71.11
            ],
            [
              -155.07,
              71.07
            ],
            [
              -155.08,
              71.13
            ],
            [
              -155.03,
              71.15
            ],
            [
              -154.78,
              71.08
            ],
            [
              -154.61,
              71.03
            ],
            [
              -154.57,
              70.99
            ],
            [
              -154.61,
              70.96
            ],
            [
              -154.6,
              70.87
            ],
            [
              -154.57,
              70.83
            ],
            [
              -154.35,
              70.83
            ],
            [
              -154.23,
              70.8
            ],
            [
              -154.17,
              70.77
            ],
            [
              -154,
              70.82
            ],
            [
              -153.89,
              70.89
            ],
            [
              -153.49,
              70.89
            ],
            [
              -153.24,
              70.92
            ],
            [
              -153.05,
              70.91
            ],
            [
              -152.91,
              70.88
            ],
            [
              -152.6,
              70.88
            ],
            [
              -152.39,
              70.85
            ],
            [
              -152.22,
              70.82
            ],
            [
              -152.19,
              70.8
            ],
            [
              -152.29,
              70.79
            ],
            [
              -152.38,
              70.71
            ],
            [
              -152.47,
              70.69
            ],
            [
              -152.42,
              70.61
            ],
            [
              -152.33,
              70.61
            ],
            [
              -152.26,
              70.59
            ],
            [
              -152.1,
              70.59
            ],
            [
              -152.07,
              70.56
            ],
            [
              -151.82,
              70.55
            ],
            [
              -151.7,
              70.55
            ],
            [
              -151.76,
              70.52
            ],
            [
              -151.73,
              70.5
            ],
            [
              -151.92,
              70.47
            ],
            [
              -151.95,
              70.45
            ],
            [
              -151.88,
              70.43
            ],
            [
              -151.56,
              70.44
            ],
            [
              -151.3,
              70.4
            ],
            [
              -151.25,
              70.37
            ],
            [
              -151.15,
              70.38
            ],
            [
              -150.99,
              70.45
            ],
            [
              -150.78,
              70.46
            ],
            [
              -150.7,
              70.45
            ],
            [
              -150.66,
              70.48
            ],
            [
              -150.52,
              70.48
            ],
            [
              -150.42,
              70.46
            ],
            [
              -150.36,
              70.41
            ],
            [
              -150.21,
              70.43
            ],
            [
              -150.07,
              70.44
            ],
            [
              -149.87,
              70.51
            ],
            [
              -149.82,
              70.49
            ],
            [
              -149.66,
              70.51
            ],
            [
              -149.58,
              70.5
            ],
            [
              -149.46,
              70.52
            ],
            [
              -149.42,
              70.49
            ],
            [
              -149.18,
              70.49
            ],
            [
              -148.96,
              70.42
            ],
            [
              -148.86,
              70.42
            ],
            [
              -148.79,
              70.4
            ],
            [
              -148.7,
              70.43
            ],
            [
              -148.61,
              70.42
            ],
            [
              -148.48,
              70.36
            ],
            [
              -148.48,
              70.32
            ],
            [
              -148.35,
              70.3
            ],
            [
              -148.2,
              70.35
            ],
            [
              -148.2,
              70.29
            ],
            [
              -148.11,
              70.34
            ],
            [
              -147.82,
              70.28
            ],
            [
              -147.77,
              70.22
            ],
            [
              -147.68,
              70.2
            ],
            [
              -147.5,
              70.2
            ],
            [
              -147.35,
              70.19
            ],
            [
              -147.25,
              70.22
            ],
            [
              -147.16,
              70.16
            ],
            [
              -146.99,
              70.15
            ],
            [
              -146.89,
              70.19
            ],
            [
              -146.73,
              70.18
            ],
            [
              -146.51,
              70.19
            ],
            [
              -146.27,
              70.18
            ],
            [
              -146.1,
              70.14
            ],
            [
              -145.92,
              70.14
            ],
            [
              -145.86,
              70.17
            ],
            [
              -145.62,
              70.08
            ],
            [
              -145.52,
              70.08
            ],
            [
              -145.41,
              70.03
            ],
            [
              -145.25,
              70.02
            ],
            [
              -145.17,
              69.99
            ],
            [
              -145.01,
              69.98
            ],
            [
              -144.95,
              69.96
            ],
            [
              -144.86,
              69.99
            ],
            [
              -144.62,
              69.97
            ],
            [
              -144.46,
              70.04
            ],
            [
              -144.28,
              70.04
            ],
            [
              -144.25,
              70.06
            ],
            [
              -143.95,
              70.1
            ],
            [
              -143.89,
              70.12
            ],
            [
              -143.58,
              70.15
            ],
            [
              -143.43,
              70.12
            ],
            [
              -143.25,
              70.15
            ],
            [
              -143.22,
              70.14
            ],
            [
              -142.94,
              70.07
            ],
            [
              -142.75,
              70.04
            ],
            [
              -142.5,
              69.97
            ],
            [
              -142.4,
              69.92
            ],
            [
              -142.27,
              69.91
            ],
            [
              -141.96,
              69.82
            ],
            [
              -141.71,
              69.79
            ],
            [
              -141.53,
              69.74
            ],
            [
              -141.43,
              69.7
            ],
            [
              -141.21,
              69.68
            ],
            [
              -141,
              69.65
            ],
            [
              -141,
              61.9
            ],
            [
              -141,
              61.07
            ],
            [
              -141,
              60.31
            ],
            [
              -140.53,
              60.22
            ],
            [
              -140.47,
              60.31
            ],
            [
              -139.99,
              60.19
            ],
            [
              -139.7,
              60.34
            ],
            [
              -139.09,
              60.36
            ],
            [
              -139.08,
              60.32
            ],
            [
              -139.2,
              60.09
            ],
            [
              -139.03,
              59.99
            ],
            [
              -138.8,
              59.93
            ],
            [
              -138.7,
              59.91
            ],
            [
              -138.66,
              59.81
            ],
            [
              -138.56,
              59.74
            ],
            [
              -137.6,
              59.24
            ],
            [
              -137.5,
              58.99
            ],
            [
              -137.53,
              58.91
            ],
            [
              -137.45,
              58.91
            ],
            [
              -137.26,
              59
            ],
            [
              -136.87,
              59.14
            ],
            [
              -136.83,
              59.16
            ],
            [
              -136.58,
              59.17
            ],
            [
              -136.47,
              59.28
            ],
            [
              -136.47,
              59.46
            ],
            [
              -136.37,
              59.45
            ],
            [
              -136.3,
              59.46
            ],
            [
              -136.23,
              59.53
            ],
            [
              -136.24,
              59.56
            ],
            [
              -136.35,
              59.6
            ],
            [
              -136.19,
              59.64
            ],
            [
              -135.95,
              59.66
            ],
            [
              -135.48,
              59.8
            ],
            [
              -135.25,
              59.7
            ],
            [
              -135.15,
              59.63
            ],
            [
              -135.11,
              59.62
            ],
            [
              -135.03,
              59.56
            ],
            [
              -135.03,
              59.47
            ],
            [
              -135.07,
              59.45
            ],
            [
              -135.07,
              59.42
            ],
            [
              -135.01,
              59.38
            ],
            [
              -135.03,
              59.35
            ],
            [
              -134.96,
              59.28
            ],
            [
              -134.7,
              59.25
            ],
            [
              -134.68,
              59.19
            ],
            [
              -134.57,
              59.13
            ],
            [
              -134.48,
              59.13
            ],
            [
              -134.38,
              59.04
            ],
            [
              -134.4,
              58.98
            ],
            [
              -134.31,
              58.96
            ],
            [
              -134.33,
              58.92
            ],
            [
              -134.25,
              58.86
            ],
            [
              -133.84,
              58.73
            ],
            [
              -133.72,
              58.63
            ],
            [
              -133.56,
              58.52
            ],
            [
              -133.38,
              58.43
            ],
            [
              -133.46,
              58.39
            ],
            [
              -133.34,
              58.27
            ],
            [
              -133.18,
              58.15
            ],
            [
              -133.08,
              58
            ],
            [
              -132.87,
              57.84
            ],
            [
              -132.76,
              57.7
            ],
            [
              -132.65,
              57.61
            ],
            [
              -132.56,
              57.5
            ],
            [
              -132.37,
              57.35
            ],
            [
              -132.25,
              57.22
            ],
            [
              -132.37,
              57.1
            ],
            [
              -132.05,
              57.05
            ],
            [
              -132.13,
              56.87
            ],
            [
              -131.87,
              56.81
            ],
            [
              -131.9,
              56.75
            ],
            [
              -131.86,
              56.7
            ],
            [
              -131.84,
              56.6
            ],
            [
              -131.58,
              56.61
            ],
            [
              -131.46,
              56.55
            ],
            [
              -131.17,
              56.45
            ],
            [
              -131.09,
              56.41
            ],
            [
              -130.78,
              56.37
            ],
            [
              -130.62,
              56.27
            ],
            [
              -130.47,
              56.24
            ],
            [
              -130.43,
              56.14
            ],
            [
              -130.34,
              56.13
            ],
            [
              -130.25,
              56.1
            ],
            [
              -130.1,
              56.12
            ],
            [
              -130,
              55.99
            ],
            [
              -130.01,
              55.92
            ],
            [
              -130.09,
              55.82
            ],
            [
              -130.15,
              55.77
            ],
            [
              -130.15,
              55.72
            ],
            [
              -130.11,
              55.68
            ],
            [
              -130.13,
              55.58
            ],
            [
              -130.09,
              55.49
            ],
            [
              -130.05,
              55.45
            ],
            [
              -130.02,
              55.34
            ],
            [
              -129.98,
              55.28
            ],
            [
              -130.1,
              55.2
            ],
            [
              -130.18,
              55.09
            ],
            [
              -130.19,
              55.06
            ],
            [
              -130.26,
              54.99
            ],
            [
              -130.34,
              54.92
            ],
            [
              -130.47,
              54.84
            ],
            [
              -130.57,
              54.79
            ],
            [
              -130.64,
              54.78
            ],
            [
              -130.63,
              54.74
            ],
            [
              -130.7,
              54.72
            ],
            [
              -130.74,
              54.75
            ],
            [
              -130.74,
              54.8
            ],
            [
              -130.79,
              54.82
            ],
            [
              -130.79,
              54.78
            ],
            [
              -130.84,
              54.77
            ],
            [
              -130.9,
              54.78
            ],
            [
              -130.95,
              54.83
            ],
            [
              -130.96,
              54.92
            ],
            [
              -130.95,
              54.97
            ],
            [
              -131.01,
              55
            ],
            [
              -130.98,
              55.08
            ],
            [
              -131.01,
              55.09
            ],
            [
              -131.07,
              55.14
            ],
            [
              -131.09,
              55.19
            ],
            [
              -130.99,
              55.25
            ],
            [
              -130.93,
              55.3
            ],
            [
              -130.87,
              55.29
            ],
            [
              -130.88,
              55.36
            ],
            [
              -130.92,
              55.43
            ],
            [
              -130.87,
              55.53
            ],
            [
              -130.9,
              55.7
            ],
            [
              -130.94,
              55.75
            ],
            [
              -131.09,
              55.9
            ],
            [
              -131.17,
              55.94
            ],
            [
              -131.22,
              55.98
            ],
            [
              -131.24,
              55.95
            ],
            [
              -131.16,
              55.9
            ],
            [
              -131.07,
              55.83
            ],
            [
              -131.04,
              55.77
            ],
            [
              -130.96,
              55.69
            ],
            [
              -130.93,
              55.58
            ],
            [
              -130.99,
              55.54
            ],
            [
              -130.99,
              55.47
            ],
            [
              -130.97,
              55.39
            ],
            [
              -130.93,
              55.34
            ],
            [
              -130.96,
              55.32
            ],
            [
              -131,
              55.4
            ],
            [
              -131.03,
              55.41
            ],
            [
              -131.02,
              55.35
            ],
            [
              -131.03,
              55.28
            ],
            [
              -131.16,
              55.2
            ],
            [
              -131.21,
              55.19
            ],
            [
              -131.3,
              55.23
            ],
            [
              -131.23,
              55.3
            ],
            [
              -131.19,
              55.36
            ],
            [
              -131.2,
              55.39
            ],
            [
              -131.29,
              55.38
            ],
            [
              -131.26,
              55.32
            ],
            [
              -131.28,
              55.29
            ],
            [
              -131.4,
              55.24
            ],
            [
              -131.43,
              55.24
            ],
            [
              -131.51,
              55.33
            ],
            [
              -131.55,
              55.29
            ],
            [
              -131.64,
              55.34
            ],
            [
              -131.7,
              55.36
            ],
            [
              -131.74,
              55.4
            ],
            [
              -131.84,
              55.46
            ],
            [
              -131.84,
              55.52
            ],
            [
              -131.73,
              55.55
            ],
            [
              -131.65,
              55.59
            ],
            [
              -131.73,
              55.63
            ],
            [
              -131.7,
              55.7
            ],
            [
              -131.73,
              55.73
            ],
            [
              -131.65,
              55.77
            ],
            [
              -131.64,
              55.79
            ],
            [
              -131.7,
              55.79
            ],
            [
              -131.71,
              55.85
            ],
            [
              -131.69,
              55.89
            ],
            [
              -131.84,
              55.88
            ],
            [
              -131.82,
              55.84
            ],
            [
              -131.78,
              55.82
            ],
            [
              -131.78,
              55.79
            ],
            [
              -131.83,
              55.72
            ],
            [
              -131.83,
              55.67
            ],
            [
              -131.9,
              55.6
            ],
            [
              -131.96,
              55.62
            ],
            [
              -131.94,
              55.54
            ],
            [
              -131.97,
              55.5
            ],
            [
              -132.06,
              55.54
            ],
            [
              -132.15,
              55.56
            ],
            [
              -132.18,
              55.59
            ],
            [
              -132.22,
              55.7
            ],
            [
              -132.28,
              55.76
            ],
            [
              -132.21,
              55.74
            ],
            [
              -132.18,
              55.8
            ],
            [
              -132.08,
              55.83
            ],
            [
              -132.04,
              55.96
            ],
            [
              -132.07,
              56.05
            ],
            [
              -132.03,
              56.1
            ],
            [
              -132.01,
              56.08
            ],
            [
              -131.97,
              56.11
            ],
            [
              -131.94,
              56.19
            ],
            [
              -132.02,
              56.18
            ],
            [
              -132.03,
              56.13
            ],
            [
              -132.1,
              56.11
            ],
            [
              -132.18,
              56.06
            ],
            [
              -132.13,
              55.96
            ],
            [
              -132.16,
              55.92
            ],
            [
              -132.28,
              55.92
            ],
            [
              -132.32,
              55.89
            ],
            [
              -132.31,
              55.86
            ],
            [
              -132.37,
              55.85
            ],
            [
              -132.4,
              55.88
            ],
            [
              -132.38,
              55.94
            ],
            [
              -132.45,
              55.96
            ],
            [
              -132.49,
              56.07
            ],
            [
              -132.61,
              56.05
            ],
            [
              -132.61,
              56.01
            ],
            [
              -132.71,
              56.11
            ],
            [
              -132.72,
              56.22
            ],
            [
              -132.69,
              56.24
            ],
            [
              -132.6,
              56.24
            ],
            [
              -132.58,
              56.3
            ],
            [
              -132.53,
              56.34
            ],
            [
              -132.42,
              56.35
            ],
            [
              -132.36,
              56.29
            ],
            [
              -132.34,
              56.34
            ],
            [
              -132.39,
              56.49
            ],
            [
              -132.36,
              56.49
            ],
            [
              -132.25,
              56.45
            ],
            [
              -132.24,
              56.4
            ],
            [
              -132.2,
              56.37
            ],
            [
              -132.18,
              56.39
            ],
            [
              -132.21,
              56.46
            ],
            [
              -132.29,
              56.49
            ],
            [
              -132.36,
              56.53
            ],
            [
              -132.37,
              56.57
            ],
            [
              -132.41,
              56.59
            ],
            [
              -132.45,
              56.56
            ],
            [
              -132.49,
              56.61
            ],
            [
              -132.57,
              56.63
            ],
            [
              -132.59,
              56.68
            ],
            [
              -132.54,
              56.7
            ],
            [
              -132.56,
              56.76
            ],
            [
              -132.64,
              56.78
            ],
            [
              -132.77,
              56.84
            ],
            [
              -132.82,
              56.9
            ],
            [
              -132.87,
              56.93
            ],
            [
              -132.92,
              56.99
            ],
            [
              -132.81,
              57.03
            ],
            [
              -132.85,
              57.08
            ],
            [
              -132.92,
              57.04
            ],
            [
              -132.99,
              57.06
            ],
            [
              -132.99,
              57.03
            ],
            [
              -133.08,
              57.08
            ],
            [
              -133.19,
              57.09
            ],
            [
              -133.23,
              57.14
            ],
            [
              -133.32,
              57.11
            ],
            [
              -133.52,
              57.18
            ],
            [
              -133.55,
              57.24
            ],
            [
              -133.49,
              57.31
            ],
            [
              -133.43,
              57.29
            ],
            [
              -133.31,
              57.29
            ],
            [
              -133.28,
              57.33
            ],
            [
              -133.36,
              57.33
            ],
            [
              -133.47,
              57.36
            ],
            [
              -133.46,
              57.39
            ],
            [
              -133.53,
              57.5
            ],
            [
              -133.48,
              57.57
            ],
            [
              -133.57,
              57.56
            ],
            [
              -133.62,
              57.58
            ],
            [
              -133.68,
              57.62
            ],
            [
              -133.65,
              57.71
            ],
            [
              -133.58,
              57.71
            ],
            [
              -133.52,
              57.68
            ],
            [
              -133.41,
              57.66
            ],
            [
              -133.18,
              57.59
            ],
            [
              -133.16,
              57.6
            ],
            [
              -133.25,
              57.65
            ],
            [
              -133.32,
              57.67
            ],
            [
              -133.56,
              57.78
            ],
            [
              -133.57,
              57.86
            ],
            [
              -133.63,
              57.85
            ],
            [
              -133.64,
              57.79
            ],
            [
              -133.71,
              57.79
            ],
            [
              -133.85,
              57.94
            ],
            [
              -134.05,
              58.06
            ],
            [
              -134.09,
              58.18
            ],
            [
              -134.06,
              58.24
            ],
            [
              -134.06,
              58.28
            ],
            [
              -133.97,
              58.32
            ],
            [
              -134.01,
              58.4
            ],
            [
              -134.04,
              58.4
            ],
            [
              -134.07,
              58.33
            ],
            [
              -134.14,
              58.3
            ],
            [
              -134.14,
              58.27
            ],
            [
              -134.1,
              58.25
            ],
            [
              -134.15,
              58.2
            ],
            [
              -134.18,
              58.21
            ],
            [
              -134.26,
              58.19
            ],
            [
              -134.35,
              58.2
            ],
            [
              -134.48,
              58.23
            ],
            [
              -134.51,
              58.22
            ],
            [
              -134.63,
              58.25
            ],
            [
              -134.78,
              58.4
            ],
            [
              -134.79,
              58.49
            ],
            [
              -134.94,
              58.61
            ],
            [
              -134.99,
              58.68
            ],
            [
              -134.92,
              58.68
            ],
            [
              -134.96,
              58.83
            ],
            [
              -135.03,
              58.78
            ],
            [
              -135.02,
              58.73
            ],
            [
              -135.15,
              58.85
            ],
            [
              -135.18,
              59
            ],
            [
              -135.21,
              59.08
            ],
            [
              -135.28,
              59.19
            ],
            [
              -135.4,
              59.29
            ],
            [
              -135.53,
              59.32
            ],
            [
              -135.54,
              59.31
            ],
            [
              -135.44,
              59.28
            ],
            [
              -135.43,
              59.24
            ],
            [
              -135.37,
              59.21
            ],
            [
              -135.3,
              59.1
            ],
            [
              -135.35,
              59.11
            ],
            [
              -135.47,
              59.23
            ],
            [
              -135.55,
              59.26
            ],
            [
              -135.63,
              59.27
            ],
            [
              -135.48,
              59.19
            ],
            [
              -135.44,
              59.11
            ],
            [
              -135.38,
              59.09
            ],
            [
              -135.4,
              59.01
            ],
            [
              -135.37,
              58.93
            ],
            [
              -135.32,
              58.91
            ],
            [
              -135.34,
              58.89
            ],
            [
              -135.24,
              58.78
            ],
            [
              -135.23,
              58.74
            ],
            [
              -135.14,
              58.62
            ],
            [
              -135.14,
              58.59
            ],
            [
              -135.19,
              58.6
            ],
            [
              -135.09,
              58.42
            ],
            [
              -135.06,
              58.35
            ],
            [
              -135.05,
              58.29
            ],
            [
              -135.1,
              58.3
            ],
            [
              -135.1,
              58.25
            ],
            [
              -135.06,
              58.19
            ],
            [
              -135.16,
              58.21
            ],
            [
              -135.23,
              58.24
            ],
            [
              -135.28,
              58.23
            ],
            [
              -135.34,
              58.27
            ],
            [
              -135.4,
              58.33
            ],
            [
              -135.43,
              58.4
            ],
            [
              -135.51,
              58.39
            ],
            [
              -135.63,
              58.43
            ],
            [
              -135.73,
              58.4
            ],
            [
              -135.91,
              58.38
            ],
            [
              -135.9,
              58.45
            ],
            [
              -135.99,
              58.46
            ],
            [
              -136,
              58.48
            ],
            [
              -135.89,
              58.51
            ],
            [
              -135.93,
              58.57
            ],
            [
              -135.91,
              58.62
            ],
            [
              -136.01,
              58.71
            ],
            [
              -136.01,
              58.74
            ],
            [
              -136.09,
              58.82
            ],
            [
              -136.04,
              58.84
            ],
            [
              -136.05,
              58.91
            ],
            [
              -136.12,
              58.97
            ],
            [
              -136.16,
              58.98
            ],
            [
              -136.11,
              58.86
            ],
            [
              -136.15,
              58.76
            ],
            [
              -136.25,
              58.75
            ],
            [
              -136.4,
              58.81
            ],
            [
              -136.49,
              58.84
            ],
            [
              -136.55,
              58.97
            ],
            [
              -136.59,
              58.91
            ],
            [
              -136.63,
              58.89
            ],
            [
              -136.79,
              58.94
            ],
            [
              -136.84,
              58.92
            ],
            [
              -136.88,
              58.96
            ],
            [
              -136.92,
              58.95
            ],
            [
              -136.93,
              58.9
            ],
            [
              -136.77,
              58.87
            ],
            [
              -136.74,
              58.88
            ],
            [
              -136.58,
              58.84
            ],
            [
              -136.46,
              58.78
            ],
            [
              -136.36,
              58.69
            ],
            [
              -136.4,
              58.65
            ],
            [
              -136.48,
              58.62
            ],
            [
              -136.46,
              58.61
            ],
            [
              -136.34,
              58.65
            ],
            [
              -136.32,
              58.67
            ],
            [
              -136.22,
              58.67
            ],
            [
              -136.19,
              58.58
            ],
            [
              -136.1,
              58.51
            ],
            [
              -136.04,
              58.38
            ],
            [
              -136.11,
              58.34
            ],
            [
              -136.27,
              58.31
            ],
            [
              -136.31,
              58.32
            ],
            [
              -136.27,
              58.36
            ],
            [
              -136.34,
              58.38
            ],
            [
              -136.38,
              58.36
            ],
            [
              -136.36,
              58.33
            ],
            [
              -136.39,
              58.3
            ],
            [
              -136.55,
              58.32
            ],
            [
              -136.59,
              58.3
            ],
            [
              -136.57,
              58.25
            ],
            [
              -136.6,
              58.21
            ],
            [
              -136.7,
              58.22
            ],
            [
              -136.73,
              58.29
            ],
            [
              -136.86,
              58.32
            ],
            [
              -136.85,
              58.33
            ],
            [
              -136.95,
              58.39
            ],
            [
              -137.01,
              58.41
            ],
            [
              -137.11,
              58.39
            ],
            [
              -137.24,
              58.45
            ],
            [
              -137.3,
              58.47
            ],
            [
              -137.5,
              58.56
            ],
            [
              -137.68,
              58.62
            ],
            [
              -137.69,
              58.67
            ],
            [
              -137.8,
              58.73
            ],
            [
              -137.93,
              58.78
            ],
            [
              -137.95,
              58.8
            ],
            [
              -137.93,
              58.87
            ],
            [
              -137.99,
              58.91
            ],
            [
              -138.18,
              59.01
            ],
            [
              -138.29,
              59.05
            ],
            [
              -138.63,
              59.13
            ],
            [
              -138.76,
              59.19
            ],
            [
              -138.92,
              59.25
            ],
            [
              -139.27,
              59.34
            ],
            [
              -139.42,
              59.38
            ],
            [
              -139.75,
              59.5
            ],
            [
              -139.86,
              59.54
            ],
            [
              -139.84,
              59.56
            ],
            [
              -139.73,
              59.64
            ],
            [
              -139.64,
              59.63
            ],
            [
              -139.67,
              59.6
            ],
            [
              -139.59,
              59.61
            ],
            [
              -139.59,
              59.64
            ],
            [
              -139.51,
              59.7
            ],
            [
              -139.59,
              59.71
            ],
            [
              -139.58,
              59.78
            ],
            [
              -139.63,
              59.87
            ],
            [
              -139.61,
              59.9
            ],
            [
              -139.53,
              59.94
            ],
            [
              -139.55,
              59.97
            ],
            [
              -139.49,
              59.99
            ],
            [
              -139.54,
              60.04
            ],
            [
              -139.6,
              60
            ],
            [
              -139.61,
              59.95
            ],
            [
              -139.7,
              59.93
            ],
            [
              -139.78,
              59.87
            ],
            [
              -139.78,
              59.83
            ],
            [
              -140.16,
              59.74
            ],
            [
              -140.21,
              59.72
            ],
            [
              -140.31,
              59.69
            ],
            [
              -140.65,
              59.71
            ],
            [
              -140.89,
              59.74
            ],
            [
              -140.98,
              59.77
            ],
            [
              -141.42,
              59.88
            ],
            [
              -141.48,
              59.93
            ],
            [
              -141.42,
              59.92
            ],
            [
              -141.3,
              59.94
            ],
            [
              -141.26,
              60
            ],
            [
              -141.38,
              60.11
            ],
            [
              -141.37,
              60.15
            ],
            [
              -141.44,
              60.13
            ],
            [
              -141.55,
              60.17
            ],
            [
              -141.53,
              60.13
            ],
            [
              -141.37,
              60.02
            ],
            [
              -141.4,
              60.01
            ],
            [
              -141.6,
              59.96
            ],
            [
              -141.74,
              59.96
            ],
            [
              -141.91,
              60.01
            ],
            [
              -142.13,
              60.03
            ],
            [
              -142.25,
              60.05
            ],
            [
              -142.54,
              60.08
            ],
            [
              -142.7,
              60.09
            ],
            [
              -142.91,
              60.09
            ],
            [
              -143.14,
              60.06
            ],
            [
              -143.41,
              60.05
            ],
            [
              -143.7,
              60.03
            ],
            [
              -143.89,
              59.99
            ],
            [
              -144.03,
              60.02
            ],
            [
              -144.19,
              60
            ],
            [
              -144.42,
              59.89
            ],
            [
              -144.59,
              59.8
            ],
            [
              -144.57,
              59.85
            ],
            [
              -144.44,
              59.94
            ],
            [
              -144.22,
              60.04
            ],
            [
              -144.05,
              60.04
            ],
            [
              -144.11,
              60.1
            ],
            [
              -144.28,
              60.14
            ],
            [
              -144.31,
              60.16
            ],
            [
              -144.35,
              60.09
            ],
            [
              -144.44,
              60.16
            ],
            [
              -144.54,
              60.19
            ],
            [
              -144.6,
              60.18
            ],
            [
              -144.65,
              60.2
            ],
            [
              -144.91,
              60.22
            ],
            [
              -144.88,
              60.24
            ],
            [
              -144.74,
              60.26
            ],
            [
              -144.89,
              60.29
            ],
            [
              -144.96,
              60.29
            ],
            [
              -144.97,
              60.31
            ],
            [
              -144.83,
              60.44
            ],
            [
              -144.89,
              60.46
            ],
            [
              -144.93,
              60.43
            ],
            [
              -145.04,
              60.41
            ],
            [
              -145.04,
              60.36
            ],
            [
              -145.11,
              60.3
            ],
            [
              -145.25,
              60.31
            ],
            [
              -145.5,
              60.39
            ],
            [
              -145.5,
              60.42
            ],
            [
              -145.59,
              60.45
            ],
            [
              -145.73,
              60.47
            ],
            [
              -145.88,
              60.44
            ],
            [
              -145.96,
              60.47
            ],
            [
              -145.91,
              60.49
            ],
            [
              -145.8,
              60.52
            ],
            [
              -145.71,
              60.58
            ],
            [
              -145.76,
              60.59
            ],
            [
              -145.83,
              60.55
            ],
            [
              -146.11,
              60.47
            ],
            [
              -146.22,
              60.45
            ],
            [
              -146.35,
              60.45
            ],
            [
              -146.35,
              60.41
            ],
            [
              -146.13,
              60.43
            ],
            [
              -146.09,
              60.41
            ],
            [
              -146.09,
              60.37
            ],
            [
              -146.15,
              60.37
            ],
            [
              -146.25,
              60.34
            ],
            [
              -146.31,
              60.34
            ],
            [
              -146.46,
              60.31
            ],
            [
              -146.61,
              60.24
            ],
            [
              -146.65,
              60.24
            ],
            [
              -146.69,
              60.28
            ],
            [
              -146.52,
              60.35
            ],
            [
              -146.66,
              60.34
            ],
            [
              -146.72,
              60.35
            ],
            [
              -146.72,
              60.4
            ],
            [
              -146.64,
              60.47
            ],
            [
              -146.59,
              60.49
            ],
            [
              -146.53,
              60.49
            ],
            [
              -146.46,
              60.47
            ],
            [
              -146.37,
              60.48
            ],
            [
              -146.29,
              60.52
            ],
            [
              -146.15,
              60.53
            ],
            [
              -145.95,
              60.58
            ],
            [
              -145.8,
              60.59
            ],
            [
              -145.83,
              60.62
            ],
            [
              -145.9,
              60.61
            ],
            [
              -145.9,
              60.67
            ],
            [
              -145.94,
              60.63
            ],
            [
              -146,
              60.62
            ],
            [
              -146,
              60.64
            ],
            [
              -145.91,
              60.7
            ],
            [
              -145.91,
              60.71
            ],
            [
              -146.03,
              60.66
            ],
            [
              -146.19,
              60.62
            ],
            [
              -146.26,
              60.62
            ],
            [
              -146.27,
              60.65
            ],
            [
              -146.04,
              60.74
            ],
            [
              -146.06,
              60.78
            ],
            [
              -146.17,
              60.73
            ],
            [
              -146.31,
              60.71
            ],
            [
              -146.35,
              60.74
            ],
            [
              -146.4,
              60.69
            ],
            [
              -146.47,
              60.68
            ],
            [
              -146.67,
              60.69
            ],
            [
              -146.7,
              60.74
            ],
            [
              -146.61,
              60.76
            ],
            [
              -146.57,
              60.75
            ],
            [
              -146.5,
              60.77
            ],
            [
              -146.36,
              60.79
            ],
            [
              -146.26,
              60.81
            ],
            [
              -146.17,
              60.87
            ],
            [
              -146.26,
              60.87
            ],
            [
              -146.31,
              60.83
            ],
            [
              -146.4,
              60.81
            ],
            [
              -146.56,
              60.81
            ],
            [
              -146.62,
              60.87
            ],
            [
              -146.66,
              60.87
            ],
            [
              -146.73,
              60.81
            ],
            [
              -146.8,
              60.81
            ],
            [
              -146.81,
              60.86
            ],
            [
              -146.76,
              60.88
            ],
            [
              -146.7,
              60.87
            ],
            [
              -146.74,
              60.91
            ],
            [
              -146.75,
              60.96
            ],
            [
              -146.7,
              60.99
            ],
            [
              -146.61,
              61.09
            ],
            [
              -146.26,
              61.09
            ],
            [
              -146.29,
              61.12
            ],
            [
              -146.61,
              61.12
            ],
            [
              -146.69,
              61.06
            ],
            [
              -146.79,
              61.04
            ],
            [
              -146.86,
              60.98
            ],
            [
              -146.97,
              60.93
            ],
            [
              -147.06,
              60.95
            ],
            [
              -146.98,
              60.98
            ],
            [
              -147.02,
              61.07
            ],
            [
              -147.06,
              61.12
            ],
            [
              -147,
              61.14
            ],
            [
              -147.08,
              61.15
            ],
            [
              -147.13,
              61.13
            ],
            [
              -147.13,
              61.09
            ],
            [
              -147.09,
              61.04
            ],
            [
              -147.14,
              60.98
            ],
            [
              -147.13,
              60.95
            ],
            [
              -147.18,
              60.93
            ],
            [
              -147.27,
              60.97
            ],
            [
              -147.28,
              60.92
            ],
            [
              -147.38,
              60.88
            ],
            [
              -147.45,
              60.9
            ],
            [
              -147.45,
              60.94
            ],
            [
              -147.49,
              60.96
            ],
            [
              -147.52,
              60.9
            ],
            [
              -147.55,
              60.91
            ],
            [
              -147.54,
              61.02
            ],
            [
              -147.5,
              61.07
            ],
            [
              -147.56,
              61.08
            ],
            [
              -147.62,
              60.97
            ],
            [
              -147.59,
              60.87
            ],
            [
              -147.6,
              60.85
            ],
            [
              -147.67,
              60.84
            ],
            [
              -147.67,
              60.88
            ],
            [
              -147.76,
              60.91
            ],
            [
              -147.79,
              60.87
            ],
            [
              -147.73,
              60.82
            ],
            [
              -147.78,
              60.81
            ],
            [
              -147.91,
              60.82
            ],
            [
              -148.04,
              60.78
            ],
            [
              -148.14,
              60.79
            ],
            [
              -148.15,
              60.82
            ],
            [
              -148.1,
              60.9
            ],
            [
              -147.95,
              61.03
            ],
            [
              -147.95,
              61.07
            ],
            [
              -147.77,
              61.18
            ],
            [
              -147.72,
              61.25
            ],
            [
              -147.74,
              61.27
            ],
            [
              -148,
              61.08
            ],
            [
              -148,
              61.05
            ],
            [
              -148.07,
              61
            ],
            [
              -148.1,
              61.01
            ],
            [
              -148.13,
              61.07
            ],
            [
              -148.17,
              61.07
            ],
            [
              -148.18,
              61
            ],
            [
              -148.22,
              60.95
            ],
            [
              -148.28,
              60.92
            ],
            [
              -148.29,
              60.86
            ],
            [
              -148.35,
              60.8
            ],
            [
              -148.43,
              60.83
            ],
            [
              -148.45,
              60.79
            ],
            [
              -148.37,
              60.77
            ],
            [
              -148.38,
              60.69
            ],
            [
              -148.35,
              60.68
            ],
            [
              -148.28,
              60.75
            ],
            [
              -148.15,
              60.76
            ],
            [
              -148.11,
              60.74
            ],
            [
              -148.09,
              60.66
            ],
            [
              -148.14,
              60.62
            ],
            [
              -148.25,
              60.6
            ],
            [
              -148.33,
              60.53
            ],
            [
              -148.33,
              60.48
            ],
            [
              -148.25,
              60.49
            ],
            [
              -148.19,
              60.56
            ],
            [
              -148.09,
              60.6
            ],
            [
              -147.98,
              60.52
            ],
            [
              -147.98,
              60.48
            ],
            [
              -147.94,
              60.44
            ],
            [
              -148.02,
              60.28
            ],
            [
              -148.12,
              60.28
            ],
            [
              -148.15,
              60.32
            ],
            [
              -148.22,
              60.33
            ],
            [
              -148.21,
              60.3
            ],
            [
              -148.31,
              60.26
            ],
            [
              -148.31,
              60.25
            ],
            [
              -148.21,
              60.26
            ],
            [
              -148.13,
              60.24
            ],
            [
              -147.91,
              60.13
            ],
            [
              -147.82,
              60.06
            ],
            [
              -147.87,
              59.99
            ],
            [
              -147.92,
              59.97
            ],
            [
              -148.04,
              59.94
            ],
            [
              -148.1,
              59.95
            ],
            [
              -148.15,
              59.94
            ],
            [
              -148.25,
              59.93
            ],
            [
              -148.22,
              59.98
            ],
            [
              -148.32,
              60.03
            ],
            [
              -148.28,
              60.09
            ],
            [
              -148.34,
              60.14
            ],
            [
              -148.4,
              60.03
            ],
            [
              -148.4,
              59.98
            ],
            [
              -148.44,
              59.94
            ],
            [
              -148.51,
              60
            ],
            [
              -148.55,
              59.99
            ],
            [
              -148.57,
              59.94
            ],
            [
              -148.63,
              59.92
            ],
            [
              -148.76,
              59.96
            ],
            [
              -148.86,
              59.92
            ],
            [
              -148.91,
              59.97
            ],
            [
              -149.01,
              59.95
            ],
            [
              -149.09,
              59.96
            ],
            [
              -149.12,
              59.98
            ],
            [
              -149.04,
              60.04
            ],
            [
              -149.07,
              60.06
            ],
            [
              -149.17,
              60.02
            ],
            [
              -149.27,
              59.87
            ],
            [
              -149.38,
              59.84
            ],
            [
              -149.41,
              59.85
            ],
            [
              -149.36,
              59.9
            ],
            [
              -149.31,
              59.97
            ],
            [
              -149.37,
              60.12
            ],
            [
              -149.42,
              60.12
            ],
            [
              -149.44,
              60.1
            ],
            [
              -149.44,
              60.03
            ],
            [
              -149.39,
              59.98
            ],
            [
              -149.43,
              59.98
            ],
            [
              -149.46,
              59.92
            ],
            [
              -149.52,
              59.93
            ],
            [
              -149.55,
              59.91
            ],
            [
              -149.57,
              59.85
            ],
            [
              -149.61,
              59.84
            ],
            [
              -149.6,
              59.8
            ],
            [
              -149.51,
              59.77
            ],
            [
              -149.53,
              59.71
            ],
            [
              -149.63,
              59.73
            ],
            [
              -149.67,
              59.84
            ],
            [
              -149.64,
              59.88
            ],
            [
              -149.68,
              59.94
            ],
            [
              -149.74,
              59.95
            ],
            [
              -149.72,
              59.9
            ],
            [
              -149.75,
              59.86
            ],
            [
              -149.73,
              59.69
            ],
            [
              -149.75,
              59.64
            ],
            [
              -149.84,
              59.7
            ],
            [
              -149.85,
              59.74
            ],
            [
              -149.91,
              59.76
            ],
            [
              -150.03,
              59.79
            ],
            [
              -150.02,
              59.75
            ],
            [
              -149.93,
              59.72
            ],
            [
              -149.93,
              59.67
            ],
            [
              -150.18,
              59.53
            ],
            [
              -150.3,
              59.46
            ],
            [
              -150.3,
              59.42
            ],
            [
              -150.35,
              59.42
            ],
            [
              -150.39,
              59.34
            ],
            [
              -150.43,
              59.34
            ],
            [
              -150.44,
              59.4
            ],
            [
              -150.32,
              59.59
            ],
            [
              -150.32,
              59.61
            ],
            [
              -150.41,
              59.55
            ],
            [
              -150.48,
              59.46
            ],
            [
              -150.52,
              59.47
            ],
            [
              -150.56,
              59.59
            ],
            [
              -150.6,
              59.55
            ],
            [
              -150.64,
              59.55
            ],
            [
              -150.58,
              59.49
            ],
            [
              -150.6,
              59.43
            ],
            [
              -150.74,
              59.43
            ],
            [
              -150.77,
              59.37
            ],
            [
              -150.83,
              59.35
            ],
            [
              -150.91,
              59.31
            ],
            [
              -150.89,
              59.27
            ],
            [
              -150.94,
              59.23
            ],
            [
              -151,
              59.22
            ],
            [
              -151,
              59.27
            ],
            [
              -151.06,
              59.3
            ],
            [
              -151.1,
              59.26
            ],
            [
              -151.11,
              59.22
            ],
            [
              -151.19,
              59.2
            ],
            [
              -151.27,
              59.23
            ],
            [
              -151.31,
              59.21
            ],
            [
              -151.38,
              59.24
            ],
            [
              -151.41,
              59.28
            ],
            [
              -151.45,
              59.25
            ],
            [
              -151.52,
              59.23
            ],
            [
              -151.5,
              59.2
            ],
            [
              -151.57,
              59.2
            ],
            [
              -151.59,
              59.16
            ],
            [
              -151.74,
              59.16
            ],
            [
              -151.76,
              59.22
            ],
            [
              -151.84,
              59.21
            ],
            [
              -151.92,
              59.23
            ],
            [
              -151.9,
              59.25
            ],
            [
              -151.98,
              59.25
            ],
            [
              -151.99,
              59.31
            ],
            [
              -151.96,
              59.34
            ],
            [
              -151.9,
              59.36
            ],
            [
              -151.89,
              59.42
            ],
            [
              -151.77,
              59.45
            ],
            [
              -151.74,
              59.44
            ],
            [
              -151.64,
              59.48
            ],
            [
              -151.52,
              59.48
            ],
            [
              -151.52,
              59.52
            ],
            [
              -151.4,
              59.54
            ],
            [
              -151.28,
              59.59
            ],
            [
              -151.17,
              59.59
            ],
            [
              -151.2,
              59.65
            ],
            [
              -151.13,
              59.67
            ],
            [
              -151.11,
              59.7
            ],
            [
              -150.98,
              59.78
            ],
            [
              -151.03,
              59.8
            ],
            [
              -151.11,
              59.78
            ],
            [
              -151.33,
              59.68
            ],
            [
              -151.44,
              59.67
            ],
            [
              -151.5,
              59.63
            ],
            [
              -151.64,
              59.65
            ],
            [
              -151.8,
              59.7
            ],
            [
              -151.85,
              59.74
            ],
            [
              -151.87,
              59.78
            ],
            [
              -151.8,
              59.88
            ],
            [
              -151.76,
              59.92
            ],
            [
              -151.7,
              60.03
            ],
            [
              -151.61,
              60.1
            ],
            [
              -151.55,
              60.13
            ],
            [
              -151.42,
              60.21
            ],
            [
              -151.38,
              60.3
            ],
            [
              -151.38,
              60.36
            ],
            [
              -151.3,
              60.39
            ],
            [
              -151.28,
              60.52
            ],
            [
              -151.27,
              60.54
            ],
            [
              -151.33,
              60.58
            ],
            [
              -151.41,
              60.72
            ],
            [
              -151.27,
              60.75
            ],
            [
              -151.25,
              60.77
            ],
            [
              -151.03,
              60.8
            ],
            [
              -150.71,
              60.94
            ],
            [
              -150.38,
              61.04
            ],
            [
              -150.19,
              60.9
            ],
            [
              -150.05,
              60.89
            ],
            [
              -150,
              60.86
            ],
            [
              -149.88,
              60.96
            ],
            [
              -149.77,
              60.97
            ],
            [
              -149.64,
              60.93
            ],
            [
              -149.57,
              60.94
            ],
            [
              -149.35,
              60.9
            ],
            [
              -149.11,
              60.88
            ],
            [
              -149,
              60.83
            ],
            [
              -149.01,
              60.85
            ],
            [
              -149.09,
              60.91
            ],
            [
              -149.19,
              60.94
            ],
            [
              -149.33,
              60.93
            ],
            [
              -149.51,
              60.98
            ],
            [
              -149.6,
              60.98
            ],
            [
              -149.74,
              61.02
            ],
            [
              -149.83,
              61.08
            ],
            [
              -149.97,
              61.13
            ],
            [
              -150.07,
              61.16
            ],
            [
              -150.01,
              61.2
            ],
            [
              -149.92,
              61.21
            ],
            [
              -149.81,
              61.32
            ],
            [
              -149.73,
              61.33
            ],
            [
              -149.7,
              61.38
            ],
            [
              -149.54,
              61.41
            ],
            [
              -149.43,
              61.45
            ],
            [
              -149.54,
              61.49
            ],
            [
              -149.61,
              61.49
            ],
            [
              -149.77,
              61.44
            ],
            [
              -149.81,
              61.4
            ],
            [
              -149.88,
              61.38
            ],
            [
              -149.92,
              61.32
            ],
            [
              -149.92,
              61.26
            ],
            [
              -149.98,
              61.24
            ],
            [
              -150.07,
              61.25
            ],
            [
              -150.2,
              61.26
            ],
            [
              -150.47,
              61.24
            ],
            [
              -150.56,
              61.28
            ],
            [
              -150.66,
              61.3
            ],
            [
              -150.71,
              61.25
            ],
            [
              -151.03,
              61.18
            ],
            [
              -151.17,
              61.05
            ],
            [
              -151.29,
              61.04
            ],
            [
              -151.36,
              61.01
            ],
            [
              -151.48,
              61.01
            ],
            [
              -151.62,
              60.96
            ],
            [
              -151.79,
              60.86
            ],
            [
              -151.8,
              60.84
            ],
            [
              -151.7,
              60.73
            ],
            [
              -151.71,
              60.71
            ],
            [
              -151.85,
              60.73
            ],
            [
              -151.92,
              60.72
            ],
            [
              -152.02,
              60.67
            ],
            [
              -152.1,
              60.59
            ],
            [
              -152.2,
              60.57
            ],
            [
              -152.31,
              60.51
            ],
            [
              -152.33,
              60.44
            ],
            [
              -152.3,
              60.41
            ],
            [
              -152.23,
              60.39
            ],
            [
              -152.38,
              60.35
            ],
            [
              -152.41,
              60.29
            ],
            [
              -152.46,
              60.28
            ],
            [
              -152.56,
              60.22
            ],
            [
              -152.63,
              60.22
            ],
            [
              -152.66,
              60.24
            ],
            [
              -152.75,
              60.23
            ],
            [
              -152.73,
              60.17
            ],
            [
              -152.68,
              60.16
            ],
            [
              -152.69,
              60.14
            ],
            [
              -152.6,
              60.1
            ],
            [
              -152.57,
              60.07
            ],
            [
              -152.61,
              60.01
            ],
            [
              -152.68,
              59.97
            ],
            [
              -152.71,
              59.92
            ],
            [
              -152.79,
              59.9
            ],
            [
              -152.81,
              59.88
            ],
            [
              -152.95,
              59.88
            ],
            [
              -153,
              59.89
            ],
            [
              -153.15,
              59.86
            ],
            [
              -153.21,
              59.86
            ],
            [
              -153.28,
              59.81
            ],
            [
              -153.2,
              59.82
            ],
            [
              -153.14,
              59.81
            ],
            [
              -153.09,
              59.83
            ],
            [
              -153.02,
              59.83
            ],
            [
              -153,
              59.79
            ],
            [
              -153.05,
              59.69
            ],
            [
              -153.12,
              59.68
            ],
            [
              -153.21,
              59.63
            ],
            [
              -153.32,
              59.67
            ],
            [
              -153.3,
              59.64
            ],
            [
              -153.34,
              59.62
            ],
            [
              -153.41,
              59.64
            ],
            [
              -153.38,
              59.67
            ],
            [
              -153.38,
              59.73
            ],
            [
              -153.46,
              59.79
            ],
            [
              -153.44,
              59.69
            ],
            [
              -153.48,
              59.64
            ],
            [
              -153.54,
              59.63
            ],
            [
              -153.59,
              59.65
            ],
            [
              -153.61,
              59.62
            ],
            [
              -153.55,
              59.6
            ],
            [
              -153.58,
              59.55
            ],
            [
              -153.76,
              59.54
            ],
            [
              -153.7,
              59.46
            ],
            [
              -153.73,
              59.44
            ],
            [
              -153.82,
              59.42
            ],
            [
              -153.86,
              59.42
            ],
            [
              -153.95,
              59.39
            ],
            [
              -153.99,
              59.4
            ],
            [
              -154.12,
              59.37
            ],
            [
              -154.1,
              59.34
            ],
            [
              -154.03,
              59.33
            ],
            [
              -154.11,
              59.3
            ],
            [
              -154.14,
              59.26
            ],
            [
              -154.13,
              59.21
            ],
            [
              -154.17,
              59.17
            ],
            [
              -154.26,
              59.14
            ],
            [
              -154.17,
              59.12
            ],
            [
              -154.19,
              59.07
            ],
            [
              -154.16,
              59.02
            ],
            [
              -154.06,
              59.07
            ],
            [
              -153.85,
              59.05
            ],
            [
              -153.79,
              59.07
            ],
            [
              -153.75,
              59.05
            ],
            [
              -153.7,
              59.07
            ],
            [
              -153.62,
              59.01
            ],
            [
              -153.55,
              58.98
            ],
            [
              -153.48,
              58.99
            ],
            [
              -153.4,
              58.97
            ],
            [
              -153.33,
              58.92
            ],
            [
              -153.3,
              58.87
            ],
            [
              -153.25,
              58.86
            ],
            [
              -153.35,
              58.84
            ],
            [
              -153.4,
              58.74
            ],
            [
              -153.44,
              58.71
            ],
            [
              -153.55,
              58.69
            ],
            [
              -153.59,
              58.64
            ],
            [
              -153.68,
              58.61
            ],
            [
              -153.85,
              58.61
            ],
            [
              -153.9,
              58.6
            ],
            [
              -153.92,
              58.52
            ],
            [
              -153.96,
              58.49
            ],
            [
              -154.06,
              58.49
            ],
            [
              -154.08,
              58.47
            ],
            [
              -154.04,
              58.4
            ],
            [
              -154,
              58.38
            ],
            [
              -154.1,
              58.35
            ],
            [
              -154.17,
              58.36
            ],
            [
              -154.18,
              58.32
            ],
            [
              -154.1,
              58.28
            ],
            [
              -154.14,
              58.21
            ],
            [
              -154.22,
              58.18
            ],
            [
              -154.24,
              58.16
            ],
            [
              -154.21,
              58.14
            ],
            [
              -154.29,
              58.14
            ],
            [
              -154.34,
              58.09
            ],
            [
              -154.44,
              58.15
            ],
            [
              -154.47,
              58.14
            ],
            [
              -154.45,
              58.09
            ],
            [
              -154.46,
              58.06
            ],
            [
              -154.54,
              58.06
            ],
            [
              -154.58,
              58.02
            ],
            [
              -154.64,
              58.03
            ],
            [
              -154.64,
              58.06
            ],
            [
              -154.72,
              58.06
            ],
            [
              -154.73,
              58.02
            ],
            [
              -154.81,
              58
            ],
            [
              -154.89,
              58.03
            ],
            [
              -154.99,
              58.01
            ],
            [
              -155.12,
              57.95
            ],
            [
              -155.06,
              57.91
            ],
            [
              -155.1,
              57.87
            ],
            [
              -155.24,
              57.83
            ],
            [
              -155.34,
              57.83
            ],
            [
              -155.34,
              57.78
            ],
            [
              -155.29,
              57.76
            ],
            [
              -155.31,
              57.72
            ],
            [
              -155.38,
              57.71
            ],
            [
              -155.51,
              57.76
            ],
            [
              -155.54,
              57.79
            ],
            [
              -155.62,
              57.77
            ],
            [
              -155.63,
              57.72
            ],
            [
              -155.63,
              57.66
            ],
            [
              -155.72,
              57.63
            ],
            [
              -155.73,
              57.55
            ],
            [
              -155.97,
              57.54
            ],
            [
              -156.04,
              57.56
            ],
            [
              -156.05,
              57.5
            ],
            [
              -156.02,
              57.44
            ],
            [
              -156.09,
              57.44
            ],
            [
              -156.14,
              57.47
            ],
            [
              -156.21,
              57.47
            ],
            [
              -156.23,
              57.44
            ],
            [
              -156.34,
              57.42
            ],
            [
              -156.48,
              57.34
            ],
            [
              -156.53,
              57.33
            ],
            [
              -156.55,
              57.29
            ],
            [
              -156.51,
              57.28
            ],
            [
              -156.34,
              57.34
            ],
            [
              -156.32,
              57.29
            ],
            [
              -156.34,
              57.25
            ],
            [
              -156.4,
              57.24
            ],
            [
              -156.4,
              57.22
            ],
            [
              -156.33,
              57.18
            ],
            [
              -156.37,
              57.15
            ],
            [
              -156.43,
              57.13
            ],
            [
              -156.44,
              57.09
            ],
            [
              -156.53,
              57.05
            ],
            [
              -156.56,
              57.02
            ],
            [
              -156.56,
              56.98
            ],
            [
              -156.67,
              57
            ],
            [
              -156.78,
              56.97
            ],
            [
              -156.8,
              56.91
            ],
            [
              -156.84,
              56.9
            ],
            [
              -156.91,
              56.97
            ],
            [
              -156.94,
              56.92
            ],
            [
              -157.03,
              56.88
            ],
            [
              -157.07,
              56.84
            ],
            [
              -157.16,
              56.83
            ],
            [
              -157.14,
              56.79
            ],
            [
              -157.2,
              56.77
            ],
            [
              -157.29,
              56.8
            ],
            [
              -157.38,
              56.86
            ],
            [
              -157.46,
              56.85
            ],
            [
              -157.46,
              56.8
            ],
            [
              -157.42,
              56.8
            ],
            [
              -157.41,
              56.77
            ],
            [
              -157.52,
              56.76
            ],
            [
              -157.56,
              56.7
            ],
            [
              -157.54,
              56.68
            ],
            [
              -157.48,
              56.67
            ],
            [
              -157.46,
              56.63
            ],
            [
              -157.59,
              56.62
            ],
            [
              -157.68,
              56.61
            ],
            [
              -157.74,
              56.68
            ],
            [
              -157.92,
              56.64
            ],
            [
              -157.98,
              56.6
            ],
            [
              -158.04,
              56.6
            ],
            [
              -158.07,
              56.55
            ],
            [
              -158.01,
              56.55
            ],
            [
              -157.91,
              56.58
            ],
            [
              -157.84,
              56.56
            ],
            [
              -157.82,
              56.51
            ],
            [
              -157.87,
              56.47
            ],
            [
              -158.03,
              56.51
            ],
            [
              -158.11,
              56.52
            ],
            [
              -158.13,
              56.46
            ],
            [
              -158.25,
              56.47
            ],
            [
              -158.33,
              56.48
            ],
            [
              -158.4,
              56.46
            ],
            [
              -158.5,
              56.38
            ],
            [
              -158.49,
              56.34
            ],
            [
              -158.32,
              56.33
            ],
            [
              -158.21,
              56.29
            ],
            [
              -158.22,
              56.27
            ],
            [
              -158.33,
              56.23
            ],
            [
              -158.33,
              56.21
            ],
            [
              -158.26,
              56.21
            ],
            [
              -158.18,
              56.24
            ],
            [
              -158.12,
              56.23
            ],
            [
              -158.32,
              56.16
            ],
            [
              -158.4,
              56.11
            ],
            [
              -158.39,
              56.06
            ],
            [
              -158.44,
              56.11
            ],
            [
              -158.48,
              56.09
            ],
            [
              -158.42,
              56.04
            ],
            [
              -158.44,
              55.99
            ],
            [
              -158.47,
              56.03
            ],
            [
              -158.5,
              56.03
            ],
            [
              -158.51,
              55.98
            ],
            [
              -158.6,
              56.05
            ],
            [
              -158.6,
              56.13
            ],
            [
              -158.67,
              56.08
            ],
            [
              -158.64,
              56.02
            ],
            [
              -158.65,
              55.96
            ],
            [
              -158.74,
              55.95
            ],
            [
              -158.73,
              56
            ],
            [
              -158.85,
              56
            ],
            [
              -158.91,
              55.94
            ],
            [
              -159,
              55.93
            ],
            [
              -159.27,
              55.89
            ],
            [
              -159.37,
              55.87
            ],
            [
              -159.4,
              55.85
            ],
            [
              -159.41,
              55.79
            ],
            [
              -159.47,
              55.83
            ],
            [
              -159.45,
              55.9
            ],
            [
              -159.54,
              55.88
            ],
            [
              -159.5,
              55.86
            ],
            [
              -159.5,
              55.77
            ],
            [
              -159.55,
              55.7
            ],
            [
              -159.53,
              55.67
            ],
            [
              -159.62,
              55.6
            ],
            [
              -159.73,
              55.57
            ],
            [
              -159.73,
              55.61
            ],
            [
              -159.64,
              55.62
            ],
            [
              -159.64,
              55.65
            ],
            [
              -159.68,
              55.66
            ],
            [
              -159.67,
              55.75
            ],
            [
              -159.61,
              55.81
            ],
            [
              -159.71,
              55.85
            ],
            [
              -159.81,
              55.86
            ],
            [
              -159.86,
              55.84
            ],
            [
              -159.85,
              55.8
            ],
            [
              -159.89,
              55.78
            ],
            [
              -159.94,
              55.8
            ],
            [
              -160.03,
              55.79
            ],
            [
              -160.06,
              55.72
            ],
            [
              -160.19,
              55.66
            ],
            [
              -160.28,
              55.64
            ],
            [
              -160.41,
              55.67
            ],
            [
              -160.43,
              55.64
            ],
            [
              -160.39,
              55.6
            ],
            [
              -160.47,
              55.53
            ],
            [
              -160.46,
              55.51
            ],
            [
              -160.54,
              55.47
            ],
            [
              -160.58,
              55.56
            ],
            [
              -160.62,
              55.58
            ],
            [
              -160.67,
              55.54
            ],
            [
              -160.71,
              55.56
            ],
            [
              -160.77,
              55.53
            ],
            [
              -160.66,
              55.52
            ],
            [
              -160.67,
              55.46
            ],
            [
              -160.78,
              55.45
            ],
            [
              -160.84,
              55.47
            ],
            [
              -160.82,
              55.51
            ],
            [
              -160.87,
              55.53
            ],
            [
              -160.95,
              55.51
            ],
            [
              -161.01,
              55.43
            ],
            [
              -161.23,
              55.36
            ],
            [
              -161.33,
              55.36
            ],
            [
              -161.37,
              55.38
            ],
            [
              -161.46,
              55.36
            ],
            [
              -161.51,
              55.36
            ],
            [
              -161.47,
              55.5
            ],
            [
              -161.37,
              55.58
            ],
            [
              -161.36,
              55.62
            ],
            [
              -161.42,
              55.63
            ],
            [
              -161.53,
              55.63
            ],
            [
              -161.61,
              55.61
            ],
            [
              -161.7,
              55.52
            ],
            [
              -161.69,
              55.41
            ],
            [
              -161.83,
              55.29
            ],
            [
              -161.85,
              55.28
            ],
            [
              -161.9,
              55.2
            ],
            [
              -161.98,
              55.24
            ],
            [
              -162.05,
              55.23
            ],
            [
              -162,
              55.17
            ],
            [
              -161.97,
              55.15
            ],
            [
              -161.96,
              55.11
            ],
            [
              -162.05,
              55.07
            ],
            [
              -162.12,
              55.1
            ],
            [
              -162.12,
              55.14
            ],
            [
              -162.18,
              55.15
            ],
            [
              -162.22,
              55.1
            ],
            [
              -162.19,
              55.06
            ],
            [
              -162.25,
              55.02
            ],
            [
              -162.3,
              55.04
            ],
            [
              -162.41,
              55.04
            ],
            [
              -162.47,
              55.05
            ],
            [
              -162.52,
              55.12
            ],
            [
              -162.41,
              55.12
            ],
            [
              -162.48,
              55.16
            ],
            [
              -162.51,
              55.25
            ],
            [
              -162.59,
              55.3
            ],
            [
              -162.63,
              55.3
            ],
            [
              -162.68,
              55.28
            ],
            [
              -162.72,
              55.22
            ],
            [
              -162.69,
              55.2
            ],
            [
              -162.64,
              55.2
            ],
            [
              -162.58,
              55.14
            ],
            [
              -162.62,
              55.1
            ],
            [
              -162.57,
              55.02
            ],
            [
              -162.57,
              54.97
            ],
            [
              -162.65,
              55
            ],
            [
              -162.72,
              54.98
            ],
            [
              -162.71,
              54.96
            ],
            [
              -162.77,
              54.93
            ],
            [
              -162.83,
              54.93
            ],
            [
              -162.91,
              54.95
            ],
            [
              -162.97,
              55
            ],
            [
              -162.96,
              55.03
            ],
            [
              -163,
              55.08
            ],
            [
              -163.08,
              55.11
            ],
            [
              -163.19,
              55.09
            ],
            [
              -163.23,
              55.04
            ],
            [
              -163.05,
              54.97
            ],
            [
              -163.03,
              54.94
            ],
            [
              -163.21,
              54.85
            ],
            [
              -163.3,
              54.83
            ],
            [
              -163.37,
              54.8
            ],
            [
              -163.31,
              54.75
            ],
            [
              -163.22,
              54.75
            ],
            [
              -163.19,
              54.78
            ],
            [
              -163.11,
              54.73
            ],
            [
              -163.06,
              54.66
            ],
            [
              -163.15,
              54.67
            ],
            [
              -163.12,
              54.7
            ],
            [
              -163.19,
              54.7
            ],
            [
              -163.22,
              54.68
            ],
            [
              -163.28,
              54.7
            ],
            [
              -163.34,
              54.75
            ],
            [
              -163.43,
              54.72
            ],
            [
              -163.42,
              54.66
            ],
            [
              -163.49,
              54.66
            ],
            [
              -163.59,
              54.61
            ],
            [
              -163.67,
              54.63
            ],
            [
              -163.8,
              54.64
            ],
            [
              -163.96,
              54.63
            ],
            [
              -164.09,
              54.62
            ],
            [
              -164.23,
              54.59
            ],
            [
              -164.34,
              54.52
            ],
            [
              -164.35,
              54.47
            ],
            [
              -164.46,
              54.42
            ],
            [
              -164.64,
              54.39
            ],
            [
              -164.74,
              54.39
            ],
            [
              -164.84,
              54.42
            ],
            [
              -164.88,
              54.44
            ],
            [
              -164.91,
              54.51
            ],
            [
              -164.94,
              54.53
            ],
            [
              -164.95,
              54.58
            ],
            [
              -164.92,
              54.61
            ],
            [
              -164.76,
              54.64
            ],
            [
              -164.71,
              54.66
            ],
            [
              -164.63,
              54.76
            ],
            [
              -164.56,
              54.85
            ],
            [
              -164.56,
              54.88
            ],
            [
              -164.49,
              54.92
            ],
            [
              -164.43,
              54.93
            ],
            [
              -164.35,
              54.89
            ],
            [
              -164.21,
              54.93
            ],
            [
              -164.12,
              54.97
            ],
            [
              -164.03,
              54.97
            ],
            [
              -163.9,
              55.04
            ],
            [
              -163.77,
              55.06
            ],
            [
              -163.65,
              55.04
            ],
            [
              -163.53,
              55.05
            ],
            [
              -163.53,
              55.02
            ],
            [
              -163.43,
              54.95
            ],
            [
              -163.4,
              54.9
            ],
            [
              -163.42,
              54.86
            ],
            [
              -163.32,
              54.88
            ],
            [
              -163.35,
              54.92
            ],
            [
              -163.34,
              54.96
            ],
            [
              -163.23,
              54.93
            ],
            [
              -163.29,
              54.97
            ],
            [
              -163.28,
              55.03
            ],
            [
              -163.31,
              55.13
            ],
            [
              -163.2,
              55.17
            ],
            [
              -163.11,
              55.18
            ],
            [
              -162.96,
              55.17
            ],
            [
              -162.88,
              55.18
            ],
            [
              -162.84,
              55.24
            ],
            [
              -162.9,
              55.25
            ],
            [
              -162.89,
              55.27
            ],
            [
              -162.82,
              55.28
            ],
            [
              -162.8,
              55.31
            ],
            [
              -162.73,
              55.31
            ],
            [
              -162.64,
              55.39
            ],
            [
              -162.63,
              55.37
            ],
            [
              -162.58,
              55.35
            ],
            [
              -162.5,
              55.39
            ],
            [
              -162.52,
              55.46
            ],
            [
              -162.59,
              55.45
            ],
            [
              -162.49,
              55.51
            ],
            [
              -162.26,
              55.69
            ],
            [
              -162.14,
              55.73
            ],
            [
              -162.06,
              55.79
            ],
            [
              -161.99,
              55.8
            ],
            [
              -161.9,
              55.83
            ],
            [
              -161.81,
              55.89
            ],
            [
              -161.71,
              55.9
            ],
            [
              -161.58,
              55.94
            ],
            [
              -161.45,
              55.95
            ],
            [
              -161.13,
              56.01
            ],
            [
              -161.02,
              56.01
            ],
            [
              -160.99,
              56.02
            ],
            [
              -160.83,
              56.03
            ],
            [
              -160.79,
              56.02
            ],
            [
              -160.86,
              56
            ],
            [
              -160.87,
              55.95
            ],
            [
              -160.82,
              55.95
            ],
            [
              -160.83,
              55.91
            ],
            [
              -160.93,
              55.9
            ],
            [
              -160.94,
              55.82
            ],
            [
              -160.81,
              55.74
            ],
            [
              -160.77,
              55.76
            ],
            [
              -160.67,
              55.72
            ],
            [
              -160.66,
              55.74
            ],
            [
              -160.76,
              55.79
            ],
            [
              -160.77,
              55.86
            ],
            [
              -160.79,
              55.89
            ],
            [
              -160.7,
              55.86
            ],
            [
              -160.49,
              55.86
            ],
            [
              -160.47,
              55.79
            ],
            [
              -160.39,
              55.8
            ],
            [
              -160.29,
              55.77
            ],
            [
              -160.27,
              55.78
            ],
            [
              -160.32,
              55.82
            ],
            [
              -160.22,
              55.83
            ],
            [
              -160.42,
              55.91
            ],
            [
              -160.54,
              55.94
            ],
            [
              -160.53,
              55.99
            ],
            [
              -160.59,
              55.98
            ],
            [
              -160.45,
              56.13
            ],
            [
              -160.4,
              56.23
            ],
            [
              -160.36,
              56.28
            ],
            [
              -160.27,
              56.32
            ],
            [
              -160.15,
              56.4
            ],
            [
              -160.08,
              56.41
            ],
            [
              -159.94,
              56.47
            ],
            [
              -159.83,
              56.54
            ],
            [
              -159.54,
              56.63
            ],
            [
              -159.39,
              56.69
            ],
            [
              -159.26,
              56.72
            ],
            [
              -159.02,
              56.81
            ],
            [
              -158.96,
              56.85
            ],
            [
              -158.85,
              56.79
            ],
            [
              -158.79,
              56.78
            ],
            [
              -158.67,
              56.8
            ],
            [
              -158.65,
              56.85
            ],
            [
              -158.69,
              56.89
            ],
            [
              -158.7,
              56.93
            ],
            [
              -158.65,
              57.03
            ],
            [
              -158.54,
              57.12
            ],
            [
              -158.39,
              57.24
            ],
            [
              -158.31,
              57.29
            ],
            [
              -158.23,
              57.32
            ],
            [
              -158.09,
              57.36
            ],
            [
              -158.01,
              57.4
            ],
            [
              -157.93,
              57.48
            ],
            [
              -157.88,
              57.49
            ],
            [
              -157.79,
              57.54
            ],
            [
              -157.68,
              57.56
            ],
            [
              -157.65,
              57.5
            ],
            [
              -157.59,
              57.49
            ],
            [
              -157.57,
              57.52
            ],
            [
              -157.61,
              57.61
            ],
            [
              -157.69,
              57.61
            ],
            [
              -157.71,
              57.64
            ],
            [
              -157.7,
              57.72
            ],
            [
              -157.67,
              57.77
            ],
            [
              -157.58,
              58.12
            ],
            [
              -157.53,
              58.16
            ],
            [
              -157.4,
              58.17
            ],
            [
              -157.35,
              58.22
            ],
            [
              -157.42,
              58.21
            ],
            [
              -157.55,
              58.28
            ],
            [
              -157.56,
              58.33
            ],
            [
              -157.53,
              58.41
            ],
            [
              -157.45,
              58.51
            ],
            [
              -157.36,
              58.53
            ],
            [
              -157.25,
              58.62
            ],
            [
              -157.08,
              58.71
            ],
            [
              -157.06,
              58.76
            ],
            [
              -156.99,
              58.84
            ],
            [
              -157.01,
              58.88
            ],
            [
              -156.97,
              58.9
            ],
            [
              -156.98,
              58.94
            ],
            [
              -156.93,
              58.97
            ],
            [
              -157,
              58.97
            ],
            [
              -157.04,
              58.95
            ],
            [
              -157.04,
              58.91
            ],
            [
              -157.12,
              58.87
            ],
            [
              -157.22,
              58.84
            ],
            [
              -157.35,
              58.82
            ],
            [
              -157.43,
              58.79
            ],
            [
              -157.53,
              58.77
            ],
            [
              -157.55,
              58.75
            ],
            [
              -157.7,
              58.73
            ],
            [
              -157.86,
              58.68
            ],
            [
              -158.14,
              58.62
            ],
            [
              -158.23,
              58.62
            ],
            [
              -158.33,
              58.67
            ],
            [
              -158.35,
              58.73
            ],
            [
              -158.42,
              58.77
            ],
            [
              -158.57,
              58.8
            ],
            [
              -158.56,
              58.84
            ],
            [
              -158.52,
              58.86
            ],
            [
              -158.49,
              59
            ],
            [
              -158.53,
              59
            ],
            [
              -158.62,
              58.91
            ],
            [
              -158.77,
              58.86
            ],
            [
              -158.79,
              58.81
            ],
            [
              -158.77,
              58.76
            ],
            [
              -158.8,
              58.73
            ],
            [
              -158.85,
              58.72
            ],
            [
              -158.86,
              58.7
            ],
            [
              -158.83,
              58.63
            ],
            [
              -158.77,
              58.55
            ],
            [
              -158.7,
              58.48
            ],
            [
              -158.8,
              58.41
            ],
            [
              -158.9,
              58.39
            ],
            [
              -159.05,
              58.42
            ],
            [
              -159.19,
              58.56
            ],
            [
              -159.36,
              58.73
            ],
            [
              -159.45,
              58.8
            ],
            [
              -159.53,
              58.83
            ],
            [
              -159.64,
              58.84
            ],
            [
              -159.59,
              58.9
            ],
            [
              -159.64,
              58.94
            ],
            [
              -159.73,
              58.93
            ],
            [
              -159.75,
              58.86
            ],
            [
              -159.81,
              58.86
            ],
            [
              -159.8,
              58.81
            ],
            [
              -159.91,
              58.78
            ],
            [
              -159.99,
              58.85
            ],
            [
              -159.98,
              58.87
            ],
            [
              -160.05,
              58.89
            ],
            [
              -160.09,
              58.86
            ],
            [
              -160.15,
              58.87
            ],
            [
              -160.15,
              58.92
            ],
            [
              -160.23,
              58.9
            ],
            [
              -160.32,
              58.95
            ],
            [
              -160.26,
              58.99
            ],
            [
              -160.32,
              59.07
            ],
            [
              -160.48,
              59.03
            ],
            [
              -160.64,
              58.96
            ],
            [
              -160.75,
              58.91
            ],
            [
              -160.82,
              58.83
            ],
            [
              -160.87,
              58.88
            ],
            [
              -161,
              58.85
            ],
            [
              -161.34,
              58.74
            ],
            [
              -161.37,
              58.71
            ],
            [
              -161.37,
              58.67
            ],
            [
              -161.52,
              58.63
            ],
            [
              -161.55,
              58.61
            ],
            [
              -161.63,
              58.6
            ],
            [
              -161.68,
              58.56
            ],
            [
              -161.75,
              58.55
            ],
            [
              -161.77,
              58.6
            ],
            [
              -161.87,
              58.64
            ],
            [
              -162.07,
              58.62
            ],
            [
              -162.17,
              58.65
            ],
            [
              -161.99,
              58.69
            ],
            [
              -161.94,
              58.66
            ],
            [
              -161.88,
              58.67
            ],
            [
              -161.86,
              58.71
            ],
            [
              -161.77,
              58.78
            ],
            [
              -161.76,
              58.83
            ],
            [
              -161.79,
              58.9
            ],
            [
              -161.78,
              58.97
            ],
            [
              -161.84,
              59.03
            ],
            [
              -161.82,
              59.05
            ],
            [
              -161.88,
              59.07
            ],
            [
              -161.98,
              59.15
            ],
            [
              -162.06,
              59.27
            ],
            [
              -161.95,
              59.38
            ],
            [
              -161.88,
              59.4
            ],
            [
              -161.79,
              59.47
            ],
            [
              -161.7,
              59.49
            ],
            [
              -161.76,
              59.56
            ],
            [
              -161.82,
              59.59
            ],
            [
              -161.88,
              59.65
            ],
            [
              -161.91,
              59.74
            ],
            [
              -162.09,
              59.88
            ],
            [
              -162.1,
              59.94
            ],
            [
              -162.19,
              60
            ],
            [
              -162.23,
              60.06
            ],
            [
              -162.34,
              60.13
            ],
            [
              -162.37,
              60.17
            ],
            [
              -162.45,
              60.17
            ],
            [
              -162.49,
              60.14
            ],
            [
              -162.5,
              60.08
            ],
            [
              -162.48,
              60.05
            ],
            [
              -162.5,
              60
            ],
            [
              -162.55,
              59.98
            ],
            [
              -162.64,
              59.97
            ],
            [
              -162.71,
              59.99
            ],
            [
              -162.78,
              59.94
            ],
            [
              -162.91,
              59.92
            ],
            [
              -163.09,
              59.86
            ],
            [
              -163.35,
              59.82
            ],
            [
              -163.66,
              59.8
            ],
            [
              -163.93,
              59.8
            ],
            [
              -164.12,
              59.84
            ],
            [
              -164.16,
              59.86
            ],
            [
              -164.21,
              59.95
            ],
            [
              -164.13,
              59.96
            ],
            [
              -164.19,
              60.02
            ],
            [
              -164.38,
              60.08
            ],
            [
              -164.5,
              60.17
            ],
            [
              -164.52,
              60.2
            ],
            [
              -164.64,
              60.24
            ],
            [
              -164.7,
              60.3
            ],
            [
              -164.85,
              60.3
            ],
            [
              -164.96,
              60.34
            ],
            [
              -165.13,
              60.43
            ],
            [
              -165.05,
              60.46
            ],
            [
              -164.96,
              60.51
            ],
            [
              -164.97,
              60.54
            ],
            [
              -165.06,
              60.54
            ],
            [
              -165.19,
              60.5
            ],
            [
              -165.36,
              60.51
            ],
            [
              -165.42,
              60.55
            ],
            [
              -165.38,
              60.58
            ],
            [
              -165.27,
              60.58
            ],
            [
              -165.06,
              60.69
            ],
            [
              -165.03,
              60.69
            ],
            [
              -164.97,
              60.72
            ],
            [
              -165.02,
              60.75
            ],
            [
              -165.04,
              60.79
            ],
            [
              -164.92,
              60.81
            ],
            [
              -165.02,
              60.82
            ],
            [
              -165,
              60.88
            ],
            [
              -164.91,
              60.94
            ],
            [
              -164.97,
              60.95
            ],
            [
              -165.03,
              60.9
            ],
            [
              -165.17,
              60.94
            ],
            [
              -165.2,
              60.97
            ],
            [
              -165.12,
              61.02
            ],
            [
              -165.02,
              61.01
            ],
            [
              -164.95,
              61.03
            ],
            [
              -164.95,
              61.07
            ],
            [
              -165.01,
              61.05
            ],
            [
              -165.12,
              61.08
            ],
            [
              -165.18,
              61.13
            ],
            [
              -165.17,
              61.15
            ],
            [
              -165.24,
              61.15
            ],
            [
              -165.29,
              61.18
            ],
            [
              -165.32,
              61.17
            ],
            [
              -165.37,
              61.08
            ],
            [
              -165.42,
              61.08
            ],
            [
              -165.55,
              61.09
            ],
            [
              -165.59,
              61.11
            ],
            [
              -165.63,
              61.17
            ],
            [
              -165.62,
              61.28
            ],
            [
              -165.66,
              61.29
            ],
            [
              -165.82,
              61.3
            ],
            [
              -165.88,
              61.34
            ],
            [
              -165.92,
              61.42
            ],
            [
              -165.77,
              61.46
            ],
            [
              -165.74,
              61.49
            ],
            [
              -165.81,
              61.53
            ],
            [
              -165.91,
              61.56
            ],
            [
              -166.08,
              61.53
            ],
            [
              -166.08,
              61.49
            ],
            [
              -166.15,
              61.51
            ],
            [
              -166.18,
              61.59
            ],
            [
              -166.15,
              61.71
            ],
            [
              -166.13,
              61.72
            ],
            [
              -166.14,
              61.63
            ],
            [
              -165.81,
              61.67
            ],
            [
              -165.81,
              61.69
            ],
            [
              -165.94,
              61.71
            ],
            [
              -166.01,
              61.73
            ],
            [
              -166.09,
              61.8
            ],
            [
              -166.09,
              61.82
            ],
            [
              -165.96,
              61.83
            ],
            [
              -165.76,
              61.83
            ],
            [
              -165.64,
              61.85
            ],
            [
              -165.74,
              61.96
            ],
            [
              -165.76,
              62
            ],
            [
              -165.75,
              62.07
            ],
            [
              -165.67,
              62.14
            ],
            [
              -165.31,
              62.38
            ],
            [
              -165.3,
              62.4
            ],
            [
              -165.2,
              62.47
            ],
            [
              -165.1,
              62.52
            ],
            [
              -165.08,
              62.58
            ],
            [
              -165.01,
              62.64
            ],
            [
              -164.94,
              62.67
            ],
            [
              -164.87,
              62.67
            ],
            [
              -164.84,
              62.69
            ],
            [
              -164.88,
              62.78
            ],
            [
              -164.78,
              62.95
            ],
            [
              -164.72,
              63.01
            ],
            [
              -164.58,
              63.06
            ],
            [
              -164.65,
              63.08
            ],
            [
              -164.63,
              63.1
            ],
            [
              -164.42,
              63.21
            ],
            [
              -164.21,
              63.25
            ],
            [
              -164.04,
              63.26
            ],
            [
              -163.89,
              63.22
            ],
            [
              -163.73,
              63.21
            ],
            [
              -163.62,
              63.14
            ],
            [
              -163.53,
              63.14
            ],
            [
              -163.51,
              63.11
            ],
            [
              -163.31,
              63.04
            ],
            [
              -163.05,
              63.06
            ],
            [
              -162.83,
              63.16
            ],
            [
              -162.82,
              63.21
            ],
            [
              -162.66,
              63.23
            ],
            [
              -162.44,
              63.38
            ],
            [
              -162.35,
              63.45
            ],
            [
              -162.27,
              63.49
            ],
            [
              -162.3,
              63.54
            ],
            [
              -162.25,
              63.54
            ],
            [
              -162.15,
              63.52
            ],
            [
              -162.07,
              63.51
            ],
            [
              -162.03,
              63.45
            ],
            [
              -161.84,
              63.45
            ],
            [
              -161.68,
              63.46
            ],
            [
              -161.58,
              63.45
            ],
            [
              -161.31,
              63.47
            ],
            [
              -161.14,
              63.5
            ],
            [
              -161.1,
              63.55
            ],
            [
              -160.9,
              63.66
            ],
            [
              -160.77,
              63.77
            ],
            [
              -160.77,
              63.83
            ],
            [
              -160.81,
              63.9
            ],
            [
              -160.89,
              63.99
            ],
            [
              -160.95,
              64.09
            ],
            [
              -160.96,
              64.19
            ],
            [
              -160.97,
              64.24
            ],
            [
              -161.23,
              64.37
            ],
            [
              -161.26,
              64.4
            ],
            [
              -161.41,
              64.42
            ],
            [
              -161.51,
              64.42
            ],
            [
              -161.47,
              64.51
            ],
            [
              -161.37,
              64.54
            ],
            [
              -161.32,
              64.51
            ],
            [
              -161.2,
              64.5
            ],
            [
              -161.01,
              64.5
            ],
            [
              -161.05,
              64.54
            ],
            [
              -160.94,
              64.55
            ],
            [
              -160.79,
              64.62
            ],
            [
              -160.78,
              64.72
            ],
            [
              -160.94,
              64.82
            ],
            [
              -161.1,
              64.88
            ],
            [
              -161.19,
              64.92
            ],
            [
              -161.2,
              64.89
            ],
            [
              -161.29,
              64.85
            ],
            [
              -161.37,
              64.78
            ],
            [
              -161.52,
              64.75
            ],
            [
              -161.67,
              64.79
            ],
            [
              -161.88,
              64.71
            ],
            [
              -162.17,
              64.68
            ],
            [
              -162.23,
              64.62
            ],
            [
              -162.54,
              64.53
            ],
            [
              -162.62,
              64.47
            ],
            [
              -162.63,
              64.39
            ],
            [
              -162.79,
              64.33
            ],
            [
              -162.81,
              64.41
            ],
            [
              -162.86,
              64.5
            ],
            [
              -162.94,
              64.54
            ],
            [
              -163.04,
              64.54
            ],
            [
              -163.03,
              64.57
            ],
            [
              -163.14,
              64.61
            ],
            [
              -163.17,
              64.64
            ],
            [
              -163.31,
              64.59
            ],
            [
              -163.25,
              64.55
            ],
            [
              -163.18,
              64.54
            ],
            [
              -163.12,
              64.51
            ],
            [
              -163.03,
              64.52
            ],
            [
              -163.03,
              64.48
            ],
            [
              -163.11,
              64.41
            ],
            [
              -163.17,
              64.4
            ],
            [
              -163.25,
              64.47
            ],
            [
              -163.45,
              64.54
            ],
            [
              -163.6,
              64.56
            ],
            [
              -163.83,
              64.57
            ],
            [
              -163.98,
              64.55
            ],
            [
              -164.07,
              64.56
            ],
            [
              -164.26,
              64.56
            ],
            [
              -164.42,
              64.55
            ],
            [
              -164.81,
              64.45
            ],
            [
              -165.02,
              64.43
            ],
            [
              -165.41,
              64.5
            ],
            [
              -165.75,
              64.54
            ],
            [
              -165.92,
              64.55
            ],
            [
              -166.24,
              64.58
            ],
            [
              -166.41,
              64.65
            ],
            [
              -166.48,
              64.73
            ],
            [
              -166.48,
              64.8
            ],
            [
              -166.41,
              64.83
            ],
            [
              -166.43,
              64.88
            ],
            [
              -166.53,
              64.94
            ],
            [
              -166.69,
              64.99
            ],
            [
              -166.7,
              65.04
            ],
            [
              -166.86,
              65.09
            ],
            [
              -166.9,
              65.14
            ],
            [
              -166.76,
              65.11
            ],
            [
              -166.64,
              65.11
            ],
            [
              -166.61,
              65.14
            ],
            [
              -166.52,
              65.15
            ],
            [
              -166.46,
              65.18
            ],
            [
              -166.47,
              65.22
            ],
            [
              -166.35,
              65.28
            ],
            [
              -166.48,
              65.33
            ],
            [
              -166.55,
              65.34
            ],
            [
              -166.66,
              65.32
            ],
            [
              -166.8,
              65.34
            ],
            [
              -167.03,
              65.38
            ],
            [
              -167.4,
              65.4
            ],
            [
              -167.58,
              65.44
            ],
            [
              -167.71,
              65.5
            ],
            [
              -167.91,
              65.55
            ],
            [
              -168.07,
              65.58
            ],
            [
              -168.13,
              65.66
            ]
          ]
        ],
        [
          [
            [
              -169.05,
              52.86
            ],
            [
              -168.96,
              52.89
            ],
            [
              -168.96,
              52.94
            ],
            [
              -168.9,
              52.94
            ],
            [
              -168.86,
              52.97
            ],
            [
              -168.86,
              53.02
            ],
            [
              -168.79,
              53.05
            ],
            [
              -168.77,
              53.09
            ],
            [
              -168.8,
              53.11
            ],
            [
              -168.76,
              53.18
            ],
            [
              -168.6,
              53.27
            ],
            [
              -168.54,
              53.25
            ],
            [
              -168.44,
              53.27
            ],
            [
              -168.34,
              53.26
            ],
            [
              -168.38,
              53.32
            ],
            [
              -168.42,
              53.32
            ],
            [
              -168.39,
              53.39
            ],
            [
              -168.41,
              53.41
            ],
            [
              -168.34,
              53.48
            ],
            [
              -168.2,
              53.53
            ],
            [
              -168.01,
              53.57
            ],
            [
              -167.9,
              53.52
            ],
            [
              -167.79,
              53.52
            ],
            [
              -167.78,
              53.5
            ],
            [
              -167.86,
              53.44
            ],
            [
              -167.84,
              53.39
            ],
            [
              -168.04,
              53.3
            ],
            [
              -168.27,
              53.24
            ],
            [
              -168.34,
              53.19
            ],
            [
              -168.34,
              53.16
            ],
            [
              -168.44,
              53.09
            ],
            [
              -168.5,
              53.04
            ],
            [
              -168.59,
              53.03
            ],
            [
              -168.69,
              52.97
            ],
            [
              -168.74,
              52.95
            ],
            [
              -168.76,
              52.91
            ],
            [
              -168.81,
              52.93
            ],
            [
              -168.91,
              52.88
            ],
            [
              -169.1,
              52.82
            ],
            [
              -169.05,
              52.86
            ]
          ]
        ],
        [
          [
            [
              -169.27,
              52.77
            ],
            [
              -169.17,
              52.81
            ],
            [
              -169.17,
              52.78
            ],
            [
              -169.26,
              52.75
            ],
            [
              -169.27,
              52.77
            ]
          ]
        ],
        [
          [
            [
              -169.76,
              52.98
            ],
            [
              -169.75,
              53.02
            ],
            [
              -169.68,
              53.03
            ],
            [
              -169.66,
              53
            ],
            [
              -169.7,
              52.96
            ],
            [
              -169.74,
              52.95
            ],
            [
              -169.76,
              52.98
            ]
          ]
        ],
        [
          [
            [
              -169.79,
              56.62
            ],
            [
              -169.61,
              56.61
            ],
            [
              -169.51,
              56.61
            ],
            [
              -169.47,
              56.6
            ],
            [
              -169.57,
              56.54
            ],
            [
              -169.65,
              56.54
            ],
            [
              -169.68,
              56.58
            ],
            [
              -169.75,
              56.59
            ],
            [
              -169.79,
              56.62
            ]
          ]
        ],
        [
          [
            [
              -169.78,
              53.08
            ],
            [
              -169.75,
              53.05
            ],
            [
              -169.8,
              53.06
            ],
            [
              -169.78,
              53.08
            ]
          ]
        ],
        [
          [
            [
              -170.01,
              52.85
            ],
            [
              -169.94,
              52.86
            ],
            [
              -169.86,
              52.86
            ],
            [
              -169.87,
              52.88
            ],
            [
              -169.77,
              52.89
            ],
            [
              -169.7,
              52.89
            ],
            [
              -169.67,
              52.86
            ],
            [
              -169.73,
              52.77
            ],
            [
              -169.84,
              52.82
            ],
            [
              -169.93,
              52.79
            ],
            [
              -169.99,
              52.8
            ],
            [
              -170.01,
              52.85
            ]
          ]
        ],
        [
          [
            [
              -170.11,
              52.9
            ],
            [
              -170.08,
              52.92
            ],
            [
              -170,
              52.91
            ],
            [
              -170,
              52.88
            ],
            [
              -170.05,
              52.86
            ],
            [
              -170.1,
              52.87
            ],
            [
              -170.11,
              52.9
            ]
          ]
        ],
        [
          [
            [
              -170.18,
              52.72
            ],
            [
              -170.17,
              52.78
            ],
            [
              -170.05,
              52.77
            ],
            [
              -170.08,
              52.72
            ],
            [
              -170.18,
              52.72
            ]
          ]
        ],
        [
          [
            [
              -170.42,
              57.17
            ],
            [
              -170.39,
              57.21
            ],
            [
              -170.31,
              57.22
            ],
            [
              -170.27,
              57.21
            ],
            [
              -170.16,
              57.23
            ],
            [
              -170.17,
              57.18
            ],
            [
              -170.29,
              57.13
            ],
            [
              -170.3,
              57.15
            ],
            [
              -170.42,
              57.17
            ]
          ]
        ],
        [
          [
            [
              -170.83,
              52.6
            ],
            [
              -170.82,
              52.64
            ],
            [
              -170.67,
              52.7
            ],
            [
              -170.56,
              52.67
            ],
            [
              -170.56,
              52.65
            ],
            [
              -170.6,
              52.6
            ],
            [
              -170.67,
              52.6
            ],
            [
              -170.73,
              52.58
            ],
            [
              -170.79,
              52.54
            ],
            [
              -170.84,
              52.56
            ],
            [
              -170.83,
              52.6
            ]
          ]
        ],
        [
          [
            [
              -171.15,
              52.58
            ],
            [
              -171.12,
              52.56
            ],
            [
              -171.18,
              52.56
            ],
            [
              -171.15,
              52.58
            ]
          ]
        ],
        [
          [
            [
              -171.31,
              52.49
            ],
            [
              -171.25,
              52.53
            ],
            [
              -171.19,
              52.5
            ],
            [
              -171.24,
              52.45
            ],
            [
              -171.3,
              52.45
            ],
            [
              -171.31,
              52.49
            ]
          ]
        ],
        [
          [
            [
              -171.84,
              63.55
            ],
            [
              -171.83,
              63.58
            ],
            [
              -171.74,
              63.65
            ],
            [
              -171.75,
              63.72
            ],
            [
              -171.72,
              63.73
            ],
            [
              -171.74,
              63.78
            ],
            [
              -171.67,
              63.79
            ],
            [
              -171.64,
              63.75
            ],
            [
              -171.65,
              63.71
            ],
            [
              -171.61,
              63.68
            ],
            [
              -171.38,
              63.63
            ],
            [
              -171.1,
              63.59
            ],
            [
              -170.91,
              63.57
            ],
            [
              -170.7,
              63.65
            ],
            [
              -170.49,
              63.7
            ],
            [
              -170.28,
              63.68
            ],
            [
              -170.18,
              63.63
            ],
            [
              -170.1,
              63.61
            ],
            [
              -170.04,
              63.52
            ],
            [
              -170.05,
              63.49
            ],
            [
              -169.86,
              63.44
            ],
            [
              -169.66,
              63.43
            ],
            [
              -169.58,
              63.4
            ],
            [
              -169.55,
              63.37
            ],
            [
              -169.42,
              63.36
            ],
            [
              -169.1,
              63.34
            ],
            [
              -169.05,
              63.34
            ],
            [
              -168.68,
              63.3
            ],
            [
              -168.78,
              63.18
            ],
            [
              -168.86,
              63.15
            ],
            [
              -169.04,
              63.18
            ],
            [
              -169.2,
              63.18
            ],
            [
              -169.38,
              63.15
            ],
            [
              -169.54,
              63.07
            ],
            [
              -169.57,
              63.02
            ],
            [
              -169.57,
              62.98
            ],
            [
              -169.64,
              62.94
            ],
            [
              -169.75,
              62.96
            ],
            [
              -169.74,
              62.98
            ],
            [
              -169.83,
              63.08
            ],
            [
              -169.94,
              63.13
            ],
            [
              -170.12,
              63.18
            ],
            [
              -170.26,
              63.18
            ],
            [
              -170.3,
              63.24
            ],
            [
              -170.36,
              63.29
            ],
            [
              -170.56,
              63.35
            ],
            [
              -170.87,
              63.41
            ],
            [
              -171.1,
              63.42
            ],
            [
              -171.27,
              63.39
            ],
            [
              -171.33,
              63.34
            ],
            [
              -171.46,
              63.31
            ],
            [
              -171.56,
              63.33
            ],
            [
              -171.74,
              63.37
            ],
            [
              -171.83,
              63.44
            ],
            [
              -171.85,
              63.49
            ],
            [
              -171.84,
              63.55
            ]
          ]
        ],
        [
          [
            [
              -172.62,
              52.3
            ],
            [
              -172.57,
              52.35
            ],
            [
              -172.45,
              52.39
            ],
            [
              -172.41,
              52.39
            ],
            [
              -172.31,
              52.36
            ],
            [
              -172.31,
              52.32
            ],
            [
              -172.41,
              52.28
            ],
            [
              -172.53,
              52.25
            ],
            [
              -172.61,
              52.25
            ],
            [
              -172.62,
              52.3
            ]
          ]
        ],
        [
          [
            [
              -173.06,
              60.5
            ],
            [
              -173.04,
              60.56
            ],
            [
              -172.95,
              60.61
            ],
            [
              -172.91,
              60.6
            ],
            [
              -172.93,
              60.55
            ],
            [
              -172.88,
              60.51
            ],
            [
              -172.77,
              60.45
            ],
            [
              -172.59,
              60.39
            ],
            [
              -172.51,
              60.38
            ],
            [
              -172.42,
              60.39
            ],
            [
              -172.22,
              60.31
            ],
            [
              -172.3,
              60.3
            ],
            [
              -172.33,
              60.33
            ],
            [
              -172.51,
              60.33
            ],
            [
              -172.6,
              60.32
            ],
            [
              -172.72,
              60.36
            ],
            [
              -172.93,
              60.48
            ],
            [
              -173.06,
              60.5
            ]
          ]
        ],
        [
          [
            [
              -173.09,
              60.7
            ],
            [
              -173.06,
              60.7
            ],
            [
              -173.05,
              60.62
            ],
            [
              -173.12,
              60.66
            ],
            [
              -173.09,
              60.7
            ]
          ]
        ],
        [
          [
            [
              -174.05,
              52.13
            ],
            [
              -173.92,
              52.13
            ],
            [
              -173.8,
              52.11
            ],
            [
              -173.77,
              52.13
            ],
            [
              -173.72,
              52.13
            ],
            [
              -173.6,
              52.15
            ],
            [
              -173.51,
              52.15
            ],
            [
              -173.53,
              52.13
            ],
            [
              -173.5,
              52.1
            ],
            [
              -173.47,
              52.12
            ],
            [
              -173.36,
              52.1
            ],
            [
              -173.28,
              52.11
            ],
            [
              -173.24,
              52.1
            ],
            [
              -173.12,
              52.11
            ],
            [
              -173.11,
              52.1
            ],
            [
              -172.96,
              52.09
            ],
            [
              -173.05,
              52.07
            ],
            [
              -173.11,
              52.08
            ],
            [
              -173.16,
              52.06
            ],
            [
              -173.31,
              52.06
            ],
            [
              -173.39,
              52.03
            ],
            [
              -173.42,
              52.04
            ],
            [
              -173.48,
              52.03
            ],
            [
              -173.55,
              52.03
            ],
            [
              -173.61,
              52.05
            ],
            [
              -173.8,
              52.05
            ],
            [
              -173.83,
              52.04
            ],
            [
              -173.94,
              52.06
            ],
            [
              -173.97,
              52.1
            ],
            [
              -174.01,
              52.1
            ],
            [
              -174.05,
              52.13
            ]
          ]
        ],
        [
          [
            [
              -175.33,
              52.03
            ],
            [
              -175.13,
              52.06
            ],
            [
              -175.09,
              52.03
            ],
            [
              -175,
              52.08
            ],
            [
              -174.99,
              52.06
            ],
            [
              -174.92,
              52.09
            ],
            [
              -174.9,
              52.12
            ],
            [
              -174.84,
              52.09
            ],
            [
              -174.74,
              52.1
            ],
            [
              -174.71,
              52.13
            ],
            [
              -174.69,
              52.11
            ],
            [
              -174.57,
              52.14
            ],
            [
              -174.56,
              52.17
            ],
            [
              -174.41,
              52.18
            ],
            [
              -174.45,
              52.22
            ],
            [
              -174.3,
              52.21
            ],
            [
              -174.25,
              52.24
            ],
            [
              -174.26,
              52.27
            ],
            [
              -174.37,
              52.28
            ],
            [
              -174.45,
              52.31
            ],
            [
              -174.43,
              52.33
            ],
            [
              -174.36,
              52.31
            ],
            [
              -174.32,
              52.35
            ],
            [
              -174.32,
              52.38
            ],
            [
              -174.19,
              52.42
            ],
            [
              -174.07,
              52.39
            ],
            [
              -173.99,
              52.33
            ],
            [
              -173.99,
              52.3
            ],
            [
              -174.06,
              52.23
            ],
            [
              -174.18,
              52.23
            ],
            [
              -174.2,
              52.2
            ],
            [
              -174.08,
              52.13
            ],
            [
              -174.09,
              52.11
            ],
            [
              -174.14,
              52.13
            ],
            [
              -174.2,
              52.12
            ],
            [
              -174.22,
              52.09
            ],
            [
              -174.28,
              52.09
            ],
            [
              -174.35,
              52.11
            ],
            [
              -174.42,
              52.03
            ],
            [
              -174.51,
              52.05
            ],
            [
              -174.74,
              52.01
            ],
            [
              -174.78,
              52.03
            ],
            [
              -174.89,
              52.04
            ],
            [
              -174.97,
              52.04
            ],
            [
              -175.02,
              52.01
            ],
            [
              -175.1,
              52
            ],
            [
              -175.21,
              52.01
            ],
            [
              -175.33,
              52.03
            ]
          ]
        ],
        [
          [
            [
              -175.51,
              51.98
            ],
            [
              -175.45,
              52
            ],
            [
              -175.43,
              51.97
            ],
            [
              -175.5,
              51.97
            ],
            [
              -175.51,
              51.98
            ]
          ]
        ],
        [
          [
            [
              -175.54,
              52.18
            ],
            [
              -175.48,
              52.17
            ],
            [
              -175.52,
              52.16
            ],
            [
              -175.54,
              52.18
            ]
          ]
        ],
        [
          [
            [
              -175.74,
              51.97
            ],
            [
              -175.72,
              51.97
            ],
            [
              -175.58,
              51.97
            ],
            [
              -175.58,
              51.95
            ],
            [
              -175.64,
              51.95
            ],
            [
              -175.72,
              51.93
            ],
            [
              -175.74,
              51.97
            ]
          ]
        ],
        [
          [
            [
              -175.95,
              51.98
            ],
            [
              -175.91,
              52
            ],
            [
              -175.81,
              51.99
            ],
            [
              -175.76,
              51.92
            ],
            [
              -175.82,
              51.92
            ],
            [
              -175.88,
              51.96
            ],
            [
              -175.95,
              51.98
            ]
          ]
        ],
        [
          [
            [
              -176.2,
              52.08
            ],
            [
              -176.15,
              52.12
            ],
            [
              -176.06,
              52.11
            ],
            [
              -175.97,
              52.04
            ],
            [
              -176.05,
              52.01
            ],
            [
              -175.99,
              51.96
            ],
            [
              -176.04,
              51.93
            ],
            [
              -176.1,
              51.93
            ],
            [
              -176.17,
              51.95
            ],
            [
              -176.16,
              52
            ],
            [
              -176.18,
              52
            ],
            [
              -176.21,
              52.06
            ],
            [
              -176.2,
              52.08
            ]
          ]
        ],
        [
          [
            [
              -176.24,
              51.83
            ],
            [
              -176.22,
              51.87
            ],
            [
              -176.18,
              51.88
            ],
            [
              -176.14,
              51.86
            ],
            [
              -176.07,
              51.87
            ],
            [
              -176.11,
              51.89
            ],
            [
              -175.99,
              51.91
            ],
            [
              -175.96,
              51.89
            ],
            [
              -175.96,
              51.85
            ],
            [
              -176.05,
              51.85
            ],
            [
              -176,
              51.8
            ],
            [
              -176.1,
              51.83
            ],
            [
              -176.1,
              51.79
            ],
            [
              -176.14,
              51.8
            ],
            [
              -176.16,
              51.77
            ],
            [
              -176.18,
              51.81
            ],
            [
              -176.24,
              51.83
            ]
          ]
        ],
        [
          [
            [
              -176.99,
              51.63
            ],
            [
              -176.95,
              51.69
            ],
            [
              -176.9,
              51.7
            ],
            [
              -176.87,
              51.73
            ],
            [
              -176.92,
              51.79
            ],
            [
              -176.9,
              51.81
            ],
            [
              -176.79,
              51.82
            ],
            [
              -176.76,
              51.87
            ],
            [
              -176.81,
              51.93
            ],
            [
              -176.77,
              51.97
            ],
            [
              -176.72,
              51.97
            ],
            [
              -176.66,
              51.95
            ],
            [
              -176.59,
              52
            ],
            [
              -176.56,
              51.99
            ],
            [
              -176.55,
              51.93
            ],
            [
              -176.62,
              51.9
            ],
            [
              -176.62,
              51.86
            ],
            [
              -176.58,
              51.84
            ],
            [
              -176.51,
              51.85
            ],
            [
              -176.4,
              51.87
            ],
            [
              -176.29,
              51.87
            ],
            [
              -176.27,
              51.82
            ],
            [
              -176.29,
              51.74
            ],
            [
              -176.34,
              51.73
            ],
            [
              -176.47,
              51.75
            ],
            [
              -176.52,
              51.7
            ],
            [
              -176.58,
              51.69
            ],
            [
              -176.63,
              51.66
            ],
            [
              -176.71,
              51.68
            ],
            [
              -176.74,
              51.66
            ],
            [
              -176.71,
              51.62
            ],
            [
              -176.75,
              51.64
            ],
            [
              -176.8,
              51.61
            ],
            [
              -176.81,
              51.66
            ],
            [
              -176.86,
              51.69
            ],
            [
              -176.93,
              51.59
            ],
            [
              -176.98,
              51.6
            ],
            [
              -176.99,
              51.63
            ]
          ]
        ],
        [
          [
            [
              -177.46,
              51.91
            ],
            [
              -177.42,
              51.92
            ],
            [
              -177.41,
              51.9
            ],
            [
              -177.46,
              51.88
            ],
            [
              -177.46,
              51.91
            ]
          ]
        ],
        [
          [
            [
              -177.7,
              51.71
            ],
            [
              -177.64,
              51.74
            ],
            [
              -177.55,
              51.72
            ],
            [
              -177.46,
              51.75
            ],
            [
              -177.28,
              51.78
            ],
            [
              -177.21,
              51.82
            ],
            [
              -177.2,
              51.93
            ],
            [
              -177.16,
              51.94
            ],
            [
              -177.1,
              51.94
            ],
            [
              -177.04,
              51.9
            ],
            [
              -177.14,
              51.81
            ],
            [
              -177.12,
              51.74
            ],
            [
              -177.14,
              51.71
            ],
            [
              -177.26,
              51.68
            ],
            [
              -177.39,
              51.73
            ],
            [
              -177.49,
              51.71
            ],
            [
              -177.63,
              51.7
            ],
            [
              -177.64,
              51.66
            ],
            [
              -177.67,
              51.66
            ],
            [
              -177.7,
              51.71
            ]
          ]
        ],
        [
          [
            [
              -178.22,
              51.88
            ],
            [
              -178.2,
              51.91
            ],
            [
              -178.09,
              51.92
            ],
            [
              -177.95,
              51.92
            ],
            [
              -177.91,
              51.88
            ],
            [
              -177.92,
              51.85
            ],
            [
              -177.85,
              51.83
            ],
            [
              -177.8,
              51.84
            ],
            [
              -177.73,
              51.83
            ],
            [
              -177.61,
              51.86
            ],
            [
              -177.65,
              51.82
            ],
            [
              -177.8,
              51.79
            ],
            [
              -177.84,
              51.73
            ],
            [
              -177.83,
              51.71
            ],
            [
              -177.87,
              51.68
            ],
            [
              -177.9,
              51.69
            ],
            [
              -177.93,
              51.66
            ],
            [
              -177.9,
              51.61
            ],
            [
              -177.93,
              51.6
            ],
            [
              -177.96,
              51.65
            ],
            [
              -178.01,
              51.63
            ],
            [
              -178.07,
              51.67
            ],
            [
              -178.12,
              51.68
            ],
            [
              -178.1,
              51.7
            ],
            [
              -177.96,
              51.72
            ],
            [
              -177.97,
              51.78
            ],
            [
              -178.04,
              51.78
            ],
            [
              -178.08,
              51.81
            ],
            [
              -178.22,
              51.86
            ],
            [
              -178.22,
              51.88
            ]
          ]
        ],
        [
          [
            [
              -178.68,
              51.61
            ],
            [
              -178.57,
              51.6
            ],
            [
              -178.58,
              51.58
            ],
            [
              -178.67,
              51.59
            ],
            [
              -178.68,
              51.61
            ]
          ]
        ],
        [
          [
            [
              -178.86,
              51.58
            ],
            [
              -178.76,
              51.56
            ],
            [
              -178.73,
              51.54
            ],
            [
              -178.82,
              51.55
            ],
            [
              -178.86,
              51.58
            ]
          ]
        ],
        [
          [
            [
              -178.87,
              51.8
            ],
            [
              -178.82,
              51.84
            ],
            [
              -178.75,
              51.81
            ],
            [
              -178.75,
              51.76
            ],
            [
              -178.82,
              51.75
            ],
            [
              -178.87,
              51.8
            ]
          ]
        ],
        [
          [
            [
              -178.99,
              51.38
            ],
            [
              -178.96,
              51.4
            ],
            [
              -178.93,
              51.38
            ],
            [
              -178.91,
              51.34
            ],
            [
              -178.95,
              51.34
            ],
            [
              -178.99,
              51.31
            ],
            [
              -178.99,
              51.38
            ]
          ]
        ],
        [
          [
            [
              -179.14,
              51.29
            ],
            [
              -179.09,
              51.3
            ],
            [
              -179.07,
              51.25
            ],
            [
              -179.14,
              51.23
            ],
            [
              -179.14,
              51.29
            ]
          ]
        ],
        [
          [
            [
              179.48,
              51.98
            ],
            [
              179.53,
              51.98
            ],
            [
              179.57,
              52.01
            ],
            [
              179.66,
              52.02
            ],
            [
              179.77,
              51.97
            ],
            [
              179.74,
              51.91
            ],
            [
              179.66,
              51.88
            ],
            [
              179.61,
              51.87
            ],
            [
              179.52,
              51.9
            ],
            [
              179.48,
              51.92
            ],
            [
              179.48,
              51.98
            ]
          ]
        ],
        [
          [
            [
              178.63,
              51.64
            ],
            [
              178.64,
              51.66
            ],
            [
              178.74,
              51.63
            ],
            [
              178.81,
              51.64
            ],
            [
              178.9,
              51.61
            ],
            [
              178.92,
              51.59
            ],
            [
              179,
              51.55
            ],
            [
              179.1,
              51.49
            ],
            [
              179.19,
              51.46
            ],
            [
              179.23,
              51.41
            ],
            [
              179.39,
              51.4
            ],
            [
              179.46,
              51.38
            ],
            [
              179.4,
              51.36
            ],
            [
              179.37,
              51.37
            ],
            [
              179.26,
              51.36
            ],
            [
              179.21,
              51.39
            ],
            [
              179.06,
              51.46
            ],
            [
              178.95,
              51.54
            ],
            [
              178.85,
              51.58
            ],
            [
              178.78,
              51.57
            ],
            [
              178.71,
              51.59
            ],
            [
              178.63,
              51.64
            ]
          ]
        ],
        [
          [
            [
              178.45,
              51.98
            ],
            [
              178.48,
              51.99
            ],
            [
              178.55,
              51.97
            ],
            [
              178.59,
              51.95
            ],
            [
              178.54,
              51.9
            ],
            [
              178.5,
              51.9
            ],
            [
              178.45,
              51.98
            ]
          ]
        ],
        [
          [
            [
              178.24,
              51.83
            ],
            [
              178.31,
              51.82
            ],
            [
              178.38,
              51.76
            ],
            [
              178.3,
              51.78
            ],
            [
              178.24,
              51.83
            ]
          ]
        ],
        [
          [
            [
              178.1,
              52.03
            ],
            [
              178.12,
              52.05
            ],
            [
              178.18,
              52.03
            ],
            [
              178.19,
              52
            ],
            [
              178.13,
              51.99
            ],
            [
              178.1,
              52.03
            ]
          ]
        ],
        [
          [
            [
              177.2,
              51.9
            ],
            [
              177.29,
              51.92
            ],
            [
              177.34,
              51.96
            ],
            [
              177.48,
              51.99
            ],
            [
              177.51,
              52.04
            ],
            [
              177.56,
              52.12
            ],
            [
              177.6,
              52.14
            ],
            [
              177.68,
              52.09
            ],
            [
              177.63,
              52.06
            ],
            [
              177.6,
              52.02
            ],
            [
              177.53,
              51.97
            ],
            [
              177.61,
              51.95
            ],
            [
              177.61,
              51.92
            ],
            [
              177.56,
              51.92
            ],
            [
              177.41,
              51.93
            ],
            [
              177.35,
              51.9
            ],
            [
              177.33,
              51.84
            ],
            [
              177.29,
              51.85
            ],
            [
              177.2,
              51.88
            ],
            [
              177.2,
              51.9
            ]
          ]
        ],
        [
          [
            [
              175.87,
              52.37
            ],
            [
              175.97,
              52.36
            ],
            [
              175.9,
              52.34
            ],
            [
              175.87,
              52.37
            ]
          ]
        ],
        [
          [
            [
              174.07,
              52.74
            ],
            [
              174.15,
              52.73
            ],
            [
              174.16,
              52.71
            ],
            [
              174.07,
              52.72
            ],
            [
              174.07,
              52.74
            ]
          ]
        ],
        [
          [
            [
              173.95,
              52.75
            ],
            [
              174,
              52.74
            ],
            [
              174,
              52.72
            ],
            [
              173.95,
              52.75
            ]
          ]
        ],
        [
          [
            [
              173.87,
              52.78
            ],
            [
              173.94,
              52.75
            ],
            [
              173.9,
              52.75
            ],
            [
              173.87,
              52.78
            ]
          ]
        ],
        [
          [
            [
              173.36,
              52.41
            ],
            [
              173.38,
              52.43
            ],
            [
              173.45,
              52.45
            ],
            [
              173.53,
              52.45
            ],
            [
              173.62,
              52.51
            ],
            [
              173.77,
              52.51
            ],
            [
              173.71,
              52.48
            ],
            [
              173.69,
              52.45
            ],
            [
              173.73,
              52.36
            ],
            [
              173.65,
              52.36
            ],
            [
              173.59,
              52.4
            ],
            [
              173.46,
              52.38
            ],
            [
              173.36,
              52.41
            ]
          ]
        ],
        [
          [
            [
              172.46,
              52.93
            ],
            [
              172.63,
              53
            ],
            [
              172.75,
              53.01
            ],
            [
              173.11,
              52.99
            ],
            [
              173.21,
              52.94
            ],
            [
              173.3,
              52.93
            ],
            [
              173.42,
              52.85
            ],
            [
              173.43,
              52.83
            ],
            [
              173.3,
              52.82
            ],
            [
              173.23,
              52.86
            ],
            [
              173.17,
              52.8
            ],
            [
              173.13,
              52.78
            ],
            [
              173,
              52.8
            ],
            [
              172.9,
              52.76
            ],
            [
              172.81,
              52.79
            ],
            [
              172.76,
              52.82
            ],
            [
              172.75,
              52.88
            ],
            [
              172.64,
              52.93
            ],
            [
              172.51,
              52.91
            ],
            [
              172.46,
              52.93
            ]
          ]
        ],
        [
          [
            [
              -131.24,
              55.09
            ],
            [
              -131.21,
              55.11
            ],
            [
              -131.17,
              55.09
            ],
            [
              -131.19,
              55.04
            ],
            [
              -131.25,
              55.07
            ],
            [
              -131.24,
              55.09
            ]
          ]
        ],
        [
          [
            [
              -131.49,
              54.95
            ],
            [
              -131.27,
              55
            ],
            [
              -131.24,
              54.93
            ],
            [
              -131.19,
              54.92
            ],
            [
              -131.27,
              54.86
            ],
            [
              -131.35,
              54.86
            ],
            [
              -131.47,
              54.91
            ],
            [
              -131.49,
              54.95
            ]
          ]
        ],
        [
          [
            [
              -131.62,
              54.95
            ],
            [
              -131.53,
              55
            ],
            [
              -131.5,
              54.98
            ],
            [
              -131.59,
              54.93
            ],
            [
              -131.62,
              54.95
            ]
          ]
        ],
        [
          [
            [
              -131.65,
              55.04
            ],
            [
              -131.59,
              55.09
            ],
            [
              -131.6,
              55.13
            ],
            [
              -131.55,
              55.14
            ],
            [
              -131.6,
              55.18
            ],
            [
              -131.61,
              55.24
            ],
            [
              -131.59,
              55.27
            ],
            [
              -131.55,
              55.28
            ],
            [
              -131.48,
              55.25
            ],
            [
              -131.46,
              55.22
            ],
            [
              -131.42,
              55.22
            ],
            [
              -131.36,
              55.18
            ],
            [
              -131.36,
              55.04
            ],
            [
              -131.39,
              55.01
            ],
            [
              -131.49,
              55.01
            ],
            [
              -131.53,
              55.04
            ],
            [
              -131.61,
              55.01
            ],
            [
              -131.65,
              55.04
            ]
          ]
        ],
        [
          [
            [
              -131.87,
              55.36
            ],
            [
              -131.85,
              55.42
            ],
            [
              -131.83,
              55.42
            ],
            [
              -131.65,
              55.31
            ],
            [
              -131.69,
              55.28
            ],
            [
              -131.69,
              55.22
            ],
            [
              -131.75,
              55.13
            ],
            [
              -131.83,
              55.19
            ],
            [
              -131.86,
              55.29
            ],
            [
              -131.87,
              55.36
            ]
          ]
        ],
        [
          [
            [
              -132.49,
              56.5
            ],
            [
              -132.48,
              56.54
            ],
            [
              -132.44,
              56.52
            ],
            [
              -132.49,
              56.5
            ]
          ]
        ],
        [
          [
            [
              -132.56,
              56.38
            ],
            [
              -132.55,
              56.4
            ],
            [
              -132.48,
              56.44
            ],
            [
              -132.4,
              56.41
            ],
            [
              -132.41,
              56.39
            ],
            [
              -132.49,
              56.36
            ],
            [
              -132.56,
              56.38
            ]
          ]
        ],
        [
          [
            [
              -132.65,
              56.48
            ],
            [
              -132.58,
              56.51
            ],
            [
              -132.52,
              56.56
            ],
            [
              -132.54,
              56.51
            ],
            [
              -132.6,
              56.45
            ],
            [
              -132.65,
              56.48
            ]
          ]
        ],
        [
          [
            [
              -132.89,
              54.97
            ],
            [
              -132.82,
              54.98
            ],
            [
              -132.84,
              54.93
            ],
            [
              -132.89,
              54.97
            ]
          ]
        ],
        [
          [
            [
              -133.02,
              56.23
            ],
            [
              -133,
              56.28
            ],
            [
              -132.96,
              56.25
            ],
            [
              -132.88,
              56.17
            ],
            [
              -132.85,
              56.11
            ],
            [
              -132.9,
              56.1
            ],
            [
              -132.97,
              56.15
            ],
            [
              -133,
              56.16
            ],
            [
              -133.02,
              56.23
            ]
          ]
        ],
        [
          [
            [
              -133.07,
              56.36
            ],
            [
              -133,
              56.43
            ],
            [
              -132.93,
              56.46
            ],
            [
              -132.82,
              56.44
            ],
            [
              -132.73,
              56.46
            ],
            [
              -132.63,
              56.42
            ],
            [
              -132.62,
              56.39
            ],
            [
              -132.68,
              56.35
            ],
            [
              -132.66,
              56.28
            ],
            [
              -132.72,
              56.26
            ],
            [
              -132.88,
              56.24
            ],
            [
              -132.96,
              56.3
            ],
            [
              -133.05,
              56.32
            ],
            [
              -133.07,
              56.36
            ]
          ]
        ],
        [
          [
            [
              -133.32,
              55.43
            ],
            [
              -133.24,
              55.45
            ],
            [
              -133.25,
              55.41
            ],
            [
              -133.31,
              55.4
            ],
            [
              -133.32,
              55.43
            ]
          ]
        ],
        [
          [
            [
              -133.56,
              54.87
            ],
            [
              -133.53,
              54.87
            ],
            [
              -133.5,
              54.76
            ],
            [
              -133.55,
              54.78
            ],
            [
              -133.56,
              54.87
            ]
          ]
        ],
        [
          [
            [
              -133.66,
              55.63
            ],
            [
              -133.62,
              55.65
            ],
            [
              -133.62,
              55.7
            ],
            [
              -133.55,
              55.67
            ],
            [
              -133.55,
              55.64
            ],
            [
              -133.62,
              55.58
            ],
            [
              -133.66,
              55.63
            ]
          ]
        ],
        [
          [
            [
              -133.71,
              55.67
            ],
            [
              -133.67,
              55.68
            ],
            [
              -133.67,
              55.65
            ],
            [
              -133.71,
              55.67
            ]
          ]
        ],
        [
          [
            [
              -133.79,
              55.46
            ],
            [
              -133.76,
              55.54
            ],
            [
              -133.73,
              55.56
            ],
            [
              -133.62,
              55.55
            ],
            [
              -133.58,
              55.54
            ],
            [
              -133.59,
              55.51
            ],
            [
              -133.65,
              55.47
            ],
            [
              -133.62,
              55.46
            ],
            [
              -133.55,
              55.49
            ],
            [
              -133.53,
              55.53
            ],
            [
              -133.48,
              55.51
            ],
            [
              -133.41,
              55.57
            ],
            [
              -133.34,
              55.57
            ],
            [
              -133.29,
              55.54
            ],
            [
              -133.3,
              55.48
            ],
            [
              -133.36,
              55.45
            ],
            [
              -133.43,
              55.47
            ],
            [
              -133.47,
              55.44
            ],
            [
              -133.41,
              55.42
            ],
            [
              -133.42,
              55.39
            ],
            [
              -133.5,
              55.37
            ],
            [
              -133.58,
              55.33
            ],
            [
              -133.61,
              55.24
            ],
            [
              -133.69,
              55.31
            ],
            [
              -133.63,
              55.36
            ],
            [
              -133.64,
              55.43
            ],
            [
              -133.74,
              55.47
            ],
            [
              -133.79,
              55.46
            ]
          ]
        ],
        [
          [
            [
              -133.82,
              55.96
            ],
            [
              -133.78,
              55.98
            ],
            [
              -133.69,
              56.07
            ],
            [
              -133.59,
              56.08
            ],
            [
              -133.55,
              56.1
            ],
            [
              -133.63,
              56.11
            ],
            [
              -133.64,
              56.15
            ],
            [
              -133.58,
              56.13
            ],
            [
              -133.55,
              56.16
            ],
            [
              -133.68,
              56.21
            ],
            [
              -133.63,
              56.24
            ],
            [
              -133.66,
              56.31
            ],
            [
              -133.58,
              56.35
            ],
            [
              -133.42,
              56.33
            ],
            [
              -133.16,
              56.32
            ],
            [
              -133.08,
              56.25
            ],
            [
              -133.04,
              56.18
            ],
            [
              -133.06,
              56.12
            ],
            [
              -133.01,
              56.12
            ],
            [
              -132.96,
              56.06
            ],
            [
              -132.9,
              56.02
            ],
            [
              -132.84,
              56.02
            ],
            [
              -132.63,
              55.92
            ],
            [
              -132.59,
              55.88
            ],
            [
              -132.47,
              55.78
            ],
            [
              -132.46,
              55.67
            ],
            [
              -132.36,
              55.65
            ],
            [
              -132.33,
              55.58
            ],
            [
              -132.3,
              55.55
            ],
            [
              -132.19,
              55.51
            ],
            [
              -132.14,
              55.46
            ],
            [
              -132.18,
              55.45
            ],
            [
              -132.25,
              55.49
            ],
            [
              -132.52,
              55.58
            ],
            [
              -132.53,
              55.55
            ],
            [
              -132.61,
              55.49
            ],
            [
              -132.57,
              55.48
            ],
            [
              -132.52,
              55.52
            ],
            [
              -132.49,
              55.5
            ],
            [
              -132.41,
              55.51
            ],
            [
              -132.39,
              55.48
            ],
            [
              -132.32,
              55.47
            ],
            [
              -132.28,
              55.44
            ],
            [
              -132.42,
              55.43
            ],
            [
              -132.39,
              55.4
            ],
            [
              -132.27,
              55.42
            ],
            [
              -132.22,
              55.37
            ],
            [
              -132.17,
              55.36
            ],
            [
              -132.13,
              55.29
            ],
            [
              -132.1,
              55.28
            ],
            [
              -132.14,
              55.24
            ],
            [
              -132.21,
              55.25
            ],
            [
              -132.21,
              55.22
            ],
            [
              -132.13,
              55.2
            ],
            [
              -132.09,
              55.21
            ],
            [
              -132.08,
              55.25
            ],
            [
              -132.03,
              55.28
            ],
            [
              -131.99,
              55.26
            ],
            [
              -131.98,
              55.18
            ],
            [
              -132.03,
              55.15
            ],
            [
              -132.02,
              55.12
            ],
            [
              -132.1,
              55.04
            ],
            [
              -132.2,
              55.01
            ],
            [
              -132.13,
              54.99
            ],
            [
              -132.04,
              55.04
            ],
            [
              -131.98,
              55.03
            ],
            [
              -131.98,
              54.85
            ],
            [
              -131.96,
              54.79
            ],
            [
              -132.03,
              54.7
            ],
            [
              -132.16,
              54.69
            ],
            [
              -132.26,
              54.73
            ],
            [
              -132.31,
              54.72
            ],
            [
              -132.37,
              54.75
            ],
            [
              -132.37,
              54.78
            ],
            [
              -132.51,
              54.78
            ],
            [
              -132.45,
              54.83
            ],
            [
              -132.35,
              54.82
            ],
            [
              -132.35,
              54.85
            ],
            [
              -132.41,
              54.89
            ],
            [
              -132.48,
              54.9
            ],
            [
              -132.61,
              54.97
            ],
            [
              -132.58,
              55
            ],
            [
              -132.54,
              55.1
            ],
            [
              -132.59,
              55.11
            ],
            [
              -132.63,
              55.06
            ],
            [
              -132.61,
              55.14
            ],
            [
              -132.58,
              55.17
            ],
            [
              -132.62,
              55.2
            ],
            [
              -132.64,
              55.15
            ],
            [
              -132.73,
              55.13
            ],
            [
              -132.68,
              55.05
            ],
            [
              -132.75,
              55
            ],
            [
              -132.92,
              55.04
            ],
            [
              -132.93,
              55.07
            ],
            [
              -132.87,
              55.12
            ],
            [
              -132.94,
              55.21
            ],
            [
              -133.01,
              55.21
            ],
            [
              -133.04,
              55.25
            ],
            [
              -133.12,
              55.25
            ],
            [
              -133.08,
              55.18
            ],
            [
              -133.01,
              55.13
            ],
            [
              -132.99,
              55.07
            ],
            [
              -133.01,
              55.04
            ],
            [
              -132.96,
              55.02
            ],
            [
              -132.89,
              54.9
            ],
            [
              -132.8,
              54.87
            ],
            [
              -132.82,
              54.92
            ],
            [
              -132.73,
              54.94
            ],
            [
              -132.63,
              54.88
            ],
            [
              -132.62,
              54.78
            ],
            [
              -132.67,
              54.76
            ],
            [
              -132.73,
              54.83
            ],
            [
              -132.76,
              54.82
            ],
            [
              -132.67,
              54.67
            ],
            [
              -132.78,
              54.67
            ],
            [
              -132.87,
              54.7
            ],
            [
              -132.88,
              54.75
            ],
            [
              -132.95,
              54.79
            ],
            [
              -133.13,
              54.94
            ],
            [
              -133.16,
              54.96
            ],
            [
              -133.17,
              55.03
            ],
            [
              -133.21,
              55.04
            ],
            [
              -133.24,
              55.09
            ],
            [
              -133.14,
              55.1
            ],
            [
              -133.23,
              55.13
            ],
            [
              -133.22,
              55.23
            ],
            [
              -133.34,
              55.21
            ],
            [
              -133.38,
              55.23
            ],
            [
              -133.44,
              55.21
            ],
            [
              -133.47,
              55.25
            ],
            [
              -133.45,
              55.32
            ],
            [
              -133.33,
              55.35
            ],
            [
              -133.29,
              55.29
            ],
            [
              -133.23,
              55.31
            ],
            [
              -133.28,
              55.33
            ],
            [
              -133.26,
              55.37
            ],
            [
              -133.21,
              55.38
            ],
            [
              -133.16,
              55.37
            ],
            [
              -133.08,
              55.41
            ],
            [
              -133.18,
              55.49
            ],
            [
              -133.13,
              55.5
            ],
            [
              -133.19,
              55.53
            ],
            [
              -133.18,
              55.59
            ],
            [
              -133.26,
              55.57
            ],
            [
              -133.44,
              55.64
            ],
            [
              -133.45,
              55.67
            ],
            [
              -133.39,
              55.67
            ],
            [
              -133.43,
              55.71
            ],
            [
              -133.42,
              55.74
            ],
            [
              -133.51,
              55.76
            ],
            [
              -133.49,
              55.71
            ],
            [
              -133.53,
              55.7
            ],
            [
              -133.64,
              55.73
            ],
            [
              -133.7,
              55.78
            ],
            [
              -133.66,
              55.82
            ],
            [
              -133.56,
              55.84
            ],
            [
              -133.42,
              55.79
            ],
            [
              -133.32,
              55.82
            ],
            [
              -133.38,
              55.88
            ],
            [
              -133.45,
              55.89
            ],
            [
              -133.49,
              55.87
            ],
            [
              -133.52,
              55.89
            ],
            [
              -133.5,
              55.91
            ],
            [
              -133.5,
              55.95
            ],
            [
              -133.48,
              56
            ],
            [
              -133.5,
              56.02
            ],
            [
              -133.54,
              55.98
            ],
            [
              -133.64,
              55.92
            ],
            [
              -133.72,
              55.89
            ],
            [
              -133.8,
              55.93
            ],
            [
              -133.82,
              55.96
            ]
          ]
        ],
        [
          [
            [
              -133.88,
              57.3
            ],
            [
              -133.83,
              57.32
            ],
            [
              -133.78,
              57.29
            ],
            [
              -133.88,
              57.27
            ],
            [
              -133.88,
              57.3
            ]
          ]
        ],
        [
          [
            [
              -133.94,
              55.91
            ],
            [
              -133.89,
              55.94
            ],
            [
              -133.85,
              55.93
            ],
            [
              -133.84,
              55.89
            ],
            [
              -133.87,
              55.85
            ],
            [
              -133.9,
              55.85
            ],
            [
              -133.94,
              55.91
            ]
          ]
        ],
        [
          [
            [
              -134.37,
              55.91
            ],
            [
              -134.27,
              55.93
            ],
            [
              -134.26,
              55.89
            ],
            [
              -134.15,
              55.92
            ],
            [
              -134.12,
              55.99
            ],
            [
              -134.1,
              55.98
            ],
            [
              -134.13,
              55.9
            ],
            [
              -134.21,
              55.88
            ],
            [
              -134.28,
              55.83
            ],
            [
              -134.35,
              55.84
            ],
            [
              -134.32,
              55.87
            ],
            [
              -134.37,
              55.91
            ]
          ]
        ],
        [
          [
            [
              -134.41,
              56.85
            ],
            [
              -134.35,
              56.89
            ],
            [
              -134.3,
              56.91
            ],
            [
              -134.27,
              56.94
            ],
            [
              -134.15,
              56.93
            ],
            [
              -134.15,
              56.96
            ],
            [
              -134.05,
              56.92
            ],
            [
              -134.01,
              56.85
            ],
            [
              -133.94,
              56.81
            ],
            [
              -133.83,
              56.8
            ],
            [
              -133.8,
              56.79
            ],
            [
              -133.76,
              56.81
            ],
            [
              -133.87,
              56.85
            ],
            [
              -133.92,
              56.91
            ],
            [
              -133.92,
              56.96
            ],
            [
              -134.05,
              57.03
            ],
            [
              -134.01,
              57.07
            ],
            [
              -133.89,
              57.1
            ],
            [
              -133.7,
              57.07
            ],
            [
              -133.61,
              57.06
            ],
            [
              -133.44,
              57.02
            ],
            [
              -133.33,
              57
            ],
            [
              -133.31,
              57.01
            ],
            [
              -133.1,
              57.01
            ],
            [
              -133,
              56.94
            ],
            [
              -132.95,
              56.87
            ],
            [
              -132.94,
              56.82
            ],
            [
              -132.9,
              56.8
            ],
            [
              -132.82,
              56.79
            ],
            [
              -132.76,
              56.75
            ],
            [
              -132.74,
              56.71
            ],
            [
              -132.63,
              56.67
            ],
            [
              -132.59,
              56.61
            ],
            [
              -132.54,
              56.58
            ],
            [
              -132.65,
              56.55
            ],
            [
              -132.72,
              56.52
            ],
            [
              -132.82,
              56.5
            ],
            [
              -132.87,
              56.51
            ],
            [
              -132.99,
              56.51
            ],
            [
              -133.14,
              56.53
            ],
            [
              -133.12,
              56.49
            ],
            [
              -133.2,
              56.45
            ],
            [
              -133.35,
              56.47
            ],
            [
              -133.42,
              56.49
            ],
            [
              -133.46,
              56.45
            ],
            [
              -133.51,
              56.44
            ],
            [
              -133.6,
              56.43
            ],
            [
              -133.66,
              56.45
            ],
            [
              -133.67,
              56.52
            ],
            [
              -133.71,
              56.55
            ],
            [
              -133.82,
              56.5
            ],
            [
              -133.78,
              56.47
            ],
            [
              -133.78,
              56.39
            ],
            [
              -133.86,
              56.39
            ],
            [
              -133.87,
              56.36
            ],
            [
              -133.84,
              56.32
            ],
            [
              -133.88,
              56.28
            ],
            [
              -133.88,
              56.22
            ],
            [
              -133.94,
              56.18
            ],
            [
              -133.93,
              56.15
            ],
            [
              -133.96,
              56.09
            ],
            [
              -134,
              56.08
            ],
            [
              -134.09,
              56.09
            ],
            [
              -134.14,
              56.01
            ],
            [
              -134.19,
              56.02
            ],
            [
              -134.23,
              56.07
            ],
            [
              -134.26,
              56.12
            ],
            [
              -134.26,
              56.22
            ],
            [
              -134.3,
              56.29
            ],
            [
              -134.29,
              56.35
            ],
            [
              -134.24,
              56.4
            ],
            [
              -134.25,
              56.44
            ],
            [
              -134.2,
              56.53
            ],
            [
              -134.24,
              56.56
            ],
            [
              -134.32,
              56.55
            ],
            [
              -134.3,
              56.62
            ],
            [
              -134.37,
              56.67
            ],
            [
              -134.4,
              56.73
            ],
            [
              -134.4,
              56.77
            ],
            [
              -134.41,
              56.85
            ]
          ]
        ],
        [
          [
            [
              -134.96,
              58.4
            ],
            [
              -134.81,
              58.32
            ],
            [
              -134.78,
              58.28
            ],
            [
              -134.73,
              58.27
            ],
            [
              -134.7,
              58.16
            ],
            [
              -134.63,
              58.16
            ],
            [
              -134.56,
              58.2
            ],
            [
              -134.52,
              58.18
            ],
            [
              -134.45,
              58.17
            ],
            [
              -134.37,
              58.15
            ],
            [
              -134.18,
              58.16
            ],
            [
              -134.19,
              58.08
            ],
            [
              -134.1,
              58.02
            ],
            [
              -134.09,
              57.97
            ],
            [
              -134.02,
              57.93
            ],
            [
              -133.97,
              57.86
            ],
            [
              -133.9,
              57.81
            ],
            [
              -133.9,
              57.69
            ],
            [
              -133.82,
              57.63
            ],
            [
              -133.81,
              57.58
            ],
            [
              -133.84,
              57.58
            ],
            [
              -133.86,
              57.62
            ],
            [
              -133.99,
              57.72
            ],
            [
              -134.03,
              57.82
            ],
            [
              -134.1,
              57.85
            ],
            [
              -134.13,
              57.9
            ],
            [
              -134.21,
              57.9
            ],
            [
              -134.11,
              57.81
            ],
            [
              -134.1,
              57.78
            ],
            [
              -134.14,
              57.76
            ],
            [
              -134.02,
              57.66
            ],
            [
              -133.94,
              57.61
            ],
            [
              -133.94,
              57.56
            ],
            [
              -133.86,
              57.46
            ],
            [
              -133.93,
              57.47
            ],
            [
              -133.87,
              57.38
            ],
            [
              -133.87,
              57.36
            ],
            [
              -133.96,
              57.31
            ],
            [
              -134.03,
              57.33
            ],
            [
              -134.09,
              57.33
            ],
            [
              -134.08,
              57.3
            ],
            [
              -134.16,
              57.21
            ],
            [
              -134.29,
              57.14
            ],
            [
              -134.38,
              57.12
            ],
            [
              -134.39,
              57.09
            ],
            [
              -134.5,
              57.03
            ],
            [
              -134.6,
              57.03
            ],
            [
              -134.63,
              57.11
            ],
            [
              -134.65,
              57.23
            ],
            [
              -134.57,
              57.29
            ],
            [
              -134.52,
              57.31
            ],
            [
              -134.58,
              57.34
            ],
            [
              -134.58,
              57.4
            ],
            [
              -134.53,
              57.41
            ],
            [
              -134.49,
              57.37
            ],
            [
              -134.46,
              57.39
            ],
            [
              -134.61,
              57.51
            ],
            [
              -134.61,
              57.56
            ],
            [
              -134.68,
              57.61
            ],
            [
              -134.69,
              57.68
            ],
            [
              -134.73,
              57.72
            ],
            [
              -134.7,
              57.83
            ],
            [
              -134.75,
              57.9
            ],
            [
              -134.76,
              57.98
            ],
            [
              -134.8,
              58.06
            ],
            [
              -134.78,
              58.1
            ],
            [
              -134.86,
              58.18
            ],
            [
              -134.92,
              58.21
            ],
            [
              -134.95,
              58.28
            ],
            [
              -134.97,
              58.37
            ],
            [
              -134.96,
              58.4
            ]
          ]
        ],
        [
          [
            [
              -135.03,
              58.52
            ],
            [
              -134.9,
              58.48
            ],
            [
              -134.81,
              58.37
            ],
            [
              -134.84,
              58.37
            ],
            [
              -134.92,
              58.47
            ],
            [
              -135,
              58.48
            ],
            [
              -135.03,
              58.52
            ]
          ]
        ],
        [
          [
            [
              -135.35,
              59.02
            ],
            [
              -135.3,
              58.96
            ],
            [
              -135.3,
              58.92
            ],
            [
              -135.33,
              58.94
            ],
            [
              -135.35,
              59.02
            ]
          ]
        ],
        [
          [
            [
              -135.7,
              57.36
            ],
            [
              -135.64,
              57.37
            ],
            [
              -135.63,
              57.39
            ],
            [
              -135.53,
              57.45
            ],
            [
              -135.55,
              57.51
            ],
            [
              -135.42,
              57.56
            ],
            [
              -135.35,
              57.55
            ],
            [
              -135.26,
              57.48
            ],
            [
              -135.21,
              57.49
            ],
            [
              -135.15,
              57.44
            ],
            [
              -135.06,
              57.42
            ],
            [
              -134.93,
              57.42
            ],
            [
              -134.85,
              57.41
            ],
            [
              -134.81,
              57.34
            ],
            [
              -134.81,
              57.3
            ],
            [
              -134.88,
              57.33
            ],
            [
              -134.95,
              57.33
            ],
            [
              -134.96,
              57.31
            ],
            [
              -134.88,
              57.29
            ],
            [
              -134.84,
              57.25
            ],
            [
              -134.74,
              57.01
            ],
            [
              -134.74,
              56.95
            ],
            [
              -134.7,
              56.9
            ],
            [
              -134.7,
              56.85
            ],
            [
              -134.63,
              56.73
            ],
            [
              -134.61,
              56.64
            ],
            [
              -134.63,
              56.54
            ],
            [
              -134.67,
              56.54
            ],
            [
              -134.64,
              56.47
            ],
            [
              -134.63,
              56.27
            ],
            [
              -134.67,
              56.17
            ],
            [
              -134.7,
              56.18
            ],
            [
              -134.81,
              56.24
            ],
            [
              -134.84,
              56.31
            ],
            [
              -134.92,
              56.36
            ],
            [
              -135.06,
              56.54
            ],
            [
              -135.05,
              56.58
            ],
            [
              -134.97,
              56.6
            ],
            [
              -135.03,
              56.63
            ],
            [
              -135.12,
              56.6
            ],
            [
              -135.17,
              56.68
            ],
            [
              -135.21,
              56.67
            ],
            [
              -135.28,
              56.7
            ],
            [
              -135.32,
              56.75
            ],
            [
              -135.31,
              56.78
            ],
            [
              -135.36,
              56.76
            ],
            [
              -135.4,
              56.78
            ],
            [
              -135.51,
              56.78
            ],
            [
              -135.57,
              56.86
            ],
            [
              -135.51,
              56.87
            ],
            [
              -135.47,
              56.84
            ],
            [
              -135.43,
              56.85
            ],
            [
              -135.44,
              56.94
            ],
            [
              -135.38,
              56.99
            ],
            [
              -135.35,
              57.02
            ],
            [
              -135.49,
              57.09
            ],
            [
              -135.41,
              57.15
            ],
            [
              -135.42,
              57.17
            ],
            [
              -135.37,
              57.2
            ],
            [
              -135.36,
              57.24
            ],
            [
              -135.48,
              57.26
            ],
            [
              -135.55,
              57.23
            ],
            [
              -135.6,
              57.3
            ],
            [
              -135.7,
              57.36
            ]
          ]
        ],
        [
          [
            [
              -135.73,
              58.37
            ],
            [
              -135.67,
              58.38
            ],
            [
              -135.6,
              58.37
            ],
            [
              -135.54,
              58.33
            ],
            [
              -135.65,
              58.32
            ],
            [
              -135.73,
              58.37
            ]
          ]
        ],
        [
          [
            [
              -135.85,
              57.24
            ],
            [
              -135.84,
              57.28
            ],
            [
              -135.85,
              57.34
            ],
            [
              -135.76,
              57.35
            ],
            [
              -135.64,
              57.29
            ],
            [
              -135.58,
              57.23
            ],
            [
              -135.54,
              57.21
            ],
            [
              -135.48,
              57.24
            ],
            [
              -135.4,
              57.23
            ],
            [
              -135.45,
              57.16
            ],
            [
              -135.54,
              57.15
            ],
            [
              -135.64,
              57.01
            ],
            [
              -135.68,
              57.01
            ],
            [
              -135.82,
              56.99
            ],
            [
              -135.86,
              57
            ],
            [
              -135.85,
              57.08
            ],
            [
              -135.76,
              57.12
            ],
            [
              -135.75,
              57.17
            ],
            [
              -135.83,
              57.17
            ],
            [
              -135.82,
              57.2
            ],
            [
              -135.87,
              57.22
            ],
            [
              -135.85,
              57.24
            ]
          ]
        ],
        [
          [
            [
              -136.15,
              58.6
            ],
            [
              -136.12,
              58.61
            ],
            [
              -136.1,
              58.56
            ],
            [
              -136.15,
              58.6
            ]
          ]
        ],
        [
          [
            [
              -136.15,
              58.28
            ],
            [
              -136.05,
              58.32
            ],
            [
              -136.04,
              58.27
            ],
            [
              -136.09,
              58.26
            ],
            [
              -136.15,
              58.28
            ]
          ]
        ],
        [
          [
            [
              -136.57,
              57.93
            ],
            [
              -136.56,
              58.08
            ],
            [
              -136.5,
              58.11
            ],
            [
              -136.47,
              58.1
            ],
            [
              -136.37,
              58.15
            ],
            [
              -136.36,
              58.19
            ],
            [
              -136.4,
              58.27
            ],
            [
              -136.28,
              58.27
            ],
            [
              -136.28,
              58.22
            ],
            [
              -136.24,
              58.17
            ],
            [
              -136.14,
              58.22
            ],
            [
              -136.04,
              58.22
            ],
            [
              -135.98,
              58.2
            ],
            [
              -135.91,
              58.24
            ],
            [
              -135.79,
              58.29
            ],
            [
              -135.73,
              58.24
            ],
            [
              -135.59,
              58.21
            ],
            [
              -135.5,
              58.17
            ],
            [
              -135.54,
              58.1
            ],
            [
              -135.65,
              58.04
            ],
            [
              -135.64,
              57.99
            ],
            [
              -135.59,
              57.99
            ],
            [
              -135.57,
              58.04
            ],
            [
              -135.45,
              58.13
            ],
            [
              -135.4,
              58.14
            ],
            [
              -135.28,
              58.1
            ],
            [
              -135.11,
              58.09
            ],
            [
              -135.07,
              58.06
            ],
            [
              -134.97,
              58.05
            ],
            [
              -134.91,
              57.98
            ],
            [
              -134.93,
              57.92
            ],
            [
              -135.01,
              57.88
            ],
            [
              -135.14,
              57.93
            ],
            [
              -135.17,
              57.92
            ],
            [
              -135.13,
              57.89
            ],
            [
              -135.07,
              57.87
            ],
            [
              -134.95,
              57.81
            ],
            [
              -135.02,
              57.78
            ],
            [
              -135.11,
              57.78
            ],
            [
              -135.1,
              57.75
            ],
            [
              -135.02,
              57.74
            ],
            [
              -134.94,
              57.76
            ],
            [
              -134.92,
              57.68
            ],
            [
              -134.87,
              57.62
            ],
            [
              -134.82,
              57.5
            ],
            [
              -134.87,
              57.46
            ],
            [
              -135.02,
              57.45
            ],
            [
              -135.09,
              57.47
            ],
            [
              -135.24,
              57.55
            ],
            [
              -135.48,
              57.63
            ],
            [
              -135.57,
              57.67
            ],
            [
              -135.65,
              57.65
            ],
            [
              -135.68,
              57.68
            ],
            [
              -135.7,
              57.65
            ],
            [
              -135.59,
              57.6
            ],
            [
              -135.51,
              57.6
            ],
            [
              -135.59,
              57.57
            ],
            [
              -135.57,
              57.55
            ],
            [
              -135.57,
              57.49
            ],
            [
              -135.6,
              57.44
            ],
            [
              -135.71,
              57.37
            ],
            [
              -135.89,
              57.41
            ],
            [
              -135.9,
              57.44
            ],
            [
              -136.05,
              57.51
            ],
            [
              -136.12,
              57.59
            ],
            [
              -136.16,
              57.56
            ],
            [
              -136.23,
              57.6
            ],
            [
              -136.27,
              57.66
            ],
            [
              -136.25,
              57.68
            ],
            [
              -136.32,
              57.76
            ],
            [
              -136.31,
              57.78
            ],
            [
              -136.37,
              57.83
            ],
            [
              -136.46,
              57.85
            ],
            [
              -136.48,
              57.9
            ],
            [
              -136.57,
              57.93
            ]
          ]
        ],
        [
          [
            [
              -145.66,
              60.37
            ],
            [
              -145.56,
              60.36
            ],
            [
              -145.51,
              60.32
            ],
            [
              -145.61,
              60.31
            ],
            [
              -145.66,
              60.37
            ]
          ]
        ],
        [
          [
            [
              -146.01,
              60.4
            ],
            [
              -145.95,
              60.41
            ],
            [
              -145.75,
              60.39
            ],
            [
              -145.76,
              60.36
            ],
            [
              -145.83,
              60.35
            ],
            [
              -146.01,
              60.4
            ]
          ]
        ],
        [
          [
            [
              -147.32,
              60.88
            ],
            [
              -147.23,
              60.91
            ],
            [
              -147.13,
              60.91
            ],
            [
              -147.08,
              60.9
            ],
            [
              -147.14,
              60.85
            ],
            [
              -147.32,
              60.88
            ]
          ]
        ],
        [
          [
            [
              -147.5,
              60.65
            ],
            [
              -147.49,
              60.73
            ],
            [
              -147.39,
              60.74
            ],
            [
              -147.31,
              60.66
            ],
            [
              -147.35,
              60.63
            ],
            [
              -147.48,
              60.62
            ],
            [
              -147.5,
              60.65
            ]
          ]
        ],
        [
          [
            [
              -147.5,
              60.25
            ],
            [
              -147.5,
              60.27
            ],
            [
              -147.34,
              60.31
            ],
            [
              -147.34,
              60.27
            ],
            [
              -147.48,
              60.22
            ],
            [
              -147.5,
              60.25
            ]
          ]
        ],
        [
          [
            [
              -147.93,
              59.78
            ],
            [
              -147.9,
              59.8
            ],
            [
              -147.89,
              59.86
            ],
            [
              -147.81,
              59.87
            ],
            [
              -147.82,
              59.91
            ],
            [
              -147.74,
              59.96
            ],
            [
              -147.68,
              59.96
            ],
            [
              -147.69,
              60
            ],
            [
              -147.59,
              60.03
            ],
            [
              -147.55,
              60.05
            ],
            [
              -147.4,
              60.12
            ],
            [
              -147.32,
              60.22
            ],
            [
              -147.22,
              60.26
            ],
            [
              -147.23,
              60.29
            ],
            [
              -147.2,
              60.35
            ],
            [
              -147.1,
              60.38
            ],
            [
              -147.09,
              60.34
            ],
            [
              -147,
              60.34
            ],
            [
              -147.06,
              60.3
            ],
            [
              -147.03,
              60.29
            ],
            [
              -146.94,
              60.31
            ],
            [
              -146.92,
              60.29
            ],
            [
              -146.95,
              60.26
            ],
            [
              -147.18,
              60.16
            ],
            [
              -147.35,
              60.05
            ],
            [
              -147.38,
              59.98
            ],
            [
              -147.5,
              59.93
            ],
            [
              -147.39,
              59.88
            ],
            [
              -147.46,
              59.84
            ],
            [
              -147.54,
              59.84
            ],
            [
              -147.62,
              59.85
            ],
            [
              -147.68,
              59.8
            ],
            [
              -147.72,
              59.8
            ],
            [
              -147.88,
              59.76
            ],
            [
              -147.93,
              59.78
            ]
          ]
        ],
        [
          [
            [
              -147.95,
              60.24
            ],
            [
              -147.79,
              60.48
            ],
            [
              -147.75,
              60.44
            ],
            [
              -147.71,
              60.45
            ],
            [
              -147.72,
              60.51
            ],
            [
              -147.57,
              60.58
            ],
            [
              -147.57,
              60.53
            ],
            [
              -147.61,
              60.51
            ],
            [
              -147.62,
              60.44
            ],
            [
              -147.69,
              60.4
            ],
            [
              -147.62,
              60.37
            ],
            [
              -147.71,
              60.29
            ],
            [
              -147.7,
              60.25
            ],
            [
              -147.76,
              60.16
            ],
            [
              -147.85,
              60.2
            ],
            [
              -147.86,
              60.22
            ],
            [
              -147.95,
              60.22
            ],
            [
              -147.95,
              60.24
            ]
          ]
        ],
        [
          [
            [
              -148.02,
              60.73
            ],
            [
              -147.97,
              60.75
            ],
            [
              -147.91,
              60.74
            ],
            [
              -147.85,
              60.69
            ],
            [
              -147.93,
              60.66
            ],
            [
              -148.02,
              60.73
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Arizona",
      fips: "04"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -114.72,
            32.72
          ],
          [
            -114.7,
            32.75
          ],
          [
            -114.62,
            32.73
          ],
          [
            -114.53,
            32.76
          ],
          [
            -114.53,
            32.79
          ],
          [
            -114.47,
            32.85
          ],
          [
            -114.46,
            32.91
          ],
          [
            -114.52,
            33.03
          ],
          [
            -114.58,
            33.04
          ],
          [
            -114.6,
            33.03
          ],
          [
            -114.65,
            33.05
          ],
          [
            -114.66,
            33.03
          ],
          [
            -114.71,
            33.09
          ],
          [
            -114.68,
            33.15
          ],
          [
            -114.68,
            33.27
          ],
          [
            -114.73,
            33.31
          ],
          [
            -114.7,
            33.36
          ],
          [
            -114.73,
            33.41
          ],
          [
            -114.66,
            33.41
          ],
          [
            -114.56,
            33.53
          ],
          [
            -114.53,
            33.55
          ],
          [
            -114.54,
            33.59
          ],
          [
            -114.53,
            33.69
          ],
          [
            -114.5,
            33.7
          ],
          [
            -114.5,
            33.76
          ],
          [
            -114.53,
            33.82
          ],
          [
            -114.53,
            33.86
          ],
          [
            -114.5,
            33.86
          ],
          [
            -114.51,
            33.91
          ],
          [
            -114.54,
            33.93
          ],
          [
            -114.44,
            34.03
          ],
          [
            -114.44,
            34.09
          ],
          [
            -114.41,
            34.11
          ],
          [
            -114.32,
            34.14
          ],
          [
            -114.29,
            34.17
          ],
          [
            -114.23,
            34.19
          ],
          [
            -114.22,
            34.21
          ],
          [
            -114.13,
            34.26
          ],
          [
            -114.14,
            34.3
          ],
          [
            -114.18,
            34.35
          ],
          [
            -114.23,
            34.37
          ],
          [
            -114.34,
            34.45
          ],
          [
            -114.39,
            34.46
          ],
          [
            -114.38,
            34.51
          ],
          [
            -114.47,
            34.71
          ],
          [
            -114.55,
            34.77
          ],
          [
            -114.58,
            34.83
          ],
          [
            -114.64,
            34.88
          ],
          [
            -114.63,
            35
          ],
          [
            -114.61,
            35.08
          ],
          [
            -114.65,
            35.1
          ],
          [
            -114.57,
            35.14
          ],
          [
            -114.57,
            35.2
          ],
          [
            -114.6,
            35.35
          ],
          [
            -114.63,
            35.41
          ],
          [
            -114.67,
            35.45
          ],
          [
            -114.68,
            35.5
          ],
          [
            -114.66,
            35.53
          ],
          [
            -114.66,
            35.62
          ],
          [
            -114.69,
            35.65
          ],
          [
            -114.68,
            35.69
          ],
          [
            -114.71,
            35.71
          ],
          [
            -114.69,
            35.76
          ],
          [
            -114.71,
            35.81
          ],
          [
            -114.7,
            35.85
          ],
          [
            -114.67,
            35.88
          ],
          [
            -114.7,
            35.9
          ],
          [
            -114.74,
            35.99
          ],
          [
            -114.73,
            36.02
          ],
          [
            -114.76,
            36.09
          ],
          [
            -114.67,
            36.12
          ],
          [
            -114.63,
            36.14
          ],
          [
            -114.62,
            36.13
          ],
          [
            -114.57,
            36.15
          ],
          [
            -114.51,
            36.15
          ],
          [
            -114.5,
            36.13
          ],
          [
            -114.42,
            36.15
          ],
          [
            -114.37,
            36.14
          ],
          [
            -114.31,
            36.08
          ],
          [
            -114.31,
            36.06
          ],
          [
            -114.24,
            36.01
          ],
          [
            -114.15,
            36.02
          ],
          [
            -114.07,
            36.18
          ],
          [
            -114.05,
            36.19
          ],
          [
            -114.04,
            36.39
          ],
          [
            -114.05,
            36.63
          ],
          [
            -114.05,
            37
          ],
          [
            -113.33,
            37
          ],
          [
            -112.54,
            37
          ],
          [
            -111.41,
            37
          ],
          [
            -111.07,
            37
          ],
          [
            -110.49,
            37
          ],
          [
            -110.47,
            37
          ],
          [
            -109.63,
            37
          ],
          [
            -109.04,
            37
          ],
          [
            -109.04,
            35.55
          ],
          [
            -109.05,
            35.34
          ],
          [
            -109.04,
            35.32
          ],
          [
            -109.04,
            34.52
          ],
          [
            -109.05,
            34
          ],
          [
            -109.04,
            33.88
          ],
          [
            -109.05,
            33.78
          ],
          [
            -109.05,
            31.33
          ],
          [
            -109.28,
            31.33
          ],
          [
            -110,
            31.33
          ],
          [
            -110.46,
            31.33
          ],
          [
            -111.08,
            31.33
          ],
          [
            -112.36,
            31.74
          ],
          [
            -113.13,
            31.97
          ],
          [
            -113.49,
            32.09
          ],
          [
            -114.81,
            32.49
          ],
          [
            -114.79,
            32.55
          ],
          [
            -114.81,
            32.57
          ],
          [
            -114.81,
            32.62
          ],
          [
            -114.78,
            32.63
          ],
          [
            -114.72,
            32.72
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Colorado",
      fips: "08"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -109.05,
            41
          ],
          [
            -108.18,
            41
          ],
          [
            -107.63,
            41
          ],
          [
            -106.45,
            41
          ],
          [
            -106.22,
            41
          ],
          [
            -105.72,
            41
          ],
          [
            -104.86,
            41
          ],
          [
            -104.83,
            41
          ],
          [
            -104.05,
            41
          ],
          [
            -103.04,
            41
          ],
          [
            -102.56,
            41
          ],
          [
            -102.05,
            41
          ],
          [
            -102.05,
            40
          ],
          [
            -102.05,
            39.68
          ],
          [
            -102.05,
            39.3
          ],
          [
            -102.05,
            39.14
          ],
          [
            -102.05,
            38.05
          ],
          [
            -102.04,
            37.93
          ],
          [
            -102.04,
            36.99
          ],
          [
            -102.7,
            37
          ],
          [
            -102.78,
            37
          ],
          [
            -103,
            37
          ],
          [
            -103.73,
            37
          ],
          [
            -104.34,
            36.99
          ],
          [
            -105,
            36.99
          ],
          [
            -105.12,
            37
          ],
          [
            -106.2,
            36.99
          ],
          [
            -106.87,
            36.99
          ],
          [
            -106.88,
            37
          ],
          [
            -107.42,
            37
          ],
          [
            -108.25,
            37
          ],
          [
            -109.04,
            37
          ],
          [
            -109.04,
            37.5
          ],
          [
            -109.04,
            37.53
          ],
          [
            -109.04,
            38.16
          ],
          [
            -109.06,
            38.28
          ],
          [
            -109.06,
            38.72
          ],
          [
            -109.05,
            38.91
          ],
          [
            -109.05,
            40.5
          ],
          [
            -109.05,
            40.54
          ],
          [
            -109.05,
            41
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Florida",
      fips: "12"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -80.75,
              24.86
            ],
            [
              -80.7,
              24.91
            ],
            [
              -80.68,
              24.88
            ],
            [
              -80.73,
              24.84
            ],
            [
              -80.75,
              24.86
            ]
          ]
        ],
        [
          [
            [
              -80.85,
              24.8
            ],
            [
              -80.82,
              24.84
            ],
            [
              -80.78,
              24.84
            ],
            [
              -80.8,
              24.81
            ],
            [
              -80.85,
              24.8
            ]
          ]
        ],
        [
          [
            [
              -81.12,
              24.71
            ],
            [
              -80.94,
              24.78
            ],
            [
              -80.92,
              24.76
            ],
            [
              -81.08,
              24.69
            ],
            [
              -81.12,
              24.71
            ]
          ]
        ],
        [
          [
            [
              -81.81,
              24.57
            ],
            [
              -81.74,
              24.66
            ],
            [
              -81.67,
              24.7
            ],
            [
              -81.58,
              24.74
            ],
            [
              -81.57,
              24.76
            ],
            [
              -81.44,
              24.81
            ],
            [
              -81.31,
              24.76
            ],
            [
              -81.29,
              24.71
            ],
            [
              -81.24,
              24.67
            ],
            [
              -81.26,
              24.66
            ],
            [
              -81.4,
              24.62
            ],
            [
              -81.41,
              24.65
            ],
            [
              -81.51,
              24.64
            ],
            [
              -81.52,
              24.62
            ],
            [
              -81.68,
              24.56
            ],
            [
              -81.81,
              24.55
            ],
            [
              -81.81,
              24.57
            ]
          ]
        ],
        [
          [
            [
              -82.01,
              24.54
            ],
            [
              -81.87,
              24.56
            ],
            [
              -81.91,
              24.53
            ],
            [
              -81.97,
              24.51
            ],
            [
              -82.02,
              24.52
            ],
            [
              -82.01,
              24.54
            ]
          ]
        ],
        [
          [
            [
              -82.16,
              24.56
            ],
            [
              -82.14,
              24.59
            ],
            [
              -82.1,
              24.58
            ],
            [
              -82.12,
              24.55
            ],
            [
              -82.16,
              24.56
            ]
          ]
        ],
        [
          [
            [
              -82.27,
              26.7
            ],
            [
              -82.25,
              26.68
            ],
            [
              -82.18,
              26.5
            ],
            [
              -82.15,
              26.48
            ],
            [
              -82.09,
              26.46
            ],
            [
              -82.06,
              26.47
            ],
            [
              -82.01,
              26.45
            ],
            [
              -82.06,
              26.43
            ],
            [
              -82.1,
              26.42
            ],
            [
              -82.17,
              26.47
            ],
            [
              -82.2,
              26.49
            ],
            [
              -82.24,
              26.59
            ],
            [
              -82.27,
              26.66
            ],
            [
              -82.27,
              26.7
            ]
          ]
        ],
        [
          [
            [
              -82.93,
              24.63
            ],
            [
              -82.88,
              24.64
            ],
            [
              -82.86,
              24.62
            ],
            [
              -82.94,
              24.62
            ],
            [
              -82.93,
              24.63
            ]
          ]
        ],
        [
          [
            [
              -84.67,
              29.79
            ],
            [
              -84.57,
              29.84
            ],
            [
              -84.57,
              29.81
            ],
            [
              -84.62,
              29.78
            ],
            [
              -84.66,
              29.77
            ],
            [
              -84.67,
              29.79
            ]
          ]
        ],
        [
          [
            [
              -85,
              31
            ],
            [
              -84.98,
              30.93
            ],
            [
              -84.94,
              30.89
            ],
            [
              -84.94,
              30.82
            ],
            [
              -84.91,
              30.75
            ],
            [
              -84.86,
              30.71
            ],
            [
              -84.38,
              30.69
            ],
            [
              -83.44,
              30.64
            ],
            [
              -82.7,
              30.6
            ],
            [
              -82.21,
              30.57
            ],
            [
              -82.23,
              30.56
            ],
            [
              -82.23,
              30.51
            ],
            [
              -82.2,
              30.49
            ],
            [
              -82.21,
              30.42
            ],
            [
              -82.17,
              30.36
            ],
            [
              -82.04,
              30.37
            ],
            [
              -82.04,
              30.43
            ],
            [
              -82.02,
              30.48
            ],
            [
              -82.01,
              30.58
            ],
            [
              -82.05,
              30.66
            ],
            [
              -82.04,
              30.71
            ],
            [
              -82.04,
              30.75
            ],
            [
              -82.01,
              30.76
            ],
            [
              -82.02,
              30.78
            ],
            [
              -81.98,
              30.78
            ],
            [
              -81.95,
              30.83
            ],
            [
              -81.9,
              30.82
            ],
            [
              -81.87,
              30.79
            ],
            [
              -81.81,
              30.79
            ],
            [
              -81.74,
              30.77
            ],
            [
              -81.72,
              30.74
            ],
            [
              -81.6,
              30.73
            ],
            [
              -81.54,
              30.71
            ],
            [
              -81.49,
              30.73
            ],
            [
              -81.44,
              30.71
            ],
            [
              -81.43,
              30.7
            ],
            [
              -81.44,
              30.6
            ],
            [
              -81.43,
              30.52
            ],
            [
              -81.45,
              30.5
            ],
            [
              -81.41,
              30.48
            ],
            [
              -81.4,
              30.4
            ],
            [
              -81.39,
              30.3
            ],
            [
              -81.31,
              29.97
            ],
            [
              -81.26,
              29.86
            ],
            [
              -81.26,
              29.81
            ],
            [
              -81.16,
              29.56
            ],
            [
              -81.05,
              29.31
            ],
            [
              -80.94,
              29.11
            ],
            [
              -80.71,
              28.76
            ],
            [
              -80.57,
              28.59
            ],
            [
              -80.56,
              28.53
            ],
            [
              -80.52,
              28.46
            ],
            [
              -80.59,
              28.41
            ],
            [
              -80.6,
              28.36
            ],
            [
              -80.61,
              28.29
            ],
            [
              -80.59,
              28.18
            ],
            [
              -80.57,
              28.1
            ],
            [
              -80.51,
              27.97
            ],
            [
              -80.38,
              27.74
            ],
            [
              -80.33,
              27.6
            ],
            [
              -80.31,
              27.53
            ],
            [
              -80.29,
              27.5
            ],
            [
              -80.26,
              27.38
            ],
            [
              -80.19,
              27.25
            ],
            [
              -80.16,
              27.19
            ],
            [
              -80.14,
              27.11
            ],
            [
              -80.09,
              27.02
            ],
            [
              -80.03,
              26.8
            ],
            [
              -80.04,
              26.59
            ],
            [
              -80.06,
              26.44
            ],
            [
              -80.08,
              26.26
            ],
            [
              -80.09,
              26.23
            ],
            [
              -80.12,
              25.99
            ],
            [
              -80.12,
              25.84
            ],
            [
              -80.13,
              25.77
            ],
            [
              -80.15,
              25.7
            ],
            [
              -80.15,
              25.67
            ],
            [
              -80.18,
              25.68
            ],
            [
              -80.17,
              25.73
            ],
            [
              -80.18,
              25.75
            ],
            [
              -80.24,
              25.72
            ],
            [
              -80.28,
              25.64
            ],
            [
              -80.3,
              25.62
            ],
            [
              -80.3,
              25.57
            ],
            [
              -80.33,
              25.53
            ],
            [
              -80.34,
              25.47
            ],
            [
              -80.32,
              25.44
            ],
            [
              -80.33,
              25.4
            ],
            [
              -80.31,
              25.38
            ],
            [
              -80.33,
              25.34
            ],
            [
              -80.36,
              25.33
            ],
            [
              -80.37,
              25.29
            ],
            [
              -80.29,
              25.32
            ],
            [
              -80.2,
              25.49
            ],
            [
              -80.18,
              25.52
            ],
            [
              -80.18,
              25.49
            ],
            [
              -80.2,
              25.41
            ],
            [
              -80.33,
              25.22
            ],
            [
              -80.36,
              25.15
            ],
            [
              -80.45,
              25.07
            ],
            [
              -80.57,
              24.95
            ],
            [
              -80.66,
              24.9
            ],
            [
              -80.67,
              24.91
            ],
            [
              -80.55,
              25.01
            ],
            [
              -80.5,
              25.05
            ],
            [
              -80.47,
              25.09
            ],
            [
              -80.46,
              25.16
            ],
            [
              -80.44,
              25.19
            ],
            [
              -80.46,
              25.21
            ],
            [
              -80.5,
              25.2
            ],
            [
              -80.52,
              25.22
            ],
            [
              -80.54,
              25.21
            ],
            [
              -80.66,
              25.19
            ],
            [
              -80.71,
              25.15
            ],
            [
              -80.75,
              25.15
            ],
            [
              -80.81,
              25.19
            ],
            [
              -80.88,
              25.17
            ],
            [
              -80.9,
              25.14
            ],
            [
              -81,
              25.12
            ],
            [
              -81.08,
              25.12
            ],
            [
              -81.14,
              25.16
            ],
            [
              -81.17,
              25.22
            ],
            [
              -81.16,
              25.29
            ],
            [
              -81.14,
              25.34
            ],
            [
              -81.12,
              25.34
            ],
            [
              -81.13,
              25.38
            ],
            [
              -81.17,
              25.46
            ],
            [
              -81.21,
              25.5
            ],
            [
              -81.2,
              25.53
            ],
            [
              -81.23,
              25.59
            ],
            [
              -81.27,
              25.61
            ],
            [
              -81.29,
              25.69
            ],
            [
              -81.31,
              25.7
            ],
            [
              -81.35,
              25.69
            ],
            [
              -81.38,
              25.78
            ],
            [
              -81.47,
              25.8
            ],
            [
              -81.47,
              25.82
            ],
            [
              -81.55,
              25.85
            ],
            [
              -81.62,
              25.9
            ],
            [
              -81.66,
              25.89
            ],
            [
              -81.69,
              25.85
            ],
            [
              -81.75,
              25.96
            ],
            [
              -81.8,
              26.09
            ],
            [
              -81.82,
              26.24
            ],
            [
              -81.85,
              26.33
            ],
            [
              -81.87,
              26.38
            ],
            [
              -81.97,
              26.48
            ],
            [
              -82.01,
              26.48
            ],
            [
              -82.01,
              26.53
            ],
            [
              -82.06,
              26.55
            ],
            [
              -82.06,
              26.49
            ],
            [
              -82.11,
              26.48
            ],
            [
              -82.11,
              26.54
            ],
            [
              -82.14,
              26.64
            ],
            [
              -82.18,
              26.68
            ],
            [
              -82.17,
              26.7
            ],
            [
              -82.13,
              26.7
            ],
            [
              -82.09,
              26.67
            ],
            [
              -82.05,
              26.8
            ],
            [
              -82.06,
              26.88
            ],
            [
              -82.09,
              26.89
            ],
            [
              -82.09,
              26.92
            ],
            [
              -82.06,
              26.93
            ],
            [
              -82.07,
              26.96
            ],
            [
              -82.12,
              26.95
            ],
            [
              -82.14,
              26.93
            ],
            [
              -82.18,
              26.92
            ],
            [
              -82.15,
              26.79
            ],
            [
              -82.18,
              26.77
            ],
            [
              -82.25,
              26.76
            ],
            [
              -82.27,
              26.72
            ],
            [
              -82.27,
              26.78
            ],
            [
              -82.29,
              26.83
            ],
            [
              -82.35,
              26.91
            ],
            [
              -82.44,
              27.06
            ],
            [
              -82.48,
              27.14
            ],
            [
              -82.55,
              27.26
            ],
            [
              -82.64,
              27.39
            ],
            [
              -82.69,
              27.44
            ],
            [
              -82.71,
              27.49
            ],
            [
              -82.74,
              27.54
            ],
            [
              -82.71,
              27.52
            ],
            [
              -82.7,
              27.5
            ],
            [
              -82.65,
              27.52
            ],
            [
              -82.61,
              27.59
            ],
            [
              -82.57,
              27.61
            ],
            [
              -82.52,
              27.69
            ],
            [
              -82.48,
              27.72
            ],
            [
              -82.48,
              27.74
            ],
            [
              -82.43,
              27.76
            ],
            [
              -82.39,
              27.84
            ],
            [
              -82.41,
              27.9
            ],
            [
              -82.49,
              27.92
            ],
            [
              -82.47,
              27.82
            ],
            [
              -82.55,
              27.85
            ],
            [
              -82.53,
              27.88
            ],
            [
              -82.53,
              27.93
            ],
            [
              -82.55,
              27.97
            ],
            [
              -82.69,
              28.03
            ],
            [
              -82.69,
              27.97
            ],
            [
              -82.72,
              27.95
            ],
            [
              -82.69,
              27.92
            ],
            [
              -82.63,
              27.91
            ],
            [
              -82.59,
              27.82
            ],
            [
              -82.62,
              27.78
            ],
            [
              -82.62,
              27.73
            ],
            [
              -82.64,
              27.7
            ],
            [
              -82.71,
              27.7
            ],
            [
              -82.72,
              27.67
            ],
            [
              -82.7,
              27.64
            ],
            [
              -82.73,
              27.61
            ],
            [
              -82.75,
              27.65
            ],
            [
              -82.74,
              27.72
            ],
            [
              -82.79,
              27.79
            ],
            [
              -82.82,
              27.81
            ],
            [
              -82.85,
              27.86
            ],
            [
              -82.83,
              28.02
            ],
            [
              -82.85,
              28.08
            ],
            [
              -82.86,
              28.22
            ],
            [
              -82.83,
              28.22
            ],
            [
              -82.83,
              28.14
            ],
            [
              -82.81,
              28.06
            ],
            [
              -82.78,
              28.06
            ],
            [
              -82.8,
              28.19
            ],
            [
              -82.76,
              28.22
            ],
            [
              -82.76,
              28.25
            ],
            [
              -82.73,
              28.29
            ],
            [
              -82.73,
              28.32
            ],
            [
              -82.71,
              28.37
            ],
            [
              -82.71,
              28.4
            ],
            [
              -82.67,
              28.44
            ],
            [
              -82.67,
              28.52
            ],
            [
              -82.65,
              28.59
            ],
            [
              -82.67,
              28.65
            ],
            [
              -82.67,
              28.7
            ],
            [
              -82.71,
              28.72
            ],
            [
              -82.7,
              28.76
            ],
            [
              -82.73,
              28.85
            ],
            [
              -82.69,
              28.91
            ],
            [
              -82.76,
              29
            ],
            [
              -82.75,
              29.03
            ],
            [
              -82.78,
              29.07
            ],
            [
              -82.82,
              29.08
            ],
            [
              -82.8,
              29.1
            ],
            [
              -82.8,
              29.15
            ],
            [
              -82.83,
              29.16
            ],
            [
              -83,
              29.18
            ],
            [
              -83.03,
              29.13
            ],
            [
              -83.05,
              29.13
            ],
            [
              -83.09,
              29.22
            ],
            [
              -83.08,
              29.26
            ],
            [
              -83.13,
              29.28
            ],
            [
              -83.17,
              29.29
            ],
            [
              -83.18,
              29.34
            ],
            [
              -83.2,
              29.39
            ],
            [
              -83.24,
              29.43
            ],
            [
              -83.3,
              29.44
            ],
            [
              -83.31,
              29.48
            ],
            [
              -83.4,
              29.52
            ],
            [
              -83.4,
              29.61
            ],
            [
              -83.41,
              29.67
            ],
            [
              -83.46,
              29.68
            ],
            [
              -83.49,
              29.71
            ],
            [
              -83.54,
              29.72
            ],
            [
              -83.59,
              29.78
            ],
            [
              -83.59,
              29.81
            ],
            [
              -83.62,
              29.84
            ],
            [
              -83.64,
              29.89
            ],
            [
              -83.69,
              29.92
            ],
            [
              -83.79,
              29.98
            ],
            [
              -83.93,
              30.04
            ],
            [
              -84.02,
              30.1
            ],
            [
              -84.06,
              30.1
            ],
            [
              -84.16,
              30.07
            ],
            [
              -84.27,
              30.1
            ],
            [
              -84.27,
              30.07
            ],
            [
              -84.36,
              30.01
            ],
            [
              -84.33,
              29.92
            ],
            [
              -84.34,
              29.9
            ],
            [
              -84.38,
              29.89
            ],
            [
              -84.43,
              29.91
            ],
            [
              -84.45,
              29.93
            ],
            [
              -84.54,
              29.91
            ],
            [
              -84.65,
              29.85
            ],
            [
              -84.88,
              29.73
            ],
            [
              -84.9,
              29.74
            ],
            [
              -84.88,
              29.77
            ],
            [
              -84.91,
              29.78
            ],
            [
              -84.94,
              29.75
            ],
            [
              -84.99,
              29.71
            ],
            [
              -85.12,
              29.72
            ],
            [
              -85.08,
              29.67
            ],
            [
              -85.07,
              29.64
            ],
            [
              -85.01,
              29.62
            ],
            [
              -84.9,
              29.67
            ],
            [
              -84.8,
              29.7
            ],
            [
              -84.7,
              29.77
            ],
            [
              -84.69,
              29.76
            ],
            [
              -84.78,
              29.69
            ],
            [
              -84.88,
              29.66
            ],
            [
              -85,
              29.6
            ],
            [
              -85.05,
              29.59
            ],
            [
              -85.08,
              29.62
            ],
            [
              -85.14,
              29.63
            ],
            [
              -85.22,
              29.68
            ],
            [
              -85.29,
              29.68
            ],
            [
              -85.35,
              29.66
            ],
            [
              -85.4,
              29.74
            ],
            [
              -85.42,
              29.84
            ],
            [
              -85.39,
              29.88
            ],
            [
              -85.39,
              29.79
            ],
            [
              -85.37,
              29.71
            ],
            [
              -85.34,
              29.69
            ],
            [
              -85.31,
              29.73
            ],
            [
              -85.3,
              29.81
            ],
            [
              -85.36,
              29.9
            ],
            [
              -85.43,
              29.95
            ],
            [
              -85.49,
              29.96
            ],
            [
              -85.54,
              30
            ],
            [
              -85.6,
              30.06
            ],
            [
              -85.7,
              30.1
            ],
            [
              -85.78,
              30.16
            ],
            [
              -85.92,
              30.24
            ],
            [
              -86.09,
              30.3
            ],
            [
              -86.3,
              30.36
            ],
            [
              -86.41,
              30.38
            ],
            [
              -86.63,
              30.4
            ],
            [
              -86.75,
              30.39
            ],
            [
              -86.92,
              30.37
            ],
            [
              -87.15,
              30.33
            ],
            [
              -87.27,
              30.32
            ],
            [
              -87.29,
              30.32
            ],
            [
              -87.52,
              30.28
            ],
            [
              -87.47,
              30.3
            ],
            [
              -87.49,
              30.32
            ],
            [
              -87.46,
              30.34
            ],
            [
              -87.43,
              30.41
            ],
            [
              -87.37,
              30.44
            ],
            [
              -87.44,
              30.48
            ],
            [
              -87.45,
              30.53
            ],
            [
              -87.39,
              30.62
            ],
            [
              -87.4,
              30.67
            ],
            [
              -87.53,
              30.74
            ],
            [
              -87.54,
              30.78
            ],
            [
              -87.63,
              30.85
            ],
            [
              -87.63,
              30.87
            ],
            [
              -87.59,
              30.96
            ],
            [
              -87.6,
              31
            ],
            [
              -87,
              31
            ],
            [
              -86.52,
              30.99
            ],
            [
              -85.89,
              30.99
            ],
            [
              -85.5,
              31
            ],
            [
              -85.24,
              31
            ],
            [
              -85,
              31
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Georgia",
      fips: "13"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -85.61,
            34.98
          ],
          [
            -85.47,
            34.98
          ],
          [
            -84.98,
            34.99
          ],
          [
            -84.32,
            34.99
          ],
          [
            -83.62,
            34.99
          ],
          [
            -83.62,
            34.99
          ],
          [
            -83.11,
            35
          ],
          [
            -83.12,
            34.94
          ],
          [
            -83.23,
            34.88
          ],
          [
            -83.32,
            34.79
          ],
          [
            -83.32,
            34.76
          ],
          [
            -83.35,
            34.74
          ],
          [
            -83.34,
            34.68
          ],
          [
            -83.23,
            34.61
          ],
          [
            -83.17,
            34.61
          ],
          [
            -83.09,
            34.52
          ],
          [
            -83,
            34.47
          ],
          [
            -82.9,
            34.49
          ],
          [
            -82.88,
            34.48
          ],
          [
            -82.85,
            34.42
          ],
          [
            -82.84,
            34.37
          ],
          [
            -82.79,
            34.34
          ],
          [
            -82.78,
            34.3
          ],
          [
            -82.74,
            34.25
          ],
          [
            -82.74,
            34.21
          ],
          [
            -82.72,
            34.15
          ],
          [
            -82.67,
            34.13
          ],
          [
            -82.65,
            34.07
          ],
          [
            -82.6,
            34.03
          ],
          [
            -82.56,
            33.94
          ],
          [
            -82.52,
            33.94
          ],
          [
            -82.46,
            33.88
          ],
          [
            -82.35,
            33.84
          ],
          [
            -82.25,
            33.75
          ],
          [
            -82.23,
            33.7
          ],
          [
            -82.2,
            33.66
          ],
          [
            -82.2,
            33.63
          ],
          [
            -82.15,
            33.6
          ],
          [
            -82.11,
            33.6
          ],
          [
            -82.05,
            33.56
          ],
          [
            -81.98,
            33.48
          ],
          [
            -81.93,
            33.46
          ],
          [
            -81.91,
            33.44
          ],
          [
            -81.94,
            33.4
          ],
          [
            -81.92,
            33.37
          ],
          [
            -81.94,
            33.34
          ],
          [
            -81.84,
            33.27
          ],
          [
            -81.85,
            33.25
          ],
          [
            -81.81,
            33.21
          ],
          [
            -81.77,
            33.22
          ],
          [
            -81.77,
            33.18
          ],
          [
            -81.74,
            33.14
          ],
          [
            -81.65,
            33.09
          ],
          [
            -81.62,
            33.1
          ],
          [
            -81.56,
            33.05
          ],
          [
            -81.49,
            33.01
          ],
          [
            -81.51,
            32.95
          ],
          [
            -81.46,
            32.9
          ],
          [
            -81.46,
            32.85
          ],
          [
            -81.43,
            32.84
          ],
          [
            -81.43,
            32.77
          ],
          [
            -81.41,
            32.74
          ],
          [
            -81.43,
            32.7
          ],
          [
            -81.41,
            32.69
          ],
          [
            -81.39,
            32.65
          ],
          [
            -81.41,
            32.62
          ],
          [
            -81.37,
            32.58
          ],
          [
            -81.28,
            32.55
          ],
          [
            -81.28,
            32.54
          ],
          [
            -81.2,
            32.47
          ],
          [
            -81.21,
            32.44
          ],
          [
            -81.16,
            32.35
          ],
          [
            -81.14,
            32.35
          ],
          [
            -81.12,
            32.28
          ],
          [
            -81.16,
            32.25
          ],
          [
            -81.12,
            32.19
          ],
          [
            -81.13,
            32.17
          ],
          [
            -81.11,
            32.11
          ],
          [
            -81.04,
            32.08
          ],
          [
            -81,
            32.1
          ],
          [
            -80.92,
            32.04
          ],
          [
            -80.89,
            32.03
          ],
          [
            -80.84,
            32.02
          ],
          [
            -80.86,
            31.97
          ],
          [
            -80.91,
            31.94
          ],
          [
            -80.95,
            31.96
          ],
          [
            -80.97,
            31.92
          ],
          [
            -80.93,
            31.91
          ],
          [
            -80.99,
            31.86
          ],
          [
            -81.07,
            31.88
          ],
          [
            -81.08,
            31.83
          ],
          [
            -81.04,
            31.82
          ],
          [
            -81.07,
            31.77
          ],
          [
            -81.13,
            31.72
          ],
          [
            -81.19,
            31.73
          ],
          [
            -81.2,
            31.72
          ],
          [
            -81.16,
            31.69
          ],
          [
            -81.13,
            31.7
          ],
          [
            -81.13,
            31.62
          ],
          [
            -81.16,
            31.57
          ],
          [
            -81.26,
            31.55
          ],
          [
            -81.26,
            31.53
          ],
          [
            -81.2,
            31.54
          ],
          [
            -81.18,
            31.52
          ],
          [
            -81.26,
            31.4
          ],
          [
            -81.28,
            31.33
          ],
          [
            -81.26,
            31.32
          ],
          [
            -81.27,
            31.29
          ],
          [
            -81.29,
            31.21
          ],
          [
            -81.34,
            31.19
          ],
          [
            -81.37,
            31.14
          ],
          [
            -81.4,
            31.13
          ],
          [
            -81.4,
            31.07
          ],
          [
            -81.43,
            31.01
          ],
          [
            -81.45,
            31.02
          ],
          [
            -81.49,
            30.98
          ],
          [
            -81.45,
            30.96
          ],
          [
            -81.41,
            30.98
          ],
          [
            -81.4,
            30.91
          ],
          [
            -81.46,
            30.77
          ],
          [
            -81.44,
            30.71
          ],
          [
            -81.49,
            30.73
          ],
          [
            -81.54,
            30.71
          ],
          [
            -81.6,
            30.73
          ],
          [
            -81.72,
            30.74
          ],
          [
            -81.74,
            30.77
          ],
          [
            -81.81,
            30.79
          ],
          [
            -81.87,
            30.79
          ],
          [
            -81.9,
            30.82
          ],
          [
            -81.95,
            30.83
          ],
          [
            -81.98,
            30.78
          ],
          [
            -82.02,
            30.78
          ],
          [
            -82.01,
            30.76
          ],
          [
            -82.04,
            30.75
          ],
          [
            -82.04,
            30.71
          ],
          [
            -82.05,
            30.66
          ],
          [
            -82.01,
            30.58
          ],
          [
            -82.02,
            30.48
          ],
          [
            -82.04,
            30.43
          ],
          [
            -82.04,
            30.37
          ],
          [
            -82.17,
            30.36
          ],
          [
            -82.21,
            30.42
          ],
          [
            -82.2,
            30.49
          ],
          [
            -82.23,
            30.51
          ],
          [
            -82.23,
            30.56
          ],
          [
            -82.21,
            30.57
          ],
          [
            -82.7,
            30.6
          ],
          [
            -83.44,
            30.64
          ],
          [
            -84.38,
            30.69
          ],
          [
            -84.86,
            30.71
          ],
          [
            -84.91,
            30.75
          ],
          [
            -84.94,
            30.82
          ],
          [
            -84.94,
            30.89
          ],
          [
            -84.98,
            30.93
          ],
          [
            -85,
            31
          ],
          [
            -85.01,
            31.05
          ],
          [
            -85.04,
            31.11
          ],
          [
            -85.11,
            31.19
          ],
          [
            -85.1,
            31.23
          ],
          [
            -85.12,
            31.28
          ],
          [
            -85.09,
            31.29
          ],
          [
            -85.09,
            31.36
          ],
          [
            -85.06,
            31.43
          ],
          [
            -85.07,
            31.47
          ],
          [
            -85.05,
            31.52
          ],
          [
            -85.06,
            31.62
          ],
          [
            -85.13,
            31.69
          ],
          [
            -85.12,
            31.73
          ],
          [
            -85.14,
            31.84
          ],
          [
            -85.13,
            31.88
          ],
          [
            -85.08,
            31.94
          ],
          [
            -85.05,
            32.01
          ],
          [
            -85.05,
            32.09
          ],
          [
            -85.06,
            32.14
          ],
          [
            -85.01,
            32.18
          ],
          [
            -84.96,
            32.2
          ],
          [
            -84.97,
            32.22
          ],
          [
            -84.93,
            32.22
          ],
          [
            -84.89,
            32.26
          ],
          [
            -84.94,
            32.3
          ],
          [
            -85,
            32.32
          ],
          [
            -84.96,
            32.42
          ],
          [
            -85,
            32.45
          ],
          [
            -85.01,
            32.52
          ],
          [
            -85.07,
            32.58
          ],
          [
            -85.1,
            32.65
          ],
          [
            -85.12,
            32.77
          ],
          [
            -85.17,
            32.81
          ],
          [
            -85.15,
            32.84
          ],
          [
            -85.19,
            32.87
          ],
          [
            -85.31,
            33.48
          ],
          [
            -85.36,
            33.75
          ],
          [
            -85.41,
            34
          ],
          [
            -85.47,
            34.33
          ],
          [
            -85.55,
            34.71
          ],
          [
            -85.61,
            34.98
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Indiana",
      fips: "18"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -87.52,
            41.71
          ],
          [
            -87.47,
            41.67
          ],
          [
            -87.43,
            41.69
          ],
          [
            -87.4,
            41.68
          ],
          [
            -87.42,
            41.64
          ],
          [
            -87.33,
            41.62
          ],
          [
            -87.22,
            41.62
          ],
          [
            -87.12,
            41.65
          ],
          [
            -86.93,
            41.71
          ],
          [
            -86.82,
            41.76
          ],
          [
            -86.5,
            41.76
          ],
          [
            -85.79,
            41.76
          ],
          [
            -85.12,
            41.76
          ],
          [
            -84.81,
            41.76
          ],
          [
            -84.81,
            41.7
          ],
          [
            -84.8,
            41.49
          ],
          [
            -84.8,
            40.3
          ],
          [
            -84.81,
            39.93
          ],
          [
            -84.81,
            39.55
          ],
          [
            -84.82,
            39.31
          ],
          [
            -84.82,
            39.11
          ],
          [
            -84.89,
            39.07
          ],
          [
            -84.9,
            39.05
          ],
          [
            -84.84,
            38.99
          ],
          [
            -84.83,
            38.96
          ],
          [
            -84.87,
            38.93
          ],
          [
            -84.86,
            38.9
          ],
          [
            -84.8,
            38.89
          ],
          [
            -84.78,
            38.87
          ],
          [
            -84.83,
            38.83
          ],
          [
            -84.81,
            38.79
          ],
          [
            -84.89,
            38.8
          ],
          [
            -84.95,
            38.78
          ],
          [
            -84.98,
            38.78
          ],
          [
            -85.1,
            38.73
          ],
          [
            -85.15,
            38.69
          ],
          [
            -85.22,
            38.7
          ],
          [
            -85.26,
            38.74
          ],
          [
            -85.35,
            38.73
          ],
          [
            -85.41,
            38.74
          ],
          [
            -85.45,
            38.71
          ],
          [
            -85.44,
            38.6
          ],
          [
            -85.42,
            38.54
          ],
          [
            -85.47,
            38.51
          ],
          [
            -85.5,
            38.47
          ],
          [
            -85.61,
            38.44
          ],
          [
            -85.67,
            38.3
          ],
          [
            -85.74,
            38.27
          ],
          [
            -85.79,
            38.29
          ],
          [
            -85.83,
            38.28
          ],
          [
            -85.85,
            38.22
          ],
          [
            -85.91,
            38.16
          ],
          [
            -85.9,
            38.09
          ],
          [
            -85.92,
            38.03
          ],
          [
            -85.95,
            38.01
          ],
          [
            -86.03,
            37.99
          ],
          [
            -86.05,
            37.96
          ],
          [
            -86.09,
            38.01
          ],
          [
            -86.17,
            38.01
          ],
          [
            -86.27,
            38.06
          ],
          [
            -86.27,
            38.14
          ],
          [
            -86.35,
            38.2
          ],
          [
            -86.37,
            38.19
          ],
          [
            -86.37,
            38.16
          ],
          [
            -86.32,
            38.15
          ],
          [
            -86.33,
            38.13
          ],
          [
            -86.37,
            38.13
          ],
          [
            -86.4,
            38.11
          ],
          [
            -86.43,
            38.13
          ],
          [
            -86.46,
            38.1
          ],
          [
            -86.43,
            38.09
          ],
          [
            -86.45,
            38.05
          ],
          [
            -86.52,
            38.04
          ],
          [
            -86.53,
            37.96
          ],
          [
            -86.51,
            37.93
          ],
          [
            -86.59,
            37.92
          ],
          [
            -86.6,
            37.87
          ],
          [
            -86.64,
            37.84
          ],
          [
            -86.66,
            37.86
          ],
          [
            -86.64,
            37.91
          ],
          [
            -86.68,
            37.92
          ],
          [
            -86.72,
            37.89
          ],
          [
            -86.75,
            37.91
          ],
          [
            -86.79,
            37.99
          ],
          [
            -86.86,
            37.99
          ],
          [
            -86.91,
            37.94
          ],
          [
            -87.01,
            37.92
          ],
          [
            -87.05,
            37.89
          ],
          [
            -87.06,
            37.81
          ],
          [
            -87.09,
            37.79
          ],
          [
            -87.13,
            37.78
          ],
          [
            -87.16,
            37.84
          ],
          [
            -87.22,
            37.85
          ],
          [
            -87.3,
            37.9
          ],
          [
            -87.38,
            37.94
          ],
          [
            -87.45,
            37.94
          ],
          [
            -87.5,
            37.91
          ],
          [
            -87.55,
            37.93
          ],
          [
            -87.57,
            37.97
          ],
          [
            -87.6,
            37.97
          ],
          [
            -87.63,
            37.92
          ],
          [
            -87.59,
            37.86
          ],
          [
            -87.63,
            37.83
          ],
          [
            -87.67,
            37.83
          ],
          [
            -87.66,
            37.88
          ],
          [
            -87.68,
            37.9
          ],
          [
            -87.83,
            37.88
          ],
          [
            -87.87,
            37.92
          ],
          [
            -87.9,
            37.92
          ],
          [
            -87.94,
            37.89
          ],
          [
            -87.9,
            37.81
          ],
          [
            -87.95,
            37.77
          ],
          [
            -88.03,
            37.8
          ],
          [
            -88.07,
            37.8
          ],
          [
            -88.08,
            37.83
          ],
          [
            -88.04,
            37.82
          ],
          [
            -88.1,
            37.9
          ],
          [
            -88.01,
            37.89
          ],
          [
            -88.07,
            37.92
          ],
          [
            -88.01,
            37.98
          ],
          [
            -88.01,
            38.03
          ],
          [
            -88.04,
            38.05
          ],
          [
            -87.97,
            38.07
          ],
          [
            -87.96,
            38.1
          ],
          [
            -88,
            38.08
          ],
          [
            -87.93,
            38.15
          ],
          [
            -87.98,
            38.2
          ],
          [
            -87.99,
            38.25
          ],
          [
            -87.96,
            38.24
          ],
          [
            -87.93,
            38.3
          ],
          [
            -87.91,
            38.27
          ],
          [
            -87.88,
            38.3
          ],
          [
            -87.85,
            38.28
          ],
          [
            -87.81,
            38.36
          ],
          [
            -87.78,
            38.37
          ],
          [
            -87.73,
            38.44
          ],
          [
            -87.74,
            38.48
          ],
          [
            -87.65,
            38.51
          ],
          [
            -87.65,
            38.57
          ],
          [
            -87.62,
            38.64
          ],
          [
            -87.6,
            38.67
          ],
          [
            -87.54,
            38.68
          ],
          [
            -87.49,
            38.74
          ],
          [
            -87.5,
            38.78
          ],
          [
            -87.55,
            38.86
          ],
          [
            -87.51,
            38.95
          ],
          [
            -87.58,
            38.99
          ],
          [
            -87.57,
            39.06
          ],
          [
            -87.63,
            39.1
          ],
          [
            -87.64,
            39.17
          ],
          [
            -87.57,
            39.22
          ],
          [
            -87.61,
            39.26
          ],
          [
            -87.6,
            39.31
          ],
          [
            -87.58,
            39.34
          ],
          [
            -87.53,
            39.35
          ],
          [
            -87.53,
            39.65
          ],
          [
            -87.53,
            39.65
          ],
          [
            -87.53,
            39.99
          ],
          [
            -87.53,
            40
          ],
          [
            -87.53,
            40.25
          ],
          [
            -87.53,
            40.46
          ],
          [
            -87.53,
            41.49
          ],
          [
            -87.52,
            41.71
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kansas",
      fips: "20"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -102.05,
            40
          ],
          [
            -101.13,
            40
          ],
          [
            -100.76,
            40
          ],
          [
            -99.81,
            40
          ],
          [
            -98.83,
            40
          ],
          [
            -98.25,
            40
          ],
          [
            -97.25,
            40
          ],
          [
            -96.3,
            40
          ],
          [
            -95.79,
            40
          ],
          [
            -95.31,
            40
          ],
          [
            -95.25,
            39.95
          ],
          [
            -95.2,
            39.94
          ],
          [
            -95.2,
            39.9
          ],
          [
            -95.15,
            39.91
          ],
          [
            -95.14,
            39.88
          ],
          [
            -95.04,
            39.86
          ],
          [
            -95.01,
            39.9
          ],
          [
            -94.93,
            39.89
          ],
          [
            -94.94,
            39.86
          ],
          [
            -94.92,
            39.84
          ],
          [
            -94.88,
            39.83
          ],
          [
            -94.89,
            39.79
          ],
          [
            -94.92,
            39.79
          ],
          [
            -94.91,
            39.76
          ],
          [
            -94.87,
            39.77
          ],
          [
            -94.87,
            39.73
          ],
          [
            -94.91,
            39.73
          ],
          [
            -94.96,
            39.75
          ],
          [
            -94.97,
            39.68
          ],
          [
            -95.03,
            39.67
          ],
          [
            -95.05,
            39.63
          ],
          [
            -95.05,
            39.59
          ],
          [
            -95.11,
            39.57
          ],
          [
            -95.1,
            39.53
          ],
          [
            -95.05,
            39.5
          ],
          [
            -95.05,
            39.47
          ],
          [
            -94.99,
            39.45
          ],
          [
            -94.95,
            39.39
          ],
          [
            -94.9,
            39.39
          ],
          [
            -94.88,
            39.38
          ],
          [
            -94.91,
            39.35
          ],
          [
            -94.89,
            39.29
          ],
          [
            -94.82,
            39.24
          ],
          [
            -94.83,
            39.22
          ],
          [
            -94.78,
            39.21
          ],
          [
            -94.76,
            39.18
          ],
          [
            -94.71,
            39.17
          ],
          [
            -94.68,
            39.18
          ],
          [
            -94.66,
            39.16
          ],
          [
            -94.59,
            39.16
          ],
          [
            -94.61,
            39.12
          ],
          [
            -94.61,
            38.74
          ],
          [
            -94.61,
            38.64
          ],
          [
            -94.61,
            38.04
          ],
          [
            -94.62,
            37.99
          ],
          [
            -94.62,
            37.32
          ],
          [
            -94.62,
            37.24
          ],
          [
            -94.62,
            37
          ],
          [
            -95.51,
            37
          ],
          [
            -96.22,
            37
          ],
          [
            -96.82,
            37
          ],
          [
            -97.61,
            37
          ],
          [
            -98.35,
            37
          ],
          [
            -99.28,
            37
          ],
          [
            -99.65,
            37
          ],
          [
            -100.2,
            37
          ],
          [
            -100.74,
            37
          ],
          [
            -101.49,
            37
          ],
          [
            -102.04,
            36.99
          ],
          [
            -102.04,
            37.93
          ],
          [
            -102.05,
            38.05
          ],
          [
            -102.05,
            39.14
          ],
          [
            -102.05,
            39.3
          ],
          [
            -102.05,
            39.68
          ],
          [
            -102.05,
            40
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Maine",
      fips: "23"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -68.37,
              44.19
            ],
            [
              -68.32,
              44.2
            ],
            [
              -68.35,
              44.17
            ],
            [
              -68.37,
              44.19
            ]
          ]
        ],
        [
          [
            [
              -68.5,
              44.16
            ],
            [
              -68.48,
              44.23
            ],
            [
              -68.45,
              44.2
            ],
            [
              -68.39,
              44.15
            ],
            [
              -68.44,
              44.12
            ],
            [
              -68.46,
              44.15
            ],
            [
              -68.5,
              44.16
            ]
          ]
        ],
        [
          [
            [
              -68.53,
              44.34
            ],
            [
              -68.52,
              44.38
            ],
            [
              -68.48,
              44.32
            ],
            [
              -68.53,
              44.34
            ]
          ]
        ],
        [
          [
            [
              -68.84,
              44.24
            ],
            [
              -68.79,
              44.24
            ],
            [
              -68.78,
              44.2
            ],
            [
              -68.84,
              44.24
            ]
          ]
        ],
        [
          [
            [
              -68.91,
              43.85
            ],
            [
              -68.88,
              43.88
            ],
            [
              -68.88,
              43.82
            ],
            [
              -68.91,
              43.85
            ]
          ]
        ],
        [
          [
            [
              -68.95,
              44.11
            ],
            [
              -68.92,
              44.15
            ],
            [
              -68.83,
              44.19
            ],
            [
              -68.79,
              44.14
            ],
            [
              -68.82,
              44.14
            ],
            [
              -68.77,
              44.07
            ],
            [
              -68.81,
              44.04
            ],
            [
              -68.87,
              44.03
            ],
            [
              -68.92,
              44.05
            ],
            [
              -68.9,
              44.07
            ],
            [
              -68.91,
              44.11
            ],
            [
              -68.95,
              44.11
            ]
          ]
        ],
        [
          [
            [
              -68.97,
              44.25
            ],
            [
              -68.92,
              44.31
            ],
            [
              -68.91,
              44.37
            ],
            [
              -68.88,
              44.39
            ],
            [
              -68.86,
              44.36
            ],
            [
              -68.89,
              44.33
            ],
            [
              -68.89,
              44.3
            ],
            [
              -68.92,
              44.24
            ],
            [
              -68.95,
              44.22
            ],
            [
              -68.97,
              44.25
            ]
          ]
        ],
        [
          [
            [
              -70.7,
              43.06
            ],
            [
              -70.83,
              43.13
            ],
            [
              -70.83,
              43.19
            ],
            [
              -70.81,
              43.22
            ],
            [
              -70.96,
              43.33
            ],
            [
              -70.99,
              43.38
            ],
            [
              -70.96,
              43.47
            ],
            [
              -70.97,
              43.48
            ],
            [
              -70.95,
              43.55
            ],
            [
              -70.97,
              43.57
            ],
            [
              -70.99,
              43.84
            ],
            [
              -70.99,
              43.92
            ],
            [
              -71.03,
              44.66
            ],
            [
              -71.08,
              45.31
            ],
            [
              -71.01,
              45.32
            ],
            [
              -71.01,
              45.35
            ],
            [
              -70.92,
              45.31
            ],
            [
              -70.92,
              45.28
            ],
            [
              -70.9,
              45.24
            ],
            [
              -70.86,
              45.23
            ],
            [
              -70.81,
              45.3
            ],
            [
              -70.8,
              45.38
            ],
            [
              -70.83,
              45.4
            ],
            [
              -70.78,
              45.43
            ],
            [
              -70.75,
              45.43
            ],
            [
              -70.71,
              45.39
            ],
            [
              -70.64,
              45.38
            ],
            [
              -70.63,
              45.42
            ],
            [
              -70.72,
              45.49
            ],
            [
              -70.72,
              45.52
            ],
            [
              -70.64,
              45.61
            ],
            [
              -70.59,
              45.63
            ],
            [
              -70.55,
              45.67
            ],
            [
              -70.52,
              45.67
            ],
            [
              -70.47,
              45.7
            ],
            [
              -70.38,
              45.73
            ],
            [
              -70.42,
              45.8
            ],
            [
              -70.34,
              45.85
            ],
            [
              -70.26,
              45.89
            ],
            [
              -70.24,
              45.94
            ],
            [
              -70.27,
              45.96
            ],
            [
              -70.32,
              45.96
            ],
            [
              -70.32,
              46.02
            ],
            [
              -70.28,
              46.05
            ],
            [
              -70.31,
              46.06
            ],
            [
              -70.26,
              46.11
            ],
            [
              -70.24,
              46.15
            ],
            [
              -70.29,
              46.19
            ],
            [
              -70.23,
              46.28
            ],
            [
              -70.21,
              46.3
            ],
            [
              -70.21,
              46.33
            ],
            [
              -70.15,
              46.36
            ],
            [
              -70.1,
              46.41
            ],
            [
              -70.06,
              46.42
            ],
            [
              -70,
              46.69
            ],
            [
              -69.23,
              47.46
            ],
            [
              -69.18,
              47.46
            ],
            [
              -69.08,
              47.42
            ],
            [
              -69.04,
              47.43
            ],
            [
              -69.05,
              47.38
            ],
            [
              -69.05,
              47.26
            ],
            [
              -69.03,
              47.24
            ],
            [
              -68.9,
              47.18
            ],
            [
              -68.81,
              47.22
            ],
            [
              -68.72,
              47.24
            ],
            [
              -68.62,
              47.24
            ],
            [
              -68.58,
              47.29
            ],
            [
              -68.47,
              47.3
            ],
            [
              -68.38,
              47.29
            ],
            [
              -68.38,
              47.34
            ],
            [
              -68.32,
              47.36
            ],
            [
              -68.23,
              47.35
            ],
            [
              -68.15,
              47.32
            ],
            [
              -68.14,
              47.3
            ],
            [
              -68.02,
              47.24
            ],
            [
              -67.89,
              47.12
            ],
            [
              -67.89,
              47.11
            ],
            [
              -67.79,
              47.07
            ],
            [
              -67.79,
              46.6
            ],
            [
              -67.78,
              46
            ],
            [
              -67.78,
              45.94
            ],
            [
              -67.75,
              45.92
            ],
            [
              -67.8,
              45.88
            ],
            [
              -67.75,
              45.82
            ],
            [
              -67.81,
              45.79
            ],
            [
              -67.8,
              45.68
            ],
            [
              -67.72,
              45.66
            ],
            [
              -67.71,
              45.68
            ],
            [
              -67.67,
              45.63
            ],
            [
              -67.61,
              45.61
            ],
            [
              -67.5,
              45.59
            ],
            [
              -67.45,
              45.6
            ],
            [
              -67.42,
              45.55
            ],
            [
              -67.42,
              45.5
            ],
            [
              -67.46,
              45.51
            ],
            [
              -67.5,
              45.49
            ],
            [
              -67.48,
              45.43
            ],
            [
              -67.42,
              45.38
            ],
            [
              -67.45,
              45.31
            ],
            [
              -67.49,
              45.28
            ],
            [
              -67.41,
              45.18
            ],
            [
              -67.41,
              45.16
            ],
            [
              -67.34,
              45.13
            ],
            [
              -67.29,
              45.15
            ],
            [
              -67.29,
              45.19
            ],
            [
              -67.23,
              45.16
            ],
            [
              -67.16,
              45.16
            ],
            [
              -67.11,
              45.11
            ],
            [
              -67.09,
              45.07
            ],
            [
              -67.12,
              45.06
            ],
            [
              -67.08,
              45.03
            ],
            [
              -67.04,
              44.95
            ],
            [
              -66.99,
              44.91
            ],
            [
              -66.98,
              44.81
            ],
            [
              -67.02,
              44.77
            ],
            [
              -67.06,
              44.77
            ],
            [
              -67.08,
              44.74
            ],
            [
              -67.19,
              44.65
            ],
            [
              -67.28,
              44.62
            ],
            [
              -67.26,
              44.6
            ],
            [
              -67.32,
              44.6
            ],
            [
              -67.29,
              44.63
            ],
            [
              -67.31,
              44.71
            ],
            [
              -67.41,
              44.68
            ],
            [
              -67.36,
              44.63
            ],
            [
              -67.41,
              44.59
            ],
            [
              -67.44,
              44.61
            ],
            [
              -67.49,
              44.56
            ],
            [
              -67.54,
              44.57
            ],
            [
              -67.57,
              44.56
            ],
            [
              -67.57,
              44.53
            ],
            [
              -67.51,
              44.5
            ],
            [
              -67.59,
              44.45
            ],
            [
              -67.64,
              44.49
            ],
            [
              -67.66,
              44.54
            ],
            [
              -67.7,
              44.53
            ],
            [
              -67.71,
              44.49
            ],
            [
              -67.74,
              44.5
            ],
            [
              -67.77,
              44.55
            ],
            [
              -67.79,
              44.49
            ],
            [
              -67.83,
              44.48
            ],
            [
              -67.85,
              44.42
            ],
            [
              -67.88,
              44.44
            ],
            [
              -67.9,
              44.39
            ],
            [
              -67.92,
              44.43
            ],
            [
              -67.99,
              44.39
            ],
            [
              -68,
              44.41
            ],
            [
              -68.05,
              44.33
            ],
            [
              -68.11,
              44.36
            ],
            [
              -68.11,
              44.4
            ],
            [
              -68.14,
              44.38
            ],
            [
              -68.18,
              44.38
            ],
            [
              -68.17,
              44.33
            ],
            [
              -68.23,
              44.27
            ],
            [
              -68.19,
              44.24
            ],
            [
              -68.32,
              44.23
            ],
            [
              -68.4,
              44.25
            ],
            [
              -68.46,
              44.34
            ],
            [
              -68.44,
              44.37
            ],
            [
              -68.36,
              44.39
            ],
            [
              -68.39,
              44.43
            ],
            [
              -68.44,
              44.4
            ],
            [
              -68.43,
              44.44
            ],
            [
              -68.46,
              44.44
            ],
            [
              -68.46,
              44.38
            ],
            [
              -68.48,
              44.38
            ],
            [
              -68.48,
              44.43
            ],
            [
              -68.56,
              44.38
            ],
            [
              -68.55,
              44.35
            ],
            [
              -68.57,
              44.32
            ],
            [
              -68.52,
              44.26
            ],
            [
              -68.53,
              44.22
            ],
            [
              -68.61,
              44.16
            ],
            [
              -68.58,
              44.15
            ],
            [
              -68.62,
              44.12
            ],
            [
              -68.58,
              44.07
            ],
            [
              -68.6,
              44.01
            ],
            [
              -68.66,
              44
            ],
            [
              -68.67,
              44.08
            ],
            [
              -68.65,
              44.08
            ],
            [
              -68.66,
              44.13
            ],
            [
              -68.72,
              44.17
            ],
            [
              -68.73,
              44.22
            ],
            [
              -68.68,
              44.26
            ],
            [
              -68.75,
              44.3
            ],
            [
              -68.73,
              44.32
            ],
            [
              -68.76,
              44.33
            ],
            [
              -68.83,
              44.31
            ],
            [
              -68.82,
              44.41
            ],
            [
              -68.78,
              44.45
            ],
            [
              -68.78,
              44.49
            ],
            [
              -68.81,
              44.5
            ],
            [
              -68.83,
              44.46
            ],
            [
              -68.88,
              44.43
            ],
            [
              -68.92,
              44.46
            ],
            [
              -68.95,
              44.43
            ],
            [
              -69,
              44.43
            ],
            [
              -68.95,
              44.36
            ],
            [
              -68.96,
              44.31
            ],
            [
              -69,
              44.29
            ],
            [
              -69.04,
              44.23
            ],
            [
              -69.05,
              44.17
            ],
            [
              -69.1,
              44.1
            ],
            [
              -69.03,
              44.08
            ],
            [
              -69.08,
              44.06
            ],
            [
              -69.04,
              44.01
            ],
            [
              -69.08,
              43.97
            ],
            [
              -69.17,
              43.98
            ],
            [
              -69.22,
              43.92
            ],
            [
              -69.28,
              43.91
            ],
            [
              -69.28,
              43.86
            ],
            [
              -69.32,
              43.86
            ],
            [
              -69.32,
              43.9
            ],
            [
              -69.3,
              43.93
            ],
            [
              -69.33,
              43.95
            ],
            [
              -69.34,
              43.92
            ],
            [
              -69.38,
              43.91
            ],
            [
              -69.37,
              43.96
            ],
            [
              -69.43,
              43.96
            ],
            [
              -69.43,
              43.91
            ],
            [
              -69.48,
              43.88
            ],
            [
              -69.5,
              43.84
            ],
            [
              -69.54,
              43.88
            ],
            [
              -69.55,
              43.84
            ],
            [
              -69.61,
              43.81
            ],
            [
              -69.65,
              43.84
            ],
            [
              -69.66,
              43.78
            ],
            [
              -69.71,
              43.82
            ],
            [
              -69.75,
              43.74
            ],
            [
              -69.84,
              43.72
            ],
            [
              -69.85,
              43.7
            ],
            [
              -69.87,
              43.78
            ],
            [
              -69.93,
              43.78
            ],
            [
              -69.98,
              43.74
            ],
            [
              -70,
              43.71
            ],
            [
              -70.07,
              43.71
            ],
            [
              -70.1,
              43.67
            ],
            [
              -70.17,
              43.68
            ],
            [
              -70.21,
              43.63
            ],
            [
              -70.22,
              43.59
            ],
            [
              -70.2,
              43.57
            ],
            [
              -70.23,
              43.54
            ],
            [
              -70.27,
              43.56
            ],
            [
              -70.35,
              43.54
            ],
            [
              -70.38,
              43.5
            ],
            [
              -70.36,
              43.44
            ],
            [
              -70.39,
              43.4
            ],
            [
              -70.43,
              43.39
            ],
            [
              -70.42,
              43.36
            ],
            [
              -70.47,
              43.34
            ],
            [
              -70.52,
              43.34
            ],
            [
              -70.55,
              43.32
            ],
            [
              -70.59,
              43.24
            ],
            [
              -70.57,
              43.22
            ],
            [
              -70.63,
              43.15
            ],
            [
              -70.62,
              43.13
            ],
            [
              -70.67,
              43.07
            ],
            [
              -70.7,
              43.06
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Massachusetts",
      fips: "25"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -70.28,
              41.31
            ],
            [
              -70.23,
              41.29
            ],
            [
              -70.13,
              41.29
            ],
            [
              -70.06,
              41.31
            ],
            [
              -70.02,
              41.37
            ],
            [
              -69.96,
              41.28
            ],
            [
              -69.96,
              41.25
            ],
            [
              -70,
              41.24
            ],
            [
              -70.12,
              41.24
            ],
            [
              -70.27,
              41.29
            ],
            [
              -70.28,
              41.31
            ]
          ]
        ],
        [
          [
            [
              -70.83,
              41.35
            ],
            [
              -70.77,
              41.35
            ],
            [
              -70.7,
              41.43
            ],
            [
              -70.6,
              41.48
            ],
            [
              -70.56,
              41.47
            ],
            [
              -70.54,
              41.41
            ],
            [
              -70.49,
              41.39
            ],
            [
              -70.45,
              41.42
            ],
            [
              -70.45,
              41.35
            ],
            [
              -70.6,
              41.35
            ],
            [
              -70.71,
              41.34
            ],
            [
              -70.78,
              41.3
            ],
            [
              -70.83,
              41.35
            ]
          ]
        ],
        [
          [
            [
              -73.26,
              42.75
            ],
            [
              -72.46,
              42.73
            ],
            [
              -71.74,
              42.71
            ],
            [
              -71.29,
              42.7
            ],
            [
              -71.26,
              42.74
            ],
            [
              -71.18,
              42.74
            ],
            [
              -71.18,
              42.79
            ],
            [
              -71.13,
              42.82
            ],
            [
              -71.06,
              42.81
            ],
            [
              -71.03,
              42.86
            ],
            [
              -70.9,
              42.89
            ],
            [
              -70.85,
              42.86
            ],
            [
              -70.82,
              42.87
            ],
            [
              -70.81,
              42.81
            ],
            [
              -70.78,
              42.69
            ],
            [
              -70.69,
              42.65
            ],
            [
              -70.65,
              42.69
            ],
            [
              -70.6,
              42.66
            ],
            [
              -70.65,
              42.58
            ],
            [
              -70.74,
              42.58
            ],
            [
              -70.87,
              42.55
            ],
            [
              -70.83,
              42.5
            ],
            [
              -70.89,
              42.46
            ],
            [
              -70.92,
              42.47
            ],
            [
              -70.94,
              42.42
            ],
            [
              -70.95,
              42.45
            ],
            [
              -70.99,
              42.41
            ],
            [
              -70.95,
              42.34
            ],
            [
              -71,
              42.35
            ],
            [
              -71.02,
              42.33
            ],
            [
              -70.99,
              42.31
            ],
            [
              -71.01,
              42.28
            ],
            [
              -70.96,
              42.27
            ],
            [
              -70.93,
              42.3
            ],
            [
              -70.88,
              42.31
            ],
            [
              -70.85,
              42.27
            ],
            [
              -70.77,
              42.24
            ],
            [
              -70.72,
              42.21
            ],
            [
              -70.71,
              42.17
            ],
            [
              -70.64,
              42.09
            ],
            [
              -70.64,
              42.05
            ],
            [
              -70.67,
              42.01
            ],
            [
              -70.71,
              42.01
            ],
            [
              -70.7,
              41.99
            ],
            [
              -70.63,
              41.94
            ],
            [
              -70.58,
              41.95
            ],
            [
              -70.55,
              41.93
            ],
            [
              -70.52,
              41.86
            ],
            [
              -70.54,
              41.82
            ],
            [
              -70.5,
              41.77
            ],
            [
              -70.41,
              41.74
            ],
            [
              -70.29,
              41.73
            ],
            [
              -70.26,
              41.71
            ],
            [
              -70.19,
              41.75
            ],
            [
              -70.12,
              41.76
            ],
            [
              -70.03,
              41.79
            ],
            [
              -70,
              41.81
            ],
            [
              -70.01,
              41.88
            ],
            [
              -70.03,
              41.93
            ],
            [
              -70.08,
              41.9
            ],
            [
              -70.08,
              41.99
            ],
            [
              -70.09,
              42.03
            ],
            [
              -70.15,
              42.06
            ],
            [
              -70.18,
              42.06
            ],
            [
              -70.2,
              42.02
            ],
            [
              -70.24,
              42.07
            ],
            [
              -70.19,
              42.08
            ],
            [
              -70.12,
              42.07
            ],
            [
              -70.03,
              42.02
            ],
            [
              -69.97,
              41.91
            ],
            [
              -69.94,
              41.81
            ],
            [
              -69.93,
              41.69
            ],
            [
              -69.98,
              41.58
            ],
            [
              -69.99,
              41.54
            ],
            [
              -70.01,
              41.55
            ],
            [
              -69.97,
              41.65
            ],
            [
              -70,
              41.67
            ],
            [
              -70.09,
              41.66
            ],
            [
              -70.24,
              41.63
            ],
            [
              -70.35,
              41.64
            ],
            [
              -70.38,
              41.61
            ],
            [
              -70.44,
              41.61
            ],
            [
              -70.49,
              41.55
            ],
            [
              -70.61,
              41.54
            ],
            [
              -70.73,
              41.49
            ],
            [
              -70.79,
              41.45
            ],
            [
              -70.87,
              41.42
            ],
            [
              -70.95,
              41.41
            ],
            [
              -70.93,
              41.43
            ],
            [
              -70.8,
              41.46
            ],
            [
              -70.74,
              41.5
            ],
            [
              -70.66,
              41.54
            ],
            [
              -70.64,
              41.58
            ],
            [
              -70.65,
              41.68
            ],
            [
              -70.63,
              41.71
            ],
            [
              -70.72,
              41.74
            ],
            [
              -70.72,
              41.68
            ],
            [
              -70.74,
              41.7
            ],
            [
              -70.76,
              41.65
            ],
            [
              -70.81,
              41.66
            ],
            [
              -70.8,
              41.63
            ],
            [
              -70.91,
              41.62
            ],
            [
              -70.94,
              41.58
            ],
            [
              -70.93,
              41.54
            ],
            [
              -70.95,
              41.51
            ],
            [
              -71.04,
              41.5
            ],
            [
              -71.08,
              41.51
            ],
            [
              -71.12,
              41.5
            ],
            [
              -71.13,
              41.66
            ],
            [
              -71.2,
              41.68
            ],
            [
              -71.22,
              41.71
            ],
            [
              -71.26,
              41.75
            ],
            [
              -71.33,
              41.78
            ],
            [
              -71.35,
              41.83
            ],
            [
              -71.34,
              41.9
            ],
            [
              -71.38,
              41.89
            ],
            [
              -71.38,
              42.02
            ],
            [
              -71.8,
              42.01
            ],
            [
              -71.8,
              42.02
            ],
            [
              -72.53,
              42.03
            ],
            [
              -72.61,
              42.03
            ],
            [
              -72.76,
              42.04
            ],
            [
              -72.77,
              42
            ],
            [
              -72.82,
              42
            ],
            [
              -72.81,
              42.04
            ],
            [
              -73.01,
              42.04
            ],
            [
              -73.43,
              42.05
            ],
            [
              -73.49,
              42.05
            ],
            [
              -73.51,
              42.09
            ],
            [
              -73.39,
              42.43
            ],
            [
              -73.26,
              42.75
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Minnesota",
      fips: "27"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -97.23,
            49
          ],
          [
            -96.93,
            49
          ],
          [
            -95.98,
            49
          ],
          [
            -95.15,
            49
          ],
          [
            -95.15,
            49.38
          ],
          [
            -95.06,
            49.35
          ],
          [
            -94.96,
            49.37
          ],
          [
            -94.85,
            49.32
          ],
          [
            -94.82,
            49.29
          ],
          [
            -94.77,
            49.12
          ],
          [
            -94.75,
            49.1
          ],
          [
            -94.68,
            48.88
          ],
          [
            -94.71,
            48.82
          ],
          [
            -94.69,
            48.78
          ],
          [
            -94.64,
            48.74
          ],
          [
            -94.54,
            48.7
          ],
          [
            -94.45,
            48.69
          ],
          [
            -94.42,
            48.71
          ],
          [
            -94.26,
            48.7
          ],
          [
            -94.22,
            48.65
          ],
          [
            -94.01,
            48.64
          ],
          [
            -93.83,
            48.63
          ],
          [
            -93.8,
            48.57
          ],
          [
            -93.82,
            48.53
          ],
          [
            -93.79,
            48.52
          ],
          [
            -93.64,
            48.52
          ],
          [
            -93.63,
            48.53
          ],
          [
            -93.55,
            48.53
          ],
          [
            -93.46,
            48.55
          ],
          [
            -93.47,
            48.59
          ],
          [
            -93.35,
            48.63
          ],
          [
            -93.21,
            48.64
          ],
          [
            -93.18,
            48.62
          ],
          [
            -92.99,
            48.62
          ],
          [
            -92.73,
            48.54
          ],
          [
            -92.63,
            48.54
          ],
          [
            -92.63,
            48.5
          ],
          [
            -92.7,
            48.49
          ],
          [
            -92.71,
            48.46
          ],
          [
            -92.66,
            48.44
          ],
          [
            -92.51,
            48.45
          ],
          [
            -92.46,
            48.4
          ],
          [
            -92.48,
            48.37
          ],
          [
            -92.46,
            48.33
          ],
          [
            -92.37,
            48.22
          ],
          [
            -92.28,
            48.24
          ],
          [
            -92.31,
            48.32
          ],
          [
            -92.26,
            48.35
          ],
          [
            -92.21,
            48.35
          ],
          [
            -92.06,
            48.36
          ],
          [
            -92,
            48.32
          ],
          [
            -92.01,
            48.27
          ],
          [
            -91.95,
            48.23
          ],
          [
            -91.9,
            48.24
          ],
          [
            -91.86,
            48.21
          ],
          [
            -91.72,
            48.2
          ],
          [
            -91.7,
            48.14
          ],
          [
            -91.71,
            48.11
          ],
          [
            -91.64,
            48.1
          ],
          [
            -91.56,
            48.11
          ],
          [
            -91.57,
            48.04
          ],
          [
            -91.49,
            48.07
          ],
          [
            -91.44,
            48.05
          ],
          [
            -91.37,
            48.07
          ],
          [
            -91.25,
            48.08
          ],
          [
            -91.08,
            48.18
          ],
          [
            -91.02,
            48.19
          ],
          [
            -90.98,
            48.22
          ],
          [
            -90.89,
            48.25
          ],
          [
            -90.84,
            48.23
          ],
          [
            -90.84,
            48.18
          ],
          [
            -90.78,
            48.16
          ],
          [
            -90.8,
            48.14
          ],
          [
            -90.76,
            48.1
          ],
          [
            -90.7,
            48.1
          ],
          [
            -90.58,
            48.12
          ],
          [
            -90.56,
            48.1
          ],
          [
            -90.47,
            48.11
          ],
          [
            -90.37,
            48.09
          ],
          [
            -90.31,
            48.1
          ],
          [
            -90.13,
            48.11
          ],
          [
            -90.03,
            48.09
          ],
          [
            -90,
            48.03
          ],
          [
            -89.87,
            47.99
          ],
          [
            -89.82,
            48.02
          ],
          [
            -89.75,
            48.02
          ],
          [
            -89.7,
            48.01
          ],
          [
            -89.62,
            48.01
          ],
          [
            -89.58,
            48
          ],
          [
            -89.49,
            48.01
          ],
          [
            -89.59,
            47.97
          ],
          [
            -89.62,
            47.98
          ],
          [
            -89.64,
            47.95
          ],
          [
            -89.7,
            47.94
          ],
          [
            -89.79,
            47.89
          ],
          [
            -89.92,
            47.86
          ],
          [
            -89.97,
            47.83
          ],
          [
            -90.16,
            47.79
          ],
          [
            -90.33,
            47.75
          ],
          [
            -90.39,
            47.74
          ],
          [
            -90.54,
            47.7
          ],
          [
            -90.55,
            47.69
          ],
          [
            -90.74,
            47.62
          ],
          [
            -90.87,
            47.56
          ],
          [
            -91.13,
            47.4
          ],
          [
            -91.19,
            47.34
          ],
          [
            -91.39,
            47.19
          ],
          [
            -91.48,
            47.13
          ],
          [
            -91.57,
            47.09
          ],
          [
            -91.67,
            47.01
          ],
          [
            -91.7,
            47.01
          ],
          [
            -91.81,
            46.93
          ],
          [
            -91.84,
            46.93
          ],
          [
            -92.06,
            46.81
          ],
          [
            -92.09,
            46.79
          ],
          [
            -92.06,
            46.75
          ],
          [
            -92.01,
            46.71
          ],
          [
            -92.09,
            46.75
          ],
          [
            -92.14,
            46.74
          ],
          [
            -92.15,
            46.71
          ],
          [
            -92.21,
            46.7
          ],
          [
            -92.18,
            46.69
          ],
          [
            -92.21,
            46.65
          ],
          [
            -92.29,
            46.66
          ],
          [
            -92.29,
            46.07
          ],
          [
            -92.33,
            46.07
          ],
          [
            -92.35,
            46.02
          ],
          [
            -92.44,
            46.02
          ],
          [
            -92.47,
            45.97
          ],
          [
            -92.52,
            45.98
          ],
          [
            -92.55,
            45.95
          ],
          [
            -92.64,
            45.93
          ],
          [
            -92.71,
            45.89
          ],
          [
            -92.79,
            45.76
          ],
          [
            -92.86,
            45.72
          ],
          [
            -92.89,
            45.62
          ],
          [
            -92.89,
            45.58
          ],
          [
            -92.81,
            45.56
          ],
          [
            -92.77,
            45.57
          ],
          [
            -92.72,
            45.54
          ],
          [
            -92.73,
            45.51
          ],
          [
            -92.65,
            45.44
          ],
          [
            -92.65,
            45.4
          ],
          [
            -92.7,
            45.36
          ],
          [
            -92.7,
            45.33
          ],
          [
            -92.76,
            45.29
          ],
          [
            -92.75,
            45.21
          ],
          [
            -92.77,
            45.19
          ],
          [
            -92.75,
            45.11
          ],
          [
            -92.8,
            45.06
          ],
          [
            -92.76,
            45.03
          ],
          [
            -92.77,
            44.97
          ],
          [
            -92.75,
            44.94
          ],
          [
            -92.77,
            44.9
          ],
          [
            -92.76,
            44.84
          ],
          [
            -92.81,
            44.77
          ],
          [
            -92.79,
            44.74
          ],
          [
            -92.73,
            44.71
          ],
          [
            -92.62,
            44.64
          ],
          [
            -92.62,
            44.62
          ],
          [
            -92.57,
            44.6
          ],
          [
            -92.54,
            44.57
          ],
          [
            -92.36,
            44.56
          ],
          [
            -92.32,
            44.54
          ],
          [
            -92.28,
            44.48
          ],
          [
            -92.23,
            44.45
          ],
          [
            -92.05,
            44.4
          ],
          [
            -91.97,
            44.37
          ],
          [
            -91.92,
            44.33
          ],
          [
            -91.92,
            44.29
          ],
          [
            -91.9,
            44.27
          ],
          [
            -91.88,
            44.2
          ],
          [
            -91.82,
            44.16
          ],
          [
            -91.72,
            44.13
          ],
          [
            -91.71,
            44.1
          ],
          [
            -91.58,
            44.03
          ],
          [
            -91.44,
            44
          ],
          [
            -91.39,
            43.95
          ],
          [
            -91.28,
            43.84
          ],
          [
            -91.25,
            43.77
          ],
          [
            -91.27,
            43.68
          ],
          [
            -91.27,
            43.62
          ],
          [
            -91.23,
            43.58
          ],
          [
            -91.25,
            43.55
          ],
          [
            -91.22,
            43.5
          ],
          [
            -91.95,
            43.5
          ],
          [
            -92.75,
            43.5
          ],
          [
            -93.17,
            43.5
          ],
          [
            -93.97,
            43.5
          ],
          [
            -94.62,
            43.5
          ],
          [
            -95.74,
            43.5
          ],
          [
            -96.45,
            43.5
          ],
          [
            -96.45,
            44.54
          ],
          [
            -96.45,
            44.63
          ],
          [
            -96.45,
            44.89
          ],
          [
            -96.45,
            45.3
          ],
          [
            -96.49,
            45.36
          ],
          [
            -96.62,
            45.41
          ],
          [
            -96.68,
            45.41
          ],
          [
            -96.73,
            45.46
          ],
          [
            -96.77,
            45.52
          ],
          [
            -96.86,
            45.61
          ],
          [
            -96.84,
            45.65
          ],
          [
            -96.75,
            45.7
          ],
          [
            -96.67,
            45.73
          ],
          [
            -96.63,
            45.79
          ],
          [
            -96.58,
            45.83
          ],
          [
            -96.56,
            45.94
          ],
          [
            -96.58,
            46.03
          ],
          [
            -96.56,
            46.06
          ],
          [
            -96.6,
            46.22
          ],
          [
            -96.6,
            46.33
          ],
          [
            -96.65,
            46.35
          ],
          [
            -96.72,
            46.44
          ],
          [
            -96.74,
            46.48
          ],
          [
            -96.75,
            46.58
          ],
          [
            -96.79,
            46.63
          ],
          [
            -96.8,
            46.66
          ],
          [
            -96.78,
            46.72
          ],
          [
            -96.8,
            46.82
          ],
          [
            -96.78,
            46.83
          ],
          [
            -96.76,
            46.93
          ],
          [
            -96.78,
            46.93
          ],
          [
            -96.82,
            46.97
          ],
          [
            -96.82,
            47.12
          ],
          [
            -96.84,
            47.19
          ],
          [
            -96.84,
            47.29
          ],
          [
            -96.83,
            47.34
          ],
          [
            -96.86,
            47.42
          ],
          [
            -96.86,
            47.61
          ],
          [
            -96.87,
            47.61
          ],
          [
            -96.9,
            47.69
          ],
          [
            -96.94,
            47.77
          ],
          [
            -96.97,
            47.78
          ],
          [
            -97.01,
            47.87
          ],
          [
            -97.02,
            47.92
          ],
          [
            -97.06,
            47.95
          ],
          [
            -97.07,
            48.05
          ],
          [
            -97.13,
            48.14
          ],
          [
            -97.14,
            48.23
          ],
          [
            -97.12,
            48.28
          ],
          [
            -97.15,
            48.36
          ],
          [
            -97.14,
            48.4
          ],
          [
            -97.14,
            48.5
          ],
          [
            -97.16,
            48.55
          ],
          [
            -97.14,
            48.61
          ],
          [
            -97.11,
            48.63
          ],
          [
            -97.1,
            48.69
          ],
          [
            -97.15,
            48.75
          ],
          [
            -97.18,
            48.86
          ],
          [
            -97.2,
            48.88
          ],
          [
            -97.24,
            48.97
          ],
          [
            -97.23,
            49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New Jersey",
      fips: "34"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -75.56,
            39.63
          ],
          [
            -75.51,
            39.69
          ],
          [
            -75.48,
            39.71
          ],
          [
            -75.46,
            39.77
          ],
          [
            -75.42,
            39.8
          ],
          [
            -75.36,
            39.84
          ],
          [
            -75.22,
            39.86
          ],
          [
            -75.13,
            39.9
          ],
          [
            -75.13,
            39.96
          ],
          [
            -75.07,
            39.98
          ],
          [
            -75.05,
            40.01
          ],
          [
            -74.93,
            40.07
          ],
          [
            -74.86,
            40.08
          ],
          [
            -74.82,
            40.13
          ],
          [
            -74.78,
            40.12
          ],
          [
            -74.72,
            40.15
          ],
          [
            -74.77,
            40.22
          ],
          [
            -74.84,
            40.25
          ],
          [
            -74.87,
            40.29
          ],
          [
            -74.94,
            40.34
          ],
          [
            -74.97,
            40.4
          ],
          [
            -75.06,
            40.42
          ],
          [
            -75.07,
            40.45
          ],
          [
            -75.06,
            40.54
          ],
          [
            -75.1,
            40.57
          ],
          [
            -75.16,
            40.56
          ],
          [
            -75.19,
            40.58
          ],
          [
            -75.2,
            40.65
          ],
          [
            -75.18,
            40.67
          ],
          [
            -75.2,
            40.69
          ],
          [
            -75.17,
            40.78
          ],
          [
            -75.13,
            40.77
          ],
          [
            -75.05,
            40.87
          ],
          [
            -75.14,
            40.97
          ],
          [
            -75.09,
            41.01
          ],
          [
            -75.03,
            41.04
          ],
          [
            -74.97,
            41.09
          ],
          [
            -74.98,
            41.11
          ],
          [
            -74.92,
            41.14
          ],
          [
            -74.88,
            41.18
          ],
          [
            -74.83,
            41.29
          ],
          [
            -74.75,
            41.35
          ],
          [
            -74.7,
            41.36
          ],
          [
            -74.38,
            41.21
          ],
          [
            -73.91,
            41
          ],
          [
            -73.89,
            40.98
          ],
          [
            -73.97,
            40.82
          ],
          [
            -74.01,
            40.76
          ],
          [
            -74.02,
            40.71
          ],
          [
            -74.05,
            40.69
          ],
          [
            -74.07,
            40.66
          ],
          [
            -74.2,
            40.63
          ],
          [
            -74.22,
            40.56
          ],
          [
            -74.25,
            40.54
          ],
          [
            -74.26,
            40.5
          ],
          [
            -74.26,
            40.47
          ],
          [
            -74.19,
            40.44
          ],
          [
            -74.14,
            40.46
          ],
          [
            -74.05,
            40.42
          ],
          [
            -74,
            40.41
          ],
          [
            -73.98,
            40.45
          ],
          [
            -73.97,
            40.37
          ],
          [
            -73.98,
            40.28
          ],
          [
            -74.03,
            40.12
          ],
          [
            -74.08,
            39.91
          ],
          [
            -74.1,
            39.76
          ],
          [
            -74.24,
            39.56
          ],
          [
            -74.28,
            39.51
          ],
          [
            -74.31,
            39.51
          ],
          [
            -74.3,
            39.48
          ],
          [
            -74.34,
            39.43
          ],
          [
            -74.41,
            39.38
          ],
          [
            -74.41,
            39.36
          ],
          [
            -74.52,
            39.31
          ],
          [
            -74.64,
            39.22
          ],
          [
            -74.71,
            39.12
          ],
          [
            -74.79,
            38.99
          ],
          [
            -74.86,
            38.94
          ],
          [
            -74.93,
            38.93
          ],
          [
            -74.97,
            38.94
          ],
          [
            -74.95,
            39.02
          ],
          [
            -74.9,
            39.1
          ],
          [
            -74.89,
            39.16
          ],
          [
            -74.96,
            39.19
          ],
          [
            -75.03,
            39.19
          ],
          [
            -75.05,
            39.22
          ],
          [
            -75.11,
            39.21
          ],
          [
            -75.14,
            39.18
          ],
          [
            -75.17,
            39.2
          ],
          [
            -75.18,
            39.24
          ],
          [
            -75.24,
            39.27
          ],
          [
            -75.25,
            39.3
          ],
          [
            -75.29,
            39.29
          ],
          [
            -75.34,
            39.35
          ],
          [
            -75.37,
            39.34
          ],
          [
            -75.43,
            39.39
          ],
          [
            -75.47,
            39.44
          ],
          [
            -75.54,
            39.46
          ],
          [
            -75.51,
            39.58
          ],
          [
            -75.56,
            39.61
          ],
          [
            -75.56,
            39.63
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "North Carolina",
      fips: "37"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -75.73,
              35.94
            ],
            [
              -75.66,
              35.92
            ],
            [
              -75.62,
              35.86
            ],
            [
              -75.61,
              35.82
            ],
            [
              -75.67,
              35.82
            ],
            [
              -75.66,
              35.86
            ],
            [
              -75.73,
              35.94
            ]
          ]
        ],
        [
          [
            [
              -76.01,
              35.07
            ],
            [
              -75.98,
              35.12
            ],
            [
              -75.96,
              35.12
            ],
            [
              -75.79,
              35.19
            ],
            [
              -75.73,
              35.2
            ],
            [
              -75.68,
              35.23
            ],
            [
              -75.64,
              35.23
            ],
            [
              -75.58,
              35.26
            ],
            [
              -75.54,
              35.27
            ],
            [
              -75.52,
              35.34
            ],
            [
              -75.48,
              35.55
            ],
            [
              -75.48,
              35.6
            ],
            [
              -75.51,
              35.68
            ],
            [
              -75.53,
              35.77
            ],
            [
              -75.52,
              35.77
            ],
            [
              -75.48,
              35.68
            ],
            [
              -75.46,
              35.6
            ],
            [
              -75.47,
              35.48
            ],
            [
              -75.52,
              35.23
            ],
            [
              -75.61,
              35.23
            ],
            [
              -75.79,
              35.17
            ],
            [
              -75.94,
              35.11
            ],
            [
              -76.01,
              35.07
            ]
          ]
        ],
        [
          [
            [
              -81.68,
              36.59
            ],
            [
              -81.37,
              36.57
            ],
            [
              -81.18,
              36.57
            ],
            [
              -80.84,
              36.56
            ],
            [
              -80.7,
              36.56
            ],
            [
              -80.29,
              36.54
            ],
            [
              -80.12,
              36.54
            ],
            [
              -79.51,
              36.54
            ],
            [
              -78.51,
              36.54
            ],
            [
              -78.25,
              36.54
            ],
            [
              -77.3,
              36.54
            ],
            [
              -76.92,
              36.54
            ],
            [
              -76.92,
              36.55
            ],
            [
              -76.81,
              36.55
            ],
            [
              -76.38,
              36.55
            ],
            [
              -75.87,
              36.55
            ],
            [
              -75.86,
              36.5
            ],
            [
              -75.8,
              36.29
            ],
            [
              -75.74,
              36.15
            ],
            [
              -75.66,
              36.02
            ],
            [
              -75.53,
              35.79
            ],
            [
              -75.56,
              35.8
            ],
            [
              -75.63,
              35.92
            ],
            [
              -75.68,
              35.99
            ],
            [
              -75.73,
              36
            ],
            [
              -75.76,
              36.15
            ],
            [
              -75.82,
              36.29
            ],
            [
              -75.84,
              36.31
            ],
            [
              -75.83,
              36.34
            ],
            [
              -75.85,
              36.42
            ],
            [
              -75.89,
              36.44
            ],
            [
              -75.9,
              36.48
            ],
            [
              -75.99,
              36.49
            ],
            [
              -75.99,
              36.53
            ],
            [
              -76.04,
              36.51
            ],
            [
              -76.02,
              36.46
            ],
            [
              -75.96,
              36.42
            ],
            [
              -75.92,
              36.43
            ],
            [
              -75.92,
              36.37
            ],
            [
              -75.87,
              36.25
            ],
            [
              -75.84,
              36.2
            ],
            [
              -75.84,
              36.18
            ],
            [
              -75.8,
              36.11
            ],
            [
              -75.8,
              36.07
            ],
            [
              -75.87,
              36.13
            ],
            [
              -75.87,
              36.16
            ],
            [
              -75.91,
              36.21
            ],
            [
              -75.92,
              36.24
            ],
            [
              -75.97,
              36.25
            ],
            [
              -75.94,
              36.22
            ],
            [
              -75.96,
              36.2
            ],
            [
              -75.9,
              36.16
            ],
            [
              -76.02,
              36.19
            ],
            [
              -76.13,
              36.29
            ],
            [
              -76.18,
              36.3
            ],
            [
              -76.12,
              36.21
            ],
            [
              -76.08,
              36.2
            ],
            [
              -76.06,
              36.16
            ],
            [
              -76.09,
              36.14
            ],
            [
              -76.18,
              36.12
            ],
            [
              -76.25,
              36.18
            ],
            [
              -76.23,
              36.13
            ],
            [
              -76.19,
              36.11
            ],
            [
              -76.22,
              36.1
            ],
            [
              -76.33,
              36.13
            ],
            [
              -76.38,
              36.14
            ],
            [
              -76.39,
              36.16
            ],
            [
              -76.46,
              36.18
            ],
            [
              -76.38,
              36.12
            ],
            [
              -76.3,
              36.1
            ],
            [
              -76.32,
              36.08
            ],
            [
              -76.41,
              36.08
            ],
            [
              -76.46,
              36.02
            ],
            [
              -76.52,
              36.01
            ],
            [
              -76.58,
              36.01
            ],
            [
              -76.6,
              36.03
            ],
            [
              -76.68,
              36.04
            ],
            [
              -76.72,
              36.15
            ],
            [
              -76.72,
              36.2
            ],
            [
              -76.68,
              36.27
            ],
            [
              -76.69,
              36.28
            ],
            [
              -76.74,
              36.21
            ],
            [
              -76.75,
              36.15
            ],
            [
              -76.72,
              36.07
            ],
            [
              -76.68,
              36
            ],
            [
              -76.7,
              35.96
            ],
            [
              -76.67,
              35.94
            ],
            [
              -76.53,
              35.94
            ],
            [
              -76.4,
              35.98
            ],
            [
              -76.36,
              35.94
            ],
            [
              -76.32,
              35.95
            ],
            [
              -76.27,
              35.97
            ],
            [
              -76.18,
              35.99
            ],
            [
              -76.06,
              35.99
            ],
            [
              -76.01,
              35.96
            ],
            [
              -76.01,
              35.92
            ],
            [
              -76.06,
              35.85
            ],
            [
              -76.05,
              35.81
            ],
            [
              -76.04,
              35.67
            ],
            [
              -76.01,
              35.67
            ],
            [
              -75.99,
              35.77
            ],
            [
              -75.98,
              35.9
            ],
            [
              -75.93,
              35.93
            ],
            [
              -75.95,
              35.96
            ],
            [
              -75.9,
              35.98
            ],
            [
              -75.81,
              35.96
            ],
            [
              -75.75,
              35.88
            ],
            [
              -75.73,
              35.82
            ],
            [
              -75.74,
              35.78
            ],
            [
              -75.71,
              35.69
            ],
            [
              -75.74,
              35.67
            ],
            [
              -75.73,
              35.63
            ],
            [
              -75.78,
              35.58
            ],
            [
              -75.84,
              35.57
            ],
            [
              -75.86,
              35.59
            ],
            [
              -75.89,
              35.57
            ],
            [
              -75.92,
              35.54
            ],
            [
              -75.95,
              35.53
            ],
            [
              -75.96,
              35.49
            ],
            [
              -75.99,
              35.48
            ],
            [
              -76.01,
              35.42
            ],
            [
              -76.06,
              35.41
            ],
            [
              -76.07,
              35.37
            ],
            [
              -76.13,
              35.35
            ],
            [
              -76.14,
              35.33
            ],
            [
              -76.24,
              35.35
            ],
            [
              -76.34,
              35.35
            ],
            [
              -76.43,
              35.36
            ],
            [
              -76.45,
              35.38
            ],
            [
              -76.49,
              35.37
            ],
            [
              -76.54,
              35.41
            ],
            [
              -76.59,
              35.51
            ],
            [
              -76.48,
              35.51
            ],
            [
              -76.46,
              35.55
            ],
            [
              -76.56,
              35.53
            ],
            [
              -76.6,
              35.54
            ],
            [
              -76.63,
              35.51
            ],
            [
              -76.6,
              35.46
            ],
            [
              -76.58,
              35.39
            ],
            [
              -76.6,
              35.39
            ],
            [
              -76.71,
              35.43
            ],
            [
              -76.76,
              35.42
            ],
            [
              -76.83,
              35.45
            ],
            [
              -76.94,
              35.47
            ],
            [
              -77.02,
              35.52
            ],
            [
              -77.03,
              35.49
            ],
            [
              -76.97,
              35.44
            ],
            [
              -76.89,
              35.43
            ],
            [
              -76.67,
              35.35
            ],
            [
              -76.5,
              35.32
            ],
            [
              -76.47,
              35.3
            ],
            [
              -76.47,
              35.26
            ],
            [
              -76.49,
              35.21
            ],
            [
              -76.54,
              35.17
            ],
            [
              -76.54,
              35.14
            ],
            [
              -76.57,
              35.1
            ],
            [
              -76.62,
              35.06
            ],
            [
              -76.8,
              34.96
            ],
            [
              -76.98,
              35.06
            ],
            [
              -76.98,
              35
            ],
            [
              -76.89,
              34.96
            ],
            [
              -76.76,
              34.92
            ],
            [
              -76.63,
              34.99
            ],
            [
              -76.59,
              34.99
            ],
            [
              -76.49,
              35.02
            ],
            [
              -76.48,
              35.07
            ],
            [
              -76.44,
              35.06
            ],
            [
              -76.43,
              35
            ],
            [
              -76.4,
              34.97
            ],
            [
              -76.33,
              34.97
            ],
            [
              -76.36,
              35.03
            ],
            [
              -76.29,
              35.01
            ],
            [
              -76.29,
              34.94
            ],
            [
              -76.35,
              34.87
            ],
            [
              -76.41,
              34.86
            ],
            [
              -76.41,
              34.83
            ],
            [
              -76.45,
              34.82
            ],
            [
              -76.5,
              34.74
            ],
            [
              -76.53,
              34.68
            ],
            [
              -76.59,
              34.7
            ],
            [
              -76.58,
              34.77
            ],
            [
              -76.62,
              34.78
            ],
            [
              -76.62,
              34.71
            ],
            [
              -76.67,
              34.71
            ],
            [
              -76.52,
              34.65
            ],
            [
              -76.44,
              34.76
            ],
            [
              -76.32,
              34.86
            ],
            [
              -76.24,
              34.93
            ],
            [
              -76.07,
              35.08
            ],
            [
              -76.04,
              35.06
            ],
            [
              -76.14,
              34.99
            ],
            [
              -76.23,
              34.91
            ],
            [
              -76.31,
              34.85
            ],
            [
              -76.39,
              34.78
            ],
            [
              -76.45,
              34.71
            ],
            [
              -76.53,
              34.62
            ],
            [
              -76.54,
              34.59
            ],
            [
              -76.55,
              34.65
            ],
            [
              -76.68,
              34.69
            ],
            [
              -76.82,
              34.69
            ],
            [
              -77.03,
              34.66
            ],
            [
              -77.14,
              34.63
            ],
            [
              -77.21,
              34.61
            ],
            [
              -77.32,
              34.54
            ],
            [
              -77.46,
              34.47
            ],
            [
              -77.56,
              34.42
            ],
            [
              -77.69,
              34.32
            ],
            [
              -77.74,
              34.27
            ],
            [
              -77.83,
              34.16
            ],
            [
              -77.88,
              34.07
            ],
            [
              -77.91,
              33.97
            ],
            [
              -77.95,
              33.91
            ],
            [
              -77.96,
              33.85
            ],
            [
              -78.01,
              33.86
            ],
            [
              -78.02,
              33.89
            ],
            [
              -78.09,
              33.91
            ],
            [
              -78.18,
              33.91
            ],
            [
              -78.28,
              33.91
            ],
            [
              -78.39,
              33.9
            ],
            [
              -78.51,
              33.87
            ],
            [
              -78.54,
              33.85
            ],
            [
              -78.87,
              34.13
            ],
            [
              -79.25,
              34.45
            ],
            [
              -79.36,
              34.55
            ],
            [
              -79.67,
              34.8
            ],
            [
              -79.89,
              34.81
            ],
            [
              -80.16,
              34.81
            ],
            [
              -80.8,
              34.82
            ],
            [
              -80.78,
              34.94
            ],
            [
              -80.93,
              35.11
            ],
            [
              -81.04,
              35.04
            ],
            [
              -81.06,
              35.06
            ],
            [
              -81.03,
              35.1
            ],
            [
              -81.04,
              35.15
            ],
            [
              -81.24,
              35.16
            ],
            [
              -81.62,
              35.17
            ],
            [
              -82.29,
              35.2
            ],
            [
              -82.37,
              35.18
            ],
            [
              -82.39,
              35.22
            ],
            [
              -82.43,
              35.17
            ],
            [
              -82.46,
              35.18
            ],
            [
              -82.53,
              35.16
            ],
            [
              -82.55,
              35.16
            ],
            [
              -82.66,
              35.12
            ],
            [
              -82.76,
              35.07
            ],
            [
              -82.78,
              35.09
            ],
            [
              -83.11,
              35
            ],
            [
              -83.62,
              34.99
            ],
            [
              -83.62,
              34.99
            ],
            [
              -84.32,
              34.99
            ],
            [
              -84.29,
              35.22
            ],
            [
              -84.21,
              35.27
            ],
            [
              -84.2,
              35.24
            ],
            [
              -84.1,
              35.25
            ],
            [
              -84.02,
              35.3
            ],
            [
              -84.04,
              35.35
            ],
            [
              -84.01,
              35.37
            ],
            [
              -84.02,
              35.41
            ],
            [
              -83.96,
              35.46
            ],
            [
              -83.91,
              35.48
            ],
            [
              -83.88,
              35.52
            ],
            [
              -83.83,
              35.52
            ],
            [
              -83.77,
              35.56
            ],
            [
              -83.49,
              35.57
            ],
            [
              -83.45,
              35.61
            ],
            [
              -83.37,
              35.64
            ],
            [
              -83.35,
              35.66
            ],
            [
              -83.31,
              35.66
            ],
            [
              -83.26,
              35.7
            ],
            [
              -83.24,
              35.73
            ],
            [
              -83.18,
              35.73
            ],
            [
              -83.16,
              35.76
            ],
            [
              -83.08,
              35.79
            ],
            [
              -82.99,
              35.77
            ],
            [
              -82.9,
              35.87
            ],
            [
              -82.91,
              35.93
            ],
            [
              -82.88,
              35.95
            ],
            [
              -82.82,
              35.92
            ],
            [
              -82.75,
              36.01
            ],
            [
              -82.63,
              36.07
            ],
            [
              -82.6,
              36.03
            ],
            [
              -82.61,
              35.97
            ],
            [
              -82.56,
              35.95
            ],
            [
              -82.46,
              36.01
            ],
            [
              -82.41,
              36.09
            ],
            [
              -82.35,
              36.12
            ],
            [
              -82.29,
              36.14
            ],
            [
              -82.25,
              36.13
            ],
            [
              -82.21,
              36.16
            ],
            [
              -82.15,
              36.15
            ],
            [
              -82.13,
              36.11
            ],
            [
              -82.08,
              36.11
            ],
            [
              -82.03,
              36.13
            ],
            [
              -81.91,
              36.3
            ],
            [
              -81.83,
              36.35
            ],
            [
              -81.79,
              36.36
            ],
            [
              -81.77,
              36.34
            ],
            [
              -81.71,
              36.34
            ],
            [
              -81.74,
              36.4
            ],
            [
              -81.72,
              36.46
            ],
            [
              -81.69,
              36.47
            ],
            [
              -81.71,
              36.54
            ],
            [
              -81.68,
              36.59
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "North Dakota",
      fips: "38"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -104.05,
            49
          ],
          [
            -103.37,
            49
          ],
          [
            -102.22,
            49
          ],
          [
            -101.46,
            49
          ],
          [
            -101.13,
            49
          ],
          [
            -100.43,
            49
          ],
          [
            -99.86,
            49
          ],
          [
            -99.38,
            49
          ],
          [
            -98.87,
            49
          ],
          [
            -97.95,
            49
          ],
          [
            -97.23,
            49
          ],
          [
            -97.24,
            48.97
          ],
          [
            -97.2,
            48.88
          ],
          [
            -97.18,
            48.86
          ],
          [
            -97.15,
            48.75
          ],
          [
            -97.1,
            48.69
          ],
          [
            -97.11,
            48.63
          ],
          [
            -97.14,
            48.61
          ],
          [
            -97.16,
            48.55
          ],
          [
            -97.14,
            48.5
          ],
          [
            -97.14,
            48.4
          ],
          [
            -97.15,
            48.36
          ],
          [
            -97.12,
            48.28
          ],
          [
            -97.14,
            48.23
          ],
          [
            -97.13,
            48.14
          ],
          [
            -97.07,
            48.05
          ],
          [
            -97.06,
            47.95
          ],
          [
            -97.02,
            47.92
          ],
          [
            -97.01,
            47.87
          ],
          [
            -96.97,
            47.78
          ],
          [
            -96.94,
            47.77
          ],
          [
            -96.9,
            47.69
          ],
          [
            -96.87,
            47.61
          ],
          [
            -96.86,
            47.61
          ],
          [
            -96.86,
            47.42
          ],
          [
            -96.83,
            47.34
          ],
          [
            -96.84,
            47.29
          ],
          [
            -96.84,
            47.19
          ],
          [
            -96.82,
            47.12
          ],
          [
            -96.82,
            46.97
          ],
          [
            -96.78,
            46.93
          ],
          [
            -96.76,
            46.93
          ],
          [
            -96.78,
            46.83
          ],
          [
            -96.8,
            46.82
          ],
          [
            -96.78,
            46.72
          ],
          [
            -96.8,
            46.66
          ],
          [
            -96.79,
            46.63
          ],
          [
            -96.75,
            46.58
          ],
          [
            -96.74,
            46.48
          ],
          [
            -96.72,
            46.44
          ],
          [
            -96.65,
            46.35
          ],
          [
            -96.6,
            46.33
          ],
          [
            -96.6,
            46.22
          ],
          [
            -96.56,
            46.06
          ],
          [
            -96.58,
            46.03
          ],
          [
            -96.56,
            45.94
          ],
          [
            -97.32,
            45.93
          ],
          [
            -97.99,
            45.94
          ],
          [
            -98.41,
            45.94
          ],
          [
            -99.32,
            45.94
          ],
          [
            -100.01,
            45.94
          ],
          [
            -100.65,
            45.94
          ],
          [
            -101.56,
            45.94
          ],
          [
            -102,
            45.94
          ],
          [
            -103.05,
            45.95
          ],
          [
            -103.67,
            45.95
          ],
          [
            -104.04,
            45.95
          ],
          [
            -104.04,
            48.37
          ],
          [
            -104.05,
            48.39
          ],
          [
            -104.05,
            49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Oklahoma",
      fips: "40"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -103,
            37
          ],
          [
            -102.78,
            37
          ],
          [
            -102.7,
            37
          ],
          [
            -102.04,
            36.99
          ],
          [
            -101.49,
            37
          ],
          [
            -100.74,
            37
          ],
          [
            -100.2,
            37
          ],
          [
            -99.65,
            37
          ],
          [
            -99.28,
            37
          ],
          [
            -98.35,
            37
          ],
          [
            -97.61,
            37
          ],
          [
            -96.82,
            37
          ],
          [
            -96.22,
            37
          ],
          [
            -95.51,
            37
          ],
          [
            -94.62,
            37
          ],
          [
            -94.62,
            36.5
          ],
          [
            -94.6,
            36.39
          ],
          [
            -94.57,
            36.21
          ],
          [
            -94.55,
            36.1
          ],
          [
            -94.5,
            35.8
          ],
          [
            -94.49,
            35.73
          ],
          [
            -94.43,
            35.39
          ],
          [
            -94.44,
            35.12
          ],
          [
            -94.45,
            34.9
          ],
          [
            -94.45,
            34.69
          ],
          [
            -94.46,
            34.55
          ],
          [
            -94.47,
            34.19
          ],
          [
            -94.49,
            33.64
          ],
          [
            -94.52,
            33.62
          ],
          [
            -94.59,
            33.68
          ],
          [
            -94.64,
            33.67
          ],
          [
            -94.65,
            33.69
          ],
          [
            -94.71,
            33.69
          ],
          [
            -94.77,
            33.75
          ],
          [
            -94.83,
            33.74
          ],
          [
            -94.87,
            33.75
          ],
          [
            -94.95,
            33.81
          ],
          [
            -94.97,
            33.86
          ],
          [
            -95.05,
            33.86
          ],
          [
            -95.13,
            33.94
          ],
          [
            -95.23,
            33.96
          ],
          [
            -95.25,
            33.9
          ],
          [
            -95.29,
            33.88
          ],
          [
            -95.34,
            33.87
          ],
          [
            -95.46,
            33.87
          ],
          [
            -95.46,
            33.89
          ],
          [
            -95.54,
            33.88
          ],
          [
            -95.56,
            33.93
          ],
          [
            -95.6,
            33.93
          ],
          [
            -95.69,
            33.89
          ],
          [
            -95.76,
            33.89
          ],
          [
            -95.75,
            33.85
          ],
          [
            -95.8,
            33.86
          ],
          [
            -95.83,
            33.83
          ],
          [
            -95.94,
            33.89
          ],
          [
            -95.94,
            33.86
          ],
          [
            -96.05,
            33.84
          ],
          [
            -96.1,
            33.85
          ],
          [
            -96.1,
            33.83
          ],
          [
            -96.15,
            33.84
          ],
          [
            -96.18,
            33.76
          ],
          [
            -96.23,
            33.75
          ],
          [
            -96.3,
            33.76
          ],
          [
            -96.32,
            33.69
          ],
          [
            -96.36,
            33.69
          ],
          [
            -96.37,
            33.71
          ],
          [
            -96.43,
            33.78
          ],
          [
            -96.5,
            33.77
          ],
          [
            -96.53,
            33.82
          ],
          [
            -96.57,
            33.82
          ],
          [
            -96.63,
            33.85
          ],
          [
            -96.59,
            33.89
          ],
          [
            -96.68,
            33.91
          ],
          [
            -96.7,
            33.83
          ],
          [
            -96.77,
            33.83
          ],
          [
            -96.78,
            33.86
          ],
          [
            -96.83,
            33.88
          ],
          [
            -96.85,
            33.85
          ],
          [
            -96.88,
            33.87
          ],
          [
            -96.91,
            33.95
          ],
          [
            -96.92,
            33.96
          ],
          [
            -96.97,
            33.94
          ],
          [
            -97,
            33.95
          ],
          [
            -96.98,
            33.89
          ],
          [
            -97.04,
            33.84
          ],
          [
            -97.09,
            33.85
          ],
          [
            -97.05,
            33.82
          ],
          [
            -97.1,
            33.8
          ],
          [
            -97.09,
            33.74
          ],
          [
            -97.12,
            33.72
          ],
          [
            -97.16,
            33.73
          ],
          [
            -97.21,
            33.81
          ],
          [
            -97.17,
            33.84
          ],
          [
            -97.18,
            33.89
          ],
          [
            -97.21,
            33.92
          ],
          [
            -97.25,
            33.9
          ],
          [
            -97.25,
            33.86
          ],
          [
            -97.3,
            33.88
          ],
          [
            -97.33,
            33.87
          ],
          [
            -97.37,
            33.82
          ],
          [
            -97.44,
            33.82
          ],
          [
            -97.46,
            33.85
          ],
          [
            -97.46,
            33.9
          ],
          [
            -97.5,
            33.92
          ],
          [
            -97.56,
            33.9
          ],
          [
            -97.6,
            33.92
          ],
          [
            -97.59,
            33.95
          ],
          [
            -97.66,
            33.99
          ],
          [
            -97.69,
            33.99
          ],
          [
            -97.73,
            33.94
          ],
          [
            -97.84,
            33.86
          ],
          [
            -97.88,
            33.85
          ],
          [
            -97.94,
            33.88
          ],
          [
            -97.97,
            33.88
          ],
          [
            -97.95,
            33.94
          ],
          [
            -97.97,
            33.94
          ],
          [
            -97.95,
            33.99
          ],
          [
            -97.97,
            34.01
          ],
          [
            -98.02,
            33.99
          ],
          [
            -98.09,
            34
          ],
          [
            -98.12,
            34.08
          ],
          [
            -98.09,
            34.11
          ],
          [
            -98.11,
            34.15
          ],
          [
            -98.17,
            34.11
          ],
          [
            -98.24,
            34.13
          ],
          [
            -98.29,
            34.13
          ],
          [
            -98.36,
            34.16
          ],
          [
            -98.4,
            34.12
          ],
          [
            -98.41,
            34.08
          ],
          [
            -98.49,
            34.06
          ],
          [
            -98.57,
            34.14
          ],
          [
            -98.65,
            34.16
          ],
          [
            -98.69,
            34.13
          ],
          [
            -98.77,
            34.14
          ],
          [
            -98.81,
            34.16
          ],
          [
            -98.86,
            34.16
          ],
          [
            -98.92,
            34.18
          ],
          [
            -98.99,
            34.22
          ],
          [
            -99.05,
            34.2
          ],
          [
            -99.08,
            34.21
          ],
          [
            -99.12,
            34.2
          ],
          [
            -99.13,
            34.22
          ],
          [
            -99.19,
            34.22
          ],
          [
            -99.21,
            34.34
          ],
          [
            -99.27,
            34.38
          ],
          [
            -99.26,
            34.4
          ],
          [
            -99.32,
            34.41
          ],
          [
            -99.38,
            34.46
          ],
          [
            -99.4,
            34.38
          ],
          [
            -99.44,
            34.37
          ],
          [
            -99.52,
            34.41
          ],
          [
            -99.58,
            34.42
          ],
          [
            -99.6,
            34.37
          ],
          [
            -99.71,
            34.39
          ],
          [
            -99.8,
            34.45
          ],
          [
            -99.93,
            34.58
          ],
          [
            -100,
            34.56
          ],
          [
            -100,
            36.5
          ],
          [
            -100.44,
            36.5
          ],
          [
            -101.08,
            36.5
          ],
          [
            -101.62,
            36.5
          ],
          [
            -102.25,
            36.5
          ],
          [
            -103,
            36.5
          ],
          [
            -103,
            36.6
          ],
          [
            -103,
            37
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Pennsylvania",
      fips: "42"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -80.52,
            41.98
          ],
          [
            -80.35,
            42.03
          ],
          [
            -80.19,
            42.09
          ],
          [
            -80.15,
            42.11
          ],
          [
            -80.12,
            42.17
          ],
          [
            -80.07,
            42.17
          ],
          [
            -80.06,
            42.14
          ],
          [
            -79.93,
            42.21
          ],
          [
            -79.76,
            42.27
          ],
          [
            -79.76,
            42
          ],
          [
            -79.76,
            42
          ],
          [
            -78.87,
            42
          ],
          [
            -78.6,
            42
          ],
          [
            -78,
            42
          ],
          [
            -77.13,
            42
          ],
          [
            -76.75,
            42
          ],
          [
            -76.35,
            42
          ],
          [
            -75.74,
            42
          ],
          [
            -75.36,
            42
          ],
          [
            -75.31,
            41.95
          ],
          [
            -75.29,
            41.95
          ],
          [
            -75.26,
            41.87
          ],
          [
            -75.21,
            41.87
          ],
          [
            -75.11,
            41.84
          ],
          [
            -75.08,
            41.8
          ],
          [
            -75.1,
            41.77
          ],
          [
            -75.05,
            41.75
          ],
          [
            -75.05,
            41.62
          ],
          [
            -75.08,
            41.61
          ],
          [
            -74.99,
            41.51
          ],
          [
            -74.98,
            41.48
          ],
          [
            -74.94,
            41.48
          ],
          [
            -74.89,
            41.46
          ],
          [
            -74.9,
            41.44
          ],
          [
            -74.81,
            41.44
          ],
          [
            -74.8,
            41.42
          ],
          [
            -74.74,
            41.43
          ],
          [
            -74.74,
            41.4
          ],
          [
            -74.7,
            41.36
          ],
          [
            -74.75,
            41.35
          ],
          [
            -74.83,
            41.29
          ],
          [
            -74.88,
            41.18
          ],
          [
            -74.92,
            41.14
          ],
          [
            -74.98,
            41.11
          ],
          [
            -74.97,
            41.09
          ],
          [
            -75.03,
            41.04
          ],
          [
            -75.09,
            41.01
          ],
          [
            -75.14,
            40.97
          ],
          [
            -75.05,
            40.87
          ],
          [
            -75.13,
            40.77
          ],
          [
            -75.17,
            40.78
          ],
          [
            -75.2,
            40.69
          ],
          [
            -75.18,
            40.67
          ],
          [
            -75.2,
            40.65
          ],
          [
            -75.19,
            40.58
          ],
          [
            -75.16,
            40.56
          ],
          [
            -75.1,
            40.57
          ],
          [
            -75.06,
            40.54
          ],
          [
            -75.07,
            40.45
          ],
          [
            -75.06,
            40.42
          ],
          [
            -74.97,
            40.4
          ],
          [
            -74.94,
            40.34
          ],
          [
            -74.87,
            40.29
          ],
          [
            -74.84,
            40.25
          ],
          [
            -74.77,
            40.22
          ],
          [
            -74.72,
            40.15
          ],
          [
            -74.78,
            40.12
          ],
          [
            -74.82,
            40.13
          ],
          [
            -74.86,
            40.08
          ],
          [
            -74.93,
            40.07
          ],
          [
            -75.05,
            40.01
          ],
          [
            -75.07,
            39.98
          ],
          [
            -75.13,
            39.96
          ],
          [
            -75.13,
            39.9
          ],
          [
            -75.22,
            39.86
          ],
          [
            -75.36,
            39.84
          ],
          [
            -75.42,
            39.8
          ],
          [
            -75.5,
            39.83
          ],
          [
            -75.58,
            39.84
          ],
          [
            -75.66,
            39.82
          ],
          [
            -75.72,
            39.79
          ],
          [
            -75.79,
            39.72
          ],
          [
            -76.57,
            39.72
          ],
          [
            -76.99,
            39.72
          ],
          [
            -77.53,
            39.72
          ],
          [
            -78.38,
            39.72
          ],
          [
            -79.48,
            39.72
          ],
          [
            -80.08,
            39.72
          ],
          [
            -80.52,
            39.72
          ],
          [
            -80.52,
            40.64
          ],
          [
            -80.52,
            41.98
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "South Dakota",
      fips: "46"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -104.06,
            45
          ],
          [
            -104.04,
            45
          ],
          [
            -104.04,
            45.75
          ],
          [
            -104.04,
            45.95
          ],
          [
            -103.67,
            45.95
          ],
          [
            -103.05,
            45.95
          ],
          [
            -102,
            45.94
          ],
          [
            -101.56,
            45.94
          ],
          [
            -100.65,
            45.94
          ],
          [
            -100.01,
            45.94
          ],
          [
            -99.32,
            45.94
          ],
          [
            -98.41,
            45.94
          ],
          [
            -97.99,
            45.94
          ],
          [
            -97.32,
            45.93
          ],
          [
            -96.56,
            45.94
          ],
          [
            -96.58,
            45.83
          ],
          [
            -96.63,
            45.79
          ],
          [
            -96.67,
            45.73
          ],
          [
            -96.75,
            45.7
          ],
          [
            -96.84,
            45.65
          ],
          [
            -96.86,
            45.61
          ],
          [
            -96.77,
            45.52
          ],
          [
            -96.73,
            45.46
          ],
          [
            -96.68,
            45.41
          ],
          [
            -96.62,
            45.41
          ],
          [
            -96.49,
            45.36
          ],
          [
            -96.45,
            45.3
          ],
          [
            -96.45,
            44.89
          ],
          [
            -96.45,
            44.63
          ],
          [
            -96.45,
            44.54
          ],
          [
            -96.45,
            43.5
          ],
          [
            -96.6,
            43.5
          ],
          [
            -96.58,
            43.48
          ],
          [
            -96.6,
            43.45
          ],
          [
            -96.53,
            43.39
          ],
          [
            -96.53,
            43.3
          ],
          [
            -96.58,
            43.3
          ],
          [
            -96.55,
            43.25
          ],
          [
            -96.56,
            43.22
          ],
          [
            -96.48,
            43.22
          ],
          [
            -96.47,
            43.15
          ],
          [
            -96.44,
            43.12
          ],
          [
            -96.46,
            43.06
          ],
          [
            -96.51,
            43.05
          ],
          [
            -96.49,
            43
          ],
          [
            -96.52,
            42.98
          ],
          [
            -96.5,
            42.96
          ],
          [
            -96.54,
            42.92
          ],
          [
            -96.54,
            42.85
          ],
          [
            -96.58,
            42.84
          ],
          [
            -96.59,
            42.79
          ],
          [
            -96.63,
            42.77
          ],
          [
            -96.63,
            42.71
          ],
          [
            -96.58,
            42.68
          ],
          [
            -96.51,
            42.63
          ],
          [
            -96.48,
            42.56
          ],
          [
            -96.49,
            42.52
          ],
          [
            -96.45,
            42.49
          ],
          [
            -96.51,
            42.48
          ],
          [
            -96.53,
            42.51
          ],
          [
            -96.61,
            42.51
          ],
          [
            -96.64,
            42.55
          ],
          [
            -96.71,
            42.61
          ],
          [
            -96.69,
            42.65
          ],
          [
            -96.73,
            42.67
          ],
          [
            -96.8,
            42.67
          ],
          [
            -96.81,
            42.7
          ],
          [
            -96.91,
            42.73
          ],
          [
            -96.95,
            42.72
          ],
          [
            -96.98,
            42.76
          ],
          [
            -97.13,
            42.77
          ],
          [
            -97.15,
            42.8
          ],
          [
            -97.21,
            42.81
          ],
          [
            -97.22,
            42.85
          ],
          [
            -97.31,
            42.87
          ],
          [
            -97.36,
            42.85
          ],
          [
            -97.42,
            42.87
          ],
          [
            -97.44,
            42.85
          ],
          [
            -97.51,
            42.86
          ],
          [
            -97.56,
            42.85
          ],
          [
            -97.62,
            42.86
          ],
          [
            -97.68,
            42.84
          ],
          [
            -97.77,
            42.85
          ],
          [
            -97.85,
            42.87
          ],
          [
            -97.87,
            42.86
          ],
          [
            -97.91,
            42.79
          ],
          [
            -97.95,
            42.77
          ],
          [
            -98.02,
            42.76
          ],
          [
            -98.13,
            42.82
          ],
          [
            -98.26,
            42.87
          ],
          [
            -98.47,
            42.95
          ],
          [
            -98.5,
            43
          ],
          [
            -98.9,
            43
          ],
          [
            -99.57,
            43
          ],
          [
            -100.12,
            43
          ],
          [
            -100.89,
            43
          ],
          [
            -101.63,
            43
          ],
          [
            -101.85,
            43
          ],
          [
            -102.49,
            43
          ],
          [
            -103,
            43
          ],
          [
            -104.05,
            43
          ],
          [
            -104.05,
            43.3
          ],
          [
            -104.06,
            43.3
          ],
          [
            -104.06,
            44.87
          ],
          [
            -104.06,
            45
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Texas",
      fips: "48"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -103,
            36.5
          ],
          [
            -102.25,
            36.5
          ],
          [
            -101.62,
            36.5
          ],
          [
            -101.08,
            36.5
          ],
          [
            -100.44,
            36.5
          ],
          [
            -100,
            36.5
          ],
          [
            -100,
            34.56
          ],
          [
            -99.93,
            34.58
          ],
          [
            -99.8,
            34.45
          ],
          [
            -99.71,
            34.39
          ],
          [
            -99.6,
            34.37
          ],
          [
            -99.58,
            34.42
          ],
          [
            -99.52,
            34.41
          ],
          [
            -99.44,
            34.37
          ],
          [
            -99.4,
            34.38
          ],
          [
            -99.38,
            34.46
          ],
          [
            -99.32,
            34.41
          ],
          [
            -99.26,
            34.4
          ],
          [
            -99.27,
            34.38
          ],
          [
            -99.21,
            34.34
          ],
          [
            -99.19,
            34.22
          ],
          [
            -99.13,
            34.22
          ],
          [
            -99.12,
            34.2
          ],
          [
            -99.08,
            34.21
          ],
          [
            -99.05,
            34.2
          ],
          [
            -98.99,
            34.22
          ],
          [
            -98.92,
            34.18
          ],
          [
            -98.86,
            34.16
          ],
          [
            -98.81,
            34.16
          ],
          [
            -98.77,
            34.14
          ],
          [
            -98.69,
            34.13
          ],
          [
            -98.65,
            34.16
          ],
          [
            -98.57,
            34.14
          ],
          [
            -98.49,
            34.06
          ],
          [
            -98.41,
            34.08
          ],
          [
            -98.4,
            34.12
          ],
          [
            -98.36,
            34.16
          ],
          [
            -98.29,
            34.13
          ],
          [
            -98.24,
            34.13
          ],
          [
            -98.17,
            34.11
          ],
          [
            -98.11,
            34.15
          ],
          [
            -98.09,
            34.11
          ],
          [
            -98.12,
            34.08
          ],
          [
            -98.09,
            34
          ],
          [
            -98.02,
            33.99
          ],
          [
            -97.97,
            34.01
          ],
          [
            -97.95,
            33.99
          ],
          [
            -97.97,
            33.94
          ],
          [
            -97.95,
            33.94
          ],
          [
            -97.97,
            33.88
          ],
          [
            -97.94,
            33.88
          ],
          [
            -97.88,
            33.85
          ],
          [
            -97.84,
            33.86
          ],
          [
            -97.73,
            33.94
          ],
          [
            -97.69,
            33.99
          ],
          [
            -97.66,
            33.99
          ],
          [
            -97.59,
            33.95
          ],
          [
            -97.6,
            33.92
          ],
          [
            -97.56,
            33.9
          ],
          [
            -97.5,
            33.92
          ],
          [
            -97.46,
            33.9
          ],
          [
            -97.46,
            33.85
          ],
          [
            -97.44,
            33.82
          ],
          [
            -97.37,
            33.82
          ],
          [
            -97.33,
            33.87
          ],
          [
            -97.3,
            33.88
          ],
          [
            -97.25,
            33.86
          ],
          [
            -97.25,
            33.9
          ],
          [
            -97.21,
            33.92
          ],
          [
            -97.18,
            33.89
          ],
          [
            -97.17,
            33.84
          ],
          [
            -97.21,
            33.81
          ],
          [
            -97.16,
            33.73
          ],
          [
            -97.12,
            33.72
          ],
          [
            -97.09,
            33.74
          ],
          [
            -97.1,
            33.8
          ],
          [
            -97.05,
            33.82
          ],
          [
            -97.09,
            33.85
          ],
          [
            -97.04,
            33.84
          ],
          [
            -96.98,
            33.89
          ],
          [
            -97,
            33.95
          ],
          [
            -96.97,
            33.94
          ],
          [
            -96.92,
            33.96
          ],
          [
            -96.91,
            33.95
          ],
          [
            -96.88,
            33.87
          ],
          [
            -96.85,
            33.85
          ],
          [
            -96.83,
            33.88
          ],
          [
            -96.78,
            33.86
          ],
          [
            -96.77,
            33.83
          ],
          [
            -96.7,
            33.83
          ],
          [
            -96.68,
            33.91
          ],
          [
            -96.59,
            33.89
          ],
          [
            -96.63,
            33.85
          ],
          [
            -96.57,
            33.82
          ],
          [
            -96.53,
            33.82
          ],
          [
            -96.5,
            33.77
          ],
          [
            -96.43,
            33.78
          ],
          [
            -96.37,
            33.71
          ],
          [
            -96.36,
            33.69
          ],
          [
            -96.32,
            33.69
          ],
          [
            -96.3,
            33.76
          ],
          [
            -96.23,
            33.75
          ],
          [
            -96.18,
            33.76
          ],
          [
            -96.15,
            33.84
          ],
          [
            -96.1,
            33.83
          ],
          [
            -96.1,
            33.85
          ],
          [
            -96.05,
            33.84
          ],
          [
            -95.94,
            33.86
          ],
          [
            -95.94,
            33.89
          ],
          [
            -95.83,
            33.83
          ],
          [
            -95.8,
            33.86
          ],
          [
            -95.75,
            33.85
          ],
          [
            -95.76,
            33.89
          ],
          [
            -95.69,
            33.89
          ],
          [
            -95.6,
            33.93
          ],
          [
            -95.56,
            33.93
          ],
          [
            -95.54,
            33.88
          ],
          [
            -95.46,
            33.89
          ],
          [
            -95.46,
            33.87
          ],
          [
            -95.34,
            33.87
          ],
          [
            -95.29,
            33.88
          ],
          [
            -95.25,
            33.9
          ],
          [
            -95.23,
            33.96
          ],
          [
            -95.13,
            33.94
          ],
          [
            -95.05,
            33.86
          ],
          [
            -94.97,
            33.86
          ],
          [
            -94.95,
            33.81
          ],
          [
            -94.87,
            33.75
          ],
          [
            -94.83,
            33.74
          ],
          [
            -94.77,
            33.75
          ],
          [
            -94.71,
            33.69
          ],
          [
            -94.65,
            33.69
          ],
          [
            -94.64,
            33.67
          ],
          [
            -94.59,
            33.68
          ],
          [
            -94.52,
            33.62
          ],
          [
            -94.49,
            33.64
          ],
          [
            -94.46,
            33.64
          ],
          [
            -94.46,
            33.6
          ],
          [
            -94.42,
            33.58
          ],
          [
            -94.39,
            33.58
          ],
          [
            -94.39,
            33.55
          ],
          [
            -94.36,
            33.54
          ],
          [
            -94.34,
            33.57
          ],
          [
            -94.31,
            33.55
          ],
          [
            -94.3,
            33.58
          ],
          [
            -94.22,
            33.55
          ],
          [
            -94.19,
            33.59
          ],
          [
            -94.14,
            33.58
          ],
          [
            -94.12,
            33.55
          ],
          [
            -94.1,
            33.57
          ],
          [
            -94.05,
            33.55
          ],
          [
            -94.05,
            33.55
          ],
          [
            -94.04,
            33.54
          ],
          [
            -94.04,
            33.02
          ],
          [
            -94.04,
            31.99
          ],
          [
            -94.01,
            31.98
          ],
          [
            -93.97,
            31.92
          ],
          [
            -93.91,
            31.89
          ],
          [
            -93.88,
            31.82
          ],
          [
            -93.82,
            31.77
          ],
          [
            -93.83,
            31.75
          ],
          [
            -93.8,
            31.7
          ],
          [
            -93.83,
            31.66
          ],
          [
            -93.82,
            31.62
          ],
          [
            -93.84,
            31.6
          ],
          [
            -93.82,
            31.55
          ],
          [
            -93.79,
            31.53
          ],
          [
            -93.74,
            31.52
          ],
          [
            -93.73,
            31.49
          ],
          [
            -93.75,
            31.47
          ],
          [
            -93.7,
            31.44
          ],
          [
            -93.7,
            31.41
          ],
          [
            -93.68,
            31.4
          ],
          [
            -93.66,
            31.36
          ],
          [
            -93.69,
            31.31
          ],
          [
            -93.64,
            31.27
          ],
          [
            -93.62,
            31.27
          ],
          [
            -93.6,
            31.17
          ],
          [
            -93.53,
            31.18
          ],
          [
            -93.55,
            31.1
          ],
          [
            -93.52,
            31.07
          ],
          [
            -93.52,
            31.02
          ],
          [
            -93.56,
            31.01
          ],
          [
            -93.57,
            30.98
          ],
          [
            -93.52,
            30.93
          ],
          [
            -93.56,
            30.91
          ],
          [
            -93.57,
            30.88
          ],
          [
            -93.55,
            30.82
          ],
          [
            -93.59,
            30.8
          ],
          [
            -93.62,
            30.74
          ],
          [
            -93.63,
            30.68
          ],
          [
            -93.67,
            30.66
          ],
          [
            -93.68,
            30.6
          ],
          [
            -93.73,
            30.57
          ],
          [
            -93.74,
            30.54
          ],
          [
            -93.71,
            30.52
          ],
          [
            -93.7,
            30.44
          ],
          [
            -93.74,
            30.4
          ],
          [
            -93.77,
            30.33
          ],
          [
            -93.71,
            30.29
          ],
          [
            -93.7,
            30.24
          ],
          [
            -93.72,
            30.21
          ],
          [
            -93.69,
            30.14
          ],
          [
            -93.73,
            30.08
          ],
          [
            -93.7,
            30.07
          ],
          [
            -93.74,
            30.02
          ],
          [
            -93.79,
            29.99
          ],
          [
            -93.82,
            29.92
          ],
          [
            -93.86,
            29.86
          ],
          [
            -93.92,
            29.82
          ],
          [
            -93.93,
            29.8
          ],
          [
            -93.9,
            29.77
          ],
          [
            -93.84,
            29.69
          ],
          [
            -93.84,
            29.68
          ],
          [
            -94,
            29.68
          ],
          [
            -94.13,
            29.65
          ],
          [
            -94.59,
            29.47
          ],
          [
            -94.69,
            29.42
          ],
          [
            -94.73,
            29.37
          ],
          [
            -94.78,
            29.38
          ],
          [
            -94.71,
            29.44
          ],
          [
            -94.67,
            29.48
          ],
          [
            -94.63,
            29.48
          ],
          [
            -94.59,
            29.49
          ],
          [
            -94.57,
            29.53
          ],
          [
            -94.53,
            29.52
          ],
          [
            -94.49,
            29.52
          ],
          [
            -94.55,
            29.57
          ],
          [
            -94.74,
            29.53
          ],
          [
            -94.77,
            29.55
          ],
          [
            -94.71,
            29.63
          ],
          [
            -94.69,
            29.69
          ],
          [
            -94.69,
            29.76
          ],
          [
            -94.74,
            29.76
          ],
          [
            -94.76,
            29.78
          ],
          [
            -94.82,
            29.76
          ],
          [
            -94.85,
            29.72
          ],
          [
            -94.87,
            29.68
          ],
          [
            -94.92,
            29.66
          ],
          [
            -94.94,
            29.7
          ],
          [
            -95.01,
            29.66
          ],
          [
            -95.01,
            29.63
          ],
          [
            -94.98,
            29.6
          ],
          [
            -95.02,
            29.56
          ],
          [
            -94.98,
            29.51
          ],
          [
            -94.91,
            29.5
          ],
          [
            -94.93,
            29.45
          ],
          [
            -94.89,
            29.43
          ],
          [
            -94.89,
            29.37
          ],
          [
            -94.89,
            29.31
          ],
          [
            -94.92,
            29.28
          ],
          [
            -94.95,
            29.29
          ],
          [
            -95.02,
            29.23
          ],
          [
            -95.1,
            29.17
          ],
          [
            -95.11,
            29.2
          ],
          [
            -95.16,
            29.19
          ],
          [
            -95.17,
            29.11
          ],
          [
            -95.14,
            29.09
          ],
          [
            -95.1,
            29.13
          ],
          [
            -95,
            29.18
          ],
          [
            -94.99,
            29.2
          ],
          [
            -94.88,
            29.29
          ],
          [
            -94.82,
            29.31
          ],
          [
            -94.82,
            29.34
          ],
          [
            -94.73,
            29.33
          ],
          [
            -94.8,
            29.28
          ],
          [
            -95.03,
            29.15
          ],
          [
            -95.11,
            29.09
          ],
          [
            -95.13,
            29.07
          ],
          [
            -95.24,
            28.99
          ],
          [
            -95.38,
            28.87
          ],
          [
            -95.44,
            28.86
          ],
          [
            -95.69,
            28.73
          ],
          [
            -95.81,
            28.67
          ],
          [
            -96,
            28.59
          ],
          [
            -96.22,
            28.49
          ],
          [
            -96.34,
            28.42
          ],
          [
            -96.39,
            28.38
          ],
          [
            -96.44,
            28.32
          ],
          [
            -96.63,
            28.22
          ],
          [
            -96.72,
            28.16
          ],
          [
            -96.89,
            28.03
          ],
          [
            -97,
            27.91
          ],
          [
            -97.04,
            27.84
          ],
          [
            -97.09,
            27.79
          ],
          [
            -97.21,
            27.6
          ],
          [
            -97.3,
            27.43
          ],
          [
            -97.34,
            27.32
          ],
          [
            -97.37,
            27.15
          ],
          [
            -97.38,
            27.06
          ],
          [
            -97.38,
            26.97
          ],
          [
            -97.35,
            26.8
          ],
          [
            -97.3,
            26.62
          ],
          [
            -97.25,
            26.5
          ],
          [
            -97.2,
            26.31
          ],
          [
            -97.16,
            26.08
          ],
          [
            -97.18,
            26.12
          ],
          [
            -97.2,
            26.25
          ],
          [
            -97.24,
            26.41
          ],
          [
            -97.28,
            26.54
          ],
          [
            -97.37,
            26.56
          ],
          [
            -97.3,
            26.58
          ],
          [
            -97.34,
            26.65
          ],
          [
            -97.36,
            26.73
          ],
          [
            -97.39,
            26.8
          ],
          [
            -97.4,
            26.89
          ],
          [
            -97.4,
            27.01
          ],
          [
            -97.4,
            27.12
          ],
          [
            -97.36,
            27.35
          ],
          [
            -97.3,
            27.51
          ],
          [
            -97.24,
            27.63
          ],
          [
            -97.19,
            27.69
          ],
          [
            -97.15,
            27.77
          ],
          [
            -97.12,
            27.8
          ],
          [
            -97.13,
            27.84
          ],
          [
            -97.08,
            27.91
          ],
          [
            -97.02,
            27.95
          ],
          [
            -96.98,
            27.98
          ],
          [
            -96.92,
            28.09
          ],
          [
            -96.82,
            28.14
          ],
          [
            -96.79,
            28.19
          ],
          [
            -96.73,
            28.19
          ],
          [
            -96.61,
            28.28
          ],
          [
            -96.53,
            28.32
          ],
          [
            -96.44,
            28.34
          ],
          [
            -96.45,
            28.38
          ],
          [
            -96.42,
            28.4
          ],
          [
            -96.45,
            28.42
          ],
          [
            -96.51,
            28.38
          ],
          [
            -96.58,
            28.35
          ],
          [
            -96.62,
            28.32
          ],
          [
            -96.68,
            28.31
          ],
          [
            -96.7,
            28.35
          ],
          [
            -96.7,
            28.4
          ],
          [
            -96.77,
            28.41
          ],
          [
            -96.79,
            28.38
          ],
          [
            -96.79,
            28.31
          ],
          [
            -96.81,
            28.29
          ],
          [
            -96.79,
            28.26
          ],
          [
            -96.8,
            28.22
          ],
          [
            -96.87,
            28.18
          ],
          [
            -96.93,
            28.12
          ],
          [
            -96.96,
            28.12
          ],
          [
            -97.03,
            28.15
          ],
          [
            -97.04,
            28.19
          ],
          [
            -97.15,
            28.13
          ],
          [
            -97.21,
            28.08
          ],
          [
            -97.14,
            28.06
          ],
          [
            -97.05,
            28.11
          ],
          [
            -97.02,
            28.04
          ],
          [
            -97.05,
            28.02
          ],
          [
            -97.19,
            27.83
          ],
          [
            -97.23,
            27.83
          ],
          [
            -97.25,
            27.88
          ],
          [
            -97.33,
            27.87
          ],
          [
            -97.34,
            27.88
          ],
          [
            -97.46,
            27.87
          ],
          [
            -97.49,
            27.88
          ],
          [
            -97.52,
            27.85
          ],
          [
            -97.47,
            27.82
          ],
          [
            -97.42,
            27.82
          ],
          [
            -97.38,
            27.84
          ],
          [
            -97.39,
            27.78
          ],
          [
            -97.37,
            27.74
          ],
          [
            -97.32,
            27.71
          ],
          [
            -97.25,
            27.7
          ],
          [
            -97.32,
            27.57
          ],
          [
            -97.37,
            27.41
          ],
          [
            -97.41,
            27.32
          ],
          [
            -97.48,
            27.3
          ],
          [
            -97.51,
            27.28
          ],
          [
            -97.55,
            27.29
          ],
          [
            -97.5,
            27.31
          ],
          [
            -97.49,
            27.36
          ],
          [
            -97.52,
            27.36
          ],
          [
            -97.54,
            27.34
          ],
          [
            -97.64,
            27.27
          ],
          [
            -97.63,
            27.24
          ],
          [
            -97.54,
            27.23
          ],
          [
            -97.45,
            27.26
          ],
          [
            -97.42,
            27.26
          ],
          [
            -97.44,
            27.16
          ],
          [
            -97.43,
            27.16
          ],
          [
            -97.44,
            26.99
          ],
          [
            -97.47,
            26.81
          ],
          [
            -97.48,
            26.81
          ],
          [
            -97.44,
            26.61
          ],
          [
            -97.42,
            26.55
          ],
          [
            -97.41,
            26.48
          ],
          [
            -97.38,
            26.48
          ],
          [
            -97.3,
            26.3
          ],
          [
            -97.28,
            26.27
          ],
          [
            -97.31,
            26.23
          ],
          [
            -97.3,
            26.2
          ],
          [
            -97.3,
            26.15
          ],
          [
            -97.27,
            26.09
          ],
          [
            -97.2,
            26.08
          ],
          [
            -97.2,
            26.05
          ],
          [
            -97.15,
            26.06
          ],
          [
            -97.15,
            25.95
          ],
          [
            -97.23,
            25.96
          ],
          [
            -97.28,
            25.95
          ],
          [
            -97.28,
            25.94
          ],
          [
            -97.35,
            25.93
          ],
          [
            -97.37,
            25.84
          ],
          [
            -97.44,
            25.85
          ],
          [
            -97.47,
            25.88
          ],
          [
            -97.52,
            25.89
          ],
          [
            -97.54,
            25.93
          ],
          [
            -97.58,
            25.94
          ],
          [
            -97.65,
            26.02
          ],
          [
            -97.76,
            26.03
          ],
          [
            -97.8,
            26.06
          ],
          [
            -97.86,
            26.05
          ],
          [
            -97.89,
            26.07
          ],
          [
            -97.97,
            26.05
          ],
          [
            -97.98,
            26.07
          ],
          [
            -98.03,
            26.07
          ],
          [
            -98.04,
            26.04
          ],
          [
            -98.08,
            26.07
          ],
          [
            -98.15,
            26.06
          ],
          [
            -98.18,
            26.07
          ],
          [
            -98.2,
            26.06
          ],
          [
            -98.25,
            26.07
          ],
          [
            -98.28,
            26.1
          ],
          [
            -98.27,
            26.12
          ],
          [
            -98.32,
            26.12
          ],
          [
            -98.33,
            26.16
          ],
          [
            -98.39,
            26.16
          ],
          [
            -98.46,
            26.22
          ],
          [
            -98.5,
            26.21
          ],
          [
            -98.59,
            26.25
          ],
          [
            -98.65,
            26.24
          ],
          [
            -98.7,
            26.27
          ],
          [
            -98.75,
            26.32
          ],
          [
            -98.79,
            26.33
          ],
          [
            -98.8,
            26.36
          ],
          [
            -98.83,
            26.37
          ],
          [
            -98.89,
            26.36
          ],
          [
            -98.97,
            26.4
          ],
          [
            -99.01,
            26.4
          ],
          [
            -99.04,
            26.41
          ],
          [
            -99.08,
            26.4
          ],
          [
            -99.11,
            26.43
          ],
          [
            -99.09,
            26.48
          ],
          [
            -99.13,
            26.53
          ],
          [
            -99.17,
            26.54
          ],
          [
            -99.18,
            26.62
          ],
          [
            -99.2,
            26.66
          ],
          [
            -99.21,
            26.72
          ],
          [
            -99.24,
            26.75
          ],
          [
            -99.24,
            26.79
          ],
          [
            -99.27,
            26.84
          ],
          [
            -99.33,
            26.88
          ],
          [
            -99.32,
            26.91
          ],
          [
            -99.37,
            26.93
          ],
          [
            -99.39,
            26.96
          ],
          [
            -99.38,
            26.98
          ],
          [
            -99.41,
            27.02
          ],
          [
            -99.45,
            27.02
          ],
          [
            -99.45,
            27.07
          ],
          [
            -99.43,
            27.09
          ],
          [
            -99.44,
            27.15
          ],
          [
            -99.43,
            27.18
          ],
          [
            -99.44,
            27.25
          ],
          [
            -99.5,
            27.27
          ],
          [
            -99.49,
            27.3
          ],
          [
            -99.54,
            27.31
          ],
          [
            -99.5,
            27.34
          ],
          [
            -99.49,
            27.41
          ],
          [
            -99.5,
            27.44
          ],
          [
            -99.48,
            27.49
          ],
          [
            -99.53,
            27.5
          ],
          [
            -99.51,
            27.56
          ],
          [
            -99.55,
            27.61
          ],
          [
            -99.58,
            27.6
          ],
          [
            -99.6,
            27.64
          ],
          [
            -99.64,
            27.63
          ],
          [
            -99.67,
            27.66
          ],
          [
            -99.71,
            27.65
          ],
          [
            -99.77,
            27.73
          ],
          [
            -99.8,
            27.74
          ],
          [
            -99.81,
            27.77
          ],
          [
            -99.84,
            27.77
          ],
          [
            -99.88,
            27.8
          ],
          [
            -99.88,
            27.84
          ],
          [
            -99.9,
            27.86
          ],
          [
            -99.89,
            27.9
          ],
          [
            -99.94,
            27.94
          ],
          [
            -99.93,
            27.98
          ],
          [
            -99.99,
            27.99
          ],
          [
            -100.02,
            28.06
          ],
          [
            -100.05,
            28.08
          ],
          [
            -100.08,
            28.14
          ],
          [
            -100.21,
            28.19
          ],
          [
            -100.22,
            28.24
          ],
          [
            -100.25,
            28.23
          ],
          [
            -100.29,
            28.28
          ],
          [
            -100.29,
            28.32
          ],
          [
            -100.35,
            28.4
          ],
          [
            -100.34,
            28.44
          ],
          [
            -100.37,
            28.48
          ],
          [
            -100.34,
            28.5
          ],
          [
            -100.38,
            28.51
          ],
          [
            -100.41,
            28.55
          ],
          [
            -100.4,
            28.59
          ],
          [
            -100.45,
            28.61
          ],
          [
            -100.44,
            28.64
          ],
          [
            -100.5,
            28.66
          ],
          [
            -100.51,
            28.71
          ],
          [
            -100.51,
            28.74
          ],
          [
            -100.53,
            28.76
          ],
          [
            -100.55,
            28.83
          ],
          [
            -100.57,
            28.83
          ],
          [
            -100.6,
            28.9
          ],
          [
            -100.63,
            28.9
          ],
          [
            -100.65,
            28.94
          ],
          [
            -100.65,
            29.01
          ],
          [
            -100.67,
            29.1
          ],
          [
            -100.74,
            29.14
          ],
          [
            -100.78,
            29.17
          ],
          [
            -100.76,
            29.19
          ],
          [
            -100.8,
            29.25
          ],
          [
            -100.88,
            29.28
          ],
          [
            -100.89,
            29.31
          ],
          [
            -100.95,
            29.35
          ],
          [
            -101.01,
            29.37
          ],
          [
            -101.06,
            29.44
          ],
          [
            -101.06,
            29.46
          ],
          [
            -101.15,
            29.48
          ],
          [
            -101.17,
            29.51
          ],
          [
            -101.26,
            29.52
          ],
          [
            -101.25,
            29.57
          ],
          [
            -101.25,
            29.63
          ],
          [
            -101.27,
            29.63
          ],
          [
            -101.29,
            29.57
          ],
          [
            -101.31,
            29.6
          ],
          [
            -101.31,
            29.64
          ],
          [
            -101.37,
            29.66
          ],
          [
            -101.41,
            29.76
          ],
          [
            -101.44,
            29.75
          ],
          [
            -101.48,
            29.78
          ],
          [
            -101.52,
            29.76
          ],
          [
            -101.55,
            29.8
          ],
          [
            -101.58,
            29.77
          ],
          [
            -101.71,
            29.76
          ],
          [
            -101.78,
            29.79
          ],
          [
            -101.8,
            29.78
          ],
          [
            -101.85,
            29.8
          ],
          [
            -101.93,
            29.79
          ],
          [
            -101.97,
            29.81
          ],
          [
            -102.03,
            29.8
          ],
          [
            -102.05,
            29.79
          ],
          [
            -102.14,
            29.8
          ],
          [
            -102.18,
            29.85
          ],
          [
            -102.23,
            29.84
          ],
          [
            -102.3,
            29.88
          ],
          [
            -102.35,
            29.86
          ],
          [
            -102.39,
            29.77
          ],
          [
            -102.51,
            29.78
          ],
          [
            -102.54,
            29.75
          ],
          [
            -102.57,
            29.76
          ],
          [
            -102.65,
            29.73
          ],
          [
            -102.67,
            29.74
          ],
          [
            -102.7,
            29.7
          ],
          [
            -102.69,
            29.68
          ],
          [
            -102.74,
            29.64
          ],
          [
            -102.74,
            29.6
          ],
          [
            -102.76,
            29.6
          ],
          [
            -102.77,
            29.55
          ],
          [
            -102.81,
            29.52
          ],
          [
            -102.81,
            29.49
          ],
          [
            -102.83,
            29.44
          ],
          [
            -102.82,
            29.4
          ],
          [
            -102.84,
            29.36
          ],
          [
            -102.88,
            29.35
          ],
          [
            -102.89,
            29.29
          ],
          [
            -102.91,
            29.26
          ],
          [
            -102.87,
            29.24
          ],
          [
            -102.89,
            29.21
          ],
          [
            -102.95,
            29.18
          ],
          [
            -102.99,
            29.18
          ],
          [
            -103.01,
            29.13
          ],
          [
            -103.08,
            29.09
          ],
          [
            -103.1,
            29.06
          ],
          [
            -103.12,
            28.99
          ],
          [
            -103.17,
            28.98
          ],
          [
            -103.23,
            28.99
          ],
          [
            -103.28,
            28.98
          ],
          [
            -103.33,
            29.02
          ],
          [
            -103.43,
            29.04
          ],
          [
            -103.52,
            29.14
          ],
          [
            -103.61,
            29.17
          ],
          [
            -103.65,
            29.16
          ],
          [
            -103.73,
            29.19
          ],
          [
            -103.79,
            29.26
          ],
          [
            -103.84,
            29.28
          ],
          [
            -103.98,
            29.3
          ],
          [
            -104.04,
            29.32
          ],
          [
            -104.11,
            29.37
          ],
          [
            -104.15,
            29.38
          ],
          [
            -104.21,
            29.45
          ],
          [
            -104.21,
            29.47
          ],
          [
            -104.26,
            29.51
          ],
          [
            -104.34,
            29.52
          ],
          [
            -104.38,
            29.54
          ],
          [
            -104.4,
            29.57
          ],
          [
            -104.51,
            29.64
          ],
          [
            -104.54,
            29.68
          ],
          [
            -104.57,
            29.77
          ],
          [
            -104.61,
            29.82
          ],
          [
            -104.63,
            29.87
          ],
          [
            -104.68,
            29.92
          ],
          [
            -104.68,
            29.98
          ],
          [
            -104.71,
            30.02
          ],
          [
            -104.68,
            30.09
          ],
          [
            -104.69,
            30.13
          ],
          [
            -104.69,
            30.18
          ],
          [
            -104.71,
            30.24
          ],
          [
            -104.75,
            30.26
          ],
          [
            -104.76,
            30.3
          ],
          [
            -104.81,
            30.34
          ],
          [
            -104.81,
            30.36
          ],
          [
            -104.86,
            30.39
          ],
          [
            -104.85,
            30.42
          ],
          [
            -104.9,
            30.57
          ],
          [
            -104.92,
            30.6
          ],
          [
            -104.97,
            30.61
          ],
          [
            -105.01,
            30.69
          ],
          [
            -105.06,
            30.69
          ],
          [
            -105.11,
            30.74
          ],
          [
            -105.15,
            30.75
          ],
          [
            -105.16,
            30.77
          ],
          [
            -105.22,
            30.8
          ],
          [
            -105.26,
            30.8
          ],
          [
            -105.29,
            30.82
          ],
          [
            -105.4,
            30.86
          ],
          [
            -105.4,
            30.89
          ],
          [
            -105.56,
            30.99
          ],
          [
            -105.6,
            31.08
          ],
          [
            -105.65,
            31.11
          ],
          [
            -105.71,
            31.14
          ],
          [
            -105.74,
            31.16
          ],
          [
            -105.77,
            31.17
          ],
          [
            -105.78,
            31.2
          ],
          [
            -105.87,
            31.29
          ],
          [
            -105.94,
            31.32
          ],
          [
            -105.95,
            31.37
          ],
          [
            -106,
            31.39
          ],
          [
            -106.08,
            31.4
          ],
          [
            -106.21,
            31.47
          ],
          [
            -106.25,
            31.54
          ],
          [
            -106.28,
            31.56
          ],
          [
            -106.3,
            31.62
          ],
          [
            -106.35,
            31.7
          ],
          [
            -106.38,
            31.73
          ],
          [
            -106.45,
            31.76
          ],
          [
            -106.49,
            31.75
          ],
          [
            -106.53,
            31.78
          ],
          [
            -106.55,
            31.81
          ],
          [
            -106.6,
            31.82
          ],
          [
            -106.6,
            31.84
          ],
          [
            -106.64,
            31.87
          ],
          [
            -106.65,
            31.9
          ],
          [
            -106.62,
            31.91
          ],
          [
            -106.62,
            32
          ],
          [
            -105.43,
            32
          ],
          [
            -104.53,
            32
          ],
          [
            -103.72,
            32
          ],
          [
            -103.07,
            32
          ],
          [
            -103.07,
            33.04
          ],
          [
            -103.06,
            33.26
          ],
          [
            -103.06,
            33.39
          ],
          [
            -103.05,
            33.75
          ],
          [
            -103.04,
            33.95
          ],
          [
            -103.04,
            35.25
          ],
          [
            -103.04,
            35.62
          ],
          [
            -103.04,
            36.32
          ],
          [
            -103.04,
            36.5
          ],
          [
            -103,
            36.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Wyoming",
      fips: "56"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -104.06,
            45
          ],
          [
            -104.06,
            44.87
          ],
          [
            -104.06,
            43.3
          ],
          [
            -104.05,
            43.3
          ],
          [
            -104.05,
            43
          ],
          [
            -104.05,
            41
          ],
          [
            -104.83,
            41
          ],
          [
            -104.86,
            41
          ],
          [
            -105.72,
            41
          ],
          [
            -106.22,
            41
          ],
          [
            -106.45,
            41
          ],
          [
            -107.63,
            41
          ],
          [
            -108.18,
            41
          ],
          [
            -109.05,
            41
          ],
          [
            -109.54,
            41
          ],
          [
            -110.05,
            41
          ],
          [
            -110.24,
            41
          ],
          [
            -110.71,
            41
          ],
          [
            -111.05,
            41
          ],
          [
            -111.05,
            41.38
          ],
          [
            -111.04,
            41.57
          ],
          [
            -111.05,
            42
          ],
          [
            -111.05,
            42.58
          ],
          [
            -111.04,
            42.72
          ],
          [
            -111.04,
            43.66
          ],
          [
            -111.05,
            43.68
          ],
          [
            -111.05,
            44.12
          ],
          [
            -111.05,
            44.35
          ],
          [
            -111.05,
            44.47
          ],
          [
            -111.05,
            44.62
          ],
          [
            -111.06,
            44.87
          ],
          [
            -111.05,
            45
          ],
          [
            -110.79,
            45
          ],
          [
            -110.71,
            44.99
          ],
          [
            -110.4,
            44.99
          ],
          [
            -110.36,
            45
          ],
          [
            -110.2,
            45
          ],
          [
            -110.11,
            45
          ],
          [
            -109.8,
            45
          ],
          [
            -109.1,
            45.01
          ],
          [
            -109.06,
            45
          ],
          [
            -108.27,
            45
          ],
          [
            -107.14,
            45
          ],
          [
            -107.09,
            45
          ],
          [
            -106.57,
            44.99
          ],
          [
            -105.93,
            44.99
          ],
          [
            -105.85,
            45
          ],
          [
            -105.37,
            45
          ],
          [
            -104.47,
            45
          ],
          [
            -104.06,
            45
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Connecticut",
      fips: "09"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -73.49,
            42.05
          ],
          [
            -73.43,
            42.05
          ],
          [
            -73.01,
            42.04
          ],
          [
            -72.81,
            42.04
          ],
          [
            -72.82,
            42
          ],
          [
            -72.77,
            42
          ],
          [
            -72.76,
            42.04
          ],
          [
            -72.61,
            42.03
          ],
          [
            -72.53,
            42.03
          ],
          [
            -71.8,
            42.02
          ],
          [
            -71.8,
            42.01
          ],
          [
            -71.8,
            41.92
          ],
          [
            -71.79,
            41.73
          ],
          [
            -71.79,
            41.6
          ],
          [
            -71.8,
            41.42
          ],
          [
            -71.84,
            41.41
          ],
          [
            -71.83,
            41.34
          ],
          [
            -71.86,
            41.32
          ],
          [
            -71.88,
            41.34
          ],
          [
            -71.95,
            41.34
          ],
          [
            -72.02,
            41.32
          ],
          [
            -72.09,
            41.32
          ],
          [
            -72.13,
            41.3
          ],
          [
            -72.19,
            41.32
          ],
          [
            -72.21,
            41.29
          ],
          [
            -72.39,
            41.26
          ],
          [
            -72.4,
            41.28
          ],
          [
            -72.45,
            41.28
          ],
          [
            -72.55,
            41.25
          ],
          [
            -72.57,
            41.27
          ],
          [
            -72.66,
            41.27
          ],
          [
            -72.69,
            41.25
          ],
          [
            -72.75,
            41.27
          ],
          [
            -72.9,
            41.24
          ],
          [
            -72.91,
            41.29
          ],
          [
            -72.94,
            41.28
          ],
          [
            -73.01,
            41.21
          ],
          [
            -73.05,
            41.21
          ],
          [
            -73.13,
            41.15
          ],
          [
            -73.18,
            41.17
          ],
          [
            -73.26,
            41.12
          ],
          [
            -73.29,
            41.13
          ],
          [
            -73.37,
            41.1
          ],
          [
            -73.35,
            41.09
          ],
          [
            -73.39,
            41.06
          ],
          [
            -73.49,
            41.05
          ],
          [
            -73.57,
            41
          ],
          [
            -73.6,
            41.01
          ],
          [
            -73.66,
            40.98
          ],
          [
            -73.65,
            41.01
          ],
          [
            -73.73,
            41.1
          ],
          [
            -73.48,
            41.21
          ],
          [
            -73.55,
            41.3
          ],
          [
            -73.54,
            41.43
          ],
          [
            -73.52,
            41.69
          ],
          [
            -73.49,
            42.05
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Missouri",
      fips: "29"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -95.76,
            40.59
          ],
          [
            -95.17,
            40.58
          ],
          [
            -94.59,
            40.57
          ],
          [
            -94.03,
            40.57
          ],
          [
            -93.57,
            40.58
          ],
          [
            -93.35,
            40.58
          ],
          [
            -92.64,
            40.59
          ],
          [
            -92.09,
            40.6
          ],
          [
            -91.73,
            40.61
          ],
          [
            -91.69,
            40.58
          ],
          [
            -91.68,
            40.55
          ],
          [
            -91.62,
            40.54
          ],
          [
            -91.62,
            40.51
          ],
          [
            -91.56,
            40.46
          ],
          [
            -91.53,
            40.46
          ],
          [
            -91.53,
            40.41
          ],
          [
            -91.49,
            40.38
          ],
          [
            -91.42,
            40.38
          ],
          [
            -91.45,
            40.36
          ],
          [
            -91.51,
            40.24
          ],
          [
            -91.51,
            40.18
          ],
          [
            -91.49,
            40.04
          ],
          [
            -91.44,
            39.95
          ],
          [
            -91.42,
            39.93
          ],
          [
            -91.45,
            39.87
          ],
          [
            -91.43,
            39.84
          ],
          [
            -91.37,
            39.81
          ],
          [
            -91.36,
            39.78
          ],
          [
            -91.37,
            39.73
          ],
          [
            -91.28,
            39.67
          ],
          [
            -91.22,
            39.62
          ],
          [
            -91.18,
            39.61
          ],
          [
            -91.15,
            39.55
          ],
          [
            -91.1,
            39.54
          ],
          [
            -91.06,
            39.47
          ],
          [
            -91.01,
            39.43
          ],
          [
            -90.79,
            39.31
          ],
          [
            -90.72,
            39.23
          ],
          [
            -90.71,
            39.16
          ],
          [
            -90.68,
            39.09
          ],
          [
            -90.71,
            39.06
          ],
          [
            -90.67,
            38.98
          ],
          [
            -90.66,
            38.93
          ],
          [
            -90.59,
            38.87
          ],
          [
            -90.55,
            38.87
          ],
          [
            -90.51,
            38.9
          ],
          [
            -90.47,
            38.96
          ],
          [
            -90.41,
            38.96
          ],
          [
            -90.31,
            38.92
          ],
          [
            -90.25,
            38.92
          ],
          [
            -90.11,
            38.85
          ],
          [
            -90.12,
            38.8
          ],
          [
            -90.17,
            38.77
          ],
          [
            -90.21,
            38.72
          ],
          [
            -90.18,
            38.64
          ],
          [
            -90.18,
            38.61
          ],
          [
            -90.26,
            38.53
          ],
          [
            -90.28,
            38.44
          ],
          [
            -90.34,
            38.39
          ],
          [
            -90.37,
            38.34
          ],
          [
            -90.37,
            38.27
          ],
          [
            -90.36,
            38.21
          ],
          [
            -90.29,
            38.17
          ],
          [
            -90.22,
            38.09
          ],
          [
            -90.13,
            38.06
          ],
          [
            -90.09,
            38.02
          ],
          [
            -90.06,
            38.02
          ],
          [
            -90,
            37.96
          ],
          [
            -89.94,
            37.97
          ],
          [
            -89.93,
            37.95
          ],
          [
            -89.97,
            37.93
          ],
          [
            -89.95,
            37.88
          ],
          [
            -89.88,
            37.88
          ],
          [
            -89.85,
            37.91
          ],
          [
            -89.8,
            37.88
          ],
          [
            -89.8,
            37.86
          ],
          [
            -89.74,
            37.85
          ],
          [
            -89.66,
            37.79
          ],
          [
            -89.67,
            37.75
          ],
          [
            -89.62,
            37.75
          ],
          [
            -89.58,
            37.71
          ],
          [
            -89.52,
            37.69
          ],
          [
            -89.52,
            37.64
          ],
          [
            -89.48,
            37.59
          ],
          [
            -89.52,
            37.58
          ],
          [
            -89.52,
            37.54
          ],
          [
            -89.42,
            37.4
          ],
          [
            -89.44,
            37.34
          ],
          [
            -89.49,
            37.33
          ],
          [
            -89.52,
            37.29
          ],
          [
            -89.46,
            37.24
          ],
          [
            -89.46,
            37.2
          ],
          [
            -89.41,
            37.13
          ],
          [
            -89.38,
            37.09
          ],
          [
            -89.38,
            37.04
          ],
          [
            -89.29,
            36.99
          ],
          [
            -89.26,
            37.02
          ],
          [
            -89.31,
            37.05
          ],
          [
            -89.26,
            37.06
          ],
          [
            -89.2,
            37.02
          ],
          [
            -89.17,
            36.97
          ],
          [
            -89.13,
            36.98
          ],
          [
            -89.1,
            36.96
          ],
          [
            -89.12,
            36.89
          ],
          [
            -89.14,
            36.85
          ],
          [
            -89.17,
            36.84
          ],
          [
            -89.18,
            36.81
          ],
          [
            -89.12,
            36.78
          ],
          [
            -89.13,
            36.75
          ],
          [
            -89.19,
            36.75
          ],
          [
            -89.2,
            36.72
          ],
          [
            -89.16,
            36.67
          ],
          [
            -89.19,
            36.64
          ],
          [
            -89.21,
            36.58
          ],
          [
            -89.26,
            36.56
          ],
          [
            -89.33,
            36.63
          ],
          [
            -89.37,
            36.62
          ],
          [
            -89.42,
            36.5
          ],
          [
            -89.45,
            36.46
          ],
          [
            -89.49,
            36.47
          ],
          [
            -89.49,
            36.5
          ],
          [
            -89.47,
            36.53
          ],
          [
            -89.48,
            36.57
          ],
          [
            -89.56,
            36.57
          ],
          [
            -89.57,
            36.55
          ],
          [
            -89.54,
            36.5
          ],
          [
            -89.52,
            36.48
          ],
          [
            -89.54,
            36.42
          ],
          [
            -89.51,
            36.37
          ],
          [
            -89.53,
            36.34
          ],
          [
            -89.61,
            36.34
          ],
          [
            -89.61,
            36.31
          ],
          [
            -89.54,
            36.28
          ],
          [
            -89.53,
            36.25
          ],
          [
            -89.59,
            36.24
          ],
          [
            -89.69,
            36.25
          ],
          [
            -89.71,
            36.24
          ],
          [
            -89.61,
            36.17
          ],
          [
            -89.6,
            36.12
          ],
          [
            -89.68,
            36.08
          ],
          [
            -89.69,
            36.02
          ],
          [
            -89.73,
            36
          ],
          [
            -90.38,
            36
          ],
          [
            -90.32,
            36.09
          ],
          [
            -90.24,
            36.14
          ],
          [
            -90.24,
            36.16
          ],
          [
            -90.18,
            36.2
          ],
          [
            -90.13,
            36.23
          ],
          [
            -90.11,
            36.27
          ],
          [
            -90.08,
            36.27
          ],
          [
            -90.06,
            36.39
          ],
          [
            -90.14,
            36.42
          ],
          [
            -90.13,
            36.44
          ],
          [
            -90.15,
            36.5
          ],
          [
            -91.4,
            36.5
          ],
          [
            -92.56,
            36.5
          ],
          [
            -93.07,
            36.5
          ],
          [
            -93.87,
            36.5
          ],
          [
            -94.62,
            36.5
          ],
          [
            -94.62,
            37
          ],
          [
            -94.62,
            37.24
          ],
          [
            -94.62,
            37.32
          ],
          [
            -94.62,
            37.99
          ],
          [
            -94.61,
            38.04
          ],
          [
            -94.61,
            38.64
          ],
          [
            -94.61,
            38.74
          ],
          [
            -94.61,
            39.12
          ],
          [
            -94.59,
            39.16
          ],
          [
            -94.66,
            39.16
          ],
          [
            -94.68,
            39.18
          ],
          [
            -94.71,
            39.17
          ],
          [
            -94.76,
            39.18
          ],
          [
            -94.78,
            39.21
          ],
          [
            -94.83,
            39.22
          ],
          [
            -94.82,
            39.24
          ],
          [
            -94.89,
            39.29
          ],
          [
            -94.91,
            39.35
          ],
          [
            -94.88,
            39.38
          ],
          [
            -94.9,
            39.39
          ],
          [
            -94.95,
            39.39
          ],
          [
            -94.99,
            39.45
          ],
          [
            -95.05,
            39.47
          ],
          [
            -95.05,
            39.5
          ],
          [
            -95.1,
            39.53
          ],
          [
            -95.11,
            39.57
          ],
          [
            -95.05,
            39.59
          ],
          [
            -95.05,
            39.63
          ],
          [
            -95.03,
            39.67
          ],
          [
            -94.97,
            39.68
          ],
          [
            -94.96,
            39.75
          ],
          [
            -94.91,
            39.73
          ],
          [
            -94.87,
            39.73
          ],
          [
            -94.87,
            39.77
          ],
          [
            -94.91,
            39.76
          ],
          [
            -94.92,
            39.79
          ],
          [
            -94.89,
            39.79
          ],
          [
            -94.88,
            39.83
          ],
          [
            -94.92,
            39.84
          ],
          [
            -94.94,
            39.86
          ],
          [
            -94.93,
            39.89
          ],
          [
            -95.01,
            39.9
          ],
          [
            -95.04,
            39.86
          ],
          [
            -95.14,
            39.88
          ],
          [
            -95.15,
            39.91
          ],
          [
            -95.2,
            39.9
          ],
          [
            -95.2,
            39.94
          ],
          [
            -95.25,
            39.95
          ],
          [
            -95.31,
            40
          ],
          [
            -95.42,
            40.05
          ],
          [
            -95.39,
            40.12
          ],
          [
            -95.48,
            40.18
          ],
          [
            -95.48,
            40.25
          ],
          [
            -95.56,
            40.26
          ],
          [
            -95.55,
            40.29
          ],
          [
            -95.62,
            40.31
          ],
          [
            -95.66,
            40.41
          ],
          [
            -95.66,
            40.44
          ],
          [
            -95.7,
            40.47
          ],
          [
            -95.7,
            40.51
          ],
          [
            -95.65,
            40.54
          ],
          [
            -95.69,
            40.56
          ],
          [
            -95.7,
            40.53
          ],
          [
            -95.77,
            40.53
          ],
          [
            -95.76,
            40.59
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "West Virginia",
      fips: "54"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -82.6,
            38.42
          ],
          [
            -82.53,
            38.41
          ],
          [
            -82.41,
            38.44
          ],
          [
            -82.32,
            38.45
          ],
          [
            -82.3,
            38.49
          ],
          [
            -82.29,
            38.58
          ],
          [
            -82.25,
            38.6
          ],
          [
            -82.19,
            38.59
          ],
          [
            -82.17,
            38.62
          ],
          [
            -82.18,
            38.71
          ],
          [
            -82.22,
            38.8
          ],
          [
            -82.14,
            38.84
          ],
          [
            -82.14,
            38.9
          ],
          [
            -82.09,
            38.97
          ],
          [
            -82.05,
            39
          ],
          [
            -82.03,
            39.03
          ],
          [
            -81.98,
            38.99
          ],
          [
            -81.94,
            38.99
          ],
          [
            -81.9,
            38.93
          ],
          [
            -81.93,
            38.89
          ],
          [
            -81.89,
            38.87
          ],
          [
            -81.86,
            38.89
          ],
          [
            -81.85,
            38.93
          ],
          [
            -81.81,
            38.95
          ],
          [
            -81.78,
            38.92
          ],
          [
            -81.77,
            39.02
          ],
          [
            -81.8,
            39.05
          ],
          [
            -81.81,
            39.08
          ],
          [
            -81.74,
            39.1
          ],
          [
            -81.76,
            39.18
          ],
          [
            -81.73,
            39.22
          ],
          [
            -81.69,
            39.23
          ],
          [
            -81.68,
            39.27
          ],
          [
            -81.57,
            39.27
          ],
          [
            -81.56,
            39.34
          ],
          [
            -81.47,
            39.4
          ],
          [
            -81.41,
            39.39
          ],
          [
            -81.39,
            39.34
          ],
          [
            -81.35,
            39.35
          ],
          [
            -81.27,
            39.39
          ],
          [
            -81.21,
            39.39
          ],
          [
            -81.17,
            39.44
          ],
          [
            -81.13,
            39.45
          ],
          [
            -81.1,
            39.49
          ],
          [
            -81.04,
            39.54
          ],
          [
            -80.94,
            39.61
          ],
          [
            -80.88,
            39.62
          ],
          [
            -80.87,
            39.69
          ],
          [
            -80.83,
            39.71
          ],
          [
            -80.87,
            39.76
          ],
          [
            -80.83,
            39.8
          ],
          [
            -80.83,
            39.85
          ],
          [
            -80.79,
            39.87
          ],
          [
            -80.8,
            39.92
          ],
          [
            -80.76,
            39.91
          ],
          [
            -80.76,
            39.95
          ],
          [
            -80.74,
            39.97
          ],
          [
            -80.74,
            40.08
          ],
          [
            -80.71,
            40.1
          ],
          [
            -80.71,
            40.15
          ],
          [
            -80.67,
            40.19
          ],
          [
            -80.65,
            40.25
          ],
          [
            -80.62,
            40.26
          ],
          [
            -80.6,
            40.32
          ],
          [
            -80.61,
            40.4
          ],
          [
            -80.6,
            40.46
          ],
          [
            -80.63,
            40.54
          ],
          [
            -80.67,
            40.57
          ],
          [
            -80.64,
            40.62
          ],
          [
            -80.59,
            40.62
          ],
          [
            -80.52,
            40.64
          ],
          [
            -80.52,
            39.72
          ],
          [
            -80.08,
            39.72
          ],
          [
            -79.48,
            39.72
          ],
          [
            -79.49,
            39.21
          ],
          [
            -79.45,
            39.21
          ],
          [
            -79.33,
            39.3
          ],
          [
            -79.29,
            39.3
          ],
          [
            -79.25,
            39.36
          ],
          [
            -79.14,
            39.41
          ],
          [
            -79.1,
            39.47
          ],
          [
            -79.06,
            39.47
          ],
          [
            -78.96,
            39.44
          ],
          [
            -78.92,
            39.49
          ],
          [
            -78.78,
            39.62
          ],
          [
            -78.73,
            39.61
          ],
          [
            -78.78,
            39.6
          ],
          [
            -78.73,
            39.59
          ],
          [
            -78.73,
            39.56
          ],
          [
            -78.65,
            39.53
          ],
          [
            -78.59,
            39.54
          ],
          [
            -78.57,
            39.52
          ],
          [
            -78.47,
            39.52
          ],
          [
            -78.42,
            39.55
          ],
          [
            -78.44,
            39.59
          ],
          [
            -78.4,
            39.59
          ],
          [
            -78.44,
            39.62
          ],
          [
            -78.39,
            39.61
          ],
          [
            -78.35,
            39.64
          ],
          [
            -78.28,
            39.62
          ],
          [
            -78.18,
            39.7
          ],
          [
            -78.1,
            39.68
          ],
          [
            -78.04,
            39.64
          ],
          [
            -78.01,
            39.6
          ],
          [
            -77.94,
            39.62
          ],
          [
            -77.88,
            39.6
          ],
          [
            -77.83,
            39.6
          ],
          [
            -77.83,
            39.57
          ],
          [
            -77.89,
            39.56
          ],
          [
            -77.85,
            39.5
          ],
          [
            -77.78,
            39.46
          ],
          [
            -77.79,
            39.44
          ],
          [
            -77.75,
            39.42
          ],
          [
            -77.74,
            39.39
          ],
          [
            -77.76,
            39.33
          ],
          [
            -77.72,
            39.32
          ],
          [
            -77.75,
            39.28
          ],
          [
            -77.83,
            39.13
          ],
          [
            -78.11,
            39.31
          ],
          [
            -78.35,
            39.47
          ],
          [
            -78.36,
            39.41
          ],
          [
            -78.34,
            39.39
          ],
          [
            -78.36,
            39.36
          ],
          [
            -78.34,
            39.35
          ],
          [
            -78.42,
            39.26
          ],
          [
            -78.4,
            39.24
          ],
          [
            -78.44,
            39.2
          ],
          [
            -78.4,
            39.17
          ],
          [
            -78.46,
            39.11
          ],
          [
            -78.49,
            39.11
          ],
          [
            -78.57,
            39.03
          ],
          [
            -78.55,
            39.02
          ],
          [
            -78.6,
            38.96
          ],
          [
            -78.63,
            38.98
          ],
          [
            -78.68,
            38.93
          ],
          [
            -78.72,
            38.91
          ],
          [
            -78.72,
            38.94
          ],
          [
            -78.8,
            38.87
          ],
          [
            -78.87,
            38.76
          ],
          [
            -79,
            38.85
          ],
          [
            -79.03,
            38.79
          ],
          [
            -79.09,
            38.72
          ],
          [
            -79.09,
            38.66
          ],
          [
            -79.12,
            38.66
          ],
          [
            -79.16,
            38.61
          ],
          [
            -79.21,
            38.49
          ],
          [
            -79.31,
            38.41
          ],
          [
            -79.48,
            38.46
          ],
          [
            -79.54,
            38.55
          ],
          [
            -79.65,
            38.59
          ],
          [
            -79.7,
            38.49
          ],
          [
            -79.69,
            38.43
          ],
          [
            -79.73,
            38.38
          ],
          [
            -79.81,
            38.31
          ],
          [
            -79.79,
            38.27
          ],
          [
            -79.83,
            38.25
          ],
          [
            -79.92,
            38.18
          ],
          [
            -79.95,
            38.13
          ],
          [
            -79.92,
            38.11
          ],
          [
            -79.95,
            38.08
          ],
          [
            -79.98,
            38.03
          ],
          [
            -80.01,
            37.99
          ],
          [
            -80.08,
            37.94
          ],
          [
            -80.18,
            37.85
          ],
          [
            -80.26,
            37.76
          ],
          [
            -80.25,
            37.73
          ],
          [
            -80.29,
            37.69
          ],
          [
            -80.28,
            37.66
          ],
          [
            -80.22,
            37.63
          ],
          [
            -80.26,
            37.59
          ],
          [
            -80.33,
            37.56
          ],
          [
            -80.33,
            37.54
          ],
          [
            -80.28,
            37.53
          ],
          [
            -80.3,
            37.51
          ],
          [
            -80.47,
            37.42
          ],
          [
            -80.51,
            37.48
          ],
          [
            -80.55,
            37.47
          ],
          [
            -80.62,
            37.43
          ],
          [
            -80.77,
            37.37
          ],
          [
            -80.78,
            37.39
          ],
          [
            -80.86,
            37.43
          ],
          [
            -80.88,
            37.38
          ],
          [
            -80.85,
            37.35
          ],
          [
            -80.92,
            37.31
          ],
          [
            -80.98,
            37.3
          ],
          [
            -81.11,
            37.28
          ],
          [
            -81.22,
            37.24
          ],
          [
            -81.32,
            37.3
          ],
          [
            -81.36,
            37.34
          ],
          [
            -81.39,
            37.32
          ],
          [
            -81.42,
            37.27
          ],
          [
            -81.5,
            37.26
          ],
          [
            -81.51,
            37.23
          ],
          [
            -81.55,
            37.21
          ],
          [
            -81.68,
            37.2
          ],
          [
            -81.74,
            37.24
          ],
          [
            -81.74,
            37.26
          ],
          [
            -81.79,
            37.28
          ],
          [
            -81.85,
            37.29
          ],
          [
            -81.88,
            37.33
          ],
          [
            -81.93,
            37.36
          ],
          [
            -81.93,
            37.44
          ],
          [
            -81.99,
            37.45
          ],
          [
            -81.99,
            37.48
          ],
          [
            -81.93,
            37.51
          ],
          [
            -81.97,
            37.54
          ],
          [
            -82.02,
            37.53
          ],
          [
            -82.12,
            37.56
          ],
          [
            -82.13,
            37.59
          ],
          [
            -82.16,
            37.59
          ],
          [
            -82.18,
            37.63
          ],
          [
            -82.21,
            37.63
          ],
          [
            -82.24,
            37.66
          ],
          [
            -82.29,
            37.67
          ],
          [
            -82.34,
            37.79
          ],
          [
            -82.38,
            37.8
          ],
          [
            -82.42,
            37.85
          ],
          [
            -82.42,
            37.88
          ],
          [
            -82.47,
            37.9
          ],
          [
            -82.5,
            37.93
          ],
          [
            -82.46,
            37.98
          ],
          [
            -82.52,
            38
          ],
          [
            -82.55,
            38.07
          ],
          [
            -82.58,
            38.11
          ],
          [
            -82.64,
            38.14
          ],
          [
            -82.64,
            38.17
          ],
          [
            -82.61,
            38.17
          ],
          [
            -82.6,
            38.22
          ],
          [
            -82.61,
            38.24
          ],
          [
            -82.57,
            38.26
          ],
          [
            -82.57,
            38.31
          ],
          [
            -82.6,
            38.34
          ],
          [
            -82.6,
            38.42
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Illinois",
      fips: "17"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -91.42,
            40.38
          ],
          [
            -91.37,
            40.39
          ],
          [
            -91.38,
            40.44
          ],
          [
            -91.37,
            40.51
          ],
          [
            -91.41,
            40.54
          ],
          [
            -91.36,
            40.6
          ],
          [
            -91.25,
            40.64
          ],
          [
            -91.18,
            40.64
          ],
          [
            -91.12,
            40.67
          ],
          [
            -91.12,
            40.73
          ],
          [
            -91.09,
            40.77
          ],
          [
            -91.09,
            40.83
          ],
          [
            -91.06,
            40.85
          ],
          [
            -91.01,
            40.9
          ],
          [
            -90.97,
            40.92
          ],
          [
            -90.94,
            41.01
          ],
          [
            -90.95,
            41.1
          ],
          [
            -90.99,
            41.16
          ],
          [
            -91.04,
            41.17
          ],
          [
            -91.11,
            41.24
          ],
          [
            -91.07,
            41.31
          ],
          [
            -91.07,
            41.37
          ],
          [
            -91.04,
            41.42
          ],
          [
            -90.98,
            41.43
          ],
          [
            -90.93,
            41.42
          ],
          [
            -90.85,
            41.46
          ],
          [
            -90.74,
            41.45
          ],
          [
            -90.65,
            41.47
          ],
          [
            -90.59,
            41.51
          ],
          [
            -90.56,
            41.52
          ],
          [
            -90.46,
            41.52
          ],
          [
            -90.4,
            41.57
          ],
          [
            -90.34,
            41.59
          ],
          [
            -90.34,
            41.65
          ],
          [
            -90.31,
            41.7
          ],
          [
            -90.31,
            41.74
          ],
          [
            -90.28,
            41.77
          ],
          [
            -90.18,
            41.81
          ],
          [
            -90.18,
            41.84
          ],
          [
            -90.15,
            41.91
          ],
          [
            -90.17,
            41.96
          ],
          [
            -90.14,
            42.01
          ],
          [
            -90.17,
            42.04
          ],
          [
            -90.16,
            42.12
          ],
          [
            -90.21,
            42.15
          ],
          [
            -90.38,
            42.21
          ],
          [
            -90.43,
            42.28
          ],
          [
            -90.42,
            42.33
          ],
          [
            -90.48,
            42.38
          ],
          [
            -90.56,
            42.42
          ],
          [
            -90.56,
            42.44
          ],
          [
            -90.64,
            42.47
          ],
          [
            -90.64,
            42.51
          ],
          [
            -90.48,
            42.51
          ],
          [
            -89.67,
            42.51
          ],
          [
            -89.48,
            42.5
          ],
          [
            -88.79,
            42.49
          ],
          [
            -88.64,
            42.5
          ],
          [
            -88.09,
            42.5
          ],
          [
            -87.8,
            42.49
          ],
          [
            -87.81,
            42.39
          ],
          [
            -87.84,
            42.3
          ],
          [
            -87.8,
            42.21
          ],
          [
            -87.72,
            42.11
          ],
          [
            -87.68,
            42.08
          ],
          [
            -87.67,
            42.03
          ],
          [
            -87.62,
            41.91
          ],
          [
            -87.61,
            41.85
          ],
          [
            -87.56,
            41.77
          ],
          [
            -87.53,
            41.75
          ],
          [
            -87.52,
            41.71
          ],
          [
            -87.53,
            41.49
          ],
          [
            -87.53,
            40.46
          ],
          [
            -87.53,
            40.25
          ],
          [
            -87.53,
            40
          ],
          [
            -87.53,
            39.99
          ],
          [
            -87.53,
            39.65
          ],
          [
            -87.53,
            39.65
          ],
          [
            -87.53,
            39.35
          ],
          [
            -87.58,
            39.34
          ],
          [
            -87.6,
            39.31
          ],
          [
            -87.61,
            39.26
          ],
          [
            -87.57,
            39.22
          ],
          [
            -87.64,
            39.17
          ],
          [
            -87.63,
            39.1
          ],
          [
            -87.57,
            39.06
          ],
          [
            -87.58,
            38.99
          ],
          [
            -87.51,
            38.95
          ],
          [
            -87.55,
            38.86
          ],
          [
            -87.5,
            38.78
          ],
          [
            -87.49,
            38.74
          ],
          [
            -87.54,
            38.68
          ],
          [
            -87.6,
            38.67
          ],
          [
            -87.62,
            38.64
          ],
          [
            -87.65,
            38.57
          ],
          [
            -87.65,
            38.51
          ],
          [
            -87.74,
            38.48
          ],
          [
            -87.73,
            38.44
          ],
          [
            -87.78,
            38.37
          ],
          [
            -87.81,
            38.36
          ],
          [
            -87.85,
            38.28
          ],
          [
            -87.88,
            38.3
          ],
          [
            -87.91,
            38.27
          ],
          [
            -87.93,
            38.3
          ],
          [
            -87.96,
            38.24
          ],
          [
            -87.99,
            38.25
          ],
          [
            -87.98,
            38.2
          ],
          [
            -87.93,
            38.15
          ],
          [
            -88,
            38.08
          ],
          [
            -87.96,
            38.1
          ],
          [
            -87.97,
            38.07
          ],
          [
            -88.04,
            38.05
          ],
          [
            -88.01,
            38.03
          ],
          [
            -88.01,
            37.98
          ],
          [
            -88.07,
            37.92
          ],
          [
            -88.01,
            37.89
          ],
          [
            -88.1,
            37.9
          ],
          [
            -88.04,
            37.82
          ],
          [
            -88.08,
            37.83
          ],
          [
            -88.07,
            37.8
          ],
          [
            -88.03,
            37.8
          ],
          [
            -88.06,
            37.74
          ],
          [
            -88.12,
            37.71
          ],
          [
            -88.16,
            37.66
          ],
          [
            -88.13,
            37.57
          ],
          [
            -88.06,
            37.52
          ],
          [
            -88.08,
            37.47
          ],
          [
            -88.26,
            37.46
          ],
          [
            -88.3,
            37.45
          ],
          [
            -88.36,
            37.4
          ],
          [
            -88.41,
            37.42
          ],
          [
            -88.48,
            37.39
          ],
          [
            -88.49,
            37.34
          ],
          [
            -88.52,
            37.28
          ],
          [
            -88.51,
            37.26
          ],
          [
            -88.45,
            37.21
          ],
          [
            -88.42,
            37.15
          ],
          [
            -88.46,
            37.07
          ],
          [
            -88.51,
            37.06
          ],
          [
            -88.56,
            37.08
          ],
          [
            -88.63,
            37.12
          ],
          [
            -88.75,
            37.16
          ],
          [
            -88.8,
            37.19
          ],
          [
            -88.92,
            37.22
          ],
          [
            -88.98,
            37.23
          ],
          [
            -89.03,
            37.21
          ],
          [
            -89.08,
            37.17
          ],
          [
            -89.11,
            37.12
          ],
          [
            -89.17,
            37.07
          ],
          [
            -89.18,
            37.03
          ],
          [
            -89.13,
            36.98
          ],
          [
            -89.17,
            36.97
          ],
          [
            -89.2,
            37.02
          ],
          [
            -89.26,
            37.06
          ],
          [
            -89.31,
            37.05
          ],
          [
            -89.26,
            37.02
          ],
          [
            -89.29,
            36.99
          ],
          [
            -89.38,
            37.04
          ],
          [
            -89.38,
            37.09
          ],
          [
            -89.41,
            37.13
          ],
          [
            -89.46,
            37.2
          ],
          [
            -89.46,
            37.24
          ],
          [
            -89.52,
            37.29
          ],
          [
            -89.49,
            37.33
          ],
          [
            -89.44,
            37.34
          ],
          [
            -89.42,
            37.4
          ],
          [
            -89.52,
            37.54
          ],
          [
            -89.52,
            37.58
          ],
          [
            -89.48,
            37.59
          ],
          [
            -89.52,
            37.64
          ],
          [
            -89.52,
            37.69
          ],
          [
            -89.58,
            37.71
          ],
          [
            -89.62,
            37.75
          ],
          [
            -89.67,
            37.75
          ],
          [
            -89.66,
            37.79
          ],
          [
            -89.74,
            37.85
          ],
          [
            -89.8,
            37.86
          ],
          [
            -89.8,
            37.88
          ],
          [
            -89.85,
            37.91
          ],
          [
            -89.88,
            37.88
          ],
          [
            -89.95,
            37.88
          ],
          [
            -89.97,
            37.93
          ],
          [
            -89.93,
            37.95
          ],
          [
            -89.94,
            37.97
          ],
          [
            -90,
            37.96
          ],
          [
            -90.06,
            38.02
          ],
          [
            -90.09,
            38.02
          ],
          [
            -90.13,
            38.06
          ],
          [
            -90.22,
            38.09
          ],
          [
            -90.29,
            38.17
          ],
          [
            -90.36,
            38.21
          ],
          [
            -90.37,
            38.27
          ],
          [
            -90.37,
            38.34
          ],
          [
            -90.34,
            38.39
          ],
          [
            -90.28,
            38.44
          ],
          [
            -90.26,
            38.53
          ],
          [
            -90.18,
            38.61
          ],
          [
            -90.18,
            38.64
          ],
          [
            -90.21,
            38.72
          ],
          [
            -90.17,
            38.77
          ],
          [
            -90.12,
            38.8
          ],
          [
            -90.11,
            38.85
          ],
          [
            -90.25,
            38.92
          ],
          [
            -90.31,
            38.92
          ],
          [
            -90.41,
            38.96
          ],
          [
            -90.47,
            38.96
          ],
          [
            -90.51,
            38.9
          ],
          [
            -90.55,
            38.87
          ],
          [
            -90.59,
            38.87
          ],
          [
            -90.66,
            38.93
          ],
          [
            -90.67,
            38.98
          ],
          [
            -90.71,
            39.06
          ],
          [
            -90.68,
            39.09
          ],
          [
            -90.71,
            39.16
          ],
          [
            -90.72,
            39.23
          ],
          [
            -90.79,
            39.31
          ],
          [
            -91.01,
            39.43
          ],
          [
            -91.06,
            39.47
          ],
          [
            -91.1,
            39.54
          ],
          [
            -91.15,
            39.55
          ],
          [
            -91.18,
            39.61
          ],
          [
            -91.22,
            39.62
          ],
          [
            -91.28,
            39.67
          ],
          [
            -91.37,
            39.73
          ],
          [
            -91.36,
            39.78
          ],
          [
            -91.37,
            39.81
          ],
          [
            -91.43,
            39.84
          ],
          [
            -91.45,
            39.87
          ],
          [
            -91.42,
            39.93
          ],
          [
            -91.44,
            39.95
          ],
          [
            -91.49,
            40.04
          ],
          [
            -91.51,
            40.18
          ],
          [
            -91.51,
            40.24
          ],
          [
            -91.45,
            40.36
          ],
          [
            -91.42,
            40.38
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New Mexico",
      fips: "35"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -109.04,
            37
          ],
          [
            -108.25,
            37
          ],
          [
            -107.42,
            37
          ],
          [
            -106.88,
            37
          ],
          [
            -106.87,
            36.99
          ],
          [
            -106.2,
            36.99
          ],
          [
            -105.12,
            37
          ],
          [
            -105,
            36.99
          ],
          [
            -104.34,
            36.99
          ],
          [
            -103.73,
            37
          ],
          [
            -103,
            37
          ],
          [
            -103,
            36.6
          ],
          [
            -103,
            36.5
          ],
          [
            -103.04,
            36.5
          ],
          [
            -103.04,
            36.32
          ],
          [
            -103.04,
            35.62
          ],
          [
            -103.04,
            35.25
          ],
          [
            -103.04,
            33.95
          ],
          [
            -103.05,
            33.75
          ],
          [
            -103.06,
            33.39
          ],
          [
            -103.06,
            33.26
          ],
          [
            -103.07,
            33.04
          ],
          [
            -103.07,
            32
          ],
          [
            -103.72,
            32
          ],
          [
            -104.53,
            32
          ],
          [
            -105.43,
            32
          ],
          [
            -106.62,
            32
          ],
          [
            -106.62,
            31.91
          ],
          [
            -106.65,
            31.9
          ],
          [
            -106.64,
            31.87
          ],
          [
            -106.6,
            31.84
          ],
          [
            -106.6,
            31.82
          ],
          [
            -106.55,
            31.81
          ],
          [
            -106.53,
            31.78
          ],
          [
            -107.3,
            31.78
          ],
          [
            -108.21,
            31.78
          ],
          [
            -108.21,
            31.33
          ],
          [
            -109.05,
            31.33
          ],
          [
            -109.05,
            33.78
          ],
          [
            -109.04,
            33.88
          ],
          [
            -109.05,
            34
          ],
          [
            -109.04,
            34.52
          ],
          [
            -109.04,
            35.32
          ],
          [
            -109.05,
            35.34
          ],
          [
            -109.04,
            35.55
          ],
          [
            -109.04,
            37
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Arkansas",
      fips: "05"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -94.62,
            36.5
          ],
          [
            -93.87,
            36.5
          ],
          [
            -93.07,
            36.5
          ],
          [
            -92.56,
            36.5
          ],
          [
            -91.4,
            36.5
          ],
          [
            -90.15,
            36.5
          ],
          [
            -90.13,
            36.44
          ],
          [
            -90.14,
            36.42
          ],
          [
            -90.06,
            36.39
          ],
          [
            -90.08,
            36.27
          ],
          [
            -90.11,
            36.27
          ],
          [
            -90.13,
            36.23
          ],
          [
            -90.18,
            36.2
          ],
          [
            -90.24,
            36.16
          ],
          [
            -90.24,
            36.14
          ],
          [
            -90.32,
            36.09
          ],
          [
            -90.38,
            36
          ],
          [
            -89.73,
            36
          ],
          [
            -89.72,
            35.97
          ],
          [
            -89.66,
            35.93
          ],
          [
            -89.66,
            35.89
          ],
          [
            -89.74,
            35.91
          ],
          [
            -89.77,
            35.86
          ],
          [
            -89.7,
            35.83
          ],
          [
            -89.74,
            35.81
          ],
          [
            -89.78,
            35.8
          ],
          [
            -89.81,
            35.76
          ],
          [
            -89.87,
            35.74
          ],
          [
            -89.91,
            35.76
          ],
          [
            -89.96,
            35.72
          ],
          [
            -89.94,
            35.67
          ],
          [
            -89.91,
            35.65
          ],
          [
            -89.86,
            35.67
          ],
          [
            -89.85,
            35.64
          ],
          [
            -89.95,
            35.6
          ],
          [
            -89.94,
            35.56
          ],
          [
            -89.91,
            35.55
          ],
          [
            -89.92,
            35.51
          ],
          [
            -90,
            35.56
          ],
          [
            -90.03,
            35.55
          ],
          [
            -90.05,
            35.5
          ],
          [
            -90.02,
            35.47
          ],
          [
            -90.06,
            35.4
          ],
          [
            -90.09,
            35.48
          ],
          [
            -90.17,
            35.42
          ],
          [
            -90.18,
            35.38
          ],
          [
            -90.14,
            35.38
          ],
          [
            -90.13,
            35.41
          ],
          [
            -90.08,
            35.38
          ],
          [
            -90.11,
            35.34
          ],
          [
            -90.11,
            35.3
          ],
          [
            -90.17,
            35.3
          ],
          [
            -90.15,
            35.26
          ],
          [
            -90.1,
            35.25
          ],
          [
            -90.08,
            35.22
          ],
          [
            -90.12,
            35.19
          ],
          [
            -90.06,
            35.14
          ],
          [
            -90.1,
            35.12
          ],
          [
            -90.14,
            35.13
          ],
          [
            -90.18,
            35.11
          ],
          [
            -90.21,
            35.03
          ],
          [
            -90.3,
            35.04
          ],
          [
            -90.31,
            35
          ],
          [
            -90.25,
            34.95
          ],
          [
            -90.25,
            34.91
          ],
          [
            -90.31,
            34.87
          ],
          [
            -90.42,
            34.83
          ],
          [
            -90.44,
            34.88
          ],
          [
            -90.48,
            34.89
          ],
          [
            -90.48,
            34.86
          ],
          [
            -90.46,
            34.82
          ],
          [
            -90.47,
            34.8
          ],
          [
            -90.45,
            34.74
          ],
          [
            -90.5,
            34.72
          ],
          [
            -90.52,
            34.75
          ],
          [
            -90.51,
            34.8
          ],
          [
            -90.55,
            34.78
          ],
          [
            -90.54,
            34.75
          ],
          [
            -90.57,
            34.74
          ],
          [
            -90.55,
            34.7
          ],
          [
            -90.47,
            34.7
          ],
          [
            -90.47,
            34.67
          ],
          [
            -90.52,
            34.63
          ],
          [
            -90.56,
            34.65
          ],
          [
            -90.55,
            34.69
          ],
          [
            -90.59,
            34.67
          ],
          [
            -90.59,
            34.62
          ],
          [
            -90.55,
            34.56
          ],
          [
            -90.54,
            34.54
          ],
          [
            -90.59,
            34.5
          ],
          [
            -90.57,
            34.43
          ],
          [
            -90.66,
            34.38
          ],
          [
            -90.66,
            34.32
          ],
          [
            -90.69,
            34.32
          ],
          [
            -90.68,
            34.37
          ],
          [
            -90.75,
            34.37
          ],
          [
            -90.77,
            34.35
          ],
          [
            -90.74,
            34.31
          ],
          [
            -90.76,
            34.28
          ],
          [
            -90.83,
            34.27
          ],
          [
            -90.85,
            34.21
          ],
          [
            -90.9,
            34.24
          ],
          [
            -90.94,
            34.22
          ],
          [
            -90.89,
            34.18
          ],
          [
            -90.81,
            34.18
          ],
          [
            -90.81,
            34.16
          ],
          [
            -90.85,
            34.14
          ],
          [
            -90.91,
            34.17
          ],
          [
            -90.95,
            34.14
          ],
          [
            -90.92,
            34.09
          ],
          [
            -90.88,
            34.1
          ],
          [
            -90.87,
            34.08
          ],
          [
            -90.9,
            34.02
          ],
          [
            -90.99,
            34.02
          ],
          [
            -90.96,
            33.98
          ],
          [
            -91,
            33.97
          ],
          [
            -91.02,
            34
          ],
          [
            -91.08,
            33.98
          ],
          [
            -91.09,
            33.96
          ],
          [
            -91.01,
            33.93
          ],
          [
            -91.07,
            33.86
          ],
          [
            -91.05,
            33.82
          ],
          [
            -90.99,
            33.79
          ],
          [
            -91.03,
            33.76
          ],
          [
            -91.06,
            33.78
          ],
          [
            -91.14,
            33.78
          ],
          [
            -91.15,
            33.73
          ],
          [
            -91.11,
            33.7
          ],
          [
            -91.06,
            33.72
          ],
          [
            -91.03,
            33.67
          ],
          [
            -91.08,
            33.66
          ],
          [
            -91.13,
            33.68
          ],
          [
            -91.16,
            33.71
          ],
          [
            -91.22,
            33.69
          ],
          [
            -91.23,
            33.67
          ],
          [
            -91.14,
            33.63
          ],
          [
            -91.13,
            33.6
          ],
          [
            -91.23,
            33.56
          ],
          [
            -91.18,
            33.51
          ],
          [
            -91.23,
            33.44
          ],
          [
            -91.17,
            33.45
          ],
          [
            -91.17,
            33.5
          ],
          [
            -91.12,
            33.47
          ],
          [
            -91.14,
            33.43
          ],
          [
            -91.2,
            33.42
          ],
          [
            -91.21,
            33.4
          ],
          [
            -91.17,
            33.38
          ],
          [
            -91.11,
            33.39
          ],
          [
            -91.08,
            33.46
          ],
          [
            -91.06,
            33.43
          ],
          [
            -91.14,
            33.35
          ],
          [
            -91.14,
            33.3
          ],
          [
            -91.1,
            33.24
          ],
          [
            -91.09,
            33.27
          ],
          [
            -91.05,
            33.29
          ],
          [
            -91.04,
            33.27
          ],
          [
            -91.09,
            33.22
          ],
          [
            -91.08,
            33.16
          ],
          [
            -91.09,
            33.14
          ],
          [
            -91.15,
            33.13
          ],
          [
            -91.18,
            33.14
          ],
          [
            -91.2,
            33.11
          ],
          [
            -91.12,
            33.05
          ],
          [
            -91.17,
            33
          ],
          [
            -91.95,
            33.01
          ],
          [
            -92.51,
            33.01
          ],
          [
            -93.07,
            33.02
          ],
          [
            -93.38,
            33.02
          ],
          [
            -94.04,
            33.02
          ],
          [
            -94.04,
            33.54
          ],
          [
            -94.05,
            33.55
          ],
          [
            -94.05,
            33.55
          ],
          [
            -94.1,
            33.57
          ],
          [
            -94.12,
            33.55
          ],
          [
            -94.14,
            33.58
          ],
          [
            -94.19,
            33.59
          ],
          [
            -94.22,
            33.55
          ],
          [
            -94.3,
            33.58
          ],
          [
            -94.31,
            33.55
          ],
          [
            -94.34,
            33.57
          ],
          [
            -94.36,
            33.54
          ],
          [
            -94.39,
            33.55
          ],
          [
            -94.39,
            33.58
          ],
          [
            -94.42,
            33.58
          ],
          [
            -94.46,
            33.6
          ],
          [
            -94.46,
            33.64
          ],
          [
            -94.49,
            33.64
          ],
          [
            -94.47,
            34.19
          ],
          [
            -94.46,
            34.55
          ],
          [
            -94.45,
            34.69
          ],
          [
            -94.45,
            34.9
          ],
          [
            -94.44,
            35.12
          ],
          [
            -94.43,
            35.39
          ],
          [
            -94.49,
            35.73
          ],
          [
            -94.5,
            35.8
          ],
          [
            -94.55,
            36.1
          ],
          [
            -94.57,
            36.21
          ],
          [
            -94.6,
            36.39
          ],
          [
            -94.62,
            36.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "California",
      fips: "06"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -118.6,
              33.48
            ],
            [
              -118.55,
              33.47
            ],
            [
              -118.45,
              33.43
            ],
            [
              -118.37,
              33.41
            ],
            [
              -118.37,
              33.39
            ],
            [
              -118.31,
              33.34
            ],
            [
              -118.33,
              33.3
            ],
            [
              -118.37,
              33.32
            ],
            [
              -118.47,
              33.33
            ],
            [
              -118.49,
              33.36
            ],
            [
              -118.49,
              33.42
            ],
            [
              -118.56,
              33.43
            ],
            [
              -118.6,
              33.48
            ]
          ]
        ],
        [
          [
            [
              -118.61,
              33.03
            ],
            [
              -118.57,
              33.03
            ],
            [
              -118.5,
              32.93
            ],
            [
              -118.35,
              32.82
            ],
            [
              -118.39,
              32.83
            ],
            [
              -118.43,
              32.81
            ],
            [
              -118.49,
              32.84
            ],
            [
              -118.53,
              32.91
            ],
            [
              -118.59,
              33.01
            ],
            [
              -118.61,
              33.03
            ]
          ]
        ],
        [
          [
            [
              -119.06,
              33.49
            ],
            [
              -119.03,
              33.5
            ],
            [
              -119.03,
              33.46
            ],
            [
              -119.07,
              33.47
            ],
            [
              -119.06,
              33.49
            ]
          ]
        ],
        [
          [
            [
              -119.43,
              34.03
            ],
            [
              -119.4,
              34.01
            ],
            [
              -119.36,
              34.03
            ],
            [
              -119.36,
              34
            ],
            [
              -119.43,
              34
            ],
            [
              -119.46,
              34.02
            ],
            [
              -119.43,
              34.03
            ]
          ]
        ],
        [
          [
            [
              -119.58,
              33.28
            ],
            [
              -119.53,
              33.29
            ],
            [
              -119.46,
              33.25
            ],
            [
              -119.43,
              33.23
            ],
            [
              -119.48,
              33.22
            ],
            [
              -119.55,
              33.23
            ],
            [
              -119.58,
              33.28
            ]
          ]
        ],
        [
          [
            [
              -119.92,
              34.08
            ],
            [
              -119.86,
              34.07
            ],
            [
              -119.81,
              34.05
            ],
            [
              -119.76,
              34.06
            ],
            [
              -119.69,
              34.02
            ],
            [
              -119.62,
              34.02
            ],
            [
              -119.59,
              34.05
            ],
            [
              -119.52,
              34.03
            ],
            [
              -119.56,
              34
            ],
            [
              -119.66,
              33.99
            ],
            [
              -119.72,
              33.96
            ],
            [
              -119.87,
              33.98
            ],
            [
              -119.88,
              34.03
            ],
            [
              -119.92,
              34.08
            ]
          ]
        ],
        [
          [
            [
              -120.25,
              34
            ],
            [
              -120.17,
              34.01
            ],
            [
              -120.14,
              34.03
            ],
            [
              -120.09,
              34.02
            ],
            [
              -120.04,
              34.04
            ],
            [
              -120.04,
              33.99
            ],
            [
              -119.98,
              33.98
            ],
            [
              -119.97,
              33.94
            ],
            [
              -120.12,
              33.9
            ],
            [
              -120.18,
              33.93
            ],
            [
              -120.25,
              34
            ]
          ]
        ],
        [
          [
            [
              -120.45,
              34.04
            ],
            [
              -120.39,
              34.05
            ],
            [
              -120.37,
              34.08
            ],
            [
              -120.35,
              34.05
            ],
            [
              -120.3,
              34.02
            ],
            [
              -120.38,
              34.02
            ],
            [
              -120.45,
              34.04
            ]
          ]
        ],
        [
          [
            [
              -124.21,
              42
            ],
            [
              -123.66,
              42
            ],
            [
              -123.62,
              42
            ],
            [
              -123.35,
              42
            ],
            [
              -123.15,
              42.01
            ],
            [
              -123.05,
              42
            ],
            [
              -122.63,
              42
            ],
            [
              -122.5,
              42.01
            ],
            [
              -122.16,
              42.01
            ],
            [
              -122,
              42
            ],
            [
              -121.45,
              42
            ],
            [
              -121.04,
              41.99
            ],
            [
              -120.33,
              41.99
            ],
            [
              -120,
              42
            ],
            [
              -120,
              41.99
            ],
            [
              -120,
              40.75
            ],
            [
              -120,
              40.72
            ],
            [
              -120,
              40.07
            ],
            [
              -120,
              39.73
            ],
            [
              -120,
              39.72
            ],
            [
              -120,
              39.33
            ],
            [
              -120.01,
              39.23
            ],
            [
              -120,
              39
            ],
            [
              -119.91,
              38.93
            ],
            [
              -119.49,
              38.65
            ],
            [
              -119.08,
              38.36
            ],
            [
              -118.86,
              38.2
            ],
            [
              -118.5,
              37.95
            ],
            [
              -118.05,
              37.63
            ],
            [
              -117.83,
              37.47
            ],
            [
              -117.38,
              37.13
            ],
            [
              -116.25,
              36.28
            ],
            [
              -115.41,
              35.63
            ],
            [
              -115.16,
              35.42
            ],
            [
              -114.63,
              35
            ],
            [
              -114.64,
              34.88
            ],
            [
              -114.58,
              34.83
            ],
            [
              -114.55,
              34.77
            ],
            [
              -114.47,
              34.71
            ],
            [
              -114.38,
              34.51
            ],
            [
              -114.39,
              34.46
            ],
            [
              -114.34,
              34.45
            ],
            [
              -114.23,
              34.37
            ],
            [
              -114.18,
              34.35
            ],
            [
              -114.14,
              34.3
            ],
            [
              -114.13,
              34.26
            ],
            [
              -114.22,
              34.21
            ],
            [
              -114.23,
              34.19
            ],
            [
              -114.29,
              34.17
            ],
            [
              -114.32,
              34.14
            ],
            [
              -114.41,
              34.11
            ],
            [
              -114.44,
              34.09
            ],
            [
              -114.44,
              34.03
            ],
            [
              -114.54,
              33.93
            ],
            [
              -114.51,
              33.91
            ],
            [
              -114.5,
              33.86
            ],
            [
              -114.53,
              33.86
            ],
            [
              -114.53,
              33.82
            ],
            [
              -114.5,
              33.76
            ],
            [
              -114.5,
              33.7
            ],
            [
              -114.53,
              33.69
            ],
            [
              -114.54,
              33.59
            ],
            [
              -114.53,
              33.55
            ],
            [
              -114.56,
              33.53
            ],
            [
              -114.66,
              33.41
            ],
            [
              -114.73,
              33.41
            ],
            [
              -114.7,
              33.36
            ],
            [
              -114.73,
              33.31
            ],
            [
              -114.68,
              33.27
            ],
            [
              -114.68,
              33.15
            ],
            [
              -114.71,
              33.09
            ],
            [
              -114.66,
              33.03
            ],
            [
              -114.65,
              33.05
            ],
            [
              -114.6,
              33.03
            ],
            [
              -114.58,
              33.04
            ],
            [
              -114.52,
              33.03
            ],
            [
              -114.46,
              32.91
            ],
            [
              -114.47,
              32.85
            ],
            [
              -114.53,
              32.79
            ],
            [
              -114.53,
              32.76
            ],
            [
              -114.62,
              32.73
            ],
            [
              -114.7,
              32.75
            ],
            [
              -114.72,
              32.72
            ],
            [
              -116.21,
              32.61
            ],
            [
              -117.12,
              32.53
            ],
            [
              -117.14,
              32.62
            ],
            [
              -117.17,
              32.67
            ],
            [
              -117.2,
              32.69
            ],
            [
              -117.25,
              32.67
            ],
            [
              -117.26,
              32.73
            ],
            [
              -117.25,
              32.79
            ],
            [
              -117.28,
              32.82
            ],
            [
              -117.25,
              32.87
            ],
            [
              -117.28,
              33.01
            ],
            [
              -117.33,
              33.12
            ],
            [
              -117.36,
              33.17
            ],
            [
              -117.5,
              33.33
            ],
            [
              -117.59,
              33.39
            ],
            [
              -117.63,
              33.43
            ],
            [
              -117.68,
              33.46
            ],
            [
              -117.72,
              33.46
            ],
            [
              -117.78,
              33.54
            ],
            [
              -117.88,
              33.59
            ],
            [
              -117.93,
              33.61
            ],
            [
              -118,
              33.65
            ],
            [
              -118.09,
              33.73
            ],
            [
              -118.18,
              33.76
            ],
            [
              -118.18,
              33.72
            ],
            [
              -118.26,
              33.7
            ],
            [
              -118.32,
              33.72
            ],
            [
              -118.36,
              33.74
            ],
            [
              -118.41,
              33.74
            ],
            [
              -118.43,
              33.77
            ],
            [
              -118.39,
              33.8
            ],
            [
              -118.39,
              33.84
            ],
            [
              -118.44,
              33.94
            ],
            [
              -118.48,
              34
            ],
            [
              -118.54,
              34.04
            ],
            [
              -118.67,
              34.04
            ],
            [
              -118.75,
              34.03
            ],
            [
              -118.8,
              34
            ],
            [
              -118.85,
              34.03
            ],
            [
              -118.95,
              34.05
            ],
            [
              -119.09,
              34.1
            ],
            [
              -119.13,
              34.1
            ],
            [
              -119.22,
              34.15
            ],
            [
              -119.28,
              34.27
            ],
            [
              -119.31,
              34.28
            ],
            [
              -119.37,
              34.32
            ],
            [
              -119.39,
              34.32
            ],
            [
              -119.46,
              34.37
            ],
            [
              -119.54,
              34.4
            ],
            [
              -119.56,
              34.41
            ],
            [
              -119.67,
              34.42
            ],
            [
              -119.73,
              34.4
            ],
            [
              -119.79,
              34.42
            ],
            [
              -119.87,
              34.41
            ],
            [
              -120.01,
              34.46
            ],
            [
              -120.09,
              34.46
            ],
            [
              -120.14,
              34.47
            ],
            [
              -120.3,
              34.47
            ],
            [
              -120.47,
              34.45
            ],
            [
              -120.48,
              34.47
            ],
            [
              -120.52,
              34.53
            ],
            [
              -120.58,
              34.56
            ],
            [
              -120.62,
              34.55
            ],
            [
              -120.65,
              34.58
            ],
            [
              -120.6,
              34.7
            ],
            [
              -120.64,
              34.76
            ],
            [
              -120.61,
              34.86
            ],
            [
              -120.67,
              34.9
            ],
            [
              -120.64,
              35
            ],
            [
              -120.63,
              35.12
            ],
            [
              -120.7,
              35.17
            ],
            [
              -120.75,
              35.18
            ],
            [
              -120.76,
              35.16
            ],
            [
              -120.86,
              35.21
            ],
            [
              -120.9,
              35.25
            ],
            [
              -120.86,
              35.36
            ],
            [
              -120.87,
              35.4
            ],
            [
              -120.91,
              35.45
            ],
            [
              -121,
              35.46
            ],
            [
              -121.1,
              35.55
            ],
            [
              -121.17,
              35.64
            ],
            [
              -121.25,
              35.66
            ],
            [
              -121.31,
              35.71
            ],
            [
              -121.33,
              35.78
            ],
            [
              -121.39,
              35.82
            ],
            [
              -121.41,
              35.86
            ],
            [
              -121.46,
              35.89
            ],
            [
              -121.49,
              35.97
            ],
            [
              -121.5,
              36
            ],
            [
              -121.58,
              36.03
            ],
            [
              -121.63,
              36.11
            ],
            [
              -121.72,
              36.2
            ],
            [
              -121.84,
              36.25
            ],
            [
              -121.88,
              36.29
            ],
            [
              -121.91,
              36.36
            ],
            [
              -121.9,
              36.39
            ],
            [
              -121.94,
              36.48
            ],
            [
              -121.93,
              36.56
            ],
            [
              -121.97,
              36.57
            ],
            [
              -121.94,
              36.64
            ],
            [
              -121.87,
              36.6
            ],
            [
              -121.84,
              36.63
            ],
            [
              -121.82,
              36.68
            ],
            [
              -121.79,
              36.8
            ],
            [
              -121.86,
              36.93
            ],
            [
              -121.91,
              36.97
            ],
            [
              -121.94,
              36.98
            ],
            [
              -121.97,
              36.95
            ],
            [
              -122.11,
              36.96
            ],
            [
              -122.21,
              37.01
            ],
            [
              -122.29,
              37.1
            ],
            [
              -122.34,
              37.12
            ],
            [
              -122.34,
              37.14
            ],
            [
              -122.4,
              37.2
            ],
            [
              -122.42,
              37.25
            ],
            [
              -122.4,
              37.36
            ],
            [
              -122.44,
              37.44
            ],
            [
              -122.45,
              37.48
            ],
            [
              -122.49,
              37.49
            ],
            [
              -122.52,
              37.52
            ],
            [
              -122.52,
              37.58
            ],
            [
              -122.5,
              37.6
            ],
            [
              -122.49,
              37.67
            ],
            [
              -122.52,
              37.78
            ],
            [
              -122.47,
              37.8
            ],
            [
              -122.41,
              37.81
            ],
            [
              -122.39,
              37.79
            ],
            [
              -122.36,
              37.72
            ],
            [
              -122.39,
              37.71
            ],
            [
              -122.35,
              37.62
            ],
            [
              -122.36,
              37.59
            ],
            [
              -122.26,
              37.57
            ],
            [
              -122.17,
              37.5
            ],
            [
              -122.14,
              37.51
            ],
            [
              -122.09,
              37.45
            ],
            [
              -122.05,
              37.46
            ],
            [
              -122.07,
              37.49
            ],
            [
              -122.11,
              37.51
            ],
            [
              -122.15,
              37.58
            ],
            [
              -122.17,
              37.68
            ],
            [
              -122.25,
              37.72
            ],
            [
              -122.25,
              37.76
            ],
            [
              -122.33,
              37.78
            ],
            [
              -122.3,
              37.85
            ],
            [
              -122.33,
              37.91
            ],
            [
              -122.38,
              37.91
            ],
            [
              -122.43,
              37.96
            ],
            [
              -122.4,
              37.96
            ],
            [
              -122.37,
              37.98
            ],
            [
              -122.37,
              38.01
            ],
            [
              -122.3,
              38.01
            ],
            [
              -122.26,
              38.04
            ],
            [
              -122.3,
              38.11
            ],
            [
              -122.39,
              38.14
            ],
            [
              -122.44,
              38.12
            ],
            [
              -122.49,
              38.11
            ],
            [
              -122.48,
              38.07
            ],
            [
              -122.5,
              38.03
            ],
            [
              -122.45,
              37.99
            ],
            [
              -122.49,
              37.97
            ],
            [
              -122.5,
              37.93
            ],
            [
              -122.44,
              37.88
            ],
            [
              -122.46,
              37.87
            ],
            [
              -122.5,
              37.89
            ],
            [
              -122.48,
              37.83
            ],
            [
              -122.53,
              37.82
            ],
            [
              -122.56,
              37.85
            ],
            [
              -122.66,
              37.9
            ],
            [
              -122.7,
              37.89
            ],
            [
              -122.78,
              37.95
            ],
            [
              -122.82,
              38
            ],
            [
              -122.88,
              38.03
            ],
            [
              -122.94,
              38.03
            ],
            [
              -123.01,
              38
            ],
            [
              -122.96,
              38.11
            ],
            [
              -122.95,
              38.15
            ],
            [
              -122.99,
              38.23
            ],
            [
              -122.97,
              38.25
            ],
            [
              -123.03,
              38.31
            ],
            [
              -123.06,
              38.3
            ],
            [
              -123.07,
              38.36
            ],
            [
              -123.13,
              38.45
            ],
            [
              -123.2,
              38.49
            ],
            [
              -123.25,
              38.51
            ],
            [
              -123.33,
              38.57
            ],
            [
              -123.46,
              38.72
            ],
            [
              -123.51,
              38.74
            ],
            [
              -123.54,
              38.78
            ],
            [
              -123.65,
              38.85
            ],
            [
              -123.74,
              38.95
            ],
            [
              -123.69,
              39.02
            ],
            [
              -123.69,
              39.06
            ],
            [
              -123.74,
              39.17
            ],
            [
              -123.8,
              39.27
            ],
            [
              -123.83,
              39.36
            ],
            [
              -123.81,
              39.45
            ],
            [
              -123.77,
              39.56
            ],
            [
              -123.79,
              39.6
            ],
            [
              -123.79,
              39.66
            ],
            [
              -123.84,
              39.74
            ],
            [
              -123.85,
              39.83
            ],
            [
              -123.91,
              39.86
            ],
            [
              -123.93,
              39.91
            ],
            [
              -124.06,
              40.02
            ],
            [
              -124.08,
              40.03
            ],
            [
              -124.08,
              40.07
            ],
            [
              -124.11,
              40.1
            ],
            [
              -124.19,
              40.13
            ],
            [
              -124.36,
              40.26
            ],
            [
              -124.35,
              40.31
            ],
            [
              -124.36,
              40.37
            ],
            [
              -124.41,
              40.44
            ],
            [
              -124.38,
              40.52
            ],
            [
              -124.33,
              40.62
            ],
            [
              -124.18,
              40.84
            ],
            [
              -124.14,
              40.93
            ],
            [
              -124.11,
              41.03
            ],
            [
              -124.16,
              41.06
            ],
            [
              -124.16,
              41.14
            ],
            [
              -124.14,
              41.14
            ],
            [
              -124.11,
              41.23
            ],
            [
              -124.06,
              41.44
            ],
            [
              -124.08,
              41.55
            ],
            [
              -124.13,
              41.66
            ],
            [
              -124.16,
              41.74
            ],
            [
              -124.2,
              41.74
            ],
            [
              -124.26,
              41.78
            ],
            [
              -124.22,
              41.85
            ],
            [
              -124.2,
              41.94
            ],
            [
              -124.21,
              42
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Delaware",
      fips: "10"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -75.56,
              39.63
            ],
            [
              -75.56,
              39.61
            ],
            [
              -75.56,
              39.63
            ],
            [
              -75.56,
              39.63
            ]
          ]
        ],
        [
          [
            [
              -75.79,
              39.72
            ],
            [
              -75.72,
              39.79
            ],
            [
              -75.66,
              39.82
            ],
            [
              -75.58,
              39.84
            ],
            [
              -75.5,
              39.83
            ],
            [
              -75.42,
              39.8
            ],
            [
              -75.46,
              39.77
            ],
            [
              -75.48,
              39.71
            ],
            [
              -75.51,
              39.69
            ],
            [
              -75.53,
              39.69
            ],
            [
              -75.61,
              39.62
            ],
            [
              -75.6,
              39.59
            ],
            [
              -75.56,
              39.56
            ],
            [
              -75.56,
              39.52
            ],
            [
              -75.59,
              39.5
            ],
            [
              -75.59,
              39.46
            ],
            [
              -75.54,
              39.42
            ],
            [
              -75.51,
              39.37
            ],
            [
              -75.44,
              39.31
            ],
            [
              -75.4,
              39.25
            ],
            [
              -75.39,
              39.2
            ],
            [
              -75.41,
              39.17
            ],
            [
              -75.4,
              39.07
            ],
            [
              -75.34,
              39.03
            ],
            [
              -75.32,
              38.99
            ],
            [
              -75.31,
              38.92
            ],
            [
              -75.19,
              38.81
            ],
            [
              -75.13,
              38.78
            ],
            [
              -75.1,
              38.8
            ],
            [
              -75.08,
              38.77
            ],
            [
              -75.06,
              38.66
            ],
            [
              -75.05,
              38.45
            ],
            [
              -75.43,
              38.45
            ],
            [
              -75.69,
              38.46
            ],
            [
              -75.7,
              38.52
            ],
            [
              -75.79,
              39.65
            ],
            [
              -75.79,
              39.72
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "District of Columbia",
      fips: "11"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -77.12,
            38.93
          ],
          [
            -77.04,
            38.99
          ],
          [
            -76.91,
            38.89
          ],
          [
            -77.04,
            38.79
          ],
          [
            -77.04,
            38.87
          ],
          [
            -77.12,
            38.93
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Hawaii",
      fips: "15"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -156.06,
              19.74
            ],
            [
              -156.05,
              19.78
            ],
            [
              -155.98,
              19.85
            ],
            [
              -155.94,
              19.85
            ],
            [
              -155.89,
              19.93
            ],
            [
              -155.83,
              19.98
            ],
            [
              -155.82,
              20.03
            ],
            [
              -155.89,
              20.11
            ],
            [
              -155.9,
              20.15
            ],
            [
              -155.9,
              20.24
            ],
            [
              -155.87,
              20.27
            ],
            [
              -155.81,
              20.26
            ],
            [
              -155.75,
              20.23
            ],
            [
              -155.73,
              20.21
            ],
            [
              -155.66,
              20.17
            ],
            [
              -155.6,
              20.13
            ],
            [
              -155.56,
              20.13
            ],
            [
              -155.47,
              20.1
            ],
            [
              -155.33,
              20.04
            ],
            [
              -155.28,
              20.02
            ],
            [
              -155.2,
              19.97
            ],
            [
              -155.15,
              19.92
            ],
            [
              -155.08,
              19.86
            ],
            [
              -155.1,
              19.81
            ],
            [
              -155.09,
              19.74
            ],
            [
              -155.06,
              19.73
            ],
            [
              -155.01,
              19.74
            ],
            [
              -154.98,
              19.69
            ],
            [
              -154.98,
              19.64
            ],
            [
              -154.91,
              19.57
            ],
            [
              -154.83,
              19.54
            ],
            [
              -154.81,
              19.52
            ],
            [
              -154.82,
              19.48
            ],
            [
              -154.87,
              19.44
            ],
            [
              -154.93,
              19.4
            ],
            [
              -154.98,
              19.35
            ],
            [
              -155.06,
              19.32
            ],
            [
              -155.13,
              19.28
            ],
            [
              -155.21,
              19.26
            ],
            [
              -155.26,
              19.27
            ],
            [
              -155.3,
              19.27
            ],
            [
              -155.36,
              19.21
            ],
            [
              -155.42,
              19.19
            ],
            [
              -155.47,
              19.15
            ],
            [
              -155.52,
              19.13
            ],
            [
              -155.56,
              19.08
            ],
            [
              -155.55,
              19.05
            ],
            [
              -155.58,
              19.02
            ],
            [
              -155.6,
              18.97
            ],
            [
              -155.67,
              18.92
            ],
            [
              -155.73,
              18.97
            ],
            [
              -155.81,
              19.01
            ],
            [
              -155.89,
              19.04
            ],
            [
              -155.92,
              19.12
            ],
            [
              -155.9,
              19.22
            ],
            [
              -155.89,
              19.35
            ],
            [
              -155.92,
              19.44
            ],
            [
              -155.92,
              19.48
            ],
            [
              -155.95,
              19.49
            ],
            [
              -155.97,
              19.59
            ],
            [
              -156,
              19.64
            ],
            [
              -156.03,
              19.65
            ],
            [
              -156.06,
              19.74
            ]
          ]
        ],
        [
          [
            [
              -156.7,
              20.92
            ],
            [
              -156.68,
              20.98
            ],
            [
              -156.64,
              21.03
            ],
            [
              -156.59,
              21.03
            ],
            [
              -156.55,
              21
            ],
            [
              -156.51,
              20.94
            ],
            [
              -156.47,
              20.89
            ],
            [
              -156.39,
              20.92
            ],
            [
              -156.32,
              20.95
            ],
            [
              -156.23,
              20.93
            ],
            [
              -156.23,
              20.92
            ],
            [
              -156.17,
              20.87
            ],
            [
              -156.13,
              20.86
            ],
            [
              -156.11,
              20.83
            ],
            [
              -156,
              20.8
            ],
            [
              -155.99,
              20.77
            ],
            [
              -155.99,
              20.72
            ],
            [
              -156.01,
              20.69
            ],
            [
              -156.06,
              20.65
            ],
            [
              -156.08,
              20.65
            ],
            [
              -156.14,
              20.62
            ],
            [
              -156.19,
              20.63
            ],
            [
              -156.3,
              20.59
            ],
            [
              -156.38,
              20.58
            ],
            [
              -156.44,
              20.6
            ],
            [
              -156.46,
              20.78
            ],
            [
              -156.49,
              20.8
            ],
            [
              -156.54,
              20.78
            ],
            [
              -156.63,
              20.82
            ],
            [
              -156.68,
              20.87
            ],
            [
              -156.7,
              20.92
            ]
          ]
        ],
        [
          [
            [
              -156.7,
              20.53
            ],
            [
              -156.68,
              20.56
            ],
            [
              -156.58,
              20.61
            ],
            [
              -156.54,
              20.58
            ],
            [
              -156.56,
              20.54
            ],
            [
              -156.54,
              20.53
            ],
            [
              -156.59,
              20.51
            ],
            [
              -156.6,
              20.52
            ],
            [
              -156.67,
              20.5
            ],
            [
              -156.7,
              20.53
            ]
          ]
        ],
        [
          [
            [
              -157.06,
              20.9
            ],
            [
              -157.04,
              20.93
            ],
            [
              -156.99,
              20.93
            ],
            [
              -156.9,
              20.92
            ],
            [
              -156.84,
              20.86
            ],
            [
              -156.81,
              20.82
            ],
            [
              -156.84,
              20.76
            ],
            [
              -156.91,
              20.74
            ],
            [
              -156.97,
              20.74
            ],
            [
              -156.99,
              20.79
            ],
            [
              -157,
              20.85
            ],
            [
              -157.06,
              20.88
            ],
            [
              -157.06,
              20.9
            ]
          ]
        ],
        [
          [
            [
              -157.31,
              21.1
            ],
            [
              -157.29,
              21.15
            ],
            [
              -157.26,
              21.17
            ],
            [
              -157.26,
              21.22
            ],
            [
              -157.2,
              21.22
            ],
            [
              -157.19,
              21.21
            ],
            [
              -157,
              21.18
            ],
            [
              -156.96,
              21.21
            ],
            [
              -156.95,
              21.18
            ],
            [
              -156.87,
              21.16
            ],
            [
              -156.77,
              21.18
            ],
            [
              -156.71,
              21.16
            ],
            [
              -156.74,
              21.11
            ],
            [
              -156.8,
              21.07
            ],
            [
              -156.88,
              21.05
            ],
            [
              -157,
              21.08
            ],
            [
              -157.09,
              21.1
            ],
            [
              -157.15,
              21.09
            ],
            [
              -157.25,
              21.09
            ],
            [
              -157.31,
              21.1
            ]
          ]
        ],
        [
          [
            [
              -158.28,
              21.58
            ],
            [
              -158.12,
              21.59
            ],
            [
              -158.08,
              21.63
            ],
            [
              -158.06,
              21.66
            ],
            [
              -158.02,
              21.7
            ],
            [
              -157.97,
              21.71
            ],
            [
              -157.95,
              21.69
            ],
            [
              -157.92,
              21.63
            ],
            [
              -157.85,
              21.56
            ],
            [
              -157.84,
              21.51
            ],
            [
              -157.85,
              21.5
            ],
            [
              -157.84,
              21.46
            ],
            [
              -157.78,
              21.41
            ],
            [
              -157.77,
              21.46
            ],
            [
              -157.72,
              21.46
            ],
            [
              -157.74,
              21.4
            ],
            [
              -157.71,
              21.38
            ],
            [
              -157.71,
              21.36
            ],
            [
              -157.65,
              21.3
            ],
            [
              -157.69,
              21.27
            ],
            [
              -157.73,
              21.28
            ],
            [
              -157.81,
              21.26
            ],
            [
              -157.83,
              21.28
            ],
            [
              -157.89,
              21.31
            ],
            [
              -157.98,
              21.32
            ],
            [
              -158.09,
              21.3
            ],
            [
              -158.11,
              21.3
            ],
            [
              -158.14,
              21.37
            ],
            [
              -158.18,
              21.4
            ],
            [
              -158.18,
              21.43
            ],
            [
              -158.23,
              21.49
            ],
            [
              -158.23,
              21.54
            ],
            [
              -158.28,
              21.58
            ]
          ]
        ],
        [
          [
            [
              -159.79,
              22.03
            ],
            [
              -159.78,
              22.06
            ],
            [
              -159.74,
              22.1
            ],
            [
              -159.73,
              22.14
            ],
            [
              -159.61,
              22.2
            ],
            [
              -159.58,
              22.22
            ],
            [
              -159.5,
              22.21
            ],
            [
              -159.49,
              22.23
            ],
            [
              -159.43,
              22.22
            ],
            [
              -159.4,
              22.23
            ],
            [
              -159.35,
              22.22
            ],
            [
              -159.31,
              22.18
            ],
            [
              -159.29,
              22.14
            ],
            [
              -159.29,
              22.11
            ],
            [
              -159.33,
              22.05
            ],
            [
              -159.33,
              21.96
            ],
            [
              -159.35,
              21.94
            ],
            [
              -159.45,
              21.87
            ],
            [
              -159.47,
              21.88
            ],
            [
              -159.6,
              21.89
            ],
            [
              -159.67,
              21.95
            ],
            [
              -159.75,
              21.98
            ],
            [
              -159.79,
              22.03
            ]
          ]
        ],
        [
          [
            [
              -160.25,
              21.85
            ],
            [
              -160.23,
              21.89
            ],
            [
              -160.19,
              21.92
            ],
            [
              -160.12,
              21.96
            ],
            [
              -160.11,
              22
            ],
            [
              -160.07,
              22
            ],
            [
              -160.07,
              21.98
            ],
            [
              -160.08,
              21.93
            ],
            [
              -160.08,
              21.9
            ],
            [
              -160.15,
              21.87
            ],
            [
              -160.21,
              21.79
            ],
            [
              -160.25,
              21.81
            ],
            [
              -160.25,
              21.85
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Iowa",
      fips: "19"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -96.45,
            43.5
          ],
          [
            -95.74,
            43.5
          ],
          [
            -94.62,
            43.5
          ],
          [
            -93.97,
            43.5
          ],
          [
            -93.17,
            43.5
          ],
          [
            -92.75,
            43.5
          ],
          [
            -91.95,
            43.5
          ],
          [
            -91.22,
            43.5
          ],
          [
            -91.23,
            43.46
          ],
          [
            -91.2,
            43.41
          ],
          [
            -91.2,
            43.35
          ],
          [
            -91.11,
            43.31
          ],
          [
            -91.06,
            43.25
          ],
          [
            -91.12,
            43.2
          ],
          [
            -91.15,
            43.15
          ],
          [
            -91.18,
            43.13
          ],
          [
            -91.17,
            43.04
          ],
          [
            -91.15,
            42.96
          ],
          [
            -91.15,
            42.9
          ],
          [
            -91.1,
            42.88
          ],
          [
            -91.06,
            42.74
          ],
          [
            -90.94,
            42.68
          ],
          [
            -90.77,
            42.65
          ],
          [
            -90.71,
            42.63
          ],
          [
            -90.64,
            42.54
          ],
          [
            -90.64,
            42.51
          ],
          [
            -90.64,
            42.47
          ],
          [
            -90.56,
            42.44
          ],
          [
            -90.56,
            42.42
          ],
          [
            -90.48,
            42.38
          ],
          [
            -90.42,
            42.33
          ],
          [
            -90.43,
            42.28
          ],
          [
            -90.38,
            42.21
          ],
          [
            -90.21,
            42.15
          ],
          [
            -90.16,
            42.12
          ],
          [
            -90.17,
            42.04
          ],
          [
            -90.14,
            42.01
          ],
          [
            -90.17,
            41.96
          ],
          [
            -90.15,
            41.91
          ],
          [
            -90.18,
            41.84
          ],
          [
            -90.18,
            41.81
          ],
          [
            -90.28,
            41.77
          ],
          [
            -90.31,
            41.74
          ],
          [
            -90.31,
            41.7
          ],
          [
            -90.34,
            41.65
          ],
          [
            -90.34,
            41.59
          ],
          [
            -90.4,
            41.57
          ],
          [
            -90.46,
            41.52
          ],
          [
            -90.56,
            41.52
          ],
          [
            -90.59,
            41.51
          ],
          [
            -90.65,
            41.47
          ],
          [
            -90.74,
            41.45
          ],
          [
            -90.85,
            41.46
          ],
          [
            -90.93,
            41.42
          ],
          [
            -90.98,
            41.43
          ],
          [
            -91.04,
            41.42
          ],
          [
            -91.07,
            41.37
          ],
          [
            -91.07,
            41.31
          ],
          [
            -91.11,
            41.24
          ],
          [
            -91.04,
            41.17
          ],
          [
            -90.99,
            41.16
          ],
          [
            -90.95,
            41.1
          ],
          [
            -90.94,
            41.01
          ],
          [
            -90.97,
            40.92
          ],
          [
            -91.01,
            40.9
          ],
          [
            -91.06,
            40.85
          ],
          [
            -91.09,
            40.83
          ],
          [
            -91.09,
            40.77
          ],
          [
            -91.12,
            40.73
          ],
          [
            -91.12,
            40.67
          ],
          [
            -91.18,
            40.64
          ],
          [
            -91.25,
            40.64
          ],
          [
            -91.36,
            40.6
          ],
          [
            -91.41,
            40.54
          ],
          [
            -91.37,
            40.51
          ],
          [
            -91.38,
            40.44
          ],
          [
            -91.37,
            40.39
          ],
          [
            -91.42,
            40.38
          ],
          [
            -91.49,
            40.38
          ],
          [
            -91.53,
            40.41
          ],
          [
            -91.53,
            40.46
          ],
          [
            -91.56,
            40.46
          ],
          [
            -91.62,
            40.51
          ],
          [
            -91.62,
            40.54
          ],
          [
            -91.68,
            40.55
          ],
          [
            -91.69,
            40.58
          ],
          [
            -91.73,
            40.61
          ],
          [
            -92.09,
            40.6
          ],
          [
            -92.64,
            40.59
          ],
          [
            -93.35,
            40.58
          ],
          [
            -93.57,
            40.58
          ],
          [
            -94.03,
            40.57
          ],
          [
            -94.59,
            40.57
          ],
          [
            -95.17,
            40.58
          ],
          [
            -95.76,
            40.59
          ],
          [
            -95.75,
            40.61
          ],
          [
            -95.79,
            40.66
          ],
          [
            -95.83,
            40.67
          ],
          [
            -95.89,
            40.72
          ],
          [
            -95.88,
            40.75
          ],
          [
            -95.83,
            40.78
          ],
          [
            -95.85,
            40.85
          ],
          [
            -95.81,
            40.9
          ],
          [
            -95.84,
            40.92
          ],
          [
            -95.83,
            40.98
          ],
          [
            -95.86,
            41
          ],
          [
            -95.86,
            41.03
          ],
          [
            -95.88,
            41.06
          ],
          [
            -95.86,
            41.08
          ],
          [
            -95.88,
            41.16
          ],
          [
            -95.84,
            41.17
          ],
          [
            -95.93,
            41.2
          ],
          [
            -95.91,
            41.23
          ],
          [
            -95.93,
            41.28
          ],
          [
            -95.88,
            41.32
          ],
          [
            -95.95,
            41.34
          ],
          [
            -95.93,
            41.36
          ],
          [
            -95.93,
            41.46
          ],
          [
            -96,
            41.47
          ],
          [
            -96,
            41.54
          ],
          [
            -96.03,
            41.54
          ],
          [
            -96.04,
            41.51
          ],
          [
            -96.09,
            41.53
          ],
          [
            -96.08,
            41.58
          ],
          [
            -96.12,
            41.61
          ],
          [
            -96.09,
            41.65
          ],
          [
            -96.12,
            41.68
          ],
          [
            -96.08,
            41.7
          ],
          [
            -96.11,
            41.74
          ],
          [
            -96.08,
            41.76
          ],
          [
            -96.07,
            41.8
          ],
          [
            -96.11,
            41.82
          ],
          [
            -96.11,
            41.85
          ],
          [
            -96.16,
            41.91
          ],
          [
            -96.14,
            41.92
          ],
          [
            -96.13,
            41.97
          ],
          [
            -96.19,
            41.98
          ],
          [
            -96.18,
            42
          ],
          [
            -96.24,
            42.01
          ],
          [
            -96.22,
            42.03
          ],
          [
            -96.27,
            42.05
          ],
          [
            -96.27,
            42.12
          ],
          [
            -96.35,
            42.17
          ],
          [
            -96.36,
            42.21
          ],
          [
            -96.32,
            42.23
          ],
          [
            -96.37,
            42.32
          ],
          [
            -96.41,
            42.34
          ],
          [
            -96.41,
            42.41
          ],
          [
            -96.38,
            42.45
          ],
          [
            -96.4,
            42.48
          ],
          [
            -96.45,
            42.49
          ],
          [
            -96.49,
            42.52
          ],
          [
            -96.48,
            42.56
          ],
          [
            -96.51,
            42.63
          ],
          [
            -96.58,
            42.68
          ],
          [
            -96.63,
            42.71
          ],
          [
            -96.63,
            42.77
          ],
          [
            -96.59,
            42.79
          ],
          [
            -96.58,
            42.84
          ],
          [
            -96.54,
            42.85
          ],
          [
            -96.54,
            42.92
          ],
          [
            -96.5,
            42.96
          ],
          [
            -96.52,
            42.98
          ],
          [
            -96.49,
            43
          ],
          [
            -96.51,
            43.05
          ],
          [
            -96.46,
            43.06
          ],
          [
            -96.44,
            43.12
          ],
          [
            -96.47,
            43.15
          ],
          [
            -96.48,
            43.22
          ],
          [
            -96.56,
            43.22
          ],
          [
            -96.55,
            43.25
          ],
          [
            -96.58,
            43.3
          ],
          [
            -96.53,
            43.3
          ],
          [
            -96.53,
            43.39
          ],
          [
            -96.6,
            43.45
          ],
          [
            -96.58,
            43.48
          ],
          [
            -96.6,
            43.5
          ],
          [
            -96.45,
            43.5
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Kentucky",
      fips: "21"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -89.13,
              36.98
            ],
            [
              -89.18,
              37.03
            ],
            [
              -89.17,
              37.07
            ],
            [
              -89.11,
              37.12
            ],
            [
              -89.08,
              37.17
            ],
            [
              -89.03,
              37.21
            ],
            [
              -88.98,
              37.23
            ],
            [
              -88.92,
              37.22
            ],
            [
              -88.8,
              37.19
            ],
            [
              -88.75,
              37.16
            ],
            [
              -88.63,
              37.12
            ],
            [
              -88.56,
              37.08
            ],
            [
              -88.51,
              37.06
            ],
            [
              -88.46,
              37.07
            ],
            [
              -88.42,
              37.15
            ],
            [
              -88.45,
              37.21
            ],
            [
              -88.51,
              37.26
            ],
            [
              -88.52,
              37.28
            ],
            [
              -88.49,
              37.34
            ],
            [
              -88.48,
              37.39
            ],
            [
              -88.41,
              37.42
            ],
            [
              -88.36,
              37.4
            ],
            [
              -88.3,
              37.45
            ],
            [
              -88.26,
              37.46
            ],
            [
              -88.08,
              37.47
            ],
            [
              -88.06,
              37.52
            ],
            [
              -88.13,
              37.57
            ],
            [
              -88.16,
              37.66
            ],
            [
              -88.12,
              37.71
            ],
            [
              -88.06,
              37.74
            ],
            [
              -88.03,
              37.8
            ],
            [
              -87.95,
              37.77
            ],
            [
              -87.9,
              37.81
            ],
            [
              -87.94,
              37.89
            ],
            [
              -87.9,
              37.92
            ],
            [
              -87.87,
              37.92
            ],
            [
              -87.83,
              37.88
            ],
            [
              -87.68,
              37.9
            ],
            [
              -87.66,
              37.88
            ],
            [
              -87.67,
              37.83
            ],
            [
              -87.63,
              37.83
            ],
            [
              -87.59,
              37.86
            ],
            [
              -87.63,
              37.92
            ],
            [
              -87.6,
              37.97
            ],
            [
              -87.57,
              37.97
            ],
            [
              -87.55,
              37.93
            ],
            [
              -87.5,
              37.91
            ],
            [
              -87.45,
              37.94
            ],
            [
              -87.38,
              37.94
            ],
            [
              -87.3,
              37.9
            ],
            [
              -87.22,
              37.85
            ],
            [
              -87.16,
              37.84
            ],
            [
              -87.13,
              37.78
            ],
            [
              -87.09,
              37.79
            ],
            [
              -87.06,
              37.81
            ],
            [
              -87.05,
              37.89
            ],
            [
              -87.01,
              37.92
            ],
            [
              -86.91,
              37.94
            ],
            [
              -86.86,
              37.99
            ],
            [
              -86.79,
              37.99
            ],
            [
              -86.75,
              37.91
            ],
            [
              -86.72,
              37.89
            ],
            [
              -86.68,
              37.92
            ],
            [
              -86.64,
              37.91
            ],
            [
              -86.66,
              37.86
            ],
            [
              -86.64,
              37.84
            ],
            [
              -86.6,
              37.87
            ],
            [
              -86.59,
              37.92
            ],
            [
              -86.51,
              37.93
            ],
            [
              -86.53,
              37.96
            ],
            [
              -86.52,
              38.04
            ],
            [
              -86.45,
              38.05
            ],
            [
              -86.43,
              38.09
            ],
            [
              -86.46,
              38.1
            ],
            [
              -86.43,
              38.13
            ],
            [
              -86.4,
              38.11
            ],
            [
              -86.37,
              38.13
            ],
            [
              -86.33,
              38.13
            ],
            [
              -86.32,
              38.15
            ],
            [
              -86.37,
              38.16
            ],
            [
              -86.37,
              38.19
            ],
            [
              -86.35,
              38.2
            ],
            [
              -86.27,
              38.14
            ],
            [
              -86.27,
              38.06
            ],
            [
              -86.17,
              38.01
            ],
            [
              -86.09,
              38.01
            ],
            [
              -86.05,
              37.96
            ],
            [
              -86.03,
              37.99
            ],
            [
              -85.95,
              38.01
            ],
            [
              -85.92,
              38.03
            ],
            [
              -85.9,
              38.09
            ],
            [
              -85.91,
              38.16
            ],
            [
              -85.85,
              38.22
            ],
            [
              -85.83,
              38.28
            ],
            [
              -85.79,
              38.29
            ],
            [
              -85.74,
              38.27
            ],
            [
              -85.67,
              38.3
            ],
            [
              -85.61,
              38.44
            ],
            [
              -85.5,
              38.47
            ],
            [
              -85.47,
              38.51
            ],
            [
              -85.42,
              38.54
            ],
            [
              -85.44,
              38.6
            ],
            [
              -85.45,
              38.71
            ],
            [
              -85.41,
              38.74
            ],
            [
              -85.35,
              38.73
            ],
            [
              -85.26,
              38.74
            ],
            [
              -85.22,
              38.7
            ],
            [
              -85.15,
              38.69
            ],
            [
              -85.1,
              38.73
            ],
            [
              -84.98,
              38.78
            ],
            [
              -84.95,
              38.78
            ],
            [
              -84.89,
              38.8
            ],
            [
              -84.81,
              38.79
            ],
            [
              -84.83,
              38.83
            ],
            [
              -84.78,
              38.87
            ],
            [
              -84.8,
              38.89
            ],
            [
              -84.86,
              38.9
            ],
            [
              -84.87,
              38.93
            ],
            [
              -84.83,
              38.96
            ],
            [
              -84.84,
              38.99
            ],
            [
              -84.9,
              39.05
            ],
            [
              -84.89,
              39.07
            ],
            [
              -84.82,
              39.11
            ],
            [
              -84.76,
              39.15
            ],
            [
              -84.73,
              39.14
            ],
            [
              -84.68,
              39.1
            ],
            [
              -84.6,
              39.07
            ],
            [
              -84.55,
              39.1
            ],
            [
              -84.5,
              39.1
            ],
            [
              -84.47,
              39.12
            ],
            [
              -84.44,
              39.11
            ],
            [
              -84.43,
              39.06
            ],
            [
              -84.33,
              39.03
            ],
            [
              -84.29,
              38.96
            ],
            [
              -84.23,
              38.88
            ],
            [
              -84.23,
              38.83
            ],
            [
              -84.21,
              38.81
            ],
            [
              -84.07,
              38.77
            ],
            [
              -83.95,
              38.79
            ],
            [
              -83.85,
              38.75
            ],
            [
              -83.84,
              38.72
            ],
            [
              -83.78,
              38.7
            ],
            [
              -83.77,
              38.65
            ],
            [
              -83.66,
              38.63
            ],
            [
              -83.61,
              38.68
            ],
            [
              -83.52,
              38.7
            ],
            [
              -83.47,
              38.68
            ],
            [
              -83.37,
              38.66
            ],
            [
              -83.33,
              38.64
            ],
            [
              -83.31,
              38.6
            ],
            [
              -83.26,
              38.62
            ],
            [
              -83.16,
              38.62
            ],
            [
              -83.12,
              38.67
            ],
            [
              -83.05,
              38.7
            ],
            [
              -83.02,
              38.73
            ],
            [
              -82.97,
              38.73
            ],
            [
              -82.89,
              38.76
            ],
            [
              -82.87,
              38.73
            ],
            [
              -82.88,
              38.69
            ],
            [
              -82.85,
              38.59
            ],
            [
              -82.8,
              38.56
            ],
            [
              -82.72,
              38.56
            ],
            [
              -82.65,
              38.49
            ],
            [
              -82.6,
              38.46
            ],
            [
              -82.6,
              38.42
            ],
            [
              -82.6,
              38.34
            ],
            [
              -82.57,
              38.31
            ],
            [
              -82.57,
              38.26
            ],
            [
              -82.61,
              38.24
            ],
            [
              -82.6,
              38.22
            ],
            [
              -82.61,
              38.17
            ],
            [
              -82.64,
              38.17
            ],
            [
              -82.64,
              38.14
            ],
            [
              -82.58,
              38.11
            ],
            [
              -82.55,
              38.07
            ],
            [
              -82.52,
              38
            ],
            [
              -82.46,
              37.98
            ],
            [
              -82.5,
              37.93
            ],
            [
              -82.47,
              37.9
            ],
            [
              -82.42,
              37.88
            ],
            [
              -82.42,
              37.85
            ],
            [
              -82.38,
              37.8
            ],
            [
              -82.34,
              37.79
            ],
            [
              -82.29,
              37.67
            ],
            [
              -82.24,
              37.66
            ],
            [
              -82.21,
              37.63
            ],
            [
              -82.18,
              37.63
            ],
            [
              -82.16,
              37.59
            ],
            [
              -82.13,
              37.59
            ],
            [
              -82.12,
              37.56
            ],
            [
              -82.02,
              37.53
            ],
            [
              -81.97,
              37.54
            ],
            [
              -82.35,
              37.27
            ],
            [
              -82.49,
              37.23
            ],
            [
              -82.57,
              37.2
            ],
            [
              -82.63,
              37.15
            ],
            [
              -82.72,
              37.12
            ],
            [
              -82.72,
              37.04
            ],
            [
              -82.78,
              37.01
            ],
            [
              -82.83,
              37.01
            ],
            [
              -82.87,
              36.98
            ],
            [
              -82.86,
              36.93
            ],
            [
              -82.88,
              36.89
            ],
            [
              -82.97,
              36.86
            ],
            [
              -83.07,
              36.85
            ],
            [
              -83.13,
              36.79
            ],
            [
              -83.14,
              36.74
            ],
            [
              -83.19,
              36.74
            ],
            [
              -83.31,
              36.71
            ],
            [
              -83.45,
              36.66
            ],
            [
              -83.53,
              36.67
            ],
            [
              -83.65,
              36.62
            ],
            [
              -83.68,
              36.6
            ],
            [
              -83.69,
              36.58
            ],
            [
              -83.99,
              36.59
            ],
            [
              -84.27,
              36.59
            ],
            [
              -84.54,
              36.6
            ],
            [
              -84.84,
              36.61
            ],
            [
              -85.03,
              36.62
            ],
            [
              -85.29,
              36.63
            ],
            [
              -85.49,
              36.61
            ],
            [
              -85.83,
              36.62
            ],
            [
              -86.03,
              36.63
            ],
            [
              -86.33,
              36.65
            ],
            [
              -86.51,
              36.65
            ],
            [
              -86.57,
              36.63
            ],
            [
              -86.59,
              36.65
            ],
            [
              -87.11,
              36.64
            ],
            [
              -87.44,
              36.64
            ],
            [
              -87.85,
              36.63
            ],
            [
              -87.85,
              36.66
            ],
            [
              -88.07,
              36.68
            ],
            [
              -88.03,
              36.55
            ],
            [
              -88.05,
              36.5
            ],
            [
              -88.55,
              36.5
            ],
            [
              -89,
              36.5
            ],
            [
              -89.3,
              36.51
            ],
            [
              -89.42,
              36.5
            ],
            [
              -89.37,
              36.62
            ],
            [
              -89.33,
              36.63
            ],
            [
              -89.26,
              36.56
            ],
            [
              -89.21,
              36.58
            ],
            [
              -89.19,
              36.64
            ],
            [
              -89.16,
              36.67
            ],
            [
              -89.2,
              36.72
            ],
            [
              -89.19,
              36.75
            ],
            [
              -89.13,
              36.75
            ],
            [
              -89.12,
              36.78
            ],
            [
              -89.18,
              36.81
            ],
            [
              -89.17,
              36.84
            ],
            [
              -89.14,
              36.85
            ],
            [
              -89.12,
              36.89
            ],
            [
              -89.1,
              36.96
            ],
            [
              -89.13,
              36.98
            ]
          ]
        ],
        [
          [
            [
              -89.49,
              36.5
            ],
            [
              -89.54,
              36.5
            ],
            [
              -89.57,
              36.55
            ],
            [
              -89.56,
              36.57
            ],
            [
              -89.48,
              36.57
            ],
            [
              -89.47,
              36.53
            ],
            [
              -89.49,
              36.5
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Maryland",
      fips: "24"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -75.99,
              37.95
            ],
            [
              -76.04,
              37.95
            ],
            [
              -76.05,
              38.02
            ],
            [
              -76.02,
              38.04
            ],
            [
              -75.98,
              38
            ],
            [
              -75.99,
              37.95
            ]
          ]
        ],
        [
          [
            [
              -76.1,
              38.12
            ],
            [
              -76.09,
              38.19
            ],
            [
              -76.05,
              38.2
            ],
            [
              -76.02,
              38.18
            ],
            [
              -76.01,
              38.08
            ],
            [
              -76.06,
              38.09
            ],
            [
              -76.04,
              38.12
            ],
            [
              -76.1,
              38.12
            ]
          ]
        ],
        [
          [
            [
              -76.4,
              38.77
            ],
            [
              -76.38,
              38.79
            ],
            [
              -76.36,
              38.75
            ],
            [
              -76.4,
              38.77
            ]
          ]
        ],
        [
          [
            [
              -79.48,
              39.72
            ],
            [
              -78.38,
              39.72
            ],
            [
              -77.53,
              39.72
            ],
            [
              -76.99,
              39.72
            ],
            [
              -76.57,
              39.72
            ],
            [
              -75.79,
              39.72
            ],
            [
              -75.79,
              39.65
            ],
            [
              -75.7,
              38.52
            ],
            [
              -75.69,
              38.46
            ],
            [
              -75.43,
              38.45
            ],
            [
              -75.05,
              38.45
            ],
            [
              -75.05,
              38.41
            ],
            [
              -75.09,
              38.32
            ],
            [
              -75.1,
              38.31
            ],
            [
              -75.18,
              38.13
            ],
            [
              -75.24,
              38.03
            ],
            [
              -75.62,
              37.99
            ],
            [
              -75.65,
              37.95
            ],
            [
              -75.67,
              37.95
            ],
            [
              -75.71,
              37.98
            ],
            [
              -75.78,
              37.97
            ],
            [
              -75.86,
              37.92
            ],
            [
              -75.89,
              37.92
            ],
            [
              -75.9,
              37.97
            ],
            [
              -75.87,
              38.03
            ],
            [
              -75.81,
              38.06
            ],
            [
              -75.87,
              38.06
            ],
            [
              -75.87,
              38.1
            ],
            [
              -75.83,
              38.13
            ],
            [
              -75.9,
              38.14
            ],
            [
              -75.94,
              38.11
            ],
            [
              -75.96,
              38.14
            ],
            [
              -75.94,
              38.19
            ],
            [
              -75.85,
              38.21
            ],
            [
              -75.87,
              38.24
            ],
            [
              -75.9,
              38.23
            ],
            [
              -75.92,
              38.26
            ],
            [
              -75.86,
              38.36
            ],
            [
              -75.92,
              38.34
            ],
            [
              -75.94,
              38.3
            ],
            [
              -75.94,
              38.25
            ],
            [
              -75.97,
              38.25
            ],
            [
              -76.01,
              38.31
            ],
            [
              -75.97,
              38.32
            ],
            [
              -75.97,
              38.37
            ],
            [
              -76,
              38.37
            ],
            [
              -76.02,
              38.33
            ],
            [
              -76.05,
              38.3
            ],
            [
              -76.03,
              38.28
            ],
            [
              -76.06,
              38.23
            ],
            [
              -76.07,
              38.25
            ],
            [
              -76.13,
              38.23
            ],
            [
              -76.17,
              38.24
            ],
            [
              -76.22,
              38.31
            ],
            [
              -76.26,
              38.33
            ],
            [
              -76.25,
              38.36
            ],
            [
              -76.34,
              38.49
            ],
            [
              -76.26,
              38.5
            ],
            [
              -76.25,
              38.54
            ],
            [
              -76.27,
              38.53
            ],
            [
              -76.31,
              38.58
            ],
            [
              -76.28,
              38.61
            ],
            [
              -76.24,
              38.63
            ],
            [
              -76.21,
              38.61
            ],
            [
              -76.17,
              38.63
            ],
            [
              -76.17,
              38.6
            ],
            [
              -76.09,
              38.59
            ],
            [
              -76.04,
              38.56
            ],
            [
              -76.03,
              38.57
            ],
            [
              -76.08,
              38.62
            ],
            [
              -76.15,
              38.64
            ],
            [
              -76.17,
              38.67
            ],
            [
              -76.2,
              38.67
            ],
            [
              -76.26,
              38.74
            ],
            [
              -76.27,
              38.71
            ],
            [
              -76.32,
              38.73
            ],
            [
              -76.32,
              38.68
            ],
            [
              -76.35,
              38.69
            ],
            [
              -76.34,
              38.77
            ],
            [
              -76.27,
              38.85
            ],
            [
              -76.22,
              38.81
            ],
            [
              -76.19,
              38.82
            ],
            [
              -76.2,
              38.93
            ],
            [
              -76.23,
              38.94
            ],
            [
              -76.29,
              38.9
            ],
            [
              -76.34,
              38.91
            ],
            [
              -76.33,
              38.86
            ],
            [
              -76.38,
              38.85
            ],
            [
              -76.36,
              38.94
            ],
            [
              -76.3,
              39.03
            ],
            [
              -76.28,
              38.98
            ],
            [
              -76.2,
              38.97
            ],
            [
              -76.16,
              39
            ],
            [
              -76.18,
              39.05
            ],
            [
              -76.15,
              39.09
            ],
            [
              -76.2,
              39.09
            ],
            [
              -76.21,
              39.04
            ],
            [
              -76.2,
              39.01
            ],
            [
              -76.24,
              39.03
            ],
            [
              -76.23,
              39.08
            ],
            [
              -76.25,
              39.13
            ],
            [
              -76.28,
              39.15
            ],
            [
              -76.22,
              39.26
            ],
            [
              -76.18,
              39.3
            ],
            [
              -76.18,
              39.32
            ],
            [
              -76.13,
              39.34
            ],
            [
              -76.11,
              39.37
            ],
            [
              -76,
              39.37
            ],
            [
              -76.04,
              39.39
            ],
            [
              -75.98,
              39.45
            ],
            [
              -76.01,
              39.45
            ],
            [
              -75.97,
              39.56
            ],
            [
              -76.1,
              39.54
            ],
            [
              -76.12,
              39.5
            ],
            [
              -76.07,
              39.48
            ],
            [
              -76.06,
              39.45
            ],
            [
              -76.1,
              39.44
            ],
            [
              -76.22,
              39.35
            ],
            [
              -76.25,
              39.38
            ],
            [
              -76.22,
              39.43
            ],
            [
              -76.25,
              39.45
            ],
            [
              -76.25,
              39.41
            ],
            [
              -76.29,
              39.37
            ],
            [
              -76.26,
              39.34
            ],
            [
              -76.28,
              39.3
            ],
            [
              -76.3,
              39.38
            ],
            [
              -76.36,
              39.39
            ],
            [
              -76.34,
              39.31
            ],
            [
              -76.36,
              39.31
            ],
            [
              -76.39,
              39.28
            ],
            [
              -76.34,
              39.26
            ],
            [
              -76.42,
              39.22
            ],
            [
              -76.44,
              39.2
            ],
            [
              -76.49,
              39.2
            ],
            [
              -76.5,
              39.22
            ],
            [
              -76.58,
              39.26
            ],
            [
              -76.57,
              39.22
            ],
            [
              -76.53,
              39.21
            ],
            [
              -76.53,
              39.18
            ],
            [
              -76.43,
              39.13
            ],
            [
              -76.42,
              39.07
            ],
            [
              -76.44,
              39.05
            ],
            [
              -76.39,
              39.01
            ],
            [
              -76.48,
              38.97
            ],
            [
              -76.45,
              38.94
            ],
            [
              -76.46,
              38.91
            ],
            [
              -76.49,
              38.91
            ],
            [
              -76.52,
              38.86
            ],
            [
              -76.5,
              38.82
            ],
            [
              -76.56,
              38.77
            ],
            [
              -76.53,
              38.72
            ],
            [
              -76.53,
              38.68
            ],
            [
              -76.51,
              38.62
            ],
            [
              -76.52,
              38.54
            ],
            [
              -76.49,
              38.48
            ],
            [
              -76.41,
              38.41
            ],
            [
              -76.39,
              38.36
            ],
            [
              -76.42,
              38.32
            ],
            [
              -76.47,
              38.33
            ],
            [
              -76.44,
              38.29
            ],
            [
              -76.4,
              38.31
            ],
            [
              -76.38,
              38.3
            ],
            [
              -76.4,
              38.26
            ],
            [
              -76.39,
              38.22
            ],
            [
              -76.32,
              38.14
            ],
            [
              -76.34,
              38.12
            ],
            [
              -76.32,
              38.04
            ],
            [
              -76.35,
              38.05
            ],
            [
              -76.39,
              38.1
            ],
            [
              -76.42,
              38.11
            ],
            [
              -76.44,
              38.16
            ],
            [
              -76.47,
              38.15
            ],
            [
              -76.48,
              38.1
            ],
            [
              -76.5,
              38.14
            ],
            [
              -76.53,
              38.13
            ],
            [
              -76.55,
              38.18
            ],
            [
              -76.59,
              38.21
            ],
            [
              -76.67,
              38.23
            ],
            [
              -76.8,
              38.24
            ],
            [
              -76.83,
              38.35
            ],
            [
              -76.86,
              38.36
            ],
            [
              -76.87,
              38.33
            ],
            [
              -76.83,
              38.27
            ],
            [
              -76.84,
              38.25
            ],
            [
              -76.92,
              38.29
            ],
            [
              -76.93,
              38.32
            ],
            [
              -76.97,
              38.35
            ],
            [
              -77.02,
              38.45
            ],
            [
              -77.09,
              38.41
            ],
            [
              -77.21,
              38.36
            ],
            [
              -77.25,
              38.38
            ],
            [
              -77.28,
              38.48
            ],
            [
              -77.24,
              38.55
            ],
            [
              -77.18,
              38.6
            ],
            [
              -77.11,
              38.63
            ],
            [
              -77.13,
              38.64
            ],
            [
              -77.13,
              38.67
            ],
            [
              -77.11,
              38.7
            ],
            [
              -77.04,
              38.72
            ],
            [
              -77.04,
              38.79
            ],
            [
              -76.91,
              38.89
            ],
            [
              -77.04,
              38.99
            ],
            [
              -77.12,
              38.93
            ],
            [
              -77.15,
              38.97
            ],
            [
              -77.22,
              38.97
            ],
            [
              -77.25,
              38.99
            ],
            [
              -77.25,
              39.03
            ],
            [
              -77.34,
              39.06
            ],
            [
              -77.46,
              39.08
            ],
            [
              -77.48,
              39.11
            ],
            [
              -77.52,
              39.12
            ],
            [
              -77.52,
              39.17
            ],
            [
              -77.48,
              39.19
            ],
            [
              -77.46,
              39.23
            ],
            [
              -77.54,
              39.26
            ],
            [
              -77.56,
              39.3
            ],
            [
              -77.62,
              39.3
            ],
            [
              -77.67,
              39.32
            ],
            [
              -77.72,
              39.32
            ],
            [
              -77.76,
              39.33
            ],
            [
              -77.74,
              39.39
            ],
            [
              -77.75,
              39.42
            ],
            [
              -77.79,
              39.44
            ],
            [
              -77.78,
              39.46
            ],
            [
              -77.85,
              39.5
            ],
            [
              -77.89,
              39.56
            ],
            [
              -77.83,
              39.57
            ],
            [
              -77.83,
              39.6
            ],
            [
              -77.88,
              39.6
            ],
            [
              -77.94,
              39.62
            ],
            [
              -78.01,
              39.6
            ],
            [
              -78.04,
              39.64
            ],
            [
              -78.1,
              39.68
            ],
            [
              -78.18,
              39.7
            ],
            [
              -78.28,
              39.62
            ],
            [
              -78.35,
              39.64
            ],
            [
              -78.39,
              39.61
            ],
            [
              -78.44,
              39.62
            ],
            [
              -78.4,
              39.59
            ],
            [
              -78.44,
              39.59
            ],
            [
              -78.42,
              39.55
            ],
            [
              -78.47,
              39.52
            ],
            [
              -78.57,
              39.52
            ],
            [
              -78.59,
              39.54
            ],
            [
              -78.65,
              39.53
            ],
            [
              -78.73,
              39.56
            ],
            [
              -78.73,
              39.59
            ],
            [
              -78.78,
              39.6
            ],
            [
              -78.73,
              39.61
            ],
            [
              -78.78,
              39.62
            ],
            [
              -78.92,
              39.49
            ],
            [
              -78.96,
              39.44
            ],
            [
              -79.06,
              39.47
            ],
            [
              -79.1,
              39.47
            ],
            [
              -79.14,
              39.41
            ],
            [
              -79.25,
              39.36
            ],
            [
              -79.29,
              39.3
            ],
            [
              -79.33,
              39.3
            ],
            [
              -79.45,
              39.21
            ],
            [
              -79.49,
              39.21
            ],
            [
              -79.48,
              39.72
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Michigan",
      fips: "26"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -84.65,
              45.86
            ],
            [
              -84.62,
              45.88
            ],
            [
              -84.59,
              45.83
            ],
            [
              -84.36,
              45.77
            ],
            [
              -84.42,
              45.72
            ],
            [
              -84.5,
              45.74
            ],
            [
              -84.55,
              45.79
            ],
            [
              -84.65,
              45.86
            ]
          ]
        ],
        [
          [
            [
              -85.39,
              45.78
            ],
            [
              -85.38,
              45.81
            ],
            [
              -85.35,
              45.8
            ],
            [
              -85.39,
              45.78
            ]
          ]
        ],
        [
          [
            [
              -85.52,
              45.83
            ],
            [
              -85.45,
              45.8
            ],
            [
              -85.46,
              45.77
            ],
            [
              -85.53,
              45.8
            ],
            [
              -85.52,
              45.83
            ]
          ]
        ],
        [
          [
            [
              -85.63,
              45.6
            ],
            [
              -85.6,
              45.64
            ],
            [
              -85.59,
              45.7
            ],
            [
              -85.57,
              45.71
            ],
            [
              -85.57,
              45.76
            ],
            [
              -85.5,
              45.75
            ],
            [
              -85.51,
              45.68
            ],
            [
              -85.49,
              45.61
            ],
            [
              -85.56,
              45.57
            ],
            [
              -85.63,
              45.6
            ]
          ]
        ],
        [
          [
            [
              -85.7,
              45.74
            ],
            [
              -85.65,
              45.74
            ],
            [
              -85.67,
              45.7
            ],
            [
              -85.7,
              45.7
            ],
            [
              -85.7,
              45.74
            ]
          ]
        ],
        [
          [
            [
              -85.88,
              45.44
            ],
            [
              -85.84,
              45.43
            ],
            [
              -85.83,
              45.38
            ],
            [
              -85.88,
              45.44
            ]
          ]
        ],
        [
          [
            [
              -86.07,
              45.14
            ],
            [
              -86.04,
              45.16
            ],
            [
              -85.98,
              45.14
            ],
            [
              -86,
              45.06
            ],
            [
              -86.06,
              45.1
            ],
            [
              -86.07,
              45.14
            ]
          ]
        ],
        [
          [
            [
              -86.16,
              45.01
            ],
            [
              -86.12,
              45.05
            ],
            [
              -86.09,
              45.01
            ],
            [
              -86.16,
              45.01
            ]
          ]
        ],
        [
          [
            [
              -86.69,
              45.62
            ],
            [
              -86.62,
              45.56
            ],
            [
              -86.65,
              45.54
            ],
            [
              -86.66,
              45.57
            ],
            [
              -86.71,
              45.61
            ],
            [
              -86.69,
              45.62
            ]
          ]
        ],
        [
          [
            [
              -86.82,
              41.76
            ],
            [
              -86.72,
              41.82
            ],
            [
              -86.62,
              41.89
            ],
            [
              -86.49,
              42.12
            ],
            [
              -86.36,
              42.24
            ],
            [
              -86.3,
              42.36
            ],
            [
              -86.26,
              42.44
            ],
            [
              -86.22,
              42.59
            ],
            [
              -86.23,
              42.64
            ],
            [
              -86.21,
              42.72
            ],
            [
              -86.21,
              42.86
            ],
            [
              -86.23,
              43.02
            ],
            [
              -86.27,
              43.12
            ],
            [
              -86.4,
              43.32
            ],
            [
              -86.44,
              43.4
            ],
            [
              -86.48,
              43.52
            ],
            [
              -86.54,
              43.62
            ],
            [
              -86.54,
              43.66
            ],
            [
              -86.46,
              43.75
            ],
            [
              -86.44,
              43.79
            ],
            [
              -86.43,
              43.86
            ],
            [
              -86.46,
              43.97
            ],
            [
              -86.51,
              44.05
            ],
            [
              -86.5,
              44.08
            ],
            [
              -86.43,
              44.12
            ],
            [
              -86.34,
              44.25
            ],
            [
              -86.27,
              44.35
            ],
            [
              -86.25,
              44.45
            ],
            [
              -86.22,
              44.57
            ],
            [
              -86.26,
              44.66
            ],
            [
              -86.26,
              44.69
            ],
            [
              -86.16,
              44.73
            ],
            [
              -86.09,
              44.74
            ],
            [
              -86.07,
              44.82
            ],
            [
              -86.07,
              44.88
            ],
            [
              -86.04,
              44.92
            ],
            [
              -85.99,
              44.9
            ],
            [
              -85.93,
              44.97
            ],
            [
              -85.87,
              44.94
            ],
            [
              -85.81,
              44.95
            ],
            [
              -85.78,
              44.98
            ],
            [
              -85.75,
              45.05
            ],
            [
              -85.71,
              45.07
            ],
            [
              -85.66,
              45.15
            ],
            [
              -85.62,
              45.19
            ],
            [
              -85.59,
              45.18
            ],
            [
              -85.54,
              45.21
            ],
            [
              -85.53,
              45.18
            ],
            [
              -85.6,
              45.15
            ],
            [
              -85.61,
              45.11
            ],
            [
              -85.57,
              45.04
            ],
            [
              -85.65,
              44.97
            ],
            [
              -85.6,
              44.99
            ],
            [
              -85.6,
              44.93
            ],
            [
              -85.62,
              44.92
            ],
            [
              -85.65,
              44.85
            ],
            [
              -85.63,
              44.77
            ],
            [
              -85.6,
              44.77
            ],
            [
              -85.53,
              44.89
            ],
            [
              -85.52,
              44.97
            ],
            [
              -85.47,
              44.99
            ],
            [
              -85.5,
              44.86
            ],
            [
              -85.56,
              44.82
            ],
            [
              -85.58,
              44.76
            ],
            [
              -85.53,
              44.75
            ],
            [
              -85.5,
              44.8
            ],
            [
              -85.47,
              44.82
            ],
            [
              -85.39,
              44.93
            ],
            [
              -85.38,
              45
            ],
            [
              -85.38,
              45.05
            ],
            [
              -85.37,
              45.12
            ],
            [
              -85.39,
              45.19
            ],
            [
              -85.37,
              45.27
            ],
            [
              -85.31,
              45.31
            ],
            [
              -85.27,
              45.32
            ],
            [
              -85.21,
              45.36
            ],
            [
              -85.14,
              45.37
            ],
            [
              -85.05,
              45.36
            ],
            [
              -84.96,
              45.38
            ],
            [
              -84.92,
              45.39
            ],
            [
              -84.92,
              45.42
            ],
            [
              -85.04,
              45.44
            ],
            [
              -85.09,
              45.48
            ],
            [
              -85.12,
              45.57
            ],
            [
              -85.06,
              45.64
            ],
            [
              -85.01,
              45.65
            ],
            [
              -84.94,
              45.71
            ],
            [
              -84.95,
              45.74
            ],
            [
              -85.01,
              45.76
            ],
            [
              -84.8,
              45.75
            ],
            [
              -84.77,
              45.79
            ],
            [
              -84.56,
              45.7
            ],
            [
              -84.46,
              45.65
            ],
            [
              -84.42,
              45.67
            ],
            [
              -84.38,
              45.66
            ],
            [
              -84.33,
              45.66
            ],
            [
              -84.21,
              45.63
            ],
            [
              -84.13,
              45.56
            ],
            [
              -84.12,
              45.51
            ],
            [
              -84.06,
              45.49
            ],
            [
              -83.94,
              45.49
            ],
            [
              -83.91,
              45.49
            ],
            [
              -83.8,
              45.42
            ],
            [
              -83.72,
              45.41
            ],
            [
              -83.6,
              45.35
            ],
            [
              -83.5,
              45.36
            ],
            [
              -83.42,
              45.29
            ],
            [
              -83.38,
              45.27
            ],
            [
              -83.41,
              45.25
            ],
            [
              -83.36,
              45.16
            ],
            [
              -83.32,
              45.14
            ],
            [
              -83.27,
              45.02
            ],
            [
              -83.34,
              45.04
            ],
            [
              -83.4,
              45.07
            ],
            [
              -83.45,
              45.04
            ],
            [
              -83.44,
              44.94
            ],
            [
              -83.4,
              44.9
            ],
            [
              -83.32,
              44.88
            ],
            [
              -83.3,
              44.83
            ],
            [
              -83.3,
              44.75
            ],
            [
              -83.27,
              44.71
            ],
            [
              -83.29,
              44.65
            ],
            [
              -83.32,
              44.6
            ],
            [
              -83.31,
              44.54
            ],
            [
              -83.33,
              44.44
            ],
            [
              -83.33,
              44.34
            ],
            [
              -83.37,
              44.33
            ],
            [
              -83.42,
              44.27
            ],
            [
              -83.51,
              44.27
            ],
            [
              -83.54,
              44.25
            ],
            [
              -83.57,
              44.16
            ],
            [
              -83.58,
              44.06
            ],
            [
              -83.65,
              44.05
            ],
            [
              -83.68,
              44.04
            ],
            [
              -83.68,
              43.99
            ],
            [
              -83.83,
              43.99
            ],
            [
              -83.88,
              43.96
            ],
            [
              -83.91,
              43.89
            ],
            [
              -83.93,
              43.79
            ],
            [
              -83.96,
              43.75
            ],
            [
              -83.91,
              43.67
            ],
            [
              -83.85,
              43.65
            ],
            [
              -83.82,
              43.67
            ],
            [
              -83.8,
              43.64
            ],
            [
              -83.73,
              43.62
            ],
            [
              -83.68,
              43.59
            ],
            [
              -83.65,
              43.6
            ],
            [
              -83.55,
              43.71
            ],
            [
              -83.5,
              43.71
            ],
            [
              -83.47,
              43.73
            ],
            [
              -83.5,
              43.77
            ],
            [
              -83.46,
              43.81
            ],
            [
              -83.43,
              43.88
            ],
            [
              -83.42,
              43.84
            ],
            [
              -83.35,
              43.87
            ],
            [
              -83.33,
              43.89
            ],
            [
              -83.41,
              43.92
            ],
            [
              -83.32,
              43.92
            ],
            [
              -83.28,
              43.94
            ],
            [
              -83.26,
              43.97
            ],
            [
              -83.18,
              43.98
            ],
            [
              -83.06,
              44.01
            ],
            [
              -83.03,
              44.04
            ],
            [
              -82.91,
              44.07
            ],
            [
              -82.88,
              44.04
            ],
            [
              -82.79,
              44.02
            ],
            [
              -82.74,
              43.99
            ],
            [
              -82.68,
              43.88
            ],
            [
              -82.64,
              43.85
            ],
            [
              -82.62,
              43.77
            ],
            [
              -82.6,
              43.59
            ],
            [
              -82.54,
              43.44
            ],
            [
              -82.52,
              43.23
            ],
            [
              -82.49,
              43.1
            ],
            [
              -82.42,
              43.01
            ],
            [
              -82.42,
              42.97
            ],
            [
              -82.46,
              42.93
            ],
            [
              -82.48,
              42.8
            ],
            [
              -82.47,
              42.76
            ],
            [
              -82.51,
              42.67
            ],
            [
              -82.52,
              42.61
            ],
            [
              -82.59,
              42.55
            ],
            [
              -82.64,
              42.55
            ],
            [
              -82.69,
              42.52
            ],
            [
              -82.68,
              42.57
            ],
            [
              -82.71,
              42.6
            ],
            [
              -82.68,
              42.61
            ],
            [
              -82.62,
              42.67
            ],
            [
              -82.67,
              42.69
            ],
            [
              -82.73,
              42.68
            ],
            [
              -82.8,
              42.65
            ],
            [
              -82.82,
              42.63
            ],
            [
              -82.79,
              42.6
            ],
            [
              -82.78,
              42.56
            ],
            [
              -82.84,
              42.57
            ],
            [
              -82.88,
              42.52
            ],
            [
              -82.87,
              42.45
            ],
            [
              -82.9,
              42.39
            ],
            [
              -82.96,
              42.34
            ],
            [
              -83.07,
              42.32
            ],
            [
              -83.13,
              42.23
            ],
            [
              -83.12,
              42.13
            ],
            [
              -83.13,
              42.09
            ],
            [
              -83.19,
              42.07
            ],
            [
              -83.19,
              42.01
            ],
            [
              -83.25,
              41.97
            ],
            [
              -83.27,
              41.94
            ],
            [
              -83.32,
              41.94
            ],
            [
              -83.34,
              41.88
            ],
            [
              -83.38,
              41.87
            ],
            [
              -83.44,
              41.81
            ],
            [
              -83.42,
              41.74
            ],
            [
              -83.45,
              41.73
            ],
            [
              -83.76,
              41.72
            ],
            [
              -84.36,
              41.71
            ],
            [
              -84.81,
              41.7
            ],
            [
              -84.81,
              41.76
            ],
            [
              -85.12,
              41.76
            ],
            [
              -85.79,
              41.76
            ],
            [
              -86.5,
              41.76
            ],
            [
              -86.82,
              41.76
            ]
          ]
        ],
        [
          [
            [
              -89.25,
              47.88
            ],
            [
              -89.18,
              47.94
            ],
            [
              -88.84,
              48.06
            ],
            [
              -88.81,
              48.05
            ],
            [
              -88.66,
              48.14
            ],
            [
              -88.55,
              48.18
            ],
            [
              -88.52,
              48.17
            ],
            [
              -88.42,
              48.19
            ],
            [
              -88.43,
              48.17
            ],
            [
              -88.47,
              48.15
            ],
            [
              -88.58,
              48.08
            ],
            [
              -88.58,
              48.06
            ],
            [
              -88.67,
              48.01
            ],
            [
              -88.85,
              47.97
            ],
            [
              -89,
              47.91
            ],
            [
              -89,
              47.89
            ],
            [
              -88.91,
              47.89
            ],
            [
              -89.12,
              47.83
            ],
            [
              -89.19,
              47.83
            ],
            [
              -89.25,
              47.88
            ]
          ]
        ],
        [
          [
            [
              -90.42,
              46.57
            ],
            [
              -90.35,
              46.6
            ],
            [
              -90.31,
              46.6
            ],
            [
              -90.17,
              46.65
            ],
            [
              -90.03,
              46.67
            ],
            [
              -89.92,
              46.74
            ],
            [
              -89.85,
              46.8
            ],
            [
              -89.79,
              46.82
            ],
            [
              -89.67,
              46.83
            ],
            [
              -89.62,
              46.82
            ],
            [
              -89.52,
              46.84
            ],
            [
              -89.44,
              46.84
            ],
            [
              -89.25,
              46.9
            ],
            [
              -89.14,
              46.98
            ],
            [
              -89.06,
              46.99
            ],
            [
              -88.96,
              47.01
            ],
            [
              -88.92,
              47.04
            ],
            [
              -88.91,
              47.09
            ],
            [
              -88.82,
              47.14
            ],
            [
              -88.77,
              47.16
            ],
            [
              -88.66,
              47.23
            ],
            [
              -88.58,
              47.25
            ],
            [
              -88.5,
              47.29
            ],
            [
              -88.46,
              47.34
            ],
            [
              -88.39,
              47.38
            ],
            [
              -88.18,
              47.46
            ],
            [
              -87.98,
              47.48
            ],
            [
              -87.8,
              47.47
            ],
            [
              -87.72,
              47.44
            ],
            [
              -87.71,
              47.4
            ],
            [
              -87.75,
              47.41
            ],
            [
              -87.81,
              47.38
            ],
            [
              -87.88,
              47.4
            ],
            [
              -87.96,
              47.39
            ],
            [
              -87.94,
              47.35
            ],
            [
              -88.05,
              47.3
            ],
            [
              -88.16,
              47.22
            ],
            [
              -88.23,
              47.2
            ],
            [
              -88.25,
              47.14
            ],
            [
              -88.27,
              47.14
            ],
            [
              -88.3,
              47.1
            ],
            [
              -88.35,
              47.08
            ],
            [
              -88.37,
              47.02
            ],
            [
              -88.41,
              46.98
            ],
            [
              -88.44,
              46.97
            ],
            [
              -88.49,
              46.83
            ],
            [
              -88.46,
              46.79
            ],
            [
              -88.5,
              46.76
            ],
            [
              -88.46,
              46.76
            ],
            [
              -88.38,
              46.83
            ],
            [
              -88.37,
              46.87
            ],
            [
              -88.35,
              46.86
            ],
            [
              -88.24,
              46.93
            ],
            [
              -88.14,
              46.97
            ],
            [
              -88.19,
              46.92
            ],
            [
              -88.23,
              46.9
            ],
            [
              -88.28,
              46.83
            ],
            [
              -88.18,
              46.9
            ],
            [
              -88.08,
              46.92
            ],
            [
              -88.03,
              46.91
            ],
            [
              -87.9,
              46.91
            ],
            [
              -87.85,
              46.88
            ],
            [
              -87.82,
              46.89
            ],
            [
              -87.76,
              46.86
            ],
            [
              -87.73,
              46.83
            ],
            [
              -87.67,
              46.84
            ],
            [
              -87.6,
              46.78
            ],
            [
              -87.58,
              46.73
            ],
            [
              -87.52,
              46.69
            ],
            [
              -87.5,
              46.65
            ],
            [
              -87.45,
              46.61
            ],
            [
              -87.38,
              46.59
            ],
            [
              -87.39,
              46.52
            ],
            [
              -87.35,
              46.5
            ],
            [
              -87.26,
              46.49
            ],
            [
              -87.11,
              46.5
            ],
            [
              -87.02,
              46.53
            ],
            [
              -86.98,
              46.53
            ],
            [
              -86.93,
              46.46
            ],
            [
              -86.88,
              46.44
            ],
            [
              -86.82,
              46.44
            ],
            [
              -86.79,
              46.48
            ],
            [
              -86.73,
              46.47
            ],
            [
              -86.7,
              46.44
            ],
            [
              -86.68,
              46.5
            ],
            [
              -86.71,
              46.54
            ],
            [
              -86.65,
              46.56
            ],
            [
              -86.63,
              46.53
            ],
            [
              -86.65,
              46.49
            ],
            [
              -86.59,
              46.46
            ],
            [
              -86.49,
              46.52
            ],
            [
              -86.35,
              46.58
            ],
            [
              -86.14,
              46.67
            ],
            [
              -86.1,
              46.65
            ],
            [
              -85.88,
              46.69
            ],
            [
              -85.71,
              46.68
            ],
            [
              -85.59,
              46.67
            ],
            [
              -85.48,
              46.68
            ],
            [
              -85.26,
              46.75
            ],
            [
              -85.17,
              46.76
            ],
            [
              -85.06,
              46.76
            ],
            [
              -84.95,
              46.77
            ],
            [
              -85.03,
              46.7
            ],
            [
              -85.04,
              46.58
            ],
            [
              -85.03,
              46.54
            ],
            [
              -85.06,
              46.53
            ],
            [
              -85.03,
              46.48
            ],
            [
              -84.97,
              46.48
            ],
            [
              -84.94,
              46.49
            ],
            [
              -84.91,
              46.47
            ],
            [
              -84.86,
              46.47
            ],
            [
              -84.8,
              46.45
            ],
            [
              -84.68,
              46.49
            ],
            [
              -84.63,
              46.48
            ],
            [
              -84.59,
              46.44
            ],
            [
              -84.59,
              46.41
            ],
            [
              -84.5,
              46.44
            ],
            [
              -84.48,
              46.43
            ],
            [
              -84.44,
              46.49
            ],
            [
              -84.38,
              46.51
            ],
            [
              -84.29,
              46.49
            ],
            [
              -84.25,
              46.5
            ],
            [
              -84.22,
              46.53
            ],
            [
              -84.13,
              46.53
            ],
            [
              -84.11,
              46.5
            ],
            [
              -84.15,
              46.42
            ],
            [
              -84.12,
              46.32
            ],
            [
              -84.12,
              46.23
            ],
            [
              -84.22,
              46.23
            ],
            [
              -84.25,
              46.18
            ],
            [
              -84.2,
              46.17
            ],
            [
              -84.18,
              46.18
            ],
            [
              -84.12,
              46.18
            ],
            [
              -84.1,
              46.15
            ],
            [
              -84.03,
              46.13
            ],
            [
              -84.07,
              46.1
            ],
            [
              -83.99,
              46.03
            ],
            [
              -83.94,
              46.03
            ],
            [
              -83.87,
              45.99
            ],
            [
              -83.84,
              46.03
            ],
            [
              -83.79,
              46
            ],
            [
              -83.77,
              46.02
            ],
            [
              -83.82,
              46.1
            ],
            [
              -83.77,
              46.09
            ],
            [
              -83.63,
              46.1
            ],
            [
              -83.58,
              46.09
            ],
            [
              -83.53,
              46.01
            ],
            [
              -83.47,
              45.98
            ],
            [
              -83.51,
              45.93
            ],
            [
              -83.56,
              45.91
            ],
            [
              -83.66,
              45.95
            ],
            [
              -83.77,
              45.93
            ],
            [
              -83.88,
              45.97
            ],
            [
              -83.92,
              45.96
            ],
            [
              -84.02,
              45.96
            ],
            [
              -84.11,
              45.98
            ],
            [
              -84.33,
              45.96
            ],
            [
              -84.38,
              45.93
            ],
            [
              -84.51,
              45.99
            ],
            [
              -84.56,
              46.03
            ],
            [
              -84.61,
              46.03
            ],
            [
              -84.66,
              46.05
            ],
            [
              -84.69,
              46.02
            ],
            [
              -84.68,
              45.97
            ],
            [
              -84.74,
              45.95
            ],
            [
              -84.73,
              45.91
            ],
            [
              -84.7,
              45.85
            ],
            [
              -84.75,
              45.84
            ],
            [
              -84.83,
              45.87
            ],
            [
              -84.84,
              45.9
            ],
            [
              -84.92,
              45.93
            ],
            [
              -84.94,
              45.96
            ],
            [
              -85.01,
              46.01
            ],
            [
              -85.15,
              46.05
            ],
            [
              -85.2,
              46.04
            ],
            [
              -85.32,
              46.09
            ],
            [
              -85.38,
              46.08
            ],
            [
              -85.43,
              46.1
            ],
            [
              -85.45,
              46.09
            ],
            [
              -85.51,
              46.09
            ],
            [
              -85.6,
              46.03
            ],
            [
              -85.66,
              45.97
            ],
            [
              -85.7,
              45.96
            ],
            [
              -85.81,
              45.98
            ],
            [
              -85.89,
              45.97
            ],
            [
              -85.92,
              45.95
            ],
            [
              -85.92,
              45.92
            ],
            [
              -86,
              45.95
            ],
            [
              -86.07,
              45.97
            ],
            [
              -86.16,
              45.95
            ],
            [
              -86.2,
              45.96
            ],
            [
              -86.28,
              45.94
            ],
            [
              -86.32,
              45.91
            ],
            [
              -86.33,
              45.85
            ],
            [
              -86.36,
              45.79
            ],
            [
              -86.41,
              45.79
            ],
            [
              -86.44,
              45.76
            ],
            [
              -86.52,
              45.75
            ],
            [
              -86.54,
              45.71
            ],
            [
              -86.59,
              45.71
            ],
            [
              -86.59,
              45.67
            ],
            [
              -86.63,
              45.66
            ],
            [
              -86.62,
              45.61
            ],
            [
              -86.69,
              45.63
            ],
            [
              -86.72,
              45.67
            ],
            [
              -86.68,
              45.69
            ],
            [
              -86.67,
              45.72
            ],
            [
              -86.63,
              45.75
            ],
            [
              -86.63,
              45.78
            ],
            [
              -86.58,
              45.78
            ],
            [
              -86.53,
              45.85
            ],
            [
              -86.54,
              45.89
            ],
            [
              -86.58,
              45.9
            ],
            [
              -86.65,
              45.83
            ],
            [
              -86.78,
              45.85
            ],
            [
              -86.77,
              45.81
            ],
            [
              -86.82,
              45.77
            ],
            [
              -86.84,
              45.72
            ],
            [
              -86.95,
              45.7
            ],
            [
              -86.96,
              45.67
            ],
            [
              -86.99,
              45.71
            ],
            [
              -86.97,
              45.75
            ],
            [
              -86.99,
              45.81
            ],
            [
              -87.02,
              45.84
            ],
            [
              -87.05,
              45.82
            ],
            [
              -87.07,
              45.72
            ],
            [
              -87.06,
              45.71
            ],
            [
              -87.17,
              45.66
            ],
            [
              -87.27,
              45.55
            ],
            [
              -87.33,
              45.43
            ],
            [
              -87.39,
              45.37
            ],
            [
              -87.47,
              45.27
            ],
            [
              -87.61,
              45.12
            ],
            [
              -87.59,
              45.1
            ],
            [
              -87.66,
              45.11
            ],
            [
              -87.69,
              45.15
            ],
            [
              -87.74,
              45.17
            ],
            [
              -87.74,
              45.2
            ],
            [
              -87.69,
              45.3
            ],
            [
              -87.65,
              45.34
            ],
            [
              -87.66,
              45.37
            ],
            [
              -87.7,
              45.39
            ],
            [
              -87.75,
              45.35
            ],
            [
              -87.85,
              45.34
            ],
            [
              -87.85,
              45.34
            ],
            [
              -87.88,
              45.38
            ],
            [
              -87.85,
              45.4
            ],
            [
              -87.86,
              45.43
            ],
            [
              -87.81,
              45.46
            ],
            [
              -87.79,
              45.5
            ],
            [
              -87.8,
              45.54
            ],
            [
              -87.77,
              45.6
            ],
            [
              -87.82,
              45.66
            ],
            [
              -87.78,
              45.67
            ],
            [
              -87.81,
              45.71
            ],
            [
              -87.86,
              45.73
            ],
            [
              -87.88,
              45.76
            ],
            [
              -87.96,
              45.76
            ],
            [
              -88,
              45.8
            ],
            [
              -88.07,
              45.78
            ],
            [
              -88.14,
              45.82
            ],
            [
              -88.08,
              45.86
            ],
            [
              -88.1,
              45.88
            ],
            [
              -88.1,
              45.92
            ],
            [
              -88.24,
              45.96
            ],
            [
              -88.3,
              45.95
            ],
            [
              -88.38,
              45.99
            ],
            [
              -88.42,
              45.98
            ],
            [
              -88.5,
              46
            ],
            [
              -88.51,
              46.02
            ],
            [
              -88.6,
              46.02
            ],
            [
              -88.61,
              45.99
            ],
            [
              -88.66,
              45.99
            ],
            [
              -88.68,
              46.01
            ],
            [
              -88.74,
              46.03
            ],
            [
              -88.78,
              46.02
            ],
            [
              -89.09,
              46.14
            ],
            [
              -90.12,
              46.34
            ],
            [
              -90.12,
              46.36
            ],
            [
              -90.22,
              46.5
            ],
            [
              -90.32,
              46.52
            ],
            [
              -90.35,
              46.54
            ],
            [
              -90.35,
              46.54
            ],
            [
              -90.39,
              46.53
            ],
            [
              -90.42,
              46.57
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Mississippi",
      fips: "28"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -88.51,
              30.22
            ],
            [
              -88.4,
              30.21
            ],
            [
              -88.45,
              30.19
            ],
            [
              -88.5,
              30.2
            ],
            [
              -88.51,
              30.22
            ]
          ]
        ],
        [
          [
            [
              -88.77,
              30.25
            ],
            [
              -88.72,
              30.26
            ],
            [
              -88.61,
              30.23
            ],
            [
              -88.59,
              30.22
            ],
            [
              -88.67,
              30.22
            ],
            [
              -88.77,
              30.25
            ]
          ]
        ],
        [
          [
            [
              -88.99,
              30.22
            ],
            [
              -88.93,
              30.22
            ],
            [
              -88.88,
              30.25
            ],
            [
              -88.89,
              30.22
            ],
            [
              -88.97,
              30.2
            ],
            [
              -88.99,
              30.22
            ]
          ]
        ],
        [
          [
            [
              -89.16,
              30.24
            ],
            [
              -89.08,
              30.24
            ],
            [
              -89.06,
              30.25
            ],
            [
              -89.07,
              30.21
            ],
            [
              -89.11,
              30.21
            ],
            [
              -89.17,
              30.23
            ],
            [
              -89.16,
              30.24
            ]
          ]
        ],
        [
          [
            [
              -91.17,
              33
            ],
            [
              -91.12,
              33.05
            ],
            [
              -91.2,
              33.11
            ],
            [
              -91.18,
              33.14
            ],
            [
              -91.15,
              33.13
            ],
            [
              -91.09,
              33.14
            ],
            [
              -91.08,
              33.16
            ],
            [
              -91.09,
              33.22
            ],
            [
              -91.04,
              33.27
            ],
            [
              -91.05,
              33.29
            ],
            [
              -91.09,
              33.27
            ],
            [
              -91.1,
              33.24
            ],
            [
              -91.14,
              33.3
            ],
            [
              -91.14,
              33.35
            ],
            [
              -91.06,
              33.43
            ],
            [
              -91.08,
              33.46
            ],
            [
              -91.11,
              33.39
            ],
            [
              -91.17,
              33.38
            ],
            [
              -91.21,
              33.4
            ],
            [
              -91.2,
              33.42
            ],
            [
              -91.14,
              33.43
            ],
            [
              -91.12,
              33.47
            ],
            [
              -91.17,
              33.5
            ],
            [
              -91.17,
              33.45
            ],
            [
              -91.23,
              33.44
            ],
            [
              -91.18,
              33.51
            ],
            [
              -91.23,
              33.56
            ],
            [
              -91.13,
              33.6
            ],
            [
              -91.14,
              33.63
            ],
            [
              -91.23,
              33.67
            ],
            [
              -91.22,
              33.69
            ],
            [
              -91.16,
              33.71
            ],
            [
              -91.13,
              33.68
            ],
            [
              -91.08,
              33.66
            ],
            [
              -91.03,
              33.67
            ],
            [
              -91.06,
              33.72
            ],
            [
              -91.11,
              33.7
            ],
            [
              -91.15,
              33.73
            ],
            [
              -91.14,
              33.78
            ],
            [
              -91.06,
              33.78
            ],
            [
              -91.03,
              33.76
            ],
            [
              -90.99,
              33.79
            ],
            [
              -91.05,
              33.82
            ],
            [
              -91.07,
              33.86
            ],
            [
              -91.01,
              33.93
            ],
            [
              -91.09,
              33.96
            ],
            [
              -91.08,
              33.98
            ],
            [
              -91.02,
              34
            ],
            [
              -91,
              33.97
            ],
            [
              -90.96,
              33.98
            ],
            [
              -90.99,
              34.02
            ],
            [
              -90.9,
              34.02
            ],
            [
              -90.87,
              34.08
            ],
            [
              -90.88,
              34.1
            ],
            [
              -90.92,
              34.09
            ],
            [
              -90.95,
              34.14
            ],
            [
              -90.91,
              34.17
            ],
            [
              -90.85,
              34.14
            ],
            [
              -90.81,
              34.16
            ],
            [
              -90.81,
              34.18
            ],
            [
              -90.89,
              34.18
            ],
            [
              -90.94,
              34.22
            ],
            [
              -90.9,
              34.24
            ],
            [
              -90.85,
              34.21
            ],
            [
              -90.83,
              34.27
            ],
            [
              -90.76,
              34.28
            ],
            [
              -90.74,
              34.31
            ],
            [
              -90.77,
              34.35
            ],
            [
              -90.75,
              34.37
            ],
            [
              -90.68,
              34.37
            ],
            [
              -90.69,
              34.32
            ],
            [
              -90.66,
              34.32
            ],
            [
              -90.66,
              34.38
            ],
            [
              -90.57,
              34.43
            ],
            [
              -90.59,
              34.5
            ],
            [
              -90.54,
              34.54
            ],
            [
              -90.55,
              34.56
            ],
            [
              -90.59,
              34.62
            ],
            [
              -90.59,
              34.67
            ],
            [
              -90.55,
              34.69
            ],
            [
              -90.56,
              34.65
            ],
            [
              -90.52,
              34.63
            ],
            [
              -90.47,
              34.67
            ],
            [
              -90.47,
              34.7
            ],
            [
              -90.55,
              34.7
            ],
            [
              -90.57,
              34.74
            ],
            [
              -90.54,
              34.75
            ],
            [
              -90.55,
              34.78
            ],
            [
              -90.51,
              34.8
            ],
            [
              -90.52,
              34.75
            ],
            [
              -90.5,
              34.72
            ],
            [
              -90.45,
              34.74
            ],
            [
              -90.47,
              34.8
            ],
            [
              -90.46,
              34.82
            ],
            [
              -90.48,
              34.86
            ],
            [
              -90.48,
              34.89
            ],
            [
              -90.44,
              34.88
            ],
            [
              -90.42,
              34.83
            ],
            [
              -90.31,
              34.87
            ],
            [
              -90.25,
              34.91
            ],
            [
              -90.25,
              34.95
            ],
            [
              -90.31,
              35
            ],
            [
              -89.49,
              34.99
            ],
            [
              -88.93,
              34.99
            ],
            [
              -88.2,
              35
            ],
            [
              -88.16,
              34.92
            ],
            [
              -88.1,
              34.89
            ],
            [
              -88.14,
              34.58
            ],
            [
              -88.21,
              34.03
            ],
            [
              -88.23,
              33.89
            ],
            [
              -88.35,
              32.93
            ],
            [
              -88.37,
              32.75
            ],
            [
              -88.44,
              32.14
            ],
            [
              -88.47,
              31.89
            ],
            [
              -88.44,
              31.23
            ],
            [
              -88.42,
              30.87
            ],
            [
              -88.41,
              30.56
            ],
            [
              -88.4,
              30.37
            ],
            [
              -88.41,
              30.34
            ],
            [
              -88.44,
              30.35
            ],
            [
              -88.47,
              30.32
            ],
            [
              -88.54,
              30.34
            ],
            [
              -88.58,
              30.33
            ],
            [
              -88.6,
              30.36
            ],
            [
              -88.66,
              30.36
            ],
            [
              -88.73,
              30.34
            ],
            [
              -88.81,
              30.38
            ],
            [
              -88.82,
              30.36
            ],
            [
              -88.89,
              30.39
            ],
            [
              -88.97,
              30.39
            ],
            [
              -89.08,
              30.37
            ],
            [
              -89.19,
              30.33
            ],
            [
              -89.29,
              30.3
            ],
            [
              -89.28,
              30.35
            ],
            [
              -89.31,
              30.38
            ],
            [
              -89.36,
              30.35
            ],
            [
              -89.33,
              30.34
            ],
            [
              -89.33,
              30.3
            ],
            [
              -89.42,
              30.25
            ],
            [
              -89.45,
              30.19
            ],
            [
              -89.48,
              30.19
            ],
            [
              -89.53,
              30.18
            ],
            [
              -89.57,
              30.18
            ],
            [
              -89.62,
              30.22
            ],
            [
              -89.63,
              30.28
            ],
            [
              -89.63,
              30.34
            ],
            [
              -89.68,
              30.41
            ],
            [
              -89.68,
              30.45
            ],
            [
              -89.72,
              30.49
            ],
            [
              -89.76,
              30.51
            ],
            [
              -89.77,
              30.54
            ],
            [
              -89.81,
              30.57
            ],
            [
              -89.82,
              30.65
            ],
            [
              -89.85,
              30.66
            ],
            [
              -89.82,
              30.74
            ],
            [
              -89.83,
              30.77
            ],
            [
              -89.81,
              30.79
            ],
            [
              -89.77,
              30.9
            ],
            [
              -89.75,
              30.91
            ],
            [
              -89.75,
              30.95
            ],
            [
              -89.73,
              30.97
            ],
            [
              -89.75,
              31
            ],
            [
              -90.34,
              31
            ],
            [
              -90.83,
              31
            ],
            [
              -91.64,
              31
            ],
            [
              -91.59,
              31.02
            ],
            [
              -91.56,
              31.07
            ],
            [
              -91.62,
              31.11
            ],
            [
              -91.63,
              31.13
            ],
            [
              -91.59,
              31.17
            ],
            [
              -91.6,
              31.21
            ],
            [
              -91.64,
              31.23
            ],
            [
              -91.64,
              31.27
            ],
            [
              -91.58,
              31.26
            ],
            [
              -91.51,
              31.28
            ],
            [
              -91.51,
              31.32
            ],
            [
              -91.55,
              31.35
            ],
            [
              -91.55,
              31.39
            ],
            [
              -91.58,
              31.4
            ],
            [
              -91.55,
              31.43
            ],
            [
              -91.53,
              31.39
            ],
            [
              -91.5,
              31.37
            ],
            [
              -91.47,
              31.37
            ],
            [
              -91.47,
              31.4
            ],
            [
              -91.52,
              31.46
            ],
            [
              -91.52,
              31.52
            ],
            [
              -91.45,
              31.54
            ],
            [
              -91.41,
              31.57
            ],
            [
              -91.42,
              31.6
            ],
            [
              -91.49,
              31.59
            ],
            [
              -91.52,
              31.61
            ],
            [
              -91.5,
              31.64
            ],
            [
              -91.46,
              31.62
            ],
            [
              -91.4,
              31.62
            ],
            [
              -91.4,
              31.71
            ],
            [
              -91.36,
              31.74
            ],
            [
              -91.27,
              31.75
            ],
            [
              -91.26,
              31.76
            ],
            [
              -91.36,
              31.77
            ],
            [
              -91.34,
              31.85
            ],
            [
              -91.3,
              31.86
            ],
            [
              -91.29,
              31.82
            ],
            [
              -91.26,
              31.81
            ],
            [
              -91.25,
              31.83
            ],
            [
              -91.27,
              31.85
            ],
            [
              -91.18,
              31.92
            ],
            [
              -91.19,
              31.96
            ],
            [
              -91.16,
              31.98
            ],
            [
              -91.09,
              31.99
            ],
            [
              -91.09,
              32.04
            ],
            [
              -91.16,
              32.06
            ],
            [
              -91.15,
              32.08
            ],
            [
              -91.1,
              32.05
            ],
            [
              -91.08,
              32.08
            ],
            [
              -91.04,
              32.1
            ],
            [
              -91.01,
              32.16
            ],
            [
              -91.06,
              32.18
            ],
            [
              -91.05,
              32.12
            ],
            [
              -91.17,
              32.13
            ],
            [
              -91.16,
              32.2
            ],
            [
              -91.06,
              32.22
            ],
            [
              -91.04,
              32.24
            ],
            [
              -90.99,
              32.22
            ],
            [
              -90.97,
              32.25
            ],
            [
              -90.98,
              32.3
            ],
            [
              -90.93,
              32.29
            ],
            [
              -90.88,
              32.36
            ],
            [
              -90.89,
              32.37
            ],
            [
              -90.91,
              32.34
            ],
            [
              -90.99,
              32.35
            ],
            [
              -90.99,
              32.4
            ],
            [
              -90.97,
              32.42
            ],
            [
              -90.99,
              32.45
            ],
            [
              -91.03,
              32.43
            ],
            [
              -91.11,
              32.48
            ],
            [
              -91.1,
              32.53
            ],
            [
              -91.08,
              32.53
            ],
            [
              -91.02,
              32.49
            ],
            [
              -90.99,
              32.49
            ],
            [
              -91.01,
              32.51
            ],
            [
              -91.08,
              32.56
            ],
            [
              -91.03,
              32.58
            ],
            [
              -91,
              32.61
            ],
            [
              -91.03,
              32.65
            ],
            [
              -91.05,
              32.61
            ],
            [
              -91.12,
              32.58
            ],
            [
              -91.14,
              32.6
            ],
            [
              -91.15,
              32.64
            ],
            [
              -91.12,
              32.67
            ],
            [
              -91.06,
              32.7
            ],
            [
              -91.06,
              32.73
            ],
            [
              -91.17,
              32.75
            ],
            [
              -91.16,
              32.81
            ],
            [
              -91.15,
              32.84
            ],
            [
              -91.07,
              32.89
            ],
            [
              -91.06,
              32.92
            ],
            [
              -91.09,
              32.98
            ],
            [
              -91.13,
              32.98
            ],
            [
              -91.13,
              32.92
            ],
            [
              -91.18,
              32.9
            ],
            [
              -91.21,
              32.92
            ],
            [
              -91.2,
              32.96
            ],
            [
              -91.17,
              33
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Montana",
      fips: "30"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -116.05,
            49
          ],
          [
            -115.21,
            49
          ],
          [
            -114.37,
            49
          ],
          [
            -113.69,
            49
          ],
          [
            -113.01,
            49
          ],
          [
            -111.76,
            49
          ],
          [
            -111,
            49
          ],
          [
            -110.17,
            49
          ],
          [
            -108.99,
            49
          ],
          [
            -108.49,
            49
          ],
          [
            -107.44,
            49
          ],
          [
            -106.63,
            49
          ],
          [
            -106.11,
            49
          ],
          [
            -105.06,
            49
          ],
          [
            -104.65,
            49
          ],
          [
            -104.05,
            49
          ],
          [
            -104.05,
            48.39
          ],
          [
            -104.04,
            48.37
          ],
          [
            -104.04,
            45.95
          ],
          [
            -104.04,
            45.75
          ],
          [
            -104.04,
            45
          ],
          [
            -104.06,
            45
          ],
          [
            -104.47,
            45
          ],
          [
            -105.37,
            45
          ],
          [
            -105.85,
            45
          ],
          [
            -105.93,
            44.99
          ],
          [
            -106.57,
            44.99
          ],
          [
            -107.09,
            45
          ],
          [
            -107.14,
            45
          ],
          [
            -108.27,
            45
          ],
          [
            -109.06,
            45
          ],
          [
            -109.1,
            45.01
          ],
          [
            -109.8,
            45
          ],
          [
            -110.11,
            45
          ],
          [
            -110.2,
            45
          ],
          [
            -110.36,
            45
          ],
          [
            -110.4,
            44.99
          ],
          [
            -110.71,
            44.99
          ],
          [
            -110.79,
            45
          ],
          [
            -111.05,
            45
          ],
          [
            -111.06,
            44.87
          ],
          [
            -111.05,
            44.62
          ],
          [
            -111.05,
            44.47
          ],
          [
            -111.12,
            44.49
          ],
          [
            -111.14,
            44.54
          ],
          [
            -111.23,
            44.59
          ],
          [
            -111.22,
            44.62
          ],
          [
            -111.32,
            44.72
          ],
          [
            -111.39,
            44.76
          ],
          [
            -111.41,
            44.71
          ],
          [
            -111.49,
            44.71
          ],
          [
            -111.47,
            44.68
          ],
          [
            -111.53,
            44.6
          ],
          [
            -111.47,
            44.54
          ],
          [
            -111.59,
            44.56
          ],
          [
            -111.62,
            44.55
          ],
          [
            -111.7,
            44.56
          ],
          [
            -111.72,
            44.54
          ],
          [
            -111.82,
            44.51
          ],
          [
            -111.87,
            44.56
          ],
          [
            -111.95,
            44.56
          ],
          [
            -112,
            44.54
          ],
          [
            -112.03,
            44.55
          ],
          [
            -112.11,
            44.52
          ],
          [
            -112.14,
            44.54
          ],
          [
            -112.19,
            44.53
          ],
          [
            -112.23,
            44.56
          ],
          [
            -112.29,
            44.57
          ],
          [
            -112.32,
            44.54
          ],
          [
            -112.35,
            44.54
          ],
          [
            -112.36,
            44.49
          ],
          [
            -112.39,
            44.45
          ],
          [
            -112.47,
            44.48
          ],
          [
            -112.5,
            44.46
          ],
          [
            -112.54,
            44.48
          ],
          [
            -112.66,
            44.49
          ],
          [
            -112.72,
            44.5
          ],
          [
            -112.78,
            44.48
          ],
          [
            -112.84,
            44.42
          ],
          [
            -112.81,
            44.38
          ],
          [
            -112.85,
            44.36
          ],
          [
            -112.89,
            44.4
          ],
          [
            -112.95,
            44.42
          ],
          [
            -113,
            44.45
          ],
          [
            -113.03,
            44.5
          ],
          [
            -113.01,
            44.53
          ],
          [
            -113.08,
            44.6
          ],
          [
            -113.05,
            44.64
          ],
          [
            -113.07,
            44.68
          ],
          [
            -113.13,
            44.77
          ],
          [
            -113.25,
            44.82
          ],
          [
            -113.34,
            44.79
          ],
          [
            -113.36,
            44.82
          ],
          [
            -113.46,
            44.87
          ],
          [
            -113.5,
            44.95
          ],
          [
            -113.45,
            44.96
          ],
          [
            -113.44,
            45.01
          ],
          [
            -113.45,
            45.06
          ],
          [
            -113.52,
            45.09
          ],
          [
            -113.51,
            45.12
          ],
          [
            -113.57,
            45.13
          ],
          [
            -113.6,
            45.19
          ],
          [
            -113.69,
            45.25
          ],
          [
            -113.69,
            45.28
          ],
          [
            -113.74,
            45.33
          ],
          [
            -113.73,
            45.39
          ],
          [
            -113.76,
            45.41
          ],
          [
            -113.78,
            45.46
          ],
          [
            -113.76,
            45.48
          ],
          [
            -113.76,
            45.52
          ],
          [
            -113.83,
            45.52
          ],
          [
            -113.81,
            45.6
          ],
          [
            -113.86,
            45.62
          ],
          [
            -113.9,
            45.62
          ],
          [
            -113.9,
            45.64
          ],
          [
            -113.93,
            45.68
          ],
          [
            -113.99,
            45.7
          ],
          [
            -114.02,
            45.69
          ],
          [
            -114.01,
            45.66
          ],
          [
            -114.07,
            45.63
          ],
          [
            -114.13,
            45.56
          ],
          [
            -114.2,
            45.54
          ],
          [
            -114.25,
            45.55
          ],
          [
            -114.26,
            45.5
          ],
          [
            -114.35,
            45.46
          ],
          [
            -114.36,
            45.49
          ],
          [
            -114.41,
            45.51
          ],
          [
            -114.46,
            45.56
          ],
          [
            -114.55,
            45.56
          ],
          [
            -114.54,
            45.61
          ],
          [
            -114.57,
            45.64
          ],
          [
            -114.5,
            45.67
          ],
          [
            -114.5,
            45.71
          ],
          [
            -114.57,
            45.77
          ],
          [
            -114.5,
            45.85
          ],
          [
            -114.41,
            45.85
          ],
          [
            -114.39,
            45.89
          ],
          [
            -114.43,
            45.94
          ],
          [
            -114.41,
            45.98
          ],
          [
            -114.48,
            46
          ],
          [
            -114.49,
            46.05
          ],
          [
            -114.46,
            46.1
          ],
          [
            -114.52,
            46.13
          ],
          [
            -114.51,
            46.17
          ],
          [
            -114.45,
            46.17
          ],
          [
            -114.45,
            46.24
          ],
          [
            -114.47,
            46.27
          ],
          [
            -114.43,
            46.29
          ],
          [
            -114.42,
            46.39
          ],
          [
            -114.37,
            46.44
          ],
          [
            -114.4,
            46.5
          ],
          [
            -114.36,
            46.51
          ],
          [
            -114.32,
            46.61
          ],
          [
            -114.33,
            46.66
          ],
          [
            -114.36,
            46.67
          ],
          [
            -114.45,
            46.65
          ],
          [
            -114.47,
            46.63
          ],
          [
            -114.55,
            46.64
          ],
          [
            -114.62,
            46.64
          ],
          [
            -114.64,
            46.67
          ],
          [
            -114.62,
            46.71
          ],
          [
            -114.65,
            46.73
          ],
          [
            -114.7,
            46.74
          ],
          [
            -114.71,
            46.71
          ],
          [
            -114.77,
            46.7
          ],
          [
            -114.79,
            46.71
          ],
          [
            -114.77,
            46.76
          ],
          [
            -114.89,
            46.81
          ],
          [
            -114.95,
            46.86
          ],
          [
            -114.93,
            46.92
          ],
          [
            -115,
            46.97
          ],
          [
            -115.05,
            46.97
          ],
          [
            -115.07,
            47.02
          ],
          [
            -115.14,
            47.09
          ],
          [
            -115.2,
            47.14
          ],
          [
            -115.24,
            47.15
          ],
          [
            -115.26,
            47.18
          ],
          [
            -115.3,
            47.19
          ],
          [
            -115.29,
            47.22
          ],
          [
            -115.33,
            47.26
          ],
          [
            -115.41,
            47.26
          ],
          [
            -115.53,
            47.3
          ],
          [
            -115.55,
            47.35
          ],
          [
            -115.72,
            47.42
          ],
          [
            -115.76,
            47.42
          ],
          [
            -115.72,
            47.45
          ],
          [
            -115.64,
            47.46
          ],
          [
            -115.63,
            47.48
          ],
          [
            -115.69,
            47.49
          ],
          [
            -115.7,
            47.53
          ],
          [
            -115.74,
            47.54
          ],
          [
            -115.74,
            47.57
          ],
          [
            -115.69,
            47.6
          ],
          [
            -115.73,
            47.64
          ],
          [
            -115.72,
            47.7
          ],
          [
            -115.77,
            47.72
          ],
          [
            -115.8,
            47.76
          ],
          [
            -115.83,
            47.75
          ],
          [
            -115.85,
            47.83
          ],
          [
            -115.91,
            47.85
          ],
          [
            -116.05,
            47.98
          ],
          [
            -116.05,
            48.22
          ],
          [
            -116.05,
            48.31
          ],
          [
            -116.05,
            49
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New Hampshire",
      fips: "33"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -71.5,
            45.01
          ],
          [
            -71.49,
            45.07
          ],
          [
            -71.43,
            45.13
          ],
          [
            -71.44,
            45.14
          ],
          [
            -71.4,
            45.2
          ],
          [
            -71.44,
            45.23
          ],
          [
            -71.38,
            45.24
          ],
          [
            -71.36,
            45.27
          ],
          [
            -71.29,
            45.3
          ],
          [
            -71.23,
            45.25
          ],
          [
            -71.13,
            45.25
          ],
          [
            -71.08,
            45.31
          ],
          [
            -71.03,
            44.66
          ],
          [
            -70.99,
            43.92
          ],
          [
            -70.99,
            43.84
          ],
          [
            -70.97,
            43.57
          ],
          [
            -70.95,
            43.55
          ],
          [
            -70.97,
            43.48
          ],
          [
            -70.96,
            43.47
          ],
          [
            -70.99,
            43.38
          ],
          [
            -70.96,
            43.33
          ],
          [
            -70.81,
            43.22
          ],
          [
            -70.83,
            43.19
          ],
          [
            -70.83,
            43.13
          ],
          [
            -70.7,
            43.06
          ],
          [
            -70.81,
            42.91
          ],
          [
            -70.82,
            42.87
          ],
          [
            -70.85,
            42.86
          ],
          [
            -70.9,
            42.89
          ],
          [
            -71.03,
            42.86
          ],
          [
            -71.06,
            42.81
          ],
          [
            -71.13,
            42.82
          ],
          [
            -71.18,
            42.79
          ],
          [
            -71.18,
            42.74
          ],
          [
            -71.26,
            42.74
          ],
          [
            -71.29,
            42.7
          ],
          [
            -71.74,
            42.71
          ],
          [
            -72.46,
            42.73
          ],
          [
            -72.49,
            42.77
          ],
          [
            -72.51,
            42.76
          ],
          [
            -72.56,
            42.85
          ],
          [
            -72.52,
            42.91
          ],
          [
            -72.52,
            42.96
          ],
          [
            -72.47,
            42.97
          ],
          [
            -72.44,
            43.01
          ],
          [
            -72.47,
            43.06
          ],
          [
            -72.43,
            43.08
          ],
          [
            -72.45,
            43.14
          ],
          [
            -72.44,
            43.26
          ],
          [
            -72.39,
            43.31
          ],
          [
            -72.42,
            43.36
          ],
          [
            -72.38,
            43.48
          ],
          [
            -72.4,
            43.51
          ],
          [
            -72.38,
            43.57
          ],
          [
            -72.33,
            43.6
          ],
          [
            -72.3,
            43.7
          ],
          [
            -72.27,
            43.73
          ],
          [
            -72.2,
            43.77
          ],
          [
            -72.18,
            43.81
          ],
          [
            -72.19,
            43.86
          ],
          [
            -72.12,
            43.92
          ],
          [
            -72.12,
            43.99
          ],
          [
            -72.08,
            44.03
          ],
          [
            -72.03,
            44.09
          ],
          [
            -72.03,
            44.13
          ],
          [
            -72.07,
            44.19
          ],
          [
            -72.05,
            44.24
          ],
          [
            -72.07,
            44.27
          ],
          [
            -72.03,
            44.32
          ],
          [
            -71.91,
            44.35
          ],
          [
            -71.87,
            44.34
          ],
          [
            -71.81,
            44.35
          ],
          [
            -71.8,
            44.4
          ],
          [
            -71.71,
            44.41
          ],
          [
            -71.66,
            44.45
          ],
          [
            -71.63,
            44.48
          ],
          [
            -71.58,
            44.5
          ],
          [
            -71.6,
            44.55
          ],
          [
            -71.56,
            44.56
          ],
          [
            -71.55,
            44.63
          ],
          [
            -71.59,
            44.66
          ],
          [
            -71.63,
            44.75
          ],
          [
            -71.57,
            44.79
          ],
          [
            -71.56,
            44.85
          ],
          [
            -71.49,
            44.91
          ],
          [
            -71.54,
            44.99
          ],
          [
            -71.5,
            45.01
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "New York",
      fips: "36"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -72.04,
              41.26
            ],
            [
              -72.02,
              41.27
            ],
            [
              -71.93,
              41.29
            ],
            [
              -72,
              41.25
            ],
            [
              -72.04,
              41.26
            ]
          ]
        ],
        [
          [
            [
              -72.14,
              41.1
            ],
            [
              -72.13,
              41.12
            ],
            [
              -72.09,
              41.1
            ],
            [
              -72.09,
              41.06
            ],
            [
              -72.11,
              41.09
            ],
            [
              -72.14,
              41.1
            ]
          ]
        ],
        [
          [
            [
              -72.22,
              41.18
            ],
            [
              -72.16,
              41.2
            ],
            [
              -72.2,
              41.16
            ],
            [
              -72.22,
              41.18
            ]
          ]
        ],
        [
          [
            [
              -74.07,
              40.66
            ],
            [
              -74.05,
              40.6
            ],
            [
              -74.09,
              40.57
            ],
            [
              -74.22,
              40.5
            ],
            [
              -74.26,
              40.5
            ],
            [
              -74.25,
              40.54
            ],
            [
              -74.22,
              40.56
            ],
            [
              -74.2,
              40.63
            ],
            [
              -74.07,
              40.66
            ]
          ]
        ],
        [
          [
            [
              -76.38,
              43.87
            ],
            [
              -76.32,
              43.92
            ],
            [
              -76.34,
              43.88
            ],
            [
              -76.38,
              43.87
            ]
          ]
        ],
        [
          [
            [
              -76.45,
              43.89
            ],
            [
              -76.41,
              43.93
            ],
            [
              -76.38,
              43.92
            ],
            [
              -76.45,
              43.89
            ]
          ]
        ],
        [
          [
            [
              -79.76,
              42.27
            ],
            [
              -79.64,
              42.32
            ],
            [
              -79.45,
              42.41
            ],
            [
              -79.35,
              42.49
            ],
            [
              -79.24,
              42.53
            ],
            [
              -79.15,
              42.55
            ],
            [
              -79.11,
              42.61
            ],
            [
              -79.06,
              42.64
            ],
            [
              -79.05,
              42.69
            ],
            [
              -78.92,
              42.74
            ],
            [
              -78.85,
              42.78
            ],
            [
              -78.87,
              42.85
            ],
            [
              -78.91,
              42.89
            ],
            [
              -78.91,
              42.92
            ],
            [
              -78.93,
              42.96
            ],
            [
              -79.01,
              42.99
            ],
            [
              -79.01,
              43.06
            ],
            [
              -79.07,
              43.08
            ],
            [
              -79.04,
              43.14
            ],
            [
              -79.06,
              43.25
            ],
            [
              -79.07,
              43.26
            ],
            [
              -78.97,
              43.28
            ],
            [
              -78.83,
              43.32
            ],
            [
              -78.63,
              43.36
            ],
            [
              -78.49,
              43.37
            ],
            [
              -78.37,
              43.38
            ],
            [
              -78.23,
              43.37
            ],
            [
              -78.11,
              43.38
            ],
            [
              -77.8,
              43.34
            ],
            [
              -77.71,
              43.32
            ],
            [
              -77.66,
              43.28
            ],
            [
              -77.58,
              43.24
            ],
            [
              -77.53,
              43.23
            ],
            [
              -77.39,
              43.28
            ],
            [
              -77.27,
              43.28
            ],
            [
              -77.11,
              43.29
            ],
            [
              -77.04,
              43.27
            ],
            [
              -76.95,
              43.27
            ],
            [
              -76.9,
              43.29
            ],
            [
              -76.8,
              43.31
            ],
            [
              -76.73,
              43.34
            ],
            [
              -76.7,
              43.34
            ],
            [
              -76.63,
              43.41
            ],
            [
              -76.52,
              43.47
            ],
            [
              -76.49,
              43.48
            ],
            [
              -76.42,
              43.52
            ],
            [
              -76.37,
              43.53
            ],
            [
              -76.3,
              43.51
            ],
            [
              -76.24,
              43.53
            ],
            [
              -76.2,
              43.57
            ],
            [
              -76.2,
              43.65
            ],
            [
              -76.23,
              43.8
            ],
            [
              -76.3,
              43.84
            ],
            [
              -76.26,
              43.88
            ],
            [
              -76.21,
              43.89
            ],
            [
              -76.2,
              43.86
            ],
            [
              -76.13,
              43.9
            ],
            [
              -76.14,
              43.93
            ],
            [
              -76.21,
              43.98
            ],
            [
              -76.29,
              43.96
            ],
            [
              -76.27,
              43.99
            ],
            [
              -76.32,
              44.03
            ],
            [
              -76.38,
              44.03
            ],
            [
              -76.37,
              44.1
            ],
            [
              -76.31,
              44.2
            ],
            [
              -76.25,
              44.2
            ],
            [
              -76.16,
              44.24
            ],
            [
              -76.16,
              44.28
            ],
            [
              -76.1,
              44.3
            ],
            [
              -76,
              44.35
            ],
            [
              -75.97,
              44.34
            ],
            [
              -75.91,
              44.37
            ],
            [
              -75.82,
              44.43
            ],
            [
              -75.81,
              44.47
            ],
            [
              -75.76,
              44.52
            ],
            [
              -75.62,
              44.62
            ],
            [
              -75.51,
              44.71
            ],
            [
              -75.31,
              44.83
            ],
            [
              -75.31,
              44.84
            ],
            [
              -75.06,
              44.93
            ],
            [
              -74.97,
              44.98
            ],
            [
              -74.91,
              44.98
            ],
            [
              -74.83,
              45.02
            ],
            [
              -74.73,
              44.99
            ],
            [
              -74.66,
              45
            ],
            [
              -74.34,
              44.99
            ],
            [
              -74.15,
              44.99
            ],
            [
              -73.76,
              45
            ],
            [
              -73.68,
              45
            ],
            [
              -73.34,
              45.01
            ],
            [
              -73.34,
              44.92
            ],
            [
              -73.36,
              44.89
            ],
            [
              -73.38,
              44.84
            ],
            [
              -73.33,
              44.79
            ],
            [
              -73.37,
              44.74
            ],
            [
              -73.37,
              44.66
            ],
            [
              -73.39,
              44.64
            ],
            [
              -73.37,
              44.58
            ],
            [
              -73.31,
              44.5
            ],
            [
              -73.29,
              44.44
            ],
            [
              -73.33,
              44.37
            ],
            [
              -73.31,
              44.27
            ],
            [
              -73.32,
              44.24
            ],
            [
              -73.39,
              44.19
            ],
            [
              -73.41,
              44.11
            ],
            [
              -73.44,
              44.04
            ],
            [
              -73.41,
              44.02
            ],
            [
              -73.41,
              43.93
            ],
            [
              -73.37,
              43.88
            ],
            [
              -73.39,
              43.82
            ],
            [
              -73.35,
              43.77
            ],
            [
              -73.41,
              43.69
            ],
            [
              -73.43,
              43.59
            ],
            [
              -73.4,
              43.57
            ],
            [
              -73.37,
              43.62
            ],
            [
              -73.3,
              43.62
            ],
            [
              -73.3,
              43.58
            ],
            [
              -73.25,
              43.55
            ],
            [
              -73.26,
              43.26
            ],
            [
              -73.28,
              42.9
            ],
            [
              -73.28,
              42.83
            ],
            [
              -73.29,
              42.8
            ],
            [
              -73.26,
              42.75
            ],
            [
              -73.39,
              42.43
            ],
            [
              -73.51,
              42.09
            ],
            [
              -73.49,
              42.05
            ],
            [
              -73.52,
              41.69
            ],
            [
              -73.54,
              41.43
            ],
            [
              -73.55,
              41.3
            ],
            [
              -73.48,
              41.21
            ],
            [
              -73.73,
              41.1
            ],
            [
              -73.65,
              41.01
            ],
            [
              -73.66,
              40.98
            ],
            [
              -73.68,
              40.95
            ],
            [
              -73.76,
              40.91
            ],
            [
              -73.77,
              40.84
            ],
            [
              -73.81,
              40.85
            ],
            [
              -73.78,
              40.79
            ],
            [
              -73.72,
              40.87
            ],
            [
              -73.68,
              40.86
            ],
            [
              -73.64,
              40.89
            ],
            [
              -73.56,
              40.92
            ],
            [
              -73.5,
              40.92
            ],
            [
              -73.49,
              40.95
            ],
            [
              -73.41,
              40.92
            ],
            [
              -73.4,
              40.96
            ],
            [
              -73.37,
              40.93
            ],
            [
              -73.3,
              40.92
            ],
            [
              -73.23,
              40.9
            ],
            [
              -73.15,
              40.93
            ],
            [
              -73.14,
              40.97
            ],
            [
              -73.08,
              40.97
            ],
            [
              -73.04,
              40.96
            ],
            [
              -72.78,
              40.97
            ],
            [
              -72.64,
              40.98
            ],
            [
              -72.58,
              41
            ],
            [
              -72.48,
              41.05
            ],
            [
              -72.44,
              41.09
            ],
            [
              -72.4,
              41.1
            ],
            [
              -72.36,
              41.14
            ],
            [
              -72.28,
              41.16
            ],
            [
              -72.24,
              41.16
            ],
            [
              -72.3,
              41.11
            ],
            [
              -72.33,
              41.11
            ],
            [
              -72.28,
              41.08
            ],
            [
              -72.26,
              41.04
            ],
            [
              -72.2,
              41.03
            ],
            [
              -72.16,
              41.05
            ],
            [
              -72.1,
              40.99
            ],
            [
              -72.05,
              41.01
            ],
            [
              -71.97,
              41.05
            ],
            [
              -71.96,
              41.07
            ],
            [
              -71.9,
              41.08
            ],
            [
              -71.86,
              41.07
            ],
            [
              -71.87,
              41.05
            ],
            [
              -72.11,
              40.97
            ],
            [
              -72.39,
              40.87
            ],
            [
              -72.57,
              40.81
            ],
            [
              -72.86,
              40.73
            ],
            [
              -73.05,
              40.67
            ],
            [
              -73.21,
              40.63
            ],
            [
              -73.31,
              40.62
            ],
            [
              -73.33,
              40.63
            ],
            [
              -73.56,
              40.58
            ],
            [
              -73.78,
              40.59
            ],
            [
              -73.94,
              40.54
            ],
            [
              -73.93,
              40.58
            ],
            [
              -74.01,
              40.57
            ],
            [
              -74,
              40.6
            ],
            [
              -74.04,
              40.63
            ],
            [
              -74.02,
              40.66
            ],
            [
              -74.05,
              40.69
            ],
            [
              -74.02,
              40.71
            ],
            [
              -74.01,
              40.76
            ],
            [
              -73.97,
              40.82
            ],
            [
              -73.89,
              40.98
            ],
            [
              -73.91,
              41
            ],
            [
              -74.38,
              41.21
            ],
            [
              -74.7,
              41.36
            ],
            [
              -74.74,
              41.4
            ],
            [
              -74.74,
              41.43
            ],
            [
              -74.8,
              41.42
            ],
            [
              -74.81,
              41.44
            ],
            [
              -74.9,
              41.44
            ],
            [
              -74.89,
              41.46
            ],
            [
              -74.94,
              41.48
            ],
            [
              -74.98,
              41.48
            ],
            [
              -74.99,
              41.51
            ],
            [
              -75.08,
              41.61
            ],
            [
              -75.05,
              41.62
            ],
            [
              -75.05,
              41.75
            ],
            [
              -75.1,
              41.77
            ],
            [
              -75.08,
              41.8
            ],
            [
              -75.11,
              41.84
            ],
            [
              -75.21,
              41.87
            ],
            [
              -75.26,
              41.87
            ],
            [
              -75.29,
              41.95
            ],
            [
              -75.31,
              41.95
            ],
            [
              -75.36,
              42
            ],
            [
              -75.74,
              42
            ],
            [
              -76.35,
              42
            ],
            [
              -76.75,
              42
            ],
            [
              -77.13,
              42
            ],
            [
              -78,
              42
            ],
            [
              -78.6,
              42
            ],
            [
              -78.87,
              42
            ],
            [
              -79.76,
              42
            ],
            [
              -79.76,
              42
            ],
            [
              -79.76,
              42.27
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Ohio",
      fips: "39"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -82.74,
              41.6
            ],
            [
              -82.68,
              41.62
            ],
            [
              -82.69,
              41.59
            ],
            [
              -82.74,
              41.6
            ]
          ]
        ],
        [
          [
            [
              -82.84,
              41.65
            ],
            [
              -82.82,
              41.72
            ],
            [
              -82.78,
              41.69
            ],
            [
              -82.79,
              41.66
            ],
            [
              -82.84,
              41.63
            ],
            [
              -82.84,
              41.65
            ]
          ]
        ],
        [
          [
            [
              -84.81,
              41.7
            ],
            [
              -84.36,
              41.71
            ],
            [
              -83.76,
              41.72
            ],
            [
              -83.45,
              41.73
            ],
            [
              -83.45,
              41.71
            ],
            [
              -83.37,
              41.69
            ],
            [
              -83.33,
              41.7
            ],
            [
              -83.19,
              41.63
            ],
            [
              -83.11,
              41.61
            ],
            [
              -83.07,
              41.6
            ],
            [
              -83,
              41.54
            ],
            [
              -82.93,
              41.51
            ],
            [
              -82.87,
              41.53
            ],
            [
              -82.86,
              41.58
            ],
            [
              -82.84,
              41.59
            ],
            [
              -82.79,
              41.54
            ],
            [
              -82.72,
              41.54
            ],
            [
              -82.72,
              41.51
            ],
            [
              -82.62,
              41.43
            ],
            [
              -82.56,
              41.4
            ],
            [
              -82.48,
              41.38
            ],
            [
              -82.33,
              41.43
            ],
            [
              -82.25,
              41.43
            ],
            [
              -82.19,
              41.46
            ],
            [
              -82.01,
              41.52
            ],
            [
              -81.88,
              41.48
            ],
            [
              -81.81,
              41.5
            ],
            [
              -81.74,
              41.49
            ],
            [
              -81.63,
              41.54
            ],
            [
              -81.53,
              41.61
            ],
            [
              -81.5,
              41.62
            ],
            [
              -81.44,
              41.67
            ],
            [
              -81.29,
              41.76
            ],
            [
              -81.25,
              41.76
            ],
            [
              -81.01,
              41.85
            ],
            [
              -80.9,
              41.87
            ],
            [
              -80.82,
              41.9
            ],
            [
              -80.58,
              41.96
            ],
            [
              -80.52,
              41.98
            ],
            [
              -80.52,
              40.64
            ],
            [
              -80.59,
              40.62
            ],
            [
              -80.64,
              40.62
            ],
            [
              -80.67,
              40.57
            ],
            [
              -80.63,
              40.54
            ],
            [
              -80.6,
              40.46
            ],
            [
              -80.61,
              40.4
            ],
            [
              -80.6,
              40.32
            ],
            [
              -80.62,
              40.26
            ],
            [
              -80.65,
              40.25
            ],
            [
              -80.67,
              40.19
            ],
            [
              -80.71,
              40.15
            ],
            [
              -80.71,
              40.1
            ],
            [
              -80.74,
              40.08
            ],
            [
              -80.74,
              39.97
            ],
            [
              -80.76,
              39.95
            ],
            [
              -80.76,
              39.91
            ],
            [
              -80.8,
              39.92
            ],
            [
              -80.79,
              39.87
            ],
            [
              -80.83,
              39.85
            ],
            [
              -80.83,
              39.8
            ],
            [
              -80.87,
              39.76
            ],
            [
              -80.83,
              39.71
            ],
            [
              -80.87,
              39.69
            ],
            [
              -80.88,
              39.62
            ],
            [
              -80.94,
              39.61
            ],
            [
              -81.04,
              39.54
            ],
            [
              -81.1,
              39.49
            ],
            [
              -81.13,
              39.45
            ],
            [
              -81.17,
              39.44
            ],
            [
              -81.21,
              39.39
            ],
            [
              -81.27,
              39.39
            ],
            [
              -81.35,
              39.35
            ],
            [
              -81.39,
              39.34
            ],
            [
              -81.41,
              39.39
            ],
            [
              -81.47,
              39.4
            ],
            [
              -81.56,
              39.34
            ],
            [
              -81.57,
              39.27
            ],
            [
              -81.68,
              39.27
            ],
            [
              -81.69,
              39.23
            ],
            [
              -81.73,
              39.22
            ],
            [
              -81.76,
              39.18
            ],
            [
              -81.74,
              39.1
            ],
            [
              -81.81,
              39.08
            ],
            [
              -81.8,
              39.05
            ],
            [
              -81.77,
              39.02
            ],
            [
              -81.78,
              38.92
            ],
            [
              -81.81,
              38.95
            ],
            [
              -81.85,
              38.93
            ],
            [
              -81.86,
              38.89
            ],
            [
              -81.89,
              38.87
            ],
            [
              -81.93,
              38.89
            ],
            [
              -81.9,
              38.93
            ],
            [
              -81.94,
              38.99
            ],
            [
              -81.98,
              38.99
            ],
            [
              -82.03,
              39.03
            ],
            [
              -82.05,
              39
            ],
            [
              -82.09,
              38.97
            ],
            [
              -82.14,
              38.9
            ],
            [
              -82.14,
              38.84
            ],
            [
              -82.22,
              38.8
            ],
            [
              -82.18,
              38.71
            ],
            [
              -82.17,
              38.62
            ],
            [
              -82.19,
              38.59
            ],
            [
              -82.25,
              38.6
            ],
            [
              -82.29,
              38.58
            ],
            [
              -82.3,
              38.49
            ],
            [
              -82.32,
              38.45
            ],
            [
              -82.41,
              38.44
            ],
            [
              -82.53,
              38.41
            ],
            [
              -82.6,
              38.42
            ],
            [
              -82.6,
              38.46
            ],
            [
              -82.65,
              38.49
            ],
            [
              -82.72,
              38.56
            ],
            [
              -82.8,
              38.56
            ],
            [
              -82.85,
              38.59
            ],
            [
              -82.88,
              38.69
            ],
            [
              -82.87,
              38.73
            ],
            [
              -82.89,
              38.76
            ],
            [
              -82.97,
              38.73
            ],
            [
              -83.02,
              38.73
            ],
            [
              -83.05,
              38.7
            ],
            [
              -83.12,
              38.67
            ],
            [
              -83.16,
              38.62
            ],
            [
              -83.26,
              38.62
            ],
            [
              -83.31,
              38.6
            ],
            [
              -83.33,
              38.64
            ],
            [
              -83.37,
              38.66
            ],
            [
              -83.47,
              38.68
            ],
            [
              -83.52,
              38.7
            ],
            [
              -83.61,
              38.68
            ],
            [
              -83.66,
              38.63
            ],
            [
              -83.77,
              38.65
            ],
            [
              -83.78,
              38.7
            ],
            [
              -83.84,
              38.72
            ],
            [
              -83.85,
              38.75
            ],
            [
              -83.95,
              38.79
            ],
            [
              -84.07,
              38.77
            ],
            [
              -84.21,
              38.81
            ],
            [
              -84.23,
              38.83
            ],
            [
              -84.23,
              38.88
            ],
            [
              -84.29,
              38.96
            ],
            [
              -84.33,
              39.03
            ],
            [
              -84.43,
              39.06
            ],
            [
              -84.44,
              39.11
            ],
            [
              -84.47,
              39.12
            ],
            [
              -84.5,
              39.1
            ],
            [
              -84.55,
              39.1
            ],
            [
              -84.6,
              39.07
            ],
            [
              -84.68,
              39.1
            ],
            [
              -84.73,
              39.14
            ],
            [
              -84.76,
              39.15
            ],
            [
              -84.82,
              39.11
            ],
            [
              -84.82,
              39.31
            ],
            [
              -84.81,
              39.55
            ],
            [
              -84.81,
              39.93
            ],
            [
              -84.8,
              40.3
            ],
            [
              -84.8,
              41.49
            ],
            [
              -84.81,
              41.7
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Oregon",
      fips: "41"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -123.55,
            46.26
          ],
          [
            -123.47,
            46.27
          ],
          [
            -123.43,
            46.23
          ],
          [
            -123.43,
            46.18
          ],
          [
            -123.37,
            46.15
          ],
          [
            -123.28,
            46.15
          ],
          [
            -123.17,
            46.19
          ],
          [
            -123.11,
            46.19
          ],
          [
            -122.9,
            46.08
          ],
          [
            -122.88,
            46.03
          ],
          [
            -122.81,
            45.96
          ],
          [
            -122.81,
            45.91
          ],
          [
            -122.78,
            45.87
          ],
          [
            -122.8,
            45.81
          ],
          [
            -122.76,
            45.73
          ],
          [
            -122.77,
            45.7
          ],
          [
            -122.76,
            45.66
          ],
          [
            -122.64,
            45.61
          ],
          [
            -122.48,
            45.58
          ],
          [
            -122.44,
            45.56
          ],
          [
            -122.38,
            45.58
          ],
          [
            -122.33,
            45.55
          ],
          [
            -122.27,
            45.54
          ],
          [
            -122.19,
            45.58
          ],
          [
            -122.1,
            45.58
          ],
          [
            -121.91,
            45.65
          ],
          [
            -121.87,
            45.69
          ],
          [
            -121.81,
            45.71
          ],
          [
            -121.74,
            45.69
          ],
          [
            -121.63,
            45.7
          ],
          [
            -121.53,
            45.73
          ],
          [
            -121.46,
            45.7
          ],
          [
            -121.4,
            45.69
          ],
          [
            -121.34,
            45.71
          ],
          [
            -121.22,
            45.67
          ],
          [
            -121.18,
            45.61
          ],
          [
            -121.13,
            45.61
          ],
          [
            -121.07,
            45.65
          ],
          [
            -120.94,
            45.66
          ],
          [
            -120.9,
            45.64
          ],
          [
            -120.86,
            45.67
          ],
          [
            -120.69,
            45.72
          ],
          [
            -120.63,
            45.75
          ],
          [
            -120.56,
            45.74
          ],
          [
            -120.48,
            45.69
          ],
          [
            -120.4,
            45.7
          ],
          [
            -120.28,
            45.72
          ],
          [
            -120.21,
            45.73
          ],
          [
            -120.17,
            45.76
          ],
          [
            -120.07,
            45.79
          ],
          [
            -119.97,
            45.82
          ],
          [
            -119.8,
            45.85
          ],
          [
            -119.67,
            45.86
          ],
          [
            -119.62,
            45.91
          ],
          [
            -119.57,
            45.93
          ],
          [
            -119.49,
            45.91
          ],
          [
            -119.26,
            45.94
          ],
          [
            -119.2,
            45.93
          ],
          [
            -119.13,
            45.93
          ],
          [
            -119.03,
            45.97
          ],
          [
            -118.99,
            46
          ],
          [
            -118.4,
            46
          ],
          [
            -117.5,
            46
          ],
          [
            -116.92,
            46
          ],
          [
            -116.86,
            45.9
          ],
          [
            -116.82,
            45.88
          ],
          [
            -116.76,
            45.82
          ],
          [
            -116.7,
            45.82
          ],
          [
            -116.66,
            45.78
          ],
          [
            -116.59,
            45.78
          ],
          [
            -116.54,
            45.74
          ],
          [
            -116.54,
            45.69
          ],
          [
            -116.49,
            45.65
          ],
          [
            -116.46,
            45.6
          ],
          [
            -116.55,
            45.51
          ],
          [
            -116.55,
            45.46
          ],
          [
            -116.59,
            45.44
          ],
          [
            -116.68,
            45.31
          ],
          [
            -116.67,
            45.28
          ],
          [
            -116.7,
            45.24
          ],
          [
            -116.73,
            45.14
          ],
          [
            -116.78,
            45.11
          ],
          [
            -116.8,
            45.06
          ],
          [
            -116.85,
            45.02
          ],
          [
            -116.86,
            44.98
          ],
          [
            -116.83,
            44.93
          ],
          [
            -116.87,
            44.87
          ],
          [
            -116.93,
            44.81
          ],
          [
            -116.93,
            44.79
          ],
          [
            -117.05,
            44.74
          ],
          [
            -117.1,
            44.67
          ],
          [
            -117.12,
            44.58
          ],
          [
            -117.16,
            44.52
          ],
          [
            -117.22,
            44.48
          ],
          [
            -117.21,
            44.43
          ],
          [
            -117.24,
            44.4
          ],
          [
            -117.19,
            44.34
          ],
          [
            -117.22,
            44.29
          ],
          [
            -117.17,
            44.26
          ],
          [
            -117.1,
            44.28
          ],
          [
            -117.05,
            44.23
          ],
          [
            -116.97,
            44.24
          ],
          [
            -116.97,
            44.19
          ],
          [
            -116.9,
            44.18
          ],
          [
            -116.9,
            44.15
          ],
          [
            -116.93,
            44.1
          ],
          [
            -116.98,
            44.09
          ],
          [
            -116.97,
            44.05
          ],
          [
            -116.93,
            44.02
          ],
          [
            -116.94,
            43.98
          ],
          [
            -116.98,
            43.92
          ],
          [
            -116.98,
            43.87
          ],
          [
            -117.02,
            43.86
          ],
          [
            -117.03,
            43.81
          ],
          [
            -117.03,
            42
          ],
          [
            -117.62,
            42
          ],
          [
            -118.6,
            41.99
          ],
          [
            -118.7,
            41.99
          ],
          [
            -119.21,
            41.99
          ],
          [
            -120,
            42
          ],
          [
            -120,
            41.99
          ],
          [
            -120,
            42
          ],
          [
            -120.33,
            41.99
          ],
          [
            -121.04,
            41.99
          ],
          [
            -121.45,
            42
          ],
          [
            -122,
            42
          ],
          [
            -122.16,
            42.01
          ],
          [
            -122.5,
            42.01
          ],
          [
            -122.63,
            42
          ],
          [
            -123.05,
            42
          ],
          [
            -123.15,
            42.01
          ],
          [
            -123.35,
            42
          ],
          [
            -123.62,
            42
          ],
          [
            -123.66,
            42
          ],
          [
            -124.21,
            42
          ],
          [
            -124.29,
            42.05
          ],
          [
            -124.34,
            42.09
          ],
          [
            -124.37,
            42.15
          ],
          [
            -124.36,
            42.18
          ],
          [
            -124.41,
            42.25
          ],
          [
            -124.4,
            42.28
          ],
          [
            -124.43,
            42.33
          ],
          [
            -124.44,
            42.44
          ],
          [
            -124.39,
            42.57
          ],
          [
            -124.41,
            42.66
          ],
          [
            -124.48,
            42.73
          ],
          [
            -124.51,
            42.73
          ],
          [
            -124.55,
            42.84
          ],
          [
            -124.5,
            42.92
          ],
          [
            -124.46,
            43
          ],
          [
            -124.44,
            43.07
          ],
          [
            -124.44,
            43.12
          ],
          [
            -124.4,
            43.18
          ],
          [
            -124.38,
            43.27
          ],
          [
            -124.4,
            43.31
          ],
          [
            -124.34,
            43.35
          ],
          [
            -124.31,
            43.39
          ],
          [
            -124.26,
            43.5
          ],
          [
            -124.2,
            43.67
          ],
          [
            -124.15,
            43.91
          ],
          [
            -124.12,
            44.1
          ],
          [
            -124.11,
            44.27
          ],
          [
            -124.12,
            44.27
          ],
          [
            -124.08,
            44.44
          ],
          [
            -124.08,
            44.5
          ],
          [
            -124.06,
            44.66
          ],
          [
            -124.06,
            44.74
          ],
          [
            -124.08,
            44.77
          ],
          [
            -124.05,
            44.85
          ],
          [
            -124.01,
            45.04
          ],
          [
            -123.98,
            45.15
          ],
          [
            -123.96,
            45.28
          ],
          [
            -123.97,
            45.34
          ],
          [
            -123.96,
            45.43
          ],
          [
            -123.98,
            45.49
          ],
          [
            -123.96,
            45.51
          ],
          [
            -123.94,
            45.66
          ],
          [
            -123.94,
            45.73
          ],
          [
            -123.98,
            45.76
          ],
          [
            -123.96,
            45.84
          ],
          [
            -123.97,
            45.91
          ],
          [
            -123.99,
            45.95
          ],
          [
            -123.94,
            45.98
          ],
          [
            -123.93,
            46.07
          ],
          [
            -124,
            46.24
          ],
          [
            -123.9,
            46.17
          ],
          [
            -123.85,
            46.16
          ],
          [
            -123.87,
            46.19
          ],
          [
            -123.78,
            46.2
          ],
          [
            -123.76,
            46.21
          ],
          [
            -123.72,
            46.19
          ],
          [
            -123.67,
            46.22
          ],
          [
            -123.62,
            46.22
          ],
          [
            -123.55,
            46.26
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Tennessee",
      fips: "47"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -89.73,
            36
          ],
          [
            -89.69,
            36.02
          ],
          [
            -89.68,
            36.08
          ],
          [
            -89.6,
            36.12
          ],
          [
            -89.61,
            36.17
          ],
          [
            -89.71,
            36.24
          ],
          [
            -89.69,
            36.25
          ],
          [
            -89.59,
            36.24
          ],
          [
            -89.53,
            36.25
          ],
          [
            -89.54,
            36.28
          ],
          [
            -89.61,
            36.31
          ],
          [
            -89.61,
            36.34
          ],
          [
            -89.53,
            36.34
          ],
          [
            -89.51,
            36.37
          ],
          [
            -89.54,
            36.42
          ],
          [
            -89.52,
            36.48
          ],
          [
            -89.54,
            36.5
          ],
          [
            -89.49,
            36.5
          ],
          [
            -89.49,
            36.47
          ],
          [
            -89.45,
            36.46
          ],
          [
            -89.42,
            36.5
          ],
          [
            -89.3,
            36.51
          ],
          [
            -89,
            36.5
          ],
          [
            -88.55,
            36.5
          ],
          [
            -88.05,
            36.5
          ],
          [
            -88.03,
            36.55
          ],
          [
            -88.07,
            36.68
          ],
          [
            -87.85,
            36.66
          ],
          [
            -87.85,
            36.63
          ],
          [
            -87.44,
            36.64
          ],
          [
            -87.11,
            36.64
          ],
          [
            -86.59,
            36.65
          ],
          [
            -86.57,
            36.63
          ],
          [
            -86.51,
            36.65
          ],
          [
            -86.33,
            36.65
          ],
          [
            -86.03,
            36.63
          ],
          [
            -85.83,
            36.62
          ],
          [
            -85.49,
            36.61
          ],
          [
            -85.29,
            36.63
          ],
          [
            -85.03,
            36.62
          ],
          [
            -84.84,
            36.61
          ],
          [
            -84.54,
            36.6
          ],
          [
            -84.27,
            36.59
          ],
          [
            -83.99,
            36.59
          ],
          [
            -83.69,
            36.58
          ],
          [
            -83.68,
            36.6
          ],
          [
            -83.56,
            36.6
          ],
          [
            -83.28,
            36.6
          ],
          [
            -83.26,
            36.59
          ],
          [
            -82.7,
            36.59
          ],
          [
            -82.48,
            36.6
          ],
          [
            -81.93,
            36.59
          ],
          [
            -81.92,
            36.62
          ],
          [
            -81.65,
            36.61
          ],
          [
            -81.68,
            36.59
          ],
          [
            -81.71,
            36.54
          ],
          [
            -81.69,
            36.47
          ],
          [
            -81.72,
            36.46
          ],
          [
            -81.74,
            36.4
          ],
          [
            -81.71,
            36.34
          ],
          [
            -81.77,
            36.34
          ],
          [
            -81.79,
            36.36
          ],
          [
            -81.83,
            36.35
          ],
          [
            -81.91,
            36.3
          ],
          [
            -82.03,
            36.13
          ],
          [
            -82.08,
            36.11
          ],
          [
            -82.13,
            36.11
          ],
          [
            -82.15,
            36.15
          ],
          [
            -82.21,
            36.16
          ],
          [
            -82.25,
            36.13
          ],
          [
            -82.29,
            36.14
          ],
          [
            -82.35,
            36.12
          ],
          [
            -82.41,
            36.09
          ],
          [
            -82.46,
            36.01
          ],
          [
            -82.56,
            35.95
          ],
          [
            -82.61,
            35.97
          ],
          [
            -82.6,
            36.03
          ],
          [
            -82.63,
            36.07
          ],
          [
            -82.75,
            36.01
          ],
          [
            -82.82,
            35.92
          ],
          [
            -82.88,
            35.95
          ],
          [
            -82.91,
            35.93
          ],
          [
            -82.9,
            35.87
          ],
          [
            -82.99,
            35.77
          ],
          [
            -83.08,
            35.79
          ],
          [
            -83.16,
            35.76
          ],
          [
            -83.18,
            35.73
          ],
          [
            -83.24,
            35.73
          ],
          [
            -83.26,
            35.7
          ],
          [
            -83.31,
            35.66
          ],
          [
            -83.35,
            35.66
          ],
          [
            -83.37,
            35.64
          ],
          [
            -83.45,
            35.61
          ],
          [
            -83.49,
            35.57
          ],
          [
            -83.77,
            35.56
          ],
          [
            -83.83,
            35.52
          ],
          [
            -83.88,
            35.52
          ],
          [
            -83.91,
            35.48
          ],
          [
            -83.96,
            35.46
          ],
          [
            -84.02,
            35.41
          ],
          [
            -84.01,
            35.37
          ],
          [
            -84.04,
            35.35
          ],
          [
            -84.02,
            35.3
          ],
          [
            -84.1,
            35.25
          ],
          [
            -84.2,
            35.24
          ],
          [
            -84.21,
            35.27
          ],
          [
            -84.29,
            35.22
          ],
          [
            -84.32,
            34.99
          ],
          [
            -84.98,
            34.99
          ],
          [
            -85.47,
            34.98
          ],
          [
            -85.61,
            34.98
          ],
          [
            -85.83,
            34.99
          ],
          [
            -86.4,
            34.99
          ],
          [
            -86.53,
            34.99
          ],
          [
            -86.86,
            34.99
          ],
          [
            -87.44,
            35
          ],
          [
            -87.66,
            35
          ],
          [
            -88.2,
            35.01
          ],
          [
            -88.2,
            35
          ],
          [
            -88.93,
            34.99
          ],
          [
            -89.49,
            34.99
          ],
          [
            -90.31,
            35
          ],
          [
            -90.3,
            35.04
          ],
          [
            -90.21,
            35.03
          ],
          [
            -90.18,
            35.11
          ],
          [
            -90.14,
            35.13
          ],
          [
            -90.1,
            35.12
          ],
          [
            -90.06,
            35.14
          ],
          [
            -90.12,
            35.19
          ],
          [
            -90.08,
            35.22
          ],
          [
            -90.1,
            35.25
          ],
          [
            -90.15,
            35.26
          ],
          [
            -90.17,
            35.3
          ],
          [
            -90.11,
            35.3
          ],
          [
            -90.11,
            35.34
          ],
          [
            -90.08,
            35.38
          ],
          [
            -90.13,
            35.41
          ],
          [
            -90.14,
            35.38
          ],
          [
            -90.18,
            35.38
          ],
          [
            -90.17,
            35.42
          ],
          [
            -90.09,
            35.48
          ],
          [
            -90.06,
            35.4
          ],
          [
            -90.02,
            35.47
          ],
          [
            -90.05,
            35.5
          ],
          [
            -90.03,
            35.55
          ],
          [
            -90,
            35.56
          ],
          [
            -89.92,
            35.51
          ],
          [
            -89.91,
            35.55
          ],
          [
            -89.94,
            35.56
          ],
          [
            -89.95,
            35.6
          ],
          [
            -89.85,
            35.64
          ],
          [
            -89.86,
            35.67
          ],
          [
            -89.91,
            35.65
          ],
          [
            -89.94,
            35.67
          ],
          [
            -89.96,
            35.72
          ],
          [
            -89.91,
            35.76
          ],
          [
            -89.87,
            35.74
          ],
          [
            -89.81,
            35.76
          ],
          [
            -89.78,
            35.8
          ],
          [
            -89.74,
            35.81
          ],
          [
            -89.7,
            35.83
          ],
          [
            -89.77,
            35.86
          ],
          [
            -89.74,
            35.91
          ],
          [
            -89.66,
            35.89
          ],
          [
            -89.66,
            35.93
          ],
          [
            -89.72,
            35.97
          ],
          [
            -89.73,
            36
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Utah",
      fips: "49"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -114.04,
            41.99
          ],
          [
            -113.82,
            41.99
          ],
          [
            -112.88,
            42
          ],
          [
            -112.19,
            42
          ],
          [
            -112.17,
            42
          ],
          [
            -111.47,
            42
          ],
          [
            -111.05,
            42
          ],
          [
            -111.04,
            41.57
          ],
          [
            -111.05,
            41.38
          ],
          [
            -111.05,
            41
          ],
          [
            -110.71,
            41
          ],
          [
            -110.24,
            41
          ],
          [
            -110.05,
            41
          ],
          [
            -109.54,
            41
          ],
          [
            -109.05,
            41
          ],
          [
            -109.05,
            40.54
          ],
          [
            -109.05,
            40.5
          ],
          [
            -109.05,
            38.91
          ],
          [
            -109.06,
            38.72
          ],
          [
            -109.06,
            38.28
          ],
          [
            -109.04,
            38.16
          ],
          [
            -109.04,
            37.53
          ],
          [
            -109.04,
            37.5
          ],
          [
            -109.04,
            37
          ],
          [
            -109.63,
            37
          ],
          [
            -110.47,
            37
          ],
          [
            -110.49,
            37
          ],
          [
            -111.07,
            37
          ],
          [
            -111.41,
            37
          ],
          [
            -112.54,
            37
          ],
          [
            -113.33,
            37
          ],
          [
            -114.05,
            37
          ],
          [
            -114.05,
            37.76
          ],
          [
            -114.05,
            37.77
          ],
          [
            -114.05,
            38
          ],
          [
            -114.05,
            38.15
          ],
          [
            -114.05,
            38.4
          ],
          [
            -114.05,
            38.68
          ],
          [
            -114.05,
            40.1
          ],
          [
            -114.04,
            40.23
          ],
          [
            -114.04,
            40.77
          ],
          [
            -114.04,
            41
          ],
          [
            -114.04,
            41.99
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Virginia",
      fips: "51"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -76,
              37.85
            ],
            [
              -75.97,
              37.84
            ],
            [
              -76,
              37.81
            ],
            [
              -76,
              37.85
            ]
          ]
        ],
        [
          [
            [
              -75.67,
              37.95
            ],
            [
              -75.65,
              37.95
            ],
            [
              -75.62,
              37.99
            ],
            [
              -75.24,
              38.03
            ],
            [
              -75.3,
              37.96
            ],
            [
              -75.35,
              37.88
            ],
            [
              -75.38,
              37.85
            ],
            [
              -75.4,
              37.87
            ],
            [
              -75.45,
              37.86
            ],
            [
              -75.52,
              37.8
            ],
            [
              -75.56,
              37.74
            ],
            [
              -75.6,
              37.63
            ],
            [
              -75.6,
              37.57
            ],
            [
              -75.68,
              37.46
            ],
            [
              -75.66,
              37.45
            ],
            [
              -75.72,
              37.37
            ],
            [
              -75.76,
              37.31
            ],
            [
              -75.8,
              37.3
            ],
            [
              -75.79,
              37.25
            ],
            [
              -75.83,
              37.17
            ],
            [
              -75.9,
              37.12
            ],
            [
              -75.96,
              37.12
            ],
            [
              -75.94,
              37.09
            ],
            [
              -75.97,
              37.09
            ],
            [
              -75.98,
              37.16
            ],
            [
              -76.01,
              37.2
            ],
            [
              -76.03,
              37.26
            ],
            [
              -76.02,
              37.32
            ],
            [
              -75.99,
              37.37
            ],
            [
              -75.98,
              37.44
            ],
            [
              -75.94,
              37.53
            ],
            [
              -75.93,
              37.6
            ],
            [
              -75.87,
              37.67
            ],
            [
              -75.8,
              37.76
            ],
            [
              -75.82,
              37.79
            ],
            [
              -75.74,
              37.81
            ],
            [
              -75.69,
              37.86
            ],
            [
              -75.69,
              37.89
            ],
            [
              -75.76,
              37.9
            ],
            [
              -75.67,
              37.95
            ]
          ]
        ],
        [
          [
            [
              -75.99,
              37.95
            ],
            [
              -76.03,
              37.92
            ],
            [
              -76.04,
              37.95
            ],
            [
              -75.99,
              37.95
            ]
          ]
        ],
        [
          [
            [
              -81.97,
              37.54
            ],
            [
              -81.93,
              37.51
            ],
            [
              -81.99,
              37.48
            ],
            [
              -81.99,
              37.45
            ],
            [
              -81.93,
              37.44
            ],
            [
              -81.93,
              37.36
            ],
            [
              -81.88,
              37.33
            ],
            [
              -81.85,
              37.29
            ],
            [
              -81.79,
              37.28
            ],
            [
              -81.74,
              37.26
            ],
            [
              -81.74,
              37.24
            ],
            [
              -81.68,
              37.2
            ],
            [
              -81.55,
              37.21
            ],
            [
              -81.51,
              37.23
            ],
            [
              -81.5,
              37.26
            ],
            [
              -81.42,
              37.27
            ],
            [
              -81.39,
              37.32
            ],
            [
              -81.36,
              37.34
            ],
            [
              -81.32,
              37.3
            ],
            [
              -81.22,
              37.24
            ],
            [
              -81.11,
              37.28
            ],
            [
              -80.98,
              37.3
            ],
            [
              -80.92,
              37.31
            ],
            [
              -80.85,
              37.35
            ],
            [
              -80.88,
              37.38
            ],
            [
              -80.86,
              37.43
            ],
            [
              -80.78,
              37.39
            ],
            [
              -80.77,
              37.37
            ],
            [
              -80.62,
              37.43
            ],
            [
              -80.55,
              37.47
            ],
            [
              -80.51,
              37.48
            ],
            [
              -80.47,
              37.42
            ],
            [
              -80.3,
              37.51
            ],
            [
              -80.28,
              37.53
            ],
            [
              -80.33,
              37.54
            ],
            [
              -80.33,
              37.56
            ],
            [
              -80.26,
              37.59
            ],
            [
              -80.22,
              37.63
            ],
            [
              -80.28,
              37.66
            ],
            [
              -80.29,
              37.69
            ],
            [
              -80.25,
              37.73
            ],
            [
              -80.26,
              37.76
            ],
            [
              -80.18,
              37.85
            ],
            [
              -80.08,
              37.94
            ],
            [
              -80.01,
              37.99
            ],
            [
              -79.98,
              38.03
            ],
            [
              -79.95,
              38.08
            ],
            [
              -79.92,
              38.11
            ],
            [
              -79.95,
              38.13
            ],
            [
              -79.92,
              38.18
            ],
            [
              -79.83,
              38.25
            ],
            [
              -79.79,
              38.27
            ],
            [
              -79.81,
              38.31
            ],
            [
              -79.73,
              38.38
            ],
            [
              -79.69,
              38.43
            ],
            [
              -79.7,
              38.49
            ],
            [
              -79.65,
              38.59
            ],
            [
              -79.54,
              38.55
            ],
            [
              -79.48,
              38.46
            ],
            [
              -79.31,
              38.41
            ],
            [
              -79.21,
              38.49
            ],
            [
              -79.16,
              38.61
            ],
            [
              -79.12,
              38.66
            ],
            [
              -79.09,
              38.66
            ],
            [
              -79.09,
              38.72
            ],
            [
              -79.03,
              38.79
            ],
            [
              -79,
              38.85
            ],
            [
              -78.87,
              38.76
            ],
            [
              -78.8,
              38.87
            ],
            [
              -78.72,
              38.94
            ],
            [
              -78.72,
              38.91
            ],
            [
              -78.68,
              38.93
            ],
            [
              -78.63,
              38.98
            ],
            [
              -78.6,
              38.96
            ],
            [
              -78.55,
              39.02
            ],
            [
              -78.57,
              39.03
            ],
            [
              -78.49,
              39.11
            ],
            [
              -78.46,
              39.11
            ],
            [
              -78.4,
              39.17
            ],
            [
              -78.44,
              39.2
            ],
            [
              -78.4,
              39.24
            ],
            [
              -78.42,
              39.26
            ],
            [
              -78.34,
              39.35
            ],
            [
              -78.36,
              39.36
            ],
            [
              -78.34,
              39.39
            ],
            [
              -78.36,
              39.41
            ],
            [
              -78.35,
              39.47
            ],
            [
              -78.11,
              39.31
            ],
            [
              -77.83,
              39.13
            ],
            [
              -77.75,
              39.28
            ],
            [
              -77.72,
              39.32
            ],
            [
              -77.67,
              39.32
            ],
            [
              -77.62,
              39.3
            ],
            [
              -77.56,
              39.3
            ],
            [
              -77.54,
              39.26
            ],
            [
              -77.46,
              39.23
            ],
            [
              -77.48,
              39.19
            ],
            [
              -77.52,
              39.17
            ],
            [
              -77.52,
              39.12
            ],
            [
              -77.48,
              39.11
            ],
            [
              -77.46,
              39.08
            ],
            [
              -77.34,
              39.06
            ],
            [
              -77.25,
              39.03
            ],
            [
              -77.25,
              38.99
            ],
            [
              -77.22,
              38.97
            ],
            [
              -77.15,
              38.97
            ],
            [
              -77.12,
              38.93
            ],
            [
              -77.04,
              38.87
            ],
            [
              -77.04,
              38.79
            ],
            [
              -77.04,
              38.72
            ],
            [
              -77.11,
              38.7
            ],
            [
              -77.13,
              38.67
            ],
            [
              -77.13,
              38.64
            ],
            [
              -77.2,
              38.62
            ],
            [
              -77.25,
              38.64
            ],
            [
              -77.25,
              38.59
            ],
            [
              -77.31,
              38.49
            ],
            [
              -77.33,
              38.45
            ],
            [
              -77.32,
              38.38
            ],
            [
              -77.27,
              38.33
            ],
            [
              -77.16,
              38.35
            ],
            [
              -77.14,
              38.37
            ],
            [
              -77.09,
              38.37
            ],
            [
              -77.04,
              38.4
            ],
            [
              -77.01,
              38.37
            ],
            [
              -77.03,
              38.31
            ],
            [
              -76.96,
              38.26
            ],
            [
              -76.96,
              38.21
            ],
            [
              -76.84,
              38.16
            ],
            [
              -76.75,
              38.16
            ],
            [
              -76.72,
              38.14
            ],
            [
              -76.7,
              38.16
            ],
            [
              -76.62,
              38.15
            ],
            [
              -76.6,
              38.11
            ],
            [
              -76.54,
              38.08
            ],
            [
              -76.52,
              38.03
            ],
            [
              -76.47,
              38.01
            ],
            [
              -76.41,
              37.97
            ],
            [
              -76.34,
              37.95
            ],
            [
              -76.24,
              37.89
            ],
            [
              -76.25,
              37.83
            ],
            [
              -76.31,
              37.81
            ],
            [
              -76.31,
              37.72
            ],
            [
              -76.3,
              37.7
            ],
            [
              -76.34,
              37.66
            ],
            [
              -76.29,
              37.64
            ],
            [
              -76.36,
              37.61
            ],
            [
              -76.47,
              37.67
            ],
            [
              -76.51,
              37.64
            ],
            [
              -76.54,
              37.66
            ],
            [
              -76.54,
              37.7
            ],
            [
              -76.58,
              37.77
            ],
            [
              -76.65,
              37.8
            ],
            [
              -76.68,
              37.83
            ],
            [
              -76.72,
              37.84
            ],
            [
              -76.8,
              37.92
            ],
            [
              -76.84,
              37.93
            ],
            [
              -76.85,
              37.97
            ],
            [
              -76.9,
              38
            ],
            [
              -76.91,
              37.97
            ],
            [
              -76.81,
              37.9
            ],
            [
              -76.73,
              37.8
            ],
            [
              -76.68,
              37.78
            ],
            [
              -76.68,
              37.76
            ],
            [
              -76.62,
              37.74
            ],
            [
              -76.58,
              37.66
            ],
            [
              -76.54,
              37.62
            ],
            [
              -76.44,
              37.61
            ],
            [
              -76.41,
              37.58
            ],
            [
              -76.3,
              37.56
            ],
            [
              -76.35,
              37.54
            ],
            [
              -76.35,
              37.5
            ],
            [
              -76.31,
              37.5
            ],
            [
              -76.29,
              37.52
            ],
            [
              -76.26,
              37.48
            ],
            [
              -76.25,
              37.39
            ],
            [
              -76.27,
              37.31
            ],
            [
              -76.34,
              37.36
            ],
            [
              -76.41,
              37.4
            ],
            [
              -76.45,
              37.37
            ],
            [
              -76.41,
              37.33
            ],
            [
              -76.38,
              37.29
            ],
            [
              -76.35,
              37.27
            ],
            [
              -76.43,
              37.25
            ],
            [
              -76.49,
              37.25
            ],
            [
              -76.47,
              37.22
            ],
            [
              -76.39,
              37.23
            ],
            [
              -76.4,
              37.16
            ],
            [
              -76.35,
              37.17
            ],
            [
              -76.34,
              37.14
            ],
            [
              -76.29,
              37.13
            ],
            [
              -76.27,
              37.08
            ],
            [
              -76.3,
              37
            ],
            [
              -76.32,
              37.01
            ],
            [
              -76.38,
              37
            ],
            [
              -76.43,
              36.97
            ],
            [
              -76.46,
              37.03
            ],
            [
              -76.57,
              37.08
            ],
            [
              -76.62,
              37.12
            ],
            [
              -76.6,
              37.16
            ],
            [
              -76.65,
              37.22
            ],
            [
              -76.73,
              37.21
            ],
            [
              -76.76,
              37.19
            ],
            [
              -76.8,
              37.23
            ],
            [
              -76.86,
              37.24
            ],
            [
              -76.87,
              37.26
            ],
            [
              -76.95,
              37.23
            ],
            [
              -76.91,
              37.2
            ],
            [
              -76.87,
              37.21
            ],
            [
              -76.8,
              37.2
            ],
            [
              -76.75,
              37.15
            ],
            [
              -76.72,
              37.15
            ],
            [
              -76.69,
              37.2
            ],
            [
              -76.66,
              37.1
            ],
            [
              -76.66,
              37.04
            ],
            [
              -76.58,
              37.02
            ],
            [
              -76.49,
              36.95
            ],
            [
              -76.48,
              36.9
            ],
            [
              -76.39,
              36.9
            ],
            [
              -76.35,
              36.92
            ],
            [
              -76.35,
              36.89
            ],
            [
              -76.32,
              36.89
            ],
            [
              -76.33,
              36.96
            ],
            [
              -76.27,
              36.96
            ],
            [
              -76.22,
              36.94
            ],
            [
              -76.1,
              36.91
            ],
            [
              -76.03,
              36.93
            ],
            [
              -75.99,
              36.92
            ],
            [
              -75.97,
              36.81
            ],
            [
              -75.92,
              36.69
            ],
            [
              -75.89,
              36.63
            ],
            [
              -75.87,
              36.55
            ],
            [
              -76.38,
              36.55
            ],
            [
              -76.81,
              36.55
            ],
            [
              -76.92,
              36.55
            ],
            [
              -76.92,
              36.54
            ],
            [
              -77.3,
              36.54
            ],
            [
              -78.25,
              36.54
            ],
            [
              -78.51,
              36.54
            ],
            [
              -79.51,
              36.54
            ],
            [
              -80.12,
              36.54
            ],
            [
              -80.29,
              36.54
            ],
            [
              -80.7,
              36.56
            ],
            [
              -80.84,
              36.56
            ],
            [
              -81.18,
              36.57
            ],
            [
              -81.37,
              36.57
            ],
            [
              -81.68,
              36.59
            ],
            [
              -81.65,
              36.61
            ],
            [
              -81.92,
              36.62
            ],
            [
              -81.93,
              36.59
            ],
            [
              -82.48,
              36.6
            ],
            [
              -82.7,
              36.59
            ],
            [
              -83.26,
              36.59
            ],
            [
              -83.28,
              36.6
            ],
            [
              -83.56,
              36.6
            ],
            [
              -83.68,
              36.6
            ],
            [
              -83.65,
              36.62
            ],
            [
              -83.53,
              36.67
            ],
            [
              -83.45,
              36.66
            ],
            [
              -83.31,
              36.71
            ],
            [
              -83.19,
              36.74
            ],
            [
              -83.14,
              36.74
            ],
            [
              -83.13,
              36.79
            ],
            [
              -83.07,
              36.85
            ],
            [
              -82.97,
              36.86
            ],
            [
              -82.88,
              36.89
            ],
            [
              -82.86,
              36.93
            ],
            [
              -82.87,
              36.98
            ],
            [
              -82.83,
              37.01
            ],
            [
              -82.78,
              37.01
            ],
            [
              -82.72,
              37.04
            ],
            [
              -82.72,
              37.12
            ],
            [
              -82.63,
              37.15
            ],
            [
              -82.57,
              37.2
            ],
            [
              -82.49,
              37.23
            ],
            [
              -82.35,
              37.27
            ],
            [
              -81.97,
              37.54
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Washington",
      fips: "53"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -122.53,
              47.36
            ],
            [
              -122.51,
              47.45
            ],
            [
              -122.48,
              47.51
            ],
            [
              -122.43,
              47.47
            ],
            [
              -122.44,
              47.42
            ],
            [
              -122.37,
              47.39
            ],
            [
              -122.44,
              47.37
            ],
            [
              -122.45,
              47.34
            ],
            [
              -122.52,
              47.33
            ],
            [
              -122.53,
              47.36
            ]
          ]
        ],
        [
          [
            [
              -122.65,
              48.55
            ],
            [
              -122.65,
              48.58
            ],
            [
              -122.58,
              48.55
            ],
            [
              -122.64,
              48.53
            ],
            [
              -122.65,
              48.55
            ]
          ]
        ],
        [
          [
            [
              -122.72,
              48.73
            ],
            [
              -122.7,
              48.74
            ],
            [
              -122.61,
              48.65
            ],
            [
              -122.67,
              48.68
            ],
            [
              -122.72,
              48.73
            ]
          ]
        ],
        [
          [
            [
              -122.74,
              48.58
            ],
            [
              -122.71,
              48.61
            ],
            [
              -122.67,
              48.57
            ],
            [
              -122.72,
              48.54
            ],
            [
              -122.74,
              48.58
            ]
          ]
        ],
        [
          [
            [
              -122.77,
              48.23
            ],
            [
              -122.72,
              48.3
            ],
            [
              -122.67,
              48.35
            ],
            [
              -122.67,
              48.4
            ],
            [
              -122.61,
              48.41
            ],
            [
              -122.58,
              48.4
            ],
            [
              -122.58,
              48.35
            ],
            [
              -122.52,
              48.32
            ],
            [
              -122.5,
              48.3
            ],
            [
              -122.56,
              48.28
            ],
            [
              -122.62,
              48.29
            ],
            [
              -122.62,
              48.27
            ],
            [
              -122.67,
              48.24
            ],
            [
              -122.72,
              48.23
            ],
            [
              -122.71,
              48.21
            ],
            [
              -122.63,
              48.22
            ],
            [
              -122.59,
              48.19
            ],
            [
              -122.56,
              48.11
            ],
            [
              -122.57,
              48.1
            ],
            [
              -122.54,
              48.02
            ],
            [
              -122.51,
              48.04
            ],
            [
              -122.53,
              48.1
            ],
            [
              -122.49,
              48.09
            ],
            [
              -122.43,
              48.05
            ],
            [
              -122.38,
              48.03
            ],
            [
              -122.35,
              47.95
            ],
            [
              -122.38,
              47.9
            ],
            [
              -122.43,
              47.91
            ],
            [
              -122.47,
              47.99
            ],
            [
              -122.55,
              47.97
            ],
            [
              -122.54,
              47.99
            ],
            [
              -122.61,
              48.03
            ],
            [
              -122.6,
              48.11
            ],
            [
              -122.62,
              48.16
            ],
            [
              -122.68,
              48.16
            ],
            [
              -122.69,
              48.18
            ],
            [
              -122.77,
              48.23
            ]
          ]
        ],
        [
          [
            [
              -122.98,
              48.79
            ],
            [
              -122.94,
              48.79
            ],
            [
              -122.82,
              48.74
            ],
            [
              -122.85,
              48.74
            ],
            [
              -122.92,
              48.75
            ],
            [
              -122.98,
              48.79
            ]
          ]
        ],
        [
          [
            [
              -123.07,
              48.7
            ],
            [
              -123.01,
              48.72
            ],
            [
              -123,
              48.69
            ],
            [
              -123.07,
              48.7
            ]
          ]
        ],
        [
          [
            [
              -123.09,
              49
            ],
            [
              -123.04,
              49
            ],
            [
              -123.02,
              48.98
            ],
            [
              -123.08,
              48.98
            ],
            [
              -123.09,
              49
            ]
          ]
        ],
        [
          [
            [
              -123.2,
              48.6
            ],
            [
              -123.18,
              48.62
            ],
            [
              -123.11,
              48.62
            ],
            [
              -123.1,
              48.6
            ],
            [
              -123.05,
              48.57
            ],
            [
              -122.99,
              48.56
            ],
            [
              -123.05,
              48.62
            ],
            [
              -122.92,
              48.71
            ],
            [
              -122.87,
              48.71
            ],
            [
              -122.74,
              48.66
            ],
            [
              -122.81,
              48.62
            ],
            [
              -122.77,
              48.56
            ],
            [
              -122.78,
              48.51
            ],
            [
              -122.82,
              48.49
            ],
            [
              -122.8,
              48.43
            ],
            [
              -122.87,
              48.42
            ],
            [
              -122.93,
              48.46
            ],
            [
              -122.96,
              48.45
            ],
            [
              -123.04,
              48.46
            ],
            [
              -123.15,
              48.51
            ],
            [
              -123.17,
              48.58
            ],
            [
              -123.2,
              48.6
            ]
          ]
        ],
        [
          [
            [
              -123.24,
              48.69
            ],
            [
              -123.17,
              48.68
            ],
            [
              -123.11,
              48.63
            ],
            [
              -123.22,
              48.67
            ],
            [
              -123.24,
              48.69
            ]
          ]
        ],
        [
          [
            [
              -117.03,
              49
            ],
            [
              -117.03,
              48.75
            ],
            [
              -117.03,
              48.37
            ],
            [
              -117.04,
              48.13
            ],
            [
              -117.04,
              47.52
            ],
            [
              -117.04,
              47.48
            ],
            [
              -117.04,
              46.41
            ],
            [
              -117.06,
              46.37
            ],
            [
              -116.99,
              46.3
            ],
            [
              -116.96,
              46.25
            ],
            [
              -116.96,
              46.2
            ],
            [
              -116.92,
              46.16
            ],
            [
              -116.98,
              46.09
            ],
            [
              -116.96,
              46.08
            ],
            [
              -116.92,
              46
            ],
            [
              -117.5,
              46
            ],
            [
              -118.4,
              46
            ],
            [
              -118.99,
              46
            ],
            [
              -119.03,
              45.97
            ],
            [
              -119.13,
              45.93
            ],
            [
              -119.2,
              45.93
            ],
            [
              -119.26,
              45.94
            ],
            [
              -119.49,
              45.91
            ],
            [
              -119.57,
              45.93
            ],
            [
              -119.62,
              45.91
            ],
            [
              -119.67,
              45.86
            ],
            [
              -119.8,
              45.85
            ],
            [
              -119.97,
              45.82
            ],
            [
              -120.07,
              45.79
            ],
            [
              -120.17,
              45.76
            ],
            [
              -120.21,
              45.73
            ],
            [
              -120.28,
              45.72
            ],
            [
              -120.4,
              45.7
            ],
            [
              -120.48,
              45.69
            ],
            [
              -120.56,
              45.74
            ],
            [
              -120.63,
              45.75
            ],
            [
              -120.69,
              45.72
            ],
            [
              -120.86,
              45.67
            ],
            [
              -120.9,
              45.64
            ],
            [
              -120.94,
              45.66
            ],
            [
              -121.07,
              45.65
            ],
            [
              -121.13,
              45.61
            ],
            [
              -121.18,
              45.61
            ],
            [
              -121.22,
              45.67
            ],
            [
              -121.34,
              45.71
            ],
            [
              -121.4,
              45.69
            ],
            [
              -121.46,
              45.7
            ],
            [
              -121.53,
              45.73
            ],
            [
              -121.63,
              45.7
            ],
            [
              -121.74,
              45.69
            ],
            [
              -121.81,
              45.71
            ],
            [
              -121.87,
              45.69
            ],
            [
              -121.91,
              45.65
            ],
            [
              -122.1,
              45.58
            ],
            [
              -122.19,
              45.58
            ],
            [
              -122.27,
              45.54
            ],
            [
              -122.33,
              45.55
            ],
            [
              -122.38,
              45.58
            ],
            [
              -122.44,
              45.56
            ],
            [
              -122.48,
              45.58
            ],
            [
              -122.64,
              45.61
            ],
            [
              -122.76,
              45.66
            ],
            [
              -122.77,
              45.7
            ],
            [
              -122.76,
              45.73
            ],
            [
              -122.8,
              45.81
            ],
            [
              -122.78,
              45.87
            ],
            [
              -122.81,
              45.91
            ],
            [
              -122.81,
              45.96
            ],
            [
              -122.88,
              46.03
            ],
            [
              -122.9,
              46.08
            ],
            [
              -123.11,
              46.19
            ],
            [
              -123.17,
              46.19
            ],
            [
              -123.28,
              46.15
            ],
            [
              -123.37,
              46.15
            ],
            [
              -123.43,
              46.18
            ],
            [
              -123.43,
              46.23
            ],
            [
              -123.47,
              46.27
            ],
            [
              -123.55,
              46.26
            ],
            [
              -123.67,
              46.27
            ],
            [
              -123.68,
              46.3
            ],
            [
              -123.73,
              46.3
            ],
            [
              -123.76,
              46.27
            ],
            [
              -123.81,
              46.28
            ],
            [
              -123.88,
              46.24
            ],
            [
              -123.91,
              46.25
            ],
            [
              -123.98,
              46.31
            ],
            [
              -124.02,
              46.32
            ],
            [
              -124.04,
              46.28
            ],
            [
              -124.08,
              46.27
            ],
            [
              -124.06,
              46.39
            ],
            [
              -124.06,
              46.49
            ],
            [
              -124.07,
              46.63
            ],
            [
              -124.02,
              46.58
            ],
            [
              -124.03,
              46.5
            ],
            [
              -124.02,
              46.38
            ],
            [
              -123.95,
              46.38
            ],
            [
              -123.95,
              46.41
            ],
            [
              -123.99,
              46.44
            ],
            [
              -123.99,
              46.5
            ],
            [
              -123.94,
              46.47
            ],
            [
              -123.89,
              46.54
            ],
            [
              -123.96,
              46.64
            ],
            [
              -123.92,
              46.67
            ],
            [
              -123.83,
              46.72
            ],
            [
              -123.89,
              46.75
            ],
            [
              -123.92,
              46.73
            ],
            [
              -123.98,
              46.73
            ],
            [
              -123.97,
              46.71
            ],
            [
              -124.02,
              46.71
            ],
            [
              -124.09,
              46.75
            ],
            [
              -124.1,
              46.79
            ],
            [
              -124.14,
              46.91
            ],
            [
              -124.11,
              46.91
            ],
            [
              -124.09,
              46.87
            ],
            [
              -124.05,
              46.89
            ],
            [
              -123.86,
              46.95
            ],
            [
              -123.9,
              46.97
            ],
            [
              -124.02,
              46.99
            ],
            [
              -124.03,
              47.03
            ],
            [
              -124.12,
              47.04
            ],
            [
              -124.15,
              47.02
            ],
            [
              -124.12,
              46.94
            ],
            [
              -124.18,
              46.93
            ],
            [
              -124.17,
              46.96
            ],
            [
              -124.18,
              47.14
            ],
            [
              -124.23,
              47.29
            ],
            [
              -124.32,
              47.36
            ],
            [
              -124.35,
              47.53
            ],
            [
              -124.37,
              47.6
            ],
            [
              -124.42,
              47.74
            ],
            [
              -124.48,
              47.77
            ],
            [
              -124.49,
              47.82
            ],
            [
              -124.54,
              47.84
            ],
            [
              -124.56,
              47.86
            ],
            [
              -124.63,
              47.89
            ],
            [
              -124.67,
              47.98
            ],
            [
              -124.7,
              48.07
            ],
            [
              -124.69,
              48.11
            ],
            [
              -124.73,
              48.16
            ],
            [
              -124.69,
              48.21
            ],
            [
              -124.66,
              48.33
            ],
            [
              -124.73,
              48.37
            ],
            [
              -124.72,
              48.39
            ],
            [
              -124.65,
              48.39
            ],
            [
              -124.51,
              48.34
            ],
            [
              -124.4,
              48.29
            ],
            [
              -124.36,
              48.29
            ],
            [
              -124.27,
              48.25
            ],
            [
              -124.25,
              48.26
            ],
            [
              -124.1,
              48.22
            ],
            [
              -124.11,
              48.2
            ],
            [
              -123.98,
              48.16
            ],
            [
              -123.78,
              48.16
            ],
            [
              -123.7,
              48.17
            ],
            [
              -123.59,
              48.13
            ],
            [
              -123.56,
              48.15
            ],
            [
              -123.52,
              48.14
            ],
            [
              -123.44,
              48.14
            ],
            [
              -123.39,
              48.11
            ],
            [
              -123.25,
              48.12
            ],
            [
              -123.13,
              48.18
            ],
            [
              -123.14,
              48.16
            ],
            [
              -123.06,
              48.12
            ],
            [
              -123.04,
              48.08
            ],
            [
              -122.98,
              48.1
            ],
            [
              -122.92,
              48.09
            ],
            [
              -122.93,
              48.06
            ],
            [
              -122.88,
              48.05
            ],
            [
              -122.87,
              48
            ],
            [
              -122.84,
              48
            ],
            [
              -122.83,
              48.05
            ],
            [
              -122.88,
              48.08
            ],
            [
              -122.88,
              48.11
            ],
            [
              -122.83,
              48.13
            ],
            [
              -122.76,
              48.14
            ],
            [
              -122.75,
              48.12
            ],
            [
              -122.8,
              48.09
            ],
            [
              -122.77,
              48.04
            ],
            [
              -122.74,
              48.05
            ],
            [
              -122.73,
              48.09
            ],
            [
              -122.7,
              48.1
            ],
            [
              -122.67,
              48.02
            ],
            [
              -122.72,
              48.01
            ],
            [
              -122.68,
              47.97
            ],
            [
              -122.66,
              47.91
            ],
            [
              -122.61,
              47.89
            ],
            [
              -122.64,
              47.87
            ],
            [
              -122.69,
              47.87
            ],
            [
              -122.69,
              47.83
            ],
            [
              -122.75,
              47.8
            ],
            [
              -122.78,
              47.7
            ],
            [
              -122.83,
              47.7
            ],
            [
              -122.79,
              47.79
            ],
            [
              -122.81,
              47.81
            ],
            [
              -122.88,
              47.72
            ],
            [
              -122.9,
              47.68
            ],
            [
              -122.97,
              47.62
            ],
            [
              -123.11,
              47.46
            ],
            [
              -123.15,
              47.36
            ],
            [
              -123.11,
              47.36
            ],
            [
              -123.03,
              47.35
            ],
            [
              -122.99,
              47.37
            ],
            [
              -122.91,
              47.39
            ],
            [
              -122.9,
              47.42
            ],
            [
              -123.06,
              47.37
            ],
            [
              -123.12,
              47.39
            ],
            [
              -122.97,
              47.59
            ],
            [
              -122.86,
              47.65
            ],
            [
              -122.75,
              47.67
            ],
            [
              -122.74,
              47.74
            ],
            [
              -122.68,
              47.8
            ],
            [
              -122.57,
              47.86
            ],
            [
              -122.61,
              47.94
            ],
            [
              -122.53,
              47.91
            ],
            [
              -122.48,
              47.75
            ],
            [
              -122.55,
              47.75
            ],
            [
              -122.54,
              47.71
            ],
            [
              -122.5,
              47.7
            ],
            [
              -122.52,
              47.65
            ],
            [
              -122.49,
              47.63
            ],
            [
              -122.49,
              47.59
            ],
            [
              -122.54,
              47.56
            ],
            [
              -122.55,
              47.52
            ],
            [
              -122.49,
              47.51
            ],
            [
              -122.53,
              47.47
            ],
            [
              -122.55,
              47.39
            ],
            [
              -122.54,
              47.38
            ],
            [
              -122.57,
              47.33
            ],
            [
              -122.55,
              47.29
            ],
            [
              -122.6,
              47.22
            ],
            [
              -122.7,
              47.28
            ],
            [
              -122.67,
              47.37
            ],
            [
              -122.73,
              47.33
            ],
            [
              -122.75,
              47.28
            ],
            [
              -122.64,
              47.21
            ],
            [
              -122.68,
              47.19
            ],
            [
              -122.67,
              47.15
            ],
            [
              -122.71,
              47.13
            ],
            [
              -122.77,
              47.17
            ],
            [
              -122.84,
              47.26
            ],
            [
              -122.8,
              47.29
            ],
            [
              -122.8,
              47.34
            ],
            [
              -122.82,
              47.36
            ],
            [
              -122.82,
              47.32
            ],
            [
              -122.86,
              47.27
            ],
            [
              -122.84,
              47.21
            ],
            [
              -122.86,
              47.17
            ],
            [
              -122.81,
              47.18
            ],
            [
              -122.77,
              47.12
            ],
            [
              -122.68,
              47.1
            ],
            [
              -122.64,
              47.14
            ],
            [
              -122.64,
              47.16
            ],
            [
              -122.59,
              47.18
            ],
            [
              -122.56,
              47.25
            ],
            [
              -122.53,
              47.29
            ],
            [
              -122.53,
              47.32
            ],
            [
              -122.44,
              47.27
            ],
            [
              -122.41,
              47.29
            ],
            [
              -122.42,
              47.32
            ],
            [
              -122.33,
              47.35
            ],
            [
              -122.33,
              47.39
            ],
            [
              -122.35,
              47.44
            ],
            [
              -122.38,
              47.45
            ],
            [
              -122.36,
              47.48
            ],
            [
              -122.4,
              47.52
            ],
            [
              -122.42,
              47.58
            ],
            [
              -122.34,
              47.61
            ],
            [
              -122.43,
              47.66
            ],
            [
              -122.37,
              47.73
            ],
            [
              -122.39,
              47.81
            ],
            [
              -122.34,
              47.85
            ],
            [
              -122.31,
              47.95
            ],
            [
              -122.23,
              47.97
            ],
            [
              -122.23,
              48.03
            ],
            [
              -122.28,
              48.05
            ],
            [
              -122.36,
              48.12
            ],
            [
              -122.36,
              48.19
            ],
            [
              -122.4,
              48.23
            ],
            [
              -122.45,
              48.23
            ],
            [
              -122.44,
              48.21
            ],
            [
              -122.48,
              48.19
            ],
            [
              -122.44,
              48.13
            ],
            [
              -122.38,
              48.09
            ],
            [
              -122.38,
              48.06
            ],
            [
              -122.47,
              48.13
            ],
            [
              -122.51,
              48.13
            ],
            [
              -122.54,
              48.18
            ],
            [
              -122.53,
              48.25
            ],
            [
              -122.47,
              48.27
            ],
            [
              -122.41,
              48.25
            ],
            [
              -122.37,
              48.29
            ],
            [
              -122.41,
              48.33
            ],
            [
              -122.51,
              48.36
            ],
            [
              -122.55,
              48.41
            ],
            [
              -122.55,
              48.44
            ],
            [
              -122.66,
              48.41
            ],
            [
              -122.68,
              48.44
            ],
            [
              -122.67,
              48.48
            ],
            [
              -122.71,
              48.46
            ],
            [
              -122.7,
              48.5
            ],
            [
              -122.62,
              48.52
            ],
            [
              -122.57,
              48.51
            ],
            [
              -122.54,
              48.47
            ],
            [
              -122.47,
              48.47
            ],
            [
              -122.5,
              48.57
            ],
            [
              -122.44,
              48.57
            ],
            [
              -122.43,
              48.6
            ],
            [
              -122.5,
              48.66
            ],
            [
              -122.52,
              48.71
            ],
            [
              -122.49,
              48.75
            ],
            [
              -122.54,
              48.78
            ],
            [
              -122.6,
              48.77
            ],
            [
              -122.64,
              48.74
            ],
            [
              -122.61,
              48.7
            ],
            [
              -122.67,
              48.73
            ],
            [
              -122.64,
              48.78
            ],
            [
              -122.68,
              48.8
            ],
            [
              -122.71,
              48.79
            ],
            [
              -122.72,
              48.85
            ],
            [
              -122.79,
              48.89
            ],
            [
              -122.75,
              48.91
            ],
            [
              -122.77,
              48.94
            ],
            [
              -122.82,
              48.96
            ],
            [
              -122.76,
              49
            ],
            [
              -122.1,
              49
            ],
            [
              -121.75,
              49
            ],
            [
              -121.23,
              49
            ],
            [
              -120.72,
              49
            ],
            [
              -120.04,
              49
            ],
            [
              -119.43,
              49
            ],
            [
              -118.84,
              49
            ],
            [
              -118.2,
              49
            ],
            [
              -117.03,
              49
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Wisconsin",
      fips: "55"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -86.96,
              45.35
            ],
            [
              -86.93,
              45.42
            ],
            [
              -86.82,
              45.41
            ],
            [
              -86.91,
              45.3
            ],
            [
              -86.96,
              45.35
            ]
          ]
        ],
        [
          [
            [
              -87.38,
              45.2
            ],
            [
              -87.33,
              45.21
            ],
            [
              -87.33,
              45.16
            ],
            [
              -87.38,
              45.18
            ],
            [
              -87.38,
              45.2
            ]
          ]
        ],
        [
          [
            [
              -90.47,
              47
            ],
            [
              -90.44,
              47.07
            ],
            [
              -90.39,
              47.08
            ],
            [
              -90.41,
              47.01
            ],
            [
              -90.47,
              47
            ]
          ]
        ],
        [
          [
            [
              -90.52,
              46.88
            ],
            [
              -90.45,
              46.9
            ],
            [
              -90.5,
              46.86
            ],
            [
              -90.52,
              46.88
            ]
          ]
        ],
        [
          [
            [
              -90.65,
              46.93
            ],
            [
              -90.64,
              46.94
            ],
            [
              -90.53,
              46.97
            ],
            [
              -90.51,
              46.96
            ],
            [
              -90.55,
              46.92
            ],
            [
              -90.64,
              46.91
            ],
            [
              -90.65,
              46.93
            ]
          ]
        ],
        [
          [
            [
              -90.76,
              46.84
            ],
            [
              -90.75,
              46.86
            ],
            [
              -90.68,
              46.9
            ],
            [
              -90.67,
              46.88
            ],
            [
              -90.76,
              46.84
            ]
          ]
        ],
        [
          [
            [
              -90.74,
              46.96
            ],
            [
              -90.69,
              46.92
            ],
            [
              -90.74,
              46.91
            ],
            [
              -90.76,
              46.95
            ],
            [
              -90.74,
              46.96
            ]
          ]
        ],
        [
          [
            [
              -90.78,
              47.02
            ],
            [
              -90.65,
              47.05
            ],
            [
              -90.61,
              47.01
            ],
            [
              -90.56,
              47.04
            ],
            [
              -90.55,
              47
            ],
            [
              -90.61,
              46.99
            ],
            [
              -90.67,
              46.95
            ],
            [
              -90.71,
              46.99
            ],
            [
              -90.77,
              47
            ],
            [
              -90.78,
              47.02
            ]
          ]
        ],
        [
          [
            [
              -90.79,
              46.79
            ],
            [
              -90.73,
              46.8
            ],
            [
              -90.62,
              46.87
            ],
            [
              -90.57,
              46.85
            ],
            [
              -90.67,
              46.82
            ],
            [
              -90.66,
              46.79
            ],
            [
              -90.72,
              46.79
            ],
            [
              -90.79,
              46.75
            ],
            [
              -90.79,
              46.79
            ]
          ]
        ],
        [
          [
            [
              -90.98,
              46.99
            ],
            [
              -90.93,
              47
            ],
            [
              -90.93,
              46.96
            ],
            [
              -90.98,
              46.99
            ]
          ]
        ],
        [
          [
            [
              -92.01,
              46.71
            ],
            [
              -91.94,
              46.68
            ],
            [
              -91.82,
              46.69
            ],
            [
              -91.64,
              46.73
            ],
            [
              -91.58,
              46.76
            ],
            [
              -91.51,
              46.76
            ],
            [
              -91.34,
              46.82
            ],
            [
              -91.25,
              46.84
            ],
            [
              -91.23,
              46.86
            ],
            [
              -91.17,
              46.84
            ],
            [
              -91.14,
              46.87
            ],
            [
              -91.05,
              46.88
            ],
            [
              -90.97,
              46.94
            ],
            [
              -90.92,
              46.93
            ],
            [
              -90.87,
              46.96
            ],
            [
              -90.84,
              46.96
            ],
            [
              -90.75,
              46.89
            ],
            [
              -90.8,
              46.82
            ],
            [
              -90.89,
              46.76
            ],
            [
              -90.85,
              46.69
            ],
            [
              -90.91,
              46.66
            ],
            [
              -90.95,
              46.6
            ],
            [
              -90.9,
              46.58
            ],
            [
              -90.75,
              46.65
            ],
            [
              -90.74,
              46.69
            ],
            [
              -90.59,
              46.6
            ],
            [
              -90.54,
              46.58
            ],
            [
              -90.51,
              46.59
            ],
            [
              -90.42,
              46.57
            ],
            [
              -90.39,
              46.53
            ],
            [
              -90.35,
              46.54
            ],
            [
              -90.35,
              46.54
            ],
            [
              -90.32,
              46.52
            ],
            [
              -90.22,
              46.5
            ],
            [
              -90.12,
              46.36
            ],
            [
              -90.12,
              46.34
            ],
            [
              -89.09,
              46.14
            ],
            [
              -88.78,
              46.02
            ],
            [
              -88.74,
              46.03
            ],
            [
              -88.68,
              46.01
            ],
            [
              -88.66,
              45.99
            ],
            [
              -88.61,
              45.99
            ],
            [
              -88.6,
              46.02
            ],
            [
              -88.51,
              46.02
            ],
            [
              -88.5,
              46
            ],
            [
              -88.42,
              45.98
            ],
            [
              -88.38,
              45.99
            ],
            [
              -88.3,
              45.95
            ],
            [
              -88.24,
              45.96
            ],
            [
              -88.1,
              45.92
            ],
            [
              -88.1,
              45.88
            ],
            [
              -88.08,
              45.86
            ],
            [
              -88.14,
              45.82
            ],
            [
              -88.07,
              45.78
            ],
            [
              -88,
              45.8
            ],
            [
              -87.96,
              45.76
            ],
            [
              -87.88,
              45.76
            ],
            [
              -87.86,
              45.73
            ],
            [
              -87.81,
              45.71
            ],
            [
              -87.78,
              45.67
            ],
            [
              -87.82,
              45.66
            ],
            [
              -87.77,
              45.6
            ],
            [
              -87.8,
              45.54
            ],
            [
              -87.79,
              45.5
            ],
            [
              -87.81,
              45.46
            ],
            [
              -87.86,
              45.43
            ],
            [
              -87.85,
              45.4
            ],
            [
              -87.88,
              45.38
            ],
            [
              -87.85,
              45.34
            ],
            [
              -87.85,
              45.34
            ],
            [
              -87.75,
              45.35
            ],
            [
              -87.7,
              45.39
            ],
            [
              -87.66,
              45.37
            ],
            [
              -87.65,
              45.34
            ],
            [
              -87.69,
              45.3
            ],
            [
              -87.74,
              45.2
            ],
            [
              -87.74,
              45.17
            ],
            [
              -87.69,
              45.15
            ],
            [
              -87.66,
              45.11
            ],
            [
              -87.59,
              45.1
            ],
            [
              -87.63,
              45.05
            ],
            [
              -87.63,
              44.98
            ],
            [
              -87.76,
              44.97
            ],
            [
              -87.84,
              44.93
            ],
            [
              -87.83,
              44.89
            ],
            [
              -87.87,
              44.84
            ],
            [
              -87.9,
              44.83
            ],
            [
              -87.94,
              44.76
            ],
            [
              -87.98,
              44.72
            ],
            [
              -88.01,
              44.63
            ],
            [
              -88,
              44.61
            ],
            [
              -88.04,
              44.57
            ],
            [
              -87.97,
              44.53
            ],
            [
              -87.93,
              44.54
            ],
            [
              -87.9,
              44.58
            ],
            [
              -87.81,
              44.64
            ],
            [
              -87.77,
              44.64
            ],
            [
              -87.72,
              44.69
            ],
            [
              -87.72,
              44.72
            ],
            [
              -87.61,
              44.84
            ],
            [
              -87.52,
              44.87
            ],
            [
              -87.48,
              44.86
            ],
            [
              -87.44,
              44.89
            ],
            [
              -87.38,
              44.87
            ],
            [
              -87.4,
              44.9
            ],
            [
              -87.36,
              44.99
            ],
            [
              -87.27,
              45.08
            ],
            [
              -87.24,
              45.17
            ],
            [
              -87.2,
              45.16
            ],
            [
              -87.12,
              45.19
            ],
            [
              -87.12,
              45.24
            ],
            [
              -87.06,
              45.29
            ],
            [
              -86.98,
              45.29
            ],
            [
              -86.99,
              45.22
            ],
            [
              -87.04,
              45.21
            ],
            [
              -87.05,
              45.09
            ],
            [
              -87.09,
              45.06
            ],
            [
              -87.12,
              45.06
            ],
            [
              -87.14,
              45.01
            ],
            [
              -87.19,
              44.97
            ],
            [
              -87.17,
              44.93
            ],
            [
              -87.22,
              44.9
            ],
            [
              -87.2,
              44.88
            ],
            [
              -87.27,
              44.85
            ],
            [
              -87.32,
              44.79
            ],
            [
              -87.34,
              44.72
            ],
            [
              -87.4,
              44.63
            ],
            [
              -87.44,
              44.6
            ],
            [
              -87.47,
              44.55
            ],
            [
              -87.54,
              44.32
            ],
            [
              -87.51,
              44.24
            ],
            [
              -87.52,
              44.18
            ],
            [
              -87.56,
              44.14
            ],
            [
              -87.65,
              44.1
            ],
            [
              -87.66,
              44.05
            ],
            [
              -87.68,
              44.02
            ],
            [
              -87.74,
              43.88
            ],
            [
              -87.73,
              43.81
            ],
            [
              -87.7,
              43.77
            ],
            [
              -87.71,
              43.68
            ],
            [
              -87.78,
              43.58
            ],
            [
              -87.81,
              43.46
            ],
            [
              -87.88,
              43.37
            ],
            [
              -87.91,
              43.24
            ],
            [
              -87.88,
              43.17
            ],
            [
              -87.9,
              43.14
            ],
            [
              -87.87,
              43.06
            ],
            [
              -87.9,
              43.02
            ],
            [
              -87.85,
              42.96
            ],
            [
              -87.85,
              42.89
            ],
            [
              -87.82,
              42.84
            ],
            [
              -87.77,
              42.78
            ],
            [
              -87.78,
              42.71
            ],
            [
              -87.82,
              42.62
            ],
            [
              -87.8,
              42.49
            ],
            [
              -88.09,
              42.5
            ],
            [
              -88.64,
              42.5
            ],
            [
              -88.79,
              42.49
            ],
            [
              -89.48,
              42.5
            ],
            [
              -89.67,
              42.51
            ],
            [
              -90.48,
              42.51
            ],
            [
              -90.64,
              42.51
            ],
            [
              -90.64,
              42.54
            ],
            [
              -90.71,
              42.63
            ],
            [
              -90.77,
              42.65
            ],
            [
              -90.94,
              42.68
            ],
            [
              -91.06,
              42.74
            ],
            [
              -91.1,
              42.88
            ],
            [
              -91.15,
              42.9
            ],
            [
              -91.15,
              42.96
            ],
            [
              -91.17,
              43.04
            ],
            [
              -91.18,
              43.13
            ],
            [
              -91.15,
              43.15
            ],
            [
              -91.12,
              43.2
            ],
            [
              -91.06,
              43.25
            ],
            [
              -91.11,
              43.31
            ],
            [
              -91.2,
              43.35
            ],
            [
              -91.2,
              43.41
            ],
            [
              -91.23,
              43.46
            ],
            [
              -91.22,
              43.5
            ],
            [
              -91.25,
              43.55
            ],
            [
              -91.23,
              43.58
            ],
            [
              -91.27,
              43.62
            ],
            [
              -91.27,
              43.68
            ],
            [
              -91.25,
              43.77
            ],
            [
              -91.28,
              43.84
            ],
            [
              -91.39,
              43.95
            ],
            [
              -91.44,
              44
            ],
            [
              -91.58,
              44.03
            ],
            [
              -91.71,
              44.1
            ],
            [
              -91.72,
              44.13
            ],
            [
              -91.82,
              44.16
            ],
            [
              -91.88,
              44.2
            ],
            [
              -91.9,
              44.27
            ],
            [
              -91.92,
              44.29
            ],
            [
              -91.92,
              44.33
            ],
            [
              -91.97,
              44.37
            ],
            [
              -92.05,
              44.4
            ],
            [
              -92.23,
              44.45
            ],
            [
              -92.28,
              44.48
            ],
            [
              -92.32,
              44.54
            ],
            [
              -92.36,
              44.56
            ],
            [
              -92.54,
              44.57
            ],
            [
              -92.57,
              44.6
            ],
            [
              -92.62,
              44.62
            ],
            [
              -92.62,
              44.64
            ],
            [
              -92.73,
              44.71
            ],
            [
              -92.79,
              44.74
            ],
            [
              -92.81,
              44.77
            ],
            [
              -92.76,
              44.84
            ],
            [
              -92.77,
              44.9
            ],
            [
              -92.75,
              44.94
            ],
            [
              -92.77,
              44.97
            ],
            [
              -92.76,
              45.03
            ],
            [
              -92.8,
              45.06
            ],
            [
              -92.75,
              45.11
            ],
            [
              -92.77,
              45.19
            ],
            [
              -92.75,
              45.21
            ],
            [
              -92.76,
              45.29
            ],
            [
              -92.7,
              45.33
            ],
            [
              -92.7,
              45.36
            ],
            [
              -92.65,
              45.4
            ],
            [
              -92.65,
              45.44
            ],
            [
              -92.73,
              45.51
            ],
            [
              -92.72,
              45.54
            ],
            [
              -92.77,
              45.57
            ],
            [
              -92.81,
              45.56
            ],
            [
              -92.89,
              45.58
            ],
            [
              -92.89,
              45.62
            ],
            [
              -92.86,
              45.72
            ],
            [
              -92.79,
              45.76
            ],
            [
              -92.71,
              45.89
            ],
            [
              -92.64,
              45.93
            ],
            [
              -92.55,
              45.95
            ],
            [
              -92.52,
              45.98
            ],
            [
              -92.47,
              45.97
            ],
            [
              -92.44,
              46.02
            ],
            [
              -92.35,
              46.02
            ],
            [
              -92.33,
              46.07
            ],
            [
              -92.29,
              46.07
            ],
            [
              -92.29,
              46.66
            ],
            [
              -92.21,
              46.65
            ],
            [
              -92.18,
              46.69
            ],
            [
              -92.21,
              46.7
            ],
            [
              -92.15,
              46.71
            ],
            [
              -92.14,
              46.74
            ],
            [
              -92.09,
              46.75
            ],
            [
              -92.01,
              46.71
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "American Samoa",
      fips: "60"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -169.52,
              -14.22
            ],
            [
              -169.43,
              -14.21
            ],
            [
              -169.42,
              -14.26
            ],
            [
              -169.46,
              -14.25
            ],
            [
              -169.48,
              -14.27
            ],
            [
              -169.52,
              -14.22
            ]
          ]
        ],
        [
          [
            [
              -169.69,
              -14.16
            ],
            [
              -169.61,
              -14.16
            ],
            [
              -169.62,
              -14.18
            ],
            [
              -169.67,
              -14.19
            ],
            [
              -169.69,
              -14.16
            ]
          ]
        ],
        [
          [
            [
              -170.85,
              -14.32
            ],
            [
              -170.8,
              -14.29
            ],
            [
              -170.74,
              -14.29
            ],
            [
              -170.67,
              -14.23
            ],
            [
              -170.66,
              -14.25
            ],
            [
              -170.56,
              -14.25
            ],
            [
              -170.55,
              -14.28
            ],
            [
              -170.57,
              -14.27
            ],
            [
              -170.68,
              -14.3
            ],
            [
              -170.76,
              -14.37
            ],
            [
              -170.8,
              -14.33
            ],
            [
              -170.85,
              -14.32
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Guam",
      fips: "66"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              144.62,
              13.45
            ],
            [
              144.64,
              13.46
            ],
            [
              144.76,
              13.48
            ],
            [
              144.84,
              13.6
            ],
            [
              144.86,
              13.65
            ],
            [
              144.88,
              13.64
            ],
            [
              144.91,
              13.61
            ],
            [
              144.96,
              13.6
            ],
            [
              144.92,
              13.52
            ],
            [
              144.81,
              13.43
            ],
            [
              144.78,
              13.39
            ],
            [
              144.77,
              13.29
            ],
            [
              144.73,
              13.25
            ],
            [
              144.66,
              13.27
            ],
            [
              144.64,
              13.36
            ],
            [
              144.66,
              13.4
            ],
            [
              144.62,
              13.45
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Commonwealth of the Northern Mariana Islands",
      fips: "69"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              146.03,
              16
            ],
            [
              146.07,
              16.04
            ],
            [
              146.08,
              16.03
            ],
            [
              146.05,
              15.99
            ],
            [
              146.03,
              16
            ]
          ]
        ],
        [
          [
            [
              145.82,
              17.6
            ],
            [
              145.83,
              17.62
            ],
            [
              145.84,
              17.58
            ],
            [
              145.82,
              17.6
            ]
          ]
        ],
        [
          [
            [
              145.71,
              18.07
            ],
            [
              145.76,
              18.11
            ],
            [
              145.76,
              18.16
            ],
            [
              145.8,
              18.16
            ],
            [
              145.8,
              18.11
            ],
            [
              145.77,
              18.1
            ],
            [
              145.73,
              18.05
            ],
            [
              145.71,
              18.07
            ]
          ]
        ],
        [
          [
            [
              145.69,
              15.13
            ],
            [
              145.7,
              15.16
            ],
            [
              145.71,
              15.24
            ],
            [
              145.74,
              15.23
            ],
            [
              145.81,
              15.29
            ],
            [
              145.83,
              15.27
            ],
            [
              145.78,
              15.2
            ],
            [
              145.8,
              15.15
            ],
            [
              145.75,
              15.15
            ],
            [
              145.75,
              15.09
            ],
            [
              145.71,
              15.11
            ],
            [
              145.69,
              15.13
            ]
          ]
        ],
        [
          [
            [
              145.64,
              18.78
            ],
            [
              145.66,
              18.81
            ],
            [
              145.7,
              18.79
            ],
            [
              145.69,
              18.74
            ],
            [
              145.67,
              18.72
            ],
            [
              145.64,
              18.75
            ],
            [
              145.64,
              18.78
            ]
          ]
        ],
        [
          [
            [
              145.63,
              16.37
            ],
            [
              145.71,
              16.37
            ],
            [
              145.72,
              16.34
            ],
            [
              145.65,
              16.33
            ],
            [
              145.63,
              16.37
            ]
          ]
        ],
        [
          [
            [
              145.58,
              15.02
            ],
            [
              145.6,
              15.05
            ],
            [
              145.64,
              15.1
            ],
            [
              145.66,
              15.05
            ],
            [
              145.65,
              15.03
            ],
            [
              145.67,
              15
            ],
            [
              145.67,
              14.95
            ],
            [
              145.63,
              14.92
            ],
            [
              145.58,
              15.02
            ]
          ]
        ],
        [
          [
            [
              145.12,
              14.12
            ],
            [
              145.16,
              14.17
            ],
            [
              145.24,
              14.2
            ],
            [
              145.29,
              14.19
            ],
            [
              145.28,
              14.16
            ],
            [
              145.24,
              14.15
            ],
            [
              145.21,
              14.12
            ],
            [
              145.17,
              14.11
            ],
            [
              145.15,
              14.13
            ],
            [
              145.12,
              14.12
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Nebraska",
      fips: "31"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -104.05,
            43
          ],
          [
            -103,
            43
          ],
          [
            -102.49,
            43
          ],
          [
            -101.85,
            43
          ],
          [
            -101.63,
            43
          ],
          [
            -100.89,
            43
          ],
          [
            -100.12,
            43
          ],
          [
            -99.57,
            43
          ],
          [
            -98.9,
            43
          ],
          [
            -98.5,
            43
          ],
          [
            -98.47,
            42.95
          ],
          [
            -98.26,
            42.87
          ],
          [
            -98.13,
            42.82
          ],
          [
            -98.02,
            42.76
          ],
          [
            -97.95,
            42.77
          ],
          [
            -97.91,
            42.79
          ],
          [
            -97.87,
            42.86
          ],
          [
            -97.85,
            42.87
          ],
          [
            -97.77,
            42.85
          ],
          [
            -97.68,
            42.84
          ],
          [
            -97.62,
            42.86
          ],
          [
            -97.56,
            42.85
          ],
          [
            -97.51,
            42.86
          ],
          [
            -97.44,
            42.85
          ],
          [
            -97.42,
            42.87
          ],
          [
            -97.36,
            42.85
          ],
          [
            -97.31,
            42.87
          ],
          [
            -97.22,
            42.85
          ],
          [
            -97.21,
            42.81
          ],
          [
            -97.15,
            42.8
          ],
          [
            -97.13,
            42.77
          ],
          [
            -96.98,
            42.76
          ],
          [
            -96.95,
            42.72
          ],
          [
            -96.91,
            42.73
          ],
          [
            -96.81,
            42.7
          ],
          [
            -96.8,
            42.67
          ],
          [
            -96.73,
            42.67
          ],
          [
            -96.69,
            42.65
          ],
          [
            -96.71,
            42.61
          ],
          [
            -96.64,
            42.55
          ],
          [
            -96.61,
            42.51
          ],
          [
            -96.53,
            42.51
          ],
          [
            -96.51,
            42.48
          ],
          [
            -96.45,
            42.49
          ],
          [
            -96.4,
            42.48
          ],
          [
            -96.38,
            42.45
          ],
          [
            -96.41,
            42.41
          ],
          [
            -96.41,
            42.34
          ],
          [
            -96.37,
            42.32
          ],
          [
            -96.32,
            42.23
          ],
          [
            -96.36,
            42.21
          ],
          [
            -96.35,
            42.17
          ],
          [
            -96.27,
            42.12
          ],
          [
            -96.27,
            42.05
          ],
          [
            -96.22,
            42.03
          ],
          [
            -96.24,
            42.01
          ],
          [
            -96.18,
            42
          ],
          [
            -96.19,
            41.98
          ],
          [
            -96.13,
            41.97
          ],
          [
            -96.14,
            41.92
          ],
          [
            -96.16,
            41.91
          ],
          [
            -96.11,
            41.85
          ],
          [
            -96.11,
            41.82
          ],
          [
            -96.07,
            41.8
          ],
          [
            -96.08,
            41.76
          ],
          [
            -96.11,
            41.74
          ],
          [
            -96.08,
            41.7
          ],
          [
            -96.12,
            41.68
          ],
          [
            -96.09,
            41.65
          ],
          [
            -96.12,
            41.61
          ],
          [
            -96.08,
            41.58
          ],
          [
            -96.09,
            41.53
          ],
          [
            -96.04,
            41.51
          ],
          [
            -96.03,
            41.54
          ],
          [
            -96,
            41.54
          ],
          [
            -96,
            41.47
          ],
          [
            -95.93,
            41.46
          ],
          [
            -95.93,
            41.36
          ],
          [
            -95.95,
            41.34
          ],
          [
            -95.88,
            41.32
          ],
          [
            -95.93,
            41.28
          ],
          [
            -95.91,
            41.23
          ],
          [
            -95.93,
            41.2
          ],
          [
            -95.84,
            41.17
          ],
          [
            -95.88,
            41.16
          ],
          [
            -95.86,
            41.08
          ],
          [
            -95.88,
            41.06
          ],
          [
            -95.86,
            41.03
          ],
          [
            -95.86,
            41
          ],
          [
            -95.83,
            40.98
          ],
          [
            -95.84,
            40.92
          ],
          [
            -95.81,
            40.9
          ],
          [
            -95.85,
            40.85
          ],
          [
            -95.83,
            40.78
          ],
          [
            -95.88,
            40.75
          ],
          [
            -95.89,
            40.72
          ],
          [
            -95.83,
            40.67
          ],
          [
            -95.79,
            40.66
          ],
          [
            -95.75,
            40.61
          ],
          [
            -95.76,
            40.59
          ],
          [
            -95.77,
            40.53
          ],
          [
            -95.7,
            40.53
          ],
          [
            -95.69,
            40.56
          ],
          [
            -95.65,
            40.54
          ],
          [
            -95.7,
            40.51
          ],
          [
            -95.7,
            40.47
          ],
          [
            -95.66,
            40.44
          ],
          [
            -95.66,
            40.41
          ],
          [
            -95.62,
            40.31
          ],
          [
            -95.55,
            40.29
          ],
          [
            -95.56,
            40.26
          ],
          [
            -95.48,
            40.25
          ],
          [
            -95.48,
            40.18
          ],
          [
            -95.39,
            40.12
          ],
          [
            -95.42,
            40.05
          ],
          [
            -95.31,
            40
          ],
          [
            -95.79,
            40
          ],
          [
            -96.3,
            40
          ],
          [
            -97.25,
            40
          ],
          [
            -98.25,
            40
          ],
          [
            -98.83,
            40
          ],
          [
            -99.81,
            40
          ],
          [
            -100.76,
            40
          ],
          [
            -101.13,
            40
          ],
          [
            -102.05,
            40
          ],
          [
            -102.05,
            41
          ],
          [
            -102.56,
            41
          ],
          [
            -103.04,
            41
          ],
          [
            -104.05,
            41
          ],
          [
            -104.05,
            43
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "South Carolina",
      fips: "45"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -83.11,
            35
          ],
          [
            -82.78,
            35.09
          ],
          [
            -82.76,
            35.07
          ],
          [
            -82.66,
            35.12
          ],
          [
            -82.55,
            35.16
          ],
          [
            -82.53,
            35.16
          ],
          [
            -82.46,
            35.18
          ],
          [
            -82.43,
            35.17
          ],
          [
            -82.39,
            35.22
          ],
          [
            -82.37,
            35.18
          ],
          [
            -82.29,
            35.2
          ],
          [
            -81.62,
            35.17
          ],
          [
            -81.24,
            35.16
          ],
          [
            -81.04,
            35.15
          ],
          [
            -81.03,
            35.1
          ],
          [
            -81.06,
            35.06
          ],
          [
            -81.04,
            35.04
          ],
          [
            -80.93,
            35.11
          ],
          [
            -80.78,
            34.94
          ],
          [
            -80.8,
            34.82
          ],
          [
            -80.16,
            34.81
          ],
          [
            -79.89,
            34.81
          ],
          [
            -79.67,
            34.8
          ],
          [
            -79.36,
            34.55
          ],
          [
            -79.25,
            34.45
          ],
          [
            -78.87,
            34.13
          ],
          [
            -78.54,
            33.85
          ],
          [
            -78.59,
            33.84
          ],
          [
            -78.72,
            33.8
          ],
          [
            -78.81,
            33.74
          ],
          [
            -78.94,
            33.64
          ],
          [
            -79,
            33.57
          ],
          [
            -79.03,
            33.53
          ],
          [
            -79.09,
            33.48
          ],
          [
            -79.14,
            33.4
          ],
          [
            -79.18,
            33.25
          ],
          [
            -79.17,
            33.21
          ],
          [
            -79.2,
            33.17
          ],
          [
            -79.25,
            33.13
          ],
          [
            -79.33,
            33.09
          ],
          [
            -79.36,
            33.01
          ],
          [
            -79.42,
            33.02
          ],
          [
            -79.48,
            33
          ],
          [
            -79.52,
            33.04
          ],
          [
            -79.58,
            33.01
          ],
          [
            -79.62,
            32.95
          ],
          [
            -79.61,
            32.93
          ],
          [
            -79.58,
            32.93
          ],
          [
            -79.58,
            32.91
          ],
          [
            -79.63,
            32.89
          ],
          [
            -79.7,
            32.85
          ],
          [
            -79.73,
            32.81
          ],
          [
            -79.85,
            32.76
          ],
          [
            -79.89,
            32.79
          ],
          [
            -79.92,
            32.78
          ],
          [
            -79.93,
            32.75
          ],
          [
            -79.87,
            32.74
          ],
          [
            -79.89,
            32.68
          ],
          [
            -79.98,
            32.64
          ],
          [
            -80,
            32.61
          ],
          [
            -80.04,
            32.61
          ],
          [
            -80.12,
            32.59
          ],
          [
            -80.18,
            32.54
          ],
          [
            -80.2,
            32.56
          ],
          [
            -80.33,
            32.48
          ],
          [
            -80.36,
            32.5
          ],
          [
            -80.42,
            32.47
          ],
          [
            -80.42,
            32.5
          ],
          [
            -80.47,
            32.5
          ],
          [
            -80.48,
            32.46
          ],
          [
            -80.43,
            32.39
          ],
          [
            -80.46,
            32.33
          ],
          [
            -80.57,
            32.27
          ],
          [
            -80.64,
            32.26
          ],
          [
            -80.65,
            32.29
          ],
          [
            -80.71,
            32.33
          ],
          [
            -80.75,
            32.31
          ],
          [
            -80.76,
            32.28
          ],
          [
            -80.72,
            32.27
          ],
          [
            -80.67,
            32.22
          ],
          [
            -80.72,
            32.16
          ],
          [
            -80.81,
            32.11
          ],
          [
            -80.84,
            32.11
          ],
          [
            -80.9,
            32.05
          ],
          [
            -80.89,
            32.03
          ],
          [
            -80.92,
            32.04
          ],
          [
            -81,
            32.1
          ],
          [
            -81.04,
            32.08
          ],
          [
            -81.11,
            32.11
          ],
          [
            -81.13,
            32.17
          ],
          [
            -81.12,
            32.19
          ],
          [
            -81.16,
            32.25
          ],
          [
            -81.12,
            32.28
          ],
          [
            -81.14,
            32.35
          ],
          [
            -81.16,
            32.35
          ],
          [
            -81.21,
            32.44
          ],
          [
            -81.2,
            32.47
          ],
          [
            -81.28,
            32.54
          ],
          [
            -81.28,
            32.55
          ],
          [
            -81.37,
            32.58
          ],
          [
            -81.41,
            32.62
          ],
          [
            -81.39,
            32.65
          ],
          [
            -81.41,
            32.69
          ],
          [
            -81.43,
            32.7
          ],
          [
            -81.41,
            32.74
          ],
          [
            -81.43,
            32.77
          ],
          [
            -81.43,
            32.84
          ],
          [
            -81.46,
            32.85
          ],
          [
            -81.46,
            32.9
          ],
          [
            -81.51,
            32.95
          ],
          [
            -81.49,
            33.01
          ],
          [
            -81.56,
            33.05
          ],
          [
            -81.62,
            33.1
          ],
          [
            -81.65,
            33.09
          ],
          [
            -81.74,
            33.14
          ],
          [
            -81.77,
            33.18
          ],
          [
            -81.77,
            33.22
          ],
          [
            -81.81,
            33.21
          ],
          [
            -81.85,
            33.25
          ],
          [
            -81.84,
            33.27
          ],
          [
            -81.94,
            33.34
          ],
          [
            -81.92,
            33.37
          ],
          [
            -81.94,
            33.4
          ],
          [
            -81.91,
            33.44
          ],
          [
            -81.93,
            33.46
          ],
          [
            -81.98,
            33.48
          ],
          [
            -82.05,
            33.56
          ],
          [
            -82.11,
            33.6
          ],
          [
            -82.15,
            33.6
          ],
          [
            -82.2,
            33.63
          ],
          [
            -82.2,
            33.66
          ],
          [
            -82.23,
            33.7
          ],
          [
            -82.25,
            33.75
          ],
          [
            -82.35,
            33.84
          ],
          [
            -82.46,
            33.88
          ],
          [
            -82.52,
            33.94
          ],
          [
            -82.56,
            33.94
          ],
          [
            -82.6,
            34.03
          ],
          [
            -82.65,
            34.07
          ],
          [
            -82.67,
            34.13
          ],
          [
            -82.72,
            34.15
          ],
          [
            -82.74,
            34.21
          ],
          [
            -82.74,
            34.25
          ],
          [
            -82.78,
            34.3
          ],
          [
            -82.79,
            34.34
          ],
          [
            -82.84,
            34.37
          ],
          [
            -82.85,
            34.42
          ],
          [
            -82.88,
            34.48
          ],
          [
            -82.9,
            34.49
          ],
          [
            -83,
            34.47
          ],
          [
            -83.09,
            34.52
          ],
          [
            -83.17,
            34.61
          ],
          [
            -83.23,
            34.61
          ],
          [
            -83.34,
            34.68
          ],
          [
            -83.35,
            34.74
          ],
          [
            -83.32,
            34.76
          ],
          [
            -83.32,
            34.79
          ],
          [
            -83.23,
            34.88
          ],
          [
            -83.12,
            34.94
          ],
          [
            -83.11,
            35
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Puerto Rico",
      fips: "72"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -65.34,
              18.35
            ],
            [
              -65.3,
              18.33
            ],
            [
              -65.26,
              18.34
            ],
            [
              -65.22,
              18.31
            ],
            [
              -65.28,
              18.28
            ],
            [
              -65.33,
              18.3
            ],
            [
              -65.34,
              18.35
            ]
          ]
        ],
        [
          [
            [
              -65.57,
              18.12
            ],
            [
              -65.4,
              18.16
            ],
            [
              -65.27,
              18.13
            ],
            [
              -65.34,
              18.11
            ],
            [
              -65.41,
              18.11
            ],
            [
              -65.45,
              18.09
            ],
            [
              -65.48,
              18.1
            ],
            [
              -65.54,
              18.08
            ],
            [
              -65.57,
              18.12
            ]
          ]
        ],
        [
          [
            [
              -65.59,
              18.39
            ],
            [
              -65.57,
              18.38
            ],
            [
              -65.57,
              18.34
            ],
            [
              -65.59,
              18.39
            ]
          ]
        ],
        [
          [
            [
              -67.27,
              18.37
            ],
            [
              -67.22,
              18.38
            ],
            [
              -67.15,
              18.42
            ],
            [
              -67.17,
              18.48
            ],
            [
              -67.14,
              18.51
            ],
            [
              -67.09,
              18.52
            ],
            [
              -67.02,
              18.51
            ],
            [
              -66.96,
              18.49
            ],
            [
              -66.78,
              18.49
            ],
            [
              -66.71,
              18.47
            ],
            [
              -66.62,
              18.49
            ],
            [
              -66.56,
              18.49
            ],
            [
              -66.47,
              18.47
            ],
            [
              -66.44,
              18.49
            ],
            [
              -66.34,
              18.49
            ],
            [
              -66.24,
              18.47
            ],
            [
              -66.19,
              18.47
            ],
            [
              -66.16,
              18.45
            ],
            [
              -66.14,
              18.47
            ],
            [
              -66.01,
              18.44
            ],
            [
              -65.99,
              18.46
            ],
            [
              -65.93,
              18.44
            ],
            [
              -65.91,
              18.45
            ],
            [
              -65.79,
              18.42
            ],
            [
              -65.74,
              18.38
            ],
            [
              -65.72,
              18.39
            ],
            [
              -65.7,
              18.37
            ],
            [
              -65.66,
              18.36
            ],
            [
              -65.61,
              18.38
            ],
            [
              -65.63,
              18.35
            ],
            [
              -65.62,
              18.28
            ],
            [
              -65.57,
              18.25
            ],
            [
              -65.6,
              18.21
            ],
            [
              -65.64,
              18.23
            ],
            [
              -65.63,
              18.21
            ],
            [
              -65.66,
              18.21
            ],
            [
              -65.69,
              18.18
            ],
            [
              -65.74,
              18.18
            ],
            [
              -65.78,
              18.13
            ],
            [
              -65.8,
              18.06
            ],
            [
              -65.83,
              18.05
            ],
            [
              -65.83,
              18.02
            ],
            [
              -65.92,
              17.98
            ],
            [
              -65.98,
              17.97
            ],
            [
              -66.02,
              17.98
            ],
            [
              -66.05,
              17.96
            ],
            [
              -66.08,
              17.97
            ],
            [
              -66.16,
              17.93
            ],
            [
              -66.19,
              17.94
            ],
            [
              -66.22,
              17.91
            ],
            [
              -66.25,
              17.92
            ],
            [
              -66.32,
              17.98
            ],
            [
              -66.36,
              17.97
            ],
            [
              -66.39,
              17.94
            ],
            [
              -66.46,
              17.99
            ],
            [
              -66.49,
              17.99
            ],
            [
              -66.58,
              17.96
            ],
            [
              -66.63,
              17.98
            ],
            [
              -66.67,
              17.97
            ],
            [
              -66.76,
              18.01
            ],
            [
              -66.79,
              17.97
            ],
            [
              -66.84,
              17.95
            ],
            [
              -66.91,
              17.95
            ],
            [
              -66.96,
              17.93
            ],
            [
              -66.99,
              17.97
            ],
            [
              -67.06,
              17.97
            ],
            [
              -67.1,
              17.95
            ],
            [
              -67.17,
              17.96
            ],
            [
              -67.21,
              17.95
            ],
            [
              -67.21,
              18
            ],
            [
              -67.17,
              18.02
            ],
            [
              -67.21,
              18.04
            ],
            [
              -67.2,
              18.09
            ],
            [
              -67.18,
              18.1
            ],
            [
              -67.18,
              18.17
            ],
            [
              -67.15,
              18.19
            ],
            [
              -67.19,
              18.28
            ],
            [
              -67.24,
              18.3
            ],
            [
              -67.27,
              18.37
            ]
          ]
        ],
        [
          [
            [
              -67.93,
              18.11
            ],
            [
              -67.86,
              18.12
            ],
            [
              -67.84,
              18.08
            ],
            [
              -67.9,
              18.05
            ],
            [
              -67.94,
              18.08
            ],
            [
              -67.93,
              18.11
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "United States Virgin Islands",
      fips: "78"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -64.8,
              18.34
            ],
            [
              -64.75,
              18.37
            ],
            [
              -64.71,
              18.37
            ],
            [
              -64.66,
              18.34
            ],
            [
              -64.71,
              18.34
            ],
            [
              -64.7,
              18.3
            ],
            [
              -64.74,
              18.32
            ],
            [
              -64.78,
              18.31
            ],
            [
              -64.8,
              18.34
            ]
          ]
        ],
        [
          [
            [
              -64.91,
              17.68
            ],
            [
              -64.88,
              17.71
            ],
            [
              -64.9,
              17.75
            ],
            [
              -64.87,
              17.77
            ],
            [
              -64.84,
              17.76
            ],
            [
              -64.81,
              17.78
            ],
            [
              -64.75,
              17.78
            ],
            [
              -64.72,
              17.76
            ],
            [
              -64.58,
              17.76
            ],
            [
              -64.58,
              17.75
            ],
            [
              -64.69,
              17.71
            ],
            [
              -64.84,
              17.68
            ],
            [
              -64.91,
              17.68
            ]
          ]
        ],
        [
          [
            [
              -65.08,
              18.34
            ],
            [
              -65.06,
              18.38
            ],
            [
              -65.03,
              18.36
            ],
            [
              -64.98,
              18.38
            ],
            [
              -64.91,
              18.37
            ],
            [
              -64.8,
              18.37
            ],
            [
              -64.8,
              18.35
            ],
            [
              -64.85,
              18.35
            ],
            [
              -64.82,
              18.31
            ],
            [
              -64.88,
              18.3
            ],
            [
              -64.93,
              18.32
            ],
            [
              -64.96,
              18.31
            ],
            [
              -65,
              18.35
            ],
            [
              -65.08,
              18.34
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Idaho",
      fips: "16"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -116.92,
            46
          ],
          [
            -116.96,
            46.08
          ],
          [
            -116.98,
            46.09
          ],
          [
            -116.92,
            46.16
          ],
          [
            -116.96,
            46.2
          ],
          [
            -116.96,
            46.25
          ],
          [
            -116.99,
            46.3
          ],
          [
            -117.06,
            46.37
          ],
          [
            -117.04,
            46.41
          ],
          [
            -117.04,
            47.48
          ],
          [
            -117.04,
            47.52
          ],
          [
            -117.04,
            48.13
          ],
          [
            -117.03,
            48.37
          ],
          [
            -117.03,
            48.75
          ],
          [
            -117.03,
            49
          ],
          [
            -116.42,
            49
          ],
          [
            -116.05,
            49
          ],
          [
            -116.05,
            48.31
          ],
          [
            -116.05,
            48.22
          ],
          [
            -116.05,
            47.98
          ],
          [
            -115.91,
            47.85
          ],
          [
            -115.85,
            47.83
          ],
          [
            -115.83,
            47.75
          ],
          [
            -115.8,
            47.76
          ],
          [
            -115.77,
            47.72
          ],
          [
            -115.72,
            47.7
          ],
          [
            -115.73,
            47.64
          ],
          [
            -115.69,
            47.6
          ],
          [
            -115.74,
            47.57
          ],
          [
            -115.74,
            47.54
          ],
          [
            -115.7,
            47.53
          ],
          [
            -115.69,
            47.49
          ],
          [
            -115.63,
            47.48
          ],
          [
            -115.64,
            47.46
          ],
          [
            -115.72,
            47.45
          ],
          [
            -115.76,
            47.42
          ],
          [
            -115.72,
            47.42
          ],
          [
            -115.55,
            47.35
          ],
          [
            -115.53,
            47.3
          ],
          [
            -115.41,
            47.26
          ],
          [
            -115.33,
            47.26
          ],
          [
            -115.29,
            47.22
          ],
          [
            -115.3,
            47.19
          ],
          [
            -115.26,
            47.18
          ],
          [
            -115.24,
            47.15
          ],
          [
            -115.2,
            47.14
          ],
          [
            -115.14,
            47.09
          ],
          [
            -115.07,
            47.02
          ],
          [
            -115.05,
            46.97
          ],
          [
            -115,
            46.97
          ],
          [
            -114.93,
            46.92
          ],
          [
            -114.95,
            46.86
          ],
          [
            -114.89,
            46.81
          ],
          [
            -114.77,
            46.76
          ],
          [
            -114.79,
            46.71
          ],
          [
            -114.77,
            46.7
          ],
          [
            -114.71,
            46.71
          ],
          [
            -114.7,
            46.74
          ],
          [
            -114.65,
            46.73
          ],
          [
            -114.62,
            46.71
          ],
          [
            -114.64,
            46.67
          ],
          [
            -114.62,
            46.64
          ],
          [
            -114.55,
            46.64
          ],
          [
            -114.47,
            46.63
          ],
          [
            -114.45,
            46.65
          ],
          [
            -114.36,
            46.67
          ],
          [
            -114.33,
            46.66
          ],
          [
            -114.32,
            46.61
          ],
          [
            -114.36,
            46.51
          ],
          [
            -114.4,
            46.5
          ],
          [
            -114.37,
            46.44
          ],
          [
            -114.42,
            46.39
          ],
          [
            -114.43,
            46.29
          ],
          [
            -114.47,
            46.27
          ],
          [
            -114.45,
            46.24
          ],
          [
            -114.45,
            46.17
          ],
          [
            -114.51,
            46.17
          ],
          [
            -114.52,
            46.13
          ],
          [
            -114.46,
            46.1
          ],
          [
            -114.49,
            46.05
          ],
          [
            -114.48,
            46
          ],
          [
            -114.41,
            45.98
          ],
          [
            -114.43,
            45.94
          ],
          [
            -114.39,
            45.89
          ],
          [
            -114.41,
            45.85
          ],
          [
            -114.5,
            45.85
          ],
          [
            -114.57,
            45.77
          ],
          [
            -114.5,
            45.71
          ],
          [
            -114.5,
            45.67
          ],
          [
            -114.57,
            45.64
          ],
          [
            -114.54,
            45.61
          ],
          [
            -114.55,
            45.56
          ],
          [
            -114.46,
            45.56
          ],
          [
            -114.41,
            45.51
          ],
          [
            -114.36,
            45.49
          ],
          [
            -114.35,
            45.46
          ],
          [
            -114.26,
            45.5
          ],
          [
            -114.25,
            45.55
          ],
          [
            -114.2,
            45.54
          ],
          [
            -114.13,
            45.56
          ],
          [
            -114.07,
            45.63
          ],
          [
            -114.01,
            45.66
          ],
          [
            -114.02,
            45.69
          ],
          [
            -113.99,
            45.7
          ],
          [
            -113.93,
            45.68
          ],
          [
            -113.9,
            45.64
          ],
          [
            -113.9,
            45.62
          ],
          [
            -113.86,
            45.62
          ],
          [
            -113.81,
            45.6
          ],
          [
            -113.83,
            45.52
          ],
          [
            -113.76,
            45.52
          ],
          [
            -113.76,
            45.48
          ],
          [
            -113.78,
            45.46
          ],
          [
            -113.76,
            45.41
          ],
          [
            -113.73,
            45.39
          ],
          [
            -113.74,
            45.33
          ],
          [
            -113.69,
            45.28
          ],
          [
            -113.69,
            45.25
          ],
          [
            -113.6,
            45.19
          ],
          [
            -113.57,
            45.13
          ],
          [
            -113.51,
            45.12
          ],
          [
            -113.52,
            45.09
          ],
          [
            -113.45,
            45.06
          ],
          [
            -113.44,
            45.01
          ],
          [
            -113.45,
            44.96
          ],
          [
            -113.5,
            44.95
          ],
          [
            -113.46,
            44.87
          ],
          [
            -113.36,
            44.82
          ],
          [
            -113.34,
            44.79
          ],
          [
            -113.25,
            44.82
          ],
          [
            -113.13,
            44.77
          ],
          [
            -113.07,
            44.68
          ],
          [
            -113.05,
            44.64
          ],
          [
            -113.08,
            44.6
          ],
          [
            -113.01,
            44.53
          ],
          [
            -113.03,
            44.5
          ],
          [
            -113,
            44.45
          ],
          [
            -112.95,
            44.42
          ],
          [
            -112.89,
            44.4
          ],
          [
            -112.85,
            44.36
          ],
          [
            -112.81,
            44.38
          ],
          [
            -112.84,
            44.42
          ],
          [
            -112.78,
            44.48
          ],
          [
            -112.72,
            44.5
          ],
          [
            -112.66,
            44.49
          ],
          [
            -112.54,
            44.48
          ],
          [
            -112.5,
            44.46
          ],
          [
            -112.47,
            44.48
          ],
          [
            -112.39,
            44.45
          ],
          [
            -112.36,
            44.49
          ],
          [
            -112.35,
            44.54
          ],
          [
            -112.32,
            44.54
          ],
          [
            -112.29,
            44.57
          ],
          [
            -112.23,
            44.56
          ],
          [
            -112.19,
            44.53
          ],
          [
            -112.14,
            44.54
          ],
          [
            -112.11,
            44.52
          ],
          [
            -112.03,
            44.55
          ],
          [
            -112,
            44.54
          ],
          [
            -111.95,
            44.56
          ],
          [
            -111.87,
            44.56
          ],
          [
            -111.82,
            44.51
          ],
          [
            -111.72,
            44.54
          ],
          [
            -111.7,
            44.56
          ],
          [
            -111.62,
            44.55
          ],
          [
            -111.59,
            44.56
          ],
          [
            -111.47,
            44.54
          ],
          [
            -111.53,
            44.6
          ],
          [
            -111.47,
            44.68
          ],
          [
            -111.49,
            44.71
          ],
          [
            -111.41,
            44.71
          ],
          [
            -111.39,
            44.76
          ],
          [
            -111.32,
            44.72
          ],
          [
            -111.22,
            44.62
          ],
          [
            -111.23,
            44.59
          ],
          [
            -111.14,
            44.54
          ],
          [
            -111.12,
            44.49
          ],
          [
            -111.05,
            44.47
          ],
          [
            -111.05,
            44.35
          ],
          [
            -111.05,
            44.12
          ],
          [
            -111.05,
            43.68
          ],
          [
            -111.04,
            43.66
          ],
          [
            -111.04,
            42.72
          ],
          [
            -111.05,
            42.58
          ],
          [
            -111.05,
            42
          ],
          [
            -111.47,
            42
          ],
          [
            -112.17,
            42
          ],
          [
            -112.19,
            42
          ],
          [
            -112.88,
            42
          ],
          [
            -113.82,
            41.99
          ],
          [
            -114.04,
            41.99
          ],
          [
            -114.47,
            42
          ],
          [
            -114.6,
            41.99
          ],
          [
            -114.81,
            42
          ],
          [
            -115.03,
            42
          ],
          [
            -115.32,
            42
          ],
          [
            -116.37,
            42
          ],
          [
            -117.03,
            42
          ],
          [
            -117.03,
            43.81
          ],
          [
            -117.02,
            43.86
          ],
          [
            -116.98,
            43.87
          ],
          [
            -116.98,
            43.92
          ],
          [
            -116.94,
            43.98
          ],
          [
            -116.93,
            44.02
          ],
          [
            -116.97,
            44.05
          ],
          [
            -116.98,
            44.09
          ],
          [
            -116.93,
            44.1
          ],
          [
            -116.9,
            44.15
          ],
          [
            -116.9,
            44.18
          ],
          [
            -116.97,
            44.19
          ],
          [
            -116.97,
            44.24
          ],
          [
            -117.05,
            44.23
          ],
          [
            -117.1,
            44.28
          ],
          [
            -117.17,
            44.26
          ],
          [
            -117.22,
            44.29
          ],
          [
            -117.19,
            44.34
          ],
          [
            -117.24,
            44.4
          ],
          [
            -117.21,
            44.43
          ],
          [
            -117.22,
            44.48
          ],
          [
            -117.16,
            44.52
          ],
          [
            -117.12,
            44.58
          ],
          [
            -117.1,
            44.67
          ],
          [
            -117.05,
            44.74
          ],
          [
            -116.93,
            44.79
          ],
          [
            -116.93,
            44.81
          ],
          [
            -116.87,
            44.87
          ],
          [
            -116.83,
            44.93
          ],
          [
            -116.86,
            44.98
          ],
          [
            -116.85,
            45.02
          ],
          [
            -116.8,
            45.06
          ],
          [
            -116.78,
            45.11
          ],
          [
            -116.73,
            45.14
          ],
          [
            -116.7,
            45.24
          ],
          [
            -116.67,
            45.28
          ],
          [
            -116.68,
            45.31
          ],
          [
            -116.59,
            45.44
          ],
          [
            -116.55,
            45.46
          ],
          [
            -116.55,
            45.51
          ],
          [
            -116.46,
            45.6
          ],
          [
            -116.49,
            45.65
          ],
          [
            -116.54,
            45.69
          ],
          [
            -116.54,
            45.74
          ],
          [
            -116.59,
            45.78
          ],
          [
            -116.66,
            45.78
          ],
          [
            -116.7,
            45.82
          ],
          [
            -116.76,
            45.82
          ],
          [
            -116.82,
            45.88
          ],
          [
            -116.86,
            45.9
          ],
          [
            -116.92,
            46
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Nevada",
      fips: "32"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -120,
            41.99
          ],
          [
            -120,
            42
          ],
          [
            -119.21,
            41.99
          ],
          [
            -118.7,
            41.99
          ],
          [
            -118.6,
            41.99
          ],
          [
            -117.62,
            42
          ],
          [
            -117.03,
            42
          ],
          [
            -116.37,
            42
          ],
          [
            -115.32,
            42
          ],
          [
            -115.03,
            42
          ],
          [
            -114.81,
            42
          ],
          [
            -114.6,
            41.99
          ],
          [
            -114.47,
            42
          ],
          [
            -114.04,
            41.99
          ],
          [
            -114.04,
            41
          ],
          [
            -114.04,
            40.77
          ],
          [
            -114.04,
            40.23
          ],
          [
            -114.05,
            40.1
          ],
          [
            -114.05,
            38.68
          ],
          [
            -114.05,
            38.4
          ],
          [
            -114.05,
            38.15
          ],
          [
            -114.05,
            38
          ],
          [
            -114.05,
            37.77
          ],
          [
            -114.05,
            37.76
          ],
          [
            -114.05,
            37
          ],
          [
            -114.05,
            36.63
          ],
          [
            -114.04,
            36.39
          ],
          [
            -114.05,
            36.19
          ],
          [
            -114.07,
            36.18
          ],
          [
            -114.15,
            36.02
          ],
          [
            -114.24,
            36.01
          ],
          [
            -114.31,
            36.06
          ],
          [
            -114.31,
            36.08
          ],
          [
            -114.37,
            36.14
          ],
          [
            -114.42,
            36.15
          ],
          [
            -114.5,
            36.13
          ],
          [
            -114.51,
            36.15
          ],
          [
            -114.57,
            36.15
          ],
          [
            -114.62,
            36.13
          ],
          [
            -114.63,
            36.14
          ],
          [
            -114.67,
            36.12
          ],
          [
            -114.76,
            36.09
          ],
          [
            -114.73,
            36.02
          ],
          [
            -114.74,
            35.99
          ],
          [
            -114.7,
            35.9
          ],
          [
            -114.67,
            35.88
          ],
          [
            -114.7,
            35.85
          ],
          [
            -114.71,
            35.81
          ],
          [
            -114.69,
            35.76
          ],
          [
            -114.71,
            35.71
          ],
          [
            -114.68,
            35.69
          ],
          [
            -114.69,
            35.65
          ],
          [
            -114.66,
            35.62
          ],
          [
            -114.66,
            35.53
          ],
          [
            -114.68,
            35.5
          ],
          [
            -114.67,
            35.45
          ],
          [
            -114.63,
            35.41
          ],
          [
            -114.6,
            35.35
          ],
          [
            -114.57,
            35.2
          ],
          [
            -114.57,
            35.14
          ],
          [
            -114.65,
            35.1
          ],
          [
            -114.61,
            35.08
          ],
          [
            -114.63,
            35
          ],
          [
            -115.16,
            35.42
          ],
          [
            -115.41,
            35.63
          ],
          [
            -116.25,
            36.28
          ],
          [
            -117.38,
            37.13
          ],
          [
            -117.83,
            37.47
          ],
          [
            -118.05,
            37.63
          ],
          [
            -118.5,
            37.95
          ],
          [
            -118.86,
            38.2
          ],
          [
            -119.08,
            38.36
          ],
          [
            -119.49,
            38.65
          ],
          [
            -119.91,
            38.93
          ],
          [
            -120,
            39
          ],
          [
            -120.01,
            39.23
          ],
          [
            -120,
            39.33
          ],
          [
            -120,
            39.72
          ],
          [
            -120,
            39.73
          ],
          [
            -120,
            40.07
          ],
          [
            -120,
            40.72
          ],
          [
            -120,
            40.75
          ],
          [
            -120,
            41.99
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Vermont",
      fips: "50"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            -73.34,
            45.01
          ],
          [
            -73.09,
            45.02
          ],
          [
            -72.67,
            45.02
          ],
          [
            -72.53,
            45.01
          ],
          [
            -72.31,
            45
          ],
          [
            -72.1,
            45.01
          ],
          [
            -71.5,
            45.01
          ],
          [
            -71.54,
            44.99
          ],
          [
            -71.49,
            44.91
          ],
          [
            -71.56,
            44.85
          ],
          [
            -71.57,
            44.79
          ],
          [
            -71.63,
            44.75
          ],
          [
            -71.59,
            44.66
          ],
          [
            -71.55,
            44.63
          ],
          [
            -71.56,
            44.56
          ],
          [
            -71.6,
            44.55
          ],
          [
            -71.58,
            44.5
          ],
          [
            -71.63,
            44.48
          ],
          [
            -71.66,
            44.45
          ],
          [
            -71.71,
            44.41
          ],
          [
            -71.8,
            44.4
          ],
          [
            -71.81,
            44.35
          ],
          [
            -71.87,
            44.34
          ],
          [
            -71.91,
            44.35
          ],
          [
            -72.03,
            44.32
          ],
          [
            -72.07,
            44.27
          ],
          [
            -72.05,
            44.24
          ],
          [
            -72.07,
            44.19
          ],
          [
            -72.03,
            44.13
          ],
          [
            -72.03,
            44.09
          ],
          [
            -72.08,
            44.03
          ],
          [
            -72.12,
            43.99
          ],
          [
            -72.12,
            43.92
          ],
          [
            -72.19,
            43.86
          ],
          [
            -72.18,
            43.81
          ],
          [
            -72.2,
            43.77
          ],
          [
            -72.27,
            43.73
          ],
          [
            -72.3,
            43.7
          ],
          [
            -72.33,
            43.6
          ],
          [
            -72.38,
            43.57
          ],
          [
            -72.4,
            43.51
          ],
          [
            -72.38,
            43.48
          ],
          [
            -72.42,
            43.36
          ],
          [
            -72.39,
            43.31
          ],
          [
            -72.44,
            43.26
          ],
          [
            -72.45,
            43.14
          ],
          [
            -72.43,
            43.08
          ],
          [
            -72.47,
            43.06
          ],
          [
            -72.44,
            43.01
          ],
          [
            -72.47,
            42.97
          ],
          [
            -72.52,
            42.96
          ],
          [
            -72.52,
            42.91
          ],
          [
            -72.56,
            42.85
          ],
          [
            -72.51,
            42.76
          ],
          [
            -72.49,
            42.77
          ],
          [
            -72.46,
            42.73
          ],
          [
            -73.26,
            42.75
          ],
          [
            -73.29,
            42.8
          ],
          [
            -73.28,
            42.83
          ],
          [
            -73.28,
            42.9
          ],
          [
            -73.26,
            43.26
          ],
          [
            -73.25,
            43.55
          ],
          [
            -73.3,
            43.58
          ],
          [
            -73.3,
            43.62
          ],
          [
            -73.37,
            43.62
          ],
          [
            -73.4,
            43.57
          ],
          [
            -73.43,
            43.59
          ],
          [
            -73.41,
            43.69
          ],
          [
            -73.35,
            43.77
          ],
          [
            -73.39,
            43.82
          ],
          [
            -73.37,
            43.88
          ],
          [
            -73.41,
            43.93
          ],
          [
            -73.41,
            44.02
          ],
          [
            -73.44,
            44.04
          ],
          [
            -73.41,
            44.11
          ],
          [
            -73.39,
            44.19
          ],
          [
            -73.32,
            44.24
          ],
          [
            -73.31,
            44.27
          ],
          [
            -73.33,
            44.37
          ],
          [
            -73.29,
            44.44
          ],
          [
            -73.31,
            44.5
          ],
          [
            -73.37,
            44.58
          ],
          [
            -73.39,
            44.64
          ],
          [
            -73.37,
            44.66
          ],
          [
            -73.37,
            44.74
          ],
          [
            -73.33,
            44.79
          ],
          [
            -73.38,
            44.84
          ],
          [
            -73.36,
            44.89
          ],
          [
            -73.34,
            44.92
          ],
          [
            -73.34,
            45.01
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Louisiana",
      fips: "22"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -88.88,
              30.05
            ],
            [
              -88.83,
              30
            ],
            [
              -88.82,
              29.93
            ],
            [
              -88.83,
              29.85
            ],
            [
              -88.86,
              29.76
            ],
            [
              -88.88,
              29.76
            ],
            [
              -88.85,
              29.84
            ],
            [
              -88.83,
              29.92
            ],
            [
              -88.84,
              29.96
            ],
            [
              -88.88,
              30.05
            ]
          ]
        ],
        [
          [
            [
              -89.34,
              30.06
            ],
            [
              -89.3,
              30.09
            ],
            [
              -89.19,
              30.16
            ],
            [
              -89.18,
              30.15
            ],
            [
              -89.23,
              30.1
            ],
            [
              -89.22,
              30.07
            ],
            [
              -89.17,
              30.04
            ],
            [
              -89.23,
              30
            ],
            [
              -89.24,
              30.04
            ],
            [
              -89.28,
              30.03
            ],
            [
              -89.34,
              30.04
            ],
            [
              -89.34,
              30.06
            ]
          ]
        ],
        [
          [
            [
              -89.63,
              29.54
            ],
            [
              -89.57,
              29.54
            ],
            [
              -89.6,
              29.51
            ],
            [
              -89.63,
              29.54
            ]
          ]
        ],
        [
          [
            [
              -90.38,
              29.11
            ],
            [
              -90.35,
              29.13
            ],
            [
              -90.31,
              29.08
            ],
            [
              -90.33,
              29.06
            ],
            [
              -90.38,
              29.11
            ]
          ]
        ],
        [
          [
            [
              -90.56,
              29.09
            ],
            [
              -90.42,
              29.07
            ],
            [
              -90.49,
              29.06
            ],
            [
              -90.56,
              29.09
            ]
          ]
        ],
        [
          [
            [
              -90.75,
              29.06
            ],
            [
              -90.66,
              29.07
            ],
            [
              -90.65,
              29.06
            ],
            [
              -90.75,
              29.04
            ],
            [
              -90.75,
              29.06
            ]
          ]
        ],
        [
          [
            [
              -92.02,
              29.59
            ],
            [
              -91.98,
              29.61
            ],
            [
              -91.94,
              29.61
            ],
            [
              -91.93,
              29.63
            ],
            [
              -91.85,
              29.63
            ],
            [
              -91.77,
              29.57
            ],
            [
              -91.73,
              29.58
            ],
            [
              -91.71,
              29.56
            ],
            [
              -91.77,
              29.52
            ],
            [
              -91.77,
              29.49
            ],
            [
              -91.82,
              29.47
            ],
            [
              -92.03,
              29.57
            ],
            [
              -92.02,
              29.59
            ]
          ]
        ],
        [
          [
            [
              -94.04,
              33.02
            ],
            [
              -93.38,
              33.02
            ],
            [
              -93.07,
              33.02
            ],
            [
              -92.51,
              33.01
            ],
            [
              -91.95,
              33.01
            ],
            [
              -91.17,
              33
            ],
            [
              -91.2,
              32.96
            ],
            [
              -91.21,
              32.92
            ],
            [
              -91.18,
              32.9
            ],
            [
              -91.13,
              32.92
            ],
            [
              -91.13,
              32.98
            ],
            [
              -91.09,
              32.98
            ],
            [
              -91.06,
              32.92
            ],
            [
              -91.07,
              32.89
            ],
            [
              -91.15,
              32.84
            ],
            [
              -91.16,
              32.81
            ],
            [
              -91.17,
              32.75
            ],
            [
              -91.06,
              32.73
            ],
            [
              -91.06,
              32.7
            ],
            [
              -91.12,
              32.67
            ],
            [
              -91.15,
              32.64
            ],
            [
              -91.14,
              32.6
            ],
            [
              -91.12,
              32.58
            ],
            [
              -91.05,
              32.61
            ],
            [
              -91.03,
              32.65
            ],
            [
              -91,
              32.61
            ],
            [
              -91.03,
              32.58
            ],
            [
              -91.08,
              32.56
            ],
            [
              -91.01,
              32.51
            ],
            [
              -90.99,
              32.49
            ],
            [
              -91.02,
              32.49
            ],
            [
              -91.08,
              32.53
            ],
            [
              -91.1,
              32.53
            ],
            [
              -91.11,
              32.48
            ],
            [
              -91.03,
              32.43
            ],
            [
              -90.99,
              32.45
            ],
            [
              -90.97,
              32.42
            ],
            [
              -90.99,
              32.4
            ],
            [
              -90.99,
              32.35
            ],
            [
              -90.91,
              32.34
            ],
            [
              -90.89,
              32.37
            ],
            [
              -90.88,
              32.36
            ],
            [
              -90.93,
              32.29
            ],
            [
              -90.98,
              32.3
            ],
            [
              -90.97,
              32.25
            ],
            [
              -90.99,
              32.22
            ],
            [
              -91.04,
              32.24
            ],
            [
              -91.06,
              32.22
            ],
            [
              -91.16,
              32.2
            ],
            [
              -91.17,
              32.13
            ],
            [
              -91.05,
              32.12
            ],
            [
              -91.06,
              32.18
            ],
            [
              -91.01,
              32.16
            ],
            [
              -91.04,
              32.1
            ],
            [
              -91.08,
              32.08
            ],
            [
              -91.1,
              32.05
            ],
            [
              -91.15,
              32.08
            ],
            [
              -91.16,
              32.06
            ],
            [
              -91.09,
              32.04
            ],
            [
              -91.09,
              31.99
            ],
            [
              -91.16,
              31.98
            ],
            [
              -91.19,
              31.96
            ],
            [
              -91.18,
              31.92
            ],
            [
              -91.27,
              31.85
            ],
            [
              -91.25,
              31.83
            ],
            [
              -91.26,
              31.81
            ],
            [
              -91.29,
              31.82
            ],
            [
              -91.3,
              31.86
            ],
            [
              -91.34,
              31.85
            ],
            [
              -91.36,
              31.77
            ],
            [
              -91.26,
              31.76
            ],
            [
              -91.27,
              31.75
            ],
            [
              -91.36,
              31.74
            ],
            [
              -91.4,
              31.71
            ],
            [
              -91.4,
              31.62
            ],
            [
              -91.46,
              31.62
            ],
            [
              -91.5,
              31.64
            ],
            [
              -91.52,
              31.61
            ],
            [
              -91.49,
              31.59
            ],
            [
              -91.42,
              31.6
            ],
            [
              -91.41,
              31.57
            ],
            [
              -91.45,
              31.54
            ],
            [
              -91.52,
              31.52
            ],
            [
              -91.52,
              31.46
            ],
            [
              -91.47,
              31.4
            ],
            [
              -91.47,
              31.37
            ],
            [
              -91.5,
              31.37
            ],
            [
              -91.53,
              31.39
            ],
            [
              -91.55,
              31.43
            ],
            [
              -91.58,
              31.4
            ],
            [
              -91.55,
              31.39
            ],
            [
              -91.55,
              31.35
            ],
            [
              -91.51,
              31.32
            ],
            [
              -91.51,
              31.28
            ],
            [
              -91.58,
              31.26
            ],
            [
              -91.64,
              31.27
            ],
            [
              -91.64,
              31.23
            ],
            [
              -91.6,
              31.21
            ],
            [
              -91.59,
              31.17
            ],
            [
              -91.63,
              31.13
            ],
            [
              -91.62,
              31.11
            ],
            [
              -91.56,
              31.07
            ],
            [
              -91.59,
              31.02
            ],
            [
              -91.64,
              31
            ],
            [
              -90.83,
              31
            ],
            [
              -90.34,
              31
            ],
            [
              -89.75,
              31
            ],
            [
              -89.73,
              30.97
            ],
            [
              -89.75,
              30.95
            ],
            [
              -89.75,
              30.91
            ],
            [
              -89.77,
              30.9
            ],
            [
              -89.81,
              30.79
            ],
            [
              -89.83,
              30.77
            ],
            [
              -89.82,
              30.74
            ],
            [
              -89.85,
              30.66
            ],
            [
              -89.82,
              30.65
            ],
            [
              -89.81,
              30.57
            ],
            [
              -89.77,
              30.54
            ],
            [
              -89.76,
              30.51
            ],
            [
              -89.72,
              30.49
            ],
            [
              -89.68,
              30.45
            ],
            [
              -89.68,
              30.41
            ],
            [
              -89.63,
              30.34
            ],
            [
              -89.63,
              30.28
            ],
            [
              -89.62,
              30.22
            ],
            [
              -89.57,
              30.18
            ],
            [
              -89.53,
              30.18
            ],
            [
              -89.59,
              30.15
            ],
            [
              -89.62,
              30.16
            ],
            [
              -89.68,
              30.11
            ],
            [
              -89.68,
              30.08
            ],
            [
              -89.73,
              30.06
            ],
            [
              -89.72,
              30.03
            ],
            [
              -89.82,
              30.04
            ],
            [
              -89.86,
              30
            ],
            [
              -89.84,
              29.95
            ],
            [
              -89.77,
              29.94
            ],
            [
              -89.73,
              29.96
            ],
            [
              -89.74,
              29.91
            ],
            [
              -89.71,
              29.88
            ],
            [
              -89.66,
              29.86
            ],
            [
              -89.61,
              29.87
            ],
            [
              -89.59,
              29.9
            ],
            [
              -89.57,
              29.98
            ],
            [
              -89.58,
              29.99
            ],
            [
              -89.49,
              30.04
            ],
            [
              -89.48,
              30.08
            ],
            [
              -89.42,
              30.05
            ],
            [
              -89.37,
              30.05
            ],
            [
              -89.37,
              30.04
            ],
            [
              -89.43,
              30.01
            ],
            [
              -89.43,
              29.98
            ],
            [
              -89.38,
              29.96
            ],
            [
              -89.37,
              29.91
            ],
            [
              -89.31,
              29.92
            ],
            [
              -89.28,
              29.99
            ],
            [
              -89.22,
              29.97
            ],
            [
              -89.23,
              29.93
            ],
            [
              -89.28,
              29.93
            ],
            [
              -89.32,
              29.89
            ],
            [
              -89.24,
              29.89
            ],
            [
              -89.25,
              29.86
            ],
            [
              -89.36,
              29.85
            ],
            [
              -89.32,
              29.79
            ],
            [
              -89.28,
              29.81
            ],
            [
              -89.3,
              29.76
            ],
            [
              -89.34,
              29.78
            ],
            [
              -89.39,
              29.79
            ],
            [
              -89.43,
              29.74
            ],
            [
              -89.43,
              29.66
            ],
            [
              -89.47,
              29.65
            ],
            [
              -89.49,
              29.73
            ],
            [
              -89.53,
              29.73
            ],
            [
              -89.53,
              29.67
            ],
            [
              -89.49,
              29.62
            ],
            [
              -89.53,
              29.65
            ],
            [
              -89.58,
              29.65
            ],
            [
              -89.61,
              29.64
            ],
            [
              -89.67,
              29.64
            ],
            [
              -89.6,
              29.61
            ],
            [
              -89.6,
              29.58
            ],
            [
              -89.68,
              29.62
            ],
            [
              -89.68,
              29.6
            ],
            [
              -89.64,
              29.58
            ],
            [
              -89.68,
              29.56
            ],
            [
              -89.68,
              29.53
            ],
            [
              -89.64,
              29.5
            ],
            [
              -89.57,
              29.49
            ],
            [
              -89.57,
              29.48
            ],
            [
              -89.53,
              29.45
            ],
            [
              -89.53,
              29.43
            ],
            [
              -89.51,
              29.39
            ],
            [
              -89.48,
              29.41
            ],
            [
              -89.46,
              29.39
            ],
            [
              -89.38,
              29.39
            ],
            [
              -89.32,
              29.36
            ],
            [
              -89.31,
              29.39
            ],
            [
              -89.24,
              29.31
            ],
            [
              -89.2,
              29.35
            ],
            [
              -89.11,
              29.25
            ],
            [
              -89.11,
              29.2
            ],
            [
              -89.09,
              29.19
            ],
            [
              -89.03,
              29.21
            ],
            [
              -89,
              29.18
            ],
            [
              -89.09,
              29.17
            ],
            [
              -89.1,
              29.14
            ],
            [
              -89.04,
              29.14
            ],
            [
              -89.07,
              29.09
            ],
            [
              -89.11,
              29.11
            ],
            [
              -89.15,
              29.03
            ],
            [
              -89.14,
              28.99
            ],
            [
              -89.22,
              29.02
            ],
            [
              -89.22,
              29.07
            ],
            [
              -89.25,
              29.08
            ],
            [
              -89.36,
              28.96
            ],
            [
              -89.42,
              28.93
            ],
            [
              -89.39,
              28.99
            ],
            [
              -89.36,
              29.01
            ],
            [
              -89.34,
              29.05
            ],
            [
              -89.31,
              29.07
            ],
            [
              -89.31,
              29.12
            ],
            [
              -89.28,
              29.14
            ],
            [
              -89.28,
              29.18
            ],
            [
              -89.32,
              29.2
            ],
            [
              -89.33,
              29.15
            ],
            [
              -89.39,
              29.12
            ],
            [
              -89.43,
              29.15
            ],
            [
              -89.48,
              29.21
            ],
            [
              -89.61,
              29.25
            ],
            [
              -89.64,
              29.29
            ],
            [
              -89.84,
              29.32
            ],
            [
              -89.89,
              29.31
            ],
            [
              -90.06,
              29.18
            ],
            [
              -90.22,
              29.09
            ],
            [
              -90.25,
              29.09
            ],
            [
              -90.23,
              29.13
            ],
            [
              -90.28,
              29.14
            ],
            [
              -90.28,
              29.18
            ],
            [
              -90.26,
              29.18
            ],
            [
              -90.31,
              29.27
            ],
            [
              -90.34,
              29.29
            ],
            [
              -90.38,
              29.29
            ],
            [
              -90.37,
              29.26
            ],
            [
              -90.4,
              29.23
            ],
            [
              -90.39,
              29.3
            ],
            [
              -90.43,
              29.35
            ],
            [
              -90.48,
              29.29
            ],
            [
              -90.53,
              29.3
            ],
            [
              -90.55,
              29.29
            ],
            [
              -90.58,
              29.31
            ],
            [
              -90.6,
              29.29
            ],
            [
              -90.56,
              29.23
            ],
            [
              -90.61,
              29.24
            ],
            [
              -90.63,
              29.21
            ],
            [
              -90.65,
              29.17
            ],
            [
              -90.67,
              29.17
            ],
            [
              -90.69,
              29.13
            ],
            [
              -90.72,
              29.14
            ],
            [
              -90.79,
              29.11
            ],
            [
              -90.81,
              29.04
            ],
            [
              -90.87,
              29.06
            ],
            [
              -90.85,
              29.07
            ],
            [
              -90.9,
              29.13
            ],
            [
              -90.96,
              29.18
            ],
            [
              -91,
              29.17
            ],
            [
              -91.09,
              29.19
            ],
            [
              -91.13,
              29.22
            ],
            [
              -91.22,
              29.23
            ],
            [
              -91.28,
              29.25
            ],
            [
              -91.34,
              29.3
            ],
            [
              -91.29,
              29.31
            ],
            [
              -91.27,
              29.36
            ],
            [
              -91.24,
              29.35
            ],
            [
              -91.2,
              29.31
            ],
            [
              -91.17,
              29.32
            ],
            [
              -91.17,
              29.27
            ],
            [
              -91.12,
              29.25
            ],
            [
              -91.13,
              29.34
            ],
            [
              -91.22,
              29.4
            ],
            [
              -91.22,
              29.43
            ],
            [
              -91.26,
              29.44
            ],
            [
              -91.29,
              29.4
            ],
            [
              -91.34,
              29.39
            ],
            [
              -91.33,
              29.43
            ],
            [
              -91.36,
              29.42
            ],
            [
              -91.35,
              29.45
            ],
            [
              -91.32,
              29.48
            ],
            [
              -91.36,
              29.51
            ],
            [
              -91.46,
              29.47
            ],
            [
              -91.5,
              29.54
            ],
            [
              -91.53,
              29.53
            ],
            [
              -91.55,
              29.63
            ],
            [
              -91.65,
              29.63
            ],
            [
              -91.63,
              29.66
            ],
            [
              -91.62,
              29.74
            ],
            [
              -91.74,
              29.75
            ],
            [
              -91.78,
              29.74
            ],
            [
              -91.86,
              29.71
            ],
            [
              -91.88,
              29.76
            ],
            [
              -91.85,
              29.79
            ],
            [
              -91.82,
              29.79
            ],
            [
              -91.83,
              29.83
            ],
            [
              -91.89,
              29.84
            ],
            [
              -91.94,
              29.82
            ],
            [
              -91.97,
              29.83
            ],
            [
              -91.98,
              29.8
            ],
            [
              -92.06,
              29.77
            ],
            [
              -92.11,
              29.74
            ],
            [
              -92.14,
              29.77
            ],
            [
              -92.2,
              29.75
            ],
            [
              -92.2,
              29.73
            ],
            [
              -92.17,
              29.7
            ],
            [
              -92.1,
              29.69
            ],
            [
              -92.14,
              29.67
            ],
            [
              -92.11,
              29.61
            ],
            [
              -92.04,
              29.63
            ],
            [
              -92.02,
              29.62
            ],
            [
              -92.06,
              29.6
            ],
            [
              -92.04,
              29.59
            ],
            [
              -92.16,
              29.58
            ],
            [
              -92.25,
              29.54
            ],
            [
              -92.32,
              29.53
            ],
            [
              -92.62,
              29.59
            ],
            [
              -92.74,
              29.62
            ],
            [
              -92.95,
              29.71
            ],
            [
              -93.03,
              29.74
            ],
            [
              -93.18,
              29.77
            ],
            [
              -93.3,
              29.77
            ],
            [
              -93.35,
              29.76
            ],
            [
              -93.47,
              29.77
            ],
            [
              -93.68,
              29.75
            ],
            [
              -93.74,
              29.74
            ],
            [
              -93.84,
              29.69
            ],
            [
              -93.9,
              29.77
            ],
            [
              -93.93,
              29.8
            ],
            [
              -93.92,
              29.82
            ],
            [
              -93.86,
              29.86
            ],
            [
              -93.82,
              29.92
            ],
            [
              -93.79,
              29.99
            ],
            [
              -93.74,
              30.02
            ],
            [
              -93.7,
              30.07
            ],
            [
              -93.73,
              30.08
            ],
            [
              -93.69,
              30.14
            ],
            [
              -93.72,
              30.21
            ],
            [
              -93.7,
              30.24
            ],
            [
              -93.71,
              30.29
            ],
            [
              -93.77,
              30.33
            ],
            [
              -93.74,
              30.4
            ],
            [
              -93.7,
              30.44
            ],
            [
              -93.71,
              30.52
            ],
            [
              -93.74,
              30.54
            ],
            [
              -93.73,
              30.57
            ],
            [
              -93.68,
              30.6
            ],
            [
              -93.67,
              30.66
            ],
            [
              -93.63,
              30.68
            ],
            [
              -93.62,
              30.74
            ],
            [
              -93.59,
              30.8
            ],
            [
              -93.55,
              30.82
            ],
            [
              -93.57,
              30.88
            ],
            [
              -93.56,
              30.91
            ],
            [
              -93.52,
              30.93
            ],
            [
              -93.57,
              30.98
            ],
            [
              -93.56,
              31.01
            ],
            [
              -93.52,
              31.02
            ],
            [
              -93.52,
              31.07
            ],
            [
              -93.55,
              31.1
            ],
            [
              -93.53,
              31.18
            ],
            [
              -93.6,
              31.17
            ],
            [
              -93.62,
              31.27
            ],
            [
              -93.64,
              31.27
            ],
            [
              -93.69,
              31.31
            ],
            [
              -93.66,
              31.36
            ],
            [
              -93.68,
              31.4
            ],
            [
              -93.7,
              31.41
            ],
            [
              -93.7,
              31.44
            ],
            [
              -93.75,
              31.47
            ],
            [
              -93.73,
              31.49
            ],
            [
              -93.74,
              31.52
            ],
            [
              -93.79,
              31.53
            ],
            [
              -93.82,
              31.55
            ],
            [
              -93.84,
              31.6
            ],
            [
              -93.82,
              31.62
            ],
            [
              -93.83,
              31.66
            ],
            [
              -93.8,
              31.7
            ],
            [
              -93.83,
              31.75
            ],
            [
              -93.82,
              31.77
            ],
            [
              -93.88,
              31.82
            ],
            [
              -93.91,
              31.89
            ],
            [
              -93.97,
              31.92
            ],
            [
              -94.01,
              31.98
            ],
            [
              -94.04,
              31.99
            ],
            [
              -94.04,
              33.02
            ]
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      name: "Rhode Island",
      fips: "44"
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [
              -71.2,
              41.68
            ],
            [
              -71.13,
              41.66
            ],
            [
              -71.12,
              41.5
            ],
            [
              -71.19,
              41.46
            ],
            [
              -71.21,
              41.55
            ],
            [
              -71.21,
              41.6
            ],
            [
              -71.24,
              41.62
            ],
            [
              -71.24,
              41.48
            ],
            [
              -71.3,
              41.48
            ],
            [
              -71.3,
              41.45
            ],
            [
              -71.34,
              41.45
            ],
            [
              -71.34,
              41.5
            ],
            [
              -71.29,
              41.58
            ],
            [
              -71.26,
              41.64
            ],
            [
              -71.2,
              41.68
            ]
          ]
        ],
        [
          [
            [
              -71.36,
              41.66
            ],
            [
              -71.35,
              41.67
            ],
            [
              -71.31,
              41.62
            ],
            [
              -71.32,
              41.62
            ],
            [
              -71.36,
              41.66
            ]
          ]
        ],
        [
          [
            [
              -71.4,
              41.46
            ],
            [
              -71.38,
              41.5
            ],
            [
              -71.39,
              41.52
            ],
            [
              -71.38,
              41.57
            ],
            [
              -71.36,
              41.56
            ],
            [
              -71.36,
              41.48
            ],
            [
              -71.4,
              41.46
            ]
          ]
        ],
        [
          [
            [
              -71.61,
              41.16
            ],
            [
              -71.57,
              41.23
            ],
            [
              -71.55,
              41.22
            ],
            [
              -71.55,
              41.15
            ],
            [
              -71.61,
              41.16
            ]
          ]
        ],
        [
          [
            [
              -71.86,
              41.32
            ],
            [
              -71.83,
              41.34
            ],
            [
              -71.84,
              41.41
            ],
            [
              -71.8,
              41.42
            ],
            [
              -71.79,
              41.6
            ],
            [
              -71.79,
              41.73
            ],
            [
              -71.8,
              41.92
            ],
            [
              -71.8,
              42.01
            ],
            [
              -71.38,
              42.02
            ],
            [
              -71.38,
              41.89
            ],
            [
              -71.34,
              41.9
            ],
            [
              -71.35,
              41.83
            ],
            [
              -71.33,
              41.78
            ],
            [
              -71.26,
              41.75
            ],
            [
              -71.22,
              41.71
            ],
            [
              -71.24,
              41.67
            ],
            [
              -71.29,
              41.64
            ],
            [
              -71.31,
              41.67
            ],
            [
              -71.29,
              41.7
            ],
            [
              -71.36,
              41.75
            ],
            [
              -71.39,
              41.78
            ],
            [
              -71.37,
              41.67
            ],
            [
              -71.45,
              41.69
            ],
            [
              -71.41,
              41.65
            ],
            [
              -71.4,
              41.59
            ],
            [
              -71.45,
              41.58
            ],
            [
              -71.42,
              41.53
            ],
            [
              -71.42,
              41.47
            ],
            [
              -71.45,
              41.43
            ],
            [
              -71.48,
              41.37
            ],
            [
              -71.53,
              41.38
            ],
            [
              -71.62,
              41.36
            ],
            [
              -71.72,
              41.33
            ],
            [
              -71.86,
              41.31
            ],
            [
              -71.86,
              41.32
            ]
          ]
        ]
      ]
    }
  }
], qp = {
  features: Yp
}, Xp = "#e3eefc", Zp = "#08306b", g2 = "#eef1f5", p8 = "#b7c1d1", Jp = (n) => {
  const o = /* @__PURE__ */ new Map();
  return n.records.filter((a) => a.level === "country" && a.countryName).forEach((a) => {
    o.set(a.countryName, {
      key: a.countryName,
      label: a.covariateName,
      count: a.count,
      pct: a.pct
    });
  }), o;
}, Qp = (n) => {
  const o = /* @__PURE__ */ new Map();
  return n.records.filter((a) => a.level === "state" && a.stateCode).forEach((a) => {
    o.set(a.stateCode, {
      key: a.stateCode,
      label: a.covariateName,
      count: a.count,
      pct: a.pct
    });
  }), o;
}, em = {
  "commonwealth of the northern mariana islands": "northern mariana islands"
}, tm = (n) => {
  if (!n)
    return;
  const o = n.toLowerCase();
  return Bo[em[o] ?? o];
}, Vo = (n) => {
  const o = Nd().domain([0, Math.max(1, n)]).range([Xp, Zp]).interpolate(Fd);
  return (a) => a && a > 0 ? o(a) : g2;
}, nm = (n) => n.size ? Math.max(...Array.from(n.values(), (o) => o.count)) : 0, rm = (n) => {
  const o = Array.from(n.values(), (a) => a.count).filter(
    (a) => a > 0
  );
  return o.length ? Math.min(...o) : 0;
}, om = (n, o) => {
  if (o <= 0)
    return g2;
  const a = Vo(o), i = Math.max(1, n), l = 16;
  return `linear-gradient(to right, ${Array.from({ length: l + 1 }, (p, g) => {
    const u = i + (o - i) * g / l;
    return `${a(u)} ${g * 100 / l}%`;
  }).join(", ")})`;
}, am = (n, o, a) => {
  const i = Math.max(1, n), l = Math.min(1, Math.max(0, a));
  return Math.round(i + (o - i) * l).toLocaleString();
}, m8 = 3, Vn = 8, h8 = {
  fontSize: 11,
  lineHeight: "12px",
  color: "#42526e",
  whiteSpace: "nowrap",
  flexShrink: 0
}, im = (n) => n === "world" ? ko.features : qp.features, sm = (n, o, a) => {
  if (n === "world")
    return a.get(o.properties.name);
  const i = tm(o.properties.name);
  return i ? a.get(i) : void 0;
}, lm = ze(
  ({ data: n, region: o, zoom: a = 1, onZoomBy: i }) => {
    const l = je(
      () => o === "world" ? Jp(n) : Qp(n),
      [n, o]
    ), c = je(() => nm(l), [l]), p = je(() => rm(l), [l]), g = je(() => Vo(c), [c]), u = je(() => om(p, c), [p, c]), [d, f] = pe(), [b, C] = pe(null), v = $1(null), A = $1(void 0), P = $1({
      active: !1,
      moved: !1,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0
    }), T = w1(
      (x) => {
        var j;
        if ((j = A.current) == null || j.call(A), A.current = void 0, v.current = x, !x)
          return;
        const m = (_) => {
          !_.ctrlKey && !_.metaKey || (_.preventDefault(), i == null || i(_.deltaY < 0 ? 1 : -1));
        };
        x.addEventListener("wheel", m, { passive: !1 }), A.current = () => x.removeEventListener("wheel", m);
      },
      [i]
    ), I = a > 1, w = (x) => {
      var j;
      const m = v.current;
      !m || x.button !== 0 || !I || (P.current = {
        active: !0,
        moved: !1,
        startX: x.clientX,
        startY: x.clientY,
        scrollLeft: m.scrollLeft,
        scrollTop: m.scrollTop
      }, (j = m.setPointerCapture) == null || j.call(m, x.pointerId));
    }, N = (x) => {
      const m = P.current, j = v.current;
      if (!m.active || !j)
        return;
      const _ = x.clientX - m.startX, z = x.clientY - m.startY;
      (Math.abs(_) > m8 || Math.abs(z) > m8) && (m.moved = !0, j.scrollLeft = m.scrollLeft - _, j.scrollTop = m.scrollTop - z);
    }, E = (x) => {
      var m, j;
      P.current.active = !1, (j = (m = v.current) == null ? void 0 : m.releasePointerCapture) == null || j.call(m, x.pointerId);
    };
    return /* @__PURE__ */ e.jsxs(X, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
      /* @__PURE__ */ e.jsx(_o, { children: ({ width: x, height: m }) => {
        const j = Math.max(0, x || 0), _ = Math.max(0, m || 0);
        if (!j || !_)
          return null;
        const z = im(o), Y = { type: "FeatureCollection", features: z }, W = o === "world" ? Dd() : Ld();
        W.fitExtent(
          [
            [Vn, Vn],
            [j - Vn, _ - Vn]
          ],
          Y
        );
        const D = Md(W), F = Math.floor(j * a), M = Math.floor(_ * a);
        return /* @__PURE__ */ e.jsx(
          X,
          {
            ref: T,
            onPointerDown: w,
            onPointerMove: N,
            onPointerUp: E,
            onPointerCancel: E,
            onMouseLeave: () => C(null),
            sx: {
              width: j,
              height: _,
              overflow: I ? "auto" : "hidden",
              cursor: I ? "grab" : "default",
              ...I ? { "&:active": { cursor: "grabbing" } } : {}
            },
            children: /* @__PURE__ */ e.jsx(X, { sx: { width: F, height: M }, children: /* @__PURE__ */ e.jsx(
              X,
              {
                sx: {
                  width: j,
                  height: _,
                  transform: `scale(${a})`,
                  transformOrigin: "0 0"
                },
                children: /* @__PURE__ */ e.jsxs(
                  "svg",
                  {
                    width: j,
                    height: _,
                    role: "img",
                    "aria-label": o === "world" ? "World location heatmap" : "USA location heatmap",
                    children: [
                      /* @__PURE__ */ e.jsx(
                        "rect",
                        {
                          width: j,
                          height: _,
                          fill: "#f7f9fc"
                        }
                      ),
                      z.map((K, J) => {
                        const q = D(K);
                        if (!q)
                          return null;
                        const B = sm(o, K, l);
                        return /* @__PURE__ */ e.jsx(
                          "path",
                          {
                            d: q,
                            fill: B ? g(B.count) : g2,
                            stroke: p8,
                            strokeWidth: 0.5,
                            style: { cursor: "pointer" },
                            onMouseMove: (k) => {
                              var re, te, U;
                              const H = (re = v.current) == null ? void 0 : re.getBoundingClientRect();
                              C({
                                x: k.clientX - ((H == null ? void 0 : H.left) ?? 0) + (((te = v.current) == null ? void 0 : te.scrollLeft) ?? 0),
                                y: k.clientY - ((H == null ? void 0 : H.top) ?? 0) + (((U = v.current) == null ? void 0 : U.scrollTop) ?? 0),
                                label: (B == null ? void 0 : B.label) ?? K.properties.name,
                                count: (B == null ? void 0 : B.count) ?? 0,
                                pct: (B == null ? void 0 : B.pct) ?? 0,
                                hasData: !!B
                              });
                            }
                          },
                          K.properties.name ?? J
                        );
                      })
                    ]
                  }
                )
              }
            ) })
          }
        );
      } }),
      b && /* @__PURE__ */ e.jsxs(
        X,
        {
          sx: {
            position: "absolute",
            left: b.x + 12,
            top: b.y + 12,
            pointerEvents: "none",
            background: "#fff",
            border: "1px solid #d8dee8",
            borderRadius: "2px",
            boxShadow: "0 2px 8px rgba(23, 43, 77, 0.12)",
            p: 1,
            zIndex: 5,
            maxWidth: 220
          },
          children: [
            /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", children: b.label }),
            b.hasData ? /* @__PURE__ */ e.jsxs(ce, { variant: "body2", children: [
              oe(b.count),
              " (",
              b.pct,
              "%)"
            ] }) : /* @__PURE__ */ e.jsx(ce, { variant: "body2", sx: { color: "#6b778c" }, children: "No data" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs(
        X,
        {
          sx: {
            position: "absolute",
            left: 12,
            bottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            background: "rgba(255,255,255,0.9)",
            border: `1px solid ${p8}`,
            borderRadius: 1,
            px: 1,
            py: 0.5
          },
          children: [
            /* @__PURE__ */ e.jsx(ce, { sx: h8, children: oe(p) }),
            /* @__PURE__ */ e.jsx(
              X,
              {
                sx: { width: 110, height: 12, flexShrink: 0, background: u },
                title: d,
                onMouseMove: (x) => {
                  const m = x.currentTarget.getBoundingClientRect(), j = (x.clientX - m.left) / m.width;
                  f(am(p, c, j));
                }
              }
            ),
            /* @__PURE__ */ e.jsx(ce, { sx: h8, children: oe(c) })
          ]
        }
      )
    ] });
  }
), i3 = 1, Uo = 6, cm = 0.5, um = (n) => Math.min(Uo, Math.max(i3, Math.round(n * 100) / 100)), Qn = 30, dm = {
  display: "flex",
  alignItems: "center",
  gap: 0.25,
  height: Qn,
  boxSizing: "border-box",
  px: 0.5,
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: 1,
  "& .MuiIconButton-root": {
    p: "3px",
    borderRadius: 1,
    "&.Mui-disabled": { background: "transparent", border: "none" },
    "& .MuiSvgIcon-root": { fontSize: 18 }
  }
}, pm = ze(
  ({ items: n, cohorts: o }) => {
    const [a, i] = pe(
      () => {
        var T;
        return (T = o == null ? void 0 : o[0]) == null ? void 0 : T.id;
      }
    ), l = je(
      () => (o == null ? void 0 : o.find((T) => String(T.id) === String(a))) ?? (o == null ? void 0 : o[0]),
      [o, a]
    );
    m1(() => {
      o != null && o.length && !o.some((T) => T.id === (l == null ? void 0 : l.id)) && i(o[0].id);
    }, [o, l]);
    const c = je(
      () => (o || []).map((T, I) => ({
        value: T.id,
        name: T.name || `Cohort ${I + 1}`
      })),
      [o]
    ), p = je(
      () => Hp({ items: n, cohort: l }),
      [n, l]
    ), g = je(
      () => p ?? Kp("5.3"),
      [p]
    ), u = je(
      () => g.records.some((T) => T.level === "country"),
      [g]
    ), d = je(
      () => g.records.some((T) => T.level === "state"),
      [g]
    ), [f, b] = pe(
      u ? "world" : "usa"
    ), [C, v] = pe(i3);
    m1(() => {
      b((T) => T === "world" && !u ? "usa" : T === "usa" && !d ? "world" : T), v(i3);
    }, [u, d]);
    const A = w1(
      (T) => v((I) => um(I + T * cm)),
      []
    ), P = (T) => {
      b(T), v(i3);
    };
    return /* @__PURE__ */ e.jsxs(X, { sx: { width: "100%", mt: 2 }, children: [
      /* @__PURE__ */ e.jsx(M1, { sx: { mb: 2 } }),
      /* @__PURE__ */ e.jsxs(
        X,
        {
          sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            mb: 1,
            flexWrap: "wrap"
          },
          children: [
            /* @__PURE__ */ e.jsxs(X, { children: [
              /* @__PURE__ */ e.jsxs(X, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
                /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", children: c.length ? "Geographic distribution for cohort:" : "Geographic distribution" }),
                c.length > 0 && /* @__PURE__ */ e.jsx(
                  X,
                  {
                    sx: {
                      minWidth: 180,
                      maxWidth: 280,
                      "& .MuiInputBase-root": { height: Qn }
                    },
                    children: /* @__PURE__ */ e.jsx(
                      W1,
                      {
                        id: "location-map-cohort",
                        name: "location-map-cohort",
                        size: "small",
                        options: c,
                        value: (l == null ? void 0 : l.id) ?? "",
                        onChange: (T) => {
                          i(T), v(i3);
                        },
                        fullWidth: !0,
                        cropItems: !0
                      }
                    )
                  }
                )
              ] }),
              !p && /* @__PURE__ */ e.jsx(ce, { variant: "caption", sx: { color: "#bf6a02" }, children: "No location could be resolved from the results - showing mock data." })
            ] }),
            /* @__PURE__ */ e.jsxs(X, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
              /* @__PURE__ */ e.jsxs(
                $4,
                {
                  size: "small",
                  variant: "outlined",
                  sx: {
                    height: Qn,
                    "& .MuiButtonBase-root": { height: Qn }
                  },
                  children: [
                    /* @__PURE__ */ e.jsx(
                      Ye,
                      {
                        variant: f === "world" ? "contained" : "outlined",
                        disabled: !u,
                        onClick: () => P("world"),
                        children: "World"
                      }
                    ),
                    /* @__PURE__ */ e.jsx(
                      Ye,
                      {
                        variant: f === "usa" ? "contained" : "outlined",
                        disabled: !d,
                        onClick: () => P("usa"),
                        children: "USA"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ e.jsxs(X, { sx: dm, children: [
                /* @__PURE__ */ e.jsx(
                  Vt,
                  {
                    size: "small",
                    "aria-label": "Zoom out",
                    title: "Zoom out",
                    disabled: C <= i3,
                    onClick: () => A(-1),
                    children: /* @__PURE__ */ e.jsx(t1, { iconName: "zoomOut", fontSize: "small" })
                  }
                ),
                /* @__PURE__ */ e.jsxs(
                  ce,
                  {
                    sx: {
                      minWidth: 34,
                      textAlign: "center",
                      userSelect: "none",
                      fontSize: 12,
                      color: "primary.main"
                    },
                    children: [
                      Math.round(C * 100),
                      "%"
                    ]
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Vt,
                  {
                    size: "small",
                    "aria-label": "Zoom in",
                    title: "Zoom in",
                    disabled: C >= Uo,
                    onClick: () => A(1),
                    children: /* @__PURE__ */ e.jsx(t1, { iconName: "zoomIn", fontSize: "small" })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Vt,
                  {
                    size: "small",
                    "aria-label": "Reset zoom",
                    title: "Reset zoom",
                    disabled: C === i3,
                    onClick: () => v(i3),
                    children: /* @__PURE__ */ e.jsx(t1, { iconName: "reload", fontSize: "small" })
                  }
                )
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(X, { sx: { height: 460, width: "100%" }, children: /* @__PURE__ */ e.jsx(
        lm,
        {
          data: g,
          region: f,
          zoom: C,
          onZoomBy: A
        }
      ) }),
      /* @__PURE__ */ e.jsxs(
        ce,
        {
          variant: "caption",
          sx: { color: "#8993a4", display: "block", mt: 0.5 },
          children: [
            "Darker = more people. Ctrl/Cmd + scroll to zoom, drag to pan.",
            u && d ? " Switch to USA to see the per-state breakdown." : ""
          ]
        }
      )
    ] });
  }
), x5 = ze((n) => {
  const { name: o, report: a, cohorts: i, allResults: l, strataOnly: c } = n, [p, g] = pe([]), u = a.resultType === R1.DISTRIBUTION, d = je(() => {
    let C = Np(a == null ? void 0 : a.resultType, a, o), v = Lo(C).list;
    return { raw: C, groupedByPage: v };
  }, [a, i]), f = je(
    () => !u && (a == null ? void 0 : a.domain) === "LOCATION",
    [u, a == null ? void 0 : a.domain]
  ), b = je(() => u ? p || [] : [], [p, u]);
  return /* @__PURE__ */ e.jsx(Ne, { elevated: !0, outlined: !0, title: o, children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    !p && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(X, { display: "flex", justifyContent: "center", p: 3, children: "No items" }) }),
    /* @__PURE__ */ e.jsx(
      y,
      {
        item: !0,
        xs: c || u ? 12 : 8,
        sx: { minWidth: 0 },
        children: p && /* @__PURE__ */ e.jsx(
          Dp,
          {
            ...n,
            setChartData: g,
            data: d.raw,
            resultType: a == null ? void 0 : a.resultType
          }
        )
      }
    ),
    !c && /* @__PURE__ */ e.jsx(y, { item: !0, xs: u ? 12 : 4, sx: { minWidth: 0 }, children: a.resultType !== R1.DISTRIBUTION ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      i.length == 1 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        a.item.length > 1 && a.item.length < 5 && /* @__PURE__ */ e.jsx(
          Fo,
          {
            list: p,
            cohort: i == null ? void 0 : i[0],
            addNA: !0
          }
        ),
        a.item.length > 5 && /* @__PURE__ */ e.jsx(No, { list: p, cohort: i == null ? void 0 : i[0] })
      ] }),
      i.length == 2 && /* @__PURE__ */ e.jsx(
        Do,
        {
          fullList: d.groupedByPage,
          cohorts: i,
          list: p,
          allResults: l,
          report: a
        }
      ),
      i.length > 2 && /* @__PURE__ */ e.jsx(Mo, { cohorts: i, list: p })
    ] }) : u && /* @__PURE__ */ e.jsx(y, { container: !0, px: 2, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Io,
      {
        report: a || {},
        cohorts: i || [],
        items: b
      }
    ) }) }) }),
    f && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, sx: { minWidth: 0 }, children: /* @__PURE__ */ e.jsx(pm, { items: d.raw, cohorts: i }) })
  ] }) });
}), mm = ze((n) => {
  const { reports: o, cohorts: a, analyses: i, subgroups: l, strataOnly: c } = n, [p, g] = pe(), [u, d] = pe(c3.INITIAL);
  return m1(() => {
    const f = {
      analysisId: 0,
      resultType: R1.PREVALENCE,
      item: [],
      analysisName: "",
      domain: null,
      faType: Oo.PRESET,
      allData: !0
    };
    o.filter(
      (C) => (C == null ? void 0 : C.resultType) === R1.PREVALENCE
    ).forEach((C) => {
      const v = C.item.map((A) => ({ ...A, analysisType: C.designName }));
      f.analysisId += C.analysisId, f.item = [...f.item, ...v];
    }), f.item = ho(
      fo(f.item, (C) => C.records[0].avg)
    ), g(f), d(c3.SUCCESS);
  }, [o]), u === c3.INITIAL ? /* @__PURE__ */ e.jsx(bd, { children: /* @__PURE__ */ e.jsx(p5, { size: 32 }) }) : !p || (p == null ? void 0 : p.item.length) < 2 ? /* @__PURE__ */ e.jsx(e.Fragment, {}) : /* @__PURE__ */ e.jsx(
    x5,
    {
      name: "All Prevalence Covariates",
      report: p,
      cohorts: a,
      allResults: !0,
      analyses: i,
      subgroups: l,
      strataOnly: c
    }
  );
}), kr = (n, o) => n.map((a) => {
  var i;
  return {
    ...a,
    realNameAnalysis: (i = o.find(
      (l) => l.designName === a.designName
    )) == null ? void 0 : i.name
  };
});
var hm = /* @__PURE__ */ ((n) => (n.PREVALENCE = "PREVALENCE", n.DISTRIBUTION = "DISTRIBUTION", n))(hm || {}), fm = /* @__PURE__ */ ((n) => (n.PRESET = "PRESET", n))(fm || {});
const Ly = ze((n) => {
  const { reports: o, cohorts: a, analyses: i, domains: l, stratas: c, strataOnly: p } = n.data, [g, u] = pe({
    cohorts: a[0] ? [a[0]] : [],
    reports: kr(o, i) || [],
    domains: l
  }), [d, f] = pe(
    c3.INITIAL
  ), b = xo(
    (A, P) => {
      u((T) => ({ ...T, [A]: P })), f(c3.SUCCESS);
    },
    1e3
  ), C = g.reports.length ? g.reports : kr(o, i), v = g.cohorts.length ? g.cohorts : a[0] ? [a[0]] : [];
  return o.length > 0 ? /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, p: 2, children: [
    /* @__PURE__ */ e.jsx(
      Tp,
      {
        value: g,
        onFilterResults: (A, P) => {
          f(c3.IN_PROGRESS), b(A, P);
        },
        cohorts: a,
        reports: kr(o, i),
        status: d
      }
    ),
    d === c3.IN_PROGRESS ? /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, pt: 2, textAlign: "center", children: /* @__PURE__ */ e.jsx(p5, { size: 50, color: "info" }) }) : v.length > 0 && C.length > 0 ? /* @__PURE__ */ e.jsxs(y, { container: !0, py: 2, spacing: 2, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        mm,
        {
          reports: C,
          cohorts: v,
          analyses: i,
          subgroups: c,
          strataOnly: p
        }
      ) }),
      C.map((A) => {
        const P = { ...A };
        if (P.item = ho(
          fo(P.item, (T) => T.records[0].avg)
        ), g.domains.includes(A.domain))
          return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            x5,
            {
              name: A.realNameAnalysis,
              report: P,
              cohorts: v,
              subgroups: c,
              strataOnly: p
            },
            A.analysisId
          ) }, A.analysisId);
      })
    ] }) : /* @__PURE__ */ e.jsx(o8, { children: "No data" })
  ] }) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(o8, { children: "No data visualization" }) });
});
Fe.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const xm = Fe(y, {
  shouldForwardProp: (n) => n !== "isActive"
})`
  font-size: 14px;
  color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
  font-weight: 400;
  border-bottom: 1px solid
    ${({ theme: n }) => n.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: n, theme: o }) => n ? o.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: n, isActive: o }) => n.palette.info.main + (o ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, gm = {
  entityNavigationPanel: (n) => [
    {
      value: Xn.FILES_IN_ARCHIVE,
      title: "Files in archive",
      onTabClick: n
    }
    // {
    //   id: CreateSubmissionFormTabs.SEPARATE_FILES,
    //   title: 'Separate files',
    //   onTab: setActive,
    // },
  ]
}, ym = (n) => {
  switch (n) {
    case _t.SCANNING:
      return "warning";
    case _t.OK:
      return "success";
    case _t.INFECTED:
      return "error";
    case _t.NOT_SCANNED:
    case _t.WILL_NOT_SCAN:
      return "secondary";
  }
}, vm = (n, o) => r4.post(`analysis/custom/${n}/upload/zip`, o), bm = (n, o, a) => r4.post(`/analysis/custom/${n}/attach-custom-code/${o}`, a), Cm = ze((n) => {
  var E, x, m;
  const { id: o, afterCreate: a, onCancel: i, subModules: l, originalEntity: c, parentId: p } = n, [g, u] = pe(!1), [d, f] = pe([]), [b, C] = pe(), [v, A] = pe({
    title: c.title,
    analysisType: po.find(
      (j) => j.value === c.type
    ).name || "-",
    analysisName: c == null ? void 0 : c.title,
    studyId: p,
    studyName: null,
    design: {
      executableFileName: null,
      cohorts: (E = c == null ? void 0 : c.design) == null ? void 0 : E.cohorts,
      conceptSets: (x = c == null ? void 0 : c.design) == null ? void 0 : x.conceptSets
    }
  }), [P, T] = pe(
    Xn.FILES_IN_ARCHIVE
  ), I = je(() => gm.entityNavigationPanel(T), []), w = w1(() => {
    u(!0);
    let j = new FormData();
    j.append(
      "dto",
      new Blob([JSON.stringify(v)], {
        type: "application/json"
      })
    ), j.append("file", b), vm(o, j).then((_) => {
      u(!1), a == null || a(_);
    });
  }, [v]), N = je(() => v.design.executableFileName, [v]);
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(
      y,
      {
        item: !0,
        xs: 12,
        px: 2,
        sx: (j) => ({
          boxShadow: j.customShadows[2],
          background: "white"
        }),
        children: /* @__PURE__ */ e.jsx(f5, { tabs: I, active: P, secondary: !0 })
      }
    ),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(k4, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
      P === Xn.FILES_IN_ARCHIVE && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        l.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: l,
          config: {
            onChange: (j, _) => {
              const z = _ ? Object.keys(_.files) : j;
              f((Y) => z.map((W) => _ ? _.files[W] : W).filter((W) => W.name.toLowerCase().includes(".sql") || W.name.toLowerCase().includes(".r")).map((W) => ({
                name: W.name,
                value: W.name
              }))), C(j);
            },
            localDownload: !0,
            createMethod: (j) => {
            },
            textAvailableExt: "ZIP",
            acceptExt: [
              "application/zip",
              "application/octet-stream",
              "application/x-zip-compressed",
              "multipart/x-zip"
            ]
          }
        }
      ) }),
      P === Xn.SEPARATE_FILES && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        l.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: l,
          config: {
            localDownload: !0,
            onChange: (j) => {
            },
            createMethod: (j) => {
            },
            freeUpload: !0
          }
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(tt, { name: "type", textLabel: "Entry point", required: !0, children: /* @__PURE__ */ e.jsx(
        W1,
        {
          className: "",
          name: "entry-point",
          disablePortal: !0,
          id: "entry point",
          options: d,
          value: (m = v.design) == null ? void 0 : m.executableFileName,
          placeholder: "Select entry point...",
          onChange: (j) => {
            var _, z;
            A({
              ...v,
              design: {
                executableFileName: j,
                cohorts: (_ = v.design) == null ? void 0 : _.cohorts,
                conceptSets: (z = v.design) == null ? void 0 : z.conceptSets
              }
            });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(tt, { name: "analysis-name", textLabel: "Analysis name", children: /* @__PURE__ */ e.jsx(
        et,
        {
          id: "analysis-name",
          name: "analysis-name",
          type: "text",
          size: "medium",
          disabled: !0,
          value: v.analysisName,
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(tt, { name: "analysis-type", textLabel: "Analysis type", children: /* @__PURE__ */ e.jsx(
        et,
        {
          id: "analysis-type",
          name: "analysis-type",
          type: "text",
          size: "medium",
          disabled: !0,
          value: v.analysisType,
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(io, { children: [
        /* @__PURE__ */ e.jsx(
          Ye,
          {
            variant: "outlined",
            onClick: i,
            startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "deactivate" }),
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ye,
          {
            disabled: g || !N,
            onClick: w,
            variant: "contained",
            color: "success",
            startIcon: g ? /* @__PURE__ */ e.jsx(p5, { size: 16 }) : /* @__PURE__ */ e.jsx(t1, { iconName: "submit" }),
            children: "Save design"
          }
        )
      ] }) })
    ] }) }) })
  ] });
}), My = ze((n) => {
  var E, x;
  const {
    subModules: o,
    parentId: a,
    design: i,
    originalEntity: l,
    id: c,
    typeContainer: p,
    updateDesign: g,
    analysisName: u,
    viewMode: d
  } = n, { openModal: f, closeModal: b } = eo(Po), [C, v] = pe(!1), [A, P] = pe(i.files || []), T = (m) => {
    g(
      "cohorts",
      m.map((j) => ({
        ...j,
        alias: e8(j)
      }))
    );
  }, I = (m) => {
    g(
      "conceptSets",
      m.map((j) => ({
        ...j,
        alias: e8(j)
      }))
    );
  }, w = (m) => {
    P(m.files), g("files", m.files), g("executableFileName", m.executableFileName), g("customCode", m.customCode);
  }, N = () => {
    f(
      () => /* @__PURE__ */ e.jsx(
        Cm,
        {
          id: c,
          subModules: o,
          originalEntity: l,
          onCancel: b,
          parentId: a,
          afterCreate: (m) => {
            w(m.design), b();
          }
        }
      ),
      "Upload analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: b
      }
    );
  };
  return console.log("Design", i.customCode), /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1.5, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsxs(sd, { severity: "info", sx: { fontSize: 12, alignItems: "center" }, children: [
      "The JSON files containing the definitions of referenced Cohorts and Concept Sets will be included in the final package within the",
      " ",
      /* @__PURE__ */ e.jsx("b", { children: "cohorts" }),
      " and ",
      /* @__PURE__ */ e.jsx("b", { children: "conceptsets" }),
      " directories."
    ] }) }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        viewMode: d,
        config: {
          buttonText: "Import Cohorts",
          titleText: "Referenced Cohorts",
          classNameContainer: "target-import-button",
          typeContainer: p,
          initialData: i == null ? void 0 : i.cohorts,
          onChange: (m) => {
            T(m);
          },
          parentId: a,
          returnEntityText: u,
          viewMode: d,
          isSelect: !0,
          withAlias: !0
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.concept,
      {
        type: "component",
        name: "widget-concept-set-import-button",
        subModules: o,
        viewMode: d,
        config: {
          buttonText: "Import Concept Sets",
          titleText: "Referenced Concept Sets",
          classNameContainer: "target-import-button",
          typeContainer: p,
          initialData: i == null ? void 0 : i.conceptSets,
          onChange: (m) => {
            I(
              m.map((j) => ({
                ...j,
                items: Id(j.items)
              }))
            );
          },
          parentId: a,
          returnEntityText: u,
          viewMode: d,
          isSelect: !0,
          withAlias: !0
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        elevated: !0,
        outlined: !0,
        title: i.customCode ? `Files in ${i.customCode.name}` : "Files",
        actions: /* @__PURE__ */ e.jsx(y, { item: !0, display: "flex", children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          ((E = i.files) == null ? void 0 : E.length) > 0 && /* @__PURE__ */ e.jsx(
            Ye,
            {
              onClick: (m) => {
                m.stopPropagation(), window.location.href = `/api/analysis/custom/${c}/download`;
              },
              variant: "outlined",
              startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "download" }),
              sx: {
                mr: 1.5,
                px: 2,
                color: "info.main",
                borderColor: "borderColor.main",
                ".start-icon-small svg": {
                  fontSize: 16
                }
              },
              className: "download-files",
              name: "download-files",
              children: "Download files"
            }
          ),
          !d && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              Ye,
              {
                onClick: N,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ e.jsx(
                  t1,
                  {
                    iconName: "download",
                    sx: { transform: "rotate(180deg)" }
                  }
                ),
                name: "upload",
                children: "Upload files"
              }
            ),
            /* @__PURE__ */ e.jsx(
              o.customCode,
              {
                type: "component",
                name: "add-custom-code-button",
                subModules: o,
                viewMode: d,
                config: {
                  instanceId: c,
                  isLoading: C,
                  onChange: async (m) => {
                    try {
                      v(!0);
                      const j = await bm(
                        c,
                        m[0].id,
                        l
                      );
                      w(j.design), v(!1);
                    } catch {
                      v(!1), console.log("something gone wrong");
                    }
                  }
                }
              }
            )
          ] })
        ] }) }),
        children: ((x = i.files) == null ? void 0 : x.length) > 0 ? /* @__PURE__ */ e.jsx(y, { container: !0, className: "table-files", mt: 1, children: A == null ? void 0 : A.map((m) => {
          const j = Rd(m.realName), _ = i.executableFileName && i.executableFileName === m.realName;
          return /* @__PURE__ */ e.jsxs(
            xm,
            {
              xs: 12,
              px: 1,
              py: 0.5,
              isActive: _,
              children: [
                /* @__PURE__ */ e.jsx(
                  t1,
                  {
                    iconName: go(j),
                    iconStatus: ym(
                      m.antivirusFileStatusDto
                    ),
                    sx: { fontSize: 26 }
                  }
                ),
                /* @__PURE__ */ e.jsx("span", { children: m.realName }),
                _ && /* @__PURE__ */ e.jsx(f1, { text: "Entry point", children: /* @__PURE__ */ e.jsx(
                  X,
                  {
                    display: "inline-flex",
                    sx: { position: "absolute", top: 4, left: 10 },
                    children: /* @__PURE__ */ e.jsx(
                      t1,
                      {
                        iconName: "bookmark",
                        color: "success",
                        sx: { fontSize: 14 }
                      }
                    )
                  }
                ) })
              ]
            },
            m.path
          );
        }) }) : /* @__PURE__ */ e.jsx(
          y,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1,
              mt: 1
            },
            children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", color: "borderColor.main", children: "No files" })
          }
        )
      }
    ) })
  ] }) });
}), ky = ze((n) => /* @__PURE__ */ e.jsx(e.Fragment, { children: "results" })), zr = (n) => {
  const {
    subModules: o,
    viewMode: a,
    id: i,
    parentId: l,
    typeContainer: c,
    initialData: p,
    analysisName: g,
    titleText: u,
    buttonText: d,
    isSelect: f = !1,
    onChange: b
  } = n;
  return /* @__PURE__ */ e.jsx(
    o.cohort,
    {
      type: "component",
      name: "widget-cohort-import-button",
      subModules: o,
      path: L1(c, i, l),
      config: {
        buttonText: d,
        titleText: u,
        typeContainer: c,
        initialData: p,
        onChange: b,
        isSelect: f,
        parentId: l,
        returnEntityText: g,
        viewMode: a
      }
    }
  );
}, _4 = (n) => {
  const {
    subModules: o,
    viewMode: a,
    id: i,
    parentId: l,
    typeContainer: c,
    initialData: p,
    analysisName: g,
    titleText: u,
    buttonText: d,
    isSelect: f = !1,
    onChange: b,
    description: C,
    isDark: v = !1
  } = n;
  return /* @__PURE__ */ e.jsx(
    o.concept,
    {
      type: "component",
      name: "widget-concept-set-import-button",
      subModules: o,
      viewMode: a,
      config: {
        buttonText: d,
        titleText: u,
        description: C,
        typeContainer: c,
        initialData: p,
        onChange: b,
        isSelect: !1,
        parentId: l,
        returnEntityText: g,
        isDark: v
      }
    }
  );
}, Go = ({
  onSubmit: n,
  onCancel: o,
  cancelButtonText: a = "Cancel",
  submitButtonText: i = "Submit"
}) => /* @__PURE__ */ e.jsx(
  y,
  {
    item: !0,
    xs: 12,
    position: "sticky",
    zIndex: 1,
    bottom: 0,
    right: 0,
    width: "100%",
    children: /* @__PURE__ */ e.jsxs(
      Gt,
      {
        elevation: 1,
        sx: { borderRadius: 0, px: 6, py: 1, textAlign: "right" },
        children: [
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              variant: "outlined",
              color: "info",
              startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "close" }),
              sx: { mr: 1 },
              onClick: o,
              children: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              variant: "contained",
              color: "success",
              startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "add" }),
              onClick: n,
              children: i
            }
          )
        ]
      }
    )
  }
), jm = ze((n) => {
  const { activeItem: o, designProps: a, onChange: i, onClose: l } = n, { typeContainer: c, id: p, parentId: g, subModules: u, analysisName: d, viewMode: f } = a, [b, C] = pe(
    o.value || {
      targetId: void 0,
      comparatorId: void 0,
      outcomeIds: [],
      excludedCovariateConceptIds: [],
      includedCovariateConceptIds: [],
      outcomeCohorts: [],
      comparatorCohort: void 0,
      targetCohort: void 0,
      negativeControlConceptSet: void 0,
      includedCovariateConceptSet: void 0,
      excludedCovariateConceptSet: void 0
    }
  ), v = (I, w) => ([N]) => {
    C((E) => ({
      ...E,
      [I]: (N == null ? void 0 : N.versionId) || void 0,
      [w]: N || void 0
    }));
  }, A = (I) => {
    C((w) => {
      let N = I != null && I.length ? I.map((x) => x.versionId) : null;
      return {
        ...w,
        outcomeIds: N,
        outcomeCohorts: I
      };
    });
  }, P = (I) => (w) => {
    const [N] = w.map((E) => ({
      id: yo(),
      name: E.name,
      description: E.description,
      expression: { items: E.items }
      // type: 'by_value'
    }));
    C((E) => ({
      ...E,
      [I]: N
    }));
  }, T = () => {
    [
      b.targetCohort,
      b.comparatorCohort,
      ...b.outcomeCohorts
    ].filter((I) => !!I), i(b, o.index), l();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, py: 2, px: 6, minHeight: "100%", children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ e.jsx(
        y,
        {
          item: !0,
          xs: 12,
          sx: {
            ".secondary-header-title": { fontWeight: 500, fontSize: 16 }
          },
          children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              zr,
              {
                subModules: u,
                viewMode: f,
                id: p,
                parentId: g,
                typeContainer: c,
                initialData: [b.targetCohort],
                analysisName: d,
                titleText: "Target cohort:",
                buttonText: "Choose target cohort",
                onChange: v("targetId", "targetCohort")
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              zr,
              {
                subModules: u,
                viewMode: f,
                id: p,
                parentId: g,
                typeContainer: c,
                initialData: [b.comparatorCohort],
                analysisName: d,
                titleText: "Comparator cohort:",
                buttonText: "Choose comparator cohort",
                onChange: v(
                  "comparatorId",
                  "comparatorCohort"
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              zr,
              {
                subModules: u,
                viewMode: f,
                id: p,
                parentId: g,
                typeContainer: c,
                initialData: b.outcomeCohorts,
                analysisName: d,
                titleText: "Outcome cohorts:",
                buttonText: "Add outcome cohorts",
                isSelect: !0,
                onChange: A
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              _4,
              {
                subModules: u,
                viewMode: f,
                id: p,
                parentId: g,
                typeContainer: c,
                initialData: [b.negativeControlConceptSet],
                analysisName: d,
                titleText: "Negative control concept set",
                description: "",
                buttonText: "Add negative control concept set",
                onChange: P("negativeControlConceptSet")
              }
            ) })
          ] })
        }
      ),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Covariate selection",
          outlined: !0,
          elevated: !0,
          children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
            /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
              /* @__PURE__ */ e.jsx(
                _4,
                {
                  subModules: u,
                  viewMode: f,
                  id: p,
                  parentId: g,
                  typeContainer: c,
                  initialData: [b.includedCovariateConceptSet],
                  analysisName: d,
                  titleText: "Included concept set",
                  description: "Concepts to include when constructing the covariates to be used in this study. (Leave blank if you want to include every concept).*",
                  buttonText: "Add included concept set",
                  isSelect: !1,
                  onChange: P("includedCovariateConceptSet")
                }
              ),
              /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Analysis settings section." })
            ] }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(M1, { sx: { my: 1, borderColor: "borderColor.light" } }) }),
            /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
              /* @__PURE__ */ e.jsx(
                _4,
                {
                  subModules: u,
                  viewMode: f,
                  id: p,
                  parentId: g,
                  typeContainer: c,
                  initialData: [b.excludedCovariateConceptSet],
                  analysisName: d,
                  titleText: "Excluded concept set",
                  description: "Concepts to exclude when constructing the covariates to be used in this study.*",
                  buttonText: "Add excluded concept set",
                  isSelect: !1,
                  onChange: P("excludedCovariateConceptSet")
                }
              ),
              /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Analysis settings section." })
            ] })
          ] })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ e.jsx(
      Go,
      {
        submitButtonText: "Save Comparison",
        onSubmit: T,
        onCancel: l
      }
    )
  ] });
}), d3 = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], Sm = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  }
], wm = [
  {
    value: !0,
    name: "yes"
  },
  {
    value: !1,
    name: "no"
  }
], O1 = (n) => {
  const { value: o, propName: a, setState: i, textLabel: l, description: c, labelSize: p } = n;
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      htmlFor: a,
      textLabel: l,
      description: c,
      labelSize: p,
      children: /* @__PURE__ */ e.jsx(
        W1,
        {
          className: `${a}-control`,
          name: a,
          disablePortal: !0,
          id: a,
          options: wm,
          value: o,
          placeholder: "Select value",
          onChange: (g) => {
            i((u) => ({
              ...u,
              [a]: g
            }));
          }
        }
      )
    }
  );
}, e1 = (n) => {
  const {
    value: o,
    propName: a,
    options: i,
    setState: l,
    textLabel: c,
    autoselect: p,
    description: g,
    labelSize: u,
    multiple: d
  } = n;
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      htmlFor: a,
      textLabel: c,
      description: g,
      labelSize: u,
      children: p ? /* @__PURE__ */ e.jsx(
        It,
        {
          className: `${a}-control`,
          placeholder: "Select value",
          name: a,
          id: a,
          value: o,
          multiple: d,
          onChange: (f) => {
            l((b) => ({
              ...b,
              [a]: f
            }));
          },
          options: i,
          sx: {
            maxWidth: 200
          }
        }
      ) : /* @__PURE__ */ e.jsx(
        W1,
        {
          className: `${a}-control`,
          name: a,
          disablePortal: !0,
          id: a,
          multiple: d,
          options: i,
          value: o || (d ? [] : null),
          placeholder: "Select value",
          cropItems: !0,
          onChange: (f) => {
            l((b) => ({
              ...b,
              [a]: f
            }));
          }
        }
      )
    }
  );
};
var P4 = /* @__PURE__ */ ((n) => (n.KEEP_ALL = "keep all", n.KEEP_FIRST = "keep first", n.REMOVE_ALL = "remove all", n))(P4 || {});
const Tm = [
  {
    value: P4.KEEP_ALL,
    name: "keep all"
  },
  {
    value: P4.KEEP_FIRST,
    name: "keep first"
  },
  {
    value: P4.REMOVE_ALL,
    name: "remove all"
  }
], Em = (n) => {
  const { values: o, onChange: a } = n;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, columnSpacing: 4, rowSpacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ve,
      {
        htmlFor: "studyStartDate",
        textLabel: "Study start date",
        description: "A calendar date specifying the minimum date that a cohort index can appear (leave blank to use all time)",
        children: /* @__PURE__ */ e.jsx(
          O3,
          {
            fullWidth: !0,
            value: o.studyStartDate,
            format: _1.DATEPICKER_DATE,
            onChange: (i) => {
              a((l) => ({
                ...l,
                studyStartDate: Zr(i, _1.ISO_DATE)
              }));
            },
            name: "studyStartDate"
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ve,
      {
        htmlFor: "studyEndDate",
        textLabel: "Study end date",
        description: "A calendar date specifying the maximum date that a cohort index can appear (leave blank to use all time). Important: the study end date is also used to truncate risk windows, meaning no outcomes beyond the study end date will be considered.",
        children: /* @__PURE__ */ e.jsx(
          O3,
          {
            fullWidth: !1,
            value: o.studyEndDate,
            format: _1.DATEPICKER_DATE,
            onChange: (i) => {
              a((l) => ({
                ...l,
                studyEndDate: Zr(i, _1.ISO_DATE)
              }));
            },
            name: "studyEndDate"
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Restrict the study to the period when both exposures are present in the data?",
        description: "(E.g. when both drugs are on the market)",
        propName: "restrictToCommonPeriod",
        value: o.restrictToCommonPeriod,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Should only the first exposure per subject be included?",
        propName: "firstExposureOnly",
        value: o.firstExposureOnly,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "The minimum required continuous observation time (in days) prior to index date for a person to be included in the cohort.",
        propName: "washoutPeriod",
        autoselect: !0,
        options: d3,
        value: o.washoutPeriod,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Remove subjects that are in both the target and comparator cohort?",
        propName: "removeDuplicateSubjects",
        options: Tm,
        value: o.removeDuplicateSubjects,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "If a subject is in multiple cohorts, should time-at-risk be censored when the new time-at-risk start to prevent overlap?",
        propName: "censorAtNewRiskWindow",
        value: o.censorAtNewRiskWindow,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Remove subjects that have the outcome prior to the risk window start?",
        propName: "removeSubjectsWithPriorOutcome",
        value: o.removeSubjectsWithPriorOutcome,
        setState: a
      }
    ) }),
    o.removeSubjectsWithPriorOutcome && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "How many days should we look back when identifying prior outcomes?",
        propName: "priorOutcomeLookback",
        autoselect: !0,
        options: d3,
        value: o.priorOutcomeLookback,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "If either the target or the comparator cohort is larger than this number it will be sampled to this size. (0 for this value indicates no maximum size)",
        propName: "maxCohortSize",
        options: Sm,
        autoselect: !0,
        value: o.maxCohortSize,
        setState: a
      }
    ) })
  ] });
}, s5 = (n) => {
  const {
    valueRisk: o,
    propNameRisk: a,
    optionsRisk: i,
    valueTime: l,
    propNameTime: c,
    optionsTime: p,
    setState: g,
    textLabel: u,
    customTime: d
  } = n;
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      htmlFor: `${c}-${a}`,
      textLabel: u,
      children: /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
          It,
          {
            name: a,
            id: a,
            options: i,
            value: o,
            placeholder: "Select",
            onChange: (f) => {
              g((b) => ({
                ...b,
                [a]: f
              }));
            }
          }
        ) }),
        d || /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, px: 1, fontSize: 12, children: "days from" }),
          /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
            W1,
            {
              className: "",
              name: c,
              disablePortal: !0,
              id: c,
              options: p,
              value: l,
              placeholder: "Select",
              onChange: (f) => {
                g((b) => ({
                  ...b,
                  [c]: f
                }));
              }
            }
          ) })
        ] })
      ] })
    }
  );
}, r2 = {
  false: {
    value: !1,
    name: "cohort start date"
  },
  true: {
    value: !0,
    name: "cohort end date"
  }
}, l5 = Object.values(
  r2
), Am = (n) => {
  const { values: o, onChange: a } = n;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      s5,
      {
        textLabel: "Define the time-at-risk window start, relative to target/comparator cohort entry",
        propNameRisk: "riskWindowStart",
        valueRisk: o.riskWindowStart,
        optionsRisk: d3,
        propNameTime: "addExposureDaysToStart",
        valueTime: o.addExposureDaysToStart,
        optionsTime: l5,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      s5,
      {
        textLabel: "Define the time-at-risk window end",
        propNameRisk: "riskWindowEnd",
        valueRisk: o.riskWindowEnd,
        optionsRisk: d3,
        propNameTime: "addExposureDaysToEnd",
        valueTime: o.addExposureDaysToEnd,
        optionsTime: l5,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "The minimum number of days at risk?",
        propName: "minDaysAtRisk",
        options: d3,
        autoselect: !0,
        value: o.minDaysAtRisk,
        setState: a
      }
    ) })
  ] });
}, _m = [
  {
    value: 100,
    name: "100"
  },
  {
    value: 500,
    name: "500"
  },
  {
    value: 1e3,
    name: "1000"
  }
], Pm = [
  {
    value: 0.1,
    name: "0.1"
  },
  {
    value: 0.01,
    name: "0.01"
  },
  {
    value: 1e-3,
    name: "0.001"
  },
  {
    value: 1e-4,
    name: "0.0001"
  },
  {
    value: 1e-5,
    name: "0.00001"
  },
  {
    value: 1e-6,
    name: "0.000001"
  }
];
var B4 = /* @__PURE__ */ ((n) => (n.AUTO = "auto", n.GRID = "grid", n))(B4 || {});
const Om = [
  {
    value: B4.AUTO,
    name: "auto"
  },
  {
    value: B4.GRID,
    name: "grid"
  }
];
var O4 = /* @__PURE__ */ ((n) => (n.GRADIENT = "gradient", n.MITTAL = "mittal", n.LANGE = "lange", n))(O4 || {});
const Im = [
  {
    value: O4.GRADIENT,
    name: "gradient"
  },
  {
    value: O4.MITTAL,
    name: "mittal"
  },
  {
    value: O4.LANGE,
    name: "lange"
  }
], l3 = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  }
];
var I4 = /* @__PURE__ */ ((n) => (n.SILENT = "silent", n.QUIET = "quiet", n.NOISY = "noisy", n))(I4 || {});
const Rm = [
  {
    value: I4.SILENT,
    name: "silent"
  },
  {
    value: I4.QUIET,
    name: "quiet"
  },
  {
    value: I4.NOISY,
    name: "noisy"
  }
], Nm = [
  {
    value: -1,
    name: "-1"
  },
  {
    value: -0.01,
    name: "-0.01"
  },
  {
    value: 0,
    name: "0"
  },
  {
    value: 0.01,
    name: "0.01"
  },
  {
    value: 1,
    name: "1"
  }
];
var R4 = /* @__PURE__ */ ((n) => (n.BY_PID = "byPid", n.BY_ROW = "byRow", n.AUTO = "auto", n))(R4 || {});
const Fm = [
  {
    value: R4.AUTO,
    name: "auto"
  },
  {
    value: R4.BY_PID,
    name: "by pid"
  },
  {
    value: R4.BY_ROW,
    name: "by row"
  }
], lt = (n) => {
  const { value: o, propName: a, setState: i, textLabel: l } = n;
  return /* @__PURE__ */ e.jsx(Ve, { htmlFor: a, textLabel: l, children: /* @__PURE__ */ e.jsx(
    et,
    {
      id: a,
      name: a,
      type: "text",
      size: "medium",
      placeholder: "Enter",
      value: o,
      onChange: (c) => {
        i((p) => ({
          ...p,
          [a]: c.target.value
        }));
      }
    }
  ) });
}, Ko = (n) => {
  const { values: o, onChange: a } = n, i = (l) => {
    a((c) => ({ ...c, control: l(c.control) }));
  };
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Maximum iterations of Cyclops to attempt before returning a failed-to-converge error.",
        propName: "maxIterations",
        options: _m,
        autoselect: !0,
        value: o.maxIterations,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Maximum relative change in convergence criterion from successive iterations to achieve convergence.",
        propName: "tolerance",
        options: Pm,
        autoselect: !0,
        value: o.tolerance,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Select the convergence type",
        propName: "convergenceType",
        options: Im,
        value: o.convergenceType,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Select the cross validation search type",
        propName: "cvType",
        options: Om,
        value: o.cvType,
        setState: i,
        labelSize: 8
      }
    ) }),
    o.cvType === B4.GRID && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        lt,
        {
          textLabel: "Lower prior variance limit",
          propName: "lowerLimit",
          value: o.lowerLimit,
          setState: i
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        lt,
        {
          textLabel: "Upper prior variance limit",
          propName: "upperLimit",
          value: o.upperLimit,
          setState: i
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        lt,
        {
          textLabel: "Number of steps",
          propName: "gridSteps",
          value: o.gridSteps,
          setState: i
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Number of random folds to employ in cross validation",
        propName: "fold",
        autoselect: !0,
        options: l3,
        value: o.fold,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Number of repetitions of 10-fold cross validation",
        propName: "cvRepetitions",
        autoselect: !0,
        options: l3,
        value: o.cvRepetitions,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Number of repetitions of data for cross validation:",
        propName: "minCVData",
        autoselect: !0,
        options: l3,
        value: o.minCVData,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Noise level for Cyclops screen output",
        propName: "noiseLevel",
        options: Rm,
        value: o.noiseLevel,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Reset all coefficients to 0 between model fits under cross-validation",
        propName: "resetCoefficients",
        value: o.resetCoefficients,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Starting variance for auto-search cross-validation",
        description: "-1 = use estimate based on data",
        propName: "startingVariance",
        autoselect: !0,
        options: Nm,
        value: o.startingVariance,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Use the Karush-Kuhn-Tucker conditions to limit search",
        propName: "useKKTSwindle",
        value: o.useKKTSwindle,
        setState: i,
        labelSize: 8
      }
    ) }),
    o.useKKTSwindle && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Size multiplier for active set",
        propName: "tuneSwindle",
        autoselect: !0,
        options: l3,
        value: o.tuneSwindle,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Name of exchangeable sampling unit. Option byPid selects entire strata.",
        description: "Option byRow selects single rows. If set to auto, byRow will be used for all models except conditional models where the average number of rows per stratum is smaller than the number of strata.",
        propName: "selectorType",
        options: Fm,
        value: o.selectorType,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Initial bound",
        propName: "initialBound",
        autoselect: !0,
        options: l3,
        value: o.initialBound,
        setState: i,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Max bound count",
        propName: "maxBoundCount",
        autoselect: !0,
        options: l3,
        value: o.maxBoundCount,
        setState: i,
        labelSize: 8
      }
    ) })
  ] });
};
var _3 = /* @__PURE__ */ ((n) => (n.NONE = "none", n.HIERARCHICAL = "hierarchical", n.LAPLACE = "laplace", n.NORMAL = "normal", n))(_3 || {});
const Dm = [
  {
    value: _3.NONE,
    name: "none"
  },
  {
    value: _3.HIERARCHICAL,
    name: "hierarchical"
  },
  {
    value: _3.LAPLACE,
    name: "laplace"
  },
  {
    value: _3.NORMAL,
    name: "normal"
  }
], Yo = (n) => {
  const { values: o, onChange: a } = n, i = (l) => {
    a((c) => ({ ...c, prior: l(c.prior) }));
  };
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Specify the prior distribution",
        propName: "priorType",
        options: Dm,
        value: o.priorType,
        setState: i
      }
    ) }),
    o.priorType === _3.HIERARCHICAL && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "Child-to-parent mapping for a hierarchical prior",
        propName: "graph",
        value: o.graph,
        setState: i
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Perform cross-validation to determine prior-variance",
        propName: "useCrossValidation",
        value: o.useCrossValidation,
        setState: i
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Force intercept coefficient into prior",
        propName: "forceIntercept",
        value: o.forceIntercept,
        setState: i
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "Specify the prior distribution variance",
        propName: "variance",
        value: o.variance,
        setState: i
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "Specify a vector of numbers or covariate Ids to exclude from prior",
        propName: "exclude",
        value: o.exclude,
        setState: i
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "A list of first-order neighborhoods for a partially fused prior",
        propName: "neighborhood",
        value: o.neighborhood,
        setState: i
      }
    ) })
  ] });
};
var Ct = /* @__PURE__ */ ((n) => (n.NONE = "none", n.MATCH_ON_PS = "matchOnPs", n.STRATIFY_BY_PS = "stratifyByPs", n))(Ct || {});
const Lm = [
  {
    value: Ct.NONE,
    name: "none"
  },
  {
    value: Ct.MATCH_ON_PS,
    name: "match on propensity score"
  },
  {
    value: Ct.STRATIFY_BY_PS,
    name: "stratify on propensity score"
  }
];
var jt = /* @__PURE__ */ ((n) => (n.NONE = "none", n.BY_PERCENT = "byPercent", n.BY_EQUIPOISE = "toEquipoise", n))(jt || {});
const Mm = [
  {
    value: jt.NONE,
    name: "none"
  },
  {
    value: jt.BY_PERCENT,
    name: "by percent"
  },
  {
    value: jt.BY_EQUIPOISE,
    name: "by equipoise"
  }
];
var N4 = /* @__PURE__ */ ((n) => (n.STANDARDIZED_LOGIT = "standardized logit", n.STANDARDIZED = "standardized", n.PROPENSITY_SCORE = "propensity score", n))(N4 || {});
const km = [
  {
    value: N4.STANDARDIZED_LOGIT,
    name: "standardized logit"
  },
  {
    value: N4.STANDARDIZED,
    name: "standardized"
  },
  {
    value: N4.PROPENSITY_SCORE,
    name: "propensity score"
  }
];
var F4 = /* @__PURE__ */ ((n) => (n.ALL = "all", n.TARGET = "target", n.COMPARATOR = "comparator", n))(F4 || {});
const zm = [
  {
    value: F4.ALL,
    name: "all"
  },
  {
    value: F4.TARGET,
    name: "target"
  },
  {
    value: F4.COMPARATOR,
    name: "comparator"
  }
], Bm = [
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  },
  {
    value: 105e3,
    name: "105000"
  },
  {
    value: 25e4,
    name: "250000"
  }
], $m = (n) => {
  const { values: o, onChange: a } = n;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "How do you want to trim your cohorts based on the propensity score distribution?",
        propName: "trimSelection",
        options: Mm,
        value: o.trimSelection,
        setState: a
      }
    ) }),
    o.trimSelection === jt.BY_PERCENT && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "Trim Fraction (1-100%)",
        propName: "trimFraction",
        value: o.trimFraction,
        setState: a
      }
    ) }),
    o.trimSelection === jt.BY_EQUIPOISE && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      lt,
      {
        textLabel: "Specify the lower and upper bound on the preference score for keeping persons (specify as: min %, max %, eg: 25,75)",
        propName: "bounds",
        value: o.bounds,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Do you want to perform matching or stratification?",
        propName: "matchStratifySelection",
        options: Lm,
        value: o.matchStratifySelection,
        setState: a
      }
    ) }),
    o.matchStratifySelection === Ct.MATCH_ON_PS && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "What is the maximum number of persons in the comparator arm to be matched to each person in the target arm within the defined caliper? (0 = means no maximum - all comparators will be assigned to a target person):",
          propName: "maxRatio",
          autoselect: !0,
          options: l3,
          value: o.maxRatio,
          setState: a
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        lt,
        {
          textLabel: "What is the caliper for matching:",
          propName: "caliper",
          value: o.caliper,
          setState: a
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "What is the caliper scale:",
          propName: "caliperScale",
          options: km,
          value: o.caliperScale,
          setState: a
        }
      ) })
    ] }),
    o.matchStratifySelection === Ct.STRATIFY_BY_PS && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "Into how many strata should the propensity score be divided?",
          description: "The boundaries of the strata are automatically defined to contain equal numbers of target persons",
          propName: "numberOfStrata",
          autoselect: !0,
          options: l3,
          value: o.numberOfStrata,
          setState: a
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "What is the base selection of subjects where the strata bounds are to be determined?",
          description: "Strata are defined as equally-sized strata inside this selection.",
          options: zm,
          value: o.baseSelection,
          setState: a,
          propName: "baseSelection"
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "What is the maximum number of people to include in the propensity score model when fitting?",
        description: "Setting this number to 0 means no down-sampling will be applied",
        propName: "maxCohortSizeForFitting",
        autoselect: !0,
        options: Bm,
        value: o.maxCohortSizeForFitting,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Test each covariate for correlation with the target assignment? ",
        description: "If any covariate has an unusually high correlation (either positive or negative), this will throw an error.",
        propName: "errorOnHighCorrelation",
        value: o.errorOnHighCorrelation,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Use regularization when fitting the propensity model?",
        propName: "useRegularization",
        value: o.useRegularization,
        setState: a
      }
    ) }),
    o.useRegularization && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, pr: 1, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Control settings",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            Ko,
            {
              values: o.control,
              onChange: a
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, pl: 1, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Prior",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            Yo,
            {
              values: o.prior,
              onChange: a
            }
          )
        }
      ) })
    ] })
  ] });
};
var Et = /* @__PURE__ */ ((n) => (n.LOGISTIC_REGRESSION = "logistic", n.POISSON_REGRESSION = "poisson", n.COX = "cox", n.SURVIVAL = "survival", n))(Et || {});
const qo = {
  [Et.LOGISTIC_REGRESSION]: {
    value: Et.LOGISTIC_REGRESSION,
    name: "logistic regression"
  },
  [Et.POISSON_REGRESSION]: {
    value: Et.POISSON_REGRESSION,
    name: "poisson regression"
  },
  [Et.COX]: {
    value: Et.COX,
    name: "cox proportional hazards"
  }
}, Wm = Object.values(qo), Hm = (n) => {
  const { values: o, onChange: a } = n;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "Specify the statistical model used to estimate the risk of outcome between target and comparator cohorts",
        propName: "modelType",
        options: Wm,
        value: o.modelType,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Should the regression be conditioned on the strata defined in the population object?",
        description: "(e.g. by matching or stratifying on propensity scores)",
        propName: "stratified",
        value: o.stratified,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Should the covariates also be included in the outcome model?",
        propName: "useCovariates",
        value: o.useCovariates,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Use inverse probability of treatment weighting?",
        propName: "inversePtWeighting",
        value: o.inversePtWeighting,
        setState: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Use regularization when fitting the outcome model?",
        propName: "useRegularization",
        value: o.useRegularization,
        setState: a
      }
    ) }),
    o.useRegularization && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, pr: 1, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Control settings",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            Ko,
            {
              values: o.control,
              onChange: a
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, pl: 1, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Prior",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            Yo,
            {
              values: o.prior,
              onChange: a
            }
          )
        }
      ) })
    ] })
  ] });
};
var o2 = /* @__PURE__ */ ((n) => (n.ALL = "all", n.FIRST = "first", n))(o2 || {});
const Vm = (n) => {
  var u, d, f;
  const o = Yt(
    n == null ? void 0 : n.conceptSetCrossReference,
    (b) => `${b.targetName}.${b.propertyName}.${b.targetIndex}`
  ), a = "negativeControlOutcomes.outcomeId", i = "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes.includedCovariateConceptIds", l = "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes.excludedCovariateConceptIds", c = n == null ? void 0 : n.cohortDefinitions, p = n == null ? void 0 : n.conceptSets;
  return ((f = (d = (u = n.estimationAnalysisSettings) == null ? void 0 : u.analysisSpecification) == null ? void 0 : d.targetComparatorOutcomes) == null ? void 0 : f.map(
    (b, C) => ({
      ...b,
      targetCohort: c.find(
        (v) => v.versionId === b.targetId
      ),
      comparatorCohort: c.find(
        (v) => v.versionId === b.comparatorId
      ),
      outcomeCohorts: c.filter(
        (v) => b.outcomeIds.includes(v.versionId)
      ),
      negativeControlConceptSet: D4(
        p,
        o[`${a}.${C}`]
      ),
      includedCovariateConceptSet: D4(
        p,
        o[`${i}.${C}`]
      ),
      excludedCovariateConceptSet: D4(
        p,
        o[`${l}.${C}`]
      )
    })
  )) || [];
}, Um = (n) => ({
  studyStartDate: (n == null ? void 0 : n.getDbCohortMethodDataArgs.studyStartDate) || null,
  studyEndDate: (n == null ? void 0 : n.getDbCohortMethodDataArgs.studyEndDate) || null,
  restrictToCommonPeriod: (n == null ? void 0 : n.getDbCohortMethodDataArgs.restrictToCommonPeriod) || !1,
  firstExposureOnly: (n == null ? void 0 : n.getDbCohortMethodDataArgs.firstExposureOnly) || !1,
  washoutPeriod: (n == null ? void 0 : n.getDbCohortMethodDataArgs.washoutPeriod) || 0,
  removeDuplicateSubjects: (n == null ? void 0 : n.getDbCohortMethodDataArgs.removeDuplicateSubjects) || P4.KEEP_ALL,
  censorAtNewRiskWindow: (n == null ? void 0 : n.createStudyPopArgs.censorAtNewRiskWindow) || !1,
  removeSubjectsWithPriorOutcome: (n == null ? void 0 : n.createStudyPopArgs.removeSubjectsWithPriorOutcome) || !1,
  priorOutcomeLookback: (n == null ? void 0 : n.createStudyPopArgs.priorOutcomeLookback) === 0 ? 0 : (n == null ? void 0 : n.createStudyPopArgs.priorOutcomeLookback) || 99999,
  maxCohortSize: (n == null ? void 0 : n.getDbCohortMethodDataArgs.maxCohortSize) || 0
}), Gm = (n, o) => ({
  getDbCohortMethodDataArgs: {
    studyStartDate: n.studyStartDate,
    studyEndDate: n.studyEndDate,
    restrictToCommonPeriod: n.restrictToCommonPeriod,
    firstExposureOnly: n.firstExposureOnly,
    washoutPeriod: n.washoutPeriod,
    removeDuplicateSubjects: n.removeDuplicateSubjects,
    maxCohortSize: n.maxCohortSize,
    covariateSettings: o
  },
  createStudyPopArgs: {
    censorAtNewRiskWindow: n.censorAtNewRiskWindow,
    removeSubjectsWithPriorOutcome: n.removeSubjectsWithPriorOutcome,
    priorOutcomeLookback: n.priorOutcomeLookback
  }
}), D4 = (n, o) => n.find((a) => a.id === (o == null ? void 0 : o.conceptSetId)), Km = (n) => {
  var p, g, u;
  const o = Yt(
    n == null ? void 0 : n.conceptSetCrossReference,
    (d) => `${d.targetName}.${d.propertyName}.${d.targetIndex}`
  ), a = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings.includedCovariateConceptIds", i = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings.excludedCovariateConceptIds", l = n == null ? void 0 : n.conceptSets;
  return ((u = (g = (p = n.estimationAnalysisSettings) == null ? void 0 : p.analysisSpecification) == null ? void 0 : g.cohortMethodAnalysisList) == null ? void 0 : u.map(
    (d, f) => ({
      ...d,
      // studyPopulation: mapStudyPopulationSection(analysis),
      covariateSettingsConcepts: {
        includedCovariateConceptSet: D4(
          l,
          o[`${a}.${f}`]
        ),
        excludedCovariateConceptSet: D4(
          l,
          o[`${i}.${f}`]
        )
      }
      // timeAtRisk: populateTimeAtRisk(analysis),
      // scoreAdjustment: populateScoreAdjustment(analysis),
      // outcomeModel: populateOutcomeModel(analysis),
    })
  )) || [];
}, Xo = (n = {}) => ({
  maxIterations: 1e3,
  tolerance: 1e-6,
  convergenceType: O4.GRADIENT,
  cvType: B4.AUTO,
  fold: 10,
  cvRepetitions: 10,
  minCVData: 10,
  noiseLevel: I4.SILENT,
  resetCoefficients: !1,
  startingVariance: (n == null ? void 0 : n.startingVariance) || 0.01,
  useKKTSwindle: !1,
  tuneSwindle: 10,
  selectorType: R4.AUTO,
  initialBound: 2,
  maxBoundCount: 5,
  // some unused stuff
  lowerLimit: 0.01,
  upperLimit: 20,
  gridSteps: 10,
  threads: 1,
  seed: 1,
  autoSearch: !0,
  algorithm: "ccd",
  ...n
}), Zo = (n = {}) => {
  var o, a, i;
  return {
    priorType: _3.HIERARCHICAL,
    graph: void 0,
    useCrossValidation: !0,
    forceIntercept: !1,
    ...n,
    exclude: (o = n == null ? void 0 : n.exclude) == null ? void 0 : o.toString(),
    neighborhood: (a = n == null ? void 0 : n.neighborhood) == null ? void 0 : a.toString(),
    variance: (i = n == null ? void 0 : n.variance) == null ? void 0 : i.toString()
  };
}, Ym = (n) => {
  var i, l, c, p;
  let o = jt.NONE, a = Ct.STRATIFY_BY_PS;
  return n != null && n.trimByPs ? o = jt.BY_PERCENT : n != null && n.trimByPsToEquipoise && (o = jt.BY_EQUIPOISE), n != null && n.matchOnPs ? a = Ct.MATCH_ON_PS : n != null && n.stratifyByPs && (a = Ct.STRATIFY_BY_PS), {
    trimSelection: o,
    matchStratifySelection: a,
    trimFraction: (n == null ? void 0 : n.trimByPsArgs.trimFraction) * 100 || 5,
    bounds: ((l = (i = n == null ? void 0 : n.trimByPsToEquipoiseArgs) == null ? void 0 : i.bounds) == null ? void 0 : l.map((g) => g * 100).toString()) || "25,75",
    maxRatio: (n == null ? void 0 : n.matchOnPsArgs.maxRatio) || 1,
    caliper: (n == null ? void 0 : n.matchOnPsArgs.caliper) || 0.2,
    caliperScale: (n == null ? void 0 : n.matchOnPsArgs.caliperScale) || N4.STANDARDIZED_LOGIT,
    numberOfStrata: (n == null ? void 0 : n.stratifyByPsArgs.numberOfStrata) || 5,
    baseSelection: (n == null ? void 0 : n.stratifyByPsArgs.baseSelection) || F4.ALL,
    maxCohortSizeForFitting: (n == null ? void 0 : n.createPsArgs.maxCohortSizeForFitting) || 25e4,
    errorOnHighCorrelation: n4(
      n == null ? void 0 : n.createPsArgs.errorOnHighCorrelation
    ) ? n == null ? void 0 : n.createPsArgs.errorOnHighCorrelation : !0,
    useRegularization: n4(n == null ? void 0 : n.createPsArgs.stopOnError) ? n == null ? void 0 : n.createPsArgs.stopOnError : !0,
    control: Xo((c = n == null ? void 0 : n.createPsArgs) == null ? void 0 : c.control),
    prior: Zo((p = n == null ? void 0 : n.createPsArgs) == null ? void 0 : p.prior)
  };
}, qm = (n) => {
  var o, a, i, l, c, p, g;
  return {
    trimByPs: n.trimSelection === jt.BY_PERCENT,
    trimByPsToEquipoise: n.trimSelection === jt.BY_EQUIPOISE,
    matchOnPs: (n == null ? void 0 : n.matchStratifySelection) === Ct.MATCH_ON_PS,
    stratifyByPs: (n == null ? void 0 : n.matchStratifySelection) === Ct.STRATIFY_BY_PS,
    trimByPsArgs: {
      trimFraction: n.trimFraction / 100
    },
    trimByPsToEquipoiseArgs: {
      bounds: (o = n.bounds.split(",")) == null ? void 0 : o.map((u) => u / 100)
    },
    matchOnPsArgs: {
      maxRatio: n.maxRatio,
      caliper: n.caliper,
      caliperScale: n.caliperScale
    },
    stratifyByPsArgs: {
      numberOfStrata: n.numberOfStrata,
      baseSelection: n.baseSelection
    },
    createPsArgs: {
      maxCohortSizeForFitting: n.maxCohortSizeForFitting,
      errorOnHighCorrelation: n.errorOnHighCorrelation,
      stopOnError: n.stopOnError,
      control: n.control,
      prior: {
        ...n.prior,
        exclude: (i = (a = n == null ? void 0 : n.prior) == null ? void 0 : a.exclude) == null ? void 0 : i.split(","),
        neighborhood: (c = (l = n == null ? void 0 : n.prior) == null ? void 0 : l.neighborhood) == null ? void 0 : c.split(","),
        variance: (g = (p = n == null ? void 0 : n.prior) == null ? void 0 : p.variance) == null ? void 0 : g.split(",")
      }
    }
  };
}, Xm = (n) => {
  var o, a, i, l, c, p, g;
  return {
    modelType: ((o = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : o.modelType) || Et.COX,
    stratified: n4((a = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : a.stratified) ? (i = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : i.stratified : !0,
    useCovariates: ((l = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : l.useCovariates) || !1,
    inversePtWeighting: ((c = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : c.inversePtWeighting) || !1,
    useRegularization: n4(n == null ? void 0 : n.fitOutcomeModel) ? n == null ? void 0 : n.fitOutcomeModel : !0,
    control: Xo((p = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : p.control),
    prior: Zo((g = n == null ? void 0 : n.fitOutcomeModelArgs) == null ? void 0 : g.prior)
  };
}, Zm = (n) => {
  var o, a, i, l, c, p;
  return {
    fitOutcomeModelArgs: {
      modelType: n.modelType,
      stratified: n.stratified,
      useCovariates: n.useCovariates,
      inversePtWeighting: n.inversePtWeighting,
      fitOutcomeModel: n.useRegularization,
      control: n.control,
      prior: {
        ...n.prior,
        exclude: (a = (o = n == null ? void 0 : n.prior) == null ? void 0 : o.exclude) == null ? void 0 : a.split(","),
        neighborhood: (l = (i = n == null ? void 0 : n.prior) == null ? void 0 : i.neighborhood) == null ? void 0 : l.split(","),
        variance: (p = (c = n == null ? void 0 : n.prior) == null ? void 0 : c.variance) == null ? void 0 : p.split(",")
      }
    }
  };
}, Jm = (n) => [
  {
    propertyName: "excludedCovariateConceptIds",
    cs: n.excludedCovariateConceptSet,
    targetName: "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes"
  },
  {
    propertyName: "includedCovariateConceptIds",
    cs: n.includedCovariateConceptSet,
    targetName: "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes"
  },
  {
    propertyName: "outcomeId",
    cs: n.negativeControlConceptSet,
    targetName: "negativeControlOutcomes"
  }
], Qm = (n) => {
  const o = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings";
  return [
    {
      propertyName: "excludedCovariateConceptIds",
      cs: n.covariateSettingsConcepts.excludedCovariateConceptSet,
      targetName: o
    },
    {
      propertyName: "includedCovariateConceptIds",
      cs: n.covariateSettingsConcepts.includedCovariateConceptSet,
      targetName: o
    }
  ];
}, f8 = (n, o) => {
  let a = [], i = [];
  return n.forEach((l, c) => {
    o(l).forEach((g) => {
      var u;
      (u = g.cs) != null && u.id && (a.push({
        conceptSetId: g.cs.id,
        propertyName: g.propertyName,
        targetIndex: c,
        targetName: g.targetName
      }), i.push(g.cs));
    });
  }), i = z4(i, "id"), { csRefs: a, conceptSets: i };
}, x8 = (n, o) => {
  const a = f8(
    n,
    Qm
  ), i = f8(
    o,
    Jm
  );
  return {
    conceptSetCrossReference: [
      ...a.csRefs,
      ...i.csRefs
    ],
    conceptSets: [
      ...a.conceptSets,
      ...i.conceptSets
    ]
  };
}, eh = (n) => {
  const o = [];
  return n.forEach((a) => {
    a.comparatorCohort && o.push(a.comparatorCohort), a.targetCohort && o.push(a.targetCohort), a.outcomeCohorts.forEach((i) => {
      o.push(i);
    });
  }), z4(o, "id");
}, th = (n) => {
  const {
    riskWindowStart: o,
    addExposureDaysToStart: a,
    riskWindowEnd: i,
    addExposureDaysToEnd: l,
    minDaysAtRisk: c
  } = (n == null ? void 0 : n.createStudyPopArgs) || {};
  return {
    riskWindowStart: o || 0,
    addExposureDaysToStart: n4(a) ? a : !1,
    riskWindowEnd: i || 0,
    addExposureDaysToEnd: n4(l) ? l : !0,
    minDaysAtRisk: c || 0
  };
}, nh = (n, o) => ({
  ...n,
  createStudyPopArgs: {
    ...n.createStudyPopArgs,
    riskWindowStart: o.riskWindowStart,
    addExposureDaysToStart: o.addExposureDaysToStart,
    riskWindowEnd: o.riskWindowEnd,
    addExposureDaysToEnd: o.addExposureDaysToEnd,
    minDaysAtRisk: o.minDaysAtRisk
  }
}), zy = () => ({}), By = (n, o) => ({
  ...o,
  name: o.title || o.name,
  type: n.type
}), rh = (n) => n || {
  attr_class: "covariateSettings",
  temporal: !1,
  DemographicsGender: !0,
  DemographicsAge: !1,
  DemographicsAgeGroup: !0,
  DemographicsRace: !0,
  DemographicsEthnicity: !0,
  DemographicsIndexYear: !0,
  DemographicsIndexMonth: !0,
  DemographicsPriorObservationTime: !1,
  DemographicsPostObservationTime: !1,
  DemographicsTimeInCohort: !1,
  DemographicsIndexYearMonth: !1,
  ConditionOccurrenceAnyTimePrior: !1,
  ConditionOccurrenceLongTerm: !1,
  ConditionOccurrenceMediumTerm: !1,
  ConditionOccurrenceShortTerm: !1,
  ConditionOccurrencePrimaryInpatientAnyTimePrior: !1,
  ConditionOccurrencePrimaryInpatientLongTerm: !1,
  ConditionOccurrencePrimaryInpatientMediumTerm: !1,
  ConditionOccurrencePrimaryInpatientShortTerm: !1,
  ConditionEraAnyTimePrior: !1,
  ConditionEraLongTerm: !1,
  ConditionEraMediumTerm: !1,
  ConditionEraShortTerm: !1,
  ConditionEraOverlapping: !1,
  ConditionEraStartLongTerm: !1,
  ConditionEraStartMediumTerm: !1,
  ConditionEraStartShortTerm: !1,
  ConditionGroupEraAnyTimePrior: !1,
  ConditionGroupEraLongTerm: !0,
  ConditionGroupEraMediumTerm: !1,
  ConditionGroupEraShortTerm: !0,
  ConditionGroupEraOverlapping: !1,
  ConditionGroupEraStartLongTerm: !1,
  ConditionGroupEraStartMediumTerm: !1,
  ConditionGroupEraStartShortTerm: !1,
  DrugExposureAnyTimePrior: !1,
  DrugExposureLongTerm: !1,
  DrugExposureMediumTerm: !1,
  DrugExposureShortTerm: !1,
  DrugEraAnyTimePrior: !1,
  DrugEraLongTerm: !1,
  DrugEraMediumTerm: !1,
  DrugEraShortTerm: !1,
  DrugEraOverlapping: !1,
  DrugEraStartLongTerm: !1,
  DrugEraStartMediumTerm: !1,
  DrugEraStartShortTerm: !1,
  DrugGroupEraAnyTimePrior: !1,
  DrugGroupEraLongTerm: !0,
  DrugGroupEraMediumTerm: !1,
  DrugGroupEraShortTerm: !0,
  DrugGroupEraOverlapping: !0,
  DrugGroupEraStartLongTerm: !1,
  DrugGroupEraStartMediumTerm: !1,
  DrugGroupEraStartShortTerm: !1,
  ProcedureOccurrenceAnyTimePrior: !1,
  ProcedureOccurrenceLongTerm: !0,
  ProcedureOccurrenceMediumTerm: !1,
  ProcedureOccurrenceShortTerm: !0,
  DeviceExposureAnyTimePrior: !1,
  DeviceExposureLongTerm: !0,
  DeviceExposureMediumTerm: !1,
  DeviceExposureShortTerm: !0,
  MeasurementAnyTimePrior: !1,
  MeasurementLongTerm: !0,
  MeasurementMediumTerm: !1,
  MeasurementShortTerm: !0,
  MeasurementValueAnyTimePrior: !1,
  MeasurementValueLongTerm: !1,
  MeasurementValueMediumTerm: !1,
  MeasurementValueShortTerm: !1,
  MeasurementRangeGroupAnyTimePrior: !1,
  MeasurementRangeGroupLongTerm: !0,
  MeasurementRangeGroupMediumTerm: !1,
  MeasurementRangeGroupShortTerm: !1,
  ObservationAnyTimePrior: !1,
  ObservationLongTerm: !0,
  ObservationMediumTerm: !1,
  ObservationShortTerm: !0,
  CharlsonIndex: !0,
  Dcsi: !0,
  Chads2: !0,
  Chads2Vasc: !0,
  DistinctConditionCountLongTerm: !1,
  DistinctConditionCountMediumTerm: !1,
  DistinctConditionCountShortTerm: !1,
  DistinctIngredientCountLongTerm: !1,
  DistinctIngredientCountMediumTerm: !1,
  DistinctIngredientCountShortTerm: !1,
  DistinctProcedureCountLongTerm: !1,
  DistinctProcedureCountMediumTerm: !1,
  DistinctProcedureCountShortTerm: !1,
  DistinctMeasurementCountLongTerm: !1,
  DistinctMeasurementCountMediumTerm: !1,
  DistinctMeasurementCountShortTerm: !1,
  DistinctObservationCountLongTerm: !1,
  DistinctObservationCountMediumTerm: !1,
  DistinctObservationCountShortTerm: !1,
  VisitCountLongTerm: !1,
  VisitCountMediumTerm: !1,
  VisitCountShortTerm: !1,
  VisitConceptCountLongTerm: !1,
  VisitConceptCountMediumTerm: !1,
  VisitConceptCountShortTerm: !1,
  longTermStartDays: -365,
  mediumTermStartDays: -180,
  shortTermStartDays: -30,
  endDays: 0,
  addDescendantsToInclude: !1,
  addDescendantsToExclude: !1,
  attr_fun: "getDbDefaultCovariateData",
  includedCovariateConceptIds: [],
  excludedCovariateConceptIds: [],
  includedCovariateIds: []
}, oh = (n) => [
  {
    Header: "Domain",
    rowSpan: 2,
    columns: [{ Header: "", invisible: !0, accessor: "domain" }]
  },
  {
    Header: "Any Time Prior",
    rowSpan: 2,
    align: "center",
    accessor: "EraAnyTimePrior",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraAnyTimePrior",
        accessor: "EraAnyTimePrior.value",
        Cell: l1
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Long Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.longTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraLongTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraLongTerm",
        accessor: "EraLongTerm.value",
        Cell: l1
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Medium Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.mediumTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraMediumTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraMediumTerm",
        accessor: "EraMediumTerm.value",
        Cell: l1
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Short Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.shortTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraShortTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraShortTerm",
        accessor: "EraShortTerm.value",
        Cell: l1
      }
    ]
  },
  {
    Header: "Overlapping",
    rowSpan: 2,
    accessor: "EraOverlapping",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraOverlapping",
        accessor: "EraOverlapping.value",
        Cell: l1
      }
    ]
  },
  {
    Header: "Era Start",
    colSpan: 3,
    align: "center",
    disableSortBy: !0,
    columns: [
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Long Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.longTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartLongTerm",
        accessor: "EraStartLongTerm.value",
        Cell: l1
      },
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Medium Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.mediumTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartMediumTerm",
        accessor: "EraStartMediumTerm.value",
        Cell: l1
      },
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Short Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.shortTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartShortTerm",
        accessor: "EraStartShortTerm.value",
        Cell: l1
      }
    ]
  }
], ah = [
  "EraAnyTimePrior",
  "EraLongTerm",
  "EraMediumTerm",
  "EraShortTerm",
  "EraOverlapping",
  "EraStartLongTerm",
  "EraStartMediumTerm",
  "EraStartShortTerm"
], ih = [
  { name: "Condition", value: "Condition" },
  { name: "Condition Group", value: "ConditionGroup" },
  { name: "Drug", value: "Drug" },
  { name: "Drug Group", value: "DrugGroup" }
], sh = (n) => {
  let o = [];
  for (const a of ih) {
    const i = {
      domain: a.name
    };
    for (const l of ah)
      for (const [c, p] of Object.entries(n || {}))
        c === a.value + l && (i[l] = { value: p, id: c });
    o.push(i);
  }
  return o;
}, lh = [
  { Header: "", align: "center", accessor: "demographics" },
  {
    Header: "Gender",
    align: "center",
    accessor: "DemographicsGender",
    Cell: l1
  },
  {
    Header: "Age",
    align: "center",
    accessor: "DemographicsAge",
    Cell: l1
  },
  {
    Header: "Age Groups",
    align: "center",
    accessor: "DemographicsAgeGroup",
    Cell: l1
  },
  {
    Header: "Race",
    align: "center",
    accessor: "DemographicsRace",
    Cell: l1
  },
  {
    Header: "Ethnicity",
    align: "center",
    accessor: "DemographicsEthnicity",
    Cell: l1
  },
  {
    Header: "Index Year",
    align: "center",
    accessor: "DemographicsIndexYear",
    Cell: l1
  },
  {
    Header: "Index Month",
    align: "center",
    accessor: "DemographicsIndexMonth",
    Cell: l1
  },
  {
    Header: "Prior Observation Time",
    align: "center",
    accessor: "DemographicsPriorObservationTime",
    Cell: l1
  },
  {
    Header: "Post Observation Time",
    align: "center",
    accessor: "DemographicsPostObservationTime",
    Cell: l1
  },
  {
    Header: "Time In Cohort",
    align: "center",
    accessor: "DemographicsTimeInCohort",
    Cell: l1
  },
  {
    Header: "Index Year & Month",
    align: "center",
    accessor: "DemographicsIndexYearMonth",
    Cell: l1
  }
], ch = {
  demographics: "Demographics"
}, uh = [
  { Header: "", align: "center", accessor: "timeWindows" },
  {
    Header: "Any Time Prior",
    align: "center",
    accessor: "allTime"
  },
  {
    Header: "Long Term",
    align: "center",
    accessor: "longTermStartDays",
    Cell: Bn
  },
  {
    Header: "Medium Term",
    align: "center",
    accessor: "mediumTermStartDays",
    Cell: Bn
  },
  {
    Header: "Short Term",
    align: "center",
    accessor: "shortTermStartDays",
    Cell: Bn
  },
  {
    Header: "End Days",
    align: "center",
    accessor: "endDays",
    Cell: Bn
  }
], Br = {
  timeWindows: "Time Windows",
  allTime: "All Time",
  longTermStartDays: -365,
  mediumTermStartDays: -180,
  shortTermStartDays: -30,
  endDays: 0
}, dh = (n) => [
  {
    Header: "Domain",
    disableSortBy: !0,
    rowSpan: 2,
    columns: [{ Header: "", invisible: !0, accessor: "domain" }]
  },
  {
    Header: "Any Time Prior",
    disableSortBy: !0,
    rowSpan: 2,
    align: "center",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "AnyTimePrior",
        accessor: "AnyTimePrior.value",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Long Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.longTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "longTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "LongTerm.value",
        id: "LongTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Medium Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.mediumTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "mediumTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "MediumTerm.value",
        id: "MediumTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { children: "Short Term" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "(",
        n.shortTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "shortTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "ShortTerm.value",
        id: "ShortTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      }
    ]
  },
  {
    Header: "Distinct Count",
    disableSortBy: !0,
    colSpan: 3,
    align: "center",
    columns: [
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Long Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.longTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountLongTerm.value",
        id: "CountLongTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      },
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Medium Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.mediumTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountMediumTerm.value",
        id: "CountMediumTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      },
      {
        Header: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { children: "Short Term" }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "(",
            n.shortTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountShortTerm.value",
        id: "CountShortTerm",
        Cell: (o) => o.value != null && /* @__PURE__ */ e.jsx(l1, { ...o })
      }
    ]
  }
], ph = [
  "AnyTimePrior",
  "LongTerm",
  "MediumTerm",
  "ShortTerm",
  "CountLongTerm",
  "CountMediumTerm",
  "CountShortTerm"
], mh = [
  {
    name: "Condition",
    value: "ConditionOccurrence",
    distinctValue: "DistinctCondition"
  },
  {
    name: "Condition - Primary Inpatient",
    value: "ConditionOccurrencePrimaryInpatient"
  },
  { name: "Drug", value: "DrugExposure", distinctValue: "DistinctIngredient" },
  {
    name: "Procedure",
    value: "ProcedureOccurrence",
    distinctValue: "DistinctProcedure"
  },
  {
    name: "Measurement",
    value: "Measurement",
    distinctValue: "DistinctMeasurement"
  },
  {
    name: "Measurement - Value",
    value: "MeasurementValue"
  },
  {
    name: "Measurement - Range Group",
    value: "MeasurementRangeGroup"
  },
  {
    name: "Observation",
    value: "Observation",
    distinctValue: "DistinctObservation"
  },
  {
    name: "Device",
    value: "DeviceExposure"
  },
  {
    name: "Visit - Count",
    value: "VisitCount"
  },
  {
    name: "Visit - Concept Count",
    value: "VisitConceptCount"
  }
], hh = (n) => {
  let o = [];
  for (const a of mh) {
    const i = {
      domain: a.name
    };
    for (const l of ph)
      for (const [c, p] of Object.entries(n || {}))
        (c === a.value + l || a.distinctValue && c === a.distinctValue + l) && (i[l] = { value: p, id: c });
    o.push(i);
  }
  return o;
}, fh = [
  {
    Header: "Index Score Type",
    accessor: "name",
    Cell: (n) => /* @__PURE__ */ e.jsx(e.Fragment, { children: n.value })
  },
  {
    Header: "",
    id: "item",
    accessor: "item.value",
    align: "center",
    Cell: l1
  }
], xh = (n) => [
  {
    name: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      "CHADS",
      /* @__PURE__ */ e.jsx("sub", { children: "2" })
    ] }),
    item: {
      id: "Chads2",
      value: n.Chads2
    }
  },
  {
    name: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      "CHA",
      /* @__PURE__ */ e.jsx("sub", { children: "2" }),
      "DS",
      /* @__PURE__ */ e.jsx("sub", { children: "2" }),
      "VASc"
    ] }),
    item: {
      id: "Chads2Vasc",
      value: n.Chads2Vasc
    }
  },
  {
    name: "DCSI",
    item: {
      id: "Dcsi",
      value: n.Dcsi
    }
  },
  {
    name: "Charlson",
    item: {
      id: "CharlsonIndex",
      value: n.CharlsonIndex
    }
  }
], Jo = ({ onClose: n, covariateSettings: o, onChange: a }) => {
  const i = sh(o), l = hh(o), c = xh(o);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(so, { children: /* @__PURE__ */ e.jsxs(
      y,
      {
        container: !0,
        py: 2,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "h2", children: "Select Covariates..." }) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsxs(
            Ye,
            {
              onClick: () => {
                n();
              },
              variant: "text",
              color: "info",
              name: "add",
              children: [
                "<",
                " Back to Analysis settings"
              ]
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, px: 6, py: 2, children: /* @__PURE__ */ e.jsx(
      Gt,
      {
        elevation: 0,
        sx: {
          p: 2,
          "th, td": {
            //   whiteSpace: 'break-spaces',
            border: "1px solid",
            borderColor: "borderColor.light"
          }
        },
        children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            At,
            {
              data: [{ ...ch, ...o }],
              columns: lh,
              onEdit: (p) => a((g) => ({ ...g, [p.columnId]: p.value }))
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(ce, { variant: "h2", children: "Time bound covariates" }) }),
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(ce, { variant: "h3", children: "Set the time windows for the time bound covariates in days relative to the cohort index" }) }),
            /* @__PURE__ */ e.jsx(
              At,
              {
                data: [{ ...Br, ...o }],
                columns: uh,
                onEdit: (p) => a((g) => ({ ...g, [p.columnId]: p.value }))
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(ce, { variant: "h3", children: "Set the time bound era covariates" }) }),
            /* @__PURE__ */ e.jsx(
              At,
              {
                data: i,
                columns: oh({
                  ...Br,
                  ...o
                }),
                onEdit: (p) => {
                  const g = p.row[p.columnId];
                  a((u) => ({
                    ...u,
                    [g.id]: p.value
                  }));
                }
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(ce, { variant: "h3", children: "Set the time bound covariates" }) }),
            /* @__PURE__ */ e.jsx(
              At,
              {
                data: l,
                columns: dh({
                  ...Br,
                  ...o
                }),
                pageSize: l == null ? void 0 : l.length,
                onEdit: (p) => {
                  const g = p.row[p.columnId];
                  a((u) => ({
                    ...u,
                    [g.id]: p.value
                  }));
                }
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 6, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(ce, { variant: "h3", children: "Set the index score covariates" }) }),
            /* @__PURE__ */ e.jsx(
              At,
              {
                data: c,
                columns: fh,
                onEdit: (p) => {
                  const g = p.row[p.columnId];
                  a((u) => ({
                    ...u,
                    [g.id]: p.value
                  }));
                }
              }
            )
          ] })
        ] })
      }
    ) })
  ] });
}, gh = ze(
  (n) => {
    var F, M, K, J;
    const { activeItem: o, designProps: a, onClose: i, onChange: l } = n, { typeContainer: c, id: p, parentId: g, subModules: u, analysisName: d, viewMode: f } = a, [b, C] = pe(!1), [v, A] = pe(
      (F = o.value) == null ? void 0 : F.description
    ), [P, T] = pe(
      Um(o.value)
    ), [I, w] = pe((M = o.value) == null ? void 0 : M.covariateSettingsConcepts), [N, E] = pe(
      th(o.value)
    ), [x, m] = pe(
      Ym(o.value)
    ), [j, _] = pe(
      Xm(o.value)
    ), [z, Y] = pe(
      rh(
        (J = (K = o.value) == null ? void 0 : K.getDbCohortMethodDataArgs) == null ? void 0 : J.covariateSettings
      )
    ), W = (q) => (B) => {
      const [k] = B.map((H) => ({
        id: yo(),
        name: H.name,
        description: H.description,
        expression: { items: H.items },
        type: "by_value"
      }));
      w((H) => ({
        ...H,
        [q]: k
      }));
    }, D = () => {
      const { excludedCovariateConceptSet: q, includedCovariateConceptSet: B } = I, k = {
        excludedCovariateConceptIds: q ? [q.id] : [],
        includedCovariateConceptIds: B ? [B.id] : []
      }, H = {
        ...nh(
          Gm(P, {
            ...z,
            ...k
          }),
          N
        ),
        ...qm(x),
        ...Zm(j),
        description: v
      };
      l(
        { ...o.value, ...H, covariateSettingsConcepts: I },
        o.index
      ), i();
    };
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, py: 2, px: 6, minHeight: "100%", children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(tt, { name: "description", textLabel: "Analysis name", children: /* @__PURE__ */ e.jsx(
          et,
          {
            id: "description",
            name: "description",
            type: "text",
            size: "medium",
            placeholder: "Enter",
            fullWidth: !0,
            value: v,
            onChange: (q) => {
              A(q.target.value);
            }
          }
        ) }) }) }) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            collapsible: !0,
            title: "Study Population",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ e.jsx(
              Em,
              {
                values: P,
                onChange: T
              }
            )
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            collapsible: !0,
            title: "Covariate Settings",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", children: [
                "Using OHDSI covariates for propensity score model.",
                " ",
                /* @__PURE__ */ e.jsx(
                  ce,
                  {
                    onClick: (q) => {
                      q.preventDefault(), C(!0);
                    },
                    component: "a",
                    sx: {
                      fontSize: 12,
                      color: "info.main",
                      fontWeight: 500,
                      cursor: "pointer"
                    },
                    children: "(Click to view details)"
                  }
                )
              ] }) }),
              /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
                /* @__PURE__ */ e.jsx(
                  _4,
                  {
                    subModules: u,
                    viewMode: f,
                    id: p,
                    parentId: g,
                    typeContainer: c,
                    initialData: [
                      I == null ? void 0 : I.includedCovariateConceptSet
                    ],
                    analysisName: d,
                    buttonText: "Import include concept set",
                    titleText: "Concepts to include when constructing the covariates to be used in this study. *",
                    description: "(Leave blank if you want to include every concept).",
                    onChange: W("includedCovariateConceptSet")
                  }
                ),
                /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Comparisons section." })
              ] }),
              /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(M1, { sx: { my: 2, borderColor: "borderColor.light" } }) }),
              /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
                /* @__PURE__ */ e.jsx(
                  _4,
                  {
                    subModules: u,
                    viewMode: f,
                    id: p,
                    parentId: g,
                    typeContainer: c,
                    initialData: [
                      I == null ? void 0 : I.excludedCovariateConceptSet
                    ],
                    analysisName: d,
                    titleText: "Concepts to exclude when constructing the covariates to be used in this study.*",
                    buttonText: "Import exclude concept set",
                    onChange: W("excludedCovariateConceptSet")
                  }
                ),
                /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Comparisons section." })
              ] })
            ] })
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            collapsible: !0,
            title: "Time At Risk",
            outlined: !0,
            elevated: !0,
            children: /* @__PURE__ */ e.jsx(
              Am,
              {
                values: N,
                onChange: E
              }
            )
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            collapsible: !0,
            title: "Propensity Score Adjustment",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ e.jsx(
              $m,
              {
                values: x,
                onChange: m
              }
            )
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            collapsible: !0,
            title: "Outcome Model",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ e.jsx(
              Hm,
              {
                values: j,
                onChange: _
              }
            )
          }
        ) })
      ] }) }),
      /* @__PURE__ */ e.jsx(
        Go,
        {
          submitButtonText: "Save analysis settings",
          onSubmit: D,
          onCancel: i
        }
      ),
      /* @__PURE__ */ e.jsx(
        m5,
        {
          open: b,
          onClose: () => {
            C(!1);
          },
          width: "90%",
          children: /* @__PURE__ */ e.jsx(
            Jo,
            {
              onClose: () => C(!1),
              covariateSettings: z || {},
              onChange: Y
            }
          )
        }
      )
    ] });
  }
), yh = [
  {
    value: o2.ALL,
    name: "all occurrence"
  },
  {
    value: o2.FIRST,
    name: "first occurrence"
  }
], vh = [
  { name: "Condition", value: "condition" },
  { name: "Drug", value: "drug" },
  { name: "Device", value: "device" },
  { name: "Measurement", value: "measurement" },
  { name: "Observation", value: "observation" },
  { name: "Procedure", value: "procedure" },
  { name: "Visit", value: "visit" }
], bh = (n) => {
  const { values: o, onChange: a } = n, [i, l] = pe(
    o || {
      occurrenceType: void 0,
      detectOnDescendants: !1,
      domains: []
    }
  );
  return m1(() => {
    a({
      negativeControlOutcomeCohortDefinition: i
    });
  }, [i]), /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: `This expression will define the criteria for inclusion and duration of time for cohorts intended for use as negative control outcomes.
          The type of occurrence of the event when selecting from the domain.`,
        propName: "occurrenceType",
        options: yh,
        value: i.occurrenceType,
        setState: l
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "When true, descendant concepts for the negative control outcome concept IDs will be used to detect the outcome and roll up the occurrence to the concept ID",
        propName: "detectOnDescendants",
        value: i.detectOnDescendants,
        setState: l
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      e1,
      {
        textLabel: "What domains should be considered to detect negative control outcomes?",
        propName: "domains",
        options: vh,
        cropItems: !0,
        value: i.domains,
        setState: l,
        multiple: !0
      }
    ) })
  ] });
}, Ch = [
  {
    value: Et.POISSON_REGRESSION,
    name: "Poisson"
  },
  {
    value: Et.SURVIVAL,
    name: "Survival"
  }
], jh = [
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  },
  {
    value: 105e3,
    name: "105000"
  },
  {
    value: 2e5,
    name: "200000"
  },
  {
    value: 25e4,
    name: "250000"
  }
], g8 = [
  {
    value: 100,
    name: "100"
  },
  {
    value: 75,
    name: "75"
  },
  {
    value: 50,
    name: "50"
  },
  {
    value: 25,
    name: "25"
  },
  {
    value: 10,
    name: "10"
  }
], Sh = (n) => {
  var d;
  const { values: o, onChange: a } = n, [i, l] = pe(
    { ...o, effectSizes: (d = o == null ? void 0 : o.effectSizes) == null ? void 0 : d.toString() }
    // || {
    //   doPositiveControlSynthesis: false,
    //   modelType: undefined,
    //   riskWindowStart: 0,
    //   addExposureDaysToStart: false,
    //   riskWindowEnd: 60,
    //   addExposureDaysToEnd: true,
    //   washoutPeriod: undefined,
    //   firstExposureOnly: false,
    //   firstOutcomeOnly: false,
    //   removePeopleWithPriorOutcomes: false,
    //   maxSubjectsForModel: undefined,
    //   effectSizes: undefined,
    //   precision: undefined,
    //   outputIdOffset: undefined,
    //   minOutcomeCountForModel: undefined,
    //   minOutcomeCountForInjection: undefined,
    // }
  ), [c, p] = pe(
    o.covariateSettings
  ), [g, u] = pe(!1);
  return m1(() => {
    var f;
    a({
      doPositiveControlSynthesis: i.doPositiveControlSynthesis,
      positiveControlSynthesisArgs: {
        modelType: i.modelType,
        riskWindowStart: i.riskWindowStart,
        addExposureDaysToStart: i.addExposureDaysToStart,
        riskWindowEnd: i.riskWindowEnd,
        addExposureDaysToEnd: i.addExposureDaysToEnd,
        washoutPeriod: i.washoutPeriod,
        firstExposureOnly: i.firstExposureOnly,
        firstOutcomeOnly: i.firstOutcomeOnly,
        removePeopleWithPriorOutcomes: i.removePeopleWithPriorOutcomes,
        maxSubjectsForModel: i.maxSubjectsForModel,
        effectSizes: (f = i == null ? void 0 : i.effectSizes) == null ? void 0 : f.split(","),
        precision: i.precision,
        outputIdOffset: i.outputIdOffset,
        minOutcomeCountForModel: i.minOutcomeCountForModel,
        minOutcomeCountForInjection: i.minOutcomeCountForInjection,
        prior: i.prior,
        covariateSettings: c,
        control: i.control
      }
    });
  }, [i, c]), /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      O1,
      {
        textLabel: "Should we perform positive control synthesis? ",
        description: "(to calibrate confidence intervals)",
        propName: "doPositiveControlSynthesis",
        value: i.doPositiveControlSynthesis,
        setState: l
      }
    ) }),
    i.doPositiveControlSynthesis && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "Model Type",
          propName: "modelType",
          options: Ch,
          value: i.modelType,
          setState: l
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", children: [
        "Using OHDSI covariates for propensity score model.",
        " ",
        /* @__PURE__ */ e.jsx(
          ce,
          {
            onClick: (f) => {
              f.preventDefault(), u(!0);
            },
            component: "a",
            sx: {
              fontSize: 12,
              color: "info.main",
              fontWeight: 500,
              cursor: "pointer"
            },
            children: "(Click to view details)"
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        s5,
        {
          textLabel: "Define the time-at-risk window start, relative to target/comparator cohort entry",
          propNameRisk: "riskWindowStart",
          valueRisk: i.riskWindowStart,
          optionsRisk: d3,
          propNameTime: "addExposureDaysToStart",
          valueTime: i.addExposureDaysToStart,
          optionsTime: l5,
          setState: l,
          customTime: /* @__PURE__ */ e.jsx(y, { item: !0, px: 1, fontSize: 12, children: "days from cohort start date" })
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        s5,
        {
          textLabel: "Define the time-at-risk window end",
          propNameRisk: "riskWindowEnd",
          valueRisk: i.riskWindowEnd,
          optionsRisk: d3,
          propNameTime: "addExposureDaysToEnd",
          valueTime: i.addExposureDaysToEnd,
          optionsTime: l5,
          setState: l
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        e1,
        {
          textLabel: "The minimum required continuous observation time (in days) prior to exposure:",
          propName: "washoutPeriod",
          options: d3,
          autoselect: !0,
          value: i.washoutPeriod,
          setState: l
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        O1,
        {
          textLabel: "Should only the first exposure per subject be included?",
          propName: "firstExposureOnly",
          value: i.firstExposureOnly,
          setState: l
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        O1,
        {
          textLabel: "Should only the first exposure per subject be included?",
          propName: "firstOutcomeOnly",
          value: i.firstOutcomeOnly,
          setState: l
        }
      ) }),
      /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
        /* @__PURE__ */ e.jsx(
          O1,
          {
            textLabel: "Remove people with prior outcomes?",
            propName: "removePeopleWithPriorOutcomes",
            value: i.removePeopleWithPriorOutcomes,
            setState: l
          }
        ),
        /* @__PURE__ */ e.jsx(M1, { sx: { m: 1 } })
      ] }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, pt: 2, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Additional settings",
          defaultState: !1,
          isDark: !0,
          children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              e1,
              {
                textLabel: "Maximum number of people used to fit an outcome model",
                propName: "maxSubjectsForModel",
                options: jh,
                autoselect: !0,
                value: i.maxSubjectsForModel,
                setState: l
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              lt,
              {
                textLabel: "What effect sizes should be inserted",
                propName: "effectSizes",
                value: i.effectSizes,
                setState: l
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              lt,
              {
                textLabel: "The allowed ratio between target and injected signal size",
                propName: "precision",
                value: i.precision,
                setState: l
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              lt,
              {
                textLabel: "What should be the first new outcome ID that is to be created",
                propName: "outputIdOffset",
                value: i.outputIdOffset,
                setState: l
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              e1,
              {
                textLabel: "Minimum number of outcome events required to build a model",
                propName: "minOutcomeCountForModel",
                options: g8,
                autoselect: !0,
                value: i.minOutcomeCountForModel,
                setState: l
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              e1,
              {
                textLabel: "Minimum number of outcome events required to inject a signal",
                propName: "minOutcomeCountForInjection",
                options: g8,
                autoselect: !0,
                value: i.minOutcomeCountForInjection,
                setState: l
              }
            ) })
          ] })
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      m5,
      {
        open: g,
        onClose: () => {
          u(!1);
        },
        width: "90%",
        children: /* @__PURE__ */ e.jsx(
          Jo,
          {
            onClose: () => u(!1),
            covariateSettings: c || {},
            onChange: p
          }
        )
      }
    )
  ] });
}, wh = (n) => {
  const { values: o, onChange: a } = n;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(ce, { variant: "h3", sx: { px: 1 }, children: "Negative Control Outcome Cohort Definition" }),
      /* @__PURE__ */ e.jsx(
        bh,
        {
          values: o.negativeControlOutcomeCohortDefinition,
          onChange: a
        }
      ),
      /* @__PURE__ */ e.jsx(M1, { sx: { m: 1 } })
    ] }),
    /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(ce, { variant: "h3", sx: { px: 1 }, children: "Positive Control Synthesis" }),
      /* @__PURE__ */ e.jsx(
        Sh,
        {
          values: {
            ...o.positiveControlSynthesisArgs,
            doPositiveControlSynthesis: o.doPositiveControlSynthesis
          },
          onChange: a
        }
      )
    ] })
  ] });
}, Th = (n, o) => [
  {
    Header: "Desciption",
    accessor: "description"
  },
  {
    Header: "Time at risk start",
    accessor: (a) => {
      var i;
      return `${((i = a.createStudyPopArgs) == null ? void 0 : i.riskWindowStart) || 0}d from ${r2[`${a.createStudyPopArgs.addExposureDaysToStart}`].name}`;
    }
  },
  {
    Header: "Time at risk end",
    accessor: (a) => {
      var i;
      return `${((i = a.createStudyPopArgs) == null ? void 0 : i.riskWindowEnd) || 0}d from ${r2[`${a.createStudyPopArgs.addExposureDaysToEnd}`].name}`;
    }
  },
  {
    Header: "Minimum time at risk",
    accessor: (a) => (a.createStudyPopArgs.minDaysAtRisk || 0) + "d"
  },
  {
    Header: "Adjustment strategy",
    accessor: (a) => {
      const { matchOnPs: i, stratifyByPs: l, matchOnPsArgs: c, stratifyByPsArgs: p } = a;
      return i ? `${c.maxRatio}:1 matching` : l ? `Stratification (stratum: ${p.numberOfStrata})` : "None";
    }
  },
  {
    Header: "Outcome Model",
    accessor: (a) => {
      var i;
      return ((i = qo[a.fitOutcomeModelArgs.modelType]) == null ? void 0 : i.name) || "";
    }
  },
  ...o ? [] : [
    {
      Header: "",
      accessor: "actions",
      isCropped: !0,
      disableSortBy: !0,
      maxWidth: 100,
      Cell: (a) => /* @__PURE__ */ e.jsx(
        lo,
        {
          onRemove: () => {
            n(a.row);
          }
        }
      )
    }
  ]
], Eh = (n) => {
  const { data: o, onRowClick: a, onRemoveRow: i, viewMode: l } = n;
  return /* @__PURE__ */ e.jsx(
    At,
    {
      columns: Th(i, l),
      data: o,
      loadingMessage: "",
      enableSorting: !0,
      enablePagination: !0,
      totalElements: o.length,
      onRowClick: (c) => {
        a(c.original, c.index);
      }
    }
  );
}, Ah = (n, o) => [
  {
    Header: "Target",
    accessor: "targetCohort.name",
    width: "22%",
    maxWidth: 240
  },
  {
    Header: "Comparator",
    accessor: "comparatorCohort.name",
    width: "22%",
    maxWidth: 240
  },
  {
    Header: "Outcomes",
    accessor: (a) => {
      var i;
      return (i = a.outcomeCohorts) == null ? void 0 : i.map((l) => l.name);
    },
    Cell: Cd,
    width: "22%",
    isCropped: !0,
    disableSortBy: !0
  },
  {
    Header: "NC Outcomes",
    accessor: "negativeControlConceptSet.name",
    width: "22%",
    maxWidth: 240
  },
  ...o ? [] : [
    {
      Header: "",
      accessor: "actions",
      isCropped: !0,
      disableSortBy: !0,
      maxWidth: 100,
      Cell: (a) => /* @__PURE__ */ e.jsx(
        lo,
        {
          onRemove: () => {
            n(a.row);
          }
        }
      )
    }
  ]
], _h = (n) => {
  const { data: o, onRowClick: a, onRemoveRow: i, viewMode: l } = n;
  return /* @__PURE__ */ e.jsx(
    At,
    {
      columns: Ah(i, l),
      data: o,
      loadingMessage: "",
      enableSorting: !0,
      enablePagination: !0,
      totalElements: o.length,
      onRowClick: (c) => {
        a(c.original, c.index);
      }
    }
  );
}, $y = ze(
  (n) => {
    const {
      subModules: o,
      parentId: a,
      design: i,
      reloadDesign: l,
      id: c,
      typeContainer: p,
      // setDesign,
      analysisName: g,
      viewMode: u
    } = n, [d, f] = pe(i), [b, C] = pe(
      Vm(i)
    ), [v, A] = pe(
      Km(i)
    ), [P, T] = pe(!1), [I, w] = pe(
      "COMPARISONS"
      /* COMPARISONS */
    ), [N, E] = pe({
      value: null,
      index: null
    }), x = () => {
      T(!1), w(null), E({ value: null, index: null });
    };
    return m1(() => {
      const m = x8(
        v,
        b
      );
      f({
        ...d,
        ...m,
        estimationAnalysisSettings: {
          analysisSpecification: {
            ...d.estimationAnalysisSettings.analysisSpecification,
            cohortMethodAnalysisList: v
          }
        }
      });
    }, [v]), m1(() => {
      const m = x8(
        v,
        b
      ), j = eh(b);
      f({
        ...d,
        ...m,
        cohorts: j,
        estimationAnalysisSettings: {
          analysisSpecification: {
            ...d.estimationAnalysisSettings.analysisSpecification,
            targetComparatorOutcomes: b.map((_) => ({
              comparatorId: _.comparatorId,
              targetId: _.targetId,
              outcomeIds: _.outcomeIds,
              excludedCovariateConceptIds: [],
              includedCovariateConceptIds: []
            }))
          }
        }
      });
    }, [b]), m1(() => {
      u2(d, i) || l(d);
    }, [d]), /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
      (!u || u && (b == null ? void 0 : b.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          elevated: !0,
          outlined: !0,
          title: /* @__PURE__ */ e.jsxs(
            y,
            {
              item: !0,
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                  N1,
                  {
                    title: "Comparisons",
                    count: b == null ? void 0 : b.length
                  }
                ) }),
                !u && /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                  Ye,
                  {
                    onClick: (m) => {
                      m.stopPropagation(), T(!0), w(
                        "COMPARISONS"
                        /* COMPARISONS */
                      );
                    },
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "add" }),
                    name: "add",
                    children: "Add comparisons"
                  }
                ) })
              ]
            }
          ),
          children: /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            _h,
            {
              viewMode: u,
              data: b,
              onRowClick: (m, j) => {
                E({ value: m, index: j }), T(!0), w(
                  "COMPARISONS"
                  /* COMPARISONS */
                );
              },
              onRemoveRow: (m) => {
                C((j) => {
                  const _ = [...j];
                  return _.splice(m.index, 1), _;
                });
              }
            }
          ) }) })
        }
      ) }),
      (!u || u && (v == null ? void 0 : v.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          elevated: !0,
          outlined: !0,
          collapsible: !0,
          title: /* @__PURE__ */ e.jsxs(
            y,
            {
              item: !0,
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                  N1,
                  {
                    title: "Analysis Settings",
                    count: v == null ? void 0 : v.length
                  }
                ) }),
                !u && /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                  Ye,
                  {
                    onClick: (m) => {
                      m.stopPropagation(), T(!0), w(
                        "ANALYSIS_SETTINGS"
                        /* ANALYSIS_SETTINGS */
                      );
                    },
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "add" }),
                    name: "add",
                    children: "Add analysis settings"
                  }
                ) })
              ]
            }
          ),
          children: /* @__PURE__ */ e.jsx(
            Eh,
            {
              data: v,
              viewMode: u,
              onRowClick: (m, j) => {
                E({ value: m, index: j }), T(!0), w(
                  "ANALYSIS_SETTINGS"
                  /* ANALYSIS_SETTINGS */
                );
              },
              onRemoveRow: (m) => {
                A((j) => {
                  const _ = [...j];
                  return _.splice(m.index, 1), _;
                });
              }
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: "Evaluation Settings",
          defaultState: u,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            wh,
            {
              values: {
                doPositiveControlSynthesis: d.doPositiveControlSynthesis,
                negativeControlOutcomeCohortDefinition: d.negativeControlOutcomeCohortDefinition,
                positiveControlSynthesisArgs: d.positiveControlSynthesisArgs
              },
              onChange: (m) => {
                f({
                  ...d,
                  ...m
                });
              }
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsxs(m5, { open: P, onClose: x, width: "80%", children: [
        /* @__PURE__ */ e.jsx(so, { children: /* @__PURE__ */ e.jsxs(
          y,
          {
            container: !0,
            py: 2,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsxs(ce, { variant: "h2", children: [
                I === "ANALYSIS_SETTINGS" && "Analysis settings",
                I === "COMPARISONS" && "Comparison"
              ] }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsxs(
                Ye,
                {
                  onClick: () => {
                    x();
                  },
                  variant: "text",
                  color: "info",
                  name: "add",
                  children: [
                    "<",
                    " Back to design"
                  ]
                }
              ) })
            ]
          }
        ) }),
        /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          I === "COMPARISONS" && /* @__PURE__ */ e.jsx(
            jm,
            {
              onChange: (m, j) => {
                C((_) => {
                  const z = [..._];
                  return j != null ? z.splice(j, 1, m) : z.push(m), z;
                });
              },
              onClose: x,
              activeItem: N,
              designProps: {
                subModules: o,
                analysisName: g,
                parentId: a,
                id: c,
                typeContainer: p,
                viewMode: u
              }
            }
          ),
          I === "ANALYSIS_SETTINGS" && /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
            gh,
            {
              activeItem: N,
              onClose: x,
              designProps: {
                subModules: o,
                analysisName: g,
                parentId: a,
                id: c,
                typeContainer: p
              },
              onChange: (m, j) => {
                A((_) => {
                  const z = [..._];
                  return j != null ? z.splice(j, 1, m) : z.push(m), z;
                });
              }
            }
          ) })
        ] })
      ] })
    ] });
  }
), Wy = ze((n) => /* @__PURE__ */ e.jsx(e.Fragment, { children: "results" })), Hy = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], y8 = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], v8 = [
  {
    value: n5.START_DATE,
    name: "start date"
  },
  {
    value: n5.END_DATE,
    name: "end date"
  }
];
Fe.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
Fe.div`
  padding: 10px 20px;
  font-size: 12px;
  color: #ffffff;
  font-weight: 700;
`;
Fe.div`
  padding: 10px 8px;
  font-size: 11px;
  color: #000000;
  font-weight: 500;
`;
Fe.div`
  background: #ffffff;
  padding: 5px;
`;
const Ph = Fe.div`
  /* font-size: 36px; */
  text-align: center;
  padding: 16px;
`, Oh = Fe.div``;
Fe.div`
  padding: 2px 15px;
  label {
    color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    color: #2a2a2a;
    font-weight: 500;
    display: block;
    font-size: 13px;
    margin-top: 10px;
    font-style: italic;
  }
  .MuiCheckbox-root {
    margin-right: 10px;
  }
`;
const b8 = Fe.div`
  margin-top: 20px;
  padding: 0;
  label {
    color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    color: #2a2a2a;
    font-weight: 500;
    display: block;
    font-size: 13px;
    margin-top: 4px;
    font-style: italic;
  }
  .MuiCheckbox-root {
    margin-right: 10px;
  }
`, C8 = Fe.div`
  /* background-color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.backgroundColor.main;
}}; */
  border-bottom: 1px solid
    ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.borderColor.main;
}};
  border-radius: 4px 4px 0 0;
  padding: 0 0 12px;
  h4 {
    margin: 0;
    color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    & + p {
      padding-top: 16px;
    }
  }
`, j8 = Fe.p`
  font-size: 14px;
  margin: 0;
`, Vy = ze((n) => {
  var f, b, C, v, A, P, T, I, w, N, E, x, m, j, _, z, Y, W;
  const {
    id: o,
    subModules: a,
    parentId: i,
    typeContainer: l,
    design: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n, d = (D) => (F) => {
    p(D, F);
  };
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
    (!u || u && ((f = c == null ? void 0 : c.targetCohorts) == null ? void 0 : f.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      a.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: a,
        path: L1(l, o, i),
        config: {
          buttonText: "Import target cohort",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Target cohorts",
              count: (b = c == null ? void 0 : c.targetCohorts) == null ? void 0 : b.length
            }
          ),
          typeContainer: l,
          classNameContainer: "target-import-button",
          initialData: c == null ? void 0 : c.targetCohorts,
          onChange: d("targetCohorts"),
          isSelect: !0,
          parentId: i,
          returnEntityText: g,
          collapsible: !0,
          defaultState: !0,
          viewMode: u
        }
      }
    ) }),
    (!u || u && ((C = c == null ? void 0 : c.outcomeCohorts) == null ? void 0 : C.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      a.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: a,
        path: L1(l, o, i),
        config: {
          buttonText: "Import outcome cohort",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Outcome cohorts",
              count: (v = c == null ? void 0 : c.outcomeCohorts) == null ? void 0 : v.length
            }
          ),
          classNameContainer: "outcome-import-button",
          initialData: c == null ? void 0 : c.outcomeCohorts,
          typeContainer: l,
          onChange: d("outcomeCohorts"),
          isSelect: !0,
          parentId: i,
          returnEntityText: g,
          collapsible: !0,
          defaultState: u,
          viewMode: u
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
      Ne,
      {
        collapsible: !0,
        title: "Time At Risk",
        defaultState: u,
        elevated: !0,
        outlined: !0,
        children: [
          /* @__PURE__ */ e.jsx(C8, { children: /* @__PURE__ */ e.jsx(j8, { children: "Time at risk defines the time window relative to the cohort start or end date with an offset to consider the person 'at risk' of the outcome." }) }),
          /* @__PURE__ */ e.jsxs(b8, { children: [
            /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "Time at risk starts with" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                W1,
                {
                  className: "",
                  name: "dateEdgeStart",
                  disablePortal: !0,
                  size: "small",
                  id: "dateEdgeStart",
                  options: v8,
                  value: (P = (A = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : A.start) == null ? void 0 : P.DateField,
                  placeholder: "Select date edge...",
                  onChange: (D) => {
                    p("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      start: {
                        ...c == null ? void 0 : c.timeAtRisk.start,
                        DateField: D
                      }
                    });
                  },
                  disabled: u
                }
              ) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "plus" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  name: "startOffset",
                  disablePortal: !0,
                  size: "small",
                  id: "startOffset",
                  options: y8,
                  value: (I = (T = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : T.start) == null ? void 0 : I.Offset,
                  placeholder: "Select offset...",
                  onChange: (D) => {
                    p("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      start: {
                        ...c == null ? void 0 : c.timeAtRisk.start,
                        Offset: D === "undefined" ? void 0 : D
                      }
                    });
                  },
                  disabled: u
                }
              ) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "days" }) })
            ] }),
            /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "Time at risk ends with" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                W1,
                {
                  className: "",
                  name: "dateEdgeStart",
                  disablePortal: !0,
                  size: "small",
                  id: "dateEdgeStart",
                  options: v8,
                  value: (N = (w = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : w.end) == null ? void 0 : N.DateField,
                  placeholder: "Select date edge...",
                  onChange: (D) => {
                    p("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      end: {
                        ...c == null ? void 0 : c.timeAtRisk.end,
                        DateField: D
                      }
                    });
                  },
                  disabled: u
                }
              ) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "plus" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  className: "",
                  name: "endOffset",
                  disablePortal: !0,
                  size: "small",
                  id: "endOffset",
                  options: y8,
                  value: (x = (E = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : E.end) == null ? void 0 : x.Offset,
                  placeholder: "Select offset...",
                  onChange: (D) => {
                    p("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      end: {
                        ...c == null ? void 0 : c.timeAtRisk.end,
                        Offset: D === "undefined" ? void 0 : D
                      }
                    });
                  },
                  disabled: u
                }
              ) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "days" }) })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(b8, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "Study window begins on" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
              O3,
              {
                size: "small",
                fullWidth: !1,
                value: (m = c == null ? void 0 : c.studyWindow) != null && m.startDate ? $n(
                  (j = c == null ? void 0 : c.studyWindow) == null ? void 0 : j.startDate,
                  _1.ISO_DATE,
                  _1.DATE
                ) : null,
                format: _1.DATEPICKER_DATE,
                onChange: (D) => {
                  t8(D, _1.DATE) ? p("studyWindow", {
                    ...c.studyWindow,
                    startDate: $n(
                      new Date(D).toISOString(),
                      _1.ISO_DATE_TIME,
                      _1.ISO_DATE
                    )
                  }) : p("studyWindow", {
                    ...c.studyWindow,
                    startDate: new Date(D).toString()
                  });
                },
                name: "dateAttrPickerEnd",
                disabled: u
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx("p", { children: "and ends on" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
              O3,
              {
                size: "small",
                fullWidth: !1,
                value: (_ = c == null ? void 0 : c.studyWindow) != null && _.endDate ? $n(
                  (z = c == null ? void 0 : c.studyWindow) == null ? void 0 : z.endDate,
                  _1.ISO_DATE,
                  _1.DATE
                ) : null,
                format: _1.DATEPICKER_DATE,
                onChange: (D) => {
                  t8(D, _1.DATE) ? p("studyWindow", {
                    ...c.studyWindow,
                    endDate: $n(
                      new Date(D).toISOString(),
                      _1.ISO_DATE_TIME,
                      _1.ISO_DATE
                    )
                  }) : p("studyWindow", {
                    ...c.studyWindow,
                    endDate: new Date(D).toString()
                  });
                },
                name: "dateAttrPickerEnd",
                disabled: u
              }
            ) })
          ] }) })
        ]
      }
    ) }),
    (!u || u && ((Y = c == null ? void 0 : c.strata) == null ? void 0 : Y.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
      Ne,
      {
        collapsible: !0,
        title: /* @__PURE__ */ e.jsx(
          N1,
          {
            title: "Stratify Criteria",
            count: (W = c == null ? void 0 : c.strata) == null ? void 0 : W.length
          }
        ),
        defaultState: u,
        elevated: !0,
        outlined: !0,
        children: [
          /* @__PURE__ */ e.jsx(C8, { children: /* @__PURE__ */ e.jsx(j8, { children: "You can provide optional stratification criteria to the analysis that will divide the population into unique groups based on their satisfied criteria." }) }),
          /* @__PURE__ */ e.jsx(Oh, { children: /* @__PURE__ */ e.jsx(
            a.cohort,
            {
              type: "component",
              name: "widget-criteria-group",
              subModules: a,
              config: {
                onChange: (D) => {
                  p("strata", D);
                },
                hiddenParentConcept: !0,
                typeContainer: l,
                parentId: i,
                values: (c == null ? void 0 : c.strata) || [],
                buttonText: "New stratify Criteria",
                titleText: "Stratify Criteria",
                contextConceptSets: {
                  conceptSets: c == null ? void 0 : c.conceptSets,
                  updateConceptSets: (D) => {
                    p("conceptSets", D);
                  }
                },
                viewMode: u
              }
            }
          ) })
        ]
      }
    ) })
  ] });
}), Uy = [
  {
    name: "Target Cohorts",
    value: "targetCohorts"
  },
  {
    name: "Outcome Cohorts",
    value: "outcomeCohorts"
  }
], Ih = {
  columns: [
    {
      Header: "Target Cohort",
      accessor: "targetName",
      isCropped: !0,
      maxWidth: 250
    },
    {
      Header: "Outcome Cohort",
      accessor: "outcomeName",
      isCropped: !0,
      maxWidth: 250
    },
    {
      Header: "Persons",
      accessor: "personCount",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Cases",
      accessor: "cases",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Proportion (per 1k persons)",
      accessor: "proportion",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Time at risk (years)",
      accessor: "timeAtRisk",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Rate (per 1k years)",
      accessor: "rate",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    }
  ]
}, Rh = {
  columns: [
    {
      Header: "Stratify Rule",
      accessor: "name"
    },
    {
      Header: "Persons",
      accessor: "personCount",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Cases",
      accessor: "cases",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Proportion (per 1k persons)",
      accessor: "proportion",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Time at risk (years)",
      accessor: "timeAtRisk",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    },
    {
      Header: "Rate (per 1k years)",
      accessor: "rate",
      Cell: ({ value: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n) })
    }
  ]
}, Gy = () => ({
  targetCohorts: [],
  outcomeCohorts: [],
  strata: [],
  conceptSets: [],
  // studyWindow: {
  //   endDate: null,
  //   startDate: null,
  // },
  timeAtRisk: {
    start: {
      DateField: n5.START_DATE,
      Offset: 0
    },
    end: {
      DateField: n5.END_DATE,
      Offset: 0
    }
  }
}), Ky = (n) => {
  var o, a;
  return n != null && n.summaries ? n.summaries.length > 1 ? `${oe(n == null ? void 0 : n.summaries.length)} combinations` : `${oe(((a = (o = n == null ? void 0 : n.summaries) == null ? void 0 : o[0]) == null ? void 0 : a.cases) || 0)} cases` : "0 cases";
}, Yy = (n, o) => {
  const a = vo(o.expression) ? JSON.parse(o.expression) : o.expression;
  return {
    ...o,
    type: n.type,
    expression: a
    // strataConceptSets: design.map(item => {
    //   if (item.concept.STANDARD_CONCEPT === StandardConceptTypes.NON_STANDARD) {
    //     item.hierarchy = item.includeDescendants;
    //     delete item.includeMapped;
    //     delete item.includeDescendants;
    //   }
    //   return item;
    // }),
  };
}, Nh = [
  "#0082cc",
  "#00a2d7",
  "#00c1c8",
  "#7ae59f",
  "#fefa82",
  "#ffd13c",
  "#ffa500",
  "#ff7300",
  "#fe0000"
], S8 = (n, o) => o > 0 ? (1 * n / (1 * o) * 1e3).toFixed(2) : 0 .toFixed(2);
function Fh(n, o) {
  var c, p, g;
  const a = n.stata || n.strata ? o.targetCohort && o.outcomeCohort ? (n.stata || n.strata).filter(
    (u) => u.outcomeId === o.outcomeCohort && u.targetId === o.targetCohort
  ) : n.stata || n.strata : [], i = ((c = n.summaries) == null ? void 0 : c.filter(
    (u) => u.outcomeId === o.outcomeCohort && u.targetId === o.targetCohort
  )) || [], l = (g = (p = n.treemapData) == null ? void 0 : p[o.targetCohort]) == null ? void 0 : g[o.outcomeCohort];
  return {
    strata: a,
    treemapData: l,
    summaries: i
  };
}
const Dh = ({ summary: n, filteredStrataSize: o }) => {
  var a, i;
  return /* @__PURE__ */ e.jsx(ce, { fontSize: 12, textAlign: "center", children: n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n.cases,
    " cases, ",
    n.timeAtRisk,
    " TAR, Rate: ",
    n.rate,
    " ",
    "per 1k years",
    /* @__PURE__ */ e.jsx("br", {}),
    " ",
    n.size,
    " (",
    n.percentage,
    "%) people,",
    " ",
    (a = n.passed) == null ? void 0 : a.length,
    " criteria passed,",
    " ",
    o - ((i = n.passed) == null ? void 0 : i.length),
    " ",
    "criteria failed."
  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {}) });
}, w8 = (n, o, a) => n.map((i) => ({
  value: i[o],
  name: i[a]
})), Lh = (n) => {
  const o = {
    targetCohort: null,
    outcomeCohort: null
  };
  return n.length > 0 ? {
    targetCohort: n[0].targetId,
    outcomeCohort: n[0].outcomeId
  } : o;
}, qy = ze(
  (n) => {
    var C, v, A;
    const { data: o } = n, [a, i] = pe(null), [l, c] = pe(
      Lh(o.summaries)
    ), p = je(
      () => Fh(o, l),
      [o, l]
    ), g = je(() => {
      let P = [];
      function T(w) {
        w.hasOwnProperty("timeAtRisk") && w.timeAtRisk > 0 && w.cases > 0 && P.push(w.cases / w.timeAtRisk), w.hasOwnProperty("children") && w.children.forEach(T);
      }
      p.treemapData && T(p.treemapData);
      const I = kd(P);
      return [I[0], Math.max(I[0] * 1.001, I[1])];
    }, [p]), u = je(() => {
      const P = zd().domain([g[0], g[1]]).range(Nh);
      let T = function(I) {
        return I.cases == 0 ? "#A0A8BA" : I.timeAtRisk > 0 ? P(I.cases / I.timeAtRisk) : "#bababa";
      };
      return T.scale = P, T;
    }, [g]);
    function d() {
      i(null);
    }
    je(() => "per 1k years", [g]);
    function f(P, T, I, w) {
      let N = [], E = [];
      for (let j = 0; j < P.length; j++) {
        let _ = o.strata[j];
        P[j] == "1" ? N.push(_) : E.push(_);
      }
      const x = p.summaries.find(
        (j) => j.targetId === l.targetCohort && j.outcomeId === l.outcomeCohort
      ), m = x.personCount > 0 ? T / x.personCount * 100 : 0;
      i({
        cases: I.toLocaleString(),
        timeAtRisk: w.toLocaleString(),
        rate: S8(I, w),
        size: T.toLocaleString(),
        percentage: m.toFixed(2),
        passed: N,
        failed: E
      });
    }
    function b(P, T, I) {
      if (I) {
        let w = I.data;
        f(
          w.name,
          w.size,
          w.cases,
          w.timeAtRisk
        );
      } else
        return !1;
    }
    return /* @__PURE__ */ e.jsx(y, { container: !0, children: l.targetCohort && l.outcomeCohort ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      o.summaries.length > 1 && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 2, children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 3, children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(
          tt,
          {
            name: "targetCohort",
            textLabel: "Target cohort",
            required: !0,
            children: /* @__PURE__ */ e.jsx(
              W1,
              {
                className: "",
                name: "targetCohort",
                disablePortal: !0,
                id: "targetCohort",
                options: w8(
                  z4(o.summaries, "targetId"),
                  "targetId",
                  "targetName"
                ),
                value: l.targetCohort,
                placeholder: "Select target cohort",
                onChange: (P) => {
                  c((T) => ({
                    ...T,
                    targetCohort: P
                  }));
                },
                fullWidth: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(
          tt,
          {
            name: "outcomeCohort",
            textLabel: "Outcome cohort",
            required: !0,
            children: /* @__PURE__ */ e.jsx(
              W1,
              {
                className: "",
                name: "outcomeCohort",
                disablePortal: !0,
                id: "outcomeCohort",
                options: w8(
                  z4(o.summaries, "outcomeId"),
                  "outcomeId",
                  "outcomeName"
                ),
                value: l.outcomeCohort,
                placeholder: "Select outcome cohort",
                onChange: (P) => {
                  c((T) => ({
                    ...T,
                    outcomeCohort: P
                  }));
                },
                fullWidth: !0
              }
            )
          }
        ) })
      ] }) }),
      /* @__PURE__ */ e.jsx(
        Gt,
        {
          elevation: 3,
          variant: "outlined",
          sx: (P) => ({ mb: 2, boxShadow: P.customShadows[3] }),
          children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            At,
            {
              columns: Ih.columns,
              data: p.summaries,
              totalElements: (C = p.summaries) == null ? void 0 : C.length
            }
          ) })
        }
      ),
      p.strata && p.strata.length > 0 && /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
        /* @__PURE__ */ e.jsx(
          y,
          {
            item: !0,
            boxSizing: "border-box",
            xs: 12,
            md: 5.5,
            lg: 7,
            minHeight: { xs: "auto", md: 500 },
            children: /* @__PURE__ */ e.jsx(
              Gt,
              {
                elevation: 3,
                variant: "outlined",
                sx: (P) => ({
                  width: "100%",
                  height: "100%",
                  boxShadow: P.customShadows[3]
                }),
                children: /* @__PURE__ */ e.jsx(
                  At,
                  {
                    columns: Rh.columns,
                    data: p.strata,
                    totalElements: (v = p.strata) == null ? void 0 : v.length
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          y,
          {
            item: !0,
            xs: 12,
            md: 6.5,
            lg: 5,
            height: 500,
            boxSizing: "border-box",
            children: /* @__PURE__ */ e.jsx(
              Gt,
              {
                variant: "outlined",
                sx: (P) => ({
                  height: "calc(100% - 32px)",
                  p: 2,
                  boxShadow: P.customShadows[3]
                }),
                children: o.treemapData ? [
                  /* @__PURE__ */ e.jsx(X, { height: 40, children: /* @__PURE__ */ e.jsx(
                    Dh,
                    {
                      summary: a,
                      filteredStrataSize: (A = p.strata) == null ? void 0 : A.length
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(
                    y,
                    {
                      sx: { minHeight: "calc(100% - 100px)" },
                      container: !0,
                      children: /* @__PURE__ */ e.jsx(
                        H4,
                        {
                          type: "treeMapCustom",
                          chartData: p.treemapData,
                          fileName: "any",
                          options: {
                            handleCellOver: b,
                            handleCellOut: d,
                            selectedConcepts: [],
                            colorPicker: u
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ e.jsx(X, { height: 60, pt: 2, textAlign: "center", children: /* @__PURE__ */ e.jsx(
                    jd,
                    {
                      colorPicker: u,
                      calculateRate: S8
                    }
                  ) })
                ] : /* @__PURE__ */ e.jsx(
                  ce,
                  {
                    fontSize: 14,
                    variant: "subtitle1",
                    fontWeight: 400,
                    textAlign: "center",
                    children: "No visualization available"
                  }
                )
              }
            )
          }
        )
      ] })
    ] }) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ph, { children: "No data visualization" }) }) });
  }
), T8 = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  }
], Mh = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 10,
    name: "10"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 30,
    name: "30"
  }
];
var Qo = { exports: {} };
const kh = /* @__PURE__ */ Hd(Bd);
var w4 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
w4.exports;
var E8;
function zh() {
  return E8 || (E8 = 1, function(n, o) {
    (function() {
      var a, i = "4.17.21", l = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", g = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", b = 1, C = 2, v = 4, A = 1, P = 2, T = 1, I = 2, w = 4, N = 8, E = 16, x = 32, m = 64, j = 128, _ = 256, z = 512, Y = 30, W = "...", D = 800, F = 16, M = 1, K = 2, J = 3, q = 1 / 0, B = 9007199254740991, k = 17976931348623157e292, H = NaN, re = 4294967295, te = re - 1, U = re >>> 1, me = [
        ["ary", j],
        ["bind", T],
        ["bindKey", I],
        ["curry", N],
        ["curryRight", E],
        ["flip", z],
        ["partial", x],
        ["partialRight", m],
        ["rearg", _]
      ], Q = "[object Arguments]", ge = "[object Array]", Z = "[object AsyncFunction]", fe = "[object Boolean]", Se = "[object Date]", be = "[object DOMException]", Te = "[object Error]", Pe = "[object Function]", xe = "[object GeneratorFunction]", Ie = "[object Map]", we = "[object Number]", he = "[object Null]", Oe = "[object Object]", ue = "[object Promise]", ye = "[object Proxy]", ae = "[object RegExp]", de = "[object Set]", ve = "[object String]", Ae = "[object Symbol]", Ce = "[object Undefined]", qe = "[object WeakMap]", He = "[object WeakSet]", v1 = "[object ArrayBuffer]", T1 = "[object DataView]", u1 = "[object Float32Array]", n1 = "[object Float64Array]", x1 = "[object Int8Array]", Rt = "[object Int16Array]", qt = "[object Int32Array]", Be = "[object Uint8Array]", ke = "[object Uint8ClampedArray]", Je = "[object Uint16Array]", i1 = "[object Uint32Array]", V1 = /\b__p \+= '';/g, Y1 = /\b(__p \+=) '' \+/g, N3 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, b1 = /&(?:amp|lt|gt|quot|#39);/g, q1 = /[&<>"']/g, Nt = RegExp(b1.source), k1 = RegExp(q1.source), F3 = /<%-([\s\S]+?)%>/g, f3 = /<%([\s\S]+?)%>/g, q4 = /<%=([\s\S]+?)%>/g, b5 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, D3 = /^\w*$/, C5 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, X4 = /[\\^$.*+?()[\]{}|]/g, L9 = RegExp(X4.source), j5 = /^\s+/, M9 = /\s/, k9 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, z9 = /\{\n\/\* \[wrapped with (.+)\] \*/, B9 = /,? & /, $9 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, W9 = /[()=,{}\[\]\/\s]/, H9 = /\\(\\)?/g, V9 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, w2 = /\w*$/, U9 = /^[-+]0x[0-9a-f]+$/i, G9 = /^0b[01]+$/i, K9 = /^\[object .+?Constructor\]$/, Y9 = /^0o[0-7]+$/i, q9 = /^(?:0|[1-9]\d*)$/, X9 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Z4 = /($^)/, Z9 = /['\n\r\u2028\u2029\\]/g, J4 = "\\ud800-\\udfff", J9 = "\\u0300-\\u036f", Q9 = "\\ufe20-\\ufe2f", ea = "\\u20d0-\\u20ff", T2 = J9 + Q9 + ea, E2 = "\\u2700-\\u27bf", A2 = "a-z\\xdf-\\xf6\\xf8-\\xff", ta = "\\xac\\xb1\\xd7\\xf7", na = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ra = "\\u2000-\\u206f", oa = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", _2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", P2 = "\\ufe0e\\ufe0f", O2 = ta + na + ra + oa, S5 = "['’]", aa = "[" + J4 + "]", I2 = "[" + O2 + "]", Q4 = "[" + T2 + "]", R2 = "\\d+", ia = "[" + E2 + "]", N2 = "[" + A2 + "]", F2 = "[^" + J4 + O2 + R2 + E2 + A2 + _2 + "]", w5 = "\\ud83c[\\udffb-\\udfff]", sa = "(?:" + Q4 + "|" + w5 + ")", D2 = "[^" + J4 + "]", T5 = "(?:\\ud83c[\\udde6-\\uddff]){2}", E5 = "[\\ud800-\\udbff][\\udc00-\\udfff]", L3 = "[" + _2 + "]", L2 = "\\u200d", M2 = "(?:" + N2 + "|" + F2 + ")", la = "(?:" + L3 + "|" + F2 + ")", k2 = "(?:" + S5 + "(?:d|ll|m|re|s|t|ve))?", z2 = "(?:" + S5 + "(?:D|LL|M|RE|S|T|VE))?", B2 = sa + "?", $2 = "[" + P2 + "]?", ca = "(?:" + L2 + "(?:" + [D2, T5, E5].join("|") + ")" + $2 + B2 + ")*", ua = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", da = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", W2 = $2 + B2 + ca, pa = "(?:" + [ia, T5, E5].join("|") + ")" + W2, ma = "(?:" + [D2 + Q4 + "?", Q4, T5, E5, aa].join("|") + ")", ha = RegExp(S5, "g"), fa = RegExp(Q4, "g"), A5 = RegExp(w5 + "(?=" + w5 + ")|" + ma + W2, "g"), xa = RegExp([
        L3 + "?" + N2 + "+" + k2 + "(?=" + [I2, L3, "$"].join("|") + ")",
        la + "+" + z2 + "(?=" + [I2, L3 + M2, "$"].join("|") + ")",
        L3 + "?" + M2 + "+" + k2,
        L3 + "+" + z2,
        da,
        ua,
        R2,
        pa
      ].join("|"), "g"), ga = RegExp("[" + L2 + J4 + T2 + P2 + "]"), ya = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, va = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ba = -1, d1 = {};
      d1[u1] = d1[n1] = d1[x1] = d1[Rt] = d1[qt] = d1[Be] = d1[ke] = d1[Je] = d1[i1] = !0, d1[Q] = d1[ge] = d1[v1] = d1[fe] = d1[T1] = d1[Se] = d1[Te] = d1[Pe] = d1[Ie] = d1[we] = d1[Oe] = d1[ae] = d1[de] = d1[ve] = d1[qe] = !1;
      var c1 = {};
      c1[Q] = c1[ge] = c1[v1] = c1[T1] = c1[fe] = c1[Se] = c1[u1] = c1[n1] = c1[x1] = c1[Rt] = c1[qt] = c1[Ie] = c1[we] = c1[Oe] = c1[ae] = c1[de] = c1[ve] = c1[Ae] = c1[Be] = c1[ke] = c1[Je] = c1[i1] = !0, c1[Te] = c1[Pe] = c1[qe] = !1;
      var Ca = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, ja = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Sa = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, wa = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Ta = parseFloat, Ea = parseInt, H2 = typeof X3 == "object" && X3 && X3.Object === Object && X3, Aa = typeof self == "object" && self && self.Object === Object && self, F1 = H2 || Aa || Function("return this")(), _5 = o && !o.nodeType && o, x3 = _5 && !0 && n && !n.nodeType && n, V2 = x3 && x3.exports === _5, P5 = V2 && H2.process, ct = function() {
        try {
          var V = x3 && x3.require && x3.require("util").types;
          return V || P5 && P5.binding && P5.binding("util");
        } catch {
        }
      }(), U2 = ct && ct.isArrayBuffer, G2 = ct && ct.isDate, K2 = ct && ct.isMap, Y2 = ct && ct.isRegExp, q2 = ct && ct.isSet, X2 = ct && ct.isTypedArray;
      function nt(V, ne, ee) {
        switch (ee.length) {
          case 0:
            return V.call(ne);
          case 1:
            return V.call(ne, ee[0]);
          case 2:
            return V.call(ne, ee[0], ee[1]);
          case 3:
            return V.call(ne, ee[0], ee[1], ee[2]);
        }
        return V.apply(ne, ee);
      }
      function _a(V, ne, ee, _e) {
        for (var $e = -1, r1 = V == null ? 0 : V.length; ++$e < r1; ) {
          var E1 = V[$e];
          ne(_e, E1, ee(E1), V);
        }
        return _e;
      }
      function ut(V, ne) {
        for (var ee = -1, _e = V == null ? 0 : V.length; ++ee < _e && ne(V[ee], ee, V) !== !1; )
          ;
        return V;
      }
      function Pa(V, ne) {
        for (var ee = V == null ? 0 : V.length; ee-- && ne(V[ee], ee, V) !== !1; )
          ;
        return V;
      }
      function Z2(V, ne) {
        for (var ee = -1, _e = V == null ? 0 : V.length; ++ee < _e; )
          if (!ne(V[ee], ee, V))
            return !1;
        return !0;
      }
      function Xt(V, ne) {
        for (var ee = -1, _e = V == null ? 0 : V.length, $e = 0, r1 = []; ++ee < _e; ) {
          var E1 = V[ee];
          ne(E1, ee, V) && (r1[$e++] = E1);
        }
        return r1;
      }
      function en(V, ne) {
        var ee = V == null ? 0 : V.length;
        return !!ee && M3(V, ne, 0) > -1;
      }
      function O5(V, ne, ee) {
        for (var _e = -1, $e = V == null ? 0 : V.length; ++_e < $e; )
          if (ee(ne, V[_e]))
            return !0;
        return !1;
      }
      function p1(V, ne) {
        for (var ee = -1, _e = V == null ? 0 : V.length, $e = Array(_e); ++ee < _e; )
          $e[ee] = ne(V[ee], ee, V);
        return $e;
      }
      function Zt(V, ne) {
        for (var ee = -1, _e = ne.length, $e = V.length; ++ee < _e; )
          V[$e + ee] = ne[ee];
        return V;
      }
      function I5(V, ne, ee, _e) {
        var $e = -1, r1 = V == null ? 0 : V.length;
        for (_e && r1 && (ee = V[++$e]); ++$e < r1; )
          ee = ne(ee, V[$e], $e, V);
        return ee;
      }
      function Oa(V, ne, ee, _e) {
        var $e = V == null ? 0 : V.length;
        for (_e && $e && (ee = V[--$e]); $e--; )
          ee = ne(ee, V[$e], $e, V);
        return ee;
      }
      function R5(V, ne) {
        for (var ee = -1, _e = V == null ? 0 : V.length; ++ee < _e; )
          if (ne(V[ee], ee, V))
            return !0;
        return !1;
      }
      var Ia = N5("length");
      function Ra(V) {
        return V.split("");
      }
      function Na(V) {
        return V.match($9) || [];
      }
      function J2(V, ne, ee) {
        var _e;
        return ee(V, function($e, r1, E1) {
          if (ne($e, r1, E1))
            return _e = r1, !1;
        }), _e;
      }
      function tn(V, ne, ee, _e) {
        for (var $e = V.length, r1 = ee + (_e ? 1 : -1); _e ? r1-- : ++r1 < $e; )
          if (ne(V[r1], r1, V))
            return r1;
        return -1;
      }
      function M3(V, ne, ee) {
        return ne === ne ? Ua(V, ne, ee) : tn(V, Q2, ee);
      }
      function Fa(V, ne, ee, _e) {
        for (var $e = ee - 1, r1 = V.length; ++$e < r1; )
          if (_e(V[$e], ne))
            return $e;
        return -1;
      }
      function Q2(V) {
        return V !== V;
      }
      function e6(V, ne) {
        var ee = V == null ? 0 : V.length;
        return ee ? D5(V, ne) / ee : H;
      }
      function N5(V) {
        return function(ne) {
          return ne == null ? a : ne[V];
        };
      }
      function F5(V) {
        return function(ne) {
          return V == null ? a : V[ne];
        };
      }
      function t6(V, ne, ee, _e, $e) {
        return $e(V, function(r1, E1, s1) {
          ee = _e ? (_e = !1, r1) : ne(ee, r1, E1, s1);
        }), ee;
      }
      function Da(V, ne) {
        var ee = V.length;
        for (V.sort(ne); ee--; )
          V[ee] = V[ee].value;
        return V;
      }
      function D5(V, ne) {
        for (var ee, _e = -1, $e = V.length; ++_e < $e; ) {
          var r1 = ne(V[_e]);
          r1 !== a && (ee = ee === a ? r1 : ee + r1);
        }
        return ee;
      }
      function L5(V, ne) {
        for (var ee = -1, _e = Array(V); ++ee < V; )
          _e[ee] = ne(ee);
        return _e;
      }
      function La(V, ne) {
        return p1(ne, function(ee) {
          return [ee, V[ee]];
        });
      }
      function n6(V) {
        return V && V.slice(0, i6(V) + 1).replace(j5, "");
      }
      function rt(V) {
        return function(ne) {
          return V(ne);
        };
      }
      function M5(V, ne) {
        return p1(ne, function(ee) {
          return V[ee];
        });
      }
      function o4(V, ne) {
        return V.has(ne);
      }
      function r6(V, ne) {
        for (var ee = -1, _e = V.length; ++ee < _e && M3(ne, V[ee], 0) > -1; )
          ;
        return ee;
      }
      function o6(V, ne) {
        for (var ee = V.length; ee-- && M3(ne, V[ee], 0) > -1; )
          ;
        return ee;
      }
      function Ma(V, ne) {
        for (var ee = V.length, _e = 0; ee--; )
          V[ee] === ne && ++_e;
        return _e;
      }
      var ka = F5(Ca), za = F5(ja);
      function Ba(V) {
        return "\\" + wa[V];
      }
      function $a(V, ne) {
        return V == null ? a : V[ne];
      }
      function k3(V) {
        return ga.test(V);
      }
      function Wa(V) {
        return ya.test(V);
      }
      function Ha(V) {
        for (var ne, ee = []; !(ne = V.next()).done; )
          ee.push(ne.value);
        return ee;
      }
      function k5(V) {
        var ne = -1, ee = Array(V.size);
        return V.forEach(function(_e, $e) {
          ee[++ne] = [$e, _e];
        }), ee;
      }
      function a6(V, ne) {
        return function(ee) {
          return V(ne(ee));
        };
      }
      function Jt(V, ne) {
        for (var ee = -1, _e = V.length, $e = 0, r1 = []; ++ee < _e; ) {
          var E1 = V[ee];
          (E1 === ne || E1 === f) && (V[ee] = f, r1[$e++] = ee);
        }
        return r1;
      }
      function nn(V) {
        var ne = -1, ee = Array(V.size);
        return V.forEach(function(_e) {
          ee[++ne] = _e;
        }), ee;
      }
      function Va(V) {
        var ne = -1, ee = Array(V.size);
        return V.forEach(function(_e) {
          ee[++ne] = [_e, _e];
        }), ee;
      }
      function Ua(V, ne, ee) {
        for (var _e = ee - 1, $e = V.length; ++_e < $e; )
          if (V[_e] === ne)
            return _e;
        return -1;
      }
      function Ga(V, ne, ee) {
        for (var _e = ee + 1; _e--; )
          if (V[_e] === ne)
            return _e;
        return _e;
      }
      function z3(V) {
        return k3(V) ? Ya(V) : Ia(V);
      }
      function gt(V) {
        return k3(V) ? qa(V) : Ra(V);
      }
      function i6(V) {
        for (var ne = V.length; ne-- && M9.test(V.charAt(ne)); )
          ;
        return ne;
      }
      var Ka = F5(Sa);
      function Ya(V) {
        for (var ne = A5.lastIndex = 0; A5.test(V); )
          ++ne;
        return ne;
      }
      function qa(V) {
        return V.match(A5) || [];
      }
      function Xa(V) {
        return V.match(xa) || [];
      }
      var Za = function V(ne) {
        ne = ne == null ? F1 : B3.defaults(F1.Object(), ne, B3.pick(F1, va));
        var ee = ne.Array, _e = ne.Date, $e = ne.Error, r1 = ne.Function, E1 = ne.Math, s1 = ne.Object, z5 = ne.RegExp, Ja = ne.String, dt = ne.TypeError, rn = ee.prototype, Qa = r1.prototype, $3 = s1.prototype, on = ne["__core-js_shared__"], an = Qa.toString, a1 = $3.hasOwnProperty, ei = 0, s6 = function() {
          var t = /[^.]+$/.exec(on && on.keys && on.keys.IE_PROTO || "");
          return t ? "Symbol(src)_1." + t : "";
        }(), sn = $3.toString, ti = an.call(s1), ni = F1._, ri = z5(
          "^" + an.call(a1).replace(X4, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), ln = V2 ? ne.Buffer : a, Qt = ne.Symbol, cn = ne.Uint8Array, l6 = ln ? ln.allocUnsafe : a, un = a6(s1.getPrototypeOf, s1), c6 = s1.create, u6 = $3.propertyIsEnumerable, dn = rn.splice, d6 = Qt ? Qt.isConcatSpreadable : a, a4 = Qt ? Qt.iterator : a, g3 = Qt ? Qt.toStringTag : a, pn = function() {
          try {
            var t = j3(s1, "defineProperty");
            return t({}, "", {}), t;
          } catch {
          }
        }(), oi = ne.clearTimeout !== F1.clearTimeout && ne.clearTimeout, ai = _e && _e.now !== F1.Date.now && _e.now, ii = ne.setTimeout !== F1.setTimeout && ne.setTimeout, mn = E1.ceil, hn = E1.floor, B5 = s1.getOwnPropertySymbols, si = ln ? ln.isBuffer : a, p6 = ne.isFinite, li = rn.join, ci = a6(s1.keys, s1), A1 = E1.max, z1 = E1.min, ui = _e.now, di = ne.parseInt, m6 = E1.random, pi = rn.reverse, $5 = j3(ne, "DataView"), i4 = j3(ne, "Map"), W5 = j3(ne, "Promise"), W3 = j3(ne, "Set"), s4 = j3(ne, "WeakMap"), l4 = j3(s1, "create"), fn = s4 && new s4(), H3 = {}, mi = S3($5), hi = S3(i4), fi = S3(W5), xi = S3(W3), gi = S3(s4), xn = Qt ? Qt.prototype : a, c4 = xn ? xn.valueOf : a, h6 = xn ? xn.toString : a;
        function O(t) {
          if (g1(t) && !We(t) && !(t instanceof Ze)) {
            if (t instanceof pt)
              return t;
            if (a1.call(t, "__wrapped__"))
              return f7(t);
          }
          return new pt(t);
        }
        var V3 = /* @__PURE__ */ function() {
          function t() {
          }
          return function(r) {
            if (!h1(r))
              return {};
            if (c6)
              return c6(r);
            t.prototype = r;
            var s = new t();
            return t.prototype = a, s;
          };
        }();
        function gn() {
        }
        function pt(t, r) {
          this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = a;
        }
        O.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: F3,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: f3,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: q4,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: O
          }
        }, O.prototype = gn.prototype, O.prototype.constructor = O, pt.prototype = V3(gn.prototype), pt.prototype.constructor = pt;
        function Ze(t) {
          this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = re, this.__views__ = [];
        }
        function yi() {
          var t = new Ze(this.__wrapped__);
          return t.__actions__ = X1(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = X1(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = X1(this.__views__), t;
        }
        function vi() {
          if (this.__filtered__) {
            var t = new Ze(this);
            t.__dir__ = -1, t.__filtered__ = !0;
          } else
            t = this.clone(), t.__dir__ *= -1;
          return t;
        }
        function bi() {
          var t = this.__wrapped__.value(), r = this.__dir__, s = We(t), h = r < 0, S = s ? t.length : 0, R = Rs(0, S, this.__views__), L = R.start, $ = R.end, G = $ - L, ie = h ? $ : L - 1, se = this.__iteratees__, le = se.length, Ee = 0, Re = z1(G, this.__takeCount__);
          if (!s || !h && S == G && Re == G)
            return k6(t, this.__actions__);
          var Le = [];
          e:
            for (; G-- && Ee < Re; ) {
              ie += r;
              for (var Ge = -1, Me = t[ie]; ++Ge < le; ) {
                var Xe = se[Ge], Qe = Xe.iteratee, it = Xe.type, K1 = Qe(Me);
                if (it == K)
                  Me = K1;
                else if (!K1) {
                  if (it == M)
                    continue e;
                  break e;
                }
              }
              Le[Ee++] = Me;
            }
          return Le;
        }
        Ze.prototype = V3(gn.prototype), Ze.prototype.constructor = Ze;
        function y3(t) {
          var r = -1, s = t == null ? 0 : t.length;
          for (this.clear(); ++r < s; ) {
            var h = t[r];
            this.set(h[0], h[1]);
          }
        }
        function Ci() {
          this.__data__ = l4 ? l4(null) : {}, this.size = 0;
        }
        function ji(t) {
          var r = this.has(t) && delete this.__data__[t];
          return this.size -= r ? 1 : 0, r;
        }
        function Si(t) {
          var r = this.__data__;
          if (l4) {
            var s = r[t];
            return s === u ? a : s;
          }
          return a1.call(r, t) ? r[t] : a;
        }
        function wi(t) {
          var r = this.__data__;
          return l4 ? r[t] !== a : a1.call(r, t);
        }
        function Ti(t, r) {
          var s = this.__data__;
          return this.size += this.has(t) ? 0 : 1, s[t] = l4 && r === a ? u : r, this;
        }
        y3.prototype.clear = Ci, y3.prototype.delete = ji, y3.prototype.get = Si, y3.prototype.has = wi, y3.prototype.set = Ti;
        function Ft(t) {
          var r = -1, s = t == null ? 0 : t.length;
          for (this.clear(); ++r < s; ) {
            var h = t[r];
            this.set(h[0], h[1]);
          }
        }
        function Ei() {
          this.__data__ = [], this.size = 0;
        }
        function Ai(t) {
          var r = this.__data__, s = yn(r, t);
          if (s < 0)
            return !1;
          var h = r.length - 1;
          return s == h ? r.pop() : dn.call(r, s, 1), --this.size, !0;
        }
        function _i(t) {
          var r = this.__data__, s = yn(r, t);
          return s < 0 ? a : r[s][1];
        }
        function Pi(t) {
          return yn(this.__data__, t) > -1;
        }
        function Oi(t, r) {
          var s = this.__data__, h = yn(s, t);
          return h < 0 ? (++this.size, s.push([t, r])) : s[h][1] = r, this;
        }
        Ft.prototype.clear = Ei, Ft.prototype.delete = Ai, Ft.prototype.get = _i, Ft.prototype.has = Pi, Ft.prototype.set = Oi;
        function Dt(t) {
          var r = -1, s = t == null ? 0 : t.length;
          for (this.clear(); ++r < s; ) {
            var h = t[r];
            this.set(h[0], h[1]);
          }
        }
        function Ii() {
          this.size = 0, this.__data__ = {
            hash: new y3(),
            map: new (i4 || Ft)(),
            string: new y3()
          };
        }
        function Ri(t) {
          var r = On(this, t).delete(t);
          return this.size -= r ? 1 : 0, r;
        }
        function Ni(t) {
          return On(this, t).get(t);
        }
        function Fi(t) {
          return On(this, t).has(t);
        }
        function Di(t, r) {
          var s = On(this, t), h = s.size;
          return s.set(t, r), this.size += s.size == h ? 0 : 1, this;
        }
        Dt.prototype.clear = Ii, Dt.prototype.delete = Ri, Dt.prototype.get = Ni, Dt.prototype.has = Fi, Dt.prototype.set = Di;
        function v3(t) {
          var r = -1, s = t == null ? 0 : t.length;
          for (this.__data__ = new Dt(); ++r < s; )
            this.add(t[r]);
        }
        function Li(t) {
          return this.__data__.set(t, u), this;
        }
        function Mi(t) {
          return this.__data__.has(t);
        }
        v3.prototype.add = v3.prototype.push = Li, v3.prototype.has = Mi;
        function yt(t) {
          var r = this.__data__ = new Ft(t);
          this.size = r.size;
        }
        function ki() {
          this.__data__ = new Ft(), this.size = 0;
        }
        function zi(t) {
          var r = this.__data__, s = r.delete(t);
          return this.size = r.size, s;
        }
        function Bi(t) {
          return this.__data__.get(t);
        }
        function $i(t) {
          return this.__data__.has(t);
        }
        function Wi(t, r) {
          var s = this.__data__;
          if (s instanceof Ft) {
            var h = s.__data__;
            if (!i4 || h.length < l - 1)
              return h.push([t, r]), this.size = ++s.size, this;
            s = this.__data__ = new Dt(h);
          }
          return s.set(t, r), this.size = s.size, this;
        }
        yt.prototype.clear = ki, yt.prototype.delete = zi, yt.prototype.get = Bi, yt.prototype.has = $i, yt.prototype.set = Wi;
        function f6(t, r) {
          var s = We(t), h = !s && w3(t), S = !s && !h && o3(t), R = !s && !h && !S && Y3(t), L = s || h || S || R, $ = L ? L5(t.length, Ja) : [], G = $.length;
          for (var ie in t)
            (r || a1.call(t, ie)) && !(L && // Safari 9 has enumerable `arguments.length` in strict mode.
            (ie == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            S && (ie == "offset" || ie == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            R && (ie == "buffer" || ie == "byteLength" || ie == "byteOffset") || // Skip index properties.
            zt(ie, G))) && $.push(ie);
          return $;
        }
        function x6(t) {
          var r = t.length;
          return r ? t[Q5(0, r - 1)] : a;
        }
        function Hi(t, r) {
          return In(X1(t), b3(r, 0, t.length));
        }
        function Vi(t) {
          return In(X1(t));
        }
        function H5(t, r, s) {
          (s !== a && !vt(t[r], s) || s === a && !(r in t)) && Lt(t, r, s);
        }
        function u4(t, r, s) {
          var h = t[r];
          (!(a1.call(t, r) && vt(h, s)) || s === a && !(r in t)) && Lt(t, r, s);
        }
        function yn(t, r) {
          for (var s = t.length; s--; )
            if (vt(t[s][0], r))
              return s;
          return -1;
        }
        function Ui(t, r, s, h) {
          return e3(t, function(S, R, L) {
            r(h, S, s(S), L);
          }), h;
        }
        function g6(t, r) {
          return t && wt(r, I1(r), t);
        }
        function Gi(t, r) {
          return t && wt(r, J1(r), t);
        }
        function Lt(t, r, s) {
          r == "__proto__" && pn ? pn(t, r, {
            configurable: !0,
            enumerable: !0,
            value: s,
            writable: !0
          }) : t[r] = s;
        }
        function V5(t, r) {
          for (var s = -1, h = r.length, S = ee(h), R = t == null; ++s < h; )
            S[s] = R ? a : wr(t, r[s]);
          return S;
        }
        function b3(t, r, s) {
          return t === t && (s !== a && (t = t <= s ? t : s), r !== a && (t = t >= r ? t : r)), t;
        }
        function mt(t, r, s, h, S, R) {
          var L, $ = r & b, G = r & C, ie = r & v;
          if (s && (L = S ? s(t, h, S, R) : s(t)), L !== a)
            return L;
          if (!h1(t))
            return t;
          var se = We(t);
          if (se) {
            if (L = Fs(t), !$)
              return X1(t, L);
          } else {
            var le = B1(t), Ee = le == Pe || le == xe;
            if (o3(t))
              return $6(t, $);
            if (le == Oe || le == Q || Ee && !S) {
              if (L = G || Ee ? {} : i7(t), !$)
                return G ? Ss(t, Gi(L, t)) : js(t, g6(L, t));
            } else {
              if (!c1[le])
                return S ? t : {};
              L = Ds(t, le, $);
            }
          }
          R || (R = new yt());
          var Re = R.get(t);
          if (Re)
            return Re;
          R.set(t, L), D7(t) ? t.forEach(function(Me) {
            L.add(mt(Me, r, s, Me, t, R));
          }) : N7(t) && t.forEach(function(Me, Xe) {
            L.set(Xe, mt(Me, r, s, Xe, t, R));
          });
          var Le = ie ? G ? ur : cr : G ? J1 : I1, Ge = se ? a : Le(t);
          return ut(Ge || t, function(Me, Xe) {
            Ge && (Xe = Me, Me = t[Xe]), u4(L, Xe, mt(Me, r, s, Xe, t, R));
          }), L;
        }
        function Ki(t) {
          var r = I1(t);
          return function(s) {
            return y6(s, t, r);
          };
        }
        function y6(t, r, s) {
          var h = s.length;
          if (t == null)
            return !h;
          for (t = s1(t); h--; ) {
            var S = s[h], R = r[S], L = t[S];
            if (L === a && !(S in t) || !R(L))
              return !1;
          }
          return !0;
        }
        function v6(t, r, s) {
          if (typeof t != "function")
            throw new dt(p);
          return g4(function() {
            t.apply(a, s);
          }, r);
        }
        function d4(t, r, s, h) {
          var S = -1, R = en, L = !0, $ = t.length, G = [], ie = r.length;
          if (!$)
            return G;
          s && (r = p1(r, rt(s))), h ? (R = O5, L = !1) : r.length >= l && (R = o4, L = !1, r = new v3(r));
          e:
            for (; ++S < $; ) {
              var se = t[S], le = s == null ? se : s(se);
              if (se = h || se !== 0 ? se : 0, L && le === le) {
                for (var Ee = ie; Ee--; )
                  if (r[Ee] === le)
                    continue e;
                G.push(se);
              } else R(r, le, h) || G.push(se);
            }
          return G;
        }
        var e3 = G6(St), b6 = G6(G5, !0);
        function Yi(t, r) {
          var s = !0;
          return e3(t, function(h, S, R) {
            return s = !!r(h, S, R), s;
          }), s;
        }
        function vn(t, r, s) {
          for (var h = -1, S = t.length; ++h < S; ) {
            var R = t[h], L = r(R);
            if (L != null && ($ === a ? L === L && !at(L) : s(L, $)))
              var $ = L, G = R;
          }
          return G;
        }
        function qi(t, r, s, h) {
          var S = t.length;
          for (s = Ue(s), s < 0 && (s = -s > S ? 0 : S + s), h = h === a || h > S ? S : Ue(h), h < 0 && (h += S), h = s > h ? 0 : M7(h); s < h; )
            t[s++] = r;
          return t;
        }
        function C6(t, r) {
          var s = [];
          return e3(t, function(h, S, R) {
            r(h, S, R) && s.push(h);
          }), s;
        }
        function D1(t, r, s, h, S) {
          var R = -1, L = t.length;
          for (s || (s = Ms), S || (S = []); ++R < L; ) {
            var $ = t[R];
            r > 0 && s($) ? r > 1 ? D1($, r - 1, s, h, S) : Zt(S, $) : h || (S[S.length] = $);
          }
          return S;
        }
        var U5 = K6(), j6 = K6(!0);
        function St(t, r) {
          return t && U5(t, r, I1);
        }
        function G5(t, r) {
          return t && j6(t, r, I1);
        }
        function bn(t, r) {
          return Xt(r, function(s) {
            return Bt(t[s]);
          });
        }
        function C3(t, r) {
          r = n3(r, t);
          for (var s = 0, h = r.length; t != null && s < h; )
            t = t[Tt(r[s++])];
          return s && s == h ? t : a;
        }
        function S6(t, r, s) {
          var h = r(t);
          return We(t) ? h : Zt(h, s(t));
        }
        function U1(t) {
          return t == null ? t === a ? Ce : he : g3 && g3 in s1(t) ? Is(t) : Vs(t);
        }
        function K5(t, r) {
          return t > r;
        }
        function Xi(t, r) {
          return t != null && a1.call(t, r);
        }
        function Zi(t, r) {
          return t != null && r in s1(t);
        }
        function Ji(t, r, s) {
          return t >= z1(r, s) && t < A1(r, s);
        }
        function Y5(t, r, s) {
          for (var h = s ? O5 : en, S = t[0].length, R = t.length, L = R, $ = ee(R), G = 1 / 0, ie = []; L--; ) {
            var se = t[L];
            L && r && (se = p1(se, rt(r))), G = z1(se.length, G), $[L] = !s && (r || S >= 120 && se.length >= 120) ? new v3(L && se) : a;
          }
          se = t[0];
          var le = -1, Ee = $[0];
          e:
            for (; ++le < S && ie.length < G; ) {
              var Re = se[le], Le = r ? r(Re) : Re;
              if (Re = s || Re !== 0 ? Re : 0, !(Ee ? o4(Ee, Le) : h(ie, Le, s))) {
                for (L = R; --L; ) {
                  var Ge = $[L];
                  if (!(Ge ? o4(Ge, Le) : h(t[L], Le, s)))
                    continue e;
                }
                Ee && Ee.push(Le), ie.push(Re);
              }
            }
          return ie;
        }
        function Qi(t, r, s, h) {
          return St(t, function(S, R, L) {
            r(h, s(S), R, L);
          }), h;
        }
        function p4(t, r, s) {
          r = n3(r, t), t = u7(t, r);
          var h = t == null ? t : t[Tt(ft(r))];
          return h == null ? a : nt(h, t, s);
        }
        function w6(t) {
          return g1(t) && U1(t) == Q;
        }
        function es(t) {
          return g1(t) && U1(t) == v1;
        }
        function ts(t) {
          return g1(t) && U1(t) == Se;
        }
        function m4(t, r, s, h, S) {
          return t === r ? !0 : t == null || r == null || !g1(t) && !g1(r) ? t !== t && r !== r : ns(t, r, s, h, m4, S);
        }
        function ns(t, r, s, h, S, R) {
          var L = We(t), $ = We(r), G = L ? ge : B1(t), ie = $ ? ge : B1(r);
          G = G == Q ? Oe : G, ie = ie == Q ? Oe : ie;
          var se = G == Oe, le = ie == Oe, Ee = G == ie;
          if (Ee && o3(t)) {
            if (!o3(r))
              return !1;
            L = !0, se = !1;
          }
          if (Ee && !se)
            return R || (R = new yt()), L || Y3(t) ? r7(t, r, s, h, S, R) : Ps(t, r, G, s, h, S, R);
          if (!(s & A)) {
            var Re = se && a1.call(t, "__wrapped__"), Le = le && a1.call(r, "__wrapped__");
            if (Re || Le) {
              var Ge = Re ? t.value() : t, Me = Le ? r.value() : r;
              return R || (R = new yt()), S(Ge, Me, s, h, R);
            }
          }
          return Ee ? (R || (R = new yt()), Os(t, r, s, h, S, R)) : !1;
        }
        function rs(t) {
          return g1(t) && B1(t) == Ie;
        }
        function q5(t, r, s, h) {
          var S = s.length, R = S, L = !h;
          if (t == null)
            return !R;
          for (t = s1(t); S--; ) {
            var $ = s[S];
            if (L && $[2] ? $[1] !== t[$[0]] : !($[0] in t))
              return !1;
          }
          for (; ++S < R; ) {
            $ = s[S];
            var G = $[0], ie = t[G], se = $[1];
            if (L && $[2]) {
              if (ie === a && !(G in t))
                return !1;
            } else {
              var le = new yt();
              if (h)
                var Ee = h(ie, se, G, t, r, le);
              if (!(Ee === a ? m4(se, ie, A | P, h, le) : Ee))
                return !1;
            }
          }
          return !0;
        }
        function T6(t) {
          if (!h1(t) || zs(t))
            return !1;
          var r = Bt(t) ? ri : K9;
          return r.test(S3(t));
        }
        function os(t) {
          return g1(t) && U1(t) == ae;
        }
        function as(t) {
          return g1(t) && B1(t) == de;
        }
        function is(t) {
          return g1(t) && Mn(t.length) && !!d1[U1(t)];
        }
        function E6(t) {
          return typeof t == "function" ? t : t == null ? Q1 : typeof t == "object" ? We(t) ? P6(t[0], t[1]) : _6(t) : Y7(t);
        }
        function X5(t) {
          if (!x4(t))
            return ci(t);
          var r = [];
          for (var s in s1(t))
            a1.call(t, s) && s != "constructor" && r.push(s);
          return r;
        }
        function ss(t) {
          if (!h1(t))
            return Hs(t);
          var r = x4(t), s = [];
          for (var h in t)
            h == "constructor" && (r || !a1.call(t, h)) || s.push(h);
          return s;
        }
        function Z5(t, r) {
          return t < r;
        }
        function A6(t, r) {
          var s = -1, h = Z1(t) ? ee(t.length) : [];
          return e3(t, function(S, R, L) {
            h[++s] = r(S, R, L);
          }), h;
        }
        function _6(t) {
          var r = pr(t);
          return r.length == 1 && r[0][2] ? l7(r[0][0], r[0][1]) : function(s) {
            return s === t || q5(s, t, r);
          };
        }
        function P6(t, r) {
          return hr(t) && s7(r) ? l7(Tt(t), r) : function(s) {
            var h = wr(s, t);
            return h === a && h === r ? Tr(s, t) : m4(r, h, A | P);
          };
        }
        function Cn(t, r, s, h, S) {
          t !== r && U5(r, function(R, L) {
            if (S || (S = new yt()), h1(R))
              ls(t, r, L, s, Cn, h, S);
            else {
              var $ = h ? h(xr(t, L), R, L + "", t, r, S) : a;
              $ === a && ($ = R), H5(t, L, $);
            }
          }, J1);
        }
        function ls(t, r, s, h, S, R, L) {
          var $ = xr(t, s), G = xr(r, s), ie = L.get(G);
          if (ie) {
            H5(t, s, ie);
            return;
          }
          var se = R ? R($, G, s + "", t, r, L) : a, le = se === a;
          if (le) {
            var Ee = We(G), Re = !Ee && o3(G), Le = !Ee && !Re && Y3(G);
            se = G, Ee || Re || Le ? We($) ? se = $ : C1($) ? se = X1($) : Re ? (le = !1, se = $6(G, !0)) : Le ? (le = !1, se = W6(G, !0)) : se = [] : y4(G) || w3(G) ? (se = $, w3($) ? se = k7($) : (!h1($) || Bt($)) && (se = i7(G))) : le = !1;
          }
          le && (L.set(G, se), S(se, G, h, R, L), L.delete(G)), H5(t, s, se);
        }
        function O6(t, r) {
          var s = t.length;
          if (s)
            return r += r < 0 ? s : 0, zt(r, s) ? t[r] : a;
        }
        function I6(t, r, s) {
          r.length ? r = p1(r, function(R) {
            return We(R) ? function(L) {
              return C3(L, R.length === 1 ? R[0] : R);
            } : R;
          }) : r = [Q1];
          var h = -1;
          r = p1(r, rt(De()));
          var S = A6(t, function(R, L, $) {
            var G = p1(r, function(ie) {
              return ie(R);
            });
            return { criteria: G, index: ++h, value: R };
          });
          return Da(S, function(R, L) {
            return Cs(R, L, s);
          });
        }
        function cs(t, r) {
          return R6(t, r, function(s, h) {
            return Tr(t, h);
          });
        }
        function R6(t, r, s) {
          for (var h = -1, S = r.length, R = {}; ++h < S; ) {
            var L = r[h], $ = C3(t, L);
            s($, L) && h4(R, n3(L, t), $);
          }
          return R;
        }
        function us(t) {
          return function(r) {
            return C3(r, t);
          };
        }
        function J5(t, r, s, h) {
          var S = h ? Fa : M3, R = -1, L = r.length, $ = t;
          for (t === r && (r = X1(r)), s && ($ = p1(t, rt(s))); ++R < L; )
            for (var G = 0, ie = r[R], se = s ? s(ie) : ie; (G = S($, se, G, h)) > -1; )
              $ !== t && dn.call($, G, 1), dn.call(t, G, 1);
          return t;
        }
        function N6(t, r) {
          for (var s = t ? r.length : 0, h = s - 1; s--; ) {
            var S = r[s];
            if (s == h || S !== R) {
              var R = S;
              zt(S) ? dn.call(t, S, 1) : nr(t, S);
            }
          }
          return t;
        }
        function Q5(t, r) {
          return t + hn(m6() * (r - t + 1));
        }
        function ds(t, r, s, h) {
          for (var S = -1, R = A1(mn((r - t) / (s || 1)), 0), L = ee(R); R--; )
            L[h ? R : ++S] = t, t += s;
          return L;
        }
        function er(t, r) {
          var s = "";
          if (!t || r < 1 || r > B)
            return s;
          do
            r % 2 && (s += t), r = hn(r / 2), r && (t += t);
          while (r);
          return s;
        }
        function Ke(t, r) {
          return gr(c7(t, r, Q1), t + "");
        }
        function ps(t) {
          return x6(q3(t));
        }
        function ms(t, r) {
          var s = q3(t);
          return In(s, b3(r, 0, s.length));
        }
        function h4(t, r, s, h) {
          if (!h1(t))
            return t;
          r = n3(r, t);
          for (var S = -1, R = r.length, L = R - 1, $ = t; $ != null && ++S < R; ) {
            var G = Tt(r[S]), ie = s;
            if (G === "__proto__" || G === "constructor" || G === "prototype")
              return t;
            if (S != L) {
              var se = $[G];
              ie = h ? h(se, G, $) : a, ie === a && (ie = h1(se) ? se : zt(r[S + 1]) ? [] : {});
            }
            u4($, G, ie), $ = $[G];
          }
          return t;
        }
        var F6 = fn ? function(t, r) {
          return fn.set(t, r), t;
        } : Q1, hs = pn ? function(t, r) {
          return pn(t, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Ar(r),
            writable: !0
          });
        } : Q1;
        function fs(t) {
          return In(q3(t));
        }
        function ht(t, r, s) {
          var h = -1, S = t.length;
          r < 0 && (r = -r > S ? 0 : S + r), s = s > S ? S : s, s < 0 && (s += S), S = r > s ? 0 : s - r >>> 0, r >>>= 0;
          for (var R = ee(S); ++h < S; )
            R[h] = t[h + r];
          return R;
        }
        function xs(t, r) {
          var s;
          return e3(t, function(h, S, R) {
            return s = r(h, S, R), !s;
          }), !!s;
        }
        function jn(t, r, s) {
          var h = 0, S = t == null ? h : t.length;
          if (typeof r == "number" && r === r && S <= U) {
            for (; h < S; ) {
              var R = h + S >>> 1, L = t[R];
              L !== null && !at(L) && (s ? L <= r : L < r) ? h = R + 1 : S = R;
            }
            return S;
          }
          return tr(t, r, Q1, s);
        }
        function tr(t, r, s, h) {
          var S = 0, R = t == null ? 0 : t.length;
          if (R === 0)
            return 0;
          r = s(r);
          for (var L = r !== r, $ = r === null, G = at(r), ie = r === a; S < R; ) {
            var se = hn((S + R) / 2), le = s(t[se]), Ee = le !== a, Re = le === null, Le = le === le, Ge = at(le);
            if (L)
              var Me = h || Le;
            else ie ? Me = Le && (h || Ee) : $ ? Me = Le && Ee && (h || !Re) : G ? Me = Le && Ee && !Re && (h || !Ge) : Re || Ge ? Me = !1 : Me = h ? le <= r : le < r;
            Me ? S = se + 1 : R = se;
          }
          return z1(R, te);
        }
        function D6(t, r) {
          for (var s = -1, h = t.length, S = 0, R = []; ++s < h; ) {
            var L = t[s], $ = r ? r(L) : L;
            if (!s || !vt($, G)) {
              var G = $;
              R[S++] = L === 0 ? 0 : L;
            }
          }
          return R;
        }
        function L6(t) {
          return typeof t == "number" ? t : at(t) ? H : +t;
        }
        function ot(t) {
          if (typeof t == "string")
            return t;
          if (We(t))
            return p1(t, ot) + "";
          if (at(t))
            return h6 ? h6.call(t) : "";
          var r = t + "";
          return r == "0" && 1 / t == -q ? "-0" : r;
        }
        function t3(t, r, s) {
          var h = -1, S = en, R = t.length, L = !0, $ = [], G = $;
          if (s)
            L = !1, S = O5;
          else if (R >= l) {
            var ie = r ? null : As(t);
            if (ie)
              return nn(ie);
            L = !1, S = o4, G = new v3();
          } else
            G = r ? [] : $;
          e:
            for (; ++h < R; ) {
              var se = t[h], le = r ? r(se) : se;
              if (se = s || se !== 0 ? se : 0, L && le === le) {
                for (var Ee = G.length; Ee--; )
                  if (G[Ee] === le)
                    continue e;
                r && G.push(le), $.push(se);
              } else S(G, le, s) || (G !== $ && G.push(le), $.push(se));
            }
          return $;
        }
        function nr(t, r) {
          return r = n3(r, t), t = u7(t, r), t == null || delete t[Tt(ft(r))];
        }
        function M6(t, r, s, h) {
          return h4(t, r, s(C3(t, r)), h);
        }
        function Sn(t, r, s, h) {
          for (var S = t.length, R = h ? S : -1; (h ? R-- : ++R < S) && r(t[R], R, t); )
            ;
          return s ? ht(t, h ? 0 : R, h ? R + 1 : S) : ht(t, h ? R + 1 : 0, h ? S : R);
        }
        function k6(t, r) {
          var s = t;
          return s instanceof Ze && (s = s.value()), I5(r, function(h, S) {
            return S.func.apply(S.thisArg, Zt([h], S.args));
          }, s);
        }
        function rr(t, r, s) {
          var h = t.length;
          if (h < 2)
            return h ? t3(t[0]) : [];
          for (var S = -1, R = ee(h); ++S < h; )
            for (var L = t[S], $ = -1; ++$ < h; )
              $ != S && (R[S] = d4(R[S] || L, t[$], r, s));
          return t3(D1(R, 1), r, s);
        }
        function z6(t, r, s) {
          for (var h = -1, S = t.length, R = r.length, L = {}; ++h < S; ) {
            var $ = h < R ? r[h] : a;
            s(L, t[h], $);
          }
          return L;
        }
        function or(t) {
          return C1(t) ? t : [];
        }
        function ar(t) {
          return typeof t == "function" ? t : Q1;
        }
        function n3(t, r) {
          return We(t) ? t : hr(t, r) ? [t] : h7(o1(t));
        }
        var gs = Ke;
        function r3(t, r, s) {
          var h = t.length;
          return s = s === a ? h : s, !r && s >= h ? t : ht(t, r, s);
        }
        var B6 = oi || function(t) {
          return F1.clearTimeout(t);
        };
        function $6(t, r) {
          if (r)
            return t.slice();
          var s = t.length, h = l6 ? l6(s) : new t.constructor(s);
          return t.copy(h), h;
        }
        function ir(t) {
          var r = new t.constructor(t.byteLength);
          return new cn(r).set(new cn(t)), r;
        }
        function ys(t, r) {
          var s = r ? ir(t.buffer) : t.buffer;
          return new t.constructor(s, t.byteOffset, t.byteLength);
        }
        function vs(t) {
          var r = new t.constructor(t.source, w2.exec(t));
          return r.lastIndex = t.lastIndex, r;
        }
        function bs(t) {
          return c4 ? s1(c4.call(t)) : {};
        }
        function W6(t, r) {
          var s = r ? ir(t.buffer) : t.buffer;
          return new t.constructor(s, t.byteOffset, t.length);
        }
        function H6(t, r) {
          if (t !== r) {
            var s = t !== a, h = t === null, S = t === t, R = at(t), L = r !== a, $ = r === null, G = r === r, ie = at(r);
            if (!$ && !ie && !R && t > r || R && L && G && !$ && !ie || h && L && G || !s && G || !S)
              return 1;
            if (!h && !R && !ie && t < r || ie && s && S && !h && !R || $ && s && S || !L && S || !G)
              return -1;
          }
          return 0;
        }
        function Cs(t, r, s) {
          for (var h = -1, S = t.criteria, R = r.criteria, L = S.length, $ = s.length; ++h < L; ) {
            var G = H6(S[h], R[h]);
            if (G) {
              if (h >= $)
                return G;
              var ie = s[h];
              return G * (ie == "desc" ? -1 : 1);
            }
          }
          return t.index - r.index;
        }
        function V6(t, r, s, h) {
          for (var S = -1, R = t.length, L = s.length, $ = -1, G = r.length, ie = A1(R - L, 0), se = ee(G + ie), le = !h; ++$ < G; )
            se[$] = r[$];
          for (; ++S < L; )
            (le || S < R) && (se[s[S]] = t[S]);
          for (; ie--; )
            se[$++] = t[S++];
          return se;
        }
        function U6(t, r, s, h) {
          for (var S = -1, R = t.length, L = -1, $ = s.length, G = -1, ie = r.length, se = A1(R - $, 0), le = ee(se + ie), Ee = !h; ++S < se; )
            le[S] = t[S];
          for (var Re = S; ++G < ie; )
            le[Re + G] = r[G];
          for (; ++L < $; )
            (Ee || S < R) && (le[Re + s[L]] = t[S++]);
          return le;
        }
        function X1(t, r) {
          var s = -1, h = t.length;
          for (r || (r = ee(h)); ++s < h; )
            r[s] = t[s];
          return r;
        }
        function wt(t, r, s, h) {
          var S = !s;
          s || (s = {});
          for (var R = -1, L = r.length; ++R < L; ) {
            var $ = r[R], G = h ? h(s[$], t[$], $, s, t) : a;
            G === a && (G = t[$]), S ? Lt(s, $, G) : u4(s, $, G);
          }
          return s;
        }
        function js(t, r) {
          return wt(t, mr(t), r);
        }
        function Ss(t, r) {
          return wt(t, o7(t), r);
        }
        function wn(t, r) {
          return function(s, h) {
            var S = We(s) ? _a : Ui, R = r ? r() : {};
            return S(s, t, De(h, 2), R);
          };
        }
        function U3(t) {
          return Ke(function(r, s) {
            var h = -1, S = s.length, R = S > 1 ? s[S - 1] : a, L = S > 2 ? s[2] : a;
            for (R = t.length > 3 && typeof R == "function" ? (S--, R) : a, L && G1(s[0], s[1], L) && (R = S < 3 ? a : R, S = 1), r = s1(r); ++h < S; ) {
              var $ = s[h];
              $ && t(r, $, h, R);
            }
            return r;
          });
        }
        function G6(t, r) {
          return function(s, h) {
            if (s == null)
              return s;
            if (!Z1(s))
              return t(s, h);
            for (var S = s.length, R = r ? S : -1, L = s1(s); (r ? R-- : ++R < S) && h(L[R], R, L) !== !1; )
              ;
            return s;
          };
        }
        function K6(t) {
          return function(r, s, h) {
            for (var S = -1, R = s1(r), L = h(r), $ = L.length; $--; ) {
              var G = L[t ? $ : ++S];
              if (s(R[G], G, R) === !1)
                break;
            }
            return r;
          };
        }
        function ws(t, r, s) {
          var h = r & T, S = f4(t);
          function R() {
            var L = this && this !== F1 && this instanceof R ? S : t;
            return L.apply(h ? s : this, arguments);
          }
          return R;
        }
        function Y6(t) {
          return function(r) {
            r = o1(r);
            var s = k3(r) ? gt(r) : a, h = s ? s[0] : r.charAt(0), S = s ? r3(s, 1).join("") : r.slice(1);
            return h[t]() + S;
          };
        }
        function G3(t) {
          return function(r) {
            return I5(G7(U7(r).replace(ha, "")), t, "");
          };
        }
        function f4(t) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new t();
              case 1:
                return new t(r[0]);
              case 2:
                return new t(r[0], r[1]);
              case 3:
                return new t(r[0], r[1], r[2]);
              case 4:
                return new t(r[0], r[1], r[2], r[3]);
              case 5:
                return new t(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new t(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new t(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var s = V3(t.prototype), h = t.apply(s, r);
            return h1(h) ? h : s;
          };
        }
        function Ts(t, r, s) {
          var h = f4(t);
          function S() {
            for (var R = arguments.length, L = ee(R), $ = R, G = K3(S); $--; )
              L[$] = arguments[$];
            var ie = R < 3 && L[0] !== G && L[R - 1] !== G ? [] : Jt(L, G);
            if (R -= ie.length, R < s)
              return Q6(
                t,
                r,
                Tn,
                S.placeholder,
                a,
                L,
                ie,
                a,
                a,
                s - R
              );
            var se = this && this !== F1 && this instanceof S ? h : t;
            return nt(se, this, L);
          }
          return S;
        }
        function q6(t) {
          return function(r, s, h) {
            var S = s1(r);
            if (!Z1(r)) {
              var R = De(s, 3);
              r = I1(r), s = function($) {
                return R(S[$], $, S);
              };
            }
            var L = t(r, s, h);
            return L > -1 ? S[R ? r[L] : L] : a;
          };
        }
        function X6(t) {
          return kt(function(r) {
            var s = r.length, h = s, S = pt.prototype.thru;
            for (t && r.reverse(); h--; ) {
              var R = r[h];
              if (typeof R != "function")
                throw new dt(p);
              if (S && !L && Pn(R) == "wrapper")
                var L = new pt([], !0);
            }
            for (h = L ? h : s; ++h < s; ) {
              R = r[h];
              var $ = Pn(R), G = $ == "wrapper" ? dr(R) : a;
              G && fr(G[0]) && G[1] == (j | N | x | _) && !G[4].length && G[9] == 1 ? L = L[Pn(G[0])].apply(L, G[3]) : L = R.length == 1 && fr(R) ? L[$]() : L.thru(R);
            }
            return function() {
              var ie = arguments, se = ie[0];
              if (L && ie.length == 1 && We(se))
                return L.plant(se).value();
              for (var le = 0, Ee = s ? r[le].apply(this, ie) : se; ++le < s; )
                Ee = r[le].call(this, Ee);
              return Ee;
            };
          });
        }
        function Tn(t, r, s, h, S, R, L, $, G, ie) {
          var se = r & j, le = r & T, Ee = r & I, Re = r & (N | E), Le = r & z, Ge = Ee ? a : f4(t);
          function Me() {
            for (var Xe = arguments.length, Qe = ee(Xe), it = Xe; it--; )
              Qe[it] = arguments[it];
            if (Re)
              var K1 = K3(Me), st = Ma(Qe, K1);
            if (h && (Qe = V6(Qe, h, S, Re)), R && (Qe = U6(Qe, R, L, Re)), Xe -= st, Re && Xe < ie) {
              var j1 = Jt(Qe, K1);
              return Q6(
                t,
                r,
                Tn,
                Me.placeholder,
                s,
                Qe,
                j1,
                $,
                G,
                ie - Xe
              );
            }
            var bt = le ? s : this, Wt = Ee ? bt[t] : t;
            return Xe = Qe.length, $ ? Qe = Us(Qe, $) : Le && Xe > 1 && Qe.reverse(), se && G < Xe && (Qe.length = G), this && this !== F1 && this instanceof Me && (Wt = Ge || f4(Wt)), Wt.apply(bt, Qe);
          }
          return Me;
        }
        function Z6(t, r) {
          return function(s, h) {
            return Qi(s, t, r(h), {});
          };
        }
        function En(t, r) {
          return function(s, h) {
            var S;
            if (s === a && h === a)
              return r;
            if (s !== a && (S = s), h !== a) {
              if (S === a)
                return h;
              typeof s == "string" || typeof h == "string" ? (s = ot(s), h = ot(h)) : (s = L6(s), h = L6(h)), S = t(s, h);
            }
            return S;
          };
        }
        function sr(t) {
          return kt(function(r) {
            return r = p1(r, rt(De())), Ke(function(s) {
              var h = this;
              return t(r, function(S) {
                return nt(S, h, s);
              });
            });
          });
        }
        function An(t, r) {
          r = r === a ? " " : ot(r);
          var s = r.length;
          if (s < 2)
            return s ? er(r, t) : r;
          var h = er(r, mn(t / z3(r)));
          return k3(r) ? r3(gt(h), 0, t).join("") : h.slice(0, t);
        }
        function Es(t, r, s, h) {
          var S = r & T, R = f4(t);
          function L() {
            for (var $ = -1, G = arguments.length, ie = -1, se = h.length, le = ee(se + G), Ee = this && this !== F1 && this instanceof L ? R : t; ++ie < se; )
              le[ie] = h[ie];
            for (; G--; )
              le[ie++] = arguments[++$];
            return nt(Ee, S ? s : this, le);
          }
          return L;
        }
        function J6(t) {
          return function(r, s, h) {
            return h && typeof h != "number" && G1(r, s, h) && (s = h = a), r = $t(r), s === a ? (s = r, r = 0) : s = $t(s), h = h === a ? r < s ? 1 : -1 : $t(h), ds(r, s, h, t);
          };
        }
        function _n(t) {
          return function(r, s) {
            return typeof r == "string" && typeof s == "string" || (r = xt(r), s = xt(s)), t(r, s);
          };
        }
        function Q6(t, r, s, h, S, R, L, $, G, ie) {
          var se = r & N, le = se ? L : a, Ee = se ? a : L, Re = se ? R : a, Le = se ? a : R;
          r |= se ? x : m, r &= ~(se ? m : x), r & w || (r &= -4);
          var Ge = [
            t,
            r,
            S,
            Re,
            le,
            Le,
            Ee,
            $,
            G,
            ie
          ], Me = s.apply(a, Ge);
          return fr(t) && d7(Me, Ge), Me.placeholder = h, p7(Me, t, r);
        }
        function lr(t) {
          var r = E1[t];
          return function(s, h) {
            if (s = xt(s), h = h == null ? 0 : z1(Ue(h), 292), h && p6(s)) {
              var S = (o1(s) + "e").split("e"), R = r(S[0] + "e" + (+S[1] + h));
              return S = (o1(R) + "e").split("e"), +(S[0] + "e" + (+S[1] - h));
            }
            return r(s);
          };
        }
        var As = W3 && 1 / nn(new W3([, -0]))[1] == q ? function(t) {
          return new W3(t);
        } : Or;
        function e7(t) {
          return function(r) {
            var s = B1(r);
            return s == Ie ? k5(r) : s == de ? Va(r) : La(r, t(r));
          };
        }
        function Mt(t, r, s, h, S, R, L, $) {
          var G = r & I;
          if (!G && typeof t != "function")
            throw new dt(p);
          var ie = h ? h.length : 0;
          if (ie || (r &= -97, h = S = a), L = L === a ? L : A1(Ue(L), 0), $ = $ === a ? $ : Ue($), ie -= S ? S.length : 0, r & m) {
            var se = h, le = S;
            h = S = a;
          }
          var Ee = G ? a : dr(t), Re = [
            t,
            r,
            s,
            h,
            S,
            se,
            le,
            R,
            L,
            $
          ];
          if (Ee && Ws(Re, Ee), t = Re[0], r = Re[1], s = Re[2], h = Re[3], S = Re[4], $ = Re[9] = Re[9] === a ? G ? 0 : t.length : A1(Re[9] - ie, 0), !$ && r & (N | E) && (r &= -25), !r || r == T)
            var Le = ws(t, r, s);
          else r == N || r == E ? Le = Ts(t, r, $) : (r == x || r == (T | x)) && !S.length ? Le = Es(t, r, s, h) : Le = Tn.apply(a, Re);
          var Ge = Ee ? F6 : d7;
          return p7(Ge(Le, Re), t, r);
        }
        function t7(t, r, s, h) {
          return t === a || vt(t, $3[s]) && !a1.call(h, s) ? r : t;
        }
        function n7(t, r, s, h, S, R) {
          return h1(t) && h1(r) && (R.set(r, t), Cn(t, r, a, n7, R), R.delete(r)), t;
        }
        function _s(t) {
          return y4(t) ? a : t;
        }
        function r7(t, r, s, h, S, R) {
          var L = s & A, $ = t.length, G = r.length;
          if ($ != G && !(L && G > $))
            return !1;
          var ie = R.get(t), se = R.get(r);
          if (ie && se)
            return ie == r && se == t;
          var le = -1, Ee = !0, Re = s & P ? new v3() : a;
          for (R.set(t, r), R.set(r, t); ++le < $; ) {
            var Le = t[le], Ge = r[le];
            if (h)
              var Me = L ? h(Ge, Le, le, r, t, R) : h(Le, Ge, le, t, r, R);
            if (Me !== a) {
              if (Me)
                continue;
              Ee = !1;
              break;
            }
            if (Re) {
              if (!R5(r, function(Xe, Qe) {
                if (!o4(Re, Qe) && (Le === Xe || S(Le, Xe, s, h, R)))
                  return Re.push(Qe);
              })) {
                Ee = !1;
                break;
              }
            } else if (!(Le === Ge || S(Le, Ge, s, h, R))) {
              Ee = !1;
              break;
            }
          }
          return R.delete(t), R.delete(r), Ee;
        }
        function Ps(t, r, s, h, S, R, L) {
          switch (s) {
            case T1:
              if (t.byteLength != r.byteLength || t.byteOffset != r.byteOffset)
                return !1;
              t = t.buffer, r = r.buffer;
            case v1:
              return !(t.byteLength != r.byteLength || !R(new cn(t), new cn(r)));
            case fe:
            case Se:
            case we:
              return vt(+t, +r);
            case Te:
              return t.name == r.name && t.message == r.message;
            case ae:
            case ve:
              return t == r + "";
            case Ie:
              var $ = k5;
            case de:
              var G = h & A;
              if ($ || ($ = nn), t.size != r.size && !G)
                return !1;
              var ie = L.get(t);
              if (ie)
                return ie == r;
              h |= P, L.set(t, r);
              var se = r7($(t), $(r), h, S, R, L);
              return L.delete(t), se;
            case Ae:
              if (c4)
                return c4.call(t) == c4.call(r);
          }
          return !1;
        }
        function Os(t, r, s, h, S, R) {
          var L = s & A, $ = cr(t), G = $.length, ie = cr(r), se = ie.length;
          if (G != se && !L)
            return !1;
          for (var le = G; le--; ) {
            var Ee = $[le];
            if (!(L ? Ee in r : a1.call(r, Ee)))
              return !1;
          }
          var Re = R.get(t), Le = R.get(r);
          if (Re && Le)
            return Re == r && Le == t;
          var Ge = !0;
          R.set(t, r), R.set(r, t);
          for (var Me = L; ++le < G; ) {
            Ee = $[le];
            var Xe = t[Ee], Qe = r[Ee];
            if (h)
              var it = L ? h(Qe, Xe, Ee, r, t, R) : h(Xe, Qe, Ee, t, r, R);
            if (!(it === a ? Xe === Qe || S(Xe, Qe, s, h, R) : it)) {
              Ge = !1;
              break;
            }
            Me || (Me = Ee == "constructor");
          }
          if (Ge && !Me) {
            var K1 = t.constructor, st = r.constructor;
            K1 != st && "constructor" in t && "constructor" in r && !(typeof K1 == "function" && K1 instanceof K1 && typeof st == "function" && st instanceof st) && (Ge = !1);
          }
          return R.delete(t), R.delete(r), Ge;
        }
        function kt(t) {
          return gr(c7(t, a, y7), t + "");
        }
        function cr(t) {
          return S6(t, I1, mr);
        }
        function ur(t) {
          return S6(t, J1, o7);
        }
        var dr = fn ? function(t) {
          return fn.get(t);
        } : Or;
        function Pn(t) {
          for (var r = t.name + "", s = H3[r], h = a1.call(H3, r) ? s.length : 0; h--; ) {
            var S = s[h], R = S.func;
            if (R == null || R == t)
              return S.name;
          }
          return r;
        }
        function K3(t) {
          var r = a1.call(O, "placeholder") ? O : t;
          return r.placeholder;
        }
        function De() {
          var t = O.iteratee || _r;
          return t = t === _r ? E6 : t, arguments.length ? t(arguments[0], arguments[1]) : t;
        }
        function On(t, r) {
          var s = t.__data__;
          return ks(r) ? s[typeof r == "string" ? "string" : "hash"] : s.map;
        }
        function pr(t) {
          for (var r = I1(t), s = r.length; s--; ) {
            var h = r[s], S = t[h];
            r[s] = [h, S, s7(S)];
          }
          return r;
        }
        function j3(t, r) {
          var s = $a(t, r);
          return T6(s) ? s : a;
        }
        function Is(t) {
          var r = a1.call(t, g3), s = t[g3];
          try {
            t[g3] = a;
            var h = !0;
          } catch {
          }
          var S = sn.call(t);
          return h && (r ? t[g3] = s : delete t[g3]), S;
        }
        var mr = B5 ? function(t) {
          return t == null ? [] : (t = s1(t), Xt(B5(t), function(r) {
            return u6.call(t, r);
          }));
        } : Ir, o7 = B5 ? function(t) {
          for (var r = []; t; )
            Zt(r, mr(t)), t = un(t);
          return r;
        } : Ir, B1 = U1;
        ($5 && B1(new $5(new ArrayBuffer(1))) != T1 || i4 && B1(new i4()) != Ie || W5 && B1(W5.resolve()) != ue || W3 && B1(new W3()) != de || s4 && B1(new s4()) != qe) && (B1 = function(t) {
          var r = U1(t), s = r == Oe ? t.constructor : a, h = s ? S3(s) : "";
          if (h)
            switch (h) {
              case mi:
                return T1;
              case hi:
                return Ie;
              case fi:
                return ue;
              case xi:
                return de;
              case gi:
                return qe;
            }
          return r;
        });
        function Rs(t, r, s) {
          for (var h = -1, S = s.length; ++h < S; ) {
            var R = s[h], L = R.size;
            switch (R.type) {
              case "drop":
                t += L;
                break;
              case "dropRight":
                r -= L;
                break;
              case "take":
                r = z1(r, t + L);
                break;
              case "takeRight":
                t = A1(t, r - L);
                break;
            }
          }
          return { start: t, end: r };
        }
        function Ns(t) {
          var r = t.match(z9);
          return r ? r[1].split(B9) : [];
        }
        function a7(t, r, s) {
          r = n3(r, t);
          for (var h = -1, S = r.length, R = !1; ++h < S; ) {
            var L = Tt(r[h]);
            if (!(R = t != null && s(t, L)))
              break;
            t = t[L];
          }
          return R || ++h != S ? R : (S = t == null ? 0 : t.length, !!S && Mn(S) && zt(L, S) && (We(t) || w3(t)));
        }
        function Fs(t) {
          var r = t.length, s = new t.constructor(r);
          return r && typeof t[0] == "string" && a1.call(t, "index") && (s.index = t.index, s.input = t.input), s;
        }
        function i7(t) {
          return typeof t.constructor == "function" && !x4(t) ? V3(un(t)) : {};
        }
        function Ds(t, r, s) {
          var h = t.constructor;
          switch (r) {
            case v1:
              return ir(t);
            case fe:
            case Se:
              return new h(+t);
            case T1:
              return ys(t, s);
            case u1:
            case n1:
            case x1:
            case Rt:
            case qt:
            case Be:
            case ke:
            case Je:
            case i1:
              return W6(t, s);
            case Ie:
              return new h();
            case we:
            case ve:
              return new h(t);
            case ae:
              return vs(t);
            case de:
              return new h();
            case Ae:
              return bs(t);
          }
        }
        function Ls(t, r) {
          var s = r.length;
          if (!s)
            return t;
          var h = s - 1;
          return r[h] = (s > 1 ? "& " : "") + r[h], r = r.join(s > 2 ? ", " : " "), t.replace(k9, `{
/* [wrapped with ` + r + `] */
`);
        }
        function Ms(t) {
          return We(t) || w3(t) || !!(d6 && t && t[d6]);
        }
        function zt(t, r) {
          var s = typeof t;
          return r = r ?? B, !!r && (s == "number" || s != "symbol" && q9.test(t)) && t > -1 && t % 1 == 0 && t < r;
        }
        function G1(t, r, s) {
          if (!h1(s))
            return !1;
          var h = typeof r;
          return (h == "number" ? Z1(s) && zt(r, s.length) : h == "string" && r in s) ? vt(s[r], t) : !1;
        }
        function hr(t, r) {
          if (We(t))
            return !1;
          var s = typeof t;
          return s == "number" || s == "symbol" || s == "boolean" || t == null || at(t) ? !0 : D3.test(t) || !b5.test(t) || r != null && t in s1(r);
        }
        function ks(t) {
          var r = typeof t;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
        }
        function fr(t) {
          var r = Pn(t), s = O[r];
          if (typeof s != "function" || !(r in Ze.prototype))
            return !1;
          if (t === s)
            return !0;
          var h = dr(s);
          return !!h && t === h[0];
        }
        function zs(t) {
          return !!s6 && s6 in t;
        }
        var Bs = on ? Bt : Rr;
        function x4(t) {
          var r = t && t.constructor, s = typeof r == "function" && r.prototype || $3;
          return t === s;
        }
        function s7(t) {
          return t === t && !h1(t);
        }
        function l7(t, r) {
          return function(s) {
            return s == null ? !1 : s[t] === r && (r !== a || t in s1(s));
          };
        }
        function $s(t) {
          var r = Dn(t, function(h) {
            return s.size === d && s.clear(), h;
          }), s = r.cache;
          return r;
        }
        function Ws(t, r) {
          var s = t[1], h = r[1], S = s | h, R = S < (T | I | j), L = h == j && s == N || h == j && s == _ && t[7].length <= r[8] || h == (j | _) && r[7].length <= r[8] && s == N;
          if (!(R || L))
            return t;
          h & T && (t[2] = r[2], S |= s & T ? 0 : w);
          var $ = r[3];
          if ($) {
            var G = t[3];
            t[3] = G ? V6(G, $, r[4]) : $, t[4] = G ? Jt(t[3], f) : r[4];
          }
          return $ = r[5], $ && (G = t[5], t[5] = G ? U6(G, $, r[6]) : $, t[6] = G ? Jt(t[5], f) : r[6]), $ = r[7], $ && (t[7] = $), h & j && (t[8] = t[8] == null ? r[8] : z1(t[8], r[8])), t[9] == null && (t[9] = r[9]), t[0] = r[0], t[1] = S, t;
        }
        function Hs(t) {
          var r = [];
          if (t != null)
            for (var s in s1(t))
              r.push(s);
          return r;
        }
        function Vs(t) {
          return sn.call(t);
        }
        function c7(t, r, s) {
          return r = A1(r === a ? t.length - 1 : r, 0), function() {
            for (var h = arguments, S = -1, R = A1(h.length - r, 0), L = ee(R); ++S < R; )
              L[S] = h[r + S];
            S = -1;
            for (var $ = ee(r + 1); ++S < r; )
              $[S] = h[S];
            return $[r] = s(L), nt(t, this, $);
          };
        }
        function u7(t, r) {
          return r.length < 2 ? t : C3(t, ht(r, 0, -1));
        }
        function Us(t, r) {
          for (var s = t.length, h = z1(r.length, s), S = X1(t); h--; ) {
            var R = r[h];
            t[h] = zt(R, s) ? S[R] : a;
          }
          return t;
        }
        function xr(t, r) {
          if (!(r === "constructor" && typeof t[r] == "function") && r != "__proto__")
            return t[r];
        }
        var d7 = m7(F6), g4 = ii || function(t, r) {
          return F1.setTimeout(t, r);
        }, gr = m7(hs);
        function p7(t, r, s) {
          var h = r + "";
          return gr(t, Ls(h, Gs(Ns(h), s)));
        }
        function m7(t) {
          var r = 0, s = 0;
          return function() {
            var h = ui(), S = F - (h - s);
            if (s = h, S > 0) {
              if (++r >= D)
                return arguments[0];
            } else
              r = 0;
            return t.apply(a, arguments);
          };
        }
        function In(t, r) {
          var s = -1, h = t.length, S = h - 1;
          for (r = r === a ? h : r; ++s < r; ) {
            var R = Q5(s, S), L = t[R];
            t[R] = t[s], t[s] = L;
          }
          return t.length = r, t;
        }
        var h7 = $s(function(t) {
          var r = [];
          return t.charCodeAt(0) === 46 && r.push(""), t.replace(C5, function(s, h, S, R) {
            r.push(S ? R.replace(H9, "$1") : h || s);
          }), r;
        });
        function Tt(t) {
          if (typeof t == "string" || at(t))
            return t;
          var r = t + "";
          return r == "0" && 1 / t == -q ? "-0" : r;
        }
        function S3(t) {
          if (t != null) {
            try {
              return an.call(t);
            } catch {
            }
            try {
              return t + "";
            } catch {
            }
          }
          return "";
        }
        function Gs(t, r) {
          return ut(me, function(s) {
            var h = "_." + s[0];
            r & s[1] && !en(t, h) && t.push(h);
          }), t.sort();
        }
        function f7(t) {
          if (t instanceof Ze)
            return t.clone();
          var r = new pt(t.__wrapped__, t.__chain__);
          return r.__actions__ = X1(t.__actions__), r.__index__ = t.__index__, r.__values__ = t.__values__, r;
        }
        function Ks(t, r, s) {
          (s ? G1(t, r, s) : r === a) ? r = 1 : r = A1(Ue(r), 0);
          var h = t == null ? 0 : t.length;
          if (!h || r < 1)
            return [];
          for (var S = 0, R = 0, L = ee(mn(h / r)); S < h; )
            L[R++] = ht(t, S, S += r);
          return L;
        }
        function Ys(t) {
          for (var r = -1, s = t == null ? 0 : t.length, h = 0, S = []; ++r < s; ) {
            var R = t[r];
            R && (S[h++] = R);
          }
          return S;
        }
        function qs() {
          var t = arguments.length;
          if (!t)
            return [];
          for (var r = ee(t - 1), s = arguments[0], h = t; h--; )
            r[h - 1] = arguments[h];
          return Zt(We(s) ? X1(s) : [s], D1(r, 1));
        }
        var Xs = Ke(function(t, r) {
          return C1(t) ? d4(t, D1(r, 1, C1, !0)) : [];
        }), Zs = Ke(function(t, r) {
          var s = ft(r);
          return C1(s) && (s = a), C1(t) ? d4(t, D1(r, 1, C1, !0), De(s, 2)) : [];
        }), Js = Ke(function(t, r) {
          var s = ft(r);
          return C1(s) && (s = a), C1(t) ? d4(t, D1(r, 1, C1, !0), a, s) : [];
        });
        function Qs(t, r, s) {
          var h = t == null ? 0 : t.length;
          return h ? (r = s || r === a ? 1 : Ue(r), ht(t, r < 0 ? 0 : r, h)) : [];
        }
        function e0(t, r, s) {
          var h = t == null ? 0 : t.length;
          return h ? (r = s || r === a ? 1 : Ue(r), r = h - r, ht(t, 0, r < 0 ? 0 : r)) : [];
        }
        function t0(t, r) {
          return t && t.length ? Sn(t, De(r, 3), !0, !0) : [];
        }
        function n0(t, r) {
          return t && t.length ? Sn(t, De(r, 3), !0) : [];
        }
        function r0(t, r, s, h) {
          var S = t == null ? 0 : t.length;
          return S ? (s && typeof s != "number" && G1(t, r, s) && (s = 0, h = S), qi(t, r, s, h)) : [];
        }
        function x7(t, r, s) {
          var h = t == null ? 0 : t.length;
          if (!h)
            return -1;
          var S = s == null ? 0 : Ue(s);
          return S < 0 && (S = A1(h + S, 0)), tn(t, De(r, 3), S);
        }
        function g7(t, r, s) {
          var h = t == null ? 0 : t.length;
          if (!h)
            return -1;
          var S = h - 1;
          return s !== a && (S = Ue(s), S = s < 0 ? A1(h + S, 0) : z1(S, h - 1)), tn(t, De(r, 3), S, !0);
        }
        function y7(t) {
          var r = t == null ? 0 : t.length;
          return r ? D1(t, 1) : [];
        }
        function o0(t) {
          var r = t == null ? 0 : t.length;
          return r ? D1(t, q) : [];
        }
        function a0(t, r) {
          var s = t == null ? 0 : t.length;
          return s ? (r = r === a ? 1 : Ue(r), D1(t, r)) : [];
        }
        function i0(t) {
          for (var r = -1, s = t == null ? 0 : t.length, h = {}; ++r < s; ) {
            var S = t[r];
            h[S[0]] = S[1];
          }
          return h;
        }
        function v7(t) {
          return t && t.length ? t[0] : a;
        }
        function s0(t, r, s) {
          var h = t == null ? 0 : t.length;
          if (!h)
            return -1;
          var S = s == null ? 0 : Ue(s);
          return S < 0 && (S = A1(h + S, 0)), M3(t, r, S);
        }
        function l0(t) {
          var r = t == null ? 0 : t.length;
          return r ? ht(t, 0, -1) : [];
        }
        var c0 = Ke(function(t) {
          var r = p1(t, or);
          return r.length && r[0] === t[0] ? Y5(r) : [];
        }), u0 = Ke(function(t) {
          var r = ft(t), s = p1(t, or);
          return r === ft(s) ? r = a : s.pop(), s.length && s[0] === t[0] ? Y5(s, De(r, 2)) : [];
        }), d0 = Ke(function(t) {
          var r = ft(t), s = p1(t, or);
          return r = typeof r == "function" ? r : a, r && s.pop(), s.length && s[0] === t[0] ? Y5(s, a, r) : [];
        });
        function p0(t, r) {
          return t == null ? "" : li.call(t, r);
        }
        function ft(t) {
          var r = t == null ? 0 : t.length;
          return r ? t[r - 1] : a;
        }
        function m0(t, r, s) {
          var h = t == null ? 0 : t.length;
          if (!h)
            return -1;
          var S = h;
          return s !== a && (S = Ue(s), S = S < 0 ? A1(h + S, 0) : z1(S, h - 1)), r === r ? Ga(t, r, S) : tn(t, Q2, S, !0);
        }
        function h0(t, r) {
          return t && t.length ? O6(t, Ue(r)) : a;
        }
        var f0 = Ke(b7);
        function b7(t, r) {
          return t && t.length && r && r.length ? J5(t, r) : t;
        }
        function x0(t, r, s) {
          return t && t.length && r && r.length ? J5(t, r, De(s, 2)) : t;
        }
        function g0(t, r, s) {
          return t && t.length && r && r.length ? J5(t, r, a, s) : t;
        }
        var y0 = kt(function(t, r) {
          var s = t == null ? 0 : t.length, h = V5(t, r);
          return N6(t, p1(r, function(S) {
            return zt(S, s) ? +S : S;
          }).sort(H6)), h;
        });
        function v0(t, r) {
          var s = [];
          if (!(t && t.length))
            return s;
          var h = -1, S = [], R = t.length;
          for (r = De(r, 3); ++h < R; ) {
            var L = t[h];
            r(L, h, t) && (s.push(L), S.push(h));
          }
          return N6(t, S), s;
        }
        function yr(t) {
          return t == null ? t : pi.call(t);
        }
        function b0(t, r, s) {
          var h = t == null ? 0 : t.length;
          return h ? (s && typeof s != "number" && G1(t, r, s) ? (r = 0, s = h) : (r = r == null ? 0 : Ue(r), s = s === a ? h : Ue(s)), ht(t, r, s)) : [];
        }
        function C0(t, r) {
          return jn(t, r);
        }
        function j0(t, r, s) {
          return tr(t, r, De(s, 2));
        }
        function S0(t, r) {
          var s = t == null ? 0 : t.length;
          if (s) {
            var h = jn(t, r);
            if (h < s && vt(t[h], r))
              return h;
          }
          return -1;
        }
        function w0(t, r) {
          return jn(t, r, !0);
        }
        function T0(t, r, s) {
          return tr(t, r, De(s, 2), !0);
        }
        function E0(t, r) {
          var s = t == null ? 0 : t.length;
          if (s) {
            var h = jn(t, r, !0) - 1;
            if (vt(t[h], r))
              return h;
          }
          return -1;
        }
        function A0(t) {
          return t && t.length ? D6(t) : [];
        }
        function _0(t, r) {
          return t && t.length ? D6(t, De(r, 2)) : [];
        }
        function P0(t) {
          var r = t == null ? 0 : t.length;
          return r ? ht(t, 1, r) : [];
        }
        function O0(t, r, s) {
          return t && t.length ? (r = s || r === a ? 1 : Ue(r), ht(t, 0, r < 0 ? 0 : r)) : [];
        }
        function I0(t, r, s) {
          var h = t == null ? 0 : t.length;
          return h ? (r = s || r === a ? 1 : Ue(r), r = h - r, ht(t, r < 0 ? 0 : r, h)) : [];
        }
        function R0(t, r) {
          return t && t.length ? Sn(t, De(r, 3), !1, !0) : [];
        }
        function N0(t, r) {
          return t && t.length ? Sn(t, De(r, 3)) : [];
        }
        var F0 = Ke(function(t) {
          return t3(D1(t, 1, C1, !0));
        }), D0 = Ke(function(t) {
          var r = ft(t);
          return C1(r) && (r = a), t3(D1(t, 1, C1, !0), De(r, 2));
        }), L0 = Ke(function(t) {
          var r = ft(t);
          return r = typeof r == "function" ? r : a, t3(D1(t, 1, C1, !0), a, r);
        });
        function M0(t) {
          return t && t.length ? t3(t) : [];
        }
        function k0(t, r) {
          return t && t.length ? t3(t, De(r, 2)) : [];
        }
        function z0(t, r) {
          return r = typeof r == "function" ? r : a, t && t.length ? t3(t, a, r) : [];
        }
        function vr(t) {
          if (!(t && t.length))
            return [];
          var r = 0;
          return t = Xt(t, function(s) {
            if (C1(s))
              return r = A1(s.length, r), !0;
          }), L5(r, function(s) {
            return p1(t, N5(s));
          });
        }
        function C7(t, r) {
          if (!(t && t.length))
            return [];
          var s = vr(t);
          return r == null ? s : p1(s, function(h) {
            return nt(r, a, h);
          });
        }
        var B0 = Ke(function(t, r) {
          return C1(t) ? d4(t, r) : [];
        }), $0 = Ke(function(t) {
          return rr(Xt(t, C1));
        }), W0 = Ke(function(t) {
          var r = ft(t);
          return C1(r) && (r = a), rr(Xt(t, C1), De(r, 2));
        }), H0 = Ke(function(t) {
          var r = ft(t);
          return r = typeof r == "function" ? r : a, rr(Xt(t, C1), a, r);
        }), V0 = Ke(vr);
        function U0(t, r) {
          return z6(t || [], r || [], u4);
        }
        function G0(t, r) {
          return z6(t || [], r || [], h4);
        }
        var K0 = Ke(function(t) {
          var r = t.length, s = r > 1 ? t[r - 1] : a;
          return s = typeof s == "function" ? (t.pop(), s) : a, C7(t, s);
        });
        function j7(t) {
          var r = O(t);
          return r.__chain__ = !0, r;
        }
        function Y0(t, r) {
          return r(t), t;
        }
        function Rn(t, r) {
          return r(t);
        }
        var q0 = kt(function(t) {
          var r = t.length, s = r ? t[0] : 0, h = this.__wrapped__, S = function(R) {
            return V5(R, t);
          };
          return r > 1 || this.__actions__.length || !(h instanceof Ze) || !zt(s) ? this.thru(S) : (h = h.slice(s, +s + (r ? 1 : 0)), h.__actions__.push({
            func: Rn,
            args: [S],
            thisArg: a
          }), new pt(h, this.__chain__).thru(function(R) {
            return r && !R.length && R.push(a), R;
          }));
        });
        function X0() {
          return j7(this);
        }
        function Z0() {
          return new pt(this.value(), this.__chain__);
        }
        function J0() {
          this.__values__ === a && (this.__values__ = L7(this.value()));
          var t = this.__index__ >= this.__values__.length, r = t ? a : this.__values__[this.__index__++];
          return { done: t, value: r };
        }
        function Q0() {
          return this;
        }
        function el(t) {
          for (var r, s = this; s instanceof gn; ) {
            var h = f7(s);
            h.__index__ = 0, h.__values__ = a, r ? S.__wrapped__ = h : r = h;
            var S = h;
            s = s.__wrapped__;
          }
          return S.__wrapped__ = t, r;
        }
        function tl() {
          var t = this.__wrapped__;
          if (t instanceof Ze) {
            var r = t;
            return this.__actions__.length && (r = new Ze(this)), r = r.reverse(), r.__actions__.push({
              func: Rn,
              args: [yr],
              thisArg: a
            }), new pt(r, this.__chain__);
          }
          return this.thru(yr);
        }
        function nl() {
          return k6(this.__wrapped__, this.__actions__);
        }
        var rl = wn(function(t, r, s) {
          a1.call(t, s) ? ++t[s] : Lt(t, s, 1);
        });
        function ol(t, r, s) {
          var h = We(t) ? Z2 : Yi;
          return s && G1(t, r, s) && (r = a), h(t, De(r, 3));
        }
        function al(t, r) {
          var s = We(t) ? Xt : C6;
          return s(t, De(r, 3));
        }
        var il = q6(x7), sl = q6(g7);
        function ll(t, r) {
          return D1(Nn(t, r), 1);
        }
        function cl(t, r) {
          return D1(Nn(t, r), q);
        }
        function ul(t, r, s) {
          return s = s === a ? 1 : Ue(s), D1(Nn(t, r), s);
        }
        function S7(t, r) {
          var s = We(t) ? ut : e3;
          return s(t, De(r, 3));
        }
        function w7(t, r) {
          var s = We(t) ? Pa : b6;
          return s(t, De(r, 3));
        }
        var dl = wn(function(t, r, s) {
          a1.call(t, s) ? t[s].push(r) : Lt(t, s, [r]);
        });
        function pl(t, r, s, h) {
          t = Z1(t) ? t : q3(t), s = s && !h ? Ue(s) : 0;
          var S = t.length;
          return s < 0 && (s = A1(S + s, 0)), kn(t) ? s <= S && t.indexOf(r, s) > -1 : !!S && M3(t, r, s) > -1;
        }
        var ml = Ke(function(t, r, s) {
          var h = -1, S = typeof r == "function", R = Z1(t) ? ee(t.length) : [];
          return e3(t, function(L) {
            R[++h] = S ? nt(r, L, s) : p4(L, r, s);
          }), R;
        }), hl = wn(function(t, r, s) {
          Lt(t, s, r);
        });
        function Nn(t, r) {
          var s = We(t) ? p1 : A6;
          return s(t, De(r, 3));
        }
        function fl(t, r, s, h) {
          return t == null ? [] : (We(r) || (r = r == null ? [] : [r]), s = h ? a : s, We(s) || (s = s == null ? [] : [s]), I6(t, r, s));
        }
        var xl = wn(function(t, r, s) {
          t[s ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function gl(t, r, s) {
          var h = We(t) ? I5 : t6, S = arguments.length < 3;
          return h(t, De(r, 4), s, S, e3);
        }
        function yl(t, r, s) {
          var h = We(t) ? Oa : t6, S = arguments.length < 3;
          return h(t, De(r, 4), s, S, b6);
        }
        function vl(t, r) {
          var s = We(t) ? Xt : C6;
          return s(t, Ln(De(r, 3)));
        }
        function bl(t) {
          var r = We(t) ? x6 : ps;
          return r(t);
        }
        function Cl(t, r, s) {
          (s ? G1(t, r, s) : r === a) ? r = 1 : r = Ue(r);
          var h = We(t) ? Hi : ms;
          return h(t, r);
        }
        function jl(t) {
          var r = We(t) ? Vi : fs;
          return r(t);
        }
        function Sl(t) {
          if (t == null)
            return 0;
          if (Z1(t))
            return kn(t) ? z3(t) : t.length;
          var r = B1(t);
          return r == Ie || r == de ? t.size : X5(t).length;
        }
        function wl(t, r, s) {
          var h = We(t) ? R5 : xs;
          return s && G1(t, r, s) && (r = a), h(t, De(r, 3));
        }
        var Tl = Ke(function(t, r) {
          if (t == null)
            return [];
          var s = r.length;
          return s > 1 && G1(t, r[0], r[1]) ? r = [] : s > 2 && G1(r[0], r[1], r[2]) && (r = [r[0]]), I6(t, D1(r, 1), []);
        }), Fn = ai || function() {
          return F1.Date.now();
        };
        function El(t, r) {
          if (typeof r != "function")
            throw new dt(p);
          return t = Ue(t), function() {
            if (--t < 1)
              return r.apply(this, arguments);
          };
        }
        function T7(t, r, s) {
          return r = s ? a : r, r = t && r == null ? t.length : r, Mt(t, j, a, a, a, a, r);
        }
        function E7(t, r) {
          var s;
          if (typeof r != "function")
            throw new dt(p);
          return t = Ue(t), function() {
            return --t > 0 && (s = r.apply(this, arguments)), t <= 1 && (r = a), s;
          };
        }
        var br = Ke(function(t, r, s) {
          var h = T;
          if (s.length) {
            var S = Jt(s, K3(br));
            h |= x;
          }
          return Mt(t, h, r, s, S);
        }), A7 = Ke(function(t, r, s) {
          var h = T | I;
          if (s.length) {
            var S = Jt(s, K3(A7));
            h |= x;
          }
          return Mt(r, h, t, s, S);
        });
        function _7(t, r, s) {
          r = s ? a : r;
          var h = Mt(t, N, a, a, a, a, a, r);
          return h.placeholder = _7.placeholder, h;
        }
        function P7(t, r, s) {
          r = s ? a : r;
          var h = Mt(t, E, a, a, a, a, a, r);
          return h.placeholder = P7.placeholder, h;
        }
        function O7(t, r, s) {
          var h, S, R, L, $, G, ie = 0, se = !1, le = !1, Ee = !0;
          if (typeof t != "function")
            throw new dt(p);
          r = xt(r) || 0, h1(s) && (se = !!s.leading, le = "maxWait" in s, R = le ? A1(xt(s.maxWait) || 0, r) : R, Ee = "trailing" in s ? !!s.trailing : Ee);
          function Re(j1) {
            var bt = h, Wt = S;
            return h = S = a, ie = j1, L = t.apply(Wt, bt), L;
          }
          function Le(j1) {
            return ie = j1, $ = g4(Xe, r), se ? Re(j1) : L;
          }
          function Ge(j1) {
            var bt = j1 - G, Wt = j1 - ie, q7 = r - bt;
            return le ? z1(q7, R - Wt) : q7;
          }
          function Me(j1) {
            var bt = j1 - G, Wt = j1 - ie;
            return G === a || bt >= r || bt < 0 || le && Wt >= R;
          }
          function Xe() {
            var j1 = Fn();
            if (Me(j1))
              return Qe(j1);
            $ = g4(Xe, Ge(j1));
          }
          function Qe(j1) {
            return $ = a, Ee && h ? Re(j1) : (h = S = a, L);
          }
          function it() {
            $ !== a && B6($), ie = 0, h = G = S = $ = a;
          }
          function K1() {
            return $ === a ? L : Qe(Fn());
          }
          function st() {
            var j1 = Fn(), bt = Me(j1);
            if (h = arguments, S = this, G = j1, bt) {
              if ($ === a)
                return Le(G);
              if (le)
                return B6($), $ = g4(Xe, r), Re(G);
            }
            return $ === a && ($ = g4(Xe, r)), L;
          }
          return st.cancel = it, st.flush = K1, st;
        }
        var Al = Ke(function(t, r) {
          return v6(t, 1, r);
        }), _l = Ke(function(t, r, s) {
          return v6(t, xt(r) || 0, s);
        });
        function Pl(t) {
          return Mt(t, z);
        }
        function Dn(t, r) {
          if (typeof t != "function" || r != null && typeof r != "function")
            throw new dt(p);
          var s = function() {
            var h = arguments, S = r ? r.apply(this, h) : h[0], R = s.cache;
            if (R.has(S))
              return R.get(S);
            var L = t.apply(this, h);
            return s.cache = R.set(S, L) || R, L;
          };
          return s.cache = new (Dn.Cache || Dt)(), s;
        }
        Dn.Cache = Dt;
        function Ln(t) {
          if (typeof t != "function")
            throw new dt(p);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !t.call(this);
              case 1:
                return !t.call(this, r[0]);
              case 2:
                return !t.call(this, r[0], r[1]);
              case 3:
                return !t.call(this, r[0], r[1], r[2]);
            }
            return !t.apply(this, r);
          };
        }
        function Ol(t) {
          return E7(2, t);
        }
        var Il = gs(function(t, r) {
          r = r.length == 1 && We(r[0]) ? p1(r[0], rt(De())) : p1(D1(r, 1), rt(De()));
          var s = r.length;
          return Ke(function(h) {
            for (var S = -1, R = z1(h.length, s); ++S < R; )
              h[S] = r[S].call(this, h[S]);
            return nt(t, this, h);
          });
        }), Cr = Ke(function(t, r) {
          var s = Jt(r, K3(Cr));
          return Mt(t, x, a, r, s);
        }), I7 = Ke(function(t, r) {
          var s = Jt(r, K3(I7));
          return Mt(t, m, a, r, s);
        }), Rl = kt(function(t, r) {
          return Mt(t, _, a, a, a, r);
        });
        function Nl(t, r) {
          if (typeof t != "function")
            throw new dt(p);
          return r = r === a ? r : Ue(r), Ke(t, r);
        }
        function Fl(t, r) {
          if (typeof t != "function")
            throw new dt(p);
          return r = r == null ? 0 : A1(Ue(r), 0), Ke(function(s) {
            var h = s[r], S = r3(s, 0, r);
            return h && Zt(S, h), nt(t, this, S);
          });
        }
        function Dl(t, r, s) {
          var h = !0, S = !0;
          if (typeof t != "function")
            throw new dt(p);
          return h1(s) && (h = "leading" in s ? !!s.leading : h, S = "trailing" in s ? !!s.trailing : S), O7(t, r, {
            leading: h,
            maxWait: r,
            trailing: S
          });
        }
        function Ll(t) {
          return T7(t, 1);
        }
        function Ml(t, r) {
          return Cr(ar(r), t);
        }
        function kl() {
          if (!arguments.length)
            return [];
          var t = arguments[0];
          return We(t) ? t : [t];
        }
        function zl(t) {
          return mt(t, v);
        }
        function Bl(t, r) {
          return r = typeof r == "function" ? r : a, mt(t, v, r);
        }
        function $l(t) {
          return mt(t, b | v);
        }
        function Wl(t, r) {
          return r = typeof r == "function" ? r : a, mt(t, b | v, r);
        }
        function Hl(t, r) {
          return r == null || y6(t, r, I1(r));
        }
        function vt(t, r) {
          return t === r || t !== t && r !== r;
        }
        var Vl = _n(K5), Ul = _n(function(t, r) {
          return t >= r;
        }), w3 = w6(/* @__PURE__ */ function() {
          return arguments;
        }()) ? w6 : function(t) {
          return g1(t) && a1.call(t, "callee") && !u6.call(t, "callee");
        }, We = ee.isArray, Gl = U2 ? rt(U2) : es;
        function Z1(t) {
          return t != null && Mn(t.length) && !Bt(t);
        }
        function C1(t) {
          return g1(t) && Z1(t);
        }
        function Kl(t) {
          return t === !0 || t === !1 || g1(t) && U1(t) == fe;
        }
        var o3 = si || Rr, Yl = G2 ? rt(G2) : ts;
        function ql(t) {
          return g1(t) && t.nodeType === 1 && !y4(t);
        }
        function Xl(t) {
          if (t == null)
            return !0;
          if (Z1(t) && (We(t) || typeof t == "string" || typeof t.splice == "function" || o3(t) || Y3(t) || w3(t)))
            return !t.length;
          var r = B1(t);
          if (r == Ie || r == de)
            return !t.size;
          if (x4(t))
            return !X5(t).length;
          for (var s in t)
            if (a1.call(t, s))
              return !1;
          return !0;
        }
        function Zl(t, r) {
          return m4(t, r);
        }
        function Jl(t, r, s) {
          s = typeof s == "function" ? s : a;
          var h = s ? s(t, r) : a;
          return h === a ? m4(t, r, a, s) : !!h;
        }
        function jr(t) {
          if (!g1(t))
            return !1;
          var r = U1(t);
          return r == Te || r == be || typeof t.message == "string" && typeof t.name == "string" && !y4(t);
        }
        function Ql(t) {
          return typeof t == "number" && p6(t);
        }
        function Bt(t) {
          if (!h1(t))
            return !1;
          var r = U1(t);
          return r == Pe || r == xe || r == Z || r == ye;
        }
        function R7(t) {
          return typeof t == "number" && t == Ue(t);
        }
        function Mn(t) {
          return typeof t == "number" && t > -1 && t % 1 == 0 && t <= B;
        }
        function h1(t) {
          var r = typeof t;
          return t != null && (r == "object" || r == "function");
        }
        function g1(t) {
          return t != null && typeof t == "object";
        }
        var N7 = K2 ? rt(K2) : rs;
        function ec(t, r) {
          return t === r || q5(t, r, pr(r));
        }
        function tc(t, r, s) {
          return s = typeof s == "function" ? s : a, q5(t, r, pr(r), s);
        }
        function nc(t) {
          return F7(t) && t != +t;
        }
        function rc(t) {
          if (Bs(t))
            throw new $e(c);
          return T6(t);
        }
        function oc(t) {
          return t === null;
        }
        function ac(t) {
          return t == null;
        }
        function F7(t) {
          return typeof t == "number" || g1(t) && U1(t) == we;
        }
        function y4(t) {
          if (!g1(t) || U1(t) != Oe)
            return !1;
          var r = un(t);
          if (r === null)
            return !0;
          var s = a1.call(r, "constructor") && r.constructor;
          return typeof s == "function" && s instanceof s && an.call(s) == ti;
        }
        var Sr = Y2 ? rt(Y2) : os;
        function ic(t) {
          return R7(t) && t >= -B && t <= B;
        }
        var D7 = q2 ? rt(q2) : as;
        function kn(t) {
          return typeof t == "string" || !We(t) && g1(t) && U1(t) == ve;
        }
        function at(t) {
          return typeof t == "symbol" || g1(t) && U1(t) == Ae;
        }
        var Y3 = X2 ? rt(X2) : is;
        function sc(t) {
          return t === a;
        }
        function lc(t) {
          return g1(t) && B1(t) == qe;
        }
        function cc(t) {
          return g1(t) && U1(t) == He;
        }
        var uc = _n(Z5), dc = _n(function(t, r) {
          return t <= r;
        });
        function L7(t) {
          if (!t)
            return [];
          if (Z1(t))
            return kn(t) ? gt(t) : X1(t);
          if (a4 && t[a4])
            return Ha(t[a4]());
          var r = B1(t), s = r == Ie ? k5 : r == de ? nn : q3;
          return s(t);
        }
        function $t(t) {
          if (!t)
            return t === 0 ? t : 0;
          if (t = xt(t), t === q || t === -q) {
            var r = t < 0 ? -1 : 1;
            return r * k;
          }
          return t === t ? t : 0;
        }
        function Ue(t) {
          var r = $t(t), s = r % 1;
          return r === r ? s ? r - s : r : 0;
        }
        function M7(t) {
          return t ? b3(Ue(t), 0, re) : 0;
        }
        function xt(t) {
          if (typeof t == "number")
            return t;
          if (at(t))
            return H;
          if (h1(t)) {
            var r = typeof t.valueOf == "function" ? t.valueOf() : t;
            t = h1(r) ? r + "" : r;
          }
          if (typeof t != "string")
            return t === 0 ? t : +t;
          t = n6(t);
          var s = G9.test(t);
          return s || Y9.test(t) ? Ea(t.slice(2), s ? 2 : 8) : U9.test(t) ? H : +t;
        }
        function k7(t) {
          return wt(t, J1(t));
        }
        function pc(t) {
          return t ? b3(Ue(t), -B, B) : t === 0 ? t : 0;
        }
        function o1(t) {
          return t == null ? "" : ot(t);
        }
        var mc = U3(function(t, r) {
          if (x4(r) || Z1(r)) {
            wt(r, I1(r), t);
            return;
          }
          for (var s in r)
            a1.call(r, s) && u4(t, s, r[s]);
        }), z7 = U3(function(t, r) {
          wt(r, J1(r), t);
        }), zn = U3(function(t, r, s, h) {
          wt(r, J1(r), t, h);
        }), hc = U3(function(t, r, s, h) {
          wt(r, I1(r), t, h);
        }), fc = kt(V5);
        function xc(t, r) {
          var s = V3(t);
          return r == null ? s : g6(s, r);
        }
        var gc = Ke(function(t, r) {
          t = s1(t);
          var s = -1, h = r.length, S = h > 2 ? r[2] : a;
          for (S && G1(r[0], r[1], S) && (h = 1); ++s < h; )
            for (var R = r[s], L = J1(R), $ = -1, G = L.length; ++$ < G; ) {
              var ie = L[$], se = t[ie];
              (se === a || vt(se, $3[ie]) && !a1.call(t, ie)) && (t[ie] = R[ie]);
            }
          return t;
        }), yc = Ke(function(t) {
          return t.push(a, n7), nt(B7, a, t);
        });
        function vc(t, r) {
          return J2(t, De(r, 3), St);
        }
        function bc(t, r) {
          return J2(t, De(r, 3), G5);
        }
        function Cc(t, r) {
          return t == null ? t : U5(t, De(r, 3), J1);
        }
        function jc(t, r) {
          return t == null ? t : j6(t, De(r, 3), J1);
        }
        function Sc(t, r) {
          return t && St(t, De(r, 3));
        }
        function wc(t, r) {
          return t && G5(t, De(r, 3));
        }
        function Tc(t) {
          return t == null ? [] : bn(t, I1(t));
        }
        function Ec(t) {
          return t == null ? [] : bn(t, J1(t));
        }
        function wr(t, r, s) {
          var h = t == null ? a : C3(t, r);
          return h === a ? s : h;
        }
        function Ac(t, r) {
          return t != null && a7(t, r, Xi);
        }
        function Tr(t, r) {
          return t != null && a7(t, r, Zi);
        }
        var _c = Z6(function(t, r, s) {
          r != null && typeof r.toString != "function" && (r = sn.call(r)), t[r] = s;
        }, Ar(Q1)), Pc = Z6(function(t, r, s) {
          r != null && typeof r.toString != "function" && (r = sn.call(r)), a1.call(t, r) ? t[r].push(s) : t[r] = [s];
        }, De), Oc = Ke(p4);
        function I1(t) {
          return Z1(t) ? f6(t) : X5(t);
        }
        function J1(t) {
          return Z1(t) ? f6(t, !0) : ss(t);
        }
        function Ic(t, r) {
          var s = {};
          return r = De(r, 3), St(t, function(h, S, R) {
            Lt(s, r(h, S, R), h);
          }), s;
        }
        function Rc(t, r) {
          var s = {};
          return r = De(r, 3), St(t, function(h, S, R) {
            Lt(s, S, r(h, S, R));
          }), s;
        }
        var Nc = U3(function(t, r, s) {
          Cn(t, r, s);
        }), B7 = U3(function(t, r, s, h) {
          Cn(t, r, s, h);
        }), Fc = kt(function(t, r) {
          var s = {};
          if (t == null)
            return s;
          var h = !1;
          r = p1(r, function(R) {
            return R = n3(R, t), h || (h = R.length > 1), R;
          }), wt(t, ur(t), s), h && (s = mt(s, b | C | v, _s));
          for (var S = r.length; S--; )
            nr(s, r[S]);
          return s;
        });
        function Dc(t, r) {
          return $7(t, Ln(De(r)));
        }
        var Lc = kt(function(t, r) {
          return t == null ? {} : cs(t, r);
        });
        function $7(t, r) {
          if (t == null)
            return {};
          var s = p1(ur(t), function(h) {
            return [h];
          });
          return r = De(r), R6(t, s, function(h, S) {
            return r(h, S[0]);
          });
        }
        function Mc(t, r, s) {
          r = n3(r, t);
          var h = -1, S = r.length;
          for (S || (S = 1, t = a); ++h < S; ) {
            var R = t == null ? a : t[Tt(r[h])];
            R === a && (h = S, R = s), t = Bt(R) ? R.call(t) : R;
          }
          return t;
        }
        function kc(t, r, s) {
          return t == null ? t : h4(t, r, s);
        }
        function zc(t, r, s, h) {
          return h = typeof h == "function" ? h : a, t == null ? t : h4(t, r, s, h);
        }
        var W7 = e7(I1), H7 = e7(J1);
        function Bc(t, r, s) {
          var h = We(t), S = h || o3(t) || Y3(t);
          if (r = De(r, 4), s == null) {
            var R = t && t.constructor;
            S ? s = h ? new R() : [] : h1(t) ? s = Bt(R) ? V3(un(t)) : {} : s = {};
          }
          return (S ? ut : St)(t, function(L, $, G) {
            return r(s, L, $, G);
          }), s;
        }
        function $c(t, r) {
          return t == null ? !0 : nr(t, r);
        }
        function Wc(t, r, s) {
          return t == null ? t : M6(t, r, ar(s));
        }
        function Hc(t, r, s, h) {
          return h = typeof h == "function" ? h : a, t == null ? t : M6(t, r, ar(s), h);
        }
        function q3(t) {
          return t == null ? [] : M5(t, I1(t));
        }
        function Vc(t) {
          return t == null ? [] : M5(t, J1(t));
        }
        function Uc(t, r, s) {
          return s === a && (s = r, r = a), s !== a && (s = xt(s), s = s === s ? s : 0), r !== a && (r = xt(r), r = r === r ? r : 0), b3(xt(t), r, s);
        }
        function Gc(t, r, s) {
          return r = $t(r), s === a ? (s = r, r = 0) : s = $t(s), t = xt(t), Ji(t, r, s);
        }
        function Kc(t, r, s) {
          if (s && typeof s != "boolean" && G1(t, r, s) && (r = s = a), s === a && (typeof r == "boolean" ? (s = r, r = a) : typeof t == "boolean" && (s = t, t = a)), t === a && r === a ? (t = 0, r = 1) : (t = $t(t), r === a ? (r = t, t = 0) : r = $t(r)), t > r) {
            var h = t;
            t = r, r = h;
          }
          if (s || t % 1 || r % 1) {
            var S = m6();
            return z1(t + S * (r - t + Ta("1e-" + ((S + "").length - 1))), r);
          }
          return Q5(t, r);
        }
        var Yc = G3(function(t, r, s) {
          return r = r.toLowerCase(), t + (s ? V7(r) : r);
        });
        function V7(t) {
          return Er(o1(t).toLowerCase());
        }
        function U7(t) {
          return t = o1(t), t && t.replace(X9, ka).replace(fa, "");
        }
        function qc(t, r, s) {
          t = o1(t), r = ot(r);
          var h = t.length;
          s = s === a ? h : b3(Ue(s), 0, h);
          var S = s;
          return s -= r.length, s >= 0 && t.slice(s, S) == r;
        }
        function Xc(t) {
          return t = o1(t), t && k1.test(t) ? t.replace(q1, za) : t;
        }
        function Zc(t) {
          return t = o1(t), t && L9.test(t) ? t.replace(X4, "\\$&") : t;
        }
        var Jc = G3(function(t, r, s) {
          return t + (s ? "-" : "") + r.toLowerCase();
        }), Qc = G3(function(t, r, s) {
          return t + (s ? " " : "") + r.toLowerCase();
        }), eu = Y6("toLowerCase");
        function tu(t, r, s) {
          t = o1(t), r = Ue(r);
          var h = r ? z3(t) : 0;
          if (!r || h >= r)
            return t;
          var S = (r - h) / 2;
          return An(hn(S), s) + t + An(mn(S), s);
        }
        function nu(t, r, s) {
          t = o1(t), r = Ue(r);
          var h = r ? z3(t) : 0;
          return r && h < r ? t + An(r - h, s) : t;
        }
        function ru(t, r, s) {
          t = o1(t), r = Ue(r);
          var h = r ? z3(t) : 0;
          return r && h < r ? An(r - h, s) + t : t;
        }
        function ou(t, r, s) {
          return s || r == null ? r = 0 : r && (r = +r), di(o1(t).replace(j5, ""), r || 0);
        }
        function au(t, r, s) {
          return (s ? G1(t, r, s) : r === a) ? r = 1 : r = Ue(r), er(o1(t), r);
        }
        function iu() {
          var t = arguments, r = o1(t[0]);
          return t.length < 3 ? r : r.replace(t[1], t[2]);
        }
        var su = G3(function(t, r, s) {
          return t + (s ? "_" : "") + r.toLowerCase();
        });
        function lu(t, r, s) {
          return s && typeof s != "number" && G1(t, r, s) && (r = s = a), s = s === a ? re : s >>> 0, s ? (t = o1(t), t && (typeof r == "string" || r != null && !Sr(r)) && (r = ot(r), !r && k3(t)) ? r3(gt(t), 0, s) : t.split(r, s)) : [];
        }
        var cu = G3(function(t, r, s) {
          return t + (s ? " " : "") + Er(r);
        });
        function uu(t, r, s) {
          return t = o1(t), s = s == null ? 0 : b3(Ue(s), 0, t.length), r = ot(r), t.slice(s, s + r.length) == r;
        }
        function du(t, r, s) {
          var h = O.templateSettings;
          s && G1(t, r, s) && (r = a), t = o1(t), r = zn({}, r, h, t7);
          var S = zn({}, r.imports, h.imports, t7), R = I1(S), L = M5(S, R), $, G, ie = 0, se = r.interpolate || Z4, le = "__p += '", Ee = z5(
            (r.escape || Z4).source + "|" + se.source + "|" + (se === q4 ? V9 : Z4).source + "|" + (r.evaluate || Z4).source + "|$",
            "g"
          ), Re = "//# sourceURL=" + (a1.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ba + "]") + `
`;
          t.replace(Ee, function(Me, Xe, Qe, it, K1, st) {
            return Qe || (Qe = it), le += t.slice(ie, st).replace(Z9, Ba), Xe && ($ = !0, le += `' +
__e(` + Xe + `) +
'`), K1 && (G = !0, le += `';
` + K1 + `;
__p += '`), Qe && (le += `' +
((__t = (` + Qe + `)) == null ? '' : __t) +
'`), ie = st + Me.length, Me;
          }), le += `';
`;
          var Le = a1.call(r, "variable") && r.variable;
          if (!Le)
            le = `with (obj) {
` + le + `
}
`;
          else if (W9.test(Le))
            throw new $e(g);
          le = (G ? le.replace(V1, "") : le).replace(Y1, "$1").replace(N3, "$1;"), le = "function(" + (Le || "obj") + `) {
` + (Le ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + ($ ? ", __e = _.escape" : "") + (G ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + le + `return __p
}`;
          var Ge = K7(function() {
            return r1(R, Re + "return " + le).apply(a, L);
          });
          if (Ge.source = le, jr(Ge))
            throw Ge;
          return Ge;
        }
        function pu(t) {
          return o1(t).toLowerCase();
        }
        function mu(t) {
          return o1(t).toUpperCase();
        }
        function hu(t, r, s) {
          if (t = o1(t), t && (s || r === a))
            return n6(t);
          if (!t || !(r = ot(r)))
            return t;
          var h = gt(t), S = gt(r), R = r6(h, S), L = o6(h, S) + 1;
          return r3(h, R, L).join("");
        }
        function fu(t, r, s) {
          if (t = o1(t), t && (s || r === a))
            return t.slice(0, i6(t) + 1);
          if (!t || !(r = ot(r)))
            return t;
          var h = gt(t), S = o6(h, gt(r)) + 1;
          return r3(h, 0, S).join("");
        }
        function xu(t, r, s) {
          if (t = o1(t), t && (s || r === a))
            return t.replace(j5, "");
          if (!t || !(r = ot(r)))
            return t;
          var h = gt(t), S = r6(h, gt(r));
          return r3(h, S).join("");
        }
        function gu(t, r) {
          var s = Y, h = W;
          if (h1(r)) {
            var S = "separator" in r ? r.separator : S;
            s = "length" in r ? Ue(r.length) : s, h = "omission" in r ? ot(r.omission) : h;
          }
          t = o1(t);
          var R = t.length;
          if (k3(t)) {
            var L = gt(t);
            R = L.length;
          }
          if (s >= R)
            return t;
          var $ = s - z3(h);
          if ($ < 1)
            return h;
          var G = L ? r3(L, 0, $).join("") : t.slice(0, $);
          if (S === a)
            return G + h;
          if (L && ($ += G.length - $), Sr(S)) {
            if (t.slice($).search(S)) {
              var ie, se = G;
              for (S.global || (S = z5(S.source, o1(w2.exec(S)) + "g")), S.lastIndex = 0; ie = S.exec(se); )
                var le = ie.index;
              G = G.slice(0, le === a ? $ : le);
            }
          } else if (t.indexOf(ot(S), $) != $) {
            var Ee = G.lastIndexOf(S);
            Ee > -1 && (G = G.slice(0, Ee));
          }
          return G + h;
        }
        function yu(t) {
          return t = o1(t), t && Nt.test(t) ? t.replace(b1, Ka) : t;
        }
        var vu = G3(function(t, r, s) {
          return t + (s ? " " : "") + r.toUpperCase();
        }), Er = Y6("toUpperCase");
        function G7(t, r, s) {
          return t = o1(t), r = s ? a : r, r === a ? Wa(t) ? Xa(t) : Na(t) : t.match(r) || [];
        }
        var K7 = Ke(function(t, r) {
          try {
            return nt(t, a, r);
          } catch (s) {
            return jr(s) ? s : new $e(s);
          }
        }), bu = kt(function(t, r) {
          return ut(r, function(s) {
            s = Tt(s), Lt(t, s, br(t[s], t));
          }), t;
        });
        function Cu(t) {
          var r = t == null ? 0 : t.length, s = De();
          return t = r ? p1(t, function(h) {
            if (typeof h[1] != "function")
              throw new dt(p);
            return [s(h[0]), h[1]];
          }) : [], Ke(function(h) {
            for (var S = -1; ++S < r; ) {
              var R = t[S];
              if (nt(R[0], this, h))
                return nt(R[1], this, h);
            }
          });
        }
        function ju(t) {
          return Ki(mt(t, b));
        }
        function Ar(t) {
          return function() {
            return t;
          };
        }
        function Su(t, r) {
          return t == null || t !== t ? r : t;
        }
        var wu = X6(), Tu = X6(!0);
        function Q1(t) {
          return t;
        }
        function _r(t) {
          return E6(typeof t == "function" ? t : mt(t, b));
        }
        function Eu(t) {
          return _6(mt(t, b));
        }
        function Au(t, r) {
          return P6(t, mt(r, b));
        }
        var _u = Ke(function(t, r) {
          return function(s) {
            return p4(s, t, r);
          };
        }), Pu = Ke(function(t, r) {
          return function(s) {
            return p4(t, s, r);
          };
        });
        function Pr(t, r, s) {
          var h = I1(r), S = bn(r, h);
          s == null && !(h1(r) && (S.length || !h.length)) && (s = r, r = t, t = this, S = bn(r, I1(r)));
          var R = !(h1(s) && "chain" in s) || !!s.chain, L = Bt(t);
          return ut(S, function($) {
            var G = r[$];
            t[$] = G, L && (t.prototype[$] = function() {
              var ie = this.__chain__;
              if (R || ie) {
                var se = t(this.__wrapped__), le = se.__actions__ = X1(this.__actions__);
                return le.push({ func: G, args: arguments, thisArg: t }), se.__chain__ = ie, se;
              }
              return G.apply(t, Zt([this.value()], arguments));
            });
          }), t;
        }
        function Ou() {
          return F1._ === this && (F1._ = ni), this;
        }
        function Or() {
        }
        function Iu(t) {
          return t = Ue(t), Ke(function(r) {
            return O6(r, t);
          });
        }
        var Ru = sr(p1), Nu = sr(Z2), Fu = sr(R5);
        function Y7(t) {
          return hr(t) ? N5(Tt(t)) : us(t);
        }
        function Du(t) {
          return function(r) {
            return t == null ? a : C3(t, r);
          };
        }
        var Lu = J6(), Mu = J6(!0);
        function Ir() {
          return [];
        }
        function Rr() {
          return !1;
        }
        function ku() {
          return {};
        }
        function zu() {
          return "";
        }
        function Bu() {
          return !0;
        }
        function $u(t, r) {
          if (t = Ue(t), t < 1 || t > B)
            return [];
          var s = re, h = z1(t, re);
          r = De(r), t -= re;
          for (var S = L5(h, r); ++s < t; )
            r(s);
          return S;
        }
        function Wu(t) {
          return We(t) ? p1(t, Tt) : at(t) ? [t] : X1(h7(o1(t)));
        }
        function Hu(t) {
          var r = ++ei;
          return o1(t) + r;
        }
        var Vu = En(function(t, r) {
          return t + r;
        }, 0), Uu = lr("ceil"), Gu = En(function(t, r) {
          return t / r;
        }, 1), Ku = lr("floor");
        function Yu(t) {
          return t && t.length ? vn(t, Q1, K5) : a;
        }
        function qu(t, r) {
          return t && t.length ? vn(t, De(r, 2), K5) : a;
        }
        function Xu(t) {
          return e6(t, Q1);
        }
        function Zu(t, r) {
          return e6(t, De(r, 2));
        }
        function Ju(t) {
          return t && t.length ? vn(t, Q1, Z5) : a;
        }
        function Qu(t, r) {
          return t && t.length ? vn(t, De(r, 2), Z5) : a;
        }
        var ed = En(function(t, r) {
          return t * r;
        }, 1), td = lr("round"), nd = En(function(t, r) {
          return t - r;
        }, 0);
        function rd(t) {
          return t && t.length ? D5(t, Q1) : 0;
        }
        function od(t, r) {
          return t && t.length ? D5(t, De(r, 2)) : 0;
        }
        return O.after = El, O.ary = T7, O.assign = mc, O.assignIn = z7, O.assignInWith = zn, O.assignWith = hc, O.at = fc, O.before = E7, O.bind = br, O.bindAll = bu, O.bindKey = A7, O.castArray = kl, O.chain = j7, O.chunk = Ks, O.compact = Ys, O.concat = qs, O.cond = Cu, O.conforms = ju, O.constant = Ar, O.countBy = rl, O.create = xc, O.curry = _7, O.curryRight = P7, O.debounce = O7, O.defaults = gc, O.defaultsDeep = yc, O.defer = Al, O.delay = _l, O.difference = Xs, O.differenceBy = Zs, O.differenceWith = Js, O.drop = Qs, O.dropRight = e0, O.dropRightWhile = t0, O.dropWhile = n0, O.fill = r0, O.filter = al, O.flatMap = ll, O.flatMapDeep = cl, O.flatMapDepth = ul, O.flatten = y7, O.flattenDeep = o0, O.flattenDepth = a0, O.flip = Pl, O.flow = wu, O.flowRight = Tu, O.fromPairs = i0, O.functions = Tc, O.functionsIn = Ec, O.groupBy = dl, O.initial = l0, O.intersection = c0, O.intersectionBy = u0, O.intersectionWith = d0, O.invert = _c, O.invertBy = Pc, O.invokeMap = ml, O.iteratee = _r, O.keyBy = hl, O.keys = I1, O.keysIn = J1, O.map = Nn, O.mapKeys = Ic, O.mapValues = Rc, O.matches = Eu, O.matchesProperty = Au, O.memoize = Dn, O.merge = Nc, O.mergeWith = B7, O.method = _u, O.methodOf = Pu, O.mixin = Pr, O.negate = Ln, O.nthArg = Iu, O.omit = Fc, O.omitBy = Dc, O.once = Ol, O.orderBy = fl, O.over = Ru, O.overArgs = Il, O.overEvery = Nu, O.overSome = Fu, O.partial = Cr, O.partialRight = I7, O.partition = xl, O.pick = Lc, O.pickBy = $7, O.property = Y7, O.propertyOf = Du, O.pull = f0, O.pullAll = b7, O.pullAllBy = x0, O.pullAllWith = g0, O.pullAt = y0, O.range = Lu, O.rangeRight = Mu, O.rearg = Rl, O.reject = vl, O.remove = v0, O.rest = Nl, O.reverse = yr, O.sampleSize = Cl, O.set = kc, O.setWith = zc, O.shuffle = jl, O.slice = b0, O.sortBy = Tl, O.sortedUniq = A0, O.sortedUniqBy = _0, O.split = lu, O.spread = Fl, O.tail = P0, O.take = O0, O.takeRight = I0, O.takeRightWhile = R0, O.takeWhile = N0, O.tap = Y0, O.throttle = Dl, O.thru = Rn, O.toArray = L7, O.toPairs = W7, O.toPairsIn = H7, O.toPath = Wu, O.toPlainObject = k7, O.transform = Bc, O.unary = Ll, O.union = F0, O.unionBy = D0, O.unionWith = L0, O.uniq = M0, O.uniqBy = k0, O.uniqWith = z0, O.unset = $c, O.unzip = vr, O.unzipWith = C7, O.update = Wc, O.updateWith = Hc, O.values = q3, O.valuesIn = Vc, O.without = B0, O.words = G7, O.wrap = Ml, O.xor = $0, O.xorBy = W0, O.xorWith = H0, O.zip = V0, O.zipObject = U0, O.zipObjectDeep = G0, O.zipWith = K0, O.entries = W7, O.entriesIn = H7, O.extend = z7, O.extendWith = zn, Pr(O, O), O.add = Vu, O.attempt = K7, O.camelCase = Yc, O.capitalize = V7, O.ceil = Uu, O.clamp = Uc, O.clone = zl, O.cloneDeep = $l, O.cloneDeepWith = Wl, O.cloneWith = Bl, O.conformsTo = Hl, O.deburr = U7, O.defaultTo = Su, O.divide = Gu, O.endsWith = qc, O.eq = vt, O.escape = Xc, O.escapeRegExp = Zc, O.every = ol, O.find = il, O.findIndex = x7, O.findKey = vc, O.findLast = sl, O.findLastIndex = g7, O.findLastKey = bc, O.floor = Ku, O.forEach = S7, O.forEachRight = w7, O.forIn = Cc, O.forInRight = jc, O.forOwn = Sc, O.forOwnRight = wc, O.get = wr, O.gt = Vl, O.gte = Ul, O.has = Ac, O.hasIn = Tr, O.head = v7, O.identity = Q1, O.includes = pl, O.indexOf = s0, O.inRange = Gc, O.invoke = Oc, O.isArguments = w3, O.isArray = We, O.isArrayBuffer = Gl, O.isArrayLike = Z1, O.isArrayLikeObject = C1, O.isBoolean = Kl, O.isBuffer = o3, O.isDate = Yl, O.isElement = ql, O.isEmpty = Xl, O.isEqual = Zl, O.isEqualWith = Jl, O.isError = jr, O.isFinite = Ql, O.isFunction = Bt, O.isInteger = R7, O.isLength = Mn, O.isMap = N7, O.isMatch = ec, O.isMatchWith = tc, O.isNaN = nc, O.isNative = rc, O.isNil = ac, O.isNull = oc, O.isNumber = F7, O.isObject = h1, O.isObjectLike = g1, O.isPlainObject = y4, O.isRegExp = Sr, O.isSafeInteger = ic, O.isSet = D7, O.isString = kn, O.isSymbol = at, O.isTypedArray = Y3, O.isUndefined = sc, O.isWeakMap = lc, O.isWeakSet = cc, O.join = p0, O.kebabCase = Jc, O.last = ft, O.lastIndexOf = m0, O.lowerCase = Qc, O.lowerFirst = eu, O.lt = uc, O.lte = dc, O.max = Yu, O.maxBy = qu, O.mean = Xu, O.meanBy = Zu, O.min = Ju, O.minBy = Qu, O.stubArray = Ir, O.stubFalse = Rr, O.stubObject = ku, O.stubString = zu, O.stubTrue = Bu, O.multiply = ed, O.nth = h0, O.noConflict = Ou, O.noop = Or, O.now = Fn, O.pad = tu, O.padEnd = nu, O.padStart = ru, O.parseInt = ou, O.random = Kc, O.reduce = gl, O.reduceRight = yl, O.repeat = au, O.replace = iu, O.result = Mc, O.round = td, O.runInContext = V, O.sample = bl, O.size = Sl, O.snakeCase = su, O.some = wl, O.sortedIndex = C0, O.sortedIndexBy = j0, O.sortedIndexOf = S0, O.sortedLastIndex = w0, O.sortedLastIndexBy = T0, O.sortedLastIndexOf = E0, O.startCase = cu, O.startsWith = uu, O.subtract = nd, O.sum = rd, O.sumBy = od, O.template = du, O.times = $u, O.toFinite = $t, O.toInteger = Ue, O.toLength = M7, O.toLower = pu, O.toNumber = xt, O.toSafeInteger = pc, O.toString = o1, O.toUpper = mu, O.trim = hu, O.trimEnd = fu, O.trimStart = xu, O.truncate = gu, O.unescape = yu, O.uniqueId = Hu, O.upperCase = vu, O.upperFirst = Er, O.each = S7, O.eachRight = w7, O.first = v7, Pr(O, function() {
          var t = {};
          return St(O, function(r, s) {
            a1.call(O.prototype, s) || (t[s] = r);
          }), t;
        }(), { chain: !1 }), O.VERSION = i, ut(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
          O[t].placeholder = O;
        }), ut(["drop", "take"], function(t, r) {
          Ze.prototype[t] = function(s) {
            s = s === a ? 1 : A1(Ue(s), 0);
            var h = this.__filtered__ && !r ? new Ze(this) : this.clone();
            return h.__filtered__ ? h.__takeCount__ = z1(s, h.__takeCount__) : h.__views__.push({
              size: z1(s, re),
              type: t + (h.__dir__ < 0 ? "Right" : "")
            }), h;
          }, Ze.prototype[t + "Right"] = function(s) {
            return this.reverse()[t](s).reverse();
          };
        }), ut(["filter", "map", "takeWhile"], function(t, r) {
          var s = r + 1, h = s == M || s == J;
          Ze.prototype[t] = function(S) {
            var R = this.clone();
            return R.__iteratees__.push({
              iteratee: De(S, 3),
              type: s
            }), R.__filtered__ = R.__filtered__ || h, R;
          };
        }), ut(["head", "last"], function(t, r) {
          var s = "take" + (r ? "Right" : "");
          Ze.prototype[t] = function() {
            return this[s](1).value()[0];
          };
        }), ut(["initial", "tail"], function(t, r) {
          var s = "drop" + (r ? "" : "Right");
          Ze.prototype[t] = function() {
            return this.__filtered__ ? new Ze(this) : this[s](1);
          };
        }), Ze.prototype.compact = function() {
          return this.filter(Q1);
        }, Ze.prototype.find = function(t) {
          return this.filter(t).head();
        }, Ze.prototype.findLast = function(t) {
          return this.reverse().find(t);
        }, Ze.prototype.invokeMap = Ke(function(t, r) {
          return typeof t == "function" ? new Ze(this) : this.map(function(s) {
            return p4(s, t, r);
          });
        }), Ze.prototype.reject = function(t) {
          return this.filter(Ln(De(t)));
        }, Ze.prototype.slice = function(t, r) {
          t = Ue(t);
          var s = this;
          return s.__filtered__ && (t > 0 || r < 0) ? new Ze(s) : (t < 0 ? s = s.takeRight(-t) : t && (s = s.drop(t)), r !== a && (r = Ue(r), s = r < 0 ? s.dropRight(-r) : s.take(r - t)), s);
        }, Ze.prototype.takeRightWhile = function(t) {
          return this.reverse().takeWhile(t).reverse();
        }, Ze.prototype.toArray = function() {
          return this.take(re);
        }, St(Ze.prototype, function(t, r) {
          var s = /^(?:filter|find|map|reject)|While$/.test(r), h = /^(?:head|last)$/.test(r), S = O[h ? "take" + (r == "last" ? "Right" : "") : r], R = h || /^find/.test(r);
          S && (O.prototype[r] = function() {
            var L = this.__wrapped__, $ = h ? [1] : arguments, G = L instanceof Ze, ie = $[0], se = G || We(L), le = function(Xe) {
              var Qe = S.apply(O, Zt([Xe], $));
              return h && Ee ? Qe[0] : Qe;
            };
            se && s && typeof ie == "function" && ie.length != 1 && (G = se = !1);
            var Ee = this.__chain__, Re = !!this.__actions__.length, Le = R && !Ee, Ge = G && !Re;
            if (!R && se) {
              L = Ge ? L : new Ze(this);
              var Me = t.apply(L, $);
              return Me.__actions__.push({ func: Rn, args: [le], thisArg: a }), new pt(Me, Ee);
            }
            return Le && Ge ? t.apply(this, $) : (Me = this.thru(le), Le ? h ? Me.value()[0] : Me.value() : Me);
          });
        }), ut(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
          var r = rn[t], s = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", h = /^(?:pop|shift)$/.test(t);
          O.prototype[t] = function() {
            var S = arguments;
            if (h && !this.__chain__) {
              var R = this.value();
              return r.apply(We(R) ? R : [], S);
            }
            return this[s](function(L) {
              return r.apply(We(L) ? L : [], S);
            });
          };
        }), St(Ze.prototype, function(t, r) {
          var s = O[r];
          if (s) {
            var h = s.name + "";
            a1.call(H3, h) || (H3[h] = []), H3[h].push({ name: r, func: s });
          }
        }), H3[Tn(a, I).name] = [{
          name: "wrapper",
          func: a
        }], Ze.prototype.clone = yi, Ze.prototype.reverse = vi, Ze.prototype.value = bi, O.prototype.at = q0, O.prototype.chain = X0, O.prototype.commit = Z0, O.prototype.next = J0, O.prototype.plant = el, O.prototype.reverse = tl, O.prototype.toJSON = O.prototype.valueOf = O.prototype.value = nl, O.prototype.first = O.prototype.head, a4 && (O.prototype[a4] = Q0), O;
      }, B3 = Za();
      x3 ? ((x3.exports = B3)._ = B3, _5._ = B3) : F1._ = B3;
    }).call(X3);
  }(w4, w4.exports)), w4.exports;
}
var $r = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
var A8;
function Bh() {
  return A8 || (A8 = 1, function(n) {
    (function(o, a) {
      n.exports ? n.exports = a() : o.numeral = a();
    })(X3, function() {
      var o, a, i = "2.0.6", l = {}, c = {}, p = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: !0
      }, g = {
        currentLocale: p.currentLocale,
        zeroFormat: p.zeroFormat,
        nullFormat: p.nullFormat,
        defaultFormat: p.defaultFormat,
        scalePercentBy100: p.scalePercentBy100
      };
      function u(d, f) {
        this._input = d, this._value = f;
      }
      return o = function(d) {
        var f, b, C, v;
        if (o.isNumeral(d))
          f = d.value();
        else if (d === 0 || typeof d > "u")
          f = 0;
        else if (d === null || a.isNaN(d))
          f = null;
        else if (typeof d == "string")
          if (g.zeroFormat && d === g.zeroFormat)
            f = 0;
          else if (g.nullFormat && d === g.nullFormat || !d.replace(/[^0-9]+/g, "").length)
            f = null;
          else {
            for (b in l)
              if (v = typeof l[b].regexps.unformat == "function" ? l[b].regexps.unformat() : l[b].regexps.unformat, v && d.match(v)) {
                C = l[b].unformat;
                break;
              }
            C = C || o._.stringToNumber, f = C(d);
          }
        else
          f = Number(d) || null;
        return new u(d, f);
      }, o.version = i, o.isNumeral = function(d) {
        return d instanceof u;
      }, o._ = a = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(d, f, b) {
          var C = c[o.options.currentLocale], v = !1, A = !1, P = 0, T = "", I = 1e12, w = 1e9, N = 1e6, E = 1e3, x = "", m = !1, j, _, z, Y, W, D, F;
          if (d = d || 0, _ = Math.abs(d), o._.includes(f, "(") ? (v = !0, f = f.replace(/[\(|\)]/g, "")) : (o._.includes(f, "+") || o._.includes(f, "-")) && (W = o._.includes(f, "+") ? f.indexOf("+") : d < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), o._.includes(f, "a") && (j = f.match(/a(k|m|b|t)?/), j = j ? j[1] : !1, o._.includes(f, " a") && (T = " "), f = f.replace(new RegExp(T + "a[kmbt]?"), ""), _ >= I && !j || j === "t" ? (T += C.abbreviations.trillion, d = d / I) : _ < I && _ >= w && !j || j === "b" ? (T += C.abbreviations.billion, d = d / w) : _ < w && _ >= N && !j || j === "m" ? (T += C.abbreviations.million, d = d / N) : (_ < N && _ >= E && !j || j === "k") && (T += C.abbreviations.thousand, d = d / E)), o._.includes(f, "[.]") && (A = !0, f = f.replace("[.]", ".")), z = d.toString().split(".")[0], Y = f.split(".")[1], D = f.indexOf(","), P = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, Y ? (o._.includes(Y, "[") ? (Y = Y.replace("]", ""), Y = Y.split("["), x = o._.toFixed(d, Y[0].length + Y[1].length, b, Y[1].length)) : x = o._.toFixed(d, Y.length, b), z = x.split(".")[0], o._.includes(x, ".") ? x = C.delimiters.decimal + x.split(".")[1] : x = "", A && Number(x.slice(1)) === 0 && (x = "")) : z = o._.toFixed(d, 0, b), T && !j && Number(z) >= 1e3 && T !== C.abbreviations.trillion)
            switch (z = String(Number(z) / 1e3), T) {
              case C.abbreviations.thousand:
                T = C.abbreviations.million;
                break;
              case C.abbreviations.million:
                T = C.abbreviations.billion;
                break;
              case C.abbreviations.billion:
                T = C.abbreviations.trillion;
                break;
            }
          if (o._.includes(z, "-") && (z = z.slice(1), m = !0), z.length < P)
            for (var M = P - z.length; M > 0; M--)
              z = "0" + z;
          return D > -1 && (z = z.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + C.delimiters.thousands)), f.indexOf(".") === 0 && (z = ""), F = z + x + (T || ""), v ? F = (v && m ? "(" : "") + F + (v && m ? ")" : "") : W >= 0 ? F = W === 0 ? (m ? "-" : "+") + F : F + (m ? "-" : "+") : m && (F = "-" + F), F;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(d) {
          var f = c[g.currentLocale], b = d, C = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          }, v, A, P;
          if (g.zeroFormat && d === g.zeroFormat)
            A = 0;
          else if (g.nullFormat && d === g.nullFormat || !d.replace(/[^0-9]+/g, "").length)
            A = null;
          else {
            A = 1, f.delimiters.decimal !== "." && (d = d.replace(/\./g, "").replace(f.delimiters.decimal, "."));
            for (v in C)
              if (P = new RegExp("[^a-zA-Z]" + f.abbreviations[v] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), b.match(P)) {
                A *= Math.pow(10, C[v]);
                break;
              }
            A *= (d.split("-").length + Math.min(d.split("(").length - 1, d.split(")").length - 1)) % 2 ? 1 : -1, d = d.replace(/[^0-9\.]+/g, ""), A *= Number(d);
          }
          return A;
        },
        isNaN: function(d) {
          return typeof d == "number" && isNaN(d);
        },
        includes: function(d, f) {
          return d.indexOf(f) !== -1;
        },
        insert: function(d, f, b) {
          return d.slice(0, b) + f + d.slice(b);
        },
        reduce: function(d, f) {
          if (this === null)
            throw new TypeError("Array.prototype.reduce called on null or undefined");
          if (typeof f != "function")
            throw new TypeError(f + " is not a function");
          var b = Object(d), C = b.length >>> 0, v = 0, A;
          if (arguments.length === 3)
            A = arguments[2];
          else {
            for (; v < C && !(v in b); )
              v++;
            if (v >= C)
              throw new TypeError("Reduce of empty array with no initial value");
            A = b[v++];
          }
          for (; v < C; v++)
            v in b && (A = f(A, b[v], v, b));
          return A;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function(d) {
          var f = d.toString().split(".");
          return f.length < 2 ? 1 : Math.pow(10, f[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function() {
          var d = Array.prototype.slice.call(arguments);
          return d.reduce(function(f, b) {
            var C = a.multiplier(b);
            return f > C ? f : C;
          }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(d, f, b, C) {
          var v = d.toString().split("."), A = f - (C || 0), P, T, I, w;
          return v.length === 2 ? P = Math.min(Math.max(v[1].length, A), f) : P = A, I = Math.pow(10, P), w = (b(d + "e+" + P) / I).toFixed(P), C > f - P && (T = new RegExp("\\.?0{1," + (C - (f - P)) + "}$"), w = w.replace(T, "")), w;
        }
      }, o.options = g, o.formats = l, o.locales = c, o.locale = function(d) {
        return d && (g.currentLocale = d.toLowerCase()), g.currentLocale;
      }, o.localeData = function(d) {
        if (!d)
          return c[g.currentLocale];
        if (d = d.toLowerCase(), !c[d])
          throw new Error("Unknown locale : " + d);
        return c[d];
      }, o.reset = function() {
        for (var d in p)
          g[d] = p[d];
      }, o.zeroFormat = function(d) {
        g.zeroFormat = typeof d == "string" ? d : null;
      }, o.nullFormat = function(d) {
        g.nullFormat = typeof d == "string" ? d : null;
      }, o.defaultFormat = function(d) {
        g.defaultFormat = typeof d == "string" ? d : "0.0";
      }, o.register = function(d, f, b) {
        if (f = f.toLowerCase(), this[d + "s"][f])
          throw new TypeError(f + " " + d + " already registered.");
        return this[d + "s"][f] = b, b;
      }, o.validate = function(d, f) {
        var b, C, v, A, P, T, I, w;
        if (typeof d != "string" && (d += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", d)), d = d.trim(), d.match(/^\d+$/))
          return !0;
        if (d === "")
          return !1;
        try {
          I = o.localeData(f);
        } catch {
          I = o.localeData(o.locale());
        }
        return v = I.currency.symbol, P = I.abbreviations, b = I.delimiters.decimal, I.delimiters.thousands === "." ? C = "\\." : C = I.delimiters.thousands, w = d.match(/^[^\d]+/), w !== null && (d = d.substr(1), w[0] !== v) || (w = d.match(/[^\d]+$/), w !== null && (d = d.slice(0, -1), w[0] !== P.thousand && w[0] !== P.million && w[0] !== P.billion && w[0] !== P.trillion)) ? !1 : (T = new RegExp(C + "{2}"), d.match(/[^\d.,]/g) ? !1 : (A = d.split(b), A.length > 2 ? !1 : A.length < 2 ? !!A[0].match(/^\d+.*\d$/) && !A[0].match(T) : A[0].length === 1 ? !!A[0].match(/^\d+$/) && !A[0].match(T) && !!A[1].match(/^\d+$/) : !!A[0].match(/^\d+.*\d$/) && !A[0].match(T) && !!A[1].match(/^\d+$/)));
      }, o.fn = u.prototype = {
        clone: function() {
          return o(this);
        },
        format: function(d, f) {
          var b = this._value, C = d || g.defaultFormat, v, A, P;
          if (f = f || Math.round, b === 0 && g.zeroFormat !== null)
            A = g.zeroFormat;
          else if (b === null && g.nullFormat !== null)
            A = g.nullFormat;
          else {
            for (v in l)
              if (C.match(l[v].regexps.format)) {
                P = l[v].format;
                break;
              }
            P = P || o._.numberToFormat, A = P(b, C, f);
          }
          return A;
        },
        value: function() {
          return this._value;
        },
        input: function() {
          return this._input;
        },
        set: function(d) {
          return this._value = Number(d), this;
        },
        add: function(d) {
          var f = a.correctionFactor.call(null, this._value, d);
          function b(C, v, A, P) {
            return C + Math.round(f * v);
          }
          return this._value = a.reduce([this._value, d], b, 0) / f, this;
        },
        subtract: function(d) {
          var f = a.correctionFactor.call(null, this._value, d);
          function b(C, v, A, P) {
            return C - Math.round(f * v);
          }
          return this._value = a.reduce([d], b, Math.round(this._value * f)) / f, this;
        },
        multiply: function(d) {
          function f(b, C, v, A) {
            var P = a.correctionFactor(b, C);
            return Math.round(b * P) * Math.round(C * P) / Math.round(P * P);
          }
          return this._value = a.reduce([this._value, d], f, 1), this;
        },
        divide: function(d) {
          function f(b, C, v, A) {
            var P = a.correctionFactor(b, C);
            return Math.round(b * P) / Math.round(C * P);
          }
          return this._value = a.reduce([this._value, d], f), this;
        },
        difference: function(d) {
          return Math.abs(o(this._value).subtract(d).value());
        }
      }, o.register("locale", "en", {
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        ordinal: function(d) {
          var f = d % 10;
          return ~~(d % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
        },
        currency: {
          symbol: "$"
        }
      }), function() {
        o.register("format", "bps", {
          regexps: {
            format: /(BPS)/,
            unformat: /(BPS)/
          },
          format: function(d, f, b) {
            var C = o._.includes(f, " BPS") ? " " : "", v;
            return d = d * 1e4, f = f.replace(/\s?BPS/, ""), v = o._.numberToFormat(d, f, b), o._.includes(v, ")") ? (v = v.split(""), v.splice(-1, 0, C + "BPS"), v = v.join("")) : v = v + C + "BPS", v;
          },
          unformat: function(d) {
            return +(o._.stringToNumber(d) * 1e-4).toFixed(15);
          }
        });
      }(), function() {
        var d = {
          base: 1e3,
          suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        }, f = {
          base: 1024,
          suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
        }, b = d.suffixes.concat(f.suffixes.filter(function(v) {
          return d.suffixes.indexOf(v) < 0;
        })), C = b.join("|");
        C = "(" + C.replace("B", "B(?!PS)") + ")", o.register("format", "bytes", {
          regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(C)
          },
          format: function(v, A, P) {
            var T, I = o._.includes(A, "ib") ? f : d, w = o._.includes(A, " b") || o._.includes(A, " ib") ? " " : "", N, E, x;
            for (A = A.replace(/\s?i?b/, ""), N = 0; N <= I.suffixes.length; N++)
              if (E = Math.pow(I.base, N), x = Math.pow(I.base, N + 1), v === null || v === 0 || v >= E && v < x) {
                w += I.suffixes[N], E > 0 && (v = v / E);
                break;
              }
            return T = o._.numberToFormat(v, A, P), T + w;
          },
          unformat: function(v) {
            var A = o._.stringToNumber(v), P, T;
            if (A) {
              for (P = d.suffixes.length - 1; P >= 0; P--) {
                if (o._.includes(v, d.suffixes[P])) {
                  T = Math.pow(d.base, P);
                  break;
                }
                if (o._.includes(v, f.suffixes[P])) {
                  T = Math.pow(f.base, P);
                  break;
                }
              }
              A *= T || 1;
            }
            return A;
          }
        });
      }(), function() {
        o.register("format", "currency", {
          regexps: {
            format: /(\$)/
          },
          format: function(d, f, b) {
            var C = o.locales[o.options.currentLocale], v = {
              before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            }, A, P, T;
            for (f = f.replace(/\s?\$\s?/, ""), A = o._.numberToFormat(d, f, b), d >= 0 ? (v.before = v.before.replace(/[\-\(]/, ""), v.after = v.after.replace(/[\-\)]/, "")) : d < 0 && !o._.includes(v.before, "-") && !o._.includes(v.before, "(") && (v.before = "-" + v.before), T = 0; T < v.before.length; T++)
              switch (P = v.before[T], P) {
                case "$":
                  A = o._.insert(A, C.currency.symbol, T);
                  break;
                case " ":
                  A = o._.insert(A, " ", T + C.currency.symbol.length - 1);
                  break;
              }
            for (T = v.after.length - 1; T >= 0; T--)
              switch (P = v.after[T], P) {
                case "$":
                  A = T === v.after.length - 1 ? A + C.currency.symbol : o._.insert(A, C.currency.symbol, -(v.after.length - (1 + T)));
                  break;
                case " ":
                  A = T === v.after.length - 1 ? A + " " : o._.insert(A, " ", -(v.after.length - (1 + T) + C.currency.symbol.length - 1));
                  break;
              }
            return A;
          }
        });
      }(), function() {
        o.register("format", "exponential", {
          regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
          },
          format: function(d, f, b) {
            var C, v = typeof d == "number" && !o._.isNaN(d) ? d.toExponential() : "0e+0", A = v.split("e");
            return f = f.replace(/e[\+|\-]{1}0/, ""), C = o._.numberToFormat(Number(A[0]), f, b), C + "e" + A[1];
          },
          unformat: function(d) {
            var f = o._.includes(d, "e+") ? d.split("e+") : d.split("e-"), b = Number(f[0]), C = Number(f[1]);
            C = o._.includes(d, "e-") ? C *= -1 : C;
            function v(A, P, T, I) {
              var w = o._.correctionFactor(A, P), N = A * w * (P * w) / (w * w);
              return N;
            }
            return o._.reduce([b, Math.pow(10, C)], v, 1);
          }
        });
      }(), function() {
        o.register("format", "ordinal", {
          regexps: {
            format: /(o)/
          },
          format: function(d, f, b) {
            var C = o.locales[o.options.currentLocale], v, A = o._.includes(f, " o") ? " " : "";
            return f = f.replace(/\s?o/, ""), A += C.ordinal(d), v = o._.numberToFormat(d, f, b), v + A;
          }
        });
      }(), function() {
        o.register("format", "percentage", {
          regexps: {
            format: /(%)/,
            unformat: /(%)/
          },
          format: function(d, f, b) {
            var C = o._.includes(f, " %") ? " " : "", v;
            return o.options.scalePercentBy100 && (d = d * 100), f = f.replace(/\s?\%/, ""), v = o._.numberToFormat(d, f, b), o._.includes(v, ")") ? (v = v.split(""), v.splice(-1, 0, C + "%"), v = v.join("")) : v = v + C + "%", v;
          },
          unformat: function(d) {
            var f = o._.stringToNumber(d);
            return o.options.scalePercentBy100 ? f * 0.01 : f;
          }
        });
      }(), function() {
        o.register("format", "time", {
          regexps: {
            format: /(:)/,
            unformat: /(:)/
          },
          format: function(d, f, b) {
            var C = Math.floor(d / 60 / 60), v = Math.floor((d - C * 60 * 60) / 60), A = Math.round(d - C * 60 * 60 - v * 60);
            return C + ":" + (v < 10 ? "0" + v : v) + ":" + (A < 10 ? "0" + A : A);
          },
          unformat: function(d) {
            var f = d.split(":"), b = 0;
            return f.length === 3 ? (b = b + Number(f[0]) * 60 * 60, b = b + Number(f[1]) * 60, b = b + Number(f[2])) : f.length === 2 && (b = b + Number(f[0]) * 60, b = b + Number(f[1])), Number(b);
          }
        });
      }(), o;
    });
  }($r)), $r.exports;
}
(function(n, o) {
  (function(a, i) {
    n.exports = i(kh, zh(), Bh());
  })(self, function(a, i, l) {
    return (() => {
      var c = { 605: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = { margin: { top: 20, right: 30, bottom: 20, left: 40 }, yTicks: 4, xFormat: x.format(",.0f"), yFormat: x.format("s") }, k = K - (q = Object.assign({}, B, q)).margin.left - q.margin.right, H = J - q.margin.top - q.margin.bottom, re = x.scaleLinear().domain(x.extent(F, function(Z) {
                return Z.x;
              })).range([0, k]), te = x.scaleLinear().domain([0, x.max(F, function(Z) {
                return Z.y;
              })]).range([H, 0]), U = x.axisBottom().scale(re).tickFormat(q.xFormat).ticks(10), me = x.axisLeft().scale(te).tickFormat(q.yFormat).ticks(q.yTicks), Q = x.area().x(function(Z) {
                return re(Z.x);
              }).y0(H).y1(function(Z) {
                return te(Z.y);
              }), ge = this.createSvg(M, K, J).append("g").attr("transform", "translate(" + q.margin.left + "," + q.margin.top + ")");
              ge.append("path").data([F]).attr("class", "area").attr("d", Q), ge.append("g").attr("class", "x axis").attr("transform", "translate(0," + H + ")").call(U), ge.append("g").attr("class", "y axis").call(me);
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 648: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = this.getOptions({ maxPercent: 100 }, q), k = this.createSvg(M, K, J), H = k.append("g").attr("transform", "translate(".concat(K / 2, ", ").concat(J / 2, ")")), re = Math.min(K - 10, J - 10) / 2, te = 0.3 * re, U = x.scaleLinear().domain([0, B.maxPercent]).range([te, re]), me = x.arc().innerRadius(te).outerRadius(function(Te) {
                return U(Te.data.percent);
              }), Q = x.arc().innerRadius(te).outerRadius(re), ge = [0, 2 * Math.PI], Z = x.pie().sort(null).startAngle(ge[0]).endAngle(ge[1]).value(function(Te) {
                return Te.weight;
              });
              F.length > 1 && Z.padAngle(0.01), H.selectAll(".solidArc").data(Z(F)).enter().append("path").attr("fill", function(Te) {
                return B.colors(Te.data.id);
              }).attr("class", "solidArc").attr("d", me), H.selectAll(".outlineArc").data(Z(F)).enter().append("path").attr("fill", "none").attr("stroke", function(Te) {
                return B.colors(Te.data.id);
              }).attr("class", "outlineArc").attr("d", Q), B.asterLabel && k.append("svg:text").attr("class", "aster-label").attr("dy", ".35em").attr("text-anchor", "middle").text(asterLabel());
              for (var fe = H.append("g").attr("class", "axisWrapper"), Se = Math.ceil(B.maxPercent / 25), be = 1; be < Se; be++) fe.append("circle").attr("class", "gridCircle").attr("r", U(25 * be)).style("fill", "none").style("stroke", "#c5c5c5").style("stroke-width", 0.6), be % 2 == 1 && (fe.append("rect").attr("x", -8).attr("y", -U(25 * be) - 5).attr("width", 20).style("height", 10).attr("fill", "#fff"), fe.append("text").attr("class", "axisLabel").attr("x", -6).attr("y", -U(25 * be)).attr("dy", ".4em").style("font-size", "8px").attr("fill", "#737373").text(function(Te, Pe) {
                return "".concat(25 * be, "%");
              }));
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 131: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "render", value: function(F, M, K, J, q) {
              var B = this;
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var k = this.getOptions({ label: "label", value: "value", rotate: 0, textAnchor: "middle", showLabels: !1 }, q), H = this.createSvg(M, K, J);
              this.useTip(function(we) {
                we.attr("class", "d3-tip").offset([-10, 0]).html(function(he) {
                  return he.value;
                });
              });
              var re = k.label, te = k.value, U = 0;
              F.forEach(function(we) {
                U += we[te];
              });
              var me = K - k.margins.left - k.margins.right, Q = J - k.margins.top - k.margins.bottom, ge = x.scaleBand().range([0, me]).padding(0.1).round(1 / F.length), Z = x.scaleLinear().range([Q, 0]), fe = x.axisBottom().scale(ge).tickSize(2, 0), Se = x.axisLeft().scale(Z).tickFormat(k.yFormat).ticks(5);
              ge.domain(F.map(function(we) {
                return we[re];
              })), Z.domain([0, k.yMax || x.max(F, function(we) {
                return we[te];
              })]);
              var be = H.append("g").attr("class", "axis");
              be.call(fe);
              var Te = Math.round(be.node().getBBox().height), Pe = Math.round(be.node().getBBox().width);
              Q -= Te, me -= Math.max(0, Pe - me), be.remove();
              var xe = H.append("g").attr("class", "axis");
              xe.call(Se);
              var Ie = Math.round(xe.node().getBBox().width);
              me -= Ie, xe.remove(), ge.range([0, me]), Z.range([Q, 0]), (H = H.append("g").attr("transform", `translate(
	          `.concat(k.margins.left + Ie, `,
	          `).concat(k.margins.top, `
	        )`))).append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Q, ")")).call(fe).selectAll(".tick text").style("text-anchor", k.textAnchor).attr("transform", function(we) {
                return "rotate(".concat(k.rotate, ")");
              }), k.wrap && H.selectAll(".tick text").call(this.wrap, ge.bandwidth()), H.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(Se), H.selectAll(".bar").data(F).enter().append("rect").attr("class", "bar").attr("x", function(we) {
                return ge(we[re]);
              }).attr("width", ge.bandwidth()).attr("y", function(we) {
                return Z(we[te]);
              }).attr("height", function(we) {
                return Q - Z(we[te]);
              }).attr("title", function(we) {
                var he = "".concat(we[re], ": ").concat(B.formatters.commaseparated(we[te], ","));
                return he += " (".concat(U > 0 ? B.formatters.formatpercent(we[te] / U) : B.formatters.formatpercent(0), ")");
              }).style("fill", function(we) {
                return k.colors(we[re]);
              }).on("mouseover", function(we) {
                return B.tip.show(we, event.target);
              }).on("mouseout", function(we) {
                return B.tip.hide(we, event.target);
              }).exit().remove(), k.showLabels && H.selectAll(".barlabel").data(F).enter().append("text").attr("class", "barlabel").text(function(we) {
                return B.formatters.formatpercent(we[te] / U);
              }).attr("x", function(we) {
                return ge(we[re]) + ge.bandwidth() / 2;
              }).attr("y", function(we) {
                return Z(we[te]) - 3;
              }).attr("text-anchor", "middle");
            } }, { key: "formatters", get: function() {
              return { commaseparated: x.format(","), formatpercent: x.format(".1%") };
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 316: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "defaultTip", value: function(F, M) {
              F.attr("class", "d3-tip").offset(function(K) {
                return K.tipOffset || [-10, 0];
              }).direction(function(K) {
                return K.tipDirection || "n";
              }).html(function(K) {
                return `<table class='boxplotValues'>
					<tr>
						<td>Max:</td>
						<td>`.concat(M.valueFormatter(K.max), `</td>
					</tr>
					<tr>
						<td>P90:</td>
						<td>`).concat(M.valueFormatter(K.UIF), `</td>
					</tr>
					<tr>
						<td>P75:</td>
						<td>`).concat(M.valueFormatter(K.q3), `</td>
					</tr>
					<tr>
						<td>Median:</td>
						<td>`).concat(M.valueFormatter(K.median), `</td>
					</tr>
					<tr>
						<td>P25:</td>
						<td>`).concat(M.valueFormatter(K.q1), `</td>
					</tr>
					<tr>
						<td>P10:</td>
						<td>`).concat(M.valueFormatter(K.LIF), `</td>
					</tr>
					<tr>
						<td>Min:</td>
						<td>`).concat(M.valueFormatter(K.min), `</td>
					</tr>
				</table>`);
              });
            } }, { key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = { valueFormatter: this.formatters.formatSI(3) }, k = this.getOptions(B, q), H = this.createSvg(M, K, J);
              k.valueFormatter, this.useTip(this.defaultTip, k);
              var re = 0, te = 0;
              if (k.xLabel) {
                var U = H.append("g").attr("transform", "translate(".concat(K / 2, ", ").concat(J - k.margins.bottom, ")"));
                U.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(k.xLabel), re = U.node().getBBox().height;
              }
              if (k.yLabel) {
                var me = H.append("g").attr("transform", `translate(
	            `.concat(k.margins.left, `,
	            `).concat((J - k.margins.bottom - k.margins.top) / 2 + k.margins.top, `
	          )`));
                me.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(k.yLabel), te = me.node().getBBox().width;
              }
              var Q = K - k.margins.left - te - k.margins.right, ge = J - k.margins.top - re - k.margins.bottom, Z = x.scaleBand().range([0, Q]).round(1 / F.length).domain(F.map(function(de) {
                return de.Category;
              })), fe = x.scaleLinear().range([ge, 0]).domain([k.yMin || 0, k.yMax || x.max(F, function(de) {
                return de.max;
              })]), Se = x.axisBottom().scale(Z), be = x.axisLeft().scale(fe).tickFormat(k.yFormat).ticks(5), Te = H.append("g").attr("class", "axis");
              Te.call(Se);
              var Pe = Math.round(Te.node().getBBox().height), xe = Math.round(Te.node().getBBox().width);
              ge -= Pe, Q -= Math.max(0, xe - Q), Te.remove();
              var Ie = H.append("g").attr("class", "axis");
              Ie.call(be);
              var we = Math.round(Ie.node().getBBox().width);
              Q -= we, Ie.remove(), Z.range([0, Q]), fe.range([ge, 0]);
              var he = Z.bandwidth() / 2 - 5, Oe = Z.bandwidth() / 2 - 2.5, ue = H.append("g").attr("transform", `translate(
	          `.concat(k.margins.left + te + we, `,
	          `).concat(k.margins.top, `
	        )`)), ye = ue.selectAll(".boxplot").data(F).enter().append("g").attr("class", "boxplot").attr("transform", function(de) {
                return "translate(".concat(Z(de.Category), ", 0)");
              }), ae = this;
              ye.each(function(de) {
                var ve = x.select(this);
                de.LIF != de.q1 && (ve.append("line").attr("class", "bar").attr("x1", Oe).attr("y1", fe(de.LIF)).attr("x2", Oe + 5).attr("y2", fe(de.LIF)), ve.append("line").attr("class", "whisker").attr("x1", Z.bandwidth() / 2).attr("y1", fe(de.LIF)).attr("x2", Z.bandwidth() / 2).attr("y2", fe(de.q1))), ve.append("rect").attr("class", "box").attr("x", he).attr("y", fe(de.q3)).attr("width", 10).attr("height", Math.max(1, fe(de.q1) - fe(de.q3))).on("mouseover", function(Ae) {
                  return ae.tip.show(Ae, event.target);
                }).on("mouseout", function(Ae) {
                  return ae.tip.hide(Ae, event.target);
                }), ve.append("line").attr("class", "median").attr("x1", he).attr("y1", fe(de.median)).attr("x2", he + 10).attr("y2", fe(de.median)), de.UIF != de.q3 && (ve.append("line").attr("class", "bar").attr("x1", Oe).attr("y1", fe(de.UIF)).attr("x2", Z.bandwidth() - Oe).attr("y2", fe(de.UIF)), ve.append("line").attr("class", "whisker").attr("x1", Z.bandwidth() / 2).attr("y1", fe(de.UIF)).attr("x2", Z.bandwidth() / 2).attr("y2", fe(de.q3)));
              }), ue.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ge, ")")).call(Se), ue.selectAll(".tick text").call(this.wrap, Z.bandwidth() || Z.range()), ue.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(be);
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 842: (u, d, f) => {
        var b, C;
        function v(A, P) {
          for (var T = 0; T < P.length; T++) {
            var I = P[T];
            I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(A, I.key, I);
          }
        }
        b = [f(680), f(92), f(383)], C = (function(A, P, T) {
          var I = function() {
            function w() {
              (function(m, j) {
                if (!(m instanceof j)) throw new TypeError("Cannot call a class as a function");
              })(this, w);
            }
            var N, E, x;
            return N = w, E = [{ key: "render", value: function(m, j, _, z, Y) {
              var W = this;
              typeof j == "string" && (j = document.querySelector(j)), this.cachedData = m, this.doResize || (this.doResize = P.debounce(function() {
                W.render(W.cachedData, j, j.clientWidth, j.clientHeight, Y);
              }, 250), window.addEventListener("resize", this.doResize));
            } }, { key: "getOptions", value: function(m, j) {
              return Object.assign({}, { margins: { top: 10, right: 10, bottom: 10, left: 10 }, xFormat: A.format(",.0f"), yFormat: A.format("s"), colors: A.scaleOrdinal(A.schemeCategory20.concat(A.schemeCategory20c)) }, Object.assign({}, m), Object.assign({}, j));
            } }, { key: "createSvg", value: function(m, j, _) {
              this.destroyTipIfExists();
              var z = A.select(m);
              z.select("svg").remove();
              var Y = z.append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `
	        0
	        0
	        `.concat(j, `
	        `).concat(_)).append("g").attr("class", "chart");
              return this.chart = Y, Y;
            } }, { key: "useTip", value: function() {
              var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
              }, j = arguments.length > 1 ? arguments[1] : void 0;
              return this.destroyTipIfExists(), this.tip = T().attr("class", "d3-tip"), m(this.tip, j), this.chart && this.chart.call(this.tip), this.tip;
            } }, { key: "destroyTipIfExists", value: function() {
              this.tip && this.tip.destroy();
            } }, { key: "truncate", value: function(m, j) {
              m.each(function() {
                for (var _ = A.select(this), z = _.text(), Y = _.node().getComputedTextLength(), W = _.text(); Y > j && W.length > 0; ) W = W.slice(0, -1), _.text("".concat(W, "...")), Y = _.node().getComputedTextLength();
                _.append("title").text(z);
              });
            } }, { key: "wrap", value: function(m, j, _) {
              m.each(function() {
                for (var z, Y = A.select(this), W = Y.text(), D = Y.text().split(/\s+/).reverse(), F = [], M = 0, K = 0, J = Y.attr("y"), q = parseFloat(Y.attr("dy")), B = Y.text(null).append("tspan").attr("x", 0).attr("y", J).attr("dy", "".concat(q, "em")); z = D.pop(); ) if (F.push(z), B.text(F.join(" ")), B.node().getComputedTextLength() > j) {
                  if (F.length > 1) {
                    F.pop(), D.push(z);
                    var k = _ && ++K === _ ? "".concat(F.splice(0, F.length - 1).join(" "), "...") : F.join(" ");
                    B.text(k);
                  }
                  if (F = [], B = Y.append("tspan").attr("x", 0).attr("y", J).attr("dy", "".concat(1.1 * ++M + q, "em")), _ && _ === K) {
                    B.remove();
                    break;
                  }
                }
                Y.append("title").text(W);
              });
            } }, { key: "tooltipFactory", value: function(m) {
              return function(j) {
                var _ = "";
                if (m !== void 0) for (var z = 0; z < m.length; z += 1) {
                  var Y = m[z].accessor(j);
                  m[z].format !== void 0 && (Y = m[z].format(Y)), _ += "".concat(m[z].label, ": ").concat(Y, "</br>");
                }
                return _;
              };
            } }, { key: "lineDefaultTooltip", value: function(m, j, _, z, Y, W, D) {
              return function(F) {
                var M = "";
                return D(F) && (M = "Series: ".concat(D(F), "</br>")), M += "".concat(m, ": ").concat(j(_(F)), "</br>"), M += "".concat(z, ": ").concat(Y(W(F)));
              };
            } }, { key: "donutDefaultTooltip", value: function(m, j, _) {
              return function(z) {
                return "".concat(m(z), ": ").concat(j(z), " (").concat(_(z), ")");
              };
            } }, { key: "dispose", value: function() {
              this.destroyTipIfExists(), this.doResize && window.removeEventListener("resize", this.doResize);
            } }, { key: "formatters", get: function() {
              return { formatSI: function(m) {
                m = m || 0;
                var j = A.format(",.".concat(m, "s"));
                return function(_) {
                  return _ < 1 ? _.toFixed(m).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "") : j(_).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "");
                };
              } };
            } }], x = [{ key: "normalizeDataframe", value: function(m) {
              var j = A.keys(m), _ = Object.assign({}, m);
              return j.forEach(function(z) {
                m[z] instanceof Array || (_[z] = [m[z]]);
              }), _;
            } }, { key: "dataframeToArray", value: function(m) {
              var j = A.keys(m);
              return m[j[0]] instanceof Array ? m[j[0]].map(function(_, z) {
                var Y = {};
                return j.forEach(function(W) {
                  Y[W] = m[W][z];
                }), Y;
              }) : [m];
            } }, { key: "mapMonthYearDataToSeries", value: function(m, j) {
              var _ = Object.assign({}, { dateField: "x", yValue: "y", yPercent: "p" }, j), z = { name: "All Time", values: [] };
              return m[_.dateField].map(function(Y, W) {
                z.values.push({ xValue: new Date(Math.floor(m[_.dateField][W] / 100), m[_.dateField][W] % 100 - 1, 1), yValue: m[_.yValue][W], yPercent: m[_.yPercent][W] });
              }), z.values.sort(function(Y, W) {
                return Y.xValue - W.xValue;
              }), [z];
            } }, { key: "prepareData", value: function(m, j) {
              if (j === this.chartTypes.BOXPLOT) {
                if (!m.CATEGORY.length) return null;
                var _ = m.CATEGORY.map(function(z, Y) {
                  return { Category: m.CATEGORY[Y], min: m.MIN_VALUE[Y], max: m.MAX_VALUE[Y], median: m.MEDIAN_VALUE[Y], LIF: m.P10_VALUE[Y], q1: m.P25_VALUE[Y], q3: m.P75_VALUE[Y], UIF: m.P90_VALUE[Y] };
                }, m);
                return Object.values(_).reduce(function(z, Y) {
                  return z.concat(Y);
                }, []).length ? _ : null;
              }
            } }, { key: "chartTypes", get: function() {
              return { AREA: "AREA", BOXPLOT: "BOXPLOT", DONUT: "DONUT", HISTOGRAM: "HISTOGRAM", LINE: "LINE", TRELLISLINE: "TRELLISLINE" };
            } }], E && v(N.prototype, E), x && v(N, x), w;
          }();
          return I;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 535: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(756), f(842)], C = (function(x, m, j) {
          var _ = function(z) {
            (function(M, K) {
              if (typeof K != "function" && K !== null) throw new TypeError("Super expression must either be null or a function");
              M.prototype = Object.create(K && K.prototype, { constructor: { value: M, writable: !0, configurable: !0 } }), K && I(M, K);
            })(F, z);
            var Y, W, D = w(F);
            function F() {
              return A(this, F), D.apply(this, arguments);
            }
            return Y = F, (W = [{ key: "render", value: function(M, K, J, q, B) {
              var k = this;
              T(E(F.prototype), "render", this).call(this, M, K, J, q, B);
              var H = this.getOptions(B), re = this.createSvg(K, J, q), te = 0;
              M.forEach(function(xe) {
                te += +xe.value;
              });
              var U = this.donutDefaultTooltip(function(xe) {
                return xe.label;
              }, function(xe) {
                return m(xe.value).format("0,0");
              }, function(xe) {
                return k.formatters.formatpercent(te != 0 ? xe.value / te : 0);
              });
              if (this.useTip(function(xe) {
                return xe.attr("class", "d3-tip").direction("s").offset([3, 0]).html(U);
              }), M.length > 0) {
                var me = re.append("g").attr("id", "chart"), Q = x.drag().on("drag", function() {
                  var xe = x.select(this), Ie = event.y - parseFloat(xe.attr("initialY"));
                  if (isNaN(Ie)) return !1;
                  xe.attr("transform", `translate(
	        `.concat(parseFloat(xe.attr("initialPositionX")), `,
	        `).concat(parseFloat(xe.attr("initialPositionY")) + Ie, `
	      )`));
                }).on("start", function() {
                  var xe = x.select(this);
                  xe.attr("initialX", event.x), xe.attr("initialY", event.y);
                }).on("end", function() {
                  var xe = x.select(this);
                  xe.transition().duration(300).attr("transform", `translate(
	          `.concat(xe.attr("initialPositionX"), `,
	          `).concat(xe.attr("initialPositionY"), `
	        )`));
                }), ge = re.append("g").attr("class", "legend").call(Q);
                ge.selectAll("rect").data(M).enter().append("rect").attr("x", 0).attr("y", function(xe, Ie) {
                  return 15 * Ie;
                }).attr("width", 10).attr("height", 10).style("fill", function(xe) {
                  return H.colors(xe.id);
                });
                var Z = 0, fe = ge.selectAll("g.legend-item").data(M).enter().append("g").attr("class", "legend-item");
                fe.append("text").attr("x", 12).attr("y", function(xe, Ie) {
                  return 15 * Ie + 9;
                }).text(function(xe) {
                  return xe.label;
                }), fe.append("title").attr("x", 12).attr("y", function(xe, Ie) {
                  return 15 * Ie + 9;
                }).text(function(xe) {
                  return xe.label;
                }), fe.each(function() {
                  var xe = this.getBBox().width;
                  xe > Z && Z + xe < 0.75 * J && (Z = xe);
                }), Z += 12, ge.attr("transform", `translate(
	            `.concat(J - Z - H.margins.right, `,
	            `).concat(H.margins.top, `
	          )`)).attr("initialPositionX", J - Z - H.margins.right).attr("initialPositionY", H.margins.top), me.attr("transform", "translate(".concat((J - Z) / 2, ", ").concat(q / 2, ")"));
                var Se = Math.min(q, J - Z) / 2 - H.margins.top, be = Math.min(q, J - Z) / 6 - H.margins.top, Te = x.arc().innerRadius(be).outerRadius(Se), Pe = x.pie().value(function(xe) {
                  return xe.value > 0 ? Math.max(xe.value, 0.015 * te) : 0;
                });
                me.selectAll("g.slice").data(Pe(M)).enter().append("g").attr("class", "slice").append("path").attr("fill", function(xe) {
                  return H.colors(xe.data.id);
                }).attr("stroke", "#fff").attr("stroke-width", 5).attr("title", function(xe) {
                  return xe.label;
                }).on("mouseover", function(xe) {
                  return k.tip.show(xe.data, event.target);
                }).on("mouseout", function(xe) {
                  return k.tip.hide(xe.data, event.target);
                }).attr("d", Te);
              } else re.append("text").attr("transform", "translate(".concat(J / 2, ", ").concat(q / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "formatters", get: function() {
              return { formatpercent: x.format(".1%") };
            } }]) && P(Y.prototype, W), F;
          }(j);
          return _;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 502: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(756), f(842)], C = (function(x, m, j) {
          var _ = function(z) {
            (function(K, J) {
              if (typeof J != "function" && J !== null) throw new TypeError("Super expression must either be null or a function");
              K.prototype = Object.create(J && J.prototype, { constructor: { value: K, writable: !0, configurable: !0 } }), J && I(K, J);
            })(M, z);
            var Y, W, D, F = w(M);
            function M() {
              return A(this, M), F.apply(this, arguments);
            }
            return Y = M, D = [{ key: "mapHistogram", value: function(K) {
              for (var J = [], q = K.OFFSET || 0, B = K.INTERVAL_SIZE, k = this.normalizeDataframe(K.DATA), H = 0; H < K.INTERVALS; H += 1) {
                var re = {};
                re.x = q + 1 * k.INTERVAL_INDEX[H] * B, re.dx = B, re.y = k.COUNT_VALUE[H] || 0, J.push(re);
              }
              return J;
            } }], (W = [{ key: "drawBoxplot", value: function(K, J, q, B) {
              var k = K, H = this.xScale, re = B / 2;
              J.LIF !== J.q1 && (k.append("line").attr("class", "bar").attr("x1", H(J.LIF)).attr("y1", B / 2 - re / 2).attr("x2", H(J.LIF)).attr("y2", B / 2 + re / 2), k.append("line").attr("class", "whisker").attr("x1", H(J.LIF)).attr("y1", B / 2).attr("x2", H(J.q1)).attr("y2", B / 2)), k.append("rect").attr("class", "box").attr("x", H(J.q1)).attr("width", H(J.q3) - H(J.q1)).attr("height", B), k.append("line").attr("class", "median").attr("x1", H(J.median)).attr("y1", 0).attr("x2", H(J.median)).attr("y2", B), J.UIF !== J.q3 && (k.append("line").attr("class", "bar").attr("x1", H(J.UIF)).attr("y1", B / 2 - re / 2).attr("x2", H(J.UIF)).attr("y2", B / 2 + re / 2), k.append("line").attr("class", "whisker").attr("x1", H(J.q3)).attr("y1", B / 2).attr("x2", H(J.UIF)).attr("y2", B / 2));
            } }, { key: "render", value: function(K, J, q, B, k) {
              var H = this;
              T(E(M.prototype), "render", this).call(this, K, J, q, B, k);
              var re = { ticks: 10, yTicks: 4, yScale: x.scaleLinear(), boxplotHeight: 10, getTooltipBuilder: null }, te = this.getOptions(re, k), U = this.createSvg(J, q, B);
              this.xScale = {};
              var me = K || [], Q = typeof te.getTooltipBuilder == "function" ? te.getTooltipBuilder(te) : function(Ae) {
                return m(Ae.y).format("0,0");
              };
              this.useTip(function(Ae) {
                Ae.attr("class", "d3-tip").offset([-10, 0]).html(Q);
              });
              var ge = 0, Z = 0;
              if (te.xLabel) {
                var fe = U.append("g").attr("transform", "translate(".concat(q / 2, ", ").concat(B - te.margins.bottom, ")"));
                fe.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(te.xLabel), ge = fe.node().getBBox().height;
              }
              if (te.yLabel) {
                var Se = U.append("g").attr("transform", `translate(
	            `.concat(te.margins.left, `,
	            `).concat((B - te.margins.bottom - te.margins.top) / 2 + te.margins.top, `
	          )`));
                Se.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(te.yLabel), Z = 1.5 * Se.node().getBBox().width;
              }
              var be = q - te.margins.left - te.margins.right - Z, Te = B - te.margins.top - te.margins.bottom - ge, Pe = this.xScale = x.scaleLinear().domain(te.xDomain || [x.min(me, function(Ae) {
                return Ae.x;
              }), x.max(me, function(Ae) {
                return Ae.x + Ae.dx;
              })]).range([0, be]), xe = x.axisBottom().scale(Pe).ticks(te.ticks).tickFormat(te.xFormat), Ie = te.yScale.domain([0, te.yMax || x.max(me, function(Ae) {
                return Ae.y;
              })]).range([Te, 0]), we = x.axisLeft().scale(Ie).ticks(te.yTicks).tickFormat(te.yFormat), he = U.append("g").attr("class", "axis");
              he.call(xe);
              var Oe = Math.round(he.node().getBBox().height), ue = Math.round(he.node().getBBox().width);
              Te -= Oe, be -= Math.max(0, ue - be), he.remove();
              var ye = U.append("g").attr("class", "axis");
              ye.call(we);
              var ae = Math.round(ye.node().getBBox().width);
              if (be -= ae, ye.remove(), te.boxplot) {
                Te -= 12;
                var de = U.append("g").attr("class", "boxplot").attr("transform", "translate(".concat(te.margins.left + Z + ae, `,
	          `).concat(te.margins.top + Te + Oe, ")"));
                this.drawBoxplot(de, te.boxplot, be, 8);
              }
              Pe.range([0, be]), Ie.range([Te, 0]);
              var ve = U.append("g").attr("transform", `translate(
	        `.concat(te.margins.left + Z + ae, `,
	        `).concat(te.margins.top, ")"));
              ve.selectAll(".bar").data(me).enter().append("g").attr("class", "bar").attr("transform", function(Ae) {
                return "translate(".concat(Pe(Ae.x), ", ").concat(Ie(Ae.y), ")");
              }).on("mouseover", function(Ae) {
                return H.tip.show(Ae, event.target);
              }).on("mouseout", function(Ae) {
                return H.tip.hide(Ae, event.target);
              }).append("rect").attr("x", 1).attr("width", function(Ae) {
                return Math.max(Pe(Ae.x + Ae.dx) - Pe(Ae.x) - 1, 0.5);
              }).attr("height", function(Ae) {
                return Te - Ie(Ae.y);
              }), ve.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Te, ")")).call(xe), ve.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(we);
            } }]) && P(Y.prototype, W), D && P(Y, D), M;
          }(j);
          return _;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 487: (u, d, f) => {
        var b, C;
        function v(E) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, v(E);
        }
        function A(E, x) {
          if (!(E instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function P(E, x) {
          for (var m = 0; m < x.length; m++) {
            var j = x[m];
            j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(E, j.key, j);
          }
        }
        function T(E, x) {
          return T = Object.setPrototypeOf || function(m, j) {
            return m.__proto__ = j, m;
          }, T(E, x);
        }
        function I(E) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var m, j = N(E);
            if (x) {
              var _ = N(this).constructor;
              m = Reflect.construct(j, arguments, _);
            } else m = j.apply(this, arguments);
            return w(this, m);
          };
        }
        function w(E, x) {
          return !x || v(x) !== "object" && typeof x != "function" ? function(m) {
            if (m === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return m;
          }(E) : x;
        }
        function N(E) {
          return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, N(E);
        }
        b = [f(680), f(316)], C = (function(E, x) {
          var m = function(j) {
            (function(D, F) {
              if (typeof F != "function" && F !== null) throw new TypeError("Super expression must either be null or a function");
              D.prototype = Object.create(F && F.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), F && T(D, F);
            })(W, j);
            var _, z, Y = I(W);
            function W() {
              return A(this, W), Y.apply(this, arguments);
            }
            return _ = W, (z = [{ key: "render", value: function(D, F, M, K, J) {
              var q = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 4 } }, B = this.getOptions(q, J), k = K < D.length * B.boxHeight ? D.length * B.boxHeight : K, H = this.createSvg(F, M, k), re = B.valueFormatter;
              this.useTip(this.defaultTip, B), D.forEach(function(de) {
                return de.Category = de.Category || "Default";
              });
              var te = M - B.margins.left - B.margins.right;
              k = k - B.margins.top - B.margins.bottom;
              var U = E.scaleLinear().range([0, te]).domain([B.xMin || E.min(D, function(de) {
                return de.min;
              }), B.xMax || E.max(D, function(de) {
                return de.max;
              })]).nice(), me = E.scaleBand().range([0, k]).round(1 / D.length).domain(D.map(function(de) {
                return de.Category;
              })), Q = E.axisBottom().scale(U).tickFormat(re), ge = E.axisLeft().scale(me), Z = E.scaleOrdinal().domain(D.map(function(de) {
                return de.Category;
              })).range(["#ff9315", "#0d61ff", "gold", "blue", "green", "red", "black", "orange", "brown", "grey", "slateblue", "grey1", "darkgreen"]), fe = 0, Se = fe;
              if (B.showXAxis) {
                var be = H.append("g").attr("class", "axis");
                be.call(Q), fe = Math.round(be.node().getBBox().height) + 2, Se = Math.round(be.node().getBBox().width) + 4, k -= fe, te -= Math.max(0, Se - te), be.remove();
              }
              var Te = 0;
              if (B.showYAxis) {
                var Pe = H.append("g").attr("class", "axis");
                Pe.call(ge), te -= Te = Math.round(Pe.node().getBBox().width), Pe.remove();
              }
              var xe = B.boxHeight, Ie = me.bandwidth() / 2 - xe / 2, we = xe / 2, he = we / 10;
              B.showMinMarkers && (te -= he > Te ? 2 * he - Te : he), U.range([0, te]), me.range([k, 0]);
              var Oe = H.append("g").attr("transform", `translate(
	          `.concat(B.margins.left + Math.max(Te, he), `,
	          `).concat(B.margins.top, `
	        )`)), ue = Oe.selectAll(".boxplot").data(D).enter().append("g").attr("class", "boxplot").attr("transform", function(de) {
                return "translate(0, ".concat(me(de.Category), ")");
              }), ye = this, ae = E.scaleLinear().range([xe / 2, 0]).domain([0, xe]);
              ue.each(function(de) {
                var ve = de, Ae = E.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(Ie, ")");
                }).append("g").datum(de);
                ve.LIF != ve.q1 && (Ae.append("line").attr("class", "bar").attr("x1", U(ve.LIF)).attr("y1", ae(1.5 * we)).attr("x2", U(ve.LIF)).attr("y2", ae(0.5 * we)).style("stroke", Z(ve.Category)), Ae.append("line").attr("class", "whisker").attr("x1", U(ve.LIF)).attr("y1", ae(we)).attr("x2", U(ve.q1)).attr("y2", ae(we)).style("stroke", Z(ve.Category))), Ae.append("rect").attr("class", "box").attr("x", U(ve.q1)).attr("y", Math.min(ae(0), ae(xe))).attr("width", Math.max(1, U(ve.q3) - U(ve.q1))).attr("height", Math.abs(ae(0) - ae(xe))).style("fill", Z(ve.Category)).style("stroke", Z(ve.Category)).style("fill-opacity", 0.4).on("mouseover", function(Ce) {
                  return ye.tip.show(Ce, event.target);
                }).on("mouseout", function(Ce) {
                  return ye.tip.hide(Ce, event.target);
                }), Ae.append("line").attr("class", "median").attr("x1", U(ve.median)).attr("y1", ae(0)).attr("x2", U(ve.median)).attr("y2", ae(xe)).style("stroke", Z(ve.Category)), ve.UIF != ve.q3 && (Ae.append("line").attr("class", "bar").attr("x1", U(ve.UIF)).attr("y1", ae(1.5 * we)).attr("x2", U(ve.UIF)).attr("y2", ae(0.5 * we)).style("stroke", Z(ve.Category)), Ae.append("line").attr("class", "whisker").attr("x1", U(ve.q3)).attr("y1", ae(we)).attr("x2", U(ve.UIF)).attr("y2", ae(we)).style("stroke", Z(ve.Category))), B.showMinMarkers && Ae.append("circle").attr("cx", U(ve.min)).attr("cy", ae(we)).attr("r", he).style("fill", Z(ve.Category)).style("stroke", Z(ve.Category)).style("fill-opacity", 0.4), B.showMaxMarkers && Ae.append("circle").attr("cx", U(ve.max)).attr("cy", ae(we)).attr("r", he).style("fill", Z(ve.Category)).style("stroke", Z(ve.Category)).style("fill-opacity", 0.4);
              }), B.showXAxis && Oe.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(k, ")")).call(Q), B.showYAxis && Oe.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(ge).selectAll(".tick text").call(this.wrap, me.bandwidth() || me.range()).selectAll(".tick text tspan").attr("x", -9);
            } }]) && P(_.prototype, z), W;
          }(x);
          return m;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 557: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(M, K) {
              if (typeof K != "function" && K !== null) throw new TypeError("Super expression must either be null or a function");
              M.prototype = Object.create(K && K.prototype, { constructor: { value: M, writable: !0, configurable: !0 } }), K && I(M, K);
            })(F, _);
            var z, Y, W, D = w(F);
            function F() {
              return A(this, F), D.apply(this, arguments);
            }
            return z = F, W = [{ key: "convertData", value: function(M) {
              return M[0].hasOwnProperty("values") || (M = [{ name: "", values: M }]), M;
            } }, { key: "getMinValue", value: function(M, K) {
              return x.min(M, function(J) {
                return x.min(J.values, function(q) {
                  return q[K];
                });
              });
            } }, { key: "getMaxValue", value: function(M, K) {
              return x.max(M, function(J) {
                return x.max(J.values, function(q) {
                  return q[K];
                });
              });
            } }, { key: "getZeroBasedY", value: function(M) {
              var K = M.data, J = M.yValue, q = M.height, B = F.getMaxValue(K, J);
              return x.scaleLinear().domain([0, B]).range([q, 0]);
            } }, { key: "getRelativeY", value: function(M) {
              var K = M.data, J = M.yValue, q = J === void 0 ? "yValue" : J, B = M.height, k = M.yRangePadding, H = k === void 0 ? 0.1 : k, re = M.defaultYRangePadding, te = re === void 0 ? 10 : re;
              K = F.convertData(K);
              var U = F.getMinValue(K, q), me = F.getMaxValue(K, q), Q = (me - U) * H || te;
              return x.scaleLinear().domain([U - Q, me + Q]).range([B, 0]);
            } }], (Y = [{ key: "render", value: function(M, K, J, q, B) {
              T(E(F.prototype), "render", this).call(this, M, K, J, q, B), typeof K == "string" && (K = document.querySelector(K));
              var k = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: this.interpolation.linear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, getTooltipBuilder: null }, H = this.getOptions(k, B), re = this.createSvg(K, J, q), te = typeof H.getTooltipBuilder == "function" ? H.getTooltipBuilder(H) : this.lineDefaultTooltip(H.xLabel || "x", H.xFormat, function(He) {
                return He[H.xValue];
              }, H.yLabel || "y", H.yFormat, function(He) {
                return He[H.yValue];
              }, function(He) {
                return He[H.seriesName];
              });
              if (M.length > 0) {
                M = F.convertData(M), this.useTip(function(He) {
                  He.attr("class", "d3-tip").offset([-10, 0]).html(te);
                });
                var U = 0, me = 0;
                if (H.xLabel) {
                  var Q = re.append("g").attr("transform", "translate(".concat(J / 2, ", ").concat(q - H.margins.bottom, ")"));
                  Q.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(H.xLabel), U += Q.node().getBBox().height;
                }
                if (H.yLabel) {
                  var ge = re.append("g").attr("transform", `translate(
	              `.concat(H.margins.left, `,
	              `).concat((q - H.margins.bottom - H.margins.top) / 2 + H.margins.top, `
	            )`));
                  ge.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(H.yLabel), me = 1.2 * ge.node().getBBox().width;
                }
                var Z = 0;
                if (H.showLegend) {
                  var fe = re.append("g").attr("class", "legend"), Se = 0;
                  M.forEach(function(He, v1) {
                    fe.append("rect").attr("x", 0).attr("y", 15 * v1).attr("width", 10).attr("height", 10).style("fill", H.colors(He.name));
                    var T1 = fe.append("text").attr("x", 12).attr("y", 15 * v1 + 9).text(He.name);
                    Se = Math.max(T1.node().getBBox().width + 12, Se);
                  }), fe.attr("transform", `translate(
	          `.concat(J - H.margins.right - Se, `,
	          `).concat(H.margins.top, `
	        )`)), (Z += Se + 5) > J / 3 && fe.style("display", "none");
                }
                var be = J - H.margins.left - H.margins.right - me - (Z > J / 5 ? 0 : Z), Te = q - H.margins.top - H.margins.bottom - U, Pe = H.xScale || x.scaleLinear().domain([x.min(M, function(He) {
                  return x.min(He.values, function(v1) {
                    return v1[H.xValue];
                  });
                }), x.max(M, function(He) {
                  return x.max(He.values, function(v1) {
                    return v1[H.xValue];
                  });
                })]), xe = x.axisBottom().scale(Pe).ticks(H.ticks);
                H.tickFormat ? xe.tickFormat(H.tickFormat) : xe.tickFormat(H.xFormat), typeof Pe.rangePoints == "function" ? Pe.rangePoints([0, be]) : Pe.range([0, be]);
                var Ie = H.yScale || F.getZeroBasedY({ data: M, height: Te, yValue: H.yValue }), we = x.axisLeft().scale(Ie).tickFormat(H.yFormat).ticks(H.yTicks), he = re.append("g").attr("class", "axis");
                he.call(xe);
                var Oe = Math.round(he.node().getBBox().height), ue = Math.round(he.node().getBBox().width);
                Te -= Oe, be -= Math.max(0, ue - be), he.remove();
                var ye = H.yAxisWidth;
                if (H.yAxisWidth == null) {
                  var ae = re.append("g").attr("class", "axis");
                  ae.call(we), ye = Math.round(ae.node().getBBox().width), ae.remove();
                }
                be -= ye, typeof Pe.rangePoints == "function" ? Pe.rangePoints([0, be]) : Pe.range([0, be]), Ie.range([Te, 0]);
                var de = x.line().x(function(He) {
                  return Pe(He[H.xValue]);
                }).y(function(He) {
                  return Ie(He[H.yValue]);
                }).curve(H.interpolate), ve = re.append("g").attr("class", H.cssClass).attr("transform", `translate(
	            `.concat(H.margins.left + me + ye, `,
	            `).concat(H.margins.top, `
	          )`)), Ae = ve.selectAll(".series").data(M).enter().append("g"), Ce = Ae.append("path").attr("class", "line").attr("d", function(He) {
                  return de(He.values.sort(function(v1, T1) {
                    return x.ascending(v1[H.xValue], T1[H.xValue]);
                  }));
                });
                H.colors && Ce.style("stroke", function(He, v1) {
                  return H.colors(He.name);
                }), H.showSeriesLabel && Ae.append("text").datum(function(He) {
                  return { name: He.name, value: He.values[He.values.length - 1] };
                }).attr("transform", function(He) {
                  return "translate(".concat(Pe(He.value[H.xValue]), ", ").concat(Ie(He.value[H.yValue]), ")");
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(He) {
                  return He.name;
                });
                var qe = { x: 0, y: 0 };
                ve.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Te, ")")).call(xe), ve.append("g").attr("class", "y axis").call(we), H.labelIndexDate && ve.append("rect").attr("transform", "translate(".concat(qe.x - 0.5, ", ").concat(qe.y, ")")).attr("width", 1).attr("height", Te), this.appendTracker({ vis: ve, data: M, width: be, height: Te, x: Pe, y: Ie, options: H });
              } else re.append("text").attr("transform", "translate(".concat(J / 2, ", ").concat(q / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "appendTracker", value: function(M) {
              var K = this, J = M.vis, q = M.data, B = M.width, k = M.height, H = M.x, re = M.y, te = M.options, U = J.append("g").attr("class", "current-focus").style("display", "none"), me = U.append("line").attr("class", "x-hover-line").style("stroke-width", "2px").style("stroke-dasharray", "3,3").attr("y1", 0), Q = U.append("circle").attr("r", 2), ge = J.append("rect").style("opacity", 0), Z = x.quadtree().x(function(Se) {
                return H(Se[te.xValue]);
              }).y(function(Se) {
                return re(Se[te.yValue]);
              }), fe = q.reduce(function(Se, be) {
                return Se.concat(be.values.map(function(Te) {
                  return Te.name = be.name, Te;
                }));
              }, []);
              Z.addAll(fe), ge.attr("class", "overlay").attr("width", B).attr("height", k).attr("pointer-events", "all").on("mouseover", function() {
                return U.style("display", null);
              }).on("mouseout", function() {
                U.style("display", "none"), K.tip.hide({}, U.node());
              }), ge.on("mousemove", function() {
                var Se = x.event, be = x.mouse(Se.target), Te = Z.find(be[0], be[1]);
                Q.style("fill", te.colors(Te.name)), me.style("stroke", te.colors(Te.name)), me.attr("y2", k - re(Te[te.yValue])), U.attr("transform", "translate(" + H(Te[te.xValue]) + "," + re(Te[te.yValue]) + ")"), K.tip.show(Te, U.node());
              });
            } }, { key: "interpolation", get: function() {
              return { linear: x.curveLinear, curveStep: x.curveStep, curveStepBefore: x.curveStepBefore, curveStepAfter: x.curveStepAfter, curveBasis: x.curveBasis, curveCardinal: x.curveCardinal, curveMonotoneX: x.curveMonotoneX, curveCatmullRom: x.curveCatmullRom };
            } }]) && P(z.prototype, Y), W && P(z, W), F;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 76: (u, d, f) => {
        var b;
        u = f.nmd(u), b = (function(C) {
          var v = { version: "0.0.1" }, A = f(842), P = f(648), T = f(605), I = f(131), w = f(316), N = f(535), E = f(502), x = f(487), m = f(557), j = f(775), _ = f(312), z = f(345), Y = f(255), W = f(587), D = f(132);
          return v.chart = A, v.aster = P, v.areachart = T, v.barchart = I, v.boxplot = w, v.donut = N, v.histogram = E, v.horizontalBoxplot = x, v.line = m, v.trellisline = j, v.treemap = _, v.scatterplot = z, v.splitBoxplot = Y, v.sunburst = W, v.util = D, v;
        }).call(d, f, d, u), b === void 0 || (u.exports = b);
      }, 345: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: x.curveLinear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, truncateLabelAtLine: 2, showXAxis: !0, tooltip: function(Ce) {
                return "<div>Series: ".concat(Ce.seriesName, `</div>
					<div>X: `).concat(Ce[k.xValue], `</div>
					<div>Y: `).concat(Ce[k.yValue], `</div>
					`);
              }, circleRadius: 1, addDiagonal: !1, diagonalColor: "#ccc" }, k = this.getOptions(B, q);
              q.colors ? k.colors = x.scaleOrdinal(Object.values(q.colors)).domain(Object.keys(q.colors)) : k.colors = x.scaleOrdinal(x.schemeCategory20).domain(F.map(function(Ce) {
                return Ce.name;
              }));
              var H = this.createSvg(M, K, J);
              if (F.length > 0) {
                F[0].hasOwnProperty("values") || (F = [{ name: "", values: F }]), this.useTip(function(Ce) {
                  Ce.attr("class", "d3-tip").offset([-10, 0]).html(k.tooltip);
                });
                var re, te, U = 0, me = 0;
                k.xLabel && ((re = H.append("g")).append("text").attr("class", "axislabel").attr("dy", 0).attr("y", 0).style("text-anchor", "middle").text(k.xLabel), U += re.node().getBBox().height), k.yLabel && ((te = H.append("g")).append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(k.yLabel), me = 1.5 * te.node().getBBox().width);
                var Q = 0;
                if (k.showLegend) {
                  var ge = H.append("g").attr("class", "legend"), Z = 0;
                  F.forEach(function(Ce, qe) {
                    ge.append("rect").attr("x", 0).attr("y", 15 * qe).attr("width", 10).attr("height", 10).style("fill", k.colors(Ce.name));
                    var He = ge.append("text").attr("x", 12).attr("y", 15 * qe + 9).text(Ce.name);
                    Z = Math.max(He.node().getBBox().width + 12, Z);
                  }), ge.attr("transform", "translate(" + (K - k.margins.right - Z) + ",0)"), Q += Z + 5;
                }
                var fe = K - k.margins.left - k.margins.right - me - Q, Se = J - k.margins.top - k.margins.bottom - U, be = k.xScale || x.scaleLinear().domain([x.min(F, function(Ce) {
                  return x.min(Ce.values, function(qe) {
                    return qe[k.xValue];
                  });
                }), x.max(F, function(Ce) {
                  return x.max(Ce.values, function(qe) {
                    return qe[k.xValue];
                  });
                })]), Te = x.axisBottom().scale(be).ticks(k.ticks);
                k.tickFormat ? Te.tickFormat(k.tickFormat) : Te.tickFormat(k.xFormat), typeof be.rangePoints == "function" ? be.rangePoints([0, fe]) : be.range([0, fe]);
                var Pe = k.yScale || x.scaleLinear().domain([0, x.max(F, function(Ce) {
                  return x.max(Ce.values, function(qe) {
                    return qe[k.yValue];
                  });
                })]).range([Se, 0]), xe = x.axisLeft().scale(Pe).tickFormat(k.yFormat).ticks(k.yTicks), Ie = H.append("g").attr("class", "axis");
                Ie.call(Te);
                var we = Math.round(Ie.node().getBBox().height), he = Math.round(Ie.node().getBBox().width);
                Se -= we, fe -= Math.max(0, he - fe), Ie.remove();
                var Oe = H.append("g").attr("class", "axis");
                Oe.call(xe);
                var ue = Math.round(Oe.node().getBBox().width);
                if (fe -= ue, Oe.remove(), k.xLabel && re) {
                  re.selectAll("text").call(this.wrap, fe, k.truncateLabelAtLine);
                  var ye = re.node().getBBox().height;
                  Se -= ye, re.attr("transform", `translate(
								`.concat(me + ue + k.margins.left + fe / 2, `,
								`).concat(J - k.margins.bottom - ye, `
							)`));
                }
                k.yLabel && te && (te.attr("transform", `translate(
							`.concat(k.margins.left, `,
							`).concat(k.margins.bottom + Se / 2, `
						)`)).selectAll("text").call(this.wrap, Se, k.truncateLabelAtLine), me = te.node().getBBox().width), typeof be.rangePoints == "function" ? be.rangePoints([0, fe]) : be.range([0, fe]), Pe.range([Se, 0]);
                var ae = H.append("g").attr("class", k.cssClass).attr("transform", "translate(" + (k.margins.left + me + ue) + "," + k.margins.top + ")"), de = ae.selectAll(".series").data(F).enter().append("g");
                de.selectAll(".dot").data(function(Ce) {
                  return Ce.values.map(function(qe) {
                    return Object.assign({}, qe, { seriesName: Ce.name });
                  });
                }).enter().append("circle").attr("class", "dot").attr("r", k.circleRadius).style("fill", function(Ce, qe) {
                  return k.colors(Ce.seriesName);
                }).attr("transform", function(Ce) {
                  return "translate(" + be(Ce[k.xValue]) + "," + Pe(Ce[k.yValue]) + ")";
                }), k.addDiagonal && de.append("line").attr("x1", 0).attr("y1", Se).attr("x2", fe).attr("y2", 0).attr("stroke-width", 1).attr("stroke", k.diagonalColor).attr("stroke-dasharray", "5,5"), k.showSeriesLabel && de.append("text").datum(function(Ce) {
                  return { name: Ce.name, value: Ce.values[Ce.values.length - 1] };
                }).attr("transform", function(Ce) {
                  return "translate(" + be(Ce.value[k.xValue]) + "," + Pe(Ce.value[k.yValue]) + ")";
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(Ce) {
                  return Ce.name;
                });
                var ve = { x: 0, y: 0 }, Ae = this;
                de.selectAll(".focus").data(function(Ce) {
                  return Ce.values.map(function(qe) {
                    return Object.assign({}, qe, { seriesName: Ce.name });
                  });
                }).enter().append("circle").attr("class", "focus").attr("r", k.circleRadius).attr("transform", function(Ce) {
                  var qe = be(Ce[k.xValue]), He = Pe(Ce[k.yValue]);
                  return Ce[k.xValue] === 0 && ve.y === 0 && (ve.x = qe, ve.y = He), "translate(" + qe + "," + He + ")";
                }).on("mouseover", function(Ce) {
                  x.select(this).style("opacity", "1").style("stroke", k.colors(Ce.seriesName)).style("stroke-width", k.circleRadius / 2), Ae.tip.show(Ce, event.target);
                }).on("mouseout", function(Ce) {
                  x.select(this).style("opacity", "0"), Ae.tip.hide(Ce, event.target);
                }), k.showXAxis && ae.append("g").attr("class", "x axis").attr("transform", "translate(0," + Se + ")").call(Te), ae.append("g").attr("class", "y axis").call(xe), k.labelIndexDate && ae.append("rect").attr("transform", function() {
                  return "translate(" + (ve.x - 0.5) + "," + ve.y + ")";
                }).attr("width", 1).attr("height", Se);
              } else H.append("text").attr("transform", "translate(" + K / 2 + "," + J / 2 + ")").style("text-anchor", "middle").text("No Data");
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 255: (u, d, f) => {
        var b, C;
        function v(E) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, v(E);
        }
        function A(E, x) {
          if (!(E instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function P(E, x) {
          for (var m = 0; m < x.length; m++) {
            var j = x[m];
            j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(E, j.key, j);
          }
        }
        function T(E, x) {
          return T = Object.setPrototypeOf || function(m, j) {
            return m.__proto__ = j, m;
          }, T(E, x);
        }
        function I(E) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var m, j = N(E);
            if (x) {
              var _ = N(this).constructor;
              m = Reflect.construct(j, arguments, _);
            } else m = j.apply(this, arguments);
            return w(this, m);
          };
        }
        function w(E, x) {
          return !x || v(x) !== "object" && typeof x != "function" ? function(m) {
            if (m === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return m;
          }(E) : x;
        }
        function N(E) {
          return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, N(E);
        }
        b = [f(680), f(316)], C = (function(E, x) {
          var m = function(j) {
            (function(D, F) {
              if (typeof F != "function" && F !== null) throw new TypeError("Super expression must either be null or a function");
              D.prototype = Object.create(F && F.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), F && T(D, F);
            })(W, j);
            var _, z, Y = I(W);
            function W() {
              return A(this, W), Y.apply(this, arguments);
            }
            return _ = W, (z = [{ key: "render", value: function(D, F, M, K, J) {
              var q = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 0 } }, B = this.getOptions(q, J), k = this.createSvg(F, M, K), H = B.valueFormatter;
              this.useTip(this.defaultTip, B), D.forEach(function(Ce) {
                return Ce.Category = Ce.Category || "Default";
              });
              var re = M - B.margins.left - B.margins.right, te = K - B.margins.top - B.margins.bottom, U = E.scaleLinear().range([0, re]).domain([B.xMin || E.min(D, function(Ce) {
                return Math.min(Ce.target.min, Ce.compare.min);
              }), B.xMax || E.max(D, function(Ce) {
                return Math.max(Ce.target.max, Ce.compare.max);
              })]), me = E.scaleBand().range([0, te]).round(1 / D.length).domain(D.map(function(Ce) {
                return Ce.Category;
              })), Q = E.axisBottom().scale(U).tickFormat(H).ticks(5), ge = E.axisLeft().scale(me), Z = 0, fe = Z;
              if (B.showXAxis) {
                var Se = k.append("g").attr("class", "axis");
                Se.call(Q), Z = Math.round(Se.node().getBBox().height) + 2, fe = Math.round(Se.node().getBBox().width) + 4, te -= Z, re -= Math.max(0, fe - re), Se.remove();
              }
              var be = 0;
              if (B.showYAxis) {
                var Te = k.append("g").attr("class", "axis");
                Te.call(ge), re -= be = Math.round(Te.node().getBBox().width), Te.remove();
              }
              var Pe = B.boxHeight, xe = me.bandwidth() / 2 - Pe / 2, Ie = Pe / 2, we = Ie / 10;
              B.showMinMarkers && (re -= we > be ? 2 * we - be : we), U.range([0, re]), me.range([te, 0]);
              var he = k.append("g").attr("transform", `translate(
	          `.concat(B.margins.left + Math.max(be, we), `,
	          `).concat(B.margins.top, `
	        )`));
              if (B.showLegend) {
                var Oe = k.append("g").attr("class", "legend"), ue = Oe.append("g"), ye = Oe.append("g");
                ue.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "target"), ue.append("text").attr("x", 15).attr("y", 9).text("Target"), ye.append("rect").attr("x", ue.node().getBBox().width + 10).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "compare"), ye.append("text").attr("x", ue.node().getBBox().width + 25).attr("y", 9).text("Compare"), Oe.attr("transform", `translate(
					`.concat((M - Oe.node().getBBox().width) / 2, `,
					0
				)`));
              }
              var ae = he.selectAll(".boxplot").data(D).enter().append("g").attr("class", "boxplot").attr("transform", function(Ce) {
                return "translate(0, ".concat(me(Ce.Category), ")");
              }), de = this, ve = E.scaleLinear().range([Pe / 2, 0]).domain([0, Pe]), Ae = E.scaleLinear().range([0, Pe / 2]).domain([0, Pe]);
              me.bandwidth(), ae.each(function(Ce) {
                var qe = E.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(xe, ")");
                }), He = qe.append("g").datum(Ce.target).attr("class", "target"), v1 = qe.append("g").datum(Ce.compare).attr("class", "compare").attr("transform", function() {
                  return "translate(0, ".concat(Pe / 2 + 2, ")");
                });
                [{ boxPlotData: Ce.target, boxplot: He, boxScale: ve }, { boxPlotData: Ce.compare, boxplot: v1, boxScale: Ae, tipDirection: "s", tipOffset: [10, 0] }].forEach(function(T1) {
                  var u1 = T1.boxPlotData, n1 = T1.boxplot, x1 = T1.boxScale;
                  u1.LIF != u1.q1 && (n1.append("line").attr("class", "bar").attr("x1", U(u1.LIF)).attr("y1", x1(0)).attr("x2", U(u1.LIF)).attr("y2", x1(Ie)), n1.append("line").attr("class", "whisker").attr("x1", U(u1.LIF)).attr("y1", x1(0)).attr("x2", U(u1.q1)).attr("y2", x1(0))), n1.append("rect").attr("class", "box").attr("x", U(u1.q1)).attr("y", Math.min(x1(0), x1(Pe))).attr("width", Math.max(1, U(u1.q3) - U(u1.q1))).attr("height", Math.abs(x1(0) - x1(Pe))).on("mouseover", function(Rt) {
                    return de.tip.show(Object.assign({}, Rt, { tipDirection: T1.tipDirection, tipOffset: T1.tipOffset }), event.target);
                  }).on("mouseout", function(Rt) {
                    return de.tip.hide(Rt, event.target);
                  }), n1.append("line").attr("class", "median").attr("x1", U(u1.median)).attr("y1", x1(0)).attr("x2", U(u1.median)).attr("y2", x1(Pe)), u1.UIF != u1.q3 && (n1.append("line").attr("class", "bar").attr("x1", U(u1.UIF)).attr("y1", x1(0)).attr("x2", U(u1.UIF)).attr("y2", x1(Ie)), n1.append("line").attr("class", "whisker").attr("x1", U(u1.q3)).attr("y1", x1(0)).attr("x2", U(u1.UIF)).attr("y2", x1(0))), B.showMinMarkers && n1.append("circle").attr("cx", U(u1.min)).attr("cy", x1(Ie / 2)).attr("r", we), B.showMaxMarkers && n1.append("circle").attr("cx", U(u1.max)).attr("cy", x1(Ie / 2)).attr("r", we);
                });
              }), B.showXAxis && he.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(te, ")")).call(Q), B.showYAxis && he.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(ge).selectAll(".tick text").call(this.wrap, me.bandwidth() || me.range());
            } }]) && P(_.prototype, z), W;
          }(x);
          return m;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 587: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "getTipDirection", value: function(F) {
              return "n";
            } }, { key: "getTipOffset", value: function(F, M) {
              var K = event.target.getBBox(), J = M.centroid(F), q = Math.abs(K.x - J[0]) - K.width / 2;
              return [Math.abs(K.y - J[1]) - 10, q];
            } }, { key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = this.getOptions({ tooltip: function(Z) {
                return "<div>No Tooltip Set</div>";
              }, minRadians: 5e-3 }, q), k = this.createSvg(M, K, J);
              k.attr("class", "sunburst"), this.useTip(function(Z, fe) {
                Z.attr("class", "d3-tip ".concat(fe.tipClass || "")).offset(function(Se) {
                  return Se.tipOffset || [-10, 0];
                }).direction(function(Se) {
                  return Se.tipDirection || "n";
                }).html(function(Se) {
                  return fe.tooltip(Se);
                });
              }, B);
              var H = k.append("svg:g").attr("transform", "translate(" + K / 2 + "," + J / 2 + ")"), re = Math.min(K, J) / 2, te = x.partition().size([2 * Math.PI, re]), U = x.arc().startAngle(function(Z) {
                return Z.x0;
              }).endAngle(function(Z) {
                return Z.x1;
              }).innerRadius(function(Z) {
                return Z.y0;
              }).outerRadius(function(Z) {
                return Z.y1;
              });
              H.append("svg:circle").attr("r", re).style("opacity", 0);
              var me = te(x.hierarchy(F).sum(function(Z) {
                return Z.size;
              }).sort(function(Z, fe) {
                return fe.value - Z.value;
              })).descendants().filter(function(Z) {
                return Z.x1 - Z.x0 > B.minRadians;
              }).reverse();
              if (B.split) {
                var Q = me.reduce(function(Z, fe) {
                  var Se = B.split(fe);
                  return Se.length > 1 && (fe.isSplit = !0, Z = Z.concat(Se.map(function(be) {
                    return Object.assign(be, { isPartialNode: !0 });
                  }))), Z;
                }, []);
                H.data([F]).selectAll("partialnode").data(Q).enter().append("svg:path").attr("d", U).attr("fill-rule", "evenodd").attr("class", "partial").style("fill", function(Z) {
                  return B.colors(Z.data.name);
                });
              }
              var ge = this;
              H.data([F]).selectAll("pathnode").data(me).enter().append("svg:path").attr("display", function(Z) {
                return Z.depth ? null : "none";
              }).attr("d", U).attr("fill-rule", "evenodd").attr("class", function(Z) {
                return B.nodeClass && B.nodeClass(Z) || "node";
              }).style("fill", function(Z) {
                return Z.isSplit ? "#000" : B.colors(Z.data.name);
              }).style("opacity", function(Z) {
                return Z.isSplit ? 0 : 1;
              }).on("mouseover", function(Z) {
                return ge.tip.show(Object.assign({}, Z, { tipDirection: ge.getTipDirection(Z), tipOffset: ge.getTipOffset(Z, U) }), event.target);
              }).on("mouseout", function(Z) {
                return ge.tip.hide(Z, event.target);
              }).on("click", function(Z) {
                return B.onclick && B.onclick(Z);
              });
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 312: (u, d, f) => {
        var b, C;
        function v(E) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, v(E);
        }
        function A(E, x) {
          if (!(E instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function P(E, x) {
          for (var m = 0; m < x.length; m++) {
            var j = x[m];
            j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(E, j.key, j);
          }
        }
        function T(E, x) {
          return T = Object.setPrototypeOf || function(m, j) {
            return m.__proto__ = j, m;
          }, T(E, x);
        }
        function I(E) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var m, j = N(E);
            if (x) {
              var _ = N(this).constructor;
              m = Reflect.construct(j, arguments, _);
            } else m = j.apply(this, arguments);
            return w(this, m);
          };
        }
        function w(E, x) {
          return !x || v(x) !== "object" && typeof x != "function" ? function(m) {
            if (m === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return m;
          }(E) : x;
        }
        function N(E) {
          return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, N(E);
        }
        b = [f(680), f(842)], C = (function(E, x) {
          var m = function(j) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && T(F, M);
            })(D, j);
            var _, z, Y, W = I(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return _ = D, z = [{ key: "render", value: function(F, M, K, J, q) {
              var B = this, k = this.getOptions(q), H = this.createSvg(M, K, J), re = E.scaleLinear().range([0, K]), te = E.scaleLinear().range([0, J]);
              E.select(M).select(".treemap_zoomtarget").text("");
              var U = 0, me = E.treemap().round(!1).size([K, J]), Q = E.hierarchy(F, function(he) {
                return he.children;
              }).sum(k.getsizevalue), ge = me(Q);
              function Z(he) {
                var Oe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], ue = K / (he.x1 - he.x0) || K, ye = J / (he.y1 - he.y0) || J;
                he.x1 && he.y1 ? (re.domain([he.x0, he.x0 + (he.x1 - he.x0)]), te.domain([he.y0, he.y0 + (he.y1 - he.y0)])) : (re.domain([0, K]), te.domain([0, J]));
                var ae = E.select(M).select(".treemap_zoomtarget");
                if (ae.size()) if (he.data.name === "root") ae.text("");
                else {
                  var de = ae.text();
                  ae.text("".concat(de, " > ").concat(he.data.name));
                }
                var ve = H.selectAll("g.cell, .grouper");
                Oe && (ve = ve.transition().duration(750)), ve.attr("transform", function(Ae) {
                  return "translate(".concat(re(Ae.x0), ", ").concat(te(Ae.y0), ")");
                }).on("end", function() {
                  H.selectAll(".grouper").attr("display", "block");
                }), ve.select("rect").attr("width", function(Ae) {
                  return Math.max(0, ue * (Ae.x1 - Ae.x0) - 1);
                }).attr("height", function(Ae) {
                  return Math.max(0, ye * (Ae.y1 - Ae.y0) - 1);
                }), event && event.stopPropagation(), k.onZoom && k.onZoom(he);
              }
              function fe(he) {
                var Oe = K / (he.x1 - he.x0), ue = J / (he.y1 - he.y0), ye = ge.children.filter(function(ae) {
                  return ae.parent === he;
                });
                H.selectAll(".grouper").remove(), H.selectAll(".grouper").data(ye).enter().append("g").attr("class", "grouper").attr("transform", function(ae) {
                  return "translate(".concat(ae.x0 + 1, ", ").concat(ae.y0 + 1, ")");
                }).attr("display", "none").append("rect").attr("width", function(ae) {
                  return Math.max(0, Oe * (ae.x1 - ae.x0) - 1);
                }).attr("height", function(ae) {
                  return Math.max(0, ue * (ae.y1 - ae.y0) - 1);
                }).attr("title", function(ae) {
                  return ae.name;
                }).attr("id", function(ae) {
                  return ae.id;
                });
              }
              var Se, be = ge.leaves().filter(function(he) {
                return k.getsizevalue(he.data);
              }), Te = E.extent(be, function(he) {
                return k.getcolorvalue(he.data);
              }), Pe = E.median(be, function(he) {
                return k.getcolorvalue(he.data);
              });
              Se = k.getcolorrange ? k.getcolorrange() : ["#E4FF7A", "#FC7F00"];
              var xe = [Te[0], Pe, Te[1]];
              k.getcolorscale && (xe = k.getcolorscale());
              var Ie = E.scaleLinear().domain(xe).range(Se), we = H.selectAll("g").data(be).enter().append("g").attr("class", "cell").attr("transform", function(he) {
                return "translate(".concat(he.x0, ", ").concat(he.y0, ")");
              });
              we.append("rect").attr("width", function(he) {
                return Math.max(0, he.x1 - he.x0 - 1);
              }).attr("height", function(he) {
                return Math.max(0, he.y1 - he.y0 - 1);
              }).attr("id", function(he) {
                return he.id;
              }).style("fill", function(he) {
                return Ie(k.getcolorvalue(he.data));
              }).on("click", function(he) {
                if (k.useTip && B.tip.hide(), event.altKey) Z(Q), fe(Q);
                else if (event.ctrlKey) {
                  for (var Oe = he; Oe.depth !== U + 1; ) Oe = Oe.parent;
                  U = Oe.depth, Oe.children && Oe.children.length > 1 ? (fe(Oe), Z(Oe)) : (U = 0, fe(Q), Z(Q));
                } else k.onclick(he.data);
              }), k.useTip ? (this.useTip(function(he) {
                he.attr("class", "d3-tip").direction(function(Oe) {
                  var ue = re.domain()[1] === 1 ? K : re.domain()[1];
                  return Oe.x1 >= ue - ue / 10 ? "w" : Oe.x0 <= ue / 10 ? "e" : "n";
                }).offset([3, 0]).html(function(Oe) {
                  return "".concat(k.gettitle(Oe.data), "<br/><br/>").concat(k.getcontent(Oe.data));
                });
              }), we.on("mouseover", function(he) {
                return B.tip.show(he, event.target);
              }).on("mouseout", function(he) {
                return B.tip.hide(he, event.target);
              })) : we.attr("data-container", "body").attr("data-toggle", "popover").attr("data-trigger", "hover").attr("data-placement", "top").attr("data-html", !0).attr("data-title", function(he) {
                return k.gettitle(he.data);
              }).attr("data-content", function(he) {
                return k.getcontent(he.data);
              }), k.initialZoomedConcept ? (fe(k.initialZoomedConcept), Z(k.initialZoomedConcept, !1)) : fe(Q), H.selectAll(".grouper").attr("display", "block");
            } }, { key: "formatters", get: function() {
              return { format_pct: E.format(".2%"), format_fixed: E.format(".2f"), format_comma: E.format(",") };
            } }], Y = [{ key: "buildHierarchyFromJSON", value: function(F, M, K) {
              var J = 0, q = { name: "root", children: [] };
              return F.PERCENT_PERSONS.forEach(function(B) {
                J += B;
              }), F.CONCEPT_PATH.forEach(function(B, k) {
                for (var H = B.split("||"), re = q, te = function(me) {
                  var Q = re.children, ge = H[me], Z = void 0;
                  if (me + 1 < H.length) {
                    var fe = !1;
                    Q.forEach(function(Se) {
                      Se.name === ge && (Z = Se, fe = !0);
                    }), fe || (Z = { name: ge, children: [] }, Q.push(Z)), re = Z;
                  } else Z = K(ge, k, F), F.PERCENT_PERSONS[k] / J > M && Q.push(Z);
                }, U = 0; U < H.length; U += 1) te(U);
              }), q;
            } }], z && P(_.prototype, z), Y && P(_, Y), D;
          }(x);
          return m;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 775: (u, d, f) => {
        var b, C;
        function v(x) {
          return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
            return typeof m;
          } : function(m) {
            return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
          }, v(x);
        }
        function A(x, m) {
          if (!(x instanceof m)) throw new TypeError("Cannot call a class as a function");
        }
        function P(x, m) {
          for (var j = 0; j < m.length; j++) {
            var _ = m[j];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
          }
        }
        function T(x, m, j) {
          return T = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(_, z, Y) {
            var W = function(F, M) {
              for (; !Object.prototype.hasOwnProperty.call(F, M) && (F = E(F)) !== null; ) ;
              return F;
            }(_, z);
            if (W) {
              var D = Object.getOwnPropertyDescriptor(W, z);
              return D.get ? D.get.call(Y) : D.value;
            }
          }, T(x, m, j || x);
        }
        function I(x, m) {
          return I = Object.setPrototypeOf || function(j, _) {
            return j.__proto__ = _, j;
          }, I(x, m);
        }
        function w(x) {
          var m = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var j, _ = E(x);
            if (m) {
              var z = E(this).constructor;
              j = Reflect.construct(_, arguments, z);
            } else j = _.apply(this, arguments);
            return N(this, j);
          };
        }
        function N(x, m) {
          return !m || v(m) !== "object" && typeof m != "function" ? function(j) {
            if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return j;
          }(x) : m;
        }
        function E(x) {
          return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
            return m.__proto__ || Object.getPrototypeOf(m);
          }, E(x);
        }
        b = [f(680), f(842)], C = (function(x, m) {
          var j = function(_) {
            (function(F, M) {
              if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(M && M.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), M && I(F, M);
            })(D, _);
            var z, Y, W = w(D);
            function D() {
              return A(this, D), W.apply(this, arguments);
            }
            return z = D, (Y = [{ key: "render", value: function(F, M, K, J, q) {
              T(E(D.prototype), "render", this).call(this, F, M, K, J, q);
              var B = { trellisSet: x.keys(F), yTicks: 4, xFormat: x.format("d"), yFormat: x.format("d"), interpolate: x.curveLinear }, k = this.getOptions(B, q), H = this.createSvg(M, K, J);
              function re() {
                var Be = ae.invert(x.mouse(event.target)[0]);
                n1.selectAll(".g-label-value.g-start").call(te, Be), n1.selectAll(".g-label-year.g-start").call(U, Be), n1.selectAll(".g-value").attr("transform", function(ke) {
                  var Je = ke.values;
                  if (Je) {
                    var i1 = Je[ge(Je, Be, 0, Je.length - 1)], V1 = i1.Y_PREVALENCE_1000PP === 0 || i1.Y_PREVALENCE_1000PP ? i1.Y_PREVALENCE_1000PP : i1.yPrevalence1000Pp;
                    return i1 && i1.date ? "translate(" + ae(i1.date) + "," + de(V1) + ")" : "translate(0,0);";
                  }
                });
              }
              function te(Be, ke) {
                var Je = x.scaleLinear().domain(ae.range()), i1 = {};
                Be.each(function(V1, Y1) {
                  var N3 = x.select(this), b1 = V1.values, q1 = ge(b1, ke, 0, b1.length - 1), Nt = Math.round(q1 / (b1.length - 1) * (b1.length - 12)), k1 = b1[q1];
                  if (k1 && k1.date) {
                    var F3 = ae(k1.date), f3 = k1.Y_PREVALENCE_1000PP === 0 || k1.Y_PREVALENCE_1000PP ? k1.Y_PREVALENCE_1000PP : k1.yPrevalence1000Pp, q4 = Je.range([0, ye.bandwidth()])(F3), b5 = de(x.max(b1.slice(Nt, Nt + 12), function(X4) {
                      return f3;
                    })), D3 = k1.TRELLIS_NAME || k1.trellisName;
                    if (D3) {
                      !i1[D3] && (i1[D3] = []);
                      var C5 = k1.date.getTime() === fe.getTime() ? "end" : (k1.date.getTime(), Z.getTime(), "start");
                      i1[D3].push({ y: b5, x: q4, textAnchor: C5, value: f3, text: N3, color: k.colors(V1.key) });
                    }
                  }
                }), Object.keys(i1).forEach(function(V1) {
                  var Y1 = i1[V1];
                  Y1.sort(function(b1, q1) {
                    return b1.y - q1.y;
                  }), Y1.forEach(function(b1, q1) {
                    if (q1 > 0) {
                      var Nt = Y1[q1 - 1].y;
                      Y1[q1].y += Math.max(0, Nt + 15 - Y1[q1].y);
                    }
                  });
                  var N3 = Y1.filter(function(b1) {
                    return b1.value <= 20;
                  });
                  Y1.forEach(function(b1) {
                    var q1 = b1.text, Nt = b1.x, k1 = b1.y, F3 = (b1.color, b1.textAnchor), f3 = b1.value;
                    q1.text(k.yFormat(f3)).style("display", "block").style("text-anchor", F3).attr("transform", `translate(
	              `.concat(F3 === "start" ? Nt + 4 : Nt - 4, `,
	              `).concat(f3 <= 20 && N3.length !== 1 ? k1 - 20 : k1, `
	            )`));
                  });
                });
              }
              function U(Be, ke) {
                var Je = x.scaleLinear().domain(ae.range()), i1 = F[0] && F[0].values[0] && F[0].values[0].values || [], V1 = i1[ge(i1, ke, 0, i1.length - 1)];
                if (V1 && V1.date) {
                  var Y1 = ae(V1.date);
                  Be.each(function(N3) {
                    x.select(this).text(V1.date.getFullYear()).attr("transform", `translate(
	              `.concat(Je.range([0, ye.bandwidth() - this.getComputedTextLength()])(Y1), `,
	              `).concat(ue + 6, `
	              )`)).style("display", null);
                  });
                }
              }
              var me, Q, ge = x.bisector(function(Be) {
                return Be.date;
              }).left, Z = x.min(F, function(Be) {
                return x.min(Be.values, function(ke) {
                  return x.min(ke.values, function(Je) {
                    return Je.date;
                  });
                });
              }), fe = x.max(F, function(Be) {
                return x.max(Be.values, function(ke) {
                  return x.max(ke.values, function(Je) {
                    return Je.date;
                  });
                });
              }), Se = x.min(F, function(Be) {
                return x.min(Be.values, function(ke) {
                  return x.min(ke.values, function(Je) {
                    return Je.Y_PREVALENCE_1000PP === 0 || Je.Y_PREVALENCE_1000PP ? Je.Y_PREVALENCE_1000PP : Je.yPrevalence1000Pp;
                  });
                });
              }), be = x.max(F, function(Be) {
                return x.max(Be.values, function(ke) {
                  return x.max(ke.values, function(Je) {
                    return Je.Y_PREVALENCE_1000PP === 0 || Je.Y_PREVALENCE_1000PP ? Je.Y_PREVALENCE_1000PP : Je.yPrevalence1000Pp;
                  });
                });
              }), Te = 0;
              k.seriesLabel && ((me = H.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(k.seriesLabel), (Te = me.node()) && (Te = me.node().getBBox().height + 10));
              var Pe, xe, Ie, we = 0;
              k.trellisLabel && ((Q = H.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(k.trellisLabel), we = Q.node().getBBox().height + 10), (Pe = H.append("g").attr("class", "g-label-trellis")).append("text").text(k.trellisSet.join("")), xe = Pe.node().getBBox().height + 10, Pe.remove();
              var he = 0;
              k.yLabel && ((Ie = H.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").text(k.yLabel), he = Ie.node().getBBox().height + 4);
              var Oe = K - k.margins.left - he - k.margins.right, ue = J - k.margins.top - we - xe - Te - 2 * k.margins.bottom, ye = x.scaleBand().domain(k.trellisSet).range([0, Oe]).paddingOuter(0.2).paddingInner(0.25), ae = x.scaleTime().domain([Z, fe]).range([0, ye.bandwidth()]), de = x.scaleLinear().domain([Se, be]).range([ue, 0]), ve = x.axisLeft().scale(de).tickFormat(k.yFormat).ticks(k.yTicks), Ae = x.axisBottom().scale(ae), Ce = H.append("g").attr("class", "axis");
              Ce.call(Ae);
              var qe = Math.round(Ce.node().getBBox().height), He = Math.round(Ce.node().getBBox().width);
              ue -= qe, Oe -= Math.max(0, He - Oe), Ce.remove();
              var v1 = H.append("g").attr("class", "axis");
              v1.call(ve);
              var T1 = Math.round(v1.node().getBBox().width);
              Oe -= T1, v1.remove(), ye.range([0, Oe]).paddingOuter(0.2).paddingInner(0.25), ae.range([0, ye.bandwidth()]), de.range([ue, 0]), k.trellisLabel && Q.attr("transform", `translate(
	        `.concat(Oe / 2 + k.margins.left, `,
	        `).concat(k.margins.top, `
	      )`)), k.seriesLabel && me.attr("transform", `translate(
	        `.concat(Oe / 2 + k.margins.left, `,
	        `).concat(we + ue + qe + Te + 2 * k.margins.top, `
	      )`)), k.yLabel && (Ie.attr("transform", `translate(
	        `.concat(k.margins.left, `,
	        `).concat(ue / 2 + we + xe, `
	      )`)), Ie.select("text").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em"));
              var u1 = x.line().x(function(Be) {
                return ae(Be.date);
              }).y(function(Be) {
                return de(Be.Y_PREVALENCE_1000PP === 0 || Be.Y_PREVALENCE_1000PP ? Be.Y_PREVALENCE_1000PP : Be.yPrevalence1000Pp);
              }).curve(k.interpolate), n1 = x.select(H.node()).append("g").attr("transform", function(Be) {
                return `translate(
	        `.concat(he + T1 + k.margins.left, `,
	        `).concat(we, `
	      )`);
              }).selectAll(".g-trellis").data(ye.domain()).enter().append("g").attr("class", "g-trellis").attr("transform", function(Be) {
                return "translate(".concat(ye(Be), ", ").concat(xe, ")");
              }), x1 = x.axisBottom().scale(ae).tickFormat("").tickSize(-ue), Rt = x.axisLeft().scale(de).tickFormat("").tickSize(-ye.bandwidth()).ticks(8);
              n1.append("g").attr("class", "x-guide").attr("transform", "translate(0, ".concat(ue, ")")).call(x1), n1.append("g").attr("class", "y-guide").call(Rt);
              var qt = n1.selectAll(".g-series").data(function(Be) {
                var ke = F.filter(function(Je) {
                  return Je.key === Be;
                });
                return ke.length > 0 ? ke[0].values : [];
              }).enter().append("g").attr("class", "g-series lineplot");
              qt.append("path").attr("class", "line").attr("d", function(Be) {
                return u1(Be.values.sort(function(ke, Je) {
                  return x.ascending(ke.date, Je.date);
                }));
              }).style("stroke", function(Be) {
                return k.colors(Be.key);
              }), qt.append("circle").attr("class", "g-value").attr("transform", function(Be) {
                var ke = Be.values;
                if (ke && ke[ke.length - 1] && ke[ke.length - 1].date && ke[ke.length - 1] && (ke[ke.length - 1].Y_PREVALENCE_1000PP || ke[ke.length - 1].yPrevalence1000Pp)) {
                  var Je = ke[ke.length - 1].Y_PREVALENCE_1000PP === 0 || ke[ke.length - 1].Y_PREVALENCE_1000PP ? ke[ke.length - 1].Y_PREVALENCE_1000PP : ke[ke.length - 1].yPrevalence1000Pp;
                  return "translate(".concat(ae(ke[ke.length - 1].date), ", ").concat(de(Je), ")");
                }
                return "translate(0, 0)";
              }).attr("r", 2.5).style("display", "none"), qt.append("text").attr("class", "g-label-value g-start").call(te, Z), qt.append("text").attr("class", "g-label-value g-end").call(te, fe), n1.append("text").attr("class", "g-label-year g-start").attr("dy", ".71em").call(U, Z), n1.append("text").attr("class", "g-label-year g-end").attr("dy", ".71em").call(U, fe), n1.append("g").attr("class", "x axis").append("line").attr("x2", ye.bandwidth()).attr("y1", de(Se)).attr("y2", de(Se)), n1.append("g").attr("class", "g-label-trellis").attr("transform", function(Be) {
                return "translate(".concat(ye.bandwidth() / 2, ", 0)");
              }).append("text").attr("dy", "-1em").style("text-anchor", "middle").text(function(Be) {
                return Be;
              }), n1.append("rect").attr("class", "g-overlay").attr("x", -4).attr("width", ye.bandwidth() + 8).attr("height", ue + 18).on("mouseover", function() {
                n1.selectAll(".g-end").style("display", "none"), n1.selectAll(".g-value").style("display", null), re.call(this);
              }).on("mousemove", re).on("mouseout", function() {
                n1.selectAll(".g-end").style("display", null), n1.selectAll(".g-label-value.g-start").call(te, Z), n1.selectAll(".g-label-year.g-start").call(U, Z), n1.selectAll(".g-label-year.g-end").call(U, fe), n1.selectAll(".g-value").style("display", "none");
              }), x.select(n1.nodes()[0]).append("g").attr("class", "y axis").attr("transform", "translate(-4,0)").call(ve), H.append("g").attr("transform", "translate(".concat(k.margins.left, ", ").concat(k.margins.top, ")")).call(function(Be) {
                var ke = 0;
                k.colors.domain().forEach(function(Je) {
                  var i1 = Be.append("g").attr("class", "trellisLegend"), V1 = i1.append("text").text(Je), Y1 = i1.node().getBBox();
                  V1.attr("x", 12).attr("y", Y1.height), i1.append("line").attr("x1", 0).attr("y1", 10).attr("x2", 10).attr("y2", 10).style("stroke", function() {
                    return k.colors(Je);
                  }), i1.attr("transform", "translate(".concat(ke, ", 0)")), ke += i1.node().getBBox().width + 5;
                });
              });
            } }]) && P(z.prototype, Y), D;
          }(m);
          return j;
        }).apply(d, b), C === void 0 || (u.exports = C);
      }, 132: (u, d, f) => {
        var b, C;
        b = [f(680)], (C = (function(v) {
          var A = v.format(",.3r");
          return { wrap: function(P, T) {
            P.each(function() {
              for (var I, w = v.select(this), N = w.text().split(/\s+/).reverse(), E = [], x = 0, m = w.attr("y"), j = parseFloat(w.attr("dy")), _ = w.text(null).append("tspan").attr("x", 0).attr("y", m).attr("dy", j + "em"); I = N.pop(); ) E.push(I), _.text(E.join(" ")), _.node().getComputedTextLength() > T && (E.length > 1 && (E.pop(), N.push(I), _.text(E.join(" "))), E = [], x += 1, _ = w.append("tspan").attr("x", 0).attr("y", m).attr("dy", 1.1 * x + j + "em"));
            });
          }, formatInteger: function(P) {
            return A(P);
          }, formatSI: function(P) {
            return P = P || 0, function(T) {
              if (T < 1) return v.round(T, P);
              var I = v.formatPrefix(T);
              return v.round(I.scale(T), P) + I.symbol;
            };
          }, buildHierarchy: function(P, T, I) {
            for (var w = T || function(J) {
              return J[0];
            }, N = I || function(J) {
              return J[1];
            }, E = { name: "root", children: [] }, x = 0; x < P.length; x++) {
              var m = w(P[x]), j = +N(P[x]);
              if (!isNaN(j)) for (var _ = m.split("-"), z = E, Y = 0; Y < _.length; Y++) {
                var W, D = z.children, F = _[Y];
                if (Y + 1 < _.length) {
                  for (var M = !1, K = 0; K < D.length; K++) if (D[K].name == F && D[K].children) {
                    W = D[K], M = !0;
                    break;
                  }
                  M || (W = { name: F, children: [] }, D.push(W)), z = W;
                } else W = { name: F, size: j }, D.push(W);
              }
            }
            return E;
          } };
        }).apply(d, b)) === void 0 || (u.exports = C);
      }, 383: function(u, d, f) {
        var b, C, v;
        C = [f(680)], b = function(A) {
          return function() {
            var P = j, T = _, I = z, w = H(), N = null, E = null, x = null;
            function m(Q) {
              N = re(Q), E = N.createSVGPoint(), document.body.appendChild(w);
            }
            function j() {
              return "n";
            }
            function _() {
              return [0, 0];
            }
            function z() {
              return " ";
            }
            m.show = function() {
              var Q = Array.prototype.slice.call(arguments);
              Q[Q.length - 1] instanceof SVGElement && (x = Q.pop());
              var ge, Z = I.apply(this, Q), fe = T.apply(this, Q), Se = P.apply(this, Q), be = te(), Te = W.length, Pe = document.documentElement.scrollTop || document.body.scrollTop, xe = document.documentElement.scrollLeft || document.body.scrollLeft;
              for (be.html(Z).style("opacity", 1).style("pointer-events", "all"); Te--; ) be.classed(W[Te], !1);
              return ge = Y.get(Se).apply(this), be.classed(Se, !0).style("top", ge.top + fe[0] + Pe + "px").style("left", ge.left + fe[1] + xe + "px"), m;
            }, m.hide = function() {
              return te().style("opacity", 0).style("pointer-events", "none"), m;
            }, m.attr = function(Q, ge) {
              if (arguments.length < 2 && typeof Q == "string") return te().attr(Q);
              var Z = Array.prototype.slice.call(arguments);
              return A.selection.prototype.attr.apply(te(), Z), m;
            }, m.style = function(Q, ge) {
              if (arguments.length < 2 && typeof Q == "string") return te().style(Q);
              var Z = Array.prototype.slice.call(arguments);
              return A.selection.prototype.style.apply(te(), Z), m;
            }, m.direction = function(Q) {
              return arguments.length ? (P = Q == null ? Q : me(Q), m) : P;
            }, m.offset = function(Q) {
              return arguments.length ? (T = Q == null ? Q : me(Q), m) : T;
            }, m.html = function(Q) {
              return arguments.length ? (I = Q == null ? Q : me(Q), m) : I;
            }, m.destroy = function() {
              return w && (te().remove(), w = null), m;
            };
            var Y = A.map({ n: D, s: F, e: M, w: K, nw: J, ne: q, sw: B, se: k }), W = Y.keys();
            function D() {
              var Q = U();
              return { top: Q.n.y - w.offsetHeight, left: Q.n.x - w.offsetWidth / 2 };
            }
            function F() {
              var Q = U();
              return { top: Q.s.y, left: Q.s.x - w.offsetWidth / 2 };
            }
            function M() {
              var Q = U();
              return { top: Q.e.y - w.offsetHeight / 2, left: Q.e.x };
            }
            function K() {
              var Q = U();
              return { top: Q.w.y - w.offsetHeight / 2, left: Q.w.x - w.offsetWidth };
            }
            function J() {
              var Q = U();
              return { top: Q.nw.y - w.offsetHeight, left: Q.nw.x - w.offsetWidth };
            }
            function q() {
              var Q = U();
              return { top: Q.ne.y - w.offsetHeight, left: Q.ne.x };
            }
            function B() {
              var Q = U();
              return { top: Q.sw.y, left: Q.sw.x - w.offsetWidth };
            }
            function k() {
              var Q = U();
              return { top: Q.se.y, left: Q.e.x };
            }
            function H() {
              var Q = A.select(document.createElement("div"));
              return Q.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), Q.node();
            }
            function re(Q) {
              return (Q = Q.node()).tagName.toLowerCase() === "svg" ? Q : Q.ownerSVGElement;
            }
            function te() {
              return w === null && (w = H(), document.body.appendChild(w)), A.select(w);
            }
            function U() {
              for (var Q = x || A.event.target; Q.getScreenCTM === void 0 && Q.parentNode === "undefined"; ) Q = Q.parentNode;
              var ge = {}, Z = Q.getScreenCTM(), fe = Q.getBBox(), Se = fe.width, be = fe.height, Te = fe.x, Pe = fe.y;
              return E.x = Te, E.y = Pe, ge.nw = E.matrixTransform(Z), E.x += Se, ge.ne = E.matrixTransform(Z), E.y += be, ge.se = E.matrixTransform(Z), E.x -= Se, ge.sw = E.matrixTransform(Z), E.y -= be / 2, ge.w = E.matrixTransform(Z), E.x += Se, ge.e = E.matrixTransform(Z), E.x -= Se / 2, E.y -= be / 2, ge.n = E.matrixTransform(Z), E.y += be, ge.s = E.matrixTransform(Z), ge;
            }
            function me(Q) {
              return typeof Q == "function" ? Q : function() {
                return Q;
              };
            }
            return m;
          };
        }, (v = typeof b == "function" ? b.apply(d, C) : b) === void 0 || (u.exports = v);
      }, 680: (u) => {
        u.exports = a;
      }, 756: (u) => {
        u.exports = l;
      }, 92: (u) => {
        u.exports = i;
      } }, p = {};
      function g(u) {
        if (p[u]) return p[u].exports;
        var d = p[u] = { id: u, loaded: !1, exports: {} };
        return c[u].call(d.exports, d, d.exports, g), d.loaded = !0, d.exports;
      }
      return g.nmd = (u) => (u.paths = [], u.children || (u.children = []), u), g(76);
    })();
  });
})(Qo);
var $h = Qo.exports;
const Xy = () => ({
  cohortVersionId: void 0
}), Zy = (n) => {
  const o = o5(n) ? n == null ? void 0 : n.personCount : n;
  return `${oe(o || 0)} persons`;
}, Jy = (n, o) => ({
  title: n.title,
  type: n.type,
  cohortName: n.cohortName,
  design: o
}), e9 = jo().domain([0.1, 0.25, 0.5, 0.75]).range(["#FF3D19", "#E77F13", "#C9C40D", "#95B90A", "#7BB209"]), c5 = function(n) {
  return (100 * n).toFixed(2) + "%";
}, Wh = (n) => {
  var o = JSON.parse(n.treemapData), a = 1, i = n.inclusionRuleStats.map(function(l, c) {
    var p = t9(o, "1".repeat(c + 1)), g = n.summary.baseCount != 0 ? p / n.summary.baseCount : 0, u = a - g;
    return a = g, {
      name: l.name,
      countSatisfying: p,
      percentSatisfying: g,
      pctDiff: u
    };
  });
  return i;
};
function t9(n, o) {
  var a = 0;
  return n.hasOwnProperty("children") ? n.children.forEach(function(i) {
    a += t9(i, o);
  }) : a = n.name.startsWith(o) ? n.size : 0, a;
}
function n9(n, o) {
  const a = Wh(o);
  if (a) {
    let i = a[n];
    return "Rule " + i.name + ": " + i.countSatisfying.toLocaleString() + ", " + c5(i.percentSatisfying);
  }
  return "";
}
const r9 = (n, o) => {
  let a = [
    {
      key: "ethnicity",
      name: "Demographics Ethnicity",
      designName: "DemographicsEthnicity"
    },
    {
      key: "gender",
      name: "Demographics Gender",
      designName: "DemographicsGender"
    },
    {
      key: "ageGroup",
      name: "Demographics Age Group",
      designName: "DemographicsAgeGroup"
    },
    {
      key: "race",
      name: "Demographics Race",
      designName: "DemographicsRace"
    }
  ];
  const i = [];
  return a.forEach((l) => {
    var c;
    ((c = n[l.key]) == null ? void 0 : c.length) > 0 && i.push(
      Hh(
        n[l.key],
        o,
        l.name,
        l.designName
      )
    );
  }), i;
}, Hh = (n, o, a, i) => ({
  name: a,
  designName: i,
  resultType: R1.PREVALENCE,
  ...o,
  item: n.map((l) => {
    var c, p;
    return {
      ...l,
      covariateName: l.name,
      records: l.records ? l.records : [
        {
          ...l,
          cohortId: l.cohortId ? l.cohortId : (p = (c = o == null ? void 0 : o.design) == null ? void 0 : c.cohort) == null ? void 0 : p.id
        }
      ]
    };
  })
}), Vh = /\s*[+,]\s*/, Uh = "name:", Gh = "#9e9e9e", o9 = (n) => String(n ?? "").split(Vh).map((o) => o.trim()).filter(Boolean), y2 = (n) => {
  const o = String(n ?? "").trim();
  if (!/^\d+$/.test(o))
    return [];
  const a = Number(o);
  if (!Number.isFinite(a) || a <= 0)
    return [];
  const i = [];
  for (let l = 1; l <= a; l *= 2)
    Math.floor(a / l) % 2 === 1 && i.push(String(l));
  return i;
}, Kh = (n) => y2(n).length === 1, Yh = (n = []) => {
  const o = (n || []).filter(Boolean), a = o.filter((p) => !p.combo && Kh(p.code)).map((p) => ({
    code: String(p.code),
    name: String(p.name),
    combo: !1
  })), i = new Set(a.map((p) => p.name)), l = [];
  o.filter((p) => p.combo).forEach((p) => {
    o9(p.name).forEach((g) => {
      i.has(g) || (i.add(g), l.push({
        code: `${Uh}${g}`,
        name: g,
        combo: !1
      }));
    });
  });
  const c = o.filter((p) => p.combo).map((p) => ({
    code: String(p.code),
    name: String(p.name),
    combo: !0
  }));
  return [
    ...a,
    ...l.sort((p, g) => p.name.localeCompare(g.name)),
    ...c
  ];
}, a9 = (n = []) => n.filter((o) => !o.combo), e5 = "end", i9 = (n) => (Array.isArray(n) ? n.join("-") : String(n || "")).split("-").filter(Boolean), _8 = /* @__PURE__ */ new WeakMap(), qh = (n) => {
  const o = _8.get(n);
  if (o)
    return o;
  const a = {
    byCode: /* @__PURE__ */ new Map(),
    byName: /* @__PURE__ */ new Map(),
    byBit: /* @__PURE__ */ new Map()
  };
  return n.forEach((i) => {
    const l = String(i.code);
    if (a.byCode.has(l) || a.byCode.set(l, i), i.combo)
      return;
    a.byName.has(i.name) || a.byName.set(i.name, i);
    const c = y2(l);
    c.length === 1 && !a.byBit.has(c[0]) && a.byBit.set(c[0], i);
  }), _8.set(n, a), a;
}, Wr = (n) => ({
  name: n.name,
  code: String(n.code)
}), v2 = (n, o = []) => {
  if (n === e5)
    return [{ name: e5, code: e5 }];
  const { byCode: a, byName: i, byBit: l } = qh(o), c = a.get(n);
  if (c && !c.combo)
    return [Wr(c)];
  if (c)
    return o9(c.name).map((g) => {
      const u = i.get(g);
      return u ? Wr(u) : { name: g, code: `name:${g}` };
    });
  const p = y2(n);
  return p.length ? p.map((g) => {
    const u = l.get(g);
    return u ? Wr(u) : { name: `Unknown (${g})`, code: g };
  }) : [{ name: n, code: n }];
}, b2 = (n, o) => v2(n, o), s9 = (n, o, a = " + ") => v2(n, o).map((i) => i.name).join(a), Xh = (n, o) => {
  var a;
  return ((a = v2(n, o)[0]) == null ? void 0 : a.code) || n;
}, Zh = (n = [], o = []) => {
  const a = n.map((i, l) => {
    const c = i9(i.path).filter((p) => p !== e5);
    return {
      id: `${l}-${i.personCount}-${c.join("-")}`,
      personCount: i.personCount,
      steps: c,
      ...c.reduce((p, g, u) => (p[`step${u + 1}`] = s9(g, o), p), {})
    };
  });
  return {
    rows: a,
    stepCount: Math.max(1, ...a.map((i) => i.steps.length))
  };
}, Jh = (n = [], o = [], a) => {
  const i = [], l = {}, c = {}, p = {
    data: { name: "root" },
    value: 0,
    parent: null
  }, g = (u, d) => {
    const f = u.slice(0, d + 1).join("-");
    if (c[f] !== void 0)
      return c[f];
    const b = d === 0 ? p : i[g(u, d - 1)].pathNode, C = u[d], v = Xh(C, o), A = i.length;
    return c[f] = A, i.push({
      name: s9(C, o),
      step: C,
      depth: d,
      key: f,
      color: a(String(v)),
      pathNode: {
        data: { name: C },
        value: 0,
        parent: b
      }
    }), A;
  };
  return n.forEach((u) => {
    const d = i9(u.path);
    d.length < 2 || d.forEach((f, b) => {
      if (i[g(d, b)].pathNode.value += u.personCount, p.value += b === 0 ? u.personCount : 0, b === d.length - 1) return;
      const C = g(d, b), v = g(d, b + 1), A = `${C}-${v}`;
      l[A] || (l[A] = {
        source: C,
        target: v,
        value: 0
      }), l[A].value += u.personCount;
    });
  }), {
    nodes: i,
    links: Object.values(l)
  };
};
function l9(n) {
  for (var o = [], a = n; a.parent; )
    o.unshift(a), a = a.parent;
  return o;
}
function c9(n, o, a) {
  return l9(n).map((i) => {
    var l;
    return {
      names: b2(String(((l = i == null ? void 0 : i.data) == null ? void 0 : l.name) ?? ""), a).map(
        (c) => ({
          name: c.name,
          color: o(String(c.code))
        })
      ),
      count: i.value
    };
  });
}
function u9(n) {
  return l9(n).map((o) => {
    var a;
    return String(((a = o == null ? void 0 : o.data) == null ? void 0 : a.name) ?? "");
  }).filter((o) => o && o !== "end");
}
function Qh(n, o, a) {
  const i = (p, g) => `<span class="tip-name" style="background-color:${g}; color:${p == "end" ? "black" : "white"}">${p}</span>`, l = (p) => `<div class="tip-step">${p.names.map((g) => i(g.name, g.color)).join("")}</div>`;
  return `<div class="tip-container">${c9(n, o, a).map((p) => l(p)).join("")}</div>`;
}
const ef = (n, o = []) => {
  var l;
  const a = b2(String(((l = n == null ? void 0 : n.data) == null ? void 0 : l.name) ?? ""), o);
  if (a.length < 2)
    return [n];
  const i = (n.y1 - n.y0) / a.length;
  return a.map((c, p) => {
    const g = Object.assign({}, n, {
      data: { name: String(c.code) }
    });
    return g.y0 = n.y0 + p * i, g.y1 = g.y0 + i, g;
  });
}, tf = (n, o) => n && n.pathways ? {
  ...n,
  pathways: n.pathways.map((a) => {
    var i, l;
    return {
      ...a,
      path: vo(a.path) ? ((l = (i = a.path) == null ? void 0 : i.split("-")) == null ? void 0 : l.length) < o ? a.path + "-end" : a.path : `${a.path.join("-")}-end`
    };
  })
} : n, nf = { end: "#efefef" }, Ut = {
  POST_INDEX: "post-index",
  PRE_INDEX: "pre-index"
}, Q3 = 365, e4 = 1, rf = (n = {}) => n.analysisType === Ut.PRE_INDEX || n.analysisType === Ut.POST_INDEX ? n.analysisType : n.includePreIndexEvents === !0 ? Ut.PRE_INDEX : Ut.POST_INDEX, T4 = (n, o) => {
  const a = Number(n);
  return Number.isFinite(a) ? Math.max(1, Math.abs(a)) : o;
}, t4 = (n, o) => -T4(n, o), of = (n = {}) => {
  const {
    includePreIndexEvents: o,
    preIndexEventLookbackStart: a,
    preIndexEventLookbackEnd: i,
    ...l
  } = n;
  return {
    ...l,
    analysisType: rf(n),
    collapseWindow: l.collapseWindow ?? l.combinationWindow,
    lookbackStartDay: t4(
      l.lookbackStartDay ?? a,
      Q3
    ),
    lookbackEndDay: t4(
      l.lookbackEndDay ?? i,
      e4
    )
  };
}, Qy = () => ({
  allowRepeats: !1,
  combinationWindow: 0,
  collapseWindow: 0,
  eventCohorts: [],
  maxDepth: 5,
  minCellCount: 0,
  analysisType: Ut.POST_INDEX,
  lookbackStartDay: -Q3,
  lookbackEndDay: -e4,
  targetCohorts: []
}), ev = (n) => {
  var o;
  return `${oe(((o = n == null ? void 0 : n.eventCodes) == null ? void 0 : o.length) || 0)} codes`;
}, tv = (n, o) => ({
  ...of(o),
  name: o.title || o.name,
  type: n.type
});
function af(n, o = [], a = !1, i) {
  const l = o.map((p) => p.id), c = [];
  if (!n) return null;
  if (a)
    n.pathwayGroups.forEach((p) => {
      const g = P8(n, p, void 0, i);
      c.push(g);
    });
  else {
    if (l.length == 0) return null;
    l.forEach((p) => {
      let g = n.pathwayGroups.find(
        (u) => p == u.targetCohortUid
      );
      if (g) {
        const u = P8(n, g, p, i);
        c.push(u);
      }
    });
  }
  return c;
}
function d9(n) {
  return n.children ? n.children.reduce((o, a) => o + d9(a), 0) : n.size;
}
function sf(n, o) {
  return {
    versionId: o == null ? void 0 : o.versionId,
    name: o == null ? void 0 : o.name,
    targetCohortCount: oe(n.cohortPersons),
    personsReported: oe(n.pathwayPersons),
    personsReportedPct: c5(
      n.pathwayPersons / n.cohortPersons
    )
  };
}
function lf(n, o) {
  return {
    totalPathways: d9(o),
    cohortPersons: n.targetCohortCount,
    pathwayPersons: n.totalPathwaysCount
  };
}
function P8(n, o, a, i) {
  var c;
  let l = tf(o, i);
  if (l) {
    const p = $h.util.buildHierarchy(
      l.pathways,
      (b) => b.path,
      (b) => b.personCount
    ), g = (c = n.targetCohorts) == null ? void 0 : c.find((b) => a == b.id), u = lf(l, p), d = sf(u, g);
    return {
      pathway: p,
      pathways: l.pathways,
      targetCohort: d,
      summary: u
      // pathDetails: ko.observable(),
    };
  }
}
const nv = ze((n) => {
  var T, I, w, N;
  const {
    subModules: o,
    parentId: a,
    updateDesign: i,
    design: l,
    id: c,
    typeContainer: p,
    analysisName: g,
    viewMode: u
  } = n, d = (E) => (x) => {
    i(E, x);
  }, f = l.analysisType === Ut.PRE_INDEX || !l.analysisType && l.includePreIndexEvents === !0, b = T4(
    l.lookbackStartDay ?? l.preIndexEventLookbackStart,
    Q3
  ), C = T4(
    l.lookbackEndDay ?? l.preIndexEventLookbackEnd,
    e4
  ), v = () => {
    const E = f ? Ut.POST_INDEX : Ut.PRE_INDEX;
    i("analysisType", E), E === Ut.PRE_INDEX && (i(
      "lookbackStartDay",
      t4(b, Q3)
    ), i(
      "lookbackEndDay",
      t4(C, e4)
    ));
  }, A = (E) => {
    const x = Math.max(
      T4(E.target.value, Q3),
      C
    );
    i(
      "lookbackStartDay",
      t4(x, Q3)
    );
  }, P = (E) => {
    const x = Math.min(
      T4(E.target.value, e4),
      b
    );
    i(
      "lookbackEndDay",
      t4(x, e4)
    );
  };
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
    (!u || u && ((T = l == null ? void 0 : l.targetCohorts) == null ? void 0 : T.length) > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(W4, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("b", { children: "Cohort Pathway" }),
        " is defined as the process of generating an aggregated sequence of transitions between the Event Cohorts among those people in the Target Cohorts."
      ] }) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        o.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: o,
          path: L1(p, c, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ e.jsx(
              N1,
              {
                title: "Target cohorts",
                count: (I = l == null ? void 0 : l.targetCohorts) == null ? void 0 : I.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: p,
            initialData: l == null ? void 0 : l.targetCohorts,
            onChange: d("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: g,
            collapsible: !0,
            defaultState: !0,
            description: "Each of the Target Cohorts will be analyzed for the pathways through the event cohorts.",
            viewMode: u
          }
        }
      ) })
    ] }),
    (!u || u && ((w = l == null ? void 0 : l.eventCohorts) == null ? void 0 : w.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        path: L1(p, c, a),
        config: {
          buttonText: "Import event cohort",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Event cohorts",
              count: (N = l == null ? void 0 : l.eventCohorts) == null ? void 0 : N.length
            }
          ),
          classNameContainer: "event-import-button",
          typeContainer: p,
          initialData: l == null ? void 0 : l.eventCohorts,
          onChange: d("eventCohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: g,
          collapsible: !0,
          defaultState: u,
          description: "Each Event Cohort defines the step in a pathway that may occur for a person in the Target Cohort.",
          viewMode: u
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        collapsible: !0,
        title: "Analysis Settings",
        defaultState: u,
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, px: 1, children: [
            /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the pathway analysis." }),
            /* @__PURE__ */ e.jsx(M1, { sx: { borderColor: "borderColor.light" } })
          ] }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "collapse-days",
              textLabel: "Collapse days",
              description: "Any dates found within the specified collapse days will be reassigned the earliest date. Collapsing dates reduces pathway variation, leading to a reduction in 'noise' in the result.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 80, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  className: "",
                  name: "collapse-days",
                  disablePortal: !0,
                  id: "collapse-days",
                  options: Mh,
                  value: l.collapseWindow ?? l.combinationWindow,
                  placeholder: "Select days...",
                  onChange: (E) => {
                    i("combinationWindow", E), i("collapseWindow", E);
                  },
                  disabled: u
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "minimumCellCount",
              textLabel: "Minimum cell count",
              description: "Minimum number of subjects in the target cohort for a given event in order to be counted in the pathway.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 80, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  className: "",
                  name: "minimumCellCount",
                  disablePortal: !0,
                  id: "minimumCellCount",
                  options: T8,
                  value: l.minCellCount,
                  placeholder: "Select count...",
                  onChange: (E) => {
                    i("minCellCount", E);
                  },
                  disabled: u
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "maximumPathLength",
              textLabel: "Maximum path length",
              description: "Maximum number of steps in a given pathway to be included in the sunburst plot.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 80, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  className: "",
                  name: "maximumPathLength",
                  disablePortal: !0,
                  id: "maximumPathLength",
                  options: T8,
                  value: l.maxDepth,
                  placeholder: "Select length...",
                  onChange: (E) => {
                    i("maxDepth", E);
                  },
                  disabled: u
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "allowRepeats",
              textLabel: "Allow repeats",
              description: "Allow cohort events/combos to appear multiple times in the same pathway.",
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "allowRepeats",
                  name: "allowRepeats",
                  onChange: () => {
                    i("allowRepeats", !l.allowRepeats);
                  },
                  checked: l.allowRepeats,
                  disabled: u
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "analysisType",
              textLabel: "Include pre-index events",
              description: "Include events that happened before index (event that triggers a person to enter the cohort).",
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "analysisType",
                  name: "analysisType",
                  onChange: v,
                  checked: f,
                  disabled: u
                }
              )
            }
          ) }),
          f && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "lookbackStartDay",
              textLabel: "Pre-index event lookback window",
              description: "Specify a lookback window start and end dates to search for pre-index events.",
              children: /* @__PURE__ */ e.jsxs(
                y,
                {
                  container: !0,
                  spacing: 1,
                  alignItems: "center",
                  flexWrap: "wrap",
                  rowGap: 1,
                  children: [
                    /* @__PURE__ */ e.jsxs(
                      y,
                      {
                        item: !0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "nowrap",
                        children: [
                          /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, whiteSpace: "nowrap", children: "starting with" }),
                          /* @__PURE__ */ e.jsx(
                            et,
                            {
                              id: "lookbackStartDay",
                              name: "lookbackStartDay",
                              type: "number",
                              value: b,
                              onChange: A,
                              min: C,
                              disabled: u,
                              sx: { width: 80 }
                            }
                          ),
                          /* @__PURE__ */ e.jsx(ce, { fontSize: 13, ml: 1, whiteSpace: "nowrap", children: "days before index" })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      y,
                      {
                        item: !0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "nowrap",
                        children: [
                          /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, whiteSpace: "nowrap", children: "and ending with" }),
                          /* @__PURE__ */ e.jsx(
                            et,
                            {
                              id: "lookbackEndDay",
                              name: "lookbackEndDay",
                              type: "number",
                              value: C,
                              onChange: P,
                              min: 1,
                              max: b,
                              disabled: u,
                              sx: { width: 80 }
                            }
                          ),
                          /* @__PURE__ */ e.jsx(ce, { fontSize: 13, ml: 1, whiteSpace: "nowrap", children: "days before index" })
                        ]
                      }
                    )
                  ]
                }
              )
            }
          ) })
        ] })
      }
    ) })
  ] });
}), u5 = Fe.div`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme: n }) => {
  var o;
  return Ot(0.5, (o = n.palette) == null ? void 0 : o.primary.main);
}};
  text-align: center;
`, cf = Fe.div`
  font-size: 12px;
  font-weight: 500;
`, uf = (n) => {
  const {
    targetCohortCount: o,
    pathwaysCount: a,
    targetCohortName: i,
    personsReportedPct: l
  } = n;
  return /* @__PURE__ */ e.jsxs(X, { children: [
    /* @__PURE__ */ e.jsx(ce, { variant: "h3", children: "Target Cohort" }),
    /* @__PURE__ */ e.jsx(ce, { variant: "body2", mt: 1, children: i }),
    /* @__PURE__ */ e.jsxs(
      ce,
      {
        component: "ul",
        my: 1,
        sx: {
          paddingInlineStart: "32px"
        },
        children: [
          /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", component: "li", children: [
            "Target cohort count: ",
            o
          ] }),
          /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", component: "li", children: [
            "Persons with pathways count: ",
            oe(a)
          ] }),
          /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", component: "li", children: [
            "Persons with pathways portion: ",
            l
          ] })
        ]
      }
    )
  ] });
}, df = Fe.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  padding-left: 20px;
`, pf = Fe.div`
  background: ${({ color: n }) => `${n}`};
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 2px;
`;
Fe(cf)``;
const mf = (n) => {
  const { eventCohorts: o, colors: a } = n, i = a9(o).map((l) => /* @__PURE__ */ e.jsxs(df, { children: [
    /* @__PURE__ */ e.jsx(pf, { color: a(l.code) }),
    /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", children: l.name })
  ] }, l.code));
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ce, { variant: "h3", mb: 1, children: "Event Cohorts" }),
    i
  ] });
}, p9 = Fe.span`
  background: ${({ color: n }) => `${n}`};
  padding: 2px 6px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 2px;
`, hf = [
  {
    header: "Name",
    accessorKey: "names",
    enableResizing: !1,
    size: 180,
    cell: (n) => /* @__PURE__ */ e.jsx(X, { display: "flex", flexWrap: "wrap", p: 0.5, alignItems: "center", children: n.getValue().map((o, a) => /* @__PURE__ */ e.jsx(
      p9,
      {
        color: o.color,
        children: o.name
      },
      `${a}-${o.name}`
    )) })
  },
  {
    header: "Remain",
    id: "remain",
    enableResizing: !1,
    size: 100,
    minSize: 120,
    cell: (n) => /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", children: [
      oe(n.row.original.personCount),
      " (",
      c5(n.row.original.remainPct),
      ")"
    ] })
  },
  {
    header: "Diff",
    id: "diff",
    enableResizing: !1,
    size: 100,
    minSize: 120,
    cell: (n) => /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", children: [
      oe(n.row.original.diff),
      " (",
      c5(n.row.original.diffPct),
      ")"
    ] })
  }
], ff = ze((n) => {
  const { pathData: o, colors: a, eventCohorts: i, pathwaysCount: l } = n;
  if (!o)
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ce, { variant: "h3", mb: 1, children: "Path Details" }),
      /* @__PURE__ */ e.jsx(u5, { children: "No path selected: click path to see details." })
    ] });
  const c = je(() => {
    let p = c9(o, a, i);
    const g = (d) => ({
      names: d.names,
      personCount: d.count,
      remainPct: d.count / l,
      diffPct: null,
      diff: null
    });
    let u = p.map(g);
    return u.forEach((d, f) => {
      f > 0 ? (d.diffPct = u[f - 1].remainPct - d.remainPct, d.diff = u[f - 1].personCount - d.personCount) : (d.diffPct = 1 - d.remainPct, d.diff = l - d.personCount);
    }), u;
  }, [o]);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ce, { variant: "h3", mb: 1, children: "Path Details" }),
    /* @__PURE__ */ e.jsx(
      y1,
      {
        columns: hf,
        data: c || [],
        pageSize: 10
      }
    )
  ] });
}), xf = ze((n) => {
  const { eventCohorts: o, colors: a, pathData: i, targetCohort: l, summary: c } = n;
  return /* @__PURE__ */ e.jsxs(
    X,
    {
      sx: {
        display: "flex",
        flexDirection: "column"
      },
      minHeight: "100%",
      children: [
        /* @__PURE__ */ e.jsxs(Gt, { elevation: 3, sx: { p: 1 }, children: [
          /* @__PURE__ */ e.jsx(
            uf,
            {
              targetCohortName: l.name,
              targetCohortCount: l.targetCohortCount,
              pathwaysCount: c.totalPathways,
              personsReportedPct: l.personsReportedPct
            }
          ),
          /* @__PURE__ */ e.jsx(mf, { eventCohorts: o, colors: a })
        ] }),
        /* @__PURE__ */ e.jsx(Gt, { elevation: 3, sx: { mt: 2, flexGrow: 1, p: 1 }, children: /* @__PURE__ */ e.jsx(
          ff,
          {
            pathData: i,
            colors: a,
            eventCohorts: o,
            pathwaysCount: c.totalPathways
          }
        ) })
      ]
    }
  );
}), gf = ({ value: n, options: o, onChange: a }) => /* @__PURE__ */ e.jsx(
  H1,
  {
    multiple: !0,
    name: "cohorts",
    id: "cohorts",
    value: n,
    placeholder: "Select cohorts...",
    options: o || [],
    fullWidth: !0,
    getOptionLabel: (i) => i.name,
    onChange: (i, l) => {
      a(l);
    },
    isOptionEqualToValue: (i, l) => i.id === l.id,
    limitTags: 2,
    renderTags: (i, l) => {
      const c = i.length, p = 2;
      return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        i.slice(0, p).map((g, u) => /* @__PURE__ */ to(
          ld,
          {
            ...l({ index: u }),
            key: u,
            label: g.name,
            size: "small"
          }
        )),
        c > p && ` +${c - p}`
      ] });
    }
  }
), yf = Fe.div`
  .pathway-all-pathways-table .cell-wrapper {
    overflow: hidden;
  }
`, vf = Fe.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  max-width: 100%;

  > * {
    margin-right: 0;
    margin-bottom: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
  }
`, bf = ze(
  ({ pathways: n, eventCohorts: o, colors: a, selectedPath: i }) => {
    const [l, c] = pe({
      textWrap: !0
    }), { rows: p, stepCount: g } = je(
      () => Zh(n, o),
      [n, o]
    ), u = je(() => {
      if (!i) return {};
      const f = u9(i).join("-");
      return f ? p.reduce((b, C) => (C.steps.join("-") === f && (b[C.id] = !0), b), {}) : {};
    }, [i, p]), d = je(() => {
      const f = Array.from({ length: g }, (b, C) => ({
        header: `Step ${C + 1}`,
        accessorKey: `step${C + 1}`,
        enableResizing: !0,
        size: 180,
        minSize: 120,
        cell: (v) => {
          const A = v.row.original.steps[C];
          return A ? /* @__PURE__ */ e.jsx(vf, { children: b2(A, o).map((P, T) => /* @__PURE__ */ e.jsx(
            p9,
            {
              color: a(String(P.code)),
              children: P.name
            },
            `${P.code}-${T}`
          )) }) : "";
        }
      }));
      return [
        {
          header: "Person count",
          accessorKey: "personCount",
          enableResizing: !0,
          size: 120,
          minSize: 100,
          cell: (b) => /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", children: oe(b.getValue()) })
        },
        ...f
      ];
    }, [g, o, a]);
    return /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: "All pathways",
        collapsible: !0,
        defaultState: !1,
        size: "dense",
        children: /* @__PURE__ */ e.jsx(yf, { children: /* @__PURE__ */ e.jsx(
          y1,
          {
            columns: d,
            data: p,
            pageSize: 10,
            noDataText: "No pathways found",
            settingsOptions: l,
            onSettingsChange: c,
            getRowId: (f) => f.id,
            selectedRowIds: u,
            className: "pathway-all-pathways-table"
          }
        ) })
      }
    );
  }
), Cf = 16, jf = 2;
function Sf(n, o) {
  const a = n + Math.max(0, o - jf);
  return Math.max(n, Math.min(Cf, a));
}
function wf(n, o = "untitled") {
  const { svgBlob: a } = m9(n), i = URL.createObjectURL(a);
  f9(i, o + ".svg"), window.setTimeout(() => URL.revokeObjectURL(i));
}
function Tf(n, o = "untitled") {
  const { svgBlob: a, width: i, height: l } = m9(n), c = window.URL || window.webkitURL || window, p = c.createObjectURL(a), g = new Image();
  g.onload = function() {
    const u = document.createElement("canvas");
    u.width = i, u.height = l;
    const d = u.getContext("2d");
    d == null || d.drawImage(g, 0, 0, i, l), c.revokeObjectURL(p), u.toBlob((f) => {
      if (!f) {
        console.error("Failed to create Sankey chart PNG blob", {
          name: o,
          width: i,
          height: l
        });
        return;
      }
      const b = c.createObjectURL(f);
      f9(b, o + ".png"), window.setTimeout(() => c.revokeObjectURL(b));
    }, "image/png");
  }, g.onerror = function() {
    c.revokeObjectURL(p), console.error("Failed to render Sankey chart SVG as PNG", {
      name: o,
      width: i,
      height: l
    });
  }, g.src = p;
}
function m9(n) {
  var g;
  const o = (g = n == null ? void 0 : n.current) == null ? void 0 : g.querySelector("svg");
  if (!o)
    throw new Error("Sankey chart SVG was not found");
  const { width: a, height: i } = Ef(o), l = o.cloneNode(!0);
  h9(o, l), l.setAttribute("xmlns", "http://www.w3.org/2000/svg"), l.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), l.setAttribute("width", String(a)), l.setAttribute("height", String(i)), l.getAttribute("viewBox") || l.setAttribute("viewBox", `0 0 ${a} ${i}`), Af(l, a, i);
  const c = new XMLSerializer().serializeToString(l);
  return { svgBlob: new Blob([c], {
    type: "image/svg+xml;charset=utf-8"
  }), width: a, height: i };
}
function Ef(n) {
  var l, c, p, g, u, d, f, b;
  const o = n.getBoundingClientRect(), a = o.width || ((c = (l = n.viewBox) == null ? void 0 : l.baseVal) == null ? void 0 : c.width) || ((g = (p = n.width) == null ? void 0 : p.baseVal) == null ? void 0 : g.value) || Number(n.getAttribute("width")) || 0, i = o.height || ((d = (u = n.viewBox) == null ? void 0 : u.baseVal) == null ? void 0 : d.height) || ((b = (f = n.height) == null ? void 0 : f.baseVal) == null ? void 0 : b.value) || Number(n.getAttribute("height")) || 0;
  return {
    width: Math.ceil(a),
    height: Math.ceil(i)
  };
}
function h9(n, o) {
  const a = window.getComputedStyle(n), i = Array.from(a).map((l) => `${l}:${a.getPropertyValue(l)}`).join(";");
  o.setAttribute("style", i), Array.from(n.children).forEach((l, c) => {
    const p = o.children[c];
    p && h9(l, p);
  });
}
function Af(n, o, a) {
  const i = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "rect"
  );
  i.setAttribute("width", String(o)), i.setAttribute("height", String(a)), i.setAttribute("fill", "#fff"), n.insertBefore(i, n.firstChild);
}
function f9(n, o) {
  const a = document.createElement("a");
  a.href = n, a.download = o, document.body.appendChild(a), a.click(), document.body.removeChild(a);
}
const _f = 20, L4 = { top: 16, right: 24, bottom: 16, left: 24 }, Pf = 26, Of = 4, O8 = 3, If = (n, o) => {
  const a = Math.max(
    0,
    n - L4.top - L4.bottom
  );
  return Math.max(
    Of,
    Math.min(
      Pf,
      Math.floor(a * 0.55 / Math.max(1, o - 1))
    )
  );
}, I8 = 14, Rf = 6, Nf = (n, o) => {
  const a = Math.max(3, o);
  return n.length > a ? `${n.slice(0, a - 1)}…` : n;
}, Ff = (n) => {
  const {
    x: o,
    y: a,
    width: i,
    height: l,
    payload: c,
    chartWidth: p,
    maxLabelChars: g,
    nodePadding: u,
    selectedKey: d,
    onSelect: f
  } = n, b = o < p / 2, C = b ? o + i + 6 : o - 6, v = b ? "start" : "end", A = Sf(l, u), P = l >= _f, T = !!d && c.key === d;
  return /* @__PURE__ */ e.jsxs(
    "g",
    {
      onClick: () => f == null ? void 0 : f(c),
      style: { cursor: "pointer" },
      role: "button",
      children: [
        /* @__PURE__ */ e.jsx("title", { children: c.name }),
        /* @__PURE__ */ e.jsx(
          "rect",
          {
            x: o,
            y: a,
            width: i,
            height: A,
            fill: c.color,
            fillOpacity: T ? 1 : 0.85,
            stroke: T ? "#172b4d" : "none",
            strokeWidth: T ? 1.5 : 0,
            rx: 1
          }
        ),
        P && /* @__PURE__ */ e.jsx(
          "text",
          {
            x: C,
            y: a + A / 2,
            textAnchor: v,
            dominantBaseline: "middle",
            fontSize: 10,
            fontWeight: T ? 600 : 400,
            fill: "#172b4d",
            children: Nf(c.name, g)
          }
        )
      ]
    }
  );
}, Df = (n) => {
  const {
    sourceX: o,
    sourceY: a,
    sourceControlX: i,
    targetX: l,
    targetY: c,
    targetControlX: p,
    linkWidth: g,
    payload: u,
    selectedKey: d,
    onSelect: f
  } = n, b = !!d && (d === u.target.key || d.startsWith(`${u.target.key}-`));
  return /* @__PURE__ */ e.jsx(
    "path",
    {
      d: `M${o},${a} C${i},${a} ${p},${c} ${l},${c}`,
      fill: "none",
      stroke: u.source.color,
      strokeWidth: Math.max(g, 1),
      strokeOpacity: b ? 0.55 : 0.22,
      style: { cursor: "pointer" },
      onClick: () => f == null ? void 0 : f(u.target)
    }
  );
}, Lf = ({ active: n, payload: o }) => {
  var c, p, g;
  if (!n || !(o != null && o.length)) return null;
  const a = (c = o[0]) == null ? void 0 : c.payload, i = (p = a == null ? void 0 : a.source) == null ? void 0 : p.name, l = (g = a == null ? void 0 : a.target) == null ? void 0 : g.name;
  return /* @__PURE__ */ e.jsxs(
    X,
    {
      sx: {
        background: "#fff",
        border: "1px solid #d8dee8",
        borderRadius: "2px",
        boxShadow: "0 2px 8px rgba(23, 43, 77, 0.12)",
        p: 1
      },
      children: [
        /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", children: i && l ? `${i} -> ${l}` : a == null ? void 0 : a.name }),
        (a == null ? void 0 : a.value) !== void 0 && /* @__PURE__ */ e.jsx(ce, { variant: "body2", children: oe(a.value) })
      ]
    }
  );
}, Mf = ze(
  ({
    pathways: n,
    eventCohorts: o,
    colors: a,
    zoom: i = 1,
    onZoomBy: l,
    selectedPath: c,
    onSelectPath: p
  }) => {
    const g = je(
      () => Jh(n, o, a),
      [n, o, a]
    ), u = je(
      () => c ? u9(c).join("-") : "",
      [c]
    ), d = je(() => {
      const E = {};
      return g.nodes.forEach((x) => {
        E[x.depth] = (E[x.depth] || 0) + 1;
      }), Math.max(1, ...Object.values(E));
    }, [g]), f = je(
      () => Math.max(
        1,
        ...g.nodes.map((E) => E.depth + 1)
      ),
      [g]
    ), b = $1(null), C = $1(void 0), v = $1({
      active: !1,
      // Tells a pan apart from a click so dragging the zoomed diagram never
      // selects the node the pointer happens to be released on.
      moved: !1,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0
    }), A = w1(
      (E) => {
        if (v.current.moved) {
          v.current.moved = !1;
          return;
        }
        p == null || p(E == null ? void 0 : E.pathNode);
      },
      [p]
    ), P = w1(
      (E) => {
        var m;
        if ((m = C.current) == null || m.call(C), C.current = void 0, b.current = E, !E)
          return;
        const x = (j) => {
          !j.ctrlKey && !j.metaKey || (j.preventDefault(), l == null || l(j.deltaY < 0 ? 1 : -1));
        };
        E.addEventListener("wheel", x, { passive: !1 }), C.current = () => E.removeEventListener("wheel", x);
      },
      [l]
    ), T = (E) => {
      v.current.moved = !1;
      const x = b.current;
      !x || E.button !== 0 || i <= 1 || (v.current = {
        active: !0,
        moved: !1,
        startX: E.clientX,
        startY: E.clientY,
        scrollLeft: x.scrollLeft,
        scrollTop: x.scrollTop
      });
    }, I = (E) => {
      var z;
      const x = v.current, m = b.current;
      if (!x.active || !m)
        return;
      const j = E.clientX - x.startX, _ = E.clientY - x.startY;
      (Math.abs(j) > O8 || Math.abs(_) > O8) && ((z = m.setPointerCapture) == null || z.call(m, E.pointerId), x.moved = !0, m.scrollLeft = x.scrollLeft - j, m.scrollTop = x.scrollTop - _);
    }, w = (E) => {
      var x, m;
      v.current.active && ((m = (x = b.current) == null ? void 0 : x.releasePointerCapture) == null || m.call(x, E.pointerId)), v.current.active = !1;
    };
    if (!g.links.length)
      return /* @__PURE__ */ e.jsx(u5, { children: "No pathways found" });
    const N = i > 1;
    return /* @__PURE__ */ e.jsx(
      X,
      {
        sx: {
          height: "100%",
          minHeight: 550,
          width: "100%",
          position: "relative"
        },
        children: /* @__PURE__ */ e.jsx(_o, { children: ({ width: E, height: x }) => {
          const m = Math.max(0, E || 0), j = Math.max(0, x || 0), _ = If(j, d), z = Math.floor(m * i), Y = Math.floor(j * i), W = m - L4.left - L4.right, D = f > 1 ? W / (f - 1) : W, F = Math.max(
            4,
            Math.floor((D - I8 - 8) / Rf)
          );
          return /* @__PURE__ */ e.jsx(
            X,
            {
              ref: P,
              onPointerDown: T,
              onPointerMove: I,
              onPointerUp: w,
              onPointerCancel: w,
              sx: {
                width: m,
                height: j,
                // No scrollbars at 100% (fits the container); they only
                // appear once the user zooms in (PRO-3920 review #1).
                overflow: N ? "auto" : "hidden",
                cursor: N ? "grab" : "default",
                ...N ? { "&:active": { cursor: "grabbing" } } : {}
              },
              children: /* @__PURE__ */ e.jsx(
                X,
                {
                  sx: {
                    width: z,
                    height: Y
                  },
                  children: /* @__PURE__ */ e.jsx(
                    X,
                    {
                      sx: {
                        width: m,
                        height: j,
                        transform: `scale(${i})`,
                        transformOrigin: "0 0"
                      },
                      children: /* @__PURE__ */ e.jsx(
                        qd,
                        {
                          width: m,
                          height: j,
                          data: g,
                          node: (M) => /* @__PURE__ */ e.jsx(
                            Ff,
                            {
                              ...M,
                              chartWidth: m,
                              maxLabelChars: F,
                              nodePadding: _,
                              selectedKey: u,
                              onSelect: A
                            }
                          ),
                          link: (M) => /* @__PURE__ */ e.jsx(
                            Df,
                            {
                              ...M,
                              selectedKey: u,
                              onSelect: A
                            }
                          ),
                          nodePadding: _,
                          nodeWidth: I8,
                          linkCurvature: 0.45,
                          iterations: 64,
                          margin: L4,
                          sort: !1,
                          children: /* @__PURE__ */ e.jsx(h3, { content: Lf })
                        }
                      )
                    }
                  )
                }
              )
            }
          );
        } })
      }
    );
  }
), s3 = 1, x9 = 4, kf = 0.25, R8 = 3, zf = (n) => Math.min(x9, Math.max(s3, Math.round(n * 100) / 100)), t5 = 30, Bf = {
  display: "flex",
  alignItems: "center",
  gap: 0.25,
  height: t5,
  boxSizing: "border-box",
  px: 0.5,
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: 1,
  "& .MuiIconButton-root": {
    p: "3px",
    borderRadius: 1,
    // Neutralise the theme's grey disabled background + border on the icons.
    "&.Mui-disabled": {
      background: "transparent",
      border: "none"
    },
    "& .MuiSvgIcon-root": { fontSize: 18 }
  }
}, $f = ({ isExit: n = !1 }) => {
  const o = "#0f1f45";
  return /* @__PURE__ */ e.jsx(
    X,
    {
      component: "svg",
      viewBox: "0 0 16 16",
      "aria-hidden": !0,
      sx: { width: 14, height: 14, display: "block" },
      children: n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M2.5 13.5 L6.5 9.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M5.5 13.5 H2.5 V10.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M13.5 2.5 L9.5 6.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M10.5 2.5 H13.5 V5.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M6.5 6.5 L2.5 2.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M2.5 5.5 V2.5 H5.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M9.5 9.5 L13.5 13.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M10.5 13.5 H13.5 V10.5",
            stroke: o,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] })
    }
  );
}, Wf = ({
  colors: n,
  eventCohorts: o,
  targetCohort: a,
  summary: i,
  pathway: l,
  pathways: c,
  legacy: p
}) => {
  const [g, u] = pe(null), [d, f] = pe("sunburst"), b = (q) => Qh(q, n, o), [C, v] = pe(1), [A, P] = pe(!1), [T, I] = pe(!1), [w, N] = pe(null), E = A || T, x = $1(null), m = $1(null), j = w1(
    (q) => v((B) => zf(B + q * kf)),
    []
  ), _ = $1(null), z = $1(void 0), Y = $1({
    active: !1,
    moved: !1,
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0
  }), W = w1(
    (q) => {
      var H;
      if ((H = z.current) == null || H.call(z), z.current = void 0, _.current = q, !q)
        return;
      const B = (re) => {
        !re.ctrlKey && !re.metaKey || (re.preventDefault(), j(re.deltaY < 0 ? 1 : -1));
      }, k = (re) => {
        Y.current.moved && (re.stopPropagation(), re.preventDefault(), Y.current.moved = !1);
      };
      q.addEventListener("wheel", B, { passive: !1 }), q.addEventListener("click", k, !0), z.current = () => {
        q.removeEventListener("wheel", B), q.removeEventListener("click", k, !0);
      };
    },
    [j]
  ), D = (q) => {
    Y.current.moved = !1;
    const B = _.current;
    !B || q.button !== 0 || C <= s3 || (Y.current = {
      active: !0,
      moved: !1,
      startX: q.clientX,
      startY: q.clientY,
      scrollLeft: B.scrollLeft,
      scrollTop: B.scrollTop
    });
  }, F = (q) => {
    var te;
    const B = Y.current, k = _.current;
    if (!B.active || !k)
      return;
    const H = q.clientX - B.startX, re = q.clientY - B.startY;
    (Math.abs(H) > R8 || Math.abs(re) > R8) && ((te = k.setPointerCapture) == null || te.call(k, q.pointerId), B.moved = !0, k.scrollLeft = B.scrollLeft - H, k.scrollTop = B.scrollTop - re);
  }, M = (q) => {
    var B, k;
    Y.current.active && ((k = (B = _.current) == null ? void 0 : B.releasePointerCapture) == null || k.call(B, q.pointerId)), Y.current.active = !1;
  }, K = (q) => {
    var k;
    if (!((k = m.current) != null && k.querySelector("svg")))
      return;
    const B = a.name ? a.name.replace(/[^A-Z0-9]+/gi, "_") + "__" : "";
    q(m, `${B}${d}`);
  };
  m1(() => {
    const q = () => {
      const B = document.fullscreenElement === x.current;
      P(B), B && I(!1);
    };
    return document.addEventListener("fullscreenchange", q), () => document.removeEventListener("fullscreenchange", q);
  }, []), m1(() => {
    if (!T)
      return;
    const q = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = q;
    };
  }, [T]), m1(() => {
    if (!E)
      return;
    const q = (B) => {
      B.key === "Escape" && (B.stopPropagation(), T && (B.preventDefault(), I(!1)));
    };
    return document.addEventListener("keydown", q, !0), () => document.removeEventListener("keydown", q, !0);
  }, [E, T]);
  const J = w1(async () => {
    var B;
    const q = x.current;
    if (q) {
      if (T) {
        I(!1);
        return;
      }
      if (document.fullscreenElement) {
        try {
          await ((B = document.exitFullscreen) == null ? void 0 : B.call(document));
        } catch {
          P(!1);
        }
        return;
      }
      if (typeof q.requestFullscreen != "function") {
        I(!0);
        return;
      }
      try {
        await q.requestFullscreen();
      } catch {
        I(!0);
      }
    }
  }, [T]);
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
    Ne,
    {
      collapsible: !p,
      defaultState: !0,
      title: a.name,
      isDark: !0,
      size: "dense",
      children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 6, md: 5.5, lg: 5, pr: 2, children: /* @__PURE__ */ e.jsx(
          xf,
          {
            eventCohorts: o,
            colors: n,
            pathData: g,
            targetCohort: a,
            summary: i
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { xs: 6, md: 6.5, lg: 7, item: !0, children: /* @__PURE__ */ e.jsx(Gt, { elevation: 3, sx: { p: 1, height: "calc(100% - 16px)" }, children: /* @__PURE__ */ e.jsxs(
          X,
          {
            ref: x,
            sx: {
              display: "flex",
              flexDirection: "column",
              height: E ? "100%" : "auto",
              ...E ? { backgroundColor: "#fff", p: 1 } : {},
              ...T ? { position: "fixed", inset: 0, zIndex: 1400 } : {}
            },
            children: [
              /* @__PURE__ */ e.jsxs(
                X,
                {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  mb: 1,
                  children: [
                    /* @__PURE__ */ e.jsxs(
                      $4,
                      {
                        size: "small",
                        variant: "outlined",
                        sx: {
                          height: t5,
                          "& .MuiButtonBase-root": {
                            height: t5,
                            minHeight: t5
                          }
                        },
                        children: [
                          /* @__PURE__ */ e.jsx(
                            Ye,
                            {
                              variant: d === "sunburst" ? "contained" : "outlined",
                              onClick: () => f("sunburst"),
                              children: "Sunburst"
                            }
                          ),
                          /* @__PURE__ */ e.jsx(
                            Ye,
                            {
                              variant: d === "sankey" ? "contained" : "outlined",
                              onClick: () => f("sankey"),
                              children: "Sankey"
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(X, { display: "flex", alignItems: "center", gap: 1, children: [
                      /* @__PURE__ */ e.jsxs(X, { sx: Bf, children: [
                        /* @__PURE__ */ e.jsx(
                          Vt,
                          {
                            size: "small",
                            "aria-label": "Zoom out",
                            title: "Zoom out",
                            disabled: C <= s3,
                            onClick: () => j(-1),
                            children: /* @__PURE__ */ e.jsx(t1, { iconName: "zoomOut", fontSize: "small" })
                          }
                        ),
                        /* @__PURE__ */ e.jsxs(
                          ce,
                          {
                            sx: {
                              minWidth: 34,
                              textAlign: "center",
                              userSelect: "none",
                              fontSize: 12,
                              fontWeight: 400,
                              color: "primary.main"
                            },
                            children: [
                              Math.round(C * 100),
                              "%"
                            ]
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          Vt,
                          {
                            size: "small",
                            "aria-label": "Zoom in",
                            title: "Zoom in",
                            disabled: C >= x9,
                            onClick: () => j(1),
                            children: /* @__PURE__ */ e.jsx(t1, { iconName: "zoomIn", fontSize: "small" })
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          Vt,
                          {
                            size: "small",
                            "aria-label": "Reset zoom",
                            title: "Reset zoom",
                            disabled: C === s3,
                            onClick: () => v(s3),
                            children: /* @__PURE__ */ e.jsx(t1, { iconName: "reload", fontSize: "small" })
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          Vt,
                          {
                            size: "small",
                            "aria-label": E ? "Exit fullscreen" : "Fullscreen",
                            title: E ? "Exit fullscreen" : "Fullscreen",
                            onClick: J,
                            children: /* @__PURE__ */ e.jsx($f, { isExit: E })
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e.jsx(
                        cd,
                        {
                          name: "download",
                          color: "primary",
                          iconName: "download",
                          tooltipText: "Download",
                          noExpand: !0,
                          onClick: (q) => N(q.currentTarget)
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(
                        ro,
                        {
                          anchorEl: w,
                          open: !!w,
                          onClose: () => N(null),
                          anchorOrigin: { vertical: "bottom", horizontal: "right" },
                          transformOrigin: { vertical: "top", horizontal: "right" },
                          slotProps: {
                            paper: { sx: { mt: 0.5, minWidth: 52 } }
                          },
                          sx: {
                            "& .MuiMenuItem-root": {
                              minHeight: 26,
                              px: 1.25,
                              py: 0.25,
                              fontSize: 12,
                              lineHeight: 1.2
                            }
                          },
                          children: [
                            /* @__PURE__ */ e.jsx(
                              Xr,
                              {
                                onClick: () => {
                                  N(null), K(wf);
                                },
                                children: "SVG"
                              }
                            ),
                            /* @__PURE__ */ e.jsx(
                              Xr,
                              {
                                onClick: () => {
                                  N(null), K(Tf);
                                },
                                children: "PNG"
                              }
                            )
                          ]
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ e.jsx(
                X,
                {
                  ref: m,
                  sx: {
                    width: "100%",
                    ...E ? { flex: 1, minHeight: 0 } : { height: 550 },
                    // The Sunburst chart ships its own overlay SVG/PNG buttons
                    // (shown on hover via Chart.css). Force them hidden — with
                    // !important to beat the equal-specificity hover rule — so
                    // downloads are driven from the toolbar above, like Sankey.
                    "& .chart-wrapper_button-group": {
                      display: "none !important"
                    }
                  },
                  children: d === "sunburst" ? (
                    // Zoom the Sunburst by rendering it into a larger box inside
                    // a scroll viewport (same idea as the Sankey) so the zoom
                    // panel works in both modes (review #5).
                    /* @__PURE__ */ e.jsx(
                      X,
                      {
                        ref: W,
                        onPointerDown: D,
                        onPointerMove: F,
                        onPointerUp: M,
                        onPointerCancel: M,
                        sx: {
                          width: "100%",
                          height: "100%",
                          overflow: C > s3 ? "auto" : "hidden",
                          cursor: C > s3 ? "grab" : "default",
                          ...C > s3 ? { "&:active": { cursor: "grabbing" } } : {}
                        },
                        children: /* @__PURE__ */ e.jsx(
                          X,
                          {
                            sx: {
                              width: `${C * 100}%`,
                              height: `${C * 100}%`
                            },
                            children: /* @__PURE__ */ e.jsx(
                              H4,
                              {
                                type: "sunburst",
                                chartData: l,
                                fileName: a.name,
                                options: () => ({
                                  colors: n,
                                  split: (q) => ef(q, o),
                                  onclick: u,
                                  tooltip: b,
                                  minRadians: 0
                                })
                              }
                            )
                          }
                        )
                      }
                    )
                  ) : /* @__PURE__ */ e.jsx(
                    Mf,
                    {
                      pathways: c,
                      eventCohorts: o,
                      colors: n,
                      zoom: C,
                      onZoomBy: j,
                      selectedPath: g,
                      onSelectPath: u
                    }
                  )
                }
              )
            ]
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ e.jsx(
          bf,
          {
            pathways: c,
            eventCohorts: o,
            colors: n,
            selectedPath: g
          }
        ) })
      ] })
    }
  ) });
}, rv = ze(({ analysisInfo: n, data: o }) => {
  var b, C, v, A;
  const a = (o == null ? void 0 : o.targetCohorts) === void 0 || (o == null ? void 0 : o.targetCohorts.length) === 0, i = o.targetCohorts || [], [l, c] = pe(i || []), p = af(
    o,
    l,
    a,
    (b = n.design) == null ? void 0 : b.maxDepth
  ), g = Yh(o.eventCodes), u = a9(g), d = $d(
    u.length > 10 ? Wd : Co
  ).domain(u.map((P) => String(P.code))).unknown(Gh), f = (P) => nf[P] || d(P);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
    y,
    {
      container: !0,
      minHeight: "calc(100vh - 280px)",
      alignContent: "flex-start",
      spacing: 2,
      p: 2,
      children: ((C = o == null ? void 0 : o.eventCodes) == null ? void 0 : C.length) > 0 && ((v = o.pathwayGroups) == null ? void 0 : v.length) > 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        ((A = o.targetCohorts) == null ? void 0 : A.length) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          gf,
          {
            value: l,
            options: i,
            onChange: c
          }
        ) }),
        p != null && p.length ? p.map(
          ({ pathway: P, pathways: T, summary: I, targetCohort: w }, N) => /* @__PURE__ */ e.jsx(
            Wf,
            {
              pathway: P,
              pathways: T,
              summary: I,
              targetCohort: w,
              eventCohorts: g,
              legacy: a,
              colors: f
            },
            N
          )
        ) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(u5, { children: "No results found" }) })
      ] }) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(u5, { children: "No results found" }) })
    }
  ) });
}), Hf = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
], ov = (n) => {
  const { onChange: o, prop: a } = n;
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
    tt,
    {
      name: "templateProp",
      textLabel: "Template attribute",
      required: !0,
      children: /* @__PURE__ */ e.jsx(
        W1,
        {
          className: "",
          name: "templateProp",
          disablePortal: !0,
          id: "templateProp",
          options: Hf,
          value: a,
          placeholder: "Select attribute",
          onChange: o,
          fullWidth: !0
        }
      )
    }
  ) }) });
}, av = ze(
  (n) => {
    var b, C, v, A, P;
    const {
      subModules: o,
      parentId: a,
      design: i,
      id: l,
      typeContainer: c,
      updateDesign: p,
      analysisName: g,
      viewMode: u
    } = n, d = (T) => (I) => {
      p(T, I);
    }, f = (T) => {
      let I = 0;
      return Object.keys(T || {}).forEach((w) => {
        const N = T[w];
        if (N) {
          if (Array.isArray(N)) {
            I += N.length;
            return;
          }
          I += 1;
        }
      }), I;
    };
    return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
      (!u || u && ((b = i == null ? void 0 : i.targetCohorts) == null ? void 0 : b.length) > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(W4, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("b", { children: "Feasibility" }),
          " analysis helps verify if data sources have enough data of interest to run a study. It runs on multiple data sources and provides a ranking of data sources from feasibility perspective. Target cohorts define the main population of interest. Event cohort represent events/concepts of interest for the study."
        ] }) }) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          o.cohort,
          {
            type: "component",
            name: "widget-cohort-import-button",
            subModules: o,
            path: L1(c, l, a),
            config: {
              buttonText: "Import target cohort",
              titleText: /* @__PURE__ */ e.jsx(
                N1,
                {
                  title: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    "Target cohorts",
                    /* @__PURE__ */ e.jsx("sup", { className: "required-star", children: "*" })
                  ] }),
                  count: (C = i == null ? void 0 : i.targetCohorts) == null ? void 0 : C.length
                }
              ),
              classNameContainer: "target-import-button",
              typeContainer: c,
              initialData: i == null ? void 0 : i.targetCohorts,
              onChange: d("targetCohorts"),
              isSelect: !0,
              parentId: a,
              returnEntityText: g,
              collapsible: !0,
              defaultState: !0,
              viewMode: u,
              required: !0,
              description: "Target cohorts define main data of interest from the perspective of your study. At least one target cohort must be specified."
            }
          }
        ) })
      ] }),
      (!u || u && ((v = i == null ? void 0 : i.eventCohorts) == null ? void 0 : v.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        o.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: o,
          path: L1(c, l, a),
          config: {
            buttonText: "Import event cohort",
            titleText: /* @__PURE__ */ e.jsx(
              N1,
              {
                title: "Event cohorts",
                count: (A = i == null ? void 0 : i.eventCohorts) == null ? void 0 : A.length
              }
            ),
            classNameContainer: "event-import-button",
            typeContainer: c,
            initialData: i == null ? void 0 : i.eventCohorts,
            onChange: d("eventCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: g,
            collapsible: !0,
            defaultState: u,
            viewMode: u,
            description: "Event cohort represent additional data to be verified for existence. Additionally, for each target and event cohort  an intersection will be calculated. Both Event cohort data and Intersection data will affect the final data source scoring."
          }
        }
      ) }),
      (!u || u && ((P = Object.keys(i.groups || {})) == null ? void 0 : P.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          title: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Additional attributes",
              count: (i == null ? void 0 : i.groups) && f(i == null ? void 0 : i.groups) || 0
            }
          ),
          defaultState: u,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsx(
            o.cohort,
            {
              type: "component",
              name: "widget-criteria-attributes",
              subModules: o,
              config: {
                typeContainer: c,
                onChange: (T) => {
                  p("groups", T);
                },
                values: i == null ? void 0 : i.groups,
                viewMode: u
              }
            }
          )
        }
      ) })
    ] });
  }
), Vf = ({ getValue: n }) => /* @__PURE__ */ e.jsx(
  ud,
  {
    name: "rating",
    defaultValue: n() || 0,
    precision: 0.1,
    readOnly: !0
  }
), Uf = [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: m3,
    size: 36,
    maxSize: 36,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  V4({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 300
  }),
  {
    id: "raiting",
    header: "Feasibility rating",
    accessorFn: (n) => n.resultInfo.summary.rating * 5 / n.resultInfo.summary.maxRating,
    cell: Vf,
    minSize: 150,
    maxSize: 150,
    enableResizing: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetNotEmpty",
    header: "Target cohorts",
    size: 120,
    accessorFn: (n) => `${n.resultInfo.summary.targetNotEmpty} / ${n.resultInfo.summary.targetTotal}`,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetPersonCount",
    header: "Target cohort PC",
    accessorKey: "resultInfo.summary.targetPersonCount",
    cell: ({ getValue: n }) => oe(n()),
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetCohorts",
    header: () => /* @__PURE__ */ e.jsxs(X, { sx: { whiteSpace: "wrap" }, children: [
      "Target cohort",
      /* @__PURE__ */ e.jsx("br", {}),
      "additional attributes"
    ] }),
    accessorFn: (n) => `${n.resultInfo.summary.mandatoryNotEmpty} / ${n.resultInfo.summary.mandatoryTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "eventTotal",
    header: "Event cohorts",
    accessorFn: (n) => `${n.resultInfo.summary.eventNotEmpty} / ${n.resultInfo.summary.eventTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "eventPersonCount",
    header: "Event cohort PC",
    accessorKey: "resultInfo.summary.eventPersonCount",
    cell: ({ getValue: n }) => oe(n()),
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "intersection",
    header: () => /* @__PURE__ */ e.jsxs(X, { sx: { whiteSpace: "wrap" }, children: [
      "Target-Event",
      /* @__PURE__ */ e.jsx("br", {}),
      "cohort intersection"
    ] }),
    accessorFn: (n) => `${n.resultInfo.summary.intersection} / ${n.resultInfo.summary.intersectionTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "intersection-attributes",
    header: () => /* @__PURE__ */ e.jsxs(X, { sx: { whiteSpace: "wrap" }, children: [
      "Target-Event intersection",
      /* @__PURE__ */ e.jsx("br", {}),
      "additional attributes"
    ] }),
    accessorFn: (n) => `${n.resultInfo.summary.intersectionWithGroups} / ${n.resultInfo.summary.intersectionWithGroupsTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  }
], Gf = ({
  resultData: n
}) => /* @__PURE__ */ e.jsx(
  y1,
  {
    variant: "uncontrolled",
    hideSettings: !0,
    columns: Uf,
    data: n
  }
), iv = () => ({
  targetCohorts: [],
  eventCohorts: [],
  groups: {}
}), sv = (n) => `Rating ${oe(
  (n == null ? void 0 : n.summary.rating) * 5 / n.summary.maxRating || 0,
  2,
  2
)}`, lv = (n, o) => ({
  ...o,
  name: o.title || o.name,
  type: n.type
}), Y4 = {
  observation: "Observation",
  condition_occurrence: "Condition",
  drug_exposure: "Drug",
  measurement: "Measurement",
  procedure_occurrence: "Procedure",
  device_exposure: "Device",
  visit_occurrence: "Visit",
  death: "Death",
  cost: "Cost"
  // location: 'Location',
  // provider: 'Provider',
  // provider_visit: 'Visit Provider',
}, Kf = [
  {
    title: "Person",
    value: "",
    end: !0
  },
  {
    title: "Attrition",
    value: "attrition"
  },
  {
    title: "Demographics",
    value: "demographics"
  },
  ...Object.entries(Y4).map(([n, o]) => ({
    title: o,
    value: `domain/${n}`
  })),
  {
    title: "Health System",
    value: "health-system"
  }
], a2 = ({
  getValue: n,
  maxWidth: o = 500,
  color: a = "success.light"
}) => {
  var c, p, g;
  const i = {
    pc: n().progress * 100 / n().maxProgress,
    totalPc: n().totalProgress * 100 / n().maxProgress,
    diff: ((n().totalProgress || n().maxProgress) - n().progress) * 100 / n().maxProgress
  }, l = 18;
  return /* @__PURE__ */ e.jsxs(
    X,
    {
      minWidth: ((c = String(n().totalProgress)) == null ? void 0 : c.length) * 8,
      maxWidth: o,
      width: i.totalPc + "%",
      display: "flex",
      children: [
        /* @__PURE__ */ e.jsx(f1, { text: oe(n().progress), children: /* @__PURE__ */ e.jsx(
          X,
          {
            minWidth: ((p = String(n().progress)) == null ? void 0 : p.length) * 8 + 6,
            sx: {
              height: l,
              lineHeight: l + "px",
              width: i.pc + "%",
              backgroundColor: a,
              position: "relative",
              textAlign: "right",
              fontSize: 11,
              boxSizing: "border-box",
              cursor: "default",
              px: 0.5,
              maxWidth: "100%",
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(92%)"
              }
            },
            children: oe(n().progress)
          }
        ) }),
        /* @__PURE__ */ e.jsx(f1, { text: oe(n().totalProgress), children: /* @__PURE__ */ e.jsx(
          X,
          {
            height: l,
            minWidth: ((g = String(n().totalProgress)) == null ? void 0 : g.length) * 8 + 6,
            width: i.diff + "%",
            sx: {
              height: l,
              lineHeight: l + "px",
              backgroundColor: "backgroundColor.dark",
              position: "relative",
              textAlign: "right",
              fontSize: 11,
              boxSizing: "border-box",
              cursor: "default",
              px: 0.5,
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(92%)"
              }
            },
            children: oe(n().totalProgress)
          }
        ) })
      ]
    }
  );
}, Yf = {
  [P1.LESS_THAN]: "less than",
  [P1.LESS_OR_EQUAL_TO]: "less or equal to",
  [P1.EQUAL_TO]: "equal to",
  [P1.GREATER_THAN]: "greater than",
  [P1.GREATER_OR_EQUAL_TO]: "greater or equal to",
  [P1.BETWEEN]: "between",
  [P1.NOT_BETWEEN]: "not between"
}, qf = [P1.BETWEEN, P1.NOT_BETWEEN].map(
  String
), Xf = (n) => typeof n == "string" ? n : n == null ? void 0 : n.CONCEPT_NAME, N8 = (n, o) => {
  if ((o == null ? void 0 : o.Value) === void 0 || (o == null ? void 0 : o.Value) === null)
    return null;
  const a = o.Op || P1.GREATER_THAN, i = Yf[a] || a, l = qf.includes(a) && o.Extent !== void 0 && o.Extent !== null ? ` and ${o.Extent}` : "";
  return `${n} = ${i} ${o.Value}${l}`;
}, g9 = (n = {}) => {
  var i;
  const o = [];
  ["race", "gender", "ethnicity"].forEach((l) => {
    var c;
    (c = n == null ? void 0 : n[l]) == null || c.map(Xf).filter(Boolean).forEach((p) => {
      o.push(`${l} = ${p}`);
    });
  }), (i = n == null ? void 0 : n.age) == null || i.map((l) => N8("Age Range", l)).filter(Boolean).forEach((l) => o.push(l));
  const a = (n == null ? void 0 : n.dateRanges) || (n == null ? void 0 : n.indexDate);
  return a == null || a.map((l) => N8("Date Range", l)).filter(Boolean).forEach((l) => o.push(l)), o;
}, Zf = (n = {}, o) => Array.from(
  /* @__PURE__ */ new Set([
    ...Object.keys(n || {}),
    ...g9(o)
  ])
).sort(), Jf = (n, o) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: m3,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  V4({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Person count",
    size: 830,
    accessorKey: `resultInfo.personDetails.${n}.personCount`,
    cell: ({ row: a, getValue: i, ...l }) => /* @__PURE__ */ e.jsx(
      a2,
      {
        getValue: () => ({
          progress: i() || 0,
          totalProgress: a.original.resultInfo.summary.totalPersonCount,
          maxProgress: o
        }),
        ...l
      }
    )
  }
], Qf = (n, o) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: m3,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  V4({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    id: "criteriaGroup",
    header: "",
    size: 120,
    enableResizing: !1
  },
  {
    header: "Criteria",
    size: 200
  },
  {
    header: "Person count",
    size: 630
  }
], ex = (n, o) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: m3,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  V4({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Event cohort",
    size: 200
  },
  {
    header: "Person count",
    size: 300
  },
  {
    header: "Intersection",
    size: 300
  }
], F8 = ({ rowSpan: n, name: o, id: a }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(
    X,
    {
      component: "td",
      rowSpan: n,
      className: "td",
      sx: { verticalAlign: "top", maxWidth: 36 },
      width: 36,
      children: /* @__PURE__ */ e.jsx(m3, { value: a })
    }
  ),
  /* @__PURE__ */ e.jsx(
    X,
    {
      component: "td",
      rowSpan: n,
      className: "td",
      sx: {
        verticalAlign: "top",
        fontWeight: 500,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "250px",
        overflow: "hidden",
        paddingTop: "8px"
      },
      children: o
    }
  )
] }), y9 = ({ name: n, id: o }) => /* @__PURE__ */ e.jsxs(X, { display: "flex", alignItems: "center", children: [
  /* @__PURE__ */ e.jsx(m3, { value: o, size: 18 }),
  /* @__PURE__ */ e.jsx(X, { ml: 1, fontWeight: 500, color: "primary.main", children: n })
] }), tx = ({
  getValue: n,
  maxWidth: o = 500,
  intersectionTooltip: a
}) => {
  var c, p, g;
  const i = {
    left: n().left * 100 / n().total,
    right: n().right * 100 / n().total,
    intersection: n().intersection * 100 / n().total,
    total: n().total * 100 / n().total
  }, l = 18;
  return /* @__PURE__ */ e.jsxs(X, { maxWidth: o || "100%", height: l, sx: { display: "flex" }, children: [
    /* @__PURE__ */ e.jsx(f1, { text: oe(n().left), children: /* @__PURE__ */ e.jsx(
      X,
      {
        sx: {
          height: l,
          lineHeight: l + "px",
          width: i.left + "%",
          cursor: "default",
          position: "relative",
          textAlign: "center",
          fontSize: 11,
          boxSizing: "border-box",
          px: 0.5,
          minWidth: ((c = String(n().left)) == null ? void 0 : c.length) * 8 + 6,
          maxWidth: "100%",
          backgroundColor: "success.light",
          transition: "all 300ms",
          ":hover": {
            filter: "brightness(95%)"
          }
        },
        children: oe(n().left)
      }
    ) }),
    n().intersection > 0 && /* @__PURE__ */ e.jsx(
      f1,
      {
        text: a || oe(n().intersection),
        children: /* @__PURE__ */ e.jsx(
          X,
          {
            sx: {
              height: l,
              lineHeight: l - 4 + "px",
              width: i.intersection + "%",
              minWidth: ((p = String(n().intersection)) == null ? void 0 : p.length) * 8 + 6,
              backgroundColor: "backgroundColor.dark",
              position: "relative",
              textAlign: "center",
              fontSize: 11,
              boxSizing: "border-box",
              px: 0.5,
              cursor: "default",
              borderTop: "3px solid",
              borderTopColor: "success.light",
              borderBottom: "3px solid",
              borderBottomColor: "info.light",
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(95%)"
              }
            },
            children: oe(n().intersection)
          }
        )
      }
    ),
    /* @__PURE__ */ e.jsx(f1, { text: oe(n().right), children: /* @__PURE__ */ e.jsx(
      X,
      {
        sx: {
          height: l,
          lineHeight: l + "px",
          width: i.right + "%",
          minWidth: ((g = String(n().right)) == null ? void 0 : g.length) * 8 + 6,
          cursor: "default",
          position: "relative",
          textAlign: "center",
          fontSize: 11,
          boxSizing: "border-box",
          px: 0.5,
          pl: n().right ? 0.5 : 0,
          maxWidth: "100%",
          backgroundColor: "info.light",
          transition: "all 300ms",
          ":hover": {
            filter: "brightness(95%)"
          }
        },
        children: oe(n().right)
      }
    ) })
  ] });
}, nx = ({ color: n }) => /* @__PURE__ */ e.jsx(
  X,
  {
    sx: {
      backgroundColor: Array.isArray(n) ? n[0] : n,
      width: 12,
      height: 12,
      borderRadius: "50%",
      boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
      cursor: "pointer",
      transition: "300ms",
      position: "relative",
      filter: "brightness(96%)",
      ":hover": {
        filter: "brightness(90%)"
      },
      ...Array.isArray(n) ? {
        ":before": {
          content: "''",
          height: 6,
          position: "absolute",
          bottom: 0,
          width: 12,
          borderRadius: "0 0 6px 6px",
          boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
          backgroundColor: n[1]
        }
      } : {}
    }
  }
), P3 = ({ config: n }) => /* @__PURE__ */ e.jsx(X, { mt: 0.5, display: "flex", children: /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: n.map((o, a) => /* @__PURE__ */ e.jsxs(y, { item: !0, display: "flex", alignItems: "center", children: [
  /* @__PURE__ */ e.jsx(nx, { color: o.color }),
  /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", ml: 0.5, children: [
    "— ",
    o.text
  ] })
] }, "legend" + a)) }) }), rx = ({ selectedCohort: n, eventCohorts: o = [], data: a, analysis: i }) => {
  var b;
  const l = Math.max(
    ...a.map((C) => C.resultInfo.summary.totalPersonCount)
  ), c = Math.max(
    ...a.map(
      (C) => {
        var v;
        return (v = C.resultInfo.personDetails[n == null ? void 0 : n.id]) == null ? void 0 : v.personCount;
      }
    )
  ), p = Yt(o, "id"), g = (o == null ? void 0 : o.length) > 0, u = a.some(
    (C) => {
      var v, A;
      return Object.keys(
        ((A = (v = C.resultInfo) == null ? void 0 : v.personDetails[n == null ? void 0 : n.id]) == null ? void 0 : A.groups) || {}
      ).length;
    }
  ), d = g9(
    (b = i == null ? void 0 : i.design) == null ? void 0 : b.groups
  ), f = u || d.length > 0;
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
      Ne,
      {
        title: "Cohort counts" + (n ? ` for ${n.name}` : ""),
        children: [
          /* @__PURE__ */ e.jsx(
            y1,
            {
              data: a,
              columns: Jf(
                n == null ? void 0 : n.id,
                l
              ),
              hideSettings: !0
            }
          ),
          /* @__PURE__ */ e.jsx(
            P3,
            {
              config: [
                {
                  color: "success.light",
                  text: `persons in cohort (${n.name})`
                },
                {
                  color: "backgroundColor.dark",
                  text: "persons in data source"
                }
              ]
            }
          )
        ]
      }
    ) }),
    f && /* @__PURE__ */ e.jsx(
      y,
      {
        item: !0,
        xs: 12,
        sx: {
          ".td": {
            textTransform: "capitalize"
          }
        },
        children: /* @__PURE__ */ e.jsxs(Ne, { title: "Additional attributes", children: [
          /* @__PURE__ */ e.jsx(
            y1,
            {
              data: a,
              columns: Qf(
                n == null ? void 0 : n.id
              ),
              customTableRow: ({ data: C, ...v }) => {
                var I;
                const A = C.resultInfo.personDetails[n == null ? void 0 : n.id], P = (A == null ? void 0 : A.groups) || {}, T = Zf(
                  P,
                  (I = i == null ? void 0 : i.design) == null ? void 0 : I.groups
                );
                return /* @__PURE__ */ e.jsx(e.Fragment, { children: T.map((w, N) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  N === 0 && /* @__PURE__ */ e.jsx("tr", { ...v, children: /* @__PURE__ */ e.jsx(
                    F8,
                    {
                      rowSpan: (T == null ? void 0 : T.length) + 1,
                      name: C.dataSource.name,
                      id: C.dataSource.id
                    }
                  ) }),
                  /* @__PURE__ */ e.jsxs("tr", { ...v, children: [
                    /* @__PURE__ */ e.jsx("td", { className: "td", children: w.split(" = ")[0] }),
                    /* @__PURE__ */ e.jsx("td", { className: "td", children: w.split(" = ")[1] }),
                    /* @__PURE__ */ e.jsx("td", { className: "td", children: /* @__PURE__ */ e.jsx(
                      a2,
                      {
                        color: "analysesColors.teal.main",
                        getValue: () => {
                          var E;
                          return {
                            progress: P[w] || 0,
                            totalProgress: ((E = C.resultInfo.personDetails[n == null ? void 0 : n.id]) == null ? void 0 : E.personCount) || 0,
                            maxProgress: c
                          };
                        }
                      }
                    ) })
                  ] })
                ] })) });
              },
              hideSettings: !0
            }
          ),
          /* @__PURE__ */ e.jsx(
            P3,
            {
              config: [
                {
                  color: "analysesColors.teal.main",
                  text: `persons in cohort (${n.name}) with this criteria`
                },
                {
                  color: "backgroundColor.dark",
                  text: `persons in cohort (${n.name})`
                }
              ]
            }
          )
        ] })
      }
    ),
    g && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { title: "Event cohorts", children: [
      /* @__PURE__ */ e.jsx(
        y1,
        {
          data: a,
          columns: ex(
            n == null ? void 0 : n.id
          ),
          customTableRow: ({ data: C, ...v }) => {
            const A = C.resultInfo.personDetails[n == null ? void 0 : n.id];
            return /* @__PURE__ */ e.jsx(e.Fragment, { children: o.map((P, T) => {
              var m, j, _;
              const I = C.resultInfo.eventCounts[P.id], w = A.personCount - (((m = A.eventPersonIntersections) == null ? void 0 : m[P.id]) || 0), N = I.personCount - (((j = A.eventPersonIntersections) == null ? void 0 : j[P.id]) || 0), E = ((_ = A.eventPersonIntersections) == null ? void 0 : _[P.id]) || 0, x = w + E + N;
              return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                T === 0 && /* @__PURE__ */ e.jsx("tr", { ...v, children: /* @__PURE__ */ e.jsx(
                  F8,
                  {
                    rowSpan: (o == null ? void 0 : o.length) + 1,
                    name: C.dataSource.name,
                    id: C.dataSource.id
                  }
                ) }),
                /* @__PURE__ */ e.jsxs("tr", { ...v, children: [
                  /* @__PURE__ */ e.jsx("td", { className: "td", children: p[P.id].name }),
                  /* @__PURE__ */ e.jsx("td", { className: "td", children: /* @__PURE__ */ e.jsx(
                    a2,
                    {
                      getValue: () => ({
                        progress: I.personCount,
                        totalProgress: C.resultInfo.summary.totalPersonCount,
                        maxProgress: l
                      }),
                      color: "info.light"
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx("td", { className: "td", children: !isNaN(x) && /* @__PURE__ */ e.jsx(
                    tx,
                    {
                      getValue: () => ({
                        left: w,
                        right: N,
                        intersection: E,
                        total: x
                      }),
                      intersectionTooltip: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                        /* @__PURE__ */ e.jsx("b", { children: oe(E) }),
                        " ",
                        "persons in both cohorts",
                        /* @__PURE__ */ e.jsx("br", {}),
                        "(",
                        P.name,
                        " and",
                        " ",
                        n.name,
                        ")"
                      ] })
                    }
                  ) })
                ] })
              ] });
            }) });
          },
          hideSettings: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        P3,
        {
          config: [
            {
              color: "info.light",
              text: "persons in event cohort"
            },
            {
              color: "backgroundColor.dark",
              text: "persons in data source"
            },
            {
              color: "success.light",
              text: "persons in target cohort"
            },
            {
              color: ["success.light", "info.light"],
              text: "persons in both cohorts (event and target)"
            }
          ]
        }
      )
    ] }) })
  ] });
};
Fe.div`
  font-size: 12px;
  text-align: center;
  min-height: 14px;
`;
Fe.div``;
Fe.div`
  width: 100%;
  height: 15px;
  background-color: #7bb209;
`;
const v9 = Fe.div`
  width: ${(n) => n.width};
  background-color: ${(n) => n.color};
  height: 15px !important;
  text-align: center;
  margin: 0 auto;
`;
Fe.div`
  th {
    /* padding-bottom: 0px !important; */
    padding: 11.5px;
  }
  tbody {
    td {
      padding: 8.75px;
      /* padding-bottom: 10px; */
    }
  }
`;
const u3 = ({ description: n, title: o }) => /* @__PURE__ */ e.jsx(f1, { text: n, children: o }), D8 = (n, o, a, i, l) => [
  {
    header: () => /* @__PURE__ */ e.jsx(
      u3,
      {
        title: "Inclusion rule",
        description: "Inclusion rules are based on inclusion rule section in the cohort builder"
      }
    ),
    id: "inclusionRule",
    accessorFn: (c) => c.id >= 0 ? `${c.id + 1}. ${c.name}` : c.name,
    disableSorting: !0
  },
  ...n.map((c) => {
    const p = c.dataSource.id;
    return {
      header: () => /* @__PURE__ */ e.jsx(y9, { name: c.dataSource.name, id: c.dataSource.id }),
      id: c.dataSource.id,
      // we need this id to identifiy data for chart
      enableHiding: !1,
      columns: [
        {
          header: () => /* @__PURE__ */ e.jsx(
            u3,
            {
              title: "N",
              description: "Number of persons that satisfy all inclusion rules applied consecutively in an order specified in the cohort builder"
            }
          ),
          id: `countSatisfying___${p + a}`,
          accessorKey: `${p}.${o}.countSatisfying`,
          cell: ({ getValue: g }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: g() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ e.jsx(
            u3,
            {
              title: "% Satisfied",
              description: "Persons that satisfy all consecutive inclusion rules expressed as % of the base cohort count"
            }
          ),
          id: `percentSatisfying___${p + a}`,
          accessorKey: `${p}.${o}.percentSatisfying`,
          cell: ({ getValue: g }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: g() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ e.jsx(
            u3,
            {
              title: "% to gain",
              description: "% to gain represents the % of population that can be recovered by relaxing the inclusion rule"
            }
          ),
          id: `percentExcluded___${p + a}`,
          accessorKey: `${p}.${o}.percentExcluded`,
          cell: ({ getValue: g }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: g() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ e.jsx(
            f1,
            {
              text: i === "attrition" ? "The Attrition view allows users to visualize a classic attrition funnel, where each consecutive rule further restricts the population. The order of criteria affects the statistics." : "The Intersect view allows users to visualize how individual inclusion rules or combinations of these rules affect results, regardless of the sequence in which the rules are applied.Hovering over each box allows to see statistical information about the subgroups that either satisfied or did not satisfy specific inclusion criteria. The failed criteria is highlighted in red.",
              children: /* @__PURE__ */ e.jsxs(
                Ye,
                {
                  variant: "text",
                  startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "reload" }),
                  onClick: () => l(),
                  size: "small",
                  color: "primary",
                  children: [
                    "Switch to",
                    " ",
                    i === "intersect" ? "attrition view" : "intersect view"
                  ]
                }
              )
            }
          ),
          id: `percentSatisfying-chart___${p + a}`,
          accessorKey: `${p}.${o}.percentSatisfying`,
          enableSorting: !1,
          // enableHiding: false,
          size: 320,
          meta: {
            headerAlign: "center",
            columnName: "Chart"
          },
          cell: (g) => {
            var f, b;
            const u = c.resultInfo.inclusionRuleReports[a][o], d = ((b = (f = c.resultInfo.inclusionRuleReports[a]) == null ? void 0 : f[o]) == null ? void 0 : b.summary.baseCount) ?? c.resultInfo.personDetails[a].personCount;
            return /* @__PURE__ */ e.jsx(
              f1,
              {
                text: g.row.original.id !== -1 ? n9(g.row.original.id, u) : `${g.row.original.name}: ${d}, 100.00%`,
                color: "primary",
                width: "auto",
                children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
                  v9,
                  {
                    color: e9(parseFloat(g.getValue()) / 100),
                    width: g.getValue()
                  }
                ) })
              }
            );
          }
        }
      ]
    };
  })
];
function L8(n, o, a) {
  n.forEach((i) => {
    const l = i.dataSource.id, { personDetails: c, inclusionRuleReports: p } = i.resultInfo;
    Object.entries(p).forEach(([g, u]) => {
      var b, C, v, A;
      const d = {
        id: -1,
        name: "Base count (Entry events)",
        percentExcluded: "0.00%",
        percentSatisfying: "100.00%",
        dataSourceId: l
      }, f = {
        byPerson: {
          ...d,
          countSatisfying: ((C = (b = p[g]) == null ? void 0 : b.byPerson) == null ? void 0 : C.summary.baseCount) ?? c[g].personCount
        },
        byEvent: {
          ...d,
          countSatisfying: ((A = (v = p[g]) == null ? void 0 : v.byEvent) == null ? void 0 : A.summary.baseCount) ?? c[g].personCount
        }
      };
      a[g] || (a[g] = { 0: d }), a[g][0][l] = f, Object.entries(u).forEach(([P, T]) => {
        T[o].forEach((I) => {
          const w = I.id + 1;
          a[g][w] || (a[g][w] = {
            name: I.name,
            id: I.id
          }), a[g][w][l] = {
            ...a[g][w][l],
            [P]: I
          };
        });
      });
    });
  });
}
function ox(n) {
  let o = { intersect: {}, attrition: {} };
  return L8(n, "inclusionRuleStats", o.intersect), L8(n, "attritions", o.attrition), o;
}
const ax = ({ count: n }) => /* @__PURE__ */ e.jsx(f1, { text: "Final count of persons in a cohort after applying all inclusion rules", children: /* @__PURE__ */ e.jsxs(
  y,
  {
    item: !0,
    alignItems: "center",
    flexWrap: "nowrap",
    display: "flex",
    justifyContent: "flex-start",
    children: [
      /* @__PURE__ */ e.jsx(
        y,
        {
          item: !0,
          sx: {
            backgroundColor: "backgroundColor.main",
            p: 2,
            borderRadius: "50%",
            mr: 2,
            svg: {
              color: "primary.main"
            },
            width: 62,
            height: 62
          },
          children: /* @__PURE__ */ e.jsx(t1, { iconName: "users", sx: { fontSize: 30 }, color: "info" })
        }
      ),
      /* @__PURE__ */ e.jsx(ce, { variant: "h2", children: n })
    ]
  }
) }), b9 = ({ resultData: n, setPassedAndFailed: o, analysisName: a }) => {
  const [i, l] = pe(null), c = je(() => n == null ? void 0 : n.inclusionRuleStats, [n.inclusionRuleStats]), p = w1(
    (u, d) => {
      var P;
      let f = 0, b = 0, C = [], v, A = [];
      for (let T = 0; T < u.length; T++)
        u[T] === "1" ? (C.push(c[T]), f++) : (A.push(c[T]), b++);
      (n == null ? void 0 : n.summary.baseCount) > 0 && (v = (d / ((P = n == null ? void 0 : n.summary) == null ? void 0 : P.baseCount) * 100).toFixed(2)), o == null || o({ passed: C, failed: A }), l((T) => ({
        ...T,
        passCount: f,
        failCount: b,
        passed: C,
        failed: A,
        size: d,
        percentage: v
      }));
    },
    [c, o]
  ), g = () => {
    l(null), o({ passed: [], failed: [] });
  };
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      container: !0,
      height: "100%",
      onMouseOut: g,
      textAlign: "center",
      alignContent: "flex-start",
      children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            variant: "subtitle2",
            minHeight: 24,
            textAlign: "center",
            width: "100%",
            children: i && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              i.size,
              " people (",
              i.percentage,
              "%),",
              " ",
              i.passCount,
              " criteria passed, ",
              i.failCount,
              " ",
              "criteria failed."
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(
          y,
          {
            container: !0,
            height: "calc(100% - 24px)",
            width: "calc(100% - 8px)",
            pl: 2,
            children: JSON.parse(n.treemapData) && /* @__PURE__ */ e.jsx(
              H4,
              {
                type: "treeMapCustom",
                chartData: JSON.parse(n.treemapData),
                fileName: a,
                options: {
                  handleCellOver: p,
                  handleCellOut: g,
                  selectedConcepts: [],
                  allAny: "ANY",
                  passedFailed: "PASSED"
                  //   setSummaryValue: setSummaryValue,
                  //   setSummaryPercent: setSummaryPercent,
                },
                report: n
              }
            )
          }
        )
      ]
    }
  );
}, ix = ({
  analysis: n,
  data: o,
  row: a,
  setPassedAndFailed: i,
  passedAndFailed: l,
  ...c
}) => {
  const p = w1(
    (g) => {
      var u;
      return !!((u = l == null ? void 0 : l.failed) != null && u.find(
        (d) => d.id === a.original.id && d.dataSourceId === g
      ));
    },
    [l.failed]
  );
  return /* @__PURE__ */ to(
    "tr",
    {
      ...c,
      className: c.className + (a.index === 0 ? " no-hover" : ""),
      key: o.activeView + o.activeTab + o.selectedCohortId + a.id
    },
    a.getVisibleCells().map((g) => {
      var C, v, A;
      const u = g.column.getIsPinned(), d = (P) => {
        const T = P.getIsPinned();
        return {
          left: T === "left" ? `${P.getStart("left")}px` : void 0,
          right: T === "right" ? `${P.getAfter("right")}px` : void 0,
          opacity: T ? 0.95 : 1,
          position: T ? "sticky" : "relative",
          width: P.getSize(),
          zIndex: T ? 2 : 0,
          backgroundColor: T ? "ffffffe0" : "inherit"
        };
      }, f = (C = Object.values(
        o.tableData[o.selectedCohortId]
      )) == null ? void 0 : C.length, b = (v = g.column.parent) == null ? void 0 : v.id;
      if (o.activeView == "intersect" && g.id.includes("percentSatisfying-chart")) {
        const P = o.treemapData[b][o.selectedCohortId][o.activeTab], T = !!(P != null && P.treemapData);
        if (a.index == 0)
          return /* @__PURE__ */ e.jsx(
            X,
            {
              component: "td",
              className: `${u ? "pinned " : ""} td`,
              rowSpan: f > 6 ? f : 6,
              sx: {
                fontSize: "10px !important",
                padding: "4px 0 ",
                height: T ? "250px" : "",
                textAlign: "center",
                backgroundColor: T ? "white" : "transparent",
                position: "relative",
                ...d(g.column)
              },
              children: T ? /* @__PURE__ */ e.jsx(
                b9,
                {
                  resultData: {
                    ...P,
                    inclusionRuleStats: (A = P.inclusionRuleStats) == null ? void 0 : A.map(
                      (I) => ({
                        ...I,
                        dataSourceId: b
                      })
                    )
                  },
                  analysisName: n == null ? void 0 : n.title,
                  setPassedAndFailed: i
                }
              ) : "N/A"
            },
            g.id
          );
      } else
        return /* @__PURE__ */ e.jsx(
          X,
          {
            component: "td",
            className: `${u ? "pinned " : ""} td`,
            sx: {
              color: p(b) ? "red" : "",
              ...d(g.column)
            },
            children: oo(g.column.columnDef.cell, {
              ...g.getContext()
            })
          },
          g.id
        );
    })
  );
}, M8 = ({
  columns: n,
  tableData: o,
  treemapData: a,
  selectedCohortId: i,
  activeTab: l,
  activeView: c,
  analysis: p
}) => {
  const [g, u] = pe({
    passed: [],
    failed: []
  }), d = w1(
    (f) => {
      u2(g, f) || u(f);
    },
    [g]
  );
  return /* @__PURE__ */ e.jsx(
    y1,
    {
      data: Object.values(o[i]),
      columns: n,
      customTableRow: (f) => /* @__PURE__ */ e.jsx(
        ix,
        {
          ...f,
          setPassedAndFailed: d,
          passedAndFailed: g,
          analysis: p,
          data: {
            tableData: o,
            treemapData: a,
            selectedCohortId: i,
            activeTab: l,
            activeView: c
          }
        }
      ),
      withDuplicates: !0,
      pinnedColumns: { left: ["inclusionRule"] }
    }
  );
}, sx = ({ cohorts: n = [], data: o, selectedCohort: a, analysis: i }) => {
  const [l, c] = pe(
    n.filter((v) => v.id !== a.id)
  ), [p, g] = pe("byPerson"), [u, d] = pe("attrition"), f = je(() => o.reduce((v, A) => {
    const P = A.dataSource.id;
    return v[P] = A.resultInfo.inclusionRuleReports, v;
  }, {}), []), b = ox(o), C = () => {
    d((v) => v === "attrition" ? "intersect" : "attrition");
  };
  return m1(() => {
    c(
      n.filter((v) => v.id !== a.id)
    );
  }, [a]), /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: a.name,
        actions: /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs($4, { children: [
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              onClick: () => g("byPerson"),
              variant: p === "byPerson" ? "contained" : "outlined",
              color: "info",
              children: "By person"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              onClick: () => g("byEvent"),
              variant: p === "byEvent" ? "contained" : "outlined",
              color: "info",
              children: "By event"
            }
          )
        ] }) }),
        children: /* @__PURE__ */ e.jsx(
          M8,
          {
            tableData: b[u],
            columns: D8(
              o,
              p,
              a.id,
              u,
              C
            ),
            treemapData: f,
            activeTab: p,
            selectedCohortId: a.id,
            activeView: u,
            analysis: i
          }
        )
      }
    ) }),
    (n == null ? void 0 : n.length) > 1 && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { children: [
      /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 2, children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Compare to:" }) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
          H1,
          {
            multiple: !0,
            fullWidth: !0,
            value: l || [],
            onChange: (v, A) => c(A),
            options: n.filter(
              (v) => v.id !== a.id
            ),
            placeholder: "Select cohort for comparison...",
            getOptionLabel: function(v) {
              var A;
              return v.name || ((A = n.find((P) => P.id === v)) == null ? void 0 : A.name);
            },
            isOptionEqualToValue: (v, A) => v.id === A.id || v.id === A
          }
        ) })
      ] }),
      /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 1, children: l.map((v) => /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            fontSize: 14,
            fontWeight: 600,
            variant: "h6",
            color: "primary.main",
            mb: 1,
            children: v.name
          }
        ),
        /* @__PURE__ */ e.jsx(M1, { sx: { mb: 1.5 } }),
        /* @__PURE__ */ e.jsx(
          M8,
          {
            tableData: b[u],
            columns: D8(
              o,
              p,
              v.id,
              u,
              C
            ),
            treemapData: f,
            activeTab: p,
            selectedCohortId: v.id,
            activeView: u,
            analysis: i
          }
        )
      ] })) })
    ] }) })
  ] });
}, lx = ({
  data: n,
  selectedCohort: o,
  analysis: a
}) => {
  const i = je(() => {
    const l = {}, c = (p, g) => ({
      ...p,
      records: [{ ...p, cohortId: g }]
    });
    return n.forEach((p) => {
      Object.entries(
        p.resultInfo.demographics[o.id]
      ).forEach(([g, u]) => {
        const d = g === "age_group" ? "ageGroup" : g;
        l.hasOwnProperty(d) ? u.forEach((f) => {
          l[d][f.covariateId] ? l[d][f.covariateId].records.push({
            ...f,
            // this is inaccurate, should be fixed to some random identifier name
            cohortId: p.dataSource.id
          }) : l[d][f.covariateId] = c(
            f,
            p.dataSource.id
          );
        }) : l[d] = Yt(
          u.map(
            (f) => c(f, p.dataSource.id)
          ),
          "covariateId"
        );
      });
    }), Object.entries(l).forEach(
      ([p, g]) => l[p] = Object.values(g)
    ), r9(l, a);
  }, [n, o]);
  return /* @__PURE__ */ e.jsx(y, { container: !0, rowGap: 1, children: i.map((l) => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
    x5,
    {
      name: l.name,
      report: l,
      cohorts: n.map((c) => c.dataSource) || [],
      analysis: a
    }
  ) }, l.id + l.name + o.id)) });
}, k8 = ({ getValue: n, maxWidth: o = 500, color: a = "success" }) => {
  var g;
  const i = n() || [], l = i.reduce((u, d, f) => {
    var b;
    return u.push(d.value - (((b = i[f - 1]) == null ? void 0 : b.value) || 0)), u;
  }, []), c = [a + ".light", "#D6D3D1", "backgroundColor.dark"], p = 18;
  return /* @__PURE__ */ e.jsx(
    X,
    {
      minWidth: ((g = String(n().totalProgress)) == null ? void 0 : g.length) * 8,
      maxWidth: o,
      width: "100%",
      display: "flex",
      children: i.map(({ value: u, tooltip: d }, f) => {
        var b;
        return /* @__PURE__ */ e.jsx(
          f1,
          {
            text: d ?? oe(u) ?? "",
            children: /* @__PURE__ */ e.jsx(
              X,
              {
                minWidth: ((b = String(u)) == null ? void 0 : b.length) * 8 + 6,
                sx: {
                  height: p,
                  lineHeight: p + "px",
                  width: l[f] * 100 / l[l.length - 1] + "%",
                  backgroundColor: c[f],
                  position: "relative",
                  textAlign: "right",
                  fontSize: 11,
                  boxSizing: "border-box",
                  px: 0.5,
                  maxWidth: "100%",
                  cursor: "default",
                  transition: "all 300ms",
                  ":hover": {
                    filter: "brightness(95%)"
                  }
                },
                children: oe(u)
              },
              f
            )
          },
          "progress-" + f
        );
      })
    }
  );
}, g5 = (n, o, a = "domains") => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: m3,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  V4({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Person count (PC)",
    accessorKey: `resultInfo.${a}.${n}.counts.${o}.personCount`,
    minSize: 300,
    maxSize: 500,
    cell: ({ row: i, getValue: l, ...c }) => {
      const p = i.original.resultInfo;
      return /* @__PURE__ */ e.jsx(
        k8,
        {
          getValue: () => {
            var g;
            return [
              { value: l() ?? 0, tooltip: null },
              {
                value: (g = p.personDetails[n]) == null ? void 0 : g.personCount,
                tooltip: null
              },
              { value: p.summary.totalPersonCount, tooltip: null }
            ];
          },
          ...c
        }
      );
    }
  },
  {
    header: "Record count (RC)",
    accessorKey: `resultInfo.${a}.${n}.counts.${o}.recordCount`,
    minSize: 300,
    maxSize: 500,
    cell: ({ row: i, getValue: l, ...c }) => {
      const p = i.original.resultInfo;
      return /* @__PURE__ */ e.jsx(
        k8,
        {
          getValue: () => [
            { value: l() ?? 0, tooltip: null },
            {
              value: p.domains[n].eventCount,
              tooltip: null
            },
            { value: p.summary.totalEventCount, tooltip: null }
          ],
          ...c
        }
      );
    }
  }
], y5 = (n, o) => [
  ...o !== "location" ? [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      enableColumnFilter: !1,
      size: 80,
      maxSize: 100,
      cell: ({ getValue: a }) => a() != -1 ? a() : "Undefined"
    }
  ] : [],
  ...o === "provider" ? [
    {
      header: "NPI",
      accessorKey: "npi",
      id: "npi",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    }
  ] : [],
  {
    header: "Name",
    accessorKey: "name",
    id: "name",
    size: 180,
    filterFn: (a, i, l) => [
      a.original.id,
      a.original.name,
      a.original.personCount,
      a.original.prevalence,
      a.original.npi,
      a.original.specialty,
      a.original.specialtySource,
      a.original.placeOfServiceConceptId,
      a.original.placeOfServiceConceptName
    ].some(
      (c) => String(c).toLowerCase().includes(l[0].toLowerCase())
    ),
    meta: {
      filterVariant: "value"
    }
  },
  ...o === "provider" || o === "provider_visit" ? [
    {
      header: "Specialty (Source)",
      accessorKey: "specialtySource",
      id: "specialtySource",
      enableColumnFilter: !1,
      size: 150
    },
    {
      header: "Specialty",
      accessorKey: "specialty",
      id: "specialty",
      enableColumnFilter: !1,
      size: 150
    }
  ] : [],
  ...o === "caresite" || o === "caresite_visit" ? [
    {
      header: "Place of service id",
      accessorKey: "placeOfServiceConceptId",
      id: "placeOfServiceConceptId",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    },
    {
      header: "Place of service",
      accessorKey: "placeOfServiceConceptName",
      id: "placeOfServiceConceptName",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    }
  ] : [],
  ...n.map((a) => {
    const i = a.dataSource.id;
    return {
      header: () => /* @__PURE__ */ e.jsx(y9, { name: a.dataSource.name, id: a.dataSource.id }),
      id: i,
      // we need this id to identifiy data for chart
      columns: [
        {
          header: "Person Count",
          accessorFn: (l) => {
            var c;
            return ((c = l == null ? void 0 : l[i]) == null ? void 0 : c.personCount) || 0;
          },
          id: "personCount___" + i,
          enableColumnFilter: !1,
          size: 110,
          sortingFn: "alphanumeric"
          // cell: ({ getValue }) => getValue() || 0,
        },
        {
          header: "Prevalence",
          id: "prevalence___" + i,
          accessorFn: (l) => {
            var c;
            return ((c = l == null ? void 0 : l[i]) == null ? void 0 : c.prevalence) || 0;
          },
          enableColumnFilter: !1,
          size: 100,
          cell: ({ getValue: l }) => (oe(l() * 100, 2, 2) || 0) + "%"
        },
        {
          header: () => /* @__PURE__ */ e.jsx(X, { whiteSpace: "wrap", children: "Avg. records per person" }),
          id: "recordsPerPerson___" + i,
          accessorFn: (l) => {
            var p, g;
            return ((p = l[i]) == null ? void 0 : p.recordCount) / ((g = l[i]) == null ? void 0 : g.personCount) || 0;
          },
          enableColumnFilter: !1,
          size: 100,
          cell: ({ getValue: l }) => oe(l(), 2, 2) || "0",
          sortingFn: "alphanumeric"
        }
      ]
    };
  })
];
function v5(n, o, a, i = "domains") {
  return Object.values(
    n.reduce((l, c) => {
      var p, g, u, d, f, b;
      return (b = (f = (d = (u = ((p = c.resultInfo) == null ? void 0 : p[i]) ?? ((g = c.resultInfo) == null ? void 0 : g.domains)) == null ? void 0 : u[o]) == null ? void 0 : d.prevalence) == null ? void 0 : f[a]) == null || b.forEach((C) => {
        l[C.id] ? l[C.id] = {
          ...l[C.id],
          ...[
            "name",
            "npi",
            "specialty",
            "specialtySource",
            "placeOfServiceConceptId",
            "placeOfServiceConceptName"
          ].reduce((v, A) => (v[A] = l[C.id][A] || C[A], v), {})
        } : l[C.id] = {
          name: C.name,
          id: C.id,
          npi: C.npi,
          placeOfServiceConceptId: C.placeOfServiceConceptId,
          placeOfServiceConceptName: C.placeOfServiceConceptName,
          specialty: C.specialty,
          specialtySource: C.specialtySource
        }, l[C.id][c.dataSource.id] = C;
      }), l;
    }, {})
  );
}
const cx = ({ data: n, selectedCohort: o }) => {
  const { domainId: a } = rp(), i = g5(o.id, a), l = y5(n, a), c = Y4[a];
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { title: c, children: [
      /* @__PURE__ */ e.jsx(y1, { data: n, columns: i, hideSettings: !0 }),
      /* @__PURE__ */ e.jsx(
        P3,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ") with",
                " ",
                c,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ e.jsx(e.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Prevalence", children: /* @__PURE__ */ e.jsx(
      y1,
      {
        variant: "uncontrolled",
        data: v5(n, o.id, a),
        columns: l,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      a
    ) }, a) })
  ] });
};
function C2(n, o, a, i) {
  return n.every((l) => {
    var p, g;
    const c = l.resultInfo[i ? "healthSystems" : "domains"][a];
    return !((p = c == null ? void 0 : c.counts) != null && p[o]) && !((g = c == null ? void 0 : c.prevalence) != null && g[o]);
  });
}
const j4 = [
  "#7ba9ff",
  "#ff9315",
  "#DC6BAD",
  "#55DBCB",
  "#79d082",
  // original
  "#a1c2ff",
  "#568dff",
  "#ffd28c",
  "#ffb34d",
  "#e893c1",
  "#f4afd8",
  "#7ee0d4",
  "#3dc4b3",
  "#9ce4a5",
  "#5bbd67",
  "#c3d6ff",
  "#96afff",
  "#ffe0b3",
  "#ffbe66",
  "#e3a6cb",
  "#f7c4e1",
  "#b3eee4"
], ux = ({
  cx: n,
  cy: o,
  midAngle: a,
  innerRadius: i,
  outerRadius: l,
  percent: c,
  payload: p
}) => {
  const g = p.payload.isEmpty, u = c * 100, d = Math.PI / 180, f = i + (l - i) * 0.4, b = n + f * Math.cos(-a * d), C = o + f * Math.sin(-a * d);
  return /* @__PURE__ */ e.jsx(
    "text",
    {
      x: b,
      y: C,
      fill: "white",
      textAnchor: b > n ? "start" : "end",
      dominantBaseline: "central",
      fontSize: 12,
      children: `${g ? "0.00%" : u.toFixed(2)}%`
    }
  );
}, dx = ({ data: n, title: o, dataSourceId: a, index: i, isEmpty: l }) => {
  const [c, p] = pe(10), g = je(() => {
    let d = [...n];
    d.sort((b, C) => C.personCount - b.personCount);
    const f = d.splice(20).reduce(
      (b, C) => (b.personCount += C.personCount, b.items.push(C.name), b),
      { personCount: 0, name: "Other", items: [] }
    );
    return f.personCount > 0 && d.push(f), d;
  }, [n]), u = (d) => l ? "lightgrey" : d >= j4.length ? d5(
    `0.${d / (1 * j4.length)}`,
    j4[d % j4.length]
  ) : j4[d];
  return /* @__PURE__ */ e.jsx(y, { item: !0, textAlign: "center", xs: 6, md: 6, xl: 4, minWidth: 400, children: /* @__PURE__ */ e.jsxs(y, { container: !0, justifyContent: l ? "space-around" : "center", children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(X, { display: "flex", justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ e.jsx(m3, { getValue: () => a, size: 20 }),
      /* @__PURE__ */ e.jsx(ce, { variant: "body2", sx: { ml: 1 }, children: o })
    ] }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 7.5, children: /* @__PURE__ */ e.jsx(R3, { height: 300, children: /* @__PURE__ */ e.jsxs(Eo, { children: [
      /* @__PURE__ */ e.jsx(
        Ao,
        {
          cx: "50%",
          cy: "50%",
          fill: u(i),
          data: g,
          labelLine: !1,
          label: (n == null ? void 0 : n.length) < 11 ? ux : void 0,
          dataKey: "personCount",
          nameKey: "name",
          children: g.map((d, f) => /* @__PURE__ */ e.jsx(m2, { fill: u(f) }, `cell-${f}`))
        }
      ),
      !l && /* @__PURE__ */ e.jsx(
        h3,
        {
          cursor: { stroke: "white", strokeWidth: 0 },
          content: ({ payload: d, ...f }) => {
            var b, C, v, A, P, T;
            return /* @__PURE__ */ e.jsxs(
              X,
              {
                sx: {
                  bgcolor: "white",
                  borderRadius: "2px",
                  p: 1,
                  fontSize: 12,
                  textAlign: "left"
                },
                children: [
                  /* @__PURE__ */ e.jsx("b", { children: (b = d == null ? void 0 : d[0]) == null ? void 0 : b.name }),
                  /* @__PURE__ */ e.jsx("br", {}),
                  "Person count:",
                  " ",
                  /* @__PURE__ */ e.jsx("b", { children: oe(Number((C = d == null ? void 0 : d[0]) == null ? void 0 : C.value)) }),
                  /* @__PURE__ */ e.jsx("br", {}),
                  ((v = d == null ? void 0 : d[0]) == null ? void 0 : v.payload.recordCount) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    "Record count:",
                    " ",
                    /* @__PURE__ */ e.jsx("b", { children: oe(
                      Number((A = d == null ? void 0 : d[0]) == null ? void 0 : A.payload.recordCount)
                    ) })
                  ] }),
                  ((P = d == null ? void 0 : d[0]) == null ? void 0 : P.payload.items) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    "Other items:",
                    " ",
                    /* @__PURE__ */ e.jsx("b", { children: ((T = d == null ? void 0 : d[0]) == null ? void 0 : T.payload.items).join(", ") })
                  ] })
                ]
              }
            );
          }
        }
      )
    ] }) }) }),
    !l && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 4.5, children: /* @__PURE__ */ e.jsxs(X, { pt: 4, textAlign: "left", children: [
      g.slice(0, c).map((d, f) => {
        const b = u(f);
        return /* @__PURE__ */ e.jsx(
          X,
          {
            title: d.name || "",
            sx: {
              fontSize: 13,
              color: "#474850",
              mb: 0.5,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              "::before": {
                content: '""',
                height: "8px",
                width: "8px",
                backgroundColor: b,
                borderRadius: "50%",
                display: "inline-block",
                mr: 0.5
              }
            },
            children: d.name ? "— " + d.name : ""
          },
          `item-${f}`
        );
      }),
      (n == null ? void 0 : n.length) > 10 && /* @__PURE__ */ e.jsx(X, { textAlign: "left", children: /* @__PURE__ */ e.jsx(
        Ye,
        {
          color: "info",
          variant: "text",
          size: "small",
          onClick: () => {
            p(c === 10 ? n.length : 10);
          },
          children: c === 10 ? "Show more" : "Show less"
        }
      ) })
    ] }) })
  ] }) });
}, Hr = (n, o, a) => (i, l) => {
  var c, p, g;
  if ("prevalence" in ((c = i.resultInfo.healthSystems) == null ? void 0 : c[n])) {
    const u = (g = ((p = i.resultInfo.healthSystems) == null ? void 0 : p[n]).prevalence) == null ? void 0 : g[o + "_" + a];
    return /* @__PURE__ */ e.jsx(
      dx,
      {
        data: u != null && u.length ? u : [
          {
            personCount: 1,
            isEmpty: !0
          }
        ],
        index: l,
        title: i.dataSource.name,
        dataSourceId: i.dataSource.id,
        isEmpty: !(u != null && u.length)
      }
    );
  }
}, px = ({ providerData: n, data: o, selectedCohort: a, hasHealthSystemData: i }) => {
  const l = n === "event" ? "provider" : "provider_visit", c = C2(
    o,
    l,
    a.id,
    i
  ), p = g5(
    a.id,
    l,
    i ? "healthSystems" : "domains"
  ), g = y5(o, l), u = v5(
    o,
    a.id,
    l,
    i ? "healthSystems" : "domains"
  ), d = Y4[l];
  return c ? /* @__PURE__ */ e.jsx(h5, { noDataText: "No data found" }) : /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ e.jsx(y1, { data: o, columns: p, hideSettings: !0 }),
      /* @__PURE__ */ e.jsx(
        P3,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                a.name,
                ") with",
                " ",
                d,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                a.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ e.jsx(e.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    i && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Domain", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
      y,
      {
        container: !0,
        spacing: 2,
        sx: { overflowX: "auto", overflowY: "hidden" },
        flexWrap: "nowrap",
        children: o == null ? void 0 : o.map(
          Hr(a.id, l, "domain")
        )
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
      y1,
      {
        variant: "uncontrolled",
        data: u,
        columns: g,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      l
    ) }) }),
    i && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Specialty", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
        y,
        {
          container: !0,
          spacing: 2,
          sx: { overflowX: "auto", overflowY: "hidden" },
          flexWrap: "nowrap",
          children: o == null ? void 0 : o.map(
            Hr(a.id, l, "specialty")
          )
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Specialty Source", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
        y,
        {
          container: !0,
          spacing: 2,
          sx: { overflowX: "auto", overflowY: "hidden" },
          flexWrap: "nowrap",
          children: o == null ? void 0 : o.map(
            Hr(
              a.id,
              l,
              "specialty_source"
            )
          )
        }
      ) }) })
    ] })
  ] });
}, mx = ({ data: n, selectedCohort: o, hasHealthSystemData: a }) => {
  const i = "location", l = g5(
    o.id,
    i,
    a ? "healthSystems" : "domains"
  ), c = y5(n, i), p = v5(
    n,
    o.id,
    i,
    a ? "healthSystems" : "domains"
  ), g = C2(
    n,
    i,
    o.id,
    a
  ), u = Y4[i];
  return g ? /* @__PURE__ */ e.jsx(h5, { noDataText: "No data found" }) : /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ e.jsx(y1, { data: n, columns: l, hideSettings: !0 }),
      /* @__PURE__ */ e.jsx(
        P3,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ") with",
                " ",
                u,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ e.jsx(e.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
      y1,
      {
        variant: "uncontrolled",
        data: p,
        columns: c,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      i
    ) }) })
  ] });
}, hx = ({ data: n, selectedCohort: o, hasHealthSystemData: a }) => {
  const i = "caresite_visit", l = g5(
    o.id,
    i,
    a ? "healthSystems" : "domains"
  ), c = y5(n, i), p = v5(
    n,
    o.id,
    i,
    a ? "healthSystems" : "domains"
  ), g = C2(
    n,
    i,
    o.id,
    a
  ), u = Y4[i];
  return g ? /* @__PURE__ */ e.jsx(h5, { noDataText: "No data found" }) : /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ e.jsx(y1, { data: n, columns: l, hideSettings: !0 }),
      /* @__PURE__ */ e.jsx(
        P3,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ") with",
                " ",
                u,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                "persons/records in cohort (",
                o.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ e.jsx(e.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ e.jsx(
      y1,
      {
        variant: "uncontrolled",
        data: p,
        columns: c,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      i
    ) }) })
  ] });
}, fx = ({
  data: n,
  selectedCohort: o
}) => {
  const [a, i] = pe("event"), l = n.some((c) => "healthSystems" in c.resultInfo);
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        defaultState: !1,
        collapsible: !0,
        title: "Provider",
        actions: /* @__PURE__ */ e.jsxs($4, { size: "small", children: [
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              variant: a === "event" ? "contained" : "outlined",
              color: "info",
              onClick: (c) => {
                c.stopPropagation(), i("event");
              },
              children: "By Event"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ye,
            {
              variant: a === "visit" ? "contained" : "outlined",
              color: "info",
              onClick: (c) => {
                c.stopPropagation(), i("visit");
              },
              children: "By visit"
            }
          )
        ] }),
        children: /* @__PURE__ */ e.jsx(
          px,
          {
            data: n,
            selectedCohort: o,
            providerData: a,
            hasHealthSystemData: l
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { defaultState: !1, collapsible: !0, title: "Care Site", children: /* @__PURE__ */ e.jsx(
      hx,
      {
        data: n,
        selectedCohort: o,
        hasHealthSystemData: l
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Ne, { defaultState: !1, collapsible: !0, title: "Location", children: /* @__PURE__ */ e.jsx(
      mx,
      {
        data: n,
        selectedCohort: o,
        hasHealthSystemData: l
      }
    ) }) })
  ] });
}, cv = ze((n) => {
  const { data: o, analysisInfo: a, subModules: i } = n, l = je(
    () => o.submissions.filter(
      (d) => d.state === Q7.AWAITING_PUBLISHING_APPROVAL || d.state === Q7.PUBLISHED
    ),
    [o]
  ), c = l[0].resultInfo.targetCohorts || [], p = l[0].resultInfo.eventCohorts || [], [g, u] = pe(c[0]);
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      container: !0,
      spacing: 1,
      sx: {
        td: {
          height: 36,
          py: 0.5
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ne,
          {
            outlined: !0,
            elevated: !0,
            collapsible: !0,
            title: "Compare results",
            size: "dense",
            children: /* @__PURE__ */ e.jsx(Gf, { resultData: l })
          }
        ) }),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
          Ne,
          {
            outlined: !0,
            elevated: !0,
            collapsible: !0,
            title: "Details",
            size: "dense",
            children: [
              /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 2, children: [
                /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
                  H1,
                  {
                    multiple: !1,
                    fullWidth: !0,
                    value: (g == null ? void 0 : g.id) || null,
                    onChange: (d, f) => u(f),
                    options: c,
                    placeholder: "Select cohort...",
                    getOptionLabel: function(d) {
                      var f;
                      return d.name || ((f = c.find((b) => b.id === d)) == null ? void 0 : f.name);
                    },
                    isOptionEqualToValue: (d, f) => d.id === f.id || d.id === f
                  }
                ) })
              ] }),
              /* @__PURE__ */ e.jsx(M1, {}),
              /* @__PURE__ */ e.jsx(f5, { tabs: Kf, withRouting: !0, secondary: !0 }),
              /* @__PURE__ */ e.jsx(co, { children: /* @__PURE__ */ e.jsxs(op, { children: [
                /* @__PURE__ */ e.jsx(
                  b4,
                  {
                    path: "/*",
                    element: /* @__PURE__ */ e.jsx(
                      rx,
                      {
                        eventCohorts: p,
                        data: l,
                        selectedCohort: g,
                        analysis: a
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  b4,
                  {
                    path: "/attrition",
                    element: /* @__PURE__ */ e.jsx(
                      sx,
                      {
                        cohorts: c,
                        data: l,
                        selectedCohort: g,
                        analysis: a
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  b4,
                  {
                    path: "/demographics",
                    element: /* @__PURE__ */ e.jsx(
                      lx,
                      {
                        analysis: a,
                        data: l,
                        selectedCohort: g
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  b4,
                  {
                    path: "/domain/:domainId",
                    element: /* @__PURE__ */ e.jsx(cx, { selectedCohort: g, data: l })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  b4,
                  {
                    path: "/health-system",
                    element: /* @__PURE__ */ e.jsx(
                      fx,
                      {
                        selectedCohort: g,
                        data: l
                      }
                    )
                  }
                )
              ] }) })
            ]
          }
        ) })
      ]
    }
  );
}), uv = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
];
var xx = /* @__PURE__ */ ((n) => (n[n.age_group = 0] = "age_group", n[n.ethnicity = 1] = "ethnicity", n[n.gender = 2] = "gender", n[n.race = 3] = "race", n))(xx || {});
const gx = Fe.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`, dv = ze((n) => {
  const { subModules: o, parentId: a, viewMode: i } = n, [l, c] = pe([]);
  return /* @__PURE__ */ e.jsx(gx, { children: /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx("h3", { children: "Target cohorts:" }),
    /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        config: {
          onChange: (p) => {
            c(p);
          },
          multiple: !0,
          parentId: a,
          viewMode: i
        }
      }
    ),
    /* @__PURE__ */ e.jsx(y, { container: !0, children: l.map((p) => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12 })) })
  ] }) }) });
}), pv = ze((n) => /* @__PURE__ */ e.jsx(e.Fragment, { children: "results" })), mv = () => ({}), hv = (n, o) => ({
  ...o,
  type: n.type
}), fv = ze(
  (n) => {
    const {
      subModules: o,
      parentId: a,
      design: i,
      id: l,
      typeContainer: c,
      updateDesign: p,
      analysisName: g,
      viewMode: u
    } = n;
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: (!u || u && i.cohortVersionId) && /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        viewMode: u,
        path: L1(c, l, a),
        config: {
          buttonText: "Import cohort",
          titleText: "Target cohort",
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: i.cohortVersionId ? [i.cohort] : [],
          onChange: ([d]) => {
            p("cohort", d || {});
          },
          parentId: a,
          returnEntityText: g,
          viewMode: u
        }
      }
    ) });
  }
), yx = (n) => (o, a, i, l) => {
  var c, p, g, u;
  return ((c = o.values[i]) == null ? void 0 : c[n]) > ((p = a.values[i]) == null ? void 0 : p[n]) ? 1 : ((g = a.values[i]) == null ? void 0 : g[n]) > ((u = o.values[i]) == null ? void 0 : u[n]) ? -1 : 0;
}, vx = (n, o, a, i) => n.values[a] - o.values[a], C9 = (n, o, a, i) => Math.abs(n.values[a]) - Math.abs(o.values[a]), j9 = (n) => {
  const o = n == null ? void 0 : n[0], a = n == null ? void 0 : n[1], i = Math.sqrt(
    ((o == null ? void 0 : o.diffValue) + (a == null ? void 0 : a.diffValue)) / 2
  );
  return i == 0 ? 0 : ((o == null ? void 0 : o.avg) - (a == null ? void 0 : a.avg)) / i;
}, i2 = (n = !1) => ({
  columns: [
    {
      Header: "Covariate",
      id: "covariateName",
      accessor: "covariateName",
      rowSpan: 2,
      sortType: yx("covariateName"),
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "covariateName_1",
          accessor: (o) => o.covariateName || o.name,
          isCropped: !0,
          maxWidth: 500,
          minWidth: 150
        }
      ]
    },
    ...n ? [] : [
      {
        Header: "Concept Id",
        id: "conceptId",
        accessor: "conceptId",
        rowSpan: 2,
        columns: [
          {
            Header: "",
            invisible: !0,
            id: "conceptId_1",
            accessor: "conceptId",
            Cell: ({ value: o }) => /* @__PURE__ */ e.jsx(ao, { to: `modal/related/${o}`, children: o })
          }
        ]
      }
    ]
  ]
}), bx = (n, o = [], a = !0, i = !1) => {
  const l = n.designName === "DemographicsAgeGroup";
  let c = o.map((p, g) => ({
    Header: p.name,
    align: "center",
    disableSortBy: !0,
    colSpan: 2,
    columns: [
      {
        Header: "Count",
        id: `records[${p.id}].count`,
        accessor: `records[${p.id}].count`,
        Cell: ({ value: u }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(u) })
      },
      {
        Header: "Pct, %",
        id: `avg${g}`,
        accessor: `records[${p.id}].avg`,
        sortType: vx,
        Cell: (u) => {
          const d = (u.value || 0) * 100, f = oe(d, 2, 2);
          return /* @__PURE__ */ e.jsx(e.Fragment, { children: a ? /* @__PURE__ */ e.jsx(Jr, { width: u.value * 100, label: `${f}%` }) : /* @__PURE__ */ e.jsx(Qr, { children: `${f}%` }) });
        }
      }
    ]
  }));
  return (o == null ? void 0 : o.length) === 2 && !i && (c = [
    ...c,
    {
      Header: "Std diff",
      accessor: "records",
      rowSpan: 2,
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "stdDiff",
          accessor: (p) => j9(Object.values(p.records)),
          Cell: ({ value: p }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(p, 4, 4) }),
          sortType: C9
        }
      ]
    }
  ]), [...i2(l).columns, ...c];
}, Cx = (n, o = []) => {
  if (o.length === 1) {
    const i = [
      {
        Header: "Persons",
        accessor: `records[${o[0].id}].count`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "Avg",
        accessor: `records[${o[0].id}].avg`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "Std Dev",
        accessor: `records[${o[0].id}].stdDev`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "Min",
        accessor: `records[${o[0].id}].min`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "P10",
        accessor: `records[${o[0].id}].p10`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "P25",
        accessor: `records[${o[0].id}].p25`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "Median",
        accessor: `records[${o[0].id}].median`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "P75",
        accessor: `records[${o[0].id}].p75`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "P90",
        accessor: `records[${o[0].id}].p90`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      },
      {
        Header: "Max",
        accessor: `records[${o[0].id}].max`,
        Cell: ({ value: l }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(l) })
      }
    ];
    return [...i2().columns, ...i];
  }
  let a = o.map((i, l) => ({
    Header: i.name,
    accessor: "records",
    align: "center",
    id: i.id,
    columns: [
      {
        Header: "Persons",
        accessor: `records[${i.id}].count`,
        id: `records[${i.id}].count`,
        Cell: ({ value: c }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(c) })
      },
      {
        Header: "Avg",
        id: `records[${i.id}].avg`,
        accessor: `records[${i.id}].avg`,
        Cell: ({ value: c }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(c) })
      },
      {
        Header: "Std Dev",
        id: `records[${i.id}].stdDev`,
        accessor: `records[${i.id}].stdDev`,
        Cell: ({ value: c }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(c) })
      },
      {
        Header: "Median",
        id: `records[${i.id}].median`,
        accessor: `records[${i.id}].median`,
        Cell: ({ value: c }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(c) })
      }
    ]
  }));
  return (o == null ? void 0 : o.length) === 2 && (a = [
    ...a,
    {
      Header: "Std diff",
      accessor: "records",
      rowSpan: 2,
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "stdDiff",
          accessor: (i) => j9(Object.values(i.records)),
          Cell: ({ value: i }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(i, 4, 4) }),
          sortType: C9
        }
      ]
    }
  ]), [...i2().columns, ...a];
}, jx = ({
  getTableProps: n,
  getTableBodyProps: o,
  // headerGroups,
  // prepareRow,
  page: a,
  // onRowClick,
  // disableRowClick,
  // columnsCnt,
  // noDataText,
  // enableSorting,
  tileView: i = !1,
  // getRowError,
  // disableRowSelect,
  cohorts: l
}) => {
  const [c] = dd();
  return /* @__PURE__ */ e.jsxs(pd, { ...n(), className: "table", children: [
    !i && /* @__PURE__ */ e.jsxs("thead", { className: "table-head", children: [
      /* @__PURE__ */ e.jsxs(Z7, { className: "table-row", children: [
        /* @__PURE__ */ e.jsx("th", { rowSpan: 2, colSpan: 2, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", component: "span", children: "Cohort" }) }),
        /* @__PURE__ */ e.jsx(
          X,
          {
            component: "th",
            colSpan: a.length,
            align: "center",
            sx: { textAlign: "center" },
            children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", component: "span", children: "Covariates" })
          }
        )
      ] }, "table-header-0"),
      /* @__PURE__ */ e.jsx(Z7, { className: "table-row", children: a.map((p) => /* @__PURE__ */ e.jsx(
        X,
        {
          component: "th",
          sx: {
            whiteSpace: "break-spaces",
            width: `calc(80% / ${a.length})`,
            minWidth: "70px"
          },
          children: p.original.covariateName
        }
      )) }, "table-header-1")
    ] }),
    /* @__PURE__ */ e.jsx("tbody", { ...o(), className: "table-body", children: l.map((p, g) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Nr, { children: /* @__PURE__ */ e.jsx(
        v4,
        {
          rowSpan: 3,
          minWidth: 50,
          maxWidth: "50%",
          width: c,
          isCropped: !0,
          children: /* @__PURE__ */ e.jsx(
            X,
            {
              sx: {
                "::before": {
                  content: '""',
                  height: "8px",
                  width: "8px",
                  backgroundColor: g >= Pt.length ? d5(
                    `0.${g / (1 * Pt.length)}`,
                    Pt[g % Pt.length]
                  ) : Pt[g],
                  borderRadius: "50%",
                  display: "inline-block",
                  mr: 1
                }
              },
              children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", component: "span", children: p.name })
            },
            `item-${g}`
          )
        }
      ) }),
      /* @__PURE__ */ e.jsxs(Nr, { children: [
        /* @__PURE__ */ e.jsx(v4, { width: 100, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", children: "Count" }) }),
        a.map((u) => {
          var d;
          return /* @__PURE__ */ e.jsx(v4, { children: oe(((d = u.original.records[p.id]) == null ? void 0 : d.count) || 0) });
        })
      ] }),
      /* @__PURE__ */ e.jsxs(Nr, { children: [
        /* @__PURE__ */ e.jsx(v4, { width: 100, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", children: "Pct, %" }) }),
        a.map((u) => {
          var d;
          return /* @__PURE__ */ e.jsx(v4, { children: oe(
            (((d = u.original.records[p.id]) == null ? void 0 : d.avg) || 0) * 100,
            2,
            2
          ) });
        })
      ] })
    ] })) })
  ] });
}, Sx = ze((n) => {
  var E, x;
  const { name: o, report: a, cohorts: i, allResults: l, analysis: c } = n, [p, g] = pe(""), [u, d] = pe([]), f = a.resultType === R1.DISTRIBUTION, b = a.designName === "DemographicsAgeGroup", C = je(() => {
    var j;
    let m = (j = a == null ? void 0 : a.item) == null ? void 0 : j.map((_) => ({
      ..._,
      analysisType: _.analysisType || o,
      records: _.records.reduce((z, Y) => (z[Y.cohortId] = Y, z), {}) || []
    }));
    return b && m.sort((_, z) => String(_.name).localeCompare(z.name)), {
      raw: m,
      groupedByPage: Lo(m).list
    };
  }, [a.item]), [v, A] = pe(C.raw), P = je(() => f ? u || [] : [], [u, f]), T = xo((m) => {
    const j = C.raw.filter((_) => _.covariateName.toLowerCase().includes(m.toLowerCase()) || _.conceptId.toString().toLowerCase().includes(m.toString().toLowerCase()));
    A(j);
  }, 300), I = (m) => {
    const { value: j } = m.target;
    g(j), T(j);
  }, w = je(() => {
    switch (a == null ? void 0 : a.resultType) {
      case R1.PREVALENCE:
        return bx(
          a,
          i,
          C.raw.length > 2,
          (c == null ? void 0 : c.type) === I3.BULK_COHORT_COUNTS || (c == null ? void 0 : c.type) === I3.FEASIBILITY
          // we don't have diff in bulk
        );
      case R1.DISTRIBUTION:
        return Cx(a, i);
      default:
        return [];
    }
  }, [a, i]), N = f || ((E = a.item) == null ? void 0 : E.length) > 8 && (i == null ? void 0 : i.length) > 2 || (i == null ? void 0 : i.length) > 3;
  return /* @__PURE__ */ e.jsx(
    Ne,
    {
      elevated: !0,
      title: o,
      actions: !v.some(
        (m) => m.covariateName === null || m.covariateName === ""
      ) && C.raw.length > 1 && /* @__PURE__ */ e.jsxs(X, { display: "flex", alignItems: "center", justifyContent: "flex-end", children: [
        /* @__PURE__ */ e.jsx(X, { mr: 1, children: "Filter: " }),
        /* @__PURE__ */ e.jsx(
          et,
          {
            id: "search",
            name: "search",
            type: "text",
            size: "medium",
            placeholder: "Search by covariate",
            value: p,
            onChange: I,
            fullWidth: !0
          }
        )
      ] }),
      children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
        !u && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(X, { display: "flex", justifyContent: "center", p: 3, children: "No items" }) }),
        /* @__PURE__ */ e.jsx(
          y,
          {
            item: !0,
            xs: N ? 12 : 7,
            lg: N ? 12 : 8,
            sx: {
              table: {
                td: {
                  fontSize: 13
                }
              }
            },
            children: u && /* @__PURE__ */ e.jsx(
              At,
              {
                columns: w,
                data: v,
                customTable: (i == null ? void 0 : i.length) > 2 ? (m) => /* @__PURE__ */ e.jsx(jx, { ...m, cohorts: i }) : void 0,
                noDataText: "The result listing is empty because of the filter you applied",
                enableSorting: !0,
                enablePagination: !0,
                totalElements: (x = C.raw) == null ? void 0 : x.length,
                setCurrentPage: d,
                initialSort: b ? void 0 : { id: "avg0", desc: !0 },
                pageSize: (i == null ? void 0 : i.length) > 2 ? v.length : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(y, { item: !0, xs: N ? 12 : 5, lg: N ? 12 : 4, children: a.resultType !== R1.DISTRIBUTION ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          i.length == 1 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            a.item.length > 1 && a.item.length < 5 && /* @__PURE__ */ e.jsx(
              Fo,
              {
                list: u,
                cohort: i == null ? void 0 : i[0],
                addNA: !0
              }
            ),
            a.item.length > 5 && /* @__PURE__ */ e.jsx(No, { list: u, cohort: i == null ? void 0 : i[0] })
          ] }),
          i.length == 2 && /* @__PURE__ */ e.jsx(
            Do,
            {
              fullList: C.groupedByPage,
              cohorts: i,
              list: u,
              allResults: l,
              report: a
            }
          ),
          i.length > 2 && /* @__PURE__ */ e.jsx(
            Mo,
            {
              cohorts: i,
              list: u,
              xAxisTickFormatter: b ? (m) => m.replace("age group:", "") : void 0
            }
          )
        ] }) : a.resultType === R1.DISTRIBUTION && /* @__PURE__ */ e.jsx(y, { container: !0, px: 2, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Io,
          {
            report: a || {},
            cohorts: i || [],
            items: P
          }
        ) }) }) })
      ] })
    }
  );
}), S9 = ({ analysis: n, result: o, cohorts: a }) => {
  const i = r9(o, n);
  return /* @__PURE__ */ e.jsx(y, { container: !0, p: 2, className: "simple-counts-demographics", children: /* @__PURE__ */ e.jsx(co, { children: (i == null ? void 0 : i.length) > 0 ? i.map((l) => {
    var c, p;
    return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 2, children: n.type === I3.BULK_COHORT_COUNTS ? /* @__PURE__ */ e.jsx(
      Sx,
      {
        name: l.name,
        report: l,
        cohorts: a || (n != null && n.design ? [(c = n == null ? void 0 : n.design) == null ? void 0 : c.cohort] : []),
        analysis: n
      }
    ) : /* @__PURE__ */ e.jsx(
      x5,
      {
        name: l.name,
        report: l,
        cohorts: a || (n != null && n.design ? [(p = n == null ? void 0 : n.design) == null ? void 0 : p.cohort] : []),
        analysis: n
      }
    ) }, l.name);
  }) : /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(h5, { noDataText: "No data currently available" }) }) }) });
}, xv = [
  {
    name: "Target cohort",
    value: "cohortVersionId"
  }
], wx = (n, o) => [
  ...o ? [
    {
      title: "Results",
      value: "results",
      onTabClick: n
    }
  ] : [
    {
      value: "byPerson",
      title: "By person",
      onTabClick: n
    },
    {
      value: "byEvent",
      title: "By event",
      onTabClick: n
    }
  ],
  {
    title: "Demographics",
    value: "demographics",
    onTabClick: n
  }
], Tx = (n) => [
  {
    value: "byPerson",
    title: "By person",
    onTabClick: n
  },
  {
    value: "byEvent",
    title: "By event",
    onTabClick: n
  }
  // ...(hasDemographics
  //   ? [
  //       {
  //         title: 'Demographics',
  //         value: 'demographics',
  //         onTabClick: setActive,
  //       },
  //     ]
  //   : []),
], Ex = [
  {
    header: "Match rate",
    accessorKey: "percentMatched"
  },
  {
    header: "Matches",
    accessorKey: "finalCount",
    cell: ({ getValue: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n()) })
  },
  {
    header: "Total events",
    accessorKey: "baseCount",
    cell: ({ getValue: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(n()) })
  }
], Ax = ({ activeView: n, setActiveView: o, resultData: a }) => [
  {
    header: () => /* @__PURE__ */ e.jsx(
      u3,
      {
        title: "Inclusion rule",
        description: "Inclusion rules are based on inclusion rule section in the cohort builder"
      }
    ),
    accessorFn: (i) => i.id >= 0 ? `${i.id + 1}. ${i.name}` : i.name,
    id: "inclusionRule",
    size: 350
  },
  {
    header: () => /* @__PURE__ */ e.jsx(
      u3,
      {
        title: "N",
        description: "Number of persons that satisfy all inclusion rules applied consecutively in an order specified in the cohort builder"
      }
    ),
    accessorKey: "countSatisfying",
    cell: ({ getValue: i }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: oe(i()) }),
    size: 80
  },
  {
    header: () => /* @__PURE__ */ e.jsx(
      u3,
      {
        title: "% Satisfied",
        description: "Persons that satisfy all consecutive inclusion rules expressed as % of the base cohort count"
      }
    ),
    accessorKey: "percentSatisfying",
    size: 80
  },
  {
    header: () => /* @__PURE__ */ e.jsx(
      u3,
      {
        title: "% to gain",
        description: "% to gain represents the % of population that can be recovered by relaxing the inclusion rule"
      }
    ),
    accessorKey: "percentExcluded",
    size: 80
  },
  {
    header: () => /* @__PURE__ */ e.jsx(
      f1,
      {
        text: n ? "The Attrition view allows users to visualize a classic attrition funnel, where each consecutive rule further restricts the population. The order of criteria affects the statistics." : "The Intersect view allows users to visualize how individual inclusion rules or combinations of these rules affect results, regardless of the sequence in which the rules are applied.Hovering over each box allows to see statistical information about the subgroups that either satisfied or did not satisfy specific inclusion criteria. The failed criteria is highlighted in red.",
        children: /* @__PURE__ */ e.jsxs(
          Ye,
          {
            variant: "text",
            startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "reload" }),
            onClick: () => o((i) => !i),
            size: "small",
            color: "primary",
            children: [
              "Switch to ",
              n ? "intersect view" : "attrition view"
            ]
          }
        )
      }
    ),
    id: "percentSatisfying-chart",
    accessorKey: "percentSatisfying",
    enableSorting: !1,
    // enableHiding: false,
    size: 320,
    meta: {
      headerAlign: "center",
      columnName: "Chart"
    },
    cell: (i) => {
      const l = a.summary.baseCount;
      return /* @__PURE__ */ e.jsx(
        f1,
        {
          text: i.row.original.id !== -1 ? n9(i.row.original.id, a) : `${i.row.original.name}: ${l}, 100.00%`,
          color: "primary",
          width: "auto",
          children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
            v9,
            {
              color: e9(parseFloat(i.getValue()) / 100),
              width: i.getValue()
            }
          ) })
        }
      );
    }
  }
], _x = 10, Px = ({
  analysis: n,
  data: o,
  row: a,
  setPassedAndFailed: i,
  passedAndFailed: l,
  index: c,
  ...p
}) => {
  const g = w1(() => {
    var C;
    return !!((C = l == null ? void 0 : l.failed) != null && C.find((v) => v.id === a.original.id));
  }, [l.failed]), u = Object.values(o.inclusionRuleStats ?? {}).length, d = new Array(Math.max(0, _x - u)).fill(
    null
  ), f = 1 + u + d.length, b = o.activeView == "intersect" && c === u;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        component: "tr",
        ...p,
        className: p.className + (c === 0 ? " no-hover" : ""),
        children: a.getVisibleCells().map((C) => {
          const v = C.column.getIsPinned();
          if (o.activeView == "intersect" && C.id.includes("percentSatisfying-chart")) {
            const A = !!o.treemapData;
            if (c == 0)
              return /* @__PURE__ */ e.jsx(
                X,
                {
                  component: "td",
                  className: `${v ? "pinned " : ""} td`,
                  rowSpan: f > 6 ? f : 6,
                  sx: {
                    fontSize: "10px !important",
                    padding: "4px 0 ",
                    height: A ? "300px" : "",
                    textAlign: "center",
                    backgroundColor: A ? "white" : "transparent",
                    position: "relative",
                    borderBottom: A ? "none" : void 0
                  },
                  children: A ? /* @__PURE__ */ e.jsx(
                    b9,
                    {
                      resultData: o,
                      setPassedAndFailed: i,
                      analysisName: n == null ? void 0 : n.title
                    }
                  ) : "N/A"
                }
              );
          } else
            return /* @__PURE__ */ e.jsx(
              X,
              {
                component: "td",
                className: `${v ? "pinned " : ""} td`,
                sx: {
                  color: g() ? "red" : ""
                },
                children: oo(C.column.columnDef.cell, {
                  ...C.getContext()
                })
              }
            );
        })
      }
    ),
    b && d.map(() => /* @__PURE__ */ e.jsxs("tr", { children: [
      /* @__PURE__ */ e.jsx("td", {}),
      /* @__PURE__ */ e.jsx("td", {}),
      /* @__PURE__ */ e.jsx("td", {}),
      /* @__PURE__ */ e.jsx("td", {})
    ] }))
  ] });
}, w9 = ({ legacy: n, resultsCount: o, activeTab: a, analysisInfo: i, count: l }) => {
  var v;
  const [c, p] = pe(!0), g = i.type === I3.BULK_COHORT_COUNTS, u = je(() => {
    var A;
    return g ? o == null ? void 0 : o.find((P) => P.type === a) : ((A = o == null ? void 0 : o.inclusionRuleReport) == null ? void 0 : A[a]) || [];
  }, [a]), d = je(() => c ? (u == null ? void 0 : u.attritions) || [] : u == null ? void 0 : u.inclusionRuleStats, [a, c]), [f, b] = pe({
    passed: [],
    failed: []
  }), C = w1(
    (A) => {
      u2(f, A) || b(A);
    },
    [f]
  );
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, p: 2, children: [
    /* @__PURE__ */ e.jsx(ax, { count: l }),
    !n && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, pt: 2, children: /* @__PURE__ */ e.jsx(M1, {}) }),
      (u == null ? void 0 : u.summary) && (u == null ? void 0 : u.summary.length) > 0 && /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 10, children: [
        /* @__PURE__ */ e.jsx(
          qn,
          {
            title: "Summary statistics",
            startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "list" })
          }
        ),
        /* @__PURE__ */ e.jsx(y, { container: !0, py: 2, children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, className: "table-cohorts", children: /* @__PURE__ */ e.jsx(
          y1,
          {
            columns: Ex,
            data: u != null && u.summary ? [u == null ? void 0 : u.summary] : [],
            loadingMessage: "",
            totalElements: (v = u == null ? void 0 : u.summary) == null ? void 0 : v.length
          }
        ) }) })
      ] })
    ] }),
    !n && /* @__PURE__ */ e.jsx(y, { container: !0, item: !0, xs: 12, mt: 3, children: /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
      y1,
      {
        columns: Ax({
          activeView: c,
          setActiveView: p,
          resultData: u
        }),
        data: [
          {
            countSatisfying: u.summary.baseCount,
            id: -1,
            name: "Base count (Entry events)",
            percentExcluded: "0.00%",
            percentSatisfying: "100.00%"
          },
          ...d
        ],
        customTableRow: (A) => /* @__PURE__ */ e.jsx(
          Px,
          {
            ...A,
            setPassedAndFailed: C,
            passedAndFailed: f,
            analysis: i,
            data: {
              ...u,
              activeTab: a,
              activeView: c ? "attrition" : "intersect"
            }
          }
        )
      }
    ) }) })
  ] }) });
}, Ox = ze((n) => {
  const { data: o, analysisInfo: a } = n, i = o5(o) ? o : null, l = !(i != null && i.inclusionRuleReport) || !(Object.keys(i.inclusionRuleReport).length > 0), c = (i == null ? void 0 : i.personCount) != null, p = (i == null ? void 0 : i.recordCount) != null, g = c || p, [u, d] = pe(
    l && !g ? "results" : "byPerson"
  ), { selectedConcepts: f, detectSelectedAction: b } = Qd(
    {},
    "id"
  ), C = a.type === I3.SIMPLE_COUNTS_CHARACTERIZATION, v = je(() => {
    if (!o5(o))
      return `${oe(o)} ${o != null ? "Persons" : ""}`;
    if (u === "byEvent") {
      const T = (i == null ? void 0 : i.recordCount) ?? (i == null ? void 0 : i.personCount);
      return `${T != null ? oe(T) : "N/A"} ${T != null ? "Records" : ""}`;
    }
    const P = (i == null ? void 0 : i.personCount) ?? (i == null ? void 0 : i.recordCount);
    return `${P != null ? oe(P) : "N/A"} ${P != null ? "Persons" : ""}`;
  }, [u, o]), A = w1((P, T) => {
    const I = {};
    P == null || P.forEach((w) => {
      I[w.id] = w;
    }), b(I, T);
  }, []);
  return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
    (!l || C || g) && /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(
        f5,
        {
          tabs: (
            // not clean - hot fix
            C ? wx(d, l && !g) : Tx(d)
          ),
          active: u
        }
      ),
      /* @__PURE__ */ e.jsx(M1, {})
    ] }),
    u !== "demographics" && /* @__PURE__ */ e.jsx(
      w9,
      {
        legacy: l,
        resultsCount: o,
        activeTab: u,
        analysisInfo: a,
        detectSelectedAction: A,
        count: v
      }
    ),
    C && u === "demographics" && /* @__PURE__ */ e.jsx(
      S9,
      {
        analysis: n.analysisInfo,
        result: o
      }
    )
  ] });
}), gv = ze(
  (n) => {
    const {
      subModules: o,
      parentId: a,
      design: i,
      id: l,
      typeContainer: c,
      updateDesign: p,
      analysisName: g,
      viewMode: u
    } = n;
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      (!u || u && i.cohortVersionId) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        o.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: o,
          viewMode: u,
          path: L1(c, l, a),
          config: {
            buttonText: "Import cohort",
            titleText: "Target cohort",
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: i.cohortVersionId ? [i.cohort] : [],
            onChange: ([d]) => {
              p("cohort", d || {});
            },
            parentId: a,
            returnEntityText: g,
            viewMode: u
          }
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          title: "Characterization settings",
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              Ve,
              {
                htmlFor: "useAgeGroups",
                textLabel: "Age Group",
                description: "Calculate age groups covariates prevalence statistics with 5 year interval.",
                labelSize: 3,
                children: /* @__PURE__ */ e.jsx(
                  S1,
                  {
                    id: "useAgeGroups",
                    name: "useAgeGroups",
                    onChange: () => {
                      p("useAgeGroups", !i.useAgeGroups);
                    },
                    checked: i.useAgeGroups,
                    disabled: u,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              Ve,
              {
                htmlFor: "useEthnicity",
                textLabel: "Ethnic Groups",
                description: "Calculate ethnicity covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ e.jsx(
                  S1,
                  {
                    id: "useEthnicity",
                    name: "useEthnicity",
                    onChange: () => {
                      p("useEthnicity", !i.useEthnicity);
                    },
                    checked: i.useEthnicity,
                    disabled: u,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              Ve,
              {
                htmlFor: "useGender",
                textLabel: "Gender",
                description: "Calculate gender covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ e.jsx(
                  S1,
                  {
                    id: "useGender",
                    name: "useGender",
                    onChange: () => {
                      p("useGender", !i.useGender);
                    },
                    checked: i.useGender,
                    disabled: u,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              Ve,
              {
                htmlFor: "useRace",
                textLabel: "Race",
                description: "Calculate race covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ e.jsx(
                  S1,
                  {
                    id: "useRace",
                    name: "useRace",
                    onChange: () => {
                      p("useRace", !i.useRace);
                    },
                    checked: i.useRace,
                    disabled: u,
                    size: "small"
                  }
                )
              }
            ) })
          ] })
        }
      ) })
    ] });
  }
), Ix = (n) => {
  switch (n) {
    case _t.SCANNING:
      return "warning";
    case _t.OK:
      return "success";
    case _t.INFECTED:
      return "error";
    case _t.NOT_SCANNED:
    case _t.WILL_NOT_SCAN:
      return "secondary";
  }
}, Rx = (n, o) => r4.post(`analysis/strategus/${n}/upload`, o), Nx = ze((n) => {
  const { id: o, afterCreate: a, onCancel: i, subModules: l, originalEntity: c, parentId: p } = n, [g, u] = pe(!1), [d, f] = pe(!1), [b, C] = pe(), [v, A] = pe(), [P, T] = pe({
    title: c.title,
    analysisType: po.find(
      (E) => E.value === c.type
    ).name || "-",
    analysisName: c == null ? void 0 : c.title,
    studyId: p,
    studyName: null,
    design: {
      analysisJsonFile: null
    }
  }), I = w1(() => {
    u(!0);
    let E = new FormData();
    E.append(
      "dto",
      new Blob([JSON.stringify(P)], {
        type: "application/json"
      })
    ), E.append("file", v), Rx(o, E).then((x) => {
      u(!1), a == null || a(x);
    });
  }, [b, P]), w = (E) => {
    try {
      if (E) {
        const x = JSON.parse(E);
        C(x), f(!1);
      } else
        C(void 0), f(!1);
    } catch {
      f(!0);
    }
  }, N = je(() => !d && b, [b, d]);
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(k4, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, display: "flex", flexWrap: "wrap", children: [
      /* @__PURE__ */ e.jsxs(y, { item: !0, mr: 2, children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Analysis name:"
          }
        ),
        /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", component: "span", fontWeight: 700, children: P.analysisName })
      ] }),
      /* @__PURE__ */ e.jsxs(y, { item: !0, mr: 2, children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Analysis type:"
          }
        ),
        /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", component: "span", fontWeight: 700, children: P.analysisType })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      l.documents,
      {
        type: "component",
        name: "import-json-file",
        subModules: l,
        config: {
          titleButton: "Upload json",
          onChange: (E, x) => {
            C(E), A(x);
          }
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Sd,
      {
        data: b || "",
        height: "63vh",
        fileName: `${c.title}.${c.type}`,
        language: bo(r5.JSON),
        onChange: w,
        readOnly: !0,
        fileExtension: r5.JSON,
        contentType: wd.APPLICATION_JSON
      }
    ) }),
    d && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ce,
      {
        variant: "subtitle2",
        fontWeight: 700,
        color: "error.main",
        children: "Invalid json"
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(io, { children: [
      /* @__PURE__ */ e.jsx(
        Ye,
        {
          variant: "outlined",
          onClick: i,
          startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ye,
        {
          disabled: g || !N,
          onClick: I,
          variant: "contained",
          color: "success",
          startIcon: g ? /* @__PURE__ */ e.jsx(p5, { size: 16 }) : /* @__PURE__ */ e.jsx(t1, { iconName: "submit" }),
          children: "Save design"
        }
      )
    ] }) })
  ] }) }) });
});
Fe.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const Fx = Fe(y)`
  font-size: 14px;
  color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.primary.main;
}};
  font-weight: 700;
  border-bottom: 1px solid
    ${({ theme: n }) => n.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: n, theme: o }) => n ? o.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: n, isActive: o }) => n.palette.info.main + (o ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, yv = ze(
  (n) => {
    var A, P, T;
    const {
      subModules: o,
      parentId: a,
      design: i,
      originalEntity: l,
      id: c,
      typeContainer: p,
      updateDesign: g,
      viewMode: u
    } = n, { openModal: d, closeModal: f } = eo(Po), [b, C] = pe(
      i.analysisJsonFile || null
    ), v = () => {
      d(
        () => /* @__PURE__ */ e.jsx(
          Nx,
          {
            id: c,
            subModules: o,
            originalEntity: l,
            onCancel: f,
            parentId: a,
            afterCreate: (I) => {
              C(I.design.analysisJsonFile), g("analysisJsonFile", I.design.analysisJsonFile), f();
            }
          }
        ),
        "Upload analysis",
        {
          closeOnClickOutside: !0,
          onClose: f
        }
      );
    };
    return je(
      () => b == null ? void 0 : b.title,
      [b == null ? void 0 : b.title]
    ), je(
      () => bo(r5.JSON),
      []
    ), /* @__PURE__ */ e.jsx(k4, { children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, px: 2, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Td,
        {
          title: "",
          customButtons: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            (i == null ? void 0 : i.analysisJsonFile) && /* @__PURE__ */ e.jsx(
              Ye,
              {
                onClick: (I) => {
                  I.stopPropagation(), window.location.href = `/api/analysis/strategus/${c}/download`;
                },
                variant: "outlined",
                startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "download" }),
                sx: {
                  mr: 2,
                  px: 2,
                  color: "info.main",
                  borderColor: "borderColor.main",
                  ".start-icon-small svg": {
                    fontSize: 16
                  }
                },
                className: "download-files",
                name: "download-files",
                children: "Download file"
              }
            ),
            !u && /* @__PURE__ */ e.jsx(
              Ye,
              {
                onClick: v,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ e.jsx(
                  t1,
                  {
                    iconName: "download",
                    sx: { transform: "rotate(180deg)" }
                  }
                ),
                name: "upload",
                children: "Upload"
              }
            )
          ] })
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: (i == null ? void 0 : i.analysisJsonFile) && /* @__PURE__ */ e.jsx(k4, { children: /* @__PURE__ */ e.jsx(
        y,
        {
          container: !0,
          spacing: 2,
          py: 2,
          className: "block-analysisJsonFile",
          children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(
            Fx,
            {
              xs: 12,
              px: 1,
              py: 0.5,
              isActive: !0,
              children: [
                /* @__PURE__ */ e.jsx(
                  t1,
                  {
                    iconName: go(r5.JSON),
                    iconStatus: Ix(
                      (A = i == null ? void 0 : i.analysisJsonFile) == null ? void 0 : A.antivirusFileStatusDto
                    ),
                    sx: { fontSize: 30 }
                  }
                ),
                /* @__PURE__ */ e.jsx("span", { children: (P = i == null ? void 0 : i.analysisJsonFile) == null ? void 0 : P.realName })
              ]
            },
            (T = i == null ? void 0 : i.analysisJsonFile) == null ? void 0 : T.path
          ) })
        }
      ) }) })
    ] }) });
  }
), vv = ze((n) => /* @__PURE__ */ e.jsx(e.Fragment, { children: "results" })), Dx = [
  "PERSON",
  "OBSERVATION_PERIOD",
  "VISIT_OCCURRENCE",
  "VISIT_DETAIL",
  "CONDITION_OCCURRENCE",
  "DRUG_EXPOSURE",
  "PROCEDURE_OCCURRENCE",
  "DEVICE_EXPOSURE",
  "MEASUREMENT",
  "OBSERVATION",
  "DEATH",
  "NOTE",
  "NOTE_NLP",
  "SPECIMEN",
  "FACT_RELATIONSHIP"
], Lx = ["METADATA", "CDM_SOURCE"], Mx = ["LOCATION", "CARE_SITE", "PROVIDER"], kx = ["PAYER_PLAN_PERIOD", "COST"], zx = [
  "CONCEPT",
  "VOCABULARY",
  "DOMAIN",
  "CONCEPT_CLASS",
  "CONCEPT_RELATIONSHIP",
  "RELATIONSHIP",
  "CONCEPT_SYNONYM",
  "CONCEPT_ANCESTOR",
  "SOURCE_TO_CONCEPT_MAP",
  "DRUG_STRENGTH",
  "COHORT_DEFINITION",
  "ATTRIBUTE_DEFINITION"
], Vr = [
  ...Dx.map((n) => ({
    name: n,
    group: "Clinical Data Tables"
  })),
  ...Lx.map((n) => ({
    name: n,
    group: "Metadata Tables"
  })),
  ...Mx.map((n) => ({
    name: n,
    group: "Health System"
  })),
  ...kx.map((n) => ({
    name: n,
    group: "Health Economics"
  })),
  ...zx.map((n) => ({
    name: n,
    group: "Vocabularies"
  }))
], z8 = {
  "Metadata Tables": { header: "#d2f7f3", options: "#ebf7f7" },
  "Clinical Data Tables": { header: "#d9ecff", options: "#f4f9ff" },
  "Health Economics": { header: "#d4f7d2", options: "#ecfceb" },
  "Health System": { header: "#fceeca", options: "#fcf5e3" },
  Vocabularies: { header: "#f6ebfc", options: "#fcf7ff" },
  selectAll: { header: "#ffffff", options: "#ffffff" }
}, Bx = Fe.div`
  padding: 8px 10px;
  position: sticky;
  background-color: ${({ color: n }) => (n == null ? void 0 : n.header) || "#ffffff"};
  z-index: 2;
  top: 0;
`, $x = Fe.div`
  background-color: ${({ color: n }) => (n == null ? void 0 : n.options) || "#ffffff"};
  min-height: 34px;
  cursor: pointer;
`, Wx = Fe.div`
  padding: 8px 10px;
  cursor: pointer;

  /* pointer-events: ${({ disabled: n }) => n ? "none" : "all"}; */
  position: sticky;
  top: 0;
`, Hx = ({
  updateDesign: n,
  design: o,
  disabled: a
}) => {
  var d;
  const i = Vr.length, [l, c] = pe(
    ((d = Object.keys(o.includedTables)) == null ? void 0 : d.length) === i
  );
  m1(() => {
    var f;
    ((f = Object.keys(o.includedTables)) == null ? void 0 : f.length) === i ? c(!0) : c(!1);
  }, [o.includedTables]);
  const p = (f, b) => {
    const C = b.map((v) => typeof v == "object" ? v.name : v).reduce((v, A) => (v[A] = !0, v), {});
    n("includedTables", C);
  }, g = (f) => {
    f.preventDefault(), l ? n("includedTables", []) : n(
      "includedTables",
      Vr.reduce((b, C) => (b[C.name] = !0, b), {})
    );
  }, u = w1(({ children: f, ...b }) => /* @__PURE__ */ e.jsx(
    Gt,
    {
      ...b,
      sx: {
        ".MuiAutocomplete-listbox": {
          p: 0,
          pb: 1,
          li: {
            pointerEvents: a ? "none" : "all"
          }
        },
        position: "relative"
      },
      children: f
    }
  ), []);
  return /* @__PURE__ */ e.jsx(
    H1,
    {
      disableCloseOnSelect: !0,
      id: "includedTables",
      name: "includedTables",
      onChange: p,
      options: [{ name: "Select all", group: "selectAll" }, ...Vr],
      value: Object.keys(o.includedTables) || [],
      multiple: !0,
      getOptionLabel: function(f) {
        return f.name || f;
      },
      PaperComponent: u,
      groupBy: (f) => f.group,
      OptionComponent: (f, b, { selected: C }) => /* @__PURE__ */ e.jsxs(X, { ...f, sx: { fontSize: "13px", height: "28px" }, children: [
        /* @__PURE__ */ e.jsx(
          S1,
          {
            sx: { mr: "8px" },
            checked: b.group === "selectAll" ? l : C,
            size: "small"
          }
        ),
        b.name
      ] }),
      isOptionEqualToValue: (f, b) => f.name === b,
      disableClearable: a,
      renderTags: (f, b) => /* @__PURE__ */ e.jsxs(
        X,
        {
          sx: {
            px: 1,
            fontSize: 14,
            color: "textColor.label"
          },
          children: [
            f != null && f.length ? (f == null ? void 0 : f.length) === i ? "All tables" : f == null ? void 0 : f.length : "None",
            " ",
            "selected..."
          ]
        },
        "tag-props"
      ),
      renderGroup: (f) => /* @__PURE__ */ e.jsx("li", { children: f.group === "selectAll" ? /* @__PURE__ */ e.jsxs(
        Wx,
        {
          onMouseDown: (b) => b.preventDefault(),
          onClick: g,
          disabled: a,
          children: [
            /* @__PURE__ */ e.jsx(
              S1,
              {
                sx: { marginRight: "8px" },
                checked: l,
                size: "small"
              }
            ),
            "Select All"
          ]
        }
      ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(Bx, { color: z8[f.group], children: f.group }),
        /* @__PURE__ */ e.jsx($x, { color: z8[f.group], children: f.children })
      ] }) }, f.key),
      disabled: a
    }
  );
}, bv = (n) => {
  var d;
  const {
    subModules: o,
    parentId: a,
    design: i,
    id: l,
    typeContainer: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    (!u || u && ((d = i == null ? void 0 : i.cohorts) == null ? void 0 : d.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        viewMode: u,
        path: L1(c, l, a),
        config: {
          buttonText: "Import cohorts",
          titleText: "Target cohorts",
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: i == null ? void 0 : i.cohorts,
          onChange: (f) => {
            p("cohorts", f);
          },
          parentId: a,
          returnEntityText: g,
          viewMode: u,
          isSelect: !0
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ e.jsx(Ne, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(y, { container: !0, children: /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(
        Ve,
        {
          textLabel: "OMOP CDM tables",
          description: "All tables are selected by default",
          labelSize: 4,
          htmlFor: "includedTables",
          required: !0,
          children: /* @__PURE__ */ e.jsx(
            Hx,
            {
              design: i,
              updateDesign: p,
              disabled: u
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ve,
        {
          htmlFor: "cohortOption",
          textLabel: "Data to export",
          description: "",
          labelSize: 4,
          required: !0,
          children: /* @__PURE__ */ e.jsxs(y, { container: !0, fontSize: 13, color: "textColor.main", children: [
            /* @__PURE__ */ e.jsxs(X, { mr: 3, component: "label", children: [
              /* @__PURE__ */ e.jsx(
                J7,
                {
                  checked: i.cohortOption === "COHORT_DATA",
                  value: "COHORT_DATA",
                  onChange: function(f) {
                    p("cohortOption", "COHORT_DATA");
                  },
                  size: "small",
                  sx: { mr: 0.5 },
                  disabled: u
                }
              ),
              "Cohort Data"
            ] }),
            /* @__PURE__ */ e.jsxs(X, { component: "label", children: [
              /* @__PURE__ */ e.jsx(
                J7,
                {
                  checked: i.cohortOption === "FULL_PATIENT_RECORD",
                  value: "FULL_PATIENT_RECORD",
                  onChange: function(f) {
                    p("cohortOption", "FULL_PATIENT_RECORD");
                  },
                  size: "small",
                  sx: { mr: 0.5 },
                  disabled: u
                }
              ),
              "Full patient record"
            ] })
          ] })
        }
      )
    ] }) }) }) })
  ] });
}, Cv = ze((n) => /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, bgcolor: "backgroundColor.dark", children: [
  n.data.map((o, a) => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, sx: { ".simple-counts-demographics": { p: 0 } }, children: /* @__PURE__ */ e.jsx(
    Ne,
    {
      collapsible: !0,
      title: o.name,
      size: "dense",
      defaultState: !a,
      children: /* @__PURE__ */ e.jsx(
        Ox,
        {
          analysisInfo: {
            ...n.analysisInfo,
            // fast workaround add cohort to design which is connected to exact results
            design: { ...n.analysisInfo.design, cohort: o }
          },
          data: o.result
        }
      )
    }
  ) })),
  " "
] })), jv = () => ({
  cohort: [],
  includedTables: [],
  cohortOption: []
}), Sv = (n) => "", wv = (n, o) => ({
  ...o,
  type: n.type
}), Tv = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], Ev = ze((n) => {
  var f, b;
  const {
    subModules: o,
    parentId: a,
    design: i,
    id: l,
    typeContainer: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n, d = (C) => (v) => {
    p(C, v);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    (!u || u && ((f = i == null ? void 0 : i.cohorts) == null ? void 0 : f.length) > 0) && /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        path: L1(c, l, a),
        config: {
          buttonText: "Import target cohort",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Target cohorts",
              count: (b = i == null ? void 0 : i.cohorts) == null ? void 0 : b.length
            }
          ),
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: i == null ? void 0 : i.cohorts,
          onChange: d("cohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: g,
          collapsible: !0,
          defaultState: !0,
          viewMode: u
        }
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: "Characterization settings",
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "useAgeGroups",
              textLabel: "Age Group",
              description: "Calculate age groups covariates prevalence statistics with 5 year interval.",
              labelSize: 3,
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "useAgeGroups",
                  name: "useAgeGroups",
                  onChange: () => {
                    p("useAgeGroups", !i.useAgeGroups);
                  },
                  checked: i.useAgeGroups,
                  disabled: u,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "useEthnicity",
              textLabel: "Ethnic Groups",
              description: "Calculate ethnicity covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "useEthnicity",
                  name: "useEthnicity",
                  onChange: () => {
                    p("useEthnicity", !i.useEthnicity);
                  },
                  checked: i.useEthnicity,
                  disabled: u,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "useGender",
              textLabel: "Gender",
              description: "Calculate gender covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "useGender",
                  name: "useGender",
                  onChange: () => {
                    p("useGender", !i.useGender);
                  },
                  checked: i.useGender,
                  disabled: u,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "useRace",
              textLabel: "Race",
              description: "Calculate race covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "useRace",
                  name: "useRace",
                  onChange: () => {
                    p("useRace", !i.useRace);
                  },
                  checked: i.useRace,
                  disabled: u,
                  size: "small"
                }
              )
            }
          ) })
        ] })
      }
    ) })
  ] });
}), Av = [
  {
    name: "Target cohort",
    value: "cohorts"
  }
], Vx = (n) => [
  {
    value: "summary",
    title: "Summary",
    onTabClick: n
  },
  {
    value: "byPerson",
    title: "By person",
    onTabClick: n
  },
  {
    value: "byEvent",
    title: "By event",
    onTabClick: n
  },
  {
    title: "Demographics",
    value: "demographics",
    onTabClick: n
  }
];
Fe.div`
  width: 100%;
  height: 15px;
  background-color: #7bb209;
`;
Fe.div`
  width: ${(n) => n.width};
  background-color: ${(n) => n.color};
  height: 15px !important;
  text-align: center;
  margin: 0 auto;
`;
const Ux = Fe.div`
  text-align: center;
  font-size: 16px;
  padding: 16px 0;
  color: ${({ theme: n }) => {
  var o;
  return (o = n.palette) == null ? void 0 : o.grey[400];
}};
  width: 100%;
`, Gx = Fe.table`
  border-collapse: collapse;
  width: 100%;
  border: 1px solid ${({ theme: n }) => n.palette.borderColor.main};
  font-size: 12px;
  tr:nth-of-type(2) td {
    border-top-color: ${({ theme: n }) => n.palette.borderColor.main + 80};
  }
  tr.active {
    background-color: ${({ theme: n }) => n.palette.info.main + "10"};
  }
  font-size: 12px;
  h1 {
    display: none;
  }

  section,
  ul {
    margin: 8px 0;
  }
`, a3 = Fe("th", {
  shouldForwardProp: (n) => n !== "align"
})(({ align: n, theme: o }) => ({
  border: "1px solid" + o.palette.borderColor.main + 80,
  backgroundColor: o.palette.backgroundColor.dark,
  textAlign: n || "left",
  padding: "4px 8px",
  fontSize: 13
})), A3 = Fe("td", {
  shouldForwardProp: (n) => n !== "align" && n !== "noData" && n !== "fontSize" && n !== "color" && n !== "percent"
})(({ align: n, theme: o, noData: a, fontSize: i, bold: l, percent: c, color: p }) => {
  var g;
  return {
    border: "1px solid" + o.palette.borderColor.main + 80,
    textAlign: n || "left",
    fontSize: i || 12,
    padding: "4px 8px",
    fontWeight: l ? "bold" : 400,
    position: "relative",
    span: {
      display: "none"
    },
    "::before": {
      content: '""',
      width: c,
      height: "100%",
      backgroundColor: p,
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0.9
    },
    "::after": {
      content: c ? `"${c}"` : '""',
      display: "inline",
      position: "relative"
      // left: '-50%',
    },
    ...a ? {
      "&::after": {
        content: '"N/A"',
        display: "inline",
        color: (g = o.palette) == null ? void 0 : g.grey[400],
        position: "relative"
      }
    } : {}
  };
}), _v = (n) => {
  var a, i;
  let o = ((a = n == null ? void 0 : n.cohorts) == null ? void 0 : a.length) == 1 ? "Cohort" : "Cohorts";
  return `${oe(((i = n == null ? void 0 : n.cohorts) == null ? void 0 : i.length) || 0)} ${o}`;
}, Kx = jo().domain([0.1, 0.25, 0.5, 0.75]).range(["#FF3D19", "#E77F13", "#C9C40D", "#95B90A", "#7BB209"]), Pv = (n, o) => ({
  title: o.title,
  description: o.description,
  type: n.type,
  cohorts: o.cohorts,
  characterizedExpression: o.characterizedExpression
}), Ov = () => ({
  cohorts: []
});
function Yx(n) {
  return Object.keys(n).reduce((o, a) => (["ethnicity", "gender", "race", "ageGroup"].includes(a) && (o[a] = Object.values(
    n[a].reduce((i, l) => (i[l.covariateId] || (i[l.covariateId] = {
      name: l.name,
      conceptId: l.conceptId,
      covariateId: l.covariateId,
      records: []
    }), i[l.covariateId].records.push(l), i), {})
  )), o), {});
}
function qx(n, o) {
  let a = n.cloneNode(!0);
  return a.querySelectorAll(o).forEach((i) => i.remove()), a;
}
function T9(n, o) {
  var a;
  return n.style && (n.style.fontSize = o + "px", n.style.fontWeight = "300"), (a = n.childNodes) != null && a.length && n.childNodes.forEach((i) => T9(i, o)), n;
}
function Xx(n, o) {
  if (o.preventDefault(), n) {
    let a = T9(qx(n, ".no-copy"), 12);
    const i = new Blob([a.outerHTML], { type: "text/html" }), l = new ClipboardItem({ "text/html": i });
    navigator.clipboard.write([l]).then(
      function() {
        console.log("Async: Copying to clipboard was successful!");
      },
      function(c) {
        console.error("Async: Could not copy text: ", c);
      }
    );
  }
}
const Zx = ({
  subModules: n,
  cohort: o
}) => {
  const a = $1(null), [i, l] = pe(!1), c = $1(0), p = $1(i);
  m1(() => {
    if (i && !p.current) {
      const u = Dr("dialog") + 1;
      c.current = u, ep("dialog", u);
    }
    p.current = i;
  }, [i]), m1(() => tp((d) => {
    i && Dr("dialog", d.state) < c.current && l(!1);
  }), [i]);
  const g = w1(() => {
    i && (l(!1), p.current = !1, Dr("dialog") >= c.current && np());
  }, [i]);
  return je(
    () => /* @__PURE__ */ e.jsx(
      n.cohort,
      {
        type: "component",
        name: "cohort-view-mode",
        subModules: n,
        config: {
          initialData: o
        }
      }
    ),
    [o]
  ), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        sx: {
          lineHeight: "1.4em",
          maxHeight: "19.6em",
          overflow: "hidden",
          position: "relative",
          "*": {
            margin: 0
          }
        },
        children: /* @__PURE__ */ e.jsx(X7, { children: o.printFriendlyExpression })
      }
    ),
    /* @__PURE__ */ e.jsx(
      X,
      {
        sx: {
          "::before ": {
            content: '""',
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0,
            background: "linear-gradient(transparent 0, white 96%)"
          }
        }
      }
    ),
    /* @__PURE__ */ e.jsx(X, { textAlign: "right", sx: { position: "absolute", right: 0, bottom: 0 }, children: /* @__PURE__ */ e.jsx(
      Ye,
      {
        size: "small",
        onClick: () => l(!0),
        className: "no-copy",
        sx: {
          fontSize: 12,
          color: "textColor.secondary"
        },
        children: "Show more..."
      }
    ) }),
    /* @__PURE__ */ e.jsxs(md, { open: i, onClose: g, fullWidth: !0, maxWidth: "lg", children: [
      /* @__PURE__ */ e.jsxs(y, { container: !0, justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(hd, { children: /* @__PURE__ */ e.jsx(ce, { variant: "h1", children: o.name }) }),
        /* @__PURE__ */ e.jsx(Vt, { size: "small", sx: { mx: 2 }, onClick: g, children: /* @__PURE__ */ e.jsx(t1, { iconName: "close" }) })
      ] }),
      /* @__PURE__ */ e.jsx(M1, {}),
      /* @__PURE__ */ e.jsx(fd, { sx: { h1: { display: "none" } }, children: /* @__PURE__ */ e.jsx(ce, { ref: a, children: /* @__PURE__ */ e.jsx(X7, { children: o.printFriendlyExpression }) }) })
    ] })
  ] });
}, Jx = ({ cohorts: n, resultsCount: o, subModules: a }) => {
  const [i, l] = pe(-1), c = $1(null), p = (g) => ({
    className: g === i ? "active" : "",
    onMouseOver: () => {
      l(g);
    },
    onMouseLeave: () => {
      l(-1);
    }
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(X, { textAlign: "right", mb: 0.5, children: /* @__PURE__ */ e.jsx(
      Ye,
      {
        onClick: (g) => Xx(c == null ? void 0 : c.current, g),
        startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "copy", fontSize: "small" }),
        children: "Copy table"
      }
    ) }),
    /* @__PURE__ */ e.jsxs(Gx, { ref: c, children: [
      /* @__PURE__ */ e.jsxs("colgroup", { children: [
        /* @__PURE__ */ e.jsx("col", { width: "20%" }),
        /* @__PURE__ */ e.jsx("col", { width: "40%" }),
        /* @__PURE__ */ e.jsx("col", { width: "12%" }),
        /* @__PURE__ */ e.jsx("col", { width: "7%" }),
        /* @__PURE__ */ e.jsx("col", { width: "7%" }),
        /* @__PURE__ */ e.jsx("col", { width: "7%" }),
        /* @__PURE__ */ e.jsx("col", { width: "7%" })
      ] }),
      /* @__PURE__ */ e.jsxs("thead", { children: [
        /* @__PURE__ */ e.jsxs("tr", { children: [
          /* @__PURE__ */ e.jsx(a3, { rowSpan: 2, children: "Cohort name" }),
          /* @__PURE__ */ e.jsx(a3, { rowSpan: 2, children: "Cohort definition" }),
          /* @__PURE__ */ e.jsx(a3, { rowSpan: 2, children: "Attrition Criteria" }),
          /* @__PURE__ */ e.jsx(a3, { rowSpan: 1, colSpan: 4, align: "center", children: "Counts / %" })
        ] }),
        /* @__PURE__ */ e.jsxs("tr", { children: [
          /* @__PURE__ */ e.jsx(a3, { children: "N" }),
          /* @__PURE__ */ e.jsx(a3, { children: "% satisfied" }),
          /* @__PURE__ */ e.jsx(a3, { children: "% to-gain" }),
          /* @__PURE__ */ e.jsx(a3, { children: "Total Count" })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("tbody", { children: n.map((g, u) => {
        var C;
        const d = (C = o.inclusionRuleReports[g.id]) == null ? void 0 : C.find((v) => v.type === "byPerson"), f = d == null ? void 0 : d.inclusionRuleStats, b = f == null ? void 0 : f.length;
        return (f || [{}]).map((v, A) => {
          var T;
          const P = o.cohortCounts.find(
            (I) => I.cohortId === g.id
          );
          return /* @__PURE__ */ e.jsxs("tr", { ...p(u), children: [
            A === 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(A3, { rowSpan: b || 1, fontSize: 13, bold: !0, children: g.name }),
              /* @__PURE__ */ e.jsx(A3, { rowSpan: b, children: /* @__PURE__ */ e.jsx(
                Zx,
                {
                  subModules: a,
                  cohort: g
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsx(A3, { noData: !b, children: v.name }),
            /* @__PURE__ */ e.jsx(A3, { noData: !b, children: oe(v.countSatisfying) }),
            /* @__PURE__ */ e.jsx(
              A3,
              {
                noData: !b,
                percent: v.percentSatisfying,
                color: Kx(
                  parseFloat(
                    ((T = v.percentSatisfying) == null ? void 0 : T.replace("%", "")) || 0
                  ) / 100
                ),
                children: /* @__PURE__ */ e.jsx("span", { children: v.percentSatisfying })
              }
            ),
            /* @__PURE__ */ e.jsx(A3, { noData: !b, children: v.percentExcluded }),
            A === 0 && /* @__PURE__ */ e.jsx(A3, { rowSpan: b, children: P.personCount ? oe(P.personCount) : 0 })
          ] }, A);
        });
      }) })
    ] })
  ] });
}, Iv = ze(
  (n) => {
    const { data: o, analysisInfo: a, subModules: i } = n, [l, c] = pe("summary"), [p, g] = pe(o.cohorts || []), u = je(
      () => Yx(o),
      [o]
    );
    return /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, px: 2, pt: 2, pb: 1, children: /* @__PURE__ */ e.jsx(
        H1,
        {
          name: "covariate",
          value: p,
          options: o.cohorts,
          multiple: !0,
          onChange: function(d, f) {
            g(f);
          },
          getOptionLabel: function(d) {
            return d.name;
          },
          isOptionEqualToValue: (d, f) => d.id === f.id,
          fullWidth: !0
        }
      ) }),
      /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
        /* @__PURE__ */ e.jsx(f5, { tabs: Vx(c), active: l }),
        /* @__PURE__ */ e.jsx(M1, {})
      ] }),
      p.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        l === "summary" && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(
          Jx,
          {
            cohorts: p,
            resultsCount: o,
            subModules: i
          }
        ) }),
        (l === "byPerson" || l === "byEvent") && /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, p: 2, children: p.map((d, f) => {
          var I, w;
          const b = (I = o == null ? void 0 : o.inclusionRuleReports) == null ? void 0 : I[d.id], C = !o5(b) || !o.inclusionRuleReports || !(Object.keys(
            o.inclusionRuleReports[d.id] || {}
          ).length > 0), v = b, A = (w = o.cohortCounts) == null ? void 0 : w.find(
            (N) => N.cohortId === d.id
          ), P = l === "byEvent" ? (A == null ? void 0 : A.recordCount) ?? (A == null ? void 0 : A.personCount) : (A == null ? void 0 : A.personCount) ?? (A == null ? void 0 : A.recordCount), T = P != null ? `${oe(P)} ${l === "byEvent" ? "Records" : "Persons"}` : "N/A";
          return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ne,
            {
              collapsible: !0,
              outlined: !0,
              title: d.name,
              defaultState: f === 0,
              size: "dense",
              children: /* @__PURE__ */ e.jsx(
                w9,
                {
                  legacy: C,
                  resultsCount: v,
                  activeTab: l,
                  analysisInfo: a,
                  count: T
                }
              )
            }
          ) });
        }) }),
        l === "demographics" && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          S9,
          {
            analysis: a,
            result: u,
            cohorts: p
          }
        ) })
      ] }) : /* @__PURE__ */ e.jsx(Ux, { children: "Select a cohort" })
    ] });
  }
), Rv = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
];
function E9(n, o, a) {
  return (i) => {
    var l;
    return `${n}__${o}__${((l = a.split("=")) == null ? void 0 : l[1]) || a}__${i}`;
  };
}
function Qx(n) {
  const o = n.toString(), a = o.indexOf(".");
  return a === -1 ? 0 : o.length - a - 1;
}
function eg(n, o, a = 6) {
  if (!o)
    return {
      domain: [0, 1],
      ticks: [0, 0.25, 0.5, 0.75, 1],
      step: 0.25,
      decimalPlaces: 2
    };
  const i = n.flatMap((T) => Object.entries(T).filter(([w]) => w.includes("__area")).map(([w, N]) => N).flat()), l = Math.min(...i), c = Math.max(...i), g = (c - l) / (a - 1), u = [
    1e-5,
    2e-5,
    5e-5,
    1e-4,
    2e-4,
    5e-4,
    1e-3,
    2e-3,
    5e-3,
    0.01,
    0.02,
    0.025,
    0.05,
    0.1,
    0.15,
    0.2,
    0.25
  ];
  let d = g;
  for (const T of u)
    if (T >= g) {
      d = T;
      break;
    }
  g > u[u.length - 1] && (d = u[u.length - 1]);
  const f = Qx(d), b = Math.pow(10, f), C = Math.floor(l * b / d) * d / b, v = [];
  let A = C;
  for (; A <= c + d; ) {
    const T = A * b / b;
    T <= 1 && v.push(T), A += d;
  }
  v[v.length - 1] !== 1 && c > 0.99 && v.push(1);
  const P = [...new Set(v)].sort((T, I) => T - I);
  return P.length < 3 ? {
    domain: [0, 1],
    ticks: [0, 0.25, 0.5, 0.75, 1],
    step: 0.25
  } : {
    domain: [Math.max(0, C - d * 0.5), 1],
    // Add small padding below
    ticks: P,
    step: d,
    decimalPlaces: f
  };
}
function tg(n, o, a) {
  const i = /* @__PURE__ */ new Set();
  let l = {};
  const c = /* @__PURE__ */ new Set(), p = n.reduce((g, u) => {
    var f, b;
    const d = ((f = a.survivalData[u.id]) == null ? void 0 : f[o.id]) || {};
    return (b = d.overall || []) == null || b.forEach((C) => {
      c.add(C.time), l[u.id] = l[u.id] || {}, l[u.id][C.time] = C.nrisk, l[u.id].targetCohort = u;
    }), Object.entries(d).forEach(([C, v]) => {
      i.add(C), v.forEach((A) => {
        g[A.time] = g[A.time] || {}, g[A.time] = Object.keys(A).reduce((P, T) => {
          if (T !== "time") {
            const I = E9(u.id, o.id, C);
            T === "lower" || T === "upper" ? P[I("area")] = P[I("area")] ? [...P[I("area")], A[T]] : [A[T]] : P[I(T)] = A[T];
          }
          return P.time = A.time, P;
        }, g[A.time]);
      });
    }, {}), g;
  }, {});
  return {
    data: Object.values(p),
    stratas: Array.from(i),
    nRisk: Object.values(l),
    timeScale: Array.from(c).sort((g, u) => g - u)
  };
}
const S4 = [
  "#FF0000",
  "#00A08A",
  "#F2AD00",
  "#F98400",
  "#5BBCD6",
  "#ECCBAE",
  "#046C9A",
  "#D69C4E",
  "#ABDDDE",
  "#000000"
], p3 = (n, o) => o ? "lightgrey" : n >= S4.length ? d5(`0.${n / (1 * S4.length)}`, S4[n % S4.length]) : S4[n];
function ng(n) {
  const o = Math.min(...n), a = Math.max(...n);
  return rg(o, a);
}
function rg(n, o, a = 10) {
  const i = o - n;
  if (i === 0)
    return [n];
  let l;
  i <= 12 ? l = 1 : i <= 21 ? l = 2 : i <= 35 ? l = 3 : i <= 56 ? l = 5 : i <= 80 ? l = 7 : i <= 105 ? l = 10 : i <= 180 ? l = 15 : i <= 315 ? l = 30 : i <= 480 ? l = 45 : i <= 630 ? l = 60 : i <= 960 ? l = 90 : i <= 1260 ? l = 120 : i <= 2e3 ? l = 180 : i <= 2700 ? l = 250 : i <= 3285 || i <= 3850 ? l = 300 : i <= 5840 ? l = 550 : i <= 8e3 ? l = 730 : i <= 10950 ? l = 1e3 : i <= 16e3 ? l = 1500 : (i <= 21e3, l = 3e3);
  const c = [];
  let p = Math.floor(n / l) * l;
  for (p < n - l * 0.5 && (p = n); p <= o; )
    p >= n && c.push(p), p += l;
  c[0] !== n && Math.abs(c[0] - n) > l * 0.1 && c.unshift(n), c[c.length - 1] !== o && Math.abs(c[c.length - 1] - o) > l * 0.1 && c.push(o);
  const g = [...new Set(c)].sort((u, d) => u - d);
  if (g.length > a * 1.5) {
    const u = Math.ceil(g.length / a);
    return g.filter(
      (f, b) => b % u === 0 || b === g.length - 1
    );
  }
  return g;
}
const B8 = [
  {
    name: "cohort start date",
    value: "cohort_start_date"
  },
  {
    name: "cohort end date",
    value: "cohort_end_date"
  }
], $8 = [
  "Infinity",
  1,
  2,
  3,
  4,
  5,
  10,
  15,
  20,
  30,
  50,
  60,
  90,
  180
].map((n) => ({
  name: String(n),
  value: n === "Infinity" ? null : n
})), og = [
  {
    header: "Target Cohort",
    accessorKey: "targetCohort.name",
    size: 250
  },
  {
    header: "Number records",
    accessorKey: "n",
    size: 200,
    cell: ({ getValue: n }) => n() != null ? oe(n()) : "-"
  },
  {
    header: "Number events",
    accessorKey: "events",
    size: 200,
    cell: ({ getValue: n }) => n() != null ? oe(n()) : "-"
  },
  {
    header: "Median survival (95% CI)",
    accessorKey: "medianSurvival",
    size: 200,
    cell: ({ getValue: n, row: o }) => n() != null ? `${oe(n())} [${o.original.medianSurvivalLowerCI || "-"}, ${o.original.medianSurvivalUpperCI || "-"}]` : "-"
  },
  {
    header: "Restricted mean survival (SE)",
    accessorKey: "meanSurvival",
    size: 200,
    cell: ({ getValue: n }) => n() != null ? oe(n()) : "-"
  }
], Un = [
  { name: "Gender", value: "gender" },
  { name: "Age group", value: "age_group" }
];
function ag(n) {
  var a;
  const o = {};
  return n.forEach((i) => {
    const [l, c] = i.split("=");
    o[l] ? o[l].push(c) : o[l] = [c];
  }), (a = o.age_group) == null || a.sort((i, l) => i.localeCompare(l)), o;
}
function ig(n) {
  let o = JSON.parse(JSON.stringify(n));
  return n.eventCohorts.forEach((a) => {
    n.targetCohorts.forEach((i) => {
      var l, c;
      (c = (l = n.survivalData) == null ? void 0 : l[i.id]) != null && c[a.id] && (o.survivalData[i.id][a.id] = Object.entries(
        n.survivalData[i.id][a.id]
      ).reduce((p, [g, u]) => {
        p[g] = [u[0]];
        let d = u[0], f = null, b = 1;
        for (; b < u.length; )
          f = u[b], f.time - d.time === 1 ? b++ : f.time - d.time > 1 && (f = { ...d, time: d.time + 1 }), p[g].push(f), d = f;
        return p;
      }, {}));
    });
  }), o;
}
const Nv = ze((n) => {
  var v, A, P, T, I;
  const {
    subModules: o,
    parentId: a,
    design: i,
    id: l,
    typeContainer: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n, d = (w) => (N) => {
    p(w, N);
  }, [f, b] = pe(
    () => {
      var w;
      return ((w = i.ageBreaks) == null ? void 0 : w.map((N) => ({
        ...N,
        id: N.id ? N.id : Kt()
      }))) || [];
    }
  ), C = (v = i.strata) == null ? void 0 : v.some(
    (w) => w === "age_group" || (w == null ? void 0 : w.value) === "age_group"
  );
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
    (!u || u && ((A = i == null ? void 0 : i.targetCohorts) == null ? void 0 : A.length) > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(W4, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("b", { children: "Time to Event analysis" }),
        " - leverages standardized clinical data to perform time-to-event calculations, providing robust estimates of survival probabilities. It generates visually compelling Kaplan–Meier curves, delivers clear milestone summaries, and enables insightful subgroup comparisons—all while accurately accounting for censoring to ensure reliable results."
      ] }) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        o.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: o,
          path: L1(c, l, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ e.jsx(
              N1,
              {
                title: "Target cohorts",
                count: (P = i == null ? void 0 : i.targetCohorts) == null ? void 0 : P.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: i == null ? void 0 : i.targetCohorts,
            onChange: d("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: g,
            collapsible: !0,
            defaultState: !0,
            viewMode: u
          }
        }
      ) })
    ] }),
    (!u || u && ((T = i == null ? void 0 : i.eventCohorts) == null ? void 0 : T.length) > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      o.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: o,
        path: L1(c, l, a),
        config: {
          buttonText: "Import outcome cohort",
          titleText: /* @__PURE__ */ e.jsx(
            N1,
            {
              title: "Outcome cohorts",
              count: (I = i == null ? void 0 : i.eventCohorts) == null ? void 0 : I.length
            }
          ),
          classNameContainer: "event-import-button",
          typeContainer: c,
          initialData: i == null ? void 0 : i.eventCohorts,
          onChange: d("eventCohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: g,
          collapsible: !0,
          defaultState: u,
          viewMode: u
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        collapsible: !0,
        title: "Analysis Settings",
        defaultState: u,
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, px: 1, children: [
            /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the analysis." }),
            /* @__PURE__ */ e.jsx(M1, { sx: { borderColor: "borderColor.light" } })
          ] }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "outcomeDateVariable",
              textLabel: "Outcome date variable",
              description: "Variable containing date of outcome event.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 270, children: /* @__PURE__ */ e.jsx(
                H1,
                {
                  className: "",
                  name: "outcomeDateVariable",
                  id: "outcomeDateVariable",
                  options: B8,
                  value: i.outcomeDateVariable,
                  placeholder: "Select days...",
                  onChange: (w, N) => {
                    p(
                      "outcomeDateVariable",
                      N.value
                    );
                  },
                  disabled: u,
                  getOptionLabel: function(w) {
                    var N;
                    return (N = B8.find(
                      (E) => E.value === w || E.value === w.value
                    )) == null ? void 0 : N.name;
                  },
                  isOptionEqualToValue: (w, N) => w.value === N
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "outcomeWashout",
              textLabel: "Outcome washout",
              description: "Washout time in days for the outcome.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  name: "outcomeWashout",
                  disablePortal: !0,
                  id: "outcomeWashout",
                  options: $8,
                  value: i.outcomeWashout || "",
                  placeholder: "Select days...",
                  onChange: (w) => {
                    p("outcomeWashout", w);
                  },
                  disabled: u,
                  dontResetOnEnter: !0
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "censorOnCohortExit",
              textLabel: "Censor on cohort exit",
              description: "If enabled, an individual’s follow up will be censored at their cohort exit.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "censorOnCohortExit",
                  name: "censorOnCohortExit",
                  onChange: () => {
                    p(
                      "censorOnCohortExit",
                      !i.censorOnCohortExit
                    );
                  },
                  checked: i.censorOnCohortExit,
                  disabled: u
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "addDay",
              textLabel: "Same day event 1 day adjustment",
              description: "Adjust outcome event start date for events that happen on the same day as patient cohort entry date.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                S1,
                {
                  id: "addDay",
                  name: "addDay",
                  onChange: () => {
                    p("addDay", !i.addDay);
                  },
                  checked: i.addDay,
                  disabled: u
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "censorOnDate",
              textLabel: "Censor on date",
              description: "If provided, an individual’s follow up will be censored at the given date.",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                O3,
                {
                  id: "censorOnDate",
                  name: "censorOnDate",
                  value: i.censorOnDate,
                  onChange: function(w) {
                    p("censorOnDate", w);
                  }
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "restrictedMeanFollowup",
              textLabel: "Restricted mean follow-up",
              description: "Number of days of follow-up to take into account when calculating restricted (mean for all cohorts).",
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  name: "restrictedMeanFollowup",
                  disablePortal: !0,
                  id: "restrictedMeanFollowup",
                  options: $8,
                  value: i.restrictedMeanFollowup || "",
                  placeholder: "Select days...",
                  onChange: (w) => {
                    p(
                      "restrictedMeanFollowup",
                      Number.isFinite(w) && w > 0 ? w : null
                    );
                  },
                  disabled: u,
                  dontResetOnEnter: !0,
                  disableClearable: !1
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "minDaysToEvent",
              textLabel: "Minimum days to event",
              description: "Minimum number of days person should be in cohort before the event (Exclude person if his time to event is less than this value).",
              children: /* @__PURE__ */ e.jsx(X, { width: 150, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  name: "minDaysToEvent",
                  disablePortal: !0,
                  id: "minDaysToEvent",
                  options: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    10,
                    15,
                    20,
                    30,
                    50,
                    60,
                    90,
                    180
                  ].map((w) => ({
                    name: String(w),
                    value: w
                  })),
                  value: i.minDaysToEvent,
                  placeholder: "Select days...",
                  onChange: (w) => {
                    p("minDaysToEvent", w);
                  },
                  disabled: u,
                  dontResetOnEnter: !0,
                  disableClearable: !1
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: "strata",
              textLabel: "Stratification criteria",
              children: /* @__PURE__ */ e.jsx(X, { width: 270, children: /* @__PURE__ */ e.jsx(
                H1,
                {
                  name: "strata",
                  multiple: !0,
                  id: "strata",
                  options: Un,
                  value: i.strata,
                  placeholder: "Select...",
                  onChange: (w, N) => {
                    p(
                      "strata",
                      N.map(
                        (E) => typeof E == "object" ? E.value : E
                      )
                    );
                  },
                  disabled: u,
                  disableClearable: !1,
                  getOptionLabel: function(w) {
                    var N;
                    return ((N = Un == null ? void 0 : Un.find((E) => E.value === w)) == null ? void 0 : N.name) ?? (w == null ? void 0 : w.name) ?? w;
                  },
                  isOptionEqualToValue: (w, N) => w.value === N || w.value === (N == null ? void 0 : N.value)
                }
              ) })
            }
          ) }),
          C && /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
            /* @__PURE__ */ e.jsx(M1, { sx: { mb: 1 } }),
            /* @__PURE__ */ e.jsxs(X, { fontSize: 12, children: [
              /* @__PURE__ */ e.jsx(
                Ve,
                {
                  htmlFor: "ageBreaks",
                  textLabel: "Age breaks",
                  children: /* @__PURE__ */ e.jsx(X, { textAlign: "right", children: /* @__PURE__ */ e.jsx(
                    xd,
                    {
                      title: "Add Age Break",
                      onClick: () => {
                        b((w) => {
                          const N = w ? [...w, { Op: "gt", id: Kt() }] : [{ Op: "gt", id: Kt() }];
                          return p("ageBreaks", N), N;
                        });
                      },
                      color: "info",
                      iconName: "add",
                      disabled: u,
                      name: "age-break-button",
                      noCollapse: !0
                    }
                  ) })
                }
              ),
              f == null ? void 0 : f.map((w, N) => /* @__PURE__ */ e.jsxs(
                y,
                {
                  container: !0,
                  mb: 1,
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ e.jsx(y, { item: !0, px: 1, children: /* @__PURE__ */ e.jsx(
                      o.cohort,
                      {
                        type: "component",
                        name: "widget-attribute-value",
                        subModules: o,
                        config: {
                          id: N + w.id,
                          value: w,
                          typeContainer: c,
                          startText: "with age in years",
                          onChange: (E, x) => {
                            b((m) => {
                              const j = [...m];
                              return j[N] = {
                                id: w.id,
                                ...x
                              }, p("ageBreaks", j), j;
                            });
                          },
                          values: w,
                          viewMode: u
                        }
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(y, { item: !0, px: 1, children: /* @__PURE__ */ e.jsx(
                      uo,
                      {
                        iconName: "delete",
                        title: "Delete",
                        noExpand: !0,
                        onClick: () => {
                          b((E) => {
                            const x = E.filter(
                              (m, j) => j !== N
                            );
                            return p("ageBreaks", x), x;
                          });
                        },
                        size: "small",
                        color: "error"
                      }
                    ) })
                  ]
                },
                w.id
              ))
            ] })
          ] })
        ] })
      }
    ) })
  ] });
}), A9 = ({
  data: n,
  targetCohorts: o,
  eventCohort: a,
  stratas: i,
  autoScale: l,
  height: c = 400,
  ticks: p,
  summaries: g = {},
  formatTicks: u,
  showStrata: d = !1,
  dataConfig: f = {}
}) => {
  const b = Yt(o, "id"), C = je(
    () => eg(n, l),
    [l, n]
  ), v = n.length === 0, A = Yt(
    g,
    (P) => `${P.targetCohortId}-${P.outcomeCohortId}`
  );
  return /* @__PURE__ */ e.jsx(y, { container: !0, sx: { position: "relative", height: c, zIndex: 2 }, children: /* @__PURE__ */ e.jsx(R3, { height: c, children: /* @__PURE__ */ e.jsxs(
    Xd,
    {
      style: {
        fontSize: "12px"
      },
      data: n,
      margin: {
        top: 20,
        right: 0,
        bottom: 20,
        left: 10
      },
      children: [
        /* @__PURE__ */ e.jsx(U4, { stroke: "#e3e3e3ff", strokeDasharray: "3 3" }),
        /* @__PURE__ */ e.jsx(
          G4,
          {
            dataKey: "time",
            name: "months",
            type: "number",
            domain: [0, Math.max(...n.map((P) => P.time))],
            ticks: p,
            allowDataOverflow: !1,
            ...p ? { ticks: p } : { tickCount: 10 },
            tickFormatter: u,
            label: {
              value: "Time",
              position: "insideBottom",
              offset: -10
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          K4,
          {
            name: "probability",
            type: "number",
            domain: C.domain,
            ticks: C.ticks,
            tickFormatter: (P) => P.toFixed(
              C.decimalPlaces ? C.decimalPlaces > 4 ? 4 : C.decimalPlaces : 2
            ),
            label: {
              value: "Probability",
              angle: -90,
              position: "insideLeft",
              offset: -5
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          r8,
          {
            y: 0.5,
            label: {
              value: 0.5,
              position: "insideBottomLeft"
            },
            strokeDasharray: "3 3",
            stroke: "#000000"
          }
        ),
        o.map((P, T) => i.map((I, w) => {
          var _, z, Y;
          const N = ((z = (_ = f == null ? void 0 : f[P.id]) == null ? void 0 : _[I]) == null ? void 0 : z.color) ?? p3(T + w * (i.length + w), v), E = E9(
            P.id,
            a.id,
            I
          ), x = E("area"), m = E("survival"), j = (Y = A[`${P.id}-${a.id}`]) == null ? void 0 : Y.medianSurvival;
          return [
            /* @__PURE__ */ e.jsx(
              Zd,
              {
                dataKey: x,
                strokeWidth: 0,
                fillOpacity: 0.2,
                type: "stepAfter",
                fill: N,
                stroke: N,
                connectNulls: !0,
                dot: !1
              },
              x
            ),
            /* @__PURE__ */ e.jsx(
              Jd,
              {
                dataKey: m,
                type: "stepAfter",
                dot: !1,
                name: P.name,
                connectNulls: !0,
                stroke: N,
                fill: N
              },
              m
            ),
            j != null ? /* @__PURE__ */ e.jsx(
              r8,
              {
                x: j,
                label: {
                  value: j,
                  position: "insideBottomLeft"
                },
                strokeDasharray: "3 3",
                stroke: N
              },
              x + m
            ) : ""
          ];
        })),
        /* @__PURE__ */ e.jsx(
          h3,
          {
            content: ({ payload: P }) => {
              var I;
              let T = [];
              return P.forEach((w, N) => {
                var E, x, m;
                if (N % 2 !== 0) {
                  const j = w == null ? void 0 : w.dataKey, [_, z, Y, W] = (j == null ? void 0 : j.split("__")) || [], D = (w == null ? void 0 : w.color) || (w == null ? void 0 : w.fill), F = `${_}__${z}__${Y}__`, M = w == null ? void 0 : w.payload[F + "area"];
                  _ && T.push(
                    /* @__PURE__ */ e.jsxs(
                      X,
                      {
                        color: D,
                        p: 1,
                        bgcolor: "white",
                        boxShadow: 1,
                        children: [
                          /* @__PURE__ */ e.jsx("b", { children: "Target cohort" }),
                          " : ",
                          (E = b[_]) == null ? void 0 : E.name,
                          /* @__PURE__ */ e.jsx("br", {}),
                          /* @__PURE__ */ e.jsx("b", { children: "Probability" }),
                          " : ",
                          (m = (x = w == null ? void 0 : w.payload) == null ? void 0 : x[j]) == null ? void 0 : m.toFixed(4),
                          " ",
                          "[",
                          M == null ? void 0 : M.map((K) => (K == null ? void 0 : K.toFixed(4)) || "N/A").join(", "),
                          "]",
                          d && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                            /* @__PURE__ */ e.jsx("br", {}),
                            /* @__PURE__ */ e.jsx("b", { children: "Strata" }),
                            " : ",
                            Y
                          ] }),
                          /* @__PURE__ */ e.jsx("br", {})
                        ]
                      },
                      F
                    )
                  );
                }
              }), /* @__PURE__ */ e.jsxs(X, { children: [
                /* @__PURE__ */ e.jsxs(X, { p: 1, bgcolor: "white", boxShadow: 1, children: [
                  /* @__PURE__ */ e.jsx("b", { children: "Time" }),
                  " : ",
                  (I = P[0]) == null ? void 0 : I.payload.time
                ] }, "time"),
                T
              ] });
            }
          }
        )
      ]
    }
  ) }) });
}, _9 = ({
  items: n,
  isEmpty: o
}) => /* @__PURE__ */ e.jsx(X, { pt: 1, textAlign: "left", children: n.map((a, i) => {
  const l = a.color || p3(i, o);
  return /* @__PURE__ */ e.jsx(
    X,
    {
      title: a.name || "",
      sx: {
        fontSize: 13,
        color: "#474850",
        mb: 0.5,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        "::before": {
          content: '""',
          height: "8px",
          width: "8px",
          backgroundColor: l,
          borderRadius: "50%",
          display: "inline-block",
          mr: 0.5
        }
      },
      children: a.name ? "— " + a.name : ""
    },
    `item-${i}`
  );
}) }), sg = ({
  setTimesUnit: n,
  timesUnit: o,
  targetCohorts: a,
  isEmpty: i
}) => /* @__PURE__ */ e.jsxs(X, { children: [
  /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, textAlign: "right", mt: 1, children: /* @__PURE__ */ e.jsxs($4, { children: [
    /* @__PURE__ */ e.jsx(
      Ye,
      {
        variant: o === "days" ? "contained" : "outlined",
        onClick: () => n("days"),
        color: "info",
        children: "days"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ye,
      {
        variant: o === "months" ? "contained" : "outlined",
        onClick: () => n("months"),
        color: "info",
        children: "months"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ye,
      {
        variant: o === "years" ? "contained" : "outlined",
        onClick: () => n("years"),
        color: "info",
        children: "years"
      }
    )
  ] }) }),
  !i && /* @__PURE__ */ e.jsx(_9, { items: a })
] }), lg = ({ data: n, targetCohorts: o = [], selectedCohorts: a }) => {
  const i = mo(n, "targetCohortId"), l = je(() => o.reduce((c, p) => (c[p.id] = p, c), {}), [o]);
  return /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: Object.keys(i).map(
    (c) => a.find((p) => p.id == c) ? /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, sm: 6, md: 4, xl: 3, children: [
      /* @__PURE__ */ e.jsx(
        ce,
        {
          variant: "subtitle2",
          component: "span",
          sx: { color: "#0d1b40", fontWeight: 600 },
          children: l[c].name
        }
      ),
      /* @__PURE__ */ e.jsx(k4, { outlined: !0, children: /* @__PURE__ */ e.jsx(
        y1,
        {
          columns: [
            {
              header: "Comparison",
              accessorFn: (p) => p.stratum1 === "all" ? "Overall" : p.stratum1 + " vs " + p.stratum2,
              size: 180
            },
            {
              header: "Chi-square",
              accessorKey: "chisq",
              cell: ({ getValue: p }) => p().toFixed(4),
              size: 100
            },
            {
              header: "P-value",
              accessorKey: "pvalue",
              cell: ({ getValue: p }) => p().toFixed(4),
              size: 100
            }
          ],
          data: i[c],
          hideSettings: !0,
          hidePagination: !0
        }
      ) })
    ] }, c) : ""
  ) });
}, cg = {
  overall: "Total",
  age_group: "Age Groups",
  gender: "Gender"
}, ug = ({
  stratas: n,
  data: o,
  targetCohorts: a,
  title: i,
  eventCohort: l,
  autoScale: c = !1,
  ticks: p,
  summaries: g,
  formatTicks: u,
  pValueData: d
}) => {
  var P;
  const [f, b] = qr.useState(
    a.slice(0, 1)
  ), [C, v] = qr.useState(n), A = je(
    () => a == null ? void 0 : a.reduce((T, I, w) => (T[I.id] = n.reduce((N, E, x) => {
      var _;
      const m = ((_ = E.split("=")) == null ? void 0 : _[1]) || E, j = p3(w + x * (n.length + x), !1);
      return N[m] = { name: m, color: j, cohortName: I.name }, N;
    }, {}), T), {}),
    [a, n]
  );
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ e.jsxs(
    Ne,
    {
      title: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        cg[i] || i,
        " ",
        /* @__PURE__ */ e.jsxs(ce, { fontWeight: 400, component: "span", fontSize: "small", children: [
          ": ",
          C.join(", ")
        ] })
      ] }),
      size: "dense",
      outlined: !0,
      children: [
        /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 1, spacing: 2, children: [
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, sm: 7, md: 8, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
              H1,
              {
                multiple: !0,
                fullWidth: !0,
                value: f || [],
                onChange: (T, I) => b(I),
                options: a,
                placeholder: "Select cohort...",
                getOptionLabel: function(T) {
                  var I;
                  return T.name || ((I = a.find((w) => w.id === T)) == null ? void 0 : I.name);
                },
                isOptionEqualToValue: (T, I) => T.id === I.id || T.id === I
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, sm: 5, md: 4, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Strata:" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
              H1,
              {
                multiple: !0,
                fullWidth: !0,
                value: C || [],
                onChange: (T, I) => v(I),
                options: n,
                placeholder: "Select stratas...",
                getOptionLabel: function(T) {
                  return T;
                },
                isOptionEqualToValue: (T, I) => T === I
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, maxWidth: "calc(100% - 300px)", flexGrow: 1, flexBasis: "75%", children: /* @__PURE__ */ e.jsx(
            A9,
            {
              data: o,
              stratas: C,
              targetCohorts: f,
              eventCohort: l,
              autoScale: c,
              height: 400,
              ticks: p,
              summaries: g,
              formatTicks: u,
              showStrata: !0,
              dataConfig: A
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, minWidth: 300, flexBasis: "25%", children: (P = Object.entries(A)) == null ? void 0 : P.map(([T, I]) => f.find((w) => w.id == T) ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mt: 1, children: Object.values(I)[0].cohortName }, T + "title"),
            /* @__PURE__ */ e.jsx(X, { ml: 1, children: /* @__PURE__ */ e.jsx(
              _9,
              {
                items: Object.values(I).filter(
                  (w) => C.includes(w.name)
                )
              }
            ) }, T + "legend")
          ] }) : "") })
        ] }),
        /* @__PURE__ */ e.jsx(y, { container: !0, mt: 2, children: /* @__PURE__ */ e.jsx(
          lg,
          {
            data: d,
            targetCohorts: a,
            selectedCohorts: f
          }
        ) })
      ]
    }
  ) });
}, dg = ({
  targetCohorts: n,
  eventCohort: o,
  data: a
}) => {
  var T, I;
  const [i, l] = pe(n), [c, p] = qr.useState(!1), [g, u] = pe("days"), d = je(
    () => a.survivalSummaries.filter(
      (w) => w.outcomeCohortId === o.id && i.some((N) => N.id === w.targetCohortId) && w.stratum === "overall"
    ).map((w) => ({
      ...w,
      targetCohort: n.find((N) => N.id === w.targetCohortId)
    })),
    [a, o, i, n]
  ), f = je(() => n.reduce((w, N) => {
    var E, x;
    return w[N.id] || (w[N.id] = (x = (E = a.survivalData[N.id]) == null ? void 0 : E[o.id]) == null ? void 0 : x.overall), w;
  }, {}), [a, n, o]), b = je(() => {
    const w = i.reduce((N, E) => (N.push(...(f == null ? void 0 : f[E.id]) || []), N), []) || [];
    return ng(w.map((N) => N.time));
  }, []), C = je(() => tg(i, o, a), [f, i]), v = je(() => ag(
    C.stratas.filter(
      (w) => typeof w == "string" && w !== "overall"
    )
  ), [C.stratas]), A = w1(
    (w) => w.filter((N) => N.outcomeCohortId === o.id),
    [a, o]
  ), P = w1(
    (w) => {
      switch (g) {
        case "days":
          return w;
        case "months": {
          const N = Math.floor(w / 30);
          return N > 0 ? N : "";
        }
        case "years": {
          const N = Math.floor(w / 360);
          return N > 0 ? N : "0";
        }
      }
    },
    [g]
  );
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      container: !0,
      sx: {
        ".content-block__title": {
          padding: 0
        }
      },
      children: [
        /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
          /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 1, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
              H1,
              {
                multiple: !0,
                fullWidth: !0,
                value: i || [],
                onChange: (w, N) => l(N),
                options: n,
                placeholder: "Select cohort...",
                getOptionLabel: function(w) {
                  var N;
                  return w.name || ((N = n.find((E) => E.id === w)) == null ? void 0 : N.name);
                },
                isOptionEqualToValue: (w, N) => w.id === N.id || w.id === N
              }
            ) })
          ] }),
          C.data.length !== 0 && /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
            /* @__PURE__ */ e.jsx(qn, { title: "Kaplan-Meier curve", children: /* @__PURE__ */ e.jsxs(
              X,
              {
                component: "label",
                sx: {
                  fontSize: 12
                },
                children: [
                  "Auto-adjust Y-axis",
                  /* @__PURE__ */ e.jsx(
                    S1,
                    {
                      checked: c,
                      onChange: (w) => p(w.target.checked),
                      size: "small",
                      sx: { ml: 1 }
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ e.jsx(X, { height: "400px", children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
              /* @__PURE__ */ e.jsx(
                y,
                {
                  item: !0,
                  maxWidth: "calc(100% - 300px)",
                  flexGrow: 1,
                  flexBasis: "75%",
                  children: /* @__PURE__ */ e.jsx(
                    A9,
                    {
                      data: C.data,
                      stratas: ["overall"],
                      targetCohorts: i,
                      eventCohort: o,
                      autoScale: c,
                      ticks: b,
                      summaries: d,
                      formatTicks: P
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(y, { item: !0, minWidth: 300, flexBasis: "25%", children: /* @__PURE__ */ e.jsx(
                sg,
                {
                  targetCohorts: i,
                  setTimesUnit: u,
                  timesUnit: g,
                  isEmpty: ((T = C.data) == null ? void 0 : T.length) === 0
                }
              ) })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
          /* @__PURE__ */ e.jsx(qn, { title: "# at risk" }),
          /* @__PURE__ */ e.jsx(
            y1,
            {
              columns: [
                {
                  header: "Target Cohort / Time",
                  accessorKey: "targetCohort.name",
                  size: 250
                },
                ...b.map((w) => ({
                  header: w.toString(),
                  accessorKey: w.toString(),
                  size: 80,
                  meta: { align: "center", headerAlign: "center" },
                  cell: ({ getValue: N }) => N() != null ? oe(N()) : "-"
                }))
              ],
              data: C.nRisk,
              hasFilters: !0,
              hideSettings: !0
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, children: [
          /* @__PURE__ */ e.jsx(qn, { title: "Estimate summary" }),
          /* @__PURE__ */ e.jsx(
            y1,
            {
              data: d,
              columns: og,
              hideSettings: !0
            }
          )
        ] }),
        ((I = Object.keys(v)) == null ? void 0 : I.length) > 0 && Object.keys(v).map(
          (w) => {
            var N;
            return (N = v[w]) != null && N.length ? /* @__PURE__ */ e.jsx(
              ug,
              {
                stratas: v[w],
                data: C.data,
                targetCohorts: n,
                title: w,
                eventCohort: o,
                autoScale: c,
                ticks: b,
                summaries: d.filter((E) => E.stratum === w),
                formatTicks: P,
                pValueData: A(
                  w === "gender" ? a.logRankGender : a.logRankAgeGroup
                )
              }
            ) : "";
          }
        )
      ]
    }
  );
}, Fv = ze((n) => {
  const { data: o } = n, a = o.targetCohorts, i = o.eventCohorts, l = je(() => ig(o), [o]);
  return i.map((c) => /* @__PURE__ */ e.jsx(X, { mb: 2, children: /* @__PURE__ */ e.jsx(
    Ne,
    {
      elevated: !0,
      outlined: !0,
      collapsible: !0,
      title: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("b", { children: "Outcome: " }),
        c.name
      ] }),
      size: "dense",
      children: /* @__PURE__ */ e.jsx(
        dg,
        {
          targetCohorts: a,
          eventCohort: c,
          data: l
        }
      )
    },
    c.id
  ) }, c.id));
}), j2 = 16, S2 = (n) => ({
  xmlns: "http://www.w3.org/2000/svg",
  width: n,
  height: n,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  focusable: !1,
  "aria-hidden": !0
}), pg = ({ size: n = j2 }) => /* @__PURE__ */ e.jsxs("svg", { ...S2(n), children: [
  /* @__PURE__ */ e.jsx("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
  /* @__PURE__ */ e.jsx("path", { d: "M8 12h8" }),
  /* @__PURE__ */ e.jsx("path", { d: "M12 8v8" })
] }), mg = ({ size: n = j2 }) => /* @__PURE__ */ e.jsxs("svg", { ...S2(n), children: [
  /* @__PURE__ */ e.jsx("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
  /* @__PURE__ */ e.jsx("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
] }), W8 = ({ size: n = j2 }) => /* @__PURE__ */ e.jsxs("svg", { ...S2(n), children: [
  /* @__PURE__ */ e.jsx("path", { d: "M10 11v6" }),
  /* @__PURE__ */ e.jsx("path", { d: "M14 11v6" }),
  /* @__PURE__ */ e.jsx("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }),
  /* @__PURE__ */ e.jsx("path", { d: "M3 6h18" }),
  /* @__PURE__ */ e.jsx("path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
] }), hg = () => r4.get("/cost/cpi/defaults"), fg = (n) => r4.put("/cost/cpi/defaults", n), xg = () => r4.get("/cost/cpi/sources"), gg = [
  [2026, 1.053],
  [2025, 1.047],
  [2024, 1.032],
  [2023, 1.02],
  [2022, 0.98],
  [2021, 1.104],
  [2020, 1.02],
  [2019, 0.991]
], Z3 = () => ({
  id: Kt(),
  year: null,
  coefficient: null
}), yg = () => gg.map(([n, o]) => ({
  id: Kt(),
  year: n,
  coefficient: o
})), E4 = "DEFAULT", vg = {
  value: E4,
  name: "Default (pre-uploaded data)"
}, H8 = (n = []) => (Array.isArray(n) ? n : []).map((o) => ({
  id: Kt(),
  year: (o == null ? void 0 : o.year) ?? null,
  coefficient: (o == null ? void 0 : o.coefficient) ?? null
})), P9 = (n) => {
  if (n == null)
    return null;
  const o = String(n).trim();
  if (o === "")
    return null;
  const a = o.replace(",", "."), i = Number(a);
  return Number.isNaN(i) ? null : i;
}, bg = (n) => {
  const o = P9(n);
  return o === null ? null : Math.trunc(o);
}, O9 = (n) => n.year === null && n.coefficient === null, Cg = (n) => n.year !== null && n.coefficient !== null, jg = (n) => !O9(n) && !Cg(n), Sg = (n) => {
  const o = n.split(/\r?\n/).map((c) => c.trim()).filter((c) => c.length > 0);
  if (o.length === 0)
    return [];
  const i = ((c) => c.includes("	") ? "	" : c.includes(";") ? ";" : ",")(o[0]), l = [];
  return o.forEach((c, p) => {
    const g = c.split(i), u = bg(g[0]), d = P9(g[1]);
    p === 0 && u === null || u === null && d === null || l.push({ id: Kt(), year: u, coefficient: d });
  }), l;
}, wg = (n) => {
  const o = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  n.forEach((p) => {
    jg(p) && o.add(p.id), p.coefficient !== null && Number(p.coefficient) <= 0 && a.add(p.id), p.year !== null && i.set(p.year, (i.get(p.year) || 0) + 1);
  });
  const l = /* @__PURE__ */ new Set();
  i.forEach((p, g) => {
    p > 1 && l.add(g);
  });
  const c = /* @__PURE__ */ new Set();
  return n.forEach((p) => {
    p.year !== null && l.has(p.year) && c.add(p.id);
  }), {
    incompleteRowIds: o,
    duplicateYears: l,
    duplicateRowIds: c,
    nonPositiveRowIds: a,
    hasErrors: o.size > 0 || l.size > 0 || a.size > 0
  };
}, A4 = (n) => [...n].sort((o, a) => o.year === null && a.year === null ? 0 : o.year === null ? 1 : a.year === null ? -1 : a.year - o.year), V8 = (n) => A4(n.filter((o) => !O9(o))), Gn = (n) => n.length ? n : [Z3()], Tg = (n) => {
  const o = n.trim();
  if (o === "") return null;
  const a = parseInt(o, 10);
  return Number.isNaN(a) ? null : a;
}, Eg = (n) => {
  const o = n.trim().replace(",", ".");
  if (o === "") return null;
  const a = Number(o);
  return Number.isNaN(a) ? null : a;
}, Ag = (n) => new Promise((o, a) => {
  const i = new FileReader();
  i.onload = () => o(String(i.result ?? "")), i.onerror = () => a(i.error), i.readAsText(n);
}), _g = /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  "Please confirm overwriting reference Consumer Price Index (CPI) settings table.",
  /* @__PURE__ */ e.jsx("br", {}),
  'All users will see the new values when they import from the "Default (pre-uploaded data)" source. Previously imported data will not be affected.'
] }), Pg = {
  // `&&` doubles the popper class so this wins over the styled() base rule,
  // which targets the same element with a single class.
  "&& .MuiTooltip-tooltip": { backgroundColor: "#5e6b8b" },
  "&& .MuiTooltip-arrow": { color: "#5e6b8b" }
}, Og = /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  "Amounts can be specified as either costs or coefficients.",
  /* @__PURE__ */ e.jsx("br", {}),
  "Formula: price × coefficient[base year] / coefficient[year].",
  /* @__PURE__ */ e.jsx("br", {}),
  "Any missing year is treated as 1 (no adjustment)."
] }), U8 = "1fr 1fr 108px", G8 = 2, K8 = {
  m: 0,
  ".MuiOutlinedInput-root": {
    bgcolor: "transparent",
    ".MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "borderColor.main"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "info.main"
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "error.main"
    },
    // Read-only mode keeps the plain-text look: no outline, no greyed-out text.
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent"
    }
  },
  ".MuiOutlinedInput-input": { fontSize: 13, padding: "5px 6px" },
  ".MuiOutlinedInput-input.Mui-disabled": {
    WebkitTextFillColor: "#212121"
  }
}, Ig = {
  ".dropzone": {
    margin: 0,
    height: 68,
    borderRadius: "4px",
    padding: "0 16px"
  },
  ".dropzone > div": {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "center",
    columnGap: "14px"
  },
  ".dropzone > div > .MuiBox-root": {
    gridRow: "1 / span 2",
    width: "auto",
    marginBottom: 0
  },
  ".dropzone svg": { fontSize: 30 },
  ".dropzone .MuiTypography-root": { textAlign: "left", fontSize: 13 }
}, s2 = 24, I9 = 16, Ur = ({ icon: n, label: o, color: a, name: i, onClick: l }) => /* @__PURE__ */ e.jsx(f1, { text: o, children: /* @__PURE__ */ e.jsx(
  Vt,
  {
    name: i,
    "aria-label": o,
    onClick: l,
    sx: {
      width: s2,
      height: s2,
      // MUI's own padding would squeeze the 16px glyph into the 8px that
      // remain inside a 24px button.
      p: 0,
      borderRadius: 1,
      color: `${a}.main`,
      "&:hover": { bgcolor: "backgroundColor.dark" }
    },
    children: /* @__PURE__ */ e.jsx(n, { size: I9 })
  }
) }), Rg = (n) => {
  const {
    open: o,
    viewMode: a,
    initialCoefficients: i,
    initialBaseYear: l,
    onClose: c,
    onSave: p
  } = n, { enqueueSnackbar: g } = gd(), [u, d] = pe([Z3()]), [f, b] = pe(null), [C, v] = pe(E4), [A, P] = pe(""), [T, I] = pe(!1), [w, N] = pe(
    l ?? null
  ), [E, x] = pe([]), [m, j] = pe([]), [_, z] = pe(!1), [Y, W] = pe(!1), [D, F] = pe(!1), [M, K] = pe(!1), J = $1(null), [q, B] = pe(null), k = (ue, ye) => {
    const ae = `${ue.id}:${ye}`;
    if ((q == null ? void 0 : q.key) === ae) return q.text;
    const de = ue[ye];
    return de === null ? "" : String(de);
  }, H = (ue, ye, ae) => {
    B({ key: `${ue.id}:${ye}`, text: ae }), me(
      ue.id,
      ye,
      ye === "year" ? Tg(ae) : Eg(ae)
    );
  };
  m1(() => {
    if (!o) return;
    const ue = A4(i || []);
    d(a ? ue : Gn(ue)), b(null), v(E4), P(""), I(!1), N(l ?? null), W(!1), K(!1), B(null);
    let ye = !0;
    return hg().then((ae) => {
      var de;
      ye && (j(H8(ae == null ? void 0 : ae.content)), z(!!((de = ae == null ? void 0 : ae.actions) != null && de.includes("update"))));
    }).catch(() => {
      ye && (j([]), z(!1));
    }), xg().then((ae) => ye && x(Array.isArray(ae) ? ae : [])).catch(() => ye && x([])), () => {
      ye = !1;
    };
  }, [o]);
  const re = je(() => wg(u), [u]), te = je(
    () => Array.from(
      new Set(
        u.filter((ue) => ue.year !== null && ue.coefficient !== null).map((ue) => Number(ue.year))
      )
    ).sort((ue, ye) => ye - ue),
    [u]
  );
  m1(() => {
    w !== null && te.includes(w) || N(te.length ? te[0] : null);
  }, [te, w]);
  const U = je(
    () => [
      vg,
      ...E.map((ue) => ({ value: ue.code, name: ue.name }))
    ],
    [E]
  ), me = (ue, ye, ae) => {
    d(
      (de) => de.map((ve) => ve.id === ue ? { ...ve, [ye]: ae } : ve)
    );
  }, Q = (ue) => {
    d((ye) => {
      const ae = [...ye];
      return ae.splice(ue + 1, 0, Z3()), ae;
    });
  }, ge = (ue) => {
    d((ye) => {
      const ae = [...ye];
      return ae.splice(ue + 1, 0, { ...ye[ue], id: Z3().id }), ae;
    });
  }, Z = (ue) => {
    d((ye) => Gn(ye.filter((ae, de) => de !== ue)));
  }, fe = () => {
    d([Z3()]), b(null);
  }, Se = () => {
    const ue = !T;
    I(ue), d((ye) => {
      const ae = A4(ye);
      if (!ue) return ae;
      const de = ae.filter((Ae) => Ae.year !== null).reverse(), ve = ae.filter((Ae) => Ae.year === null);
      return [...de, ...ve];
    });
  }, be = async (ue) => {
    P("");
    const ye = ue == null ? void 0 : ue[0];
    if (ye)
      try {
        const ae = await Ag(ye), de = Sg(ae);
        if (!de.length) {
          P(
            "No coefficients found in the file. Expected two columns: year and coefficient."
          );
          return;
        }
        d(Gn(A4(de))), I(!1), b(ye.name);
      } catch {
        P("Could not read the file.");
      }
  }, Te = () => {
    if (P(""), C === E4) {
      const ue = m.length ? m.map((ye) => ({ ...ye, id: Z3().id })) : yg();
      d(Gn(A4(ue))), I(!1), b(null);
      return;
    }
    P(
      "Downloading from this source is not available yet — drag & drop a CSV/TSV file instead."
    );
  }, Pe = a || C !== E4, xe = () => {
    const ue = V8(u), ye = ue.filter((de) => de.year !== null).map((de) => Number(de.year)), ae = w !== null && ye.includes(w) ? w : ye.length ? Math.max(...ye) : null;
    p(ue, ae), c();
  }, Ie = () => {
    re.hasErrors || xe();
  }, we = async () => {
    var ue, ye;
    if (!re.hasErrors) {
      F(!0);
      try {
        const ae = V8(u).map((ve) => ({
          year: Number(ve.year),
          coefficient: Number(ve.coefficient)
        })), de = await fg(ae);
        j(H8(de)), g({
          message: "Reference CPI table saved as default.",
          variant: "success"
        }), xe();
      } catch (ae) {
        g({
          message: ((ye = (ue = ae == null ? void 0 : ae.response) == null ? void 0 : ue.data) == null ? void 0 : ye.message) || "Could not save the default table.",
          variant: "error"
        });
      } finally {
        F(!1);
      }
    }
  }, he = {
    fontSize: 13,
    fontWeight: 700,
    color: "textColor.secondary"
  }, Oe = re.hasErrors ? "Fix duplicate years and incomplete rows before saving" : "";
  return (
    // The app's standard side panel. A centred dialog is sized by its content,
    // so every added row grew and re-centred the window under the pointer;
    // the panel has a fixed frame and only its body scrolls.
    /* @__PURE__ */ e.jsxs(m5, { open: o, onClose: c, width: "620px", children: [
      /* @__PURE__ */ e.jsxs(
        X,
        {
          sx: {
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            bgcolor: "backgroundColor.main"
          },
          children: [
            /* @__PURE__ */ e.jsx(yd, { onClose: c, children: "Consumer Price Index (CPI) options" }),
            /* @__PURE__ */ e.jsx(
              X,
              {
                sx: {
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  p: 2
                },
                children: /* @__PURE__ */ e.jsxs(
                  X,
                  {
                    sx: {
                      bgcolor: "#ffffff",
                      border: "1px solid",
                      borderColor: "borderColor.main",
                      borderRadius: 1,
                      p: 2
                    },
                    children: [
                      !a && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                        /* @__PURE__ */ e.jsx(X, { sx: Ig, children: /* @__PURE__ */ e.jsx(
                          Ed,
                          {
                            onDrop: be,
                            acceptExt: [
                              "text/csv",
                              "text/tab-separated-values",
                              "text/plain"
                            ],
                            textAvailableExt: ".CSV, .TSV",
                            uploadText: "Drag 'n' drop some files here, or click to select files"
                          }
                        ) }),
                        f && /* @__PURE__ */ e.jsxs(ce, { fontSize: 12, color: "textColor.label", mt: 0.75, children: [
                          "Last uploaded: ",
                          /* @__PURE__ */ e.jsx("b", { children: f })
                        ] }),
                        /* @__PURE__ */ e.jsx(
                          ce,
                          {
                            fontSize: 13,
                            color: "textColor.secondary",
                            textAlign: "center",
                            my: 1.5,
                            children: "OR"
                          }
                        ),
                        /* @__PURE__ */ e.jsxs(X, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
                          /* @__PURE__ */ e.jsx(X, { sx: { flex: 1, minWidth: 0 }, children: /* @__PURE__ */ e.jsx(
                            W1,
                            {
                              id: "cpiImportSource",
                              value: C,
                              options: U,
                              onChange: (ue) => {
                                v(ue), P("");
                              },
                              fullWidth: !0
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(
                            Ye,
                            {
                              variant: "outlined",
                              color: "darkGrey",
                              startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "import" }),
                              onClick: Te,
                              disabled: Pe,
                              name: "cpi-import",
                              sx: { flexShrink: 0 },
                              children: "Import"
                            }
                          )
                        ] }),
                        A && /* @__PURE__ */ e.jsx(ce, { fontSize: 12, color: "error.main", mt: 1, children: A })
                      ] }),
                      /* @__PURE__ */ e.jsxs(
                        X,
                        {
                          sx: {
                            display: "grid",
                            gridTemplateColumns: U8,
                            columnGap: G8,
                            alignItems: "center",
                            mt: a ? 0 : 2.5,
                            pb: 1,
                            borderBottom: "1px solid",
                            borderColor: "borderColor.main"
                          },
                          children: [
                            /* @__PURE__ */ e.jsxs(
                              X,
                              {
                                onClick: Se,
                                sx: {
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  width: "fit-content",
                                  cursor: "pointer",
                                  userSelect: "none"
                                },
                                children: [
                                  /* @__PURE__ */ e.jsx(ce, { sx: he, children: "Year" }),
                                  /* @__PURE__ */ e.jsx(
                                    t1,
                                    {
                                      iconName: "arrowDown",
                                      sx: {
                                        fontSize: 12,
                                        color: "textColor.label",
                                        transform: T ? "rotate(180deg)" : "none"
                                      }
                                    }
                                  )
                                ]
                              }
                            ),
                            /* @__PURE__ */ e.jsx(ce, { sx: he, children: "Coefficient" }),
                            !a && /* @__PURE__ */ e.jsx(X, { sx: { display: "flex", justifyContent: "flex-end" }, children: /* @__PURE__ */ e.jsx(
                              Ye,
                              {
                                variant: "text",
                                size: "small",
                                onClick: fe,
                                name: "cpi-clear-all",
                                endIcon: (
                                  // Same glyph, size and box as a row's Delete, so the two
                                  // line up in one column — "Clear all" reads as its header.
                                  /* @__PURE__ */ e.jsx(
                                    X,
                                    {
                                      sx: {
                                        width: s2,
                                        display: "flex",
                                        justifyContent: "center",
                                        color: "error.main"
                                      },
                                      children: /* @__PURE__ */ e.jsx(W8, { size: I9 })
                                    }
                                  )
                                ),
                                sx: {
                                  minWidth: 0,
                                  p: 0,
                                  fontSize: 13,
                                  fontWeight: 400,
                                  color: "textColor.secondary",
                                  ".end-icon": { ml: 1, mr: 0 },
                                  "&:hover": { bgcolor: "transparent" }
                                },
                                children: "Clear all"
                              }
                            ) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsx(X, { children: u.map((ue, ye) => {
                        const ae = re.duplicateRowIds.has(ue.id), de = re.incompleteRowIds.has(ue.id), ve = re.nonPositiveRowIds.has(ue.id), Ae = ae || de && ue.year === null, Ce = de && ue.coefficient === null || ve;
                        return /* @__PURE__ */ e.jsxs(
                          X,
                          {
                            sx: (qe) => ({
                              display: "grid",
                              gridTemplateColumns: U8,
                              columnGap: G8,
                              alignItems: "center",
                              py: 0.25,
                              // Same separator the shared `Table` draws between rows.
                              borderBottom: `1px solid ${no(
                                0.05,
                                qe.palette.borderColor.light
                              )}`,
                              backgroundColor: ae || de || ve ? "rgba(217, 66, 33, 0.08)" : "transparent",
                              // The kit paints the field's own root white, and `sx` on
                              // the field loses to that rule — inside a highlighted row
                              // it punched white holes through the band. Reset it from
                              // the row, where the selector is specific enough to win.
                              ".MuiTextField-root": { backgroundColor: "transparent" }
                            }),
                            children: [
                              /* @__PURE__ */ e.jsx(
                                f1,
                                {
                                  text: ae ? "Duplicate year" : Ae ? "Both Year and Coefficient are required" : "",
                                  disabled: !Ae,
                                  children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(
                                    et,
                                    {
                                      size: "small",
                                      inputMode: "numeric",
                                      value: k(ue, "year"),
                                      error: Ae,
                                      disabled: a,
                                      onChange: (qe) => H(ue, "year", qe.target.value),
                                      onBlur: () => B(null),
                                      fullWidth: !0,
                                      sx: K8
                                    }
                                  ) })
                                }
                              ),
                              /* @__PURE__ */ e.jsx(
                                f1,
                                {
                                  text: ve ? "Coefficient must be greater than zero" : Ce ? "Both Year and Coefficient are required" : "",
                                  disabled: !Ce,
                                  children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(
                                    et,
                                    {
                                      size: "small",
                                      inputMode: "decimal",
                                      value: k(ue, "coefficient"),
                                      error: Ce,
                                      disabled: a,
                                      onChange: (qe) => H(ue, "coefficient", qe.target.value),
                                      onBlur: () => B(null),
                                      fullWidth: !0,
                                      sx: K8
                                    }
                                  ) })
                                }
                              ),
                              !a && /* @__PURE__ */ e.jsxs(
                                X,
                                {
                                  sx: {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1
                                  },
                                  children: [
                                    /* @__PURE__ */ e.jsx(
                                      Ur,
                                      {
                                        icon: pg,
                                        color: "info",
                                        label: "Add row below",
                                        name: `cpi-add-row-${ye}`,
                                        onClick: () => Q(ye)
                                      }
                                    ),
                                    /* @__PURE__ */ e.jsx(
                                      Ur,
                                      {
                                        icon: mg,
                                        color: "info",
                                        label: "Copy row below",
                                        name: `cpi-copy-row-${ye}`,
                                        onClick: () => ge(ye)
                                      }
                                    ),
                                    /* @__PURE__ */ e.jsx(
                                      Ur,
                                      {
                                        icon: W8,
                                        color: "error",
                                        label: "Delete row",
                                        name: `cpi-delete-row-${ye}`,
                                        onClick: () => Z(ye)
                                      }
                                    )
                                  ]
                                }
                              )
                            ]
                          },
                          ue.id
                        );
                      }) }),
                      /* @__PURE__ */ e.jsxs(
                        X,
                        {
                          sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mt: 2
                          },
                          children: [
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, color: "textColor.secondary", children: "Base year" }),
                            /* @__PURE__ */ e.jsx(
                              f1,
                              {
                                text: "Add at least one complete row to pick a base year",
                                disabled: te.length > 0,
                                children: /* @__PURE__ */ e.jsx(X, { sx: { width: 130 }, children: /* @__PURE__ */ e.jsx(
                                  W1,
                                  {
                                    id: "cpiBaseYear",
                                    value: w ?? "",
                                    options: te.map((ue) => ({
                                      value: ue,
                                      name: String(ue)
                                    })),
                                    onChange: (ue) => N(ue ?? null),
                                    disabled: a || te.length === 0,
                                    placeholder: "Select year",
                                    fullWidth: !0
                                  }
                                ) })
                              }
                            ),
                            /* @__PURE__ */ e.jsxs(X, { sx: { display: "flex", alignItems: "center", gap: 0.5 }, children: [
                              /* @__PURE__ */ e.jsx(ce, { fontSize: 12, color: "textColor.label", children: "Amounts are converted to this year." }),
                              /* @__PURE__ */ e.jsx(f1, { text: Og, width: 360, sx: Pg, children: /* @__PURE__ */ e.jsx(X, { sx: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ e.jsx(
                                t1,
                                {
                                  iconName: "info",
                                  sx: { fontSize: 18, color: "textColor.label" }
                                }
                              ) }) })
                            ] })
                          ]
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsxs(
              X,
              {
                sx: {
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  px: 2,
                  py: 1.5,
                  bgcolor: "#ffffff",
                  borderTop: "1px solid",
                  borderColor: "borderColor.main"
                },
                children: [
                  a ? /* @__PURE__ */ e.jsx(
                    Ye,
                    {
                      variant: "outlined",
                      color: "darkGrey",
                      onClick: c,
                      name: "cpi-close-view",
                      children: "Close"
                    }
                  ) : /* @__PURE__ */ e.jsx(f1, { text: Oe, disabled: !re.hasErrors, children: /* @__PURE__ */ e.jsxs(X, { sx: { display: "flex" }, children: [
                    /* @__PURE__ */ e.jsx(
                      Ye,
                      {
                        variant: "outlined",
                        color: "darkGrey",
                        startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "save", sx: { color: "success.main" } }),
                        onClick: Ie,
                        disabled: re.hasErrors || D,
                        name: "cpi-save",
                        sx: _ ? { borderRadius: "4px 0 0 4px", borderRightWidth: 0 } : void 0,
                        children: "Save"
                      }
                    ),
                    _ && /* @__PURE__ */ e.jsx(
                      Ye,
                      {
                        ref: J,
                        variant: "outlined",
                        color: "darkGrey",
                        onClick: () => K(!0),
                        disabled: re.hasErrors || D,
                        name: "cpi-save-menu",
                        "aria-haspopup": "true",
                        sx: { minWidth: 28, px: 0, borderRadius: "0 4px 4px 0" },
                        children: /* @__PURE__ */ e.jsx(t1, { iconName: "arrowDown", sx: { fontSize: 12 } })
                      }
                    )
                  ] }) }),
                  /* @__PURE__ */ e.jsx(
                    ro,
                    {
                      open: M,
                      anchorEl: J.current,
                      onClose: () => K(!1),
                      anchorOrigin: { vertical: "top", horizontal: "right" },
                      transformOrigin: { vertical: "bottom", horizontal: "right" },
                      children: /* @__PURE__ */ e.jsx(
                        Xr,
                        {
                          sx: { fontSize: 13 },
                          onClick: () => {
                            K(!1), W(!0);
                          },
                          children: 'Save and set as "Default (pre-uploaded data)"'
                        }
                      )
                    }
                  )
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ad,
        {
          open: Y,
          text: _g,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          variant: "info",
          onSubmit: we,
          onClose: () => W(!1)
        }
      )
    ] })
  );
}, l2 = [
  { name: "Total cost", value: "total_cost" },
  { name: "Total paid", value: "total_paid" },
  { name: "Paid by payer", value: "paid_by_payer" },
  { name: "Paid by patient", value: "paid_by_patient" },
  { name: "Paid by patient copay", value: "paid_patient_copay" },
  { name: "Paid patient coinsurance", value: "paid_patient_coinsurance" },
  { name: "Paid patient deductible", value: "paid_patient_deductible" },
  { name: "Total charge", value: "total_charge" }
], Ng = 100;
function Fg(n, o) {
  const a = (i) => i >= 1e6 ? `${(i / 1e6).toFixed(2)}M` : i >= 1e3 ? `${(i / 1e3).toFixed(2)}k` : `${i}`;
  return `${a(n)}-${a(o)}`;
}
function R9(n) {
  const o = Math.max(0, Math.abs(n));
  return o <= 100 ? 1 : o <= 1e3 ? 10 : o <= 1e4 ? 100 : o <= 1e5 ? 1e3 : o <= 1e6 ? 1e4 : 1e5;
}
function Dg(n, o) {
  const [a, i] = o, l = n.data.filter((g) => g.max >= a && g.min <= i).map((g) => g.min), c = n.data.map((g) => g.min), p = l.length > 0 ? l : c;
  return p.length ? R9(Math.min(...p)) : 1;
}
function Lg(n, o) {
  const a = [];
  let i = 1;
  for (; i <= o; )
    i >= n && a.push(i), i *= 10;
  return a.length ? a : [Math.max(1, n)];
}
function Mg(n, o) {
  if (!n.length)
    return [];
  const [a, i] = o, l = Math.max(0, i - a), c = R9(l), p = n.reduce((d, f) => Math.max(d, Dg(f, o)), 1), g = Math.max(c, p), u = Math.max(g, l);
  return Lg(g, u);
}
function kg(n, o, a = Ng) {
  const i = Math.max(1, o), l = Math.max(0, n[1] - n[0]), c = l === 0 ? 1 : Math.ceil(l / i);
  return Math.max(1, Math.min(a, c));
}
function N9(n) {
  if (!n.length)
    return { minCost: 0, maxCost: 0 };
  const o = n.flatMap((u) => u.data), a = o.filter((u) => (u.personCount ?? 0) > 0), i = a.length ? a : o, l = i.map((u) => u.min), c = i.map((u) => u.max);
  if (!l.length || !c.length)
    return { minCost: 0, maxCost: 0 };
  const p = Math.min(...l), g = Math.max(...c);
  return { minCost: p, maxCost: g };
}
function zg(n, o, a) {
  if (n > o) {
    const i = n - o;
    return Math.max(1, Math.trunc(i / a));
  }
  return 1;
}
function Bg(n, o = 10, a, i) {
  if (!n.length || !n[0].data.length)
    return { bins: [], minCost: 0, maxCost: 0, binSize: 0 };
  const { minCost: l, maxCost: c } = N9(n);
  let p = l, g = c;
  i && i.length === 2 && (p = Math.max(p, i[0]), g = Math.min(g, i[1])), g < p && (g = p);
  const u = Math.max(1, o), d = Math.max(
    1,
    a || zg(g, p, u)
  ), f = [];
  for (let b = 0; b < u; b++) {
    const C = p + b * d, v = C + d, A = {
      range: Fg(Math.round(C), Math.round(v)),
      rangeStart: Math.round(C),
      rangeEnd: Math.round(v)
    };
    n.forEach(({ data: P, id: T }) => {
      const w = P.filter((N) => {
        const E = (N.min + N.max) / 2;
        return E >= C && E < v || b === u - 1 && E === v;
      }).reduce((N, E) => N + E.personCount, 0);
      A[T] = w;
    }), f.push(A);
  }
  return { bins: f, minCost: p, maxCost: g, binSize: d };
}
const $g = [
  {
    header: "Target Cohort / Time",
    accessorKey: "targetCohort.name"
  },
  {
    header: "Avg",
    accessorKey: "avgValue",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 100
  },
  {
    header: "Std dev",
    accessorKey: "stdevValue",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 100
  },
  {
    header: "Min",
    accessorKey: "minValue",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "P10",
    accessorKey: "p10Value",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "P25",
    accessorKey: "p25Value",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Median",
    accessorKey: "medianValue",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "P75",
    accessorKey: "p75Value",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "P90",
    accessorKey: "p90Value",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Max",
    accessorKey: "maxValue",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Total cost",
    accessorKey: "totalCost",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPM",
    accessorKey: "costPppm",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPQ",
    accessorKey: "costPppq",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPY",
    accessorKey: "costPppy",
    cell: ({ getValue: n }) => oe(n(), 2, 2),
    size: 80
  }
], Dv = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  }
];
var Ht = /* @__PURE__ */ ((n) => (n.TOTALS = "totals", n.DOMAINS = "domains", n.CONCEPT_SETS = "conceptSets", n))(Ht || {});
const Wg = [
  { value: "totals", name: "Totals" },
  { value: "domains", name: "Domains" },
  { value: "conceptSets", name: "Concept-sets" }
], Hg = {
  totals: "TOTALS",
  domains: "DOMAINS",
  conceptSets: "CONCEPT_SETS"
}, Vg = {
  TOTALS: "totals",
  DOMAINS: "domains",
  CONCEPT_SETS: "conceptSets"
  /* CONCEPT_SETS */
}, c2 = (n) => ({
  id: Kt(),
  name: `Analysis ${n + 1}`,
  type: "totals",
  domainsToUse: [],
  conceptSets: [],
  costMeasures: ["total_cost"],
  excludeNegativeCosts: !1,
  excludeZeroCostPatients: !1,
  visitConceptIds: [],
  visitLength: {
    Op: P1.GREATER_THAN,
    Value: null,
    Extent: null
  },
  dateRangeStart: null,
  dateRangeEnd: null,
  window: {
    startWith: "start",
    startOffset: 0,
    endWith: "start",
    endOffset: 365
  },
  applyCpi: !1,
  cpiCoefficients: [],
  cpiBaseYear: null
}), Ug = [
  { value: P1.LESS_THAN, name: "less than" },
  { value: P1.LESS_OR_EQUAL_TO, name: "less or equal to" },
  { value: P1.EQUAL_TO, name: "equal to" },
  { value: P1.GREATER_THAN, name: "greater than" },
  { value: P1.GREATER_OR_EQUAL_TO, name: "greater or equal to" },
  { value: P1.BETWEEN, name: "between" }
], Gr = [P1.BETWEEN], Y8 = "Start value must be less than end value", Gg = "Start date cannot be later than end date", Kg = "Both dates must be filled or left empty", F9 = "__select_all__", q8 = { name: "Select all", value: F9 }, Yg = (n, o) => n.name.localeCompare(o.name), qg = (n, o) => n.localeCompare(o), Kn = [...l2].sort(Yg), Kr = [
  "Condition",
  "Device",
  "Drug",
  "Measurement",
  "Observation",
  "Procedure",
  "Visit"
].sort(qg), X8 = (n) => {
  const o = Zr(n, _1.ISO_DATE);
  return !o || o === "Invalid date" ? null : o;
}, Z8 = (n) => {
  if (n == null || n === "")
    return null;
  const o = Number(n);
  return Number.isNaN(o) ? null : Math.max(o, 0);
}, Xg = {
  [Ht.TOTALS]: "Additionally calculate total chart (costs associated with all domains).",
  [Ht.DOMAINS]: "Calculate cost associated with specific selected domain(s) (one chart per domain).",
  [Ht.CONCEPT_SETS]: "Additionally calculate cost associated with specific concept sets (one chart)."
}, M4 = (n) => (n == null ? void 0 : n.value) === F9, J8 = (n, o) => (a, i, { selected: l }) => [
  /* @__PURE__ */ e.jsxs(
    X,
    {
      ...a,
      sx: { fontSize: 13, height: "28px" },
      onClick: M4(i) ? o : a.onClick,
      children: [
        /* @__PURE__ */ e.jsx(
          S1,
          {
            sx: { mr: 1 },
            checked: M4(i) ? n : l,
            size: "small"
          }
        ),
        i.name || i
      ]
    }
  ),
  M4(i) ? /* @__PURE__ */ e.jsx(M1, {}, "divider") : ""
], Zg = ze((n) => {
  const {
    analysis: o,
    index: a,
    viewMode: i,
    subModules: l,
    typeContainer: c,
    id: p,
    parentId: g,
    analysisName: u,
    onFieldChange: d,
    onFieldsChange: f,
    onRemove: b
  } = n, [C, v] = pe(!1), A = o.type || Ht.TOTALS, P = o.visitLength || {
    Op: P1.GREATER_THAN,
    Value: null,
    Extent: null
  }, T = o.window || {
    startWith: "start",
    startOffset: 0,
    endWith: "start",
    endOffset: 365
  }, I = Gr.includes(
    P.Op
  ), w = I && P.Value !== null && P.Extent !== null && Number(P.Value) >= Number(P.Extent), N = I && w, E = o.dateRangeStart ?? null, x = o.dateRangeEnd ?? null, m = !!E != !!x, j = !!(E && x && E > x), _ = m || j, z = m ? Kg : j ? Gg : "", Y = o.costMeasures || [], W = Y.length === Kn.length, D = o.domainsToUse || [], F = D.length === Kr.length, M = () => {
    d(
      "costMeasures",
      W ? [] : Kn.map((U) => U.value)
    );
  }, K = (U) => {
    U.preventDefault(), M();
  }, J = () => {
    d("domainsToUse", F ? [] : Kr);
  }, q = (U) => {
    U.preventDefault(), J();
  }, B = (U) => {
    d("visitLength", { ...P, ...U });
  }, k = (U) => {
    d("window", { ...T, ...U });
  }, H = (o.cpiCoefficients || []).filter(
    (U) => U.year !== null && U.coefficient !== null
  ), re = H.map((U) => Number(U.year)), te = o.applyCpi ? H.length === 0 ? "Add CPI coefficients or turn CPI off." : H.some((U) => Number(U.coefficient) <= 0) ? "CPI coefficients must be greater than zero." : new Set(re).size !== re.length ? "Remove duplicate CPI years." : o.cpiBaseYear != null && !re.includes(Number(o.cpiBaseYear)) ? "CPI base year must be one of the listed years." : "" : "";
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        collapsible: !0,
        defaultState: !0,
        elevated: !0,
        outlined: !0,
        title: /* @__PURE__ */ e.jsxs(
          y,
          {
            item: !0,
            flexGrow: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, display: "flex", alignItems: "center", children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle1", fontWeight: 600, children: o.name || `Analysis ${a + 1}` }) }),
              !i && /* @__PURE__ */ e.jsx(y, { item: !0, sx: { pr: "2px", py: "8px" }, children: /* @__PURE__ */ e.jsx(
                uo,
                {
                  iconName: "delete",
                  title: "Remove analysis",
                  size: "small",
                  noExpand: !0,
                  color: "error",
                  onClick: (U) => {
                    var me;
                    (me = U == null ? void 0 : U.stopPropagation) == null || me.call(U), b();
                  }
                }
              ) })
            ]
          }
        ),
        children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: `analysisName-${o.id}`,
              textLabel: "Name",
              labelSize: 5,
              description: "Displayed in results to identify this analysis.",
              children: /* @__PURE__ */ e.jsx(
                et,
                {
                  id: `analysisName-${o.id}`,
                  name: `analysisName-${o.id}`,
                  value: o.name,
                  onChange: (U) => d("name", U.target.value),
                  disabled: i,
                  sx: { width: 260 }
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: `analysisType-${o.id}`,
              textLabel: "Type",
              labelSize: 5,
              description: (
                // Always rendered, hidden when it does not apply: letting the
                // line appear and disappear re-centred the row and moved the
                // select out from under the pointer on every type change.
                /* @__PURE__ */ e.jsx(
                  X,
                  {
                    component: "span",
                    sx: {
                      display: "block",
                      visibility: A === Ht.TOTALS ? "visible" : "hidden"
                    },
                    children: Xg[Ht.TOTALS]
                  }
                )
              ),
              children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 260, children: /* @__PURE__ */ e.jsx(
                W1,
                {
                  id: `analysisType-${o.id}`,
                  value: A,
                  onChange: (U) => d("type", U),
                  options: Wg,
                  disabled: i,
                  fullWidth: !0
                }
              ) })
            }
          ) }),
          A === Ht.DOMAINS && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ve,
            {
              htmlFor: `domainsToUse-${o.id}`,
              textLabel: "Domains",
              description: "Calculate cost associated with specific selected domain(s) (one chart per domain).",
              labelSize: 5,
              children: /* @__PURE__ */ e.jsx(
                H1,
                {
                  name: `domainsToUse-${o.id}`,
                  multiple: !0,
                  id: `domainsToUse-${o.id}`,
                  options: [q8, ...Kr],
                  value: D,
                  placeholder: "Select...",
                  onChange: (U, me) => {
                    if (me.some(M4)) {
                      J();
                      return;
                    }
                    d(
                      "domainsToUse",
                      me.map((Q) => Q)
                    );
                  },
                  disabled: i,
                  disableCloseOnSelect: !0,
                  disableClearable: !1,
                  OptionComponent: J8(
                    F,
                    q
                  ),
                  getOptionLabel: function(U) {
                    return (U == null ? void 0 : U.name) || U;
                  },
                  isOptionEqualToValue: (U, me) => U === me
                }
              )
            }
          ) }),
          A === Ht.CONCEPT_SETS && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsx(
            l.concept,
            {
              type: "component",
              name: "widget-concept-set-import-button",
              subModules: l,
              viewMode: i,
              config: {
                buttonText: "Import Concept Sets",
                titleText: "Concept Sets",
                classNameContainer: "target-import-button",
                typeContainer: c,
                initialData: o.conceptSets,
                onChange: (U) => {
                  d("conceptSets", U);
                },
                parentId: g,
                returnEntityText: u,
                viewMode: i,
                description: "Additionally calculate cost associated with specific concept sets (one chart).",
                isSelect: !0
              }
            }
          ) }),
          /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ne,
            {
              collapsible: !0,
              title: "Analysis Settings",
              defaultState: i,
              elevated: !0,
              outlined: !0,
              children: /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
                /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, px: 1, children: [
                  /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the analysis." }),
                  /* @__PURE__ */ e.jsx(M1, { sx: { borderColor: "borderColor.light" } })
                ] }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `costMeasures-${o.id}`,
                    textLabel: "Cost measures",
                    labelSize: 5,
                    description: "Select one or more cost measures to compute.",
                    children: /* @__PURE__ */ e.jsx(
                      H1,
                      {
                        name: `costMeasures-${o.id}`,
                        multiple: !0,
                        id: `costMeasures-${o.id}`,
                        options: [q8, ...Kn],
                        value: Y,
                        placeholder: "Select...",
                        fullWidth: !0,
                        onChange: (U, me) => {
                          if (me.some(M4)) {
                            M();
                            return;
                          }
                          d(
                            "costMeasures",
                            me.map(
                              (Q) => typeof Q == "string" ? Q : Q.value
                            )
                          );
                        },
                        disabled: i,
                        disableCloseOnSelect: !0,
                        disableClearable: !1,
                        OptionComponent: J8(
                          W,
                          K
                        ),
                        getOptionLabel: function(U) {
                          var me;
                          return (U == null ? void 0 : U.name) ?? ((me = Kn.find(
                            (Q) => Q.value === U || Q.value === (U == null ? void 0 : U.value)
                          )) == null ? void 0 : me.name) ?? U;
                        },
                        isOptionEqualToValue: (U, me) => U.value === me || U.value === (me == null ? void 0 : me.value)
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `applyCpi-${o.id}`,
                    textLabel: "CPI (Consumer Price Index)",
                    labelSize: 5,
                    description: "Apply Consumer Price Index adjustment to cost measures.",
                    children: /* @__PURE__ */ e.jsxs(X, { children: [
                      /* @__PURE__ */ e.jsxs(
                        y,
                        {
                          container: !0,
                          spacing: 1,
                          alignItems: "center",
                          wrap: "nowrap",
                          children: [
                            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                              S1,
                              {
                                id: `applyCpi-${o.id}`,
                                name: `applyCpi-${o.id}`,
                                onChange: () => {
                                  d("applyCpi", !o.applyCpi);
                                },
                                checked: o.applyCpi,
                                disabled: i
                              }
                            ) }),
                            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                              Ye,
                              {
                                variant: "outlined",
                                color: "info",
                                size: "small",
                                onClick: () => v(!0),
                                disabled: !o.applyCpi,
                                name: `cpiSettings-${o.id}`,
                                children: "CPI settings"
                              }
                            ) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        ce,
                        {
                          color: "error.main",
                          fontSize: 12,
                          noWrap: !0,
                          sx: {
                            mt: 0.5,
                            visibility: te ? "visible" : "hidden"
                          },
                          children: te || " "
                        }
                      )
                    ] })
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `excludeNegativeCosts-${o.id}`,
                    textLabel: "Exclude negative costs",
                    labelSize: 5,
                    description: "Filter out events with negative cost values from analyses.",
                    children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                      S1,
                      {
                        id: `excludeNegativeCosts-${o.id}`,
                        name: `excludeNegativeCosts-${o.id}`,
                        onChange: () => {
                          d(
                            "excludeNegativeCosts",
                            !o.excludeNegativeCosts
                          );
                        },
                        checked: o.excludeNegativeCosts,
                        disabled: i
                      }
                    ) })
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `excludeZeroCostPatients-${o.id}`,
                    textLabel: "Exclude zero costs",
                    labelSize: 5,
                    description: "Filter out patients (and their person-time) if their total cost for the specific analysis is zero.",
                    children: /* @__PURE__ */ e.jsx(y, { item: !0, width: 150, children: /* @__PURE__ */ e.jsx(
                      S1,
                      {
                        id: `excludeZeroCostPatients-${o.id}`,
                        name: `excludeZeroCostPatients-${o.id}`,
                        onChange: () => {
                          d(
                            "excludeZeroCostPatients",
                            !o.excludeZeroCostPatients
                          );
                        },
                        checked: o.excludeZeroCostPatients,
                        disabled: i
                      }
                    ) })
                  }
                ) }),
                /* @__PURE__ */ e.jsx(
                  y,
                  {
                    item: !0,
                    xs: 12,
                    alignItems: "center",
                    sx: {
                      ".attribute-vocabulary .chip": { mb: 0.5 },
                      ".start-text": { display: "none" }
                    },
                    children: /* @__PURE__ */ e.jsx(
                      Ve,
                      {
                        htmlFor: `visitConceptIds-${o.id}`,
                        textLabel: "Visit",
                        labelSize: 5,
                        description: "Filter events to specific visit types.",
                        children: /* @__PURE__ */ e.jsx(
                          l.cohort,
                          {
                            type: "component",
                            name: "widget-attribute-vocabulary",
                            subModules: l,
                            config: {
                              id: `visitConceptIds-${o.id}`,
                              value: o.visitConceptIds,
                              typeContainer: c,
                              attrName: "concepts",
                              domainId: "Visit",
                              onChange: (U, me) => {
                                d("visitConceptIds", me);
                              },
                              viewMode: i,
                              showSelectAll: !1
                            }
                          }
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `periodLength-${o.id}`,
                    textLabel: "Visit length",
                    labelSize: 5,
                    description: "Filter event from visits with corresponding duration.",
                    children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, alignItems: "center", children: [
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                        W1,
                        {
                          id: `periodLengthOp-${o.id}`,
                          value: P.Op,
                          onChange: (U) => {
                            const me = U;
                            B({
                              Op: me,
                              Extent: Gr.includes(me) ? 1 : null
                            });
                          },
                          options: Ug,
                          placeholder: "Select option..."
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                        f1,
                        {
                          text: N ? Y8 : "",
                          disabled: !N,
                          children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(
                            et,
                            {
                              value: P.Value,
                              type: "number",
                              onChange: (U) => B({
                                Value: Z8(
                                  U.target.value
                                )
                              }),
                              min: 0,
                              error: N,
                              sx: { width: 100 }
                            }
                          ) })
                        }
                      ) }),
                      Gr.includes(
                        P.Op
                      ) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                        /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { fontSize: 13, children: "and" }) }),
                        /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                          f1,
                          {
                            text: N ? Y8 : "",
                            disabled: !N,
                            children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(
                              et,
                              {
                                value: P.Extent,
                                type: "number",
                                onChange: (U) => B({
                                  Extent: Z8(
                                    U.target.value
                                  )
                                }),
                                min: 0,
                                error: N,
                                sx: { width: 100 }
                              }
                            ) })
                          }
                        ) })
                      ] }),
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { fontSize: 13, children: "days" }) })
                    ] })
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `eventDateRange-${o.id}`,
                    textLabel: "Event date range",
                    labelSize: 5,
                    description: "Filter events to ones starting/ending within the specified date range.",
                    children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, alignItems: "center", children: [
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { fontSize: 13, children: "event start date" }) }),
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                        f1,
                        {
                          text: z,
                          disabled: !_,
                          children: /* @__PURE__ */ e.jsx(X, { sx: { width: 150 }, children: /* @__PURE__ */ e.jsx(
                            O3,
                            {
                              fullWidth: !1,
                              value: E,
                              error: _,
                              format: _1.DATEPICKER_DATE,
                              onChange: (U) => d(
                                "dateRangeStart",
                                X8(U)
                              ),
                              name: `eventDateRangeStartDate-${o.id}`
                            }
                          ) })
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { fontSize: 13, children: "event end date" }) }),
                      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                        f1,
                        {
                          text: z,
                          disabled: !_,
                          children: /* @__PURE__ */ e.jsx(X, { sx: { width: 150 }, children: /* @__PURE__ */ e.jsx(
                            O3,
                            {
                              fullWidth: !1,
                              value: x,
                              error: _,
                              format: _1.DATEPICKER_DATE,
                              onChange: (U) => d(
                                "dateRangeEnd",
                                X8(U)
                              ),
                              name: `eventDateRangeEndDate-${o.id}`
                            }
                          ) })
                        }
                      ) })
                    ] })
                  }
                ) }),
                /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    htmlFor: `window-${o.id}`,
                    textLabel: "Window",
                    labelSize: 5,
                    description: "Analysis time window adjustments.",
                    children: /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 1, children: [
                      /* @__PURE__ */ e.jsxs(
                        y,
                        {
                          item: !0,
                          flexWrap: "nowrap",
                          display: "flex",
                          alignItems: "center",
                          children: [
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, children: "starting with" }),
                            /* @__PURE__ */ e.jsx(
                              W1,
                              {
                                id: `startWith-${o.id}`,
                                value: T.startWith,
                                onChange: (U) => k({ startWith: U }),
                                options: [
                                  { value: "end", name: "end" },
                                  { value: "start", name: "start" }
                                ]
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(
                        y,
                        {
                          item: !0,
                          flexWrap: "nowrap",
                          display: "flex",
                          alignItems: "center",
                          children: [
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, children: "+" }),
                            /* @__PURE__ */ e.jsx(
                              et,
                              {
                                value: T.startOffset,
                                type: "number",
                                onChange: (U) => k({
                                  startOffset: Number(U.target.value)
                                }),
                                sx: { width: 100 }
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(
                        y,
                        {
                          item: !0,
                          flexWrap: "nowrap",
                          display: "flex",
                          alignItems: "center",
                          children: [
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, children: "days ending with" }),
                            /* @__PURE__ */ e.jsx(
                              W1,
                              {
                                name: `endWith-${o.id}`,
                                value: T.endWith,
                                onChange: (U) => k({ endWith: U }),
                                options: [
                                  { value: "end", name: "end" },
                                  { value: "start", name: "start" }
                                ],
                                placeholder: "start with..."
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(
                        y,
                        {
                          item: !0,
                          flexWrap: "nowrap",
                          display: "flex",
                          alignItems: "center",
                          children: [
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, mr: 1, children: "+" }),
                            /* @__PURE__ */ e.jsx(
                              et,
                              {
                                value: T.endOffset,
                                type: "number",
                                onChange: (U) => k({ endOffset: Number(U.target.value) }),
                                min: 0,
                                sx: { width: 100 }
                              }
                            ),
                            /* @__PURE__ */ e.jsx(ce, { fontSize: 13, ml: 1, children: "days" })
                          ]
                        }
                      )
                    ] })
                  }
                ) })
              ] })
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ e.jsx(
      Rg,
      {
        open: C,
        viewMode: i,
        initialCoefficients: o.cpiCoefficients || [],
        initialBaseYear: o.cpiBaseYear ?? null,
        onClose: () => v(!1),
        onSave: (U, me) => f({
          cpiCoefficients: U,
          cpiBaseYear: me
        })
      }
    )
  ] });
}), Lv = ze((n) => {
  var P, T;
  const {
    subModules: o,
    parentId: a,
    design: i,
    id: l,
    typeContainer: c,
    updateDesign: p,
    analysisName: g,
    viewMode: u
  } = n, d = i.analyses || [], f = (I) => (w) => {
    p(I, w);
  };
  m1(() => {
    !u && (!i.analyses || i.analyses.length === 0) && p("analyses", [c2(0)]);
  }, []);
  const b = () => {
    p("analyses", [
      ...d,
      c2(d.length)
    ]);
  }, C = (I) => {
    const w = [...d];
    w.splice(I, 1), p("analyses", w);
  }, v = (I) => (w, N) => {
    const E = d.map(
      (x, m) => m === I ? { ...x, [w]: N } : x
    );
    p("analyses", E);
  }, A = (I) => (w) => {
    const N = d.map(
      (E, x) => x === I ? { ...E, ...w } : E
    );
    p("analyses", N);
  };
  return /* @__PURE__ */ e.jsxs(y, { container: !0, spacing: 2, children: [
    (!u || u && ((P = i == null ? void 0 : i.targetCohorts) == null ? void 0 : P.length) > 0) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(W4, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("b", { children: "Cost utilization" }),
        " measures and normalizes healthcare costs from standardized data, enabling breakdowns by clinical areas or defined concept sets."
      ] }) }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        o.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: o,
          path: L1(c, l, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ e.jsx(
              N1,
              {
                title: "Target cohorts",
                count: (T = i == null ? void 0 : i.targetCohorts) == null ? void 0 : T.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: i == null ? void 0 : i.targetCohorts,
            onChange: f("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: g,
            collapsible: !0,
            defaultState: !0,
            viewMode: u
          }
        }
      ) })
    ] }),
    (!u || u && d.length > 0) && /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        collapsible: !0,
        defaultState: !0,
        elevated: !0,
        outlined: !0,
        title: /* @__PURE__ */ e.jsxs(
          y,
          {
            item: !0,
            flexGrow: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(N1, { title: "Analyses", count: d.length }) }),
              !u && /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(
                Ye,
                {
                  onClick: (I) => {
                    I.stopPropagation(), b();
                  },
                  variant: "contained",
                  color: "info",
                  startIcon: /* @__PURE__ */ e.jsx(t1, { iconName: "add" }),
                  name: "add-analysis",
                  children: "Add analysis"
                }
              ) })
            ]
          }
        ),
        children: /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: d.map((I, w) => /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Zg,
          {
            analysis: I,
            index: w,
            viewMode: u,
            subModules: o,
            typeContainer: c,
            id: l,
            parentId: a,
            analysisName: g,
            onFieldChange: v(w),
            onFieldsChange: A(w),
            onRemove: () => C(w)
          }
        ) }, I.id)) })
      }
    ) })
  ] });
}), Jg = ({ histogramData: n, datasets: o, targetCohorts: a }) => {
  const i = Yt(o, "id"), l = Yt(a, "id");
  return /* @__PURE__ */ e.jsx(R3, { width: "100%", height: "100%", children: /* @__PURE__ */ e.jsxs(
    d2,
    {
      data: n,
      margin: { top: 20, right: 10, left: 10, bottom: 60 },
      children: [
        /* @__PURE__ */ e.jsx(U4, { strokeDasharray: "3 3", stroke: "#e5e7eb" }),
        /* @__PURE__ */ e.jsx(
          G4,
          {
            dataKey: "range",
            angle: -45,
            textAnchor: "end",
            style: { fontSize: "12px" }
          }
        ),
        /* @__PURE__ */ e.jsx(
          K4,
          {
            label: {
              value: "Number of People",
              angle: -90,
              position: "insideLeft",
              fontSize: "12px"
            },
            style: { fontSize: "12px" },
            type: "number",
            domain: [0, "dataMax"]
          }
        ),
        /* @__PURE__ */ e.jsx(
          h3,
          {
            contentStyle: {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              border: "1px solid #e5e7eb",
              borderRadius: "6px"
            },
            content: ({ payload: c }) => {
              var d, f, b, C;
              const p = (f = (d = c[0]) == null ? void 0 : d.payload) == null ? void 0 : f.rangeEnd, g = (C = (b = c[0]) == null ? void 0 : b.payload) == null ? void 0 : C.rangeStart;
              let u = [
                /* @__PURE__ */ e.jsxs(X, { p: 1, bgcolor: "white", boxShadow: 3, children: [
                  "Range: ",
                  oe(g),
                  " - ",
                  oe(p)
                ] }, "range")
              ];
              return c.forEach((v, A) => {
                var I, w, N;
                const P = v == null ? void 0 : v.dataKey, T = (v == null ? void 0 : v.color) || (v == null ? void 0 : v.fill);
                P && u.push(
                  /* @__PURE__ */ e.jsxs(
                    X,
                    {
                      color: T,
                      p: 1,
                      bgcolor: "white",
                      boxShadow: 3,
                      children: [
                        /* @__PURE__ */ e.jsx("b", { children: "Target cohort" }),
                        " : ",
                        (I = i[P]) == null ? void 0 : I.name,
                        /* @__PURE__ */ e.jsx("br", {}),
                        /* @__PURE__ */ e.jsx("b", { children: "Number of People" }),
                        " :",
                        " ",
                        (N = (w = v == null ? void 0 : v.payload) == null ? void 0 : w[P]) == null ? void 0 : N.toFixed(0)
                      ]
                    },
                    P
                  )
                );
              }), /* @__PURE__ */ e.jsx(X, { fontSize: 13, children: u });
            }
          }
        ),
        o.map(
          (c, p) => l[c.id] ? /* @__PURE__ */ e.jsx(
            p2,
            {
              dataKey: c.id,
              fill: Ot(0.5, c.color || p3(p, !1))
            },
            c.id
          ) : ""
        )
      ]
    }
  ) });
}, Qg = So(wo);
function ey(n, o) {
  return n.map((i, l) => [
    {
      type: "box",
      name: i.cohortName,
      y: [i.cohortName],
      lowerfence: [i.p10Value],
      q1: [i.p25Value],
      median: [i.medianValue],
      q3: [i.p75Value],
      upperfence: [i.p90Value],
      line: {
        width: 1
      },
      jitter: 0.3,
      pointpos: -1.8,
      orientation: "h",
      marker: {
        color: Ot(0.5, i.color || p3(l, !1))
      },
      hoverinfo: "skip",
      showlegend: !1
    },
    // this scatter is used to show detailed hover info, since box plot hover is very limited
    // I suggest we keep it like this until plotly supports better hover for box plots or we create custom tooltip
    {
      type: "scatter",
      mode: "markers",
      x: [i.medianValue || i.maxValue || i.minValue],
      y: [i.cohortName],
      marker: {
        size: 10,
        opacity: 0
      },
      hovertemplate: "Min: " + i.minValue + "<br>P10: " + i.p10Value + "<br>P25: " + i.p25Value + "<br>Median: " + i.medianValue + "<br>P75: " + i.p75Value + "<br>P90: " + i.p90Value + "<br>Max: " + i.maxValue + "<extra></extra>",
      showlegend: !1
    },
    ...o ? [] : [
      {
        type: "scatter",
        mode: "markers",
        name: `${i.cohortName} Min`,
        x: [i.minValue],
        y: [i.cohortName],
        marker: {
          size: 8,
          color: Ot(0.5, i.color || p3(l, !1)),
          symbol: "circle",
          line: { color: "white", width: 2 }
        },
        hoverinfo: "skip",
        showlegend: !1
      },
      {
        type: "scatter",
        mode: "markers",
        name: `${i.cohortName} Max`,
        x: [i.maxValue],
        y: [i.cohortName],
        marker: {
          size: 8,
          color: Ot(0.5, i.color || p3(l, !1)),
          symbol: "circle",
          line: { color: "white", width: 2 }
        },
        hoverinfo: "skip",
        showlegend: !1
      }
    ]
  ]).flat();
}
const ty = {
  xaxis: {
    gridcolor: "#e5e7eb"
  },
  yaxis: {
    visible: !1,
    zeroline: !1
  },
  showlegend: !1,
  hovermode: "y unified",
  margin: {
    l: 0,
    // Left margin
    r: 20,
    // Right margin
    b: 40,
    // Bottom margin
    t: 40,
    // Top margin
    pad: 5
    // Padding between the plot area and the axis labels/titles
  }
}, ny = {
  responsive: !0,
  displayModeBar: !0,
  displaylogo: !1,
  modeBarButtonsToRemove: [
    "pan2d",
    "lasso2d",
    "select2d",
    "resetScale2d",
    "zoom"
  ]
}, ry = ({ data: n }) => {
  const [o, a] = pe(!1), i = (n == null ? void 0 : n.length) * 40 + 60, l = je(
    () => ey(n, o),
    [n, o]
  );
  return /* @__PURE__ */ e.jsxs(
    X,
    {
      sx: {
        minHeight: i,
        position: "relative",
        ".main-svg": {
          overflow: "visible",
          ".hoverlayer": {
            zIndex: 2
          }
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(X, { sx: { minHeight: i }, children: /* @__PURE__ */ e.jsx(
          Qg,
          {
            data: l,
            config: ny,
            style: { width: "100%", height: "100%" },
            layout: {
              ...ty,
              height: i
            }
          }
        ) }),
        /* @__PURE__ */ e.jsxs(
          X,
          {
            component: "label",
            sx: {
              fontSize: 12
            },
            children: [
              /* @__PURE__ */ e.jsx(
                S1,
                {
                  checked: o,
                  onChange: (c) => a(c.target.checked),
                  size: "small",
                  sx: { mr: 1 }
                }
              ),
              "Hide Min/Max"
            ]
          }
        )
      ]
    }
  );
}, oy = {
  totalCost: "totalAdjustedCost",
  costPppy: "adjustedCostPppy",
  costPppq: "adjustedCostPppq",
  costPppm: "adjustedCostPppm",
  avgValue: "adjustedAvgValue",
  stdevValue: "adjustedStdevValue",
  minValue: "adjustedMinValue",
  p10Value: "adjustedP10Value",
  p25Value: "adjustedP25Value",
  medianValue: "adjustedMedianValue",
  p75Value: "adjustedP75Value",
  p90Value: "adjustedP90Value",
  maxValue: "adjustedMaxValue"
}, Yn = (n, o) => !(n != null && n.outlierBasis) || n.outlierBasis === o, Yr = (n, o) => {
  if (!n || o !== "adjusted") return n;
  const a = { ...n };
  return Object.entries(oy).forEach(([i, l]) => {
    n[l] !== void 0 && n[l] !== null && (a[i] = n[l]);
  }), a;
}, ay = ({
  data: n,
  title: o,
  targetCohorts: a,
  costMeasures: i,
  outliersDetectionMethods: l
}) => {
  const [c, p] = pe(
    a ?? []
  ), [g, u] = pe(i == null ? void 0 : i[0]), [d, f] = pe(null), [b, C] = pe([0, 0]), [v, A] = pe("raw"), P = je(() => (a ?? []).some((W) => {
    const D = (n == null ? void 0 : n[W.id]) || {};
    return Object.keys(D).some((F) => {
      var K, J, q;
      const M = D[F];
      return ((K = M == null ? void 0 : M.summary) == null ? void 0 : K.some((B) => B.outlierBasis === "adjusted")) || ((J = M == null ? void 0 : M.distribution) == null ? void 0 : J.some((B) => B.outlierBasis === "adjusted")) || ((q = M == null ? void 0 : M.histogram) == null ? void 0 : q.some((B) => B.outlierBasis === "adjusted"));
    });
  }), [n, a]);
  m1(() => {
    P || A("raw");
  }, [P]);
  const T = je(
    () => a.reduce((W, D, F) => (W[D.id] = p3(F, !1), W), {}),
    [a]
  ), I = je(
    () => a.reduce((W, D) => (Object.keys((n == null ? void 0 : n[D.id]) || {}).forEach((M) => W.add(M)), W), /* @__PURE__ */ new Set()),
    [n, a]
  );
  m1(() => {
    u([...I][0] ?? "total_chrge");
  }, [I]), m1(() => {
    p(a ?? []);
  }, [a]);
  const w = je(() => g ? c.reduce((W, D) => {
    var M, K, J;
    const F = (J = (K = (M = n[D.id]) == null ? void 0 : M[g]) == null ? void 0 : K.histogram) == null ? void 0 : J.filter((q) => Yn(q, v));
    if (F) {
      const q = F.map((B) => ({
        ...B,
        personCount: d && B.outlierMethod ? B.outlierMethod[d] ?? B.personCount : B.personCount
      }));
      W.push({
        name: D.name,
        id: D.id,
        data: q,
        color: T[D.id]
      });
    }
    return W;
  }, []) : [], [n, g, d, c, T, v]), { minCost: N, maxCost: E } = je(
    () => N9(w),
    [w]
  ), x = je(
    () => Mg(w, b)[0] ?? 1,
    [w, b]
  ), m = d || "No Outlier Removal", j = je(
    () => c.reduce((W, D) => {
      var J, q, B, k, H, re;
      const F = (B = (q = (J = n[D.id]) == null ? void 0 : J[g]) == null ? void 0 : q.distribution) == null ? void 0 : B.find(
        (te) => Yn(te, v) && te.outlierMethod === m
      ), M = (re = (H = (k = n[D.id]) == null ? void 0 : k[g]) == null ? void 0 : H.summary) == null ? void 0 : re.find(
        (te) => Yn(te, v) && te.outlierMethod === m
      ), K = {
        ...Yr(F, v) ?? [],
        ...Yr(M, v) ?? [],
        targetCohort: D
      };
      return K && W.push(K), W;
    }, []),
    [n, c, g, d, v, m]
  ), _ = je(
    () => c.reduce((W, D) => {
      var K, J, q;
      const F = (q = (J = (K = n[D.id]) == null ? void 0 : K[g]) == null ? void 0 : J.distribution) == null ? void 0 : q.find(
        (B) => Yn(B, v) && B.outlierMethod === m
      ), M = {
        ...Yr(F, v) ?? [],
        cohortId: D.id,
        cohortName: D.name,
        color: T[D.id]
        //   targetCohort: tc,
      };
      return F && W.push(M), W;
    }, []),
    [
      n,
      c,
      g,
      d,
      T,
      v,
      m
    ]
  ), z = je(() => {
    const W = w.map((F) => ({
      ...F,
      data: F.data.filter(
        (M) => M.max >= b[0] && M.min <= b[1]
      )
    })), D = kg(b, x);
    return Bg(
      W,
      D,
      x,
      b
    );
  }, [w, b, x]);
  m1(() => {
    C([N, E]);
  }, [N, E]);
  const Y = (W, D) => {
    typeof D == "number" && C([N, D]);
  };
  return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ne, { elevated: !0, outlined: !0, title: o, children: [
    /* @__PURE__ */ e.jsx(X, { display: "flex", alignItems: "center", children: /* @__PURE__ */ e.jsx(X, { flexGrow: 1, children: /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Cohorts:" }) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
        H1,
        {
          multiple: !0,
          fullWidth: !0,
          value: c,
          onChange: (W, D) => p(D),
          options: a,
          placeholder: "Select cohort...",
          getOptionLabel: function(W) {
            var D;
            return W.name || ((D = a.find((F) => F.id === W)) == null ? void 0 : D.name);
          },
          isOptionEqualToValue: (W, D) => W.id === D.id || W.id === D
        }
      ) })
    ] }) }) }),
    /* @__PURE__ */ e.jsxs(y, { container: !0, children: [
      /* @__PURE__ */ e.jsxs(y, { item: !0, xs: 12, minHeight: 400, display: "flex", children: [
        /* @__PURE__ */ e.jsx(X, { flex: 1, children: /* @__PURE__ */ e.jsx(
          Jg,
          {
            histogramData: z.bins,
            datasets: w,
            targetCohorts: c
          }
        ) }),
        /* @__PURE__ */ e.jsxs(X, { minWidth: 250, width: "25%", pl: 1, children: [
          /* @__PURE__ */ e.jsx(X, { pt: 2, children: /* @__PURE__ */ e.jsxs(X, { flexGrow: 1, children: [
            /* @__PURE__ */ e.jsx(y, { item: !0, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Cost measures:" }) }),
            /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
              H1,
              {
                fullWidth: !0,
                value: g || null,
                onChange: (W, D) => u(D.value),
                options: l2.filter(
                  (W) => I.has(W.value)
                ),
                placeholder: "Select cohort...",
                getOptionLabel: function(W) {
                  var D;
                  return W.name || ((D = l2.find((F) => F.value === W)) == null ? void 0 : D.name);
                },
                isOptionEqualToValue: (W, D) => W.value === D.value || W.value === D,
                disableClearable: !0
              }
            ) })
          ] }) }),
          /* @__PURE__ */ e.jsx(X, { pt: 2, textAlign: "left", children: c.map((W, D) => {
            const F = T[W.id];
            return /* @__PURE__ */ e.jsx(
              X,
              {
                title: W.name || "",
                sx: {
                  fontSize: 13,
                  color: "#474850",
                  mb: 0.5,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  "::before": {
                    content: '""',
                    height: "8px",
                    width: "8px",
                    backgroundColor: Ot(0.5, F),
                    borderRadius: "50%",
                    display: "inline-block",
                    mr: 0.5
                  }
                },
                children: W.name ? "— " + W.name : ""
              },
              `item-${D}`
            );
          }) }),
          /* @__PURE__ */ e.jsx(M1, { sx: { mt: 2 } }),
          /* @__PURE__ */ e.jsxs(X, { pt: 2, children: [
            P && /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 2, children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Amounts basis:" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
                H1,
                {
                  fullWidth: !0,
                  disableClearable: !0,
                  value: v,
                  onChange: (W, D) => A(
                    ((D == null ? void 0 : D.value) ?? D) || "raw"
                  ),
                  options: [
                    { value: "raw", name: "Nominal (raw)" },
                    { value: "adjusted", name: "CPI-adjusted" }
                  ],
                  getOptionLabel: function(W) {
                    return (W == null ? void 0 : W.name) || (W === "adjusted" ? "CPI-adjusted" : "Nominal (raw)");
                  },
                  isOptionEqualToValue: (W, D) => (W.value ?? W) === (D.value ?? D)
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsx(X, { flexGrow: 1, children: /* @__PURE__ */ e.jsxs(y, { container: !0, alignItems: "center", mb: 2, children: [
              /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", mr: 1, children: "Exclude outliers method:" }) }),
              /* @__PURE__ */ e.jsx(y, { item: !0, flexGrow: 1, children: /* @__PURE__ */ e.jsx(
                H1,
                {
                  fullWidth: !0,
                  value: d || null,
                  onChange: (W, D) => {
                    f(D);
                  },
                  options: l,
                  placeholder: "Select method...",
                  getOptionLabel: function(W) {
                    return W || "";
                  },
                  isOptionEqualToValue: (W, D) => W === D
                }
              ) })
            ] }) }),
            /* @__PURE__ */ e.jsxs(ce, { variant: "subtitle2", mr: 1, children: [
              "Cost range: ",
              oe(N),
              " -",
              " ",
              oe(b[1])
            ] }),
            /* @__PURE__ */ e.jsx(
              vd,
              {
                getAriaLabel: () => "Cost range",
                value: b[1],
                onChange: Y,
                valueLabelDisplay: "auto",
                min: N,
                max: E,
                valueLabelFormat: oe,
                getAriaValueText: oe,
                size: "small",
                color: "info"
              }
            ),
            /* @__PURE__ */ e.jsxs(
              X,
              {
                sx: { display: "flex", justifyContent: "space-between" },
                mx: -0.75,
                mt: -1,
                fontSize: 12,
                children: [
                  /* @__PURE__ */ e.jsx(ce, { variant: "body2", sx: { cursor: "pointer" }, children: oe(N, 0, 0) }),
                  /* @__PURE__ */ e.jsx(ce, { variant: "body2", sx: { cursor: "pointer" }, children: oe(E, 0, 0) })
                ]
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        y1,
        {
          hideSettings: !0,
          hidePagination: !0,
          columns: $g,
          data: j
        }
      ) }),
      /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(X, { children: /* @__PURE__ */ e.jsx(ry, { data: _ }) }) })
    ] })
  ] }) });
}, iy = /* @__PURE__ */ new Set([
  "id",
  "name",
  "type",
  "costMeasures",
  "domainsToUse",
  "conceptSetNames"
]), sy = /* @__PURE__ */ new Set([
  "targetCohorts",
  "outliersDetectionMethods",
  "analyses",
  "costMeasures",
  "domainsToUse",
  "conceptSetNames"
]), ly = (n) => n === "overall" ? "Totals" : n === "conceptSet" ? "Concept set" : n.charAt(0).toUpperCase() + n.slice(1), Q8 = ({
  blockKey: n,
  value: o,
  targetCohorts: a,
  costMeasures: i,
  outliersDetectionMethods: l
}) => o ? /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
  ay,
  {
    data: o,
    title: /* @__PURE__ */ e.jsx(X, { sx: { textTransform: "capitalize" }, children: ly(n) }),
    targetCohorts: a,
    costMeasures: i,
    outliersDetectionMethods: l
  }
) }) : null, Mv = ({ data: n }) => {
  const { targetCohorts: o, outliersDetectionMethods: a, analyses: i } = n;
  if (Array.isArray(i))
    return i.length ? /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: i.map((c) => {
      const p = Object.entries(c).filter(
        ([g, u]) => !iy.has(g) && u
      );
      return /* @__PURE__ */ e.jsx(y, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        Ne,
        {
          collapsible: !0,
          defaultState: !0,
          elevated: !0,
          outlined: !0,
          title: c.name || `Analysis ${c.id}`,
          children: /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: p.map(([g, u]) => /* @__PURE__ */ e.jsx(
            Q8,
            {
              blockKey: g,
              value: u,
              targetCohorts: o,
              costMeasures: c.costMeasures,
              outliersDetectionMethods: a
            },
            g
          )) })
        }
      ) }, c.id);
    }) }) : /* @__PURE__ */ e.jsx(ce, { variant: "subtitle2", p: 2, children: "No results to display." });
  const l = Object.entries(n).filter(
    ([c, p]) => !sy.has(c) && p && Object.keys(p).length > 0
  );
  return /* @__PURE__ */ e.jsx(y, { container: !0, spacing: 2, children: l.map(([c, p]) => /* @__PURE__ */ e.jsx(
    Q8,
    {
      blockKey: c === "conceptSets" ? "conceptSet" : c,
      value: p,
      targetCohorts: o,
      costMeasures: n.costMeasures || [],
      outliersDetectionMethods: a
    },
    c
  )) });
}, cy = ["bt"], D9 = (n) => {
  const o = (n == null ? void 0 : n.Op) ?? "gt", a = cy.includes(o);
  return {
    Op: o,
    Value: (n == null ? void 0 : n.Value) ?? null,
    Extent: a ? (n == null ? void 0 : n.Extent) ?? null : null
  };
}, uy = (n = []) => (Array.isArray(n) ? n : []).filter(
  (o) => o && o.year !== null && o.year !== void 0 && o.coefficient !== null && o.coefficient !== void 0
).map((o) => ({
  year: Number(o.year),
  coefficient: Number(o.coefficient)
})), dy = (n) => n.length ? n.reduce(
  (o, a) => a.year > o ? a.year : o,
  n[0].year
) : null, py = (n = {}) => {
  const {
    // `id` is a local uuid — the backend assigns a positional int id itself.
    id: o,
    type: a,
    applyCpi: i,
    cpiCoefficients: l,
    cpiBaseYear: c,
    visitLength: p,
    ...g
  } = n || {}, u = uy(l), { dateRangeStart: d, dateRangeEnd: f, visitConceptIds: b, ...C } = g, v = {
    ...C,
    type: Hg[a] ?? "TOTALS",
    cpiAdjustment: !!i
  }, A = D9(p);
  return A.Value !== null && A.Value !== void 0 && (v.visitLength = A), d && (v.dateRangeStart = d), f && (v.dateRangeEnd = f), Array.isArray(b) && b.length && (v.visitConceptIds = b), u.length && (v.cpiFactors = u, v.cpiBaseYear = c != null && u.some((P) => P.year === c) ? c : dy(u)), v;
}, my = (n = {}) => {
  const o = Array.isArray(n == null ? void 0 : n.analyses) ? n.analyses.map(py) : [];
  return { targetCohorts: Array.isArray(n == null ? void 0 : n.targetCohorts) ? n.targetCohorts.filter((i) => i == null ? void 0 : i.versionId).map((i) => ({
    ...i.id != null ? { id: i.id } : {},
    versionId: i.versionId,
    ...i.alias ? { alias: i.alias } : {}
  })) : [], analyses: o };
}, kv = (n) => n && n.design ? { ...n, design: my(n.design) } : n, hy = (n = {}, o = 0) => {
  const a = c2(o), {
    // Backend int id is dropped; a fresh local uuid (from `base`) is the React
    // key. Results are matched to settings inside the results payload itself.
    id: i,
    type: l,
    cpiAdjustment: c,
    cpiFactors: p,
    cpiBaseYear: g,
    visitLength: u,
    name: d,
    window: f,
    dateRangeStart: b,
    dateRangeEnd: C,
    costMeasures: v,
    domainsToUse: A,
    conceptSets: P,
    visitConceptIds: T,
    excludeNegativeCosts: I,
    excludeZeroCostPatients: w
  } = n || {};
  return {
    id: a.id,
    name: d || a.name,
    type: Vg[l] ?? l ?? a.type,
    domainsToUse: Array.isArray(A) ? A : a.domainsToUse,
    conceptSets: Array.isArray(P) ? P : a.conceptSets,
    // Existing analyses can come back with an empty costMeasures — keep it so
    // the form forces the user to fill it before submitting.
    costMeasures: Array.isArray(v) ? v : a.costMeasures,
    excludeNegativeCosts: !!I,
    excludeZeroCostPatients: !!w,
    visitConceptIds: Array.isArray(T) ? T : a.visitConceptIds,
    visitLength: D9(u ?? a.visitLength),
    dateRangeStart: b ?? null,
    dateRangeEnd: C ?? null,
    window: f && typeof f == "object" ? { ...a.window, ...f } : a.window,
    applyCpi: !!c,
    cpiCoefficients: Array.isArray(p) ? p.map((N) => ({
      id: Kt(),
      year: (N == null ? void 0 : N.year) ?? null,
      coefficient: (N == null ? void 0 : N.coefficient) ?? null
    })) : a.cpiCoefficients,
    cpiBaseYear: g ?? a.cpiBaseYear
  };
}, fy = (n = {}) => !n || !Array.isArray(n.analyses) ? n : {
  ...n,
  analyses: n.analyses.map(
    (o, a) => hy(o, a)
  )
}, zv = (n) => n && n.design ? { ...n, design: fy(n.design) } : n;
export {
  Wg as ANALYSIS_TYPE_OPTIONS,
  Ev as BulkCohortCounts,
  Iv as BulkCohortCountsResults,
  Vg as COST_TYPE_FROM_API,
  Hg as COST_TYPE_TO_API,
  N4 as CaliperScale,
  Iy as Characterization,
  fm as CharacterizationFaTypes,
  hm as CharacterizationResultTypes,
  Ly as CharacterizationResults,
  bv as CohortBasedDataCut,
  Cv as CohortBasedDataCutResults,
  O4 as ConvergenceType,
  Ht as CostAnalysisType,
  Lv as CostUtilization,
  Mv as CostUtilizationResults,
  My as Custom,
  ky as CustomResults,
  B4 as CvType,
  xx as Demographics,
  $y as Estimation,
  Wy as EstimationResults,
  av as Feasibility,
  cv as FeasibilityResults,
  Vy as Incidence,
  qy as IncidenceResults,
  pm as LocationMapSection,
  Vp as MOCK_CDM_53,
  Gp as MOCK_CDM_54,
  Ct as MatchStratify,
  Et as ModelType,
  I4 as NoiseLevel,
  o2 as OccurrenceType,
  nv as Pathway,
  rv as PathwayResults,
  ov as PathwayTemplate,
  dv as Prediction,
  pv as PredictionResults,
  _3 as PriorType,
  P4 as RemoveDuplicateSubject,
  R4 as SelectorType,
  fv as SimpleCount,
  Ox as SimpleCountResults,
  gv as SimpleCountWithCharacterization,
  Ox as SimpleCountWithCharacterizationResults,
  yv as Strategus,
  vv as StrategusResults,
  F4 as StratificationBaseSelection,
  Nv as TimeToEvent,
  Fv as TimeToEventResult,
  jt as Trim,
  Hp as buildLocationDataFromReport,
  Av as bulkCohortCountsTemplateList,
  Dy as characterizationTemplateList,
  Tv as cohortBasedDataCutTemplateList,
  c2 as createEmptyCostAnalysis,
  hy as deserializeCostAnalysis,
  fy as deserializeCostDesign,
  zv as deserializeCostEntity,
  Hy as estimationTemplateList,
  uv as feasibilityTemplateList,
  Ov as getBulkCohortCountsTemplate,
  Ry as getCharacterizationTemplate,
  jv as getDataCutTemplate,
  zy as getEstimationTemplate,
  iv as getFeasibilityTemplate,
  Gy as getIncidenceTemplate,
  Kp as getMockData,
  Qy as getPathwayTemplate,
  mv as getPredictionTemplate,
  Xy as getSimpleCohortCharacterizationTemplate,
  Xy as getSimpleCohortTemplate,
  Uy as incidenceRateTemplateList,
  Pv as parseBulkCohortCountsDesign,
  _v as parseBulkCohortCountsFormatResults,
  Fy as parseCharacterizationDesign,
  Ny as parseCharacterizationFormatResult,
  wv as parseDataCutDesign,
  Sv as parseDataCutFormatResult,
  By as parseEstimationDesign,
  lv as parseFeasibilityDesign,
  sv as parseFeasibilityFormatResult,
  Yy as parseIncidenceDesign,
  Ky as parseIncidenceFormatResult,
  tv as parsePathwayDesign,
  ev as parsePathwayFormatResult,
  hv as parsePredictionDesign,
  Jy as parseSimpleCountCharacterizationDesign,
  Zy as parseSimpleCountCharacterizationFormatResult,
  Jy as parseSimpleCountDesign,
  Zy as parseSimpleCountFormatResult,
  Hf as pathwayTemplateList,
  $p as resolveGeo,
  py as serializeCostAnalysis,
  my as serializeCostDesign,
  kv as serializeCostEntity,
  xv as simpleCountCharacterizationTemplateList,
  xv as simpleCountTemplateList,
  Dv as templateCostUtilization,
  Rv as templateListTimeToEvent
};
//# sourceMappingURL=plugins.js.map
